// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../../../node_modules/flatpickr/dist/flatpickr.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23111111\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"m7 10 5.5 5.5L18 10\"%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23343434\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"-12 -12 24 24\"%3e%3ccircle r=\"6\" fill=\"%23343434\"/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cline stroke=\"%23343434\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate%286.000000, 11.500000%29\" x1=\"12\" y1=\"0.5\" x2=\"4.99600361e-16\" y2=\"0.5\"%3e%3c/line%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-9 -9 18 18%27%3e%3ccircle r=%277%27 fill=%27%23fff%27 style=%27filter: drop-shadow%280px 2px 1px rgb%2817 17 17 / 0.18%29%29%27 /%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-9 -9 18 18%27%3e%3ccircle r=%277%27 fill=%27%23fff%27 stroke=%27%23304ffe%27 stroke-width=%270.6%27 style=%27filter: drop-shadow%280px 2px 1px rgb%2817 17 17 / 0.18%29%29%27 /%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-9 -9 18 18%27%3e%3ccircle r=%277%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%2315ad5c\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" d=\"M0 0h32v32H0z\"%3e%3c/path%3e%3cpath fill=\"%23e64949\" d=\"m24.928 24.116-8.4-15.6c-.21-.389-.847-.389-1.057 0l-8.4 15.6A.6.6 0 0 0 7.6 25h16.8a.6.6 0 0 0 .528-.884Zm-7.9-10.516-.428 6h-1.2l-.428-6h2.056ZM16 23.2a1.067 1.067 0 1 1 0-2.134 1.067 1.067 0 0 1 0 2.134Z\"%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2817, 17, 17, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23111111\" vector-effect=\"non-scaling-stroke\" opacity=\"1\" d=\"m7 10 5.5 5.5L18 10\"%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"9\" height=\"9\"%3e%3cpath fill=\"none\" stroke=\"%23111111\" stroke-linecap=\"square\" d=\"m2.8 1 3.5 3.5L2.8 8\" opacity=\".4\"/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg width=\"100%25\" height=\"100%25\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath stroke=\"%23111111\" stroke-linecap=\"square\" fill=\"none\" d=\"M16.2 7.8l-8.4 8.4m8.4 0L7.8 7.8\"%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"9\" height=\"9\"%3e%3cpath fill=\"none\" stroke=\"%23fff\" stroke-linecap=\"square\" d=\"m2.8 1 3.5 3.5L2.8 8\" opacity=\".4\"/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23fff\" vector-effect=\"non-scaling-stroke\" opacity=\"1\" d=\"m7 10 5.5 5.5L18 10\"%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath stroke-linecap=\"square\" fill=\"%23111111\" opacity=\"0.54\" d=\"M6.6 9.4h10.8L12 16.6z\"%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23111111\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"M15.25 15.1 12 18.35 8.75 15.1m0-5.2L12 6.65l3.25 3.25\"%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23fff\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"m7 10 5.5 5.5L18 10\"%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath stroke-linecap=\"square\" fill=\"%23fff\" opacity=\"0.54\" d=\"M6.6 9.4h10.8L12 16.6z\"%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23fff\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"M15.25 15.1 12 18.35 8.75 15.1m0-5.2L12 6.65l3.25 3.25\"%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"-12 -12 24 24\"%3e%3ccircle r=\"6\" fill=\"%23878787\"/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"-12 -12 24 24\"%3e%3ccircle r=\"6\" fill=\"%23111111\"/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23111111\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23e64949\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23f2f2f2%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23dedede%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23fcfcfc\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23dedede\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cline stroke=\"%23dedede\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate%286.000000, 11.500000%29\" x1=\"12\" y1=\"0.5\" x2=\"4.99600361e-16\" y2=\"0.5\"%3e%3c/line%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23808080\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%232ee68c\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23ff7591\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"-12 -12 24 24\"%3e%3ccircle r=\"6\" fill=\"%23dedede\"/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"-12 -12 24 24\"%3e%3ccircle r=\"6\" fill=\"%23fcfcfc\"/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"-12 -12 24 24\"%3e%3ccircle r=\"6\" fill=\"%23808080\"/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23cccccc%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ededed%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-9 -9 18 18%27%3e%3ccircle r=%277%27 fill=%27%23cccccc%27 stroke=%27%23304ffe%27 stroke-width=%270.6%27 style=%27filter: drop-shadow%280px 2px 1px rgb%2817 17 17 / 0.18%29%29%27 /%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23575757%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23232323%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23fff\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cline stroke=\"%23fff\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate%286.000000, 11.500000%29\" x1=\"12\" y1=\"0.5\" x2=\"4.99600361e-16\" y2=\"0.5\"%3e%3c/line%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23878787\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23767676%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-9 -9 18 18%27%3e%3ccircle r=%277%27 fill=%27%23767676%27 stroke=%27%23304ffe%27 stroke-width=%270.6%27 style=%27filter: drop-shadow%280px 2px 1px rgb%2817 17 17 / 0.18%29%29%27 /%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cline stroke=\"%23111111\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate%286.000000, 11.500000%29\" x1=\"12\" y1=\"0.5\" x2=\"4.99600361e-16\" y2=\"0.5\"%3e%3c/line%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("data:image/svg+xml,%3csvg width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" d=\"M0 0h32v32H0z\"%3e%3c/path%3e%3cpath fill=\"%23ff7591\" d=\"m24.928 24.116-8.4-15.6c-.21-.389-.847-.389-1.057 0l-8.4 15.6A.6.6 0 0 0 7.6 25h16.8a.6.6 0 0 0 .528-.884Zm-7.9-10.516-.428 6h-1.2l-.428-6h2.056ZM16 23.2a1.067 1.067 0 1 1 0-2.134 1.067 1.067 0 0 1 0 2.134Z\"%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23090909\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"rgba%28255, 255, 255, 0.64%29\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;1,300;1,400;1,500&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.absolute-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.opacity-100-hover {
  transition: opacity 300ms;
}
.opacity-100-hover:hover {
  opacity: 1 !important;
}

.hover-shadow {
  transition: box-shadow 300ms;
}
.hover-shadow:hover {
  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);
}

.hover-shadow-lg {
  transition: box-shadow 300ms;
}
.hover-shadow-lg:hover {
  box-shadow: 0 1.25rem 1.875rem rgba(35, 35, 35, 0.2);
}

.hover-shadow-elevated {
  transition: box-shadow 300ms;
  box-shadow: 0 0.5625rem 0.875rem rgba(35, 35, 35, 0.14);
}
.hover-shadow-elevated:hover {
  box-shadow: 0 1.25rem 1.875rem rgba(35, 35, 35, 0.2);
}

@media (min-width: 992px) {
  .lh-lg-1-5 {
    line-height: 1.5 !important;
  }
}
.dark .dark-d-none {
  display: none !important;
}
.dark .dark-d-inline {
  display: inline !important;
}
.dark .hover-shadow:hover {
  box-shadow: 0 0.75rem 1rem rgba(0, 0, 0, 0.5);
}
.dark .hover-shadow-lg:hover {
  box-shadow: 0 1.25rem 1.875rem rgba(0, 0, 0, 0.6);
}
.dark .hover-shadow-elevated {
  box-shadow: 0 0.5625rem 0.875rem rgba(0, 0, 0, 0.5);
}
.dark .hover-shadow-elevated:hover {
  box-shadow: 0 1.25rem 1.875rem rgba(0, 0, 0, 0.6);
}

/*!
 * Bootstrap  v5.3.2 (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #2ee68c;
  --bs-info: #4fc3f7;
  --bs-warning: #ffee5c;
  --bs-danger: #ff7591;
  --bs-light: #f2f2f2;
  --bs-dark: #111111;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 46, 230, 140;
  --bs-info-rgb: 79, 195, 247;
  --bs-warning-rgb: 255, 238, 92;
  --bs-danger-rgb: 255, 117, 145;
  --bs-light-rgb: 242, 242, 242;
  --bs-dark-rgb: 17, 17, 17;
  --bs-primary-text-emphasis: #052c65;
  --bs-secondary-text-emphasis: #2b2f32;
  --bs-success-text-emphasis: #125c38;
  --bs-info-text-emphasis: #204e63;
  --bs-warning-text-emphasis: #665f25;
  --bs-danger-text-emphasis: #662f3a;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #cfe2ff;
  --bs-secondary-bg-subtle: #e2e3e5;
  --bs-success-bg-subtle: #e6fff2;
  --bs-info-bg-subtle: #ecfafe;
  --bs-warning-bg-subtle: #fffff0;
  --bs-danger-bg-subtle: #ffedf0;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #9ec5fe;
  --bs-secondary-border-subtle: #c4c8cb;
  --bs-success-border-subtle: #2ee68c;
  --bs-info-border-subtle: #4fc3f7;
  --bs-warning-border-subtle: #ffee5c;
  --bs-danger-border-subtle: #ff7591;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: Arial, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: "Roboto", Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.75;
  --bs-body-color: #111111;
  --bs-body-color-rgb: 17, 17, 17;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: #666666;
  --bs-secondary-color-rgb: 102, 102, 102;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(17, 17, 17, 0.5);
  --bs-tertiary-color-rgb: 17, 17, 17;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #002bbc;
  --bs-link-color-rgb: 0, 43, 188;
  --bs-link-decoration: none;
  --bs-link-hover-color: #002bbc;
  --bs-link-hover-color-rgb: 0, 43, 188;
  --bs-link-hover-decoration: underline;
  --bs-code-color: #d63384;
  --bs-highlight-color: #111111;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #ededed;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.3125rem;
  --bs-border-radius-sm: 0.1875rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 0.75rem;
  --bs-border-radius-xxl: 1rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);
  --bs-box-shadow-sm: 0 0.5625rem 0.875rem rgba(35, 35, 35, 0.14);
  --bs-box-shadow-lg: 0 1.25rem 1.875rem rgba(35, 35, 35, 0.2);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #0c6636;
  --bs-form-valid-border-color: #15ad5c;
  --bs-form-invalid-color: #9e3232;
  --bs-form-invalid-border-color: #e64949;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 2rem;
  font-weight: 300;
  line-height: 1.5;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: 2rem;
}

h2, .h2 {
  font-size: 1.8125rem;
}

h3, .h3 {
  font-size: 1.625rem;
}

h4, .h4 {
  font-size: 1.4375rem;
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 0.875rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.8125em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: none;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
  text-decoration: underline;
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.8125em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.8125em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.8125em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.1875rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  font-weight: normal;
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.125rem;
  font-weight: 300;
}

.display-1 {
  font-size: 5.625rem;
  font-weight: 300;
  line-height: 1.5;
}

.display-2 {
  font-size: 4.1875rem;
  font-weight: 300;
  line-height: 1.5;
}

.display-3 {
  font-size: 3.1875rem;
  font-weight: 300;
  line-height: 1.5;
}

.display-4 {
  font-size: 2.375rem;
  font-weight: 300;
  line-height: 1.5;
}

.display-5 {
  font-size: 1.75rem;
  font-weight: 300;
  line-height: 1.5;
}

.display-6 {
  font-size: 1.333rem;
  font-weight: 300;
  line-height: 1.5;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.8125em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.8125em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.8125em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.875rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.875rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.125rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.125rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.25rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.25rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 0.5rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 0.5rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 1.5rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 1.5rem;
}

.g-6,
.gx-6 {
  --bs-gutter-x: 2rem;
}

.g-6,
.gy-6 {
  --bs-gutter-y: 2rem;
}

.g-7,
.gx-7 {
  --bs-gutter-x: 2.5rem;
}

.g-7,
.gy-7 {
  --bs-gutter-y: 2.5rem;
}

.g-8,
.gx-8 {
  --bs-gutter-x: 3rem;
}

.g-8,
.gy-8 {
  --bs-gutter-y: 3rem;
}

.g-9,
.gx-9 {
  --bs-gutter-x: 3.5rem;
}

.g-9,
.gy-9 {
  --bs-gutter-y: 3.5rem;
}

.g-10,
.gx-10 {
  --bs-gutter-x: 4rem;
}

.g-10,
.gy-10 {
  --bs-gutter-y: 4rem;
}

.g-11,
.gx-11 {
  --bs-gutter-x: 5rem;
}

.g-11,
.gy-11 {
  --bs-gutter-y: 5rem;
}

.g-12,
.gx-12 {
  --bs-gutter-x: 6rem;
}

.g-12,
.gy-12 {
  --bs-gutter-y: 6rem;
}

.g-13,
.gx-13 {
  --bs-gutter-x: 6.5rem;
}

.g-13,
.gy-13 {
  --bs-gutter-y: 6.5rem;
}

.g-14,
.gx-14 {
  --bs-gutter-x: 8rem;
}

.g-14,
.gy-14 {
  --bs-gutter-y: 8rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.125rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.125rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-6,
  .gx-sm-6 {
    --bs-gutter-x: 2rem;
  }
  .g-sm-6,
  .gy-sm-6 {
    --bs-gutter-y: 2rem;
  }
  .g-sm-7,
  .gx-sm-7 {
    --bs-gutter-x: 2.5rem;
  }
  .g-sm-7,
  .gy-sm-7 {
    --bs-gutter-y: 2.5rem;
  }
  .g-sm-8,
  .gx-sm-8 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-8,
  .gy-sm-8 {
    --bs-gutter-y: 3rem;
  }
  .g-sm-9,
  .gx-sm-9 {
    --bs-gutter-x: 3.5rem;
  }
  .g-sm-9,
  .gy-sm-9 {
    --bs-gutter-y: 3.5rem;
  }
  .g-sm-10,
  .gx-sm-10 {
    --bs-gutter-x: 4rem;
  }
  .g-sm-10,
  .gy-sm-10 {
    --bs-gutter-y: 4rem;
  }
  .g-sm-11,
  .gx-sm-11 {
    --bs-gutter-x: 5rem;
  }
  .g-sm-11,
  .gy-sm-11 {
    --bs-gutter-y: 5rem;
  }
  .g-sm-12,
  .gx-sm-12 {
    --bs-gutter-x: 6rem;
  }
  .g-sm-12,
  .gy-sm-12 {
    --bs-gutter-y: 6rem;
  }
  .g-sm-13,
  .gx-sm-13 {
    --bs-gutter-x: 6.5rem;
  }
  .g-sm-13,
  .gy-sm-13 {
    --bs-gutter-y: 6.5rem;
  }
  .g-sm-14,
  .gx-sm-14 {
    --bs-gutter-x: 8rem;
  }
  .g-sm-14,
  .gy-sm-14 {
    --bs-gutter-y: 8rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.125rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.125rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-6,
  .gx-md-6 {
    --bs-gutter-x: 2rem;
  }
  .g-md-6,
  .gy-md-6 {
    --bs-gutter-y: 2rem;
  }
  .g-md-7,
  .gx-md-7 {
    --bs-gutter-x: 2.5rem;
  }
  .g-md-7,
  .gy-md-7 {
    --bs-gutter-y: 2.5rem;
  }
  .g-md-8,
  .gx-md-8 {
    --bs-gutter-x: 3rem;
  }
  .g-md-8,
  .gy-md-8 {
    --bs-gutter-y: 3rem;
  }
  .g-md-9,
  .gx-md-9 {
    --bs-gutter-x: 3.5rem;
  }
  .g-md-9,
  .gy-md-9 {
    --bs-gutter-y: 3.5rem;
  }
  .g-md-10,
  .gx-md-10 {
    --bs-gutter-x: 4rem;
  }
  .g-md-10,
  .gy-md-10 {
    --bs-gutter-y: 4rem;
  }
  .g-md-11,
  .gx-md-11 {
    --bs-gutter-x: 5rem;
  }
  .g-md-11,
  .gy-md-11 {
    --bs-gutter-y: 5rem;
  }
  .g-md-12,
  .gx-md-12 {
    --bs-gutter-x: 6rem;
  }
  .g-md-12,
  .gy-md-12 {
    --bs-gutter-y: 6rem;
  }
  .g-md-13,
  .gx-md-13 {
    --bs-gutter-x: 6.5rem;
  }
  .g-md-13,
  .gy-md-13 {
    --bs-gutter-y: 6.5rem;
  }
  .g-md-14,
  .gx-md-14 {
    --bs-gutter-x: 8rem;
  }
  .g-md-14,
  .gy-md-14 {
    --bs-gutter-y: 8rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.125rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.125rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-6,
  .gx-lg-6 {
    --bs-gutter-x: 2rem;
  }
  .g-lg-6,
  .gy-lg-6 {
    --bs-gutter-y: 2rem;
  }
  .g-lg-7,
  .gx-lg-7 {
    --bs-gutter-x: 2.5rem;
  }
  .g-lg-7,
  .gy-lg-7 {
    --bs-gutter-y: 2.5rem;
  }
  .g-lg-8,
  .gx-lg-8 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-8,
  .gy-lg-8 {
    --bs-gutter-y: 3rem;
  }
  .g-lg-9,
  .gx-lg-9 {
    --bs-gutter-x: 3.5rem;
  }
  .g-lg-9,
  .gy-lg-9 {
    --bs-gutter-y: 3.5rem;
  }
  .g-lg-10,
  .gx-lg-10 {
    --bs-gutter-x: 4rem;
  }
  .g-lg-10,
  .gy-lg-10 {
    --bs-gutter-y: 4rem;
  }
  .g-lg-11,
  .gx-lg-11 {
    --bs-gutter-x: 5rem;
  }
  .g-lg-11,
  .gy-lg-11 {
    --bs-gutter-y: 5rem;
  }
  .g-lg-12,
  .gx-lg-12 {
    --bs-gutter-x: 6rem;
  }
  .g-lg-12,
  .gy-lg-12 {
    --bs-gutter-y: 6rem;
  }
  .g-lg-13,
  .gx-lg-13 {
    --bs-gutter-x: 6.5rem;
  }
  .g-lg-13,
  .gy-lg-13 {
    --bs-gutter-y: 6.5rem;
  }
  .g-lg-14,
  .gx-lg-14 {
    --bs-gutter-x: 8rem;
  }
  .g-lg-14,
  .gy-lg-14 {
    --bs-gutter-y: 8rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.125rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.125rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-6,
  .gx-xl-6 {
    --bs-gutter-x: 2rem;
  }
  .g-xl-6,
  .gy-xl-6 {
    --bs-gutter-y: 2rem;
  }
  .g-xl-7,
  .gx-xl-7 {
    --bs-gutter-x: 2.5rem;
  }
  .g-xl-7,
  .gy-xl-7 {
    --bs-gutter-y: 2.5rem;
  }
  .g-xl-8,
  .gx-xl-8 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-8,
  .gy-xl-8 {
    --bs-gutter-y: 3rem;
  }
  .g-xl-9,
  .gx-xl-9 {
    --bs-gutter-x: 3.5rem;
  }
  .g-xl-9,
  .gy-xl-9 {
    --bs-gutter-y: 3.5rem;
  }
  .g-xl-10,
  .gx-xl-10 {
    --bs-gutter-x: 4rem;
  }
  .g-xl-10,
  .gy-xl-10 {
    --bs-gutter-y: 4rem;
  }
  .g-xl-11,
  .gx-xl-11 {
    --bs-gutter-x: 5rem;
  }
  .g-xl-11,
  .gy-xl-11 {
    --bs-gutter-y: 5rem;
  }
  .g-xl-12,
  .gx-xl-12 {
    --bs-gutter-x: 6rem;
  }
  .g-xl-12,
  .gy-xl-12 {
    --bs-gutter-y: 6rem;
  }
  .g-xl-13,
  .gx-xl-13 {
    --bs-gutter-x: 6.5rem;
  }
  .g-xl-13,
  .gy-xl-13 {
    --bs-gutter-y: 6.5rem;
  }
  .g-xl-14,
  .gx-xl-14 {
    --bs-gutter-x: 8rem;
  }
  .g-xl-14,
  .gy-xl-14 {
    --bs-gutter-y: 8rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.125rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.125rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-6,
  .gx-xxl-6 {
    --bs-gutter-x: 2rem;
  }
  .g-xxl-6,
  .gy-xxl-6 {
    --bs-gutter-y: 2rem;
  }
  .g-xxl-7,
  .gx-xxl-7 {
    --bs-gutter-x: 2.5rem;
  }
  .g-xxl-7,
  .gy-xxl-7 {
    --bs-gutter-y: 2.5rem;
  }
  .g-xxl-8,
  .gx-xxl-8 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-8,
  .gy-xxl-8 {
    --bs-gutter-y: 3rem;
  }
  .g-xxl-9,
  .gx-xxl-9 {
    --bs-gutter-x: 3.5rem;
  }
  .g-xxl-9,
  .gy-xxl-9 {
    --bs-gutter-y: 3.5rem;
  }
  .g-xxl-10,
  .gx-xxl-10 {
    --bs-gutter-x: 4rem;
  }
  .g-xxl-10,
  .gy-xxl-10 {
    --bs-gutter-y: 4rem;
  }
  .g-xxl-11,
  .gx-xxl-11 {
    --bs-gutter-x: 5rem;
  }
  .g-xxl-11,
  .gy-xxl-11 {
    --bs-gutter-y: 5rem;
  }
  .g-xxl-12,
  .gx-xxl-12 {
    --bs-gutter-x: 6rem;
  }
  .g-xxl-12,
  .gy-xxl-12 {
    --bs-gutter-y: 6rem;
  }
  .g-xxl-13,
  .gx-xxl-13 {
    --bs-gutter-x: 6.5rem;
  }
  .g-xxl-13,
  .gy-xxl-13 {
    --bs-gutter-y: 6.5rem;
  }
  .g-xxl-14,
  .gx-xxl-14 {
    --bs-gutter-x: 8rem;
  }
  .g-xxl-14,
  .gy-xxl-14 {
    --bs-gutter-y: 8rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: rgba(17, 17, 17, 0.64);
  --bs-table-bg: #fff;
  --bs-table-border-color: #ededed;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: rgba(17, 17, 17, 0.64);
  --bs-table-striped-bg: #fafafa;
  --bs-table-active-color: rgba(17, 17, 17, 0.64);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: rgba(17, 17, 17, 0.64);
  --bs-table-hover-bg: rgba(17, 17, 17, 0.02);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.75rem 0.9375rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.5rem 0.75rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #cfe2ff;
  --bs-table-border-color: #a6b5cc;
  --bs-table-striped-bg: #c5d7f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bacbe6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfd1ec;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #e2e3e5;
  --bs-table-border-color: #b5b6b7;
  --bs-table-striped-bg: #d7d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cbccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d1d2d4;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d5fae8;
  --bs-table-border-color: #aac8ba;
  --bs-table-striped-bg: #caeedc;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #c0e1d1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c5e7d7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #dcf3fd;
  --bs-table-border-color: #b0c2ca;
  --bs-table-striped-bg: #d1e7f0;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #c6dbe4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #cce1ea;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fffcde;
  --bs-table-border-color: #cccab2;
  --bs-table-striped-bg: #f2efd3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6e3c8;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece9cd;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #ffe3e9;
  --bs-table-border-color: #ccb6ba;
  --bs-table-striped-bg: #f2d8dd;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6ccd2;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ecd2d8;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f2f2f2;
  --bs-table-border-color: #c2c2c2;
  --bs-table-striped-bg: #e6e6e6;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dadada;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e0e0e0;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #111111;
  --bs-table-border-color: #414141;
  --bs-table-striped-bg: #1d1d1d;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #292929;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #232323;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
}

.col-form-label {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.7142857143;
}

.col-form-label-lg {
  padding-top: calc(0.6875rem + var(--bs-border-width));
  padding-bottom: calc(0.6875rem + var(--bs-border-width));
  font-size: 0.9375rem;
}

.col-form-label-sm {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  font-size: 0.8125rem;
}

.form-text {
  margin-top: 0.5rem;
  font-size: 0.6875rem;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9375rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.7142857143;
  color: #111111;
  appearance: none;
  background-color: transparent;
  background-clip: padding-box;
  border: var(--bs-border-width) solid #dedede;
  border-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #111111;
  background-color: transparent;
  border-color: #304ffe;
  outline: 0;
  box-shadow: none;
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.7142857143em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: rgba(17, 17, 17, 0.64);
  opacity: 1;
}
.form-control:disabled {
  background-color: #fafafa;
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.5rem 0.9375rem;
  margin: -0.5rem -0.9375rem;
  margin-inline-end: 0.9375rem;
  color: #111111;
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.5rem 0;
  margin-bottom: 0;
  line-height: 1.7142857143;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: 2.25rem;
  padding: 0.375rem 0.9375rem;
  font-size: 0.8125rem;
  border-radius: 0;
}
.form-control-sm::file-selector-button {
  padding: 0.375rem 0.9375rem;
  margin: -0.375rem -0.9375rem;
  margin-inline-end: 0.9375rem;
}

.form-control-lg {
  min-height: 2.875rem;
  padding: 0.6875rem 0.9375rem;
  font-size: 0.9375rem;
  border-radius: 0;
}
.form-control-lg::file-selector-button {
  padding: 0.6875rem 0.9375rem;
  margin: -0.6875rem -0.9375rem;
  margin-inline-end: 0.9375rem;
}

textarea.form-control {
  min-height: 2.5rem;
}
textarea.form-control-sm {
  min-height: 2.25rem;
}
textarea.form-control-lg {
  min-height: 2.875rem;
}

.form-control-color {
  width: 3rem;
  height: 2.5rem;
  padding: 0.5rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 0;
}
.form-control-color.form-control-sm {
  height: 2.25rem;
}
.form-control-color.form-control-lg {
  height: 2.875rem;
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.5rem 2.75rem 0.5rem 0.9375rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.7142857143;
  color: #111111;
  appearance: none;
  background-color: transparent;
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.625rem center;
  background-size: 24px 24px;
  border: var(--bs-border-width) solid #dedede;
  border-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: #304ffe;
  outline: 0;
  box-shadow: none;
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.9375rem;
  background-image: none;
}
.form-select:disabled {
  background-color: #fafafa;
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #111111;
}

.form-select-sm, .input-group-sm > .form-select {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  padding-left: 0.9375rem;
  font-size: 0.8125rem;
  border-radius: 0;
}

.form-select-lg, .input-group-lg > .form-select {
  padding-top: 0.6875rem;
  padding-bottom: 0.6875rem;
  padding-left: 0.9375rem;
  font-size: 0.9375rem;
  border-radius: 0;
}

.form-check {
  display: block;
  min-height: 1.75rem;
  padding-left: 1.875rem;
  margin-bottom: 1rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.875rem;
}

.form-check-reverse {
  padding-right: 1.875rem;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.875rem;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: #fff;
  flex-shrink: 0;
  width: 1.125rem;
  height: 1.125rem;
  margin-top: 0.3125rem;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid #b6b6b6;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-check-input {
    transition: none;
  }
}
.form-check-input[type=checkbox] {
  border-radius: 0;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #304ffe;
  outline: 0;
  box-shadow: none;
}
.form-check-input:checked {
  background-color: #fff;
  border-color: #b6b6b6;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #fff;
  border-color: #b6b6b6;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 1;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-check-label {
  color: rgba(17, 17, 17, 0.84);
  cursor: pointer;
}

.form-switch {
  padding-left: 3.25rem;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  width: 2.25rem;
  margin-left: -3.25rem;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2.25rem;
  transition: background-position 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch.form-check-reverse {
  padding-right: 3.25rem;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -3.25rem;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1.9375rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, none;
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, none;
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #343434;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #c2c2c2;
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #343434;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #c2c2c2;
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.9375rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.9375rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.46875rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: transparent;
  border-radius: 0;
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: #fafafa;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.9375rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.7142857143;
  color: rgba(17, 17, 17, 0.64);
  text-align: center;
  white-space: nowrap;
  background-color: #f2f2f2;
  border: var(--bs-border-width) solid #dedede;
  border-radius: 0;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.6875rem 0.9375rem;
  font-size: 0.9375rem;
  border-radius: 0;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.375rem 0.9375rem;
  font-size: 0.8125rem;
  border-radius: 0;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3.6875rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.5rem;
  font-size: 0.6875rem;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.375rem 1rem;
  margin-top: 0.1rem;
  font-size: 0.75rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: 0.1875rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.7142857143em + 1rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: right calc(0.4285714286em + -0.0625rem) center;
  background-size: calc(0.8571428572em + 0.5rem) calc(0.8571428572em + 0.5rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.7142857143em + 1rem);
  background-position: top calc(0.4285714286em + -0.0625rem) right calc(0.4285714286em + -0.0625rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  padding-right: 5.09375rem;
  background-position: right 0.625rem center, center right 2.75rem;
  background-size: 24px 24px, 32px 32px;
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.7142857143em + 1rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.5rem;
  font-size: 0.6875rem;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.375rem 1rem;
  margin-top: 0.1rem;
  font-size: 0.75rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: 0.1875rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.7142857143em + 1rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.4285714286em + -0.0625rem) center;
  background-size: calc(0.8571428572em + 0.5rem) calc(0.8571428572em + 0.5rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.7142857143em + 1rem);
  background-position: top calc(0.4285714286em + -0.0625rem) right calc(0.4285714286em + -0.0625rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  padding-right: 5.09375rem;
  background-position: right 0.625rem center, center right 2.75rem;
  background-size: 24px 24px, 32px 32px;
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.7142857143em + 1rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 1.25rem;
  --bs-btn-padding-y: 0.3125rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 2;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.3125rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.5;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  text-decoration: none;
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0b5ed7;
  --bs-btn-hover-border-color: #0a58ca;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a58ca;
  --bs-btn-active-border-color: #0a53be;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5c636a;
  --bs-btn-hover-border-color: #565e64;
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #565e64;
  --bs-btn-active-border-color: #51585e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #000;
  --bs-btn-bg: #2ee68c;
  --bs-btn-border-color: #2ee68c;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #4dea9d;
  --bs-btn-hover-border-color: #43e998;
  --bs-btn-focus-shadow-rgb: 39, 196, 119;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #58eba3;
  --bs-btn-active-border-color: #43e998;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #2ee68c;
  --bs-btn-disabled-border-color: #2ee68c;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #4fc3f7;
  --bs-btn-border-color: #4fc3f7;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #69ccf8;
  --bs-btn-hover-border-color: #61c9f8;
  --bs-btn-focus-shadow-rgb: 67, 166, 210;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #72cff9;
  --bs-btn-active-border-color: #61c9f8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #4fc3f7;
  --bs-btn-disabled-border-color: #4fc3f7;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffee5c;
  --bs-btn-border-color: #ffee5c;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #fff174;
  --bs-btn-hover-border-color: #fff06c;
  --bs-btn-focus-shadow-rgb: 217, 202, 78;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #fff17d;
  --bs-btn-active-border-color: #fff06c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffee5c;
  --bs-btn-disabled-border-color: #ffee5c;
}

.btn-danger {
  --bs-btn-color: #000;
  --bs-btn-bg: #ff7591;
  --bs-btn-border-color: #ff7591;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ff8aa2;
  --bs-btn-hover-border-color: #ff839c;
  --bs-btn-focus-shadow-rgb: 217, 99, 123;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ff91a7;
  --bs-btn-active-border-color: #ff839c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ff7591;
  --bs-btn-disabled-border-color: #ff7591;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f2f2f2;
  --bs-btn-border-color: #f2f2f2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #cecece;
  --bs-btn-hover-border-color: #c2c2c2;
  --bs-btn-focus-shadow-rgb: 206, 206, 206;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c2c2c2;
  --bs-btn-active-border-color: #b6b6b6;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f2f2f2;
  --bs-btn-disabled-border-color: #f2f2f2;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #111111;
  --bs-btn-border-color: #111111;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #353535;
  --bs-btn-hover-border-color: #292929;
  --bs-btn-focus-shadow-rgb: 53, 53, 53;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #414141;
  --bs-btn-active-border-color: #292929;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #111111;
  --bs-btn-disabled-border-color: #111111;
}

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #2ee68c;
  --bs-btn-border-color: #2ee68c;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #2ee68c;
  --bs-btn-hover-border-color: #2ee68c;
  --bs-btn-focus-shadow-rgb: 46, 230, 140;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #2ee68c;
  --bs-btn-active-border-color: #2ee68c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #2ee68c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #2ee68c;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #4fc3f7;
  --bs-btn-border-color: #4fc3f7;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #4fc3f7;
  --bs-btn-hover-border-color: #4fc3f7;
  --bs-btn-focus-shadow-rgb: 79, 195, 247;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #4fc3f7;
  --bs-btn-active-border-color: #4fc3f7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #4fc3f7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #4fc3f7;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffee5c;
  --bs-btn-border-color: #ffee5c;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffee5c;
  --bs-btn-hover-border-color: #ffee5c;
  --bs-btn-focus-shadow-rgb: 255, 238, 92;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffee5c;
  --bs-btn-active-border-color: #ffee5c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffee5c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffee5c;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #ff7591;
  --bs-btn-border-color: #ff7591;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ff7591;
  --bs-btn-hover-border-color: #ff7591;
  --bs-btn-focus-shadow-rgb: 255, 117, 145;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ff7591;
  --bs-btn-active-border-color: #ff7591;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ff7591;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ff7591;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f2f2f2;
  --bs-btn-border-color: #f2f2f2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f2f2f2;
  --bs-btn-hover-border-color: #f2f2f2;
  --bs-btn-focus-shadow-rgb: 242, 242, 242;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f2f2f2;
  --bs-btn-active-border-color: #f2f2f2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f2f2f2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f2f2f2;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #111111;
  --bs-btn-border-color: #111111;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #111111;
  --bs-btn-hover-border-color: #111111;
  --bs-btn-focus-shadow-rgb: 17, 17, 17;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #111111;
  --bs-btn-active-border-color: #111111;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #111111;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #111111;
  --bs-gradient: none;
}

.btn-link, .btn-brand-quartenary,
.btn-darker-quartenary,
.btn-standard-quartenary {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 38, 75, 198;
  text-decoration: none;
}
.btn-link:hover, .btn-brand-quartenary:hover,
.btn-darker-quartenary:hover,
.btn-standard-quartenary:hover, .btn-link:focus-visible, .btn-brand-quartenary:focus-visible,
.btn-darker-quartenary:focus-visible,
.btn-standard-quartenary:focus-visible {
  text-decoration: underline;
}
.btn-link:focus-visible, .btn-brand-quartenary:focus-visible,
.btn-darker-quartenary:focus-visible,
.btn-standard-quartenary:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover, .btn-brand-quartenary:hover,
.btn-darker-quartenary:hover,
.btn-standard-quartenary:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1.5625rem;
  --bs-btn-font-size: 0.9375rem;
  --bs-btn-border-radius: 0.3125rem;
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.3125rem;
  --bs-btn-padding-x: 1.125rem;
  --bs-btn-font-size: 0.8125rem;
  --bs-btn-border-radius: 0.3125rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.875rem;
  --bs-dropdown-color: rgba(17, 17, 17, 0.64);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: 0;
  --bs-dropdown-border-width: 0;
  --bs-dropdown-inner-border-radius: calc(0 - 0);
  --bs-dropdown-divider-bg: #ededed;
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 1.25rem 1.875rem rgba(35, 35, 35, 0.2);
  --bs-dropdown-link-color: rgba(17, 17, 17, 0.64);
  --bs-dropdown-link-hover-color: #111111;
  --bs-dropdown-link-hover-bg: #fafafa;
  --bs-dropdown-link-active-color: #111111;
  --bs-dropdown-link-active-bg: #f2f2f2;
  --bs-dropdown-link-disabled-color: rgba(17, 17, 17, 0.4);
  --bs-dropdown-item-padding-x: 0.9375rem;
  --bs-dropdown-item-padding-y: 0.5rem;
  --bs-dropdown-header-color: #111111;
  --bs-dropdown-header-padding-x: 0.9375rem;
  --bs-dropdown-header-padding-y: 0.75rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: rgba(255, 255, 255, 0.64);
  --bs-dropdown-bg: #232323;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: 0 1.25rem 1.875rem rgba(17, 17, 17, 0.6);
  --bs-dropdown-link-color: rgba(255, 255, 255, 0.64);
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: #404040;
  --bs-dropdown-link-hover-bg: #343434;
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #404040;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.3125rem;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.84375rem;
  padding-left: 0.84375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 1.171875rem;
  padding-left: 1.171875rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1.25rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-size: 0.875rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: rgba(17, 17, 17, 0.64);
  --bs-nav-link-hover-color: #111111;
  --bs-nav-link-disabled-color: rgba(17, 17, 17, 0.5);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
  text-decoration: none;
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: none;
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: #cccccc;
  --bs-nav-tabs-border-radius: 0;
  --bs-nav-tabs-link-hover-border-color: #111111 #111111 transparent;
  --bs-nav-tabs-link-active-color: rgba(17, 17, 17, 0.84);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: #cccccc #cccccc transparent;
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: 0;
  --bs-nav-pills-link-active-color: rgba(255, 255, 255, 0.92);
  --bs-nav-pills-link-active-bg: #666666;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.3125rem;
  --bs-navbar-color: rgba(17, 17, 17, 0.64);
  --bs-navbar-hover-color: #111111;
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(17, 17, 17, 0.92);
  --bs-navbar-brand-padding-y: 0;
  --bs-navbar-brand-margin-end: 1.5625rem;
  --bs-navbar-brand-font-size: 1rem;
  --bs-navbar-brand-color: #111111;
  --bs-navbar-brand-hover-color: rgba(17, 17, 17, 0.92);
  --bs-navbar-nav-link-padding-x: 0.625rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: 0.3125rem;
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
  text-decoration: none;
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-size: 0.875rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.card {
  --bs-card-spacer-y: 1.25rem;
  --bs-card-spacer-x: 1.5625rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: 0;
  --bs-card-border-color: #dedede;
  --bs-card-border-radius: 0;
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: 0;
  --bs-card-cap-padding-y: 0.625rem;
  --bs-card-cap-padding-x: 1.5625rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1.5625rem;
  --bs-card-group-margin: 0.9375rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: #111111;
  --bs-accordion-bg: #fff;
  --bs-accordion-transition: border-radius 0.15s ease;
  --bs-accordion-border-color: #dedede;
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: 0;
  --bs-accordion-inner-border-radius: 0.75rem;
  --bs-accordion-btn-padding-x: 1.1875rem;
  --bs-accordion-btn-padding-y: 0.6875rem;
  --bs-accordion-btn-color: #111111;
  --bs-accordion-btn-bg: #fff;
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-accordion-btn-icon-width: 1.5rem;
  --bs-accordion-btn-icon-transform: rotate(180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-accordion-btn-focus-border-color: #304ffe;
  --bs-accordion-btn-focus-box-shadow: none;
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: #111111;
  --bs-accordion-active-bg: #fff;
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-font-size: 0.75rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: rgba(17, 17, 17, 0.5);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, url(${___CSS_LOADER_URL_REPLACEMENT_12___})) /* rtl: var(--bs-breadcrumb-divider, url('data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" width="9" height="9"%3e%3cpath fill="none" stroke="%23111111" stroke-linecap="square" d="m2.8 1 3.5 3.5L2.8 8" opacity=".4"/%3e%3c/svg%3e')) */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.9rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 0.8125rem;
  --bs-pagination-color: rgba(17, 17, 17, 0.64);
  --bs-pagination-bg: transparent;
  --bs-pagination-border-width: 0;
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: #111111;
  --bs-pagination-hover-bg: rgba(17, 17, 17, 0.06);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: rgba(17, 17, 17, 0.64);
  --bs-pagination-focus-bg: transparent;
  --bs-pagination-focus-box-shadow: none;
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #111111;
  --bs-pagination-active-border-color: #343434;
  --bs-pagination-disabled-color: rgba(17, 17, 17, 0.5);
  --bs-pagination-disabled-bg: transparent;
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: none;
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  text-decoration: none;
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(0 * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.9rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.9em;
  --bs-badge-padding-y: 0.3em;
  --bs-badge-font-size: 62.5%;
  --bs-badge-font-weight: normal;
  --bs-badge-color: #111111;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1.25rem;
  --bs-alert-padding-y: 0.5rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 0.1875rem;
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 300;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3.75rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.625rem 1.25rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.3125rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 0.3125rem;
  --bs-progress-font-size: 0.6875rem;
  --bs-progress-bg: #ededed;
  --bs-progress-border-radius: 0;
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #767676;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: rgba(17, 17, 17, 0.64);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: #f2f2f2;
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: 0;
  --bs-list-group-item-padding-x: 0.9375rem;
  --bs-list-group-item-padding-y: 0;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: #111111;
  --bs-list-group-action-hover-bg: #f2f2f2;
  --bs-list-group-action-active-color: rgba(17, 17, 17, 0.84);
  --bs-list-group-action-active-bg: #fafafa;
  --bs-list-group-disabled-color: #111111;
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: rgba(17, 17, 17, 0.84);
  --bs-list-group-active-bg: #fafafa;
  --bs-list-group-active-border-color: #f2f2f2;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #111111;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.8;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 0.5;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0 0;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1.5rem auto no-repeat;
  border: 0;
  border-radius: 0.3125rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 0.75rem;
  --bs-toast-max-width: 255px;
  --bs-toast-font-size: 0.8125rem;
  --bs-toast-color: rgba(255, 255, 255, 0.64);
  --bs-toast-bg: #232323;
  --bs-toast-border-width: 0;
  --bs-toast-border-color: transparent;
  --bs-toast-border-radius: 0;
  --bs-toast-box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);
  --bs-toast-header-color: #fff;
  --bs-toast-header-bg: transparent;
  --bs-toast-header-border-color: #404040;
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 540px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: transparent;
  --bs-modal-border-width: 0;
  --bs-modal-border-radius: 0.3125rem;
  --bs-modal-box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);
  --bs-modal-inner-border-radius: 0.3125rem;
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: transparent;
  --bs-modal-header-border-width: 0;
  --bs-modal-title-line-height: 1.75;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: #ededed;
  --bs-modal-footer-border-width: 1px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 285px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 980px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1110px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 1rem;
  --bs-tooltip-padding-y: 0.375rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.75rem;
  --bs-tooltip-color: #fff;
  --bs-tooltip-bg: #343434;
  --bs-tooltip-border-radius: 0.1875rem;
  --bs-tooltip-opacity: 1;
  --bs-tooltip-arrow-width: 0.875rem;
  --bs-tooltip-arrow-height: 0.4375rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: "Roboto", Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-style: normal;
  font-weight: 400;
  line-height: 1.75;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 240px;
  --bs-popover-font-size: 0.8125rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: 0px;
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: 0.3125rem;
  --bs-popover-inner-border-radius: calc(0.3125rem - 0px);
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: #111111;
  --bs-popover-header-bg: transparent;
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1.1875rem;
  --bs-popover-arrow-height: 0.625rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: "Roboto", Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-style: normal;
  font-weight: 400;
  line-height: 1.75;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.2em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.2em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 320px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 0.9375rem;
  --bs-offcanvas-padding-y: 1.125rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: 1px;
  --bs-offcanvas-border-color: #ededed;
  --bs-offcanvas-box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.75;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.8;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #000 !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #000 !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(7, 55, 127, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(7, 55, 127, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(54, 59, 63, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(54, 59, 63, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(151, 243, 198, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(151, 243, 198, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(167, 225, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(167, 225, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 247, 174, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 247, 174, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(255, 186, 200, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 186, 200, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(249, 249, 249, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 249, 249, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(9, 9, 9, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(9, 9, 9, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-10 {
  opacity: 0.1 !important;
}

.opacity-20 {
  opacity: 0.2 !important;
}

.opacity-30 {
  opacity: 0.3 !important;
}

.opacity-40 {
  opacity: 0.4 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-60 {
  opacity: 0.6 !important;
}

.opacity-70 {
  opacity: 0.7 !important;
}

.opacity-80 {
  opacity: 0.8 !important;
}

.opacity-90 {
  opacity: 0.9 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2) !important;
}

.shadow-xs {
  box-shadow: 0 0.625rem 1.25rem rgba(35, 35, 35, 0.08) !important;
}

.shadow-sm {
  box-shadow: 0 0.5625rem 0.875rem rgba(35, 35, 35, 0.14) !important;
}

.shadow-lg {
  box-shadow: 0 1.25rem 1.875rem rgba(35, 35, 35, 0.2) !important;
}

.shadow-xl {
  box-shadow: 0 1.875rem 2.5rem rgba(35, 35, 35, 0.26) !important;
}

.shadow-dark-xs {
  box-shadow: 0 0.625rem 1.25rem rgba(17, 17, 17, 0.5) !important;
}

.shadow-dark-sm {
  box-shadow: 0 0.5625rem 0.875rem rgba(17, 17, 17, 0.5) !important;
}

.shadow-dark {
  box-shadow: 0 0.75rem 1rem rgba(17, 17, 17, 0.5) !important;
}

.shadow-dark-lg {
  box-shadow: 0 1.25rem 1.875rem rgba(17, 17, 17, 0.6) !important;
}

.shadow-dark-xl {
  box-shadow: 0 1.875rem 2.5rem rgba(17, 17, 17, 0.7) !important;
}

.shadow-nm-up {
  box-shadow: 12px 12px 24px rgba(0, 0, 0, 0.12), -12px -12px 24px #fff !important;
}

.shadow-nm-down {
  box-shadow: inset 8px 8px 12px rgba(0, 0, 0, 0.12), inset -8px -8px 12px rgba(255, 255, 255, 0.54) !important;
}

.shadow-nm-dark-up {
  box-shadow: 12px 12px 24px 0 rgba(0, 0, 0, 0.6), -12px -12px 24px 0 rgba(255, 255, 255, 0.06) !important;
}

.shadow-nm-dark-down {
  box-shadow: inset 8px 8px 12px 0 rgba(0, 0, 0, 0.32), inset -8px -8px 12px 0 rgba(255, 255, 255, 0.04) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: #ededed !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.125rem !important;
}

.m-2 {
  margin: 0.25rem !important;
}

.m-3 {
  margin: 0.5rem !important;
}

.m-4 {
  margin: 1rem !important;
}

.m-5 {
  margin: 1.5rem !important;
}

.m-6 {
  margin: 2rem !important;
}

.m-7 {
  margin: 2.5rem !important;
}

.m-8 {
  margin: 3rem !important;
}

.m-9 {
  margin: 3.5rem !important;
}

.m-10 {
  margin: 4rem !important;
}

.m-11 {
  margin: 5rem !important;
}

.m-12 {
  margin: 6rem !important;
}

.m-13 {
  margin: 6.5rem !important;
}

.m-14 {
  margin: 8rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.125rem !important;
  margin-left: 0.125rem !important;
}

.mx-2 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-3 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-4 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-5 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-6 {
  margin-right: 2rem !important;
  margin-left: 2rem !important;
}

.mx-7 {
  margin-right: 2.5rem !important;
  margin-left: 2.5rem !important;
}

.mx-8 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-9 {
  margin-right: 3.5rem !important;
  margin-left: 3.5rem !important;
}

.mx-10 {
  margin-right: 4rem !important;
  margin-left: 4rem !important;
}

.mx-11 {
  margin-right: 5rem !important;
  margin-left: 5rem !important;
}

.mx-12 {
  margin-right: 6rem !important;
  margin-left: 6rem !important;
}

.mx-13 {
  margin-right: 6.5rem !important;
  margin-left: 6.5rem !important;
}

.mx-14 {
  margin-right: 8rem !important;
  margin-left: 8rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.125rem !important;
  margin-bottom: 0.125rem !important;
}

.my-2 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-3 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-5 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-6 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}

.my-7 {
  margin-top: 2.5rem !important;
  margin-bottom: 2.5rem !important;
}

.my-8 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-9 {
  margin-top: 3.5rem !important;
  margin-bottom: 3.5rem !important;
}

.my-10 {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}

.my-11 {
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}

.my-12 {
  margin-top: 6rem !important;
  margin-bottom: 6rem !important;
}

.my-13 {
  margin-top: 6.5rem !important;
  margin-bottom: 6.5rem !important;
}

.my-14 {
  margin-top: 8rem !important;
  margin-bottom: 8rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.125rem !important;
}

.mt-2 {
  margin-top: 0.25rem !important;
}

.mt-3 {
  margin-top: 0.5rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.5rem !important;
}

.mt-6 {
  margin-top: 2rem !important;
}

.mt-7 {
  margin-top: 2.5rem !important;
}

.mt-8 {
  margin-top: 3rem !important;
}

.mt-9 {
  margin-top: 3.5rem !important;
}

.mt-10 {
  margin-top: 4rem !important;
}

.mt-11 {
  margin-top: 5rem !important;
}

.mt-12 {
  margin-top: 6rem !important;
}

.mt-13 {
  margin-top: 6.5rem !important;
}

.mt-14 {
  margin-top: 8rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.125rem !important;
}

.me-2 {
  margin-right: 0.25rem !important;
}

.me-3 {
  margin-right: 0.5rem !important;
}

.me-4 {
  margin-right: 1rem !important;
}

.me-5 {
  margin-right: 1.5rem !important;
}

.me-6 {
  margin-right: 2rem !important;
}

.me-7 {
  margin-right: 2.5rem !important;
}

.me-8 {
  margin-right: 3rem !important;
}

.me-9 {
  margin-right: 3.5rem !important;
}

.me-10 {
  margin-right: 4rem !important;
}

.me-11 {
  margin-right: 5rem !important;
}

.me-12 {
  margin-right: 6rem !important;
}

.me-13 {
  margin-right: 6.5rem !important;
}

.me-14 {
  margin-right: 8rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.125rem !important;
}

.mb-2 {
  margin-bottom: 0.25rem !important;
}

.mb-3 {
  margin-bottom: 0.5rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.5rem !important;
}

.mb-6 {
  margin-bottom: 2rem !important;
}

.mb-7 {
  margin-bottom: 2.5rem !important;
}

.mb-8 {
  margin-bottom: 3rem !important;
}

.mb-9 {
  margin-bottom: 3.5rem !important;
}

.mb-10 {
  margin-bottom: 4rem !important;
}

.mb-11 {
  margin-bottom: 5rem !important;
}

.mb-12 {
  margin-bottom: 6rem !important;
}

.mb-13 {
  margin-bottom: 6.5rem !important;
}

.mb-14 {
  margin-bottom: 8rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.125rem !important;
}

.ms-2 {
  margin-left: 0.25rem !important;
}

.ms-3 {
  margin-left: 0.5rem !important;
}

.ms-4 {
  margin-left: 1rem !important;
}

.ms-5 {
  margin-left: 1.5rem !important;
}

.ms-6 {
  margin-left: 2rem !important;
}

.ms-7 {
  margin-left: 2.5rem !important;
}

.ms-8 {
  margin-left: 3rem !important;
}

.ms-9 {
  margin-left: 3.5rem !important;
}

.ms-10 {
  margin-left: 4rem !important;
}

.ms-11 {
  margin-left: 5rem !important;
}

.ms-12 {
  margin-left: 6rem !important;
}

.ms-13 {
  margin-left: 6.5rem !important;
}

.ms-14 {
  margin-left: 8rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.125rem !important;
}

.m-n2 {
  margin: -0.25rem !important;
}

.m-n3 {
  margin: -0.5rem !important;
}

.m-n4 {
  margin: -1rem !important;
}

.m-n5 {
  margin: -1.5rem !important;
}

.m-n6 {
  margin: -2rem !important;
}

.m-n7 {
  margin: -2.5rem !important;
}

.m-n8 {
  margin: -3rem !important;
}

.m-n9 {
  margin: -3.5rem !important;
}

.m-n10 {
  margin: -4rem !important;
}

.m-n11 {
  margin: -5rem !important;
}

.m-n12 {
  margin: -6rem !important;
}

.m-n13 {
  margin: -6.5rem !important;
}

.m-n14 {
  margin: -8rem !important;
}

.mx-n1 {
  margin-right: -0.125rem !important;
  margin-left: -0.125rem !important;
}

.mx-n2 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n3 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n4 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n5 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n6 {
  margin-right: -2rem !important;
  margin-left: -2rem !important;
}

.mx-n7 {
  margin-right: -2.5rem !important;
  margin-left: -2.5rem !important;
}

.mx-n8 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.mx-n9 {
  margin-right: -3.5rem !important;
  margin-left: -3.5rem !important;
}

.mx-n10 {
  margin-right: -4rem !important;
  margin-left: -4rem !important;
}

.mx-n11 {
  margin-right: -5rem !important;
  margin-left: -5rem !important;
}

.mx-n12 {
  margin-right: -6rem !important;
  margin-left: -6rem !important;
}

.mx-n13 {
  margin-right: -6.5rem !important;
  margin-left: -6.5rem !important;
}

.mx-n14 {
  margin-right: -8rem !important;
  margin-left: -8rem !important;
}

.my-n1 {
  margin-top: -0.125rem !important;
  margin-bottom: -0.125rem !important;
}

.my-n2 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n3 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n4 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n5 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n6 {
  margin-top: -2rem !important;
  margin-bottom: -2rem !important;
}

.my-n7 {
  margin-top: -2.5rem !important;
  margin-bottom: -2.5rem !important;
}

.my-n8 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.my-n9 {
  margin-top: -3.5rem !important;
  margin-bottom: -3.5rem !important;
}

.my-n10 {
  margin-top: -4rem !important;
  margin-bottom: -4rem !important;
}

.my-n11 {
  margin-top: -5rem !important;
  margin-bottom: -5rem !important;
}

.my-n12 {
  margin-top: -6rem !important;
  margin-bottom: -6rem !important;
}

.my-n13 {
  margin-top: -6.5rem !important;
  margin-bottom: -6.5rem !important;
}

.my-n14 {
  margin-top: -8rem !important;
  margin-bottom: -8rem !important;
}

.mt-n1 {
  margin-top: -0.125rem !important;
}

.mt-n2 {
  margin-top: -0.25rem !important;
}

.mt-n3 {
  margin-top: -0.5rem !important;
}

.mt-n4 {
  margin-top: -1rem !important;
}

.mt-n5 {
  margin-top: -1.5rem !important;
}

.mt-n6 {
  margin-top: -2rem !important;
}

.mt-n7 {
  margin-top: -2.5rem !important;
}

.mt-n8 {
  margin-top: -3rem !important;
}

.mt-n9 {
  margin-top: -3.5rem !important;
}

.mt-n10 {
  margin-top: -4rem !important;
}

.mt-n11 {
  margin-top: -5rem !important;
}

.mt-n12 {
  margin-top: -6rem !important;
}

.mt-n13 {
  margin-top: -6.5rem !important;
}

.mt-n14 {
  margin-top: -8rem !important;
}

.me-n1 {
  margin-right: -0.125rem !important;
}

.me-n2 {
  margin-right: -0.25rem !important;
}

.me-n3 {
  margin-right: -0.5rem !important;
}

.me-n4 {
  margin-right: -1rem !important;
}

.me-n5 {
  margin-right: -1.5rem !important;
}

.me-n6 {
  margin-right: -2rem !important;
}

.me-n7 {
  margin-right: -2.5rem !important;
}

.me-n8 {
  margin-right: -3rem !important;
}

.me-n9 {
  margin-right: -3.5rem !important;
}

.me-n10 {
  margin-right: -4rem !important;
}

.me-n11 {
  margin-right: -5rem !important;
}

.me-n12 {
  margin-right: -6rem !important;
}

.me-n13 {
  margin-right: -6.5rem !important;
}

.me-n14 {
  margin-right: -8rem !important;
}

.mb-n1 {
  margin-bottom: -0.125rem !important;
}

.mb-n2 {
  margin-bottom: -0.25rem !important;
}

.mb-n3 {
  margin-bottom: -0.5rem !important;
}

.mb-n4 {
  margin-bottom: -1rem !important;
}

.mb-n5 {
  margin-bottom: -1.5rem !important;
}

.mb-n6 {
  margin-bottom: -2rem !important;
}

.mb-n7 {
  margin-bottom: -2.5rem !important;
}

.mb-n8 {
  margin-bottom: -3rem !important;
}

.mb-n9 {
  margin-bottom: -3.5rem !important;
}

.mb-n10 {
  margin-bottom: -4rem !important;
}

.mb-n11 {
  margin-bottom: -5rem !important;
}

.mb-n12 {
  margin-bottom: -6rem !important;
}

.mb-n13 {
  margin-bottom: -6.5rem !important;
}

.mb-n14 {
  margin-bottom: -8rem !important;
}

.ms-n1 {
  margin-left: -0.125rem !important;
}

.ms-n2 {
  margin-left: -0.25rem !important;
}

.ms-n3 {
  margin-left: -0.5rem !important;
}

.ms-n4 {
  margin-left: -1rem !important;
}

.ms-n5 {
  margin-left: -1.5rem !important;
}

.ms-n6 {
  margin-left: -2rem !important;
}

.ms-n7 {
  margin-left: -2.5rem !important;
}

.ms-n8 {
  margin-left: -3rem !important;
}

.ms-n9 {
  margin-left: -3.5rem !important;
}

.ms-n10 {
  margin-left: -4rem !important;
}

.ms-n11 {
  margin-left: -5rem !important;
}

.ms-n12 {
  margin-left: -6rem !important;
}

.ms-n13 {
  margin-left: -6.5rem !important;
}

.ms-n14 {
  margin-left: -8rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.125rem !important;
}

.p-2 {
  padding: 0.25rem !important;
}

.p-3 {
  padding: 0.5rem !important;
}

.p-4 {
  padding: 1rem !important;
}

.p-5 {
  padding: 1.5rem !important;
}

.p-6 {
  padding: 2rem !important;
}

.p-7 {
  padding: 2.5rem !important;
}

.p-8 {
  padding: 3rem !important;
}

.p-9 {
  padding: 3.5rem !important;
}

.p-10 {
  padding: 4rem !important;
}

.p-11 {
  padding: 5rem !important;
}

.p-12 {
  padding: 6rem !important;
}

.p-13 {
  padding: 6.5rem !important;
}

.p-14 {
  padding: 8rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.125rem !important;
  padding-left: 0.125rem !important;
}

.px-2 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-3 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-4 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-5 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-6 {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}

.px-7 {
  padding-right: 2.5rem !important;
  padding-left: 2.5rem !important;
}

.px-8 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.px-9 {
  padding-right: 3.5rem !important;
  padding-left: 3.5rem !important;
}

.px-10 {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}

.px-11 {
  padding-right: 5rem !important;
  padding-left: 5rem !important;
}

.px-12 {
  padding-right: 6rem !important;
  padding-left: 6rem !important;
}

.px-13 {
  padding-right: 6.5rem !important;
  padding-left: 6.5rem !important;
}

.px-14 {
  padding-right: 8rem !important;
  padding-left: 8rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.125rem !important;
  padding-bottom: 0.125rem !important;
}

.py-2 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-3 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-5 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-6 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.py-7 {
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}

.py-8 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.py-9 {
  padding-top: 3.5rem !important;
  padding-bottom: 3.5rem !important;
}

.py-10 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}

.py-11 {
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}

.py-12 {
  padding-top: 6rem !important;
  padding-bottom: 6rem !important;
}

.py-13 {
  padding-top: 6.5rem !important;
  padding-bottom: 6.5rem !important;
}

.py-14 {
  padding-top: 8rem !important;
  padding-bottom: 8rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.125rem !important;
}

.pt-2 {
  padding-top: 0.25rem !important;
}

.pt-3 {
  padding-top: 0.5rem !important;
}

.pt-4 {
  padding-top: 1rem !important;
}

.pt-5 {
  padding-top: 1.5rem !important;
}

.pt-6 {
  padding-top: 2rem !important;
}

.pt-7 {
  padding-top: 2.5rem !important;
}

.pt-8 {
  padding-top: 3rem !important;
}

.pt-9 {
  padding-top: 3.5rem !important;
}

.pt-10 {
  padding-top: 4rem !important;
}

.pt-11 {
  padding-top: 5rem !important;
}

.pt-12 {
  padding-top: 6rem !important;
}

.pt-13 {
  padding-top: 6.5rem !important;
}

.pt-14 {
  padding-top: 8rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.125rem !important;
}

.pe-2 {
  padding-right: 0.25rem !important;
}

.pe-3 {
  padding-right: 0.5rem !important;
}

.pe-4 {
  padding-right: 1rem !important;
}

.pe-5 {
  padding-right: 1.5rem !important;
}

.pe-6 {
  padding-right: 2rem !important;
}

.pe-7 {
  padding-right: 2.5rem !important;
}

.pe-8 {
  padding-right: 3rem !important;
}

.pe-9 {
  padding-right: 3.5rem !important;
}

.pe-10 {
  padding-right: 4rem !important;
}

.pe-11 {
  padding-right: 5rem !important;
}

.pe-12 {
  padding-right: 6rem !important;
}

.pe-13 {
  padding-right: 6.5rem !important;
}

.pe-14 {
  padding-right: 8rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.125rem !important;
}

.pb-2 {
  padding-bottom: 0.25rem !important;
}

.pb-3 {
  padding-bottom: 0.5rem !important;
}

.pb-4 {
  padding-bottom: 1rem !important;
}

.pb-5 {
  padding-bottom: 1.5rem !important;
}

.pb-6 {
  padding-bottom: 2rem !important;
}

.pb-7 {
  padding-bottom: 2.5rem !important;
}

.pb-8 {
  padding-bottom: 3rem !important;
}

.pb-9 {
  padding-bottom: 3.5rem !important;
}

.pb-10 {
  padding-bottom: 4rem !important;
}

.pb-11 {
  padding-bottom: 5rem !important;
}

.pb-12 {
  padding-bottom: 6rem !important;
}

.pb-13 {
  padding-bottom: 6.5rem !important;
}

.pb-14 {
  padding-bottom: 8rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.125rem !important;
}

.ps-2 {
  padding-left: 0.25rem !important;
}

.ps-3 {
  padding-left: 0.5rem !important;
}

.ps-4 {
  padding-left: 1rem !important;
}

.ps-5 {
  padding-left: 1.5rem !important;
}

.ps-6 {
  padding-left: 2rem !important;
}

.ps-7 {
  padding-left: 2.5rem !important;
}

.ps-8 {
  padding-left: 3rem !important;
}

.ps-9 {
  padding-left: 3.5rem !important;
}

.ps-10 {
  padding-left: 4rem !important;
}

.ps-11 {
  padding-left: 5rem !important;
}

.ps-12 {
  padding-left: 6rem !important;
}

.ps-13 {
  padding-left: 6.5rem !important;
}

.ps-14 {
  padding-left: 8rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.125rem !important;
}

.gap-2 {
  gap: 0.25rem !important;
}

.gap-3 {
  gap: 0.5rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.5rem !important;
}

.gap-6 {
  gap: 2rem !important;
}

.gap-7 {
  gap: 2.5rem !important;
}

.gap-8 {
  gap: 3rem !important;
}

.gap-9 {
  gap: 3.5rem !important;
}

.gap-10 {
  gap: 4rem !important;
}

.gap-11 {
  gap: 5rem !important;
}

.gap-12 {
  gap: 6rem !important;
}

.gap-13 {
  gap: 6.5rem !important;
}

.gap-14 {
  gap: 8rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.125rem !important;
}

.row-gap-2 {
  row-gap: 0.25rem !important;
}

.row-gap-3 {
  row-gap: 0.5rem !important;
}

.row-gap-4 {
  row-gap: 1rem !important;
}

.row-gap-5 {
  row-gap: 1.5rem !important;
}

.row-gap-6 {
  row-gap: 2rem !important;
}

.row-gap-7 {
  row-gap: 2.5rem !important;
}

.row-gap-8 {
  row-gap: 3rem !important;
}

.row-gap-9 {
  row-gap: 3.5rem !important;
}

.row-gap-10 {
  row-gap: 4rem !important;
}

.row-gap-11 {
  row-gap: 5rem !important;
}

.row-gap-12 {
  row-gap: 6rem !important;
}

.row-gap-13 {
  row-gap: 6.5rem !important;
}

.row-gap-14 {
  row-gap: 8rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.125rem !important;
}

.column-gap-2 {
  column-gap: 0.25rem !important;
}

.column-gap-3 {
  column-gap: 0.5rem !important;
}

.column-gap-4 {
  column-gap: 1rem !important;
}

.column-gap-5 {
  column-gap: 1.5rem !important;
}

.column-gap-6 {
  column-gap: 2rem !important;
}

.column-gap-7 {
  column-gap: 2.5rem !important;
}

.column-gap-8 {
  column-gap: 3rem !important;
}

.column-gap-9 {
  column-gap: 3.5rem !important;
}

.column-gap-10 {
  column-gap: 4rem !important;
}

.column-gap-11 {
  column-gap: 5rem !important;
}

.column-gap-12 {
  column-gap: 6rem !important;
}

.column-gap-13 {
  column-gap: 6.5rem !important;
}

.column-gap-14 {
  column-gap: 8rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: 2rem !important;
}

.fs-2 {
  font-size: 1.8125rem !important;
}

.fs-3 {
  font-size: 1.625rem !important;
}

.fs-4 {
  font-size: 1.4375rem !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 0.875rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-1-125 {
  line-height: 1.125 !important;
}

.lh-1-25 {
  line-height: 1.25 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-1-375 {
  line-height: 1.375 !important;
}

.lh-1-5 {
  line-height: 1.5 !important;
}

.lh-1-625 {
  line-height: 1.625 !important;
}

.lh-1-75 {
  line-height: 1.75 !important;
}

.lh-base {
  line-height: 1.75 !important;
}

.lh-1-875 {
  line-height: 1.875 !important;
}

.lh-2 {
  line-height: 2 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: #fff !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: #fafafa !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-tertiary {
  --bs-bg-opacity: 1;
  background-color: #f2f2f2 !important;
}

.bg-quartenary {
  --bs-bg-opacity: 1;
  background-color: #ededed !important;
}

.bg-quinary {
  --bs-bg-opacity: 1;
  background-color: #dedede !important;
}

.bg-bp-yellow {
  --bs-bg-opacity: 1;
  background-color: #ffe600 !important;
}

.bg-bp-green-logo {
  --bs-bg-opacity: 1;
  background-color: #009900 !important;
}

.bg-bp-green {
  --bs-bg-opacity: 1;
  background-color: #007f00 !important;
}

.bg-bp-light-green {
  --bs-bg-opacity: 1;
  background-color: #99cc00 !important;
}

.bg-almost-dark {
  --bs-bg-opacity: 1;
  background-color: #1d1d1d !important;
}

.bg-dark-secondary {
  --bs-bg-opacity: 1;
  background-color: #121212 !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-xs) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-6 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-7 {
  border-radius: var(--bs-border-radius-3xl) !important;
}

.rounded-8 {
  border-radius: var(--bs-border-radius-4xl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-xs) !important;
  border-top-right-radius: var(--bs-border-radius-xs) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-6 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-7 {
  border-top-left-radius: var(--bs-border-radius-3xl) !important;
  border-top-right-radius: var(--bs-border-radius-3xl) !important;
}

.rounded-top-8 {
  border-top-left-radius: var(--bs-border-radius-4xl) !important;
  border-top-right-radius: var(--bs-border-radius-4xl) !important;
}

.rounded-end {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-1 {
  border-bottom-right-radius: var(--bs-border-radius-xs) !important;
  border-top-right-radius: var(--bs-border-radius-xs) !important;
}

.rounded-end-2 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-3 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-4 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-5 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-6 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-7 {
  border-bottom-right-radius: var(--bs-border-radius-3xl) !important;
  border-top-right-radius: var(--bs-border-radius-3xl) !important;
}

.rounded-end-8 {
  border-bottom-right-radius: var(--bs-border-radius-4xl) !important;
  border-top-right-radius: var(--bs-border-radius-4xl) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-xs) !important;
  border-bottom-left-radius: var(--bs-border-radius-xs) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-6 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-7 {
  border-bottom-right-radius: var(--bs-border-radius-3xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-3xl) !important;
}

.rounded-bottom-8 {
  border-bottom-right-radius: var(--bs-border-radius-4xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-4xl) !important;
}

.rounded-start {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-1 {
  border-top-left-radius: var(--bs-border-radius-xs) !important;
  border-bottom-left-radius: var(--bs-border-radius-xs) !important;
}

.rounded-start-2 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-3 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-4 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-5 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-6 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-7 {
  border-top-left-radius: var(--bs-border-radius-3xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-3xl) !important;
}

.rounded-start-8 {
  border-top-left-radius: var(--bs-border-radius-4xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-4xl) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

.rounded-top-left {
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-top-left-1 {
  border-top-left-radius: var(--bs-border-radius-xs) !important;
}

.rounded-top-left-2 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-left-3 {
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-top-left-4 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-left-5 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-left-6 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-left-7 {
  border-top-left-radius: var(--bs-border-radius-3xl) !important;
}

.rounded-top-left-8 {
  border-top-left-radius: var(--bs-border-radius-4xl) !important;
}

.rounded-top-right {
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-right-1 {
  border-top-right-radius: var(--bs-border-radius-xs) !important;
}

.rounded-top-right-2 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-right-3 {
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-right-4 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-right-5 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-right-6 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-right-7 {
  border-top-right-radius: var(--bs-border-radius-3xl) !important;
}

.rounded-top-right-8 {
  border-top-right-radius: var(--bs-border-radius-4xl) !important;
}

.rounded-bottom-right {
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-right-1 {
  border-bottom-right-radius: var(--bs-border-radius-xs) !important;
}

.rounded-bottom-right-2 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-right-3 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-right-4 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-right-5 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-right-6 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-right-7 {
  border-bottom-right-radius: var(--bs-border-radius-3xl) !important;
}

.rounded-bottom-right-8 {
  border-bottom-right-radius: var(--bs-border-radius-4xl) !important;
}

.rounded-bottom-left {
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-left-1 {
  border-bottom-left-radius: var(--bs-border-radius-xs) !important;
}

.rounded-bottom-left-2 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-left-3 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-left-4 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-left-5 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-left-6 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-left-7 {
  border-bottom-left-radius: var(--bs-border-radius-3xl) !important;
}

.rounded-bottom-left-8 {
  border-bottom-left-radius: var(--bs-border-radius-4xl) !important;
}

.ls-0 {
  letter-spacing: 0 !important;
}

.ls-0-3 {
  letter-spacing: 0.3px !important;
}

.ls-1 {
  letter-spacing: 1px !important;
}

.ls-1-2 {
  letter-spacing: 1.2px !important;
}

.ls-1-5 {
  letter-spacing: 1.5px !important;
}

.ls-2 {
  letter-spacing: 2px !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.125rem !important;
  }
  .m-sm-2 {
    margin: 0.25rem !important;
  }
  .m-sm-3 {
    margin: 0.5rem !important;
  }
  .m-sm-4 {
    margin: 1rem !important;
  }
  .m-sm-5 {
    margin: 1.5rem !important;
  }
  .m-sm-6 {
    margin: 2rem !important;
  }
  .m-sm-7 {
    margin: 2.5rem !important;
  }
  .m-sm-8 {
    margin: 3rem !important;
  }
  .m-sm-9 {
    margin: 3.5rem !important;
  }
  .m-sm-10 {
    margin: 4rem !important;
  }
  .m-sm-11 {
    margin: 5rem !important;
  }
  .m-sm-12 {
    margin: 6rem !important;
  }
  .m-sm-13 {
    margin: 6.5rem !important;
  }
  .m-sm-14 {
    margin: 8rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.125rem !important;
    margin-left: 0.125rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-3 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-5 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-6 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-sm-7 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-sm-8 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-9 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-sm-10 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-sm-11 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-sm-12 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-sm-13 {
    margin-right: 6.5rem !important;
    margin-left: 6.5rem !important;
  }
  .mx-sm-14 {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.125rem !important;
    margin-bottom: 0.125rem !important;
  }
  .my-sm-2 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-3 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-5 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-6 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-sm-7 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-sm-8 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-9 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-sm-10 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-sm-11 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-sm-12 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-sm-13 {
    margin-top: 6.5rem !important;
    margin-bottom: 6.5rem !important;
  }
  .my-sm-14 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.125rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-3 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-4 {
    margin-top: 1rem !important;
  }
  .mt-sm-5 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-6 {
    margin-top: 2rem !important;
  }
  .mt-sm-7 {
    margin-top: 2.5rem !important;
  }
  .mt-sm-8 {
    margin-top: 3rem !important;
  }
  .mt-sm-9 {
    margin-top: 3.5rem !important;
  }
  .mt-sm-10 {
    margin-top: 4rem !important;
  }
  .mt-sm-11 {
    margin-top: 5rem !important;
  }
  .mt-sm-12 {
    margin-top: 6rem !important;
  }
  .mt-sm-13 {
    margin-top: 6.5rem !important;
  }
  .mt-sm-14 {
    margin-top: 8rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.125rem !important;
  }
  .me-sm-2 {
    margin-right: 0.25rem !important;
  }
  .me-sm-3 {
    margin-right: 0.5rem !important;
  }
  .me-sm-4 {
    margin-right: 1rem !important;
  }
  .me-sm-5 {
    margin-right: 1.5rem !important;
  }
  .me-sm-6 {
    margin-right: 2rem !important;
  }
  .me-sm-7 {
    margin-right: 2.5rem !important;
  }
  .me-sm-8 {
    margin-right: 3rem !important;
  }
  .me-sm-9 {
    margin-right: 3.5rem !important;
  }
  .me-sm-10 {
    margin-right: 4rem !important;
  }
  .me-sm-11 {
    margin-right: 5rem !important;
  }
  .me-sm-12 {
    margin-right: 6rem !important;
  }
  .me-sm-13 {
    margin-right: 6.5rem !important;
  }
  .me-sm-14 {
    margin-right: 8rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.125rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-6 {
    margin-bottom: 2rem !important;
  }
  .mb-sm-7 {
    margin-bottom: 2.5rem !important;
  }
  .mb-sm-8 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-9 {
    margin-bottom: 3.5rem !important;
  }
  .mb-sm-10 {
    margin-bottom: 4rem !important;
  }
  .mb-sm-11 {
    margin-bottom: 5rem !important;
  }
  .mb-sm-12 {
    margin-bottom: 6rem !important;
  }
  .mb-sm-13 {
    margin-bottom: 6.5rem !important;
  }
  .mb-sm-14 {
    margin-bottom: 8rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.125rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-3 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-4 {
    margin-left: 1rem !important;
  }
  .ms-sm-5 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-6 {
    margin-left: 2rem !important;
  }
  .ms-sm-7 {
    margin-left: 2.5rem !important;
  }
  .ms-sm-8 {
    margin-left: 3rem !important;
  }
  .ms-sm-9 {
    margin-left: 3.5rem !important;
  }
  .ms-sm-10 {
    margin-left: 4rem !important;
  }
  .ms-sm-11 {
    margin-left: 5rem !important;
  }
  .ms-sm-12 {
    margin-left: 6rem !important;
  }
  .ms-sm-13 {
    margin-left: 6.5rem !important;
  }
  .ms-sm-14 {
    margin-left: 8rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.125rem !important;
  }
  .m-sm-n2 {
    margin: -0.25rem !important;
  }
  .m-sm-n3 {
    margin: -0.5rem !important;
  }
  .m-sm-n4 {
    margin: -1rem !important;
  }
  .m-sm-n5 {
    margin: -1.5rem !important;
  }
  .m-sm-n6 {
    margin: -2rem !important;
  }
  .m-sm-n7 {
    margin: -2.5rem !important;
  }
  .m-sm-n8 {
    margin: -3rem !important;
  }
  .m-sm-n9 {
    margin: -3.5rem !important;
  }
  .m-sm-n10 {
    margin: -4rem !important;
  }
  .m-sm-n11 {
    margin: -5rem !important;
  }
  .m-sm-n12 {
    margin: -6rem !important;
  }
  .m-sm-n13 {
    margin: -6.5rem !important;
  }
  .m-sm-n14 {
    margin: -8rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.125rem !important;
    margin-left: -0.125rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-sm-n3 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-sm-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-sm-n5 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n6 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-sm-n7 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-sm-n8 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-sm-n9 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-sm-n10 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-sm-n11 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .mx-sm-n12 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-sm-n13 {
    margin-right: -6.5rem !important;
    margin-left: -6.5rem !important;
  }
  .mx-sm-n14 {
    margin-right: -8rem !important;
    margin-left: -8rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.125rem !important;
    margin-bottom: -0.125rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-sm-n3 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-sm-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-sm-n5 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n6 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-sm-n7 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-sm-n8 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-sm-n9 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-sm-n10 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-sm-n11 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .my-sm-n12 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-sm-n13 {
    margin-top: -6.5rem !important;
    margin-bottom: -6.5rem !important;
  }
  .my-sm-n14 {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.125rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.25rem !important;
  }
  .mt-sm-n3 {
    margin-top: -0.5rem !important;
  }
  .mt-sm-n4 {
    margin-top: -1rem !important;
  }
  .mt-sm-n5 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n6 {
    margin-top: -2rem !important;
  }
  .mt-sm-n7 {
    margin-top: -2.5rem !important;
  }
  .mt-sm-n8 {
    margin-top: -3rem !important;
  }
  .mt-sm-n9 {
    margin-top: -3.5rem !important;
  }
  .mt-sm-n10 {
    margin-top: -4rem !important;
  }
  .mt-sm-n11 {
    margin-top: -5rem !important;
  }
  .mt-sm-n12 {
    margin-top: -6rem !important;
  }
  .mt-sm-n13 {
    margin-top: -6.5rem !important;
  }
  .mt-sm-n14 {
    margin-top: -8rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.125rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.25rem !important;
  }
  .me-sm-n3 {
    margin-right: -0.5rem !important;
  }
  .me-sm-n4 {
    margin-right: -1rem !important;
  }
  .me-sm-n5 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n6 {
    margin-right: -2rem !important;
  }
  .me-sm-n7 {
    margin-right: -2.5rem !important;
  }
  .me-sm-n8 {
    margin-right: -3rem !important;
  }
  .me-sm-n9 {
    margin-right: -3.5rem !important;
  }
  .me-sm-n10 {
    margin-right: -4rem !important;
  }
  .me-sm-n11 {
    margin-right: -5rem !important;
  }
  .me-sm-n12 {
    margin-right: -6rem !important;
  }
  .me-sm-n13 {
    margin-right: -6.5rem !important;
  }
  .me-sm-n14 {
    margin-right: -8rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.125rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.25rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -0.5rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n6 {
    margin-bottom: -2rem !important;
  }
  .mb-sm-n7 {
    margin-bottom: -2.5rem !important;
  }
  .mb-sm-n8 {
    margin-bottom: -3rem !important;
  }
  .mb-sm-n9 {
    margin-bottom: -3.5rem !important;
  }
  .mb-sm-n10 {
    margin-bottom: -4rem !important;
  }
  .mb-sm-n11 {
    margin-bottom: -5rem !important;
  }
  .mb-sm-n12 {
    margin-bottom: -6rem !important;
  }
  .mb-sm-n13 {
    margin-bottom: -6.5rem !important;
  }
  .mb-sm-n14 {
    margin-bottom: -8rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.125rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.25rem !important;
  }
  .ms-sm-n3 {
    margin-left: -0.5rem !important;
  }
  .ms-sm-n4 {
    margin-left: -1rem !important;
  }
  .ms-sm-n5 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n6 {
    margin-left: -2rem !important;
  }
  .ms-sm-n7 {
    margin-left: -2.5rem !important;
  }
  .ms-sm-n8 {
    margin-left: -3rem !important;
  }
  .ms-sm-n9 {
    margin-left: -3.5rem !important;
  }
  .ms-sm-n10 {
    margin-left: -4rem !important;
  }
  .ms-sm-n11 {
    margin-left: -5rem !important;
  }
  .ms-sm-n12 {
    margin-left: -6rem !important;
  }
  .ms-sm-n13 {
    margin-left: -6.5rem !important;
  }
  .ms-sm-n14 {
    margin-left: -8rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.125rem !important;
  }
  .p-sm-2 {
    padding: 0.25rem !important;
  }
  .p-sm-3 {
    padding: 0.5rem !important;
  }
  .p-sm-4 {
    padding: 1rem !important;
  }
  .p-sm-5 {
    padding: 1.5rem !important;
  }
  .p-sm-6 {
    padding: 2rem !important;
  }
  .p-sm-7 {
    padding: 2.5rem !important;
  }
  .p-sm-8 {
    padding: 3rem !important;
  }
  .p-sm-9 {
    padding: 3.5rem !important;
  }
  .p-sm-10 {
    padding: 4rem !important;
  }
  .p-sm-11 {
    padding: 5rem !important;
  }
  .p-sm-12 {
    padding: 6rem !important;
  }
  .p-sm-13 {
    padding: 6.5rem !important;
  }
  .p-sm-14 {
    padding: 8rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.125rem !important;
    padding-left: 0.125rem !important;
  }
  .px-sm-2 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-3 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-5 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-6 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-sm-7 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-sm-8 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-sm-9 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-sm-10 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-sm-11 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .px-sm-12 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-sm-13 {
    padding-right: 6.5rem !important;
    padding-left: 6.5rem !important;
  }
  .px-sm-14 {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.125rem !important;
    padding-bottom: 0.125rem !important;
  }
  .py-sm-2 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-3 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-5 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-6 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-sm-7 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-sm-8 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-sm-9 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-sm-10 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-sm-11 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .py-sm-12 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-sm-13 {
    padding-top: 6.5rem !important;
    padding-bottom: 6.5rem !important;
  }
  .py-sm-14 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.125rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-3 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-4 {
    padding-top: 1rem !important;
  }
  .pt-sm-5 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-6 {
    padding-top: 2rem !important;
  }
  .pt-sm-7 {
    padding-top: 2.5rem !important;
  }
  .pt-sm-8 {
    padding-top: 3rem !important;
  }
  .pt-sm-9 {
    padding-top: 3.5rem !important;
  }
  .pt-sm-10 {
    padding-top: 4rem !important;
  }
  .pt-sm-11 {
    padding-top: 5rem !important;
  }
  .pt-sm-12 {
    padding-top: 6rem !important;
  }
  .pt-sm-13 {
    padding-top: 6.5rem !important;
  }
  .pt-sm-14 {
    padding-top: 8rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.125rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-3 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-4 {
    padding-right: 1rem !important;
  }
  .pe-sm-5 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-6 {
    padding-right: 2rem !important;
  }
  .pe-sm-7 {
    padding-right: 2.5rem !important;
  }
  .pe-sm-8 {
    padding-right: 3rem !important;
  }
  .pe-sm-9 {
    padding-right: 3.5rem !important;
  }
  .pe-sm-10 {
    padding-right: 4rem !important;
  }
  .pe-sm-11 {
    padding-right: 5rem !important;
  }
  .pe-sm-12 {
    padding-right: 6rem !important;
  }
  .pe-sm-13 {
    padding-right: 6.5rem !important;
  }
  .pe-sm-14 {
    padding-right: 8rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.125rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-6 {
    padding-bottom: 2rem !important;
  }
  .pb-sm-7 {
    padding-bottom: 2.5rem !important;
  }
  .pb-sm-8 {
    padding-bottom: 3rem !important;
  }
  .pb-sm-9 {
    padding-bottom: 3.5rem !important;
  }
  .pb-sm-10 {
    padding-bottom: 4rem !important;
  }
  .pb-sm-11 {
    padding-bottom: 5rem !important;
  }
  .pb-sm-12 {
    padding-bottom: 6rem !important;
  }
  .pb-sm-13 {
    padding-bottom: 6.5rem !important;
  }
  .pb-sm-14 {
    padding-bottom: 8rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.125rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-3 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-4 {
    padding-left: 1rem !important;
  }
  .ps-sm-5 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-6 {
    padding-left: 2rem !important;
  }
  .ps-sm-7 {
    padding-left: 2.5rem !important;
  }
  .ps-sm-8 {
    padding-left: 3rem !important;
  }
  .ps-sm-9 {
    padding-left: 3.5rem !important;
  }
  .ps-sm-10 {
    padding-left: 4rem !important;
  }
  .ps-sm-11 {
    padding-left: 5rem !important;
  }
  .ps-sm-12 {
    padding-left: 6rem !important;
  }
  .ps-sm-13 {
    padding-left: 6.5rem !important;
  }
  .ps-sm-14 {
    padding-left: 8rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.125rem !important;
  }
  .gap-sm-2 {
    gap: 0.25rem !important;
  }
  .gap-sm-3 {
    gap: 0.5rem !important;
  }
  .gap-sm-4 {
    gap: 1rem !important;
  }
  .gap-sm-5 {
    gap: 1.5rem !important;
  }
  .gap-sm-6 {
    gap: 2rem !important;
  }
  .gap-sm-7 {
    gap: 2.5rem !important;
  }
  .gap-sm-8 {
    gap: 3rem !important;
  }
  .gap-sm-9 {
    gap: 3.5rem !important;
  }
  .gap-sm-10 {
    gap: 4rem !important;
  }
  .gap-sm-11 {
    gap: 5rem !important;
  }
  .gap-sm-12 {
    gap: 6rem !important;
  }
  .gap-sm-13 {
    gap: 6.5rem !important;
  }
  .gap-sm-14 {
    gap: 8rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.125rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-6 {
    row-gap: 2rem !important;
  }
  .row-gap-sm-7 {
    row-gap: 2.5rem !important;
  }
  .row-gap-sm-8 {
    row-gap: 3rem !important;
  }
  .row-gap-sm-9 {
    row-gap: 3.5rem !important;
  }
  .row-gap-sm-10 {
    row-gap: 4rem !important;
  }
  .row-gap-sm-11 {
    row-gap: 5rem !important;
  }
  .row-gap-sm-12 {
    row-gap: 6rem !important;
  }
  .row-gap-sm-13 {
    row-gap: 6.5rem !important;
  }
  .row-gap-sm-14 {
    row-gap: 8rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.125rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-6 {
    column-gap: 2rem !important;
  }
  .column-gap-sm-7 {
    column-gap: 2.5rem !important;
  }
  .column-gap-sm-8 {
    column-gap: 3rem !important;
  }
  .column-gap-sm-9 {
    column-gap: 3.5rem !important;
  }
  .column-gap-sm-10 {
    column-gap: 4rem !important;
  }
  .column-gap-sm-11 {
    column-gap: 5rem !important;
  }
  .column-gap-sm-12 {
    column-gap: 6rem !important;
  }
  .column-gap-sm-13 {
    column-gap: 6.5rem !important;
  }
  .column-gap-sm-14 {
    column-gap: 8rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.125rem !important;
  }
  .m-md-2 {
    margin: 0.25rem !important;
  }
  .m-md-3 {
    margin: 0.5rem !important;
  }
  .m-md-4 {
    margin: 1rem !important;
  }
  .m-md-5 {
    margin: 1.5rem !important;
  }
  .m-md-6 {
    margin: 2rem !important;
  }
  .m-md-7 {
    margin: 2.5rem !important;
  }
  .m-md-8 {
    margin: 3rem !important;
  }
  .m-md-9 {
    margin: 3.5rem !important;
  }
  .m-md-10 {
    margin: 4rem !important;
  }
  .m-md-11 {
    margin: 5rem !important;
  }
  .m-md-12 {
    margin: 6rem !important;
  }
  .m-md-13 {
    margin: 6.5rem !important;
  }
  .m-md-14 {
    margin: 8rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.125rem !important;
    margin-left: 0.125rem !important;
  }
  .mx-md-2 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-3 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-5 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-6 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-md-7 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-md-8 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-9 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-md-10 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-md-11 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-md-12 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-md-13 {
    margin-right: 6.5rem !important;
    margin-left: 6.5rem !important;
  }
  .mx-md-14 {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.125rem !important;
    margin-bottom: 0.125rem !important;
  }
  .my-md-2 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-3 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-5 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-6 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-md-7 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-md-8 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-9 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-md-10 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-md-11 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-md-12 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-md-13 {
    margin-top: 6.5rem !important;
    margin-bottom: 6.5rem !important;
  }
  .my-md-14 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.125rem !important;
  }
  .mt-md-2 {
    margin-top: 0.25rem !important;
  }
  .mt-md-3 {
    margin-top: 0.5rem !important;
  }
  .mt-md-4 {
    margin-top: 1rem !important;
  }
  .mt-md-5 {
    margin-top: 1.5rem !important;
  }
  .mt-md-6 {
    margin-top: 2rem !important;
  }
  .mt-md-7 {
    margin-top: 2.5rem !important;
  }
  .mt-md-8 {
    margin-top: 3rem !important;
  }
  .mt-md-9 {
    margin-top: 3.5rem !important;
  }
  .mt-md-10 {
    margin-top: 4rem !important;
  }
  .mt-md-11 {
    margin-top: 5rem !important;
  }
  .mt-md-12 {
    margin-top: 6rem !important;
  }
  .mt-md-13 {
    margin-top: 6.5rem !important;
  }
  .mt-md-14 {
    margin-top: 8rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.125rem !important;
  }
  .me-md-2 {
    margin-right: 0.25rem !important;
  }
  .me-md-3 {
    margin-right: 0.5rem !important;
  }
  .me-md-4 {
    margin-right: 1rem !important;
  }
  .me-md-5 {
    margin-right: 1.5rem !important;
  }
  .me-md-6 {
    margin-right: 2rem !important;
  }
  .me-md-7 {
    margin-right: 2.5rem !important;
  }
  .me-md-8 {
    margin-right: 3rem !important;
  }
  .me-md-9 {
    margin-right: 3.5rem !important;
  }
  .me-md-10 {
    margin-right: 4rem !important;
  }
  .me-md-11 {
    margin-right: 5rem !important;
  }
  .me-md-12 {
    margin-right: 6rem !important;
  }
  .me-md-13 {
    margin-right: 6.5rem !important;
  }
  .me-md-14 {
    margin-right: 8rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.125rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-3 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1rem !important;
  }
  .mb-md-5 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-6 {
    margin-bottom: 2rem !important;
  }
  .mb-md-7 {
    margin-bottom: 2.5rem !important;
  }
  .mb-md-8 {
    margin-bottom: 3rem !important;
  }
  .mb-md-9 {
    margin-bottom: 3.5rem !important;
  }
  .mb-md-10 {
    margin-bottom: 4rem !important;
  }
  .mb-md-11 {
    margin-bottom: 5rem !important;
  }
  .mb-md-12 {
    margin-bottom: 6rem !important;
  }
  .mb-md-13 {
    margin-bottom: 6.5rem !important;
  }
  .mb-md-14 {
    margin-bottom: 8rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.125rem !important;
  }
  .ms-md-2 {
    margin-left: 0.25rem !important;
  }
  .ms-md-3 {
    margin-left: 0.5rem !important;
  }
  .ms-md-4 {
    margin-left: 1rem !important;
  }
  .ms-md-5 {
    margin-left: 1.5rem !important;
  }
  .ms-md-6 {
    margin-left: 2rem !important;
  }
  .ms-md-7 {
    margin-left: 2.5rem !important;
  }
  .ms-md-8 {
    margin-left: 3rem !important;
  }
  .ms-md-9 {
    margin-left: 3.5rem !important;
  }
  .ms-md-10 {
    margin-left: 4rem !important;
  }
  .ms-md-11 {
    margin-left: 5rem !important;
  }
  .ms-md-12 {
    margin-left: 6rem !important;
  }
  .ms-md-13 {
    margin-left: 6.5rem !important;
  }
  .ms-md-14 {
    margin-left: 8rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.125rem !important;
  }
  .m-md-n2 {
    margin: -0.25rem !important;
  }
  .m-md-n3 {
    margin: -0.5rem !important;
  }
  .m-md-n4 {
    margin: -1rem !important;
  }
  .m-md-n5 {
    margin: -1.5rem !important;
  }
  .m-md-n6 {
    margin: -2rem !important;
  }
  .m-md-n7 {
    margin: -2.5rem !important;
  }
  .m-md-n8 {
    margin: -3rem !important;
  }
  .m-md-n9 {
    margin: -3.5rem !important;
  }
  .m-md-n10 {
    margin: -4rem !important;
  }
  .m-md-n11 {
    margin: -5rem !important;
  }
  .m-md-n12 {
    margin: -6rem !important;
  }
  .m-md-n13 {
    margin: -6.5rem !important;
  }
  .m-md-n14 {
    margin: -8rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.125rem !important;
    margin-left: -0.125rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-md-n3 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-md-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-md-n5 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n6 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-md-n7 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-md-n8 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-md-n9 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-md-n10 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-md-n11 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .mx-md-n12 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-md-n13 {
    margin-right: -6.5rem !important;
    margin-left: -6.5rem !important;
  }
  .mx-md-n14 {
    margin-right: -8rem !important;
    margin-left: -8rem !important;
  }
  .my-md-n1 {
    margin-top: -0.125rem !important;
    margin-bottom: -0.125rem !important;
  }
  .my-md-n2 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-md-n3 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-md-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-md-n5 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n6 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-md-n7 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-md-n8 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-md-n9 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-md-n10 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-md-n11 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .my-md-n12 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-md-n13 {
    margin-top: -6.5rem !important;
    margin-bottom: -6.5rem !important;
  }
  .my-md-n14 {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.125rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.25rem !important;
  }
  .mt-md-n3 {
    margin-top: -0.5rem !important;
  }
  .mt-md-n4 {
    margin-top: -1rem !important;
  }
  .mt-md-n5 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n6 {
    margin-top: -2rem !important;
  }
  .mt-md-n7 {
    margin-top: -2.5rem !important;
  }
  .mt-md-n8 {
    margin-top: -3rem !important;
  }
  .mt-md-n9 {
    margin-top: -3.5rem !important;
  }
  .mt-md-n10 {
    margin-top: -4rem !important;
  }
  .mt-md-n11 {
    margin-top: -5rem !important;
  }
  .mt-md-n12 {
    margin-top: -6rem !important;
  }
  .mt-md-n13 {
    margin-top: -6.5rem !important;
  }
  .mt-md-n14 {
    margin-top: -8rem !important;
  }
  .me-md-n1 {
    margin-right: -0.125rem !important;
  }
  .me-md-n2 {
    margin-right: -0.25rem !important;
  }
  .me-md-n3 {
    margin-right: -0.5rem !important;
  }
  .me-md-n4 {
    margin-right: -1rem !important;
  }
  .me-md-n5 {
    margin-right: -1.5rem !important;
  }
  .me-md-n6 {
    margin-right: -2rem !important;
  }
  .me-md-n7 {
    margin-right: -2.5rem !important;
  }
  .me-md-n8 {
    margin-right: -3rem !important;
  }
  .me-md-n9 {
    margin-right: -3.5rem !important;
  }
  .me-md-n10 {
    margin-right: -4rem !important;
  }
  .me-md-n11 {
    margin-right: -5rem !important;
  }
  .me-md-n12 {
    margin-right: -6rem !important;
  }
  .me-md-n13 {
    margin-right: -6.5rem !important;
  }
  .me-md-n14 {
    margin-right: -8rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.125rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.25rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -0.5rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n6 {
    margin-bottom: -2rem !important;
  }
  .mb-md-n7 {
    margin-bottom: -2.5rem !important;
  }
  .mb-md-n8 {
    margin-bottom: -3rem !important;
  }
  .mb-md-n9 {
    margin-bottom: -3.5rem !important;
  }
  .mb-md-n10 {
    margin-bottom: -4rem !important;
  }
  .mb-md-n11 {
    margin-bottom: -5rem !important;
  }
  .mb-md-n12 {
    margin-bottom: -6rem !important;
  }
  .mb-md-n13 {
    margin-bottom: -6.5rem !important;
  }
  .mb-md-n14 {
    margin-bottom: -8rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.125rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.25rem !important;
  }
  .ms-md-n3 {
    margin-left: -0.5rem !important;
  }
  .ms-md-n4 {
    margin-left: -1rem !important;
  }
  .ms-md-n5 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n6 {
    margin-left: -2rem !important;
  }
  .ms-md-n7 {
    margin-left: -2.5rem !important;
  }
  .ms-md-n8 {
    margin-left: -3rem !important;
  }
  .ms-md-n9 {
    margin-left: -3.5rem !important;
  }
  .ms-md-n10 {
    margin-left: -4rem !important;
  }
  .ms-md-n11 {
    margin-left: -5rem !important;
  }
  .ms-md-n12 {
    margin-left: -6rem !important;
  }
  .ms-md-n13 {
    margin-left: -6.5rem !important;
  }
  .ms-md-n14 {
    margin-left: -8rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.125rem !important;
  }
  .p-md-2 {
    padding: 0.25rem !important;
  }
  .p-md-3 {
    padding: 0.5rem !important;
  }
  .p-md-4 {
    padding: 1rem !important;
  }
  .p-md-5 {
    padding: 1.5rem !important;
  }
  .p-md-6 {
    padding: 2rem !important;
  }
  .p-md-7 {
    padding: 2.5rem !important;
  }
  .p-md-8 {
    padding: 3rem !important;
  }
  .p-md-9 {
    padding: 3.5rem !important;
  }
  .p-md-10 {
    padding: 4rem !important;
  }
  .p-md-11 {
    padding: 5rem !important;
  }
  .p-md-12 {
    padding: 6rem !important;
  }
  .p-md-13 {
    padding: 6.5rem !important;
  }
  .p-md-14 {
    padding: 8rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.125rem !important;
    padding-left: 0.125rem !important;
  }
  .px-md-2 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-3 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-5 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-6 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-md-7 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-md-8 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-md-9 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-md-10 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-md-11 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .px-md-12 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-md-13 {
    padding-right: 6.5rem !important;
    padding-left: 6.5rem !important;
  }
  .px-md-14 {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.125rem !important;
    padding-bottom: 0.125rem !important;
  }
  .py-md-2 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-3 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-5 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-6 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-md-7 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-md-8 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-md-9 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-md-10 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-md-11 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .py-md-12 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-md-13 {
    padding-top: 6.5rem !important;
    padding-bottom: 6.5rem !important;
  }
  .py-md-14 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.125rem !important;
  }
  .pt-md-2 {
    padding-top: 0.25rem !important;
  }
  .pt-md-3 {
    padding-top: 0.5rem !important;
  }
  .pt-md-4 {
    padding-top: 1rem !important;
  }
  .pt-md-5 {
    padding-top: 1.5rem !important;
  }
  .pt-md-6 {
    padding-top: 2rem !important;
  }
  .pt-md-7 {
    padding-top: 2.5rem !important;
  }
  .pt-md-8 {
    padding-top: 3rem !important;
  }
  .pt-md-9 {
    padding-top: 3.5rem !important;
  }
  .pt-md-10 {
    padding-top: 4rem !important;
  }
  .pt-md-11 {
    padding-top: 5rem !important;
  }
  .pt-md-12 {
    padding-top: 6rem !important;
  }
  .pt-md-13 {
    padding-top: 6.5rem !important;
  }
  .pt-md-14 {
    padding-top: 8rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.125rem !important;
  }
  .pe-md-2 {
    padding-right: 0.25rem !important;
  }
  .pe-md-3 {
    padding-right: 0.5rem !important;
  }
  .pe-md-4 {
    padding-right: 1rem !important;
  }
  .pe-md-5 {
    padding-right: 1.5rem !important;
  }
  .pe-md-6 {
    padding-right: 2rem !important;
  }
  .pe-md-7 {
    padding-right: 2.5rem !important;
  }
  .pe-md-8 {
    padding-right: 3rem !important;
  }
  .pe-md-9 {
    padding-right: 3.5rem !important;
  }
  .pe-md-10 {
    padding-right: 4rem !important;
  }
  .pe-md-11 {
    padding-right: 5rem !important;
  }
  .pe-md-12 {
    padding-right: 6rem !important;
  }
  .pe-md-13 {
    padding-right: 6.5rem !important;
  }
  .pe-md-14 {
    padding-right: 8rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.125rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-3 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1rem !important;
  }
  .pb-md-5 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-6 {
    padding-bottom: 2rem !important;
  }
  .pb-md-7 {
    padding-bottom: 2.5rem !important;
  }
  .pb-md-8 {
    padding-bottom: 3rem !important;
  }
  .pb-md-9 {
    padding-bottom: 3.5rem !important;
  }
  .pb-md-10 {
    padding-bottom: 4rem !important;
  }
  .pb-md-11 {
    padding-bottom: 5rem !important;
  }
  .pb-md-12 {
    padding-bottom: 6rem !important;
  }
  .pb-md-13 {
    padding-bottom: 6.5rem !important;
  }
  .pb-md-14 {
    padding-bottom: 8rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.125rem !important;
  }
  .ps-md-2 {
    padding-left: 0.25rem !important;
  }
  .ps-md-3 {
    padding-left: 0.5rem !important;
  }
  .ps-md-4 {
    padding-left: 1rem !important;
  }
  .ps-md-5 {
    padding-left: 1.5rem !important;
  }
  .ps-md-6 {
    padding-left: 2rem !important;
  }
  .ps-md-7 {
    padding-left: 2.5rem !important;
  }
  .ps-md-8 {
    padding-left: 3rem !important;
  }
  .ps-md-9 {
    padding-left: 3.5rem !important;
  }
  .ps-md-10 {
    padding-left: 4rem !important;
  }
  .ps-md-11 {
    padding-left: 5rem !important;
  }
  .ps-md-12 {
    padding-left: 6rem !important;
  }
  .ps-md-13 {
    padding-left: 6.5rem !important;
  }
  .ps-md-14 {
    padding-left: 8rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.125rem !important;
  }
  .gap-md-2 {
    gap: 0.25rem !important;
  }
  .gap-md-3 {
    gap: 0.5rem !important;
  }
  .gap-md-4 {
    gap: 1rem !important;
  }
  .gap-md-5 {
    gap: 1.5rem !important;
  }
  .gap-md-6 {
    gap: 2rem !important;
  }
  .gap-md-7 {
    gap: 2.5rem !important;
  }
  .gap-md-8 {
    gap: 3rem !important;
  }
  .gap-md-9 {
    gap: 3.5rem !important;
  }
  .gap-md-10 {
    gap: 4rem !important;
  }
  .gap-md-11 {
    gap: 5rem !important;
  }
  .gap-md-12 {
    gap: 6rem !important;
  }
  .gap-md-13 {
    gap: 6.5rem !important;
  }
  .gap-md-14 {
    gap: 8rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.125rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-3 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1rem !important;
  }
  .row-gap-md-5 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-6 {
    row-gap: 2rem !important;
  }
  .row-gap-md-7 {
    row-gap: 2.5rem !important;
  }
  .row-gap-md-8 {
    row-gap: 3rem !important;
  }
  .row-gap-md-9 {
    row-gap: 3.5rem !important;
  }
  .row-gap-md-10 {
    row-gap: 4rem !important;
  }
  .row-gap-md-11 {
    row-gap: 5rem !important;
  }
  .row-gap-md-12 {
    row-gap: 6rem !important;
  }
  .row-gap-md-13 {
    row-gap: 6.5rem !important;
  }
  .row-gap-md-14 {
    row-gap: 8rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.125rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-3 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1rem !important;
  }
  .column-gap-md-5 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-6 {
    column-gap: 2rem !important;
  }
  .column-gap-md-7 {
    column-gap: 2.5rem !important;
  }
  .column-gap-md-8 {
    column-gap: 3rem !important;
  }
  .column-gap-md-9 {
    column-gap: 3.5rem !important;
  }
  .column-gap-md-10 {
    column-gap: 4rem !important;
  }
  .column-gap-md-11 {
    column-gap: 5rem !important;
  }
  .column-gap-md-12 {
    column-gap: 6rem !important;
  }
  .column-gap-md-13 {
    column-gap: 6.5rem !important;
  }
  .column-gap-md-14 {
    column-gap: 8rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.125rem !important;
  }
  .m-lg-2 {
    margin: 0.25rem !important;
  }
  .m-lg-3 {
    margin: 0.5rem !important;
  }
  .m-lg-4 {
    margin: 1rem !important;
  }
  .m-lg-5 {
    margin: 1.5rem !important;
  }
  .m-lg-6 {
    margin: 2rem !important;
  }
  .m-lg-7 {
    margin: 2.5rem !important;
  }
  .m-lg-8 {
    margin: 3rem !important;
  }
  .m-lg-9 {
    margin: 3.5rem !important;
  }
  .m-lg-10 {
    margin: 4rem !important;
  }
  .m-lg-11 {
    margin: 5rem !important;
  }
  .m-lg-12 {
    margin: 6rem !important;
  }
  .m-lg-13 {
    margin: 6.5rem !important;
  }
  .m-lg-14 {
    margin: 8rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.125rem !important;
    margin-left: 0.125rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-3 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-5 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-6 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-lg-7 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-lg-8 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-9 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-lg-10 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-lg-11 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-lg-12 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-lg-13 {
    margin-right: 6.5rem !important;
    margin-left: 6.5rem !important;
  }
  .mx-lg-14 {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.125rem !important;
    margin-bottom: 0.125rem !important;
  }
  .my-lg-2 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-3 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-5 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-6 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-lg-7 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-lg-8 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-9 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-lg-10 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-lg-11 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-lg-12 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-lg-13 {
    margin-top: 6.5rem !important;
    margin-bottom: 6.5rem !important;
  }
  .my-lg-14 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.125rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-3 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-4 {
    margin-top: 1rem !important;
  }
  .mt-lg-5 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-6 {
    margin-top: 2rem !important;
  }
  .mt-lg-7 {
    margin-top: 2.5rem !important;
  }
  .mt-lg-8 {
    margin-top: 3rem !important;
  }
  .mt-lg-9 {
    margin-top: 3.5rem !important;
  }
  .mt-lg-10 {
    margin-top: 4rem !important;
  }
  .mt-lg-11 {
    margin-top: 5rem !important;
  }
  .mt-lg-12 {
    margin-top: 6rem !important;
  }
  .mt-lg-13 {
    margin-top: 6.5rem !important;
  }
  .mt-lg-14 {
    margin-top: 8rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.125rem !important;
  }
  .me-lg-2 {
    margin-right: 0.25rem !important;
  }
  .me-lg-3 {
    margin-right: 0.5rem !important;
  }
  .me-lg-4 {
    margin-right: 1rem !important;
  }
  .me-lg-5 {
    margin-right: 1.5rem !important;
  }
  .me-lg-6 {
    margin-right: 2rem !important;
  }
  .me-lg-7 {
    margin-right: 2.5rem !important;
  }
  .me-lg-8 {
    margin-right: 3rem !important;
  }
  .me-lg-9 {
    margin-right: 3.5rem !important;
  }
  .me-lg-10 {
    margin-right: 4rem !important;
  }
  .me-lg-11 {
    margin-right: 5rem !important;
  }
  .me-lg-12 {
    margin-right: 6rem !important;
  }
  .me-lg-13 {
    margin-right: 6.5rem !important;
  }
  .me-lg-14 {
    margin-right: 8rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.125rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-6 {
    margin-bottom: 2rem !important;
  }
  .mb-lg-7 {
    margin-bottom: 2.5rem !important;
  }
  .mb-lg-8 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-9 {
    margin-bottom: 3.5rem !important;
  }
  .mb-lg-10 {
    margin-bottom: 4rem !important;
  }
  .mb-lg-11 {
    margin-bottom: 5rem !important;
  }
  .mb-lg-12 {
    margin-bottom: 6rem !important;
  }
  .mb-lg-13 {
    margin-bottom: 6.5rem !important;
  }
  .mb-lg-14 {
    margin-bottom: 8rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.125rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-3 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-4 {
    margin-left: 1rem !important;
  }
  .ms-lg-5 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-6 {
    margin-left: 2rem !important;
  }
  .ms-lg-7 {
    margin-left: 2.5rem !important;
  }
  .ms-lg-8 {
    margin-left: 3rem !important;
  }
  .ms-lg-9 {
    margin-left: 3.5rem !important;
  }
  .ms-lg-10 {
    margin-left: 4rem !important;
  }
  .ms-lg-11 {
    margin-left: 5rem !important;
  }
  .ms-lg-12 {
    margin-left: 6rem !important;
  }
  .ms-lg-13 {
    margin-left: 6.5rem !important;
  }
  .ms-lg-14 {
    margin-left: 8rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.125rem !important;
  }
  .m-lg-n2 {
    margin: -0.25rem !important;
  }
  .m-lg-n3 {
    margin: -0.5rem !important;
  }
  .m-lg-n4 {
    margin: -1rem !important;
  }
  .m-lg-n5 {
    margin: -1.5rem !important;
  }
  .m-lg-n6 {
    margin: -2rem !important;
  }
  .m-lg-n7 {
    margin: -2.5rem !important;
  }
  .m-lg-n8 {
    margin: -3rem !important;
  }
  .m-lg-n9 {
    margin: -3.5rem !important;
  }
  .m-lg-n10 {
    margin: -4rem !important;
  }
  .m-lg-n11 {
    margin: -5rem !important;
  }
  .m-lg-n12 {
    margin: -6rem !important;
  }
  .m-lg-n13 {
    margin: -6.5rem !important;
  }
  .m-lg-n14 {
    margin: -8rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.125rem !important;
    margin-left: -0.125rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-lg-n3 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-lg-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-lg-n5 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n6 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-lg-n7 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-lg-n8 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-lg-n9 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-lg-n10 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-lg-n11 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .mx-lg-n12 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-lg-n13 {
    margin-right: -6.5rem !important;
    margin-left: -6.5rem !important;
  }
  .mx-lg-n14 {
    margin-right: -8rem !important;
    margin-left: -8rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.125rem !important;
    margin-bottom: -0.125rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-lg-n3 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-lg-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-lg-n5 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n6 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-lg-n7 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-lg-n8 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-lg-n9 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-lg-n10 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-lg-n11 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .my-lg-n12 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-lg-n13 {
    margin-top: -6.5rem !important;
    margin-bottom: -6.5rem !important;
  }
  .my-lg-n14 {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.125rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.25rem !important;
  }
  .mt-lg-n3 {
    margin-top: -0.5rem !important;
  }
  .mt-lg-n4 {
    margin-top: -1rem !important;
  }
  .mt-lg-n5 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n6 {
    margin-top: -2rem !important;
  }
  .mt-lg-n7 {
    margin-top: -2.5rem !important;
  }
  .mt-lg-n8 {
    margin-top: -3rem !important;
  }
  .mt-lg-n9 {
    margin-top: -3.5rem !important;
  }
  .mt-lg-n10 {
    margin-top: -4rem !important;
  }
  .mt-lg-n11 {
    margin-top: -5rem !important;
  }
  .mt-lg-n12 {
    margin-top: -6rem !important;
  }
  .mt-lg-n13 {
    margin-top: -6.5rem !important;
  }
  .mt-lg-n14 {
    margin-top: -8rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.125rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.25rem !important;
  }
  .me-lg-n3 {
    margin-right: -0.5rem !important;
  }
  .me-lg-n4 {
    margin-right: -1rem !important;
  }
  .me-lg-n5 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n6 {
    margin-right: -2rem !important;
  }
  .me-lg-n7 {
    margin-right: -2.5rem !important;
  }
  .me-lg-n8 {
    margin-right: -3rem !important;
  }
  .me-lg-n9 {
    margin-right: -3.5rem !important;
  }
  .me-lg-n10 {
    margin-right: -4rem !important;
  }
  .me-lg-n11 {
    margin-right: -5rem !important;
  }
  .me-lg-n12 {
    margin-right: -6rem !important;
  }
  .me-lg-n13 {
    margin-right: -6.5rem !important;
  }
  .me-lg-n14 {
    margin-right: -8rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.125rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.25rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -0.5rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n6 {
    margin-bottom: -2rem !important;
  }
  .mb-lg-n7 {
    margin-bottom: -2.5rem !important;
  }
  .mb-lg-n8 {
    margin-bottom: -3rem !important;
  }
  .mb-lg-n9 {
    margin-bottom: -3.5rem !important;
  }
  .mb-lg-n10 {
    margin-bottom: -4rem !important;
  }
  .mb-lg-n11 {
    margin-bottom: -5rem !important;
  }
  .mb-lg-n12 {
    margin-bottom: -6rem !important;
  }
  .mb-lg-n13 {
    margin-bottom: -6.5rem !important;
  }
  .mb-lg-n14 {
    margin-bottom: -8rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.125rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.25rem !important;
  }
  .ms-lg-n3 {
    margin-left: -0.5rem !important;
  }
  .ms-lg-n4 {
    margin-left: -1rem !important;
  }
  .ms-lg-n5 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n6 {
    margin-left: -2rem !important;
  }
  .ms-lg-n7 {
    margin-left: -2.5rem !important;
  }
  .ms-lg-n8 {
    margin-left: -3rem !important;
  }
  .ms-lg-n9 {
    margin-left: -3.5rem !important;
  }
  .ms-lg-n10 {
    margin-left: -4rem !important;
  }
  .ms-lg-n11 {
    margin-left: -5rem !important;
  }
  .ms-lg-n12 {
    margin-left: -6rem !important;
  }
  .ms-lg-n13 {
    margin-left: -6.5rem !important;
  }
  .ms-lg-n14 {
    margin-left: -8rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.125rem !important;
  }
  .p-lg-2 {
    padding: 0.25rem !important;
  }
  .p-lg-3 {
    padding: 0.5rem !important;
  }
  .p-lg-4 {
    padding: 1rem !important;
  }
  .p-lg-5 {
    padding: 1.5rem !important;
  }
  .p-lg-6 {
    padding: 2rem !important;
  }
  .p-lg-7 {
    padding: 2.5rem !important;
  }
  .p-lg-8 {
    padding: 3rem !important;
  }
  .p-lg-9 {
    padding: 3.5rem !important;
  }
  .p-lg-10 {
    padding: 4rem !important;
  }
  .p-lg-11 {
    padding: 5rem !important;
  }
  .p-lg-12 {
    padding: 6rem !important;
  }
  .p-lg-13 {
    padding: 6.5rem !important;
  }
  .p-lg-14 {
    padding: 8rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.125rem !important;
    padding-left: 0.125rem !important;
  }
  .px-lg-2 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-3 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-5 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-6 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-lg-7 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-lg-8 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-lg-9 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-lg-10 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-lg-11 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .px-lg-12 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-lg-13 {
    padding-right: 6.5rem !important;
    padding-left: 6.5rem !important;
  }
  .px-lg-14 {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.125rem !important;
    padding-bottom: 0.125rem !important;
  }
  .py-lg-2 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-3 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-5 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-6 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-lg-7 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-lg-8 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-lg-9 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-lg-10 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-lg-11 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .py-lg-12 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-lg-13 {
    padding-top: 6.5rem !important;
    padding-bottom: 6.5rem !important;
  }
  .py-lg-14 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.125rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-3 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-4 {
    padding-top: 1rem !important;
  }
  .pt-lg-5 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-6 {
    padding-top: 2rem !important;
  }
  .pt-lg-7 {
    padding-top: 2.5rem !important;
  }
  .pt-lg-8 {
    padding-top: 3rem !important;
  }
  .pt-lg-9 {
    padding-top: 3.5rem !important;
  }
  .pt-lg-10 {
    padding-top: 4rem !important;
  }
  .pt-lg-11 {
    padding-top: 5rem !important;
  }
  .pt-lg-12 {
    padding-top: 6rem !important;
  }
  .pt-lg-13 {
    padding-top: 6.5rem !important;
  }
  .pt-lg-14 {
    padding-top: 8rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.125rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-3 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-4 {
    padding-right: 1rem !important;
  }
  .pe-lg-5 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-6 {
    padding-right: 2rem !important;
  }
  .pe-lg-7 {
    padding-right: 2.5rem !important;
  }
  .pe-lg-8 {
    padding-right: 3rem !important;
  }
  .pe-lg-9 {
    padding-right: 3.5rem !important;
  }
  .pe-lg-10 {
    padding-right: 4rem !important;
  }
  .pe-lg-11 {
    padding-right: 5rem !important;
  }
  .pe-lg-12 {
    padding-right: 6rem !important;
  }
  .pe-lg-13 {
    padding-right: 6.5rem !important;
  }
  .pe-lg-14 {
    padding-right: 8rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.125rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-6 {
    padding-bottom: 2rem !important;
  }
  .pb-lg-7 {
    padding-bottom: 2.5rem !important;
  }
  .pb-lg-8 {
    padding-bottom: 3rem !important;
  }
  .pb-lg-9 {
    padding-bottom: 3.5rem !important;
  }
  .pb-lg-10 {
    padding-bottom: 4rem !important;
  }
  .pb-lg-11 {
    padding-bottom: 5rem !important;
  }
  .pb-lg-12 {
    padding-bottom: 6rem !important;
  }
  .pb-lg-13 {
    padding-bottom: 6.5rem !important;
  }
  .pb-lg-14 {
    padding-bottom: 8rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.125rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-3 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-4 {
    padding-left: 1rem !important;
  }
  .ps-lg-5 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-6 {
    padding-left: 2rem !important;
  }
  .ps-lg-7 {
    padding-left: 2.5rem !important;
  }
  .ps-lg-8 {
    padding-left: 3rem !important;
  }
  .ps-lg-9 {
    padding-left: 3.5rem !important;
  }
  .ps-lg-10 {
    padding-left: 4rem !important;
  }
  .ps-lg-11 {
    padding-left: 5rem !important;
  }
  .ps-lg-12 {
    padding-left: 6rem !important;
  }
  .ps-lg-13 {
    padding-left: 6.5rem !important;
  }
  .ps-lg-14 {
    padding-left: 8rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.125rem !important;
  }
  .gap-lg-2 {
    gap: 0.25rem !important;
  }
  .gap-lg-3 {
    gap: 0.5rem !important;
  }
  .gap-lg-4 {
    gap: 1rem !important;
  }
  .gap-lg-5 {
    gap: 1.5rem !important;
  }
  .gap-lg-6 {
    gap: 2rem !important;
  }
  .gap-lg-7 {
    gap: 2.5rem !important;
  }
  .gap-lg-8 {
    gap: 3rem !important;
  }
  .gap-lg-9 {
    gap: 3.5rem !important;
  }
  .gap-lg-10 {
    gap: 4rem !important;
  }
  .gap-lg-11 {
    gap: 5rem !important;
  }
  .gap-lg-12 {
    gap: 6rem !important;
  }
  .gap-lg-13 {
    gap: 6.5rem !important;
  }
  .gap-lg-14 {
    gap: 8rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.125rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-6 {
    row-gap: 2rem !important;
  }
  .row-gap-lg-7 {
    row-gap: 2.5rem !important;
  }
  .row-gap-lg-8 {
    row-gap: 3rem !important;
  }
  .row-gap-lg-9 {
    row-gap: 3.5rem !important;
  }
  .row-gap-lg-10 {
    row-gap: 4rem !important;
  }
  .row-gap-lg-11 {
    row-gap: 5rem !important;
  }
  .row-gap-lg-12 {
    row-gap: 6rem !important;
  }
  .row-gap-lg-13 {
    row-gap: 6.5rem !important;
  }
  .row-gap-lg-14 {
    row-gap: 8rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.125rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-6 {
    column-gap: 2rem !important;
  }
  .column-gap-lg-7 {
    column-gap: 2.5rem !important;
  }
  .column-gap-lg-8 {
    column-gap: 3rem !important;
  }
  .column-gap-lg-9 {
    column-gap: 3.5rem !important;
  }
  .column-gap-lg-10 {
    column-gap: 4rem !important;
  }
  .column-gap-lg-11 {
    column-gap: 5rem !important;
  }
  .column-gap-lg-12 {
    column-gap: 6rem !important;
  }
  .column-gap-lg-13 {
    column-gap: 6.5rem !important;
  }
  .column-gap-lg-14 {
    column-gap: 8rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.125rem !important;
  }
  .m-xl-2 {
    margin: 0.25rem !important;
  }
  .m-xl-3 {
    margin: 0.5rem !important;
  }
  .m-xl-4 {
    margin: 1rem !important;
  }
  .m-xl-5 {
    margin: 1.5rem !important;
  }
  .m-xl-6 {
    margin: 2rem !important;
  }
  .m-xl-7 {
    margin: 2.5rem !important;
  }
  .m-xl-8 {
    margin: 3rem !important;
  }
  .m-xl-9 {
    margin: 3.5rem !important;
  }
  .m-xl-10 {
    margin: 4rem !important;
  }
  .m-xl-11 {
    margin: 5rem !important;
  }
  .m-xl-12 {
    margin: 6rem !important;
  }
  .m-xl-13 {
    margin: 6.5rem !important;
  }
  .m-xl-14 {
    margin: 8rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.125rem !important;
    margin-left: 0.125rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-3 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-5 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-6 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-xl-7 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-xl-8 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-9 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-xl-10 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-xl-11 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-xl-12 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-xl-13 {
    margin-right: 6.5rem !important;
    margin-left: 6.5rem !important;
  }
  .mx-xl-14 {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.125rem !important;
    margin-bottom: 0.125rem !important;
  }
  .my-xl-2 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-3 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-5 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-6 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-xl-7 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-xl-8 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-9 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-xl-10 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-xl-11 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-xl-12 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-xl-13 {
    margin-top: 6.5rem !important;
    margin-bottom: 6.5rem !important;
  }
  .my-xl-14 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.125rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-3 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-4 {
    margin-top: 1rem !important;
  }
  .mt-xl-5 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-6 {
    margin-top: 2rem !important;
  }
  .mt-xl-7 {
    margin-top: 2.5rem !important;
  }
  .mt-xl-8 {
    margin-top: 3rem !important;
  }
  .mt-xl-9 {
    margin-top: 3.5rem !important;
  }
  .mt-xl-10 {
    margin-top: 4rem !important;
  }
  .mt-xl-11 {
    margin-top: 5rem !important;
  }
  .mt-xl-12 {
    margin-top: 6rem !important;
  }
  .mt-xl-13 {
    margin-top: 6.5rem !important;
  }
  .mt-xl-14 {
    margin-top: 8rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.125rem !important;
  }
  .me-xl-2 {
    margin-right: 0.25rem !important;
  }
  .me-xl-3 {
    margin-right: 0.5rem !important;
  }
  .me-xl-4 {
    margin-right: 1rem !important;
  }
  .me-xl-5 {
    margin-right: 1.5rem !important;
  }
  .me-xl-6 {
    margin-right: 2rem !important;
  }
  .me-xl-7 {
    margin-right: 2.5rem !important;
  }
  .me-xl-8 {
    margin-right: 3rem !important;
  }
  .me-xl-9 {
    margin-right: 3.5rem !important;
  }
  .me-xl-10 {
    margin-right: 4rem !important;
  }
  .me-xl-11 {
    margin-right: 5rem !important;
  }
  .me-xl-12 {
    margin-right: 6rem !important;
  }
  .me-xl-13 {
    margin-right: 6.5rem !important;
  }
  .me-xl-14 {
    margin-right: 8rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.125rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-6 {
    margin-bottom: 2rem !important;
  }
  .mb-xl-7 {
    margin-bottom: 2.5rem !important;
  }
  .mb-xl-8 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-9 {
    margin-bottom: 3.5rem !important;
  }
  .mb-xl-10 {
    margin-bottom: 4rem !important;
  }
  .mb-xl-11 {
    margin-bottom: 5rem !important;
  }
  .mb-xl-12 {
    margin-bottom: 6rem !important;
  }
  .mb-xl-13 {
    margin-bottom: 6.5rem !important;
  }
  .mb-xl-14 {
    margin-bottom: 8rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.125rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-3 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-4 {
    margin-left: 1rem !important;
  }
  .ms-xl-5 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-6 {
    margin-left: 2rem !important;
  }
  .ms-xl-7 {
    margin-left: 2.5rem !important;
  }
  .ms-xl-8 {
    margin-left: 3rem !important;
  }
  .ms-xl-9 {
    margin-left: 3.5rem !important;
  }
  .ms-xl-10 {
    margin-left: 4rem !important;
  }
  .ms-xl-11 {
    margin-left: 5rem !important;
  }
  .ms-xl-12 {
    margin-left: 6rem !important;
  }
  .ms-xl-13 {
    margin-left: 6.5rem !important;
  }
  .ms-xl-14 {
    margin-left: 8rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.125rem !important;
  }
  .m-xl-n2 {
    margin: -0.25rem !important;
  }
  .m-xl-n3 {
    margin: -0.5rem !important;
  }
  .m-xl-n4 {
    margin: -1rem !important;
  }
  .m-xl-n5 {
    margin: -1.5rem !important;
  }
  .m-xl-n6 {
    margin: -2rem !important;
  }
  .m-xl-n7 {
    margin: -2.5rem !important;
  }
  .m-xl-n8 {
    margin: -3rem !important;
  }
  .m-xl-n9 {
    margin: -3.5rem !important;
  }
  .m-xl-n10 {
    margin: -4rem !important;
  }
  .m-xl-n11 {
    margin: -5rem !important;
  }
  .m-xl-n12 {
    margin: -6rem !important;
  }
  .m-xl-n13 {
    margin: -6.5rem !important;
  }
  .m-xl-n14 {
    margin: -8rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.125rem !important;
    margin-left: -0.125rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xl-n3 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xl-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xl-n5 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n6 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-xl-n7 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-xl-n8 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-xl-n9 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-xl-n10 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-xl-n11 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .mx-xl-n12 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-xl-n13 {
    margin-right: -6.5rem !important;
    margin-left: -6.5rem !important;
  }
  .mx-xl-n14 {
    margin-right: -8rem !important;
    margin-left: -8rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.125rem !important;
    margin-bottom: -0.125rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xl-n3 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xl-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xl-n5 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n6 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-xl-n7 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-xl-n8 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-xl-n9 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-xl-n10 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-xl-n11 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .my-xl-n12 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-xl-n13 {
    margin-top: -6.5rem !important;
    margin-bottom: -6.5rem !important;
  }
  .my-xl-n14 {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.125rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.25rem !important;
  }
  .mt-xl-n3 {
    margin-top: -0.5rem !important;
  }
  .mt-xl-n4 {
    margin-top: -1rem !important;
  }
  .mt-xl-n5 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n6 {
    margin-top: -2rem !important;
  }
  .mt-xl-n7 {
    margin-top: -2.5rem !important;
  }
  .mt-xl-n8 {
    margin-top: -3rem !important;
  }
  .mt-xl-n9 {
    margin-top: -3.5rem !important;
  }
  .mt-xl-n10 {
    margin-top: -4rem !important;
  }
  .mt-xl-n11 {
    margin-top: -5rem !important;
  }
  .mt-xl-n12 {
    margin-top: -6rem !important;
  }
  .mt-xl-n13 {
    margin-top: -6.5rem !important;
  }
  .mt-xl-n14 {
    margin-top: -8rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.125rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.25rem !important;
  }
  .me-xl-n3 {
    margin-right: -0.5rem !important;
  }
  .me-xl-n4 {
    margin-right: -1rem !important;
  }
  .me-xl-n5 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n6 {
    margin-right: -2rem !important;
  }
  .me-xl-n7 {
    margin-right: -2.5rem !important;
  }
  .me-xl-n8 {
    margin-right: -3rem !important;
  }
  .me-xl-n9 {
    margin-right: -3.5rem !important;
  }
  .me-xl-n10 {
    margin-right: -4rem !important;
  }
  .me-xl-n11 {
    margin-right: -5rem !important;
  }
  .me-xl-n12 {
    margin-right: -6rem !important;
  }
  .me-xl-n13 {
    margin-right: -6.5rem !important;
  }
  .me-xl-n14 {
    margin-right: -8rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.125rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n6 {
    margin-bottom: -2rem !important;
  }
  .mb-xl-n7 {
    margin-bottom: -2.5rem !important;
  }
  .mb-xl-n8 {
    margin-bottom: -3rem !important;
  }
  .mb-xl-n9 {
    margin-bottom: -3.5rem !important;
  }
  .mb-xl-n10 {
    margin-bottom: -4rem !important;
  }
  .mb-xl-n11 {
    margin-bottom: -5rem !important;
  }
  .mb-xl-n12 {
    margin-bottom: -6rem !important;
  }
  .mb-xl-n13 {
    margin-bottom: -6.5rem !important;
  }
  .mb-xl-n14 {
    margin-bottom: -8rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.125rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.25rem !important;
  }
  .ms-xl-n3 {
    margin-left: -0.5rem !important;
  }
  .ms-xl-n4 {
    margin-left: -1rem !important;
  }
  .ms-xl-n5 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n6 {
    margin-left: -2rem !important;
  }
  .ms-xl-n7 {
    margin-left: -2.5rem !important;
  }
  .ms-xl-n8 {
    margin-left: -3rem !important;
  }
  .ms-xl-n9 {
    margin-left: -3.5rem !important;
  }
  .ms-xl-n10 {
    margin-left: -4rem !important;
  }
  .ms-xl-n11 {
    margin-left: -5rem !important;
  }
  .ms-xl-n12 {
    margin-left: -6rem !important;
  }
  .ms-xl-n13 {
    margin-left: -6.5rem !important;
  }
  .ms-xl-n14 {
    margin-left: -8rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.125rem !important;
  }
  .p-xl-2 {
    padding: 0.25rem !important;
  }
  .p-xl-3 {
    padding: 0.5rem !important;
  }
  .p-xl-4 {
    padding: 1rem !important;
  }
  .p-xl-5 {
    padding: 1.5rem !important;
  }
  .p-xl-6 {
    padding: 2rem !important;
  }
  .p-xl-7 {
    padding: 2.5rem !important;
  }
  .p-xl-8 {
    padding: 3rem !important;
  }
  .p-xl-9 {
    padding: 3.5rem !important;
  }
  .p-xl-10 {
    padding: 4rem !important;
  }
  .p-xl-11 {
    padding: 5rem !important;
  }
  .p-xl-12 {
    padding: 6rem !important;
  }
  .p-xl-13 {
    padding: 6.5rem !important;
  }
  .p-xl-14 {
    padding: 8rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.125rem !important;
    padding-left: 0.125rem !important;
  }
  .px-xl-2 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-3 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-5 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-6 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-xl-7 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-xl-8 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xl-9 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-xl-10 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-xl-11 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .px-xl-12 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-xl-13 {
    padding-right: 6.5rem !important;
    padding-left: 6.5rem !important;
  }
  .px-xl-14 {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.125rem !important;
    padding-bottom: 0.125rem !important;
  }
  .py-xl-2 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-3 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-5 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-6 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-xl-7 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-xl-8 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xl-9 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-xl-10 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-xl-11 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .py-xl-12 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-xl-13 {
    padding-top: 6.5rem !important;
    padding-bottom: 6.5rem !important;
  }
  .py-xl-14 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.125rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-3 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-4 {
    padding-top: 1rem !important;
  }
  .pt-xl-5 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-6 {
    padding-top: 2rem !important;
  }
  .pt-xl-7 {
    padding-top: 2.5rem !important;
  }
  .pt-xl-8 {
    padding-top: 3rem !important;
  }
  .pt-xl-9 {
    padding-top: 3.5rem !important;
  }
  .pt-xl-10 {
    padding-top: 4rem !important;
  }
  .pt-xl-11 {
    padding-top: 5rem !important;
  }
  .pt-xl-12 {
    padding-top: 6rem !important;
  }
  .pt-xl-13 {
    padding-top: 6.5rem !important;
  }
  .pt-xl-14 {
    padding-top: 8rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.125rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-3 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-4 {
    padding-right: 1rem !important;
  }
  .pe-xl-5 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-6 {
    padding-right: 2rem !important;
  }
  .pe-xl-7 {
    padding-right: 2.5rem !important;
  }
  .pe-xl-8 {
    padding-right: 3rem !important;
  }
  .pe-xl-9 {
    padding-right: 3.5rem !important;
  }
  .pe-xl-10 {
    padding-right: 4rem !important;
  }
  .pe-xl-11 {
    padding-right: 5rem !important;
  }
  .pe-xl-12 {
    padding-right: 6rem !important;
  }
  .pe-xl-13 {
    padding-right: 6.5rem !important;
  }
  .pe-xl-14 {
    padding-right: 8rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.125rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-6 {
    padding-bottom: 2rem !important;
  }
  .pb-xl-7 {
    padding-bottom: 2.5rem !important;
  }
  .pb-xl-8 {
    padding-bottom: 3rem !important;
  }
  .pb-xl-9 {
    padding-bottom: 3.5rem !important;
  }
  .pb-xl-10 {
    padding-bottom: 4rem !important;
  }
  .pb-xl-11 {
    padding-bottom: 5rem !important;
  }
  .pb-xl-12 {
    padding-bottom: 6rem !important;
  }
  .pb-xl-13 {
    padding-bottom: 6.5rem !important;
  }
  .pb-xl-14 {
    padding-bottom: 8rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.125rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-3 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-4 {
    padding-left: 1rem !important;
  }
  .ps-xl-5 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-6 {
    padding-left: 2rem !important;
  }
  .ps-xl-7 {
    padding-left: 2.5rem !important;
  }
  .ps-xl-8 {
    padding-left: 3rem !important;
  }
  .ps-xl-9 {
    padding-left: 3.5rem !important;
  }
  .ps-xl-10 {
    padding-left: 4rem !important;
  }
  .ps-xl-11 {
    padding-left: 5rem !important;
  }
  .ps-xl-12 {
    padding-left: 6rem !important;
  }
  .ps-xl-13 {
    padding-left: 6.5rem !important;
  }
  .ps-xl-14 {
    padding-left: 8rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.125rem !important;
  }
  .gap-xl-2 {
    gap: 0.25rem !important;
  }
  .gap-xl-3 {
    gap: 0.5rem !important;
  }
  .gap-xl-4 {
    gap: 1rem !important;
  }
  .gap-xl-5 {
    gap: 1.5rem !important;
  }
  .gap-xl-6 {
    gap: 2rem !important;
  }
  .gap-xl-7 {
    gap: 2.5rem !important;
  }
  .gap-xl-8 {
    gap: 3rem !important;
  }
  .gap-xl-9 {
    gap: 3.5rem !important;
  }
  .gap-xl-10 {
    gap: 4rem !important;
  }
  .gap-xl-11 {
    gap: 5rem !important;
  }
  .gap-xl-12 {
    gap: 6rem !important;
  }
  .gap-xl-13 {
    gap: 6.5rem !important;
  }
  .gap-xl-14 {
    gap: 8rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.125rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-6 {
    row-gap: 2rem !important;
  }
  .row-gap-xl-7 {
    row-gap: 2.5rem !important;
  }
  .row-gap-xl-8 {
    row-gap: 3rem !important;
  }
  .row-gap-xl-9 {
    row-gap: 3.5rem !important;
  }
  .row-gap-xl-10 {
    row-gap: 4rem !important;
  }
  .row-gap-xl-11 {
    row-gap: 5rem !important;
  }
  .row-gap-xl-12 {
    row-gap: 6rem !important;
  }
  .row-gap-xl-13 {
    row-gap: 6.5rem !important;
  }
  .row-gap-xl-14 {
    row-gap: 8rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.125rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-6 {
    column-gap: 2rem !important;
  }
  .column-gap-xl-7 {
    column-gap: 2.5rem !important;
  }
  .column-gap-xl-8 {
    column-gap: 3rem !important;
  }
  .column-gap-xl-9 {
    column-gap: 3.5rem !important;
  }
  .column-gap-xl-10 {
    column-gap: 4rem !important;
  }
  .column-gap-xl-11 {
    column-gap: 5rem !important;
  }
  .column-gap-xl-12 {
    column-gap: 6rem !important;
  }
  .column-gap-xl-13 {
    column-gap: 6.5rem !important;
  }
  .column-gap-xl-14 {
    column-gap: 8rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.125rem !important;
  }
  .m-xxl-2 {
    margin: 0.25rem !important;
  }
  .m-xxl-3 {
    margin: 0.5rem !important;
  }
  .m-xxl-4 {
    margin: 1rem !important;
  }
  .m-xxl-5 {
    margin: 1.5rem !important;
  }
  .m-xxl-6 {
    margin: 2rem !important;
  }
  .m-xxl-7 {
    margin: 2.5rem !important;
  }
  .m-xxl-8 {
    margin: 3rem !important;
  }
  .m-xxl-9 {
    margin: 3.5rem !important;
  }
  .m-xxl-10 {
    margin: 4rem !important;
  }
  .m-xxl-11 {
    margin: 5rem !important;
  }
  .m-xxl-12 {
    margin: 6rem !important;
  }
  .m-xxl-13 {
    margin: 6.5rem !important;
  }
  .m-xxl-14 {
    margin: 8rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.125rem !important;
    margin-left: 0.125rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-3 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-5 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-6 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-xxl-7 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-xxl-8 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-9 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-xxl-10 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-xxl-11 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-xxl-12 {
    margin-right: 6rem !important;
    margin-left: 6rem !important;
  }
  .mx-xxl-13 {
    margin-right: 6.5rem !important;
    margin-left: 6.5rem !important;
  }
  .mx-xxl-14 {
    margin-right: 8rem !important;
    margin-left: 8rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.125rem !important;
    margin-bottom: 0.125rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-3 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-5 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-6 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-xxl-7 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-xxl-8 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-9 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-xxl-10 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-xxl-11 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-xxl-12 {
    margin-top: 6rem !important;
    margin-bottom: 6rem !important;
  }
  .my-xxl-13 {
    margin-top: 6.5rem !important;
    margin-bottom: 6.5rem !important;
  }
  .my-xxl-14 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.125rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-3 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1rem !important;
  }
  .mt-xxl-5 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-6 {
    margin-top: 2rem !important;
  }
  .mt-xxl-7 {
    margin-top: 2.5rem !important;
  }
  .mt-xxl-8 {
    margin-top: 3rem !important;
  }
  .mt-xxl-9 {
    margin-top: 3.5rem !important;
  }
  .mt-xxl-10 {
    margin-top: 4rem !important;
  }
  .mt-xxl-11 {
    margin-top: 5rem !important;
  }
  .mt-xxl-12 {
    margin-top: 6rem !important;
  }
  .mt-xxl-13 {
    margin-top: 6.5rem !important;
  }
  .mt-xxl-14 {
    margin-top: 8rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.125rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-3 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-4 {
    margin-right: 1rem !important;
  }
  .me-xxl-5 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-6 {
    margin-right: 2rem !important;
  }
  .me-xxl-7 {
    margin-right: 2.5rem !important;
  }
  .me-xxl-8 {
    margin-right: 3rem !important;
  }
  .me-xxl-9 {
    margin-right: 3.5rem !important;
  }
  .me-xxl-10 {
    margin-right: 4rem !important;
  }
  .me-xxl-11 {
    margin-right: 5rem !important;
  }
  .me-xxl-12 {
    margin-right: 6rem !important;
  }
  .me-xxl-13 {
    margin-right: 6.5rem !important;
  }
  .me-xxl-14 {
    margin-right: 8rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.125rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-6 {
    margin-bottom: 2rem !important;
  }
  .mb-xxl-7 {
    margin-bottom: 2.5rem !important;
  }
  .mb-xxl-8 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-9 {
    margin-bottom: 3.5rem !important;
  }
  .mb-xxl-10 {
    margin-bottom: 4rem !important;
  }
  .mb-xxl-11 {
    margin-bottom: 5rem !important;
  }
  .mb-xxl-12 {
    margin-bottom: 6rem !important;
  }
  .mb-xxl-13 {
    margin-bottom: 6.5rem !important;
  }
  .mb-xxl-14 {
    margin-bottom: 8rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.125rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-3 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1rem !important;
  }
  .ms-xxl-5 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-6 {
    margin-left: 2rem !important;
  }
  .ms-xxl-7 {
    margin-left: 2.5rem !important;
  }
  .ms-xxl-8 {
    margin-left: 3rem !important;
  }
  .ms-xxl-9 {
    margin-left: 3.5rem !important;
  }
  .ms-xxl-10 {
    margin-left: 4rem !important;
  }
  .ms-xxl-11 {
    margin-left: 5rem !important;
  }
  .ms-xxl-12 {
    margin-left: 6rem !important;
  }
  .ms-xxl-13 {
    margin-left: 6.5rem !important;
  }
  .ms-xxl-14 {
    margin-left: 8rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.125rem !important;
  }
  .m-xxl-n2 {
    margin: -0.25rem !important;
  }
  .m-xxl-n3 {
    margin: -0.5rem !important;
  }
  .m-xxl-n4 {
    margin: -1rem !important;
  }
  .m-xxl-n5 {
    margin: -1.5rem !important;
  }
  .m-xxl-n6 {
    margin: -2rem !important;
  }
  .m-xxl-n7 {
    margin: -2.5rem !important;
  }
  .m-xxl-n8 {
    margin: -3rem !important;
  }
  .m-xxl-n9 {
    margin: -3.5rem !important;
  }
  .m-xxl-n10 {
    margin: -4rem !important;
  }
  .m-xxl-n11 {
    margin: -5rem !important;
  }
  .m-xxl-n12 {
    margin: -6rem !important;
  }
  .m-xxl-n13 {
    margin: -6.5rem !important;
  }
  .m-xxl-n14 {
    margin: -8rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.125rem !important;
    margin-left: -0.125rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n6 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-xxl-n7 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-xxl-n8 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-xxl-n9 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-xxl-n10 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-xxl-n11 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .mx-xxl-n12 {
    margin-right: -6rem !important;
    margin-left: -6rem !important;
  }
  .mx-xxl-n13 {
    margin-right: -6.5rem !important;
    margin-left: -6.5rem !important;
  }
  .mx-xxl-n14 {
    margin-right: -8rem !important;
    margin-left: -8rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.125rem !important;
    margin-bottom: -0.125rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxl-n3 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxl-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxl-n5 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n6 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-xxl-n7 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-xxl-n8 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-xxl-n9 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-xxl-n10 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-xxl-n11 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .my-xxl-n12 {
    margin-top: -6rem !important;
    margin-bottom: -6rem !important;
  }
  .my-xxl-n13 {
    margin-top: -6.5rem !important;
    margin-bottom: -6.5rem !important;
  }
  .my-xxl-n14 {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.125rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.25rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -0.5rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -1rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n6 {
    margin-top: -2rem !important;
  }
  .mt-xxl-n7 {
    margin-top: -2.5rem !important;
  }
  .mt-xxl-n8 {
    margin-top: -3rem !important;
  }
  .mt-xxl-n9 {
    margin-top: -3.5rem !important;
  }
  .mt-xxl-n10 {
    margin-top: -4rem !important;
  }
  .mt-xxl-n11 {
    margin-top: -5rem !important;
  }
  .mt-xxl-n12 {
    margin-top: -6rem !important;
  }
  .mt-xxl-n13 {
    margin-top: -6.5rem !important;
  }
  .mt-xxl-n14 {
    margin-top: -8rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.125rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.25rem !important;
  }
  .me-xxl-n3 {
    margin-right: -0.5rem !important;
  }
  .me-xxl-n4 {
    margin-right: -1rem !important;
  }
  .me-xxl-n5 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n6 {
    margin-right: -2rem !important;
  }
  .me-xxl-n7 {
    margin-right: -2.5rem !important;
  }
  .me-xxl-n8 {
    margin-right: -3rem !important;
  }
  .me-xxl-n9 {
    margin-right: -3.5rem !important;
  }
  .me-xxl-n10 {
    margin-right: -4rem !important;
  }
  .me-xxl-n11 {
    margin-right: -5rem !important;
  }
  .me-xxl-n12 {
    margin-right: -6rem !important;
  }
  .me-xxl-n13 {
    margin-right: -6.5rem !important;
  }
  .me-xxl-n14 {
    margin-right: -8rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.125rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n6 {
    margin-bottom: -2rem !important;
  }
  .mb-xxl-n7 {
    margin-bottom: -2.5rem !important;
  }
  .mb-xxl-n8 {
    margin-bottom: -3rem !important;
  }
  .mb-xxl-n9 {
    margin-bottom: -3.5rem !important;
  }
  .mb-xxl-n10 {
    margin-bottom: -4rem !important;
  }
  .mb-xxl-n11 {
    margin-bottom: -5rem !important;
  }
  .mb-xxl-n12 {
    margin-bottom: -6rem !important;
  }
  .mb-xxl-n13 {
    margin-bottom: -6.5rem !important;
  }
  .mb-xxl-n14 {
    margin-bottom: -8rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.125rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.25rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -0.5rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -1rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n6 {
    margin-left: -2rem !important;
  }
  .ms-xxl-n7 {
    margin-left: -2.5rem !important;
  }
  .ms-xxl-n8 {
    margin-left: -3rem !important;
  }
  .ms-xxl-n9 {
    margin-left: -3.5rem !important;
  }
  .ms-xxl-n10 {
    margin-left: -4rem !important;
  }
  .ms-xxl-n11 {
    margin-left: -5rem !important;
  }
  .ms-xxl-n12 {
    margin-left: -6rem !important;
  }
  .ms-xxl-n13 {
    margin-left: -6.5rem !important;
  }
  .ms-xxl-n14 {
    margin-left: -8rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.125rem !important;
  }
  .p-xxl-2 {
    padding: 0.25rem !important;
  }
  .p-xxl-3 {
    padding: 0.5rem !important;
  }
  .p-xxl-4 {
    padding: 1rem !important;
  }
  .p-xxl-5 {
    padding: 1.5rem !important;
  }
  .p-xxl-6 {
    padding: 2rem !important;
  }
  .p-xxl-7 {
    padding: 2.5rem !important;
  }
  .p-xxl-8 {
    padding: 3rem !important;
  }
  .p-xxl-9 {
    padding: 3.5rem !important;
  }
  .p-xxl-10 {
    padding: 4rem !important;
  }
  .p-xxl-11 {
    padding: 5rem !important;
  }
  .p-xxl-12 {
    padding: 6rem !important;
  }
  .p-xxl-13 {
    padding: 6.5rem !important;
  }
  .p-xxl-14 {
    padding: 8rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.125rem !important;
    padding-left: 0.125rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-3 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-5 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-6 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-xxl-7 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-xxl-8 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xxl-9 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-xxl-10 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-xxl-11 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .px-xxl-12 {
    padding-right: 6rem !important;
    padding-left: 6rem !important;
  }
  .px-xxl-13 {
    padding-right: 6.5rem !important;
    padding-left: 6.5rem !important;
  }
  .px-xxl-14 {
    padding-right: 8rem !important;
    padding-left: 8rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.125rem !important;
    padding-bottom: 0.125rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-3 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-5 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-6 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-xxl-7 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-xxl-8 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xxl-9 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-xxl-10 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-xxl-11 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .py-xxl-12 {
    padding-top: 6rem !important;
    padding-bottom: 6rem !important;
  }
  .py-xxl-13 {
    padding-top: 6.5rem !important;
    padding-bottom: 6.5rem !important;
  }
  .py-xxl-14 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.125rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-3 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1rem !important;
  }
  .pt-xxl-5 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-6 {
    padding-top: 2rem !important;
  }
  .pt-xxl-7 {
    padding-top: 2.5rem !important;
  }
  .pt-xxl-8 {
    padding-top: 3rem !important;
  }
  .pt-xxl-9 {
    padding-top: 3.5rem !important;
  }
  .pt-xxl-10 {
    padding-top: 4rem !important;
  }
  .pt-xxl-11 {
    padding-top: 5rem !important;
  }
  .pt-xxl-12 {
    padding-top: 6rem !important;
  }
  .pt-xxl-13 {
    padding-top: 6.5rem !important;
  }
  .pt-xxl-14 {
    padding-top: 8rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.125rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-3 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1rem !important;
  }
  .pe-xxl-5 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-6 {
    padding-right: 2rem !important;
  }
  .pe-xxl-7 {
    padding-right: 2.5rem !important;
  }
  .pe-xxl-8 {
    padding-right: 3rem !important;
  }
  .pe-xxl-9 {
    padding-right: 3.5rem !important;
  }
  .pe-xxl-10 {
    padding-right: 4rem !important;
  }
  .pe-xxl-11 {
    padding-right: 5rem !important;
  }
  .pe-xxl-12 {
    padding-right: 6rem !important;
  }
  .pe-xxl-13 {
    padding-right: 6.5rem !important;
  }
  .pe-xxl-14 {
    padding-right: 8rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.125rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-6 {
    padding-bottom: 2rem !important;
  }
  .pb-xxl-7 {
    padding-bottom: 2.5rem !important;
  }
  .pb-xxl-8 {
    padding-bottom: 3rem !important;
  }
  .pb-xxl-9 {
    padding-bottom: 3.5rem !important;
  }
  .pb-xxl-10 {
    padding-bottom: 4rem !important;
  }
  .pb-xxl-11 {
    padding-bottom: 5rem !important;
  }
  .pb-xxl-12 {
    padding-bottom: 6rem !important;
  }
  .pb-xxl-13 {
    padding-bottom: 6.5rem !important;
  }
  .pb-xxl-14 {
    padding-bottom: 8rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.125rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-3 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1rem !important;
  }
  .ps-xxl-5 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-6 {
    padding-left: 2rem !important;
  }
  .ps-xxl-7 {
    padding-left: 2.5rem !important;
  }
  .ps-xxl-8 {
    padding-left: 3rem !important;
  }
  .ps-xxl-9 {
    padding-left: 3.5rem !important;
  }
  .ps-xxl-10 {
    padding-left: 4rem !important;
  }
  .ps-xxl-11 {
    padding-left: 5rem !important;
  }
  .ps-xxl-12 {
    padding-left: 6rem !important;
  }
  .ps-xxl-13 {
    padding-left: 6.5rem !important;
  }
  .ps-xxl-14 {
    padding-left: 8rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.125rem !important;
  }
  .gap-xxl-2 {
    gap: 0.25rem !important;
  }
  .gap-xxl-3 {
    gap: 0.5rem !important;
  }
  .gap-xxl-4 {
    gap: 1rem !important;
  }
  .gap-xxl-5 {
    gap: 1.5rem !important;
  }
  .gap-xxl-6 {
    gap: 2rem !important;
  }
  .gap-xxl-7 {
    gap: 2.5rem !important;
  }
  .gap-xxl-8 {
    gap: 3rem !important;
  }
  .gap-xxl-9 {
    gap: 3.5rem !important;
  }
  .gap-xxl-10 {
    gap: 4rem !important;
  }
  .gap-xxl-11 {
    gap: 5rem !important;
  }
  .gap-xxl-12 {
    gap: 6rem !important;
  }
  .gap-xxl-13 {
    gap: 6.5rem !important;
  }
  .gap-xxl-14 {
    gap: 8rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.125rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-6 {
    row-gap: 2rem !important;
  }
  .row-gap-xxl-7 {
    row-gap: 2.5rem !important;
  }
  .row-gap-xxl-8 {
    row-gap: 3rem !important;
  }
  .row-gap-xxl-9 {
    row-gap: 3.5rem !important;
  }
  .row-gap-xxl-10 {
    row-gap: 4rem !important;
  }
  .row-gap-xxl-11 {
    row-gap: 5rem !important;
  }
  .row-gap-xxl-12 {
    row-gap: 6rem !important;
  }
  .row-gap-xxl-13 {
    row-gap: 6.5rem !important;
  }
  .row-gap-xxl-14 {
    row-gap: 8rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.125rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-6 {
    column-gap: 2rem !important;
  }
  .column-gap-xxl-7 {
    column-gap: 2.5rem !important;
  }
  .column-gap-xxl-8 {
    column-gap: 3rem !important;
  }
  .column-gap-xxl-9 {
    column-gap: 3.5rem !important;
  }
  .column-gap-xxl-10 {
    column-gap: 4rem !important;
  }
  .column-gap-xxl-11 {
    column-gap: 5rem !important;
  }
  .column-gap-xxl-12 {
    column-gap: 6rem !important;
  }
  .column-gap-xxl-13 {
    column-gap: 6.5rem !important;
  }
  .column-gap-xxl-14 {
    column-gap: 8rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
[data-bs-theme=dark],
.dark {
  --bs-body-color: #fff;
  --bs-border-color: #343434;
  --bs-success-rgb: 107, 240, 175;
  --bs-info-rgb: 140, 219, 255;
  --bs-warning-rgb: 255, 243, 148;
  --bs-danger-rgb: 255, 169, 187;
  --bs-success-border-subtle: #24a365;
  --bs-info-border-subtle: #3789ad;
  --bs-warning-border-subtle: #c4b63f;
  --bs-danger-border-subtle: #c34b63;
  --bs-form-valid-border-color: #2ee68c;
  --bs-form-invalid-border-color: #ff7591;
}

.dark {
  background: #111;
  color: #fff;
}

:root {
  --bs-border-radius-xs: 0.125rem;
  --bs-border-radius-3xl: 1.25rem;
  --bs-border-radius-4xl: 1.5rem;
}

.dark .bg-primary {
  background-color: #343434 !important;
}
.dark .bg-secondary {
  background-color: #232323 !important;
}
.dark .bg-tertiary {
  background-color: #111111 !important;
}
.dark .bg-quartenary {
  background-color: #090909 !important;
}
.dark .bg-quinary {
  background-color: #000000 !important;
}
.dark .dark-bg-primary {
  background-color: #343434 !important;
}
.dark .dark-bg-secondary {
  background-color: #232323 !important;
}
.dark .dark-bg-tertiary {
  background-color: #111111 !important;
}
.dark .dark-bg-quartenary {
  background-color: #090909 !important;
}
.dark .dark-bg-quinary {
  background-color: #000000 !important;
}

.bg-dark-gray-50 {
  background-color: #767676 !important;
}

.text-dark-gray-50 {
  color: #767676 !important;
}

.border-dark-gray-50 {
  border-color: #767676 !important;
}

.bg-dark-gray-100 {
  background-color: #666666 !important;
}

.text-dark-gray-100 {
  color: #666666 !important;
}

.border-dark-gray-100 {
  border-color: #666666 !important;
}

.bg-dark-gray-200 {
  background-color: #575757 !important;
}

.text-dark-gray-200 {
  color: #575757 !important;
}

.border-dark-gray-200 {
  border-color: #575757 !important;
}

.bg-dark-gray-300 {
  background-color: #4b4b4b !important;
}

.text-dark-gray-300 {
  color: #4b4b4b !important;
}

.border-dark-gray-300 {
  border-color: #4b4b4b !important;
}

.bg-dark-gray-400 {
  background-color: #404040 !important;
}

.text-dark-gray-400 {
  color: #404040 !important;
}

.border-dark-gray-400 {
  border-color: #404040 !important;
}

.bg-dark-gray-500 {
  background-color: #343434 !important;
}

.text-dark-gray-500 {
  color: #343434 !important;
}

.border-dark-gray-500 {
  border-color: #343434 !important;
}

.bg-dark-gray-600 {
  background-color: #232323 !important;
}

.text-dark-gray-600 {
  color: #232323 !important;
}

.border-dark-gray-600 {
  border-color: #232323 !important;
}

.bg-dark-gray-700 {
  background-color: #111111 !important;
}

.text-dark-gray-700 {
  color: #111111 !important;
}

.border-dark-gray-700 {
  border-color: #111111 !important;
}

.bg-dark-gray-800 {
  background-color: #090909 !important;
}

.text-dark-gray-800 {
  color: #090909 !important;
}

.border-dark-gray-800 {
  border-color: #090909 !important;
}

.bg-dark-gray-900 {
  background-color: #000000 !important;
}

.text-dark-gray-900 {
  color: #000000 !important;
}

.border-dark-gray-900 {
  border-color: #000000 !important;
}

.bg-light-gray-50 {
  background-color: #fcfcfc !important;
}

.text-light-gray-50 {
  color: #fcfcfc !important;
}

.border-light-gray-50 {
  border-color: #fcfcfc !important;
}

.bg-light-gray-100 {
  background-color: #fafafa !important;
}

.text-light-gray-100 {
  color: #fafafa !important;
}

.border-light-gray-100 {
  border-color: #fafafa !important;
}

.bg-light-gray-200 {
  background-color: #f2f2f2 !important;
}

.text-light-gray-200 {
  color: #f2f2f2 !important;
}

.border-light-gray-200 {
  border-color: #f2f2f2 !important;
}

.bg-light-gray-300 {
  background-color: #ededed !important;
}

.text-light-gray-300 {
  color: #ededed !important;
}

.border-light-gray-300 {
  border-color: #ededed !important;
}

.bg-light-gray-400 {
  background-color: #dedede !important;
}

.text-light-gray-400 {
  color: #dedede !important;
}

.border-light-gray-400 {
  border-color: #dedede !important;
}

.bg-light-gray-500 {
  background-color: #cccccc !important;
}

.text-light-gray-500 {
  color: #cccccc !important;
}

.border-light-gray-500 {
  border-color: #cccccc !important;
}

.bg-light-gray-600 {
  background-color: #b6b6b6 !important;
}

.text-light-gray-600 {
  color: #b6b6b6 !important;
}

.border-light-gray-600 {
  border-color: #b6b6b6 !important;
}

.bg-light-gray-700 {
  background-color: #a1a1a1 !important;
}

.text-light-gray-700 {
  color: #a1a1a1 !important;
}

.border-light-gray-700 {
  border-color: #a1a1a1 !important;
}

.bg-light-gray-800 {
  background-color: #878787 !important;
}

.text-light-gray-800 {
  color: #878787 !important;
}

.border-light-gray-800 {
  border-color: #878787 !important;
}

.bg-light-gray-900 {
  background-color: #808080 !important;
}

.text-light-gray-900 {
  color: #808080 !important;
}

.border-light-gray-900 {
  border-color: #808080 !important;
}

.bg-op-dark-gray-50 {
  background-color: rgba(17, 17, 17, 0.575) !important;
}

.text-op-dark-gray-50 {
  color: rgba(17, 17, 17, 0.575) !important;
}

.border-op-dark-gray-50 {
  border-color: rgba(17, 17, 17, 0.575) !important;
}

.bg-op-dark-gray-100 {
  background-color: rgba(17, 17, 17, 0.645) !important;
}

.text-op-dark-gray-100 {
  color: rgba(17, 17, 17, 0.645) !important;
}

.border-op-dark-gray-100 {
  border-color: rgba(17, 17, 17, 0.645) !important;
}

.bg-op-dark-gray-200 {
  background-color: rgba(17, 17, 17, 0.705) !important;
}

.text-op-dark-gray-200 {
  color: rgba(17, 17, 17, 0.705) !important;
}

.border-op-dark-gray-200 {
  border-color: rgba(17, 17, 17, 0.705) !important;
}

.bg-op-dark-gray-300 {
  background-color: rgba(17, 17, 17, 0.755) !important;
}

.text-op-dark-gray-300 {
  color: rgba(17, 17, 17, 0.755) !important;
}

.border-op-dark-gray-300 {
  border-color: rgba(17, 17, 17, 0.755) !important;
}

.bg-op-dark-gray-400 {
  background-color: rgba(17, 17, 17, 0.805) !important;
}

.text-op-dark-gray-400 {
  color: rgba(17, 17, 17, 0.805) !important;
}

.border-op-dark-gray-400 {
  border-color: rgba(17, 17, 17, 0.805) !important;
}

.bg-op-dark-gray-500 {
  background-color: rgba(17, 17, 17, 0.85) !important;
}

.text-op-dark-gray-500 {
  color: rgba(17, 17, 17, 0.85) !important;
}

.border-op-dark-gray-500 {
  border-color: rgba(17, 17, 17, 0.85) !important;
}

.bg-op-dark-gray-600 {
  background-color: rgba(17, 17, 17, 0.925) !important;
}

.text-op-dark-gray-600 {
  color: rgba(17, 17, 17, 0.925) !important;
}

.border-op-dark-gray-600 {
  border-color: rgba(17, 17, 17, 0.925) !important;
}

.bg-op-dark-gray-700 {
  background-color: #111111 !important;
}

.text-op-dark-gray-700 {
  color: #111111 !important;
}

.border-op-dark-gray-700 {
  border-color: #111111 !important;
}

.bg-op-dark-gray-800 {
  background-color: #090909 !important;
}

.text-op-dark-gray-800 {
  color: #090909 !important;
}

.border-op-dark-gray-800 {
  border-color: #090909 !important;
}

.bg-op-dark-gray-900 {
  background-color: black !important;
}

.text-op-dark-gray-900 {
  color: black !important;
}

.border-op-dark-gray-900 {
  border-color: black !important;
}

.bg-op-light-gray-50 {
  background-color: rgba(17, 17, 17, 0.01) !important;
}

.text-op-light-gray-50 {
  color: rgba(17, 17, 17, 0.01) !important;
}

.border-op-light-gray-50 {
  border-color: rgba(17, 17, 17, 0.01) !important;
}

.bg-op-light-gray-100 {
  background-color: rgba(17, 17, 17, 0.02) !important;
}

.text-op-light-gray-100 {
  color: rgba(17, 17, 17, 0.02) !important;
}

.border-op-light-gray-100 {
  border-color: rgba(17, 17, 17, 0.02) !important;
}

.bg-op-light-gray-200 {
  background-color: rgba(17, 17, 17, 0.055) !important;
}

.text-op-light-gray-200 {
  color: rgba(17, 17, 17, 0.055) !important;
}

.border-op-light-gray-200 {
  border-color: rgba(17, 17, 17, 0.055) !important;
}

.bg-op-light-gray-300 {
  background-color: rgba(17, 17, 17, 0.075) !important;
}

.text-op-light-gray-300 {
  color: rgba(17, 17, 17, 0.075) !important;
}

.border-op-light-gray-300 {
  border-color: rgba(17, 17, 17, 0.075) !important;
}

.bg-op-light-gray-400 {
  background-color: rgba(17, 17, 17, 0.135) !important;
}

.text-op-light-gray-400 {
  color: rgba(17, 17, 17, 0.135) !important;
}

.border-op-light-gray-400 {
  border-color: rgba(17, 17, 17, 0.135) !important;
}

.bg-op-light-gray-500 {
  background-color: rgba(17, 17, 17, 0.215) !important;
}

.text-op-light-gray-500 {
  color: rgba(17, 17, 17, 0.215) !important;
}

.border-op-light-gray-500 {
  border-color: rgba(17, 17, 17, 0.215) !important;
}

.bg-op-light-gray-600 {
  background-color: rgba(17, 17, 17, 0.305) !important;
}

.text-op-light-gray-600 {
  color: rgba(17, 17, 17, 0.305) !important;
}

.border-op-light-gray-600 {
  border-color: rgba(17, 17, 17, 0.305) !important;
}

.bg-op-light-gray-700 {
  background-color: rgba(17, 17, 17, 0.395) !important;
}

.text-op-light-gray-700 {
  color: rgba(17, 17, 17, 0.395) !important;
}

.border-op-light-gray-700 {
  border-color: rgba(17, 17, 17, 0.395) !important;
}

.bg-op-light-gray-800 {
  background-color: rgba(17, 17, 17, 0.505) !important;
}

.text-op-light-gray-800 {
  color: rgba(17, 17, 17, 0.505) !important;
}

.border-op-light-gray-800 {
  border-color: rgba(17, 17, 17, 0.505) !important;
}

.bg-op-light-gray-900 {
  background-color: rgba(17, 17, 17, 0.535) !important;
}

.text-op-light-gray-900 {
  color: rgba(17, 17, 17, 0.535) !important;
}

.border-op-light-gray-900 {
  border-color: rgba(17, 17, 17, 0.535) !important;
}

.bg-bp-green-50 {
  background-color: #e7f5e6 !important;
}

.text-bp-green-50 {
  color: #e7f5e6 !important;
}

.border-bp-green-50 {
  border-color: #e7f5e6 !important;
}

.bg-bp-green-100 {
  background-color: #c5e7c1 !important;
}

.text-bp-green-100 {
  color: #c5e7c1 !important;
}

.border-bp-green-100 {
  border-color: #c5e7c1 !important;
}

.bg-bp-green-200 {
  background-color: #a0d799 !important;
}

.text-bp-green-200 {
  color: #a0d799 !important;
}

.border-bp-green-200 {
  border-color: #a0d799 !important;
}

.bg-bp-green-300 {
  background-color: #77c96e !important;
}

.text-bp-green-300 {
  color: #77c96e !important;
}

.border-bp-green-300 {
  border-color: #77c96e !important;
}

.bg-bp-green-400 {
  background-color: #57bd4d !important;
}

.text-bp-green-400 {
  color: #57bd4d !important;
}

.border-bp-green-400 {
  border-color: #57bd4d !important;
}

.bg-bp-green-500 {
  background-color: #34b128 !important;
}

.text-bp-green-500 {
  color: #34b128 !important;
}

.border-bp-green-500 {
  border-color: #34b128 !important;
}

.bg-bp-green-600 {
  background-color: #29a21f !important;
}

.text-bp-green-600 {
  color: #29a21f !important;
}

.border-bp-green-600 {
  border-color: #29a21f !important;
}

.bg-bp-green-700 {
  background-color: #199011 !important;
}

.text-bp-green-700 {
  color: #199011 !important;
}

.border-bp-green-700 {
  border-color: #199011 !important;
}

.bg-bp-green-800 {
  background-color: #007f00 !important;
}

.text-bp-green-800 {
  color: #007f00 !important;
}

.border-bp-green-800 {
  border-color: #007f00 !important;
}

.bg-bp-green-900 {
  background-color: #006000 !important;
}

.text-bp-green-900 {
  color: #006000 !important;
}

.border-bp-green-900 {
  border-color: #006000 !important;
}

.bg-bp-light-green-50 {
  background-color: #f4f9e5 !important;
}

.text-bp-light-green-50 {
  color: #f4f9e5 !important;
}

.border-bp-light-green-50 {
  border-color: #f4f9e5 !important;
}

.bg-bp-light-green-100 {
  background-color: #e3f0bf !important;
}

.text-bp-light-green-100 {
  color: #e3f0bf !important;
}

.border-bp-light-green-100 {
  border-color: #e3f0bf !important;
}

.bg-bp-light-green-200 {
  background-color: #cfe696 !important;
}

.text-bp-light-green-200 {
  color: #cfe696 !important;
}

.border-bp-light-green-200 {
  border-color: #cfe696 !important;
}

.bg-bp-light-green-300 {
  background-color: #bbdc68 !important;
}

.text-bp-light-green-300 {
  color: #bbdc68 !important;
}

.border-bp-light-green-300 {
  border-color: #bbdc68 !important;
}

.bg-bp-light-green-400 {
  background-color: #a9d441 !important;
}

.text-bp-light-green-400 {
  color: #a9d441 !important;
}

.border-bp-light-green-400 {
  border-color: #a9d441 !important;
}

.bg-bp-light-green-500 {
  background-color: #99cc00 !important;
}

.text-bp-light-green-500 {
  color: #99cc00 !important;
}

.border-bp-light-green-500 {
  border-color: #99cc00 !important;
}

.bg-bp-light-green-600 {
  background-color: #88bc00 !important;
}

.text-bp-light-green-600 {
  color: #88bc00 !important;
}

.border-bp-light-green-600 {
  border-color: #88bc00 !important;
}

.bg-bp-light-green-700 {
  background-color: #71a800 !important;
}

.text-bp-light-green-700 {
  color: #71a800 !important;
}

.border-bp-light-green-700 {
  border-color: #71a800 !important;
}

.bg-bp-light-green-800 {
  background-color: #5a9400 !important;
}

.text-bp-light-green-800 {
  color: #5a9400 !important;
}

.border-bp-light-green-800 {
  border-color: #5a9400 !important;
}

.bg-bp-light-green-900 {
  background-color: #2e7300 !important;
}

.text-bp-light-green-900 {
  color: #2e7300 !important;
}

.border-bp-light-green-900 {
  border-color: #2e7300 !important;
}

.bg-bp-yellow-50 {
  background-color: #fffce5 !important;
}

.text-bp-yellow-50 {
  color: #fffce5 !important;
}

.border-bp-yellow-50 {
  border-color: #fffce5 !important;
}

.bg-bp-yellow-100 {
  background-color: #fff7be !important;
}

.text-bp-yellow-100 {
  color: #fff7be !important;
}

.border-bp-yellow-100 {
  border-color: #fff7be !important;
}

.bg-bp-yellow-200 {
  background-color: #fff292 !important;
}

.text-bp-yellow-200 {
  color: #fff292 !important;
}

.border-bp-yellow-200 {
  border-color: #fff292 !important;
}

.bg-bp-yellow-300 {
  background-color: #ffed65 !important;
}

.text-bp-yellow-300 {
  color: #ffed65 !important;
}

.border-bp-yellow-300 {
  border-color: #ffed65 !important;
}

.bg-bp-yellow-400 {
  background-color: #fee83d !important;
}

.text-bp-yellow-400 {
  color: #fee83d !important;
}

.border-bp-yellow-400 {
  border-color: #fee83d !important;
}

.bg-bp-yellow-500 {
  background-color: #ffe600 !important;
}

.text-bp-yellow-500 {
  color: #ffe600 !important;
}

.border-bp-yellow-500 {
  border-color: #ffe600 !important;
}

.bg-bp-yellow-600 {
  background-color: #fed200 !important;
}

.text-bp-yellow-600 {
  color: #fed200 !important;
}

.border-bp-yellow-600 {
  border-color: #fed200 !important;
}

.bg-bp-yellow-700 {
  background-color: #fdb900 !important;
}

.text-bp-yellow-700 {
  color: #fdb900 !important;
}

.border-bp-yellow-700 {
  border-color: #fdb900 !important;
}

.bg-bp-yellow-800 {
  background-color: #fda000 !important;
}

.text-bp-yellow-800 {
  color: #fda000 !important;
}

.border-bp-yellow-800 {
  border-color: #fda000 !important;
}

.bg-bp-yellow-900 {
  background-color: #fb7300 !important;
}

.text-bp-yellow-900 {
  color: #fb7300 !important;
}

.border-bp-yellow-900 {
  border-color: #fb7300 !important;
}

.bg-bp-bright-green-50 {
  background-color: #f9ffe7 !important;
}

.text-bp-bright-green-50 {
  color: #f9ffe7 !important;
}

.border-bp-bright-green-50 {
  border-color: #f9ffe7 !important;
}

.bg-bp-bright-green-100 {
  background-color: #f0ffc2 !important;
}

.text-bp-bright-green-100 {
  color: #f0ffc2 !important;
}

.border-bp-bright-green-100 {
  border-color: #f0ffc2 !important;
}

.bg-bp-bright-green-200 {
  background-color: #e4fe98 !important;
}

.text-bp-bright-green-200 {
  color: #e4fe98 !important;
}

.border-bp-bright-green-200 {
  border-color: #e4fe98 !important;
}

.bg-bp-bright-green-300 {
  background-color: #d8fd69 !important;
}

.text-bp-bright-green-300 {
  color: #d8fd69 !important;
}

.border-bp-bright-green-300 {
  border-color: #d8fd69 !important;
}

.bg-bp-bright-green-400 {
  background-color: #cdfa3f !important;
}

.text-bp-bright-green-400 {
  color: #cdfa3f !important;
}

.border-bp-bright-green-400 {
  border-color: #cdfa3f !important;
}

.bg-bp-bright-green-500 {
  background-color: #ccff00 !important;
}

.text-bp-bright-green-500 {
  color: #ccff00 !important;
}

.border-bp-bright-green-500 {
  border-color: #ccff00 !important;
}

.bg-bp-bright-green-600 {
  background-color: #c1eb00 !important;
}

.text-bp-bright-green-600 {
  color: #c1eb00 !important;
}

.border-bp-bright-green-600 {
  border-color: #c1eb00 !important;
}

.bg-bp-bright-green-700 {
  background-color: #b1d400 !important;
}

.text-bp-bright-green-700 {
  color: #b1d400 !important;
}

.border-bp-bright-green-700 {
  border-color: #b1d400 !important;
}

.bg-bp-bright-green-800 {
  background-color: #a3bc00 !important;
}

.text-bp-bright-green-800 {
  color: #a3bc00 !important;
}

.border-bp-bright-green-800 {
  border-color: #a3bc00 !important;
}

.bg-bp-bright-green-900 {
  background-color: #8c9300 !important;
}

.text-bp-bright-green-900 {
  color: #8c9300 !important;
}

.border-bp-bright-green-900 {
  border-color: #8c9300 !important;
}

.bg-bp-dark-green-50 {
  background-color: #e5f4e9 !important;
}

.text-bp-dark-green-50 {
  color: #e5f4e9 !important;
}

.border-bp-dark-green-50 {
  border-color: #e5f4e9 !important;
}

.bg-bp-dark-green-100 {
  background-color: #c1e4ca !important;
}

.text-bp-dark-green-100 {
  color: #c1e4ca !important;
}

.border-bp-dark-green-100 {
  border-color: #c1e4ca !important;
}

.bg-bp-dark-green-200 {
  background-color: #99d3a8 !important;
}

.text-bp-dark-green-200 {
  color: #99d3a8 !important;
}

.border-bp-dark-green-200 {
  border-color: #99d3a8 !important;
}

.bg-bp-dark-green-300 {
  background-color: #6ec386 !important;
}

.text-bp-dark-green-300 {
  color: #6ec386 !important;
}

.border-bp-dark-green-300 {
  border-color: #6ec386 !important;
}

.bg-bp-dark-green-400 {
  background-color: #4db66d !important;
}

.text-bp-dark-green-400 {
  color: #4db66d !important;
}

.border-bp-dark-green-400 {
  border-color: #4db66d !important;
}

.bg-bp-dark-green-500 {
  background-color: #24aa54 !important;
}

.text-bp-dark-green-500 {
  color: #24aa54 !important;
}

.border-bp-dark-green-500 {
  border-color: #24aa54 !important;
}

.bg-bp-dark-green-600 {
  background-color: #1b9b4a !important;
}

.text-bp-dark-green-600 {
  color: #1b9b4a !important;
}

.border-bp-dark-green-600 {
  border-color: #1b9b4a !important;
}

.bg-bp-dark-green-700 {
  background-color: #0e893f !important;
}

.text-bp-dark-green-700 {
  color: #0e893f !important;
}

.border-bp-dark-green-700 {
  border-color: #0e893f !important;
}

.bg-bp-dark-green-800 {
  background-color: #007834 !important;
}

.text-bp-dark-green-800 {
  color: #007834 !important;
}

.border-bp-dark-green-800 {
  border-color: #007834 !important;
}

.bg-bp-dark-green-900 {
  background-color: #005921 !important;
}

.text-bp-dark-green-900 {
  color: #005921 !important;
}

.border-bp-dark-green-900 {
  border-color: #005921 !important;
}

.bg-bp-dark-blue-50 {
  background-color: #ece5f6 !important;
}

.text-bp-dark-blue-50 {
  color: #ece5f6 !important;
}

.border-bp-dark-blue-50 {
  border-color: #ece5f6 !important;
}

.bg-bp-dark-blue-100 {
  background-color: #cebee9 !important;
}

.text-bp-dark-blue-100 {
  color: #cebee9 !important;
}

.border-bp-dark-blue-100 {
  border-color: #cebee9 !important;
}

.bg-bp-dark-blue-200 {
  background-color: #ad93db !important;
}

.text-bp-dark-blue-200 {
  color: #ad93db !important;
}

.border-bp-dark-blue-200 {
  border-color: #ad93db !important;
}

.bg-bp-dark-blue-300 {
  background-color: #8c67ce !important;
}

.text-bp-dark-blue-300 {
  color: #8c67ce !important;
}

.border-bp-dark-blue-300 {
  border-color: #8c67ce !important;
}

.bg-bp-dark-blue-400 {
  background-color: #7246c4 !important;
}

.text-bp-dark-blue-400 {
  color: #7246c4 !important;
}

.border-bp-dark-blue-400 {
  border-color: #7246c4 !important;
}

.bg-bp-dark-blue-500 {
  background-color: #5724b9 !important;
}

.text-bp-dark-blue-500 {
  color: #5724b9 !important;
}

.border-bp-dark-blue-500 {
  border-color: #5724b9 !important;
}

.bg-bp-dark-blue-600 {
  background-color: #4d1fb4 !important;
}

.text-bp-dark-blue-600 {
  color: #4d1fb4 !important;
}

.border-bp-dark-blue-600 {
  border-color: #4d1fb4 !important;
}

.bg-bp-dark-blue-700 {
  background-color: #3e17ab !important;
}

.text-bp-dark-blue-700 {
  color: #3e17ab !important;
}

.border-bp-dark-blue-700 {
  border-color: #3e17ab !important;
}

.bg-bp-dark-blue-800 {
  background-color: #2e10a4 !important;
}

.text-bp-dark-blue-800 {
  color: #2e10a4 !important;
}

.border-bp-dark-blue-800 {
  border-color: #2e10a4 !important;
}

.bg-bp-dark-blue-900 {
  background-color: #000099 !important;
}

.text-bp-dark-blue-900 {
  color: #000099 !important;
}

.border-bp-dark-blue-900 {
  border-color: #000099 !important;
}

.bg-bp-yellow-orange-50 {
  background-color: #fcf7e1 !important;
}

.text-bp-yellow-orange-50 {
  color: #fcf7e1 !important;
}

.border-bp-yellow-orange-50 {
  border-color: #fcf7e1 !important;
}

.bg-bp-yellow-orange-100 {
  background-color: #f9eab4 !important;
}

.text-bp-yellow-orange-100 {
  color: #f9eab4 !important;
}

.border-bp-yellow-orange-100 {
  border-color: #f9eab4 !important;
}

.bg-bp-yellow-orange-200 {
  background-color: #f5dc84 !important;
}

.text-bp-yellow-orange-200 {
  color: #f5dc84 !important;
}

.border-bp-yellow-orange-200 {
  border-color: #f5dc84 !important;
}

.bg-bp-yellow-orange-300 {
  background-color: #f1d054 !important;
}

.text-bp-yellow-orange-300 {
  color: #f1d054 !important;
}

.border-bp-yellow-orange-300 {
  border-color: #f1d054 !important;
}

.bg-bp-yellow-orange-400 {
  background-color: #efc433 !important;
}

.text-bp-yellow-orange-400 {
  color: #efc433 !important;
}

.border-bp-yellow-orange-400 {
  border-color: #efc433 !important;
}

.bg-bp-yellow-orange-500 {
  background-color: #edbb20 !important;
}

.text-bp-yellow-orange-500 {
  color: #edbb20 !important;
}

.border-bp-yellow-orange-500 {
  border-color: #edbb20 !important;
}

.bg-bp-yellow-orange-600 {
  background-color: #edac1a !important;
}

.text-bp-yellow-orange-600 {
  color: #edac1a !important;
}

.border-bp-yellow-orange-600 {
  border-color: #edac1a !important;
}

.bg-bp-yellow-orange-700 {
  background-color: #ec9c16 !important;
}

.text-bp-yellow-orange-700 {
  color: #ec9c16 !important;
}

.border-bp-yellow-orange-700 {
  border-color: #ec9c16 !important;
}

.bg-bp-yellow-orange-800 {
  background-color: #ec8c12 !important;
}

.text-bp-yellow-orange-800 {
  color: #ec8c12 !important;
}

.border-bp-yellow-orange-800 {
  border-color: #ec8c12 !important;
}

.bg-bp-yellow-orange-900 {
  background-color: #ea6f0d !important;
}

.text-bp-yellow-orange-900 {
  color: #ea6f0d !important;
}

.border-bp-yellow-orange-900 {
  border-color: #ea6f0d !important;
}

.bg-bp-pale-yellow-50 {
  background-color: #fef9e4 !important;
}

.text-bp-pale-yellow-50 {
  color: #fef9e4 !important;
}

.border-bp-pale-yellow-50 {
  border-color: #fef9e4 !important;
}

.bg-bp-pale-yellow-100 {
  background-color: #fceebb !important;
}

.text-bp-pale-yellow-100 {
  color: #fceebb !important;
}

.border-bp-pale-yellow-100 {
  border-color: #fceebb !important;
}

.bg-bp-pale-yellow-200 {
  background-color: #fce48f !important;
}

.text-bp-pale-yellow-200 {
  color: #fce48f !important;
}

.border-bp-pale-yellow-200 {
  border-color: #fce48f !important;
}

.bg-bp-pale-yellow-300 {
  background-color: #fbdb65 !important;
}

.text-bp-pale-yellow-300 {
  color: #fbdb65 !important;
}

.border-bp-pale-yellow-300 {
  border-color: #fbdb65 !important;
}

.bg-bp-pale-yellow-400 {
  background-color: #fad14a !important;
}

.text-bp-pale-yellow-400 {
  color: #fad14a !important;
}

.border-bp-pale-yellow-400 {
  border-color: #fad14a !important;
}

.bg-bp-pale-yellow-500 {
  background-color: #fbc93a !important;
}

.text-bp-pale-yellow-500 {
  color: #fbc93a !important;
}

.border-bp-pale-yellow-500 {
  border-color: #fbc93a !important;
}

.bg-bp-pale-yellow-600 {
  background-color: #fabb34 !important;
}

.text-bp-pale-yellow-600 {
  color: #fabb34 !important;
}

.border-bp-pale-yellow-600 {
  border-color: #fabb34 !important;
}

.bg-bp-pale-yellow-700 {
  background-color: #f9a92e !important;
}

.text-bp-pale-yellow-700 {
  color: #f9a92e !important;
}

.border-bp-pale-yellow-700 {
  border-color: #f9a92e !important;
}

.bg-bp-pale-yellow-800 {
  background-color: #f89929 !important;
}

.text-bp-pale-yellow-800 {
  color: #f89929 !important;
}

.border-bp-pale-yellow-800 {
  border-color: #f89929 !important;
}

.bg-bp-pale-yellow-900 {
  background-color: #f77d1f !important;
}

.text-bp-pale-yellow-900 {
  color: #f77d1f !important;
}

.border-bp-pale-yellow-900 {
  border-color: #f77d1f !important;
}

.bg-bp-pale-green-50 {
  background-color: #e4f1e5 !important;
}

.text-bp-pale-green-50 {
  color: #e4f1e5 !important;
}

.border-bp-pale-green-50 {
  border-color: #e4f1e5 !important;
}

.bg-bp-pale-green-100 {
  background-color: #bedbbf !important;
}

.text-bp-pale-green-100 {
  color: #bedbbf !important;
}

.border-bp-pale-green-100 {
  border-color: #bedbbf !important;
}

.bg-bp-pale-green-200 {
  background-color: #94c496 !important;
}

.text-bp-pale-green-200 {
  color: #94c496 !important;
}

.border-bp-pale-green-200 {
  border-color: #94c496 !important;
}

.bg-bp-pale-green-300 {
  background-color: #6aae6e !important;
}

.text-bp-pale-green-300 {
  color: #6aae6e !important;
}

.border-bp-pale-green-300 {
  border-color: #6aae6e !important;
}

.bg-bp-pale-green-400 {
  background-color: #4a9e51 !important;
}

.text-bp-pale-green-400 {
  color: #4a9e51 !important;
}

.border-bp-pale-green-400 {
  border-color: #4a9e51 !important;
}

.bg-bp-pale-green-500 {
  background-color: #288f33 !important;
}

.text-bp-pale-green-500 {
  color: #288f33 !important;
}

.border-bp-pale-green-500 {
  border-color: #288f33 !important;
}

.bg-bp-pale-green-600 {
  background-color: #1f812b !important;
}

.text-bp-pale-green-600 {
  color: #1f812b !important;
}

.border-bp-pale-green-600 {
  border-color: #1f812b !important;
}

.bg-bp-pale-green-700 {
  background-color: #147122 !important;
}

.text-bp-pale-green-700 {
  color: #147122 !important;
}

.border-bp-pale-green-700 {
  border-color: #147122 !important;
}

.bg-bp-pale-green-800 {
  background-color: #066018 !important;
}

.text-bp-pale-green-800 {
  color: #066018 !important;
}

.border-bp-pale-green-800 {
  border-color: #066018 !important;
}

.bg-bp-pale-green-900 {
  background-color: #004306 !important;
}

.text-bp-pale-green-900 {
  color: #004306 !important;
}

.border-bp-pale-green-900 {
  border-color: #004306 !important;
}

.bg-bp-orange-50 {
  background-color: #fff7e0 !important;
}

.text-bp-orange-50 {
  color: #fff7e0 !important;
}

.border-bp-orange-50 {
  border-color: #fff7e0 !important;
}

.bg-bp-orange-100 {
  background-color: #ffeab1 !important;
}

.text-bp-orange-100 {
  color: #ffeab1 !important;
}

.border-bp-orange-100 {
  border-color: #ffeab1 !important;
}

.bg-bp-orange-200 {
  background-color: #ffdc7e !important;
}

.text-bp-orange-200 {
  color: #ffdc7e !important;
}

.border-bp-orange-200 {
  border-color: #ffdc7e !important;
}

.bg-bp-orange-300 {
  background-color: #ffd04a !important;
}

.text-bp-orange-300 {
  color: #ffd04a !important;
}

.border-bp-orange-300 {
  border-color: #ffd04a !important;
}

.bg-bp-orange-400 {
  background-color: #ffc41f !important;
}

.text-bp-orange-400 {
  color: #ffc41f !important;
}

.border-bp-orange-400 {
  border-color: #ffc41f !important;
}

.bg-bp-orange-500 {
  background-color: #ffba00 !important;
}

.text-bp-orange-500 {
  color: #ffba00 !important;
}

.border-bp-orange-500 {
  border-color: #ffba00 !important;
}

.bg-bp-orange-600 {
  background-color: #ffac00 !important;
}

.text-bp-orange-600 {
  color: #ffac00 !important;
}

.border-bp-orange-600 {
  border-color: #ffac00 !important;
}

.bg-bp-orange-700 {
  background-color: #ff9900 !important;
}

.text-bp-orange-700 {
  color: #ff9900 !important;
}

.border-bp-orange-700 {
  border-color: #ff9900 !important;
}

.bg-bp-orange-800 {
  background-color: #ff8700 !important;
}

.text-bp-orange-800 {
  color: #ff8700 !important;
}

.border-bp-orange-800 {
  border-color: #ff8700 !important;
}

.bg-bp-orange-900 {
  background-color: #ff6600 !important;
}

.text-bp-orange-900 {
  color: #ff6600 !important;
}

.border-bp-orange-900 {
  border-color: #ff6600 !important;
}

.bg-bp-CO2-blue-50 {
  background-color: #e1f5fd !important;
}

.text-bp-CO2-blue-50 {
  color: #e1f5fd !important;
}

.border-bp-CO2-blue-50 {
  border-color: #e1f5fd !important;
}

.bg-bp-CO2-blue-100 {
  background-color: #b3e6fa !important;
}

.text-bp-CO2-blue-100 {
  color: #b3e6fa !important;
}

.border-bp-CO2-blue-100 {
  border-color: #b3e6fa !important;
}

.bg-bp-CO2-blue-200 {
  background-color: #82d5f6 !important;
}

.text-bp-CO2-blue-200 {
  color: #82d5f6 !important;
}

.border-bp-CO2-blue-200 {
  border-color: #82d5f6 !important;
}

.bg-bp-CO2-blue-300 {
  background-color: #51c4f2 !important;
}

.text-bp-CO2-blue-300 {
  color: #51c4f2 !important;
}

.border-bp-CO2-blue-300 {
  border-color: #51c4f2 !important;
}

.bg-bp-CO2-blue-400 {
  background-color: #2db7f1 !important;
}

.text-bp-CO2-blue-400 {
  color: #2db7f1 !important;
}

.border-bp-CO2-blue-400 {
  border-color: #2db7f1 !important;
}

.bg-bp-CO2-blue-500 {
  background-color: #05abef !important;
}

.text-bp-CO2-blue-500 {
  color: #05abef !important;
}

.border-bp-CO2-blue-500 {
  border-color: #05abef !important;
}

.bg-bp-CO2-blue-600 {
  background-color: #009de0 !important;
}

.text-bp-CO2-blue-600 {
  color: #009de0 !important;
}

.border-bp-CO2-blue-600 {
  border-color: #009de0 !important;
}

.bg-bp-CO2-blue-700 {
  background-color: #008acc !important;
}

.text-bp-CO2-blue-700 {
  color: #008acc !important;
}

.border-bp-CO2-blue-700 {
  border-color: #008acc !important;
}

.bg-bp-CO2-blue-800 {
  background-color: #0079b9 !important;
}

.text-bp-CO2-blue-800 {
  color: #0079b9 !important;
}

.border-bp-CO2-blue-800 {
  border-color: #0079b9 !important;
}

.bg-bp-CO2-blue-900 {
  background-color: #005997 !important;
}

.text-bp-CO2-blue-900 {
  color: #005997 !important;
}

.border-bp-CO2-blue-900 {
  border-color: #005997 !important;
}

.bg-bp-purple-50 {
  background-color: #f3e4f5 !important;
}

.text-bp-purple-50 {
  color: #f3e4f5 !important;
}

.border-bp-purple-50 {
  border-color: #f3e4f5 !important;
}

.bg-bp-purple-100 {
  background-color: #e0bae6 !important;
}

.text-bp-purple-100 {
  color: #e0bae6 !important;
}

.border-bp-purple-100 {
  border-color: #e0bae6 !important;
}

.bg-bp-purple-200 {
  background-color: #cd8dd6 !important;
}

.text-bp-purple-200 {
  color: #cd8dd6 !important;
}

.border-bp-purple-200 {
  border-color: #cd8dd6 !important;
}

.bg-bp-purple-300 {
  background-color: #b85fc5 !important;
}

.text-bp-purple-300 {
  color: #b85fc5 !important;
}

.border-bp-purple-300 {
  border-color: #b85fc5 !important;
}

.bg-bp-purple-400 {
  background-color: #a939b9 !important;
}

.text-bp-purple-400 {
  color: #a939b9 !important;
}

.border-bp-purple-400 {
  border-color: #a939b9 !important;
}

.bg-bp-purple-500 {
  background-color: #9907ad !important;
}

.text-bp-purple-500 {
  color: #9907ad !important;
}

.border-bp-purple-500 {
  border-color: #9907ad !important;
}

.bg-bp-purple-600 {
  background-color: #8b06a8 !important;
}

.text-bp-purple-600 {
  color: #8b06a8 !important;
}

.border-bp-purple-600 {
  border-color: #8b06a8 !important;
}

.bg-bp-purple-700 {
  background-color: #7802a0 !important;
}

.text-bp-purple-700 {
  color: #7802a0 !important;
}

.border-bp-purple-700 {
  border-color: #7802a0 !important;
}

.bg-bp-purple-800 {
  background-color: #660099 !important;
}

.text-bp-purple-800 {
  color: #660099 !important;
}

.border-bp-purple-800 {
  border-color: #660099 !important;
}

.bg-bp-purple-900 {
  background-color: #44008d !important;
}

.text-bp-purple-900 {
  color: #44008d !important;
}

.border-bp-purple-900 {
  border-color: #44008d !important;
}

:root,
[data-bs-theme=light] {
  --text-default-color: #111;
  --text-brand-primary-color: #007f00;
}

[data-bs-theme=dark],
.dark {
  --text-default-color: #fff;
  --text-brand-primary-color: #ccff00;
}

.text-default {
  color: var(--text-default-color) !important;
}

.text-bp-bright-green {
  color: #ccff00 !important;
}

.text-brand-primary {
  color: var(--text-brand-primary-color) !important;
}

a.link-border,
.btn-link,
.btn-brand-quartenary,
.btn-darker-quartenary,
.btn-standard-quartenary {
  display: inline-flex;
  align-items: center;
}

a.link-border,
.btn-link span,
.btn-brand-quartenary span,
.btn-darker-quartenary span,
.btn-standard-quartenary span {
  background-image: linear-gradient(to right, rgba(0, 43, 188, 0) 0%, rgba(0, 43, 188, 0) 100%);
  background-size: 100% 3.6%;
  background-position: right 93%;
  background-repeat: no-repeat;
  transition: opacity 300ms, color 300ms, background-position 300ms;
}

a.link-border:hover,
.btn-link:hover span,
.btn-brand-quartenary:hover span,
.btn-darker-quartenary:hover span,
.btn-standard-quartenary:hover span {
  background-image: linear-gradient(to right, currentColor 0%, currentColor 100%);
}

a.link-border:focus,
a.link-border.focus {
  background-position-y: 100%;
}

a.link-border,
.card-link,
.btn-link,
.btn-brand-quartenary,
.btn-darker-quartenary,
.btn-standard-quartenary,
.btn-link:hover,
.btn-link:focus,
.btn-link.focus {
  text-decoration: none;
}

.dark {
  --bs-link-color-rgb: 141, 219, 255;
  --bs-link-hover-color-rgb: 141, 219, 255;
  --bs-link-color: #8ddbff;
  --bs-link-hover-color: #8ddbff;
}

.link-primary:not(.btn) {
  color: rgba(17, 17, 17, 0.7) !important;
}
.link-primary:hover {
  color: #111111 !important;
}

.dark .link-primary:not(.btn) {
  color: rgba(255, 255, 255, 0.7) !important;
}
.dark .link-primary:hover, .dark .link-primary:focus {
  color: #fff !important;
}

a.link-border-animation {
  background-image: linear-gradient(to right, currentColor 0%, currentColor 100%);
}
a.link-border-animation:hover {
  animation: 450ms cubic-bezier(0.785, 0.135, 0.15, 0.86) 0s 1 normal none running linkAnimation;
}

a.link-dark {
  color: rgba(17, 17, 17, 0.7) !important;
}

a.link-light {
  color: rgba(255, 255, 255, 0.7) !important;
}
a.link-light:hover, a.link-light:focus {
  color: #fff !important;
}

@keyframes linkAnimation {
  0% {
    background-size: 100% 4%;
    background-position-x: 100%;
  }
  50% {
    background-size: 0px 4%;
    background-position-x: 100%;
  }
  50.01% {
    background-size: 0px 4%;
    background-position-x: 0px;
  }
  100% {
    background-size: 100% 4%;
    background-position-x: 0px;
  }
}
body {
  letter-spacing: 0.15px;
}

.bg-dark,
.bg-dark-secondary {
  color: #fff;
}

h1,
.h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5 {
  letter-spacing: 0.2px;
}
h1.fw-normal, h2.fw-normal, h3.fw-normal, h4.fw-normal, h5.fw-normal,
.h1.fw-normal, .h2.fw-normal, .h3.fw-normal, .h4.fw-normal, .h5.fw-normal {
  letter-spacing: 0.15px;
}
h1.fw-medium, h2.fw-medium, h3.fw-medium, h4.fw-medium, h5.fw-medium,
.h1.fw-medium, .h2.fw-medium, .h3.fw-medium, .h4.fw-medium, .h5.fw-medium {
  letter-spacing: 0.1px;
}

h2, .h2 {
  line-height: 1.5172413793;
}

h4, .h4 {
  line-height: 1.5217391304;
}

h3,
.h3, h4, .h4 {
  margin-bottom: 1.5rem;
}

h5,
.h5, h6, .h6 {
  margin-bottom: 1rem;
}

h6, .h6 {
  text-transform: uppercase;
  letter-spacing: 1.6px;
}

.font-family-base {
  font-family: "Roboto", Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
}

.display-1 {
  letter-spacing: 0.3px;
  line-height: 1.1222222222;
}
.display-1.fw-normal {
  letter-spacing: 0.25px;
}
.display-1.fw-medium {
  letter-spacing: 0.2px;
}

.display-2 {
  line-height: 1.2537313433;
}

.display-1,
.display-2 {
  margin-bottom: 2.5rem;
}

.display-2,
.display-3 {
  letter-spacing: 0.4px;
}
.display-2.fw-normal,
.display-3.fw-normal {
  letter-spacing: 0.35px;
}
.display-2.fw-medium,
.display-3.fw-medium {
  letter-spacing: 0.3px;
}

.display-3 {
  line-height: 1.3725490196;
}

.display-3,
.display-4 {
  margin-bottom: 2rem;
}

.display-4 {
  line-height: 1.4473684211;
}

.display-4,
.display-5 {
  letter-spacing: 0.5px;
}
.display-4.fw-normal,
.display-5.fw-normal {
  letter-spacing: 0.45px;
}
.display-4.fw-medium,
.display-5.fw-medium {
  letter-spacing: 0.4px;
}

.display-5 {
  line-height: 1.4285714286;
}

.display-5,
.display-6 {
  margin-bottom: 1.5rem;
}

.fs-base {
  font-size: 1rem !important;
  line-height: 1.75;
}

p {
  opacity: 0.8;
}

.lead {
  letter-spacing: 0.2px;
  line-height: 1.7777777778;
  opacity: 1;
}

.small-md {
  font-size: 0.875rem;
  line-height: 1.5;
}

p.small {
  font-size: 0.8125rem;
  line-height: 1.7692307692;
  letter-spacing: 0.25px;
  opacity: 0.7;
}

small,
.small {
  font-weight: 300;
  font-size: 0.75rem;
  line-height: 1.75;
  letter-spacing: 0.25px;
}

.small-sm {
  font-size: 0.6875rem;
  line-height: 1.9090909091;
  font-weight: 400;
}

.small-xs {
  font-size: 0.625rem !important;
  line-height: 2;
  font-weight: 400;
}

.list-styled,
.list-styled ul,
.list-styled ol {
  padding-left: 1.5rem;
}
.list-styled li + li,
.list-styled ul li:first-child,
.list-styled ol li:first-child {
  margin-top: 0.5rem;
}

.dark .border-primary {
  border-color: #343434 !important;
}

.row-5 .col {
  flex: 1 0;
}
.row-5 .row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}
.row-5 .row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}
.row-5 .row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}
.row-5 .row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}
.row-5 .row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}
.row-5 .row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}
.row-5 .row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}
.row-5 .col-auto {
  flex: 0 0 auto;
  width: auto;
}
.row-5 .col-1 {
  flex: 0 0 auto;
  width: 20%;
}
.row-5 .col-2 {
  flex: 0 0 auto;
  width: 40%;
}
.row-5 .col-3 {
  flex: 0 0 auto;
  width: 60%;
}
.row-5 .col-4 {
  flex: 0 0 auto;
  width: 80%;
}
.row-5 .col-5 {
  flex: 0 0 auto;
  width: 100%;
}
.row-5 .offset-1 {
  margin-left: 20%;
}
.row-5 .offset-2 {
  margin-left: 40%;
}
.row-5 .offset-3 {
  margin-left: 60%;
}
.row-5 .offset-4 {
  margin-left: 80%;
}
.row-5 .g-0,
.row-5 .gx-0 {
  --bs-gutter-x: 0;
}
.row-5 .g-0,
.row-5 .gy-0 {
  --bs-gutter-y: 0;
}
.row-5 .g-1,
.row-5 .gx-1 {
  --bs-gutter-x: 0.125rem;
}
.row-5 .g-1,
.row-5 .gy-1 {
  --bs-gutter-y: 0.125rem;
}
.row-5 .g-2,
.row-5 .gx-2 {
  --bs-gutter-x: 0.25rem;
}
.row-5 .g-2,
.row-5 .gy-2 {
  --bs-gutter-y: 0.25rem;
}
.row-5 .g-3,
.row-5 .gx-3 {
  --bs-gutter-x: 0.5rem;
}
.row-5 .g-3,
.row-5 .gy-3 {
  --bs-gutter-y: 0.5rem;
}
.row-5 .g-4,
.row-5 .gx-4 {
  --bs-gutter-x: 1rem;
}
.row-5 .g-4,
.row-5 .gy-4 {
  --bs-gutter-y: 1rem;
}
.row-5 .g-5,
.row-5 .gx-5 {
  --bs-gutter-x: 1.5rem;
}
.row-5 .g-5,
.row-5 .gy-5 {
  --bs-gutter-y: 1.5rem;
}
.row-5 .g-6,
.row-5 .gx-6 {
  --bs-gutter-x: 2rem;
}
.row-5 .g-6,
.row-5 .gy-6 {
  --bs-gutter-y: 2rem;
}
.row-5 .g-7,
.row-5 .gx-7 {
  --bs-gutter-x: 2.5rem;
}
.row-5 .g-7,
.row-5 .gy-7 {
  --bs-gutter-y: 2.5rem;
}
.row-5 .g-8,
.row-5 .gx-8 {
  --bs-gutter-x: 3rem;
}
.row-5 .g-8,
.row-5 .gy-8 {
  --bs-gutter-y: 3rem;
}
.row-5 .g-9,
.row-5 .gx-9 {
  --bs-gutter-x: 3.5rem;
}
.row-5 .g-9,
.row-5 .gy-9 {
  --bs-gutter-y: 3.5rem;
}
.row-5 .g-10,
.row-5 .gx-10 {
  --bs-gutter-x: 4rem;
}
.row-5 .g-10,
.row-5 .gy-10 {
  --bs-gutter-y: 4rem;
}
.row-5 .g-11,
.row-5 .gx-11 {
  --bs-gutter-x: 5rem;
}
.row-5 .g-11,
.row-5 .gy-11 {
  --bs-gutter-y: 5rem;
}
.row-5 .g-12,
.row-5 .gx-12 {
  --bs-gutter-x: 6rem;
}
.row-5 .g-12,
.row-5 .gy-12 {
  --bs-gutter-y: 6rem;
}
.row-5 .g-13,
.row-5 .gx-13 {
  --bs-gutter-x: 6.5rem;
}
.row-5 .g-13,
.row-5 .gy-13 {
  --bs-gutter-y: 6.5rem;
}
.row-5 .g-14,
.row-5 .gx-14 {
  --bs-gutter-x: 8rem;
}
.row-5 .g-14,
.row-5 .gy-14 {
  --bs-gutter-y: 8rem;
}
@media (min-width: 576px) {
  .row-5 .col-sm {
    flex: 1 0;
  }
  .row-5 .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-5 .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-5 .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-5 .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-5 .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-5 .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-5 .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .row-5 .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .row-5 .col-sm-1 {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-5 .col-sm-2 {
    flex: 0 0 auto;
    width: 40%;
  }
  .row-5 .col-sm-3 {
    flex: 0 0 auto;
    width: 60%;
  }
  .row-5 .col-sm-4 {
    flex: 0 0 auto;
    width: 80%;
  }
  .row-5 .col-sm-5 {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-5 .offset-sm-0 {
    margin-left: 0;
  }
  .row-5 .offset-sm-1 {
    margin-left: 20%;
  }
  .row-5 .offset-sm-2 {
    margin-left: 40%;
  }
  .row-5 .offset-sm-3 {
    margin-left: 60%;
  }
  .row-5 .offset-sm-4 {
    margin-left: 80%;
  }
  .row-5 .g-sm-0,
  .row-5 .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .row-5 .g-sm-0,
  .row-5 .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .row-5 .g-sm-1,
  .row-5 .gx-sm-1 {
    --bs-gutter-x: 0.125rem;
  }
  .row-5 .g-sm-1,
  .row-5 .gy-sm-1 {
    --bs-gutter-y: 0.125rem;
  }
  .row-5 .g-sm-2,
  .row-5 .gx-sm-2 {
    --bs-gutter-x: 0.25rem;
  }
  .row-5 .g-sm-2,
  .row-5 .gy-sm-2 {
    --bs-gutter-y: 0.25rem;
  }
  .row-5 .g-sm-3,
  .row-5 .gx-sm-3 {
    --bs-gutter-x: 0.5rem;
  }
  .row-5 .g-sm-3,
  .row-5 .gy-sm-3 {
    --bs-gutter-y: 0.5rem;
  }
  .row-5 .g-sm-4,
  .row-5 .gx-sm-4 {
    --bs-gutter-x: 1rem;
  }
  .row-5 .g-sm-4,
  .row-5 .gy-sm-4 {
    --bs-gutter-y: 1rem;
  }
  .row-5 .g-sm-5,
  .row-5 .gx-sm-5 {
    --bs-gutter-x: 1.5rem;
  }
  .row-5 .g-sm-5,
  .row-5 .gy-sm-5 {
    --bs-gutter-y: 1.5rem;
  }
  .row-5 .g-sm-6,
  .row-5 .gx-sm-6 {
    --bs-gutter-x: 2rem;
  }
  .row-5 .g-sm-6,
  .row-5 .gy-sm-6 {
    --bs-gutter-y: 2rem;
  }
  .row-5 .g-sm-7,
  .row-5 .gx-sm-7 {
    --bs-gutter-x: 2.5rem;
  }
  .row-5 .g-sm-7,
  .row-5 .gy-sm-7 {
    --bs-gutter-y: 2.5rem;
  }
  .row-5 .g-sm-8,
  .row-5 .gx-sm-8 {
    --bs-gutter-x: 3rem;
  }
  .row-5 .g-sm-8,
  .row-5 .gy-sm-8 {
    --bs-gutter-y: 3rem;
  }
  .row-5 .g-sm-9,
  .row-5 .gx-sm-9 {
    --bs-gutter-x: 3.5rem;
  }
  .row-5 .g-sm-9,
  .row-5 .gy-sm-9 {
    --bs-gutter-y: 3.5rem;
  }
  .row-5 .g-sm-10,
  .row-5 .gx-sm-10 {
    --bs-gutter-x: 4rem;
  }
  .row-5 .g-sm-10,
  .row-5 .gy-sm-10 {
    --bs-gutter-y: 4rem;
  }
  .row-5 .g-sm-11,
  .row-5 .gx-sm-11 {
    --bs-gutter-x: 5rem;
  }
  .row-5 .g-sm-11,
  .row-5 .gy-sm-11 {
    --bs-gutter-y: 5rem;
  }
  .row-5 .g-sm-12,
  .row-5 .gx-sm-12 {
    --bs-gutter-x: 6rem;
  }
  .row-5 .g-sm-12,
  .row-5 .gy-sm-12 {
    --bs-gutter-y: 6rem;
  }
  .row-5 .g-sm-13,
  .row-5 .gx-sm-13 {
    --bs-gutter-x: 6.5rem;
  }
  .row-5 .g-sm-13,
  .row-5 .gy-sm-13 {
    --bs-gutter-y: 6.5rem;
  }
  .row-5 .g-sm-14,
  .row-5 .gx-sm-14 {
    --bs-gutter-x: 8rem;
  }
  .row-5 .g-sm-14,
  .row-5 .gy-sm-14 {
    --bs-gutter-y: 8rem;
  }
}
@media (min-width: 768px) {
  .row-5 .col-md {
    flex: 1 0;
  }
  .row-5 .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-5 .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-5 .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-5 .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-5 .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-5 .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-5 .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .row-5 .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .row-5 .col-md-1 {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-5 .col-md-2 {
    flex: 0 0 auto;
    width: 40%;
  }
  .row-5 .col-md-3 {
    flex: 0 0 auto;
    width: 60%;
  }
  .row-5 .col-md-4 {
    flex: 0 0 auto;
    width: 80%;
  }
  .row-5 .col-md-5 {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-5 .offset-md-0 {
    margin-left: 0;
  }
  .row-5 .offset-md-1 {
    margin-left: 20%;
  }
  .row-5 .offset-md-2 {
    margin-left: 40%;
  }
  .row-5 .offset-md-3 {
    margin-left: 60%;
  }
  .row-5 .offset-md-4 {
    margin-left: 80%;
  }
  .row-5 .g-md-0,
  .row-5 .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .row-5 .g-md-0,
  .row-5 .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .row-5 .g-md-1,
  .row-5 .gx-md-1 {
    --bs-gutter-x: 0.125rem;
  }
  .row-5 .g-md-1,
  .row-5 .gy-md-1 {
    --bs-gutter-y: 0.125rem;
  }
  .row-5 .g-md-2,
  .row-5 .gx-md-2 {
    --bs-gutter-x: 0.25rem;
  }
  .row-5 .g-md-2,
  .row-5 .gy-md-2 {
    --bs-gutter-y: 0.25rem;
  }
  .row-5 .g-md-3,
  .row-5 .gx-md-3 {
    --bs-gutter-x: 0.5rem;
  }
  .row-5 .g-md-3,
  .row-5 .gy-md-3 {
    --bs-gutter-y: 0.5rem;
  }
  .row-5 .g-md-4,
  .row-5 .gx-md-4 {
    --bs-gutter-x: 1rem;
  }
  .row-5 .g-md-4,
  .row-5 .gy-md-4 {
    --bs-gutter-y: 1rem;
  }
  .row-5 .g-md-5,
  .row-5 .gx-md-5 {
    --bs-gutter-x: 1.5rem;
  }
  .row-5 .g-md-5,
  .row-5 .gy-md-5 {
    --bs-gutter-y: 1.5rem;
  }
  .row-5 .g-md-6,
  .row-5 .gx-md-6 {
    --bs-gutter-x: 2rem;
  }
  .row-5 .g-md-6,
  .row-5 .gy-md-6 {
    --bs-gutter-y: 2rem;
  }
  .row-5 .g-md-7,
  .row-5 .gx-md-7 {
    --bs-gutter-x: 2.5rem;
  }
  .row-5 .g-md-7,
  .row-5 .gy-md-7 {
    --bs-gutter-y: 2.5rem;
  }
  .row-5 .g-md-8,
  .row-5 .gx-md-8 {
    --bs-gutter-x: 3rem;
  }
  .row-5 .g-md-8,
  .row-5 .gy-md-8 {
    --bs-gutter-y: 3rem;
  }
  .row-5 .g-md-9,
  .row-5 .gx-md-9 {
    --bs-gutter-x: 3.5rem;
  }
  .row-5 .g-md-9,
  .row-5 .gy-md-9 {
    --bs-gutter-y: 3.5rem;
  }
  .row-5 .g-md-10,
  .row-5 .gx-md-10 {
    --bs-gutter-x: 4rem;
  }
  .row-5 .g-md-10,
  .row-5 .gy-md-10 {
    --bs-gutter-y: 4rem;
  }
  .row-5 .g-md-11,
  .row-5 .gx-md-11 {
    --bs-gutter-x: 5rem;
  }
  .row-5 .g-md-11,
  .row-5 .gy-md-11 {
    --bs-gutter-y: 5rem;
  }
  .row-5 .g-md-12,
  .row-5 .gx-md-12 {
    --bs-gutter-x: 6rem;
  }
  .row-5 .g-md-12,
  .row-5 .gy-md-12 {
    --bs-gutter-y: 6rem;
  }
  .row-5 .g-md-13,
  .row-5 .gx-md-13 {
    --bs-gutter-x: 6.5rem;
  }
  .row-5 .g-md-13,
  .row-5 .gy-md-13 {
    --bs-gutter-y: 6.5rem;
  }
  .row-5 .g-md-14,
  .row-5 .gx-md-14 {
    --bs-gutter-x: 8rem;
  }
  .row-5 .g-md-14,
  .row-5 .gy-md-14 {
    --bs-gutter-y: 8rem;
  }
}
@media (min-width: 992px) {
  .row-5 .col-lg {
    flex: 1 0;
  }
  .row-5 .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-5 .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-5 .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-5 .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-5 .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-5 .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-5 .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .row-5 .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .row-5 .col-lg-1 {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-5 .col-lg-2 {
    flex: 0 0 auto;
    width: 40%;
  }
  .row-5 .col-lg-3 {
    flex: 0 0 auto;
    width: 60%;
  }
  .row-5 .col-lg-4 {
    flex: 0 0 auto;
    width: 80%;
  }
  .row-5 .col-lg-5 {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-5 .offset-lg-0 {
    margin-left: 0;
  }
  .row-5 .offset-lg-1 {
    margin-left: 20%;
  }
  .row-5 .offset-lg-2 {
    margin-left: 40%;
  }
  .row-5 .offset-lg-3 {
    margin-left: 60%;
  }
  .row-5 .offset-lg-4 {
    margin-left: 80%;
  }
  .row-5 .g-lg-0,
  .row-5 .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .row-5 .g-lg-0,
  .row-5 .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .row-5 .g-lg-1,
  .row-5 .gx-lg-1 {
    --bs-gutter-x: 0.125rem;
  }
  .row-5 .g-lg-1,
  .row-5 .gy-lg-1 {
    --bs-gutter-y: 0.125rem;
  }
  .row-5 .g-lg-2,
  .row-5 .gx-lg-2 {
    --bs-gutter-x: 0.25rem;
  }
  .row-5 .g-lg-2,
  .row-5 .gy-lg-2 {
    --bs-gutter-y: 0.25rem;
  }
  .row-5 .g-lg-3,
  .row-5 .gx-lg-3 {
    --bs-gutter-x: 0.5rem;
  }
  .row-5 .g-lg-3,
  .row-5 .gy-lg-3 {
    --bs-gutter-y: 0.5rem;
  }
  .row-5 .g-lg-4,
  .row-5 .gx-lg-4 {
    --bs-gutter-x: 1rem;
  }
  .row-5 .g-lg-4,
  .row-5 .gy-lg-4 {
    --bs-gutter-y: 1rem;
  }
  .row-5 .g-lg-5,
  .row-5 .gx-lg-5 {
    --bs-gutter-x: 1.5rem;
  }
  .row-5 .g-lg-5,
  .row-5 .gy-lg-5 {
    --bs-gutter-y: 1.5rem;
  }
  .row-5 .g-lg-6,
  .row-5 .gx-lg-6 {
    --bs-gutter-x: 2rem;
  }
  .row-5 .g-lg-6,
  .row-5 .gy-lg-6 {
    --bs-gutter-y: 2rem;
  }
  .row-5 .g-lg-7,
  .row-5 .gx-lg-7 {
    --bs-gutter-x: 2.5rem;
  }
  .row-5 .g-lg-7,
  .row-5 .gy-lg-7 {
    --bs-gutter-y: 2.5rem;
  }
  .row-5 .g-lg-8,
  .row-5 .gx-lg-8 {
    --bs-gutter-x: 3rem;
  }
  .row-5 .g-lg-8,
  .row-5 .gy-lg-8 {
    --bs-gutter-y: 3rem;
  }
  .row-5 .g-lg-9,
  .row-5 .gx-lg-9 {
    --bs-gutter-x: 3.5rem;
  }
  .row-5 .g-lg-9,
  .row-5 .gy-lg-9 {
    --bs-gutter-y: 3.5rem;
  }
  .row-5 .g-lg-10,
  .row-5 .gx-lg-10 {
    --bs-gutter-x: 4rem;
  }
  .row-5 .g-lg-10,
  .row-5 .gy-lg-10 {
    --bs-gutter-y: 4rem;
  }
  .row-5 .g-lg-11,
  .row-5 .gx-lg-11 {
    --bs-gutter-x: 5rem;
  }
  .row-5 .g-lg-11,
  .row-5 .gy-lg-11 {
    --bs-gutter-y: 5rem;
  }
  .row-5 .g-lg-12,
  .row-5 .gx-lg-12 {
    --bs-gutter-x: 6rem;
  }
  .row-5 .g-lg-12,
  .row-5 .gy-lg-12 {
    --bs-gutter-y: 6rem;
  }
  .row-5 .g-lg-13,
  .row-5 .gx-lg-13 {
    --bs-gutter-x: 6.5rem;
  }
  .row-5 .g-lg-13,
  .row-5 .gy-lg-13 {
    --bs-gutter-y: 6.5rem;
  }
  .row-5 .g-lg-14,
  .row-5 .gx-lg-14 {
    --bs-gutter-x: 8rem;
  }
  .row-5 .g-lg-14,
  .row-5 .gy-lg-14 {
    --bs-gutter-y: 8rem;
  }
}
@media (min-width: 1200px) {
  .row-5 .col-xl {
    flex: 1 0;
  }
  .row-5 .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-5 .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-5 .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-5 .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-5 .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-5 .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-5 .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .row-5 .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .row-5 .col-xl-1 {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-5 .col-xl-2 {
    flex: 0 0 auto;
    width: 40%;
  }
  .row-5 .col-xl-3 {
    flex: 0 0 auto;
    width: 60%;
  }
  .row-5 .col-xl-4 {
    flex: 0 0 auto;
    width: 80%;
  }
  .row-5 .col-xl-5 {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-5 .offset-xl-0 {
    margin-left: 0;
  }
  .row-5 .offset-xl-1 {
    margin-left: 20%;
  }
  .row-5 .offset-xl-2 {
    margin-left: 40%;
  }
  .row-5 .offset-xl-3 {
    margin-left: 60%;
  }
  .row-5 .offset-xl-4 {
    margin-left: 80%;
  }
  .row-5 .g-xl-0,
  .row-5 .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .row-5 .g-xl-0,
  .row-5 .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .row-5 .g-xl-1,
  .row-5 .gx-xl-1 {
    --bs-gutter-x: 0.125rem;
  }
  .row-5 .g-xl-1,
  .row-5 .gy-xl-1 {
    --bs-gutter-y: 0.125rem;
  }
  .row-5 .g-xl-2,
  .row-5 .gx-xl-2 {
    --bs-gutter-x: 0.25rem;
  }
  .row-5 .g-xl-2,
  .row-5 .gy-xl-2 {
    --bs-gutter-y: 0.25rem;
  }
  .row-5 .g-xl-3,
  .row-5 .gx-xl-3 {
    --bs-gutter-x: 0.5rem;
  }
  .row-5 .g-xl-3,
  .row-5 .gy-xl-3 {
    --bs-gutter-y: 0.5rem;
  }
  .row-5 .g-xl-4,
  .row-5 .gx-xl-4 {
    --bs-gutter-x: 1rem;
  }
  .row-5 .g-xl-4,
  .row-5 .gy-xl-4 {
    --bs-gutter-y: 1rem;
  }
  .row-5 .g-xl-5,
  .row-5 .gx-xl-5 {
    --bs-gutter-x: 1.5rem;
  }
  .row-5 .g-xl-5,
  .row-5 .gy-xl-5 {
    --bs-gutter-y: 1.5rem;
  }
  .row-5 .g-xl-6,
  .row-5 .gx-xl-6 {
    --bs-gutter-x: 2rem;
  }
  .row-5 .g-xl-6,
  .row-5 .gy-xl-6 {
    --bs-gutter-y: 2rem;
  }
  .row-5 .g-xl-7,
  .row-5 .gx-xl-7 {
    --bs-gutter-x: 2.5rem;
  }
  .row-5 .g-xl-7,
  .row-5 .gy-xl-7 {
    --bs-gutter-y: 2.5rem;
  }
  .row-5 .g-xl-8,
  .row-5 .gx-xl-8 {
    --bs-gutter-x: 3rem;
  }
  .row-5 .g-xl-8,
  .row-5 .gy-xl-8 {
    --bs-gutter-y: 3rem;
  }
  .row-5 .g-xl-9,
  .row-5 .gx-xl-9 {
    --bs-gutter-x: 3.5rem;
  }
  .row-5 .g-xl-9,
  .row-5 .gy-xl-9 {
    --bs-gutter-y: 3.5rem;
  }
  .row-5 .g-xl-10,
  .row-5 .gx-xl-10 {
    --bs-gutter-x: 4rem;
  }
  .row-5 .g-xl-10,
  .row-5 .gy-xl-10 {
    --bs-gutter-y: 4rem;
  }
  .row-5 .g-xl-11,
  .row-5 .gx-xl-11 {
    --bs-gutter-x: 5rem;
  }
  .row-5 .g-xl-11,
  .row-5 .gy-xl-11 {
    --bs-gutter-y: 5rem;
  }
  .row-5 .g-xl-12,
  .row-5 .gx-xl-12 {
    --bs-gutter-x: 6rem;
  }
  .row-5 .g-xl-12,
  .row-5 .gy-xl-12 {
    --bs-gutter-y: 6rem;
  }
  .row-5 .g-xl-13,
  .row-5 .gx-xl-13 {
    --bs-gutter-x: 6.5rem;
  }
  .row-5 .g-xl-13,
  .row-5 .gy-xl-13 {
    --bs-gutter-y: 6.5rem;
  }
  .row-5 .g-xl-14,
  .row-5 .gx-xl-14 {
    --bs-gutter-x: 8rem;
  }
  .row-5 .g-xl-14,
  .row-5 .gy-xl-14 {
    --bs-gutter-y: 8rem;
  }
}
@media (min-width: 1400px) {
  .row-5 .col-xxl {
    flex: 1 0;
  }
  .row-5 .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-5 .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-5 .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-5 .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-5 .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-5 .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-5 .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .row-5 .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .row-5 .col-xxl-1 {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-5 .col-xxl-2 {
    flex: 0 0 auto;
    width: 40%;
  }
  .row-5 .col-xxl-3 {
    flex: 0 0 auto;
    width: 60%;
  }
  .row-5 .col-xxl-4 {
    flex: 0 0 auto;
    width: 80%;
  }
  .row-5 .col-xxl-5 {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-5 .offset-xxl-0 {
    margin-left: 0;
  }
  .row-5 .offset-xxl-1 {
    margin-left: 20%;
  }
  .row-5 .offset-xxl-2 {
    margin-left: 40%;
  }
  .row-5 .offset-xxl-3 {
    margin-left: 60%;
  }
  .row-5 .offset-xxl-4 {
    margin-left: 80%;
  }
  .row-5 .g-xxl-0,
  .row-5 .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .row-5 .g-xxl-0,
  .row-5 .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .row-5 .g-xxl-1,
  .row-5 .gx-xxl-1 {
    --bs-gutter-x: 0.125rem;
  }
  .row-5 .g-xxl-1,
  .row-5 .gy-xxl-1 {
    --bs-gutter-y: 0.125rem;
  }
  .row-5 .g-xxl-2,
  .row-5 .gx-xxl-2 {
    --bs-gutter-x: 0.25rem;
  }
  .row-5 .g-xxl-2,
  .row-5 .gy-xxl-2 {
    --bs-gutter-y: 0.25rem;
  }
  .row-5 .g-xxl-3,
  .row-5 .gx-xxl-3 {
    --bs-gutter-x: 0.5rem;
  }
  .row-5 .g-xxl-3,
  .row-5 .gy-xxl-3 {
    --bs-gutter-y: 0.5rem;
  }
  .row-5 .g-xxl-4,
  .row-5 .gx-xxl-4 {
    --bs-gutter-x: 1rem;
  }
  .row-5 .g-xxl-4,
  .row-5 .gy-xxl-4 {
    --bs-gutter-y: 1rem;
  }
  .row-5 .g-xxl-5,
  .row-5 .gx-xxl-5 {
    --bs-gutter-x: 1.5rem;
  }
  .row-5 .g-xxl-5,
  .row-5 .gy-xxl-5 {
    --bs-gutter-y: 1.5rem;
  }
  .row-5 .g-xxl-6,
  .row-5 .gx-xxl-6 {
    --bs-gutter-x: 2rem;
  }
  .row-5 .g-xxl-6,
  .row-5 .gy-xxl-6 {
    --bs-gutter-y: 2rem;
  }
  .row-5 .g-xxl-7,
  .row-5 .gx-xxl-7 {
    --bs-gutter-x: 2.5rem;
  }
  .row-5 .g-xxl-7,
  .row-5 .gy-xxl-7 {
    --bs-gutter-y: 2.5rem;
  }
  .row-5 .g-xxl-8,
  .row-5 .gx-xxl-8 {
    --bs-gutter-x: 3rem;
  }
  .row-5 .g-xxl-8,
  .row-5 .gy-xxl-8 {
    --bs-gutter-y: 3rem;
  }
  .row-5 .g-xxl-9,
  .row-5 .gx-xxl-9 {
    --bs-gutter-x: 3.5rem;
  }
  .row-5 .g-xxl-9,
  .row-5 .gy-xxl-9 {
    --bs-gutter-y: 3.5rem;
  }
  .row-5 .g-xxl-10,
  .row-5 .gx-xxl-10 {
    --bs-gutter-x: 4rem;
  }
  .row-5 .g-xxl-10,
  .row-5 .gy-xxl-10 {
    --bs-gutter-y: 4rem;
  }
  .row-5 .g-xxl-11,
  .row-5 .gx-xxl-11 {
    --bs-gutter-x: 5rem;
  }
  .row-5 .g-xxl-11,
  .row-5 .gy-xxl-11 {
    --bs-gutter-y: 5rem;
  }
  .row-5 .g-xxl-12,
  .row-5 .gx-xxl-12 {
    --bs-gutter-x: 6rem;
  }
  .row-5 .g-xxl-12,
  .row-5 .gy-xxl-12 {
    --bs-gutter-y: 6rem;
  }
  .row-5 .g-xxl-13,
  .row-5 .gx-xxl-13 {
    --bs-gutter-x: 6.5rem;
  }
  .row-5 .g-xxl-13,
  .row-5 .gy-xxl-13 {
    --bs-gutter-y: 6.5rem;
  }
  .row-5 .g-xxl-14,
  .row-5 .gx-xxl-14 {
    --bs-gutter-x: 8rem;
  }
  .row-5 .g-xxl-14,
  .row-5 .gy-xxl-14 {
    --bs-gutter-y: 8rem;
  }
}

.x5-me-0,
.x5-mx-0 {
  margin-right: 0 !important;
}

.x5-ms-0,
.x5-mx-0 {
  margin-left: 0 !important;
}

.x5-me-1,
.x5-mx-1 {
  margin-right: 0.3125rem !important;
}

.x5-ms-1,
.x5-mx-1 {
  margin-left: 0.3125rem !important;
}

.x5-me-2,
.x5-mx-2 {
  margin-right: 0.625rem !important;
}

.x5-ms-2,
.x5-mx-2 {
  margin-left: 0.625rem !important;
}

.x5-me-3,
.x5-mx-3 {
  margin-right: 0.9375rem !important;
}

.x5-ms-3,
.x5-mx-3 {
  margin-left: 0.9375rem !important;
}

.x5-me-4,
.x5-mx-4 {
  margin-right: 1.5625rem !important;
}

.x5-ms-4,
.x5-mx-4 {
  margin-left: 1.5625rem !important;
}

.x5-me-5,
.x5-mx-5 {
  margin-right: 1.875rem !important;
}

.x5-ms-5,
.x5-mx-5 {
  margin-left: 1.875rem !important;
}

.x5-me-6,
.x5-mx-6 {
  margin-right: 2.5rem !important;
}

.x5-ms-6,
.x5-mx-6 {
  margin-left: 2.5rem !important;
}

.x5-me-7,
.x5-mx-7 {
  margin-right: 2.8125rem !important;
}

.x5-ms-7,
.x5-mx-7 {
  margin-left: 2.8125rem !important;
}

.x5-me-8,
.x5-mx-8 {
  margin-right: 3.75rem !important;
}

.x5-ms-8,
.x5-mx-8 {
  margin-left: 3.75rem !important;
}

.x5-pe-0,
.x5-px-0 {
  padding-right: 0 !important;
}

.x5-ps-0,
.x5-px-0 {
  padding-left: 0 !important;
}

.x5-pe-1,
.x5-px-1 {
  padding-right: 0.3125rem !important;
}

.x5-ps-1,
.x5-px-1 {
  padding-left: 0.3125rem !important;
}

.x5-pe-2,
.x5-px-2 {
  padding-right: 0.625rem !important;
}

.x5-ps-2,
.x5-px-2 {
  padding-left: 0.625rem !important;
}

.x5-pe-3,
.x5-px-3 {
  padding-right: 0.9375rem !important;
}

.x5-ps-3,
.x5-px-3 {
  padding-left: 0.9375rem !important;
}

.x5-pe-4,
.x5-px-4 {
  padding-right: 1.5625rem !important;
}

.x5-ps-4,
.x5-px-4 {
  padding-left: 1.5625rem !important;
}

.x5-pe-5,
.x5-px-5 {
  padding-right: 1.875rem !important;
}

.x5-ps-5,
.x5-px-5 {
  padding-left: 1.875rem !important;
}

.x5-pe-6,
.x5-px-6 {
  padding-right: 2.5rem !important;
}

.x5-ps-6,
.x5-px-6 {
  padding-left: 2.5rem !important;
}

.x5-pe-7,
.x5-px-7 {
  padding-right: 2.8125rem !important;
}

.x5-ps-7,
.x5-px-7 {
  padding-left: 2.8125rem !important;
}

.x5-pe-8,
.x5-px-8 {
  padding-right: 3.75rem !important;
}

.x5-ps-8,
.x5-px-8 {
  padding-left: 3.75rem !important;
}

.x5-me-n1,
.x5-mx-n1 {
  margin-right: -0.3125rem !important;
}

.x5-ms-n1,
.x5-mx-n1 {
  margin-left: -0.3125rem !important;
}

.x5-me-n2,
.x5-mx-n2 {
  margin-right: -0.625rem !important;
}

.x5-ms-n2,
.x5-mx-n2 {
  margin-left: -0.625rem !important;
}

.x5-me-n3,
.x5-mx-n3 {
  margin-right: -0.9375rem !important;
}

.x5-ms-n3,
.x5-mx-n3 {
  margin-left: -0.9375rem !important;
}

.x5-me-n4,
.x5-mx-n4 {
  margin-right: -1.5625rem !important;
}

.x5-ms-n4,
.x5-mx-n4 {
  margin-left: -1.5625rem !important;
}

.x5-me-n5,
.x5-mx-n5 {
  margin-right: -1.875rem !important;
}

.x5-ms-n5,
.x5-mx-n5 {
  margin-left: -1.875rem !important;
}

.x5-me-n6,
.x5-mx-n6 {
  margin-right: -2.5rem !important;
}

.x5-ms-n6,
.x5-mx-n6 {
  margin-left: -2.5rem !important;
}

.x5-me-n7,
.x5-mx-n7 {
  margin-right: -2.8125rem !important;
}

.x5-ms-n7,
.x5-mx-n7 {
  margin-left: -2.8125rem !important;
}

.x5-me-n8,
.x5-mx-n8 {
  margin-right: -3.75rem !important;
}

.x5-ms-n8,
.x5-mx-n8 {
  margin-left: -3.75rem !important;
}

@media (min-width: 576px) {
  .x5-me-sm-0,
  .x5-mx-sm-0 {
    margin-right: 0 !important;
  }
  .x5-ms-sm-0,
  .x5-mx-sm-0 {
    margin-left: 0 !important;
  }
  .x5-me-sm-1,
  .x5-mx-sm-1 {
    margin-right: 0.3125rem !important;
  }
  .x5-ms-sm-1,
  .x5-mx-sm-1 {
    margin-left: 0.3125rem !important;
  }
  .x5-me-sm-2,
  .x5-mx-sm-2 {
    margin-right: 0.625rem !important;
  }
  .x5-ms-sm-2,
  .x5-mx-sm-2 {
    margin-left: 0.625rem !important;
  }
  .x5-me-sm-3,
  .x5-mx-sm-3 {
    margin-right: 0.9375rem !important;
  }
  .x5-ms-sm-3,
  .x5-mx-sm-3 {
    margin-left: 0.9375rem !important;
  }
  .x5-me-sm-4,
  .x5-mx-sm-4 {
    margin-right: 1.5625rem !important;
  }
  .x5-ms-sm-4,
  .x5-mx-sm-4 {
    margin-left: 1.5625rem !important;
  }
  .x5-me-sm-5,
  .x5-mx-sm-5 {
    margin-right: 1.875rem !important;
  }
  .x5-ms-sm-5,
  .x5-mx-sm-5 {
    margin-left: 1.875rem !important;
  }
  .x5-me-sm-6,
  .x5-mx-sm-6 {
    margin-right: 2.5rem !important;
  }
  .x5-ms-sm-6,
  .x5-mx-sm-6 {
    margin-left: 2.5rem !important;
  }
  .x5-me-sm-7,
  .x5-mx-sm-7 {
    margin-right: 2.8125rem !important;
  }
  .x5-ms-sm-7,
  .x5-mx-sm-7 {
    margin-left: 2.8125rem !important;
  }
  .x5-me-sm-8,
  .x5-mx-sm-8 {
    margin-right: 3.75rem !important;
  }
  .x5-ms-sm-8,
  .x5-mx-sm-8 {
    margin-left: 3.75rem !important;
  }
  .x5-pe-sm-0,
  .x5-px-sm-0 {
    padding-right: 0 !important;
  }
  .x5-ps-sm-0,
  .x5-px-sm-0 {
    padding-left: 0 !important;
  }
  .x5-pe-sm-1,
  .x5-px-sm-1 {
    padding-right: 0.3125rem !important;
  }
  .x5-ps-sm-1,
  .x5-px-sm-1 {
    padding-left: 0.3125rem !important;
  }
  .x5-pe-sm-2,
  .x5-px-sm-2 {
    padding-right: 0.625rem !important;
  }
  .x5-ps-sm-2,
  .x5-px-sm-2 {
    padding-left: 0.625rem !important;
  }
  .x5-pe-sm-3,
  .x5-px-sm-3 {
    padding-right: 0.9375rem !important;
  }
  .x5-ps-sm-3,
  .x5-px-sm-3 {
    padding-left: 0.9375rem !important;
  }
  .x5-pe-sm-4,
  .x5-px-sm-4 {
    padding-right: 1.5625rem !important;
  }
  .x5-ps-sm-4,
  .x5-px-sm-4 {
    padding-left: 1.5625rem !important;
  }
  .x5-pe-sm-5,
  .x5-px-sm-5 {
    padding-right: 1.875rem !important;
  }
  .x5-ps-sm-5,
  .x5-px-sm-5 {
    padding-left: 1.875rem !important;
  }
  .x5-pe-sm-6,
  .x5-px-sm-6 {
    padding-right: 2.5rem !important;
  }
  .x5-ps-sm-6,
  .x5-px-sm-6 {
    padding-left: 2.5rem !important;
  }
  .x5-pe-sm-7,
  .x5-px-sm-7 {
    padding-right: 2.8125rem !important;
  }
  .x5-ps-sm-7,
  .x5-px-sm-7 {
    padding-left: 2.8125rem !important;
  }
  .x5-pe-sm-8,
  .x5-px-sm-8 {
    padding-right: 3.75rem !important;
  }
  .x5-ps-sm-8,
  .x5-px-sm-8 {
    padding-left: 3.75rem !important;
  }
  .x5-me-sm-n1,
  .x5-mx-sm-n1 {
    margin-right: -0.3125rem !important;
  }
  .x5-ms-sm-n1,
  .x5-mx-sm-n1 {
    margin-left: -0.3125rem !important;
  }
  .x5-me-sm-n2,
  .x5-mx-sm-n2 {
    margin-right: -0.625rem !important;
  }
  .x5-ms-sm-n2,
  .x5-mx-sm-n2 {
    margin-left: -0.625rem !important;
  }
  .x5-me-sm-n3,
  .x5-mx-sm-n3 {
    margin-right: -0.9375rem !important;
  }
  .x5-ms-sm-n3,
  .x5-mx-sm-n3 {
    margin-left: -0.9375rem !important;
  }
  .x5-me-sm-n4,
  .x5-mx-sm-n4 {
    margin-right: -1.5625rem !important;
  }
  .x5-ms-sm-n4,
  .x5-mx-sm-n4 {
    margin-left: -1.5625rem !important;
  }
  .x5-me-sm-n5,
  .x5-mx-sm-n5 {
    margin-right: -1.875rem !important;
  }
  .x5-ms-sm-n5,
  .x5-mx-sm-n5 {
    margin-left: -1.875rem !important;
  }
  .x5-me-sm-n6,
  .x5-mx-sm-n6 {
    margin-right: -2.5rem !important;
  }
  .x5-ms-sm-n6,
  .x5-mx-sm-n6 {
    margin-left: -2.5rem !important;
  }
  .x5-me-sm-n7,
  .x5-mx-sm-n7 {
    margin-right: -2.8125rem !important;
  }
  .x5-ms-sm-n7,
  .x5-mx-sm-n7 {
    margin-left: -2.8125rem !important;
  }
  .x5-me-sm-n8,
  .x5-mx-sm-n8 {
    margin-right: -3.75rem !important;
  }
  .x5-ms-sm-n8,
  .x5-mx-sm-n8 {
    margin-left: -3.75rem !important;
  }
}
@media (min-width: 768px) {
  .x5-me-md-0,
  .x5-mx-md-0 {
    margin-right: 0 !important;
  }
  .x5-ms-md-0,
  .x5-mx-md-0 {
    margin-left: 0 !important;
  }
  .x5-me-md-1,
  .x5-mx-md-1 {
    margin-right: 0.3125rem !important;
  }
  .x5-ms-md-1,
  .x5-mx-md-1 {
    margin-left: 0.3125rem !important;
  }
  .x5-me-md-2,
  .x5-mx-md-2 {
    margin-right: 0.625rem !important;
  }
  .x5-ms-md-2,
  .x5-mx-md-2 {
    margin-left: 0.625rem !important;
  }
  .x5-me-md-3,
  .x5-mx-md-3 {
    margin-right: 0.9375rem !important;
  }
  .x5-ms-md-3,
  .x5-mx-md-3 {
    margin-left: 0.9375rem !important;
  }
  .x5-me-md-4,
  .x5-mx-md-4 {
    margin-right: 1.5625rem !important;
  }
  .x5-ms-md-4,
  .x5-mx-md-4 {
    margin-left: 1.5625rem !important;
  }
  .x5-me-md-5,
  .x5-mx-md-5 {
    margin-right: 1.875rem !important;
  }
  .x5-ms-md-5,
  .x5-mx-md-5 {
    margin-left: 1.875rem !important;
  }
  .x5-me-md-6,
  .x5-mx-md-6 {
    margin-right: 2.5rem !important;
  }
  .x5-ms-md-6,
  .x5-mx-md-6 {
    margin-left: 2.5rem !important;
  }
  .x5-me-md-7,
  .x5-mx-md-7 {
    margin-right: 2.8125rem !important;
  }
  .x5-ms-md-7,
  .x5-mx-md-7 {
    margin-left: 2.8125rem !important;
  }
  .x5-me-md-8,
  .x5-mx-md-8 {
    margin-right: 3.75rem !important;
  }
  .x5-ms-md-8,
  .x5-mx-md-8 {
    margin-left: 3.75rem !important;
  }
  .x5-pe-md-0,
  .x5-px-md-0 {
    padding-right: 0 !important;
  }
  .x5-ps-md-0,
  .x5-px-md-0 {
    padding-left: 0 !important;
  }
  .x5-pe-md-1,
  .x5-px-md-1 {
    padding-right: 0.3125rem !important;
  }
  .x5-ps-md-1,
  .x5-px-md-1 {
    padding-left: 0.3125rem !important;
  }
  .x5-pe-md-2,
  .x5-px-md-2 {
    padding-right: 0.625rem !important;
  }
  .x5-ps-md-2,
  .x5-px-md-2 {
    padding-left: 0.625rem !important;
  }
  .x5-pe-md-3,
  .x5-px-md-3 {
    padding-right: 0.9375rem !important;
  }
  .x5-ps-md-3,
  .x5-px-md-3 {
    padding-left: 0.9375rem !important;
  }
  .x5-pe-md-4,
  .x5-px-md-4 {
    padding-right: 1.5625rem !important;
  }
  .x5-ps-md-4,
  .x5-px-md-4 {
    padding-left: 1.5625rem !important;
  }
  .x5-pe-md-5,
  .x5-px-md-5 {
    padding-right: 1.875rem !important;
  }
  .x5-ps-md-5,
  .x5-px-md-5 {
    padding-left: 1.875rem !important;
  }
  .x5-pe-md-6,
  .x5-px-md-6 {
    padding-right: 2.5rem !important;
  }
  .x5-ps-md-6,
  .x5-px-md-6 {
    padding-left: 2.5rem !important;
  }
  .x5-pe-md-7,
  .x5-px-md-7 {
    padding-right: 2.8125rem !important;
  }
  .x5-ps-md-7,
  .x5-px-md-7 {
    padding-left: 2.8125rem !important;
  }
  .x5-pe-md-8,
  .x5-px-md-8 {
    padding-right: 3.75rem !important;
  }
  .x5-ps-md-8,
  .x5-px-md-8 {
    padding-left: 3.75rem !important;
  }
  .x5-me-md-n1,
  .x5-mx-md-n1 {
    margin-right: -0.3125rem !important;
  }
  .x5-ms-md-n1,
  .x5-mx-md-n1 {
    margin-left: -0.3125rem !important;
  }
  .x5-me-md-n2,
  .x5-mx-md-n2 {
    margin-right: -0.625rem !important;
  }
  .x5-ms-md-n2,
  .x5-mx-md-n2 {
    margin-left: -0.625rem !important;
  }
  .x5-me-md-n3,
  .x5-mx-md-n3 {
    margin-right: -0.9375rem !important;
  }
  .x5-ms-md-n3,
  .x5-mx-md-n3 {
    margin-left: -0.9375rem !important;
  }
  .x5-me-md-n4,
  .x5-mx-md-n4 {
    margin-right: -1.5625rem !important;
  }
  .x5-ms-md-n4,
  .x5-mx-md-n4 {
    margin-left: -1.5625rem !important;
  }
  .x5-me-md-n5,
  .x5-mx-md-n5 {
    margin-right: -1.875rem !important;
  }
  .x5-ms-md-n5,
  .x5-mx-md-n5 {
    margin-left: -1.875rem !important;
  }
  .x5-me-md-n6,
  .x5-mx-md-n6 {
    margin-right: -2.5rem !important;
  }
  .x5-ms-md-n6,
  .x5-mx-md-n6 {
    margin-left: -2.5rem !important;
  }
  .x5-me-md-n7,
  .x5-mx-md-n7 {
    margin-right: -2.8125rem !important;
  }
  .x5-ms-md-n7,
  .x5-mx-md-n7 {
    margin-left: -2.8125rem !important;
  }
  .x5-me-md-n8,
  .x5-mx-md-n8 {
    margin-right: -3.75rem !important;
  }
  .x5-ms-md-n8,
  .x5-mx-md-n8 {
    margin-left: -3.75rem !important;
  }
}
@media (min-width: 992px) {
  .x5-me-lg-0,
  .x5-mx-lg-0 {
    margin-right: 0 !important;
  }
  .x5-ms-lg-0,
  .x5-mx-lg-0 {
    margin-left: 0 !important;
  }
  .x5-me-lg-1,
  .x5-mx-lg-1 {
    margin-right: 0.3125rem !important;
  }
  .x5-ms-lg-1,
  .x5-mx-lg-1 {
    margin-left: 0.3125rem !important;
  }
  .x5-me-lg-2,
  .x5-mx-lg-2 {
    margin-right: 0.625rem !important;
  }
  .x5-ms-lg-2,
  .x5-mx-lg-2 {
    margin-left: 0.625rem !important;
  }
  .x5-me-lg-3,
  .x5-mx-lg-3 {
    margin-right: 0.9375rem !important;
  }
  .x5-ms-lg-3,
  .x5-mx-lg-3 {
    margin-left: 0.9375rem !important;
  }
  .x5-me-lg-4,
  .x5-mx-lg-4 {
    margin-right: 1.5625rem !important;
  }
  .x5-ms-lg-4,
  .x5-mx-lg-4 {
    margin-left: 1.5625rem !important;
  }
  .x5-me-lg-5,
  .x5-mx-lg-5 {
    margin-right: 1.875rem !important;
  }
  .x5-ms-lg-5,
  .x5-mx-lg-5 {
    margin-left: 1.875rem !important;
  }
  .x5-me-lg-6,
  .x5-mx-lg-6 {
    margin-right: 2.5rem !important;
  }
  .x5-ms-lg-6,
  .x5-mx-lg-6 {
    margin-left: 2.5rem !important;
  }
  .x5-me-lg-7,
  .x5-mx-lg-7 {
    margin-right: 2.8125rem !important;
  }
  .x5-ms-lg-7,
  .x5-mx-lg-7 {
    margin-left: 2.8125rem !important;
  }
  .x5-me-lg-8,
  .x5-mx-lg-8 {
    margin-right: 3.75rem !important;
  }
  .x5-ms-lg-8,
  .x5-mx-lg-8 {
    margin-left: 3.75rem !important;
  }
  .x5-pe-lg-0,
  .x5-px-lg-0 {
    padding-right: 0 !important;
  }
  .x5-ps-lg-0,
  .x5-px-lg-0 {
    padding-left: 0 !important;
  }
  .x5-pe-lg-1,
  .x5-px-lg-1 {
    padding-right: 0.3125rem !important;
  }
  .x5-ps-lg-1,
  .x5-px-lg-1 {
    padding-left: 0.3125rem !important;
  }
  .x5-pe-lg-2,
  .x5-px-lg-2 {
    padding-right: 0.625rem !important;
  }
  .x5-ps-lg-2,
  .x5-px-lg-2 {
    padding-left: 0.625rem !important;
  }
  .x5-pe-lg-3,
  .x5-px-lg-3 {
    padding-right: 0.9375rem !important;
  }
  .x5-ps-lg-3,
  .x5-px-lg-3 {
    padding-left: 0.9375rem !important;
  }
  .x5-pe-lg-4,
  .x5-px-lg-4 {
    padding-right: 1.5625rem !important;
  }
  .x5-ps-lg-4,
  .x5-px-lg-4 {
    padding-left: 1.5625rem !important;
  }
  .x5-pe-lg-5,
  .x5-px-lg-5 {
    padding-right: 1.875rem !important;
  }
  .x5-ps-lg-5,
  .x5-px-lg-5 {
    padding-left: 1.875rem !important;
  }
  .x5-pe-lg-6,
  .x5-px-lg-6 {
    padding-right: 2.5rem !important;
  }
  .x5-ps-lg-6,
  .x5-px-lg-6 {
    padding-left: 2.5rem !important;
  }
  .x5-pe-lg-7,
  .x5-px-lg-7 {
    padding-right: 2.8125rem !important;
  }
  .x5-ps-lg-7,
  .x5-px-lg-7 {
    padding-left: 2.8125rem !important;
  }
  .x5-pe-lg-8,
  .x5-px-lg-8 {
    padding-right: 3.75rem !important;
  }
  .x5-ps-lg-8,
  .x5-px-lg-8 {
    padding-left: 3.75rem !important;
  }
  .x5-me-lg-n1,
  .x5-mx-lg-n1 {
    margin-right: -0.3125rem !important;
  }
  .x5-ms-lg-n1,
  .x5-mx-lg-n1 {
    margin-left: -0.3125rem !important;
  }
  .x5-me-lg-n2,
  .x5-mx-lg-n2 {
    margin-right: -0.625rem !important;
  }
  .x5-ms-lg-n2,
  .x5-mx-lg-n2 {
    margin-left: -0.625rem !important;
  }
  .x5-me-lg-n3,
  .x5-mx-lg-n3 {
    margin-right: -0.9375rem !important;
  }
  .x5-ms-lg-n3,
  .x5-mx-lg-n3 {
    margin-left: -0.9375rem !important;
  }
  .x5-me-lg-n4,
  .x5-mx-lg-n4 {
    margin-right: -1.5625rem !important;
  }
  .x5-ms-lg-n4,
  .x5-mx-lg-n4 {
    margin-left: -1.5625rem !important;
  }
  .x5-me-lg-n5,
  .x5-mx-lg-n5 {
    margin-right: -1.875rem !important;
  }
  .x5-ms-lg-n5,
  .x5-mx-lg-n5 {
    margin-left: -1.875rem !important;
  }
  .x5-me-lg-n6,
  .x5-mx-lg-n6 {
    margin-right: -2.5rem !important;
  }
  .x5-ms-lg-n6,
  .x5-mx-lg-n6 {
    margin-left: -2.5rem !important;
  }
  .x5-me-lg-n7,
  .x5-mx-lg-n7 {
    margin-right: -2.8125rem !important;
  }
  .x5-ms-lg-n7,
  .x5-mx-lg-n7 {
    margin-left: -2.8125rem !important;
  }
  .x5-me-lg-n8,
  .x5-mx-lg-n8 {
    margin-right: -3.75rem !important;
  }
  .x5-ms-lg-n8,
  .x5-mx-lg-n8 {
    margin-left: -3.75rem !important;
  }
}
@media (min-width: 1200px) {
  .x5-me-xl-0,
  .x5-mx-xl-0 {
    margin-right: 0 !important;
  }
  .x5-ms-xl-0,
  .x5-mx-xl-0 {
    margin-left: 0 !important;
  }
  .x5-me-xl-1,
  .x5-mx-xl-1 {
    margin-right: 0.3125rem !important;
  }
  .x5-ms-xl-1,
  .x5-mx-xl-1 {
    margin-left: 0.3125rem !important;
  }
  .x5-me-xl-2,
  .x5-mx-xl-2 {
    margin-right: 0.625rem !important;
  }
  .x5-ms-xl-2,
  .x5-mx-xl-2 {
    margin-left: 0.625rem !important;
  }
  .x5-me-xl-3,
  .x5-mx-xl-3 {
    margin-right: 0.9375rem !important;
  }
  .x5-ms-xl-3,
  .x5-mx-xl-3 {
    margin-left: 0.9375rem !important;
  }
  .x5-me-xl-4,
  .x5-mx-xl-4 {
    margin-right: 1.5625rem !important;
  }
  .x5-ms-xl-4,
  .x5-mx-xl-4 {
    margin-left: 1.5625rem !important;
  }
  .x5-me-xl-5,
  .x5-mx-xl-5 {
    margin-right: 1.875rem !important;
  }
  .x5-ms-xl-5,
  .x5-mx-xl-5 {
    margin-left: 1.875rem !important;
  }
  .x5-me-xl-6,
  .x5-mx-xl-6 {
    margin-right: 2.5rem !important;
  }
  .x5-ms-xl-6,
  .x5-mx-xl-6 {
    margin-left: 2.5rem !important;
  }
  .x5-me-xl-7,
  .x5-mx-xl-7 {
    margin-right: 2.8125rem !important;
  }
  .x5-ms-xl-7,
  .x5-mx-xl-7 {
    margin-left: 2.8125rem !important;
  }
  .x5-me-xl-8,
  .x5-mx-xl-8 {
    margin-right: 3.75rem !important;
  }
  .x5-ms-xl-8,
  .x5-mx-xl-8 {
    margin-left: 3.75rem !important;
  }
  .x5-pe-xl-0,
  .x5-px-xl-0 {
    padding-right: 0 !important;
  }
  .x5-ps-xl-0,
  .x5-px-xl-0 {
    padding-left: 0 !important;
  }
  .x5-pe-xl-1,
  .x5-px-xl-1 {
    padding-right: 0.3125rem !important;
  }
  .x5-ps-xl-1,
  .x5-px-xl-1 {
    padding-left: 0.3125rem !important;
  }
  .x5-pe-xl-2,
  .x5-px-xl-2 {
    padding-right: 0.625rem !important;
  }
  .x5-ps-xl-2,
  .x5-px-xl-2 {
    padding-left: 0.625rem !important;
  }
  .x5-pe-xl-3,
  .x5-px-xl-3 {
    padding-right: 0.9375rem !important;
  }
  .x5-ps-xl-3,
  .x5-px-xl-3 {
    padding-left: 0.9375rem !important;
  }
  .x5-pe-xl-4,
  .x5-px-xl-4 {
    padding-right: 1.5625rem !important;
  }
  .x5-ps-xl-4,
  .x5-px-xl-4 {
    padding-left: 1.5625rem !important;
  }
  .x5-pe-xl-5,
  .x5-px-xl-5 {
    padding-right: 1.875rem !important;
  }
  .x5-ps-xl-5,
  .x5-px-xl-5 {
    padding-left: 1.875rem !important;
  }
  .x5-pe-xl-6,
  .x5-px-xl-6 {
    padding-right: 2.5rem !important;
  }
  .x5-ps-xl-6,
  .x5-px-xl-6 {
    padding-left: 2.5rem !important;
  }
  .x5-pe-xl-7,
  .x5-px-xl-7 {
    padding-right: 2.8125rem !important;
  }
  .x5-ps-xl-7,
  .x5-px-xl-7 {
    padding-left: 2.8125rem !important;
  }
  .x5-pe-xl-8,
  .x5-px-xl-8 {
    padding-right: 3.75rem !important;
  }
  .x5-ps-xl-8,
  .x5-px-xl-8 {
    padding-left: 3.75rem !important;
  }
  .x5-me-xl-n1,
  .x5-mx-xl-n1 {
    margin-right: -0.3125rem !important;
  }
  .x5-ms-xl-n1,
  .x5-mx-xl-n1 {
    margin-left: -0.3125rem !important;
  }
  .x5-me-xl-n2,
  .x5-mx-xl-n2 {
    margin-right: -0.625rem !important;
  }
  .x5-ms-xl-n2,
  .x5-mx-xl-n2 {
    margin-left: -0.625rem !important;
  }
  .x5-me-xl-n3,
  .x5-mx-xl-n3 {
    margin-right: -0.9375rem !important;
  }
  .x5-ms-xl-n3,
  .x5-mx-xl-n3 {
    margin-left: -0.9375rem !important;
  }
  .x5-me-xl-n4,
  .x5-mx-xl-n4 {
    margin-right: -1.5625rem !important;
  }
  .x5-ms-xl-n4,
  .x5-mx-xl-n4 {
    margin-left: -1.5625rem !important;
  }
  .x5-me-xl-n5,
  .x5-mx-xl-n5 {
    margin-right: -1.875rem !important;
  }
  .x5-ms-xl-n5,
  .x5-mx-xl-n5 {
    margin-left: -1.875rem !important;
  }
  .x5-me-xl-n6,
  .x5-mx-xl-n6 {
    margin-right: -2.5rem !important;
  }
  .x5-ms-xl-n6,
  .x5-mx-xl-n6 {
    margin-left: -2.5rem !important;
  }
  .x5-me-xl-n7,
  .x5-mx-xl-n7 {
    margin-right: -2.8125rem !important;
  }
  .x5-ms-xl-n7,
  .x5-mx-xl-n7 {
    margin-left: -2.8125rem !important;
  }
  .x5-me-xl-n8,
  .x5-mx-xl-n8 {
    margin-right: -3.75rem !important;
  }
  .x5-ms-xl-n8,
  .x5-mx-xl-n8 {
    margin-left: -3.75rem !important;
  }
}
@media (min-width: 1400px) {
  .x5-me-xxl-0,
  .x5-mx-xxl-0 {
    margin-right: 0 !important;
  }
  .x5-ms-xxl-0,
  .x5-mx-xxl-0 {
    margin-left: 0 !important;
  }
  .x5-me-xxl-1,
  .x5-mx-xxl-1 {
    margin-right: 0.3125rem !important;
  }
  .x5-ms-xxl-1,
  .x5-mx-xxl-1 {
    margin-left: 0.3125rem !important;
  }
  .x5-me-xxl-2,
  .x5-mx-xxl-2 {
    margin-right: 0.625rem !important;
  }
  .x5-ms-xxl-2,
  .x5-mx-xxl-2 {
    margin-left: 0.625rem !important;
  }
  .x5-me-xxl-3,
  .x5-mx-xxl-3 {
    margin-right: 0.9375rem !important;
  }
  .x5-ms-xxl-3,
  .x5-mx-xxl-3 {
    margin-left: 0.9375rem !important;
  }
  .x5-me-xxl-4,
  .x5-mx-xxl-4 {
    margin-right: 1.5625rem !important;
  }
  .x5-ms-xxl-4,
  .x5-mx-xxl-4 {
    margin-left: 1.5625rem !important;
  }
  .x5-me-xxl-5,
  .x5-mx-xxl-5 {
    margin-right: 1.875rem !important;
  }
  .x5-ms-xxl-5,
  .x5-mx-xxl-5 {
    margin-left: 1.875rem !important;
  }
  .x5-me-xxl-6,
  .x5-mx-xxl-6 {
    margin-right: 2.5rem !important;
  }
  .x5-ms-xxl-6,
  .x5-mx-xxl-6 {
    margin-left: 2.5rem !important;
  }
  .x5-me-xxl-7,
  .x5-mx-xxl-7 {
    margin-right: 2.8125rem !important;
  }
  .x5-ms-xxl-7,
  .x5-mx-xxl-7 {
    margin-left: 2.8125rem !important;
  }
  .x5-me-xxl-8,
  .x5-mx-xxl-8 {
    margin-right: 3.75rem !important;
  }
  .x5-ms-xxl-8,
  .x5-mx-xxl-8 {
    margin-left: 3.75rem !important;
  }
  .x5-pe-xxl-0,
  .x5-px-xxl-0 {
    padding-right: 0 !important;
  }
  .x5-ps-xxl-0,
  .x5-px-xxl-0 {
    padding-left: 0 !important;
  }
  .x5-pe-xxl-1,
  .x5-px-xxl-1 {
    padding-right: 0.3125rem !important;
  }
  .x5-ps-xxl-1,
  .x5-px-xxl-1 {
    padding-left: 0.3125rem !important;
  }
  .x5-pe-xxl-2,
  .x5-px-xxl-2 {
    padding-right: 0.625rem !important;
  }
  .x5-ps-xxl-2,
  .x5-px-xxl-2 {
    padding-left: 0.625rem !important;
  }
  .x5-pe-xxl-3,
  .x5-px-xxl-3 {
    padding-right: 0.9375rem !important;
  }
  .x5-ps-xxl-3,
  .x5-px-xxl-3 {
    padding-left: 0.9375rem !important;
  }
  .x5-pe-xxl-4,
  .x5-px-xxl-4 {
    padding-right: 1.5625rem !important;
  }
  .x5-ps-xxl-4,
  .x5-px-xxl-4 {
    padding-left: 1.5625rem !important;
  }
  .x5-pe-xxl-5,
  .x5-px-xxl-5 {
    padding-right: 1.875rem !important;
  }
  .x5-ps-xxl-5,
  .x5-px-xxl-5 {
    padding-left: 1.875rem !important;
  }
  .x5-pe-xxl-6,
  .x5-px-xxl-6 {
    padding-right: 2.5rem !important;
  }
  .x5-ps-xxl-6,
  .x5-px-xxl-6 {
    padding-left: 2.5rem !important;
  }
  .x5-pe-xxl-7,
  .x5-px-xxl-7 {
    padding-right: 2.8125rem !important;
  }
  .x5-ps-xxl-7,
  .x5-px-xxl-7 {
    padding-left: 2.8125rem !important;
  }
  .x5-pe-xxl-8,
  .x5-px-xxl-8 {
    padding-right: 3.75rem !important;
  }
  .x5-ps-xxl-8,
  .x5-px-xxl-8 {
    padding-left: 3.75rem !important;
  }
  .x5-me-xxl-n1,
  .x5-mx-xxl-n1 {
    margin-right: -0.3125rem !important;
  }
  .x5-ms-xxl-n1,
  .x5-mx-xxl-n1 {
    margin-left: -0.3125rem !important;
  }
  .x5-me-xxl-n2,
  .x5-mx-xxl-n2 {
    margin-right: -0.625rem !important;
  }
  .x5-ms-xxl-n2,
  .x5-mx-xxl-n2 {
    margin-left: -0.625rem !important;
  }
  .x5-me-xxl-n3,
  .x5-mx-xxl-n3 {
    margin-right: -0.9375rem !important;
  }
  .x5-ms-xxl-n3,
  .x5-mx-xxl-n3 {
    margin-left: -0.9375rem !important;
  }
  .x5-me-xxl-n4,
  .x5-mx-xxl-n4 {
    margin-right: -1.5625rem !important;
  }
  .x5-ms-xxl-n4,
  .x5-mx-xxl-n4 {
    margin-left: -1.5625rem !important;
  }
  .x5-me-xxl-n5,
  .x5-mx-xxl-n5 {
    margin-right: -1.875rem !important;
  }
  .x5-ms-xxl-n5,
  .x5-mx-xxl-n5 {
    margin-left: -1.875rem !important;
  }
  .x5-me-xxl-n6,
  .x5-mx-xxl-n6 {
    margin-right: -2.5rem !important;
  }
  .x5-ms-xxl-n6,
  .x5-mx-xxl-n6 {
    margin-left: -2.5rem !important;
  }
  .x5-me-xxl-n7,
  .x5-mx-xxl-n7 {
    margin-right: -2.8125rem !important;
  }
  .x5-ms-xxl-n7,
  .x5-mx-xxl-n7 {
    margin-left: -2.8125rem !important;
  }
  .x5-me-xxl-n8,
  .x5-mx-xxl-n8 {
    margin-right: -3.75rem !important;
  }
  .x5-ms-xxl-n8,
  .x5-mx-xxl-n8 {
    margin-left: -3.75rem !important;
  }
}
.absolute-fill, .overlay::before {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

.overlay {
  position: relative;
}
.overlay::before {
  content: "";
  z-index: 1;
}
.overlay .container {
  z-index: 2;
  position: relative;
}

.overlay-scrim {
  --overlay-angle: to bottom;
  --overlay-color: 17, 17, 17;
  --overlay-opacity: 0.7;
  --overlay-end-color: var(--overlay-color);
  --overlay-end-opacity: 0;
}
.overlay-scrim::before {
  background-image: linear-gradient(var(--overlay-angle), rgba(var(--overlay-color), var(--overlay-opacity)) 0%, rgba(var(--overlay-end-color), var(--overlay-end-opacity)) 100%);
}

.overlay-solid {
  --overlay-color: 35, 35, 35;
  --overlay-opacity: 0.8;
}
.overlay-solid::before {
  background-color: rgba(var(--overlay-color), var(--overlay-opacity));
}

.overlay-scrim-left {
  --overlay-angle: to right;
}

.overlay-scrim-right {
  --overlay-angle: to left;
}

.overlay-scrim-top {
  --overlay-angle: to bottom;
}

.overlay-scrim-bottom {
  --overlay-angle: to top;
}

.overlay-scrim-top-left {
  --overlay-angle: to bottom right;
}

.overlay-scrim-top-right {
  --overlay-angle: to bottom left;
}

.overlay-scrim-bottom-right {
  --overlay-angle: to top left;
}

.overlay-scrim-bottom-left {
  --overlay-angle: to top right;
}

.overlay-dark {
  --overlay-color: 17, 17, 17;
}

.overlay-blue {
  --overlay-color: 46, 16, 164;
}

.overlay-green {
  --overlay-color: 0, 96, 0;
}

.overlay-light {
  --overlay-color: 242, 242, 242;
}

.overlay-opacity-100 {
  --overlay-opacity: 1;
}

.overlay-opacity-90 {
  --overlay-opacity: 0.9;
}

.overlay-opacity-80 {
  --overlay-opacity: 0.8;
}

.overlay-opacity-70 {
  --overlay-opacity: 0.7;
}

.overlay-opacity-60 {
  --overlay-opacity: 0.6;
}

.overlay-opacity-50 {
  --overlay-opacity: 0.5;
}

.overlay-opacity-40 {
  --overlay-opacity: 0.4;
}

.overlay-opacity-30 {
  --overlay-opacity: 0.3;
}

.overlay-opacity-20 {
  --overlay-opacity: 0.2;
}

.overlay-opacity-10 {
  --overlay-opacity: 0.1;
}

.overlay-scrim-light-blue::before {
  background-image: linear-gradient(to bottom, rgba(200, 201, 255, 0.8), rgba(227, 248, 255, 0.8));
}

.overlay-primary {
  --overlay-color: 255, 255, 255;
}
.dark .overlay-primary {
  --overlay-color: 0, 0, 0;
}

.toast:not(.toast-light) .btn-close,
.dark .toast-light .btn-close,
.dark .card .btn-close,
.dark .alert:not([class*=alert-solid-]) .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.btn-close-inline {
  background: none;
  color: #111111;
  padding: 0;
  opacity: 0.5;
  border: 1px solid transparent;
}
.btn-close-inline:hover {
  color: #111111;
  text-decoration: none;
  opacity: 0.8;
}
.btn-close-inline:focus {
  outline: 0;
  box-shadow: none;
}
.btn-close-inline:focus-visible {
  border-color: #304ffe;
}
.btn-close-inline:disabled, .btn-close-inline.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.25;
}

.dark .btn-close-inline {
  color: #fff;
}

.alert {
  --bs-alert-color: #111111;
  --bs-alert-link-color: #111111;
  font-weight: 300;
  display: flex;
}
.alert > svg {
  color: var(--bs-alert-icon-color);
  flex-shrink: 0;
  margin: 0.125rem 0.5rem 0 -0.5625rem;
}
.alert p {
  opacity: 0.8;
}
.alert p:last-child {
  margin-bottom: 0;
}
.alert .link-border {
  background-image: linear-gradient(to right, rgba(17, 17, 17, 0.3) 0%, rgba(17, 17, 17, 0.3) 100%);
}
.alert .link-border:hover {
  background-image: linear-gradient(to right, #111111 0%, #111111 100%);
}

.alert > svg.text-default,
[class*=alert-solid-] > svg {
  opacity: 0.8;
}

.alert-heading {
  font-size: 1.125rem;
  line-height: 1.7777777778;
  margin-bottom: 0.5rem;
}

.alert-dismissible {
  padding-right: 3.1875rem;
}
.alert-dismissible .btn-close {
  width: 1.75rem;
  height: 1.75rem;
  background-position: 60% center;
  padding: 0.5rem 0.6875rem 0.5rem 1rem;
  opacity: 0.8;
}
.alert-dismissible .btn-close:hover, .alert-dismissible .btn-close:focus {
  box-shadow: none;
  opacity: 1;
}

.alert-lg {
  padding: 1.25rem 1.875rem;
}
.alert-lg.alert-dismissible {
  padding-right: 3.6875rem;
}
.alert-lg > svg {
  margin-top: 0;
  margin-left: -15px;
}
.alert-lg .btn-close {
  width: 2rem;
  height: 2rem;
  background-size: 2rem;
}

.alert-success {
  --bs-alert-icon-color: #15ad5c;
}

.alert-info {
  --bs-alert-icon-color: #218dcc;
}

.alert-warning {
  --bs-alert-icon-color: #ffc000;
}

.alert-danger {
  --bs-alert-icon-color: #e64949;
}

.alert-neutral {
  --bs-alert-bg: #fafafa;
  --bs-alert-border-color: #cccccc;
}

[class*=alert-solid-] p {
  opacity: 1;
}

.alert-solid-success {
  --bs-alert-bg: #2ee68c;
}

.alert-solid-info {
  --bs-alert-bg: #4fc3f7;
}

.alert-solid-warning {
  --bs-alert-bg: #ffee5c;
}

.alert-solid-danger {
  --bs-alert-bg: #ff7591;
}

.alert-solid-neutral {
  --bs-alert-bg: rgba(17, 17, 17, 0.08);
}

.dark .alert {
  --bs-alert-bg: #343434;
  --bs-alert-color: #fff;
  --bs-alert-link-color: #fff;
}
.dark .alert:not([class*=alert-solid-]) .link-border {
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.3) 100%);
}
.dark .alert:not([class*=alert-solid-]) .link-border:hover {
  background-image: linear-gradient(to right, #fff 0%, #fff 100%);
}
.dark .alert-success {
  --bs-alert-icon-color: #2ee68c;
}
.dark .alert-info {
  --bs-alert-icon-color: #4fc3f7;
}
.dark .alert-warning {
  --bs-alert-icon-color: #ffee5c;
}
.dark .alert-danger {
  --bs-alert-icon-color: #ff7591;
}
.dark .alert-neutral {
  --bs-alert-border-color: #575757;
  --bs-alert-bg: #232323;
}
.dark [class*=alert-solid-] {
  --bs-alert-color: #111111;
  --bs-alert-link-color: #111111;
}
.dark .alert-solid-success {
  --bs-alert-bg: #6bf0af;
}
.dark .alert-solid-info {
  --bs-alert-bg: #8cdbff;
}
.dark .alert-solid-warning {
  --bs-alert-bg: #fff394;
}
.dark .alert-solid-danger {
  --bs-alert-bg: #ffa9bb;
}
.dark .alert-solid-neutral {
  --bs-alert-color: #fff;
  --bs-alert-bg: #4b4b4b;
  --bs-alert-link-color: #fff;
}
.dark .alert-solid-neutral .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%);
}
.dark .alert-solid-neutral .link-border {
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.3) 100%);
}
.dark .alert-solid-neutral .link-border:hover {
  background-image: linear-gradient(to right, #fff 0%, #fff 100%);
}

.avatar-inner {
  width: 40px;
  height: 40px;
  background-color: #e8e8e8;
  font-size: 0.8125rem;
  letter-spacing: 0.9px;
  color: rgba(17, 17, 17, 0.84);
  box-shadow: 0 0 0 1px transparent, 0 0 0 3px transparent;
  transition: box-shadow 0.15s ease-in-out, color 0.15s ease-in-out, background-color 0.15s ease-in-out;
}
.avatar-inner svg {
  color: #111111;
}

.avatar-label {
  position: relative;
  font-size: 0.9375rem;
  line-height: 1.3333333333;
  color: var(--avatar-label-color);
  transition: color 0.15s ease-in-out;
}
.avatar-label::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 0.0625rem;
  width: 100%;
  background-color: transparent;
  transition: background-color 0.15s ease-in-out;
}

.avatar-label-prefix {
  margin-right: 0.9375rem;
}

.avatar-label-suffix {
  margin-left: 0.9375rem;
}

.avatar-arrow {
  color: #111;
  opacity: 0.54;
  margin-left: 0.4375rem;
}

.avatar {
  --avatar-inner-shadow-color: #fff;
  --avatar-hover-shadow-color: #dedede;
  --avatar-active-shadow-color: #111111;
  --avatar-label-color: rgba(17, 17, 17, 0.64);
  --avatar-hover-label-color: #111111;
  --avatar-hover-label-border: #111111;
  --avatar-active-label-color: rgba(17, 17, 17, 0.92);
  --avatar-active-label-border: #a1a1a1;
  --avatar-focus-label-color: rgba(17, 17, 17, 0.64);
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  text-decoration: none !important;
  border: none;
  background-color: transparent;
  padding: 0;
  -webkit-user-select: none;
          user-select: none;
  transition: border-color 0.15s ease-in-out;
}
.avatar.dropdown-toggle + .dropdown-menu {
  margin-top: 3px;
}

.avatar-action:hover .avatar-inner {
  box-shadow: 0 0 0 1px var(--avatar-inner-shadow-color), 0 0 0 3px var(--avatar-hover-shadow-color);
}
.avatar-action:hover .avatar-label {
  color: var(--avatar-hover-label-color);
}
.avatar-action:hover .avatar-label::after {
  background-color: var(--avatar-hover-label-border);
}
.avatar-action:hover .avatar-arrow {
  opacity: 0.9;
}
.avatar-action:active .avatar-inner,
.avatar-action .active .avatar-inner, .dropdown.show > .avatar-action .avatar-inner {
  box-shadow: 0 0 0 1px var(--avatar-inner-shadow-color), 0 0 0 3px var(--avatar-active-shadow-color);
}
.avatar-action:active .avatar-label,
.avatar-action .active .avatar-label, .dropdown.show > .avatar-action .avatar-label {
  color: var(--avatar-active-label-color);
}
.avatar-action:active .avatar-label::after,
.avatar-action .active .avatar-label::after, .dropdown.show > .avatar-action .avatar-label::after {
  background-color: var(--avatar-active-label-border);
}
.avatar-action:active .avatar-arrow,
.avatar-action .active .avatar-arrow, .dropdown.show > .avatar-action .avatar-arrow {
  opacity: 0.8;
}
.avatar-action:focus-visible {
  outline: 0;
}
.avatar-action:focus-visible .avatar-inner {
  box-shadow: 0 0 0 1px var(--avatar-inner-shadow-color), 0 0 0 2px #304ffe;
}
.avatar-action:focus-visible .avatar-label {
  color: var(--avatar-focus-label-color);
}
.avatar-action:focus-visible .avatar-label::after {
  background-color: #304ffe;
}
.avatar-action:focus-visible .avatar-arrow {
  opacity: 0.56;
}

.avatar-pill {
  --avatar-pill-background-color: #fff;
  --avatar-pill-hover-background-color: #111111;
  --avatar-pill-hover-label-color: #fff;
  --avatar-pill-active-background-color: #f2f2f2;
  --avatar-pill-active-border-color: #111111;
  --avatar-pill-active-label-color: rgba(17, 17, 17, 0.84);
  --avatar-pill-active-arrow-color: #111111;
  --avatar-pill-hover-arrow-color: #fff;
  --avatar-pill-hover-inner-background-color: #343434;
  --avatar-pill-hover-border-color: #404040;
  --avatar-pill-hover-inner-color: rgba(255, 255, 255, 0.92);
  --avatar-pill-active-inner-border-color: #fff;
  --avatar-pill-active-inner-background-color: #e8e8e8;
  --avatar-pill-active-inner-color: rgba(17, 17, 17, 0.84);
  --avatar-pill-hover-notification-border-color: #111111;
  --avatar-pill-hover-notification-background-color: #ededed;
  --avatar-pill-hover-notification-color: #111111;
  background-color: var(--avatar-pill-background-color);
  border-radius: 0.3125rem;
  border: 1px solid transparent;
  padding: 0.4375rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
.avatar-pill .avatar-inner {
  width: 32px;
  height: 32px;
  font-size: 0.75rem;
}
.avatar-pill .avatar-label-prefix {
  margin-left: 0.4375rem;
}
.avatar-pill .avatar-label-suffix {
  margin-right: 0.4375rem;
}
.avatar-pill .avatar-arrow {
  margin-right: 0.5rem;
}
.avatar-pill.avatar-sm .avatar-inner {
  width: 24px;
  height: 24px;
  font-size: 0.6875rem;
}
.avatar-pill.avatar-sm .avatar-label-prefix {
  margin: 0 0.75rem 0 0.3125rem;
}
.avatar-pill.avatar-sm .avatar-label-suffix {
  margin: 0 0.3125rem 0 0.75rem;
}
.avatar-pill.avatar-sm .avatar-arrow {
  margin-right: 0.1875rem;
}
.avatar-pill.avatar-sm .avatar-notification {
  width: auto;
  height: 18px;
  padding: 0 0.239375rem;
  margin-top: -0.5rem;
  margin-right: -0.375rem;
}
.avatar-pill.avatar-xs {
  padding: 0.1875rem;
}
.avatar-pill.avatar-xs .avatar-label-prefix {
  margin: 0 0.625rem 0 0.4375rem;
}
.avatar-pill.avatar-xs .avatar-label-suffix {
  margin: 0 0.4375rem 0 0.625rem;
}
.avatar-pill.avatar-xs .avatar-arrow {
  margin-right: 0.1875rem;
}
.avatar-pill.avatar-xs .avatar-notification {
  width: 12px;
  height: 12px;
  padding: 0;
  margin-top: -0.125rem;
  margin-right: -0.125rem;
}
.dropdown > .avatar-pill .avatar-label-suffix {
  margin-right: 0;
}
.avatar-pill .avatar-label::after {
  content: none;
}
.avatar-pill:hover {
  background-color: var(--avatar-pill-hover-background-color);
}
.avatar-pill:hover .avatar-inner {
  background-color: var(--avatar-pill-hover-inner-background-color);
  color: var(--avatar-pill-hover-inner-color);
}
.avatar-pill:hover .avatar-label {
  color: var(--avatar-pill-hover-label-color);
}
.avatar-pill:hover:not(:active) .avatar-inner {
  box-shadow: 0 0 0 1px var(--avatar-pill-hover-background-color), 0 0 0 3px var(--avatar-pill-hover-border-color);
}
.avatar-pill:hover:not(:active) .avatar-notification {
  border-color: var(--avatar-pill-hover-notification-border-color);
  background-color: var(--avatar-pill-hover-notification-background-color);
  color: var(--avatar-pill-hover-notification-color);
}
.avatar-pill:hover .avatar-arrow {
  color: var(--avatar-pill-hover-arrow-color);
}
.avatar-pill:active,
.avatar-pill .active, .dropdown.show > .avatar-pill {
  background-color: var(--avatar-pill-active-background-color);
}
.avatar-pill:active .avatar-inner,
.avatar-pill .active .avatar-inner, .dropdown.show > .avatar-pill .avatar-inner {
  background-color: var(--avatar-pill-active-inner-background-color);
  color: var(--avatar-pill-active-inner-color);
}
.avatar-pill:active .avatar-label,
.avatar-pill .active .avatar-label, .dropdown.show > .avatar-pill .avatar-label {
  color: var(--avatar-pill-active-label-color);
}
.avatar-pill:active .avatar-arrow,
.avatar-pill .active .avatar-arrow, .dropdown.show > .avatar-pill .avatar-arrow {
  color: var(--avatar-pill-active-arrow-color);
}
.avatar-pill:focus-visible {
  border-color: #304ffe;
}

.avatar-lg .avatar-inner {
  width: 48px;
  height: 48px;
  font-size: 0.875rem;
  letter-spacing: 0.8px;
}
.avatar-lg .avatar-online {
  margin-right: -2px;
  margin-bottom: -2px;
}

.avatar-sm .avatar-inner {
  width: 32px;
  height: 32px;
  font-size: 0.75rem;
  line-height: 1.5833333333;
}
.avatar-sm .avatar-online {
  margin-right: -2px;
  margin-bottom: -2px;
}
.avatar-sm .avatar-label {
  font-size: 0.875rem;
  line-height: 1.4285714286;
}
.avatar-sm .avatar-label-prefix {
  margin-right: 0.5625rem;
}
.avatar-sm .avatar-label-suffix {
  margin-left: 0.5625rem;
}
.avatar-sm .avatar-notification {
  margin-top: -0.5625rem;
  margin-right: -0.5625rem;
}

.avatar-xs .avatar-inner {
  width: 24px;
  height: 24px;
  font-size: 0.6875rem;
  letter-spacing: 1px;
}
.avatar-xs .avatar-online {
  width: 12px;
  height: 12px;
  margin-right: -2px;
  margin-bottom: -2px;
}
.avatar-xs .avatar-label {
  font-size: 0.8125rem;
  line-height: 1.4615384615;
}
.avatar-xs .avatar-label-prefix {
  margin-right: 0.4375rem;
}
.avatar-xs .avatar-label-suffix {
  margin-left: 0.4375rem;
}
.avatar-xs .avatar-notification {
  width: auto;
  height: 18px;
  padding: 0 0.239375rem;
  margin-top: -0.3125rem;
  margin-right: -0.3125rem;
}

.avatar-light-color {
  background-color: #ece5f6;
}
.avatar-light-color,
.avatar-light-color svg {
  color: #000099;
}

.avatar-solid {
  background-color: #111111;
  color: rgba(255, 255, 255, 0.84);
}
.avatar-solid svg {
  color: #fff;
}

.avatar-solid-color {
  background-color: #000099;
  color: rgba(255, 255, 255, 0.84);
}
.avatar-solid-color svg {
  color: #fff;
}

.avatar-notification {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  padding: 0 0.37625rem;
  background-color: #111111;
  color: #fff;
  border-radius: var(--bs-border-radius-pill);
  font-size: 0.5625rem;
  line-height: 1.1111111111;
  margin-top: -0.4375rem;
  margin-right: -0.4375rem;
  transition: border-color 0.15s ease-in-out, color 0.15s ease-in-out, background-color 0.15s ease-in-out;
}
.avatar-notification.position-absolute {
  border: 2px solid #fff;
}

.avatar-online {
  width: 14px;
  height: 14px;
  background-color: #15ad5c;
  border-radius: var(--bs-border-radius-pill);
  background-image: none !important;
  margin-right: -1px;
  margin-bottom: -1px;
}
.avatar-online.position-absolute {
  border: 2px solid #fff;
}

.dark .avatar-inner {
  background-color: #343434;
  color: rgba(255, 255, 255, 0.92);
}
.dark .avatar-inner svg {
  color: rgba(255, 255, 255, 0.9);
}
.dark .avatar-arrow {
  color: #fff;
}
.dark .avatar {
  --avatar-inner-shadow-color: #111111;
  --avatar-hover-shadow-color: #404040;
  --avatar-active-shadow-color: #dedede;
  --avatar-label-color: rgba(255, 255, 255, 0.64);
  --avatar-hover-label-color: #fff;
  --avatar-hover-label-border: #cccccc;
  --avatar-active-label-color: rgba(255, 255, 255, 0.92);
  --avatar-active-label-border: #808080;
  --avatar-focus-label-color: rgba(255, 255, 255, 0.64);
}
.dark .avatar-pill {
  --avatar-pill-background-color: #111111;
  --avatar-pill-hover-background-color: #fff;
  --avatar-pill-hover-label-color: #111111;
  --avatar-pill-active-background-color: #232323;
  --avatar-pill-active-arrow-color: #fff;
  --avatar-pill-active-label-color: #fff;
  --avatar-pill-active-border-color: #dedede;
  --avatar-pill-hover-arrow-color: #111111;
  --avatar-pill-hover-inner-background-color: #e8e8e8;
  --avatar-pill-hover-border-color: #dedede;
  --avatar-pill-hover-inner-color: rgba(17, 17, 17, 0.84);
  --avatar-pill-active-inner-border-color: #111111;
  --avatar-pill-active-inner-background-color: #343434;
  --avatar-pill-active-inner-color: rgba(255, 255, 255, 0.92);
  --avatar-pill-hover-notification-border-color: #fff;
  --avatar-pill-hover-notification-background-color: #111111;
  --avatar-pill-hover-notification-color: #fff;
}
.dark .avatar-light-color {
  background-color: #000099;
}
.dark .avatar-solid {
  background-color: #f2f2f2;
  color: rgba(17, 17, 17, 0.92);
}
.dark .avatar-solid svg {
  color: #111111;
}
.dark .avatar-solid-color {
  background-color: #ad93db;
}
.dark .avatar-solid-color,
.dark .avatar-solid-color svg {
  color: #000099;
}
.dark .avatar-notification {
  background-color: #fff;
  border-color: #111111;
  color: #111111;
}

.badge {
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  line-height: 1.9;
  vertical-align: middle;
  border: 1px solid transparent;
}
.badge.rounded-pill {
  padding: 0.3em 1.2em;
}
.badge > svg:first-child {
  margin: 0 0.4em 0 -0.4em;
}

h1 .badge, .h1 .badge,
h2 .badge,
.h2 .badge,
h3 .badge,
.h3 .badge,
h4 .badge,
.h4 .badge,
h5 .badge,
.h5 .badge,
h6 .badge,
.h6 .badge {
  font-weight: 300;
  font-size: 75%;
  letter-spacing: 0.5px;
  line-height: 1.25;
  padding: 0.25em 0.4em;
  text-transform: none;
}

.nav-link .badge {
  font-weight: 400;
  padding: 0.33333em 0.7em;
}

.badge.bg-light {
  background-color: #ededed !important;
}
.badge.bg-neutral {
  background-color: var(--badge-neutral-bg) !important;
  color: var(--badge-neutral-color);
}
.badge.bg-neutral-subtle {
  background-color: var(--badge-neutral-subtle-bg) !important;
  border-color: var(--badge-neutral-subtle-border-color);
}
.badge.bg-danger-subtle {
  background-color: var(--badge-danger-subtle-bg) !important;
  border-color: var(--badge-danger-subtle-border-color);
}
.badge.bg-success-subtle {
  background-color: var(--badge-success-subtle-bg) !important;
  border-color: var(--badge-success-subtle-border-color);
}
.badge.bg-warning-subtle {
  background-color: var(--badge-warning-subtle-bg) !important;
  border-color: var(--badge-warning-subtle-border-color);
}
.badge.bg-info-subtle {
  background-color: var(--badge-info-subtle-bg) !important;
  border-color: var(--badge-info-subtle-border-color);
}
.badge[class*=-subtle] {
  color: var(--badge-subtle-color);
}

:root,
[data-bs-theme=light],
.light {
  --badge-neutral-bg: #111111;
  --badge-neutral-color: #fff;
  --badge-neutral-subtle-bg: #ededed;
  --badge-neutral-subtle-border-color: transparent;
  --badge-danger-subtle-bg: var(--bs-danger-bg-subtle);
  --badge-danger-subtle-border-color: transparent;
  --badge-success-subtle-bg: var(--bs-success-bg-subtle);
  --badge-success-subtle-border-color: transparent;
  --badge-warning-subtle-bg: var(--bs-warning-bg-subtle);
  --badge-warning-subtle-border-color: transparent;
  --badge-info-subtle-bg: var(--bs-info-bg-subtle);
  --badge-info-subtle-border-color: transparent;
  --badge-subtle-color: #111111;
}

[data-bs-theme=dark],
.dark {
  --badge-neutral-bg: #fcfcfc;
  --badge-neutral-color: #111111;
  --badge-neutral-subtle-bg: #343434;
  --badge-neutral-subtle-border-color: #878787;
  --badge-danger-subtle-bg: #343434;
  --badge-danger-subtle-border-color: #c34b63;
  --badge-success-subtle-bg: #343434;
  --badge-success-subtle-border-color: #24a365;
  --badge-warning-subtle-bg: #343434;
  --badge-warning-subtle-border-color: #c4b63f;
  --badge-info-subtle-bg: #343434;
  --badge-info-subtle-border-color: #3789ad;
  --badge-subtle-color: #fff;
}

.chip {
  display: inline-flex;
  align-items: center;
  border: 1px solid transparent;
  margin: 0.125rem;
  border-radius: 50em;
  color: #111111;
  overflow: hidden;
}

.chip-label {
  font-size: 0.625rem;
  padding: 0.1875rem 0 0.1875rem 0.75rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: uppercase;
  line-height: 1.9;
  letter-spacing: 1px;
}

.chip-icon-prefix {
  color: var(--chip-icon-color);
  margin: 0 0.125rem 0 0.375rem;
}
.chip-icon-prefix + .chip-label {
  padding-left: 0;
}

.chip-remove {
  display: flex;
  padding: 0.1875rem;
  color: unset !important;
}

.chip-success,
.chip-bordered-success {
  --chip-icon-color: #15ad5c;
  background: #e6fff2;
}

.chip-info,
.chip-bordered-info {
  --chip-icon-color: #218dcc;
  background: #ecfafe;
}

.chip-warning,
.chip-bordered-warning {
  --chip-icon-color: #ffc000;
  background: #fffff0;
}

.chip-danger,
.chip-bordered-danger {
  --chip-icon-color: #e64949;
  background: #ffedf0;
}

.chip-neutral {
  background: #ededed;
}

.chip-bordered-success {
  border-color: #2ee68c;
}

.chip-bordered-info {
  border-color: #4fc3f7;
}

.chip-bordered-warning {
  border-color: #ffee5c;
}

.chip-bordered-danger {
  border-color: #ff7591;
}

.chip-bordered-neutral {
  border-color: #dedede;
}

.chip-solid-success {
  background: #2ee68c;
}

.chip-solid-info {
  background: #4fc3f7;
}

.chip-solid-warning {
  background: #ffee5c;
}

.chip-solid-danger {
  background: #ff7591;
}

.chip-solid-neutral {
  background: #111111;
  color: #fff;
}

.dark .chip-success,
.dark .chip-bordered-success,
.dark .chip-info,
.dark .chip-bordered-info,
.dark .chip-warning,
.dark .chip-bordered-warning,
.dark .chip-danger,
.dark .chip-bordered-danger,
.dark .chip-neutral,
.dark .chip-bordered-neutral {
  background-color: #343434;
  color: #fff;
}
.dark .chip-success,
.dark .chip-bordered-success {
  --chip-icon-color: #2ee68c;
  border-color: #24a365;
}
.dark .chip-info,
.dark .chip-bordered-info {
  --chip-icon-color: #4fc3f7;
  border-color: #3789ad;
}
.dark .chip-warning,
.dark .chip-bordered-warning {
  --chip-icon-color: #ffee5c;
  border-color: #c4b63f;
}
.dark .chip-danger,
.dark .chip-bordered-danger {
  --chip-icon-color: #ff7591;
  border-color: #c34b63;
}
.dark .chip-neutral,
.dark .chip-bordered-neutral {
  border-color: #878787;
}
.dark .chip-solid-success {
  background: #6bf0af;
}
.dark .chip-solid-info {
  background: #8cdbff;
}
.dark .chip-solid-warning {
  background: #fff394;
}
.dark .chip-solid-danger {
  background: #ffa9bb;
}
.dark .chip-solid-neutral {
  background: #fcfcfc;
  color: #111111;
}

.notification-badge {
  display: inline-flex;
  align-items: center;
  font-size: 0.75rem;
  line-height: 1.5833333333;
  padding: 0.3125rem 0.5rem 0.3125rem 0.75rem;
  letter-spacing: 0.2px;
  border-radius: 50rem;
  color: #111111;
  background-color: #ededed;
}

.notification-badge-counter {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 1.125rem;
  height: 18px;
  line-height: 0;
  font-size: 0.5625rem;
  padding: 0 0.375rem;
  margin-left: 0.3125rem;
  border-radius: var(--bs-border-radius-pill);
  color: #111111;
}

.notification-badge-counter-neutral {
  background-color: #111111;
  color: #fff;
}

.notification-badge-dark {
  background-color: #111111;
  color: #fff;
}
.notification-badge-dark .notification-badge-counter-neutral {
  background-color: #ededed;
  color: #111111;
}

.dark .notification-badge {
  background-color: #343434;
  color: #fff;
}
.dark .notification-badge .notification-badge-counter-neutral {
  background-color: #ededed;
  color: #111111;
}
.dark .notification-badge-dark {
  background-color: #fcfcfc;
  color: #111111;
}
.dark .notification-badge-dark .notification-badge-counter-neutral {
  background-color: #111111;
  color: #fff;
}

.breadcrumb {
  align-items: center;
}
.breadcrumb a {
  display: flex;
  align-items: center;
  color: #111111;
  opacity: 0.64;
}
.breadcrumb a:hover {
  opacity: 1;
}
.breadcrumb svg:first-child:not(:only-child) {
  margin-right: 0.375rem;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
}

.breadcrumb-slash {
  --bs-breadcrumb-divider: "/";
  --bs-breadcrumb-divider-color: rgba(17, 17, 17, 0.4);
}
.breadcrumb-slash .breadcrumb-item + .breadcrumb-item::before {
  font-size: 1rem;
  line-height: 1;
}

.dark .breadcrumb {
  --bs-breadcrumb-item-active-color: rgba(255, 255, 255, 0.4);
}
.dark .breadcrumb:not(.breadcrumb-slash) {
  --bs-breadcrumb-divider: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.dark .breadcrumb a,
.dark .breadcrumb a:hover {
  color: #fff;
}
.dark .breadcrumb-slash {
  --bs-breadcrumb-divider-color: rgba(255, 255, 255, 0.4);
}

.btn:has(svg) {
  align-items: center;
  display: inline-flex;
}
.btn.text-uppercase {
  letter-spacing: 0.7px;
}
.btn:disabled, .btn.disabled {
  pointer-events: all;
  cursor: not-allowed;
}

.btn-xs, .btn-group-xs > .btn {
  --bs-btn-padding-y: 0.125rem;
  --bs-btn-padding-x: 0.9375rem;
  --bs-btn-font-size: 0.75rem;
  --bs-btn-border-radius: 0.3125rem;
  letter-spacing: 0.2px;
  line-height: 1.4375rem;
}

.btn-sm, .btn-group-sm > .btn,
.input-group-sm > .btn {
  line-height: 1.5rem;
}

.btn-lg, .btn-group-lg > .btn,
.input-group-lg > .btn {
  line-height: 1.75rem;
}

.btn-xl, .btn-group-xl > .btn {
  --bs-btn-padding-y: 0.625rem;
  --bs-btn-padding-x: 1.875rem;
  --bs-btn-font-size: 1rem;
  --bs-btn-border-radius: 0.3125rem;
  line-height: 2.125rem;
  letter-spacing: 0.05px;
}

.btn svg {
  opacity: 0.5;
  transition: color 0.15s ease-in-out, opacity 0.15s ease-in-out;
  color: var(--bs-btn-icon-color);
}
.btn:hover svg {
  opacity: 0.9;
}
.btn:active svg, .btn.active svg {
  opacity: 0.6;
}

.btn-icon-prefix {
  margin-right: 0.375rem;
  margin-left: -0.625rem;
}

.btn-icon-suffix {
  margin-left: 0.375rem;
  margin-right: -0.625rem;
}

.btn-xl .btn-icon-prefix, .btn-group-xl > .btn .btn-icon-prefix {
  margin-right: 0.5rem;
  margin-left: -1.125rem;
}
.btn-xl .btn-icon-suffix, .btn-group-xl > .btn .btn-icon-suffix {
  margin-left: 0.5rem;
  margin-right: -1.125rem;
}

.btn-lg .btn-icon-prefix, .btn-group-lg > .btn .btn-icon-prefix {
  margin-right: 0.5rem;
  margin-left: -0.8125rem;
}
.btn-lg .btn-icon-suffix, .btn-group-lg > .btn .btn-icon-suffix {
  margin-left: 0.5rem;
  margin-right: -0.8125rem;
}

.btn-sm .btn-icon-prefix, .btn-group-sm > .btn .btn-icon-prefix {
  margin-right: 0.5rem;
  margin-left: -0.5rem;
}
.btn-sm .btn-icon-suffix, .btn-group-sm > .btn .btn-icon-suffix {
  margin-left: 0.5rem;
  margin-right: -0.5rem;
}

.btn-xs .btn-icon-prefix, .btn-group-xs > .btn .btn-icon-prefix {
  margin-right: 0.375rem;
  margin-left: -0.4375rem;
}
.btn-xs .btn-icon-suffix, .btn-group-xs > .btn .btn-icon-suffix {
  margin-left: 0.375rem;
  margin-right: -0.4375rem;
}

.btn-link:not(.btn) .btn-icon-prefix, .btn-brand-quartenary:not(.btn) .btn-icon-prefix,
.btn-darker-quartenary:not(.btn) .btn-icon-prefix,
.btn-standard-quartenary:not(.btn) .btn-icon-prefix {
  margin-left: 0;
}
.btn-link:not(.btn) .btn-icon-suffix, .btn-brand-quartenary:not(.btn) .btn-icon-suffix,
.btn-darker-quartenary:not(.btn) .btn-icon-suffix,
.btn-standard-quartenary:not(.btn) .btn-icon-suffix {
  margin-right: 0;
}

.btn-square {
  padding: 0 !important;
  position: relative;
  width: 2.5rem;
  height: 2.5rem;
}
.btn-square.btn-xl, .btn-group-xl > .btn-square.btn {
  width: 3.375rem;
  height: 3.375rem;
}
.btn-square.btn-lg, .btn-group-lg > .btn-square.btn, .input-group-lg > .btn-square {
  width: 2.875rem;
  height: 2.875rem;
}
.btn-square.btn-sm, .btn-group-sm > .btn-square.btn, .input-group-sm > .btn-square {
  width: 2.25rem;
  height: 2.25rem;
}
.btn-square.btn-xs, .btn-group-xs > .btn-square.btn {
  width: 1.8125rem;
  height: 1.8125rem;
}

.btn-success,
.btn-info,
.btn-warning,
.btn-danger {
  color: #111111;
}
.btn-success:hover,
.btn-info:hover,
.btn-warning:hover,
.btn-danger:hover {
  color: #000;
}

.btn-brand-primary {
  --bs-btn-color: rgba(255, 255, 255, 0.92);
  --bs-btn-bg: #007f00;
  --bs-btn-border-color: #007f00;
  --bs-btn-icon-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #004f00;
  --bs-btn-hover-border-color: #004f00;
  --bs-btn-active-color: rgba(255, 255, 255, 0.92);
  --bs-btn-active-bg: #006600;
  --bs-btn-active-border-color: #006600;
  --bs-btn-focus-box-shadow: 0 3px 4px 0 rgba(17, 17, 17, 0.22);
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.84);
  --bs-btn-disabled-bg: #b2d8b2;
  --bs-btn-disabled-border-color: #b2d8b2;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .btn-brand-primary, .btn-brand-primary:focus-visible {
  --bs-btn-hover-color: rgba(255, 255, 255, 0.92);
  --bs-btn-hover-bg: #007f00;
  --bs-btn-hover-border-color: #007f00;
}

.btn-brand-secondary {
  --bs-btn-color: rgba(17, 17, 17, 0.84);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: rgba(0, 127, 0, 0.4);
  --bs-btn-icon-color: #111111;
  --bs-btn-hover-color: #111111;
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: #004f00;
  --bs-btn-active-color: #111111;
  --bs-btn-active-bg: transparent;
  --bs-btn-active-border-color: #006600;
  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;
  --bs-btn-disabled-color: rgba(17, 17, 17, 0.5);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #b2d8b2;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .btn-brand-secondary, .btn-brand-secondary:focus-visible {
  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: transparent;
}

.btn-brand-tertiary {
  --bs-btn-color: rgba(17, 17, 17, 0.84);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: #cccccc;
  --bs-btn-icon-color: #111111;
  --bs-btn-hover-color: #111111;
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: #111111;
  --bs-btn-active-color: #111111;
  --bs-btn-active-bg: transparent;
  --bs-btn-active-border-color: #006600;
  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;
  --bs-btn-disabled-color: rgba(17, 17, 17, 0.5);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ededed;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .btn-brand-tertiary, .btn-brand-tertiary:focus-visible {
  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: transparent;
}

.btn-primary,
.btn-dark,
.btn-darker-primary {
  --bs-btn-color: rgba(255, 255, 255, 0.92);
  --bs-btn-bg: #343434;
  --bs-btn-border-color: #343434;
  --bs-btn-icon-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #111111;
  --bs-btn-hover-border-color: #111111;
  --bs-btn-active-color: rgba(255, 255, 255, 0.92);
  --bs-btn-active-bg: #232323;
  --bs-btn-active-border-color: #232323;
  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.84);
  --bs-btn-disabled-bg: #a1a1a1;
  --bs-btn-disabled-border-color: #a1a1a1;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .btn-primary, .btn-primary:focus-visible,
.btn-check:focus-visible + .btn-dark,
.btn-dark:focus-visible,
.btn-check:focus-visible + .btn-darker-primary,
.btn-darker-primary:focus-visible {
  --bs-btn-hover-color: rgba(255, 255, 255, 0.92);
  --bs-btn-hover-bg: #343434;
  --bs-btn-hover-border-color: #343434;
}
.btn-primary.shadow-nm-dark-up,
.btn-dark.shadow-nm-dark-up,
.btn-darker-primary.shadow-nm-dark-up {
  --bs-btn-color: rgba(255, 255, 255, 0.92);
  --bs-btn-bg: #1d1d1d;
  --bs-btn-border-color: #1d1d1d;
  --bs-btn-icon-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #111111;
  --bs-btn-hover-border-color: #111111;
  --bs-btn-active-color: rgba(255, 255, 255, 0.92);
  --bs-btn-active-bg: #1d1d1d;
  --bs-btn-active-border-color: #343434;
  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.84);
  --bs-btn-disabled-bg: #a1a1a1;
  --bs-btn-disabled-border-color: #a1a1a1;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .btn-primary.shadow-nm-dark-up, .btn-primary.shadow-nm-dark-up:focus-visible,
.btn-check:focus-visible + .btn-dark.shadow-nm-dark-up,
.btn-dark.shadow-nm-dark-up:focus-visible,
.btn-check:focus-visible + .btn-darker-primary.shadow-nm-dark-up,
.btn-darker-primary.shadow-nm-dark-up:focus-visible {
  --bs-btn-hover-color: rgba(255, 255, 255, 0.92);
  --bs-btn-hover-bg: #1d1d1d;
  --bs-btn-hover-border-color: #343434;
}

.btn-secondary,
.btn-darker-secondary {
  --bs-btn-color: rgba(255, 255, 255, 0.92);
  --bs-btn-bg: #666666;
  --bs-btn-border-color: #666666;
  --bs-btn-icon-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #343434;
  --bs-btn-hover-border-color: #343434;
  --bs-btn-active-color: rgba(255, 255, 255, 0.92);
  --bs-btn-active-bg: #404040;
  --bs-btn-active-border-color: #404040;
  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.84);
  --bs-btn-disabled-bg: #b6b6b6;
  --bs-btn-disabled-border-color: #b6b6b6;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .btn-secondary, .btn-secondary:focus-visible,
.btn-check:focus-visible + .btn-darker-secondary,
.btn-darker-secondary:focus-visible {
  --bs-btn-hover-color: rgba(255, 255, 255, 0.92);
  --bs-btn-hover-bg: #666666;
  --bs-btn-hover-border-color: #666666;
}

.btn-darker-tertiary,
.btn-darker-outline {
  --bs-btn-color: rgba(17, 17, 17, 0.84);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: #b6b6b6;
  --bs-btn-icon-color: #111111;
  --bs-btn-hover-color: #111111;
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: #111111;
  --bs-btn-active-color: #111111;
  --bs-btn-active-bg: transparent;
  --bs-btn-active-border-color: #111111;
  --bs-btn-focus-box-shadow: none;
  --bs-btn-disabled-color: rgba(17, 17, 17, 0.5);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dedede;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .btn-darker-tertiary, .btn-darker-tertiary:focus-visible,
.btn-check:focus-visible + .btn-darker-outline,
.btn-darker-outline:focus-visible {
  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: #304ffe;
}

.btn-standard-primary {
  --bs-btn-color: rgba(255, 255, 255, 0.92);
  --bs-btn-bg: #404040;
  --bs-btn-border-color: #404040;
  --bs-btn-icon-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #343434;
  --bs-btn-hover-border-color: #343434;
  --bs-btn-active-color: rgba(255, 255, 255, 0.92);
  --bs-btn-active-bg: #232323;
  --bs-btn-active-border-color: #232323;
  --bs-btn-focus-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.84);
  --bs-btn-disabled-bg: #a1a1a1;
  --bs-btn-disabled-border-color: #a1a1a1;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .btn-standard-primary, .btn-standard-primary:focus-visible {
  --bs-btn-hover-color: rgba(255, 255, 255, 0.92);
  --bs-btn-hover-bg: #404040;
  --bs-btn-hover-border-color: #404040;
}

.btn-standard-secondary {
  --bs-btn-color: rgba(17, 17, 17, 0.84);
  --bs-btn-bg: #ededed;
  --bs-btn-border-color: #ededed;
  --bs-btn-icon-color: #111111;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #666666;
  --bs-btn-hover-border-color: #666666;
  --bs-btn-active-color: rgba(255, 255, 255, 0.92);
  --bs-btn-active-bg: #767676;
  --bs-btn-active-border-color: #767676;
  --bs-btn-focus-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  --bs-btn-disabled-color: rgba(17, 17, 17, 0.5);
  --bs-btn-disabled-bg: #f2f2f2;
  --bs-btn-disabled-border-color: #f2f2f2;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .btn-standard-secondary, .btn-standard-secondary:focus-visible {
  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);
  --bs-btn-hover-bg: #ededed;
  --bs-btn-hover-border-color: #ededed;
}
.btn-standard-secondary:hover svg, .btn-standard-secondary:active svg, .btn-standard-secondary.active svg {
  color: #fff;
}

.btn-standard-tertiary,
.btn-standard-outline {
  --bs-btn-color: rgba(17, 17, 17, 0.84);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: #cccccc;
  --bs-btn-icon-color: #111111;
  --bs-btn-hover-color: #111111;
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: #111111;
  --bs-btn-active-color: #111111;
  --bs-btn-active-bg: transparent;
  --bs-btn-active-border-color: #404040;
  --bs-btn-focus-box-shadow: none;
  --bs-btn-disabled-color: rgba(17, 17, 17, 0.5);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ededed;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .btn-standard-tertiary, .btn-standard-tertiary:focus-visible,
.btn-check:focus-visible + .btn-standard-outline,
.btn-standard-outline:focus-visible {
  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: #304ffe;
}

.btn-brand-quartenary,
.btn-darker-quartenary,
.btn-standard-quartenary {
  --bs-btn-color: rgba(17, 17, 17, 0.84);
  --bs-btn-active-color: #111111;
  --bs-btn-hover-color: #111111;
}
.btn-brand-quartenary svg,
.btn-darker-quartenary svg,
.btn-standard-quartenary svg {
  color: #111111;
}
.btn-brand-quartenary.d-block,
.btn-darker-quartenary.d-block,
.btn-standard-quartenary.d-block {
  display: flex !important;
  justify-content: center;
}
.btn-brand-quartenary:hover, .btn-brand-quartenary:focus-visible,
.btn-darker-quartenary:hover,
.btn-darker-quartenary:focus-visible,
.btn-standard-quartenary:hover,
.btn-standard-quartenary:focus-visible {
  text-decoration: none;
}
.btn-brand-quartenary:hover span,
.btn-darker-quartenary:hover span,
.btn-standard-quartenary:hover span {
  background-image: linear-gradient(to right, #111111 0%, #111111 100%);
}
.btn-brand-quartenary.active span, .btn-brand-quartenary:active span,
.btn-darker-quartenary.active span,
.btn-darker-quartenary:active span,
.btn-standard-quartenary.active span,
.btn-standard-quartenary:active span {
  background-image: linear-gradient(to right, rgba(17, 17, 17, 0.5) 0%, rgba(17, 17, 17, 0.5) 100%);
}
.btn-brand-quartenary:disabled span, .btn-brand-quartenary.disabled span,
.btn-darker-quartenary:disabled span,
.btn-darker-quartenary.disabled span,
.btn-standard-quartenary:disabled span,
.btn-standard-quartenary.disabled span {
  color: rgba(17, 17, 17, 0.5);
  background-image: none;
}

.btn-brand-quartenary {
  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;
}
.btn-brand-quartenary:focus-visible {
  box-shadow: 0 0 4px 0 #304ffe;
  color: rgba(17, 17, 17, 0.84);
}

.btn-darker-quartenary,
.btn-standard-quartenary {
  --bs-btn-focus-box-shadow: none;
}
.btn-darker-quartenary:focus-visible,
.btn-standard-quartenary:focus-visible {
  border: 1px solid rgba(48, 79, 254, 0.5);
}

.btn-secondary-inverse {
  --bs-btn-color: rgba(255, 255, 255, 0.8);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: rgba(255, 255, 255, 0.4);
  --bs-btn-icon-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: rgba(255, 255, 255, 0.8);
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: transparent;
  --bs-btn-active-border-color: rgba(255, 255, 255, 0.8);
  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #343434;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .btn-secondary-inverse, .btn-secondary-inverse:focus-visible {
  --bs-btn-hover-color: rgba(255, 255, 255, 0.8);
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: rgba(255, 255, 255, 0.5);
}

.dark .btn-primary,
.dark .btn-darker-primary,
.btn-light {
  --bs-btn-color: rgba(17, 17, 17, 0.84);
  --bs-btn-bg: #fcfcfc;
  --bs-btn-border-color: #fcfcfc;
  --bs-btn-icon-color: #111111;
  --bs-btn-hover-color: #111111;
  --bs-btn-hover-bg: #dedede;
  --bs-btn-hover-border-color: #dedede;
  --bs-btn-active-color: rgba(17, 17, 17, 0.92);
  --bs-btn-active-bg: #f2f2f2;
  --bs-btn-active-border-color: #f2f2f2;
  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);
  --bs-btn-disabled-bg: #4b4b4b;
  --bs-btn-disabled-border-color: #4b4b4b;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .dark .btn-primary, .dark .btn-primary:focus-visible,
.btn-check:focus-visible + .dark .btn-darker-primary,
.dark .btn-darker-primary:focus-visible,
.btn-check:focus-visible + .btn-light,
.btn-light:focus-visible {
  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);
  --bs-btn-hover-bg: #fcfcfc;
  --bs-btn-hover-border-color: #fcfcfc;
}

.dark .show > .btn-primary.dropdown-toggle,
.dark .show > .btn-darker-primary.dropdown-toggle,
.show > .btn-light.dropdown-toggle {
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-bg);
  color: var(--bs-btn-hover-color);
}

.dark .btn-secondary,
.dark .btn-darker-secondary,
.dark .btn-darker-outline {
  --bs-btn-color: rgba(255, 255, 255, 0.84);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: #343434;
  --bs-btn-icon-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: #fff;
  --bs-btn-active-color: rgba(255, 255, 255, 0.92);
  --bs-btn-active-bg: transparent;
  --bs-btn-active-border-color: #808080;
  --bs-btn-focus-box-shadow: none;
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #343434;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .dark .btn-secondary, .dark .btn-secondary:focus-visible,
.btn-check:focus-visible + .dark .btn-darker-secondary,
.dark .btn-darker-secondary:focus-visible,
.btn-check:focus-visible + .dark .btn-darker-outline,
.dark .btn-darker-outline:focus-visible {
  --bs-btn-hover-color: rgba(255, 255, 255, 0.84);
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: #304ffe;
}
.dark .btn-darker-outline {
  --bs-btn-border-color: #575757;
}
.dark .btn-darker-tertiary {
  --bs-btn-color: rgba(255, 255, 255, 0.84);
  --bs-btn-bg: rgba(255, 255, 255, 0.06);
  --bs-btn-border-color: transparent;
  --bs-btn-icon-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgba(255, 255, 255, 0.14);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: rgba(255, 255, 255, 0.92);
  --bs-btn-active-bg: rgba(255, 255, 255, 0.08);
  --bs-btn-active-border-color: transparent;
  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);
  --bs-btn-disabled-bg: rgba(255, 255, 255, 0.02);
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .dark .btn-darker-tertiary, .dark .btn-darker-tertiary:focus-visible {
  --bs-btn-hover-color: rgba(255, 255, 255, 0.84);
  --bs-btn-hover-bg: rgba(255, 255, 255, 0.06);
  --bs-btn-hover-border-color: rgba(255, 255, 255, 0.06);
}
.dark .btn-brand-primary {
  --bs-btn-color: rgba(17, 17, 17, 0.84);
  --bs-btn-bg: #ccff00;
  --bs-btn-border-color: #ccff00;
  --bs-btn-icon-color: #111111;
  --bs-btn-hover-color: #111111;
  --bs-btn-hover-bg: #9fe300;
  --bs-btn-hover-border-color: #9fe300;
  --bs-btn-active-color: rgba(17, 17, 17, 0.92);
  --bs-btn-active-bg: #b0f000;
  --bs-btn-active-border-color: #b0f000;
  --bs-btn-focus-box-shadow: 0 3px 4px 0 rgba(17, 17, 17, 0.22);
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);
  --bs-btn-disabled-bg: #414e0c;
  --bs-btn-disabled-border-color: #414e0c;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .dark .btn-brand-primary, .dark .btn-brand-primary:focus-visible {
  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);
  --bs-btn-hover-bg: #ccff00;
  --bs-btn-hover-border-color: #ccff00;
}
.dark .btn-brand-secondary {
  --bs-btn-color: rgba(255, 255, 255, 0.84);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: rgba(204, 255, 0, 0.4);
  --bs-btn-icon-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: #9fe300;
  --bs-btn-active-color: rgba(255, 255, 255, 0.92);
  --bs-btn-active-bg: transparent;
  --bs-btn-active-border-color: #b0f000;
  --bs-btn-focus-box-shadow: none;
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #414e0c;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .dark .btn-brand-secondary, .dark .btn-brand-secondary:focus-visible {
  --bs-btn-hover-color: rgba(255, 255, 255, 0.84);
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: #304ffe;
}
.dark .btn-brand-tertiary {
  --bs-btn-color: rgba(255, 255, 255, 0.84);
  --bs-btn-bg: rgba(255, 255, 255, 0.02);
  --bs-btn-border-color: transparent;
  --bs-btn-icon-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgba(255, 255, 255, 0.08);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: rgba(255, 255, 255, 0.92);
  --bs-btn-active-bg: rgba(255, 255, 255, 0.06);
  --bs-btn-active-border-color: transparent;
  --bs-btn-focus-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);
  --bs-btn-disabled-bg: rgba(255, 255, 255, 0.02);
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .dark .btn-brand-tertiary, .dark .btn-brand-tertiary:focus-visible {
  --bs-btn-hover-color: rgba(255, 255, 255, 0.84);
  --bs-btn-hover-bg: rgba(255, 255, 255, 0.02);
  --bs-btn-hover-border-color: transparent;
}
.dark .btn-standard-primary {
  --bs-btn-color: rgba(17, 17, 17, 0.84);
  --bs-btn-bg: #dedede;
  --bs-btn-border-color: #dedede;
  --bs-btn-icon-color: #111111;
  --bs-btn-hover-color: #111111;
  --bs-btn-hover-bg: #a1a1a1;
  --bs-btn-hover-border-color: #a1a1a1;
  --bs-btn-active-color: rgba(17, 17, 17, 0.92);
  --bs-btn-active-bg: #b6b6b6;
  --bs-btn-active-border-color: #b6b6b6;
  --bs-btn-focus-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);
  --bs-btn-disabled-bg: #404040;
  --bs-btn-disabled-border-color: #404040;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .dark .btn-standard-primary, .dark .btn-standard-primary:focus-visible {
  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);
  --bs-btn-hover-bg: #dedede;
  --bs-btn-hover-border-color: #dedede;
}
.dark .btn-standard-secondary,
.dark .btn-standard-outline {
  --bs-btn-color: rgba(255, 255, 255, 0.84);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: #343434;
  --bs-btn-icon-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: #b6b6b6;
  --bs-btn-active-color: rgba(255, 255, 255, 0.92);
  --bs-btn-active-bg: transparent;
  --bs-btn-active-border-color: #808080;
  --bs-btn-focus-box-shadow: none;
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #232323;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .dark .btn-standard-secondary, .dark .btn-standard-secondary:focus-visible,
.btn-check:focus-visible + .dark .btn-standard-outline,
.dark .btn-standard-outline:focus-visible {
  --bs-btn-hover-color: rgba(255, 255, 255, 0.84);
  --bs-btn-hover-bg: transparent;
  --bs-btn-hover-border-color: #304ffe;
}
.dark .btn-standard-tertiary {
  --bs-btn-color: rgba(255, 255, 255, 0.84);
  --bs-btn-bg: rgba(255, 255, 255, 0.02);
  --bs-btn-border-color: transparent;
  --bs-btn-icon-color: #fff;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgba(255, 255, 255, 0.08);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: rgba(255, 255, 255, 0.92);
  --bs-btn-active-bg: rgba(255, 255, 255, 0.06);
  --bs-btn-active-border-color: transparent;
  --bs-btn-focus-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);
  --bs-btn-disabled-bg: rgba(255, 255, 255, 0.02);
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-disabled-opacity: 1;
}
.btn-check:focus-visible + .dark .btn-standard-tertiary, .dark .btn-standard-tertiary:focus-visible {
  --bs-btn-hover-color: rgba(255, 255, 255, 0.84);
  --bs-btn-hover-bg: rgba(255, 255, 255, 0.02);
  --bs-btn-hover-border-color: transparent;
}
.dark .btn-brand-quartenary,
.dark .btn-darker-quartenary,
.dark .btn-standard-quartenary {
  color: rgba(255, 255, 255, 0.84);
}
.dark .btn-brand-quartenary svg,
.dark .btn-darker-quartenary svg,
.dark .btn-standard-quartenary svg {
  color: #fff;
}
.dark .btn-brand-quartenary:hover,
.dark .btn-darker-quartenary:hover,
.dark .btn-standard-quartenary:hover {
  color: #fff;
}
.dark .btn-brand-quartenary:hover span,
.dark .btn-darker-quartenary:hover span,
.dark .btn-standard-quartenary:hover span {
  background-image: linear-gradient(to right, #fff 0%, #fff 100%);
}
.dark .btn-brand-quartenary.active, .dark .btn-brand-quartenary:active,
.dark .btn-darker-quartenary.active,
.dark .btn-darker-quartenary:active,
.dark .btn-standard-quartenary.active,
.dark .btn-standard-quartenary:active {
  color: rgba(255, 255, 255, 0.92);
}
.dark .btn-brand-quartenary.active span, .dark .btn-brand-quartenary:active span,
.dark .btn-darker-quartenary.active span,
.dark .btn-darker-quartenary:active span,
.dark .btn-standard-quartenary.active span,
.dark .btn-standard-quartenary:active span {
  background-image: linear-gradient(to right, #808080 0%, #808080 100%);
}
.dark .btn-brand-quartenary:disabled span, .dark .btn-brand-quartenary.disabled span,
.dark .btn-darker-quartenary:disabled span,
.dark .btn-darker-quartenary.disabled span,
.dark .btn-standard-quartenary:disabled span,
.dark .btn-standard-quartenary.disabled span {
  color: rgba(255, 255, 255, 0.4);
  background-image: none;
}
.dark .btn-brand-quartenary:focus-visible,
.dark .btn-darker-quartenary:focus-visible,
.dark .btn-standard-quartenary:focus-visible {
  color: rgba(255, 255, 255, 0.84);
}
.dark .btn-darker-quartenary:focus-visible,
.dark .btn-standard-quartenary:focus-visible {
  border-color: rgba(48, 79, 254, 0.5);
}
.dark .btn-brand-quartenary {
  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);
}
.dark .btn-brand-quartenary:focus-visible {
  box-shadow: 0 0 4px 0 rgba(48, 79, 254, 0.5);
}

.btn-group-shadow {
  background: #ededed;
}
.btn-group-shadow .btn {
  color: rgba(17, 17, 17, 0.84);
  background-color: transparent;
  border-color: transparent;
}
.btn-group-shadow .btn:hover, .btn-group-shadow .btn:focus, .btn-group-shadow .btn:not(:disabled):not(.disabled):active {
  color: #000;
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
}
.btn-group-shadow .btn:not(:disabled):not(.disabled).active,
.btn-group-shadow .show > .btn.dropdown-toggle {
  color: #111111;
  background-color: #fff;
  border-color: transparent;
  box-shadow: 0 0.4375rem 0.875rem 0 rgba(0, 0, 0, 0.14);
}
.btn-group-shadow .btn:not(:disabled):not(.disabled).active:focus,
.btn-group-shadow .show > .btn.dropdown-toggle:focus {
  color: #000;
  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.24);
}

.btn-group-brand {
  --btn-group-brand-border-color: #c5e7c1;
}
.btn-group-brand .btn {
  background-color: transparent;
  color: rgba(17, 17, 17, 0.84);
}
.btn-group-brand .btn, .btn-group-brand .btn:focus {
  border-color: var(--btn-group-brand-border-color);
}
.btn-group-brand .btn:not(:first-child):not(:last-child) {
  border-left-color: transparent;
  border-right-color: transparent;
}
.btn-group-brand .btn:first-child {
  border-right-color: transparent;
}
.btn-group-brand .btn:last-child {
  border-left-color: transparent;
}
.btn-group-brand .btn:hover {
  border-color: #004f00 !important;
}
.btn-group-brand .btn:focus, .btn-group-brand .btn:not(:disabled):not(.disabled):active {
  border-color: #304ffe !important;
  box-shadow: none;
  background-color: unset;
  color: unset;
}
.btn-group-brand .btn:not(:disabled):not(.disabled).active {
  background-color: #006600;
  border-color: #006600;
  color: #fff;
}

.btn-group-fill {
  background: #ededed;
}
.btn-group-fill .btn {
  color: rgba(17, 17, 17, 0.84);
  background-color: transparent;
  border-color: transparent;
}
.btn-group-fill .btn:hover, .btn-group-fill .btn:not(:disabled):not(.disabled):active {
  color: #111111;
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
}
.btn-group-fill .btn:hover:focus, .btn-group-fill .btn:not(:disabled):not(.disabled):active:focus {
  box-shadow: 0 0 4px 0 #304ffe;
}
.btn-group-fill .btn:not(:disabled):not(.disabled).active,
.btn-group-fill .show > .btn.dropdown-toggle {
  color: #fff;
  background-color: #232323;
  border-color: transparent;
}

.btn-group.rounded-0 > .btn {
  --bs-btn-border-radius: 0;
}
.btn-group.rounded-2 > .btn {
  --bs-btn-border-radius: 0.1875rem;
}
.btn-group.rounded-4 > .btn {
  --bs-btn-border-radius: 0.5rem;
}
.btn-group.rounded-pill > .btn {
  --bs-btn-border-radius: 50rem;
}

.btn-group-fill > .btn,
.btn-group-shadow > .btn {
  border-radius: var(--bs-btn-border-radius) !important;
}

.dark .btn-group-shadow {
  background: #090909;
}
.dark .btn-group-shadow .btn {
  color: rgba(255, 255, 255, 0.84);
}
.dark .btn-group-shadow .btn:hover, .dark .btn-group-shadow .btn:focus, .dark .btn-group-shadow .btn:not(:disabled):not(.disabled):active {
  color: #fff;
}
.dark .btn-group-shadow .btn:not(:disabled):not(.disabled).active,
.dark .btn-group-shadow .show > .btn.dropdown-toggle {
  color: rgba(255, 255, 255, 0.92);
  background-color: #232323;
  border-color: transparent;
  box-shadow: 0 0.4375rem 0.875rem rgba(0, 0, 0, 0.5);
}
.dark .btn-group-shadow .btn:not(:disabled):not(.disabled).active:focus,
.dark .btn-group-shadow .show > .btn.dropdown-toggle:focus {
  color: #fff;
  box-shadow: 0 0.5625rem 0.875rem rgba(17, 17, 17, 0.7);
}
.dark .btn-group-brand {
  --btn-group-brand-border-color: rgba(0, 127, 0, 0.2);
}
.dark .btn-group-brand .btn {
  color: rgba(255, 255, 255, 0.84);
}
.dark .btn-group-brand .btn:hover {
  border-color: #9fe300 !important;
}
.dark .btn-group-brand .btn:not(:disabled):not(.disabled).active {
  background-color: #b0f000;
  border-color: #b0f000;
  color: #111111;
}
.dark .btn-group-fill {
  background: #090909;
}
.dark .btn-group-fill .btn {
  color: rgba(255, 255, 255, 0.84);
  background-color: transparent;
  border-color: transparent;
}
.dark .btn-group-fill .btn:hover, .dark .btn-group-fill .btn:not(:disabled):not(.disabled):active {
  color: #fff;
  border-color: transparent;
  box-shadow: none;
}
.dark .btn-group-fill .btn:hover:focus, .dark .btn-group-fill .btn:not(:disabled):not(.disabled):active:focus {
  box-shadow: 0 0 4px 0 #304ffe;
}
.dark .btn-group-fill .btn:not(:disabled):not(.disabled).active,
.dark .btn-group-fill .show > .btn.dropdown-toggle {
  color: #111111;
  background-color: #fafafa;
  border-color: transparent;
}
.dark .btn-group-fill .btn:not(:disabled):not(.disabled).active:focus,
.dark .btn-group-fill .show > .btn.dropdown-toggle:focus {
  color: #000;
}

.accordion {
  --bs-accordion-hover-bg: #fafafa;
  --bs-accordion-btn-active-icon: var(--bs-accordion-btn-icon);
}
.accordion.rounded-0, .accordion.accordion-flush {
  --bs-accordion-border-radius: 0;
  --bs-accordion-inner-border-radius: 0;
}
.accordion:not(.rounded-0) .accordion-item:last-child .accordion-body {
  border-radius: 0 0 0.75rem 0.75rem;
}

.accordion-item {
  position: relative;
  overflow: hidden;
  border: 0;
  background-color: transparent;
}
.accordion-item + .accordion-item {
  margin-top: -1px;
}
.accordion-item.disabled {
  cursor: not-allowed;
}
.accordion-item.disabled .accordion-button {
  pointer-events: none;
}
.accordion-item.disabled .accordion-button .accordion-title,
.accordion-item.disabled .accordion-button .accordion-subtitle {
  opacity: 0.5;
}
.accordion-item.disabled .accordion-button svg, .accordion-item.disabled .accordion-button::after {
  opacity: 0.4;
}
.accordion-item.disabled .accordion-button:focus-visible {
  box-shadow: none;
  border-color: var(--bs-accordion-border-color) !important;
}

.accordion-has-icon-suffix .accordion-button::after {
  margin-left: 0.625rem;
}

.accordion-btn-icon-prefix {
  margin-right: 0.5rem;
}

.accordion-title {
  opacity: 0.84;
}

.accordion-subtitle {
  opacity: 0.57;
  font-size: 0.75rem;
  letter-spacing: 0.2px;
  line-height: 1.9166666667;
}
.accordion-subtitle:first-child {
  margin-top: 0.0625rem;
}
.accordion-subtitle + .accordion-title {
  margin-bottom: 0.0625rem;
}

.accordion-button {
  align-items: start;
  font-size: 0.875rem;
  line-height: 1.7142857143;
  outline: 0;
  border: 1px solid var(--bs-accordion-border-color);
}
.accordion-button:focus {
  border-color: var(--bs-accordion-border-color) !important;
  z-index: 2;
}
.accordion-button:active, .accordion-button:focus, .accordion-button:focus-visible {
  outline: 0;
  box-shadow: none;
}
.accordion-button svg, .accordion-button::after {
  opacity: 0.64;
}
.accordion-button:focus-visible {
  border-color: #304ffe !important;
  z-index: 3;
}
.accordion-button:focus-visible .accordion-subtitle {
  opacity: 0.64;
}
.accordion-button:not(.collapsed) {
  box-shadow: none;
}
.accordion-button:hover {
  z-index: 3;
  background-color: var(--bs-accordion-hover-bg);
  border-color: #000000 !important;
}
.accordion-button:hover .accordion-title {
  opacity: 1;
}
.accordion-button:hover .accordion-subtitle {
  opacity: 0.64;
}
.accordion-button:hover svg, .accordion-button:hover::after {
  opacity: 0.9;
}

.accordion-body {
  background-color: var(--bs-accordion-bg);
  padding: 0.9375rem 1.1875rem 1.1875rem;
  font-size: 0.875rem;
  border: 1px solid var(--bs-accordion-border-color);
  border-top: none;
  letter-spacing: 0;
}
.accordion-body p {
  opacity: 0.64;
}
.accordion-body p:last-child {
  margin-bottom: 0;
}

.accordion-has-btn-icon-prefix .accordion-button {
  padding-left: 0.875rem;
}
.accordion-has-btn-icon-prefix .accordion-body {
  padding-left: 2.875rem;
}

.accordion-lg {
  --bs-accordion-btn-icon-width: 2rem;
}
.accordion-lg.accordion-has-btn-icon-prefix .accordion-button {
  padding-left: 1.0625rem;
}
.accordion-lg.accordion-has-btn-icon-prefix .accordion-body {
  padding-left: 3.5625rem;
}
.accordion-lg .accordion-button {
  padding: 0.6875rem 1.0625rem 0.6875rem 1.5rem;
  font-size: 0.9375rem;
  line-height: 2.1333333333;
}
.accordion-lg .accordion-subtitle {
  font-size: 0.8125rem;
  margin: -0.0625rem 0 0.1875rem;
  line-height: 1.4615384615;
  letter-spacing: 0;
}
.accordion-lg .accordion-subtitle:first-child {
  margin: 0.4375rem 0 0;
}
.accordion-lg .accordion-subtitle + .accordion-title {
  line-height: 1.8;
  margin-bottom: 0.25rem;
}
.accordion-lg .accordion-body {
  padding: 1.1875rem 1.5rem 1.5rem;
  font-size: 1rem;
  letter-spacing: 0.1px;
}

.accordion-sm.accordion-has-btn-icon-prefix .accordion-button {
  padding-left: 0.5625rem;
}
.accordion-sm.accordion-has-btn-icon-prefix .accordion-body {
  padding-left: 2.5625rem;
}
.accordion-sm .accordion-button {
  padding: 0.4375rem 0.5rem 0.4375rem 0.875rem;
  font-size: 0.8125rem;
  line-height: 1.8461538462;
}
.accordion-sm .accordion-subtitle {
  margin-bottom: 0.0625rem;
}
.accordion-sm .accordion-subtitle:first-child,
.accordion-sm .accordion-subtitle + .accordion-title {
  margin-bottom: 0;
}
.accordion-sm .accordion-body {
  padding: 1rem 0.875rem 1.1875rem;
  font-size: 0.8125rem;
  line-height: 1.6153846154;
  letter-spacing: 0.2px;
}

.accordion-marketing {
  --bs-accordion-btn-icon-width: 3rem;
}
.accordion-marketing.accordion-has-btn-icon-prefix .accordion-button {
  padding-left: 0.875rem;
}
.accordion-marketing.accordion-has-btn-icon-prefix .accordion-body {
  padding-left: 4.375rem;
}
.accordion-marketing .accordion-button {
  padding: 1.9375rem 0.875rem 1.9375rem 1.5rem;
  font-size: 1.625rem;
  line-height: 1.8461538462;
}
.accordion-marketing .accordion-subtitle {
  font-size: 1.125rem;
  line-height: 1.8888888889;
  margin-bottom: 0.125rem;
  letter-spacing: 0.15px;
}
.accordion-marketing .accordion-subtitle:first-child {
  line-height: 1.7777777778;
  margin: 0.5rem 0 0;
}
.accordion-marketing .accordion-subtitle + .accordion-title {
  line-height: 1.8076923077;
  margin-bottom: 0;
}
.accordion-marketing .accordion-body {
  padding: 2rem 1.5rem 2.1875rem;
  font-size: 1.125rem;
  line-height: 1.7777777778;
  letter-spacing: 0.15px;
}
.accordion-marketing.accordion-lg.accordion-has-btn-icon-prefix .accordion-button {
  padding-left: 1.1875rem;
}
.accordion-marketing.accordion-lg.accordion-has-btn-icon-prefix .accordion-body {
  padding-left: 4.75rem;
}
.accordion-marketing.accordion-lg .accordion-button {
  padding: 2.4375rem 1.1875rem 2.4375rem 1.8125rem;
  font-size: 1.75rem;
  line-height: 1.7142857143;
  letter-spacing: 0.45px;
}
.accordion-marketing.accordion-lg .accordion-subtitle {
  margin-bottom: 0.1875rem;
}
.accordion-marketing.accordion-lg .accordion-subtitle:first-child {
  margin-bottom: 0;
}
.accordion-marketing.accordion-lg .accordion-subtitle + .accordion-title {
  line-height: 1.7142857143;
}
.accordion-marketing.accordion-lg .accordion-body {
  padding: 2.25rem 1.8125rem 2.4375rem;
}
.accordion-marketing.accordion-sm.accordion-has-btn-icon-prefix .accordion-button {
  padding-left: 0.875rem;
}
.accordion-marketing.accordion-sm.accordion-has-btn-icon-prefix .accordion-body {
  padding-left: 4.375rem;
}
.accordion-marketing.accordion-sm .accordion-button {
  padding: 1.4375rem 0.5625rem 1.4375rem 1.5rem;
  font-size: 1.4375rem;
  line-height: 2.0869565217;
}
.accordion-marketing.accordion-sm .accordion-subtitle {
  line-height: 1.6111111111;
  margin-bottom: 0.3125rem;
}
.accordion-marketing.accordion-sm .accordion-subtitle:first-child {
  margin: 0.5625rem 0 0.1875rem;
}
.accordion-marketing.accordion-sm .accordion-subtitle + .accordion-title {
  line-height: 1.8260869565;
}
.accordion-marketing.accordion-sm .accordion-body {
  padding: 1.75rem 1.5rem 2.1875rem;
}

.accordion-flush {
  --bs-accordion-bg: transparent !important;
  --bs-accordion-btn-bg: transparent !important;
  --bs-accordion-active-bg: transparent !important;
  --bs-accordion-hover-bg: transparent !important;
}
.accordion-flush .accordion-item:last-child .accordion-body {
  border: 0;
}
.accordion-flush .accordion-item + .accordion-item {
  margin-top: 0;
}
.accordion-flush .accordion-item .accordion-button {
  border-top: 0;
}
.accordion-flush .accordion-button,
.accordion-flush .accordion-body {
  border-left: 0;
  border-right: 0;
}

.dark .accordion {
  --bs-accordion-bg: #111111;
  --bs-accordion-color: #fff;
  --bs-accordion-btn-color: #fff;
  --bs-accordion-active-color: #fff;
  --bs-accordion-btn-bg: #111111;
  --bs-accordion-active-bg: #111111;
  --bs-accordion-border-color: #232323;
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-hover-bg: #232323;
}
.dark .accordion-button:hover {
  border-color: #fff !important;
}

a.card {
  color: #111111;
}

button.card {
  padding: 0;
  text-align: left;
}

.card-title {
  font-size: 1rem;
  font-weight: normal;
  line-height: 1.5;
  letter-spacing: 0.05px;
}

.card-subtitle {
  font-size: 0.8125rem;
  letter-spacing: 0.2px;
  text-transform: none;
  font-weight: normal;
  opacity: 0.6;
}

.card-body {
  padding: 1rem 1.5625rem 1.5rem 1.5625rem;
}

.card-text {
  font-size: 0.875rem;
  letter-spacing: 0.2px;
  line-height: 1.7857142857;
  opacity: 0.6;
}

.card-text-sm {
  font-size: 0.8125rem;
  letter-spacing: 0.2px;
  line-height: 1.7692307692;
  opacity: 0.84;
}

.card-text-lg {
  font-size: 1rem;
  letter-spacing: 0.1px;
  line-height: 1.75;
  opacity: 0.6;
}

.card-lg .card-title {
  font-size: 1.125rem;
}
.card-lg .card-title-lg {
  font-size: 1.4375rem;
  line-height: 1.5217391304;
  letter-spacing: 0.15px;
}
.card-lg .card-body {
  padding: 1.875rem;
}
.card-lg .card-text {
  font-size: 1rem;
  line-height: 1.75;
  letter-spacing: 0.1px;
}
.card-lg .card-subtitle {
  font-size: 0.8125rem;
  letter-spacing: 0.2px;
  line-height: 1.5384615385;
  text-transform: none;
  opacity: 0.6;
  margin-bottom: 1rem;
}

.card-border {
  --bs-card-border-width: 1px;
}

.card-implicit {
  --bs-card-bg: transparent !important;
}
.card-implicit .card-body {
  padding-left: 0;
  padding-right: 0;
}

.card-link {
  font-size: 0.875rem;
  line-height: 1.4285714286;
  color: rgba(17, 17, 17, 0.84);
}
.card-link:hover {
  color: #111111;
}

.dark a.card,
.dark button.card {
  color: #fff;
}
.dark .card {
  --bs-card-bg: #111111;
}
.dark .card-border {
  --bs-card-border-color: #343434;
}
.dark .card-link {
  color: rgba(255, 255, 255, 0.84);
}
.dark .card-link:hover {
  color: #fff;
}

.dropdown-menu {
  box-shadow: var(--bs-dropdown-box-shadow);
}

.dropdown-menu-media .dropdown-item svg {
  opacity: 0.54;
}
.dropdown-menu-media .dropdown-item h5, .dropdown-menu-media .dropdown-item .h5 {
  opacity: 0.84;
}
.dropdown-menu-media .dropdown-item p {
  opacity: 0.64;
}
.dropdown-menu-media .dropdown-item:hover svg {
  opacity: 0.9;
}
.dropdown-menu-media .dropdown-item:hover h5, .dropdown-menu-media .dropdown-item:hover .h5 {
  opacity: 1;
}
.dropdown-menu-media .dropdown-item:hover p {
  opacity: 0.84;
}

.dropdown-menu-scroll {
  max-height: 315px;
  overflow-y: scroll;
}

.dropdown-header {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 400;
  font-size: 0.9375rem;
}

.show > .dropdown-toggle > svg {
  transform: scaleY(-1);
}
.dropdown-toggle > * {
  pointer-events: none;
}
.dropdown-toggle::after, .dropup .dropdown-toggle::after, .dropend .dropdown-toggle::after {
  content: none;
}
.dropstart .dropdown-toggle::before {
  content: none;
}
.dropend .dropdown-toggle.dropdown-item .dropdown-suffix {
  opacity: 0.3;
}
.dropend .dropdown-toggle.dropdown-item:hover .dropdown-suffix, .dropend .dropdown-toggle.dropdown-item:focus .dropdown-suffix {
  opacity: 1;
}

.dropdown-menu .dropend .dropdown-menu {
  margin-left: -0.5em;
  margin-top: -0.5em;
}

.dropdown-item {
  display: flex;
  align-items: center;
  line-height: 1.7142857143;
}

.dropdown-icon-prefix {
  margin-left: -0.3125rem;
  margin-right: 0.625rem;
}

.dropdown-suffix {
  margin-left: auto;
  padding-left: 30px;
  font-size: 0.8125rem;
  display: flex;
  align-items: center;
}

.dropdown-menu-sm {
  font-size: 0.8125rem;
}
.dropdown-menu-sm .dropdown-item {
  line-height: 1.8461538462;
  padding: 0.375rem 0.9375rem;
}

.dropdown-menu-lg {
  font-size: 0.9375rem;
}
.dropdown-menu-lg .dropdown-item {
  line-height: 2.1333333333;
  padding: 0.4375rem 0.9375rem;
}

.dark .dropdown-menu {
  --bs-dropdown-color: rgba(255, 255, 255, 0.64);
  --bs-dropdown-bg: #232323;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: 0 1.25rem 1.875rem rgba(17, 17, 17, 0.6);
  --bs-dropdown-link-color: rgba(255, 255, 255, 0.64);
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: #404040;
  --bs-dropdown-link-hover-bg: #343434;
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #404040;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.list-group {
  --list-group-sub-color: #111111;
  --bs-info-rgb: 33, 141, 204;
  min-width: 255px;
}
.list-group .avatar {
  margin-right: 0.625rem;
}

.list-group-item {
  display: flex;
  align-items: center;
  height: 48px;
  font-size: 0.875rem;
  line-height: 1.4285714286;
  letter-spacing: 0;
  transition: border 0.15s ease-in-out, color 0.15s ease-in-out, background-color 0.15s ease-in-out;
}
.list-group-item + .list-group-item {
  border-top: 1px solid transparent;
}
.list-group-item + .list-group-item.active {
  margin-top: 0;
}
.list-group-item .list-group-icon {
  color: var(--list-group-sub-color);
  opacity: 0.54;
}
.list-group-item:focus-visible {
  outline: 0;
  background: var(--bs-list-group-bg);
  border-color: #304ffe !important;
}
.list-group-item:focus-visible:not(.disabled) {
  color: var(--bs-list-group-color);
}
.list-group-item:hover .list-group-icon,
.list-group-item:hover .list-group-icon-prefix {
  opacity: 0.9;
}
.list-group-item:hover .list-group-item-subtitle {
  opacity: 0.64;
}
.list-group-item.active .list-group-icon,
.list-group-item.active .list-group-icon-prefix, .list-group-item:active .list-group-icon,
.list-group-item:active .list-group-icon-prefix {
  opacity: 0.64;
}
.list-group-item.active .list-group-item-subtitle, .list-group-item:active .list-group-item-subtitle {
  opacity: 0.57;
}
.list-group-item.disabled, .list-group-item:disabled {
  pointer-events: auto;
  cursor: not-allowed;
}
.list-group-item.disabled > *, .list-group-item:disabled > * {
  opacity: 0.5;
}
.list-group-item.disabled .list-group-item-subtitle, .list-group-item:disabled .list-group-item-subtitle {
  opacity: 1;
}
.list-group-item.disabled > svg, .list-group-item:disabled > svg {
  opacity: 0.4 !important;
}

.list-group-icon-prefix {
  margin-right: 6px;
  opacity: 0.5;
  color: var(--list-group-sub-color);
}

.list-group-item-subtitle {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 1.5833333333;
  opacity: 0.5;
  color: var(--list-group-sub-color);
}

.list-group-borderless {
  --bs-list-group-border-color: transparent !important;
}
.list-group-borderless .list-group-item.active {
  border-color: transparent;
}

.list-group-flush > .list-group-item {
  border-top: 1px solid transparent;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom: 1px solid transparent;
}

.list-group-sm .list-group-item {
  height: 44px;
  font-size: 0.8125rem;
  line-height: 1.4615384615;
}
.list-group-sm .list-group-icon-prefix {
  margin-right: 4px;
}

.list-group-lg .list-group-item {
  height: 56px;
  font-size: 0.9375rem;
  line-height: 1.3333333333;
}
.list-group-lg .list-group-icon-prefix {
  margin-right: 8px;
}
.list-group-lg .avatar {
  margin-right: 0.9375rem;
}

.list-group-two-tier .list-group-item {
  height: 72px;
}
.list-group-two-tier .list-group-item-subtitle {
  margin-top: 0.125rem;
}
.list-group-two-tier.list-group-lg .list-group-item {
  height: 80px;
}
.list-group-two-tier.list-group-lg .list-group-item-subtitle {
  margin-top: 0.25rem;
  font-size: 0.8125rem;
  line-height: 1.4615384615;
}
.list-group-two-tier.list-group-sm .list-group-item {
  height: 64px;
}
.list-group-two-tier.list-group-sm .list-group-item-subtitle {
  margin-top: 0;
  font-size: 0.75rem;
  line-height: 1.5833333333;
}

.dark .list-group {
  --list-group-sub-color: #fff;
  --bs-info-rgb: 79, 195, 247;
  --bs-list-group-color: rgba(255, 255, 255, 0.64);
  --bs-list-group-bg: #111111;
  --bs-list-group-border-color: #232323;
  --bs-list-group-disabled-color: #fff;
  --bs-list-group-active-bg: #232323;
  --bs-list-group-active-color: rgba(255, 255, 255, 0.84);
  --bs-list-group-active-border-color: #232323;
  --bs-list-group-action-color: rgba(255, 255, 255, 0.64);
  --bs-list-group-action-hover-color: rgba(255, 255, 255, 0.84);
  --bs-list-group-action-hover-bg: #343434;
  --bs-list-group-action-active-color: rgba(255, 255, 255, 0.84);
  --bs-list-group-action-active-bg: #232323;
  --bs-list-group-disabled-bg: #111111;
  --bs-list-group-disabled-color: #fff;
}

.modal-content {
  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);
}
@media (min-width: 768px) {
  .modal-content {
    box-shadow: 0 1.875rem 2.5rem rgba(35, 35, 35, 0.26);
  }
}

@media (min-width: 216px) {
  .modal-xs {
    margin: 1.75rem auto;
    max-width: 180px;
  }
}
.modal-xs .modal-header {
  padding: 0.3125rem;
}
.modal-xs .modal-header .btn-close-inline {
  padding: 0.3125rem;
  margin: -0.3125rem -0.3125rem -0.3125rem auto;
}
.modal-xs .modal-body {
  padding: 1rem 0.625rem;
}
.modal-xs .modal-header + .modal-body {
  padding-top: 0;
}

.modal-sm .modal-header {
  padding: 0.5rem;
}
.modal-sm .modal-header .btn-close-inline {
  padding: 0.5rem;
  margin: -0.5rem -0.5rem -0.5rem auto;
}
.modal-sm .modal-content {
  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);
}
.modal-sm .modal-body {
  padding: 1.5rem 0.9375rem;
}
.modal-sm .btn.text-uppercase {
  font-size: 0.8125rem;
}

.modal-lg,
.modal-xl {
  --bs-modal-border-radius: 0.75rem;
  --bs-modal-inner-border-radius: 0.75rem;
}

.modal-btn-margin {
  margin: 0.1875rem;
}

.modal-footer-row > div + div {
  border-left: 1px solid #ededed;
}

.modal-footer-column > * {
  margin: 0;
}
.modal-footer-column > div + div {
  border-top: 1px solid #ededed;
}

@media (max-width: 575.98px) {
  .modal-footer-grid > div:nth-child(even) {
    border-left: 1px solid #ededed;
  }
  .modal-footer-grid > div:nth-child(n+3) {
    border-top: 1px solid #ededed;
  }
}
@media (min-width: 576px) {
  .modal-footer-grid > div + div:not(:nth-child(5n)) {
    border-left: 1px solid #ededed;
  }
  .modal-footer-grid > div:nth-child(n+5) {
    border-top: 1px solid #ededed;
  }
}

.dark .modal-footer-column .btn:focus,
.dark .modal-footer-row .btn:focus,
.dark .modal-footer-grid .btn:focus {
  box-shadow: none;
}

.modal-header .btn-close-inline {
  border-radius: var(--bs-modal-border-radius);
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
}

.dark .modal-sm .modal-content {
  box-shadow: 0 0.75rem 1rem 0 rgba(17, 17, 17, 0.5);
}
.dark .modal-content {
  background: #232323;
  color: #fff;
  box-shadow: 0 1.875rem 2.5rem 0 rgba(17, 17, 17, 0.26);
}
@media (min-width: 768px) {
  .dark .modal-content {
    box-shadow: 0 1.875rem 2.5rem rgba(17, 17, 17, 0.7);
  }
}
.dark .modal-footer,
.dark .modal-footer-row > div,
.dark .modal-footer-column > div,
.dark .modal-footer-grid > div {
  border-color: #343434 !important;
}

.page-item:first-child .page-link, .pagination-lg .page-item:first-child .page-link, .pagination-sm .page-item:first-child .page-link,
.page-item:last-child .page-link,
.pagination-lg .page-item:last-child .page-link,
.pagination-sm .page-item:last-child .page-link {
  border-radius: 0;
}

.page-item.disabled {
  cursor: not-allowed;
}
.page-item:not(.disabled) .page-link:focus-visible {
  box-shadow: 0 0 4px 0 #304ffe;
}

.page-item-circle .page-link,
.page-item-square .page-link {
  width: var(--pagination-square-size);
  height: var(--pagination-square-size);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 0;
}

.page-item-pill .page-link {
  border-radius: var(--bs-border-radius-pill) !important;
}

.page-item-word .page-link {
  height: var(--pagination-square-size);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--pagination-word-font-size);
  letter-spacing: 1px;
  text-transform: uppercase;
}

.page-item-circle {
  margin: 0 2px;
}
.page-item-circle .page-link {
  border-radius: 50% !important;
}

.pagination {
  --pagination-word-font-size: 0.6875rem;
  --pagination-square-size: 2.5rem;
}

.pagination-lg {
  --pagination-word-font-size: 1.0625rem;
  --pagination-square-size: 2.875rem;
}

.pagination-sm {
  --bs-pagination-font-size: 0.75rem;
  --pagination-word-font-size: 0.625rem;
  --pagination-square-size: 2.25rem;
}

.dark .pagination {
  --bs-pagination-color: rgba(255, 255, 255, 0.64);
  --bs-pagination-disabled-color: rgba(255, 255, 255, 0.4);
  --bs-pagination-active-bg: #fff;
  --bs-pagination-active-color: #111111;
  --bs-pagination-hover-color: #fff;
  --bs-pagination-hover-bg: #232323;
  --bs-pagination-focus-color: #fff;
}

.popover {
  padding: 1rem 1.25rem 1.125rem;
  box-shadow: var(--bs-box-shadow);
}

.popover-header {
  font-weight: 400;
  font-family: "Roboto", Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  font-size: 0.875rem;
  letter-spacing: 0.3px;
  line-height: 1.5;
  padding: 0;
  margin-bottom: 0.75rem;
}
.popover-header svg:first-child {
  margin: -0.125rem 0.3125rem -0.0625rem -0.375rem;
}

.popover-body {
  opacity: 0.64;
  padding: 0;
  letter-spacing: 0.2px;
}

.popover-dark {
  --bs-popover-bg: #232323;
}
.popover-dark .popover-inner {
  filter: invert(1) grayscale(100%) brightness(120%);
}
.popover-dark .popover-header,
.popover-dark .popover-body {
  color: unset;
}

.bs-popover-top, .bs-popover-auto[data-popper-placement^=top] {
  margin-bottom: 0.625rem;
}

.bs-popover-end, .bs-popover-auto[data-popper-placement^=right] {
  margin-left: 0.625rem;
}

.bs-popover-bottom, .bs-popover-auto[data-popper-placement^=bottom] {
  margin-top: 0.625rem;
}

.bs-popover-start, .bs-popover-auto[data-popper-placement^=left] {
  margin-right: 0.625rem;
}

.dark .popover {
  --bs-popover-bg: #232323;
  --bs-popover-header-color: #fff;
  --bs-popover-body-color: #fff;
}
.dark .popover-dark {
  --bs-popover-bg: #fff;
}

.popover-walkthrough {
  --bs-popover-max-width: 280px;
}

.__floater__arrow {
  display: none;
}

.react-joyride__spotlight {
  margin-left: -1px;
}

.spinner-border-lg,
.spinner-grow-lg {
  --bs-spinner-width: 3rem;
  --bs-spinner-height: 3rem;
}

.spinner-label {
  transition: opacity 300ms;
}

.steps {
  --steps-contrast-color: #fff;
  --steps-incomplete-track-color: #ededed;
  --steps-complete-track-color: #767676;
  --steps-incomplete-circle-color: rgba(#111111, 0.64);
  --steps-incomplete-circle-bg: #ededed;
  --steps-incomplete-circle-hover-bg: #000000;
  --steps-active-circle-bg: #343434;
  --steps-success-color: #15ad5c;
  --steps-warning-color: #ffc000;
  --steps-warning-text-color: #a67d00;
  --steps-danger-color: #e64949;
  --steps-danger-text-color: #9e3232;
  --steps-progress-circle-bg: #fff;
  --steps-circular-progress-color: #2ee68c;
  --steps-circular-progress-background-color: #ededed;
  --steps-tabbed-background: #fafafa;
  --steps-tabbed-background-active: #fff;
  --steps-tabbed-border: #dedede;
  --steps-tabbed-active-border-bottom: #a1a1a1;
  --steps-tabbed-hover-border-bottom: #111111;
  --steps-xs-circle-border: #cccccc;
  --steps-xs-circle-active-border: #767676;
  --steps-xs-complete: #343434;
}

.steps-step {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}
.steps-step:first-child .step-left-line {
  opacity: 0;
}
.steps-step:last-child .step-right-line {
  opacity: 0;
}
.steps-step.step-complete .step-circle {
  color: var(--steps-contrast-color);
  background-color: var(--steps-success-color);
}
.steps-step.step-complete .step-line {
  background-color: var(--steps-complete-track-color);
}
.steps-step.step-active .step-circle {
  color: var(--steps-contrast-color);
  background-color: var(--steps-active-circle-bg);
}
.steps-step.step-active .step-line.step-left-line {
  background-color: var(--steps-complete-track-color);
}
.steps-step.step-warning .step-circle {
  background-color: var(--steps-warning-color);
  color: #111111;
}
.steps-step.step-warning .step-description {
  opacity: 1;
  color: var(--steps-warning-text-color);
}
.steps-step.step-error .step-circle {
  background-color: var(--steps-danger-color);
  color: var(--steps-contrast-color);
}
.steps-step.step-error .step-description {
  opacity: 1;
  color: var(--steps-danger-text-color);
}

a.step-action {
  text-decoration: none;
}

.step-action {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  outline: none;
}
.step-action:disabled .step-label,
.step-action:disabled .step-description,
.step-action:disabled .step-number {
  opacity: 0.5;
}
.step-action:not(:disabled):hover .step-label {
  opacity: 1;
}
.step-action:not(:disabled):hover.step-incomplete.step-normal .step-circle {
  background-color: var(--steps-incomplete-circle-hover-bg);
  color: var(--steps-contrast-color);
}
.step-action:focus-visible .step-circle {
  border-color: #304ffe;
}

.step-top {
  display: flex;
  align-items: center;
}

.step-line {
  background-color: var(--steps-incomplete-track-color);
  flex-grow: 1;
  height: 1px;
}

.step-circle {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  font-size: 0.75rem;
  height: 1.5rem;
  width: 1.5rem;
  border: 1px solid transparent;
  border-radius: 50%;
  background-color: var(--steps-incomplete-circle-bg);
  color: var(--steps-incomplete-circle-color);
  flex-shrink: 0;
}
.step-circle.step-circle-progress {
  background-color: var(--steps-progress-circle-bg);
}
.step-circle .step-progress-track {
  stroke: var(--steps-circular-progress-background-color);
}
.step-circle .step-progress-percent {
  stroke: var(--steps-circular-progress-color);
  transition: stroke-dashoffset 0.15s ease-in;
}

.step-label {
  line-height: 1.25rem;
  opacity: 0.84;
  font-size: 0.875rem;
}

.step-description {
  line-height: 1rem;
  opacity: 0.57;
  font-size: 0.75rem;
}

.steps-sm .step-top {
  height: 1.5rem;
}
.steps-sm .step-circle {
  height: 1rem;
  width: 1rem;
}
.steps-sm .step-error .step-circle,
.steps-sm .step-warning .step-circle {
  background-color: transparent;
  height: 1.5rem;
  width: 1.5rem;
}
.steps-sm .step-error .step-circle {
  color: var(--steps-danger-color);
}
.steps-sm .step-warning .step-circle {
  color: var(--steps-warning-color);
}

.steps-xs .step-circle {
  height: 0.75rem;
  width: 0.75rem;
  background-color: var(--steps-contrast-color);
  border-color: var(--steps-xs-circle-border);
}
.steps-xs .steps-step.step-complete .step-circle {
  background-color: var(--steps-xs-complete);
  border-color: var(--steps-xs-complete);
}
.steps-xs .steps-step.step-active .step-circle {
  border-color: var(--steps-xs-circle-active-border);
}
.steps-xs .steps-step.step-error .step-circle {
  border-color: var(--steps-danger-color);
}
.steps-xs .steps-step.step-warning .step-circle {
  border-color: var(--steps-warning-color);
}
.steps-xs .step-action.step-normal:not(:disabled):hover .step-circle {
  background-color: transparent;
  border-color: var(--steps-incomplete-circle-hover-bg);
}

.steps-alignment-left .steps-step {
  text-align: left;
}
.steps-alignment-left .step-left-line {
  display: none;
}
.steps-alignment-left .step-right-line {
  margin: 0 0.625rem;
}
.steps-alignment-left.steps-xs .step-right-line {
  margin: 0;
}

.steps-tabbed .steps-step {
  display: flex;
  background-color: var(--steps-tabbed-background);
  border: 1px solid var(--steps-tabbed-border);
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  flex-direction: row;
}
.steps-tabbed .steps-step + .steps-step {
  margin-left: -1px;
}
.steps-tabbed .steps-step.step-active {
  background-color: var(--steps-tabbed-background-active);
  border-bottom-color: var(--steps-tabbed-active-border-bottom);
}
.steps-tabbed .step-text {
  text-align: left;
  margin: 0 !important;
}
.steps-tabbed .step-action:not(:disabled):hover {
  border-bottom-color: var(--steps-tabbed-hover-border-bottom);
}
.steps-tabbed .step-action:focus-visible {
  border-color: #304ffe;
  z-index: 1;
}
.steps-tabbed .step-action:focus-visible .step-circle {
  border-color: transparent;
}

.dark .steps {
  --steps-contrast-color: #111111;
  --steps-incomplete-track-color: #4b4b4b;
  --steps-complete-track-color: #878787;
  --steps-incomplete-circle-color: rgba(#fff, 0.84);
  --steps-incomplete-circle-bg: #343434;
  --steps-incomplete-circle-hover-bg: #fff;
  --steps-active-circle-bg: #dedede;
  --steps-success-color: #2ee68c;
  --steps-warning-color: #ffee5c;
  --steps-warning-text-color: #fff17a;
  --steps-danger-color: #ff7591;
  --steps-danger-text-color: #ff94aa;
  --steps-progress-circle-bg: #343434;
  --steps-circular-progress-color: #2ee68c;
  --steps-circular-progress-background-color: #4b4b4b;
  --steps-tabbed-background: #232323;
  --steps-tabbed-background-active: #343434;
  --steps-tabbed-border: #343434;
  --steps-tabbed-active-border-bottom: #808080;
  --steps-tabbed-hover-border-bottom: #cccccc;
  --steps-xs-circle-border: #4b4b4b;
  --steps-xs-circle-active-border: #878787;
  --steps-xs-complete: #dedede;
}

.table {
  --bs-table-cell-padding-y: 0.75rem;
}
.table,
.table .table {
  --bs-table-cell-square-width: 47px;
}
.table tfoot th,
.table thead th {
  font-size: 0.8125rem;
  color: #111111;
}
.table thead th {
  border-bottom: 1px solid #666666;
}
.table tbody {
  font-size: 0.875rem;
  line-height: 1.5714285714;
}
.table > tbody:not(caption) > :last-child > * {
  border-bottom-width: 0;
}
.table > :not(:first-child) {
  border-top: none;
}

.table-cell-square {
  width: var(--bs-table-cell-square-width);
  min-width: var(--bs-table-cell-square-width);
}

th .table-cell-square-icon {
  bottom: var(--bs-table-cell-padding-y);
}

td .table-cell-square-icon {
  top: var(--bs-table-cell-padding-y);
}

.table-layout-fixed {
  table-layout: fixed;
}

[class*=table-responsive] {
  margin-bottom: 1rem;
  overflow-y: hidden;
}
[class*=table-responsive] .table {
  margin-bottom: 0;
}

.table .table {
  --bs-table-bg: #f2f2f2;
}
.table .table thead th {
  background-color: var(--bs-table-bg) !important;
}

.table-bordered .table-bordered {
  margin: -1px;
  width: calc(100% + 2px);
}

.table-header-borderless thead th {
  border-bottom: none;
}

.table-striped {
  --bs-table-bg: #f2f2f2;
  --bs-table-hover-bg: rgba(17, 17, 17, 0.02);
}
.table-striped thead th {
  background-color: #fff;
}

.table-striped-blue {
  --bs-table-bg: #eef0f5;
  --bs-table-striped-bg: #f6f8fd;
}

.table-striped-blue-and-white {
  --bs-table-bg: #fff;
  --bs-table-striped-bg: #f6f8fd;
}

.tr-blue {
  --bs-table-bg: #f6f8fd;
}

.table-striped-gray-and-white {
  --bs-table-bg: #fafafa;
  --bs-table-striped-bg: #fff;
}

.table-heading-blue thead th {
  background-color: #f6f8fd;
  border-bottom: 1px solid #cccccc;
}

.table-heading-gray thead th {
  background-color: #f2f2f2;
  border-bottom: 1px solid #cccccc;
}

.table-sm {
  --bs-table-cell-padding-y: 0.5rem;
}
.table-sm,
.table-sm .table {
  --bs-table-cell-square-width: 39px;
}
.table-sm tfoot th,
.table-sm thead th {
  font-size: 0.75rem;
  line-height: 1.75;
}
.table-sm tbody {
  font-size: 0.8125rem;
  line-height: 1.7692307692;
}
.table-sm > :not(caption) > * > * {
  padding: 0.5rem 0.75rem;
}

.table-lg {
  --bs-table-cell-padding-y: 0.875rem;
}
.table-lg,
.table-lg .table {
  --bs-table-cell-square-width: 52px;
}
.table-lg tbody {
  font-size: 0.9375rem;
  line-height: 1.6;
}
.table-lg > :not(caption) > * > * {
  padding: 0.875rem 0.9375rem;
}

.table-bordered,
.table-bordered th,
.table-bordered td {
  border-color: #cccccc;
}
.table-bordered thead th {
  border-color: #a1a1a1;
  border-bottom-color: #404040;
}

.table-center {
  text-align: center;
}
.table-center tr > th:first-child,
.table-center tr > td:first-child {
  text-align: left;
}
.table-center tr > th:last-child,
.table-center tr > td:last-child {
  text-align: right;
}

.table-col-2-left tr > th:nth-child(2),
.table-col-2-left tr > td:nth-child(2) {
  text-align: left;
}

.table-vertical-stack {
  --bs-table-first-column-bg: #fafafa;
  --bs-table-thead-th-color: rgba(17, 17, 17, 0.92);
  --bs-table-color: rgba(17, 17, 17, 0.84);
}
.table-vertical-stack thead th {
  border-bottom-color: #ccc;
}
.table-vertical-stack > :not(caption):not(thead) > tr > th:first-child {
  background: var(--bs-table-first-column-bg);
}
.table-vertical-stack > :not(thead) th {
  color: var(--bs-table-thead-th-color);
}
.table-vertical-stack tbody td {
  color: var(--bs-table-color);
}

.table-vertical-stack-collapse.collapsed tr:nth-child(n+4) {
  display: none;
}
.table-vertical-stack-collapse th {
  color: #111111;
}

.table-column-sticky {
  --table-column-sticky-shadow: 0 1.25rem 1.875rem rgba(35, 35, 35, 0.2);
}
@media (max-width: 767.98px) {
  .table-column-sticky {
    table-layout: fixed;
  }
  .table-column-sticky th {
    white-space: nowrap;
    width: 150px;
  }
  .table-column-sticky.table-row-selection th:first-child,
  .table-column-sticky.table-row-selection td:first-child {
    z-index: 2;
  }
  .table-column-sticky.table-row-selection th:first-child::after,
  .table-column-sticky.table-row-selection td:first-child::after {
    display: none;
  }
  .table-column-sticky.table-row-selection th:nth-child(2),
  .table-column-sticky.table-row-selection td:nth-child(2) {
    position: sticky;
    left: 40px;
    z-index: 1;
  }
  .table-column-sticky.table-row-selection th:nth-child(2)::after,
  .table-column-sticky.table-row-selection td:nth-child(2)::after {
    content: "";
    position: absolute;
    top: 1px;
    right: 0;
    height: 100%;
    width: 100%;
    box-shadow: var(--table-column-sticky-shadow);
    z-index: -1;
  }
  .table-column-sticky.table-row-selection tr:last-child td:nth-child(2) {
    overflow-y: clip;
  }
  .table-column-sticky th:first-child,
  .table-column-sticky td:first-child {
    position: sticky;
    left: 0;
    z-index: 1;
  }
  .table-column-sticky th:first-child::after,
  .table-column-sticky td:first-child::after {
    content: "";
    position: absolute;
    top: 1px;
    right: 0;
    height: 100%;
    width: 100%;
    box-shadow: var(--table-column-sticky-shadow);
    z-index: -1;
  }
  .table-column-sticky tr:last-child td:first-child {
    overflow-y: clip;
  }
}

.dark .table {
  --bs-table-bg: #111111;
  --bs-table-color: rgba(255, 255, 255, 0.64);
  --bs-table-striped-color: rgba(255, 255, 255, 0.64);
  --bs-table-striped-bg: #1f1f1f;
  --bs-table-hover-bg: rgba(255, 255, 255, 0.05);
  --bs-table-hover-color: rgba(255, 255, 255, 0.64);
}
.dark .table:not(caption) > * > * {
  border-bottom: 1px solid #232323;
}
.dark .table thead th {
  border-color: #b6b6b6;
}
.dark .table .table {
  --bs-table-bg: #1f1f1f;
}
.dark .table-striped {
  --bs-table-bg: #1f1f1f;
  --bs-table-striped-bg: #141414;
}
.dark .table-striped thead th {
  background-color: #111111;
}
.dark .table-striped-blue {
  --bs-table-bg: #1e1f23;
  --bs-table-striped-bg: #16181a;
}
.dark .table-striped-blue-and-white {
  --bs-table-bg: #111111;
  --bs-table-striped-bg: #16181a;
}
.dark .tr-blue {
  --bs-table-bg: #16181a;
}
.dark .table-striped-gray-and-white {
  --bs-table-bg: #141414;
  --bs-table-striped-bg: #111111;
}
.dark .table-striped-gray-and-white thead th {
  background: #1f1f1f;
}
.dark .table-heading-blue thead th {
  background: #1e1f23;
  border-bottom: 1px solid #404040;
}
.dark .table-heading-gray thead th {
  background: #1f1f1f;
  border-bottom: 1px solid #404040;
}
.dark .table-borderless:not(caption) > * > * {
  border-bottom-width: 0;
}
.dark .table-bordered,
.dark .table-bordered th,
.dark .table-bordered td {
  border-color: #404040;
}
.dark .table-bordered:not(caption) > * > * {
  border-bottom: 1px solid #404040;
}
.dark .table-bordered thead th {
  border-color: #575757;
}
.dark tfoot th,
.dark thead th {
  color: rgba(255, 255, 255, 0.92);
}
.dark .table-vertical-stack {
  --bs-table-first-column-bg: #141414;
  --bs-table-thead-th-color: rgba(255, 255, 255, 0.92);
  --bs-table-color: rgba(255, 255, 255, 0.84);
}
.dark .table-vertical-stack-collapse th {
  color: rgba(255, 255, 255, 0.92);
}
.dark .table-column-sticky {
  --table-column-sticky-shadow: 0 1.25rem 1.875rem rgba(0, 0, 0, 0.6);
}

.tooltip {
  letter-spacing: 0.3px;
}

.tooltip-inner {
  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);
}

.tooltip-lg {
  font-size: 0.8125rem;
  letter-spacing: 0.5px;
}
.tooltip-lg .tooltip-inner {
  border-radius: 0.3125rem;
  padding: 0.5625rem 1rem;
}

.bs-tooltip-top, .bs-tooltip-auto[data-popper-placement^=top] {
  margin-bottom: 0.5rem;
}

.bs-tooltip-end, .bs-tooltip-auto[data-popper-placement^=right] {
  margin-left: 0.5rem;
}

.bs-tooltip-bottom, .bs-tooltip-auto[data-popper-placement^=bottom] {
  margin-top: 0.5rem;
}

.bs-tooltip-start, .bs-tooltip-auto[data-popper-placement^=left] {
  margin-right: 0.5rem;
}

.tooltip-link.bs-tooltip-top, .tooltip-link.bs-tooltip-auto[data-popper-placement^=top] {
  margin-bottom: 0.125rem;
}
.tooltip-link.bs-tooltip-end, .tooltip-link.bs-tooltip-auto[data-popper-placement^=right] {
  margin-left: 0.125rem;
}
.tooltip-link.bs-tooltip-bottom, .tooltip-link.bs-tooltip-auto[data-popper-placement^=bottom] {
  margin-top: 0.125rem;
}
.tooltip-link.bs-tooltip-start, .tooltip-link.bs-tooltip-auto[data-popper-placement^=left] {
  margin-right: 0.125rem;
}

.tooltip-light,
.dark .tooltip {
  --bs-tooltip-bg: #fff;
  --bs-tooltip-color: #111111;
}

.dark .tooltip-light {
  --bs-tooltip-bg: #343434;
  --bs-tooltip-color: #fff;
}

.toast-container {
  padding: 1.375rem;
}

.toast-header {
  font-size: 0.875rem;
  letter-spacing: 0.3px;
  line-height: 1.7142857143;
  border-bottom: none;
  padding: 1rem 1.25rem 0.75rem;
}
.toast-header + .toast-body {
  padding: 0 1.25rem 1.25rem;
}
.toast-header small, .toast-header .small {
  line-height: 2;
}

.toast-body {
  display: flex;
  align-items: flex-start;
  letter-spacing: 0.2px;
  padding: 1rem 1.25rem;
  line-height: 1.5;
}

.toast-icon {
  margin-right: 1px;
  margin-left: -6px;
  opacity: 0.8;
}

.toast .btn-close {
  margin-top: -8px;
  margin-left: 5px;
  margin-right: -10px;
  flex-shrink: 0;
}

.toast-border .toast-header {
  border-bottom: 1px solid #404040;
  padding: 0.5rem 1.25rem;
}
.toast-border .toast-header + .toast-body {
  padding-top: 0.75rem;
}
.toast-border .btn-close {
  margin-top: 0;
  margin-bottom: 0;
}

.toast-header:only-child {
  padding-top: 0.75rem;
}
.toast-header:only-child .btn-close {
  margin-top: 0;
}

.toast-body:only-child .btn-close {
  margin-top: -4px;
}

.toast-light,
.dark .toast {
  --bs-toast-bg: #fff;
  --bs-toast-color: rgba(17, 17, 17, 0.64);
  --bs-toast-header-color: #111111;
}
.toast-light .toast-header,
.dark .toast .toast-header {
  border-bottom-color: #dedede;
}

.dark .toast-light {
  --bs-toast-bg: #232323;
  --bs-toast-color: rgba(255, 255, 255, 0.64);
  --bs-toast-header-color: #fff;
}
.dark .toast-light .toast-header {
  border-bottom-color: #404040;
}
.dark .toast:not(.toast-light) .btn-close {
  filter: none;
}

.tree-root {
  background: var(--tree-background-color);
  overflow-y: auto;
  overflow-x: hidden;
}
.tree-root ul,
.tree-root li {
  list-style-type: none;
  text-indent: 0;
  margin: 0;
}
.tree-root ul {
  padding: 0;
}

.tree-sm .tree-node {
  padding: 0.34375rem 0.9375rem;
}
.tree-sm .tree-label {
  font-size: 0.875rem;
}

.tree-node-expand {
  color: inherit;
  opacity: 0.54;
}

.tree-node {
  border: 1px solid transparent;
  padding: 0.59375rem 0.9375rem;
  cursor: pointer;
  background: var(--tree-background-color);
}
.tree-node:not(.tree-node-disabled):hover {
  background: var(--tree-hover-background-color);
}
.tree-node:not(.tree-node-disabled):hover .tree-node-expand,
.tree-node:not(.tree-node-disabled):hover .tree-icon {
  opacity: 0.9;
}
.tree-node:not(.tree-node-disabled):hover .tree-label {
  opacity: 1;
}

.tree-node-focusable {
  outline: none;
}

button.tree-node:focus-visible,
a.tree-node:focus-visible,
li:focus-visible > .tree-node {
  border-color: #304ffe;
}

a.tree-node:hover {
  text-decoration: none;
}

.tree-node-disabled {
  cursor: not-allowed;
}
.tree-node-disabled .tree-node-expand,
.tree-node-disabled .tree-icon,
.tree-node-disabled .tree-label {
  opacity: 0.5;
}
.tree-node-disabled:hover {
  background: var(--tree-disabled-hover-background-color);
}

.tree-label {
  font-size: 0.9375rem;
  line-height: 1.25rem;
  padding: 0.21875rem 0;
  opacity: 0.64;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
}

.tree-prefix {
  width: 24px;
  flex-shrink: 0;
}

.tree-indicator-spacing {
  width: 16px;
  flex-shrink: 0;
}

.tree-vertical-line {
  position: absolute;
  z-index: 1;
  align-self: center;
  width: 1px;
  background: var(--tree-indicator-color);
}
.tree-vertical-line.tree-node-full-height {
  height: calc(100% + 2px);
  top: 0;
  bottom: 0;
}
.tree-vertical-line.tree-node-bottom-half {
  height: calc(50% - 12px);
  bottom: -2px;
}

.tree-icon {
  opacity: 0.54;
}

.tree-is-above {
  border-top-color: #304ffe;
}

.tree-is-below {
  border-bottom-color: #304ffe;
  margin-bottom: -1px;
  position: relative;
  padding-bottom: 0.65625rem;
}

.tree-sm .tree-is-below {
  padding-bottom: 0.40625rem;
}

.tree-node-notification {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 18px;
  height: 18px;
  line-height: 0;
  font-size: 0.5625rem;
  padding: 0 0.37625rem;
  background-color: var(--tree-notification-background-color);
  color: var(--tree-notification-text-color);
  border-radius: var(--bs-border-radius-pill);
}

.tree-notification-badge {
  font-weight: 400;
  padding: 0.33333em 0.7em !important;
}

.tree-spacer {
  background: var(--tree-background-color);
  min-height: 10px;
  border: 1px solid transparent;
}
.tree-spacer.tree-is-over {
  border-top-color: #304ffe;
}

:root,
[data-bs-theme=light],
.light {
  --tree-background-color: #fff;
  --tree-hover-background-color: #f2f2f2;
  --tree-disabled-hover-background-color: #fafafa;
  --tree-notification-background-color: #111111;
  --tree-notification-text-color: #fff;
  --tree-indicator-color: #dedede;
}

[data-bs-theme=dark],
.dark {
  --tree-background-color: #111111;
  --tree-hover-background-color: #343434;
  --tree-disabled-hover-background-color: #232323;
  --tree-notification-background-color: #ededed;
  --tree-notification-text-color: #111111;
  --tree-indicator-color: #404040;
}

.nav {
  --bs-nav-tabs-link-active-color: rgba(17, 17, 17, 0.84);
  letter-spacing: 0.3px;
}

.nav-link {
  line-height: 2;
}
.nav-link svg {
  color: #111111;
  opacity: 0.54;
  transition: opacity 0.15s ease-in-out, color 0.15s ease-in-out;
}
.nav-link svg:first-child:not(:only-child) {
  margin-right: 0.3125rem;
}
.nav-link:focus, .nav-link:focus-within {
  outline: 0;
}
.nav-link.active {
  color: var(--bs-nav-tabs-link-active-color);
}
.nav-link.active svg {
  opacity: 0.8;
}
.nav-link:hover {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:hover svg {
  opacity: 0.9;
}
.nav-link:focus-visible {
  color: var(--bs-nav-link-color);
}
.nav-link.disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: auto;
  cursor: not-allowed;
}
.nav-link.disabled svg {
  opacity: 0.4;
}

.tab-content-vertical {
  border-left: 1px solid #ededed;
  background: #fff;
}

.nav-tabs-column {
  min-width: 15.9375rem;
  background: #fff;
}

[class=nav] .nav-link:focus-visible,
[class="nav flex-column"] .nav-link:focus-visible {
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.nav-tabs {
  --bs-nav-tabs-bg-color: #fff;
  --bs-nav-tabs-focus-border-color: #304ffe #304ffe transparent;
  background-color: var(--bs-nav-tabs-bg-color);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  position: relative;
}
.nav-tabs .nav-link.active {
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .nav-link:not(.disabled):hover {
  color: var(--bs-nav-link-hover-color);
  border-color: var(--bs-nav-tabs-link-hover-border-color);
  z-index: 2;
}
.nav-tabs .nav-link:not(.disabled):focus-visible {
  border-color: var(--bs-nav-tabs-focus-border-color) !important;
  z-index: 1;
}
.nav-tabs:not(.flex-column) .nav-item + .nav-item,
.nav-tabs:not(.flex-column) .nav-link + .nav-link {
  margin-left: -1px;
}
.nav-tabs + .tab-content {
  --bs-nav-tabs-border-color: #cccccc;
  border: 1px solid var(--bs-nav-tabs-border-color);
  border-top: 0;
}
.nav-tabs.flex-column {
  --bs-nav-tabs-link-hover-border-color: #111111 transparent #111111 #111111;
  --bs-nav-tabs-link-active-border-color: #cccccc transparent #cccccc #cccccc;
  --bs-nav-tabs-focus-border-color: #304ffe transparent #304ffe #304ffe;
  border-bottom: 0;
}
.nav-tabs.flex-column .nav-link {
  margin-right: calc(-1 * var(--bs-nav-tabs-border-width));
}

.nav-tabs + .tab-content-vertical {
  border: 1px solid #cccccc;
}

.nav-standard {
  --bs-nav-standard-border-color: #cccccc;
  --bs-nav-standard-focus-border-color: #304ffe;
  --bs-nav-standard-link-bg-color: #fff;
  --bs-nav-standard-link-border-color: transparent;
  --bs-nav-standard-link-active-border-color: #a1a1a1;
  --bs-nav-standard-link-hover-border-color: #111111;
  border-bottom: 1px solid var(--bs-nav-standard-border-color);
}
.nav-standard .nav-link {
  background-color: var(--bs-nav-standard-link-bg-color);
  border: 1px solid var(--bs-nav-standard-link-border-color);
}
.nav-standard .nav-link.active {
  border-bottom-color: var(--bs-nav-standard-link-active-border-color);
}
.nav-standard .nav-link:not(.disabled):hover {
  border-bottom-color: var(--bs-nav-standard-link-hover-border-color);
}
.nav-standard .nav-link:not(.disabled):focus-visible {
  border-color: var(--bs-nav-standard-focus-border-color) !important;
}
.nav-standard.flex-column {
  border-bottom: 0;
}
.nav-standard.flex-column .nav-link {
  border-bottom-color: transparent;
}
.nav-standard.flex-column .nav-link.active {
  border-left-color: var(--bs-nav-standard-link-active-border-color);
}
.nav-standard.flex-column .nav-link:not(.disabled):hover {
  border-bottom-color: transparent;
  border-left-color: var(--bs-nav-standard-link-hover-border-color);
}

.nav-pills {
  --bs-nav-pills-bg-link-color: #fff;
  --bs-nav-link-color: rgba(17, 17, 17, 0.84);
  --bs-nav-pills-border-color: #fff;
  --bs-nav-pills-hover-bg-color: #111111;
  --bs-nav-pills-hover-border-color: #111111;
  --bs-nav-pills-hover-color: #fff;
  --bs-nav-pills-hover-focus-color: #fff;
  --bs-nav-pills-active-icon-color: #fff;
}
.nav-pills .nav-link {
  background-color: var(--bs-nav-pills-bg-link-color);
  border: 1px solid var(--bs-nav-pills-border-color);
}
.nav-pills .nav-link.active {
  border-color: var(--bs-nav-pills-link-active-bg);
  color: var(--bs-nav-pills-link-active-color);
}
.nav-pills .nav-link.active svg {
  color: var(--bs-nav-pills-active-icon-color);
}
.nav-pills .nav-link:not(.disabled):hover {
  background-color: var(--bs-nav-pills-hover-bg-color);
  border-color: var(--bs-nav-pills-hover-border-color);
  color: var(--bs-nav-pills-hover-color);
}
.nav-pills .nav-link:not(.disabled):hover svg {
  color: var(--bs-nav-pills-hover-color);
}
.nav-pills .nav-link:not(.disabled):focus-visible {
  border-color: #304ffe;
}

.nav-boxed {
  --bs-nav-boxed-bg-color: #fafafa;
  --bs-nav-boxed-link-bg-color: #fafafa;
  --bs-nav-boxed-link-focus-border-color: #304ffe;
  --bs-nav-boxed-link-focus-color: #f2f2f2;
  --bs-nav-boxed-link-hover-border-color: #111111;
  --bs-nav-boxed-link-hover-bg-color: #f2f2f2;
  --bs-nav-boxed-link-active-bg: #f7f7f7;
  --bs-nav-boxed-link-active-border-color: #a1a1a1;
  background: var(--bs-nav-boxed-bg-color) !important;
}
.nav-boxed .nav-link {
  background-color: var(--bs-nav-boxed-link-bg-color);
  border: 1px solid var(--bs-nav-boxed-link-bg-color);
  border-bottom-color: transparent;
}
.nav-boxed .nav-link.active {
  background-color: var(--bs-nav-boxed-link-active-bg);
  border-color: var(--bs-nav-boxed-link-active-bg);
  border-bottom-color: var(--bs-nav-boxed-link-active-border-color);
}
.nav-boxed .nav-link:not(.disabled):hover {
  background-color: var(--bs-nav-boxed-link-hover-bg-color);
  border-color: var(--bs-nav-boxed-link-hover-bg-color);
  border-bottom-color: var(--bs-nav-boxed-link-hover-border-color);
}
.nav-boxed .nav-link:not(.disabled):focus-visible {
  border-color: var(--bs-nav-boxed-link-focus-border-color) !important;
  color: var(--bs-nav-link-focus-color);
}
.nav-boxed.flex-column .nav-link {
  border-bottom-color: transparent;
}
.nav-boxed.flex-column .nav-link.active {
  border-left-color: var(--bs-nav-boxed-link-active-border-color);
}
.nav-boxed.flex-column .nav-link:not(.disabled):hover {
  border-bottom-color: transparent;
  border-left-color: var(--bs-nav-boxed-link-hover-border-color);
}

.nav-bordered {
  --bs-nav-tabs-link-active-border-color: #a1a1a1;
  --bs-nav-tabs-link-bg-color: #fff;
  --bs-nav-tabs-link-border-color: #dedede;
  --bs-nav-tabs-link-focus-border-color: #304ffe;
  --bs-nav-tabs-link-hover-border-color: #111111;
}
.nav-bordered .nav-item:first-child .nav-link {
  border-left-color: var(--bs-nav-tabs-link-border-color);
}
.nav-bordered .nav-link {
  background-color: var(--bs-nav-tabs-link-bg-color);
  border: 1px solid var(--bs-nav-tabs-link-border-color);
  border-left-color: var(--bs-nav-tabs-link-bg-color);
}
.nav-bordered .nav-link.active {
  border-bottom-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-bordered .nav-link:not(.disabled):hover {
  border-bottom-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-bordered .nav-link:not(.disabled):focus-visible {
  border-color: var(--bs-nav-tabs-link-focus-border-color) !important;
  color: var(--bs-nav-link-color);
}
.nav-bordered.flex-column .nav-item:first-child .nav-link {
  border-top: 1px solid var(--bs-nav-tabs-link-border-color);
}
.nav-bordered.flex-column .nav-link {
  border-left-color: var(--bs-nav-tabs-link-border-color);
  border-top-color: transparent;
  border-right-color: transparent;
}
.nav-bordered.flex-column .nav-link.active {
  border-left-color: var(--bs-nav-tabs-link-active-border-color);
  border-bottom-color: var(--bs-nav-tabs-link-border-color);
}
.nav-bordered.flex-column .nav-link:hover {
  border-left-color: var(--bs-nav-tabs-link-hover-border-color);
  border-bottom-color: var(--bs-nav-tabs-link-border-color);
}

.nav-bordered + .tab-content-vertical {
  border-left-color: #dedede;
}

.nav-elevated {
  --bs-nav-elevated-box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);
  --bs-nav-elevated-nav-link-active-box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);
  --bs-nav-elevated-link-bg-color: #fff;
  flex-shrink: 0;
  overflow: hidden;
  box-shadow: var(--bs-nav-elevated-box-shadow);
}
.nav-elevated:not(.nav-justified):not(.flex-column) {
  display: inline-flex;
}
.nav-elevated .nav-link {
  background-color: var(--bs-nav-elevated-link-bg-color);
  border: 1px solid var(--bs-nav-elevated-link-bg-color);
}
.nav-elevated .nav-link:not(.disabled):focus-visible {
  border-color: #304ffe;
  color: var(--bs-nav-link-color);
}
.nav-elevated .nav-link.active {
  box-shadow: var(--bs-nav-elevated-nav-link-active-box-shadow);
  position: relative;
  z-index: 1;
}
.nav-elevated + .tab-content {
  --bs-nav-elevated-tab-content-box-shadow: 0 0 1rem rgba(35, 35, 35, 0.2);
  --bs-nav-tabs-bg-color: #fff;
  background: var(--bs-nav-tabs-bg-color);
  box-shadow: var(--bs-nav-elevated-tab-content-box-shadow);
  position: relative;
}
.nav-elevated + .tab-content-vertical {
  box-shadow: 0 1.25rem 1.875rem 0 rgba(35, 35, 35, 0.08);
  border: 0;
}
.nav-elevated.flex-column {
  --bs-nav-elevated-nav-link-active-box-shadow: 0 0.5rem 1.25rem 0 rgba(35, 35, 35, 0.2);
  box-shadow: none;
}

.dark .nav-link {
  --bs-nav-tabs-link-active-color: rgba(255, 255, 255, 0.84);
  --bs-nav-link-hover-color: #fff;
  --bs-nav-link-color: rgba(255, 255, 255, 0.64);
  --bs-nav-link-disabled-color: rgba(255, 255, 255, 0.4);
}
.dark .nav-link svg {
  color: #fff;
}
.dark .tab-content-vertical {
  border-left-color: #343434;
  background: #232323;
}
.dark .nav-tabs-column {
  background: #232323;
}
.dark .nav-tabs {
  --bs-nav-tabs-active-color: rgba(17, 17, 17, 0.84);
  --bs-nav-tabs-bg-color: #232323;
  --bs-nav-tabs-border-color: #575757;
  --bs-nav-tabs-link-hover-border-color: #cccccc #cccccc transparent;
  --bs-nav-tabs-link-active-bg: #232323;
  --bs-nav-tabs-link-active-border-color: #575757 #575757 transparent;
}
.dark .nav-tabs.flex-column {
  --bs-nav-tabs-link-hover-border-color: #cccccc transparent #cccccc #cccccc;
  --bs-nav-tabs-link-active-border-color: #575757 transparent #575757 #575757;
}
.dark .nav-tabs + .tab-content {
  --bs-nav-tabs-border-color: #575757;
}
.dark .nav-tabs + .tab-content-vertical {
  border-color: #575757;
}
.dark .nav-standard {
  --bs-nav-standard-link-bg-color: #232323;
  --bs-nav-standard-border-color: #343434;
  --bs-nav-standard-link-active-border-color: #808080;
  --bs-nav-standard-link-hover-border-color: #cccccc;
}
.dark .nav-pills {
  --bs-nav-pills-link-active-bg: #434343;
  --bs-nav-pills-link-active-color: rgba(255, 255, 255, 0.92);
  --bs-nav-pills-bg-link-color: #232323;
  --bs-nav-pills-border-color: #232323;
  --bs-nav-pills-hover-bg-color: #fff;
  --bs-nav-pills-hover-border-color: #fff;
  --bs-nav-pills-hover-color: #111111;
  --bs-nav-pills-hover-focus-color: #111111;
}
.dark .nav-boxed {
  --bs-nav-boxed-bg-color: #1e1e1e;
  --bs-nav-boxed-link-bg-color: #1e1e1e;
  --bs-nav-boxed-link-focus-color: rgba(255, 255, 255, 0.64);
  --bs-nav-boxed-link-hover-border-color: #cccccc;
  --bs-nav-boxed-link-hover-bg-color: #343434;
  --bs-nav-boxed-link-active-bg: #232323;
  --bs-nav-boxed-link-active-border-color: #808080;
}
.dark .nav-boxed + .tab-content-vertical {
  border-left-color: #1e1e1e;
}
.dark .nav-bordered {
  --bs-nav-tabs-link-active-border-color: #808080;
  --bs-nav-tabs-link-bg-color: #232323;
  --bs-nav-tabs-link-border-color: #343434;
  --bs-nav-tabs-link-hover-border-color: #cccccc;
}
.dark .nav-elevated {
  --bs-nav-elevated-box-shadow: 0 0.75rem 1rem rgba(17, 17, 17, 0.5);
  --bs-nav-elevated-nav-link-active-box-shadow: 0 0.75rem 1rem rgba(9, 9, 9, 0.64);
  --bs-nav-elevated-link-bg-color: #232323;
}
.dark .nav-elevated + .tab-content {
  --bs-nav-elevated-tab-content-box-shadow: 0 0 1rem rgba(9, 9, 9, 0.64);
  --bs-nav-tabs-bg-color: #232323;
}
.dark .nav-elevated.flex-column {
  --bs-nav-elevated-nav-link-active-box-shadow: 0 0.5rem 1.25rem rgba(9, 9, 9, 0.64);
  background: #111111;
}
.dark .nav-elevated + .tab-content-vertical {
  box-shadow: 0 0.75rem 1rem rgba(17, 17, 17, 0.5);
}

.offcanvas-sidebar {
  z-index: 1029;
}

.offcanvas-backdrop-sidebar {
  z-index: 1028;
}

.nav-sidebar-header {
  text-transform: uppercase;
  letter-spacing: 0.05625rem;
  font-size: 0.75rem;
  padding: 0.5rem 1.875rem;
  margin-bottom: 0.125rem;
}

.nav-sidebar {
  width: 20rem;
  background-color: #fff;
  overflow-y: auto;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
.dark .nav-sidebar {
  background-color: #111111;
}
.nav-sidebar .list-unstyled > li {
  margin-top: 1rem;
}
.nav-sidebar .nav {
  --bs-nav-link-hover-bg-color: #111111;
  --bs-nav-link-hover-color: #fff;
}
.nav-sidebar .nav.flex-column .nav-link {
  padding: 0.5rem 1.875rem;
  position: relative;
  border: 1px solid transparent;
}
.nav-sidebar .nav.flex-column .nav-link.active {
  background-color: #f2f2f2;
}
.dark .nav-sidebar .nav.flex-column .nav-link.active {
  background-color: #232323;
}
.nav-sidebar .nav.flex-column .nav-link:not(.disabled):hover {
  background: var(--bs-nav-link-hover-bg-color) !important;
  color: var(--bs-nav-link-hover-color);
}
.nav-sidebar .nav.flex-column .nav-link:not(.disabled):hover .nav-link-icon {
  color: var(--bs-nav-link-hover-color);
}
.nav-sidebar .nav.flex-column .nav-link:focus {
  color: var(--bs-nav-link-color);
}
.nav-sidebar .nav.flex-column .nav-link:focus-visible {
  border-color: #304ffe !important;
  box-shadow: none;
  outline: 0;
}
.nav-sidebar .nav.flex-column .nav-link .avatar:first-child {
  margin-right: 0.75rem;
}
.nav-sidebar .nav.flex-column .flex-column .nav-link {
  padding-left: 3.125rem;
}
.nav-sidebar .nav.flex-column .flex-column .flex-column .nav-link {
  padding-left: 4.375rem;
}
.nav-sidebar .nav.flex-column .nav-item-icon .flex-column .nav-link {
  padding-left: 5rem;
}
.nav-sidebar .nav.flex-column .nav-item-icon .flex-column .flex-column .nav-link {
  padding-left: 6.875rem;
}

.nav-link-accordion {
  display: flex;
  align-items: center;
}
.nav-link-accordion::before {
  content: "";
  position: absolute;
  background-color: transparent;
  width: 0;
  height: 85%;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: background-color 300ms, width 300ms;
}
.nav-link-accordion.active {
  background-color: transparent !important;
}
.nav-link-accordion.active::before {
  background-color: #111111;
  width: 2px;
}
.dark .nav-link-accordion.active::before {
  background-color: #fff;
}
.nav-link-accordion + div .nav-link-accordion::before {
  content: none;
}

.user-profile {
  display: flex;
  align-items: center;
  padding: 1.5rem 1.875rem;
}

.user-name {
  font-size: 0.9375rem;
  line-height: 1.3333333333;
  opacity: 0.84;
}

.user-contact {
  font-size: 0.875rem;
  line-height: 1.4285714286;
  opacity: 0.64;
}

.nav-sidebar .nav-pills {
  --bs-nav-pills-border-radius: 0.3125rem;
  --bs-nav-pills-link-active-color: #111111;
}
.nav-sidebar .nav-pills .nav-link {
  background: transparent;
}
.nav-sidebar .nav-pills .nav-link-accordion::before {
  content: none;
}
.nav-sidebar .nav-pills .nav-item + .nav-item,
.nav-sidebar .nav-pills .nav-link-accordion + div {
  margin-top: 0.125rem;
}
.nav-sidebar .nav-pills.nav.flex-column .nav-link {
  padding: 0.3125rem 0.9375rem;
}
.nav-sidebar .nav-pills.nav.flex-column .flex-column .nav-link {
  padding-left: 2.25rem;
}
.nav-sidebar .nav-pills.nav.flex-column .flex-column .flex-column .nav-link {
  padding-left: 3.5rem;
}
.nav-sidebar .nav-pills.nav.flex-column .nav-item-icon .flex-column .nav-link {
  padding-left: 4rem;
}
.nav-sidebar .nav-pills.nav.flex-column .nav-item-icon .flex-column .flex-column .nav-link {
  padding-left: 6rem;
}

.nav-sidebar-sm .nav.flex-column .nav-link {
  font-size: 0.8125rem;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
}
.nav-sidebar-sm .nav.flex-column .nav-link .avatar:first-child {
  margin-right: 0.625rem;
}
.nav-sidebar-sm .nav-pills.nav.flex-column .nav-link {
  padding-top: 0.1875rem;
  padding-bottom: 0.1875rem;
}
.nav-sidebar-sm .user-profile {
  padding: 1.25rem 1.875rem;
}
.nav-sidebar-sm .user-name {
  font-size: 0.875rem;
}
.nav-sidebar-sm .user-contact {
  display: none;
}

.nav-sidebar-lg .nav.flex-column .nav-link {
  font-size: 0.9375rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.nav-sidebar-lg .nav-pills.nav.flex-column .nav-link {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.nav-sidebar-lg .user-profile {
  padding: 1.875rem;
}
.nav-sidebar-lg .user-name {
  font-size: 1rem;
}
.nav-sidebar-lg .user-contact {
  font-size: 0.9375rem;
}

.dark .nav-sidebar .nav-link {
  --bs-nav-link-hover-bg-color: #fff;
  --bs-nav-link-hover-color: #111111;
}
.dark .nav-sidebar .nav-pills {
  --bs-nav-pills-link-active-color: #fff;
}

.navbar {
  background-color: #fff;
  font-size: 0.875rem;
}
.navbar > [class*=container-fluid] {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.navbar .nav-link > span,
.navbar .dropdown-item > span {
  position: relative;
}
.navbar .nav-link > span::after,
.navbar .dropdown-item > span::after {
  content: "";
  position: absolute;
  bottom: -0.3125rem;
  height: 0.0625rem;
  background-color: transparent;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  transition: background-color 0.15s ease-in-out;
}
.navbar .nav-link.active > span::after,
.navbar .nav-item.show > .nav-link > span::after,
.navbar .dropdown-item.active > span::after {
  background-color: #a1a1a1;
}
.dark .navbar .nav-link.active > span::after,
.dark .navbar .nav-item.show > .nav-link > span::after,
.dark .navbar .dropdown-item.active > span::after {
  background-color: #808080;
}
.navbar .nav-link:focus-visible,
.navbar .dropdown-item:focus-visible {
  outline: none;
}
.navbar .nav-link:focus-visible > span::after,
.navbar .dropdown-item:focus-visible > span::after {
  background-color: #304ffe;
}
.navbar .nav-link:hover > span::after,
.navbar .dropdown-item:hover > span::after {
  background-color: #111111;
}
.dark .navbar .nav-link:hover > span::after,
.dark .navbar .dropdown-item:hover > span::after {
  background-color: #cccccc;
}
.navbar .dropdown-item {
  background-color: transparent;
}
.navbar .dropdown-item > span::after {
  bottom: 2px;
}
.navbar .dropdown-menu-lg .dropdown-item > span::after {
  bottom: 6px;
}
.navbar .dropdown-menu {
  border: 1px solid #ededed;
}
.dark .navbar .dropdown-menu {
  border-color: #404040;
}
.navbar .dropdown-btn-item svg {
  opacity: 0.64;
}
.navbar .dropdown-btn-item > div {
  opacity: 0.84;
}
.navbar .dropdown-btn-item:hover {
  background: #fafafa;
}
.navbar .dropdown-btn-item:hover svg,
.navbar .dropdown-btn-item:hover > div {
  opacity: 1;
}

.btn-navbar-nine-dot {
  --btn-navbar-nine-dot-hover-bg: #fafafa;
  --btn-navbar-nine-dot-hover-border-color: #111111;
  --btn-navbar-nine-dot-hover-color: #111111;
  --btn-navbar-nine-dot-active-bg: #fafafa;
  --btn-navbar-nine-dot-active-border-color: #a1a1a1;
  background: transparent;
  border: 0;
  border-bottom: 1px solid transparent !important;
}
.btn-navbar-nine-dot + .dropdown-menu {
  width: 320px;
}
@media (min-width: 430px) {
  .btn-navbar-nine-dot + .dropdown-menu {
    width: 405px;
  }
}
.btn-navbar-nine-dot svg {
  color: inherit;
}
.btn-navbar-nine-dot:hover {
  background: var(--btn-navbar-nine-dot-hover-bg);
  border-bottom: 1px solid var(--btn-navbar-nine-dot-hover-border-color) !important;
  color: var(--btn-navbar-nine-dot-hover-color);
}
.btn-navbar-nine-dot:focus-visible {
  border-bottom-color: #304ffe !important;
}
.dropdown.show > .btn-navbar-nine-dot {
  background: var(--btn-navbar-nine-dot-active-bg);
  border-bottom: 1px solid var(--btn-navbar-nine-dot-active-border-color) !important;
  color: var(--btn-navbar-nine-dot-hover-color);
}
.dropdown.show > .btn-navbar-nine-dot svg {
  opacity: 0.9;
}
.dropdown:has(.btn-navbar-nine-dot) {
  margin-left: -1.25rem;
  margin-right: 1.25rem;
}

.navbar-border {
  border-bottom: 1px solid #dedede;
}
.dark .navbar-border {
  border-color: #404040;
}

.navbar-elevation {
  box-shadow: 0 0.5625rem 0.875rem rgba(35, 35, 35, 0.14);
  z-index: 2;
}
.dark .navbar-elevation {
  box-shadow: 0 0.5625rem 0.875rem #000;
}

.navbar-nav.nav-pills {
  --bs-nav-pills-link-active-color: #111111;
  --bs-nav-pills-link-active-bg: #f2f2f2;
}
.dark .navbar-nav.nav-pills {
  --bs-nav-pills-link-active-color: #fff;
}
.navbar-nav.nav-pills .nav-link {
  padding: 0.375rem 0.75rem;
  border-color: transparent;
}
.dark .navbar-nav.nav-pills .nav-link {
  background-color: transparent;
}
.dark .navbar-nav.nav-pills .nav-link.active {
  background-color: #232323;
}
.dark .navbar-nav.nav-pills .nav-link:hover {
  background-color: #fff;
}
.navbar-nav.nav-pills .nav-item + .nav-item {
  margin-left: 0.125rem;
}

.navbar-notification {
  background-color: #111111;
  color: #fff;
  border-radius: var(--bs-border-radius-pill);
  font-size: 0.5625rem;
  line-height: 1.1111111111;
  padding: 0.25rem 0.4375rem;
  text-align: center;
}
.navbar-notification.position-absolute {
  border: 2px solid #fff;
}

.dropdown-mega-menu .nav-col-title {
  font-size: 0.8125rem;
  line-height: 1.4615384615;
  color: rgba(17, 17, 17, 0.92);
}
.dropdown-mega-menu .nav-link {
  padding-left: 0 !important;
  line-height: 1.4285714286;
}

.dark .navbar {
  --bs-navbar-color: rgba(255, 255, 255, 0.64);
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-active-color: rgba(255, 255, 255, 0.92);
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-color: #111111;
}
.dark .navbar .dropdown-btn-item {
  background: #232323;
}
.dark .navbar .dropdown-btn-item:hover {
  background: #343434;
}
.dark .btn-navbar-nine-dot {
  --btn-navbar-nine-dot-hover-bg: #232323;
  --btn-navbar-nine-dot-hover-border-color: #cccccc;
  --btn-navbar-nine-dot-hover-color: #fff;
  --btn-navbar-nine-dot-active-bg: #232323;
  --btn-navbar-nine-dot-active-border-color: #808080;
}
.dark .navbar-notification {
  background-color: #ededed;
  color: #111111;
}
.dark .navbar-notification.position-absolute {
  border-color: #232323;
}
.dark .dropdown-mega-menu .nav-col-title {
  color: #fff;
}

.navbar-brand img {
  max-height: 62px;
}

.navbar-sm {
  --bs-navbar-nav-link-padding-x: 0.46875rem;
  font-size: 0.8125rem;
}
.navbar-sm .nav-link {
  --bs-nav-link-font-size: 0.8125rem;
}
.navbar-sm .navbar-brand img {
  max-height: 54px;
}
.navbar-sm .navbar-notification {
  padding: 0.125rem 0.3125rem;
}

.navbar-lg {
  --bs-navbar-padding-y: 0.6875rem;
  --bs-navbar-nav-link-padding-x: 0.78125rem;
  font-size: 0.9375rem;
}
.navbar-lg .nav-link {
  --bs-nav-link-font-size: 0.9375rem;
}
.navbar-lg .navbar-brand img {
  max-height: 66px;
}

.navbar-expand-xs .dropdown-menu {
  left: var(--bs-navbar-nav-link-padding-x);
  border: none;
  box-shadow: none;
}

@media (min-width: 576px) {
  .navbar-expand-sm .dropdown-menu {
    left: var(--bs-navbar-nav-link-padding-x);
  }
}
@media (max-width: 575.98px) {
  .navbar-expand-sm .dropdown-menu {
    border: none;
    box-shadow: none;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .dropdown-menu {
    left: var(--bs-navbar-nav-link-padding-x);
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md .dropdown-menu {
    border: none;
    box-shadow: none;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .dropdown-menu {
    left: var(--bs-navbar-nav-link-padding-x);
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg .dropdown-menu {
    border: none;
    box-shadow: none;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .dropdown-menu {
    left: var(--bs-navbar-nav-link-padding-x);
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl .dropdown-menu {
    border: none;
    box-shadow: none;
  }
}

@media (min-width: 1400px) {
  .navbar-expand-xxl .dropdown-menu {
    left: var(--bs-navbar-nav-link-padding-x);
  }
}
@media (max-width: 1399.98px) {
  .navbar-expand-xxl .dropdown-menu {
    border: none;
    box-shadow: none;
  }
}

.navbar-secondary {
  padding: 0 0.625rem;
  --bs-navbar-nav-link-padding-x: 0.625rem;
}
.navbar-secondary .navbar-nav {
  --bs-nav-link-padding-y: 0.625rem;
}
.navbar-secondary.navbar-sm .navbar-nav {
  --bs-nav-link-padding-y: 0.4375rem;
}
.navbar-secondary.navbar-elevation {
  z-index: 1;
}
.navbar-secondary + .navbar-tabs {
  padding: 0 0.3125rem;
}

.navbar-tabs {
  --bs-navbar-nav-link-padding-x: 0.9375rem;
  padding: 0;
}
.navbar-tabs .nav-item {
  position: relative;
}
.navbar-tabs .nav-item .nav-link > span {
  position: unset;
}
.navbar-tabs .nav-item .nav-link > span::after {
  bottom: 0;
}

.progress {
  --bs-progress-bg: var(--progress-bg);
  --bs-progress-bar-bg: var(--progress-bar-bg);
}

.progress-dark {
  --bs-progress-bg: var(--progress-dark-bg);
  --bs-progress-bar-bg: var(--progress-dark-bar-bg);
}

.progress-brand {
  --bs-progress-bg: var(--progress-brand-bg);
  --bs-progress-bar-bg: var(--progress-brand-bar-bg);
}

:root,
[data-bs-theme=light],
.light {
  --progress-bg: #ededed;
  --progress-bar-bg: #767676;
  --progress-dark-bg: #b6b6b6;
  --progress-dark-bar-bg: #000000;
  --progress-brand-bg: #ededed;
  --progress-brand-bar-bg: #007f00;
}

[data-bs-theme=dark],
.dark {
  --progress-bg: #4b4b4b;
  --progress-bar-bg: #878787;
  --progress-dark-bg: #666666;
  --progress-dark-bar-bg: #fcfcfc;
  --progress-brand-bg: #404040;
  --progress-brand-bar-bg: #ccff00;
}

.offcanvas {
  --bs-offcanvas-close-margin-x: 0.625rem;
  --bs-offcanvas-close-margin-calc: calc(
    -1 * var(--bs-offcanvas-padding-x) + var(--bs-offcanvas-close-margin-x)
  );
}
.offcanvas .btn-close-inline {
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}

.offcanvas-shadow {
  border: 0 !important;
}
.offcanvas-shadow.offcanvas-start {
  box-shadow: 5px 0 20px 0 rgba(35, 35, 35, 0.14);
}
.offcanvas-shadow.offcanvas-end {
  box-shadow: -5px 0 20px 0 rgba(35, 35, 35, 0.14);
}
.offcanvas-shadow.offcanvas-top {
  box-shadow: 0 10px 20px 0 rgba(35, 35, 35, 0.08);
}
.offcanvas-shadow.offcanvas-bottom {
  box-shadow: 0 -10px 20px 0 rgba(35, 35, 35, 0.08);
}

.offcanvas-header {
  border-bottom: 1px solid var(--bs-offcanvas-border-color);
}
.offcanvas-header .btn-close-inline {
  margin-right: var(--bs-offcanvas-close-margin-calc);
}
.offcanvas-header.flex-row-reverse .btn-close-inline {
  margin-left: var(--bs-offcanvas-close-margin-calc);
}

.offcanvas-header-shadow {
  box-shadow: 0 10px 20px 0 rgba(35, 35, 35, 0.08);
}

.offcanvas-title {
  font-size: 1rem;
}

.btn-panel-xs {
  --bs-btn-active-border-color: transparent;
  --bs-btn-padding-x: 0.625rem;
  --bs-btn-padding-y: 0.875rem;
}
.btn-panel-xs .btn-label {
  font-size: 0.75rem;
  line-height: 1.75;
  color: rgba(17, 17, 17, 0.64);
}
.btn-panel-xs:focus-visible {
  border-color: #304ffe !important;
}
.btn-panel-xs.active svg, .btn-panel-xs:focus-visible svg {
  opacity: 1 !important;
}
.btn-panel-xs.active .btn-label {
  color: #000000;
}
.btn-panel-xs:focus-visible .btn-label {
  color: #111111;
}
.btn-panel-xs:hover svg {
  opacity: 0.7 !important;
}
.btn-panel-xs:hover .btn-label {
  color: rgba(17, 17, 17, 0.84);
}
.btn-panel-xs.disabled, .btn-panel-xs:disabled {
  border-color: transparent;
  opacity: 1;
}
.btn-panel-xs.disabled svg, .btn-panel-xs:disabled svg {
  opacity: 0.4 !important;
}
.btn-panel-xs.disabled .btn-label, .btn-panel-xs:disabled .btn-label {
  color: rgba(17, 17, 17, 0.5);
}

.offcanvas-end .btn-panel-xs:not(:disabled):hover {
  border-left-color: rgba(0, 0, 0, 0.52);
}
.offcanvas-end .btn-panel-xs.active {
  border-left-color: #000000;
}

.offcanvas-start .btn-panel-xs:not(:disabled):hover {
  border-right-color: rgba(0, 0, 0, 0.52);
}
.offcanvas-start .btn-panel-xs.active {
  border-right-color: #000000;
}

.offcanvas-panel-xs {
  --bs-offcanvas-width: 80px;
  --bs-offcanvas-padding-y: 0;
  --bs-offcanvas-padding-x: 0;
}

.offcanvas-panel-sm {
  --bs-offcanvas-width: 256px;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-padding-x: 0.9375rem;
}
.offcanvas-panel-sm .offcanvas-title {
  font-size: 0.8125rem;
  line-height: 1.6923076923;
}

.offcanvas-panel-lg {
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-padding-y: 1.25rem;
  --bs-offcanvas-padding-x: 1.25rem;
}
.offcanvas-panel-lg .offcanvas-title {
  font-size: 1.125rem;
  line-height: 1.7777777778;
}

.offcanvas-panel-xl {
  --bs-offcanvas-width: 528px;
  --bs-offcanvas-padding-y: 1.5625rem;
  --bs-offcanvas-padding-x: 1.5625rem;
  --bs-offcanvas-close-margin-x: 0.9375rem;
}
.offcanvas-panel-xl .offcanvas-title {
  font-size: 1.25rem;
  line-height: 1.5;
}

.offcanvas-tray {
  --bs-offcanvas-height: 72px;
}

.dark .offcanvas {
  --bs-offcanvas-border-color: #404040;
  --bs-offcanvas-bg: #111111;
}
.dark .offcanvas-shadow.offcanvas-start {
  box-shadow: 15px 0 16px 0 #000000;
}
.dark .offcanvas-shadow.offcanvas-end {
  box-shadow: -15px 0 -16px 0 #000000;
}
.dark .offcanvas-shadow.offcanvas-top {
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.5);
}
.dark .offcanvas-shadow.offcanvas-bottom {
  box-shadow: 0 -10px 20px 0 rgba(0, 0, 0, 0.5);
}
.dark .offcanvas-backdrop {
  background-color: #111111;
}
.dark .btn-panel-xs svg {
  color: #fff;
  opacity: 0.64;
}
.dark .btn-panel-xs .btn-label {
  color: rgba(255, 255, 255, 0.84);
}
.dark .btn-panel-xs.active .btn-label {
  color: #fff;
}
.dark .btn-panel-xs:focus-visible .btn-label {
  color: rgba(255, 255, 255, 0.92);
}
.dark .btn-panel-xs.disabled .btn-label, .dark .btn-panel-xs:disabled .btn-label {
  color: rgba(255, 255, 255, 0.4);
}
.dark .offcanvas-end .btn-panel-xs:not(:disabled):hover {
  border-left-color: rgba(255, 255, 255, 0.64);
}
.dark .offcanvas-end .btn-panel-xs.btn.active {
  border-left-color: #fff;
}
.dark .offcanvas-start .btn-panel-xs:not(:disabled):hover {
  border-right-color: rgba(255, 255, 255, 0.64);
}
.dark .offcanvas-start .btn-panel-xs.btn.active {
  border-right-color: #fff;
}

.range-slider {
  --range-slider-bg: #ededed;
  --range-slider-connect-bg: #767676;
  --range-slider-handle-bg: #fff;
  --range-slider-disabled-bg: #ededed;
  --range-slider-disabled-connect-bg: #cccccc;
  --range-slider-disabled-handle-bg: #dedede;
  --range-slider-marker-bg: #b6b6b6;
  --range-slider-marker-end-bg: #a1a1a1;
  --range-slider-value-color: rgba(17, 17, 17, 0.7);
  --range-slider-tooltip-bg: #fff;
  --range-slider-tooltip-color: #111111;
  display: flex;
  align-items: center;
  --range-slider-handle-size: \$handleSize;
  height: 21px;
  margin-left: 5.5px;
  margin-right: 5.5px;
}
.range-slider .range-slider-track {
  height: 5px;
}
.range-slider .range-slider-track:not(:first-of-type) {
  margin-left: 10.5px;
  margin-right: 10.5px;
}
.range-slider .range-slider-track:first-of-type {
  margin-left: 10.5px;
}
.range-slider .range-slider-track-connect {
  margin-right: 10.5px;
}
.range-slider .range-slider-handle {
  width: 21px;
  height: 21px;
}
.range-slider .range-slider-marker {
  height: 5px;
  margin-left: 10.5px;
}

.range-slider.disabled .range-slider-track {
  background: var(--range-slider-disabled-bg);
}
.range-slider.disabled .range-slider-track-connect {
  background: var(--range-slider-disabled-connect-bg);
}
.range-slider.disabled .range-slider-handle {
  background: var(--range-slider-disabled-handle-bg);
  box-shadow: none;
}
.range-slider.disabled .range-slider-handle:hover {
  transform: none;
}

.range-slider-xs {
  --range-slider-handle-size: \$handleSize;
  height: 13px;
  margin-left: 9.5px;
  margin-right: 9.5px;
}
.range-slider-xs .range-slider-track {
  height: 1px;
}
.range-slider-xs .range-slider-track:not(:first-of-type) {
  margin-left: 6.5px;
  margin-right: 6.5px;
}
.range-slider-xs .range-slider-track:first-of-type {
  margin-left: 6.5px;
}
.range-slider-xs .range-slider-track-connect {
  margin-right: 6.5px;
}
.range-slider-xs .range-slider-handle {
  width: 13px;
  height: 13px;
}
.range-slider-xs .range-slider-marker {
  height: 1px;
  margin-left: 6.5px;
}

.range-slider-sm {
  --range-slider-handle-size: \$handleSize;
  height: 15px;
  margin-left: 8.5px;
  margin-right: 8.5px;
}
.range-slider-sm .range-slider-track {
  height: 3px;
}
.range-slider-sm .range-slider-track:not(:first-of-type) {
  margin-left: 7.5px;
  margin-right: 7.5px;
}
.range-slider-sm .range-slider-track:first-of-type {
  margin-left: 7.5px;
}
.range-slider-sm .range-slider-track-connect {
  margin-right: 7.5px;
}
.range-slider-sm .range-slider-handle {
  width: 15px;
  height: 15px;
}
.range-slider-sm .range-slider-marker {
  height: 3px;
  margin-left: 7.5px;
}

.range-slider-lg {
  --range-slider-handle-size: \$handleSize;
  height: 24px;
  margin-left: 4px;
  margin-right: 4px;
}
.range-slider-lg .range-slider-track {
  height: 8px;
}
.range-slider-lg .range-slider-track:not(:first-of-type) {
  margin-left: 12px;
  margin-right: 12px;
}
.range-slider-lg .range-slider-track:first-of-type {
  margin-left: 12px;
}
.range-slider-lg .range-slider-track-connect {
  margin-right: 12px;
}
.range-slider-lg .range-slider-handle {
  width: 24px;
  height: 24px;
}
.range-slider-lg .range-slider-marker {
  height: 8px;
  margin-left: 12px;
}

.range-slider-xl {
  --range-slider-handle-size: \$handleSize;
  height: 32px;
  margin-left: 0px;
  margin-right: 0px;
}
.range-slider-xl .range-slider-track {
  height: 12px;
}
.range-slider-xl .range-slider-track:not(:first-of-type) {
  margin-left: 16px;
  margin-right: 16px;
}
.range-slider-xl .range-slider-track:first-of-type {
  margin-left: 16px;
}
.range-slider-xl .range-slider-track-connect {
  margin-right: 16px;
}
.range-slider-xl .range-slider-handle {
  width: 32px;
  height: 32px;
}
.range-slider-xl .range-slider-marker {
  height: 12px;
  margin-left: 16px;
}

.range-slider-xs .range-slider-handle:hover, .range-slider-xs .range-slider-handle:active,
.range-slider-md .range-slider-handle:hover,
.range-slider-md .range-slider-handle:active {
  transform: scale(1.2);
}

.range-slider-handle {
  background: var(--range-slider-handle-bg);
  transition: transform 200ms, left 100ms;
  box-shadow: 0 0.25rem 0.625rem 0 rgba(35, 35, 35, 0.2);
  border: none;
  border-radius: 50%;
  cursor: grab;
}
.range-slider-handle:focus {
  outline: none;
}
.range-slider-handle:focus-visible {
  box-shadow: 0 0 6px 0 #304ffe;
  border: solid 1px #304ffe;
}
.range-slider-handle:active {
  cursor: grabbing;
  transition: none;
}
.range-slider-handle::before, .range-slider-handle::after {
  content: none;
}
.range-slider-handle:hover, .range-slider-handle:active {
  transform: scale(1.0625);
}

.range-slider-tooltip {
  position: absolute;
  border: none;
  border-radius: 3px;
  text-align: center;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 150%;
  opacity: 0;
  transition: opacity 200ms;
  background: var(--range-slider-tooltip-bg);
  color: var(--range-slider-tooltip-color);
  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);
  font-size: 0.75rem;
  padding: 0.375rem 1rem;
  letter-spacing: 0.3px;
}
.range-slider-handle:hover .range-slider-tooltip, .range-slider-handle:active .range-slider-tooltip, .range-slider-handle:focus-visible .range-slider-tooltip {
  opacity: 1;
}
.range-slider-tooltip::before {
  content: "";
  position: absolute;
  width: 0.875rem;
  height: 0.4375rem;
  border-color: transparent;
  border-style: solid;
  top: 100%;
  margin-top: -1px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 0.4375rem 0.4375rem 0;
  border-top-color: var(--range-slider-tooltip-bg);
}

.range-slider-light .range-slider-handle:focus-visible {
  border-color: rgba(48, 79, 254, 0.7);
}

.range-slider-tooltip-dark {
  --range-slider-tooltip-bg: #343434;
  --range-slider-tooltip-color: #fff;
}

.range-slider-track {
  background: var(--range-slider-bg);
  transition: left 100ms, right 100ms;
}

.range-slider-is-dragging {
  transition: none !important;
}

.range-slider-track-connect {
  background: var(--range-slider-connect-bg);
  z-index: 1;
}

.range-slider-track-rounded {
  border-radius: 50rem;
}

.range-slider-value {
  font-size: 0.8125rem;
  letter-spacing: 0.2px;
  color: var(--range-slider-value-color);
  opacity: 0.64;
}

.range-slider-marker {
  background: var(--range-slider-marker-bg);
  width: 1px;
}
.range-slider-marker:first-child {
  width: 100px !important;
}

.range-slider .range-slider-marker:first-of-type,
.range-slider .range-slider-marker:last-of-type {
  background: var(--range-slider-marker-end-bg);
}

.range-slider-dark {
  --range-slider-bg: #b6b6b6;
  --range-slider-connect-bg: #000;
  --range-slider-handle-bg: #343434;
  --range-slider-disabled-bg: #cccccc;
  --range-slider-disabled-connect-bg: #a1a1a1;
  --range-slider-disabled-handle-bg: #878787;
  --range-slider-marker-bg: #808080;
}
.range-slider-dark.range-slider-xs {
  --range-slider-marker-end-bg: #575757;
  --range-slider-marker-bg: #4b4b4b;
}

.range-slider-brand {
  --range-slider-handle-bg: #007f00;
  --range-slider-disabled-handle-bg: #666666;
}

.range-slider-brand-light {
  --range-slider-connect-bg: #007f00;
  --range-slider-handle-bg: #34b128;
  --range-slider-disabled-connect-bg: #666666;
  --range-slider-disabled-handle-bg: #cccccc;
}

.dark .range-slider {
  --range-slider-bg: #4b4b4b;
  --range-slider-connect-bg: #878787;
  --range-slider-handle-bg: #343434;
  --range-slider-disabled-bg: #404040;
  --range-slider-disabled-connect-bg: #4b4b4b;
  --range-slider-disabled-handle-bg: #4b4b4b;
  --range-slider-marker-bg: #666666;
  --range-slider-marker-end-bg: #666666;
  --range-slider-value-color: rgba(255, 255, 255, 0.7);
  --range-slider-tooltip-bg: #343434;
  --range-slider-tooltip-color: #fff;
}
.dark .range-slider-tooltip-dark {
  --range-slider-tooltip-bg: #fff;
  --range-slider-tooltip-color: #111111;
}
.dark .range-slider-dark {
  --range-slider-bg: #666666;
  --range-slider-connect-bg: #fcfcfc;
  --range-slider-disabled-bg: #4b4b4b;
  --range-slider-disabled-connect-bg: #575757;
  --range-slider-disabled-handle-bg: #767676;
  --range-slider-handle-bg: #ededed;
  --range-slider-marker-bg: #b6b6b6;
  --range-slider-marker-end-bg: #a1a1a1;
}
.dark .range-slider-dark.range-slider-xs {
  --range-slider-marker-bg: #b6b6b6;
}
.dark .range-slider-brand {
  --range-slider-bg: #404040;
  --range-slider-handle-bg: #ccff00;
  --range-slider-disabled-bg: #404040;
  --range-slider-disabled-handle-bg: #4b4b4b;
  --range-slider-marker-bg: #666666;
}
.dark .range-slider-brand-light {
  --range-slider-bg: #404040;
  --range-slider-connect-bg: #ccff00;
  --range-slider-handle-bg: #9fe300;
  --range-slider-disabled-connect-bg: #4b4b4b;
  --range-slider-disabled-handle-bg: #666666;
  --range-slider-marker-bg: #666666;
  --range-slider-disabled-bg: #4b4b4b;
}
.dark .range-slider-xs {
  --range-slider-marker-end-bg: #a1a1a1;
  --range-slider-marker-bg: #878787;
}
.dark .range-slider-light .range-slider-handle:focus-visible {
  border-color: #304ffe;
}

.form-label {
  line-height: 1.5;
}

.col-form-label {
  font-size: 0.875rem;
}

.label-optional::after {
  opacity: 0.64;
  content: "optional";
  font-size: 0.75rem;
  margin-left: 0.5rem;
  letter-spacing: 0.3px;
}

.label-info {
  text-decoration: none;
  margin-left: auto;
  margin-bottom: 0.75rem;
  font-size: 0.6875rem;
  line-height: 1.9090909091;
}

.form-text,
.invalid-feedback,
.valid-feedback {
  letter-spacing: 0.5px;
}

.dark .valid-feedback {
  color: #47ed9c;
}
.dark .invalid-feedback {
  color: #ff94aa;
}

.form-control {
  height: 2.5rem;
}
.form-control:not(:disabled):hover {
  border-color: #666666;
}
.form-control:focus {
  border-color: #304ffe;
  box-shadow: none !important;
}
.form-control:focus-visible {
  border-color: #304ffe !important;
  outline: 0;
}
.form-control:disabled::placeholder, .form-control[readonly]::placeholder {
  color: #c2c2c2;
}
.form-control::-ms-reveal {
  display: none;
}

.form-control,
.form-select {
  letter-spacing: 0.1px;
  line-height: 1.7142857143;
}

.form-control-lg {
  height: 2.875rem;
  line-height: 1.6;
}

.form-control-sm {
  height: 2.25rem;
  line-height: 1.8461538462;
}

textarea.form-control {
  height: auto;
  min-height: 2.5rem;
}

input + .input-length,
textarea + .input-length {
  font-size: 0.6875rem;
  letter-spacing: 0.5px;
  margin-top: 0.5rem;
  text-align: right;
}

.dark .form-control,
.dark .form-select {
  color: #fff;
  caret-color: #fff;
  border-color: #404040;
}
.dark .form-control:focus,
.dark .form-select:focus {
  border-color: #878787;
}
.dark .form-control::placeholder,
.dark .form-select::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.dark .form-control:disabled, .dark .form-control[readonly] {
  color: rgba(255, 255, 255, 0.5);
  background-color: #232323;
  border-color: #404040;
}
.dark .form-control:disabled::placeholder, .dark .form-control[readonly]::placeholder {
  color: rgba(255, 255, 255, 0.4);
}
.dark .input-group-text {
  color: rgba(255, 255, 255, 0.64);
  border-color: #404040;
  background-color: #232323;
}

.form-select:not([multiple]) {
  height: 2.5rem;
}
.form-select[multiple] {
  padding: 0;
}
.form-select[multiple] option {
  padding: 11px 0.9375rem;
}
.form-select:not(:disabled):hover {
  border-color: #666666;
}
.form-select:focus-visible {
  box-shadow: none !important;
  border-color: #304ffe !important;
  outline: 0;
}

.form-select-placeholder-hack:invalid {
  color: rgba(17, 17, 17, 0.64);
}

.form-select-lg:not([multiple]), .input-group-lg > .form-select:not([multiple]) {
  height: 2.875rem;
  background-size: 32px 32px;
  padding-right: 3.25rem;
}

.form-select-sm:not([multiple]), .input-group-sm > .form-select:not([multiple]) {
  height: 2.25rem;
}

.form-select-triangle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.form-select-up-down {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.dark .form-select:not([multiple]) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.dark .form-select:not([multiple]) option {
  background-color: #232323;
}
.dark .form-select-triangle {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) !important;
}
.dark .form-select-up-down {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) !important;
}
.dark .form-select-placeholder-hack:invalid {
  color: rgba(255, 255, 255, 0.6);
}

.form-check-input {
  cursor: pointer;
  margin-top: 1px;
}
.form-check-input:focus-visible {
  border-color: #304ffe !important;
  outline: none;
}
.form-check-input:not(:checked):focus {
  border: 1px solid #b6b6b6;
}
.form-check-input:not(:disabled):hover {
  border-color: #090909;
}
.form-check-input:not(:disabled):hover ~ .form-check-label {
  color: #111111;
}
.form-check-input:disabled {
  background-color: #ededed;
  border-color: transparent;
  pointer-events: all;
  cursor: not-allowed;
}
.form-check-input:disabled ~ .form-check-label {
  cursor: not-allowed;
}
.form-check-input[type=radio]:disabled:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.form-check-input[type=radio]:not(:disabled):checked:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

.form-check:not(.form-switch) .form-check-input {
  background-size: 110%;
}
.form-check:not(.form-switch) .form-check-input[type=checkbox]:not(:disabled):checked:hover {
  background-image: var(--form-check-input-checked-hover-bg-image);
}

.form-check-label {
  font-size: 0.875rem;
  letter-spacing: 0.05px;
  margin-bottom: 0;
}

.form-check-comfortable {
  margin-bottom: 1.1875rem;
}

.form-check {
  --form-check-input-checked-hover-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  min-height: 1.125rem;
  line-height: 1.125rem;
}
.form-check .form-check-input:focus-visible {
  box-shadow: none;
}
.form-check .form-check-input:disabled ~ .form-check-label {
  color: #111111;
}
.was-validated .form-check .form-check-input:valid, .form-check .form-check-input.is-valid {
  border-color: #15ad5c;
}
.was-validated .form-check .form-check-input:valid:focus, .form-check .form-check-input.is-valid:focus {
  box-shadow: none;
}
.was-validated .form-check .form-check-input:valid ~ .form-check-label, .form-check .form-check-input.is-valid ~ .form-check-label {
  color: rgba(17, 17, 17, 0.84);
}
.was-validated .form-check .form-check-input:valid:hover ~ .form-check-label, .form-check .form-check-input.is-valid:hover ~ .form-check-label {
  color: #111111;
}
.was-validated .form-check .form-check-input:valid:checked, .form-check .form-check-input.is-valid:checked {
  background-color: #fff;
  border-color: #15ad5c;
}
.was-validated .form-check .form-check-input:valid:checked[type=checkbox], .form-check .form-check-input.is-valid:checked[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.was-validated .form-check .form-check-input:valid:checked:hover, .form-check .form-check-input.is-valid:checked:hover {
  --form-check-input-checked-hover-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.was-validated .form-check .form-check-input:invalid, .form-check .form-check-input.is-invalid {
  border-color: #e64949;
}
.was-validated .form-check .form-check-input:invalid:focus, .form-check .form-check-input.is-invalid:focus {
  box-shadow: none;
}
.was-validated .form-check .form-check-input:invalid ~ .form-check-label, .form-check .form-check-input.is-invalid ~ .form-check-label {
  color: rgba(17, 17, 17, 0.84);
}
.was-validated .form-check .form-check-input:invalid:hover ~ .form-check-label, .form-check .form-check-input.is-invalid:hover ~ .form-check-label {
  color: #111111;
}
.was-validated .form-check .form-check-input:invalid:checked, .form-check .form-check-input.is-invalid:checked {
  background-color: #fff;
}
.was-validated .form-check .form-check-input:invalid:checked[type=checkbox], .form-check .form-check-input.is-invalid:checked[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.was-validated .form-check .form-check-input:invalid:checked:hover, .form-check .form-check-input.is-invalid:checked:hover {
  --form-check-input-checked-hover-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

.nested-checks {
  list-style: none;
  padding-left: 0;
}
.nested-checks ul {
  list-style: none;
  padding-left: 1.625rem;
}
.nested-checks li .form-check {
  margin-bottom: 1.3125rem;
}
.nested-checks > li > .form-check {
  margin-bottom: 1.3125rem;
}

.nested-checks-lg ul {
  padding-left: 2rem;
}
.nested-checks-lg li .form-check {
  margin-bottom: 1.25rem;
}
.nested-checks-lg > li > .form-check {
  margin-bottom: 1.5rem;
}

.form-check-reverse {
  text-align: left;
}
.form-check-reverse .form-check-label {
  width: 100%;
}

.form-switch .form-check-input {
  border-color: transparent;
  background-color: #dedede;
}
.form-switch .form-check-input:checked {
  background-color: #343434;
}
.form-switch .form-check-input:not(:disabled):checked:hover {
  background-color: #090909;
}
.form-switch .form-check-input:not(:checked):not(:disabled):hover {
  background-color: #878787;
  border-color: #878787;
}
.form-switch .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-switch .form-check-input:disabled {
  background-color: #dedede;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
.form-switch .form-check-input:disabled:checked {
  background-color: #b6b6b6;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
.form-switch .form-check-input:not(:checked):focus-visible {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-switch .form-check-input:checked:not(:disabled):focus-visible {
  border: 1px solid transparent;
  box-shadow: 0 0 1px 3px rgba(48, 79, 254, 0.3);
}

.dark .form-check {
  --form-check-input-checked-hover-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.dark .form-check-input {
  background-color: #111111;
  border-color: #575757;
}
.dark .form-check-input:not(:disabled):checked {
  background-color: #111111;
  border-color: #575757;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}
.dark .form-check-input[type=checkbox]:indeterminate {
  background-color: #111111;
  border-color: #575757;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}
.dark .form-check-input:disabled {
  border-color: transparent;
  background-color: #343434;
}
.dark .form-check-input:disabled:checked[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}
.dark .form-check-input:disabled ~ .form-check-label {
  opacity: 0.4;
  color: #fff;
}
.dark .form-check-input:not(:checked):focus {
  border-color: #575757;
}
.dark .form-check-input:not(:disabled):hover {
  border-color: #fcfcfc;
}
.dark .form-check-input:not(:disabled):hover ~ .form-check-label {
  color: #fff;
}
.was-validated .dark .form-check-input:valid, .dark .form-check-input.is-valid {
  border-color: #2ee68c;
}
.was-validated .dark .form-check-input:valid ~ .form-check-label, .dark .form-check-input.is-valid ~ .form-check-label {
  color: rgba(255, 255, 255, 0.84);
}
.was-validated .dark .form-check-input:valid:checked, .was-validated .dark .form-check-input:valid:checked:not(:disabled):hover, .dark .form-check-input.is-valid:checked, .dark .form-check-input.is-valid:checked:not(:disabled):hover {
  border-color: #2ee68c;
  background-color: #111111;
}
.was-validated .dark .form-check-input:valid:checked[type=checkbox], .was-validated .dark .form-check-input:valid:checked:not(:disabled):hover[type=checkbox], .dark .form-check-input.is-valid:checked[type=checkbox], .dark .form-check-input.is-valid:checked:not(:disabled):hover[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}
.was-validated .dark .form-check-input:valid:not(:checked):hover, .was-validated .dark .form-check-input:valid:not(:checked):focus, .dark .form-check-input.is-valid:not(:checked):hover, .dark .form-check-input.is-valid:not(:checked):focus {
  border-color: #2ee68c;
}
.was-validated .dark .form-check-input:invalid, .dark .form-check-input.is-invalid {
  border-color: #ff7591;
  background-color: #111111;
}
.was-validated .dark .form-check-input:invalid ~ .form-check-label, .dark .form-check-input.is-invalid ~ .form-check-label {
  color: rgba(255, 255, 255, 0.84);
}
.was-validated .dark .form-check-input:invalid:checked, .was-validated .dark .form-check-input:invalid:checked:not(:disabled):hover, .dark .form-check-input.is-invalid:checked, .dark .form-check-input.is-invalid:checked:not(:disabled):hover {
  border-color: #ff7591;
  background-color: #111111;
}
.was-validated .dark .form-check-input:invalid:checked[type=checkbox], .was-validated .dark .form-check-input:invalid:checked:not(:disabled):hover[type=checkbox], .dark .form-check-input.is-invalid:checked[type=checkbox], .dark .form-check-input.is-invalid:checked:not(:disabled):hover[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}
.was-validated .dark .form-check-input:invalid:not(:checked):hover, .was-validated .dark .form-check-input:invalid:not(:checked):focus, .dark .form-check-input.is-invalid:not(:checked):hover, .dark .form-check-input.is-invalid:not(:checked):focus {
  border-color: #ff7591;
}
.dark .form-check-input[type=radio]:not(:disabled):hover {
  border-color: #fcfcfc;
}
.dark .form-check-input[type=radio]:not(:disabled):checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}
.dark .form-check-input[type=radio]:not(:disabled):checked:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}
.dark .form-check-input[type=radio]:disabled {
  border-color: transparent;
}
.dark .form-check-input[type=radio]:disabled:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}
.dark .form-switch .form-check-input {
  border-color: #b6b6b6;
  background-color: #232323;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}
.dark .form-switch .form-check-input:not(:disabled):hover {
  border-color: #fff;
  background-color: #232323;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}
.dark .form-switch .form-check-input:not(:checked):focus {
  border-color: #b6b6b6;
}
.dark .form-switch .form-check-input:not(:disabled):not(:checked):focus-visible {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}
.dark .form-switch .form-check-input:not(:checked):disabled {
  border-color: #575757;
  background-color: #232323;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}
.dark .form-switch .form-check-input:checked:disabled {
  border-color: #575757;
  background-color: #575757;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.dark .form-switch .form-check-input:not(:disabled):checked {
  border-color: #ededed;
  background-color: #ededed;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.dark .form-switch .form-check-input:not(:disabled):checked:hover {
  border-color: #fff;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.dark .form-switch .form-check-input:not(:disabled):checked:focus-visible {
  box-shadow: 0 0 1px 3px rgba(48, 79, 254, 0.6);
}
.dark .form-check-label {
  color: rgba(255, 255, 255, 0.84);
}

.form-check-lg {
  min-height: 1.5rem;
  line-height: 1.5rem;
  padding-left: 2.4375rem;
  margin-bottom: 1rem;
}
.form-check-lg.form-check-inline {
  margin-right: 1.875rem;
}
.form-check-lg .form-check-input {
  width: 1.5rem;
  height: 1.5rem;
  margin-left: -2.4375rem;
  margin-top: 0;
}
.form-check-lg .form-check-label {
  font-size: 1rem;
}
.form-check-lg.form-check-comfortable {
  margin-bottom: 1.25rem;
}

.form-switch.form-check-lg {
  padding-left: 4rem;
}
.form-switch.form-check-lg .form-check-input {
  width: 3rem;
  margin-left: -4rem;
}

.form-check-reverse.form-check-lg {
  padding-left: 0;
}

.form-check-alt {
  --form-check-input-checked-hover-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}
.form-check-alt .form-check-input[type=checkbox]:checked:not(:disabled) {
  border: 1px solid #343434;
  background-color: #343434;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}
.form-check-alt .form-check-input[type=checkbox]:indeterminate {
  background-color: #343434;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  border-color: #343434;
}
.form-check-alt .form-check-input[type=checkbox]:checked:disabled {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
}
.form-check-alt .form-check-input[type=checkbox]:checked:not(:disabled):hover {
  background-color: #000000;
  border-color: #000000;
}
.was-validated .form-check-alt .form-check-input[type=checkbox]:valid:checked:not(:disabled), .form-check-alt .form-check-input[type=checkbox].is-valid:checked:not(:disabled) {
  background-color: #15ad5c;
  border-color: #15ad5c;
}
.was-validated .form-check-alt .form-check-input[type=checkbox]:valid:checked:not(:disabled)[type=checkbox], .form-check-alt .form-check-input[type=checkbox].is-valid:checked:not(:disabled)[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}
.was-validated .form-check-alt .form-check-input[type=checkbox]:invalid, .form-check-alt .form-check-input[type=checkbox].is-invalid {
  border-color: #e64949;
}
.was-validated .form-check-alt .form-check-input[type=checkbox]:invalid:checked:not(:disabled), .form-check-alt .form-check-input[type=checkbox].is-invalid:checked:not(:disabled) {
  background-color: #e64949;
  border-color: #e64949;
}
.was-validated .form-check-alt .form-check-input[type=checkbox]:invalid:checked:not(:disabled)[type=checkbox], .form-check-alt .form-check-input[type=checkbox].is-invalid:checked:not(:disabled)[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}
.form-check-alt.form-switch .form-check-input {
  background-color: #fff;
  border: 1px solid #b6b6b6;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
}
.form-check-alt.form-switch .form-check-input:checked:not(:disabled) {
  border-color: transparent !important;
  background-color: #090909;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}
.form-check-alt.form-switch .form-check-input:checked:not(:disabled):hover {
  background-color: #000000;
}
.form-check-alt.form-switch .form-check-input:not(:checked):not(:disabled):hover {
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  border-color: #090909;
}
.form-check-alt.form-switch .form-check-input:not(:checked):not(:disabled):focus-visible {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}
.form-check-alt.form-switch .form-check-input:not(:checked):disabled {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  border-color: #dedede;
}
.form-check-alt.form-switch .form-check-input:disabled:checked {
  background-color: #ededed;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  border-color: #ededed;
}

.dark .form-check-alt {
  --form-check-input-checked-hover-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.dark .form-check-alt .form-check-input[type=checkbox]:checked:not(:disabled) {
  border-color: #dedede;
  background-color: #dedede;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.dark .form-check-alt .form-check-input[type=checkbox]:checked:not(:disabled):hover {
  background-color: #fff;
}
.dark .form-check-alt .form-check-input[type=checkbox]:indeterminate {
  background-color: #dedede;
  border-color: #dedede;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}
.was-validated .dark .form-check-alt .form-check-input[type=checkbox]:valid:checked, .was-validated .dark .form-check-alt .form-check-input[type=checkbox]:valid:checked:not(:disabled):hover, .dark .form-check-alt .form-check-input[type=checkbox].is-valid:checked, .dark .form-check-alt .form-check-input[type=checkbox].is-valid:checked:not(:disabled):hover {
  border-color: #2ee68c;
  background-color: #2ee68c;
}
.was-validated .dark .form-check-alt .form-check-input[type=checkbox]:valid:checked[type=checkbox], .was-validated .dark .form-check-alt .form-check-input[type=checkbox]:valid:checked:not(:disabled):hover[type=checkbox], .dark .form-check-alt .form-check-input[type=checkbox].is-valid:checked[type=checkbox], .dark .form-check-alt .form-check-input[type=checkbox].is-valid:checked:not(:disabled):hover[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.was-validated .dark .form-check-alt .form-check-input[type=checkbox]:invalid:checked, .was-validated .dark .form-check-alt .form-check-input[type=checkbox]:invalid:checked:not(:disabled):hover, .dark .form-check-alt .form-check-input[type=checkbox].is-invalid:checked, .dark .form-check-alt .form-check-input[type=checkbox].is-invalid:checked:not(:disabled):hover {
  border-color: #ff7591;
  background-color: #ff7591;
}
.was-validated .dark .form-check-alt .form-check-input[type=checkbox]:invalid:checked[type=checkbox], .was-validated .dark .form-check-alt .form-check-input[type=checkbox]:invalid:checked:not(:disabled):hover[type=checkbox], .dark .form-check-alt .form-check-input[type=checkbox].is-invalid:checked[type=checkbox], .dark .form-check-alt .form-check-input[type=checkbox].is-invalid:checked:not(:disabled):hover[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.dark .form-check-alt.form-switch .form-check-input {
  border-color: #b6b6b6;
  background-color: #232323;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}
.dark .form-check-alt.form-switch .form-check-input:not(:disabled):hover {
  border-color: #fff;
  background-color: #232323;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}
.dark .form-check-alt.form-switch .form-check-input:not(:disabled):hover ~ .form-check-label {
  color: #fff;
}
.dark .form-check-alt.form-switch .form-check-input:not(:disabled):not(:checked):focus-visible {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}
.dark .form-check-alt.form-switch .form-check-input:not(:checked):disabled {
  border-color: #575757;
  background-color: #232323;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}
.dark .form-check-alt.form-switch .form-check-input:checked:disabled {
  border-color: #575757;
  background-color: #575757;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.dark .form-check-alt.form-switch .form-check-input:not(:disabled):checked {
  border-color: #ededed;
  background-color: #ededed;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.dark .form-check-alt.form-switch .form-check-input:not(:disabled):checked:hover {
  border-color: #fff;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.dark .form-check-alt.form-switch .form-check-input:not(:disabled):checked:focus-visible {
  box-shadow: 0 0 1px 3px rgba(48, 79, 254, 0.6);
}

.input-group .btn {
  border-radius: 0;
}
.input-group .form-control:hover,
.input-group .form-select:hover,
.input-group .btn:hover {
  z-index: 3;
}
.input-group > .form-control-square {
  text-align: center;
  flex-grow: 0;
  width: 2.5rem;
  padding: 0.5rem 0.5rem;
}

.input-group-text {
  height: 2.5rem;
}
.input-group-text[data-toggle] {
  cursor: pointer;
}

.input-group-search {
  max-width: 540px;
  flex: 1 1;
}

.input-group-lg > .input-group-text,
.input-group-lg > .form-control:not(textarea) {
  height: 2.875rem;
}
.input-group-lg > .btn {
  padding: 0.5rem 1.5625rem;
}
.input-group-lg > .form-control-square {
  width: 2.875rem;
}

.input-group-sm > .btn {
  padding-top: var(--bs-btn-padding-y);
  padding-bottom: var(--bs-btn-padding-y);
}
.input-group-sm > .input-group-text,
.input-group-sm > .form-control:not(textarea) {
  height: 2.25rem;
}
.input-group-sm > .form-select {
  padding-right: 2.75rem;
}
.input-group-sm > .form-control-square {
  width: 2.25rem;
  padding: 0.375rem 0.375rem;
}

.input-group-spinner {
  max-width: 192px;
}

.input-group.input-group-merge {
  --bs-input-disabled-bg: #fafafa;
}
.input-group.input-group-merge > .form-control:not(:disabled):hover,
.input-group.input-group-merge > .form-control:not(:disabled):hover ~ [class*=input-group] {
  z-index: 3;
}
.input-group.input-group-merge > .form-control:not(:disabled):hover > .input-group-text,
.input-group.input-group-merge > .form-control:not(:disabled):hover ~ [class*=input-group] > .input-group-text {
  border-color: #666666 !important;
}
.input-group.input-group-merge > .form-control.is-valid,
.input-group.input-group-merge > .form-control.is-valid ~ [class*=input-group] > .input-group-text {
  border-color: var(--bs-form-valid-border-color) !important;
}
.input-group.input-group-merge > .form-control.is-invalid,
.input-group.input-group-merge > .form-control.is-invalid ~ [class*=input-group] > .input-group-text {
  border-color: var(--bs-form-invalid-border-color) !important;
}
.input-group.input-group-merge > .form-control:not(:disabled):focus {
  box-shadow: none;
}
.input-group.input-group-merge > .form-control:not(:disabled):focus,
.input-group.input-group-merge > .form-control:not(:disabled):focus ~ [class*=input-group] {
  z-index: 5;
}
.input-group.input-group-merge > .form-control:not(:disabled):focus > .input-group-text,
.input-group.input-group-merge > .form-control:not(:disabled):focus ~ [class*=input-group] > .input-group-text {
  border-color: #304ffe !important;
}
.input-group.input-group-merge > .form-control ~ [class*=input-group] > .input-group-text {
  background-color: transparent;
}
.input-group.input-group-merge > .form-control:disabled ~ [class*=input-group] > .input-group-text, .input-group.input-group-merge > .form-control[readonly] ~ [class*=input-group] > .input-group-text {
  background-color: var(--bs-input-disabled-bg);
}
.input-group.input-group-merge > .form-control-prepended {
  padding-left: 0.3125rem;
  border-left-width: 0;
}
.input-group.input-group-merge > .form-control-appended:not(.is-valid):not(.is-invalid) {
  padding-right: 0.3125rem;
}
.input-group.input-group-merge > .form-control-appended {
  border-right-width: 0;
}
.input-group.input-group-merge > .input-group-prepend {
  order: -1;
}
.input-group.input-group-merge > .input-group-prepend > .input-group-text {
  padding-left: 0.625rem;
  padding-right: 0.3125rem;
  border-right-width: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.input-group.input-group-merge > .input-group-append > .input-group-text {
  padding-left: 0.3125rem;
  padding-right: 0.625rem;
  border-left-width: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.input-group-lg.input-group-merge > .input-group-prepend > .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  height: 2.875rem;
}
.input-group-lg.input-group-merge > .input-group-append > .input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  height: 2.875rem;
}

.input-group-sm.input-group-merge > .input-group-prepend > .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  height: 2.25rem;
}
.input-group-sm.input-group-merge > .input-group-append > .input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  height: 2.25rem;
}

.dark .input-group.input-group-merge {
  --bs-input-disabled-bg: #232323;
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}

.was-validated .form-select-triangle:valid, .form-select-triangle.is-valid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___}), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) !important;
}
.was-validated .form-select-triangle:invalid, .form-select-triangle.is-invalid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___}), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) !important;
}

.was-validated .form-select-up-down:valid, .form-select-up-down.is-valid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) !important;
}
.was-validated .form-select-up-down:invalid, .form-select-up-down.is-invalid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) !important;
}

.was-validated .form-control:valid, .form-control.is-valid {
  background-size: 32px 32px;
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-control:invalid, .form-control.is-invalid {
  background-size: 32px 32px;
  border-color: var(--bs-form-invalid-border-color);
}

.was-validated .dark .form-select:valid, .dark .form-select.is-valid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) !important;
}
.was-validated .dark .form-select:invalid, .dark .form-select.is-invalid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}), url(${___CSS_LOADER_URL_REPLACEMENT_48___}) !important;
}
.was-validated .dark .form-select-triangle:valid, .dark .form-select-triangle.is-valid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___}), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) !important;
}
.was-validated .dark .form-select-triangle:invalid, .dark .form-select-triangle.is-invalid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___}), url(${___CSS_LOADER_URL_REPLACEMENT_48___}) !important;
}
.was-validated .dark .form-select-up-down:valid, .dark .form-select-up-down.is-valid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___}), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) !important;
}
.was-validated .dark .form-select-up-down:invalid, .dark .form-select-up-down.is-invalid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___}), url(${___CSS_LOADER_URL_REPLACEMENT_48___}) !important;
}
.was-validated .dark .form-control:valid, .dark .form-control.is-valid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}
.was-validated .dark .form-control:invalid, .dark .form-control.is-invalid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}

.bg-footer {
  background: #fff;
}
.dark .bg-footer {
  background: #111111;
}

.anchor-grid .col-6 {
  border: 1px solid #232323;
}
.anchor-grid .col-6:nth-child(n+3) {
  margin-top: -1px;
}
.anchor-grid .col-6:nth-child(even) {
  margin-left: -1px;
}
.anchor-grid a {
  text-decoration: none;
}

@media (max-width: 575.98px) {
  .border-grid > div + div {
    margin-top: -1px;
  }
}
@media (min-width: 576px) and (max-width: 991.98px) {
  .border-grid > div:nth-child(n+3) {
    margin-top: -1px;
  }
  .border-grid > div:nth-child(even) {
    margin-left: -1px;
  }
}
@media (min-width: 992px) {
  .border-grid > div + div {
    margin-left: -1px;
  }
}

.card-tag {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  text-transform: uppercase;
  padding: 0.5rem 1rem;
  background: #fff;
  box-shadow: 0 0.625rem 1.25rem rgba(35, 35, 35, 0.08);
}

.card-body-side {
  padding: 2.5rem 1.875rem;
}

.card-body-side-sm {
  padding: 2.5rem 1.625rem 2.5rem 2.125rem;
}

.card-body-side-xs {
  padding: 1.25rem 1.875rem 1.5rem 1.25rem;
}

.card-hover-bg {
  text-decoration: none !important;
  transition: box-shadow 300ms, background-color 300ms;
}
.card-hover-bg:hover {
  background-color: #fff;
}
.dark .card-hover-bg:hover {
  background-color: #343434;
}

.image-stacks-7-cc {
  display: flex;
  align-items: flex-end;
  height: 267px;
  max-width: 427px;
  margin: 0 auto;
  padding: 2.1875rem 1.875rem;
  border-radius: 1rem;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0.5rem 1.4375rem -0.125rem rgba(17, 17, 17, 0.6);
}
.image-stacks-7-cc h6, .image-stacks-7-cc .h6 {
  font-size: 7px;
  margin-bottom: 9px;
}

.image-stacks-7-cc-number {
  font-size: 1.3125rem;
  letter-spacing: 1.75px;
  margin-bottom: 37px;
}

.heading-badge {
  display: inline-block;
  padding: 0.125rem 0.754rem;
  line-height: 2;
  letter-spacing: 1.5px;
  font-size: 0.6875rem;
  font-weight: normal;
  color: #111111;
  background-color: #f2f2f2;
}
.dark .heading-badge {
  background-color: #343434;
  color: #fff;
}

@media (min-width: 1440px) {
  .hero-1-nav-container {
    display: flex;
  }
  .hero-1-nav-container > div {
    text-align: right;
    margin-bottom: 0.35rem !important;
    margin-left: auto;
    order: 2;
  }
}
.line-after {
  position: relative;
}
.line-after::after {
  content: "";
  height: 1px;
  width: 2.5rem;
  background: #007f00;
  position: absolute;
  bottom: 0;
  left: 0;
}

.price-card-currency {
  position: absolute;
  font-size: 1.5rem;
  top: 0.5rem;
  right: 100%;
  margin-right: 2px;
}

.radio-grid > div:not(:last-child) {
  margin-bottom: 30px;
}
@media (min-width: 576px) {
  .radio-grid > div:nth-child(n+7) {
    margin-bottom: 0;
  }
}
@media (min-width: 992px) {
  .radio-grid > div:nth-child(n+5) {
    margin-bottom: 0;
  }
}
.radio-grid input[type=radio] {
  opacity: 0;
  position: fixed;
  width: 0;
}
.radio-grid label {
  display: block;
  position: relative;
  height: 100%;
  padding: 1.875rem 1.875rem 2.5rem 1.875rem;
  font-weight: 300;
  border: 1px solid #232323;
  border-radius: 5px;
  transition: border-color 300ms, box-shadow 300ms;
}
.radio-grid label:hover {
  border-color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
}
.radio-grid input[type=radio]:focus + label {
  box-shadow: 0 0px 10px 0px #304ffe;
}
.radio-grid input[type=radio]:checked + label {
  border-color: #fff;
}
.radio-grid input[type=radio]:checked + label::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_41___}) center no-repeat;
  background-size: cover;
  display: block;
  width: 32px;
  height: 32px;
  position: absolute;
  top: 10px;
  right: 10px;
}

.section-padding-xs {
  padding: 2rem 0;
}
@media (min-width: 576px) {
  .section-padding-xs {
    padding: 3rem 0;
  }
}
@media (min-width: 768px) {
  .section-padding-xs {
    padding: 4rem 0;
  }
}

.section-padding-sm {
  padding: 2.5rem 0;
}
@media (min-width: 576px) {
  .section-padding-sm {
    padding: 3.5rem 0;
  }
}
@media (min-width: 768px) {
  .section-padding-sm {
    padding: 5rem 0;
  }
}

.section-padding {
  padding: 3rem 0;
}
@media (min-width: 576px) {
  .section-padding {
    padding: 4rem 0;
  }
}
@media (min-width: 768px) {
  .section-padding {
    padding: 6rem 0;
  }
}

.section-padding-lg {
  padding: 3.5rem 0;
}
@media (min-width: 576px) {
  .section-padding-lg {
    padding: 5rem 0;
  }
}
@media (min-width: 768px) {
  .section-padding-lg {
    padding: 6.5rem 0;
  }
}

.section-padding-xl {
  padding: 4rem 0;
}
@media (min-width: 576px) {
  .section-padding-xl {
    padding: 6rem 0;
  }
}
@media (min-width: 768px) {
  .section-padding-xl {
    padding: 8rem 0;
  }
}

@media (min-width: 1200px) {
  .cta-pb-xl {
    padding-bottom: 20.875rem;
  }
}

@media (min-width: 992px) {
  .splits-5-row {
    min-height: 95vh;
  }
}
.splits-5-anchor {
  position: relative;
  overflow: hidden;
  text-decoration: none !important;
}
.splits-5-anchor .absolute-fill, .splits-5-anchor .overlay::before {
  transition: transform 300ms;
}
.splits-5-anchor:hover .absolute-fill, .splits-5-anchor:hover .overlay::before {
  transform: scale(1.1);
}

.splits-text-width-sm {
  max-width: 400px;
}

.splits-text-width {
  max-width: 445px;
}

.splits-text-width-lg {
  max-width: 600px;
}

@media (max-width: 991.98px) {
  .split-media-col {
    min-height: 400px;
  }
}
@media (max-width: 767.98px) {
  .split-media-col {
    min-height: 300px;
  }
}

.square-sm {
  width: 3rem;
  height: 3rem;
}

.square {
  width: 4rem;
  height: 4rem;
}

.square-lg {
  width: 4.5rem;
  height: 4.5rem;
}

.square-xl {
  width: 5rem;
  height: 5rem;
}

.square-xxl {
  width: 6rem;
  height: 6rem;
}

.video-play-anchor {
  display: block;
  border: 0;
  padding: 0;
  opacity: 1 !important;
}
.video-play-anchor::before {
  opacity: 0.1;
  transition: opacity 300ms;
}
.video-play-anchor:hover::before {
  opacity: 0.3;
}
.video-play-anchor .bg-white {
  color: #343434;
}

@keyframes modal-video {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes modal-video-inner {
  from {
    transform: translate(0, 100px);
  }
  to {
    transform: translate(0, 0);
  }
}
.modal-video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000000;
  cursor: pointer;
  opacity: 1;
  animation-timing-function: ease-out;
  animation-duration: 0.3s;
  animation-name: modal-video;
  transition: opacity 0.3s ease-out;
}

.modal-video-effect-exit {
  opacity: 0;
}
.modal-video-effect-exit .modal-video-movie-wrap {
  transform: translate(0, 100px);
}

.modal-video-body {
  max-width: 960px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}

.modal-video-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
@media (orientation: landscape) {
  .modal-video-inner {
    padding: 10px 60px;
    box-sizing: border-box;
  }
}

.modal-video-movie-wrap {
  width: 100%;
  height: 0;
  position: relative;
  padding-bottom: 56.25%;
  background-color: #333;
  animation-timing-function: ease-out;
  animation-duration: 0.3s;
  animation-name: modal-video-inner;
  transform: translate(0, 0);
  transition: transform 0.3s ease-out;
}
.modal-video-movie-wrap iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.modal-video-close-btn {
  position: absolute;
  z-index: 2;
  top: -45px;
  right: 0px;
  display: inline-block;
  width: 35px;
  height: 35px;
  overflow: hidden;
  border: none;
  background: transparent;
}
@media (orientation: landscape) {
  .modal-video-close-btn {
    top: 0;
    right: -45px;
  }
}
.modal-video-close-btn:before {
  transform: rotate(45deg);
}
.modal-video-close-btn:after {
  transform: rotate(-45deg);
}
.modal-video-close-btn:before, .modal-video-close-btn:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 100%;
  top: 50%;
  left: 0;
  margin-top: -1px;
  background: #fff;
  border-radius: 5px;
  margin-top: -6px;
}

.react-table-pagination-total {
  line-height: 41px;
}
.react-table-pagination-total input::-webkit-outer-spin-button,
.react-table-pagination-total input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.react-table-pagination-total input[type=number] {
  -moz-appearance: textfield;
}

.react-table-pagination {
  font-size: 0.875rem;
}

.react-table-pagination-sm {
  font-size: 0.8125rem;
}

.react-table-pagination-lg {
  font-size: 0.9375rem;
}

.react-table-sort {
  height: 25px;
}

/* Slider */
.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}

.slick-list {
  position: relative;
  overflow: hidden;
  display: block;
  margin: 0;
  padding: 0;
}
.slick-list:focus {
  outline: none;
}
.slick-list.dragging {
  cursor: pointer;
  cursor: hand;
}

.slick-slider .slick-track,
.slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
}

.slick-track {
  position: relative;
  left: 0;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.slick-track:before, .slick-track:after {
  content: "";
  display: table;
}
.slick-track:after {
  clear: both;
}
.slick-loading .slick-track {
  visibility: hidden;
}

.slick-slide {
  float: left;
  height: 100%;
  min-height: 1px;
  display: none;
}
[dir=rtl] .slick-slide {
  float: right;
}
.slick-slide img {
  display: block;
}
.slick-slide.slick-loading img {
  display: none;
}
.slick-slide.dragging img {
  pointer-events: none;
}
.slick-initialized .slick-slide {
  display: block;
}
.slick-loading .slick-slide {
  visibility: hidden;
}
.slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}

.slick-arrow.slick-hidden {
  display: none;
}

.slick-slide img {
  display: unset;
}

.slick-vertical .slick-slide {
  border: none;
}

.slick-slider:not(.slick-vertical) .slick-track {
  display: flex;
}
.slick-slider:not(.slick-vertical) .slick-slide {
  height: auto;
}
.slick-slider:not(.slick-vertical) .slick-slide > div {
  height: 100%;
}

.carousel-page {
  --carousel-page-item-bg: #b6b6b6;
  --carousel-page-item-bg-hover: #111111;
  --carousel-page-item-bg-active: #343434;
  background: transparent;
  border: 1px solid transparent;
}
.carousel-page::before {
  content: "";
  display: block;
  background: var(--carousel-page-item-bg);
  transition: background-color 0.15s ease-in-out;
}
.carousel-page.active::before {
  background: var(--carousel-page-item-bg-active);
}
.carousel-page:hover::before {
  background: var(--carousel-page-item-bg-hover);
}
.carousel-page:focus-visible {
  outline: 0;
  border-color: #304ffe;
}

.carousel-text-transition {
  transition: opacity 500ms ease;
}

.carousel-page-dot {
  padding: 0.4375rem;
  width: 24px;
  height: 24px;
}
.carousel-page-dot::before {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.carousel-page-dot-lg {
  width: 28px;
  height: 28px;
}
.carousel-page-dot-lg::before {
  width: 12px;
  height: 12px;
}

.carousel-page-bar,
.carousel-page-pill {
  padding: 1.125rem 0.1875rem;
}
.carousel-page-bar::before,
.carousel-page-pill::before {
  width: 2rem;
  height: 0.125rem;
}

.carousel-page-bar-lg,
.carousel-page-pill-lg {
  padding: 1.25rem 0.1875rem;
}
.carousel-page-bar-lg::before,
.carousel-page-pill-lg::before {
  width: 2.375rem;
  height: 0.25rem;
}

.carousel-page-pill::before {
  border-radius: 0.125rem;
}

.carousel-progress-parent:hover .carousel-progress-bar {
  animation-play-state: paused;
}

.carousel-progress-bar {
  transition: none;
  width: 0;
  animation: grow-width var(--carousel-slide-duration) linear forwards;
}

@keyframes grow-width {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
.btn-carousel-overlay {
  --bs-btn-disabled-bg: rgba(255, 255, 255, 0.5);
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-disabled-color: rgba(17, 17, 17, 0.5);
}
.btn-carousel-overlay:not(.disabled), .btn-carousel-overlay:not(:disabled) {
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.26);
}

.carousel-page-overlay {
  --carousel-page-item-bg: #a1a1a1;
  --carousel-page-item-bg-hover: #fff;
  --carousel-page-item-bg-active: #fcfcfc;
}
.carousel-page-overlay::before {
  box-shadow: 0 0.03125rem 0.03125rem 0 rgba(0, 0, 0, 0.84);
}
.carousel-page-overlay.active::before {
  box-shadow: 0 0.03125rem 0.1875rem 0 rgba(0, 0, 0, 0.92);
}

.dark .carousel-page:not(.carousel-page-overlay) {
  --carousel-page-item-bg: #343434;
  --carousel-page-item-bg-hover: #fff;
  --carousel-page-item-bg-active: #808080;
}

.recharts-wrapper {
  --recharts-grid-color: #111111;
  --recharts-polar-grid-opacity: 0.14;
  --recharts-radial-bar-bg: #ededed;
  --recharts-tooltip-cursor-stroke: #002bbc;
  --recharts-reference-line-blue: #ccd5f2;
  --recharts-bar-tooltip-cursor-fill: rgba(17, 17, 17, 0.08);
  --recharts-bg: #fff;
  --recharts-pie-text-overlay-color: #fff;
  font-size: 0.8125rem;
}

.recharts-surface text {
  fill: currentColor;
}

.recharts-tooltip-content {
  min-width: 165px;
  max-width: 200px;
  visibility: "visible";
}

.recharts-cartesian-grid line {
  stroke: var(--recharts-grid-color);
  stroke-opacity: 0.08;
}

.recharts-cartesian-axis line {
  stroke: var(--recharts-grid-color);
  stroke-opacity: 0.4;
}
.recharts-cartesian-axis .recharts-label {
  font-size: 1rem;
  opacity: 0.52;
  text-anchor: middle;
}

.recharts-polar-grid line,
.recharts-polar-grid path {
  stroke: var(--recharts-grid-color);
  stroke-opacity: var(--recharts-polar-grid-opacity);
}

.recharts-tooltip-cursor:not(.recharts-rectangle) {
  stroke: var(--recharts-tooltip-cursor-stroke);
}
.recharts-tooltip-cursor.recharts-rectangle {
  fill: var(--recharts-bar-tooltip-cursor-fill);
}

.recharts-radial-bar-background-sector {
  fill: var(--recharts-radial-bar-bg);
}

.recharts-label-list {
  font-size: 0.75rem;
  text-anchor: middle;
  fill-opacity: 0.84;
  stroke: var(--recharts-bg);
  stroke-opacity: 0.8;
  stroke-width: 4px;
  paint-order: stroke;
}

.recharts-reference-line .recharts-label {
  stroke: var(--recharts-bg);
  stroke-opacity: 0.8;
  stroke-width: 10px;
  paint-order: stroke;
}

.recharts-pie-sector:focus,
.recharts-sector:focus {
  outline: none;
}

.recharts-pie-sector .recharts-sector {
  stroke: var(--recharts-bg);
  transition: opacity 0.15s ease-in-out;
}

.recharts-pie-label-line {
  stroke: var(--recharts-grid-color);
  stroke-opacity: 0.4;
  stroke-width: 1;
}

.recharts-pie-text-overlay {
  fill: var(--recharts-pie-text-overlay-color) !important;
}

.dark .recharts-wrapper {
  --recharts-grid-color: #fff;
  --recharts-polar-grid-opacity: 0.4;
  --recharts-radial-bar-bg: #090909;
  --recharts-tooltip-cursor-stroke: #8ddbff;
  --recharts-reference-line-blue: #2a3a41;
  --recharts-bar-tooltip-cursor-fill: rgba(255, 255, 255, 0.06);
  --recharts-bg: #111111;
  --recharts-pie-text-overlay-color: #111111;
}

.recharts-wrapper {
  --recharts-color-1-1: #090909;
  --recharts-color-2-1: #090909;
  --recharts-color-2-2: #b6b6b6;
  --recharts-color-3-1: #090909;
  --recharts-color-3-2: #606060;
  --recharts-color-3-3: #b6b6b6;
  --recharts-color-4-1: #090909;
  --recharts-color-4-2: #434343;
  --recharts-color-4-3: #7d7d7d;
  --recharts-color-4-4: #b6b6b6;
  --recharts-color-5-1: #090909;
  --recharts-color-5-2: #343434;
  --recharts-color-5-3: #5f5f5f;
  --recharts-color-5-4: #bababa;
  --recharts-color-5-5: #b6b6b6;
  --recharts-color-6-1: #090909;
  --recharts-color-6-2: #2c2c2c;
  --recharts-color-6-3: #4f4f4f;
  --recharts-color-6-4: #727272;
  --recharts-color-6-5: #959595;
  --recharts-color-6-6: #b6b6b6;
}

.dark .recharts-wrapper {
  --recharts-color-1-1: #fcfcfc;
  --recharts-color-2-1: #fcfcfc;
  --recharts-color-2-2: #575757;
  --recharts-color-3-1: #fcfcfc;
  --recharts-color-3-2: #a6a6a6;
  --recharts-color-3-3: #575757;
  --recharts-color-4-1: #fcfcfc;
  --recharts-color-4-2: #c2c2c2;
  --recharts-color-4-3: #8a8a8a;
  --recharts-color-4-4: #575757;
  --recharts-color-5-1: #fcfcfc;
  --recharts-color-5-2: #d0d0d0;
  --recharts-color-5-3: #a6a6a6;
  --recharts-color-5-4: #7d7d7d;
  --recharts-color-5-5: #575757;
  --recharts-color-6-1: #fcfcfc;
  --recharts-color-6-2: #d9d9d9;
  --recharts-color-6-3: #b6b6b6;
  --recharts-color-6-4: #959595;
  --recharts-color-6-5: #757575;
  --recharts-color-6-6: #575757;
}

.recharts-brush {
  --recharts-brush-bg: #ededed;
  --recharts-brush-connect-bg: #767676;
  --recharts-brush-handle-bg: #fff;
  --recharts-brush-stroke: #dedede;
  transform: translateY(30px);
}
.recharts-brush > rect:first-child {
  fill: var(--recharts-brush-bg);
  stroke: none;
}

.recharts-brush-slide {
  fill: var(--recharts-brush-connect-bg);
  fill-opacity: 1;
}

.recharts-brush-traveller-circle {
  fill: var(--recharts-brush-handle-bg);
  stroke: var(--recharts-brush-stroke);
}

.recharts-brush-texts text {
  fill: currentColor;
}
.recharts-brush-texts text:first-child {
  transform: translate(10.5px, 30px);
  text-anchor: middle;
}
.recharts-brush-texts text:last-child {
  transform: translate(-10.5px, 30px);
  text-anchor: middle;
}

.dark .recharts-brush {
  --recharts-brush-bg: #4b4b4b;
  --recharts-brush-connect-bg: #878787;
  --recharts-brush-handle-bg: #343434;
  --recharts-brush-stroke: #575757;
}

.flatpickr-wrapper {
  display: block;
}

.flatpickr-calendar {
  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);
  border-radius: 0;
  padding: 20px;
  width: 320px;
}
.flatpickr-calendar.multiMonth {
  width: 602px !important;
}
.flatpickr-calendar.arrowTop::before, .flatpickr-calendar.arrowTop::after {
  content: none;
}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {
  box-shadow: none;
}
.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
  border-top: none;
}

.flatpickr-months {
  margin-bottom: 14px;
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  top: 20px;
  display: flex;
  fill: rgba(17, 17, 17, 0.54);
}
.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
  fill: #111111;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
  left: 20px;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
.flatpickr-months .flatpickr-next-month.flatpickr-next-month {
  right: 20px;
}

.flatpickr-days {
  width: 280px;
}

.flatpickr-day {
  color: #111111;
  border: none;
  width: 40px;
  height: 40px;
  max-width: 40px;
}
.flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay {
  color: rgba(17, 17, 17, 0.5);
}
.flatpickr-day.inRange {
  border-radius: 50%;
  box-shadow: none;
}
.flatpickr-day.inRange::after {
  box-shadow: -5px 0 0 #f2f2f2, 5px 0 0 #f2f2f2;
  content: "";
  position: absolute;
  background-color: #f2f2f2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}
.flatpickr-day.inRange:nth-child(7n+7)::after, .flatpickr-day.inRange:nth-child(7n+1)::after {
  box-shadow: none;
}
.flatpickr-day.inRange, .flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange {
  background: #f2f2f2;
}
.flatpickr-day.today.inRange, .flatpickr-day.prevMonthDay.today.inRange, .flatpickr-day.nextMonthDay.today.inRange {
  background: rgba(17, 17, 17, 0.075);
}
.flatpickr-day:hover, .flatpickr-day:focus, .flatpickr-day.prevMonthDay:hover, .flatpickr-day.prevMonthDay:focus, .flatpickr-day.nextMonthDay:hover, .flatpickr-day.nextMonthDay:focus {
  background: #ededed;
}
.flatpickr-day.today {
  background-color: rgba(17, 17, 17, 0.075);
}
.flatpickr-day.today:hover, .flatpickr-day.today:focus {
  background-color: #b6b6b6;
}
.flatpickr-day.selected, .flatpickr-day.selected.inRange, .flatpickr-day.selected:focus, .flatpickr-day.selected:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange, .flatpickr-day.startRange.inRange, .flatpickr-day.startRange:focus, .flatpickr-day.startRange:hover, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange, .flatpickr-day.endRange.inRange, .flatpickr-day.endRange:focus, .flatpickr-day.endRange:hover, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.endRange.nextMonthDay {
  background: #111111;
}
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
  box-shadow: none;
}
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1))::after, .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1))::after, .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1))::after {
  box-shadow: -5px 0 0 #f2f2f2;
}
.flatpickr-day.selected.startRange, .flatpickr-day.startRange.startRange, .flatpickr-day.endRange.startRange, .flatpickr-day.selected.endRange, .flatpickr-day.startRange.endRange, .flatpickr-day.endRange.endRange {
  border-radius: 50%;
}
.flatpickr-day.selected.startRange::after, .flatpickr-day.startRange.startRange::after, .flatpickr-day.endRange.startRange::after, .flatpickr-day.selected.endRange::after, .flatpickr-day.startRange.endRange::after, .flatpickr-day.endRange.endRange::after {
  content: "";
  position: absolute;
  background-color: #f2f2f2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}
.flatpickr-day.selected.startRange::after, .flatpickr-day.startRange.startRange::after, .flatpickr-day.endRange.startRange::after {
  left: 50%;
}
.flatpickr-day.selected.endRange::after, .flatpickr-day.startRange.endRange::after, .flatpickr-day.endRange.endRange::after {
  right: 50%;
}

.rangeMode .flatpickr-day {
  margin-top: 0px;
}

.dayContainer {
  width: 280px;
  min-width: 280px;
  max-width: 280px;
}

span.flatpickr-weekday {
  font-weight: normal;
  font-size: 0.875rem;
  color: #0f0f0f;
}

.dayContainer + .dayContainer {
  box-shadow: none;
  border-left: 1px solid #dedede;
}

.flatpickr-input[readonly],
.flatpickr-input[readonly] ~ [class*=input-group] > .input-group-text,
.flatpickr-input + .form-control[readonly],
.flatpickr-input + .form-control[readonly] ~ [class*=input-group] > .input-group-text,
.form-control[data-fp-omit][readonly],
.form-control[data-fp-omit][readonly] ~ [class*=input-group] > .input-group-text {
  background-color: transparent !important;
}

.input-group-flatpickr {
  --flatpickr-input-active-border-color: #000000;
}

.flatpickr-input + .form-control:not(:focus).active, .flatpickr-input + .form-control:not(:focus).active + .input-group-prepend .input-group-text, .flatpickr-input.form-control:not(:focus).active, .flatpickr-input.form-control:not(:focus).active + .input-group-prepend .input-group-text {
  border-color: var(--flatpickr-input-active-border-color);
}

.numInputWrapper span {
  border: 0;
}
.numInputWrapper:hover,
.numInputWrapper span:hover {
  background: transparent;
}

.flatpickr-current-month .flatpickr-monthDropdown-months {
  margin-right: 18px;
}
.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  background: transparent;
}
.flatpickr-current-month .flatpickr-monthDropdown-months,
.flatpickr-current-month input.cur-year,
.flatpickr-current-month span.cur-month {
  font-weight: 500;
  font-size: 1rem;
  letter-spacing: 0.05px;
}
.flatpickr-current-month .numInputWrapper span.arrowUp:after {
  border-bottom-color: rgba(17, 17, 17, 0.3);
}
.flatpickr-current-month .numInputWrapper span.arrowUp:hover:after {
  border-bottom-color: #111111;
}
.flatpickr-current-month .numInputWrapper span.arrowDown:after {
  border-top-color: rgba(17, 17, 17, 0.3);
}
.flatpickr-current-month .numInputWrapper span.arrowDown:hover:after {
  border-top-color: #111111;
}

.flatpickr-time .flatpickr-time-separator {
  font-weight: 700;
  width: 40px;
}
.flatpickr-time input {
  padding-right: 22px;
  cursor: pointer;
  transition: border-color 0.15s ease-in-out;
  border: 1px solid transparent;
}
.flatpickr-time input:focus {
  border: 1px solid #304ffe;
}
.flatpickr-time input:hover, .flatpickr-time input:focus {
  background-color: #f2f2f2;
}
.flatpickr-time input.flatpickr-hour, .flatpickr-time input.flatpickr-minute, .flatpickr-time input.flatpickr-second {
  font-size: 1.125rem;
  font-weight: 400;
  color: #111111;
}
.flatpickr-time .flatpickr-time-separator {
  font-size: 1.125rem;
  font-weight: 400;
  color: #111111;
}
.flatpickr-time .flatpickr-am-pm {
  border-radius: 50%;
  width: 40px;
  margin-left: 30px;
  color: #111111;
}
.flatpickr-time .flatpickr-am-pm:hover, .flatpickr-time .flatpickr-am-pm:focus {
  background: #ededed;
}
.flatpickr-time .numInputWrapper span {
  padding: 0 16px 0 6px;
  opacity: 0.5;
  transition: opacity 0.2s ease-in-out;
}
.flatpickr-time .numInputWrapper span:hover {
  opacity: 1;
}
.flatpickr-time .numInputWrapper span.arrowUp:after {
  border-bottom-width: 6px;
  border-bottom-color: #111111;
  top: 40%;
}
.flatpickr-time .numInputWrapper span.arrowDown:after {
  border-top-width: 6px;
  border-top-color: #111111;
  top: 25%;
}

.dark .input-group-flatpickr {
  --flatpickr-input-active-border-color: #fafafa;
}
.dark .flatpickr-calendar {
  box-shadow: 0 1.25rem 1.875rem rgba(17, 17, 17, 0.6);
  background-color: #232323;
}
.dark .flatpickr-months .flatpickr-prev-month,
.dark .flatpickr-months .flatpickr-next-month {
  fill: rgba(255, 255, 255, 0.54);
}
.dark .flatpickr-months .flatpickr-prev-month:hover svg,
.dark .flatpickr-months .flatpickr-next-month:hover svg {
  fill: #fff;
}
.dark .flatpickr-current-month .flatpickr-monthDropdown-months,
.dark .flatpickr-current-month input.cur-year,
.dark .flatpickr-current-month span.cur-month {
  color: #fff;
}
.dark span.flatpickr-weekday {
  color: #fff;
}
.dark .flatpickr-day {
  color: rgba(255, 255, 255, 0.92);
}
.dark .flatpickr-day.flatpickr-disabled:hover {
  color: rgba(255, 255, 255, 0.92);
}
.dark .flatpickr-day.inRange::after {
  box-shadow: -5px 0 0 #343434, 5px 0 0 #343434;
  background-color: #343434;
}
.dark .flatpickr-day:nth-child(7n+7)::after, .dark .flatpickr-day:nth-child(7n+1)::after {
  box-shadow: none;
}
.dark .flatpickr-day.inRange, .dark .flatpickr-day.prevMonthDay.inRange, .dark .flatpickr-day.nextMonthDay.inRange {
  background: #343434;
}
.dark .flatpickr-day.today.inRange, .dark .flatpickr-day.prevMonthDay.today.inRange, .dark .flatpickr-day.nextMonthDay.today.inRange {
  background: #404040;
}
.dark .flatpickr-day:hover, .dark .flatpickr-day:focus, .dark .flatpickr-day.prevMonthDay:hover, .dark .flatpickr-day.prevMonthDay:focus, .dark .flatpickr-day.nextMonthDay:hover, .dark .flatpickr-day.nextMonthDay:focus {
  background: #404040;
}
.dark .flatpickr-day.prevMonthDay, .dark .flatpickr-day.nextMonthDay {
  color: rgba(255, 255, 255, 0.4);
}
.dark .flatpickr-day.today {
  background-color: #343434;
}
.dark .flatpickr-day.today:hover, .dark .flatpickr-day.today:focus {
  background-color: #404040;
  color: #fff;
}
.dark .flatpickr-day.selected {
  background-color: #fff;
  color: #111111;
}
.dark .flatpickr-day.startRange, .dark .flatpickr-day.startRange.inRange, .dark .flatpickr-day.startRange:focus, .dark .flatpickr-day.startRange:hover, .dark .flatpickr-day.startRange.prevMonthDay, .dark .flatpickr-day.startRange.nextMonthDay, .dark .flatpickr-day.endRange, .dark .flatpickr-day.endRange.inRange, .dark .flatpickr-day.endRange:focus, .dark .flatpickr-day.endRange:hover, .dark .flatpickr-day.endRange.prevMonthDay, .dark .flatpickr-day.endRange.nextMonthDay {
  background: #111111;
}
.dark .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1))::after, .dark .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1))::after, .dark .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1))::after {
  box-shadow: -5px 0 0 #343434;
}
.dark .flatpickr-day.selected.startRange, .dark .flatpickr-day.startRange.startRange, .dark .flatpickr-day.endRange.startRange, .dark .flatpickr-day.selected.endRange, .dark .flatpickr-day.startRange.endRange, .dark .flatpickr-day.endRange.endRange {
  background-color: #fff;
  color: #111111;
}
.dark .flatpickr-day.selected.startRange::after, .dark .flatpickr-day.startRange.startRange::after, .dark .flatpickr-day.endRange.startRange::after, .dark .flatpickr-day.selected.endRange::after, .dark .flatpickr-day.startRange.endRange::after, .dark .flatpickr-day.endRange.endRange::after {
  background-color: #343434;
}
.dark .flatpickr-time input.flatpickr-hour,
.dark .flatpickr-time .flatpickr-time-separator,
.dark .flatpickr-time input.flatpickr-minute,
.dark .flatpickr-time input.flatpickr-second {
  color: #fff;
}
.dark .flatpickr-time .flatpickr-am-pm {
  color: #fff;
}
.dark .flatpickr-time .flatpickr-am-pm:hover, .dark .flatpickr-time .flatpickr-am-pm:focus {
  background: #404040;
}
.dark .flatpickr-time input {
  transition: border-color 0.15s ease-in-out;
  border: 1px solid transparent;
}
.dark .flatpickr-time input:focus {
  border: 1px solid #304ffe;
  background-color: #404040;
}
.dark .flatpickr-time input:hover {
  background-color: #404040;
}
.dark .flatpickr-time .numInputWrapper span.arrowUp:after {
  border-bottom-color: #fff;
}
.dark .flatpickr-time .numInputWrapper span.arrowDown:after {
  border-top-color: #fff;
}
.dark .dayContainer + .dayContainer {
  border-color: #4b4b4b;
}
.dark .flatpickr-current-month .numInputWrapper span.arrowUp:after {
  border-bottom-color: rgba(255, 255, 255, 0.3);
}
.dark .flatpickr-current-month .numInputWrapper span.arrowUp:hover:after {
  border-bottom-color: #fff;
}
.dark .flatpickr-current-month .numInputWrapper span.arrowDown:after {
  border-top-color: rgba(255, 255, 255, 0.3);
}
.dark .flatpickr-current-month .numInputWrapper span.arrowDown:hover:after {
  border-top-color: #fff;
}

.rbt .rbt-input-main::-ms-clear {
  display: none;
}

/**
 * Menu
 */
.rbt-menu {
  margin-bottom: 2px;
}
.rbt-menu > .dropdown-item {
  overflow: hidden;
  text-overflow: ellipsis;
}
.rbt-menu > .dropdown-item:focus {
  outline: none;
}
.rbt-menu-pagination-option {
  text-align: center;
}

/**
 * Multi-select Input
 */
.rbt-input-multi {
  cursor: text;
  overflow: hidden;
  position: relative;
}
.rbt-input-multi.focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  color: #495057;
  outline: 0;
}
.rbt-input-multi.form-control {
  height: auto;
}
.rbt-input-multi.disabled {
  background-color: #e9ecef;
  opacity: 1;
}
.rbt-input-multi.is-invalid.focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.rbt-input-multi.is-valid.focus {
  border-color: #28a745;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.rbt-input-multi input::-moz-placeholder {
  color: #6c757d;
  opacity: 1;
}
.rbt-input-multi input:-ms-input-placeholder {
  color: #6c757d;
}
.rbt-input-multi input::-webkit-input-placeholder {
  color: #6c757d;
}
.rbt-input-multi .rbt-input-wrapper {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: -4px;
  margin-top: -1px;
  overflow: hidden;
}
.rbt-input-multi .rbt-input-main {
  margin: 1px 0 4px;
}

/**
 * Close Button
 */
.rbt-close {
  z-index: 1;
}
.rbt-close-lg {
  font-size: 1.5rem;
}

/**
 * Token
 */
.rbt-token {
  background-color: #e7f4ff;
  border: 0;
  border-radius: 0.25rem;
  color: #007bff;
  display: inline-flex;
  line-height: 1rem;
  margin: 1px 3px 2px 0;
}
.rbt-token .rbt-token-label {
  padding: 0.25rem 0.5rem;
}
.rbt-token .rbt-token-label:not(:last-child) {
  padding-right: 0.25rem;
}
.rbt-token-disabled {
  background-color: rgba(0, 0, 0, 0.1);
  color: #495057;
  pointer-events: none;
}
.rbt-token-removeable {
  cursor: pointer;
}
.rbt-token-active {
  background-color: #007bff;
  color: #fff;
  outline: none;
  text-decoration: none;
}
.rbt-token .rbt-token-remove-button {
  background-image: none;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  box-shadow: none;
  color: inherit;
  display: flex;
  justify-content: center;
  font-size: inherit;
  font-weight: normal;
  opacity: 1;
  outline: none;
  padding: 0.25rem 0.5rem;
  padding-left: 0;
  text-shadow: none;
}
.rbt-token .rbt-token-remove-button .rbt-close-content {
  display: block;
}

/**
 * Loader + CloseButton container
 */
.rbt-aux {
  align-items: center;
  display: flex;
  bottom: 0;
  justify-content: center;
  pointer-events: none; /* Don't block clicks on the input */
  position: absolute;
  right: 0;
  top: 0;
  width: 2rem;
}
.rbt-aux-lg {
  width: 3rem;
}
.rbt-aux .rbt-close {
  margin-top: -0.25rem;
  pointer-events: auto; /* Override pointer-events: none; above */
}

.has-aux .form-control {
  padding-right: 2rem;
}
.has-aux .form-control.is-valid, .has-aux .form-control.is-invalid {
  background-position: right 2rem center;
  padding-right: 4rem;
}

.rbt-highlight-text {
  background-color: inherit;
  color: inherit;
  font-weight: bold;
  padding: 0;
}

/**
 * Input Groups
 */
.input-group > .rbt {
  flex: 1 1;
}
.input-group > .rbt .rbt-input-hint, .input-group > .rbt .rbt-aux {
  z-index: 5;
}
.input-group > .rbt:not(:first-child) .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .rbt:not(:last-child) .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbt-close {
  font-size: 1rem;
}
.rbt-close-sm {
  font-size: 0.75rem;
}
.rbt-close-content {
  display: none;
}

.rbt-aux {
  width: 2.5rem;
}
.rbt-aux-lg {
  width: 3rem;
}
.rbt-aux .rbt-close {
  margin-top: 0;
}

.rbt .form-floating {
  flex: 1 1;
}

.form-floating > .rbt-input-multi:not(:placeholder-shown) ~ label {
  opacity: inherit;
  transform: inherit;
}
.form-floating > .rbt-input-multi .rbt-input-main::placeholder {
  color: transparent;
}
.form-floating > .rbt-input-multi.focus ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.rbt .dropdown-item {
  display: block;
}

.rbt-highlight-text {
  font-weight: 400;
  color: #000;
}

.rbt-aux .rbt-close {
  margin-top: 0;
}

.rbt-input-hint {
  letter-spacing: 0.1px;
}

.dark .rbt-highlight-text {
  color: #fff;
}
.dark .rbt-input-hint {
  color: rgba(255, 255, 255, 0.54) !important;
}

.react-select__control {
  background-color: transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  font-size: 0.875rem;
}
.react-select__control:hover {
  border-color: #666666 !important;
}
.react-select__control--is-focused {
  border-color: #304ffe !important;
}
.react-select__control, .react-select__option {
  cursor: pointer !important;
}
.react-select__option {
  color: rgba(17, 17, 17, 0.64) !important;
  font-size: 0.875rem !important;
  background-color: transparent !important;
}
.react-select__option--is-selected {
  background-color: transparent !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  background-repeat: no-repeat;
  background-position: right 0.625rem center;
  background-size: 24px 24px;
  padding-right: 3.6875rem;
  color: #111111 !important;
}
.react-select__option:hover, .react-select__option--is-focused {
  color: #111111 !important;
  background-color: #fafafa !important;
}
.react-select__option:active {
  background-color: #f2f2f2 !important;
}
.react-select__value-container {
  padding-left: 0.9375rem !important;
}

.dark .react-select__control {
  border-color: #404040;
}
.dark .react-select__control--is-focused {
  border-color: #878787 !important;
}
.dark .react-select__placeholder {
  color: rgba(255, 255, 255, 0.64);
}
.dark .react-select__input-container {
  color: #fff;
}
.dark .react-select__menu {
  background: #232323;
}
.dark .react-select__option {
  color: rgba(255, 255, 255, 0.64) !important;
}
.dark .react-select__option--is-selected {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  color: #fff !important;
}
.dark .react-select__option:hover, .dark .react-select__option--is-focused {
  background-color: #343434 !important;
  color: #fff !important;
}
.dark .react-select__option:active {
  background-color: #404040 !important;
}
.dark .react-select__single-value {
  color: #fff !important;
}

body {
  background-color: #fff;
  font-family: "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

#webpack-dev-server-client-overlay {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/scss/styles.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/scss/_utilities.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/scss/_dark.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/scss/_root.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/foundations/colors/_background.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/foundations/colors/_color-utils.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/foundations/colors/_text.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/foundations/typography/_links.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/scss/_mixins.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/foundations/typography/_type.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/foundations/typography/_lists.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/foundations/borders/_border.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/foundations/grids-and-spacing/spacing/_spacingX5.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/foundations/imagery/_scrim.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/close/_close.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/alert/_alert.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/avatar/_avatar.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/badges-and-chips/_badge.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/badges-and-chips/_chip.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/badges-and-chips/notification-badge/_notification-badge.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/breadcrumb/_breadcrumb.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/button/_buttons.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/button/_brand-buttons.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/button/_brand-buttons-mixins.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/button-group/_button-group.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/accordion/_accordion.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/card/_card.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/dropdown/_dropdown.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/list-group/_list-group.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/modal/_modal.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/pagination/_pagination.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/popover/_popover.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/spinner/_spinner.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/steps/_steps.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/tables/_tables.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/tooltips/_tooltip.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/toast/_toast.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/tree/_tree.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/navbar/_nav.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/navbar/_nav-sidebar.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/navbar/_navbar.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/progress/_progress.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/offcanvas/_offcanvas.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/slider/_slider.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/forms/styles/_labels.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/forms/styles/_form-text.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/forms/styles/_form-control.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/forms/styles/_form-select.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/forms/styles/_form-check.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/forms/styles/_form-check-large.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/forms/styles/_form-check-alt.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/forms/styles/_input-group.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/forms/styles/_input-group-merge.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/forms/styles/_validation.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/blocks/sections/footer/_footers.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/blocks/styles/_anchor-grid.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/blocks/styles/_border-grid.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/blocks/styles/_card-tag.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/blocks/styles/_cards.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/blocks/styles/_heading-badge.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/blocks/styles/_hero.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/blocks/styles/_line-after.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/blocks/styles/_price-card-currency.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/blocks/styles/_radio-grid.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/blocks/styles/_section-padding.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/blocks/styles/_splits.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/blocks/styles/_square.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/blocks/styles/_video-play.scss","webpack://./node_modules/@bphxd/ds-core-react/node_modules/react-modal-video/scss/modal-video.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/tables/react-table/_react-table.scss","webpack://./node_modules/slick-carousel/slick/slick.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/components/carousel/_carousel.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/dataviz/styles/_base.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/dataviz/styles/_colors.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/dataviz/styles/_brush.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/forms/extra/flatpickr/_flatpickr.scss","webpack://./node_modules/react-bootstrap-typeahead/css/Typeahead.scss","webpack://./node_modules/react-bootstrap-typeahead/css/Typeahead.bs5.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/forms/extra/react-bootstrap-typeahead/_typeahead.scss","webpack://./node_modules/@bphxd/ds-core-react/lib/forms/extra/react-select/_react-select.scss","webpack://./src/scss/_app.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACmQhB;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AD/PF;;ACmQA;EACE,yBAAA;ADhQF;ACkQE;EACE,qBAAA;ADhQJ;;ACsQA;EACE,4BAAA;ADnQF;ACqQE;EACE,gDCkWS;AFrmBb;;ACuQA;EACE,4BAAA;ADpQF;ACsQE;EACE,oDC2VY;AF/lBhB;;ACwQA;EACE,4BAAA;EACA,uDCmVc;AFxlBhB;ACuQE;EACE,oDCkVY;AFvlBhB;;AG0BI;EFiPF;IACE,2BAAA;EDvQF;AACF;AC4QE;EACE,wBAAA;AD1QJ;AC6QE;EACE,0BAAA;AD3QJ;AC+QI;EACE,6CAAA;AD7QN;ACkRI;EACE,iDAAA;ADhRN;ACoRE;EACE,mDAAA;ADlRJ;ACoRI;EACE,iDAAA;ADlRN;;AI5DE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,2MAAA;EACA,yGAAA;EACA,yFAAA;EAOA,wMAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,2BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,6BAAA;EACA,uCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,+BAAA;EACA,0BAAA;EAEA,8BAAA;EACA,qCAAA;EAGE,qCAAA;EAGF,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,6BAAA;EACA,gCAAA;EACA,6BAAA;EACA,8BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,qDAAA;EACA,+DAAA;EACA,4DAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AL6DF;;AO7KA;;;EAGE,sBAAA;APgLF;;AOjKI;EANJ;IAOM,uBAAA;EPqKJ;AACF;;AOxJA;EACE,SAAA;EACA,uCAAA;ED6OI,mCALI;ECtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AP2JF;;AOlJA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;ARpe9B;;AO3IA;EACE,aAAA;EACA,mBLwmBuB;EKrmBvB,gBLskBkB;EKrkBlB,gBLqmBqB;EKpmBrB,8BAAA;AP4IF;;AOzIA;EDmMM,eALI;ANjDV;;AOxIA;ED8LM,oBALI;AN7CV;;AOvIA;EDyLM,mBALI;ANzCV;;AOtIA;EDoLM,oBALI;ANrCV;;AOrIA;ED+KM,kBALI;ANjCV;;AOpIA;ED0KM,mBALI;AN7BV;;AO7HA;EACE,aAAA;EACA,mBCwV0B;ARxN5B;;AOtHA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;APyHF;;AOnHA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;APsHF;;AOhHA;;EAEE,kBAAA;APmHF;;AOhHA;;;EAGE,aAAA;EACA,mBAAA;APmHF;;AOhHA;;;;EAIE,gBAAA;APmHF;;AOhHA;EACE,gBC6b4B;AR1U9B;;AO9GA;EACE,qBAAA;EACA,cAAA;APiHF;;AO3GA;EACE,gBAAA;AP8GF;;AOtGA;;EAEE,mBCsa4B;AR7T9B;;AOjGA;ED6EM,mBALI;AN6BV;;AO9FA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;APiGF;;AOxFA;;EAEE,kBAAA;EDwDI,iBALI;ECjDR,cAAA;EACA,wBAAA;AP2FF;;AOxFA;EAAM,eAAA;AP4FN;;AO3FA;EAAM,WAAA;AP+FN;;AO1FA;EACE,gEAAA;EACA,qBL2WgB;AF9QlB;AO3FE;EACE,mDAAA;EACA,0BLwWoB;AF3QxB;;AOnFE;EAEE,cAAA;EACA,qBAAA;APqFJ;;AO9EA;;;;EAIE,qCCgV4B;EFlUxB,cALI;ANyEV;;AO1EA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EDEI,mBALI;ANiFV;AOzEE;EDHI,kBALI;ECUN,cAAA;EACA,kBAAA;AP2EJ;;AOvEA;EDVM,mBALI;ECiBR,2BAAA;EACA,qBAAA;AP0EF;AOvEE;EACE,cAAA;APyEJ;;AOrEA;EACE,2BAAA;EDtBI,mBALI;EC6BR,wBCu5CkC;EDt5ClC,sCCu5CkC;EC5rDhC,wBAAA;AT8WJ;AOtEE;EACE,UAAA;ED7BE,cALI;AN2GV;;AO9DA;EACE,gBAAA;APiEF;;AO3DA;;EAEE,sBAAA;AP8DF;;AOtDA;EACE,oBAAA;EACA,yBAAA;APyDF;;AOtDA;EACE,oBL4XqB;EK3XrB,uBL2XqB;EK1XrB,gCC4Z4B;ED3Z5B,gBAAA;APyDF;;AOlDA;EACE,mBLoYqB;EKnYrB,mBAAA;EACA,gCAAA;APqDF;;AOlDA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;APqDF;;AO7CA;EACE,qBAAA;APgDF;;AO1CA;EAEE,gBAAA;AP4CF;;AOpCA;EACE,UAAA;APuCF;;AOlCA;;;;;EAKE,SAAA;EACA,oBAAA;ED5HI,kBALI;ECmIR,oBAAA;APqCF;;AOjCA;;EAEE,oBAAA;APoCF;;AO/BA;EACE,eAAA;APkCF;;AO/BA;EAGE,iBAAA;APgCF;AO7BE;EACE,UAAA;AP+BJ;;AOxBA;EACE,wBAAA;AP2BF;;AOnBA;;;;EAIE,0BAAA;APsBF;AOnBI;;;;EACE,eAAA;APwBN;;AOjBA;EACE,UAAA;EACA,kBAAA;APoBF;;AOfA;EACE,gBAAA;APkBF;;AORA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;APWF;;AOHA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EFxaxB,iBALI;EC6NR,oBAAA;APKF;AOHE;EACE,WAAA;APKJ;;AOEA;;;;;;;EAOE,UAAA;APCF;;AOEA;EACE,YAAA;APCF;;AOQA;EACE,6BAAA;EACA,oBAAA;APLF;;AOaA;;;;;;;CAAA;AAWA;EACE,wBAAA;APbF;;AOkBA;EACE,UAAA;APfF;;AOsBA;EACE,aAAA;EACA,0BAAA;APnBF;;AOwBA;EACE,qBAAA;APrBF;;AO0BA;EACE,SAAA;APvBF;;AO8BA;EACE,kBAAA;EACA,eAAA;AP3BF;;AOmCA;EACE,wBAAA;APhCF;;AOwCA;EACE,wBAAA;APrCF;;AUhiBA;EJmQM,mBALI;EI5PR,gBFwoB4B;ARrG9B;;AU9hBE;EJ4PI,mBALI;EInPN,gBFynBkB;EExnBlB,gBRqpBmB;AFtHvB;;AUpiBE;EJ4PI,oBALI;EInPN,gBFynBkB;EExnBlB,gBRqpBmB;AFhHvB;;AU1iBE;EJ4PI,oBALI;EInPN,gBFynBkB;EExnBlB,gBRqpBmB;AF1GvB;;AUhjBE;EJ4PI,mBALI;EInPN,gBFynBkB;EExnBlB,gBRqpBmB;AFpGvB;;AUtjBE;EJ4PI,kBALI;EInPN,gBFynBkB;EExnBlB,gBRqpBmB;AF9FvB;;AU5jBE;EJ4PI,mBALI;EInPN,gBFynBkB;EExnBlB,gBRqpBmB;AFxFvB;;AU1iBA;ECvDE,eAAA;EACA,gBAAA;AXqmBF;;AU1iBA;EC5DE,eAAA;EACA,gBAAA;AX0mBF;;AU5iBA;EACE,qBAAA;AV+iBF;AU7iBE;EACE,oBFsoB0B;ARvF9B;;AUriBA;EJ8MM,mBALI;EIvMR,yBAAA;AVwiBF;;AUpiBA;EACE,mBR6aO;EItOH,kBALI;ANsWV;AUriBE;EACE,gBAAA;AVuiBJ;;AUniBA;EACE,iBAAA;EACA,mBRmaO;EItOH,mBALI;EItLR,cFtFS;AR4nBX;AUpiBE;EACE,aAAA;AVsiBJ;;AYtoBA;ECIE,eAAA;EAGA,YAAA;AbooBF;;AYroBA;EACE,gBJ6jDkC;EI5jDlC,mCJ6jDkC;EI5jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;Ab6oBF;;AY/nBA;EAEE,qBAAA;AZioBF;;AY9nBA;EACE,qBAAA;EACA,cAAA;AZioBF;;AY9nBA;ENyPM,mBALI;EMlPR,gCJgjDkC;AR/6BpC;;AcnqBE;;;;;;;ECHA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AfgrBF;;AG1nBI;EW5CE;IACE,gBNkee;ERwMrB;AACF;AGhoBI;EW5CE;IACE,gBNkee;ER6MrB;AACF;AGroBI;EW5CE;IACE,gBNkee;ERkNrB;AACF;AG1oBI;EW5CE;IACE,iBNkee;ERuNrB;AACF;AG/oBI;EW5CE;IACE,iBNkee;ER4NrB;AACF;AgB/sBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AhBqtBJ;;AgBhtBE;ECNA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AjBytBF;AgBvtBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AjBmtBF;;AiBpqBM;EACE,SAAA;AjBuqBR;;AiBpqBM;EApCJ,cAAA;EACA,WAAA;AjB4sBF;;AiB9rBE;EACE,cAAA;EACA,WAAA;AjBisBJ;;AiBnsBE;EACE,cAAA;EACA,UAAA;AjBssBJ;;AiBxsBE;EACE,cAAA;EACA,mBAAA;AjB2sBJ;;AiB7sBE;EACE,cAAA;EACA,UAAA;AjBgtBJ;;AiBltBE;EACE,cAAA;EACA,UAAA;AjBqtBJ;;AiBvtBE;EACE,cAAA;EACA,mBAAA;AjB0tBJ;;AiB3rBM;EAhDJ,cAAA;EACA,WAAA;AjB+uBF;;AiB1rBU;EAhEN,cAAA;EACA,kBAAA;AjB8vBJ;;AiB/rBU;EAhEN,cAAA;EACA,mBAAA;AjBmwBJ;;AiBpsBU;EAhEN,cAAA;EACA,UAAA;AjBwwBJ;;AiBzsBU;EAhEN,cAAA;EACA,mBAAA;AjB6wBJ;;AiB9sBU;EAhEN,cAAA;EACA,mBAAA;AjBkxBJ;;AiBntBU;EAhEN,cAAA;EACA,UAAA;AjBuxBJ;;AiBxtBU;EAhEN,cAAA;EACA,mBAAA;AjB4xBJ;;AiB7tBU;EAhEN,cAAA;EACA,mBAAA;AjBiyBJ;;AiBluBU;EAhEN,cAAA;EACA,UAAA;AjBsyBJ;;AiBvuBU;EAhEN,cAAA;EACA,mBAAA;AjB2yBJ;;AiB5uBU;EAhEN,cAAA;EACA,mBAAA;AjBgzBJ;;AiBjvBU;EAhEN,cAAA;EACA,WAAA;AjBqzBJ;;AiB9uBY;EAxDV,wBAAA;AjB0yBF;;AiBlvBY;EAxDV,yBAAA;AjB8yBF;;AiBtvBY;EAxDV,gBAAA;AjBkzBF;;AiB1vBY;EAxDV,yBAAA;AjBszBF;;AiB9vBY;EAxDV,yBAAA;AjB0zBF;;AiBlwBY;EAxDV,gBAAA;AjB8zBF;;AiBtwBY;EAxDV,yBAAA;AjBk0BF;;AiB1wBY;EAxDV,yBAAA;AjBs0BF;;AiB9wBY;EAxDV,gBAAA;AjB00BF;;AiBlxBY;EAxDV,yBAAA;AjB80BF;;AiBtxBY;EAxDV,yBAAA;AjBk1BF;;AiB/wBQ;;EAEE,gBAAA;AjBkxBV;;AiB/wBQ;;EAEE,gBAAA;AjBkxBV;;AiBzxBQ;;EAEE,uBAAA;AjB4xBV;;AiBzxBQ;;EAEE,uBAAA;AjB4xBV;;AiBnyBQ;;EAEE,sBAAA;AjBsyBV;;AiBnyBQ;;EAEE,sBAAA;AjBsyBV;;AiB7yBQ;;EAEE,qBAAA;AjBgzBV;;AiB7yBQ;;EAEE,qBAAA;AjBgzBV;;AiBvzBQ;;EAEE,mBAAA;AjB0zBV;;AiBvzBQ;;EAEE,mBAAA;AjB0zBV;;AiBj0BQ;;EAEE,qBAAA;AjBo0BV;;AiBj0BQ;;EAEE,qBAAA;AjBo0BV;;AiB30BQ;;EAEE,mBAAA;AjB80BV;;AiB30BQ;;EAEE,mBAAA;AjB80BV;;AiBr1BQ;;EAEE,qBAAA;AjBw1BV;;AiBr1BQ;;EAEE,qBAAA;AjBw1BV;;AiB/1BQ;;EAEE,mBAAA;AjBk2BV;;AiB/1BQ;;EAEE,mBAAA;AjBk2BV;;AiBz2BQ;;EAEE,qBAAA;AjB42BV;;AiBz2BQ;;EAEE,qBAAA;AjB42BV;;AiBn3BQ;;EAEE,mBAAA;AjBs3BV;;AiBn3BQ;;EAEE,mBAAA;AjBs3BV;;AiB73BQ;;EAEE,mBAAA;AjBg4BV;;AiB73BQ;;EAEE,mBAAA;AjBg4BV;;AiBv4BQ;;EAEE,mBAAA;AjB04BV;;AiBv4BQ;;EAEE,mBAAA;AjB04BV;;AiBj5BQ;;EAEE,qBAAA;AjBo5BV;;AiBj5BQ;;EAEE,qBAAA;AjBo5BV;;AiB35BQ;;EAEE,mBAAA;AjB85BV;;AiB35BQ;;EAEE,mBAAA;AjB85BV;;AGx9BI;EcUE;IACE,SAAA;EjBk9BN;EiB/8BI;IApCJ,cAAA;IACA,WAAA;EjBs/BA;EiBx+BA;IACE,cAAA;IACA,WAAA;EjB0+BF;EiB5+BA;IACE,cAAA;IACA,UAAA;EjB8+BF;EiBh/BA;IACE,cAAA;IACA,mBAAA;EjBk/BF;EiBp/BA;IACE,cAAA;IACA,UAAA;EjBs/BF;EiBx/BA;IACE,cAAA;IACA,UAAA;EjB0/BF;EiB5/BA;IACE,cAAA;IACA,mBAAA;EjB8/BF;EiB/9BI;IAhDJ,cAAA;IACA,WAAA;EjBkhCA;EiB79BQ;IAhEN,cAAA;IACA,kBAAA;EjBgiCF;EiBj+BQ;IAhEN,cAAA;IACA,mBAAA;EjBoiCF;EiBr+BQ;IAhEN,cAAA;IACA,UAAA;EjBwiCF;EiBz+BQ;IAhEN,cAAA;IACA,mBAAA;EjB4iCF;EiB7+BQ;IAhEN,cAAA;IACA,mBAAA;EjBgjCF;EiBj/BQ;IAhEN,cAAA;IACA,UAAA;EjBojCF;EiBr/BQ;IAhEN,cAAA;IACA,mBAAA;EjBwjCF;EiBz/BQ;IAhEN,cAAA;IACA,mBAAA;EjB4jCF;EiB7/BQ;IAhEN,cAAA;IACA,UAAA;EjBgkCF;EiBjgCQ;IAhEN,cAAA;IACA,mBAAA;EjBokCF;EiBrgCQ;IAhEN,cAAA;IACA,mBAAA;EjBwkCF;EiBzgCQ;IAhEN,cAAA;IACA,WAAA;EjB4kCF;EiBrgCU;IAxDV,cAAA;EjBgkCA;EiBxgCU;IAxDV,wBAAA;EjBmkCA;EiB3gCU;IAxDV,yBAAA;EjBskCA;EiB9gCU;IAxDV,gBAAA;EjBykCA;EiBjhCU;IAxDV,yBAAA;EjB4kCA;EiBphCU;IAxDV,yBAAA;EjB+kCA;EiBvhCU;IAxDV,gBAAA;EjBklCA;EiB1hCU;IAxDV,yBAAA;EjBqlCA;EiB7hCU;IAxDV,yBAAA;EjBwlCA;EiBhiCU;IAxDV,gBAAA;EjB2lCA;EiBniCU;IAxDV,yBAAA;EjB8lCA;EiBtiCU;IAxDV,yBAAA;EjBimCA;EiB9hCM;;IAEE,gBAAA;EjBgiCR;EiB7hCM;;IAEE,gBAAA;EjB+hCR;EiBtiCM;;IAEE,uBAAA;EjBwiCR;EiBriCM;;IAEE,uBAAA;EjBuiCR;EiB9iCM;;IAEE,sBAAA;EjBgjCR;EiB7iCM;;IAEE,sBAAA;EjB+iCR;EiBtjCM;;IAEE,qBAAA;EjBwjCR;EiBrjCM;;IAEE,qBAAA;EjBujCR;EiB9jCM;;IAEE,mBAAA;EjBgkCR;EiB7jCM;;IAEE,mBAAA;EjB+jCR;EiBtkCM;;IAEE,qBAAA;EjBwkCR;EiBrkCM;;IAEE,qBAAA;EjBukCR;EiB9kCM;;IAEE,mBAAA;EjBglCR;EiB7kCM;;IAEE,mBAAA;EjB+kCR;EiBtlCM;;IAEE,qBAAA;EjBwlCR;EiBrlCM;;IAEE,qBAAA;EjBulCR;EiB9lCM;;IAEE,mBAAA;EjBgmCR;EiB7lCM;;IAEE,mBAAA;EjB+lCR;EiBtmCM;;IAEE,qBAAA;EjBwmCR;EiBrmCM;;IAEE,qBAAA;EjBumCR;EiB9mCM;;IAEE,mBAAA;EjBgnCR;EiB7mCM;;IAEE,mBAAA;EjB+mCR;EiBtnCM;;IAEE,mBAAA;EjBwnCR;EiBrnCM;;IAEE,mBAAA;EjBunCR;EiB9nCM;;IAEE,mBAAA;EjBgoCR;EiB7nCM;;IAEE,mBAAA;EjB+nCR;EiBtoCM;;IAEE,qBAAA;EjBwoCR;EiBroCM;;IAEE,qBAAA;EjBuoCR;EiB9oCM;;IAEE,mBAAA;EjBgpCR;EiB7oCM;;IAEE,mBAAA;EjB+oCR;AACF;AG1sCI;EcUE;IACE,SAAA;EjBmsCN;EiBhsCI;IApCJ,cAAA;IACA,WAAA;EjBuuCA;EiBztCA;IACE,cAAA;IACA,WAAA;EjB2tCF;EiB7tCA;IACE,cAAA;IACA,UAAA;EjB+tCF;EiBjuCA;IACE,cAAA;IACA,mBAAA;EjBmuCF;EiBruCA;IACE,cAAA;IACA,UAAA;EjBuuCF;EiBzuCA;IACE,cAAA;IACA,UAAA;EjB2uCF;EiB7uCA;IACE,cAAA;IACA,mBAAA;EjB+uCF;EiBhtCI;IAhDJ,cAAA;IACA,WAAA;EjBmwCA;EiB9sCQ;IAhEN,cAAA;IACA,kBAAA;EjBixCF;EiBltCQ;IAhEN,cAAA;IACA,mBAAA;EjBqxCF;EiBttCQ;IAhEN,cAAA;IACA,UAAA;EjByxCF;EiB1tCQ;IAhEN,cAAA;IACA,mBAAA;EjB6xCF;EiB9tCQ;IAhEN,cAAA;IACA,mBAAA;EjBiyCF;EiBluCQ;IAhEN,cAAA;IACA,UAAA;EjBqyCF;EiBtuCQ;IAhEN,cAAA;IACA,mBAAA;EjByyCF;EiB1uCQ;IAhEN,cAAA;IACA,mBAAA;EjB6yCF;EiB9uCQ;IAhEN,cAAA;IACA,UAAA;EjBizCF;EiBlvCQ;IAhEN,cAAA;IACA,mBAAA;EjBqzCF;EiBtvCQ;IAhEN,cAAA;IACA,mBAAA;EjByzCF;EiB1vCQ;IAhEN,cAAA;IACA,WAAA;EjB6zCF;EiBtvCU;IAxDV,cAAA;EjBizCA;EiBzvCU;IAxDV,wBAAA;EjBozCA;EiB5vCU;IAxDV,yBAAA;EjBuzCA;EiB/vCU;IAxDV,gBAAA;EjB0zCA;EiBlwCU;IAxDV,yBAAA;EjB6zCA;EiBrwCU;IAxDV,yBAAA;EjBg0CA;EiBxwCU;IAxDV,gBAAA;EjBm0CA;EiB3wCU;IAxDV,yBAAA;EjBs0CA;EiB9wCU;IAxDV,yBAAA;EjBy0CA;EiBjxCU;IAxDV,gBAAA;EjB40CA;EiBpxCU;IAxDV,yBAAA;EjB+0CA;EiBvxCU;IAxDV,yBAAA;EjBk1CA;EiB/wCM;;IAEE,gBAAA;EjBixCR;EiB9wCM;;IAEE,gBAAA;EjBgxCR;EiBvxCM;;IAEE,uBAAA;EjByxCR;EiBtxCM;;IAEE,uBAAA;EjBwxCR;EiB/xCM;;IAEE,sBAAA;EjBiyCR;EiB9xCM;;IAEE,sBAAA;EjBgyCR;EiBvyCM;;IAEE,qBAAA;EjByyCR;EiBtyCM;;IAEE,qBAAA;EjBwyCR;EiB/yCM;;IAEE,mBAAA;EjBizCR;EiB9yCM;;IAEE,mBAAA;EjBgzCR;EiBvzCM;;IAEE,qBAAA;EjByzCR;EiBtzCM;;IAEE,qBAAA;EjBwzCR;EiB/zCM;;IAEE,mBAAA;EjBi0CR;EiB9zCM;;IAEE,mBAAA;EjBg0CR;EiBv0CM;;IAEE,qBAAA;EjBy0CR;EiBt0CM;;IAEE,qBAAA;EjBw0CR;EiB/0CM;;IAEE,mBAAA;EjBi1CR;EiB90CM;;IAEE,mBAAA;EjBg1CR;EiBv1CM;;IAEE,qBAAA;EjBy1CR;EiBt1CM;;IAEE,qBAAA;EjBw1CR;EiB/1CM;;IAEE,mBAAA;EjBi2CR;EiB91CM;;IAEE,mBAAA;EjBg2CR;EiBv2CM;;IAEE,mBAAA;EjBy2CR;EiBt2CM;;IAEE,mBAAA;EjBw2CR;EiB/2CM;;IAEE,mBAAA;EjBi3CR;EiB92CM;;IAEE,mBAAA;EjBg3CR;EiBv3CM;;IAEE,qBAAA;EjBy3CR;EiBt3CM;;IAEE,qBAAA;EjBw3CR;EiB/3CM;;IAEE,mBAAA;EjBi4CR;EiB93CM;;IAEE,mBAAA;EjBg4CR;AACF;AG37CI;EcUE;IACE,SAAA;EjBo7CN;EiBj7CI;IApCJ,cAAA;IACA,WAAA;EjBw9CA;EiB18CA;IACE,cAAA;IACA,WAAA;EjB48CF;EiB98CA;IACE,cAAA;IACA,UAAA;EjBg9CF;EiBl9CA;IACE,cAAA;IACA,mBAAA;EjBo9CF;EiBt9CA;IACE,cAAA;IACA,UAAA;EjBw9CF;EiB19CA;IACE,cAAA;IACA,UAAA;EjB49CF;EiB99CA;IACE,cAAA;IACA,mBAAA;EjBg+CF;EiBj8CI;IAhDJ,cAAA;IACA,WAAA;EjBo/CA;EiB/7CQ;IAhEN,cAAA;IACA,kBAAA;EjBkgDF;EiBn8CQ;IAhEN,cAAA;IACA,mBAAA;EjBsgDF;EiBv8CQ;IAhEN,cAAA;IACA,UAAA;EjB0gDF;EiB38CQ;IAhEN,cAAA;IACA,mBAAA;EjB8gDF;EiB/8CQ;IAhEN,cAAA;IACA,mBAAA;EjBkhDF;EiBn9CQ;IAhEN,cAAA;IACA,UAAA;EjBshDF;EiBv9CQ;IAhEN,cAAA;IACA,mBAAA;EjB0hDF;EiB39CQ;IAhEN,cAAA;IACA,mBAAA;EjB8hDF;EiB/9CQ;IAhEN,cAAA;IACA,UAAA;EjBkiDF;EiBn+CQ;IAhEN,cAAA;IACA,mBAAA;EjBsiDF;EiBv+CQ;IAhEN,cAAA;IACA,mBAAA;EjB0iDF;EiB3+CQ;IAhEN,cAAA;IACA,WAAA;EjB8iDF;EiBv+CU;IAxDV,cAAA;EjBkiDA;EiB1+CU;IAxDV,wBAAA;EjBqiDA;EiB7+CU;IAxDV,yBAAA;EjBwiDA;EiBh/CU;IAxDV,gBAAA;EjB2iDA;EiBn/CU;IAxDV,yBAAA;EjB8iDA;EiBt/CU;IAxDV,yBAAA;EjBijDA;EiBz/CU;IAxDV,gBAAA;EjBojDA;EiB5/CU;IAxDV,yBAAA;EjBujDA;EiB//CU;IAxDV,yBAAA;EjB0jDA;EiBlgDU;IAxDV,gBAAA;EjB6jDA;EiBrgDU;IAxDV,yBAAA;EjBgkDA;EiBxgDU;IAxDV,yBAAA;EjBmkDA;EiBhgDM;;IAEE,gBAAA;EjBkgDR;EiB//CM;;IAEE,gBAAA;EjBigDR;EiBxgDM;;IAEE,uBAAA;EjB0gDR;EiBvgDM;;IAEE,uBAAA;EjBygDR;EiBhhDM;;IAEE,sBAAA;EjBkhDR;EiB/gDM;;IAEE,sBAAA;EjBihDR;EiBxhDM;;IAEE,qBAAA;EjB0hDR;EiBvhDM;;IAEE,qBAAA;EjByhDR;EiBhiDM;;IAEE,mBAAA;EjBkiDR;EiB/hDM;;IAEE,mBAAA;EjBiiDR;EiBxiDM;;IAEE,qBAAA;EjB0iDR;EiBviDM;;IAEE,qBAAA;EjByiDR;EiBhjDM;;IAEE,mBAAA;EjBkjDR;EiB/iDM;;IAEE,mBAAA;EjBijDR;EiBxjDM;;IAEE,qBAAA;EjB0jDR;EiBvjDM;;IAEE,qBAAA;EjByjDR;EiBhkDM;;IAEE,mBAAA;EjBkkDR;EiB/jDM;;IAEE,mBAAA;EjBikDR;EiBxkDM;;IAEE,qBAAA;EjB0kDR;EiBvkDM;;IAEE,qBAAA;EjBykDR;EiBhlDM;;IAEE,mBAAA;EjBklDR;EiB/kDM;;IAEE,mBAAA;EjBilDR;EiBxlDM;;IAEE,mBAAA;EjB0lDR;EiBvlDM;;IAEE,mBAAA;EjBylDR;EiBhmDM;;IAEE,mBAAA;EjBkmDR;EiB/lDM;;IAEE,mBAAA;EjBimDR;EiBxmDM;;IAEE,qBAAA;EjB0mDR;EiBvmDM;;IAEE,qBAAA;EjBymDR;EiBhnDM;;IAEE,mBAAA;EjBknDR;EiB/mDM;;IAEE,mBAAA;EjBinDR;AACF;AG5qDI;EcUE;IACE,SAAA;EjBqqDN;EiBlqDI;IApCJ,cAAA;IACA,WAAA;EjBysDA;EiB3rDA;IACE,cAAA;IACA,WAAA;EjB6rDF;EiB/rDA;IACE,cAAA;IACA,UAAA;EjBisDF;EiBnsDA;IACE,cAAA;IACA,mBAAA;EjBqsDF;EiBvsDA;IACE,cAAA;IACA,UAAA;EjBysDF;EiB3sDA;IACE,cAAA;IACA,UAAA;EjB6sDF;EiB/sDA;IACE,cAAA;IACA,mBAAA;EjBitDF;EiBlrDI;IAhDJ,cAAA;IACA,WAAA;EjBquDA;EiBhrDQ;IAhEN,cAAA;IACA,kBAAA;EjBmvDF;EiBprDQ;IAhEN,cAAA;IACA,mBAAA;EjBuvDF;EiBxrDQ;IAhEN,cAAA;IACA,UAAA;EjB2vDF;EiB5rDQ;IAhEN,cAAA;IACA,mBAAA;EjB+vDF;EiBhsDQ;IAhEN,cAAA;IACA,mBAAA;EjBmwDF;EiBpsDQ;IAhEN,cAAA;IACA,UAAA;EjBuwDF;EiBxsDQ;IAhEN,cAAA;IACA,mBAAA;EjB2wDF;EiB5sDQ;IAhEN,cAAA;IACA,mBAAA;EjB+wDF;EiBhtDQ;IAhEN,cAAA;IACA,UAAA;EjBmxDF;EiBptDQ;IAhEN,cAAA;IACA,mBAAA;EjBuxDF;EiBxtDQ;IAhEN,cAAA;IACA,mBAAA;EjB2xDF;EiB5tDQ;IAhEN,cAAA;IACA,WAAA;EjB+xDF;EiBxtDU;IAxDV,cAAA;EjBmxDA;EiB3tDU;IAxDV,wBAAA;EjBsxDA;EiB9tDU;IAxDV,yBAAA;EjByxDA;EiBjuDU;IAxDV,gBAAA;EjB4xDA;EiBpuDU;IAxDV,yBAAA;EjB+xDA;EiBvuDU;IAxDV,yBAAA;EjBkyDA;EiB1uDU;IAxDV,gBAAA;EjBqyDA;EiB7uDU;IAxDV,yBAAA;EjBwyDA;EiBhvDU;IAxDV,yBAAA;EjB2yDA;EiBnvDU;IAxDV,gBAAA;EjB8yDA;EiBtvDU;IAxDV,yBAAA;EjBizDA;EiBzvDU;IAxDV,yBAAA;EjBozDA;EiBjvDM;;IAEE,gBAAA;EjBmvDR;EiBhvDM;;IAEE,gBAAA;EjBkvDR;EiBzvDM;;IAEE,uBAAA;EjB2vDR;EiBxvDM;;IAEE,uBAAA;EjB0vDR;EiBjwDM;;IAEE,sBAAA;EjBmwDR;EiBhwDM;;IAEE,sBAAA;EjBkwDR;EiBzwDM;;IAEE,qBAAA;EjB2wDR;EiBxwDM;;IAEE,qBAAA;EjB0wDR;EiBjxDM;;IAEE,mBAAA;EjBmxDR;EiBhxDM;;IAEE,mBAAA;EjBkxDR;EiBzxDM;;IAEE,qBAAA;EjB2xDR;EiBxxDM;;IAEE,qBAAA;EjB0xDR;EiBjyDM;;IAEE,mBAAA;EjBmyDR;EiBhyDM;;IAEE,mBAAA;EjBkyDR;EiBzyDM;;IAEE,qBAAA;EjB2yDR;EiBxyDM;;IAEE,qBAAA;EjB0yDR;EiBjzDM;;IAEE,mBAAA;EjBmzDR;EiBhzDM;;IAEE,mBAAA;EjBkzDR;EiBzzDM;;IAEE,qBAAA;EjB2zDR;EiBxzDM;;IAEE,qBAAA;EjB0zDR;EiBj0DM;;IAEE,mBAAA;EjBm0DR;EiBh0DM;;IAEE,mBAAA;EjBk0DR;EiBz0DM;;IAEE,mBAAA;EjB20DR;EiBx0DM;;IAEE,mBAAA;EjB00DR;EiBj1DM;;IAEE,mBAAA;EjBm1DR;EiBh1DM;;IAEE,mBAAA;EjBk1DR;EiBz1DM;;IAEE,qBAAA;EjB21DR;EiBx1DM;;IAEE,qBAAA;EjB01DR;EiBj2DM;;IAEE,mBAAA;EjBm2DR;EiBh2DM;;IAEE,mBAAA;EjBk2DR;AACF;AG75DI;EcUE;IACE,SAAA;EjBs5DN;EiBn5DI;IApCJ,cAAA;IACA,WAAA;EjB07DA;EiB56DA;IACE,cAAA;IACA,WAAA;EjB86DF;EiBh7DA;IACE,cAAA;IACA,UAAA;EjBk7DF;EiBp7DA;IACE,cAAA;IACA,mBAAA;EjBs7DF;EiBx7DA;IACE,cAAA;IACA,UAAA;EjB07DF;EiB57DA;IACE,cAAA;IACA,UAAA;EjB87DF;EiBh8DA;IACE,cAAA;IACA,mBAAA;EjBk8DF;EiBn6DI;IAhDJ,cAAA;IACA,WAAA;EjBs9DA;EiBj6DQ;IAhEN,cAAA;IACA,kBAAA;EjBo+DF;EiBr6DQ;IAhEN,cAAA;IACA,mBAAA;EjBw+DF;EiBz6DQ;IAhEN,cAAA;IACA,UAAA;EjB4+DF;EiB76DQ;IAhEN,cAAA;IACA,mBAAA;EjBg/DF;EiBj7DQ;IAhEN,cAAA;IACA,mBAAA;EjBo/DF;EiBr7DQ;IAhEN,cAAA;IACA,UAAA;EjBw/DF;EiBz7DQ;IAhEN,cAAA;IACA,mBAAA;EjB4/DF;EiB77DQ;IAhEN,cAAA;IACA,mBAAA;EjBggEF;EiBj8DQ;IAhEN,cAAA;IACA,UAAA;EjBogEF;EiBr8DQ;IAhEN,cAAA;IACA,mBAAA;EjBwgEF;EiBz8DQ;IAhEN,cAAA;IACA,mBAAA;EjB4gEF;EiB78DQ;IAhEN,cAAA;IACA,WAAA;EjBghEF;EiBz8DU;IAxDV,cAAA;EjBogEA;EiB58DU;IAxDV,wBAAA;EjBugEA;EiB/8DU;IAxDV,yBAAA;EjB0gEA;EiBl9DU;IAxDV,gBAAA;EjB6gEA;EiBr9DU;IAxDV,yBAAA;EjBghEA;EiBx9DU;IAxDV,yBAAA;EjBmhEA;EiB39DU;IAxDV,gBAAA;EjBshEA;EiB99DU;IAxDV,yBAAA;EjByhEA;EiBj+DU;IAxDV,yBAAA;EjB4hEA;EiBp+DU;IAxDV,gBAAA;EjB+hEA;EiBv+DU;IAxDV,yBAAA;EjBkiEA;EiB1+DU;IAxDV,yBAAA;EjBqiEA;EiBl+DM;;IAEE,gBAAA;EjBo+DR;EiBj+DM;;IAEE,gBAAA;EjBm+DR;EiB1+DM;;IAEE,uBAAA;EjB4+DR;EiBz+DM;;IAEE,uBAAA;EjB2+DR;EiBl/DM;;IAEE,sBAAA;EjBo/DR;EiBj/DM;;IAEE,sBAAA;EjBm/DR;EiB1/DM;;IAEE,qBAAA;EjB4/DR;EiBz/DM;;IAEE,qBAAA;EjB2/DR;EiBlgEM;;IAEE,mBAAA;EjBogER;EiBjgEM;;IAEE,mBAAA;EjBmgER;EiB1gEM;;IAEE,qBAAA;EjB4gER;EiBzgEM;;IAEE,qBAAA;EjB2gER;EiBlhEM;;IAEE,mBAAA;EjBohER;EiBjhEM;;IAEE,mBAAA;EjBmhER;EiB1hEM;;IAEE,qBAAA;EjB4hER;EiBzhEM;;IAEE,qBAAA;EjB2hER;EiBliEM;;IAEE,mBAAA;EjBoiER;EiBjiEM;;IAEE,mBAAA;EjBmiER;EiB1iEM;;IAEE,qBAAA;EjB4iER;EiBziEM;;IAEE,qBAAA;EjB2iER;EiBljEM;;IAEE,mBAAA;EjBojER;EiBjjEM;;IAEE,mBAAA;EjBmjER;EiB1jEM;;IAEE,mBAAA;EjB4jER;EiBzjEM;;IAEE,mBAAA;EjB2jER;EiBlkEM;;IAEE,mBAAA;EjBokER;EiBjkEM;;IAEE,mBAAA;EjBmkER;EiB1kEM;;IAEE,qBAAA;EjB4kER;EiBzkEM;;IAEE,qBAAA;EjB2kER;EiBllEM;;IAEE,mBAAA;EjBolER;EiBjlEM;;IAEE,mBAAA;EjBmlER;AACF;AkBzsEA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,wCAAA;EACA,mBAAA;EACA,gCAAA;EACA,iCAAA;EACA,gDAAA;EACA,8BAAA;EACA,+CAAA;EACA,6DAAA;EACA,8CAAA;EACA,2CAAA;EAEA,WAAA;EACA,mBhB8eO;EgB7eP,mBVusB4B;EUtsB5B,0CAAA;AlBwsEF;AkBjsEE;EACE,0BAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CV+sB0B;EU9sB1B,2GAAA;AlBksEJ;AkB/rEE;EACE,uBAAA;AlBisEJ;AkB9rEE;EACE,sBAAA;AlBgsEJ;;AkB5rEA;EACE,+DAAA;AlB+rEF;;AkBxrEA;EACE,iBAAA;AlB2rEF;;AkBjrEE;EACE,uBAAA;AlBorEJ;;AkBrqEE;EACE,sCAAA;AlBwqEJ;AkBrqEI;EACE,sCAAA;AlBuqEN;;AkBhqEE;EACE,sBAAA;AlBmqEJ;AkBhqEE;EACE,mBAAA;AlBkqEJ;;AkBxpEE;EACE,oDAAA;EACA,8CAAA;AlB2pEJ;;AkBrpEE;EACE,oDAAA;EACA,8CAAA;AlBwpEJ;;AkBhpEA;EACE,oDAAA;EACA,8CAAA;AlBmpEF;;AkB3oEE;EACE,mDAAA;EACA,6CAAA;AlB8oEJ;;AmB1xEE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBsxEJ;;AmBxyEE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBoyEJ;;AmBtzEE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBkzEJ;;AmBp0EE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBg0EJ;;AmBl1EE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB80EJ;;AmBh2EE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB41EJ;;AmB92EE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB02EJ;;AmB53EE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBw3EJ;;AkBvuEI;EACE,gBAAA;EACA,iCAAA;AlB0uEN;;AGr0EI;EeyFA;IACE,gBAAA;IACA,iCAAA;ElBgvEJ;AACF;AG50EI;EeyFA;IACE,gBAAA;IACA,iCAAA;ElBsvEJ;AACF;AGl1EI;EeyFA;IACE,gBAAA;IACA,iCAAA;ElB4vEJ;AACF;AGx1EI;EeyFA;IACE,gBAAA;IACA,iCAAA;ElBkwEJ;AACF;AG91EI;EeyFA;IACE,gBAAA;IACA,iCAAA;ElBwwEJ;AACF;AoB56EA;EACE,sBlBgyByB;EItgBrB,mBALI;AN0pEV;;AoBt6EA;EACE,kDAAA;EACA,qDAAA;EACA,gBAAA;Ed8QI,kBALI;EcrQR,yBlB8xBkB;AFyoDpB;;AoBn6EA;EACE,qDAAA;EACA,wDAAA;EdoQI,oBALI;ANwqEV;;AoBn6EA;EACE,oDAAA;EACA,uDAAA;Ed8PI,oBALI;AN8qEV;;AqBp8EA;EACE,kBnB6xBqB;EIngBjB,oBALI;EejRR,gCb+1BsC;ARsmDxC;;AsB18EA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;EhBwRI,mBALI;EgBhRR,gBdkmB4B;EcjmB5B,yBpBwyBkB;EoBvyBlB,cpBKc;EoBJd,gBAAA;EACA,6BpBwyBS;EoBvyBT,4BAAA;EACA,4CAAA;EbGE,gBAAA;EcHE,wEDMJ;AtBw8EF;AuB18EM;EDhBN;ICiBQ,gBAAA;EvB68EN;AACF;AsB38EE;EACE,gBAAA;AtB68EJ;AsB38EI;EACE,eAAA;AtB68EN;AsBx8EE;EACE,cpBjBY;EoBkBZ,6BpBmxBO;EoBlxBP,qBpBkOY;EoBjOZ,UAAA;EAKE,gBpBkxBmB;AForDzB;AsBl8EE;EAME,eAAA;EAMA,sBAAA;EAKA,SAAA;AtBs7EJ;AsBj7EE;EACE,cAAA;EACA,UAAA;AtBm7EJ;AsB/6EE;EACE,6BpB6vBsB;EoB3vBtB,UAAA;AtBg7EJ;AsBx6EE;EAEE,yBpBpDa;EoBuDb,UAAA;AtBu6EJ;AsBn6EE;EACE,yBAAA;EACA,0BAAA;EACA,4BpBwsBc;EoBvsBd,cpBjFY;EsBbd,uChBqiCgC;Ecr8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CdgsB0B;Ec/rB1B,gBAAA;ECzFE,qID0FF;AtBq6EJ;AuB3/EM;ED0EJ;ICzEM,gBAAA;EvB8/EN;AACF;AsBv6EE;EACE,wCd47B8B;AR6+ClC;;AsBh6EA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBpBurBkB;EoBtrBlB,2Bd2xBsC;Ec1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;AtBm6EF;AsBj6EE;EACE,UAAA;AtBm6EJ;AsBh6EE;EAEE,gBAAA;EACA,eAAA;AtBi6EJ;;AsBt5EA;EACE,mBpB6rBgB;EoB5rBhB,2BAAA;EhByII,oBALI;EGvQN,gBAAA;AT8hFJ;AsBv5EE;EACE,2BAAA;EACA,4BAAA;EACA,4BpB4oBc;AF6wDlB;;AsBr5EA;EACE,oBpBirBgB;EoBhrBhB,4BAAA;EhB4HI,oBALI;EGvQN,gBAAA;AT0iFJ;AsBt5EE;EACE,4BAAA;EACA,6BAAA;EACA,4BpB+nBc;AFyxDlB;;AsBh5EE;EACE,kBpB8pBW;AFqvDf;AsBh5EE;EACE,mBpB2pBc;AFuvDlB;AsB/4EE;EACE,oBpBwpBc;AFyvDlB;;AsB54EA;EACE,WdquBsC;EcpuBtC,cpB+oBa;EoB9oBb,epBqmBgB;AF0yDlB;AsB74EE;EACE,eAAA;AtB+4EJ;AsB54EE;EACE,oBAAA;EbvLA,gBAAA;ATskFJ;AsB34EE;EACE,oBAAA;Eb5LA,gBAAA;AT0kFJ;AsB14EE;EAAoB,epB+nBJ;AF8wDlB;AsB54EE;EAAoB,gBpB+nBJ;AFgxDlB;;AyB9lFA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,wCAAA;EnBqRI,mBALI;EmB7QR,gBjB+lB4B;EiB9lB5B,yBvBqyBkB;EuBpyBlB,cvBEc;EuBDd,gBAAA;EACA,6BvBqyBS;EuBpyBT,mFAAA;EACA,4BAAA;EACA,0CvBw8BwB;EuBv8BxB,0BvBw8BoB;EuBv8BpB,4CAAA;EhBHE,gBAAA;EcHE,wEESJ;AzB8lFF;AuBnmFM;EEfN;IFgBQ,gBAAA;EvBsmFN;AACF;AyBjmFE;EACE,qBvB0OY;EuBzOZ,UAAA;EAKE,gBvB0xBmB;AFq0DzB;AyB3lFE;EAEE,wBvBiwBc;EuBhwBd,sBAAA;AzB4lFJ;AyBzlFE;EAEE,yBvBXa;AFqmFjB;AyBrlFE;EACE,kBAAA;EACA,0BAAA;AzBulFJ;;AyBnlFA;EACE,qBvBivBmB;EuBhvBnB,wBvBgvBmB;EuB/uBnB,uBvB6uBgB;EI1gBZ,oBALI;EGvQN,gBAAA;ATioFJ;;AyBnlFA;EACE,sBvB4uBmB;EuB3uBnB,yBvB2uBmB;EuB1uBnB,uBvBquBgB;EI1gBZ,oBALI;EGvQN,gBAAA;ATyoFJ;;A0BxpFA;EACE,cAAA;EACA,mBlBq6BwC;EkBp6BxC,sBxB21ByB;EwB11BzB,mBxB21ByB;AFg0D3B;A0BzpFE;EACE,WAAA;EACA,sBAAA;A1B2pFJ;;A0BvpFA;EACE,uBxBi1ByB;EwBh1BzB,eAAA;EACA,iBAAA;A1B0pFF;A0BxpFE;EACE,YAAA;EACA,uBAAA;EACA,cAAA;A1B0pFJ;;A0BtpFA;EACE,wBAAA;EAEA,cAAA;EACA,exBi0BuB;EwBh0BvB,gBxBg0BuB;EwB/zBvB,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,yBxBi0BwB;EwBh0BxB,iCAAA;UAAA,yBAAA;EH3BI,4GG4BJ;A1BwpFF;AuBhrFM;EGQN;IHPQ,gBAAA;EvBmrFN;AACF;A0B3pFE;EjB3BE,gBAAA;ATyrFJ;A0B1pFE;EAEE,kBlBm4BsC;ARwxD1C;A0BxpFE;EACE,uBlB03BsC;ARgyD1C;A0BvpFE;EACE,qBxB0MY;EwBzMZ,UAAA;EACA,gBxByzBgC;AFg2DpC;A0BtpFE;EACE,sBxB3DI;EwB4DJ,qBxB3Ba;AFmrFjB;A0BtpFI;EAII,iEAAA;A1BqpFR;A0BjpFI;EAII,iEAAA;A1BgpFR;A0B3oFE;EACE,sBxBhFI;EwBiFJ,qBxBhDa;EwBqDX,iEAAA;A1ByoFN;A0BroFE;EACE,oBAAA;EACA,YAAA;EACA,UxBgxBgC;AFu3DpC;A0BhoFI;EACE,eAAA;EACA,YxBwwB8B;AF03DpC;;A0B7nFA;EACE,6BxBsvBuB;EwBrvBvB,exBgvBwB;AFg5D1B;;A0BznFA;EACE,qBxBqzB0B;AFu0D5B;A0B1nFE;EACE,4DAAA;EAEA,cxB+yBgB;EwB9yBhB,qBAAA;EACA,0CAAA;EACA,gCAAA;EjBjHA,sBAAA;EcHE,mJGsHF;A1B2nFJ;AuB7uFM;EG0GJ;IHzGM,gBAAA;EvBgvFN;AACF;A0B9nFI;EACE,4DAAA;A1BgoFN;A0B7nFI;EACE,iClB60B4B;EkBx0B1B,4DAAA;A1B2nFR;A0BtnFE;EACE,sBxByxBwB;EwBxxBxB,eAAA;A1BwnFJ;A0BtnFI;EACE,sBAAA;EACA,cAAA;A1BwnFN;;A0BnnFA;EACE,qBAAA;EACA,uBxBqtB6B;AFi6D/B;;A0BnnFA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A1BsnFF;A0BlnFI;EACE,oBAAA;EACA,YAAA;EACA,YxBqmCiB;AF+gDvB;;A2B/xFA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A3BkyFF;A2BhyFE;EACE,UAAA;A3BkyFJ;A2B9xFI;EAA0B,gCnB8gCa;ARmxD3C;A2BhyFI;EAA0B,gCnB6gCa;ARsxD3C;A2BhyFE;EACE,SAAA;A3BkyFJ;A2B/xFE;EACE,WnB+/BuC;EmB9/BvC,YnB8/BuC;EmB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBtBWc;EyBiBZ,SnB6/BuC;EC1gCvC,mBAAA;EcHE,oHImBF;EJnBE,4GImBF;A3BgyFJ;AuB/yFM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EvBkzFN;AACF;A2BnyFI;EHjCF,yBhB8hCyC;ARyyD3C;A2BjyFE;EACE,WnBw+B8B;EmBv+B9B,cnBw+B8B;EmBv+B9B,kBAAA;EACA,enBu+B8B;EmBt+B9B,wCnBu+B8B;EmBt+B9B,yBAAA;ElB7BA,mBAAA;ATi0FJ;A2B/xFE;EACE,WnBo+BuC;EmBn+BvC,YnBm+BuC;EmBl+BvC,gBAAA;EHpDF,yBtBWc;EyB2CZ,SnBm+BuC;EC1gCvC,mBAAA;EcHE,iHI6CF;EJ7CE,4GI6CF;A3BgyFJ;AuBz0FM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EvB40FN;AACF;A2BnyFI;EH3DF,yBhB8hCyC;ARm0D3C;A2BjyFE;EACE,WnB88B8B;EmB78B9B,cnB88B8B;EmB78B9B,kBAAA;EACA,enB68B8B;EmB58B9B,wCnB68B8B;EmB58B9B,yBAAA;ElBvDA,mBAAA;AT21FJ;A2B/xFE;EACE,oBAAA;A3BiyFJ;A2B/xFI;EACE,2CnBg9BqC;ARi1D3C;A2B9xFI;EACE,2CnB48BqC;ARo1D3C;;A4Bv3FA;EACE,kBAAA;A5B03FF;A4Bx3FE;;;EAGE,uDpBwiCoC;EoBviCpC,2DpBuiCoC;EoBtiCpC,iBpBuiCoC;ARm1DxC;A4Bv3FE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELRE,gEKSF;A5By3FJ;AuB93FM;EKTJ;ILUM,gBAAA;EvBi4FN;AACF;A4B33FE;;EAEE,uBAAA;A5B63FJ;A4B33FI;;EACE,kBAAA;A5B83FN;A4B33FI;;;EAEE,qBpB4gCkC;EoB3gClC,wBpB4gCkC;ARk3DxC;A4B33FI;;EACE,qBpBugCkC;EoBtgClC,wBpBugCkC;ARu3DxC;A4B13FE;EACE,qBpBigCoC;EoBhgCpC,wBpBigCoC;AR23DxC;A4Br3FI;;;;EACE,2CAAA;EACA,8DpB2/BkC;AR+3DxC;A4Bx3FM;;;;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,apBm/BgC;EoBl/BhC,WAAA;EACA,6B1BmvBG;EOnyBP,gBAAA;AT86FJ;A4Bv3FI;EACE,2CAAA;EACA,8DpB0+BkC;AR+4DxC;A4Bp3FI;EACE,sCAAA;A5Bs3FN;A4Bl3FE;;EAEE,cpB1EO;AR87FX;A4Bl3FI;;EACE,yB1BxDW;AF66FjB;;A6B58FA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A7B+8FF;A6B78FE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A7B+8FJ;A6B38FE;;;EAGE,UAAA;A7B68FJ;A6Bv8FE;EACE,kBAAA;EACA,UAAA;A7By8FJ;A6Bv8FI;EACE,UAAA;A7By8FN;;A6B97FA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EvB8OI,mBALI;EuBvOR,gBrByjB4B;EqBxjB5B,yB3B+vBkB;E2B9vBlB,6B3BqyBwB;E2BpyBxB,kBAAA;EACA,mBAAA;EACA,yB3BpBe;E2BqBf,4CAAA;EpBtCE,gBAAA;ATw+FJ;;A6Bx7FA;;;;EAIE,4BAAA;EvBwNI,oBALI;EGvQN,gBAAA;ATi/FJ;;A6Bx7FA;;;;EAIE,2BAAA;EvB+MI,oBALI;EGvQN,gBAAA;AT0/FJ;;A6Bx7FA;;EAEE,wBAAA;A7B27FF;;A6B96FI;;;;EpBjEA,0BAAA;EACA,6BAAA;ATs/FJ;A6B76FI;;;;EpB1EA,0BAAA;EACA,6BAAA;AT6/FJ;A6Bv6FE;EACE,8CAAA;EpB1EA,yBAAA;EACA,4BAAA;ATo/FJ;A6Bv6FE;;EpB9EE,yBAAA;EACA,4BAAA;ATy/FJ;;A8BjhGE;EACE,aAAA;EACA,WAAA;EACA,kB5BqwBmB;EIngBjB,oBALI;EwB1PN,iCtBkjCqB;ARi+DzB;;A8BhhGE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;ExBqPE,kBALI;EwB7ON,WtBqiCqB;EsBpiCrB,mCtBoiCqB;EC/jCrB,wBAAA;AT8iGJ;;A8B9gGI;;;;EAEE,cAAA;A9BmhGN;;A8BlkGI;EAqDE,+CtBuhCmB;EsBphCjB,0CtB81BgC;EsB71BhC,yDAAA;EACA,4BAAA;EACA,mEAAA;EACA,4EAAA;A9B+gGR;A8B5gGM;EACE,+CtB4gCiB;EsB3gCjB,2DtB2gCiB;ARmgEzB;;A8B/kGI;EA0EI,0CtB40BgC;EsB30BhC,kGAAA;A9BygGR;;A8BplGI;EAkFE,+CtB0/BmB;AR4gEzB;A8BngGQ;EAEE,iEAAA;EACA,yBtB05B8B;EsBz5B9B,gEAAA;EACA,qCAAA;A9BogGV;A8BhgGM;EACE,+CtB6+BiB;EsB5+BjB,2DtB4+BiB;ARshEzB;;A8BlmGI;EAwGI,+CAAA;A9B8/FR;;A8BtmGI;EA+GE,+CtB69BmB;AR8hEzB;A8Bz/FM;EACE,4CtB09BiB;ARiiEzB;A8Bx/FM;EACE,2DtBs9BiB;ARoiEzB;A8Bv/FM;EACE,iCtBk9BiB;ARuiEzB;;A8Bp/FI;EACE,kBAAA;A9Bu/FN;;A8BvnGI;;;;;EA0IM,UAAA;A9Bq/FV;;A8B3mGE;EACE,aAAA;EACA,WAAA;EACA,kB5BqwBmB;EIngBjB,oBALI;EwB1PN,mCtBkjCqB;AR2jEzB;;A8B1mGE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;ExBqPE,kBALI;EwB7ON,WtBqiCqB;EsBpiCrB,kCtBoiCqB;EC/jCrB,wBAAA;ATwoGJ;;A8BxmGI;;;;EAEE,cAAA;A9B6mGN;;A8B5pGI;EAqDE,iDtBuhCmB;EsBphCjB,0CtB81BgC;EsB71BhC,yDAAA;EACA,4BAAA;EACA,mEAAA;EACA,4EAAA;A9BymGR;A8BtmGM;EACE,iDtB4gCiB;EsB3gCjB,0DtB2gCiB;AR6lEzB;;A8BzqGI;EA0EI,0CtB40BgC;EsB30BhC,kGAAA;A9BmmGR;;A8B9qGI;EAkFE,iDtB0/BmB;ARsmEzB;A8B7lGQ;EAEE,iEAAA;EACA,yBtB05B8B;EsBz5B9B,gEAAA;EACA,qCAAA;A9B8lGV;A8B1lGM;EACE,iDtB6+BiB;EsB5+BjB,0DtB4+BiB;ARgnEzB;;A8B5rGI;EAwGI,+CAAA;A9BwlGR;;A8BhsGI;EA+GE,iDtB69BmB;ARwnEzB;A8BnlGM;EACE,8CtB09BiB;AR2nEzB;A8BllGM;EACE,0DtBs9BiB;AR8nEzB;A8BjlGM;EACE,mCtBk9BiB;ARioEzB;;A8B9kGI;EACE,kBAAA;A9BilGN;;A8BjtGI;;;;;EA4IM,UAAA;A9B6kGV;;A+B3tGA;EAEE,2BAAA;EACA,6BAAA;EACA,sBAAA;EzBuRI,4BALI;EyBhRR,yBAAA;EACA,uBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,iCAAA;EACA,wCAAA;EACA,4FAAA;EACA,8BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;EzBsQI,kCALI;EyB/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EtBjBE,0CAAA;EefF,kCOkCqB;ERtBjB,qIQwBJ;A/BwtGF;AuB5uGM;EQhBN;IRiBQ,gBAAA;EvB+uGN;AACF;A+B3tGE;EACE,gCAAA;EACA,qBAAA;EACA,wCAAA;EACA,8CAAA;A/B6tGJ;A+B1tGE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A/B2tGJ;A+BxtGE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A/BstGN;A+BltGE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A/BgtGN;A+B5sGE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A/BwsGJ;A+BrsGI;EAKI,0CAAA;A/BmsGR;A+B9rGE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A/B6rGJ;;A+BjrGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC2xGF;;A+BlsGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC4yGF;;A+BntGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC6zGF;;A+BpuGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC80GF;;A+BrvGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC+1GF;;A+BtwGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCg3GF;;A+BvxGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCi4GF;;A+BxyGE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCk5GF;;A+B/xGE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC04GF;;A+BhzGE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC25GF;;A+Bj0GE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC46GF;;A+Bl1GE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC67GF;;A+Bn2GE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC88GF;;A+Bp3GE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC+9GF;;A+Br4GE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCg/GF;;A+Bt5GE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCigHF;;A+B35GA;;;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,sCAAA;EAEA,qB7BkbgB;AF6+FlB;A+B15GE;;;;;EAEE,0B7B4aoB;AFm/FxB;A+B55GE;;;EACE,0BAAA;A/Bg6GJ;A+B75GE;;;EACE,gCAAA;A/Bi6GJ;;A+Bt5GA;ECxIE,0BAAA;EACA,6BAAA;E1B8NI,6BALI;E0BvNR,iCAAA;AhCkiHF;;A+Bz5GA;EC5IE,6BAAA;EACA,4BAAA;E1B8NI,6BALI;E0BvNR,iCAAA;AhCyiHF;;AiC5mHA;EVgBM,gCUfJ;AjC+mHF;AuB5lHM;EUpBN;IVqBQ,gBAAA;EvB+lHN;AACF;AiClnHE;EACE,UAAA;AjConHJ;;AiC9mHE;EACE,aAAA;AjCinHJ;;AiC7mHA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AjCgnHF;AuB9mHM;EULN;IVMQ,gBAAA;EvBinHN;AACF;AiCnnHE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AjCqnHJ;AuBxnHM;EUAJ;IVCM,gBAAA;EvB2nHN;AACF;;AkChpHA;;;;;;EAME,kBAAA;AlCmpHF;;AkChpHA;EACE,mBAAA;AlCmpHF;AmC3nHI;EACE,qBAAA;EACA,oB3B6hBwB;E2B5hBxB,uB3B2hBwB;E2B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AnCmqHF;AmCzmHI;EACE,cAAA;AnC2mHN;;AkCzpHA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E5BuQI,iCALI;E4BhQR,2CAAA;EACA,mCAAA;EACA,8DAAA;EACA,8BAAA;EACA,6BAAA;EACA,8CAAA;EACA,iCAAA;EACA,sCAAA;EACA,kEAAA;EACA,gDAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;EACA,qCAAA;EACA,wDAAA;EACA,uCAAA;EACA,oCAAA;EACA,mCAAA;EACA,yCAAA;EACA,uCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E5B0OI,uCALI;E4BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;EzBzCE,+CAAA;ATmsHJ;AkCtpHE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AlCwpHJ;;AkChoHI;EACE,oBAAA;AlCmoHN;AkCjoHM;EACE,WAAA;EACA,OAAA;AlCmoHR;;AkC/nHI;EACE,kBAAA;AlCkoHN;AkChoHM;EACE,QAAA;EACA,UAAA;AlCkoHR;;AG5qHI;E+B4BA;IACE,oBAAA;ElCopHJ;EkClpHI;IACE,WAAA;IACA,OAAA;ElCopHN;EkChpHE;IACE,kBAAA;ElCkpHJ;EkChpHI;IACE,QAAA;IACA,UAAA;ElCkpHN;AACF;AG7rHI;E+B4BA;IACE,oBAAA;ElCoqHJ;EkClqHI;IACE,WAAA;IACA,OAAA;ElCoqHN;EkChqHE;IACE,kBAAA;ElCkqHJ;EkChqHI;IACE,QAAA;IACA,UAAA;ElCkqHN;AACF;AG7sHI;E+B4BA;IACE,oBAAA;ElCorHJ;EkClrHI;IACE,WAAA;IACA,OAAA;ElCorHN;EkChrHE;IACE,kBAAA;ElCkrHJ;EkChrHI;IACE,QAAA;IACA,UAAA;ElCkrHN;AACF;AG7tHI;E+B4BA;IACE,oBAAA;ElCosHJ;EkClsHI;IACE,WAAA;IACA,OAAA;ElCosHN;EkChsHE;IACE,kBAAA;ElCksHJ;EkChsHI;IACE,QAAA;IACA,UAAA;ElCksHN;AACF;AG7uHI;E+B4BA;IACE,oBAAA;ElCotHJ;EkCltHI;IACE,WAAA;IACA,OAAA;ElCotHN;EkChtHE;IACE,kBAAA;ElCktHJ;EkChtHI;IACE,QAAA;IACA,UAAA;ElCktHN;AACF;AkCzsHE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AlC2sHJ;AmC/xHI;EACE,qBAAA;EACA,oB3B6hBwB;E2B5hBxB,uB3B2hBwB;E2B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AnCg0HF;AmC7wHI;EACE,cAAA;AnC+wHN;;AkC/sHE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AlCktHJ;AmCpzHI;EACE,qBAAA;EACA,oB3B6hBwB;E2B5hBxB,uB3B2hBwB;E2B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AnC80HF;AmClyHI;EACE,cAAA;AnCoyHN;AkC1tHI;EACE,iBAAA;AlC4tHN;;AkCttHE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AlCytHJ;AmC50HI;EACE,qBAAA;EACA,oB3B6hBwB;E2B5hBxB,uB3B2hBwB;E2B1hBxB,WAAA;AnC80HN;AmCn0HM;EACE,aAAA;AnCq0HR;AmCl0HM;EACE,qBAAA;EACA,qB3B0gBsB;E2BzgBtB,uB3BwgBsB;E2BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AnCw2HF;AmCl0HI;EACE,cAAA;AnCo0HN;AkCzuHI;EACE,iBAAA;AlC2uHN;;AkCpuHA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AlCuuHF;;AkCjuHA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB1Byb4B;E0Bxb5B,oCAAA;EACA,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;EzBtKE,uDAAA;AT04HJ;AkCjuHE;EAEE,0CAAA;EACA,qBAAA;EV3LF,kDU4LuB;AlCkuHzB;AkC/tHE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AlCguHzB;AkC7tHE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AlC8tHJ;;AkCxtHA;EACE,cAAA;AlC2tHF;;AkCvtHA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E5BmEI,mBALI;E4B5DR,sCAAA;EACA,mBAAA;AlC0tHF;;AkCttHA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AlCytHF;;AkCrtHA;EAEE,8CAAA;EACA,yBAAA;EACA,8DAAA;EACA,kEAAA;EACA,mDAAA;EACA,oCAAA;EACA,iCAAA;EACA,oCAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AlCutHF;;AoC78HA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ApCg9HF;AoC98HE;;EACE,kBAAA;EACA,cAAA;ApCi9HJ;AoC58HE;;;;;;;;;;;;EAME,UAAA;ApCo9HJ;;AoC/8HA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ApCk9HF;AoCh9HE;EACE,WAAA;ApCk9HJ;;AoC98HA;E3BhBI,wBAAA;ATk+HJ;AoC98HE;;EAEE,8CAAA;ApCg9HJ;AoC58HE;;;E3BVE,0BAAA;EACA,6BAAA;AT29HJ;AoCx8HE;;;E3BNE,yBAAA;EACA,4BAAA;ATm9HJ;;AoC37HA;EACE,wBAAA;EACA,uBAAA;ApC87HF;AoC57HE;EAGE,cAAA;ApC47HJ;AoCz7HE;EACE,eAAA;ApC27HJ;;AoCv7HA;EACE,yBAAA;EACA,wBAAA;ApC07HF;;AoCv7HA;EACE,0BAAA;EACA,yBAAA;ApC07HF;;AoCt6HA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ApCy6HF;AoCv6HE;;EAEE,WAAA;ApCy6HJ;AoCt6HE;;EAEE,6CAAA;ApCw6HJ;AoCp6HE;;E3B1FE,6BAAA;EACA,4BAAA;ATkgIJ;AoCp6HE;;E3B7GE,yBAAA;EACA,0BAAA;ATqhIJ;;AqC7iIA;EAEE,gCAAA;EACA,+BAAA;E/BuRI,iCALI;E+BhRR,2BAAA;EACA,2CAAA;EACA,kCAAA;EACA,mDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArC6iIF;;AqC1iIA;EACE,cAAA;EACA,kEAAA;E/BsQI,uCALI;E+B/PR,2CAAA;EACA,+BAAA;EAEA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ArC4iIF;AuBxjIM;EcGN;IdFQ,gBAAA;EvB2jIN;AACF;AqC/iIE;EAEE,qCAAA;EACA,qBAAA;ArCgjIJ;AqC7iIE;EACE,UAAA;EACA,gBnC8+BwB;AFikG5B;AqC3iIE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ArC4iIJ;;AqCpiIA;EAEE,kDAAA;EACA,mCAAA;EACA,8BAAA;EACA,kEAAA;EACA,uDAAA;EACA,+CAAA;EACA,mEAAA;EAGA,oFAAA;ArCoiIF;AqCliIE;EACE,yDAAA;EACA,yDAAA;E5B7CA,wDAAA;EACA,yDAAA;ATklIJ;AqCniII;EAGE,kBAAA;EACA,wDAAA;ArCmiIN;AqC/hIE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ArCiiIJ;AqC9hIE;EAEE,sDAAA;E5BjEA,yBAAA;EACA,0BAAA;ATimIJ;;AqCthIA;EAEE,+BAAA;EACA,2DAAA;EACA,sCAAA;ArCwhIF;AqCrhIE;E5B5FE,gDAAA;ATonIJ;AqCphIE;;EAEE,4CAAA;EbjHF,oDakHuB;ArCshIzB;;AqC7gIA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ArC6gIF;AqC3gIE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ArC6gIJ;AqC3gII;EAEE,iCAAA;ArC4gIN;AqCxgIE;;EAEE,gB7B0d0B;E6Bzd1B,gDAAA;EACA,iCAAA;ArC0gIJ;;AqChgIE;;EAEE,cAAA;EACA,kBAAA;ArCmgIJ;;AqC9/HE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;ArCigIJ;;AqC3/HE;;EACE,WAAA;ArC+/HJ;;AqCr/HE;EACE,aAAA;ArCw/HJ;AqCt/HE;EACE,cAAA;ArCw/HJ;;AsCrrIA;EAEE,wBAAA;EACA,gCAAA;EACA,yCAAA;EACA,gCAAA;EACA,mEAAA;EACA,gDAAA;EACA,8BAAA;EACA,uCAAA;EACA,iCAAA;EACA,gCAAA;EACA,qDAAA;EACA,wCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,oEAAA;EACA,0EAAA;EACA,4CAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AtCqrIF;AsC/qIE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AtCurIJ;AsCnqIA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EhC4NI,2CALI;EgCrNR,mCAAA;EAEA,mBAAA;AtCoqIF;AsClqIE;EAEE,yCAAA;EACA,qBAAA;AtCmqIJ;;AsC1pIA;EAEE,0BAAA;EACA,+BAAA;EhCuMI,iCALI;EgChMR,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtC0pIF;AsCvpII;EAEE,oCAAA;AtCwpIN;AsCppIE;EACE,gBAAA;AtCspIJ;;AsC7oIA;EACE,mBpC05BmB;EoCz5BnB,sBpCy5BmB;EoCx5BnB,6BAAA;AtCgpIF;AsC9oIE;;;EAGE,oCAAA;AtCgpIJ;;AsCnoIA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AtCooIF;;AsChoIA;EACE,8EAAA;EhCyII,6CALI;EgClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E7BxIE,qDAAA;EcHE,+Ce6IJ;AtCmoIF;AuB5wIM;EeiIN;IfhIQ,gBAAA;EvB+wIN;AACF;AsCtoIE;EACE,qBAAA;AtCwoIJ;AsCroIE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AtCuoIJ;;AsCjoIA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AtCooIF;;AsCjoIA;EACE,yCAAA;EACA,gBAAA;AtCooIF;;AG9vII;EmCsIA;IAEI,iBAAA;IACA,2BAAA;EtC2nIN;EsCznIM;IACE,mBAAA;EtC2nIR;EsCznIQ;IACE,kBAAA;EtC2nIV;EsCxnIQ;IACE,kDAAA;IACA,iDAAA;EtC0nIV;EsCtnIM;IACE,iBAAA;EtCwnIR;EsCrnIM;IACE,wBAAA;IACA,gBAAA;EtCunIR;EsCpnIM;IACE,aAAA;EtCsnIR;EsCnnIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCmnIR;EsChnIQ;IACE,aAAA;EtCknIV;EsC/mIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCinIV;AACF;AG9yII;EmCsIA;IAEI,iBAAA;IACA,2BAAA;EtC0qIN;EsCxqIM;IACE,mBAAA;EtC0qIR;EsCxqIQ;IACE,kBAAA;EtC0qIV;EsCvqIQ;IACE,kDAAA;IACA,iDAAA;EtCyqIV;EsCrqIM;IACE,iBAAA;EtCuqIR;EsCpqIM;IACE,wBAAA;IACA,gBAAA;EtCsqIR;EsCnqIM;IACE,aAAA;EtCqqIR;EsClqIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCkqIR;EsC/pIQ;IACE,aAAA;EtCiqIV;EsC9pIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCgqIV;AACF;AG71II;EmCsIA;IAEI,iBAAA;IACA,2BAAA;EtCytIN;EsCvtIM;IACE,mBAAA;EtCytIR;EsCvtIQ;IACE,kBAAA;EtCytIV;EsCttIQ;IACE,kDAAA;IACA,iDAAA;EtCwtIV;EsCptIM;IACE,iBAAA;EtCstIR;EsCntIM;IACE,wBAAA;IACA,gBAAA;EtCqtIR;EsCltIM;IACE,aAAA;EtCotIR;EsCjtIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCitIR;EsC9sIQ;IACE,aAAA;EtCgtIV;EsC7sIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtC+sIV;AACF;AG54II;EmCsIA;IAEI,iBAAA;IACA,2BAAA;EtCwwIN;EsCtwIM;IACE,mBAAA;EtCwwIR;EsCtwIQ;IACE,kBAAA;EtCwwIV;EsCrwIQ;IACE,kDAAA;IACA,iDAAA;EtCuwIV;EsCnwIM;IACE,iBAAA;EtCqwIR;EsClwIM;IACE,wBAAA;IACA,gBAAA;EtCowIR;EsCjwIM;IACE,aAAA;EtCmwIR;EsChwIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCgwIR;EsC7vIQ;IACE,aAAA;EtC+vIV;EsC5vIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtC8vIV;AACF;AG37II;EmCsIA;IAEI,iBAAA;IACA,2BAAA;EtCuzIN;EsCrzIM;IACE,mBAAA;EtCuzIR;EsCrzIQ;IACE,kBAAA;EtCuzIV;EsCpzIQ;IACE,kDAAA;IACA,iDAAA;EtCszIV;EsClzIM;IACE,iBAAA;EtCozIR;EsCjzIM;IACE,wBAAA;IACA,gBAAA;EtCmzIR;EsChzIM;IACE,aAAA;EtCkzIR;EsC/yIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtC+yIR;EsC5yIQ;IACE,aAAA;EtC8yIV;EsC3yIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtC6yIV;AACF;AsCp2II;EAEI,iBAAA;EACA,2BAAA;AtCq2IR;AsCn2IQ;EACE,mBAAA;AtCq2IV;AsCn2IU;EACE,kBAAA;AtCq2IZ;AsCl2IU;EACE,kDAAA;EACA,iDAAA;AtCo2IZ;AsCh2IQ;EACE,iBAAA;AtCk2IV;AsC/1IQ;EACE,wBAAA;EACA,gBAAA;AtCi2IV;AsC91IQ;EACE,aAAA;AtCg2IV;AsC71IQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;AtC61IV;AsC11IU;EACE,aAAA;AtC41IZ;AsCz1IU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AtC21IZ;;AsC10IA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;AtC40IF;;AuC9lJA;EAEE,2BAAA;EACA,6BAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,+BAAA;EACA,0BAAA;EACA,sBAAA;EACA,gCAAA;EACA,iCAAA;EACA,kCAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,wCAAA;EACA,iCAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E9BjBE,2CAAA;ATgnJJ;AuC3lJE;EACE,eAAA;EACA,cAAA;AvC6lJJ;AuC1lJE;EACE,mBAAA;EACA,sBAAA;AvC4lJJ;AuC1lJI;EACE,mBAAA;E9BtBF,0DAAA;EACA,2DAAA;ATmnJJ;AuC1lJI;EACE,sBAAA;E9BbF,8DAAA;EACA,6DAAA;AT0mJJ;AuCvlJE;;EAEE,aAAA;AvCylJJ;;AuCrlJA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AvCslJF;;AuCnlJA;EACE,4CAAA;EACA,iCAAA;AvCslJF;;AuCnlJA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AvCslJF;;AuCnlJA;EACE,gBAAA;AvCslJF;;AuCllJE;EACE,qBAAA;AvCqlJJ;AuCllJE;EACE,oCAAA;AvColJJ;;AuC5kJA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AvC+kJF;AuC7kJE;E9B7FE,wFAAA;AT6qJJ;;AuC3kJA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AvC8kJF;AuC5kJE;E9BxGE,wFAAA;ATurJJ;;AuCrkJA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AvCwkJF;AuCtkJE;EACE,mCAAA;EACA,sCAAA;AvCwkJJ;;AuCpkJA;EACE,uDAAA;EACA,sDAAA;AvCukJF;;AuCnkJA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E9B1IE,iDAAA;ATitJJ;;AuCnkJA;;;EAGE,WAAA;AvCskJF;;AuCnkJA;;E9B3II,0DAAA;EACA,2DAAA;ATmtJJ;;AuCpkJA;;E9BlII,8DAAA;EACA,6DAAA;AT2sJJ;;AuC7jJE;EACE,0CAAA;AvCgkJJ;AG3rJI;EoCuHJ;IAQI,aAAA;IACA,mBAAA;EvCgkJF;EuC7jJE;IAEE,SAAA;IACA,gBAAA;EvC8jJJ;EuC5jJI;IACE,cAAA;IACA,cAAA;EvC8jJN;EuCzjJM;I9B3KJ,0BAAA;IACA,6BAAA;ETuuJF;EuC1jJQ;;IAGE,0BAAA;EvC2jJV;EuCzjJQ;;IAGE,6BAAA;EvC0jJV;EuCtjJM;I9B5KJ,yBAAA;IACA,4BAAA;ETquJF;EuCvjJQ;;IAGE,yBAAA;EvCwjJV;EuCtjJQ;;IAGE,4BAAA;EvCujJV;AACF;;AwC5xJA;EAEE,6BAAA;EACA,uBAAA;EACA,mDAAA;EACA,oCAAA;EACA,mDAAA;EACA,+BAAA;EACA,2CAAA;EACA,uCAAA;EACA,uCAAA;EACA,iCAAA;EACA,2BAAA;EACA,iEAAA;EACA,qCAAA;EACA,iDAAA;EACA,8DAAA;EACA,wEAAA;EACA,8CAAA;EACA,yCAAA;EACA,sCAAA;EACA,mCAAA;EACA,oCAAA;EACA,8BAAA;AxC8xJF;;AwC1xJA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;ElC2PI,eALI;EkCpPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;E/BtBE,gBAAA;E+BwBF,qBAAA;EjB3BI,0CiB4BJ;AxC6xJF;AuBrzJM;EiBWN;IjBVQ,gBAAA;EvBwzJN;AACF;AwChyJE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AxCkyJJ;AwChyJI;EACE,qDAAA;EACA,iDAAA;AxCkyJN;AwC7xJE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBlDE,mDiBmDF;AxC+xJJ;AuB90JM;EiBsCJ;IjBrCM,gBAAA;EvBi1JN;AACF;AwCjyJE;EACE,UAAA;AxCmyJJ;AwChyJE;EACE,UAAA;EACA,wDAAA;EACA,UAAA;EACA,oDAAA;AxCkyJJ;;AwC9xJA;EACE,gBAAA;AxCiyJF;;AwC9xJA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AxCiyJF;AwC/xJE;E/B/DE,yDAAA;EACA,0DAAA;ATi2JJ;AwChyJI;E/BlEA,+DAAA;EACA,gEAAA;ATq2JJ;AwC/xJE;EACE,aAAA;AxCiyJJ;AwC7xJE;E/B9DE,6DAAA;EACA,4DAAA;AT81JJ;AwC7xJM;E/BlEF,mEAAA;EACA,kEAAA;ATk2JJ;AwC5xJI;E/BvEA,6DAAA;EACA,4DAAA;ATs2JJ;;AwC1xJA;EACE,8EAAA;AxC6xJF;;AwCpxJE;EACE,eAAA;AxCuxJJ;AwCpxJE;EACE,eAAA;EACA,cAAA;E/BpHA,gBAAA;AT24JJ;AwCpxJI;EAAgB,aAAA;AxCuxJpB;AwCtxJI;EAAe,gBAAA;AxCyxJnB;AwCtxJM;E/B3HF,gBAAA;ATo5JJ;;AyCv6JA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EnC2RI,kCALI;EmCpRR,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,wDAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EnC+QI,yCALI;EmCxQR,gBAAA;EACA,yCAAA;EhCAE,iDAAA;ATw6JJ;;AyCl6JE;EACE,iDAAA;AzCq6JJ;AyCn6JI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,sUAAA;AzCq6JN;AyCj6JE;EACE,6CAAA;AzCm6JJ;;A0Cx8JA;EAEE,iCAAA;EACA,mCAAA;EpC4RI,oCALI;EoCrRR,6CAAA;EACA,+BAAA;EACA,+BAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,gDAAA;EACA,0DAAA;EACA,mDAAA;EACA,qCAAA;EACA,sCAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,qDAAA;EACA,wCAAA;EACA,6DAAA;EAGA,aAAA;E/BpBA,eAAA;EACA,gBAAA;AX69JF;;A0Ct8JA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EpCgQI,yCALI;EoCzPR,iCAAA;EAEA,yCAAA;EACA,iFAAA;EnBpBI,gBmBqBJ;A1Cw8JF;A0Ct8JE;EACE,UAAA;EACA,uCAAA;EACA,qBAAA;EACA,+CAAA;EACA,qDAAA;A1Cw8JJ;A0Cr8JE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UlC2uCgC;EkC1uChC,iDAAA;A1Cu8JJ;A0Cp8JE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A1Cq8JJ;A0Cl8JE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A1Cm8JJ;;A0C97JE;EACE,yBlC8sCgC;ARmvHpC;A0C57JM;EjC9BF,0DAAA;EACA,6DAAA;AT69JJ;A0C17JM;EjClDF,2DAAA;EACA,8DAAA;AT++JJ;;A0C76JA;EClGE,iCAAA;EACA,kCAAA;ErC0RI,kCALI;EqCnRR,yDAAA;A3CmhKF;;A0Ch7JA;ECtGE,iCAAA;EACA,kCAAA;ErC0RI,mCALI;EqCnRR,yDAAA;A3C0hKF;;A4C5hKA;EAEE,2BAAA;EACA,2BAAA;EtCuRI,2BALI;EsChRR,8BAAA;EACA,yBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;EtC+QI,oCALI;EsCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EnCJE,4CAAA;ATiiKJ;A4CxhKE;EACE,aAAA;A5C0hKJ;;A4CrhKA;EACE,kBAAA;EACA,SAAA;A5CwhKF;;A6CxjKA;EAEE,0BAAA;EACA,6BAAA;EACA,4BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,mCAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EpCHE,4CAAA;AT4jKJ;;A6CpjKA;EAEE,cAAA;A7CsjKF;;A6CljKA;EACE,gB3CquCuB;E2CpuCvB,iCAAA;A7CqjKF;;A6C7iKA;EACE,sBrCo+C8B;AR4kHhC;A6C7iKE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;A7C+iKJ;;A6CviKE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7C0iKJ;;A6C9iKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A7CijKJ;;A6CrjKE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7CwjKJ;;A6C5jKE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A7C+jKJ;;A6CnkKE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7CskKJ;;A6C1kKE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A7C6kKJ;;A6CjlKE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A7ColKJ;;A6CxlKE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A7C2lKJ;;A8CvpKE;EACE;IAAK,gC5CswCS;EFq5HhB;AACF;A8CvpKA;;EAGE,+BAAA;ExCkRI,kCALI;EwC3QR,yBAAA;EACA,8BAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;ExCsQI,uCALI;EwC/PR,uCAAA;ErCRE,+CAAA;AT+pKJ;;A8ClpKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A9CqpKF;AuB1qKM;EuBYN;IvBXQ,gBAAA;EvB6qKN;AACF;;A8CvpKA;EtBAE,qMAAA;EsBEA,oEAAA;A9C0pKF;;A8CvpKA;EACE,iBAAA;A9C0pKF;;A8CvpKA;EACE,WAAA;A9C0pKF;;A8CtpKE;EACE,kDAAA;A9CypKJ;A8CtpKM;EAJJ;IAKM,eAAA;E9CypKN;AACF;;A+CrtKA;EAEE,6CAAA;EACA,qCAAA;EACA,qCAAA;EACA,oDAAA;EACA,gCAAA;EACA,yCAAA;EACA,iCAAA;EACA,uDAAA;EACA,2CAAA;EACA,wCAAA;EACA,2DAAA;EACA,yCAAA;EACA,uCAAA;EACA,8CAAA;EACA,oDAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EtCXE,iDAAA;AT+tKJ;;A+ChtKA;EACE,qBAAA;EACA,sBAAA;A/CmtKF;A+CjtKE;EAEE,oCAAA;EACA,0BAAA;A/CktKJ;;A+CzsKA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A/C4sKF;A+CzsKE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A/C0sKJ;A+CvsKE;EACE,+CAAA;EACA,uDAAA;A/CysKJ;;A+CjsKA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EAEA,yCAAA;EACA,iFAAA;A/CmsKF;A+CjsKE;EtCvDE,+BAAA;EACA,gCAAA;AT2vKJ;A+CjsKE;EtC7CE,mCAAA;EACA,kCAAA;ATivKJ;A+CjsKE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A/CksKJ;A+C9rKE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A/CgsKJ;A+C5rKE;EACE,mBAAA;A/C8rKJ;A+C5rKI;EACE,wDAAA;EACA,mDAAA;A/C8rKN;;A+CjrKI;EACE,mBAAA;A/CorKN;A+CjrKQ;EtCvDJ,6DAAA;EAZA,0BAAA;ATwvKJ;A+ChrKQ;EtCxEJ,2DAAA;EAYA,4BAAA;ATgvKJ;A+C/qKQ;EACE,aAAA;A/CirKV;A+C9qKQ;EACE,mDAAA;EACA,oBAAA;A/CgrKV;A+C9qKU;EACE,yDAAA;EACA,oDAAA;A/CgrKZ;;AGtwKI;E4C8DA;IACE,mBAAA;E/C4sKJ;E+CzsKM;ItCvDJ,6DAAA;IAZA,0BAAA;ETgxKF;E+CxsKM;ItCxEJ,2DAAA;IAYA,4BAAA;ETwwKF;E+CvsKM;IACE,aAAA;E/CysKR;E+CtsKM;IACE,mDAAA;IACA,oBAAA;E/CwsKR;E+CtsKQ;IACE,yDAAA;IACA,oDAAA;E/CwsKV;AACF;AG/xKI;E4C8DA;IACE,mBAAA;E/CouKJ;E+CjuKM;ItCvDJ,6DAAA;IAZA,0BAAA;ETwyKF;E+ChuKM;ItCxEJ,2DAAA;IAYA,4BAAA;ETgyKF;E+C/tKM;IACE,aAAA;E/CiuKR;E+C9tKM;IACE,mDAAA;IACA,oBAAA;E/CguKR;E+C9tKQ;IACE,yDAAA;IACA,oDAAA;E/CguKV;AACF;AGvzKI;E4C8DA;IACE,mBAAA;E/C4vKJ;E+CzvKM;ItCvDJ,6DAAA;IAZA,0BAAA;ETg0KF;E+CxvKM;ItCxEJ,2DAAA;IAYA,4BAAA;ETwzKF;E+CvvKM;IACE,aAAA;E/CyvKR;E+CtvKM;IACE,mDAAA;IACA,oBAAA;E/CwvKR;E+CtvKQ;IACE,yDAAA;IACA,oDAAA;E/CwvKV;AACF;AG/0KI;E4C8DA;IACE,mBAAA;E/CoxKJ;E+CjxKM;ItCvDJ,6DAAA;IAZA,0BAAA;ETw1KF;E+ChxKM;ItCxEJ,2DAAA;IAYA,4BAAA;ETg1KF;E+C/wKM;IACE,aAAA;E/CixKR;E+C9wKM;IACE,mDAAA;IACA,oBAAA;E/CgxKR;E+C9wKQ;IACE,yDAAA;IACA,oDAAA;E/CgxKV;AACF;AGv2KI;E4C8DA;IACE,mBAAA;E/C4yKJ;E+CzyKM;ItCvDJ,6DAAA;IAZA,0BAAA;ETg3KF;E+CxyKM;ItCxEJ,2DAAA;IAYA,4BAAA;ETw2KF;E+CvyKM;IACE,aAAA;E/CyyKR;E+CtyKM;IACE,mDAAA;IACA,oBAAA;E/CwyKR;E+CtyKQ;IACE,yDAAA;IACA,oDAAA;E/CwyKV;AACF;A+C3xKA;EtChJI,gBAAA;AT86KJ;A+C3xKE;EACE,mDAAA;A/C6xKJ;A+C3xKI;EACE,sBAAA;A/C6xKN;;A+ChxKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/CmxKJ;;A+C7xKE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A/CgyKJ;;A+C1yKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/C6yKJ;;A+CvzKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A/C0zKJ;;A+Cp0KE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/Cu0KJ;;A+Cj1KE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A/Co1KJ;;A+C91KE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A/Ci2KJ;;A+C32KE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A/C82KJ;;AgD1iLA;EAEE,6BAAA;EACA,2DAAA;EACA,2BAAA;EACA,iCAAA;EACA,mEAAA;EACA,iCAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,a9C8kDgB;E8C7kDhB,c9C6kDgB;E8C5kDhB,YAAA;EACA,gCAAA;EACA,2EAAA;EACA,SAAA;EvCJE,wBAAA;EuCMF,oCAAA;AhD0iLF;AgDviLE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AhDyiLJ;AgDtiLE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AhDwiLJ;AgDriLE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;AhDsiLJ;;AgD9hLA;EAHE,wCAAA;AhDqiLF;;AiDtlLA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;E3CyRI,+BALI;E2ClRR,2CAAA;EACA,sBAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,2DAAA;EACA,6BAAA;EACA,iCAAA;EACA,uCAAA;EAGA,gCAAA;EACA,eAAA;E3C2QI,oCALI;E2CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;ExCRE,4CAAA;AT+lLJ;AiDplLE;EACE,UAAA;AjDslLJ;AiDnlLE;EACE,aAAA;AjDqlLJ;;AiDjlLA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AjDmlLF;AiDjlLE;EACE,sCAAA;AjDmlLJ;;AiD/kLA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;ExChCE,0FAAA;EACA,2FAAA;ATmnLJ;AiDjlLE;EACE,oDAAA;EACA,sCAAA;AjDmlLJ;;AiD/kLA;EACE,kCAAA;EACA,qBAAA;AjDklLF;;AkDhpLA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,oCAAA;EACA,0BAAA;EACA,mCAAA;EACA,2DAAA;EACA,yCAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,2CAAA;EACA,iCAAA;EACA,kCAAA;EACA,6BAAA;EACA,sBAAA;EACA,uCAAA;EACA,mCAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AlD8oLF;;AkDvoLA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AlDyoLF;AkDtoLE;E3B5CI,mC2B6CF;EACA,8B1Cg8CgC;ARwsIpC;AuBlrLM;E2BwCJ;I3BvCM,gBAAA;EvBqrLN;AACF;AkD3oLE;EACE,e1C87CgC;AR+sIpC;AkDzoLE;EACE,sB1C27CgC;ARgtIpC;;AkDvoLA;EACE,+CAAA;AlD0oLF;AkDxoLE;EACE,gBAAA;EACA,gBAAA;AlD0oLJ;AkDvoLE;EACE,gBAAA;AlDyoLJ;;AkDroLA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AlDwoLF;;AkDpoLA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EzCrFE,4CAAA;EyCyFF,UAAA;AlDooLF;;AkDhoLA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AlDsoL9D;AmDlvLE;EAAS,UAAA;AnDqvLX;AmDpvLE;EAAS,mCD2GiF;AlD4oL5F;;AkDvoLA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,4FAAA;EzCtGE,2DAAA;EACA,4DAAA;ATivLJ;AkDzoLE;EACE,kGAAA;EACA,sJAAA;AlD2oLJ;;AkDtoLA;EACE,gBAAA;EACA,8CAAA;AlDyoLF;;AkDpoLA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AlDqoLF;;AkDjoLA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;EzC1HE,+DAAA;EACA,8DAAA;AT+vLJ;AkDhoLE;EACE,8CAAA;AlDkoLJ;;AG9uLI;E+CkHF;IACE,0BAAA;IACA,2CAAA;ElDgoLF;EkD5nLA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;ElD8nLF;EkD3nLA;IACE,uBAAA;ElD6nLF;AACF;AG7vLI;E+CoIF;;IAEE,uBAAA;ElD4nLF;AACF;AGnwLI;E+C2IF;IACE,wBAAA;ElD2nLF;AACF;AkDlnLI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AlDonLN;AkDlnLM;EACE,YAAA;EACA,SAAA;EzC1MJ,gBAAA;AT+zLJ;AkDjnLM;;EzC9MF,gBAAA;ATm0LJ;AkDhnLM;EACE,gBAAA;AlDknLR;;AG7wLI;E+CyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDwoLJ;EkDtoLI;IACE,YAAA;IACA,SAAA;IzC1MJ,gBAAA;ETm1LF;EkDroLI;;IzC9MF,gBAAA;ETu1LF;EkDpoLI;IACE,gBAAA;ElDsoLN;AACF;AGlyLI;E+CyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD4pLJ;EkD1pLI;IACE,YAAA;IACA,SAAA;IzC1MJ,gBAAA;ETu2LF;EkDzpLI;;IzC9MF,gBAAA;ET22LF;EkDxpLI;IACE,gBAAA;ElD0pLN;AACF;AGtzLI;E+CyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDgrLJ;EkD9qLI;IACE,YAAA;IACA,SAAA;IzC1MJ,gBAAA;ET23LF;EkD7qLI;;IzC9MF,gBAAA;ET+3LF;EkD5qLI;IACE,gBAAA;ElD8qLN;AACF;AG10LI;E+CyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDosLJ;EkDlsLI;IACE,YAAA;IACA,SAAA;IzC1MJ,gBAAA;ET+4LF;EkDjsLI;;IzC9MF,gBAAA;ETm5LF;EkDhsLI;IACE,gBAAA;ElDksLN;AACF;AG91LI;E+CyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDwtLJ;EkDttLI;IACE,YAAA;IACA,SAAA;IzC1MJ,gBAAA;ETm6LF;EkDrtLI;;IzC9MF,gBAAA;ETu6LF;EkDptLI;IACE,gBAAA;ElDstLN;AACF;AoD77LA;EAEE,yBAAA;EACA,6BAAA;EACA,4BAAA;EACA,gCAAA;EACA,qBAAA;E9CwRI,+BALI;E8CjRR,wBAAA;EACA,wBAAA;EACA,qCAAA;EACA,uBAAA;EACA,kCAAA;EACA,oCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,8LnDopBiB;EmDlpBjB,kBAAA;EACA,gB7CwmB4B;E6CvmB5B,iBnDiqBiB;EmDhqBjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CgRI,sCALI;E8ChQR,qBAAA;EACA,UAAA;ApDq8LF;AoDn8LE;EAAS,kCAAA;ApDs8LX;AoDp8LE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ApDs8LJ;AoDp8LI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApDs8LN;;AoDj8LA;EACE,iDAAA;ApDo8LF;AoDl8LE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;ApDo8LJ;;AoDh8LA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;ApDm8LF;AoDj8LE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;ApDm8LJ;;AoD/7LA,mBAAA;AAEA;EACE,8CAAA;ApDi8LF;AoD/7LE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;ApDi8LJ;;AoD77LA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;ApDg8LF;AoD97LE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;ApDg8LJ;;AoD57LA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E3CjGE,8CAAA;ATghMJ;;AsDniMA;EAEE,yBAAA;EACA,6BAAA;EhD4RI,iCALI;EgDrRR,kCAAA;EACA,8BAAA;EACA,6DAAA;EACA,qCAAA;EACA,uDAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;EhDmRI,mCALI;EgD5QR,kCAAA;EACA,mCAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,mCAAA;EACA,mCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,8LnDopBiB;EmDlpBjB,kBAAA;EACA,gB7CwmB4B;E6CvmB5B,iBnDiqBiB;EmDhqBjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E/CgRI,sCALI;EgD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E7ChBE,8CAAA;AT8jMJ;AsD1iME;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AtD4iMJ;AsD1iMI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AtD2iMN;;AsDriME;EACE,oFAAA;AtDwiMJ;AsDtiMI;EAEE,wFAAA;AtDuiMN;AsDpiMI;EACE,SAAA;EACA,gDAAA;AtDsiMN;AsDniMI;EACE,sCAAA;EACA,sCAAA;AtDqiMN;;AsDhiMA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AtDkiMJ;AsDhiMI;EAEE,kIAAA;AtDiiMN;AsD9hMI;EACE,OAAA;EACA,kDAAA;AtDgiMN;AsD7hMI;EACE,oCAAA;EACA,wCAAA;AtD+hMN;;AsD1hMA,mBAAA;AAGE;EACE,iFAAA;AtD2hMJ;AsDzhMI;EAEE,wFAAA;AtD0hMN;AsDvhMI;EACE,MAAA;EACA,mDAAA;AtDyhMN;AsDthMI;EACE,mCAAA;EACA,yCAAA;AtDwhMN;AsDnhME;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AtDqhMJ;;AsDjhMA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AtDmhMJ;AsDjhMI;EAEE,kIAAA;AtDkhMN;AsD/gMI;EACE,QAAA;EACA,iDAAA;AtDihMN;AsD9gMI;EACE,qCAAA;EACA,uCAAA;AtDghMN;;AsD3gMA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;EhD2GI,6CALI;EgDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E7C5JE,6DAAA;EACA,8DAAA;AT0pMJ;AsD5/LE;EACE,aAAA;AtD8/LJ;;AsD1/LA;EACE,0EAAA;EACA,mCAAA;AtD6/LF;;AuD3rMA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AvD6rMF;;AuDzrMA;EACE;IAAK,0CAAA;EvD6rML;AACF;AuD1rMA;EAEE,wBAAA;EACA,yBAAA;EACA,mCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AvDyrMF;;AuDtrMA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AvDwrMF;;AuD/qMA;EACE;IACE,mBAAA;EvDkrMF;EuDhrMA;IACE,UAAA;IACA,eAAA;EvDkrMF;AACF;AuD9qMA;EAEE,wBAAA;EACA,yBAAA;EACA,mCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AvD6qMF;;AuD1qMA;EACE,wBAAA;EACA,yBAAA;AvD6qMF;;AuDzqME;EACE;;IAEE,kCAAA;EvD4qMJ;AACF;AwD5vMA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,mCAAA;EACA,kCAAA;EACA,0CAAA;EACA,oCAAA;EACA,gCAAA;EACA,oCAAA;EACA,+DAAA;EACA,qDAAA;EACA,sCAAA;AxD6vMF;;AGhsMI;EqD5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IjC5BA,0CiC8BA;ExD8uMJ;AACF;AuBzwMM;EiCYJ;IjCXM,gBAAA;EvB4wMN;AACF;AGttMI;EqD5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;ExDqvMN;EwDlvMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;ExDovMN;EwDjvMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;ExDmvMN;EwDhvMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;ExDkvMN;EwD/uMI;IAEE,eAAA;ExDgvMN;EwD7uMI;IAGE,mBAAA;ExD6uMN;AACF;AG1wMI;EqD/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;ExD4uMN;EwD1uMM;IACE,aAAA;ExD4uMR;EwDzuMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;ExD0uMR;AACF;;AG9wMI;EqD5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IjC5BA,0CiC8BA;ExD4zMJ;AACF;AuBv1MM;EiCYJ;IjCXM,gBAAA;EvB01MN;AACF;AGpyMI;EqD5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;ExDm0MN;EwDh0MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;ExDk0MN;EwD/zMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;ExDi0MN;EwD9zMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;ExDg0MN;EwD7zMI;IAEE,eAAA;ExD8zMN;EwD3zMI;IAGE,mBAAA;ExD2zMN;AACF;AGx1MI;EqD/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;ExD0zMN;EwDxzMM;IACE,aAAA;ExD0zMR;EwDvzMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;ExDwzMR;AACF;;AG51MI;EqD5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IjC5BA,0CiC8BA;ExD04MJ;AACF;AuBr6MM;EiCYJ;IjCXM,gBAAA;EvBw6MN;AACF;AGl3MI;EqD5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;ExDi5MN;EwD94MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;ExDg5MN;EwD74MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;ExD+4MN;EwD54MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;ExD84MN;EwD34MI;IAEE,eAAA;ExD44MN;EwDz4MI;IAGE,mBAAA;ExDy4MN;AACF;AGt6MI;EqD/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;ExDw4MN;EwDt4MM;IACE,aAAA;ExDw4MR;EwDr4MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;ExDs4MR;AACF;;AG16MI;EqD5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IjC5BA,0CiC8BA;ExDw9MJ;AACF;AuBn/MM;EiCYJ;IjCXM,gBAAA;EvBs/MN;AACF;AGh8MI;EqD5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;ExD+9MN;EwD59MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;ExD89MN;EwD39MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;ExD69MN;EwD19MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;ExD49MN;EwDz9MI;IAEE,eAAA;ExD09MN;EwDv9MI;IAGE,mBAAA;ExDu9MN;AACF;AGp/MI;EqD/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;ExDs9MN;EwDp9MM;IACE,aAAA;ExDs9MR;EwDn9MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;ExDo9MR;AACF;;AGx/MI;EqD5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IjC5BA,0CiC8BA;ExDsiNJ;AACF;AuBjkNM;EiCYJ;IjCXM,gBAAA;EvBokNN;AACF;AG9gNI;EqD5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;ExD6iNN;EwD1iNI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;ExD4iNN;EwDziNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;ExD2iNN;EwDxiNI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;ExD0iNN;EwDviNI;IAEE,eAAA;ExDwiNN;EwDriNI;IAGE,mBAAA;ExDqiNN;AACF;AGlkNI;EqD/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;ExDoiNN;EwDliNM;IACE,aAAA;ExDoiNR;EwDjiNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;ExDkiNR;AACF;;AwDlnNE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EjC5BA,0CiC8BA;AxDmnNN;AuB7oNM;EiCYJ;IjCXM,gBAAA;EvBgpNN;AACF;AwDtnNM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AxDwnNR;AwDrnNM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AxDunNR;AwDpnNM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AxDsnNR;AwDnnNM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AxDqnNR;AwDlnNM;EAEE,eAAA;AxDmnNR;AwDhnNM;EAGE,mBAAA;AxDgnNR;;AwDrlNA;ELpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a3C0mCkC;E2CzmClC,YAAA;EACA,aAAA;EACA,sBjDDM;AF8sNR;AmD1sNE;EAAS,UAAA;AnD6sNX;AmD5sNE;EAAS,YjDimDkB;AF8mK7B;;AwDjmNA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oEAAA;AxDomNF;AwDlmNE;EACE,4FAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;AxDomNJ;;AwDhmNA;EACE,gBAAA;EACA,kDAAA;AxDmmNF;;AwDhmNA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AxDmmNF;;AyDnvNA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YjDgzCkC;ARs8KpC;AyDpvNE;EACE,qBAAA;EACA,WAAA;AzDsvNJ;;AyDjvNA;EACE,iBAAA;AzDovNF;;AyDjvNA;EACE,iBAAA;AzDovNF;;AyDjvNA;EACE,iBAAA;AzDovNF;;AyD/uNE;EACE,mDAAA;AzDkvNJ;;AyD9uNA;EACE;IACE,YjDmxCgC;ER89KlC;AACF;AyD9uNA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;AzDgvNF;;AyD7uNA;EACE;IACE,uBAAA;EzDgvNF;AACF;A0D/xNE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A1DiyNJ;;A2DpyNE;EACE,sBAAA;EACA,iFAAA;A3DuyNJ;;A2DzyNE;EACE,sBAAA;EACA,mFAAA;A3D4yNJ;;A2D9yNE;EACE,sBAAA;EACA,iFAAA;A3DizNJ;;A2DnzNE;EACE,sBAAA;EACA,8EAAA;A3DszNJ;;A2DxzNE;EACE,sBAAA;EACA,iFAAA;A3D2zNJ;;A2D7zNE;EACE,sBAAA;EACA,gFAAA;A3Dg0NJ;;A2Dl0NE;EACE,sBAAA;EACA,+EAAA;A3Dq0NJ;;A2Dv0NE;EACE,sBAAA;EACA,8EAAA;A3D00NJ;;A4D50NE;EACE,wEAAA;EACA,kGAAA;A5D+0NJ;A4D50NM;EAGE,6DAAA;EACA,uFAAA;A5D40NR;;A4Dr1NE;EACE,0EAAA;EACA,oGAAA;A5Dw1NJ;A4Dr1NM;EAGE,6DAAA;EACA,uFAAA;A5Dq1NR;;A4D91NE;EACE,wEAAA;EACA,kGAAA;A5Di2NJ;A4D91NM;EAGE,gEAAA;EACA,0FAAA;A5D81NR;;A4Dv2NE;EACE,qEAAA;EACA,+FAAA;A5D02NJ;A4Dv2NM;EAGE,gEAAA;EACA,0FAAA;A5Du2NR;;A4Dh3NE;EACE,wEAAA;EACA,kGAAA;A5Dm3NJ;A4Dh3NM;EAGE,gEAAA;EACA,0FAAA;A5Dg3NR;;A4Dz3NE;EACE,uEAAA;EACA,iGAAA;A5D43NJ;A4Dz3NM;EAGE,gEAAA;EACA,0FAAA;A5Dy3NR;;A4Dl4NE;EACE,sEAAA;EACA,gGAAA;A5Dq4NJ;A4Dl4NM;EAGE,gEAAA;EACA,0FAAA;A5Dk4NR;;A4D34NE;EACE,qEAAA;EACA,+FAAA;A5D84NJ;A4D34NM;EAGE,0DAAA;EACA,oFAAA;A5D24NR;;A4Dp4NA;EACE,+EAAA;EACA,yGAAA;A5Du4NF;A4Dp4NI;EAEE,kFAAA;EACA,4GAAA;A5Dq4NN;;A6D/5NA;EACE,UAAA;EAEA,kJAAA;A7Di6NF;;A8Dp6NA;EACE,oBAAA;EACA,atD6c4B;EsD5c5B,mBAAA;EACA,kFAAA;EACA,6BtD2c4B;EsD1c5B,2BAAA;A9Du6NF;A8Dr6NE;EACE,cAAA;EACA,UtDuc0B;EsDtc1B,WtDsc0B;EsDrc1B,kBAAA;EvCIE,sCuCHF;A9Du6NJ;AuBh6NM;EuCZJ;IvCaM,gBAAA;EvBm6NN;AACF;;A8Dr6NI;EACE,mEAAA;A9Dw6NN;;A+D37NA;EACE,kBAAA;EACA,WAAA;A/D87NF;A+D57NE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A/D87NJ;A+D37NE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A/D67NJ;;A+Dx7NE;EACE,uBAAA;A/D27NJ;;A+D57NE;EACE,sBAAA;A/D+7NJ;;A+Dh8NE;EACE,yBAAA;A/Dm8NJ;;A+Dp8NE;EACE,iCAAA;A/Du8NJ;;AgE59NA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,axDumCkC;ARw3LpC;;AgE59NA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,axD+lCkC;ARg4LpC;;AgEv9NI;EACE,gBAAA;EACA,MAAA;EACA,axDmlC8B;ARu4LpC;;AgEv9NI;EACE,gBAAA;EACA,SAAA;EACA,axD6kC8B;AR64LpC;;AG37NI;E6DxCA;IACE,gBAAA;IACA,MAAA;IACA,axDmlC8B;ERo5LlC;EgEp+NE;IACE,gBAAA;IACA,SAAA;IACA,axD6kC8B;ERy5LlC;AACF;AGx8NI;E6DxCA;IACE,gBAAA;IACA,MAAA;IACA,axDmlC8B;ERg6LlC;EgEh/NE;IACE,gBAAA;IACA,SAAA;IACA,axD6kC8B;ERq6LlC;AACF;AGp9NI;E6DxCA;IACE,gBAAA;IACA,MAAA;IACA,axDmlC8B;ER46LlC;EgE5/NE;IACE,gBAAA;IACA,SAAA;IACA,axD6kC8B;ERi7LlC;AACF;AGh+NI;E6DxCA;IACE,gBAAA;IACA,MAAA;IACA,axDmlC8B;ERw7LlC;EgExgOE;IACE,gBAAA;IACA,SAAA;IACA,axD6kC8B;ER67LlC;AACF;AG5+NI;E6DxCA;IACE,gBAAA;IACA,MAAA;IACA,axDmlC8B;ERo8LlC;EgEphOE;IACE,gBAAA;IACA,SAAA;IACA,axD6kC8B;ERy8LlC;AACF;AiEtjOA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AjEwjOF;;AiErjOA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AjEwjOF;;AkEhkOA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AnEikOF;AmE9jOE;;EACE,6BAAA;AnEikOJ;;AoE/kOE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U5DgcsC;E4D/btC,WAAA;ApEklOJ;;AqE1lOA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AtE8lOF;;AuEpmOA;EACE,qBAAA;EACA,mBAAA;EACA,6B/DisB4B;E+DhsB5B,eAAA;EACA,8BAAA;EACA,a/D2rB4B;AR46M9B;;AwE3iOQ;EAOI,mCAAA;AxEwiOZ;;AwE/iOQ;EAOI,8BAAA;AxE4iOZ;;AwEnjOQ;EAOI,iCAAA;AxEgjOZ;;AwEvjOQ;EAOI,iCAAA;AxEojOZ;;AwE3jOQ;EAOI,sCAAA;AxEwjOZ;;AwE/jOQ;EAOI,mCAAA;AxE4jOZ;;AwEnkOQ;EAOI,sBAAA;AxEgkOZ;;AwEvkOQ;EAOI,uBAAA;AxEokOZ;;AwE3kOQ;EAOI,sBAAA;AxEwkOZ;;AwE/kOQ;EAOI,8BAAA;AxE4kOZ;;AwEnlOQ;EAOI,4BAAA;AxEglOZ;;AwEvlOQ;EAOI,2BAAA;AxEolOZ;;AwE3lOQ;EAOI,iCAAA;AxEwlOZ;;AwE/lOQ;EAOI,2BAAA;AxE4lOZ;;AwEnmOQ;EAOI,qBAAA;AxEgmOZ;;AwEvmOQ;EAOI,uBAAA;AxEomOZ;;AwE3mOQ;EAOI,uBAAA;AxEwmOZ;;AwE/mOQ;EAOI,uBAAA;AxE4mOZ;;AwEnnOQ;EAOI,uBAAA;AxEgnOZ;;AwEvnOQ;EAOI,uBAAA;AxEonOZ;;AwE3nOQ;EAOI,uBAAA;AxEwnOZ;;AwE/nOQ;EAOI,uBAAA;AxE4nOZ;;AwEnoOQ;EAOI,uBAAA;AxEgoOZ;;AwEvoOQ;EAOI,uBAAA;AxEooOZ;;AwE3oOQ;EAOI,qBAAA;AxEwoOZ;;AwE/oOQ;EAOI,yBAAA;AxE4oOZ;;AwEnpOQ;EAOI,2BAAA;AxEgpOZ;;AwEvpOQ;EAOI,4BAAA;AxEopOZ;;AwE3pOQ;EAOI,2BAAA;AxEwpOZ;;AwE/pOQ;EAOI,2BAAA;AxE4pOZ;;AwEnqOQ;EAOI,6BAAA;AxEgqOZ;;AwEvqOQ;EAOI,8BAAA;AxEoqOZ;;AwE3qOQ;EAOI,6BAAA;AxEwqOZ;;AwE/qOQ;EAOI,2BAAA;AxE4qOZ;;AwEnrOQ;EAOI,6BAAA;AxEgrOZ;;AwEvrOQ;EAOI,8BAAA;AxEorOZ;;AwE3rOQ;EAOI,6BAAA;AxEwrOZ;;AwE/rOQ;EAOI,0BAAA;AxE4rOZ;;AwEnsOQ;EAOI,gCAAA;AxEgsOZ;;AwEvsOQ;EAOI,yBAAA;AxEosOZ;;AwE3sOQ;EAOI,wBAAA;AxEwsOZ;;AwE/sOQ;EAOI,+BAAA;AxE4sOZ;;AwEntOQ;EAOI,yBAAA;AxEgtOZ;;AwEvtOQ;EAOI,6BAAA;AxEotOZ;;AwE3tOQ;EAOI,8BAAA;AxEwtOZ;;AwE/tOQ;EAOI,wBAAA;AxE4tOZ;;AwEnuOQ;EAOI,+BAAA;AxEguOZ;;AwEvuOQ;EAOI,wBAAA;AxEouOZ;;AwE3uOQ;EAOI,2DAAA;AxEwuOZ;;AwE/uOQ;EAOI,gEAAA;AxE4uOZ;;AwEnvOQ;EAOI,kEAAA;AxEgvOZ;;AwEvvOQ;EAOI,+DAAA;AxEovOZ;;AwE3vOQ;EAOI,+DAAA;AxEwvOZ;;AwE/vOQ;EAOI,+DAAA;AxE4vOZ;;AwEnwOQ;EAOI,iEAAA;AxEgwOZ;;AwEvwOQ;EAOI,2DAAA;AxEowOZ;;AwE3wOQ;EAOI,+DAAA;AxEwwOZ;;AwE/wOQ;EAOI,8DAAA;AxE4wOZ;;AwEnxOQ;EAOI,gFAAA;AxEgxOZ;;AwEvxOQ;EAOI,6GAAA;AxEoxOZ;;AwE3xOQ;EAOI,wGAAA;AxEwxOZ;;AwE/xOQ;EAOI,iHAAA;AxE4xOZ;;AwEnyOQ;EAOI,2BAAA;AxEgyOZ;;AwEjzOQ;EACE,gFAAA;AxEozOV;;AwErzOQ;EACE,kFAAA;AxEwzOV;;AwEzzOQ;EACE,gFAAA;AxE4zOV;;AwE7zOQ;EACE,6EAAA;AxEg0OV;;AwEj0OQ;EACE,gFAAA;AxEo0OV;;AwEr0OQ;EACE,+EAAA;AxEw0OV;;AwEz0OQ;EACE,8EAAA;AxE40OV;;AwE70OQ;EACE,6EAAA;AxEg1OV;;AwEv0OQ;EAOI,2BAAA;AxEo0OZ;;AwE30OQ;EAOI,6BAAA;AxEw0OZ;;AwE/0OQ;EAOI,6BAAA;AxE40OZ;;AwEn1OQ;EAOI,0BAAA;AxEg1OZ;;AwEv1OQ;EAOI,2BAAA;AxEo1OZ;;AwE31OQ;EAOI,iBAAA;AxEw1OZ;;AwE/1OQ;EAOI,mBAAA;AxE41OZ;;AwEn2OQ;EAOI,oBAAA;AxEg2OZ;;AwEv2OQ;EAOI,oBAAA;AxEo2OZ;;AwE32OQ;EAOI,sBAAA;AxEw2OZ;;AwE/2OQ;EAOI,uBAAA;AxE42OZ;;AwEn3OQ;EAOI,kBAAA;AxEg3OZ;;AwEv3OQ;EAOI,oBAAA;AxEo3OZ;;AwE33OQ;EAOI,qBAAA;AxEw3OZ;;AwE/3OQ;EAOI,mBAAA;AxE43OZ;;AwEn4OQ;EAOI,qBAAA;AxEg4OZ;;AwEv4OQ;EAOI,sBAAA;AxEo4OZ;;AwE34OQ;EAOI,2CAAA;AxEw4OZ;;AwE/4OQ;EAOI,sCAAA;AxE44OZ;;AwEn5OQ;EAOI,sCAAA;AxEg5OZ;;AwEv5OQ;EAOI,uFAAA;AxEo5OZ;;AwE35OQ;EAOI,oBAAA;AxEw5OZ;;AwE/5OQ;EAOI,2FAAA;AxE45OZ;;AwEn6OQ;EAOI,wBAAA;AxEg6OZ;;AwEv6OQ;EAOI,6FAAA;AxEo6OZ;;AwE36OQ;EAOI,0BAAA;AxEw6OZ;;AwE/6OQ;EAOI,8FAAA;AxE46OZ;;AwEn7OQ;EAOI,2BAAA;AxEg7OZ;;AwEv7OQ;EAOI,4FAAA;AxEo7OZ;;AwE37OQ;EAOI,yBAAA;AxEw7OZ;;AwE/7OQ;EAIQ,sBAAA;EAGJ,gCAAA;AxE67OZ;;AwEp8OQ;EAIQ,sBAAA;EAGJ,gFAAA;AxEk8OZ;;AwEz8OQ;EAIQ,sBAAA;EAGJ,8EAAA;AxEu8OZ;;AwE98OQ;EAIQ,sBAAA;EAGJ,2EAAA;AxE48OZ;;AwEn9OQ;EAIQ,sBAAA;EAGJ,8EAAA;AxEi9OZ;;AwEx9OQ;EAIQ,sBAAA;EAGJ,6EAAA;AxEs9OZ;;AwE79OQ;EAIQ,sBAAA;EAGJ,4EAAA;AxE29OZ;;AwEl+OQ;EAIQ,sBAAA;EAGJ,2EAAA;AxEg+OZ;;AwEv+OQ;EAIQ,sBAAA;EAGJ,4EAAA;AxEq+OZ;;AwE5+OQ;EAIQ,sBAAA;EAGJ,4EAAA;AxE0+OZ;;AwEj/OQ;EAOI,wDAAA;AxE8+OZ;;AwEr/OQ;EAOI,0DAAA;AxEk/OZ;;AwEz/OQ;EAOI,wDAAA;AxEs/OZ;;AwE7/OQ;EAOI,qDAAA;AxE0/OZ;;AwEjgPQ;EAOI,wDAAA;AxE8/OZ;;AwErgPQ;EAOI,uDAAA;AxEkgPZ;;AwEzgPQ;EAOI,sDAAA;AxEsgPZ;;AwE7gPQ;EAOI,qDAAA;AxE0gPZ;;AwEjhPQ;EAOI,4BAAA;AxE8gPZ;;AwErhPQ;EAOI,4BAAA;AxEkhPZ;;AwEzhPQ;EAOI,4BAAA;AxEshPZ;;AwE7hPQ;EAOI,4BAAA;AxE0hPZ;;AwEjiPQ;EAOI,4BAAA;AxE8hPZ;;AwE/iPQ;EACE,wBAAA;AxEkjPV;;AwEnjPQ;EACE,yBAAA;AxEsjPV;;AwEvjPQ;EACE,wBAAA;AxE0jPV;;AwE3jPQ;EACE,yBAAA;AxE8jPV;;AwE/jPQ;EACE,sBAAA;AxEkkPV;;AwEzjPQ;EAOI,qBAAA;AxEsjPZ;;AwE7jPQ;EAOI,qBAAA;AxE0jPZ;;AwEjkPQ;EAOI,qBAAA;AxE8jPZ;;AwErkPQ;EAOI,sBAAA;AxEkkPZ;;AwEzkPQ;EAOI,sBAAA;AxEskPZ;;AwE7kPQ;EAOI,0BAAA;AxE0kPZ;;AwEjlPQ;EAOI,uBAAA;AxE8kPZ;;AwErlPQ;EAOI,2BAAA;AxEklPZ;;AwEzlPQ;EAOI,sBAAA;AxEslPZ;;AwE7lPQ;EAOI,sBAAA;AxE0lPZ;;AwEjmPQ;EAOI,sBAAA;AxE8lPZ;;AwErmPQ;EAOI,uBAAA;AxEkmPZ;;AwEzmPQ;EAOI,uBAAA;AxEsmPZ;;AwE7mPQ;EAOI,2BAAA;AxE0mPZ;;AwEjnPQ;EAOI,wBAAA;AxE8mPZ;;AwErnPQ;EAOI,4BAAA;AxEknPZ;;AwEznPQ;EAOI,yBAAA;AxEsnPZ;;AwE7nPQ;EAOI,8BAAA;AxE0nPZ;;AwEjoPQ;EAOI,iCAAA;AxE8nPZ;;AwEroPQ;EAOI,sCAAA;AxEkoPZ;;AwEzoPQ;EAOI,yCAAA;AxEsoPZ;;AwE7oPQ;EAOI,uBAAA;AxE0oPZ;;AwEjpPQ;EAOI,uBAAA;AxE8oPZ;;AwErpPQ;EAOI,yBAAA;AxEkpPZ;;AwEzpPQ;EAOI,yBAAA;AxEspPZ;;AwE7pPQ;EAOI,0BAAA;AxE0pPZ;;AwEjqPQ;EAOI,4BAAA;AxE8pPZ;;AwErqPQ;EAOI,kCAAA;AxEkqPZ;;AwEzqPQ;EAOI,sCAAA;AxEsqPZ;;AwE7qPQ;EAOI,oCAAA;AxE0qPZ;;AwEjrPQ;EAOI,kCAAA;AxE8qPZ;;AwErrPQ;EAOI,yCAAA;AxEkrPZ;;AwEzrPQ;EAOI,wCAAA;AxEsrPZ;;AwE7rPQ;EAOI,wCAAA;AxE0rPZ;;AwEjsPQ;EAOI,kCAAA;AxE8rPZ;;AwErsPQ;EAOI,gCAAA;AxEksPZ;;AwEzsPQ;EAOI,8BAAA;AxEssPZ;;AwE7sPQ;EAOI,gCAAA;AxE0sPZ;;AwEjtPQ;EAOI,+BAAA;AxE8sPZ;;AwErtPQ;EAOI,oCAAA;AxEktPZ;;AwEztPQ;EAOI,kCAAA;AxEstPZ;;AwE7tPQ;EAOI,gCAAA;AxE0tPZ;;AwEjuPQ;EAOI,uCAAA;AxE8tPZ;;AwEruPQ;EAOI,sCAAA;AxEkuPZ;;AwEzuPQ;EAOI,iCAAA;AxEsuPZ;;AwE7uPQ;EAOI,2BAAA;AxE0uPZ;;AwEjvPQ;EAOI,iCAAA;AxE8uPZ;;AwErvPQ;EAOI,+BAAA;AxEkvPZ;;AwEzvPQ;EAOI,6BAAA;AxEsvPZ;;AwE7vPQ;EAOI,+BAAA;AxE0vPZ;;AwEjwPQ;EAOI,8BAAA;AxE8vPZ;;AwErwPQ;EAOI,oBAAA;AxEkwPZ;;AwEzwPQ;EAOI,mBAAA;AxEswPZ;;AwE7wPQ;EAOI,mBAAA;AxE0wPZ;;AwEjxPQ;EAOI,mBAAA;AxE8wPZ;;AwErxPQ;EAOI,mBAAA;AxEkxPZ;;AwEzxPQ;EAOI,mBAAA;AxEsxPZ;;AwE7xPQ;EAOI,mBAAA;AxE0xPZ;;AwEjyPQ;EAOI,mBAAA;AxE8xPZ;;AwEryPQ;EAOI,oBAAA;AxEkyPZ;;AwEzyPQ;EAOI,2BAAA;AxEsyPZ;;AwE7yPQ;EAOI,0BAAA;AxE0yPZ;;AwEjzPQ;EAOI,yBAAA;AxE8yPZ;;AwErzPQ;EAOI,uBAAA;AxEkzPZ;;AwEzzPQ;EAOI,yBAAA;AxEszPZ;;AwE7zPQ;EAOI,uBAAA;AxE0zPZ;;AwEj0PQ;EAOI,yBAAA;AxE8zPZ;;AwEr0PQ;EAOI,uBAAA;AxEk0PZ;;AwEz0PQ;EAOI,yBAAA;AxEs0PZ;;AwE70PQ;EAOI,uBAAA;AxE00PZ;;AwEj1PQ;EAOI,uBAAA;AxE80PZ;;AwEr1PQ;EAOI,uBAAA;AxEk1PZ;;AwEz1PQ;EAOI,yBAAA;AxEs1PZ;;AwE71PQ;EAOI,uBAAA;AxE01PZ;;AwEj2PQ;EAOI,uBAAA;AxE81PZ;;AwEr2PQ;EAOI,0BAAA;EAAA,yBAAA;AxEm2PZ;;AwE12PQ;EAOI,iCAAA;EAAA,gCAAA;AxEw2PZ;;AwE/2PQ;EAOI,gCAAA;EAAA,+BAAA;AxE62PZ;;AwEp3PQ;EAOI,+BAAA;EAAA,8BAAA;AxEk3PZ;;AwEz3PQ;EAOI,6BAAA;EAAA,4BAAA;AxEu3PZ;;AwE93PQ;EAOI,+BAAA;EAAA,8BAAA;AxE43PZ;;AwEn4PQ;EAOI,6BAAA;EAAA,4BAAA;AxEi4PZ;;AwEx4PQ;EAOI,+BAAA;EAAA,8BAAA;AxEs4PZ;;AwE74PQ;EAOI,6BAAA;EAAA,4BAAA;AxE24PZ;;AwEl5PQ;EAOI,+BAAA;EAAA,8BAAA;AxEg5PZ;;AwEv5PQ;EAOI,6BAAA;EAAA,4BAAA;AxEq5PZ;;AwE55PQ;EAOI,6BAAA;EAAA,4BAAA;AxE05PZ;;AwEj6PQ;EAOI,6BAAA;EAAA,4BAAA;AxE+5PZ;;AwEt6PQ;EAOI,+BAAA;EAAA,8BAAA;AxEo6PZ;;AwE36PQ;EAOI,6BAAA;EAAA,4BAAA;AxEy6PZ;;AwEh7PQ;EAOI,6BAAA;EAAA,4BAAA;AxE86PZ;;AwEr7PQ;EAOI,wBAAA;EAAA,2BAAA;AxEm7PZ;;AwE17PQ;EAOI,+BAAA;EAAA,kCAAA;AxEw7PZ;;AwE/7PQ;EAOI,8BAAA;EAAA,iCAAA;AxE67PZ;;AwEp8PQ;EAOI,6BAAA;EAAA,gCAAA;AxEk8PZ;;AwEz8PQ;EAOI,2BAAA;EAAA,8BAAA;AxEu8PZ;;AwE98PQ;EAOI,6BAAA;EAAA,gCAAA;AxE48PZ;;AwEn9PQ;EAOI,2BAAA;EAAA,8BAAA;AxEi9PZ;;AwEx9PQ;EAOI,6BAAA;EAAA,gCAAA;AxEs9PZ;;AwE79PQ;EAOI,2BAAA;EAAA,8BAAA;AxE29PZ;;AwEl+PQ;EAOI,6BAAA;EAAA,gCAAA;AxEg+PZ;;AwEv+PQ;EAOI,2BAAA;EAAA,8BAAA;AxEq+PZ;;AwE5+PQ;EAOI,2BAAA;EAAA,8BAAA;AxE0+PZ;;AwEj/PQ;EAOI,2BAAA;EAAA,8BAAA;AxE++PZ;;AwEt/PQ;EAOI,6BAAA;EAAA,gCAAA;AxEo/PZ;;AwE3/PQ;EAOI,2BAAA;EAAA,8BAAA;AxEy/PZ;;AwEhgQQ;EAOI,2BAAA;EAAA,8BAAA;AxE8/PZ;;AwErgQQ;EAOI,wBAAA;AxEkgQZ;;AwEzgQQ;EAOI,+BAAA;AxEsgQZ;;AwE7gQQ;EAOI,8BAAA;AxE0gQZ;;AwEjhQQ;EAOI,6BAAA;AxE8gQZ;;AwErhQQ;EAOI,2BAAA;AxEkhQZ;;AwEzhQQ;EAOI,6BAAA;AxEshQZ;;AwE7hQQ;EAOI,2BAAA;AxE0hQZ;;AwEjiQQ;EAOI,6BAAA;AxE8hQZ;;AwEriQQ;EAOI,2BAAA;AxEkiQZ;;AwEziQQ;EAOI,6BAAA;AxEsiQZ;;AwE7iQQ;EAOI,2BAAA;AxE0iQZ;;AwEjjQQ;EAOI,2BAAA;AxE8iQZ;;AwErjQQ;EAOI,2BAAA;AxEkjQZ;;AwEzjQQ;EAOI,6BAAA;AxEsjQZ;;AwE7jQQ;EAOI,2BAAA;AxE0jQZ;;AwEjkQQ;EAOI,2BAAA;AxE8jQZ;;AwErkQQ;EAOI,0BAAA;AxEkkQZ;;AwEzkQQ;EAOI,iCAAA;AxEskQZ;;AwE7kQQ;EAOI,gCAAA;AxE0kQZ;;AwEjlQQ;EAOI,+BAAA;AxE8kQZ;;AwErlQQ;EAOI,6BAAA;AxEklQZ;;AwEzlQQ;EAOI,+BAAA;AxEslQZ;;AwE7lQQ;EAOI,6BAAA;AxE0lQZ;;AwEjmQQ;EAOI,+BAAA;AxE8lQZ;;AwErmQQ;EAOI,6BAAA;AxEkmQZ;;AwEzmQQ;EAOI,+BAAA;AxEsmQZ;;AwE7mQQ;EAOI,6BAAA;AxE0mQZ;;AwEjnQQ;EAOI,6BAAA;AxE8mQZ;;AwErnQQ;EAOI,6BAAA;AxEknQZ;;AwEznQQ;EAOI,+BAAA;AxEsnQZ;;AwE7nQQ;EAOI,6BAAA;AxE0nQZ;;AwEjoQQ;EAOI,6BAAA;AxE8nQZ;;AwEroQQ;EAOI,2BAAA;AxEkoQZ;;AwEzoQQ;EAOI,kCAAA;AxEsoQZ;;AwE7oQQ;EAOI,iCAAA;AxE0oQZ;;AwEjpQQ;EAOI,gCAAA;AxE8oQZ;;AwErpQQ;EAOI,8BAAA;AxEkpQZ;;AwEzpQQ;EAOI,gCAAA;AxEspQZ;;AwE7pQQ;EAOI,8BAAA;AxE0pQZ;;AwEjqQQ;EAOI,gCAAA;AxE8pQZ;;AwErqQQ;EAOI,8BAAA;AxEkqQZ;;AwEzqQQ;EAOI,gCAAA;AxEsqQZ;;AwE7qQQ;EAOI,8BAAA;AxE0qQZ;;AwEjrQQ;EAOI,8BAAA;AxE8qQZ;;AwErrQQ;EAOI,8BAAA;AxEkrQZ;;AwEzrQQ;EAOI,gCAAA;AxEsrQZ;;AwE7rQQ;EAOI,8BAAA;AxE0rQZ;;AwEjsQQ;EAOI,8BAAA;AxE8rQZ;;AwErsQQ;EAOI,yBAAA;AxEksQZ;;AwEzsQQ;EAOI,gCAAA;AxEssQZ;;AwE7sQQ;EAOI,+BAAA;AxE0sQZ;;AwEjtQQ;EAOI,8BAAA;AxE8sQZ;;AwErtQQ;EAOI,4BAAA;AxEktQZ;;AwEztQQ;EAOI,8BAAA;AxEstQZ;;AwE7tQQ;EAOI,4BAAA;AxE0tQZ;;AwEjuQQ;EAOI,8BAAA;AxE8tQZ;;AwEruQQ;EAOI,4BAAA;AxEkuQZ;;AwEzuQQ;EAOI,8BAAA;AxEsuQZ;;AwE7uQQ;EAOI,4BAAA;AxE0uQZ;;AwEjvQQ;EAOI,4BAAA;AxE8uQZ;;AwErvQQ;EAOI,4BAAA;AxEkvQZ;;AwEzvQQ;EAOI,8BAAA;AxEsvQZ;;AwE7vQQ;EAOI,4BAAA;AxE0vQZ;;AwEjwQQ;EAOI,4BAAA;AxE8vQZ;;AwErwQQ;EAOI,4BAAA;AxEkwQZ;;AwEzwQQ;EAOI,2BAAA;AxEswQZ;;AwE7wQQ;EAOI,0BAAA;AxE0wQZ;;AwEjxQQ;EAOI,wBAAA;AxE8wQZ;;AwErxQQ;EAOI,0BAAA;AxEkxQZ;;AwEzxQQ;EAOI,wBAAA;AxEsxQZ;;AwE7xQQ;EAOI,0BAAA;AxE0xQZ;;AwEjyQQ;EAOI,wBAAA;AxE8xQZ;;AwEryQQ;EAOI,0BAAA;AxEkyQZ;;AwEzyQQ;EAOI,wBAAA;AxEsyQZ;;AwE7yQQ;EAOI,wBAAA;AxE0yQZ;;AwEjzQQ;EAOI,wBAAA;AxE8yQZ;;AwErzQQ;EAOI,0BAAA;AxEkzQZ;;AwEzzQQ;EAOI,wBAAA;AxEszQZ;;AwE7zQQ;EAOI,kCAAA;EAAA,iCAAA;AxE2zQZ;;AwEl0QQ;EAOI,iCAAA;EAAA,gCAAA;AxEg0QZ;;AwEv0QQ;EAOI,gCAAA;EAAA,+BAAA;AxEq0QZ;;AwE50QQ;EAOI,8BAAA;EAAA,6BAAA;AxE00QZ;;AwEj1QQ;EAOI,gCAAA;EAAA,+BAAA;AxE+0QZ;;AwEt1QQ;EAOI,8BAAA;EAAA,6BAAA;AxEo1QZ;;AwE31QQ;EAOI,gCAAA;EAAA,+BAAA;AxEy1QZ;;AwEh2QQ;EAOI,8BAAA;EAAA,6BAAA;AxE81QZ;;AwEr2QQ;EAOI,gCAAA;EAAA,+BAAA;AxEm2QZ;;AwE12QQ;EAOI,8BAAA;EAAA,6BAAA;AxEw2QZ;;AwE/2QQ;EAOI,8BAAA;EAAA,6BAAA;AxE62QZ;;AwEp3QQ;EAOI,8BAAA;EAAA,6BAAA;AxEk3QZ;;AwEz3QQ;EAOI,gCAAA;EAAA,+BAAA;AxEu3QZ;;AwE93QQ;EAOI,8BAAA;EAAA,6BAAA;AxE43QZ;;AwEn4QQ;EAOI,gCAAA;EAAA,mCAAA;AxEi4QZ;;AwEx4QQ;EAOI,+BAAA;EAAA,kCAAA;AxEs4QZ;;AwE74QQ;EAOI,8BAAA;EAAA,iCAAA;AxE24QZ;;AwEl5QQ;EAOI,4BAAA;EAAA,+BAAA;AxEg5QZ;;AwEv5QQ;EAOI,8BAAA;EAAA,iCAAA;AxEq5QZ;;AwE55QQ;EAOI,4BAAA;EAAA,+BAAA;AxE05QZ;;AwEj6QQ;EAOI,8BAAA;EAAA,iCAAA;AxE+5QZ;;AwEt6QQ;EAOI,4BAAA;EAAA,+BAAA;AxEo6QZ;;AwE36QQ;EAOI,8BAAA;EAAA,iCAAA;AxEy6QZ;;AwEh7QQ;EAOI,4BAAA;EAAA,+BAAA;AxE86QZ;;AwEr7QQ;EAOI,4BAAA;EAAA,+BAAA;AxEm7QZ;;AwE17QQ;EAOI,4BAAA;EAAA,+BAAA;AxEw7QZ;;AwE/7QQ;EAOI,8BAAA;EAAA,iCAAA;AxE67QZ;;AwEp8QQ;EAOI,4BAAA;EAAA,+BAAA;AxEk8QZ;;AwEz8QQ;EAOI,gCAAA;AxEs8QZ;;AwE78QQ;EAOI,+BAAA;AxE08QZ;;AwEj9QQ;EAOI,8BAAA;AxE88QZ;;AwEr9QQ;EAOI,4BAAA;AxEk9QZ;;AwEz9QQ;EAOI,8BAAA;AxEs9QZ;;AwE79QQ;EAOI,4BAAA;AxE09QZ;;AwEj+QQ;EAOI,8BAAA;AxE89QZ;;AwEr+QQ;EAOI,4BAAA;AxEk+QZ;;AwEz+QQ;EAOI,8BAAA;AxEs+QZ;;AwE7+QQ;EAOI,4BAAA;AxE0+QZ;;AwEj/QQ;EAOI,4BAAA;AxE8+QZ;;AwEr/QQ;EAOI,4BAAA;AxEk/QZ;;AwEz/QQ;EAOI,8BAAA;AxEs/QZ;;AwE7/QQ;EAOI,4BAAA;AxE0/QZ;;AwEjgRQ;EAOI,kCAAA;AxE8/QZ;;AwErgRQ;EAOI,iCAAA;AxEkgRZ;;AwEzgRQ;EAOI,gCAAA;AxEsgRZ;;AwE7gRQ;EAOI,8BAAA;AxE0gRZ;;AwEjhRQ;EAOI,gCAAA;AxE8gRZ;;AwErhRQ;EAOI,8BAAA;AxEkhRZ;;AwEzhRQ;EAOI,gCAAA;AxEshRZ;;AwE7hRQ;EAOI,8BAAA;AxE0hRZ;;AwEjiRQ;EAOI,gCAAA;AxE8hRZ;;AwEriRQ;EAOI,8BAAA;AxEkiRZ;;AwEziRQ;EAOI,8BAAA;AxEsiRZ;;AwE7iRQ;EAOI,8BAAA;AxE0iRZ;;AwEjjRQ;EAOI,gCAAA;AxE8iRZ;;AwErjRQ;EAOI,8BAAA;AxEkjRZ;;AwEzjRQ;EAOI,mCAAA;AxEsjRZ;;AwE7jRQ;EAOI,kCAAA;AxE0jRZ;;AwEjkRQ;EAOI,iCAAA;AxE8jRZ;;AwErkRQ;EAOI,+BAAA;AxEkkRZ;;AwEzkRQ;EAOI,iCAAA;AxEskRZ;;AwE7kRQ;EAOI,+BAAA;AxE0kRZ;;AwEjlRQ;EAOI,iCAAA;AxE8kRZ;;AwErlRQ;EAOI,+BAAA;AxEklRZ;;AwEzlRQ;EAOI,iCAAA;AxEslRZ;;AwE7lRQ;EAOI,+BAAA;AxE0lRZ;;AwEjmRQ;EAOI,+BAAA;AxE8lRZ;;AwErmRQ;EAOI,+BAAA;AxEkmRZ;;AwEzmRQ;EAOI,iCAAA;AxEsmRZ;;AwE7mRQ;EAOI,+BAAA;AxE0mRZ;;AwEjnRQ;EAOI,iCAAA;AxE8mRZ;;AwErnRQ;EAOI,gCAAA;AxEknRZ;;AwEznRQ;EAOI,+BAAA;AxEsnRZ;;AwE7nRQ;EAOI,6BAAA;AxE0nRZ;;AwEjoRQ;EAOI,+BAAA;AxE8nRZ;;AwEroRQ;EAOI,6BAAA;AxEkoRZ;;AwEzoRQ;EAOI,+BAAA;AxEsoRZ;;AwE7oRQ;EAOI,6BAAA;AxE0oRZ;;AwEjpRQ;EAOI,+BAAA;AxE8oRZ;;AwErpRQ;EAOI,6BAAA;AxEkpRZ;;AwEzpRQ;EAOI,6BAAA;AxEspRZ;;AwE7pRQ;EAOI,6BAAA;AxE0pRZ;;AwEjqRQ;EAOI,+BAAA;AxE8pRZ;;AwErqRQ;EAOI,6BAAA;AxEkqRZ;;AwEzqRQ;EAOI,qBAAA;AxEsqRZ;;AwE7qRQ;EAOI,4BAAA;AxE0qRZ;;AwEjrRQ;EAOI,2BAAA;AxE8qRZ;;AwErrRQ;EAOI,0BAAA;AxEkrRZ;;AwEzrRQ;EAOI,wBAAA;AxEsrRZ;;AwE7rRQ;EAOI,0BAAA;AxE0rRZ;;AwEjsRQ;EAOI,wBAAA;AxE8rRZ;;AwErsRQ;EAOI,0BAAA;AxEksRZ;;AwEzsRQ;EAOI,wBAAA;AxEssRZ;;AwE7sRQ;EAOI,0BAAA;AxE0sRZ;;AwEjtRQ;EAOI,wBAAA;AxE8sRZ;;AwErtRQ;EAOI,wBAAA;AxEktRZ;;AwEztRQ;EAOI,wBAAA;AxEstRZ;;AwE7tRQ;EAOI,0BAAA;AxE0tRZ;;AwEjuRQ;EAOI,wBAAA;AxE8tRZ;;AwEruRQ;EAOI,2BAAA;EAAA,0BAAA;AxEmuRZ;;AwE1uRQ;EAOI,kCAAA;EAAA,iCAAA;AxEwuRZ;;AwE/uRQ;EAOI,iCAAA;EAAA,gCAAA;AxE6uRZ;;AwEpvRQ;EAOI,gCAAA;EAAA,+BAAA;AxEkvRZ;;AwEzvRQ;EAOI,8BAAA;EAAA,6BAAA;AxEuvRZ;;AwE9vRQ;EAOI,gCAAA;EAAA,+BAAA;AxE4vRZ;;AwEnwRQ;EAOI,8BAAA;EAAA,6BAAA;AxEiwRZ;;AwExwRQ;EAOI,gCAAA;EAAA,+BAAA;AxEswRZ;;AwE7wRQ;EAOI,8BAAA;EAAA,6BAAA;AxE2wRZ;;AwElxRQ;EAOI,gCAAA;EAAA,+BAAA;AxEgxRZ;;AwEvxRQ;EAOI,8BAAA;EAAA,6BAAA;AxEqxRZ;;AwE5xRQ;EAOI,8BAAA;EAAA,6BAAA;AxE0xRZ;;AwEjyRQ;EAOI,8BAAA;EAAA,6BAAA;AxE+xRZ;;AwEtyRQ;EAOI,gCAAA;EAAA,+BAAA;AxEoyRZ;;AwE3yRQ;EAOI,8BAAA;EAAA,6BAAA;AxEyyRZ;;AwEhzRQ;EAOI,yBAAA;EAAA,4BAAA;AxE8yRZ;;AwErzRQ;EAOI,gCAAA;EAAA,mCAAA;AxEmzRZ;;AwE1zRQ;EAOI,+BAAA;EAAA,kCAAA;AxEwzRZ;;AwE/zRQ;EAOI,8BAAA;EAAA,iCAAA;AxE6zRZ;;AwEp0RQ;EAOI,4BAAA;EAAA,+BAAA;AxEk0RZ;;AwEz0RQ;EAOI,8BAAA;EAAA,iCAAA;AxEu0RZ;;AwE90RQ;EAOI,4BAAA;EAAA,+BAAA;AxE40RZ;;AwEn1RQ;EAOI,8BAAA;EAAA,iCAAA;AxEi1RZ;;AwEx1RQ;EAOI,4BAAA;EAAA,+BAAA;AxEs1RZ;;AwE71RQ;EAOI,8BAAA;EAAA,iCAAA;AxE21RZ;;AwEl2RQ;EAOI,4BAAA;EAAA,+BAAA;AxEg2RZ;;AwEv2RQ;EAOI,4BAAA;EAAA,+BAAA;AxEq2RZ;;AwE52RQ;EAOI,4BAAA;EAAA,+BAAA;AxE02RZ;;AwEj3RQ;EAOI,8BAAA;EAAA,iCAAA;AxE+2RZ;;AwEt3RQ;EAOI,4BAAA;EAAA,+BAAA;AxEo3RZ;;AwE33RQ;EAOI,yBAAA;AxEw3RZ;;AwE/3RQ;EAOI,gCAAA;AxE43RZ;;AwEn4RQ;EAOI,+BAAA;AxEg4RZ;;AwEv4RQ;EAOI,8BAAA;AxEo4RZ;;AwE34RQ;EAOI,4BAAA;AxEw4RZ;;AwE/4RQ;EAOI,8BAAA;AxE44RZ;;AwEn5RQ;EAOI,4BAAA;AxEg5RZ;;AwEv5RQ;EAOI,8BAAA;AxEo5RZ;;AwE35RQ;EAOI,4BAAA;AxEw5RZ;;AwE/5RQ;EAOI,8BAAA;AxE45RZ;;AwEn6RQ;EAOI,4BAAA;AxEg6RZ;;AwEv6RQ;EAOI,4BAAA;AxEo6RZ;;AwE36RQ;EAOI,4BAAA;AxEw6RZ;;AwE/6RQ;EAOI,8BAAA;AxE46RZ;;AwEn7RQ;EAOI,4BAAA;AxEg7RZ;;AwEv7RQ;EAOI,2BAAA;AxEo7RZ;;AwE37RQ;EAOI,kCAAA;AxEw7RZ;;AwE/7RQ;EAOI,iCAAA;AxE47RZ;;AwEn8RQ;EAOI,gCAAA;AxEg8RZ;;AwEv8RQ;EAOI,8BAAA;AxEo8RZ;;AwE38RQ;EAOI,gCAAA;AxEw8RZ;;AwE/8RQ;EAOI,8BAAA;AxE48RZ;;AwEn9RQ;EAOI,gCAAA;AxEg9RZ;;AwEv9RQ;EAOI,8BAAA;AxEo9RZ;;AwE39RQ;EAOI,gCAAA;AxEw9RZ;;AwE/9RQ;EAOI,8BAAA;AxE49RZ;;AwEn+RQ;EAOI,8BAAA;AxEg+RZ;;AwEv+RQ;EAOI,8BAAA;AxEo+RZ;;AwE3+RQ;EAOI,gCAAA;AxEw+RZ;;AwE/+RQ;EAOI,8BAAA;AxE4+RZ;;AwEn/RQ;EAOI,4BAAA;AxEg/RZ;;AwEv/RQ;EAOI,mCAAA;AxEo/RZ;;AwE3/RQ;EAOI,kCAAA;AxEw/RZ;;AwE//RQ;EAOI,iCAAA;AxE4/RZ;;AwEngSQ;EAOI,+BAAA;AxEggSZ;;AwEvgSQ;EAOI,iCAAA;AxEogSZ;;AwE3gSQ;EAOI,+BAAA;AxEwgSZ;;AwE/gSQ;EAOI,iCAAA;AxE4gSZ;;AwEnhSQ;EAOI,+BAAA;AxEghSZ;;AwEvhSQ;EAOI,iCAAA;AxEohSZ;;AwE3hSQ;EAOI,+BAAA;AxEwhSZ;;AwE/hSQ;EAOI,+BAAA;AxE4hSZ;;AwEniSQ;EAOI,+BAAA;AxEgiSZ;;AwEviSQ;EAOI,iCAAA;AxEoiSZ;;AwE3iSQ;EAOI,+BAAA;AxEwiSZ;;AwE/iSQ;EAOI,0BAAA;AxE4iSZ;;AwEnjSQ;EAOI,iCAAA;AxEgjSZ;;AwEvjSQ;EAOI,gCAAA;AxEojSZ;;AwE3jSQ;EAOI,+BAAA;AxEwjSZ;;AwE/jSQ;EAOI,6BAAA;AxE4jSZ;;AwEnkSQ;EAOI,+BAAA;AxEgkSZ;;AwEvkSQ;EAOI,6BAAA;AxEokSZ;;AwE3kSQ;EAOI,+BAAA;AxEwkSZ;;AwE/kSQ;EAOI,6BAAA;AxE4kSZ;;AwEnlSQ;EAOI,+BAAA;AxEglSZ;;AwEvlSQ;EAOI,6BAAA;AxEolSZ;;AwE3lSQ;EAOI,6BAAA;AxEwlSZ;;AwE/lSQ;EAOI,6BAAA;AxE4lSZ;;AwEnmSQ;EAOI,+BAAA;AxEgmSZ;;AwEvmSQ;EAOI,6BAAA;AxEomSZ;;AwE3mSQ;EAOI,iBAAA;AxEwmSZ;;AwE/mSQ;EAOI,wBAAA;AxE4mSZ;;AwEnnSQ;EAOI,uBAAA;AxEgnSZ;;AwEvnSQ;EAOI,sBAAA;AxEonSZ;;AwE3nSQ;EAOI,oBAAA;AxEwnSZ;;AwE/nSQ;EAOI,sBAAA;AxE4nSZ;;AwEnoSQ;EAOI,oBAAA;AxEgoSZ;;AwEvoSQ;EAOI,sBAAA;AxEooSZ;;AwE3oSQ;EAOI,oBAAA;AxEwoSZ;;AwE/oSQ;EAOI,sBAAA;AxE4oSZ;;AwEnpSQ;EAOI,oBAAA;AxEgpSZ;;AwEvpSQ;EAOI,oBAAA;AxEopSZ;;AwE3pSQ;EAOI,oBAAA;AxEwpSZ;;AwE/pSQ;EAOI,sBAAA;AxE4pSZ;;AwEnqSQ;EAOI,oBAAA;AxEgqSZ;;AwEvqSQ;EAOI,qBAAA;AxEoqSZ;;AwE3qSQ;EAOI,4BAAA;AxEwqSZ;;AwE/qSQ;EAOI,2BAAA;AxE4qSZ;;AwEnrSQ;EAOI,0BAAA;AxEgrSZ;;AwEvrSQ;EAOI,wBAAA;AxEorSZ;;AwE3rSQ;EAOI,0BAAA;AxEwrSZ;;AwE/rSQ;EAOI,wBAAA;AxE4rSZ;;AwEnsSQ;EAOI,0BAAA;AxEgsSZ;;AwEvsSQ;EAOI,wBAAA;AxEosSZ;;AwE3sSQ;EAOI,0BAAA;AxEwsSZ;;AwE/sSQ;EAOI,wBAAA;AxE4sSZ;;AwEntSQ;EAOI,wBAAA;AxEgtSZ;;AwEvtSQ;EAOI,wBAAA;AxEotSZ;;AwE3tSQ;EAOI,0BAAA;AxEwtSZ;;AwE/tSQ;EAOI,wBAAA;AxE4tSZ;;AwEnuSQ;EAOI,wBAAA;AxEguSZ;;AwEvuSQ;EAOI,+BAAA;AxEouSZ;;AwE3uSQ;EAOI,8BAAA;AxEwuSZ;;AwE/uSQ;EAOI,6BAAA;AxE4uSZ;;AwEnvSQ;EAOI,2BAAA;AxEgvSZ;;AwEvvSQ;EAOI,6BAAA;AxEovSZ;;AwE3vSQ;EAOI,2BAAA;AxEwvSZ;;AwE/vSQ;EAOI,6BAAA;AxE4vSZ;;AwEnwSQ;EAOI,2BAAA;AxEgwSZ;;AwEvwSQ;EAOI,6BAAA;AxEowSZ;;AwE3wSQ;EAOI,2BAAA;AxEwwSZ;;AwE/wSQ;EAOI,2BAAA;AxE4wSZ;;AwEnxSQ;EAOI,2BAAA;AxEgxSZ;;AwEvxSQ;EAOI,6BAAA;AxEoxSZ;;AwE3xSQ;EAOI,2BAAA;AxEwxSZ;;AwE/xSQ;EAOI,gDAAA;AxE4xSZ;;AwEnySQ;EAOI,0BAAA;AxEgySZ;;AwEvySQ;EAOI,+BAAA;AxEoySZ;;AwE3ySQ;EAOI,8BAAA;AxEwySZ;;AwE/ySQ;EAOI,+BAAA;AxE4ySZ;;AwEnzSQ;EAOI,6BAAA;AxEgzSZ;;AwEvzSQ;EAOI,8BAAA;AxEozSZ;;AwE3zSQ;EAOI,6BAAA;AxEwzSZ;;AwE/zSQ;EAOI,6BAAA;AxE4zSZ;;AwEn0SQ;EAOI,+BAAA;AxEg0SZ;;AwEv0SQ;EAOI,2BAAA;AxEo0SZ;;AwE30SQ;EAOI,2BAAA;AxEw0SZ;;AwE/0SQ;EAOI,2BAAA;AxE40SZ;;AwEn1SQ;EAOI,2BAAA;AxEg1SZ;;AwEv1SQ;EAOI,2BAAA;AxEo1SZ;;AwE31SQ;EAOI,8BAAA;AxEw1SZ;;AwE/1SQ;EAOI,yBAAA;AxE41SZ;;AwEn2SQ;EAOI,6BAAA;AxEg2SZ;;AwEv2SQ;EAOI,4BAAA;AxEo2SZ;;AwE32SQ;EAOI,4BAAA;AxEw2SZ;;AwE/2SQ;EAOI,6BAAA;AxE42SZ;;AwEn3SQ;EAOI,2BAAA;AxEg3SZ;;AwEv3SQ;EAOI,6BAAA;AxEo3SZ;;AwE33SQ;EAOI,4BAAA;AxEw3SZ;;AwE/3SQ;EAOI,4BAAA;AxE43SZ;;AwEn4SQ;EAOI,6BAAA;AxEg4SZ;;AwEv4SQ;EAOI,yBAAA;AxEo4SZ;;AwE34SQ;EAOI,yBAAA;AxEw4SZ;;AwE/4SQ;EAOI,2BAAA;AxE44SZ;;AwEn5SQ;EAOI,4BAAA;AxEg5SZ;;AwEv5SQ;EAOI,6BAAA;AxEo5SZ;;AwE35SQ;EAOI,gCAAA;AxEw5SZ;;AwE/5SQ;EAOI,qCAAA;AxE45SZ;;AwEn6SQ;EAOI,wCAAA;AxEg6SZ;;AwEv6SQ;EAOI,oCAAA;AxEo6SZ;;AwE36SQ;EAOI,oCAAA;AxEw6SZ;;AwE/6SQ;EAOI,qCAAA;AxE46SZ;;AwEn7SQ;EAOI,8BAAA;AxEg7SZ;;AwEv7SQ;EAOI,8BAAA;AxEo7SZ;;AwEz8SQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AxE07SZ;;AwEv6SQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AxEg8SZ;;AwEv8SQ;EAIQ,oBAAA;EAGJ,uEAAA;AxEq8SZ;;AwE58SQ;EAIQ,oBAAA;EAGJ,qEAAA;AxE08SZ;;AwEj9SQ;EAIQ,oBAAA;EAGJ,kEAAA;AxE+8SZ;;AwEt9SQ;EAIQ,oBAAA;EAGJ,qEAAA;AxEo9SZ;;AwE39SQ;EAIQ,oBAAA;EAGJ,oEAAA;AxEy9SZ;;AwEh+SQ;EAIQ,oBAAA;EAGJ,mEAAA;AxE89SZ;;AwEr+SQ;EAIQ,oBAAA;EAGJ,kEAAA;AxEm+SZ;;AwE1+SQ;EAIQ,oBAAA;EAGJ,mEAAA;AxEw+SZ;;AwE/+SQ;EAIQ,oBAAA;EAGJ,mEAAA;AxE6+SZ;;AwEp/SQ;EAIQ,oBAAA;EAGJ,wEAAA;AxEk/SZ;;AwEz/SQ;EAIQ,oBAAA;EAGJ,2CAAA;AxEu/SZ;;AwE9/SQ;EAIQ,oBAAA;EAGJ,oCAAA;AxE4/SZ;;AwEngTQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEigTZ;;AwExgTQ;EAIQ,oBAAA;EAGJ,2CAAA;AxEsgTZ;;AwE7gTQ;EAIQ,oBAAA;EAGJ,0CAAA;AxE2gTZ;;AwElhTQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEghTZ;;AwEvhTQ;EAIQ,oBAAA;EAGJ,yBAAA;AxEqhTZ;;AwEtiTQ;EACE,uBAAA;AxEyiTV;;AwE1iTQ;EACE,sBAAA;AxE6iTV;;AwE9iTQ;EACE,uBAAA;AxEijTV;;AwEljTQ;EACE,oBAAA;AxEqjTV;;AwE5iTQ;EAOI,iDAAA;AxEyiTZ;;AwEhjTQ;EAOI,mDAAA;AxE6iTZ;;AwEpjTQ;EAOI,iDAAA;AxEijTZ;;AwExjTQ;EAOI,8CAAA;AxEqjTZ;;AwE5jTQ;EAOI,iDAAA;AxEyjTZ;;AwEhkTQ;EAOI,gDAAA;AxE6jTZ;;AwEpkTQ;EAOI,+CAAA;AxEikTZ;;AwExkTQ;EAOI,8CAAA;AxEqkTZ;;AwEtlTQ;EACE,sBAAA;AxEylTV;;AwErlTU;EACE,sBAAA;AxEwlTZ;;AwE9lTQ;EACE,uBAAA;AxEimTV;;AwE7lTU;EACE,uBAAA;AxEgmTZ;;AwEtmTQ;EACE,sBAAA;AxEymTV;;AwErmTU;EACE,sBAAA;AxEwmTZ;;AwE9mTQ;EACE,uBAAA;AxEinTV;;AwE7mTU;EACE,uBAAA;AxEgnTZ;;AwEtnTQ;EACE,oBAAA;AxEynTV;;AwErnTU;EACE,oBAAA;AxEwnTZ;;AwEpnTQ;EAOI,yCAAA;AxEinTZ;;AwE5mTU;EAOI,yCAAA;AxEymTd;;AwE5nTQ;EAOI,wCAAA;AxEynTZ;;AwEpnTU;EAOI,wCAAA;AxEinTd;;AwEpoTQ;EAOI,yCAAA;AxEioTZ;;AwE5nTU;EAOI,yCAAA;AxEynTd;;AwE5oTQ;EAIQ,8BAAA;EAGJ,+FAAA;AxE0oTZ;;AwEjpTQ;EAIQ,8BAAA;EAGJ,iGAAA;AxE+oTZ;;AwEtpTQ;EAIQ,8BAAA;EAGJ,+FAAA;AxEopTZ;;AwE3pTQ;EAIQ,8BAAA;EAGJ,4FAAA;AxEypTZ;;AwEhqTQ;EAIQ,8BAAA;EAGJ,+FAAA;AxE8pTZ;;AwErqTQ;EAIQ,8BAAA;EAGJ,8FAAA;AxEmqTZ;;AwE1qTQ;EAIQ,8BAAA;EAGJ,6FAAA;AxEwqTZ;;AwE/qTQ;EAIQ,8BAAA;EAGJ,4FAAA;AxE6qTZ;;AwEprTQ;EAIQ,8BAAA;EAGJ,qGAAA;AxEkrTZ;;AwEnsTQ;EACE,8BAAA;AxEssTV;;AwElsTU;EACE,8BAAA;AxEqsTZ;;AwE3sTQ;EACE,gCAAA;AxE8sTV;;AwE1sTU;EACE,gCAAA;AxE6sTZ;;AwEntTQ;EACE,iCAAA;AxEstTV;;AwEltTU;EACE,iCAAA;AxEqtTZ;;AwE3tTQ;EACE,gCAAA;AxE8tTV;;AwE1tTU;EACE,gCAAA;AxE6tTZ;;AwEnuTQ;EACE,iCAAA;AxEsuTV;;AwEluTU;EACE,iCAAA;AxEquTZ;;AwE3uTQ;EACE,8BAAA;AxE8uTV;;AwE1uTU;EACE,8BAAA;AxE6uTZ;;AwEzuTQ;EAIQ,kBAAA;EAGJ,iCAAA;AxEuuTZ;;AwE9uTQ;EAIQ,kBAAA;EAGJ,oCAAA;AxE4uTZ;;AwEnvTQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEivTZ;;AwExvTQ;EAIQ,kBAAA;EAGJ,2EAAA;AxEsvTZ;;AwE7vTQ;EAIQ,kBAAA;EAGJ,8EAAA;AxE2vTZ;;AwElwTQ;EAIQ,kBAAA;EAGJ,6EAAA;AxEgwTZ;;AwEvwTQ;EAIQ,kBAAA;EAGJ,4EAAA;AxEqwTZ;;AwE5wTQ;EAIQ,kBAAA;EAGJ,2EAAA;AxE0wTZ;;AwEjxTQ;EAIQ,kBAAA;EAGJ,4EAAA;AxE+wTZ;;AwEtxTQ;EAIQ,kBAAA;EAGJ,4EAAA;AxEoxTZ;;AwE3xTQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEyxTZ;;AwEhyTQ;EAIQ,kBAAA;EAGJ,wCAAA;AxE8xTZ;;AwEryTQ;EAIQ,kBAAA;EAGJ,oCAAA;AxEmyTZ;;AwE1yTQ;EAIQ,kBAAA;EAGJ,oCAAA;AxEwyTZ;;AwE/yTQ;EAIQ,kBAAA;EAGJ,oCAAA;AxE6yTZ;;AwEpzTQ;EAIQ,kBAAA;EAGJ,oCAAA;AxEkzTZ;;AwEzzTQ;EAIQ,kBAAA;EAGJ,oCAAA;AxEuzTZ;;AwE9zTQ;EAIQ,kBAAA;EAGJ,oCAAA;AxE4zTZ;;AwEn0TQ;EAIQ,kBAAA;EAGJ,oCAAA;AxEi0TZ;;AwEx0TQ;EAIQ,kBAAA;EAGJ,oCAAA;AxEs0TZ;;AwE70TQ;EAIQ,kBAAA;EAGJ,oCAAA;AxE20TZ;;AwE51TQ;EACE,oBAAA;AxE+1TV;;AwEh2TQ;EACE,qBAAA;AxEm2TV;;AwEp2TQ;EACE,oBAAA;AxEu2TV;;AwEx2TQ;EACE,qBAAA;AxE22TV;;AwE52TQ;EACE,kBAAA;AxE+2TV;;AwEt2TQ;EAOI,wDAAA;AxEm2TZ;;AwE12TQ;EAOI,0DAAA;AxEu2TZ;;AwE92TQ;EAOI,wDAAA;AxE22TZ;;AwEl3TQ;EAOI,qDAAA;AxE+2TZ;;AwEt3TQ;EAOI,wDAAA;AxEm3TZ;;AwE13TQ;EAOI,uDAAA;AxEu3TZ;;AwE93TQ;EAOI,sDAAA;AxE23TZ;;AwEl4TQ;EAOI,qDAAA;AxE+3TZ;;AwEt4TQ;EAOI,+CAAA;AxEm4TZ;;AwE14TQ;EAOI,mCAAA;UAAA,2BAAA;AxEu4TZ;;AwE94TQ;EAOI,oCAAA;UAAA,4BAAA;AxE24TZ;;AwEl5TQ;EAOI,oCAAA;UAAA,4BAAA;AxE+4TZ;;AwEt5TQ;EAOI,+BAAA;AxEm5TZ;;AwE15TQ;EAOI,+BAAA;AxEu5TZ;;AwE95TQ;EAOI,iDAAA;AxE25TZ;;AwEl6TQ;EAOI,2BAAA;AxE+5TZ;;AwEt6TQ;EAOI,oDAAA;AxEm6TZ;;AwE16TQ;EAOI,oDAAA;AxEu6TZ;;AwE96TQ;EAOI,iDAAA;AxE26TZ;;AwEl7TQ;EAOI,oDAAA;AxE+6TZ;;AwEt7TQ;EAOI,oDAAA;AxEm7TZ;;AwE17TQ;EAOI,qDAAA;AxEu7TZ;;AwE97TQ;EAOI,qDAAA;AxE27TZ;;AwEl8TQ;EAOI,qDAAA;AxE+7TZ;;AwEt8TQ;EAOI,6BAAA;AxEm8TZ;;AwE18TQ;EAOI,sDAAA;AxEu8TZ;;AwE98TQ;EAOI,0DAAA;EAAA,2DAAA;AxE48TZ;;AwEn9TQ;EAOI,6DAAA;EAAA,8DAAA;AxEi9TZ;;AwEx9TQ;EAOI,6DAAA;EAAA,8DAAA;AxEs9TZ;;AwE79TQ;EAOI,0DAAA;EAAA,2DAAA;AxE29TZ;;AwEl+TQ;EAOI,6DAAA;EAAA,8DAAA;AxEg+TZ;;AwEv+TQ;EAOI,6DAAA;EAAA,8DAAA;AxEq+TZ;;AwE5+TQ;EAOI,8DAAA;EAAA,+DAAA;AxE0+TZ;;AwEj/TQ;EAOI,8DAAA;EAAA,+DAAA;AxE++TZ;;AwEt/TQ;EAOI,8DAAA;EAAA,+DAAA;AxEo/TZ;;AwE3/TQ;EAOI,8DAAA;EAAA,2DAAA;AxEy/TZ;;AwEhgUQ;EAOI,iEAAA;EAAA,8DAAA;AxE8/TZ;;AwErgUQ;EAOI,iEAAA;EAAA,8DAAA;AxEmgUZ;;AwE1gUQ;EAOI,8DAAA;EAAA,2DAAA;AxEwgUZ;;AwE/gUQ;EAOI,iEAAA;EAAA,8DAAA;AxE6gUZ;;AwEphUQ;EAOI,iEAAA;EAAA,8DAAA;AxEkhUZ;;AwEzhUQ;EAOI,kEAAA;EAAA,+DAAA;AxEuhUZ;;AwE9hUQ;EAOI,kEAAA;EAAA,+DAAA;AxE4hUZ;;AwEniUQ;EAOI,kEAAA;EAAA,+DAAA;AxEiiUZ;;AwExiUQ;EAOI,8DAAA;EAAA,6DAAA;AxEsiUZ;;AwE7iUQ;EAOI,iEAAA;EAAA,gEAAA;AxE2iUZ;;AwEljUQ;EAOI,iEAAA;EAAA,gEAAA;AxEgjUZ;;AwEvjUQ;EAOI,8DAAA;EAAA,6DAAA;AxEqjUZ;;AwE5jUQ;EAOI,iEAAA;EAAA,gEAAA;AxE0jUZ;;AwEjkUQ;EAOI,iEAAA;EAAA,gEAAA;AxE+jUZ;;AwEtkUQ;EAOI,kEAAA;EAAA,iEAAA;AxEokUZ;;AwE3kUQ;EAOI,kEAAA;EAAA,iEAAA;AxEykUZ;;AwEhlUQ;EAOI,kEAAA;EAAA,iEAAA;AxE8kUZ;;AwErlUQ;EAOI,0DAAA;EAAA,6DAAA;AxEmlUZ;;AwE1lUQ;EAOI,6DAAA;EAAA,gEAAA;AxEwlUZ;;AwE/lUQ;EAOI,6DAAA;EAAA,gEAAA;AxE6lUZ;;AwEpmUQ;EAOI,0DAAA;EAAA,6DAAA;AxEkmUZ;;AwEzmUQ;EAOI,6DAAA;EAAA,gEAAA;AxEumUZ;;AwE9mUQ;EAOI,6DAAA;EAAA,gEAAA;AxE4mUZ;;AwEnnUQ;EAOI,8DAAA;EAAA,iEAAA;AxEinUZ;;AwExnUQ;EAOI,8DAAA;EAAA,iEAAA;AxEsnUZ;;AwE7nUQ;EAOI,8DAAA;EAAA,iEAAA;AxE2nUZ;;AwEloUQ;EAOI,8BAAA;AxE+nUZ;;AwEtoUQ;EAOI,6BAAA;AxEmoUZ;;AwE1oUQ;EAOI,sBAAA;AxEuoUZ;;AwE9oUQ;EAOI,qBAAA;AxE2oUZ;;AwElpUQ;EAOI,qBAAA;AxE+oUZ;;AwEtpUQ;EAOI,qBAAA;AxEmpUZ;;AwE1pUQ;EAOI,qBAAA;AxEupUZ;;AwE9pUQ;EAOI,0DAAA;AxE2pUZ;;AwElqUQ;EAOI,6DAAA;AxE+pUZ;;AwEtqUQ;EAOI,6DAAA;AxEmqUZ;;AwE1qUQ;EAOI,0DAAA;AxEuqUZ;;AwE9qUQ;EAOI,6DAAA;AxE2qUZ;;AwElrUQ;EAOI,6DAAA;AxE+qUZ;;AwEtrUQ;EAOI,8DAAA;AxEmrUZ;;AwE1rUQ;EAOI,8DAAA;AxEurUZ;;AwE9rUQ;EAOI,8DAAA;AxE2rUZ;;AwElsUQ;EAOI,2DAAA;AxE+rUZ;;AwEtsUQ;EAOI,8DAAA;AxEmsUZ;;AwE1sUQ;EAOI,8DAAA;AxEusUZ;;AwE9sUQ;EAOI,2DAAA;AxE2sUZ;;AwEltUQ;EAOI,8DAAA;AxE+sUZ;;AwEttUQ;EAOI,8DAAA;AxEmtUZ;;AwE1tUQ;EAOI,+DAAA;AxEutUZ;;AwE9tUQ;EAOI,+DAAA;AxE2tUZ;;AwEluUQ;EAOI,+DAAA;AxE+tUZ;;AwEtuUQ;EAOI,8DAAA;AxEmuUZ;;AwE1uUQ;EAOI,iEAAA;AxEuuUZ;;AwE9uUQ;EAOI,iEAAA;AxE2uUZ;;AwElvUQ;EAOI,8DAAA;AxE+uUZ;;AwEtvUQ;EAOI,iEAAA;AxEmvUZ;;AwE1vUQ;EAOI,iEAAA;AxEuvUZ;;AwE9vUQ;EAOI,kEAAA;AxE2vUZ;;AwElwUQ;EAOI,kEAAA;AxE+vUZ;;AwEtwUQ;EAOI,kEAAA;AxEmwUZ;;AwE1wUQ;EAOI,6DAAA;AxEuwUZ;;AwE9wUQ;EAOI,gEAAA;AxE2wUZ;;AwElxUQ;EAOI,gEAAA;AxE+wUZ;;AwEtxUQ;EAOI,6DAAA;AxEmxUZ;;AwE1xUQ;EAOI,gEAAA;AxEuxUZ;;AwE9xUQ;EAOI,gEAAA;AxE2xUZ;;AwElyUQ;EAOI,iEAAA;AxE+xUZ;;AwEtyUQ;EAOI,iEAAA;AxEmyUZ;;AwE1yUQ;EAOI,iEAAA;AxEuyUZ;;AwE9yUQ;EAOI,4BAAA;AxE2yUZ;;AwElzUQ;EAOI,gCAAA;AxE+yUZ;;AwEtzUQ;EAOI,8BAAA;AxEmzUZ;;AwE1zUQ;EAOI,gCAAA;AxEuzUZ;;AwE9zUQ;EAOI,gCAAA;AxE2zUZ;;AwEl0UQ;EAOI,8BAAA;AxE+zUZ;;AGz0UI;EqEGI;IAOI,sBAAA;ExEo0UV;EwE30UM;IAOI,uBAAA;ExEu0UV;EwE90UM;IAOI,sBAAA;ExE00UV;EwEj1UM;IAOI,8BAAA;ExE60UV;EwEp1UM;IAOI,4BAAA;ExEg1UV;EwEv1UM;IAOI,2BAAA;ExEm1UV;EwE11UM;IAOI,iCAAA;ExEs1UV;EwE71UM;IAOI,2BAAA;ExEy1UV;EwEh2UM;IAOI,0BAAA;ExE41UV;EwEn2UM;IAOI,gCAAA;ExE+1UV;EwEt2UM;IAOI,yBAAA;ExEk2UV;EwEz2UM;IAOI,wBAAA;ExEq2UV;EwE52UM;IAOI,+BAAA;ExEw2UV;EwE/2UM;IAOI,yBAAA;ExE22UV;EwEl3UM;IAOI,6BAAA;ExE82UV;EwEr3UM;IAOI,8BAAA;ExEi3UV;EwEx3UM;IAOI,wBAAA;ExEo3UV;EwE33UM;IAOI,+BAAA;ExEu3UV;EwE93UM;IAOI,wBAAA;ExE03UV;EwEj4UM;IAOI,yBAAA;ExE63UV;EwEp4UM;IAOI,8BAAA;ExEg4UV;EwEv4UM;IAOI,iCAAA;ExEm4UV;EwE14UM;IAOI,sCAAA;ExEs4UV;EwE74UM;IAOI,yCAAA;ExEy4UV;EwEh5UM;IAOI,uBAAA;ExE44UV;EwEn5UM;IAOI,uBAAA;ExE+4UV;EwEt5UM;IAOI,yBAAA;ExEk5UV;EwEz5UM;IAOI,yBAAA;ExEq5UV;EwE55UM;IAOI,0BAAA;ExEw5UV;EwE/5UM;IAOI,4BAAA;ExE25UV;EwEl6UM;IAOI,kCAAA;ExE85UV;EwEr6UM;IAOI,sCAAA;ExEi6UV;EwEx6UM;IAOI,oCAAA;ExEo6UV;EwE36UM;IAOI,kCAAA;ExEu6UV;EwE96UM;IAOI,yCAAA;ExE06UV;EwEj7UM;IAOI,wCAAA;ExE66UV;EwEp7UM;IAOI,wCAAA;ExEg7UV;EwEv7UM;IAOI,kCAAA;ExEm7UV;EwE17UM;IAOI,gCAAA;ExEs7UV;EwE77UM;IAOI,8BAAA;ExEy7UV;EwEh8UM;IAOI,gCAAA;ExE47UV;EwEn8UM;IAOI,+BAAA;ExE+7UV;EwEt8UM;IAOI,oCAAA;ExEk8UV;EwEz8UM;IAOI,kCAAA;ExEq8UV;EwE58UM;IAOI,gCAAA;ExEw8UV;EwE/8UM;IAOI,uCAAA;ExE28UV;EwEl9UM;IAOI,sCAAA;ExE88UV;EwEr9UM;IAOI,iCAAA;ExEi9UV;EwEx9UM;IAOI,2BAAA;ExEo9UV;EwE39UM;IAOI,iCAAA;ExEu9UV;EwE99UM;IAOI,+BAAA;ExE09UV;EwEj+UM;IAOI,6BAAA;ExE69UV;EwEp+UM;IAOI,+BAAA;ExEg+UV;EwEv+UM;IAOI,8BAAA;ExEm+UV;EwE1+UM;IAOI,oBAAA;ExEs+UV;EwE7+UM;IAOI,mBAAA;ExEy+UV;EwEh/UM;IAOI,mBAAA;ExE4+UV;EwEn/UM;IAOI,mBAAA;ExE++UV;EwEt/UM;IAOI,mBAAA;ExEk/UV;EwEz/UM;IAOI,mBAAA;ExEq/UV;EwE5/UM;IAOI,mBAAA;ExEw/UV;EwE//UM;IAOI,mBAAA;ExE2/UV;EwElgVM;IAOI,oBAAA;ExE8/UV;EwErgVM;IAOI,2BAAA;ExEigVV;EwExgVM;IAOI,0BAAA;ExEogVV;EwE3gVM;IAOI,yBAAA;ExEugVV;EwE9gVM;IAOI,uBAAA;ExE0gVV;EwEjhVM;IAOI,yBAAA;ExE6gVV;EwEphVM;IAOI,uBAAA;ExEghVV;EwEvhVM;IAOI,yBAAA;ExEmhVV;EwE1hVM;IAOI,uBAAA;ExEshVV;EwE7hVM;IAOI,yBAAA;ExEyhVV;EwEhiVM;IAOI,uBAAA;ExE4hVV;EwEniVM;IAOI,uBAAA;ExE+hVV;EwEtiVM;IAOI,uBAAA;ExEkiVV;EwEziVM;IAOI,yBAAA;ExEqiVV;EwE5iVM;IAOI,uBAAA;ExEwiVV;EwE/iVM;IAOI,uBAAA;ExE2iVV;EwEljVM;IAOI,0BAAA;IAAA,yBAAA;ExE+iVV;EwEtjVM;IAOI,iCAAA;IAAA,gCAAA;ExEmjVV;EwE1jVM;IAOI,gCAAA;IAAA,+BAAA;ExEujVV;EwE9jVM;IAOI,+BAAA;IAAA,8BAAA;ExE2jVV;EwElkVM;IAOI,6BAAA;IAAA,4BAAA;ExE+jVV;EwEtkVM;IAOI,+BAAA;IAAA,8BAAA;ExEmkVV;EwE1kVM;IAOI,6BAAA;IAAA,4BAAA;ExEukVV;EwE9kVM;IAOI,+BAAA;IAAA,8BAAA;ExE2kVV;EwEllVM;IAOI,6BAAA;IAAA,4BAAA;ExE+kVV;EwEtlVM;IAOI,+BAAA;IAAA,8BAAA;ExEmlVV;EwE1lVM;IAOI,6BAAA;IAAA,4BAAA;ExEulVV;EwE9lVM;IAOI,6BAAA;IAAA,4BAAA;ExE2lVV;EwElmVM;IAOI,6BAAA;IAAA,4BAAA;ExE+lVV;EwEtmVM;IAOI,+BAAA;IAAA,8BAAA;ExEmmVV;EwE1mVM;IAOI,6BAAA;IAAA,4BAAA;ExEumVV;EwE9mVM;IAOI,6BAAA;IAAA,4BAAA;ExE2mVV;EwElnVM;IAOI,wBAAA;IAAA,2BAAA;ExE+mVV;EwEtnVM;IAOI,+BAAA;IAAA,kCAAA;ExEmnVV;EwE1nVM;IAOI,8BAAA;IAAA,iCAAA;ExEunVV;EwE9nVM;IAOI,6BAAA;IAAA,gCAAA;ExE2nVV;EwEloVM;IAOI,2BAAA;IAAA,8BAAA;ExE+nVV;EwEtoVM;IAOI,6BAAA;IAAA,gCAAA;ExEmoVV;EwE1oVM;IAOI,2BAAA;IAAA,8BAAA;ExEuoVV;EwE9oVM;IAOI,6BAAA;IAAA,gCAAA;ExE2oVV;EwElpVM;IAOI,2BAAA;IAAA,8BAAA;ExE+oVV;EwEtpVM;IAOI,6BAAA;IAAA,gCAAA;ExEmpVV;EwE1pVM;IAOI,2BAAA;IAAA,8BAAA;ExEupVV;EwE9pVM;IAOI,2BAAA;IAAA,8BAAA;ExE2pVV;EwElqVM;IAOI,2BAAA;IAAA,8BAAA;ExE+pVV;EwEtqVM;IAOI,6BAAA;IAAA,gCAAA;ExEmqVV;EwE1qVM;IAOI,2BAAA;IAAA,8BAAA;ExEuqVV;EwE9qVM;IAOI,2BAAA;IAAA,8BAAA;ExE2qVV;EwElrVM;IAOI,wBAAA;ExE8qVV;EwErrVM;IAOI,+BAAA;ExEirVV;EwExrVM;IAOI,8BAAA;ExEorVV;EwE3rVM;IAOI,6BAAA;ExEurVV;EwE9rVM;IAOI,2BAAA;ExE0rVV;EwEjsVM;IAOI,6BAAA;ExE6rVV;EwEpsVM;IAOI,2BAAA;ExEgsVV;EwEvsVM;IAOI,6BAAA;ExEmsVV;EwE1sVM;IAOI,2BAAA;ExEssVV;EwE7sVM;IAOI,6BAAA;ExEysVV;EwEhtVM;IAOI,2BAAA;ExE4sVV;EwEntVM;IAOI,2BAAA;ExE+sVV;EwEttVM;IAOI,2BAAA;ExEktVV;EwEztVM;IAOI,6BAAA;ExEqtVV;EwE5tVM;IAOI,2BAAA;ExEwtVV;EwE/tVM;IAOI,2BAAA;ExE2tVV;EwEluVM;IAOI,0BAAA;ExE8tVV;EwEruVM;IAOI,iCAAA;ExEiuVV;EwExuVM;IAOI,gCAAA;ExEouVV;EwE3uVM;IAOI,+BAAA;ExEuuVV;EwE9uVM;IAOI,6BAAA;ExE0uVV;EwEjvVM;IAOI,+BAAA;ExE6uVV;EwEpvVM;IAOI,6BAAA;ExEgvVV;EwEvvVM;IAOI,+BAAA;ExEmvVV;EwE1vVM;IAOI,6BAAA;ExEsvVV;EwE7vVM;IAOI,+BAAA;ExEyvVV;EwEhwVM;IAOI,6BAAA;ExE4vVV;EwEnwVM;IAOI,6BAAA;ExE+vVV;EwEtwVM;IAOI,6BAAA;ExEkwVV;EwEzwVM;IAOI,+BAAA;ExEqwVV;EwE5wVM;IAOI,6BAAA;ExEwwVV;EwE/wVM;IAOI,6BAAA;ExE2wVV;EwElxVM;IAOI,2BAAA;ExE8wVV;EwErxVM;IAOI,kCAAA;ExEixVV;EwExxVM;IAOI,iCAAA;ExEoxVV;EwE3xVM;IAOI,gCAAA;ExEuxVV;EwE9xVM;IAOI,8BAAA;ExE0xVV;EwEjyVM;IAOI,gCAAA;ExE6xVV;EwEpyVM;IAOI,8BAAA;ExEgyVV;EwEvyVM;IAOI,gCAAA;ExEmyVV;EwE1yVM;IAOI,8BAAA;ExEsyVV;EwE7yVM;IAOI,gCAAA;ExEyyVV;EwEhzVM;IAOI,8BAAA;ExE4yVV;EwEnzVM;IAOI,8BAAA;ExE+yVV;EwEtzVM;IAOI,8BAAA;ExEkzVV;EwEzzVM;IAOI,gCAAA;ExEqzVV;EwE5zVM;IAOI,8BAAA;ExEwzVV;EwE/zVM;IAOI,8BAAA;ExE2zVV;EwEl0VM;IAOI,yBAAA;ExE8zVV;EwEr0VM;IAOI,gCAAA;ExEi0VV;EwEx0VM;IAOI,+BAAA;ExEo0VV;EwE30VM;IAOI,8BAAA;ExEu0VV;EwE90VM;IAOI,4BAAA;ExE00VV;EwEj1VM;IAOI,8BAAA;ExE60VV;EwEp1VM;IAOI,4BAAA;ExEg1VV;EwEv1VM;IAOI,8BAAA;ExEm1VV;EwE11VM;IAOI,4BAAA;ExEs1VV;EwE71VM;IAOI,8BAAA;ExEy1VV;EwEh2VM;IAOI,4BAAA;ExE41VV;EwEn2VM;IAOI,4BAAA;ExE+1VV;EwEt2VM;IAOI,4BAAA;ExEk2VV;EwEz2VM;IAOI,8BAAA;ExEq2VV;EwE52VM;IAOI,4BAAA;ExEw2VV;EwE/2VM;IAOI,4BAAA;ExE22VV;EwEl3VM;IAOI,4BAAA;ExE82VV;EwEr3VM;IAOI,2BAAA;ExEi3VV;EwEx3VM;IAOI,0BAAA;ExEo3VV;EwE33VM;IAOI,wBAAA;ExEu3VV;EwE93VM;IAOI,0BAAA;ExE03VV;EwEj4VM;IAOI,wBAAA;ExE63VV;EwEp4VM;IAOI,0BAAA;ExEg4VV;EwEv4VM;IAOI,wBAAA;ExEm4VV;EwE14VM;IAOI,0BAAA;ExEs4VV;EwE74VM;IAOI,wBAAA;ExEy4VV;EwEh5VM;IAOI,wBAAA;ExE44VV;EwEn5VM;IAOI,wBAAA;ExE+4VV;EwEt5VM;IAOI,0BAAA;ExEk5VV;EwEz5VM;IAOI,wBAAA;ExEq5VV;EwE55VM;IAOI,kCAAA;IAAA,iCAAA;ExEy5VV;EwEh6VM;IAOI,iCAAA;IAAA,gCAAA;ExE65VV;EwEp6VM;IAOI,gCAAA;IAAA,+BAAA;ExEi6VV;EwEx6VM;IAOI,8BAAA;IAAA,6BAAA;ExEq6VV;EwE56VM;IAOI,gCAAA;IAAA,+BAAA;ExEy6VV;EwEh7VM;IAOI,8BAAA;IAAA,6BAAA;ExE66VV;EwEp7VM;IAOI,gCAAA;IAAA,+BAAA;ExEi7VV;EwEx7VM;IAOI,8BAAA;IAAA,6BAAA;ExEq7VV;EwE57VM;IAOI,gCAAA;IAAA,+BAAA;ExEy7VV;EwEh8VM;IAOI,8BAAA;IAAA,6BAAA;ExE67VV;EwEp8VM;IAOI,8BAAA;IAAA,6BAAA;ExEi8VV;EwEx8VM;IAOI,8BAAA;IAAA,6BAAA;ExEq8VV;EwE58VM;IAOI,gCAAA;IAAA,+BAAA;ExEy8VV;EwEh9VM;IAOI,8BAAA;IAAA,6BAAA;ExE68VV;EwEp9VM;IAOI,gCAAA;IAAA,mCAAA;ExEi9VV;EwEx9VM;IAOI,+BAAA;IAAA,kCAAA;ExEq9VV;EwE59VM;IAOI,8BAAA;IAAA,iCAAA;ExEy9VV;EwEh+VM;IAOI,4BAAA;IAAA,+BAAA;ExE69VV;EwEp+VM;IAOI,8BAAA;IAAA,iCAAA;ExEi+VV;EwEx+VM;IAOI,4BAAA;IAAA,+BAAA;ExEq+VV;EwE5+VM;IAOI,8BAAA;IAAA,iCAAA;ExEy+VV;EwEh/VM;IAOI,4BAAA;IAAA,+BAAA;ExE6+VV;EwEp/VM;IAOI,8BAAA;IAAA,iCAAA;ExEi/VV;EwEx/VM;IAOI,4BAAA;IAAA,+BAAA;ExEq/VV;EwE5/VM;IAOI,4BAAA;IAAA,+BAAA;ExEy/VV;EwEhgWM;IAOI,4BAAA;IAAA,+BAAA;ExE6/VV;EwEpgWM;IAOI,8BAAA;IAAA,iCAAA;ExEigWV;EwExgWM;IAOI,4BAAA;IAAA,+BAAA;ExEqgWV;EwE5gWM;IAOI,gCAAA;ExEwgWV;EwE/gWM;IAOI,+BAAA;ExE2gWV;EwElhWM;IAOI,8BAAA;ExE8gWV;EwErhWM;IAOI,4BAAA;ExEihWV;EwExhWM;IAOI,8BAAA;ExEohWV;EwE3hWM;IAOI,4BAAA;ExEuhWV;EwE9hWM;IAOI,8BAAA;ExE0hWV;EwEjiWM;IAOI,4BAAA;ExE6hWV;EwEpiWM;IAOI,8BAAA;ExEgiWV;EwEviWM;IAOI,4BAAA;ExEmiWV;EwE1iWM;IAOI,4BAAA;ExEsiWV;EwE7iWM;IAOI,4BAAA;ExEyiWV;EwEhjWM;IAOI,8BAAA;ExE4iWV;EwEnjWM;IAOI,4BAAA;ExE+iWV;EwEtjWM;IAOI,kCAAA;ExEkjWV;EwEzjWM;IAOI,iCAAA;ExEqjWV;EwE5jWM;IAOI,gCAAA;ExEwjWV;EwE/jWM;IAOI,8BAAA;ExE2jWV;EwElkWM;IAOI,gCAAA;ExE8jWV;EwErkWM;IAOI,8BAAA;ExEikWV;EwExkWM;IAOI,gCAAA;ExEokWV;EwE3kWM;IAOI,8BAAA;ExEukWV;EwE9kWM;IAOI,gCAAA;ExE0kWV;EwEjlWM;IAOI,8BAAA;ExE6kWV;EwEplWM;IAOI,8BAAA;ExEglWV;EwEvlWM;IAOI,8BAAA;ExEmlWV;EwE1lWM;IAOI,gCAAA;ExEslWV;EwE7lWM;IAOI,8BAAA;ExEylWV;EwEhmWM;IAOI,mCAAA;ExE4lWV;EwEnmWM;IAOI,kCAAA;ExE+lWV;EwEtmWM;IAOI,iCAAA;ExEkmWV;EwEzmWM;IAOI,+BAAA;ExEqmWV;EwE5mWM;IAOI,iCAAA;ExEwmWV;EwE/mWM;IAOI,+BAAA;ExE2mWV;EwElnWM;IAOI,iCAAA;ExE8mWV;EwErnWM;IAOI,+BAAA;ExEinWV;EwExnWM;IAOI,iCAAA;ExEonWV;EwE3nWM;IAOI,+BAAA;ExEunWV;EwE9nWM;IAOI,+BAAA;ExE0nWV;EwEjoWM;IAOI,+BAAA;ExE6nWV;EwEpoWM;IAOI,iCAAA;ExEgoWV;EwEvoWM;IAOI,+BAAA;ExEmoWV;EwE1oWM;IAOI,iCAAA;ExEsoWV;EwE7oWM;IAOI,gCAAA;ExEyoWV;EwEhpWM;IAOI,+BAAA;ExE4oWV;EwEnpWM;IAOI,6BAAA;ExE+oWV;EwEtpWM;IAOI,+BAAA;ExEkpWV;EwEzpWM;IAOI,6BAAA;ExEqpWV;EwE5pWM;IAOI,+BAAA;ExEwpWV;EwE/pWM;IAOI,6BAAA;ExE2pWV;EwElqWM;IAOI,+BAAA;ExE8pWV;EwErqWM;IAOI,6BAAA;ExEiqWV;EwExqWM;IAOI,6BAAA;ExEoqWV;EwE3qWM;IAOI,6BAAA;ExEuqWV;EwE9qWM;IAOI,+BAAA;ExE0qWV;EwEjrWM;IAOI,6BAAA;ExE6qWV;EwEprWM;IAOI,qBAAA;ExEgrWV;EwEvrWM;IAOI,4BAAA;ExEmrWV;EwE1rWM;IAOI,2BAAA;ExEsrWV;EwE7rWM;IAOI,0BAAA;ExEyrWV;EwEhsWM;IAOI,wBAAA;ExE4rWV;EwEnsWM;IAOI,0BAAA;ExE+rWV;EwEtsWM;IAOI,wBAAA;ExEksWV;EwEzsWM;IAOI,0BAAA;ExEqsWV;EwE5sWM;IAOI,wBAAA;ExEwsWV;EwE/sWM;IAOI,0BAAA;ExE2sWV;EwEltWM;IAOI,wBAAA;ExE8sWV;EwErtWM;IAOI,wBAAA;ExEitWV;EwExtWM;IAOI,wBAAA;ExEotWV;EwE3tWM;IAOI,0BAAA;ExEutWV;EwE9tWM;IAOI,wBAAA;ExE0tWV;EwEjuWM;IAOI,2BAAA;IAAA,0BAAA;ExE8tWV;EwEruWM;IAOI,kCAAA;IAAA,iCAAA;ExEkuWV;EwEzuWM;IAOI,iCAAA;IAAA,gCAAA;ExEsuWV;EwE7uWM;IAOI,gCAAA;IAAA,+BAAA;ExE0uWV;EwEjvWM;IAOI,8BAAA;IAAA,6BAAA;ExE8uWV;EwErvWM;IAOI,gCAAA;IAAA,+BAAA;ExEkvWV;EwEzvWM;IAOI,8BAAA;IAAA,6BAAA;ExEsvWV;EwE7vWM;IAOI,gCAAA;IAAA,+BAAA;ExE0vWV;EwEjwWM;IAOI,8BAAA;IAAA,6BAAA;ExE8vWV;EwErwWM;IAOI,gCAAA;IAAA,+BAAA;ExEkwWV;EwEzwWM;IAOI,8BAAA;IAAA,6BAAA;ExEswWV;EwE7wWM;IAOI,8BAAA;IAAA,6BAAA;ExE0wWV;EwEjxWM;IAOI,8BAAA;IAAA,6BAAA;ExE8wWV;EwErxWM;IAOI,gCAAA;IAAA,+BAAA;ExEkxWV;EwEzxWM;IAOI,8BAAA;IAAA,6BAAA;ExEsxWV;EwE7xWM;IAOI,yBAAA;IAAA,4BAAA;ExE0xWV;EwEjyWM;IAOI,gCAAA;IAAA,mCAAA;ExE8xWV;EwEryWM;IAOI,+BAAA;IAAA,kCAAA;ExEkyWV;EwEzyWM;IAOI,8BAAA;IAAA,iCAAA;ExEsyWV;EwE7yWM;IAOI,4BAAA;IAAA,+BAAA;ExE0yWV;EwEjzWM;IAOI,8BAAA;IAAA,iCAAA;ExE8yWV;EwErzWM;IAOI,4BAAA;IAAA,+BAAA;ExEkzWV;EwEzzWM;IAOI,8BAAA;IAAA,iCAAA;ExEszWV;EwE7zWM;IAOI,4BAAA;IAAA,+BAAA;ExE0zWV;EwEj0WM;IAOI,8BAAA;IAAA,iCAAA;ExE8zWV;EwEr0WM;IAOI,4BAAA;IAAA,+BAAA;ExEk0WV;EwEz0WM;IAOI,4BAAA;IAAA,+BAAA;ExEs0WV;EwE70WM;IAOI,4BAAA;IAAA,+BAAA;ExE00WV;EwEj1WM;IAOI,8BAAA;IAAA,iCAAA;ExE80WV;EwEr1WM;IAOI,4BAAA;IAAA,+BAAA;ExEk1WV;EwEz1WM;IAOI,yBAAA;ExEq1WV;EwE51WM;IAOI,gCAAA;ExEw1WV;EwE/1WM;IAOI,+BAAA;ExE21WV;EwEl2WM;IAOI,8BAAA;ExE81WV;EwEr2WM;IAOI,4BAAA;ExEi2WV;EwEx2WM;IAOI,8BAAA;ExEo2WV;EwE32WM;IAOI,4BAAA;ExEu2WV;EwE92WM;IAOI,8BAAA;ExE02WV;EwEj3WM;IAOI,4BAAA;ExE62WV;EwEp3WM;IAOI,8BAAA;ExEg3WV;EwEv3WM;IAOI,4BAAA;ExEm3WV;EwE13WM;IAOI,4BAAA;ExEs3WV;EwE73WM;IAOI,4BAAA;ExEy3WV;EwEh4WM;IAOI,8BAAA;ExE43WV;EwEn4WM;IAOI,4BAAA;ExE+3WV;EwEt4WM;IAOI,2BAAA;ExEk4WV;EwEz4WM;IAOI,kCAAA;ExEq4WV;EwE54WM;IAOI,iCAAA;ExEw4WV;EwE/4WM;IAOI,gCAAA;ExE24WV;EwEl5WM;IAOI,8BAAA;ExE84WV;EwEr5WM;IAOI,gCAAA;ExEi5WV;EwEx5WM;IAOI,8BAAA;ExEo5WV;EwE35WM;IAOI,gCAAA;ExEu5WV;EwE95WM;IAOI,8BAAA;ExE05WV;EwEj6WM;IAOI,gCAAA;ExE65WV;EwEp6WM;IAOI,8BAAA;ExEg6WV;EwEv6WM;IAOI,8BAAA;ExEm6WV;EwE16WM;IAOI,8BAAA;ExEs6WV;EwE76WM;IAOI,gCAAA;ExEy6WV;EwEh7WM;IAOI,8BAAA;ExE46WV;EwEn7WM;IAOI,4BAAA;ExE+6WV;EwEt7WM;IAOI,mCAAA;ExEk7WV;EwEz7WM;IAOI,kCAAA;ExEq7WV;EwE57WM;IAOI,iCAAA;ExEw7WV;EwE/7WM;IAOI,+BAAA;ExE27WV;EwEl8WM;IAOI,iCAAA;ExE87WV;EwEr8WM;IAOI,+BAAA;ExEi8WV;EwEx8WM;IAOI,iCAAA;ExEo8WV;EwE38WM;IAOI,+BAAA;ExEu8WV;EwE98WM;IAOI,iCAAA;ExE08WV;EwEj9WM;IAOI,+BAAA;ExE68WV;EwEp9WM;IAOI,+BAAA;ExEg9WV;EwEv9WM;IAOI,+BAAA;ExEm9WV;EwE19WM;IAOI,iCAAA;ExEs9WV;EwE79WM;IAOI,+BAAA;ExEy9WV;EwEh+WM;IAOI,0BAAA;ExE49WV;EwEn+WM;IAOI,iCAAA;ExE+9WV;EwEt+WM;IAOI,gCAAA;ExEk+WV;EwEz+WM;IAOI,+BAAA;ExEq+WV;EwE5+WM;IAOI,6BAAA;ExEw+WV;EwE/+WM;IAOI,+BAAA;ExE2+WV;EwEl/WM;IAOI,6BAAA;ExE8+WV;EwEr/WM;IAOI,+BAAA;ExEi/WV;EwEx/WM;IAOI,6BAAA;ExEo/WV;EwE3/WM;IAOI,+BAAA;ExEu/WV;EwE9/WM;IAOI,6BAAA;ExE0/WV;EwEjgXM;IAOI,6BAAA;ExE6/WV;EwEpgXM;IAOI,6BAAA;ExEggXV;EwEvgXM;IAOI,+BAAA;ExEmgXV;EwE1gXM;IAOI,6BAAA;ExEsgXV;EwE7gXM;IAOI,iBAAA;ExEygXV;EwEhhXM;IAOI,wBAAA;ExE4gXV;EwEnhXM;IAOI,uBAAA;ExE+gXV;EwEthXM;IAOI,sBAAA;ExEkhXV;EwEzhXM;IAOI,oBAAA;ExEqhXV;EwE5hXM;IAOI,sBAAA;ExEwhXV;EwE/hXM;IAOI,oBAAA;ExE2hXV;EwEliXM;IAOI,sBAAA;ExE8hXV;EwEriXM;IAOI,oBAAA;ExEiiXV;EwExiXM;IAOI,sBAAA;ExEoiXV;EwE3iXM;IAOI,oBAAA;ExEuiXV;EwE9iXM;IAOI,oBAAA;ExE0iXV;EwEjjXM;IAOI,oBAAA;ExE6iXV;EwEpjXM;IAOI,sBAAA;ExEgjXV;EwEvjXM;IAOI,oBAAA;ExEmjXV;EwE1jXM;IAOI,qBAAA;ExEsjXV;EwE7jXM;IAOI,4BAAA;ExEyjXV;EwEhkXM;IAOI,2BAAA;ExE4jXV;EwEnkXM;IAOI,0BAAA;ExE+jXV;EwEtkXM;IAOI,wBAAA;ExEkkXV;EwEzkXM;IAOI,0BAAA;ExEqkXV;EwE5kXM;IAOI,wBAAA;ExEwkXV;EwE/kXM;IAOI,0BAAA;ExE2kXV;EwEllXM;IAOI,wBAAA;ExE8kXV;EwErlXM;IAOI,0BAAA;ExEilXV;EwExlXM;IAOI,wBAAA;ExEolXV;EwE3lXM;IAOI,wBAAA;ExEulXV;EwE9lXM;IAOI,wBAAA;ExE0lXV;EwEjmXM;IAOI,0BAAA;ExE6lXV;EwEpmXM;IAOI,wBAAA;ExEgmXV;EwEvmXM;IAOI,wBAAA;ExEmmXV;EwE1mXM;IAOI,+BAAA;ExEsmXV;EwE7mXM;IAOI,8BAAA;ExEymXV;EwEhnXM;IAOI,6BAAA;ExE4mXV;EwEnnXM;IAOI,2BAAA;ExE+mXV;EwEtnXM;IAOI,6BAAA;ExEknXV;EwEznXM;IAOI,2BAAA;ExEqnXV;EwE5nXM;IAOI,6BAAA;ExEwnXV;EwE/nXM;IAOI,2BAAA;ExE2nXV;EwEloXM;IAOI,6BAAA;ExE8nXV;EwEroXM;IAOI,2BAAA;ExEioXV;EwExoXM;IAOI,2BAAA;ExEooXV;EwE3oXM;IAOI,2BAAA;ExEuoXV;EwE9oXM;IAOI,6BAAA;ExE0oXV;EwEjpXM;IAOI,2BAAA;ExE6oXV;EwEppXM;IAOI,2BAAA;ExEgpXV;EwEvpXM;IAOI,4BAAA;ExEmpXV;EwE1pXM;IAOI,6BAAA;ExEspXV;AACF;AGjqXI;EqEGI;IAOI,sBAAA;ExE2pXV;EwElqXM;IAOI,uBAAA;ExE8pXV;EwErqXM;IAOI,sBAAA;ExEiqXV;EwExqXM;IAOI,8BAAA;ExEoqXV;EwE3qXM;IAOI,4BAAA;ExEuqXV;EwE9qXM;IAOI,2BAAA;ExE0qXV;EwEjrXM;IAOI,iCAAA;ExE6qXV;EwEprXM;IAOI,2BAAA;ExEgrXV;EwEvrXM;IAOI,0BAAA;ExEmrXV;EwE1rXM;IAOI,gCAAA;ExEsrXV;EwE7rXM;IAOI,yBAAA;ExEyrXV;EwEhsXM;IAOI,wBAAA;ExE4rXV;EwEnsXM;IAOI,+BAAA;ExE+rXV;EwEtsXM;IAOI,yBAAA;ExEksXV;EwEzsXM;IAOI,6BAAA;ExEqsXV;EwE5sXM;IAOI,8BAAA;ExEwsXV;EwE/sXM;IAOI,wBAAA;ExE2sXV;EwEltXM;IAOI,+BAAA;ExE8sXV;EwErtXM;IAOI,wBAAA;ExEitXV;EwExtXM;IAOI,yBAAA;ExEotXV;EwE3tXM;IAOI,8BAAA;ExEutXV;EwE9tXM;IAOI,iCAAA;ExE0tXV;EwEjuXM;IAOI,sCAAA;ExE6tXV;EwEpuXM;IAOI,yCAAA;ExEguXV;EwEvuXM;IAOI,uBAAA;ExEmuXV;EwE1uXM;IAOI,uBAAA;ExEsuXV;EwE7uXM;IAOI,yBAAA;ExEyuXV;EwEhvXM;IAOI,yBAAA;ExE4uXV;EwEnvXM;IAOI,0BAAA;ExE+uXV;EwEtvXM;IAOI,4BAAA;ExEkvXV;EwEzvXM;IAOI,kCAAA;ExEqvXV;EwE5vXM;IAOI,sCAAA;ExEwvXV;EwE/vXM;IAOI,oCAAA;ExE2vXV;EwElwXM;IAOI,kCAAA;ExE8vXV;EwErwXM;IAOI,yCAAA;ExEiwXV;EwExwXM;IAOI,wCAAA;ExEowXV;EwE3wXM;IAOI,wCAAA;ExEuwXV;EwE9wXM;IAOI,kCAAA;ExE0wXV;EwEjxXM;IAOI,gCAAA;ExE6wXV;EwEpxXM;IAOI,8BAAA;ExEgxXV;EwEvxXM;IAOI,gCAAA;ExEmxXV;EwE1xXM;IAOI,+BAAA;ExEsxXV;EwE7xXM;IAOI,oCAAA;ExEyxXV;EwEhyXM;IAOI,kCAAA;ExE4xXV;EwEnyXM;IAOI,gCAAA;ExE+xXV;EwEtyXM;IAOI,uCAAA;ExEkyXV;EwEzyXM;IAOI,sCAAA;ExEqyXV;EwE5yXM;IAOI,iCAAA;ExEwyXV;EwE/yXM;IAOI,2BAAA;ExE2yXV;EwElzXM;IAOI,iCAAA;ExE8yXV;EwErzXM;IAOI,+BAAA;ExEizXV;EwExzXM;IAOI,6BAAA;ExEozXV;EwE3zXM;IAOI,+BAAA;ExEuzXV;EwE9zXM;IAOI,8BAAA;ExE0zXV;EwEj0XM;IAOI,oBAAA;ExE6zXV;EwEp0XM;IAOI,mBAAA;ExEg0XV;EwEv0XM;IAOI,mBAAA;ExEm0XV;EwE10XM;IAOI,mBAAA;ExEs0XV;EwE70XM;IAOI,mBAAA;ExEy0XV;EwEh1XM;IAOI,mBAAA;ExE40XV;EwEn1XM;IAOI,mBAAA;ExE+0XV;EwEt1XM;IAOI,mBAAA;ExEk1XV;EwEz1XM;IAOI,oBAAA;ExEq1XV;EwE51XM;IAOI,2BAAA;ExEw1XV;EwE/1XM;IAOI,0BAAA;ExE21XV;EwEl2XM;IAOI,yBAAA;ExE81XV;EwEr2XM;IAOI,uBAAA;ExEi2XV;EwEx2XM;IAOI,yBAAA;ExEo2XV;EwE32XM;IAOI,uBAAA;ExEu2XV;EwE92XM;IAOI,yBAAA;ExE02XV;EwEj3XM;IAOI,uBAAA;ExE62XV;EwEp3XM;IAOI,yBAAA;ExEg3XV;EwEv3XM;IAOI,uBAAA;ExEm3XV;EwE13XM;IAOI,uBAAA;ExEs3XV;EwE73XM;IAOI,uBAAA;ExEy3XV;EwEh4XM;IAOI,yBAAA;ExE43XV;EwEn4XM;IAOI,uBAAA;ExE+3XV;EwEt4XM;IAOI,uBAAA;ExEk4XV;EwEz4XM;IAOI,0BAAA;IAAA,yBAAA;ExEs4XV;EwE74XM;IAOI,iCAAA;IAAA,gCAAA;ExE04XV;EwEj5XM;IAOI,gCAAA;IAAA,+BAAA;ExE84XV;EwEr5XM;IAOI,+BAAA;IAAA,8BAAA;ExEk5XV;EwEz5XM;IAOI,6BAAA;IAAA,4BAAA;ExEs5XV;EwE75XM;IAOI,+BAAA;IAAA,8BAAA;ExE05XV;EwEj6XM;IAOI,6BAAA;IAAA,4BAAA;ExE85XV;EwEr6XM;IAOI,+BAAA;IAAA,8BAAA;ExEk6XV;EwEz6XM;IAOI,6BAAA;IAAA,4BAAA;ExEs6XV;EwE76XM;IAOI,+BAAA;IAAA,8BAAA;ExE06XV;EwEj7XM;IAOI,6BAAA;IAAA,4BAAA;ExE86XV;EwEr7XM;IAOI,6BAAA;IAAA,4BAAA;ExEk7XV;EwEz7XM;IAOI,6BAAA;IAAA,4BAAA;ExEs7XV;EwE77XM;IAOI,+BAAA;IAAA,8BAAA;ExE07XV;EwEj8XM;IAOI,6BAAA;IAAA,4BAAA;ExE87XV;EwEr8XM;IAOI,6BAAA;IAAA,4BAAA;ExEk8XV;EwEz8XM;IAOI,wBAAA;IAAA,2BAAA;ExEs8XV;EwE78XM;IAOI,+BAAA;IAAA,kCAAA;ExE08XV;EwEj9XM;IAOI,8BAAA;IAAA,iCAAA;ExE88XV;EwEr9XM;IAOI,6BAAA;IAAA,gCAAA;ExEk9XV;EwEz9XM;IAOI,2BAAA;IAAA,8BAAA;ExEs9XV;EwE79XM;IAOI,6BAAA;IAAA,gCAAA;ExE09XV;EwEj+XM;IAOI,2BAAA;IAAA,8BAAA;ExE89XV;EwEr+XM;IAOI,6BAAA;IAAA,gCAAA;ExEk+XV;EwEz+XM;IAOI,2BAAA;IAAA,8BAAA;ExEs+XV;EwE7+XM;IAOI,6BAAA;IAAA,gCAAA;ExE0+XV;EwEj/XM;IAOI,2BAAA;IAAA,8BAAA;ExE8+XV;EwEr/XM;IAOI,2BAAA;IAAA,8BAAA;ExEk/XV;EwEz/XM;IAOI,2BAAA;IAAA,8BAAA;ExEs/XV;EwE7/XM;IAOI,6BAAA;IAAA,gCAAA;ExE0/XV;EwEjgYM;IAOI,2BAAA;IAAA,8BAAA;ExE8/XV;EwErgYM;IAOI,2BAAA;IAAA,8BAAA;ExEkgYV;EwEzgYM;IAOI,wBAAA;ExEqgYV;EwE5gYM;IAOI,+BAAA;ExEwgYV;EwE/gYM;IAOI,8BAAA;ExE2gYV;EwElhYM;IAOI,6BAAA;ExE8gYV;EwErhYM;IAOI,2BAAA;ExEihYV;EwExhYM;IAOI,6BAAA;ExEohYV;EwE3hYM;IAOI,2BAAA;ExEuhYV;EwE9hYM;IAOI,6BAAA;ExE0hYV;EwEjiYM;IAOI,2BAAA;ExE6hYV;EwEpiYM;IAOI,6BAAA;ExEgiYV;EwEviYM;IAOI,2BAAA;ExEmiYV;EwE1iYM;IAOI,2BAAA;ExEsiYV;EwE7iYM;IAOI,2BAAA;ExEyiYV;EwEhjYM;IAOI,6BAAA;ExE4iYV;EwEnjYM;IAOI,2BAAA;ExE+iYV;EwEtjYM;IAOI,2BAAA;ExEkjYV;EwEzjYM;IAOI,0BAAA;ExEqjYV;EwE5jYM;IAOI,iCAAA;ExEwjYV;EwE/jYM;IAOI,gCAAA;ExE2jYV;EwElkYM;IAOI,+BAAA;ExE8jYV;EwErkYM;IAOI,6BAAA;ExEikYV;EwExkYM;IAOI,+BAAA;ExEokYV;EwE3kYM;IAOI,6BAAA;ExEukYV;EwE9kYM;IAOI,+BAAA;ExE0kYV;EwEjlYM;IAOI,6BAAA;ExE6kYV;EwEplYM;IAOI,+BAAA;ExEglYV;EwEvlYM;IAOI,6BAAA;ExEmlYV;EwE1lYM;IAOI,6BAAA;ExEslYV;EwE7lYM;IAOI,6BAAA;ExEylYV;EwEhmYM;IAOI,+BAAA;ExE4lYV;EwEnmYM;IAOI,6BAAA;ExE+lYV;EwEtmYM;IAOI,6BAAA;ExEkmYV;EwEzmYM;IAOI,2BAAA;ExEqmYV;EwE5mYM;IAOI,kCAAA;ExEwmYV;EwE/mYM;IAOI,iCAAA;ExE2mYV;EwElnYM;IAOI,gCAAA;ExE8mYV;EwErnYM;IAOI,8BAAA;ExEinYV;EwExnYM;IAOI,gCAAA;ExEonYV;EwE3nYM;IAOI,8BAAA;ExEunYV;EwE9nYM;IAOI,gCAAA;ExE0nYV;EwEjoYM;IAOI,8BAAA;ExE6nYV;EwEpoYM;IAOI,gCAAA;ExEgoYV;EwEvoYM;IAOI,8BAAA;ExEmoYV;EwE1oYM;IAOI,8BAAA;ExEsoYV;EwE7oYM;IAOI,8BAAA;ExEyoYV;EwEhpYM;IAOI,gCAAA;ExE4oYV;EwEnpYM;IAOI,8BAAA;ExE+oYV;EwEtpYM;IAOI,8BAAA;ExEkpYV;EwEzpYM;IAOI,yBAAA;ExEqpYV;EwE5pYM;IAOI,gCAAA;ExEwpYV;EwE/pYM;IAOI,+BAAA;ExE2pYV;EwElqYM;IAOI,8BAAA;ExE8pYV;EwErqYM;IAOI,4BAAA;ExEiqYV;EwExqYM;IAOI,8BAAA;ExEoqYV;EwE3qYM;IAOI,4BAAA;ExEuqYV;EwE9qYM;IAOI,8BAAA;ExE0qYV;EwEjrYM;IAOI,4BAAA;ExE6qYV;EwEprYM;IAOI,8BAAA;ExEgrYV;EwEvrYM;IAOI,4BAAA;ExEmrYV;EwE1rYM;IAOI,4BAAA;ExEsrYV;EwE7rYM;IAOI,4BAAA;ExEyrYV;EwEhsYM;IAOI,8BAAA;ExE4rYV;EwEnsYM;IAOI,4BAAA;ExE+rYV;EwEtsYM;IAOI,4BAAA;ExEksYV;EwEzsYM;IAOI,4BAAA;ExEqsYV;EwE5sYM;IAOI,2BAAA;ExEwsYV;EwE/sYM;IAOI,0BAAA;ExE2sYV;EwEltYM;IAOI,wBAAA;ExE8sYV;EwErtYM;IAOI,0BAAA;ExEitYV;EwExtYM;IAOI,wBAAA;ExEotYV;EwE3tYM;IAOI,0BAAA;ExEutYV;EwE9tYM;IAOI,wBAAA;ExE0tYV;EwEjuYM;IAOI,0BAAA;ExE6tYV;EwEpuYM;IAOI,wBAAA;ExEguYV;EwEvuYM;IAOI,wBAAA;ExEmuYV;EwE1uYM;IAOI,wBAAA;ExEsuYV;EwE7uYM;IAOI,0BAAA;ExEyuYV;EwEhvYM;IAOI,wBAAA;ExE4uYV;EwEnvYM;IAOI,kCAAA;IAAA,iCAAA;ExEgvYV;EwEvvYM;IAOI,iCAAA;IAAA,gCAAA;ExEovYV;EwE3vYM;IAOI,gCAAA;IAAA,+BAAA;ExEwvYV;EwE/vYM;IAOI,8BAAA;IAAA,6BAAA;ExE4vYV;EwEnwYM;IAOI,gCAAA;IAAA,+BAAA;ExEgwYV;EwEvwYM;IAOI,8BAAA;IAAA,6BAAA;ExEowYV;EwE3wYM;IAOI,gCAAA;IAAA,+BAAA;ExEwwYV;EwE/wYM;IAOI,8BAAA;IAAA,6BAAA;ExE4wYV;EwEnxYM;IAOI,gCAAA;IAAA,+BAAA;ExEgxYV;EwEvxYM;IAOI,8BAAA;IAAA,6BAAA;ExEoxYV;EwE3xYM;IAOI,8BAAA;IAAA,6BAAA;ExEwxYV;EwE/xYM;IAOI,8BAAA;IAAA,6BAAA;ExE4xYV;EwEnyYM;IAOI,gCAAA;IAAA,+BAAA;ExEgyYV;EwEvyYM;IAOI,8BAAA;IAAA,6BAAA;ExEoyYV;EwE3yYM;IAOI,gCAAA;IAAA,mCAAA;ExEwyYV;EwE/yYM;IAOI,+BAAA;IAAA,kCAAA;ExE4yYV;EwEnzYM;IAOI,8BAAA;IAAA,iCAAA;ExEgzYV;EwEvzYM;IAOI,4BAAA;IAAA,+BAAA;ExEozYV;EwE3zYM;IAOI,8BAAA;IAAA,iCAAA;ExEwzYV;EwE/zYM;IAOI,4BAAA;IAAA,+BAAA;ExE4zYV;EwEn0YM;IAOI,8BAAA;IAAA,iCAAA;ExEg0YV;EwEv0YM;IAOI,4BAAA;IAAA,+BAAA;ExEo0YV;EwE30YM;IAOI,8BAAA;IAAA,iCAAA;ExEw0YV;EwE/0YM;IAOI,4BAAA;IAAA,+BAAA;ExE40YV;EwEn1YM;IAOI,4BAAA;IAAA,+BAAA;ExEg1YV;EwEv1YM;IAOI,4BAAA;IAAA,+BAAA;ExEo1YV;EwE31YM;IAOI,8BAAA;IAAA,iCAAA;ExEw1YV;EwE/1YM;IAOI,4BAAA;IAAA,+BAAA;ExE41YV;EwEn2YM;IAOI,gCAAA;ExE+1YV;EwEt2YM;IAOI,+BAAA;ExEk2YV;EwEz2YM;IAOI,8BAAA;ExEq2YV;EwE52YM;IAOI,4BAAA;ExEw2YV;EwE/2YM;IAOI,8BAAA;ExE22YV;EwEl3YM;IAOI,4BAAA;ExE82YV;EwEr3YM;IAOI,8BAAA;ExEi3YV;EwEx3YM;IAOI,4BAAA;ExEo3YV;EwE33YM;IAOI,8BAAA;ExEu3YV;EwE93YM;IAOI,4BAAA;ExE03YV;EwEj4YM;IAOI,4BAAA;ExE63YV;EwEp4YM;IAOI,4BAAA;ExEg4YV;EwEv4YM;IAOI,8BAAA;ExEm4YV;EwE14YM;IAOI,4BAAA;ExEs4YV;EwE74YM;IAOI,kCAAA;ExEy4YV;EwEh5YM;IAOI,iCAAA;ExE44YV;EwEn5YM;IAOI,gCAAA;ExE+4YV;EwEt5YM;IAOI,8BAAA;ExEk5YV;EwEz5YM;IAOI,gCAAA;ExEq5YV;EwE55YM;IAOI,8BAAA;ExEw5YV;EwE/5YM;IAOI,gCAAA;ExE25YV;EwEl6YM;IAOI,8BAAA;ExE85YV;EwEr6YM;IAOI,gCAAA;ExEi6YV;EwEx6YM;IAOI,8BAAA;ExEo6YV;EwE36YM;IAOI,8BAAA;ExEu6YV;EwE96YM;IAOI,8BAAA;ExE06YV;EwEj7YM;IAOI,gCAAA;ExE66YV;EwEp7YM;IAOI,8BAAA;ExEg7YV;EwEv7YM;IAOI,mCAAA;ExEm7YV;EwE17YM;IAOI,kCAAA;ExEs7YV;EwE77YM;IAOI,iCAAA;ExEy7YV;EwEh8YM;IAOI,+BAAA;ExE47YV;EwEn8YM;IAOI,iCAAA;ExE+7YV;EwEt8YM;IAOI,+BAAA;ExEk8YV;EwEz8YM;IAOI,iCAAA;ExEq8YV;EwE58YM;IAOI,+BAAA;ExEw8YV;EwE/8YM;IAOI,iCAAA;ExE28YV;EwEl9YM;IAOI,+BAAA;ExE88YV;EwEr9YM;IAOI,+BAAA;ExEi9YV;EwEx9YM;IAOI,+BAAA;ExEo9YV;EwE39YM;IAOI,iCAAA;ExEu9YV;EwE99YM;IAOI,+BAAA;ExE09YV;EwEj+YM;IAOI,iCAAA;ExE69YV;EwEp+YM;IAOI,gCAAA;ExEg+YV;EwEv+YM;IAOI,+BAAA;ExEm+YV;EwE1+YM;IAOI,6BAAA;ExEs+YV;EwE7+YM;IAOI,+BAAA;ExEy+YV;EwEh/YM;IAOI,6BAAA;ExE4+YV;EwEn/YM;IAOI,+BAAA;ExE++YV;EwEt/YM;IAOI,6BAAA;ExEk/YV;EwEz/YM;IAOI,+BAAA;ExEq/YV;EwE5/YM;IAOI,6BAAA;ExEw/YV;EwE//YM;IAOI,6BAAA;ExE2/YV;EwElgZM;IAOI,6BAAA;ExE8/YV;EwErgZM;IAOI,+BAAA;ExEigZV;EwExgZM;IAOI,6BAAA;ExEogZV;EwE3gZM;IAOI,qBAAA;ExEugZV;EwE9gZM;IAOI,4BAAA;ExE0gZV;EwEjhZM;IAOI,2BAAA;ExE6gZV;EwEphZM;IAOI,0BAAA;ExEghZV;EwEvhZM;IAOI,wBAAA;ExEmhZV;EwE1hZM;IAOI,0BAAA;ExEshZV;EwE7hZM;IAOI,wBAAA;ExEyhZV;EwEhiZM;IAOI,0BAAA;ExE4hZV;EwEniZM;IAOI,wBAAA;ExE+hZV;EwEtiZM;IAOI,0BAAA;ExEkiZV;EwEziZM;IAOI,wBAAA;ExEqiZV;EwE5iZM;IAOI,wBAAA;ExEwiZV;EwE/iZM;IAOI,wBAAA;ExE2iZV;EwEljZM;IAOI,0BAAA;ExE8iZV;EwErjZM;IAOI,wBAAA;ExEijZV;EwExjZM;IAOI,2BAAA;IAAA,0BAAA;ExEqjZV;EwE5jZM;IAOI,kCAAA;IAAA,iCAAA;ExEyjZV;EwEhkZM;IAOI,iCAAA;IAAA,gCAAA;ExE6jZV;EwEpkZM;IAOI,gCAAA;IAAA,+BAAA;ExEikZV;EwExkZM;IAOI,8BAAA;IAAA,6BAAA;ExEqkZV;EwE5kZM;IAOI,gCAAA;IAAA,+BAAA;ExEykZV;EwEhlZM;IAOI,8BAAA;IAAA,6BAAA;ExE6kZV;EwEplZM;IAOI,gCAAA;IAAA,+BAAA;ExEilZV;EwExlZM;IAOI,8BAAA;IAAA,6BAAA;ExEqlZV;EwE5lZM;IAOI,gCAAA;IAAA,+BAAA;ExEylZV;EwEhmZM;IAOI,8BAAA;IAAA,6BAAA;ExE6lZV;EwEpmZM;IAOI,8BAAA;IAAA,6BAAA;ExEimZV;EwExmZM;IAOI,8BAAA;IAAA,6BAAA;ExEqmZV;EwE5mZM;IAOI,gCAAA;IAAA,+BAAA;ExEymZV;EwEhnZM;IAOI,8BAAA;IAAA,6BAAA;ExE6mZV;EwEpnZM;IAOI,yBAAA;IAAA,4BAAA;ExEinZV;EwExnZM;IAOI,gCAAA;IAAA,mCAAA;ExEqnZV;EwE5nZM;IAOI,+BAAA;IAAA,kCAAA;ExEynZV;EwEhoZM;IAOI,8BAAA;IAAA,iCAAA;ExE6nZV;EwEpoZM;IAOI,4BAAA;IAAA,+BAAA;ExEioZV;EwExoZM;IAOI,8BAAA;IAAA,iCAAA;ExEqoZV;EwE5oZM;IAOI,4BAAA;IAAA,+BAAA;ExEyoZV;EwEhpZM;IAOI,8BAAA;IAAA,iCAAA;ExE6oZV;EwEppZM;IAOI,4BAAA;IAAA,+BAAA;ExEipZV;EwExpZM;IAOI,8BAAA;IAAA,iCAAA;ExEqpZV;EwE5pZM;IAOI,4BAAA;IAAA,+BAAA;ExEypZV;EwEhqZM;IAOI,4BAAA;IAAA,+BAAA;ExE6pZV;EwEpqZM;IAOI,4BAAA;IAAA,+BAAA;ExEiqZV;EwExqZM;IAOI,8BAAA;IAAA,iCAAA;ExEqqZV;EwE5qZM;IAOI,4BAAA;IAAA,+BAAA;ExEyqZV;EwEhrZM;IAOI,yBAAA;ExE4qZV;EwEnrZM;IAOI,gCAAA;ExE+qZV;EwEtrZM;IAOI,+BAAA;ExEkrZV;EwEzrZM;IAOI,8BAAA;ExEqrZV;EwE5rZM;IAOI,4BAAA;ExEwrZV;EwE/rZM;IAOI,8BAAA;ExE2rZV;EwElsZM;IAOI,4BAAA;ExE8rZV;EwErsZM;IAOI,8BAAA;ExEisZV;EwExsZM;IAOI,4BAAA;ExEosZV;EwE3sZM;IAOI,8BAAA;ExEusZV;EwE9sZM;IAOI,4BAAA;ExE0sZV;EwEjtZM;IAOI,4BAAA;ExE6sZV;EwEptZM;IAOI,4BAAA;ExEgtZV;EwEvtZM;IAOI,8BAAA;ExEmtZV;EwE1tZM;IAOI,4BAAA;ExEstZV;EwE7tZM;IAOI,2BAAA;ExEytZV;EwEhuZM;IAOI,kCAAA;ExE4tZV;EwEnuZM;IAOI,iCAAA;ExE+tZV;EwEtuZM;IAOI,gCAAA;ExEkuZV;EwEzuZM;IAOI,8BAAA;ExEquZV;EwE5uZM;IAOI,gCAAA;ExEwuZV;EwE/uZM;IAOI,8BAAA;ExE2uZV;EwElvZM;IAOI,gCAAA;ExE8uZV;EwErvZM;IAOI,8BAAA;ExEivZV;EwExvZM;IAOI,gCAAA;ExEovZV;EwE3vZM;IAOI,8BAAA;ExEuvZV;EwE9vZM;IAOI,8BAAA;ExE0vZV;EwEjwZM;IAOI,8BAAA;ExE6vZV;EwEpwZM;IAOI,gCAAA;ExEgwZV;EwEvwZM;IAOI,8BAAA;ExEmwZV;EwE1wZM;IAOI,4BAAA;ExEswZV;EwE7wZM;IAOI,mCAAA;ExEywZV;EwEhxZM;IAOI,kCAAA;ExE4wZV;EwEnxZM;IAOI,iCAAA;ExE+wZV;EwEtxZM;IAOI,+BAAA;ExEkxZV;EwEzxZM;IAOI,iCAAA;ExEqxZV;EwE5xZM;IAOI,+BAAA;ExEwxZV;EwE/xZM;IAOI,iCAAA;ExE2xZV;EwElyZM;IAOI,+BAAA;ExE8xZV;EwEryZM;IAOI,iCAAA;ExEiyZV;EwExyZM;IAOI,+BAAA;ExEoyZV;EwE3yZM;IAOI,+BAAA;ExEuyZV;EwE9yZM;IAOI,+BAAA;ExE0yZV;EwEjzZM;IAOI,iCAAA;ExE6yZV;EwEpzZM;IAOI,+BAAA;ExEgzZV;EwEvzZM;IAOI,0BAAA;ExEmzZV;EwE1zZM;IAOI,iCAAA;ExEszZV;EwE7zZM;IAOI,gCAAA;ExEyzZV;EwEh0ZM;IAOI,+BAAA;ExE4zZV;EwEn0ZM;IAOI,6BAAA;ExE+zZV;EwEt0ZM;IAOI,+BAAA;ExEk0ZV;EwEz0ZM;IAOI,6BAAA;ExEq0ZV;EwE50ZM;IAOI,+BAAA;ExEw0ZV;EwE/0ZM;IAOI,6BAAA;ExE20ZV;EwEl1ZM;IAOI,+BAAA;ExE80ZV;EwEr1ZM;IAOI,6BAAA;ExEi1ZV;EwEx1ZM;IAOI,6BAAA;ExEo1ZV;EwE31ZM;IAOI,6BAAA;ExEu1ZV;EwE91ZM;IAOI,+BAAA;ExE01ZV;EwEj2ZM;IAOI,6BAAA;ExE61ZV;EwEp2ZM;IAOI,iBAAA;ExEg2ZV;EwEv2ZM;IAOI,wBAAA;ExEm2ZV;EwE12ZM;IAOI,uBAAA;ExEs2ZV;EwE72ZM;IAOI,sBAAA;ExEy2ZV;EwEh3ZM;IAOI,oBAAA;ExE42ZV;EwEn3ZM;IAOI,sBAAA;ExE+2ZV;EwEt3ZM;IAOI,oBAAA;ExEk3ZV;EwEz3ZM;IAOI,sBAAA;ExEq3ZV;EwE53ZM;IAOI,oBAAA;ExEw3ZV;EwE/3ZM;IAOI,sBAAA;ExE23ZV;EwEl4ZM;IAOI,oBAAA;ExE83ZV;EwEr4ZM;IAOI,oBAAA;ExEi4ZV;EwEx4ZM;IAOI,oBAAA;ExEo4ZV;EwE34ZM;IAOI,sBAAA;ExEu4ZV;EwE94ZM;IAOI,oBAAA;ExE04ZV;EwEj5ZM;IAOI,qBAAA;ExE64ZV;EwEp5ZM;IAOI,4BAAA;ExEg5ZV;EwEv5ZM;IAOI,2BAAA;ExEm5ZV;EwE15ZM;IAOI,0BAAA;ExEs5ZV;EwE75ZM;IAOI,wBAAA;ExEy5ZV;EwEh6ZM;IAOI,0BAAA;ExE45ZV;EwEn6ZM;IAOI,wBAAA;ExE+5ZV;EwEt6ZM;IAOI,0BAAA;ExEk6ZV;EwEz6ZM;IAOI,wBAAA;ExEq6ZV;EwE56ZM;IAOI,0BAAA;ExEw6ZV;EwE/6ZM;IAOI,wBAAA;ExE26ZV;EwEl7ZM;IAOI,wBAAA;ExE86ZV;EwEr7ZM;IAOI,wBAAA;ExEi7ZV;EwEx7ZM;IAOI,0BAAA;ExEo7ZV;EwE37ZM;IAOI,wBAAA;ExEu7ZV;EwE97ZM;IAOI,wBAAA;ExE07ZV;EwEj8ZM;IAOI,+BAAA;ExE67ZV;EwEp8ZM;IAOI,8BAAA;ExEg8ZV;EwEv8ZM;IAOI,6BAAA;ExEm8ZV;EwE18ZM;IAOI,2BAAA;ExEs8ZV;EwE78ZM;IAOI,6BAAA;ExEy8ZV;EwEh9ZM;IAOI,2BAAA;ExE48ZV;EwEn9ZM;IAOI,6BAAA;ExE+8ZV;EwEt9ZM;IAOI,2BAAA;ExEk9ZV;EwEz9ZM;IAOI,6BAAA;ExEq9ZV;EwE59ZM;IAOI,2BAAA;ExEw9ZV;EwE/9ZM;IAOI,2BAAA;ExE29ZV;EwEl+ZM;IAOI,2BAAA;ExE89ZV;EwEr+ZM;IAOI,6BAAA;ExEi+ZV;EwEx+ZM;IAOI,2BAAA;ExEo+ZV;EwE3+ZM;IAOI,2BAAA;ExEu+ZV;EwE9+ZM;IAOI,4BAAA;ExE0+ZV;EwEj/ZM;IAOI,6BAAA;ExE6+ZV;AACF;AGx/ZI;EqEGI;IAOI,sBAAA;ExEk/ZV;EwEz/ZM;IAOI,uBAAA;ExEq/ZV;EwE5/ZM;IAOI,sBAAA;ExEw/ZV;EwE//ZM;IAOI,8BAAA;ExE2/ZV;EwElgaM;IAOI,4BAAA;ExE8/ZV;EwErgaM;IAOI,2BAAA;ExEigaV;EwExgaM;IAOI,iCAAA;ExEogaV;EwE3gaM;IAOI,2BAAA;ExEugaV;EwE9gaM;IAOI,0BAAA;ExE0gaV;EwEjhaM;IAOI,gCAAA;ExE6gaV;EwEphaM;IAOI,yBAAA;ExEghaV;EwEvhaM;IAOI,wBAAA;ExEmhaV;EwE1haM;IAOI,+BAAA;ExEshaV;EwE7haM;IAOI,yBAAA;ExEyhaV;EwEhiaM;IAOI,6BAAA;ExE4haV;EwEniaM;IAOI,8BAAA;ExE+haV;EwEtiaM;IAOI,wBAAA;ExEkiaV;EwEziaM;IAOI,+BAAA;ExEqiaV;EwE5iaM;IAOI,wBAAA;ExEwiaV;EwE/iaM;IAOI,yBAAA;ExE2iaV;EwEljaM;IAOI,8BAAA;ExE8iaV;EwErjaM;IAOI,iCAAA;ExEijaV;EwExjaM;IAOI,sCAAA;ExEojaV;EwE3jaM;IAOI,yCAAA;ExEujaV;EwE9jaM;IAOI,uBAAA;ExE0jaV;EwEjkaM;IAOI,uBAAA;ExE6jaV;EwEpkaM;IAOI,yBAAA;ExEgkaV;EwEvkaM;IAOI,yBAAA;ExEmkaV;EwE1kaM;IAOI,0BAAA;ExEskaV;EwE7kaM;IAOI,4BAAA;ExEykaV;EwEhlaM;IAOI,kCAAA;ExE4kaV;EwEnlaM;IAOI,sCAAA;ExE+kaV;EwEtlaM;IAOI,oCAAA;ExEklaV;EwEzlaM;IAOI,kCAAA;ExEqlaV;EwE5laM;IAOI,yCAAA;ExEwlaV;EwE/laM;IAOI,wCAAA;ExE2laV;EwElmaM;IAOI,wCAAA;ExE8laV;EwErmaM;IAOI,kCAAA;ExEimaV;EwExmaM;IAOI,gCAAA;ExEomaV;EwE3maM;IAOI,8BAAA;ExEumaV;EwE9maM;IAOI,gCAAA;ExE0maV;EwEjnaM;IAOI,+BAAA;ExE6maV;EwEpnaM;IAOI,oCAAA;ExEgnaV;EwEvnaM;IAOI,kCAAA;ExEmnaV;EwE1naM;IAOI,gCAAA;ExEsnaV;EwE7naM;IAOI,uCAAA;ExEynaV;EwEhoaM;IAOI,sCAAA;ExE4naV;EwEnoaM;IAOI,iCAAA;ExE+naV;EwEtoaM;IAOI,2BAAA;ExEkoaV;EwEzoaM;IAOI,iCAAA;ExEqoaV;EwE5oaM;IAOI,+BAAA;ExEwoaV;EwE/oaM;IAOI,6BAAA;ExE2oaV;EwElpaM;IAOI,+BAAA;ExE8oaV;EwErpaM;IAOI,8BAAA;ExEipaV;EwExpaM;IAOI,oBAAA;ExEopaV;EwE3paM;IAOI,mBAAA;ExEupaV;EwE9paM;IAOI,mBAAA;ExE0paV;EwEjqaM;IAOI,mBAAA;ExE6paV;EwEpqaM;IAOI,mBAAA;ExEgqaV;EwEvqaM;IAOI,mBAAA;ExEmqaV;EwE1qaM;IAOI,mBAAA;ExEsqaV;EwE7qaM;IAOI,mBAAA;ExEyqaV;EwEhraM;IAOI,oBAAA;ExE4qaV;EwEnraM;IAOI,2BAAA;ExE+qaV;EwEtraM;IAOI,0BAAA;ExEkraV;EwEzraM;IAOI,yBAAA;ExEqraV;EwE5raM;IAOI,uBAAA;ExEwraV;EwE/raM;IAOI,yBAAA;ExE2raV;EwElsaM;IAOI,uBAAA;ExE8raV;EwErsaM;IAOI,yBAAA;ExEisaV;EwExsaM;IAOI,uBAAA;ExEosaV;EwE3saM;IAOI,yBAAA;ExEusaV;EwE9saM;IAOI,uBAAA;ExE0saV;EwEjtaM;IAOI,uBAAA;ExE6saV;EwEptaM;IAOI,uBAAA;ExEgtaV;EwEvtaM;IAOI,yBAAA;ExEmtaV;EwE1taM;IAOI,uBAAA;ExEstaV;EwE7taM;IAOI,uBAAA;ExEytaV;EwEhuaM;IAOI,0BAAA;IAAA,yBAAA;ExE6taV;EwEpuaM;IAOI,iCAAA;IAAA,gCAAA;ExEiuaV;EwExuaM;IAOI,gCAAA;IAAA,+BAAA;ExEquaV;EwE5uaM;IAOI,+BAAA;IAAA,8BAAA;ExEyuaV;EwEhvaM;IAOI,6BAAA;IAAA,4BAAA;ExE6uaV;EwEpvaM;IAOI,+BAAA;IAAA,8BAAA;ExEivaV;EwExvaM;IAOI,6BAAA;IAAA,4BAAA;ExEqvaV;EwE5vaM;IAOI,+BAAA;IAAA,8BAAA;ExEyvaV;EwEhwaM;IAOI,6BAAA;IAAA,4BAAA;ExE6vaV;EwEpwaM;IAOI,+BAAA;IAAA,8BAAA;ExEiwaV;EwExwaM;IAOI,6BAAA;IAAA,4BAAA;ExEqwaV;EwE5waM;IAOI,6BAAA;IAAA,4BAAA;ExEywaV;EwEhxaM;IAOI,6BAAA;IAAA,4BAAA;ExE6waV;EwEpxaM;IAOI,+BAAA;IAAA,8BAAA;ExEixaV;EwExxaM;IAOI,6BAAA;IAAA,4BAAA;ExEqxaV;EwE5xaM;IAOI,6BAAA;IAAA,4BAAA;ExEyxaV;EwEhyaM;IAOI,wBAAA;IAAA,2BAAA;ExE6xaV;EwEpyaM;IAOI,+BAAA;IAAA,kCAAA;ExEiyaV;EwExyaM;IAOI,8BAAA;IAAA,iCAAA;ExEqyaV;EwE5yaM;IAOI,6BAAA;IAAA,gCAAA;ExEyyaV;EwEhzaM;IAOI,2BAAA;IAAA,8BAAA;ExE6yaV;EwEpzaM;IAOI,6BAAA;IAAA,gCAAA;ExEizaV;EwExzaM;IAOI,2BAAA;IAAA,8BAAA;ExEqzaV;EwE5zaM;IAOI,6BAAA;IAAA,gCAAA;ExEyzaV;EwEh0aM;IAOI,2BAAA;IAAA,8BAAA;ExE6zaV;EwEp0aM;IAOI,6BAAA;IAAA,gCAAA;ExEi0aV;EwEx0aM;IAOI,2BAAA;IAAA,8BAAA;ExEq0aV;EwE50aM;IAOI,2BAAA;IAAA,8BAAA;ExEy0aV;EwEh1aM;IAOI,2BAAA;IAAA,8BAAA;ExE60aV;EwEp1aM;IAOI,6BAAA;IAAA,gCAAA;ExEi1aV;EwEx1aM;IAOI,2BAAA;IAAA,8BAAA;ExEq1aV;EwE51aM;IAOI,2BAAA;IAAA,8BAAA;ExEy1aV;EwEh2aM;IAOI,wBAAA;ExE41aV;EwEn2aM;IAOI,+BAAA;ExE+1aV;EwEt2aM;IAOI,8BAAA;ExEk2aV;EwEz2aM;IAOI,6BAAA;ExEq2aV;EwE52aM;IAOI,2BAAA;ExEw2aV;EwE/2aM;IAOI,6BAAA;ExE22aV;EwEl3aM;IAOI,2BAAA;ExE82aV;EwEr3aM;IAOI,6BAAA;ExEi3aV;EwEx3aM;IAOI,2BAAA;ExEo3aV;EwE33aM;IAOI,6BAAA;ExEu3aV;EwE93aM;IAOI,2BAAA;ExE03aV;EwEj4aM;IAOI,2BAAA;ExE63aV;EwEp4aM;IAOI,2BAAA;ExEg4aV;EwEv4aM;IAOI,6BAAA;ExEm4aV;EwE14aM;IAOI,2BAAA;ExEs4aV;EwE74aM;IAOI,2BAAA;ExEy4aV;EwEh5aM;IAOI,0BAAA;ExE44aV;EwEn5aM;IAOI,iCAAA;ExE+4aV;EwEt5aM;IAOI,gCAAA;ExEk5aV;EwEz5aM;IAOI,+BAAA;ExEq5aV;EwE55aM;IAOI,6BAAA;ExEw5aV;EwE/5aM;IAOI,+BAAA;ExE25aV;EwEl6aM;IAOI,6BAAA;ExE85aV;EwEr6aM;IAOI,+BAAA;ExEi6aV;EwEx6aM;IAOI,6BAAA;ExEo6aV;EwE36aM;IAOI,+BAAA;ExEu6aV;EwE96aM;IAOI,6BAAA;ExE06aV;EwEj7aM;IAOI,6BAAA;ExE66aV;EwEp7aM;IAOI,6BAAA;ExEg7aV;EwEv7aM;IAOI,+BAAA;ExEm7aV;EwE17aM;IAOI,6BAAA;ExEs7aV;EwE77aM;IAOI,6BAAA;ExEy7aV;EwEh8aM;IAOI,2BAAA;ExE47aV;EwEn8aM;IAOI,kCAAA;ExE+7aV;EwEt8aM;IAOI,iCAAA;ExEk8aV;EwEz8aM;IAOI,gCAAA;ExEq8aV;EwE58aM;IAOI,8BAAA;ExEw8aV;EwE/8aM;IAOI,gCAAA;ExE28aV;EwEl9aM;IAOI,8BAAA;ExE88aV;EwEr9aM;IAOI,gCAAA;ExEi9aV;EwEx9aM;IAOI,8BAAA;ExEo9aV;EwE39aM;IAOI,gCAAA;ExEu9aV;EwE99aM;IAOI,8BAAA;ExE09aV;EwEj+aM;IAOI,8BAAA;ExE69aV;EwEp+aM;IAOI,8BAAA;ExEg+aV;EwEv+aM;IAOI,gCAAA;ExEm+aV;EwE1+aM;IAOI,8BAAA;ExEs+aV;EwE7+aM;IAOI,8BAAA;ExEy+aV;EwEh/aM;IAOI,yBAAA;ExE4+aV;EwEn/aM;IAOI,gCAAA;ExE++aV;EwEt/aM;IAOI,+BAAA;ExEk/aV;EwEz/aM;IAOI,8BAAA;ExEq/aV;EwE5/aM;IAOI,4BAAA;ExEw/aV;EwE//aM;IAOI,8BAAA;ExE2/aV;EwElgbM;IAOI,4BAAA;ExE8/aV;EwErgbM;IAOI,8BAAA;ExEigbV;EwExgbM;IAOI,4BAAA;ExEogbV;EwE3gbM;IAOI,8BAAA;ExEugbV;EwE9gbM;IAOI,4BAAA;ExE0gbV;EwEjhbM;IAOI,4BAAA;ExE6gbV;EwEphbM;IAOI,4BAAA;ExEghbV;EwEvhbM;IAOI,8BAAA;ExEmhbV;EwE1hbM;IAOI,4BAAA;ExEshbV;EwE7hbM;IAOI,4BAAA;ExEyhbV;EwEhibM;IAOI,4BAAA;ExE4hbV;EwEnibM;IAOI,2BAAA;ExE+hbV;EwEtibM;IAOI,0BAAA;ExEkibV;EwEzibM;IAOI,wBAAA;ExEqibV;EwE5ibM;IAOI,0BAAA;ExEwibV;EwE/ibM;IAOI,wBAAA;ExE2ibV;EwEljbM;IAOI,0BAAA;ExE8ibV;EwErjbM;IAOI,wBAAA;ExEijbV;EwExjbM;IAOI,0BAAA;ExEojbV;EwE3jbM;IAOI,wBAAA;ExEujbV;EwE9jbM;IAOI,wBAAA;ExE0jbV;EwEjkbM;IAOI,wBAAA;ExE6jbV;EwEpkbM;IAOI,0BAAA;ExEgkbV;EwEvkbM;IAOI,wBAAA;ExEmkbV;EwE1kbM;IAOI,kCAAA;IAAA,iCAAA;ExEukbV;EwE9kbM;IAOI,iCAAA;IAAA,gCAAA;ExE2kbV;EwEllbM;IAOI,gCAAA;IAAA,+BAAA;ExE+kbV;EwEtlbM;IAOI,8BAAA;IAAA,6BAAA;ExEmlbV;EwE1lbM;IAOI,gCAAA;IAAA,+BAAA;ExEulbV;EwE9lbM;IAOI,8BAAA;IAAA,6BAAA;ExE2lbV;EwElmbM;IAOI,gCAAA;IAAA,+BAAA;ExE+lbV;EwEtmbM;IAOI,8BAAA;IAAA,6BAAA;ExEmmbV;EwE1mbM;IAOI,gCAAA;IAAA,+BAAA;ExEumbV;EwE9mbM;IAOI,8BAAA;IAAA,6BAAA;ExE2mbV;EwElnbM;IAOI,8BAAA;IAAA,6BAAA;ExE+mbV;EwEtnbM;IAOI,8BAAA;IAAA,6BAAA;ExEmnbV;EwE1nbM;IAOI,gCAAA;IAAA,+BAAA;ExEunbV;EwE9nbM;IAOI,8BAAA;IAAA,6BAAA;ExE2nbV;EwElobM;IAOI,gCAAA;IAAA,mCAAA;ExE+nbV;EwEtobM;IAOI,+BAAA;IAAA,kCAAA;ExEmobV;EwE1obM;IAOI,8BAAA;IAAA,iCAAA;ExEuobV;EwE9obM;IAOI,4BAAA;IAAA,+BAAA;ExE2obV;EwElpbM;IAOI,8BAAA;IAAA,iCAAA;ExE+obV;EwEtpbM;IAOI,4BAAA;IAAA,+BAAA;ExEmpbV;EwE1pbM;IAOI,8BAAA;IAAA,iCAAA;ExEupbV;EwE9pbM;IAOI,4BAAA;IAAA,+BAAA;ExE2pbV;EwElqbM;IAOI,8BAAA;IAAA,iCAAA;ExE+pbV;EwEtqbM;IAOI,4BAAA;IAAA,+BAAA;ExEmqbV;EwE1qbM;IAOI,4BAAA;IAAA,+BAAA;ExEuqbV;EwE9qbM;IAOI,4BAAA;IAAA,+BAAA;ExE2qbV;EwElrbM;IAOI,8BAAA;IAAA,iCAAA;ExE+qbV;EwEtrbM;IAOI,4BAAA;IAAA,+BAAA;ExEmrbV;EwE1rbM;IAOI,gCAAA;ExEsrbV;EwE7rbM;IAOI,+BAAA;ExEyrbV;EwEhsbM;IAOI,8BAAA;ExE4rbV;EwEnsbM;IAOI,4BAAA;ExE+rbV;EwEtsbM;IAOI,8BAAA;ExEksbV;EwEzsbM;IAOI,4BAAA;ExEqsbV;EwE5sbM;IAOI,8BAAA;ExEwsbV;EwE/sbM;IAOI,4BAAA;ExE2sbV;EwEltbM;IAOI,8BAAA;ExE8sbV;EwErtbM;IAOI,4BAAA;ExEitbV;EwExtbM;IAOI,4BAAA;ExEotbV;EwE3tbM;IAOI,4BAAA;ExEutbV;EwE9tbM;IAOI,8BAAA;ExE0tbV;EwEjubM;IAOI,4BAAA;ExE6tbV;EwEpubM;IAOI,kCAAA;ExEgubV;EwEvubM;IAOI,iCAAA;ExEmubV;EwE1ubM;IAOI,gCAAA;ExEsubV;EwE7ubM;IAOI,8BAAA;ExEyubV;EwEhvbM;IAOI,gCAAA;ExE4ubV;EwEnvbM;IAOI,8BAAA;ExE+ubV;EwEtvbM;IAOI,gCAAA;ExEkvbV;EwEzvbM;IAOI,8BAAA;ExEqvbV;EwE5vbM;IAOI,gCAAA;ExEwvbV;EwE/vbM;IAOI,8BAAA;ExE2vbV;EwElwbM;IAOI,8BAAA;ExE8vbV;EwErwbM;IAOI,8BAAA;ExEiwbV;EwExwbM;IAOI,gCAAA;ExEowbV;EwE3wbM;IAOI,8BAAA;ExEuwbV;EwE9wbM;IAOI,mCAAA;ExE0wbV;EwEjxbM;IAOI,kCAAA;ExE6wbV;EwEpxbM;IAOI,iCAAA;ExEgxbV;EwEvxbM;IAOI,+BAAA;ExEmxbV;EwE1xbM;IAOI,iCAAA;ExEsxbV;EwE7xbM;IAOI,+BAAA;ExEyxbV;EwEhybM;IAOI,iCAAA;ExE4xbV;EwEnybM;IAOI,+BAAA;ExE+xbV;EwEtybM;IAOI,iCAAA;ExEkybV;EwEzybM;IAOI,+BAAA;ExEqybV;EwE5ybM;IAOI,+BAAA;ExEwybV;EwE/ybM;IAOI,+BAAA;ExE2ybV;EwElzbM;IAOI,iCAAA;ExE8ybV;EwErzbM;IAOI,+BAAA;ExEizbV;EwExzbM;IAOI,iCAAA;ExEozbV;EwE3zbM;IAOI,gCAAA;ExEuzbV;EwE9zbM;IAOI,+BAAA;ExE0zbV;EwEj0bM;IAOI,6BAAA;ExE6zbV;EwEp0bM;IAOI,+BAAA;ExEg0bV;EwEv0bM;IAOI,6BAAA;ExEm0bV;EwE10bM;IAOI,+BAAA;ExEs0bV;EwE70bM;IAOI,6BAAA;ExEy0bV;EwEh1bM;IAOI,+BAAA;ExE40bV;EwEn1bM;IAOI,6BAAA;ExE+0bV;EwEt1bM;IAOI,6BAAA;ExEk1bV;EwEz1bM;IAOI,6BAAA;ExEq1bV;EwE51bM;IAOI,+BAAA;ExEw1bV;EwE/1bM;IAOI,6BAAA;ExE21bV;EwEl2bM;IAOI,qBAAA;ExE81bV;EwEr2bM;IAOI,4BAAA;ExEi2bV;EwEx2bM;IAOI,2BAAA;ExEo2bV;EwE32bM;IAOI,0BAAA;ExEu2bV;EwE92bM;IAOI,wBAAA;ExE02bV;EwEj3bM;IAOI,0BAAA;ExE62bV;EwEp3bM;IAOI,wBAAA;ExEg3bV;EwEv3bM;IAOI,0BAAA;ExEm3bV;EwE13bM;IAOI,wBAAA;ExEs3bV;EwE73bM;IAOI,0BAAA;ExEy3bV;EwEh4bM;IAOI,wBAAA;ExE43bV;EwEn4bM;IAOI,wBAAA;ExE+3bV;EwEt4bM;IAOI,wBAAA;ExEk4bV;EwEz4bM;IAOI,0BAAA;ExEq4bV;EwE54bM;IAOI,wBAAA;ExEw4bV;EwE/4bM;IAOI,2BAAA;IAAA,0BAAA;ExE44bV;EwEn5bM;IAOI,kCAAA;IAAA,iCAAA;ExEg5bV;EwEv5bM;IAOI,iCAAA;IAAA,gCAAA;ExEo5bV;EwE35bM;IAOI,gCAAA;IAAA,+BAAA;ExEw5bV;EwE/5bM;IAOI,8BAAA;IAAA,6BAAA;ExE45bV;EwEn6bM;IAOI,gCAAA;IAAA,+BAAA;ExEg6bV;EwEv6bM;IAOI,8BAAA;IAAA,6BAAA;ExEo6bV;EwE36bM;IAOI,gCAAA;IAAA,+BAAA;ExEw6bV;EwE/6bM;IAOI,8BAAA;IAAA,6BAAA;ExE46bV;EwEn7bM;IAOI,gCAAA;IAAA,+BAAA;ExEg7bV;EwEv7bM;IAOI,8BAAA;IAAA,6BAAA;ExEo7bV;EwE37bM;IAOI,8BAAA;IAAA,6BAAA;ExEw7bV;EwE/7bM;IAOI,8BAAA;IAAA,6BAAA;ExE47bV;EwEn8bM;IAOI,gCAAA;IAAA,+BAAA;ExEg8bV;EwEv8bM;IAOI,8BAAA;IAAA,6BAAA;ExEo8bV;EwE38bM;IAOI,yBAAA;IAAA,4BAAA;ExEw8bV;EwE/8bM;IAOI,gCAAA;IAAA,mCAAA;ExE48bV;EwEn9bM;IAOI,+BAAA;IAAA,kCAAA;ExEg9bV;EwEv9bM;IAOI,8BAAA;IAAA,iCAAA;ExEo9bV;EwE39bM;IAOI,4BAAA;IAAA,+BAAA;ExEw9bV;EwE/9bM;IAOI,8BAAA;IAAA,iCAAA;ExE49bV;EwEn+bM;IAOI,4BAAA;IAAA,+BAAA;ExEg+bV;EwEv+bM;IAOI,8BAAA;IAAA,iCAAA;ExEo+bV;EwE3+bM;IAOI,4BAAA;IAAA,+BAAA;ExEw+bV;EwE/+bM;IAOI,8BAAA;IAAA,iCAAA;ExE4+bV;EwEn/bM;IAOI,4BAAA;IAAA,+BAAA;ExEg/bV;EwEv/bM;IAOI,4BAAA;IAAA,+BAAA;ExEo/bV;EwE3/bM;IAOI,4BAAA;IAAA,+BAAA;ExEw/bV;EwE//bM;IAOI,8BAAA;IAAA,iCAAA;ExE4/bV;EwEngcM;IAOI,4BAAA;IAAA,+BAAA;ExEggcV;EwEvgcM;IAOI,yBAAA;ExEmgcV;EwE1gcM;IAOI,gCAAA;ExEsgcV;EwE7gcM;IAOI,+BAAA;ExEygcV;EwEhhcM;IAOI,8BAAA;ExE4gcV;EwEnhcM;IAOI,4BAAA;ExE+gcV;EwEthcM;IAOI,8BAAA;ExEkhcV;EwEzhcM;IAOI,4BAAA;ExEqhcV;EwE5hcM;IAOI,8BAAA;ExEwhcV;EwE/hcM;IAOI,4BAAA;ExE2hcV;EwElicM;IAOI,8BAAA;ExE8hcV;EwEricM;IAOI,4BAAA;ExEiicV;EwExicM;IAOI,4BAAA;ExEoicV;EwE3icM;IAOI,4BAAA;ExEuicV;EwE9icM;IAOI,8BAAA;ExE0icV;EwEjjcM;IAOI,4BAAA;ExE6icV;EwEpjcM;IAOI,2BAAA;ExEgjcV;EwEvjcM;IAOI,kCAAA;ExEmjcV;EwE1jcM;IAOI,iCAAA;ExEsjcV;EwE7jcM;IAOI,gCAAA;ExEyjcV;EwEhkcM;IAOI,8BAAA;ExE4jcV;EwEnkcM;IAOI,gCAAA;ExE+jcV;EwEtkcM;IAOI,8BAAA;ExEkkcV;EwEzkcM;IAOI,gCAAA;ExEqkcV;EwE5kcM;IAOI,8BAAA;ExEwkcV;EwE/kcM;IAOI,gCAAA;ExE2kcV;EwEllcM;IAOI,8BAAA;ExE8kcV;EwErlcM;IAOI,8BAAA;ExEilcV;EwExlcM;IAOI,8BAAA;ExEolcV;EwE3lcM;IAOI,gCAAA;ExEulcV;EwE9lcM;IAOI,8BAAA;ExE0lcV;EwEjmcM;IAOI,4BAAA;ExE6lcV;EwEpmcM;IAOI,mCAAA;ExEgmcV;EwEvmcM;IAOI,kCAAA;ExEmmcV;EwE1mcM;IAOI,iCAAA;ExEsmcV;EwE7mcM;IAOI,+BAAA;ExEymcV;EwEhncM;IAOI,iCAAA;ExE4mcV;EwEnncM;IAOI,+BAAA;ExE+mcV;EwEtncM;IAOI,iCAAA;ExEkncV;EwEzncM;IAOI,+BAAA;ExEqncV;EwE5ncM;IAOI,iCAAA;ExEwncV;EwE/ncM;IAOI,+BAAA;ExE2ncV;EwElocM;IAOI,+BAAA;ExE8ncV;EwErocM;IAOI,+BAAA;ExEiocV;EwExocM;IAOI,iCAAA;ExEoocV;EwE3ocM;IAOI,+BAAA;ExEuocV;EwE9ocM;IAOI,0BAAA;ExE0ocV;EwEjpcM;IAOI,iCAAA;ExE6ocV;EwEppcM;IAOI,gCAAA;ExEgpcV;EwEvpcM;IAOI,+BAAA;ExEmpcV;EwE1pcM;IAOI,6BAAA;ExEspcV;EwE7pcM;IAOI,+BAAA;ExEypcV;EwEhqcM;IAOI,6BAAA;ExE4pcV;EwEnqcM;IAOI,+BAAA;ExE+pcV;EwEtqcM;IAOI,6BAAA;ExEkqcV;EwEzqcM;IAOI,+BAAA;ExEqqcV;EwE5qcM;IAOI,6BAAA;ExEwqcV;EwE/qcM;IAOI,6BAAA;ExE2qcV;EwElrcM;IAOI,6BAAA;ExE8qcV;EwErrcM;IAOI,+BAAA;ExEircV;EwExrcM;IAOI,6BAAA;ExEorcV;EwE3rcM;IAOI,iBAAA;ExEurcV;EwE9rcM;IAOI,wBAAA;ExE0rcV;EwEjscM;IAOI,uBAAA;ExE6rcV;EwEpscM;IAOI,sBAAA;ExEgscV;EwEvscM;IAOI,oBAAA;ExEmscV;EwE1scM;IAOI,sBAAA;ExEsscV;EwE7scM;IAOI,oBAAA;ExEyscV;EwEhtcM;IAOI,sBAAA;ExE4scV;EwEntcM;IAOI,oBAAA;ExE+scV;EwEttcM;IAOI,sBAAA;ExEktcV;EwEztcM;IAOI,oBAAA;ExEqtcV;EwE5tcM;IAOI,oBAAA;ExEwtcV;EwE/tcM;IAOI,oBAAA;ExE2tcV;EwElucM;IAOI,sBAAA;ExE8tcV;EwErucM;IAOI,oBAAA;ExEiucV;EwExucM;IAOI,qBAAA;ExEoucV;EwE3ucM;IAOI,4BAAA;ExEuucV;EwE9ucM;IAOI,2BAAA;ExE0ucV;EwEjvcM;IAOI,0BAAA;ExE6ucV;EwEpvcM;IAOI,wBAAA;ExEgvcV;EwEvvcM;IAOI,0BAAA;ExEmvcV;EwE1vcM;IAOI,wBAAA;ExEsvcV;EwE7vcM;IAOI,0BAAA;ExEyvcV;EwEhwcM;IAOI,wBAAA;ExE4vcV;EwEnwcM;IAOI,0BAAA;ExE+vcV;EwEtwcM;IAOI,wBAAA;ExEkwcV;EwEzwcM;IAOI,wBAAA;ExEqwcV;EwE5wcM;IAOI,wBAAA;ExEwwcV;EwE/wcM;IAOI,0BAAA;ExE2wcV;EwElxcM;IAOI,wBAAA;ExE8wcV;EwErxcM;IAOI,wBAAA;ExEixcV;EwExxcM;IAOI,+BAAA;ExEoxcV;EwE3xcM;IAOI,8BAAA;ExEuxcV;EwE9xcM;IAOI,6BAAA;ExE0xcV;EwEjycM;IAOI,2BAAA;ExE6xcV;EwEpycM;IAOI,6BAAA;ExEgycV;EwEvycM;IAOI,2BAAA;ExEmycV;EwE1ycM;IAOI,6BAAA;ExEsycV;EwE7ycM;IAOI,2BAAA;ExEyycV;EwEhzcM;IAOI,6BAAA;ExE4ycV;EwEnzcM;IAOI,2BAAA;ExE+ycV;EwEtzcM;IAOI,2BAAA;ExEkzcV;EwEzzcM;IAOI,2BAAA;ExEqzcV;EwE5zcM;IAOI,6BAAA;ExEwzcV;EwE/zcM;IAOI,2BAAA;ExE2zcV;EwEl0cM;IAOI,2BAAA;ExE8zcV;EwEr0cM;IAOI,4BAAA;ExEi0cV;EwEx0cM;IAOI,6BAAA;ExEo0cV;AACF;AG/0cI;EqEGI;IAOI,sBAAA;ExEy0cV;EwEh1cM;IAOI,uBAAA;ExE40cV;EwEn1cM;IAOI,sBAAA;ExE+0cV;EwEt1cM;IAOI,8BAAA;ExEk1cV;EwEz1cM;IAOI,4BAAA;ExEq1cV;EwE51cM;IAOI,2BAAA;ExEw1cV;EwE/1cM;IAOI,iCAAA;ExE21cV;EwEl2cM;IAOI,2BAAA;ExE81cV;EwEr2cM;IAOI,0BAAA;ExEi2cV;EwEx2cM;IAOI,gCAAA;ExEo2cV;EwE32cM;IAOI,yBAAA;ExEu2cV;EwE92cM;IAOI,wBAAA;ExE02cV;EwEj3cM;IAOI,+BAAA;ExE62cV;EwEp3cM;IAOI,yBAAA;ExEg3cV;EwEv3cM;IAOI,6BAAA;ExEm3cV;EwE13cM;IAOI,8BAAA;ExEs3cV;EwE73cM;IAOI,wBAAA;ExEy3cV;EwEh4cM;IAOI,+BAAA;ExE43cV;EwEn4cM;IAOI,wBAAA;ExE+3cV;EwEt4cM;IAOI,yBAAA;ExEk4cV;EwEz4cM;IAOI,8BAAA;ExEq4cV;EwE54cM;IAOI,iCAAA;ExEw4cV;EwE/4cM;IAOI,sCAAA;ExE24cV;EwEl5cM;IAOI,yCAAA;ExE84cV;EwEr5cM;IAOI,uBAAA;ExEi5cV;EwEx5cM;IAOI,uBAAA;ExEo5cV;EwE35cM;IAOI,yBAAA;ExEu5cV;EwE95cM;IAOI,yBAAA;ExE05cV;EwEj6cM;IAOI,0BAAA;ExE65cV;EwEp6cM;IAOI,4BAAA;ExEg6cV;EwEv6cM;IAOI,kCAAA;ExEm6cV;EwE16cM;IAOI,sCAAA;ExEs6cV;EwE76cM;IAOI,oCAAA;ExEy6cV;EwEh7cM;IAOI,kCAAA;ExE46cV;EwEn7cM;IAOI,yCAAA;ExE+6cV;EwEt7cM;IAOI,wCAAA;ExEk7cV;EwEz7cM;IAOI,wCAAA;ExEq7cV;EwE57cM;IAOI,kCAAA;ExEw7cV;EwE/7cM;IAOI,gCAAA;ExE27cV;EwEl8cM;IAOI,8BAAA;ExE87cV;EwEr8cM;IAOI,gCAAA;ExEi8cV;EwEx8cM;IAOI,+BAAA;ExEo8cV;EwE38cM;IAOI,oCAAA;ExEu8cV;EwE98cM;IAOI,kCAAA;ExE08cV;EwEj9cM;IAOI,gCAAA;ExE68cV;EwEp9cM;IAOI,uCAAA;ExEg9cV;EwEv9cM;IAOI,sCAAA;ExEm9cV;EwE19cM;IAOI,iCAAA;ExEs9cV;EwE79cM;IAOI,2BAAA;ExEy9cV;EwEh+cM;IAOI,iCAAA;ExE49cV;EwEn+cM;IAOI,+BAAA;ExE+9cV;EwEt+cM;IAOI,6BAAA;ExEk+cV;EwEz+cM;IAOI,+BAAA;ExEq+cV;EwE5+cM;IAOI,8BAAA;ExEw+cV;EwE/+cM;IAOI,oBAAA;ExE2+cV;EwEl/cM;IAOI,mBAAA;ExE8+cV;EwEr/cM;IAOI,mBAAA;ExEi/cV;EwEx/cM;IAOI,mBAAA;ExEo/cV;EwE3/cM;IAOI,mBAAA;ExEu/cV;EwE9/cM;IAOI,mBAAA;ExE0/cV;EwEjgdM;IAOI,mBAAA;ExE6/cV;EwEpgdM;IAOI,mBAAA;ExEggdV;EwEvgdM;IAOI,oBAAA;ExEmgdV;EwE1gdM;IAOI,2BAAA;ExEsgdV;EwE7gdM;IAOI,0BAAA;ExEygdV;EwEhhdM;IAOI,yBAAA;ExE4gdV;EwEnhdM;IAOI,uBAAA;ExE+gdV;EwEthdM;IAOI,yBAAA;ExEkhdV;EwEzhdM;IAOI,uBAAA;ExEqhdV;EwE5hdM;IAOI,yBAAA;ExEwhdV;EwE/hdM;IAOI,uBAAA;ExE2hdV;EwElidM;IAOI,yBAAA;ExE8hdV;EwEridM;IAOI,uBAAA;ExEiidV;EwExidM;IAOI,uBAAA;ExEoidV;EwE3idM;IAOI,uBAAA;ExEuidV;EwE9idM;IAOI,yBAAA;ExE0idV;EwEjjdM;IAOI,uBAAA;ExE6idV;EwEpjdM;IAOI,uBAAA;ExEgjdV;EwEvjdM;IAOI,0BAAA;IAAA,yBAAA;ExEojdV;EwE3jdM;IAOI,iCAAA;IAAA,gCAAA;ExEwjdV;EwE/jdM;IAOI,gCAAA;IAAA,+BAAA;ExE4jdV;EwEnkdM;IAOI,+BAAA;IAAA,8BAAA;ExEgkdV;EwEvkdM;IAOI,6BAAA;IAAA,4BAAA;ExEokdV;EwE3kdM;IAOI,+BAAA;IAAA,8BAAA;ExEwkdV;EwE/kdM;IAOI,6BAAA;IAAA,4BAAA;ExE4kdV;EwEnldM;IAOI,+BAAA;IAAA,8BAAA;ExEgldV;EwEvldM;IAOI,6BAAA;IAAA,4BAAA;ExEoldV;EwE3ldM;IAOI,+BAAA;IAAA,8BAAA;ExEwldV;EwE/ldM;IAOI,6BAAA;IAAA,4BAAA;ExE4ldV;EwEnmdM;IAOI,6BAAA;IAAA,4BAAA;ExEgmdV;EwEvmdM;IAOI,6BAAA;IAAA,4BAAA;ExEomdV;EwE3mdM;IAOI,+BAAA;IAAA,8BAAA;ExEwmdV;EwE/mdM;IAOI,6BAAA;IAAA,4BAAA;ExE4mdV;EwEnndM;IAOI,6BAAA;IAAA,4BAAA;ExEgndV;EwEvndM;IAOI,wBAAA;IAAA,2BAAA;ExEondV;EwE3ndM;IAOI,+BAAA;IAAA,kCAAA;ExEwndV;EwE/ndM;IAOI,8BAAA;IAAA,iCAAA;ExE4ndV;EwEnodM;IAOI,6BAAA;IAAA,gCAAA;ExEgodV;EwEvodM;IAOI,2BAAA;IAAA,8BAAA;ExEoodV;EwE3odM;IAOI,6BAAA;IAAA,gCAAA;ExEwodV;EwE/odM;IAOI,2BAAA;IAAA,8BAAA;ExE4odV;EwEnpdM;IAOI,6BAAA;IAAA,gCAAA;ExEgpdV;EwEvpdM;IAOI,2BAAA;IAAA,8BAAA;ExEopdV;EwE3pdM;IAOI,6BAAA;IAAA,gCAAA;ExEwpdV;EwE/pdM;IAOI,2BAAA;IAAA,8BAAA;ExE4pdV;EwEnqdM;IAOI,2BAAA;IAAA,8BAAA;ExEgqdV;EwEvqdM;IAOI,2BAAA;IAAA,8BAAA;ExEoqdV;EwE3qdM;IAOI,6BAAA;IAAA,gCAAA;ExEwqdV;EwE/qdM;IAOI,2BAAA;IAAA,8BAAA;ExE4qdV;EwEnrdM;IAOI,2BAAA;IAAA,8BAAA;ExEgrdV;EwEvrdM;IAOI,wBAAA;ExEmrdV;EwE1rdM;IAOI,+BAAA;ExEsrdV;EwE7rdM;IAOI,8BAAA;ExEyrdV;EwEhsdM;IAOI,6BAAA;ExE4rdV;EwEnsdM;IAOI,2BAAA;ExE+rdV;EwEtsdM;IAOI,6BAAA;ExEksdV;EwEzsdM;IAOI,2BAAA;ExEqsdV;EwE5sdM;IAOI,6BAAA;ExEwsdV;EwE/sdM;IAOI,2BAAA;ExE2sdV;EwEltdM;IAOI,6BAAA;ExE8sdV;EwErtdM;IAOI,2BAAA;ExEitdV;EwExtdM;IAOI,2BAAA;ExEotdV;EwE3tdM;IAOI,2BAAA;ExEutdV;EwE9tdM;IAOI,6BAAA;ExE0tdV;EwEjudM;IAOI,2BAAA;ExE6tdV;EwEpudM;IAOI,2BAAA;ExEgudV;EwEvudM;IAOI,0BAAA;ExEmudV;EwE1udM;IAOI,iCAAA;ExEsudV;EwE7udM;IAOI,gCAAA;ExEyudV;EwEhvdM;IAOI,+BAAA;ExE4udV;EwEnvdM;IAOI,6BAAA;ExE+udV;EwEtvdM;IAOI,+BAAA;ExEkvdV;EwEzvdM;IAOI,6BAAA;ExEqvdV;EwE5vdM;IAOI,+BAAA;ExEwvdV;EwE/vdM;IAOI,6BAAA;ExE2vdV;EwElwdM;IAOI,+BAAA;ExE8vdV;EwErwdM;IAOI,6BAAA;ExEiwdV;EwExwdM;IAOI,6BAAA;ExEowdV;EwE3wdM;IAOI,6BAAA;ExEuwdV;EwE9wdM;IAOI,+BAAA;ExE0wdV;EwEjxdM;IAOI,6BAAA;ExE6wdV;EwEpxdM;IAOI,6BAAA;ExEgxdV;EwEvxdM;IAOI,2BAAA;ExEmxdV;EwE1xdM;IAOI,kCAAA;ExEsxdV;EwE7xdM;IAOI,iCAAA;ExEyxdV;EwEhydM;IAOI,gCAAA;ExE4xdV;EwEnydM;IAOI,8BAAA;ExE+xdV;EwEtydM;IAOI,gCAAA;ExEkydV;EwEzydM;IAOI,8BAAA;ExEqydV;EwE5ydM;IAOI,gCAAA;ExEwydV;EwE/ydM;IAOI,8BAAA;ExE2ydV;EwElzdM;IAOI,gCAAA;ExE8ydV;EwErzdM;IAOI,8BAAA;ExEizdV;EwExzdM;IAOI,8BAAA;ExEozdV;EwE3zdM;IAOI,8BAAA;ExEuzdV;EwE9zdM;IAOI,gCAAA;ExE0zdV;EwEj0dM;IAOI,8BAAA;ExE6zdV;EwEp0dM;IAOI,8BAAA;ExEg0dV;EwEv0dM;IAOI,yBAAA;ExEm0dV;EwE10dM;IAOI,gCAAA;ExEs0dV;EwE70dM;IAOI,+BAAA;ExEy0dV;EwEh1dM;IAOI,8BAAA;ExE40dV;EwEn1dM;IAOI,4BAAA;ExE+0dV;EwEt1dM;IAOI,8BAAA;ExEk1dV;EwEz1dM;IAOI,4BAAA;ExEq1dV;EwE51dM;IAOI,8BAAA;ExEw1dV;EwE/1dM;IAOI,4BAAA;ExE21dV;EwEl2dM;IAOI,8BAAA;ExE81dV;EwEr2dM;IAOI,4BAAA;ExEi2dV;EwEx2dM;IAOI,4BAAA;ExEo2dV;EwE32dM;IAOI,4BAAA;ExEu2dV;EwE92dM;IAOI,8BAAA;ExE02dV;EwEj3dM;IAOI,4BAAA;ExE62dV;EwEp3dM;IAOI,4BAAA;ExEg3dV;EwEv3dM;IAOI,4BAAA;ExEm3dV;EwE13dM;IAOI,2BAAA;ExEs3dV;EwE73dM;IAOI,0BAAA;ExEy3dV;EwEh4dM;IAOI,wBAAA;ExE43dV;EwEn4dM;IAOI,0BAAA;ExE+3dV;EwEt4dM;IAOI,wBAAA;ExEk4dV;EwEz4dM;IAOI,0BAAA;ExEq4dV;EwE54dM;IAOI,wBAAA;ExEw4dV;EwE/4dM;IAOI,0BAAA;ExE24dV;EwEl5dM;IAOI,wBAAA;ExE84dV;EwEr5dM;IAOI,wBAAA;ExEi5dV;EwEx5dM;IAOI,wBAAA;ExEo5dV;EwE35dM;IAOI,0BAAA;ExEu5dV;EwE95dM;IAOI,wBAAA;ExE05dV;EwEj6dM;IAOI,kCAAA;IAAA,iCAAA;ExE85dV;EwEr6dM;IAOI,iCAAA;IAAA,gCAAA;ExEk6dV;EwEz6dM;IAOI,gCAAA;IAAA,+BAAA;ExEs6dV;EwE76dM;IAOI,8BAAA;IAAA,6BAAA;ExE06dV;EwEj7dM;IAOI,gCAAA;IAAA,+BAAA;ExE86dV;EwEr7dM;IAOI,8BAAA;IAAA,6BAAA;ExEk7dV;EwEz7dM;IAOI,gCAAA;IAAA,+BAAA;ExEs7dV;EwE77dM;IAOI,8BAAA;IAAA,6BAAA;ExE07dV;EwEj8dM;IAOI,gCAAA;IAAA,+BAAA;ExE87dV;EwEr8dM;IAOI,8BAAA;IAAA,6BAAA;ExEk8dV;EwEz8dM;IAOI,8BAAA;IAAA,6BAAA;ExEs8dV;EwE78dM;IAOI,8BAAA;IAAA,6BAAA;ExE08dV;EwEj9dM;IAOI,gCAAA;IAAA,+BAAA;ExE88dV;EwEr9dM;IAOI,8BAAA;IAAA,6BAAA;ExEk9dV;EwEz9dM;IAOI,gCAAA;IAAA,mCAAA;ExEs9dV;EwE79dM;IAOI,+BAAA;IAAA,kCAAA;ExE09dV;EwEj+dM;IAOI,8BAAA;IAAA,iCAAA;ExE89dV;EwEr+dM;IAOI,4BAAA;IAAA,+BAAA;ExEk+dV;EwEz+dM;IAOI,8BAAA;IAAA,iCAAA;ExEs+dV;EwE7+dM;IAOI,4BAAA;IAAA,+BAAA;ExE0+dV;EwEj/dM;IAOI,8BAAA;IAAA,iCAAA;ExE8+dV;EwEr/dM;IAOI,4BAAA;IAAA,+BAAA;ExEk/dV;EwEz/dM;IAOI,8BAAA;IAAA,iCAAA;ExEs/dV;EwE7/dM;IAOI,4BAAA;IAAA,+BAAA;ExE0/dV;EwEjgeM;IAOI,4BAAA;IAAA,+BAAA;ExE8/dV;EwErgeM;IAOI,4BAAA;IAAA,+BAAA;ExEkgeV;EwEzgeM;IAOI,8BAAA;IAAA,iCAAA;ExEsgeV;EwE7geM;IAOI,4BAAA;IAAA,+BAAA;ExE0geV;EwEjheM;IAOI,gCAAA;ExE6geV;EwEpheM;IAOI,+BAAA;ExEgheV;EwEvheM;IAOI,8BAAA;ExEmheV;EwE1heM;IAOI,4BAAA;ExEsheV;EwE7heM;IAOI,8BAAA;ExEyheV;EwEhieM;IAOI,4BAAA;ExE4heV;EwEnieM;IAOI,8BAAA;ExE+heV;EwEtieM;IAOI,4BAAA;ExEkieV;EwEzieM;IAOI,8BAAA;ExEqieV;EwE5ieM;IAOI,4BAAA;ExEwieV;EwE/ieM;IAOI,4BAAA;ExE2ieV;EwEljeM;IAOI,4BAAA;ExE8ieV;EwErjeM;IAOI,8BAAA;ExEijeV;EwExjeM;IAOI,4BAAA;ExEojeV;EwE3jeM;IAOI,kCAAA;ExEujeV;EwE9jeM;IAOI,iCAAA;ExE0jeV;EwEjkeM;IAOI,gCAAA;ExE6jeV;EwEpkeM;IAOI,8BAAA;ExEgkeV;EwEvkeM;IAOI,gCAAA;ExEmkeV;EwE1keM;IAOI,8BAAA;ExEskeV;EwE7keM;IAOI,gCAAA;ExEykeV;EwEhleM;IAOI,8BAAA;ExE4keV;EwEnleM;IAOI,gCAAA;ExE+keV;EwEtleM;IAOI,8BAAA;ExEkleV;EwEzleM;IAOI,8BAAA;ExEqleV;EwE5leM;IAOI,8BAAA;ExEwleV;EwE/leM;IAOI,gCAAA;ExE2leV;EwElmeM;IAOI,8BAAA;ExE8leV;EwErmeM;IAOI,mCAAA;ExEimeV;EwExmeM;IAOI,kCAAA;ExEomeV;EwE3meM;IAOI,iCAAA;ExEumeV;EwE9meM;IAOI,+BAAA;ExE0meV;EwEjneM;IAOI,iCAAA;ExE6meV;EwEpneM;IAOI,+BAAA;ExEgneV;EwEvneM;IAOI,iCAAA;ExEmneV;EwE1neM;IAOI,+BAAA;ExEsneV;EwE7neM;IAOI,iCAAA;ExEyneV;EwEhoeM;IAOI,+BAAA;ExE4neV;EwEnoeM;IAOI,+BAAA;ExE+neV;EwEtoeM;IAOI,+BAAA;ExEkoeV;EwEzoeM;IAOI,iCAAA;ExEqoeV;EwE5oeM;IAOI,+BAAA;ExEwoeV;EwE/oeM;IAOI,iCAAA;ExE2oeV;EwElpeM;IAOI,gCAAA;ExE8oeV;EwErpeM;IAOI,+BAAA;ExEipeV;EwExpeM;IAOI,6BAAA;ExEopeV;EwE3peM;IAOI,+BAAA;ExEupeV;EwE9peM;IAOI,6BAAA;ExE0peV;EwEjqeM;IAOI,+BAAA;ExE6peV;EwEpqeM;IAOI,6BAAA;ExEgqeV;EwEvqeM;IAOI,+BAAA;ExEmqeV;EwE1qeM;IAOI,6BAAA;ExEsqeV;EwE7qeM;IAOI,6BAAA;ExEyqeV;EwEhreM;IAOI,6BAAA;ExE4qeV;EwEnreM;IAOI,+BAAA;ExE+qeV;EwEtreM;IAOI,6BAAA;ExEkreV;EwEzreM;IAOI,qBAAA;ExEqreV;EwE5reM;IAOI,4BAAA;ExEwreV;EwE/reM;IAOI,2BAAA;ExE2reV;EwElseM;IAOI,0BAAA;ExE8reV;EwErseM;IAOI,wBAAA;ExEiseV;EwExseM;IAOI,0BAAA;ExEoseV;EwE3seM;IAOI,wBAAA;ExEuseV;EwE9seM;IAOI,0BAAA;ExE0seV;EwEjteM;IAOI,wBAAA;ExE6seV;EwEpteM;IAOI,0BAAA;ExEgteV;EwEvteM;IAOI,wBAAA;ExEmteV;EwE1teM;IAOI,wBAAA;ExEsteV;EwE7teM;IAOI,wBAAA;ExEyteV;EwEhueM;IAOI,0BAAA;ExE4teV;EwEnueM;IAOI,wBAAA;ExE+teV;EwEtueM;IAOI,2BAAA;IAAA,0BAAA;ExEmueV;EwE1ueM;IAOI,kCAAA;IAAA,iCAAA;ExEuueV;EwE9ueM;IAOI,iCAAA;IAAA,gCAAA;ExE2ueV;EwElveM;IAOI,gCAAA;IAAA,+BAAA;ExE+ueV;EwEtveM;IAOI,8BAAA;IAAA,6BAAA;ExEmveV;EwE1veM;IAOI,gCAAA;IAAA,+BAAA;ExEuveV;EwE9veM;IAOI,8BAAA;IAAA,6BAAA;ExE2veV;EwElweM;IAOI,gCAAA;IAAA,+BAAA;ExE+veV;EwEtweM;IAOI,8BAAA;IAAA,6BAAA;ExEmweV;EwE1weM;IAOI,gCAAA;IAAA,+BAAA;ExEuweV;EwE9weM;IAOI,8BAAA;IAAA,6BAAA;ExE2weV;EwElxeM;IAOI,8BAAA;IAAA,6BAAA;ExE+weV;EwEtxeM;IAOI,8BAAA;IAAA,6BAAA;ExEmxeV;EwE1xeM;IAOI,gCAAA;IAAA,+BAAA;ExEuxeV;EwE9xeM;IAOI,8BAAA;IAAA,6BAAA;ExE2xeV;EwElyeM;IAOI,yBAAA;IAAA,4BAAA;ExE+xeV;EwEtyeM;IAOI,gCAAA;IAAA,mCAAA;ExEmyeV;EwE1yeM;IAOI,+BAAA;IAAA,kCAAA;ExEuyeV;EwE9yeM;IAOI,8BAAA;IAAA,iCAAA;ExE2yeV;EwElzeM;IAOI,4BAAA;IAAA,+BAAA;ExE+yeV;EwEtzeM;IAOI,8BAAA;IAAA,iCAAA;ExEmzeV;EwE1zeM;IAOI,4BAAA;IAAA,+BAAA;ExEuzeV;EwE9zeM;IAOI,8BAAA;IAAA,iCAAA;ExE2zeV;EwEl0eM;IAOI,4BAAA;IAAA,+BAAA;ExE+zeV;EwEt0eM;IAOI,8BAAA;IAAA,iCAAA;ExEm0eV;EwE10eM;IAOI,4BAAA;IAAA,+BAAA;ExEu0eV;EwE90eM;IAOI,4BAAA;IAAA,+BAAA;ExE20eV;EwEl1eM;IAOI,4BAAA;IAAA,+BAAA;ExE+0eV;EwEt1eM;IAOI,8BAAA;IAAA,iCAAA;ExEm1eV;EwE11eM;IAOI,4BAAA;IAAA,+BAAA;ExEu1eV;EwE91eM;IAOI,yBAAA;ExE01eV;EwEj2eM;IAOI,gCAAA;ExE61eV;EwEp2eM;IAOI,+BAAA;ExEg2eV;EwEv2eM;IAOI,8BAAA;ExEm2eV;EwE12eM;IAOI,4BAAA;ExEs2eV;EwE72eM;IAOI,8BAAA;ExEy2eV;EwEh3eM;IAOI,4BAAA;ExE42eV;EwEn3eM;IAOI,8BAAA;ExE+2eV;EwEt3eM;IAOI,4BAAA;ExEk3eV;EwEz3eM;IAOI,8BAAA;ExEq3eV;EwE53eM;IAOI,4BAAA;ExEw3eV;EwE/3eM;IAOI,4BAAA;ExE23eV;EwEl4eM;IAOI,4BAAA;ExE83eV;EwEr4eM;IAOI,8BAAA;ExEi4eV;EwEx4eM;IAOI,4BAAA;ExEo4eV;EwE34eM;IAOI,2BAAA;ExEu4eV;EwE94eM;IAOI,kCAAA;ExE04eV;EwEj5eM;IAOI,iCAAA;ExE64eV;EwEp5eM;IAOI,gCAAA;ExEg5eV;EwEv5eM;IAOI,8BAAA;ExEm5eV;EwE15eM;IAOI,gCAAA;ExEs5eV;EwE75eM;IAOI,8BAAA;ExEy5eV;EwEh6eM;IAOI,gCAAA;ExE45eV;EwEn6eM;IAOI,8BAAA;ExE+5eV;EwEt6eM;IAOI,gCAAA;ExEk6eV;EwEz6eM;IAOI,8BAAA;ExEq6eV;EwE56eM;IAOI,8BAAA;ExEw6eV;EwE/6eM;IAOI,8BAAA;ExE26eV;EwEl7eM;IAOI,gCAAA;ExE86eV;EwEr7eM;IAOI,8BAAA;ExEi7eV;EwEx7eM;IAOI,4BAAA;ExEo7eV;EwE37eM;IAOI,mCAAA;ExEu7eV;EwE97eM;IAOI,kCAAA;ExE07eV;EwEj8eM;IAOI,iCAAA;ExE67eV;EwEp8eM;IAOI,+BAAA;ExEg8eV;EwEv8eM;IAOI,iCAAA;ExEm8eV;EwE18eM;IAOI,+BAAA;ExEs8eV;EwE78eM;IAOI,iCAAA;ExEy8eV;EwEh9eM;IAOI,+BAAA;ExE48eV;EwEn9eM;IAOI,iCAAA;ExE+8eV;EwEt9eM;IAOI,+BAAA;ExEk9eV;EwEz9eM;IAOI,+BAAA;ExEq9eV;EwE59eM;IAOI,+BAAA;ExEw9eV;EwE/9eM;IAOI,iCAAA;ExE29eV;EwEl+eM;IAOI,+BAAA;ExE89eV;EwEr+eM;IAOI,0BAAA;ExEi+eV;EwEx+eM;IAOI,iCAAA;ExEo+eV;EwE3+eM;IAOI,gCAAA;ExEu+eV;EwE9+eM;IAOI,+BAAA;ExE0+eV;EwEj/eM;IAOI,6BAAA;ExE6+eV;EwEp/eM;IAOI,+BAAA;ExEg/eV;EwEv/eM;IAOI,6BAAA;ExEm/eV;EwE1/eM;IAOI,+BAAA;ExEs/eV;EwE7/eM;IAOI,6BAAA;ExEy/eV;EwEhgfM;IAOI,+BAAA;ExE4/eV;EwEngfM;IAOI,6BAAA;ExE+/eV;EwEtgfM;IAOI,6BAAA;ExEkgfV;EwEzgfM;IAOI,6BAAA;ExEqgfV;EwE5gfM;IAOI,+BAAA;ExEwgfV;EwE/gfM;IAOI,6BAAA;ExE2gfV;EwElhfM;IAOI,iBAAA;ExE8gfV;EwErhfM;IAOI,wBAAA;ExEihfV;EwExhfM;IAOI,uBAAA;ExEohfV;EwE3hfM;IAOI,sBAAA;ExEuhfV;EwE9hfM;IAOI,oBAAA;ExE0hfV;EwEjifM;IAOI,sBAAA;ExE6hfV;EwEpifM;IAOI,oBAAA;ExEgifV;EwEvifM;IAOI,sBAAA;ExEmifV;EwE1ifM;IAOI,oBAAA;ExEsifV;EwE7ifM;IAOI,sBAAA;ExEyifV;EwEhjfM;IAOI,oBAAA;ExE4ifV;EwEnjfM;IAOI,oBAAA;ExE+ifV;EwEtjfM;IAOI,oBAAA;ExEkjfV;EwEzjfM;IAOI,sBAAA;ExEqjfV;EwE5jfM;IAOI,oBAAA;ExEwjfV;EwE/jfM;IAOI,qBAAA;ExE2jfV;EwElkfM;IAOI,4BAAA;ExE8jfV;EwErkfM;IAOI,2BAAA;ExEikfV;EwExkfM;IAOI,0BAAA;ExEokfV;EwE3kfM;IAOI,wBAAA;ExEukfV;EwE9kfM;IAOI,0BAAA;ExE0kfV;EwEjlfM;IAOI,wBAAA;ExE6kfV;EwEplfM;IAOI,0BAAA;ExEglfV;EwEvlfM;IAOI,wBAAA;ExEmlfV;EwE1lfM;IAOI,0BAAA;ExEslfV;EwE7lfM;IAOI,wBAAA;ExEylfV;EwEhmfM;IAOI,wBAAA;ExE4lfV;EwEnmfM;IAOI,wBAAA;ExE+lfV;EwEtmfM;IAOI,0BAAA;ExEkmfV;EwEzmfM;IAOI,wBAAA;ExEqmfV;EwE5mfM;IAOI,wBAAA;ExEwmfV;EwE/mfM;IAOI,+BAAA;ExE2mfV;EwElnfM;IAOI,8BAAA;ExE8mfV;EwErnfM;IAOI,6BAAA;ExEinfV;EwExnfM;IAOI,2BAAA;ExEonfV;EwE3nfM;IAOI,6BAAA;ExEunfV;EwE9nfM;IAOI,2BAAA;ExE0nfV;EwEjofM;IAOI,6BAAA;ExE6nfV;EwEpofM;IAOI,2BAAA;ExEgofV;EwEvofM;IAOI,6BAAA;ExEmofV;EwE1ofM;IAOI,2BAAA;ExEsofV;EwE7ofM;IAOI,2BAAA;ExEyofV;EwEhpfM;IAOI,2BAAA;ExE4ofV;EwEnpfM;IAOI,6BAAA;ExE+ofV;EwEtpfM;IAOI,2BAAA;ExEkpfV;EwEzpfM;IAOI,2BAAA;ExEqpfV;EwE5pfM;IAOI,4BAAA;ExEwpfV;EwE/pfM;IAOI,6BAAA;ExE2pfV;AACF;AGtqfI;EqEGI;IAOI,sBAAA;ExEgqfV;EwEvqfM;IAOI,uBAAA;ExEmqfV;EwE1qfM;IAOI,sBAAA;ExEsqfV;EwE7qfM;IAOI,8BAAA;ExEyqfV;EwEhrfM;IAOI,4BAAA;ExE4qfV;EwEnrfM;IAOI,2BAAA;ExE+qfV;EwEtrfM;IAOI,iCAAA;ExEkrfV;EwEzrfM;IAOI,2BAAA;ExEqrfV;EwE5rfM;IAOI,0BAAA;ExEwrfV;EwE/rfM;IAOI,gCAAA;ExE2rfV;EwElsfM;IAOI,yBAAA;ExE8rfV;EwErsfM;IAOI,wBAAA;ExEisfV;EwExsfM;IAOI,+BAAA;ExEosfV;EwE3sfM;IAOI,yBAAA;ExEusfV;EwE9sfM;IAOI,6BAAA;ExE0sfV;EwEjtfM;IAOI,8BAAA;ExE6sfV;EwEptfM;IAOI,wBAAA;ExEgtfV;EwEvtfM;IAOI,+BAAA;ExEmtfV;EwE1tfM;IAOI,wBAAA;ExEstfV;EwE7tfM;IAOI,yBAAA;ExEytfV;EwEhufM;IAOI,8BAAA;ExE4tfV;EwEnufM;IAOI,iCAAA;ExE+tfV;EwEtufM;IAOI,sCAAA;ExEkufV;EwEzufM;IAOI,yCAAA;ExEqufV;EwE5ufM;IAOI,uBAAA;ExEwufV;EwE/ufM;IAOI,uBAAA;ExE2ufV;EwElvfM;IAOI,yBAAA;ExE8ufV;EwErvfM;IAOI,yBAAA;ExEivfV;EwExvfM;IAOI,0BAAA;ExEovfV;EwE3vfM;IAOI,4BAAA;ExEuvfV;EwE9vfM;IAOI,kCAAA;ExE0vfV;EwEjwfM;IAOI,sCAAA;ExE6vfV;EwEpwfM;IAOI,oCAAA;ExEgwfV;EwEvwfM;IAOI,kCAAA;ExEmwfV;EwE1wfM;IAOI,yCAAA;ExEswfV;EwE7wfM;IAOI,wCAAA;ExEywfV;EwEhxfM;IAOI,wCAAA;ExE4wfV;EwEnxfM;IAOI,kCAAA;ExE+wfV;EwEtxfM;IAOI,gCAAA;ExEkxfV;EwEzxfM;IAOI,8BAAA;ExEqxfV;EwE5xfM;IAOI,gCAAA;ExEwxfV;EwE/xfM;IAOI,+BAAA;ExE2xfV;EwElyfM;IAOI,oCAAA;ExE8xfV;EwEryfM;IAOI,kCAAA;ExEiyfV;EwExyfM;IAOI,gCAAA;ExEoyfV;EwE3yfM;IAOI,uCAAA;ExEuyfV;EwE9yfM;IAOI,sCAAA;ExE0yfV;EwEjzfM;IAOI,iCAAA;ExE6yfV;EwEpzfM;IAOI,2BAAA;ExEgzfV;EwEvzfM;IAOI,iCAAA;ExEmzfV;EwE1zfM;IAOI,+BAAA;ExEszfV;EwE7zfM;IAOI,6BAAA;ExEyzfV;EwEh0fM;IAOI,+BAAA;ExE4zfV;EwEn0fM;IAOI,8BAAA;ExE+zfV;EwEt0fM;IAOI,oBAAA;ExEk0fV;EwEz0fM;IAOI,mBAAA;ExEq0fV;EwE50fM;IAOI,mBAAA;ExEw0fV;EwE/0fM;IAOI,mBAAA;ExE20fV;EwEl1fM;IAOI,mBAAA;ExE80fV;EwEr1fM;IAOI,mBAAA;ExEi1fV;EwEx1fM;IAOI,mBAAA;ExEo1fV;EwE31fM;IAOI,mBAAA;ExEu1fV;EwE91fM;IAOI,oBAAA;ExE01fV;EwEj2fM;IAOI,2BAAA;ExE61fV;EwEp2fM;IAOI,0BAAA;ExEg2fV;EwEv2fM;IAOI,yBAAA;ExEm2fV;EwE12fM;IAOI,uBAAA;ExEs2fV;EwE72fM;IAOI,yBAAA;ExEy2fV;EwEh3fM;IAOI,uBAAA;ExE42fV;EwEn3fM;IAOI,yBAAA;ExE+2fV;EwEt3fM;IAOI,uBAAA;ExEk3fV;EwEz3fM;IAOI,yBAAA;ExEq3fV;EwE53fM;IAOI,uBAAA;ExEw3fV;EwE/3fM;IAOI,uBAAA;ExE23fV;EwEl4fM;IAOI,uBAAA;ExE83fV;EwEr4fM;IAOI,yBAAA;ExEi4fV;EwEx4fM;IAOI,uBAAA;ExEo4fV;EwE34fM;IAOI,uBAAA;ExEu4fV;EwE94fM;IAOI,0BAAA;IAAA,yBAAA;ExE24fV;EwEl5fM;IAOI,iCAAA;IAAA,gCAAA;ExE+4fV;EwEt5fM;IAOI,gCAAA;IAAA,+BAAA;ExEm5fV;EwE15fM;IAOI,+BAAA;IAAA,8BAAA;ExEu5fV;EwE95fM;IAOI,6BAAA;IAAA,4BAAA;ExE25fV;EwEl6fM;IAOI,+BAAA;IAAA,8BAAA;ExE+5fV;EwEt6fM;IAOI,6BAAA;IAAA,4BAAA;ExEm6fV;EwE16fM;IAOI,+BAAA;IAAA,8BAAA;ExEu6fV;EwE96fM;IAOI,6BAAA;IAAA,4BAAA;ExE26fV;EwEl7fM;IAOI,+BAAA;IAAA,8BAAA;ExE+6fV;EwEt7fM;IAOI,6BAAA;IAAA,4BAAA;ExEm7fV;EwE17fM;IAOI,6BAAA;IAAA,4BAAA;ExEu7fV;EwE97fM;IAOI,6BAAA;IAAA,4BAAA;ExE27fV;EwEl8fM;IAOI,+BAAA;IAAA,8BAAA;ExE+7fV;EwEt8fM;IAOI,6BAAA;IAAA,4BAAA;ExEm8fV;EwE18fM;IAOI,6BAAA;IAAA,4BAAA;ExEu8fV;EwE98fM;IAOI,wBAAA;IAAA,2BAAA;ExE28fV;EwEl9fM;IAOI,+BAAA;IAAA,kCAAA;ExE+8fV;EwEt9fM;IAOI,8BAAA;IAAA,iCAAA;ExEm9fV;EwE19fM;IAOI,6BAAA;IAAA,gCAAA;ExEu9fV;EwE99fM;IAOI,2BAAA;IAAA,8BAAA;ExE29fV;EwEl+fM;IAOI,6BAAA;IAAA,gCAAA;ExE+9fV;EwEt+fM;IAOI,2BAAA;IAAA,8BAAA;ExEm+fV;EwE1+fM;IAOI,6BAAA;IAAA,gCAAA;ExEu+fV;EwE9+fM;IAOI,2BAAA;IAAA,8BAAA;ExE2+fV;EwEl/fM;IAOI,6BAAA;IAAA,gCAAA;ExE++fV;EwEt/fM;IAOI,2BAAA;IAAA,8BAAA;ExEm/fV;EwE1/fM;IAOI,2BAAA;IAAA,8BAAA;ExEu/fV;EwE9/fM;IAOI,2BAAA;IAAA,8BAAA;ExE2/fV;EwElggBM;IAOI,6BAAA;IAAA,gCAAA;ExE+/fV;EwEtggBM;IAOI,2BAAA;IAAA,8BAAA;ExEmggBV;EwE1ggBM;IAOI,2BAAA;IAAA,8BAAA;ExEuggBV;EwE9ggBM;IAOI,wBAAA;ExE0ggBV;EwEjhgBM;IAOI,+BAAA;ExE6ggBV;EwEphgBM;IAOI,8BAAA;ExEghgBV;EwEvhgBM;IAOI,6BAAA;ExEmhgBV;EwE1hgBM;IAOI,2BAAA;ExEshgBV;EwE7hgBM;IAOI,6BAAA;ExEyhgBV;EwEhigBM;IAOI,2BAAA;ExE4hgBV;EwEnigBM;IAOI,6BAAA;ExE+hgBV;EwEtigBM;IAOI,2BAAA;ExEkigBV;EwEzigBM;IAOI,6BAAA;ExEqigBV;EwE5igBM;IAOI,2BAAA;ExEwigBV;EwE/igBM;IAOI,2BAAA;ExE2igBV;EwEljgBM;IAOI,2BAAA;ExE8igBV;EwErjgBM;IAOI,6BAAA;ExEijgBV;EwExjgBM;IAOI,2BAAA;ExEojgBV;EwE3jgBM;IAOI,2BAAA;ExEujgBV;EwE9jgBM;IAOI,0BAAA;ExE0jgBV;EwEjkgBM;IAOI,iCAAA;ExE6jgBV;EwEpkgBM;IAOI,gCAAA;ExEgkgBV;EwEvkgBM;IAOI,+BAAA;ExEmkgBV;EwE1kgBM;IAOI,6BAAA;ExEskgBV;EwE7kgBM;IAOI,+BAAA;ExEykgBV;EwEhlgBM;IAOI,6BAAA;ExE4kgBV;EwEnlgBM;IAOI,+BAAA;ExE+kgBV;EwEtlgBM;IAOI,6BAAA;ExEklgBV;EwEzlgBM;IAOI,+BAAA;ExEqlgBV;EwE5lgBM;IAOI,6BAAA;ExEwlgBV;EwE/lgBM;IAOI,6BAAA;ExE2lgBV;EwElmgBM;IAOI,6BAAA;ExE8lgBV;EwErmgBM;IAOI,+BAAA;ExEimgBV;EwExmgBM;IAOI,6BAAA;ExEomgBV;EwE3mgBM;IAOI,6BAAA;ExEumgBV;EwE9mgBM;IAOI,2BAAA;ExE0mgBV;EwEjngBM;IAOI,kCAAA;ExE6mgBV;EwEpngBM;IAOI,iCAAA;ExEgngBV;EwEvngBM;IAOI,gCAAA;ExEmngBV;EwE1ngBM;IAOI,8BAAA;ExEsngBV;EwE7ngBM;IAOI,gCAAA;ExEyngBV;EwEhogBM;IAOI,8BAAA;ExE4ngBV;EwEnogBM;IAOI,gCAAA;ExE+ngBV;EwEtogBM;IAOI,8BAAA;ExEkogBV;EwEzogBM;IAOI,gCAAA;ExEqogBV;EwE5ogBM;IAOI,8BAAA;ExEwogBV;EwE/ogBM;IAOI,8BAAA;ExE2ogBV;EwElpgBM;IAOI,8BAAA;ExE8ogBV;EwErpgBM;IAOI,gCAAA;ExEipgBV;EwExpgBM;IAOI,8BAAA;ExEopgBV;EwE3pgBM;IAOI,8BAAA;ExEupgBV;EwE9pgBM;IAOI,yBAAA;ExE0pgBV;EwEjqgBM;IAOI,gCAAA;ExE6pgBV;EwEpqgBM;IAOI,+BAAA;ExEgqgBV;EwEvqgBM;IAOI,8BAAA;ExEmqgBV;EwE1qgBM;IAOI,4BAAA;ExEsqgBV;EwE7qgBM;IAOI,8BAAA;ExEyqgBV;EwEhrgBM;IAOI,4BAAA;ExE4qgBV;EwEnrgBM;IAOI,8BAAA;ExE+qgBV;EwEtrgBM;IAOI,4BAAA;ExEkrgBV;EwEzrgBM;IAOI,8BAAA;ExEqrgBV;EwE5rgBM;IAOI,4BAAA;ExEwrgBV;EwE/rgBM;IAOI,4BAAA;ExE2rgBV;EwElsgBM;IAOI,4BAAA;ExE8rgBV;EwErsgBM;IAOI,8BAAA;ExEisgBV;EwExsgBM;IAOI,4BAAA;ExEosgBV;EwE3sgBM;IAOI,4BAAA;ExEusgBV;EwE9sgBM;IAOI,4BAAA;ExE0sgBV;EwEjtgBM;IAOI,2BAAA;ExE6sgBV;EwEptgBM;IAOI,0BAAA;ExEgtgBV;EwEvtgBM;IAOI,wBAAA;ExEmtgBV;EwE1tgBM;IAOI,0BAAA;ExEstgBV;EwE7tgBM;IAOI,wBAAA;ExEytgBV;EwEhugBM;IAOI,0BAAA;ExE4tgBV;EwEnugBM;IAOI,wBAAA;ExE+tgBV;EwEtugBM;IAOI,0BAAA;ExEkugBV;EwEzugBM;IAOI,wBAAA;ExEqugBV;EwE5ugBM;IAOI,wBAAA;ExEwugBV;EwE/ugBM;IAOI,wBAAA;ExE2ugBV;EwElvgBM;IAOI,0BAAA;ExE8ugBV;EwErvgBM;IAOI,wBAAA;ExEivgBV;EwExvgBM;IAOI,kCAAA;IAAA,iCAAA;ExEqvgBV;EwE5vgBM;IAOI,iCAAA;IAAA,gCAAA;ExEyvgBV;EwEhwgBM;IAOI,gCAAA;IAAA,+BAAA;ExE6vgBV;EwEpwgBM;IAOI,8BAAA;IAAA,6BAAA;ExEiwgBV;EwExwgBM;IAOI,gCAAA;IAAA,+BAAA;ExEqwgBV;EwE5wgBM;IAOI,8BAAA;IAAA,6BAAA;ExEywgBV;EwEhxgBM;IAOI,gCAAA;IAAA,+BAAA;ExE6wgBV;EwEpxgBM;IAOI,8BAAA;IAAA,6BAAA;ExEixgBV;EwExxgBM;IAOI,gCAAA;IAAA,+BAAA;ExEqxgBV;EwE5xgBM;IAOI,8BAAA;IAAA,6BAAA;ExEyxgBV;EwEhygBM;IAOI,8BAAA;IAAA,6BAAA;ExE6xgBV;EwEpygBM;IAOI,8BAAA;IAAA,6BAAA;ExEiygBV;EwExygBM;IAOI,gCAAA;IAAA,+BAAA;ExEqygBV;EwE5ygBM;IAOI,8BAAA;IAAA,6BAAA;ExEyygBV;EwEhzgBM;IAOI,gCAAA;IAAA,mCAAA;ExE6ygBV;EwEpzgBM;IAOI,+BAAA;IAAA,kCAAA;ExEizgBV;EwExzgBM;IAOI,8BAAA;IAAA,iCAAA;ExEqzgBV;EwE5zgBM;IAOI,4BAAA;IAAA,+BAAA;ExEyzgBV;EwEh0gBM;IAOI,8BAAA;IAAA,iCAAA;ExE6zgBV;EwEp0gBM;IAOI,4BAAA;IAAA,+BAAA;ExEi0gBV;EwEx0gBM;IAOI,8BAAA;IAAA,iCAAA;ExEq0gBV;EwE50gBM;IAOI,4BAAA;IAAA,+BAAA;ExEy0gBV;EwEh1gBM;IAOI,8BAAA;IAAA,iCAAA;ExE60gBV;EwEp1gBM;IAOI,4BAAA;IAAA,+BAAA;ExEi1gBV;EwEx1gBM;IAOI,4BAAA;IAAA,+BAAA;ExEq1gBV;EwE51gBM;IAOI,4BAAA;IAAA,+BAAA;ExEy1gBV;EwEh2gBM;IAOI,8BAAA;IAAA,iCAAA;ExE61gBV;EwEp2gBM;IAOI,4BAAA;IAAA,+BAAA;ExEi2gBV;EwEx2gBM;IAOI,gCAAA;ExEo2gBV;EwE32gBM;IAOI,+BAAA;ExEu2gBV;EwE92gBM;IAOI,8BAAA;ExE02gBV;EwEj3gBM;IAOI,4BAAA;ExE62gBV;EwEp3gBM;IAOI,8BAAA;ExEg3gBV;EwEv3gBM;IAOI,4BAAA;ExEm3gBV;EwE13gBM;IAOI,8BAAA;ExEs3gBV;EwE73gBM;IAOI,4BAAA;ExEy3gBV;EwEh4gBM;IAOI,8BAAA;ExE43gBV;EwEn4gBM;IAOI,4BAAA;ExE+3gBV;EwEt4gBM;IAOI,4BAAA;ExEk4gBV;EwEz4gBM;IAOI,4BAAA;ExEq4gBV;EwE54gBM;IAOI,8BAAA;ExEw4gBV;EwE/4gBM;IAOI,4BAAA;ExE24gBV;EwEl5gBM;IAOI,kCAAA;ExE84gBV;EwEr5gBM;IAOI,iCAAA;ExEi5gBV;EwEx5gBM;IAOI,gCAAA;ExEo5gBV;EwE35gBM;IAOI,8BAAA;ExEu5gBV;EwE95gBM;IAOI,gCAAA;ExE05gBV;EwEj6gBM;IAOI,8BAAA;ExE65gBV;EwEp6gBM;IAOI,gCAAA;ExEg6gBV;EwEv6gBM;IAOI,8BAAA;ExEm6gBV;EwE16gBM;IAOI,gCAAA;ExEs6gBV;EwE76gBM;IAOI,8BAAA;ExEy6gBV;EwEh7gBM;IAOI,8BAAA;ExE46gBV;EwEn7gBM;IAOI,8BAAA;ExE+6gBV;EwEt7gBM;IAOI,gCAAA;ExEk7gBV;EwEz7gBM;IAOI,8BAAA;ExEq7gBV;EwE57gBM;IAOI,mCAAA;ExEw7gBV;EwE/7gBM;IAOI,kCAAA;ExE27gBV;EwEl8gBM;IAOI,iCAAA;ExE87gBV;EwEr8gBM;IAOI,+BAAA;ExEi8gBV;EwEx8gBM;IAOI,iCAAA;ExEo8gBV;EwE38gBM;IAOI,+BAAA;ExEu8gBV;EwE98gBM;IAOI,iCAAA;ExE08gBV;EwEj9gBM;IAOI,+BAAA;ExE68gBV;EwEp9gBM;IAOI,iCAAA;ExEg9gBV;EwEv9gBM;IAOI,+BAAA;ExEm9gBV;EwE19gBM;IAOI,+BAAA;ExEs9gBV;EwE79gBM;IAOI,+BAAA;ExEy9gBV;EwEh+gBM;IAOI,iCAAA;ExE49gBV;EwEn+gBM;IAOI,+BAAA;ExE+9gBV;EwEt+gBM;IAOI,iCAAA;ExEk+gBV;EwEz+gBM;IAOI,gCAAA;ExEq+gBV;EwE5+gBM;IAOI,+BAAA;ExEw+gBV;EwE/+gBM;IAOI,6BAAA;ExE2+gBV;EwEl/gBM;IAOI,+BAAA;ExE8+gBV;EwEr/gBM;IAOI,6BAAA;ExEi/gBV;EwEx/gBM;IAOI,+BAAA;ExEo/gBV;EwE3/gBM;IAOI,6BAAA;ExEu/gBV;EwE9/gBM;IAOI,+BAAA;ExE0/gBV;EwEjghBM;IAOI,6BAAA;ExE6/gBV;EwEpghBM;IAOI,6BAAA;ExEgghBV;EwEvghBM;IAOI,6BAAA;ExEmghBV;EwE1ghBM;IAOI,+BAAA;ExEsghBV;EwE7ghBM;IAOI,6BAAA;ExEyghBV;EwEhhhBM;IAOI,qBAAA;ExE4ghBV;EwEnhhBM;IAOI,4BAAA;ExE+ghBV;EwEthhBM;IAOI,2BAAA;ExEkhhBV;EwEzhhBM;IAOI,0BAAA;ExEqhhBV;EwE5hhBM;IAOI,wBAAA;ExEwhhBV;EwE/hhBM;IAOI,0BAAA;ExE2hhBV;EwElihBM;IAOI,wBAAA;ExE8hhBV;EwErihBM;IAOI,0BAAA;ExEiihBV;EwExihBM;IAOI,wBAAA;ExEoihBV;EwE3ihBM;IAOI,0BAAA;ExEuihBV;EwE9ihBM;IAOI,wBAAA;ExE0ihBV;EwEjjhBM;IAOI,wBAAA;ExE6ihBV;EwEpjhBM;IAOI,wBAAA;ExEgjhBV;EwEvjhBM;IAOI,0BAAA;ExEmjhBV;EwE1jhBM;IAOI,wBAAA;ExEsjhBV;EwE7jhBM;IAOI,2BAAA;IAAA,0BAAA;ExE0jhBV;EwEjkhBM;IAOI,kCAAA;IAAA,iCAAA;ExE8jhBV;EwErkhBM;IAOI,iCAAA;IAAA,gCAAA;ExEkkhBV;EwEzkhBM;IAOI,gCAAA;IAAA,+BAAA;ExEskhBV;EwE7khBM;IAOI,8BAAA;IAAA,6BAAA;ExE0khBV;EwEjlhBM;IAOI,gCAAA;IAAA,+BAAA;ExE8khBV;EwErlhBM;IAOI,8BAAA;IAAA,6BAAA;ExEklhBV;EwEzlhBM;IAOI,gCAAA;IAAA,+BAAA;ExEslhBV;EwE7lhBM;IAOI,8BAAA;IAAA,6BAAA;ExE0lhBV;EwEjmhBM;IAOI,gCAAA;IAAA,+BAAA;ExE8lhBV;EwErmhBM;IAOI,8BAAA;IAAA,6BAAA;ExEkmhBV;EwEzmhBM;IAOI,8BAAA;IAAA,6BAAA;ExEsmhBV;EwE7mhBM;IAOI,8BAAA;IAAA,6BAAA;ExE0mhBV;EwEjnhBM;IAOI,gCAAA;IAAA,+BAAA;ExE8mhBV;EwErnhBM;IAOI,8BAAA;IAAA,6BAAA;ExEknhBV;EwEznhBM;IAOI,yBAAA;IAAA,4BAAA;ExEsnhBV;EwE7nhBM;IAOI,gCAAA;IAAA,mCAAA;ExE0nhBV;EwEjohBM;IAOI,+BAAA;IAAA,kCAAA;ExE8nhBV;EwErohBM;IAOI,8BAAA;IAAA,iCAAA;ExEkohBV;EwEzohBM;IAOI,4BAAA;IAAA,+BAAA;ExEsohBV;EwE7ohBM;IAOI,8BAAA;IAAA,iCAAA;ExE0ohBV;EwEjphBM;IAOI,4BAAA;IAAA,+BAAA;ExE8ohBV;EwErphBM;IAOI,8BAAA;IAAA,iCAAA;ExEkphBV;EwEzphBM;IAOI,4BAAA;IAAA,+BAAA;ExEsphBV;EwE7phBM;IAOI,8BAAA;IAAA,iCAAA;ExE0phBV;EwEjqhBM;IAOI,4BAAA;IAAA,+BAAA;ExE8phBV;EwErqhBM;IAOI,4BAAA;IAAA,+BAAA;ExEkqhBV;EwEzqhBM;IAOI,4BAAA;IAAA,+BAAA;ExEsqhBV;EwE7qhBM;IAOI,8BAAA;IAAA,iCAAA;ExE0qhBV;EwEjrhBM;IAOI,4BAAA;IAAA,+BAAA;ExE8qhBV;EwErrhBM;IAOI,yBAAA;ExEirhBV;EwExrhBM;IAOI,gCAAA;ExEorhBV;EwE3rhBM;IAOI,+BAAA;ExEurhBV;EwE9rhBM;IAOI,8BAAA;ExE0rhBV;EwEjshBM;IAOI,4BAAA;ExE6rhBV;EwEpshBM;IAOI,8BAAA;ExEgshBV;EwEvshBM;IAOI,4BAAA;ExEmshBV;EwE1shBM;IAOI,8BAAA;ExEsshBV;EwE7shBM;IAOI,4BAAA;ExEyshBV;EwEhthBM;IAOI,8BAAA;ExE4shBV;EwEnthBM;IAOI,4BAAA;ExE+shBV;EwEtthBM;IAOI,4BAAA;ExEkthBV;EwEzthBM;IAOI,4BAAA;ExEqthBV;EwE5thBM;IAOI,8BAAA;ExEwthBV;EwE/thBM;IAOI,4BAAA;ExE2thBV;EwEluhBM;IAOI,2BAAA;ExE8thBV;EwEruhBM;IAOI,kCAAA;ExEiuhBV;EwExuhBM;IAOI,iCAAA;ExEouhBV;EwE3uhBM;IAOI,gCAAA;ExEuuhBV;EwE9uhBM;IAOI,8BAAA;ExE0uhBV;EwEjvhBM;IAOI,gCAAA;ExE6uhBV;EwEpvhBM;IAOI,8BAAA;ExEgvhBV;EwEvvhBM;IAOI,gCAAA;ExEmvhBV;EwE1vhBM;IAOI,8BAAA;ExEsvhBV;EwE7vhBM;IAOI,gCAAA;ExEyvhBV;EwEhwhBM;IAOI,8BAAA;ExE4vhBV;EwEnwhBM;IAOI,8BAAA;ExE+vhBV;EwEtwhBM;IAOI,8BAAA;ExEkwhBV;EwEzwhBM;IAOI,gCAAA;ExEqwhBV;EwE5whBM;IAOI,8BAAA;ExEwwhBV;EwE/whBM;IAOI,4BAAA;ExE2whBV;EwElxhBM;IAOI,mCAAA;ExE8whBV;EwErxhBM;IAOI,kCAAA;ExEixhBV;EwExxhBM;IAOI,iCAAA;ExEoxhBV;EwE3xhBM;IAOI,+BAAA;ExEuxhBV;EwE9xhBM;IAOI,iCAAA;ExE0xhBV;EwEjyhBM;IAOI,+BAAA;ExE6xhBV;EwEpyhBM;IAOI,iCAAA;ExEgyhBV;EwEvyhBM;IAOI,+BAAA;ExEmyhBV;EwE1yhBM;IAOI,iCAAA;ExEsyhBV;EwE7yhBM;IAOI,+BAAA;ExEyyhBV;EwEhzhBM;IAOI,+BAAA;ExE4yhBV;EwEnzhBM;IAOI,+BAAA;ExE+yhBV;EwEtzhBM;IAOI,iCAAA;ExEkzhBV;EwEzzhBM;IAOI,+BAAA;ExEqzhBV;EwE5zhBM;IAOI,0BAAA;ExEwzhBV;EwE/zhBM;IAOI,iCAAA;ExE2zhBV;EwEl0hBM;IAOI,gCAAA;ExE8zhBV;EwEr0hBM;IAOI,+BAAA;ExEi0hBV;EwEx0hBM;IAOI,6BAAA;ExEo0hBV;EwE30hBM;IAOI,+BAAA;ExEu0hBV;EwE90hBM;IAOI,6BAAA;ExE00hBV;EwEj1hBM;IAOI,+BAAA;ExE60hBV;EwEp1hBM;IAOI,6BAAA;ExEg1hBV;EwEv1hBM;IAOI,+BAAA;ExEm1hBV;EwE11hBM;IAOI,6BAAA;ExEs1hBV;EwE71hBM;IAOI,6BAAA;ExEy1hBV;EwEh2hBM;IAOI,6BAAA;ExE41hBV;EwEn2hBM;IAOI,+BAAA;ExE+1hBV;EwEt2hBM;IAOI,6BAAA;ExEk2hBV;EwEz2hBM;IAOI,iBAAA;ExEq2hBV;EwE52hBM;IAOI,wBAAA;ExEw2hBV;EwE/2hBM;IAOI,uBAAA;ExE22hBV;EwEl3hBM;IAOI,sBAAA;ExE82hBV;EwEr3hBM;IAOI,oBAAA;ExEi3hBV;EwEx3hBM;IAOI,sBAAA;ExEo3hBV;EwE33hBM;IAOI,oBAAA;ExEu3hBV;EwE93hBM;IAOI,sBAAA;ExE03hBV;EwEj4hBM;IAOI,oBAAA;ExE63hBV;EwEp4hBM;IAOI,sBAAA;ExEg4hBV;EwEv4hBM;IAOI,oBAAA;ExEm4hBV;EwE14hBM;IAOI,oBAAA;ExEs4hBV;EwE74hBM;IAOI,oBAAA;ExEy4hBV;EwEh5hBM;IAOI,sBAAA;ExE44hBV;EwEn5hBM;IAOI,oBAAA;ExE+4hBV;EwEt5hBM;IAOI,qBAAA;ExEk5hBV;EwEz5hBM;IAOI,4BAAA;ExEq5hBV;EwE55hBM;IAOI,2BAAA;ExEw5hBV;EwE/5hBM;IAOI,0BAAA;ExE25hBV;EwEl6hBM;IAOI,wBAAA;ExE85hBV;EwEr6hBM;IAOI,0BAAA;ExEi6hBV;EwEx6hBM;IAOI,wBAAA;ExEo6hBV;EwE36hBM;IAOI,0BAAA;ExEu6hBV;EwE96hBM;IAOI,wBAAA;ExE06hBV;EwEj7hBM;IAOI,0BAAA;ExE66hBV;EwEp7hBM;IAOI,wBAAA;ExEg7hBV;EwEv7hBM;IAOI,wBAAA;ExEm7hBV;EwE17hBM;IAOI,wBAAA;ExEs7hBV;EwE77hBM;IAOI,0BAAA;ExEy7hBV;EwEh8hBM;IAOI,wBAAA;ExE47hBV;EwEn8hBM;IAOI,wBAAA;ExE+7hBV;EwEt8hBM;IAOI,+BAAA;ExEk8hBV;EwEz8hBM;IAOI,8BAAA;ExEq8hBV;EwE58hBM;IAOI,6BAAA;ExEw8hBV;EwE/8hBM;IAOI,2BAAA;ExE28hBV;EwEl9hBM;IAOI,6BAAA;ExE88hBV;EwEr9hBM;IAOI,2BAAA;ExEi9hBV;EwEx9hBM;IAOI,6BAAA;ExEo9hBV;EwE39hBM;IAOI,2BAAA;ExEu9hBV;EwE99hBM;IAOI,6BAAA;ExE09hBV;EwEj+hBM;IAOI,2BAAA;ExE69hBV;EwEp+hBM;IAOI,2BAAA;ExEg+hBV;EwEv+hBM;IAOI,2BAAA;ExEm+hBV;EwE1+hBM;IAOI,6BAAA;ExEs+hBV;EwE7+hBM;IAOI,2BAAA;ExEy+hBV;EwEh/hBM;IAOI,2BAAA;ExE4+hBV;EwEn/hBM;IAOI,4BAAA;ExE++hBV;EwEt/hBM;IAOI,6BAAA;ExEk/hBV;AACF;AyEthiBA;ED4BQ;IAOI,0BAAA;ExEu/hBV;EwE9/hBM;IAOI,gCAAA;ExE0/hBV;EwEjgiBM;IAOI,yBAAA;ExE6/hBV;EwEpgiBM;IAOI,wBAAA;ExEggiBV;EwEvgiBM;IAOI,+BAAA;ExEmgiBV;EwE1giBM;IAOI,yBAAA;ExEsgiBV;EwE7giBM;IAOI,6BAAA;ExEygiBV;EwEhhiBM;IAOI,8BAAA;ExE4giBV;EwEnhiBM;IAOI,wBAAA;ExE+giBV;EwEthiBM;IAOI,+BAAA;ExEkhiBV;EwEzhiBM;IAOI,wBAAA;ExEqhiBV;AACF;A0E/liBA;;EAEE,qBAAA;EACA,0BAAA;EAEA,+BAAA;EACA,4BAAA;EACA,+BAAA;EACA,8BAAA;EAEA,mCAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EAEA,qCAAA;EACA,uCAAA;A1E8liBF;;A0E3liBA;EACE,gBAAA;EACA,WxEdM;AF4miBR;;A2EnniBA;EACE,+BAAA;EACA,+BAAA;EACA,8BAAA;A3EsniBF;;A4EtniBE;EACE,oCAAA;A5EyniBJ;A4EtniBE;EACE,oCAAA;A5EwniBJ;A4ErniBE;EACE,oCAAA;A5EuniBJ;A4EpniBE;EACE,oCAAA;A5EsniBJ;A4EnniBE;EACE,oCAAA;A5EqniBJ;A4EhniBE;EACE,oCAAA;A5EkniBJ;A4E/miBE;EACE,oCAAA;A5EiniBJ;A4E9miBE;EACE,oCAAA;A5EgniBJ;A4E7miBE;EACE,oCAAA;A5E+miBJ;A4E5miBE;EACE,oCAAA;A5E8miBJ;;A6EzniBM;EACE,oCAAA;A7E4niBR;;A6E7niBM;EACE,yBAAA;A7EgoiBR;;A6EjoiBM;EACE,gCAAA;A7EooiBR;;A6EroiBM;EACE,oCAAA;A7EwoiBR;;A6EzoiBM;EACE,yBAAA;A7E4oiBR;;A6E7oiBM;EACE,gCAAA;A7EgpiBR;;A6EjpiBM;EACE,oCAAA;A7EopiBR;;A6ErpiBM;EACE,yBAAA;A7EwpiBR;;A6EzpiBM;EACE,gCAAA;A7E4piBR;;A6E7piBM;EACE,oCAAA;A7EgqiBR;;A6EjqiBM;EACE,yBAAA;A7EoqiBR;;A6ErqiBM;EACE,gCAAA;A7EwqiBR;;A6EzqiBM;EACE,oCAAA;A7E4qiBR;;A6E7qiBM;EACE,yBAAA;A7EgriBR;;A6EjriBM;EACE,gCAAA;A7EoriBR;;A6ErriBM;EACE,oCAAA;A7EwriBR;;A6EzriBM;EACE,yBAAA;A7E4riBR;;A6E7riBM;EACE,gCAAA;A7EgsiBR;;A6EjsiBM;EACE,oCAAA;A7EosiBR;;A6ErsiBM;EACE,yBAAA;A7EwsiBR;;A6EzsiBM;EACE,gCAAA;A7E4siBR;;A6E7siBM;EACE,oCAAA;A7EgtiBR;;A6EjtiBM;EACE,yBAAA;A7EotiBR;;A6ErtiBM;EACE,gCAAA;A7EwtiBR;;A6EztiBM;EACE,oCAAA;A7E4tiBR;;A6E7tiBM;EACE,yBAAA;A7EguiBR;;A6EjuiBM;EACE,gCAAA;A7EouiBR;;A6EruiBM;EACE,oCAAA;A7EwuiBR;;A6EzuiBM;EACE,yBAAA;A7E4uiBR;;A6E7uiBM;EACE,gCAAA;A7EgviBR;;A6EjviBM;EACE,oCAAA;A7EoviBR;;A6ErviBM;EACE,yBAAA;A7EwviBR;;A6EzviBM;EACE,gCAAA;A7E4viBR;;A6E7viBM;EACE,oCAAA;A7EgwiBR;;A6EjwiBM;EACE,yBAAA;A7EowiBR;;A6ErwiBM;EACE,gCAAA;A7EwwiBR;;A6EzwiBM;EACE,oCAAA;A7E4wiBR;;A6E7wiBM;EACE,yBAAA;A7EgxiBR;;A6EjxiBM;EACE,gCAAA;A7EoxiBR;;A6ErxiBM;EACE,oCAAA;A7EwxiBR;;A6EzxiBM;EACE,yBAAA;A7E4xiBR;;A6E7xiBM;EACE,gCAAA;A7EgyiBR;;A6EjyiBM;EACE,oCAAA;A7EoyiBR;;A6EryiBM;EACE,yBAAA;A7EwyiBR;;A6EzyiBM;EACE,gCAAA;A7E4yiBR;;A6E7yiBM;EACE,oCAAA;A7EgziBR;;A6EjziBM;EACE,yBAAA;A7EoziBR;;A6ErziBM;EACE,gCAAA;A7EwziBR;;A6EzziBM;EACE,oCAAA;A7E4ziBR;;A6E7ziBM;EACE,yBAAA;A7Eg0iBR;;A6Ej0iBM;EACE,gCAAA;A7Eo0iBR;;A6Er0iBM;EACE,oCAAA;A7Ew0iBR;;A6Ez0iBM;EACE,yBAAA;A7E40iBR;;A6E70iBM;EACE,gCAAA;A7Eg1iBR;;A6Ej1iBM;EACE,oCAAA;A7Eo1iBR;;A6Er1iBM;EACE,yBAAA;A7Ew1iBR;;A6Ez1iBM;EACE,gCAAA;A7E41iBR;;A6E71iBM;EACE,oCAAA;A7Eg2iBR;;A6Ej2iBM;EACE,yBAAA;A7Eo2iBR;;A6Er2iBM;EACE,gCAAA;A7Ew2iBR;;A6Ez2iBM;EACE,oDAAA;A7E42iBR;;A6E72iBM;EACE,yCAAA;A7Eg3iBR;;A6Ej3iBM;EACE,gDAAA;A7Eo3iBR;;A6Er3iBM;EACE,oDAAA;A7Ew3iBR;;A6Ez3iBM;EACE,yCAAA;A7E43iBR;;A6E73iBM;EACE,gDAAA;A7Eg4iBR;;A6Ej4iBM;EACE,oDAAA;A7Eo4iBR;;A6Er4iBM;EACE,yCAAA;A7Ew4iBR;;A6Ez4iBM;EACE,gDAAA;A7E44iBR;;A6E74iBM;EACE,oDAAA;A7Eg5iBR;;A6Ej5iBM;EACE,yCAAA;A7Eo5iBR;;A6Er5iBM;EACE,gDAAA;A7Ew5iBR;;A6Ez5iBM;EACE,oDAAA;A7E45iBR;;A6E75iBM;EACE,yCAAA;A7Eg6iBR;;A6Ej6iBM;EACE,gDAAA;A7Eo6iBR;;A6Er6iBM;EACE,mDAAA;A7Ew6iBR;;A6Ez6iBM;EACE,wCAAA;A7E46iBR;;A6E76iBM;EACE,+CAAA;A7Eg7iBR;;A6Ej7iBM;EACE,oDAAA;A7Eo7iBR;;A6Er7iBM;EACE,yCAAA;A7Ew7iBR;;A6Ez7iBM;EACE,gDAAA;A7E47iBR;;A6E77iBM;EACE,oCAAA;A7Eg8iBR;;A6Ej8iBM;EACE,yBAAA;A7Eo8iBR;;A6Er8iBM;EACE,gCAAA;A7Ew8iBR;;A6Ez8iBM;EACE,oCAAA;A7E48iBR;;A6E78iBM;EACE,yBAAA;A7Eg9iBR;;A6Ej9iBM;EACE,gCAAA;A7Eo9iBR;;A6Er9iBM;EACE,kCAAA;A7Ew9iBR;;A6Ez9iBM;EACE,uBAAA;A7E49iBR;;A6E79iBM;EACE,8BAAA;A7Eg+iBR;;A6Ej+iBM;EACE,mDAAA;A7Eo+iBR;;A6Er+iBM;EACE,wCAAA;A7Ew+iBR;;A6Ez+iBM;EACE,+CAAA;A7E4+iBR;;A6E7+iBM;EACE,mDAAA;A7Eg/iBR;;A6Ej/iBM;EACE,wCAAA;A7Eo/iBR;;A6Er/iBM;EACE,+CAAA;A7Ew/iBR;;A6Ez/iBM;EACE,oDAAA;A7E4/iBR;;A6E7/iBM;EACE,yCAAA;A7EggjBR;;A6EjgjBM;EACE,gDAAA;A7EogjBR;;A6ErgjBM;EACE,oDAAA;A7EwgjBR;;A6EzgjBM;EACE,yCAAA;A7E4gjBR;;A6E7gjBM;EACE,gDAAA;A7EghjBR;;A6EjhjBM;EACE,oDAAA;A7EohjBR;;A6ErhjBM;EACE,yCAAA;A7EwhjBR;;A6EzhjBM;EACE,gDAAA;A7E4hjBR;;A6E7hjBM;EACE,oDAAA;A7EgijBR;;A6EjijBM;EACE,yCAAA;A7EoijBR;;A6ErijBM;EACE,gDAAA;A7EwijBR;;A6EzijBM;EACE,oDAAA;A7E4ijBR;;A6E7ijBM;EACE,yCAAA;A7EgjjBR;;A6EjjjBM;EACE,gDAAA;A7EojjBR;;A6ErjjBM;EACE,oDAAA;A7EwjjBR;;A6EzjjBM;EACE,yCAAA;A7E4jjBR;;A6E7jjBM;EACE,gDAAA;A7EgkjBR;;A6EjkjBM;EACE,oDAAA;A7EokjBR;;A6ErkjBM;EACE,yCAAA;A7EwkjBR;;A6EzkjBM;EACE,gDAAA;A7E4kjBR;;A6E7kjBM;EACE,oDAAA;A7EgljBR;;A6EjljBM;EACE,yCAAA;A7EoljBR;;A6ErljBM;EACE,gDAAA;A7EwljBR;;A6EzljBM;EACE,oCAAA;A7E4ljBR;;A6E7ljBM;EACE,yBAAA;A7EgmjBR;;A6EjmjBM;EACE,gCAAA;A7EomjBR;;A6ErmjBM;EACE,oCAAA;A7EwmjBR;;A6EzmjBM;EACE,yBAAA;A7E4mjBR;;A6E7mjBM;EACE,gCAAA;A7EgnjBR;;A6EjnjBM;EACE,oCAAA;A7EonjBR;;A6ErnjBM;EACE,yBAAA;A7EwnjBR;;A6EznjBM;EACE,gCAAA;A7E4njBR;;A6E7njBM;EACE,oCAAA;A7EgojBR;;A6EjojBM;EACE,yBAAA;A7EoojBR;;A6ErojBM;EACE,gCAAA;A7EwojBR;;A6EzojBM;EACE,oCAAA;A7E4ojBR;;A6E7ojBM;EACE,yBAAA;A7EgpjBR;;A6EjpjBM;EACE,gCAAA;A7EopjBR;;A6ErpjBM;EACE,oCAAA;A7EwpjBR;;A6EzpjBM;EACE,yBAAA;A7E4pjBR;;A6E7pjBM;EACE,gCAAA;A7EgqjBR;;A6EjqjBM;EACE,oCAAA;A7EoqjBR;;A6ErqjBM;EACE,yBAAA;A7EwqjBR;;A6EzqjBM;EACE,gCAAA;A7E4qjBR;;A6E7qjBM;EACE,oCAAA;A7EgrjBR;;A6EjrjBM;EACE,yBAAA;A7EorjBR;;A6ErrjBM;EACE,gCAAA;A7EwrjBR;;A6EzrjBM;EACE,oCAAA;A7E4rjBR;;A6E7rjBM;EACE,yBAAA;A7EgsjBR;;A6EjsjBM;EACE,gCAAA;A7EosjBR;;A6ErsjBM;EACE,oCAAA;A7EwsjBR;;A6EzsjBM;EACE,yBAAA;A7E4sjBR;;A6E7sjBM;EACE,gCAAA;A7EgtjBR;;A6EjtjBM;EACE,oCAAA;A7EotjBR;;A6ErtjBM;EACE,yBAAA;A7EwtjBR;;A6EztjBM;EACE,gCAAA;A7E4tjBR;;A6E7tjBM;EACE,oCAAA;A7EgujBR;;A6EjujBM;EACE,yBAAA;A7EoujBR;;A6ErujBM;EACE,gCAAA;A7EwujBR;;A6EzujBM;EACE,oCAAA;A7E4ujBR;;A6E7ujBM;EACE,yBAAA;A7EgvjBR;;A6EjvjBM;EACE,gCAAA;A7EovjBR;;A6ErvjBM;EACE,oCAAA;A7EwvjBR;;A6EzvjBM;EACE,yBAAA;A7E4vjBR;;A6E7vjBM;EACE,gCAAA;A7EgwjBR;;A6EjwjBM;EACE,oCAAA;A7EowjBR;;A6ErwjBM;EACE,yBAAA;A7EwwjBR;;A6EzwjBM;EACE,gCAAA;A7E4wjBR;;A6E7wjBM;EACE,oCAAA;A7EgxjBR;;A6EjxjBM;EACE,yBAAA;A7EoxjBR;;A6ErxjBM;EACE,gCAAA;A7EwxjBR;;A6EzxjBM;EACE,oCAAA;A7E4xjBR;;A6E7xjBM;EACE,yBAAA;A7EgyjBR;;A6EjyjBM;EACE,gCAAA;A7EoyjBR;;A6EryjBM;EACE,oCAAA;A7EwyjBR;;A6EzyjBM;EACE,yBAAA;A7E4yjBR;;A6E7yjBM;EACE,gCAAA;A7EgzjBR;;A6EjzjBM;EACE,oCAAA;A7EozjBR;;A6ErzjBM;EACE,yBAAA;A7EwzjBR;;A6EzzjBM;EACE,gCAAA;A7E4zjBR;;A6E7zjBM;EACE,oCAAA;A7Eg0jBR;;A6Ej0jBM;EACE,yBAAA;A7Eo0jBR;;A6Er0jBM;EACE,gCAAA;A7Ew0jBR;;A6Ez0jBM;EACE,oCAAA;A7E40jBR;;A6E70jBM;EACE,yBAAA;A7Eg1jBR;;A6Ej1jBM;EACE,gCAAA;A7Eo1jBR;;A6Er1jBM;EACE,oCAAA;A7Ew1jBR;;A6Ez1jBM;EACE,yBAAA;A7E41jBR;;A6E71jBM;EACE,gCAAA;A7Eg2jBR;;A6Ej2jBM;EACE,oCAAA;A7Eo2jBR;;A6Er2jBM;EACE,yBAAA;A7Ew2jBR;;A6Ez2jBM;EACE,gCAAA;A7E42jBR;;A6E72jBM;EACE,oCAAA;A7Eg3jBR;;A6Ej3jBM;EACE,yBAAA;A7Eo3jBR;;A6Er3jBM;EACE,gCAAA;A7Ew3jBR;;A6Ez3jBM;EACE,oCAAA;A7E43jBR;;A6E73jBM;EACE,yBAAA;A7Eg4jBR;;A6Ej4jBM;EACE,gCAAA;A7Eo4jBR;;A6Er4jBM;EACE,oCAAA;A7Ew4jBR;;A6Ez4jBM;EACE,yBAAA;A7E44jBR;;A6E74jBM;EACE,gCAAA;A7Eg5jBR;;A6Ej5jBM;EACE,oCAAA;A7Eo5jBR;;A6Er5jBM;EACE,yBAAA;A7Ew5jBR;;A6Ez5jBM;EACE,gCAAA;A7E45jBR;;A6E75jBM;EACE,oCAAA;A7Eg6jBR;;A6Ej6jBM;EACE,yBAAA;A7Eo6jBR;;A6Er6jBM;EACE,gCAAA;A7Ew6jBR;;A6Ez6jBM;EACE,oCAAA;A7E46jBR;;A6E76jBM;EACE,yBAAA;A7Eg7jBR;;A6Ej7jBM;EACE,gCAAA;A7Eo7jBR;;A6Er7jBM;EACE,oCAAA;A7Ew7jBR;;A6Ez7jBM;EACE,yBAAA;A7E47jBR;;A6E77jBM;EACE,gCAAA;A7Eg8jBR;;A6Ej8jBM;EACE,oCAAA;A7Eo8jBR;;A6Er8jBM;EACE,yBAAA;A7Ew8jBR;;A6Ez8jBM;EACE,gCAAA;A7E48jBR;;A6E78jBM;EACE,oCAAA;A7Eg9jBR;;A6Ej9jBM;EACE,yBAAA;A7Eo9jBR;;A6Er9jBM;EACE,gCAAA;A7Ew9jBR;;A6Ez9jBM;EACE,oCAAA;A7E49jBR;;A6E79jBM;EACE,yBAAA;A7Eg+jBR;;A6Ej+jBM;EACE,gCAAA;A7Eo+jBR;;A6Er+jBM;EACE,oCAAA;A7Ew+jBR;;A6Ez+jBM;EACE,yBAAA;A7E4+jBR;;A6E7+jBM;EACE,gCAAA;A7Eg/jBR;;A6Ej/jBM;EACE,oCAAA;A7Eo/jBR;;A6Er/jBM;EACE,yBAAA;A7Ew/jBR;;A6Ez/jBM;EACE,gCAAA;A7E4/jBR;;A6E7/jBM;EACE,oCAAA;A7EggkBR;;A6EjgkBM;EACE,yBAAA;A7EogkBR;;A6ErgkBM;EACE,gCAAA;A7EwgkBR;;A6EzgkBM;EACE,oCAAA;A7E4gkBR;;A6E7gkBM;EACE,yBAAA;A7EghkBR;;A6EjhkBM;EACE,gCAAA;A7EohkBR;;A6ErhkBM;EACE,oCAAA;A7EwhkBR;;A6EzhkBM;EACE,yBAAA;A7E4hkBR;;A6E7hkBM;EACE,gCAAA;A7EgikBR;;A6EjikBM;EACE,oCAAA;A7EoikBR;;A6ErikBM;EACE,yBAAA;A7EwikBR;;A6EzikBM;EACE,gCAAA;A7E4ikBR;;A6E7ikBM;EACE,oCAAA;A7EgjkBR;;A6EjjkBM;EACE,yBAAA;A7EojkBR;;A6ErjkBM;EACE,gCAAA;A7EwjkBR;;A6EzjkBM;EACE,oCAAA;A7E4jkBR;;A6E7jkBM;EACE,yBAAA;A7EgkkBR;;A6EjkkBM;EACE,gCAAA;A7EokkBR;;A6ErkkBM;EACE,oCAAA;A7EwkkBR;;A6EzkkBM;EACE,yBAAA;A7E4kkBR;;A6E7kkBM;EACE,gCAAA;A7EglkBR;;A6EjlkBM;EACE,oCAAA;A7EolkBR;;A6ErlkBM;EACE,yBAAA;A7EwlkBR;;A6EzlkBM;EACE,gCAAA;A7E4lkBR;;A6E7lkBM;EACE,oCAAA;A7EgmkBR;;A6EjmkBM;EACE,yBAAA;A7EomkBR;;A6ErmkBM;EACE,gCAAA;A7EwmkBR;;A6EzmkBM;EACE,oCAAA;A7E4mkBR;;A6E7mkBM;EACE,yBAAA;A7EgnkBR;;A6EjnkBM;EACE,gCAAA;A7EonkBR;;A6ErnkBM;EACE,oCAAA;A7EwnkBR;;A6EznkBM;EACE,yBAAA;A7E4nkBR;;A6E7nkBM;EACE,gCAAA;A7EgokBR;;A6EjokBM;EACE,oCAAA;A7EookBR;;A6ErokBM;EACE,yBAAA;A7EwokBR;;A6EzokBM;EACE,gCAAA;A7E4okBR;;A6E7okBM;EACE,oCAAA;A7EgpkBR;;A6EjpkBM;EACE,yBAAA;A7EopkBR;;A6ErpkBM;EACE,gCAAA;A7EwpkBR;;A6EzpkBM;EACE,oCAAA;A7E4pkBR;;A6E7pkBM;EACE,yBAAA;A7EgqkBR;;A6EjqkBM;EACE,gCAAA;A7EoqkBR;;A6ErqkBM;EACE,oCAAA;A7EwqkBR;;A6EzqkBM;EACE,yBAAA;A7E4qkBR;;A6E7qkBM;EACE,gCAAA;A7EgrkBR;;A6EjrkBM;EACE,oCAAA;A7EorkBR;;A6ErrkBM;EACE,yBAAA;A7EwrkBR;;A6EzrkBM;EACE,gCAAA;A7E4rkBR;;A6E7rkBM;EACE,oCAAA;A7EgskBR;;A6EjskBM;EACE,yBAAA;A7EoskBR;;A6ErskBM;EACE,gCAAA;A7EwskBR;;A6EzskBM;EACE,oCAAA;A7E4skBR;;A6E7skBM;EACE,yBAAA;A7EgtkBR;;A6EjtkBM;EACE,gCAAA;A7EotkBR;;A6ErtkBM;EACE,oCAAA;A7EwtkBR;;A6EztkBM;EACE,yBAAA;A7E4tkBR;;A6E7tkBM;EACE,gCAAA;A7EgukBR;;A6EjukBM;EACE,oCAAA;A7EoukBR;;A6ErukBM;EACE,yBAAA;A7EwukBR;;A6EzukBM;EACE,gCAAA;A7E4ukBR;;A6E7ukBM;EACE,oCAAA;A7EgvkBR;;A6EjvkBM;EACE,yBAAA;A7EovkBR;;A6ErvkBM;EACE,gCAAA;A7EwvkBR;;A6EzvkBM;EACE,oCAAA;A7E4vkBR;;A6E7vkBM;EACE,yBAAA;A7EgwkBR;;A6EjwkBM;EACE,gCAAA;A7EowkBR;;A6ErwkBM;EACE,oCAAA;A7EwwkBR;;A6EzwkBM;EACE,yBAAA;A7E4wkBR;;A6E7wkBM;EACE,gCAAA;A7EgxkBR;;A6EjxkBM;EACE,oCAAA;A7EoxkBR;;A6ErxkBM;EACE,yBAAA;A7EwxkBR;;A6EzxkBM;EACE,gCAAA;A7E4xkBR;;A6E7xkBM;EACE,oCAAA;A7EgykBR;;A6EjykBM;EACE,yBAAA;A7EoykBR;;A6ErykBM;EACE,gCAAA;A7EwykBR;;A6EzykBM;EACE,oCAAA;A7E4ykBR;;A6E7ykBM;EACE,yBAAA;A7EgzkBR;;A6EjzkBM;EACE,gCAAA;A7EozkBR;;A6ErzkBM;EACE,oCAAA;A7EwzkBR;;A6EzzkBM;EACE,yBAAA;A7E4zkBR;;A6E7zkBM;EACE,gCAAA;A7Eg0kBR;;A6Ej0kBM;EACE,oCAAA;A7Eo0kBR;;A6Er0kBM;EACE,yBAAA;A7Ew0kBR;;A6Ez0kBM;EACE,gCAAA;A7E40kBR;;A6E70kBM;EACE,oCAAA;A7Eg1kBR;;A6Ej1kBM;EACE,yBAAA;A7Eo1kBR;;A6Er1kBM;EACE,gCAAA;A7Ew1kBR;;A6Ez1kBM;EACE,oCAAA;A7E41kBR;;A6E71kBM;EACE,yBAAA;A7Eg2kBR;;A6Ej2kBM;EACE,gCAAA;A7Eo2kBR;;A6Er2kBM;EACE,oCAAA;A7Ew2kBR;;A6Ez2kBM;EACE,yBAAA;A7E42kBR;;A6E72kBM;EACE,gCAAA;A7Eg3kBR;;A6Ej3kBM;EACE,oCAAA;A7Eo3kBR;;A6Er3kBM;EACE,yBAAA;A7Ew3kBR;;A6Ez3kBM;EACE,gCAAA;A7E43kBR;;A6E73kBM;EACE,oCAAA;A7Eg4kBR;;A6Ej4kBM;EACE,yBAAA;A7Eo4kBR;;A6Er4kBM;EACE,gCAAA;A7Ew4kBR;;A6Ez4kBM;EACE,oCAAA;A7E44kBR;;A6E74kBM;EACE,yBAAA;A7Eg5kBR;;A6Ej5kBM;EACE,gCAAA;A7Eo5kBR;;A6Er5kBM;EACE,oCAAA;A7Ew5kBR;;A6Ez5kBM;EACE,yBAAA;A7E45kBR;;A6E75kBM;EACE,gCAAA;A7Eg6kBR;;A6Ej6kBM;EACE,oCAAA;A7Eo6kBR;;A6Er6kBM;EACE,yBAAA;A7Ew6kBR;;A6Ez6kBM;EACE,gCAAA;A7E46kBR;;A6E76kBM;EACE,oCAAA;A7Eg7kBR;;A6Ej7kBM;EACE,yBAAA;A7Eo7kBR;;A6Er7kBM;EACE,gCAAA;A7Ew7kBR;;A6Ez7kBM;EACE,oCAAA;A7E47kBR;;A6E77kBM;EACE,yBAAA;A7Eg8kBR;;A6Ej8kBM;EACE,gCAAA;A7Eo8kBR;;A6Er8kBM;EACE,oCAAA;A7Ew8kBR;;A6Ez8kBM;EACE,yBAAA;A7E48kBR;;A6E78kBM;EACE,gCAAA;A7Eg9kBR;;A6Ej9kBM;EACE,oCAAA;A7Eo9kBR;;A6Er9kBM;EACE,yBAAA;A7Ew9kBR;;A6Ez9kBM;EACE,gCAAA;A7E49kBR;;A6E79kBM;EACE,oCAAA;A7Eg+kBR;;A6Ej+kBM;EACE,yBAAA;A7Eo+kBR;;A6Er+kBM;EACE,gCAAA;A7Ew+kBR;;A6Ez+kBM;EACE,oCAAA;A7E4+kBR;;A6E7+kBM;EACE,yBAAA;A7Eg/kBR;;A6Ej/kBM;EACE,gCAAA;A7Eo/kBR;;A6Er/kBM;EACE,oCAAA;A7Ew/kBR;;A6Ez/kBM;EACE,yBAAA;A7E4/kBR;;A6E7/kBM;EACE,gCAAA;A7EgglBR;;A6EjglBM;EACE,oCAAA;A7EoglBR;;A6ErglBM;EACE,yBAAA;A7EwglBR;;A6EzglBM;EACE,gCAAA;A7E4glBR;;A6E7glBM;EACE,oCAAA;A7EghlBR;;A6EjhlBM;EACE,yBAAA;A7EohlBR;;A6ErhlBM;EACE,gCAAA;A7EwhlBR;;A6EzhlBM;EACE,oCAAA;A7E4hlBR;;A6E7hlBM;EACE,yBAAA;A7EgilBR;;A6EjilBM;EACE,gCAAA;A7EoilBR;;A6ErilBM;EACE,oCAAA;A7EwilBR;;A6EzilBM;EACE,yBAAA;A7E4ilBR;;A6E7ilBM;EACE,gCAAA;A7EgjlBR;;A6EjjlBM;EACE,oCAAA;A7EojlBR;;A6ErjlBM;EACE,yBAAA;A7EwjlBR;;A6EzjlBM;EACE,gCAAA;A7E4jlBR;;A6E7jlBM;EACE,oCAAA;A7EgklBR;;A6EjklBM;EACE,yBAAA;A7EoklBR;;A6ErklBM;EACE,gCAAA;A7EwklBR;;A6EzklBM;EACE,oCAAA;A7E4klBR;;A6E7klBM;EACE,yBAAA;A7EgllBR;;A6EjllBM;EACE,gCAAA;A7EollBR;;A6ErllBM;EACE,oCAAA;A7EwllBR;;A6EzllBM;EACE,yBAAA;A7E4llBR;;A6E7llBM;EACE,gCAAA;A7EgmlBR;;A6EjmlBM;EACE,oCAAA;A7EomlBR;;A6ErmlBM;EACE,yBAAA;A7EwmlBR;;A6EzmlBM;EACE,gCAAA;A7E4mlBR;;A6E7mlBM;EACE,oCAAA;A7EgnlBR;;A6EjnlBM;EACE,yBAAA;A7EonlBR;;A6ErnlBM;EACE,gCAAA;A7EwnlBR;;A6EznlBM;EACE,oCAAA;A7E4nlBR;;A6E7nlBM;EACE,yBAAA;A7EgolBR;;A6EjolBM;EACE,gCAAA;A7EoolBR;;A6ErolBM;EACE,oCAAA;A7EwolBR;;A6EzolBM;EACE,yBAAA;A7E4olBR;;A6E7olBM;EACE,gCAAA;A7EgplBR;;A6EjplBM;EACE,oCAAA;A7EoplBR;;A6ErplBM;EACE,yBAAA;A7EwplBR;;A6EzplBM;EACE,gCAAA;A7E4plBR;;A6E7plBM;EACE,oCAAA;A7EgqlBR;;A6EjqlBM;EACE,yBAAA;A7EoqlBR;;A6ErqlBM;EACE,gCAAA;A7EwqlBR;;A6EzqlBM;EACE,oCAAA;A7E4qlBR;;A6E7qlBM;EACE,yBAAA;A7EgrlBR;;A6EjrlBM;EACE,gCAAA;A7EorlBR;;A6ErrlBM;EACE,oCAAA;A7EwrlBR;;A6EzrlBM;EACE,yBAAA;A7E4rlBR;;A6E7rlBM;EACE,gCAAA;A7EgslBR;;A6EjslBM;EACE,oCAAA;A7EoslBR;;A6ErslBM;EACE,yBAAA;A7EwslBR;;A6EzslBM;EACE,gCAAA;A7E4slBR;;A6E7slBM;EACE,oCAAA;A7EgtlBR;;A6EjtlBM;EACE,yBAAA;A7EotlBR;;A6ErtlBM;EACE,gCAAA;A7EwtlBR;;A6EztlBM;EACE,oCAAA;A7E4tlBR;;A6E7tlBM;EACE,yBAAA;A7EgulBR;;A6EjulBM;EACE,gCAAA;A7EoulBR;;A6ErulBM;EACE,oCAAA;A7EwulBR;;A6EzulBM;EACE,yBAAA;A7E4ulBR;;A6E7ulBM;EACE,gCAAA;A7EgvlBR;;A6EjvlBM;EACE,oCAAA;A7EovlBR;;A6ErvlBM;EACE,yBAAA;A7EwvlBR;;A6EzvlBM;EACE,gCAAA;A7E4vlBR;;A6E7vlBM;EACE,oCAAA;A7EgwlBR;;A6EjwlBM;EACE,yBAAA;A7EowlBR;;A6ErwlBM;EACE,gCAAA;A7EwwlBR;;A6EzwlBM;EACE,oCAAA;A7E4wlBR;;A6E7wlBM;EACE,yBAAA;A7EgxlBR;;A6EjxlBM;EACE,gCAAA;A7EoxlBR;;A6ErxlBM;EACE,oCAAA;A7EwxlBR;;A6EzxlBM;EACE,yBAAA;A7E4xlBR;;A6E7xlBM;EACE,gCAAA;A7EgylBR;;A6EjylBM;EACE,oCAAA;A7EoylBR;;A6ErylBM;EACE,yBAAA;A7EwylBR;;A6EzylBM;EACE,gCAAA;A7E4ylBR;;A6E7ylBM;EACE,oCAAA;A7EgzlBR;;A6EjzlBM;EACE,yBAAA;A7EozlBR;;A6ErzlBM;EACE,gCAAA;A7EwzlBR;;A6EzzlBM;EACE,oCAAA;A7E4zlBR;;A6E7zlBM;EACE,yBAAA;A7Eg0lBR;;A6Ej0lBM;EACE,gCAAA;A7Eo0lBR;;A6Er0lBM;EACE,oCAAA;A7Ew0lBR;;A6Ez0lBM;EACE,yBAAA;A7E40lBR;;A6E70lBM;EACE,gCAAA;A7Eg1lBR;;A6Ej1lBM;EACE,oCAAA;A7Eo1lBR;;A6Er1lBM;EACE,yBAAA;A7Ew1lBR;;A6Ez1lBM;EACE,gCAAA;A7E41lBR;;A6E71lBM;EACE,oCAAA;A7Eg2lBR;;A6Ej2lBM;EACE,yBAAA;A7Eo2lBR;;A6Er2lBM;EACE,gCAAA;A7Ew2lBR;;A6Ez2lBM;EACE,oCAAA;A7E42lBR;;A6E72lBM;EACE,yBAAA;A7Eg3lBR;;A6Ej3lBM;EACE,gCAAA;A7Eo3lBR;;A6Er3lBM;EACE,oCAAA;A7Ew3lBR;;A6Ez3lBM;EACE,yBAAA;A7E43lBR;;A6E73lBM;EACE,gCAAA;A7Eg4lBR;;A6Ej4lBM;EACE,oCAAA;A7Eo4lBR;;A6Er4lBM;EACE,yBAAA;A7Ew4lBR;;A6Ez4lBM;EACE,gCAAA;A7E44lBR;;A6E74lBM;EACE,oCAAA;A7Eg5lBR;;A6Ej5lBM;EACE,yBAAA;A7Eo5lBR;;A6Er5lBM;EACE,gCAAA;A7Ew5lBR;;A6Ez5lBM;EACE,oCAAA;A7E45lBR;;A6E75lBM;EACE,yBAAA;A7Eg6lBR;;A6Ej6lBM;EACE,gCAAA;A7Eo6lBR;;A6Er6lBM;EACE,oCAAA;A7Ew6lBR;;A6Ez6lBM;EACE,yBAAA;A7E46lBR;;A6E76lBM;EACE,gCAAA;A7Eg7lBR;;A6Ej7lBM;EACE,oCAAA;A7Eo7lBR;;A6Er7lBM;EACE,yBAAA;A7Ew7lBR;;A6Ez7lBM;EACE,gCAAA;A7E47lBR;;A6E77lBM;EACE,oCAAA;A7Eg8lBR;;A6Ej8lBM;EACE,yBAAA;A7Eo8lBR;;A6Er8lBM;EACE,gCAAA;A7Ew8lBR;;A6Ez8lBM;EACE,oCAAA;A7E48lBR;;A6E78lBM;EACE,yBAAA;A7Eg9lBR;;A6Ej9lBM;EACE,gCAAA;A7Eo9lBR;;A6Er9lBM;EACE,oCAAA;A7Ew9lBR;;A6Ez9lBM;EACE,yBAAA;A7E49lBR;;A6E79lBM;EACE,gCAAA;A7Eg+lBR;;A6Ej+lBM;EACE,oCAAA;A7Eo+lBR;;A6Er+lBM;EACE,yBAAA;A7Ew+lBR;;A6Ez+lBM;EACE,gCAAA;A7E4+lBR;;A6E7+lBM;EACE,oCAAA;A7Eg/lBR;;A6Ej/lBM;EACE,yBAAA;A7Eo/lBR;;A6Er/lBM;EACE,gCAAA;A7Ew/lBR;;A8ExhmBA;;EAEE,0BAAA;EACA,mCAAA;A9E2hmBF;;A8ExhmBA;;EAEE,0BAAA;EACA,mCAAA;A9E2hmBF;;A8ExhmBA;EACE,2CAAA;A9E2hmBF;;A8ExhmBA;EACE,yBAAA;A9E2hmBF;;A8ExhmBA;EACE,iDAAA;A9E2hmBF;;A+EximBA;;;;;EAGE,oBAAA;EACA,mBAAA;A/E6imBF;;A+E1imBA;;;;;ECPE,6FAAA;EDUA,0BAAA;EACA,8BAAA;EACA,4BAAA;EACA,iEAAA;A/EgjmBF;;A+E5imBA;;;;;ECjBE,+EAAA;AhFqkmBF;;A+E9imBA;;EAEE,2BAAA;A/EijmBF;;A+E9imBA;;;;;;;;;EAME,qBAAA;A/EojmBF;;A+E9imBA;EACE,kCAAA;EACA,wCAAA;EACA,wBAAA;EACA,8BAAA;A/EijmBF;;A+E7imBE;EACE,uCAAA;A/EgjmBJ;A+E7imBE;EACE,yBAAA;A/E+imBJ;;A+EximBI;EACE,0CAAA;A/E2imBN;A+EximBI;EAEE,sBAAA;A/EyimBN;;A+EhimBA;EC3EE,+EAAA;AhF+mmBF;A+EjimBE;EACE,8FAAA;A/EmimBJ;;A+E5hmBA;EACE,uCAAA;A/E+hmBF;;A+E5hmBA;EACE,0CAAA;A/E+hmBF;A+E7hmBE;EAEE,sBAAA;A/E8hmBJ;;A+E1hmBA;EACE;IACE,wBAAA;IACA,2BAAA;E/E6hmBF;E+E3hmBA;IACE,uBAAA;IACA,2BAAA;E/E6hmBF;E+E3hmBA;IACE,uBAAA;IACA,0BAAA;E/E6hmBF;E+E3hmBA;IACE,wBAAA;IACA,0BAAA;E/E6hmBF;AACF;AiFxpmBA;EACE,sBAAA;AjF0pmBF;;AiFvpmBA;;EAEE,W/ECM;AFypmBR;;AiFlpmBA;;EAEE,qBAAA;AjFqpmBF;AiFlpmBE;;EACE,sBAAA;AjFqpmBJ;AiFjpmBE;;EACE,qBAAA;AjFopmBJ;;AiF/omBA;EACE,yBAAA;AjFkpmBF;;AiF9omBA;EACE,yBAAA;AjFipmBF;;AiF7omBA;;EAEE,qBAAA;AjFgpmBF;;AiF5omBA;;EAEE,mBAAA;AjF+omBF;;AiF3omBA;EACE,yBAAA;EACA,qBAAA;AjF8omBF;;AiF3omBA;EACE,8L/E2lBiB;AFmjlBnB;;AiFzomBA;EACE,qBAAA;EACA,yBAAA;AjF4omBF;AiF1omBE;EACE,sBAAA;AjF4omBJ;AiFzomBE;EACE,qBAAA;AjF2omBJ;;AiFvomBA;EACE,yBAAA;AjF0omBF;;AiFvomBA;;EAEE,qBAAA;AjF0omBF;;AiFvomBA;;EAEE,qBAAA;AjF0omBF;AiFxomBE;;EACE,sBAAA;AjF2omBJ;AiFxomBE;;EACE,qBAAA;AjF2omBJ;;AiFvomBA;EACE,yBAAA;AjF0omBF;;AiFvomBA;;EAEE,mBAAA;AjF0omBF;;AiFvomBA;EACE,yBAAA;AjF0omBF;;AiFvomBA;;EAEE,qBAAA;AjF0omBF;AiFxomBE;;EACE,sBAAA;AjF2omBJ;AiFxomBE;;EACE,qBAAA;AjF2omBJ;;AiFvomBA;EACE,yBAAA;AjF0omBF;;AiFvomBA;;EAEE,qBAAA;AjF0omBF;;AiFvomBA;EACE,0BAAA;EACA,iBAAA;AjF0omBF;;AiFnomBA;EACE,YAAA;AjFsomBF;;AiFnomBA;EACE,qBAAA;EACA,yBAAA;EACA,UAAA;AjFsomBF;;AiFlomBA;EACE,mBAAA;EACA,gBAAA;AjFqomBF;;AiFlomBA;EACE,oBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;AjFqomBF;;AiFlomBA;;EAEE,gB/EsfkB;E+ErflB,kBAAA;EACA,iBAAA;EACA,sBAAA;AjFqomBF;;AiFlomBA;EACE,oBAAA;EACA,yBAAA;EACA,gBzE4b4B;ARyslB9B;;AiFlomBA;EACE,8BAAA;EACA,cAAA;EACA,gBzEsb4B;AR+slB9B;;AkF1zmBE;;;EAGE,oBAAA;AlF6zmBJ;AkF1zmBE;;;EAGE,kBAAA;AlF4zmBJ;;AmFr0mBE;EACE,gCAAA;AnFw0mBJ;;AiBjwmBM;EACE,SAAA;AjBowmBR;AiBjwmBM;EApCJ,cAAA;EACA,WAAA;AjBwymBF;AiB1xmBE;EACE,cAAA;EACA,WAAA;AjB4xmBJ;AiB9xmBE;EACE,cAAA;EACA,UAAA;AjBgymBJ;AiBlymBE;EACE,cAAA;EACA,mBAAA;AjBoymBJ;AiBtymBE;EACE,cAAA;EACA,UAAA;AjBwymBJ;AiB1ymBE;EACE,cAAA;EACA,UAAA;AjB4ymBJ;AiB9ymBE;EACE,cAAA;EACA,mBAAA;AjBgzmBJ;AiBjxmBM;EAhDJ,cAAA;EACA,WAAA;AjBo0mBF;AiB/wmBU;EAhEN,cAAA;EACA,UAAA;AjBk1mBJ;AiBnxmBU;EAhEN,cAAA;EACA,UAAA;AjBs1mBJ;AiBvxmBU;EAhEN,cAAA;EACA,UAAA;AjB01mBJ;AiB3xmBU;EAhEN,cAAA;EACA,UAAA;AjB81mBJ;AiB/xmBU;EAhEN,cAAA;EACA,WAAA;AjBk2mBJ;AiB3xmBY;EAxDV,gBAAA;AjBs1mBF;AiB9xmBY;EAxDV,gBAAA;AjBy1mBF;AiBjymBY;EAxDV,gBAAA;AjB41mBF;AiBpymBY;EAxDV,gBAAA;AjB+1mBF;AiB5xmBQ;;EAEE,gBAAA;AjB8xmBV;AiB3xmBQ;;EAEE,gBAAA;AjB6xmBV;AiBpymBQ;;EAEE,uBAAA;AjBsymBV;AiBnymBQ;;EAEE,uBAAA;AjBqymBV;AiB5ymBQ;;EAEE,sBAAA;AjB8ymBV;AiB3ymBQ;;EAEE,sBAAA;AjB6ymBV;AiBpzmBQ;;EAEE,qBAAA;AjBszmBV;AiBnzmBQ;;EAEE,qBAAA;AjBqzmBV;AiB5zmBQ;;EAEE,mBAAA;AjB8zmBV;AiB3zmBQ;;EAEE,mBAAA;AjB6zmBV;AiBp0mBQ;;EAEE,qBAAA;AjBs0mBV;AiBn0mBQ;;EAEE,qBAAA;AjBq0mBV;AiB50mBQ;;EAEE,mBAAA;AjB80mBV;AiB30mBQ;;EAEE,mBAAA;AjB60mBV;AiBp1mBQ;;EAEE,qBAAA;AjBs1mBV;AiBn1mBQ;;EAEE,qBAAA;AjBq1mBV;AiB51mBQ;;EAEE,mBAAA;AjB81mBV;AiB31mBQ;;EAEE,mBAAA;AjB61mBV;AiBp2mBQ;;EAEE,qBAAA;AjBs2mBV;AiBn2mBQ;;EAEE,qBAAA;AjBq2mBV;AiB52mBQ;;EAEE,mBAAA;AjB82mBV;AiB32mBQ;;EAEE,mBAAA;AjB62mBV;AiBp3mBQ;;EAEE,mBAAA;AjBs3mBV;AiBn3mBQ;;EAEE,mBAAA;AjBq3mBV;AiB53mBQ;;EAEE,mBAAA;AjB83mBV;AiB33mBQ;;EAEE,mBAAA;AjB63mBV;AiBp4mBQ;;EAEE,qBAAA;AjBs4mBV;AiBn4mBQ;;EAEE,qBAAA;AjBq4mBV;AiB54mBQ;;EAEE,mBAAA;AjB84mBV;AiB34mBQ;;EAEE,mBAAA;AjB64mBV;AGv8mBI;EcUE;IACE,SAAA;EjBg8mBN;EiB77mBI;IApCJ,cAAA;IACA,WAAA;EjBo+mBA;EiBt9mBA;IACE,cAAA;IACA,WAAA;EjBw9mBF;EiB19mBA;IACE,cAAA;IACA,UAAA;EjB49mBF;EiB99mBA;IACE,cAAA;IACA,mBAAA;EjBg+mBF;EiBl+mBA;IACE,cAAA;IACA,UAAA;EjBo+mBF;EiBt+mBA;IACE,cAAA;IACA,UAAA;EjBw+mBF;EiB1+mBA;IACE,cAAA;IACA,mBAAA;EjB4+mBF;EiB78mBI;IAhDJ,cAAA;IACA,WAAA;EjBggnBA;EiB38mBQ;IAhEN,cAAA;IACA,UAAA;EjB8gnBF;EiB/8mBQ;IAhEN,cAAA;IACA,UAAA;EjBkhnBF;EiBn9mBQ;IAhEN,cAAA;IACA,UAAA;EjBshnBF;EiBv9mBQ;IAhEN,cAAA;IACA,UAAA;EjB0hnBF;EiB39mBQ;IAhEN,cAAA;IACA,WAAA;EjB8hnBF;EiBv9mBU;IAxDV,cAAA;EjBkhnBA;EiB19mBU;IAxDV,gBAAA;EjBqhnBA;EiB79mBU;IAxDV,gBAAA;EjBwhnBA;EiBh+mBU;IAxDV,gBAAA;EjB2hnBA;EiBn+mBU;IAxDV,gBAAA;EjB8hnBA;EiB39mBM;;IAEE,gBAAA;EjB69mBR;EiB19mBM;;IAEE,gBAAA;EjB49mBR;EiBn+mBM;;IAEE,uBAAA;EjBq+mBR;EiBl+mBM;;IAEE,uBAAA;EjBo+mBR;EiB3+mBM;;IAEE,sBAAA;EjB6+mBR;EiB1+mBM;;IAEE,sBAAA;EjB4+mBR;EiBn/mBM;;IAEE,qBAAA;EjBq/mBR;EiBl/mBM;;IAEE,qBAAA;EjBo/mBR;EiB3/mBM;;IAEE,mBAAA;EjB6/mBR;EiB1/mBM;;IAEE,mBAAA;EjB4/mBR;EiBngnBM;;IAEE,qBAAA;EjBqgnBR;EiBlgnBM;;IAEE,qBAAA;EjBognBR;EiB3gnBM;;IAEE,mBAAA;EjB6gnBR;EiB1gnBM;;IAEE,mBAAA;EjB4gnBR;EiBnhnBM;;IAEE,qBAAA;EjBqhnBR;EiBlhnBM;;IAEE,qBAAA;EjBohnBR;EiB3hnBM;;IAEE,mBAAA;EjB6hnBR;EiB1hnBM;;IAEE,mBAAA;EjB4hnBR;EiBninBM;;IAEE,qBAAA;EjBqinBR;EiBlinBM;;IAEE,qBAAA;EjBoinBR;EiB3inBM;;IAEE,mBAAA;EjB6inBR;EiB1inBM;;IAEE,mBAAA;EjB4inBR;EiBnjnBM;;IAEE,mBAAA;EjBqjnBR;EiBljnBM;;IAEE,mBAAA;EjBojnBR;EiB3jnBM;;IAEE,mBAAA;EjB6jnBR;EiB1jnBM;;IAEE,mBAAA;EjB4jnBR;EiBnknBM;;IAEE,qBAAA;EjBqknBR;EiBlknBM;;IAEE,qBAAA;EjBoknBR;EiB3knBM;;IAEE,mBAAA;EjB6knBR;EiB1knBM;;IAEE,mBAAA;EjB4knBR;AACF;AGvonBI;EcUE;IACE,SAAA;EjBgonBN;EiB7nnBI;IApCJ,cAAA;IACA,WAAA;EjBoqnBA;EiBtpnBA;IACE,cAAA;IACA,WAAA;EjBwpnBF;EiB1pnBA;IACE,cAAA;IACA,UAAA;EjB4pnBF;EiB9pnBA;IACE,cAAA;IACA,mBAAA;EjBgqnBF;EiBlqnBA;IACE,cAAA;IACA,UAAA;EjBoqnBF;EiBtqnBA;IACE,cAAA;IACA,UAAA;EjBwqnBF;EiB1qnBA;IACE,cAAA;IACA,mBAAA;EjB4qnBF;EiB7onBI;IAhDJ,cAAA;IACA,WAAA;EjBgsnBA;EiB3onBQ;IAhEN,cAAA;IACA,UAAA;EjB8snBF;EiB/onBQ;IAhEN,cAAA;IACA,UAAA;EjBktnBF;EiBnpnBQ;IAhEN,cAAA;IACA,UAAA;EjBstnBF;EiBvpnBQ;IAhEN,cAAA;IACA,UAAA;EjB0tnBF;EiB3pnBQ;IAhEN,cAAA;IACA,WAAA;EjB8tnBF;EiBvpnBU;IAxDV,cAAA;EjBktnBA;EiB1pnBU;IAxDV,gBAAA;EjBqtnBA;EiB7pnBU;IAxDV,gBAAA;EjBwtnBA;EiBhqnBU;IAxDV,gBAAA;EjB2tnBA;EiBnqnBU;IAxDV,gBAAA;EjB8tnBA;EiB3pnBM;;IAEE,gBAAA;EjB6pnBR;EiB1pnBM;;IAEE,gBAAA;EjB4pnBR;EiBnqnBM;;IAEE,uBAAA;EjBqqnBR;EiBlqnBM;;IAEE,uBAAA;EjBoqnBR;EiB3qnBM;;IAEE,sBAAA;EjB6qnBR;EiB1qnBM;;IAEE,sBAAA;EjB4qnBR;EiBnrnBM;;IAEE,qBAAA;EjBqrnBR;EiBlrnBM;;IAEE,qBAAA;EjBornBR;EiB3rnBM;;IAEE,mBAAA;EjB6rnBR;EiB1rnBM;;IAEE,mBAAA;EjB4rnBR;EiBnsnBM;;IAEE,qBAAA;EjBqsnBR;EiBlsnBM;;IAEE,qBAAA;EjBosnBR;EiB3snBM;;IAEE,mBAAA;EjB6snBR;EiB1snBM;;IAEE,mBAAA;EjB4snBR;EiBntnBM;;IAEE,qBAAA;EjBqtnBR;EiBltnBM;;IAEE,qBAAA;EjBotnBR;EiB3tnBM;;IAEE,mBAAA;EjB6tnBR;EiB1tnBM;;IAEE,mBAAA;EjB4tnBR;EiBnunBM;;IAEE,qBAAA;EjBqunBR;EiBlunBM;;IAEE,qBAAA;EjBounBR;EiB3unBM;;IAEE,mBAAA;EjB6unBR;EiB1unBM;;IAEE,mBAAA;EjB4unBR;EiBnvnBM;;IAEE,mBAAA;EjBqvnBR;EiBlvnBM;;IAEE,mBAAA;EjBovnBR;EiB3vnBM;;IAEE,mBAAA;EjB6vnBR;EiB1vnBM;;IAEE,mBAAA;EjB4vnBR;EiBnwnBM;;IAEE,qBAAA;EjBqwnBR;EiBlwnBM;;IAEE,qBAAA;EjBownBR;EiB3wnBM;;IAEE,mBAAA;EjB6wnBR;EiB1wnBM;;IAEE,mBAAA;EjB4wnBR;AACF;AGv0nBI;EcUE;IACE,SAAA;EjBg0nBN;EiB7znBI;IApCJ,cAAA;IACA,WAAA;EjBo2nBA;EiBt1nBA;IACE,cAAA;IACA,WAAA;EjBw1nBF;EiB11nBA;IACE,cAAA;IACA,UAAA;EjB41nBF;EiB91nBA;IACE,cAAA;IACA,mBAAA;EjBg2nBF;EiBl2nBA;IACE,cAAA;IACA,UAAA;EjBo2nBF;EiBt2nBA;IACE,cAAA;IACA,UAAA;EjBw2nBF;EiB12nBA;IACE,cAAA;IACA,mBAAA;EjB42nBF;EiB70nBI;IAhDJ,cAAA;IACA,WAAA;EjBg4nBA;EiB30nBQ;IAhEN,cAAA;IACA,UAAA;EjB84nBF;EiB/0nBQ;IAhEN,cAAA;IACA,UAAA;EjBk5nBF;EiBn1nBQ;IAhEN,cAAA;IACA,UAAA;EjBs5nBF;EiBv1nBQ;IAhEN,cAAA;IACA,UAAA;EjB05nBF;EiB31nBQ;IAhEN,cAAA;IACA,WAAA;EjB85nBF;EiBv1nBU;IAxDV,cAAA;EjBk5nBA;EiB11nBU;IAxDV,gBAAA;EjBq5nBA;EiB71nBU;IAxDV,gBAAA;EjBw5nBA;EiBh2nBU;IAxDV,gBAAA;EjB25nBA;EiBn2nBU;IAxDV,gBAAA;EjB85nBA;EiB31nBM;;IAEE,gBAAA;EjB61nBR;EiB11nBM;;IAEE,gBAAA;EjB41nBR;EiBn2nBM;;IAEE,uBAAA;EjBq2nBR;EiBl2nBM;;IAEE,uBAAA;EjBo2nBR;EiB32nBM;;IAEE,sBAAA;EjB62nBR;EiB12nBM;;IAEE,sBAAA;EjB42nBR;EiBn3nBM;;IAEE,qBAAA;EjBq3nBR;EiBl3nBM;;IAEE,qBAAA;EjBo3nBR;EiB33nBM;;IAEE,mBAAA;EjB63nBR;EiB13nBM;;IAEE,mBAAA;EjB43nBR;EiBn4nBM;;IAEE,qBAAA;EjBq4nBR;EiBl4nBM;;IAEE,qBAAA;EjBo4nBR;EiB34nBM;;IAEE,mBAAA;EjB64nBR;EiB14nBM;;IAEE,mBAAA;EjB44nBR;EiBn5nBM;;IAEE,qBAAA;EjBq5nBR;EiBl5nBM;;IAEE,qBAAA;EjBo5nBR;EiB35nBM;;IAEE,mBAAA;EjB65nBR;EiB15nBM;;IAEE,mBAAA;EjB45nBR;EiBn6nBM;;IAEE,qBAAA;EjBq6nBR;EiBl6nBM;;IAEE,qBAAA;EjBo6nBR;EiB36nBM;;IAEE,mBAAA;EjB66nBR;EiB16nBM;;IAEE,mBAAA;EjB46nBR;EiBn7nBM;;IAEE,mBAAA;EjBq7nBR;EiBl7nBM;;IAEE,mBAAA;EjBo7nBR;EiB37nBM;;IAEE,mBAAA;EjB67nBR;EiB17nBM;;IAEE,mBAAA;EjB47nBR;EiBn8nBM;;IAEE,qBAAA;EjBq8nBR;EiBl8nBM;;IAEE,qBAAA;EjBo8nBR;EiB38nBM;;IAEE,mBAAA;EjB68nBR;EiB18nBM;;IAEE,mBAAA;EjB48nBR;AACF;AGvgoBI;EcUE;IACE,SAAA;EjBggoBN;EiB7/nBI;IApCJ,cAAA;IACA,WAAA;EjBoioBA;EiBthoBA;IACE,cAAA;IACA,WAAA;EjBwhoBF;EiB1hoBA;IACE,cAAA;IACA,UAAA;EjB4hoBF;EiB9hoBA;IACE,cAAA;IACA,mBAAA;EjBgioBF;EiBlioBA;IACE,cAAA;IACA,UAAA;EjBoioBF;EiBtioBA;IACE,cAAA;IACA,UAAA;EjBwioBF;EiB1ioBA;IACE,cAAA;IACA,mBAAA;EjB4ioBF;EiB7goBI;IAhDJ,cAAA;IACA,WAAA;EjBgkoBA;EiB3goBQ;IAhEN,cAAA;IACA,UAAA;EjB8koBF;EiB/goBQ;IAhEN,cAAA;IACA,UAAA;EjBkloBF;EiBnhoBQ;IAhEN,cAAA;IACA,UAAA;EjBsloBF;EiBvhoBQ;IAhEN,cAAA;IACA,UAAA;EjB0loBF;EiB3hoBQ;IAhEN,cAAA;IACA,WAAA;EjB8loBF;EiBvhoBU;IAxDV,cAAA;EjBkloBA;EiB1hoBU;IAxDV,gBAAA;EjBqloBA;EiB7hoBU;IAxDV,gBAAA;EjBwloBA;EiBhioBU;IAxDV,gBAAA;EjB2loBA;EiBnioBU;IAxDV,gBAAA;EjB8loBA;EiB3hoBM;;IAEE,gBAAA;EjB6hoBR;EiB1hoBM;;IAEE,gBAAA;EjB4hoBR;EiBnioBM;;IAEE,uBAAA;EjBqioBR;EiBlioBM;;IAEE,uBAAA;EjBoioBR;EiB3ioBM;;IAEE,sBAAA;EjB6ioBR;EiB1ioBM;;IAEE,sBAAA;EjB4ioBR;EiBnjoBM;;IAEE,qBAAA;EjBqjoBR;EiBljoBM;;IAEE,qBAAA;EjBojoBR;EiB3joBM;;IAEE,mBAAA;EjB6joBR;EiB1joBM;;IAEE,mBAAA;EjB4joBR;EiBnkoBM;;IAEE,qBAAA;EjBqkoBR;EiBlkoBM;;IAEE,qBAAA;EjBokoBR;EiB3koBM;;IAEE,mBAAA;EjB6koBR;EiB1koBM;;IAEE,mBAAA;EjB4koBR;EiBnloBM;;IAEE,qBAAA;EjBqloBR;EiBlloBM;;IAEE,qBAAA;EjBoloBR;EiB3loBM;;IAEE,mBAAA;EjB6loBR;EiB1loBM;;IAEE,mBAAA;EjB4loBR;EiBnmoBM;;IAEE,qBAAA;EjBqmoBR;EiBlmoBM;;IAEE,qBAAA;EjBomoBR;EiB3moBM;;IAEE,mBAAA;EjB6moBR;EiB1moBM;;IAEE,mBAAA;EjB4moBR;EiBnnoBM;;IAEE,mBAAA;EjBqnoBR;EiBlnoBM;;IAEE,mBAAA;EjBonoBR;EiB3noBM;;IAEE,mBAAA;EjB6noBR;EiB1noBM;;IAEE,mBAAA;EjB4noBR;EiBnooBM;;IAEE,qBAAA;EjBqooBR;EiBlooBM;;IAEE,qBAAA;EjBoooBR;EiB3ooBM;;IAEE,mBAAA;EjB6ooBR;EiB1ooBM;;IAEE,mBAAA;EjB4ooBR;AACF;AGvsoBI;EcUE;IACE,SAAA;EjBgsoBN;EiB7roBI;IApCJ,cAAA;IACA,WAAA;EjBouoBA;EiBttoBA;IACE,cAAA;IACA,WAAA;EjBwtoBF;EiB1toBA;IACE,cAAA;IACA,UAAA;EjB4toBF;EiB9toBA;IACE,cAAA;IACA,mBAAA;EjBguoBF;EiBluoBA;IACE,cAAA;IACA,UAAA;EjBouoBF;EiBtuoBA;IACE,cAAA;IACA,UAAA;EjBwuoBF;EiB1uoBA;IACE,cAAA;IACA,mBAAA;EjB4uoBF;EiB7soBI;IAhDJ,cAAA;IACA,WAAA;EjBgwoBA;EiB3soBQ;IAhEN,cAAA;IACA,UAAA;EjB8woBF;EiB/soBQ;IAhEN,cAAA;IACA,UAAA;EjBkxoBF;EiBntoBQ;IAhEN,cAAA;IACA,UAAA;EjBsxoBF;EiBvtoBQ;IAhEN,cAAA;IACA,UAAA;EjB0xoBF;EiB3toBQ;IAhEN,cAAA;IACA,WAAA;EjB8xoBF;EiBvtoBU;IAxDV,cAAA;EjBkxoBA;EiB1toBU;IAxDV,gBAAA;EjBqxoBA;EiB7toBU;IAxDV,gBAAA;EjBwxoBA;EiBhuoBU;IAxDV,gBAAA;EjB2xoBA;EiBnuoBU;IAxDV,gBAAA;EjB8xoBA;EiB3toBM;;IAEE,gBAAA;EjB6toBR;EiB1toBM;;IAEE,gBAAA;EjB4toBR;EiBnuoBM;;IAEE,uBAAA;EjBquoBR;EiBluoBM;;IAEE,uBAAA;EjBouoBR;EiB3uoBM;;IAEE,sBAAA;EjB6uoBR;EiB1uoBM;;IAEE,sBAAA;EjB4uoBR;EiBnvoBM;;IAEE,qBAAA;EjBqvoBR;EiBlvoBM;;IAEE,qBAAA;EjBovoBR;EiB3voBM;;IAEE,mBAAA;EjB6voBR;EiB1voBM;;IAEE,mBAAA;EjB4voBR;EiBnwoBM;;IAEE,qBAAA;EjBqwoBR;EiBlwoBM;;IAEE,qBAAA;EjBowoBR;EiB3woBM;;IAEE,mBAAA;EjB6woBR;EiB1woBM;;IAEE,mBAAA;EjB4woBR;EiBnxoBM;;IAEE,qBAAA;EjBqxoBR;EiBlxoBM;;IAEE,qBAAA;EjBoxoBR;EiB3xoBM;;IAEE,mBAAA;EjB6xoBR;EiB1xoBM;;IAEE,mBAAA;EjB4xoBR;EiBnyoBM;;IAEE,qBAAA;EjBqyoBR;EiBlyoBM;;IAEE,qBAAA;EjBoyoBR;EiB3yoBM;;IAEE,mBAAA;EjB6yoBR;EiB1yoBM;;IAEE,mBAAA;EjB4yoBR;EiBnzoBM;;IAEE,mBAAA;EjBqzoBR;EiBlzoBM;;IAEE,mBAAA;EjBozoBR;EiB3zoBM;;IAEE,mBAAA;EjB6zoBR;EiB1zoBM;;IAEE,mBAAA;EjB4zoBR;EiBn0oBM;;IAEE,qBAAA;EjBq0oBR;EiBl0oBM;;IAEE,qBAAA;EjBo0oBR;EiB30oBM;;IAEE,mBAAA;EjB60oBR;EiB10oBM;;IAEE,mBAAA;EjB40oBR;AACF;;AoF57oBQ;;EAEE,0BAAA;ApF+7oBV;;AoF77oBQ;;EAEE,yBAAA;ApFg8oBV;;AoFt8oBQ;;EAEE,kCAAA;ApFy8oBV;;AoFv8oBQ;;EAEE,iCAAA;ApF08oBV;;AoFh9oBQ;;EAEE,iCAAA;ApFm9oBV;;AoFj9oBQ;;EAEE,gCAAA;ApFo9oBV;;AoF19oBQ;;EAEE,kCAAA;ApF69oBV;;AoF39oBQ;;EAEE,iCAAA;ApF89oBV;;AoFp+oBQ;;EAEE,kCAAA;ApFu+oBV;;AoFr+oBQ;;EAEE,iCAAA;ApFw+oBV;;AoF9+oBQ;;EAEE,iCAAA;ApFi/oBV;;AoF/+oBQ;;EAEE,gCAAA;ApFk/oBV;;AoFx/oBQ;;EAEE,+BAAA;ApF2/oBV;;AoFz/oBQ;;EAEE,8BAAA;ApF4/oBV;;AoFlgpBQ;;EAEE,kCAAA;ApFqgpBV;;AoFngpBQ;;EAEE,iCAAA;ApFsgpBV;;AoF5gpBQ;;EAEE,gCAAA;ApF+gpBV;;AoF7gpBQ;;EAEE,+BAAA;ApFghpBV;;AoFthpBQ;;EAEE,2BAAA;ApFyhpBV;;AoFvhpBQ;;EAEE,0BAAA;ApF0hpBV;;AoFhipBQ;;EAEE,mCAAA;ApFmipBV;;AoFjipBQ;;EAEE,kCAAA;ApFoipBV;;AoF1ipBQ;;EAEE,kCAAA;ApF6ipBV;;AoF3ipBQ;;EAEE,iCAAA;ApF8ipBV;;AoFpjpBQ;;EAEE,mCAAA;ApFujpBV;;AoFrjpBQ;;EAEE,kCAAA;ApFwjpBV;;AoF9jpBQ;;EAEE,mCAAA;ApFikpBV;;AoF/jpBQ;;EAEE,kCAAA;ApFkkpBV;;AoFxkpBQ;;EAEE,kCAAA;ApF2kpBV;;AoFzkpBQ;;EAEE,iCAAA;ApF4kpBV;;AoFllpBQ;;EAEE,gCAAA;ApFqlpBV;;AoFnlpBQ;;EAEE,+BAAA;ApFslpBV;;AoF5lpBQ;;EAEE,mCAAA;ApF+lpBV;;AoF7lpBQ;;EAEE,kCAAA;ApFgmpBV;;AoFtmpBQ;;EAEE,iCAAA;ApFympBV;;AoFvmpBQ;;EAEE,gCAAA;ApF0mpBV;;AoFlmpBQ;;EAEE,mCAAA;ApFqmpBV;;AoFnmpBQ;;EAEE,kCAAA;ApFsmpBV;;AoF5mpBQ;;EAEE,kCAAA;ApF+mpBV;;AoF7mpBQ;;EAEE,iCAAA;ApFgnpBV;;AoFtnpBQ;;EAEE,mCAAA;ApFynpBV;;AoFvnpBQ;;EAEE,kCAAA;ApF0npBV;;AoFhopBQ;;EAEE,mCAAA;ApFmopBV;;AoFjopBQ;;EAEE,kCAAA;ApFoopBV;;AoF1opBQ;;EAEE,kCAAA;ApF6opBV;;AoF3opBQ;;EAEE,iCAAA;ApF8opBV;;AoFpppBQ;;EAEE,gCAAA;ApFuppBV;;AoFrppBQ;;EAEE,+BAAA;ApFwppBV;;AoF9ppBQ;;EAEE,mCAAA;ApFiqpBV;;AoF/ppBQ;;EAEE,kCAAA;ApFkqpBV;;AoFxqpBQ;;EAEE,iCAAA;ApF2qpBV;;AoFzqpBQ;;EAEE,gCAAA;ApF4qpBV;;AG3opBI;EiFrDI;;IAEE,0BAAA;EpFospBR;EoFlspBM;;IAEE,yBAAA;EpFospBR;EoF1spBM;;IAEE,kCAAA;EpF4spBR;EoF1spBM;;IAEE,iCAAA;EpF4spBR;EoFltpBM;;IAEE,iCAAA;EpFotpBR;EoFltpBM;;IAEE,gCAAA;EpFotpBR;EoF1tpBM;;IAEE,kCAAA;EpF4tpBR;EoF1tpBM;;IAEE,iCAAA;EpF4tpBR;EoFlupBM;;IAEE,kCAAA;EpFoupBR;EoFlupBM;;IAEE,iCAAA;EpFoupBR;EoF1upBM;;IAEE,iCAAA;EpF4upBR;EoF1upBM;;IAEE,gCAAA;EpF4upBR;EoFlvpBM;;IAEE,+BAAA;EpFovpBR;EoFlvpBM;;IAEE,8BAAA;EpFovpBR;EoF1vpBM;;IAEE,kCAAA;EpF4vpBR;EoF1vpBM;;IAEE,iCAAA;EpF4vpBR;EoFlwpBM;;IAEE,gCAAA;EpFowpBR;EoFlwpBM;;IAEE,+BAAA;EpFowpBR;EoF1wpBM;;IAEE,2BAAA;EpF4wpBR;EoF1wpBM;;IAEE,0BAAA;EpF4wpBR;EoFlxpBM;;IAEE,mCAAA;EpFoxpBR;EoFlxpBM;;IAEE,kCAAA;EpFoxpBR;EoF1xpBM;;IAEE,kCAAA;EpF4xpBR;EoF1xpBM;;IAEE,iCAAA;EpF4xpBR;EoFlypBM;;IAEE,mCAAA;EpFoypBR;EoFlypBM;;IAEE,kCAAA;EpFoypBR;EoF1ypBM;;IAEE,mCAAA;EpF4ypBR;EoF1ypBM;;IAEE,kCAAA;EpF4ypBR;EoFlzpBM;;IAEE,kCAAA;EpFozpBR;EoFlzpBM;;IAEE,iCAAA;EpFozpBR;EoF1zpBM;;IAEE,gCAAA;EpF4zpBR;EoF1zpBM;;IAEE,+BAAA;EpF4zpBR;EoFl0pBM;;IAEE,mCAAA;EpFo0pBR;EoFl0pBM;;IAEE,kCAAA;EpFo0pBR;EoF10pBM;;IAEE,iCAAA;EpF40pBR;EoF10pBM;;IAEE,gCAAA;EpF40pBR;EoFp0pBM;;IAEE,mCAAA;EpFs0pBR;EoFp0pBM;;IAEE,kCAAA;EpFs0pBR;EoF50pBM;;IAEE,kCAAA;EpF80pBR;EoF50pBM;;IAEE,iCAAA;EpF80pBR;EoFp1pBM;;IAEE,mCAAA;EpFs1pBR;EoFp1pBM;;IAEE,kCAAA;EpFs1pBR;EoF51pBM;;IAEE,mCAAA;EpF81pBR;EoF51pBM;;IAEE,kCAAA;EpF81pBR;EoFp2pBM;;IAEE,kCAAA;EpFs2pBR;EoFp2pBM;;IAEE,iCAAA;EpFs2pBR;EoF52pBM;;IAEE,gCAAA;EpF82pBR;EoF52pBM;;IAEE,+BAAA;EpF82pBR;EoFp3pBM;;IAEE,mCAAA;EpFs3pBR;EoFp3pBM;;IAEE,kCAAA;EpFs3pBR;EoF53pBM;;IAEE,iCAAA;EpF83pBR;EoF53pBM;;IAEE,gCAAA;EpF83pBR;AACF;AG91pBI;EiFrDI;;IAEE,0BAAA;EpFs5pBR;EoFp5pBM;;IAEE,yBAAA;EpFs5pBR;EoF55pBM;;IAEE,kCAAA;EpF85pBR;EoF55pBM;;IAEE,iCAAA;EpF85pBR;EoFp6pBM;;IAEE,iCAAA;EpFs6pBR;EoFp6pBM;;IAEE,gCAAA;EpFs6pBR;EoF56pBM;;IAEE,kCAAA;EpF86pBR;EoF56pBM;;IAEE,iCAAA;EpF86pBR;EoFp7pBM;;IAEE,kCAAA;EpFs7pBR;EoFp7pBM;;IAEE,iCAAA;EpFs7pBR;EoF57pBM;;IAEE,iCAAA;EpF87pBR;EoF57pBM;;IAEE,gCAAA;EpF87pBR;EoFp8pBM;;IAEE,+BAAA;EpFs8pBR;EoFp8pBM;;IAEE,8BAAA;EpFs8pBR;EoF58pBM;;IAEE,kCAAA;EpF88pBR;EoF58pBM;;IAEE,iCAAA;EpF88pBR;EoFp9pBM;;IAEE,gCAAA;EpFs9pBR;EoFp9pBM;;IAEE,+BAAA;EpFs9pBR;EoF59pBM;;IAEE,2BAAA;EpF89pBR;EoF59pBM;;IAEE,0BAAA;EpF89pBR;EoFp+pBM;;IAEE,mCAAA;EpFs+pBR;EoFp+pBM;;IAEE,kCAAA;EpFs+pBR;EoF5+pBM;;IAEE,kCAAA;EpF8+pBR;EoF5+pBM;;IAEE,iCAAA;EpF8+pBR;EoFp/pBM;;IAEE,mCAAA;EpFs/pBR;EoFp/pBM;;IAEE,kCAAA;EpFs/pBR;EoF5/pBM;;IAEE,mCAAA;EpF8/pBR;EoF5/pBM;;IAEE,kCAAA;EpF8/pBR;EoFpgqBM;;IAEE,kCAAA;EpFsgqBR;EoFpgqBM;;IAEE,iCAAA;EpFsgqBR;EoF5gqBM;;IAEE,gCAAA;EpF8gqBR;EoF5gqBM;;IAEE,+BAAA;EpF8gqBR;EoFphqBM;;IAEE,mCAAA;EpFshqBR;EoFphqBM;;IAEE,kCAAA;EpFshqBR;EoF5hqBM;;IAEE,iCAAA;EpF8hqBR;EoF5hqBM;;IAEE,gCAAA;EpF8hqBR;EoFthqBM;;IAEE,mCAAA;EpFwhqBR;EoFthqBM;;IAEE,kCAAA;EpFwhqBR;EoF9hqBM;;IAEE,kCAAA;EpFgiqBR;EoF9hqBM;;IAEE,iCAAA;EpFgiqBR;EoFtiqBM;;IAEE,mCAAA;EpFwiqBR;EoFtiqBM;;IAEE,kCAAA;EpFwiqBR;EoF9iqBM;;IAEE,mCAAA;EpFgjqBR;EoF9iqBM;;IAEE,kCAAA;EpFgjqBR;EoFtjqBM;;IAEE,kCAAA;EpFwjqBR;EoFtjqBM;;IAEE,iCAAA;EpFwjqBR;EoF9jqBM;;IAEE,gCAAA;EpFgkqBR;EoF9jqBM;;IAEE,+BAAA;EpFgkqBR;EoFtkqBM;;IAEE,mCAAA;EpFwkqBR;EoFtkqBM;;IAEE,kCAAA;EpFwkqBR;EoF9kqBM;;IAEE,iCAAA;EpFglqBR;EoF9kqBM;;IAEE,gCAAA;EpFglqBR;AACF;AGhjqBI;EiFrDI;;IAEE,0BAAA;EpFwmqBR;EoFtmqBM;;IAEE,yBAAA;EpFwmqBR;EoF9mqBM;;IAEE,kCAAA;EpFgnqBR;EoF9mqBM;;IAEE,iCAAA;EpFgnqBR;EoFtnqBM;;IAEE,iCAAA;EpFwnqBR;EoFtnqBM;;IAEE,gCAAA;EpFwnqBR;EoF9nqBM;;IAEE,kCAAA;EpFgoqBR;EoF9nqBM;;IAEE,iCAAA;EpFgoqBR;EoFtoqBM;;IAEE,kCAAA;EpFwoqBR;EoFtoqBM;;IAEE,iCAAA;EpFwoqBR;EoF9oqBM;;IAEE,iCAAA;EpFgpqBR;EoF9oqBM;;IAEE,gCAAA;EpFgpqBR;EoFtpqBM;;IAEE,+BAAA;EpFwpqBR;EoFtpqBM;;IAEE,8BAAA;EpFwpqBR;EoF9pqBM;;IAEE,kCAAA;EpFgqqBR;EoF9pqBM;;IAEE,iCAAA;EpFgqqBR;EoFtqqBM;;IAEE,gCAAA;EpFwqqBR;EoFtqqBM;;IAEE,+BAAA;EpFwqqBR;EoF9qqBM;;IAEE,2BAAA;EpFgrqBR;EoF9qqBM;;IAEE,0BAAA;EpFgrqBR;EoFtrqBM;;IAEE,mCAAA;EpFwrqBR;EoFtrqBM;;IAEE,kCAAA;EpFwrqBR;EoF9rqBM;;IAEE,kCAAA;EpFgsqBR;EoF9rqBM;;IAEE,iCAAA;EpFgsqBR;EoFtsqBM;;IAEE,mCAAA;EpFwsqBR;EoFtsqBM;;IAEE,kCAAA;EpFwsqBR;EoF9sqBM;;IAEE,mCAAA;EpFgtqBR;EoF9sqBM;;IAEE,kCAAA;EpFgtqBR;EoFttqBM;;IAEE,kCAAA;EpFwtqBR;EoFttqBM;;IAEE,iCAAA;EpFwtqBR;EoF9tqBM;;IAEE,gCAAA;EpFguqBR;EoF9tqBM;;IAEE,+BAAA;EpFguqBR;EoFtuqBM;;IAEE,mCAAA;EpFwuqBR;EoFtuqBM;;IAEE,kCAAA;EpFwuqBR;EoF9uqBM;;IAEE,iCAAA;EpFgvqBR;EoF9uqBM;;IAEE,gCAAA;EpFgvqBR;EoFxuqBM;;IAEE,mCAAA;EpF0uqBR;EoFxuqBM;;IAEE,kCAAA;EpF0uqBR;EoFhvqBM;;IAEE,kCAAA;EpFkvqBR;EoFhvqBM;;IAEE,iCAAA;EpFkvqBR;EoFxvqBM;;IAEE,mCAAA;EpF0vqBR;EoFxvqBM;;IAEE,kCAAA;EpF0vqBR;EoFhwqBM;;IAEE,mCAAA;EpFkwqBR;EoFhwqBM;;IAEE,kCAAA;EpFkwqBR;EoFxwqBM;;IAEE,kCAAA;EpF0wqBR;EoFxwqBM;;IAEE,iCAAA;EpF0wqBR;EoFhxqBM;;IAEE,gCAAA;EpFkxqBR;EoFhxqBM;;IAEE,+BAAA;EpFkxqBR;EoFxxqBM;;IAEE,mCAAA;EpF0xqBR;EoFxxqBM;;IAEE,kCAAA;EpF0xqBR;EoFhyqBM;;IAEE,iCAAA;EpFkyqBR;EoFhyqBM;;IAEE,gCAAA;EpFkyqBR;AACF;AGlwqBI;EiFrDI;;IAEE,0BAAA;EpF0zqBR;EoFxzqBM;;IAEE,yBAAA;EpF0zqBR;EoFh0qBM;;IAEE,kCAAA;EpFk0qBR;EoFh0qBM;;IAEE,iCAAA;EpFk0qBR;EoFx0qBM;;IAEE,iCAAA;EpF00qBR;EoFx0qBM;;IAEE,gCAAA;EpF00qBR;EoFh1qBM;;IAEE,kCAAA;EpFk1qBR;EoFh1qBM;;IAEE,iCAAA;EpFk1qBR;EoFx1qBM;;IAEE,kCAAA;EpF01qBR;EoFx1qBM;;IAEE,iCAAA;EpF01qBR;EoFh2qBM;;IAEE,iCAAA;EpFk2qBR;EoFh2qBM;;IAEE,gCAAA;EpFk2qBR;EoFx2qBM;;IAEE,+BAAA;EpF02qBR;EoFx2qBM;;IAEE,8BAAA;EpF02qBR;EoFh3qBM;;IAEE,kCAAA;EpFk3qBR;EoFh3qBM;;IAEE,iCAAA;EpFk3qBR;EoFx3qBM;;IAEE,gCAAA;EpF03qBR;EoFx3qBM;;IAEE,+BAAA;EpF03qBR;EoFh4qBM;;IAEE,2BAAA;EpFk4qBR;EoFh4qBM;;IAEE,0BAAA;EpFk4qBR;EoFx4qBM;;IAEE,mCAAA;EpF04qBR;EoFx4qBM;;IAEE,kCAAA;EpF04qBR;EoFh5qBM;;IAEE,kCAAA;EpFk5qBR;EoFh5qBM;;IAEE,iCAAA;EpFk5qBR;EoFx5qBM;;IAEE,mCAAA;EpF05qBR;EoFx5qBM;;IAEE,kCAAA;EpF05qBR;EoFh6qBM;;IAEE,mCAAA;EpFk6qBR;EoFh6qBM;;IAEE,kCAAA;EpFk6qBR;EoFx6qBM;;IAEE,kCAAA;EpF06qBR;EoFx6qBM;;IAEE,iCAAA;EpF06qBR;EoFh7qBM;;IAEE,gCAAA;EpFk7qBR;EoFh7qBM;;IAEE,+BAAA;EpFk7qBR;EoFx7qBM;;IAEE,mCAAA;EpF07qBR;EoFx7qBM;;IAEE,kCAAA;EpF07qBR;EoFh8qBM;;IAEE,iCAAA;EpFk8qBR;EoFh8qBM;;IAEE,gCAAA;EpFk8qBR;EoF17qBM;;IAEE,mCAAA;EpF47qBR;EoF17qBM;;IAEE,kCAAA;EpF47qBR;EoFl8qBM;;IAEE,kCAAA;EpFo8qBR;EoFl8qBM;;IAEE,iCAAA;EpFo8qBR;EoF18qBM;;IAEE,mCAAA;EpF48qBR;EoF18qBM;;IAEE,kCAAA;EpF48qBR;EoFl9qBM;;IAEE,mCAAA;EpFo9qBR;EoFl9qBM;;IAEE,kCAAA;EpFo9qBR;EoF19qBM;;IAEE,kCAAA;EpF49qBR;EoF19qBM;;IAEE,iCAAA;EpF49qBR;EoFl+qBM;;IAEE,gCAAA;EpFo+qBR;EoFl+qBM;;IAEE,+BAAA;EpFo+qBR;EoF1+qBM;;IAEE,mCAAA;EpF4+qBR;EoF1+qBM;;IAEE,kCAAA;EpF4+qBR;EoFl/qBM;;IAEE,iCAAA;EpFo/qBR;EoFl/qBM;;IAEE,gCAAA;EpFo/qBR;AACF;AGp9qBI;EiFrDI;;IAEE,0BAAA;EpF4grBR;EoF1grBM;;IAEE,yBAAA;EpF4grBR;EoFlhrBM;;IAEE,kCAAA;EpFohrBR;EoFlhrBM;;IAEE,iCAAA;EpFohrBR;EoF1hrBM;;IAEE,iCAAA;EpF4hrBR;EoF1hrBM;;IAEE,gCAAA;EpF4hrBR;EoFlirBM;;IAEE,kCAAA;EpFoirBR;EoFlirBM;;IAEE,iCAAA;EpFoirBR;EoF1irBM;;IAEE,kCAAA;EpF4irBR;EoF1irBM;;IAEE,iCAAA;EpF4irBR;EoFljrBM;;IAEE,iCAAA;EpFojrBR;EoFljrBM;;IAEE,gCAAA;EpFojrBR;EoF1jrBM;;IAEE,+BAAA;EpF4jrBR;EoF1jrBM;;IAEE,8BAAA;EpF4jrBR;EoFlkrBM;;IAEE,kCAAA;EpFokrBR;EoFlkrBM;;IAEE,iCAAA;EpFokrBR;EoF1krBM;;IAEE,gCAAA;EpF4krBR;EoF1krBM;;IAEE,+BAAA;EpF4krBR;EoFllrBM;;IAEE,2BAAA;EpFolrBR;EoFllrBM;;IAEE,0BAAA;EpFolrBR;EoF1lrBM;;IAEE,mCAAA;EpF4lrBR;EoF1lrBM;;IAEE,kCAAA;EpF4lrBR;EoFlmrBM;;IAEE,kCAAA;EpFomrBR;EoFlmrBM;;IAEE,iCAAA;EpFomrBR;EoF1mrBM;;IAEE,mCAAA;EpF4mrBR;EoF1mrBM;;IAEE,kCAAA;EpF4mrBR;EoFlnrBM;;IAEE,mCAAA;EpFonrBR;EoFlnrBM;;IAEE,kCAAA;EpFonrBR;EoF1nrBM;;IAEE,kCAAA;EpF4nrBR;EoF1nrBM;;IAEE,iCAAA;EpF4nrBR;EoFlorBM;;IAEE,gCAAA;EpFoorBR;EoFlorBM;;IAEE,+BAAA;EpFoorBR;EoF1orBM;;IAEE,mCAAA;EpF4orBR;EoF1orBM;;IAEE,kCAAA;EpF4orBR;EoFlprBM;;IAEE,iCAAA;EpFoprBR;EoFlprBM;;IAEE,gCAAA;EpFoprBR;EoF5orBM;;IAEE,mCAAA;EpF8orBR;EoF5orBM;;IAEE,kCAAA;EpF8orBR;EoFpprBM;;IAEE,kCAAA;EpFsprBR;EoFpprBM;;IAEE,iCAAA;EpFsprBR;EoF5prBM;;IAEE,mCAAA;EpF8prBR;EoF5prBM;;IAEE,kCAAA;EpF8prBR;EoFpqrBM;;IAEE,mCAAA;EpFsqrBR;EoFpqrBM;;IAEE,kCAAA;EpFsqrBR;EoF5qrBM;;IAEE,kCAAA;EpF8qrBR;EoF5qrBM;;IAEE,iCAAA;EpF8qrBR;EoFprrBM;;IAEE,gCAAA;EpFsrrBR;EoFprrBM;;IAEE,+BAAA;EpFsrrBR;EoF5rrBM;;IAEE,mCAAA;EpF8rrBR;EoF5rrBM;;IAEE,kCAAA;EpF8rrBR;EoFpsrBM;;IAEE,iCAAA;EpFssrBR;EoFpsrBM;;IAEE,gCAAA;EpFssrBR;AACF;AqFpurBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;ArFsurBF;;AqFhurBA;EACE,kBAAA;ArFmurBF;AqFjurBE;EAEE,WAAA;EACA,UAAA;ArFkurBJ;AqF9trBE;EACE,UAAA;EACA,kBAAA;ArFgurBJ;;AqFxtrBA;EACE,0BAAA;EACA,2BAAA;EACA,sBAAA;EACA,yCAAA;EACA,wBAAA;ArF2trBF;AqFztrBE;EACE,+KAAA;ArF2trBJ;;AqFntrBA;EACE,2BAAA;EACA,sBAAA;ArFstrBF;AqFptrBE;EACE,oEAAA;ArFstrBJ;;AqFpsrBE;EACE,yBAAA;ArFusrBJ;;AqFxsrBE;EACE,wBAAA;ArF2srBJ;;AqF5srBE;EACE,0BAAA;ArF+srBJ;;AqFhtrBE;EACE,uBAAA;ArFmtrBJ;;AqFptrBE;EACE,gCAAA;ArFutrBJ;;AqFxtrBE;EACE,+BAAA;ArF2trBJ;;AqF5trBE;EACE,4BAAA;ArF+trBJ;;AqFhurBE;EACE,6BAAA;ArFmurBJ;;AqFrtrBE;EACE,2BAAA;ArFwtrBJ;;AqFztrBE;EACE,4BAAA;ArF4trBJ;;AqF7trBE;EACE,yBAAA;ArFgurBJ;;AqFjurBE;EACE,8BAAA;ArFourBJ;;AqF7trBE;EACE,oBAAA;ArFgurBJ;;AqFjurBE;EACE,sBAAA;ArFourBJ;;AqFrurBE;EACE,sBAAA;ArFwurBJ;;AqFzurBE;EACE,sBAAA;ArF4urBJ;;AqF7urBE;EACE,sBAAA;ArFgvrBJ;;AqFjvrBE;EACE,sBAAA;ArFovrBJ;;AqFrvrBE;EACE,sBAAA;ArFwvrBJ;;AqFzvrBE;EACE,sBAAA;ArF4vrBJ;;AqF7vrBE;EACE,sBAAA;ArFgwrBJ;;AqFjwrBE;EACE,sBAAA;ArFowrBJ;;AqF3vrBE;E7DhFA,gGAAA;AxB+0rBF;;AqF1vrBA;EACE,8BAAA;ArF6vrBF;AqF3vrBE;EACE,wBAAA;ArF6vrBJ;;AsFx2rBE;;;;EAEE,kD9EwqDyB;ARqsoB7B;;AsFv2rBA;EACE,gBAAA;EACA,cpFCc;EoFAd,UAAA;EACA,Y9E0pD2B;E8EzpD3B,6BAAA;AtF02rBF;AsFv2rBE;EACE,cpFNY;EoFOZ,qBAAA;EACA,YpF2kDsB;AF8xoB1B;AsFt2rBE;EACE,UAAA;EACA,gBAAA;AtFw2rBJ;AsFr2rBE;EACE,qBpFoOY;AFmorBhB;AsFp2rBE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,a9EsoDyB;AR+toB7B;;AsFh2rBE;EACE,WpFxCI;AF24rBR;;AuFl5rBA;EACE,yBAAA;EACA,8BAAA;EAEA,gBrFypBkB;EqFxpBlB,aAAA;AvFo5rBF;AuFj5rBE;EACE,iCAAA;EACA,cAAA;EACA,oCAAA;AvFm5rBJ;AuFh5rBE;EACE,YAAA;AvFk5rBJ;AuFh5rBI;EACE,gBAAA;AvFk5rBN;AuF94rBE;EPdA,iGAAA;AhF+5rBF;AuF94rBI;EPjBF,qEAAA;AhFk6rBF;;AuF34rBA;;EAEE,YAAA;AvF84rBF;;AuF34rBA;EACE,mBAAA;EACA,yBAAA;EACA,qBAAA;AvF84rBF;;AuF34rBA;EAEE,wBAAA;AvF64rBF;AuF34rBE;EP7CA,cO8CkB;EP7ClB,eO6CkB;EAChB,+BAAA;EACA,qCAAA;EACA,YAAA;AvF84rBJ;AuF54rBI;EAEE,gBAAA;EACA,UAAA;AvF64rBN;;AuFt4rBA;EACE,yBAAA;AvFy4rBF;AuFv4rBE;EAEE,wBAAA;AvFw4rBJ;AuFr4rBE;EACE,aAAA;EACA,kBAAA;AvFu4rBJ;AuFn4rBE;EP3EA,WO4EkB;EP3ElB,YO2EkB;EAChB,qBAAA;AvFs4rBJ;;AuFh4rBA;EACE,8BAAA;AvFm4rBF;;AuFh4rBA;EACE,8BAAA;AvFm4rBF;;AuFh4rBA;EACE,8BAAA;AvFm4rBF;;AuFh4rBA;EACE,8BAAA;AvFm4rBF;;AuFh4rBA;EACE,sBAAA;EACA,gCAAA;AvFm4rBF;;AuF73rBE;EACE,UAAA;AvFg4rBJ;;AuF53rBA;EACE,sBAAA;AvF+3rBF;;AuF53rBA;EACE,sBAAA;AvF+3rBF;;AuF53rBA;EACE,sBAAA;AvF+3rBF;;AuF53rBA;EACE,sBAAA;AvF+3rBF;;AuF53rBA;EACE,qCAAA;AvF+3rBF;;AuFz3rBE;EACE,sBAAA;EACA,sBAAA;EACA,2BAAA;AvF43rBJ;AuFz3rBM;EPtIJ,uGAAA;AhFkgsBF;AuFz3rBQ;EPzIN,+DAAA;AhFqgsBF;AuFr3rBE;EACE,8BAAA;AvFu3rBJ;AuFp3rBE;EACE,8BAAA;AvFs3rBJ;AuFn3rBE;EACE,8BAAA;AvFq3rBJ;AuFl3rBE;EACE,8BAAA;AvFo3rBJ;AuFj3rBE;EACE,gCAAA;EACA,sBAAA;AvFm3rBJ;AuF92rBE;EACE,yBAAA;EACA,8BAAA;AvFg3rBJ;AuF72rBE;EACE,sBAAA;AvF+2rBJ;AuF52rBE;EACE,sBAAA;AvF82rBJ;AuF32rBE;EACE,sBAAA;AvF62rBJ;AuF12rBE;EACE,sBAAA;AvF42rBJ;AuFz2rBE;EACE,sBAAA;EACA,sBAAA;EACA,2BAAA;AvF22rBJ;AuFz2rBI;EACE,kD/Es+CuB;ARq4oB7B;AuFx2rBI;EPrMF,uGAAA;AhFgjsBF;AuFx2rBM;EPxMJ,+DAAA;AhFmjsBF;;AwF3jsBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,6BAAA;EACA,wDAAA;EACA,qGAAA;AxF8jsBF;AwF3jsBE;EACE,ctFKY;AFwjsBhB;;AwFvjsBA;EACE,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,gCAAA;EACA,mCAAA;AxF0jsBF;AwFxjsBE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,6BAAA;EACA,8CAAA;AxF0jsBJ;;AwFtjsBA;EACE,uBAAA;AxFyjsBF;;AwFtjsBA;EACE,sBAAA;AxFyjsBF;;AwFpjsBA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AxFujsBF;;AwFljsBA;EACE,iCAAA;EACA,oCAAA;EACA,qCAAA;EAEA,4CAAA;EACA,mCAAA;EACA,oCAAA;EACA,mDAAA;EACA,qCAAA;EACA,kDAAA;EAGA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;EAGA,YAAA;EACA,6BAAA;EACA,UAAA;EACA,yBAAA;UAAA,iBAAA;EACA,0CAAA;AxFgjsBF;AwF7isBI;EACE,eAAA;AxF+isBN;;AwFxisBI;EACE,kGAAA;AxF2isBN;AwFvisBI;EACE,sCAAA;AxFyisBN;AwFvisBM;EACE,kDAAA;AxFyisBR;AwFrisBI;EACE,YAAA;AxFuisBN;AwFhisBI;;EACE,mGAAA;AxFmisBN;AwF/hsBI;;EACE,uCAAA;AxFkisBN;AwFhisBM;;EACE,mDAAA;AxFmisBR;AwF/hsBI;;EACE,YAAA;AxFkisBN;AwF9hsBE;EACE,UAAA;AxFgisBJ;AwF9hsBI;EACE,yEAAA;AxFgisBN;AwF7hsBI;EACE,sCAAA;AxF+hsBN;AwF7hsBM;EACE,yBtF2HQ;AFo6rBhB;AwF3hsBI;EACE,aAAA;AxF6hsBN;;AwFthsBA;EACE,oCAAA;EACA,6CAAA;EACA,qCAAA;EACA,8CAAA;EACA,0CAAA;EACA,wDAAA;EACA,yCAAA;EACA,qCAAA;EACA,mDAAA;EACA,yCAAA;EACA,0DAAA;EACA,6CAAA;EACA,oDAAA;EACA,wDAAA;EACA,sDAAA;EACA,0DAAA;EACA,+CAAA;EAEA,qDAAA;EACA,wBtFocc;EsFncd,6BAAA;EACA,kBAAA;EACA,8EAAA;AxFwhsBF;AwFthsBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AxFwhsBJ;AwFrhsBE;EACE,sBAAA;AxFuhsBJ;AwFphsBE;EACE,uBAAA;AxFshsBJ;AwFnhsBE;EACE,oBAAA;AxFqhsBJ;AwFjhsBI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AxFmhsBN;AwFhhsBI;EACE,6BAAA;AxFkhsBN;AwF/gsBI;EACE,6BAAA;AxFihsBN;AwF9gsBI;EACE,uBAAA;AxFghsBN;AwF7gsBI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AxF+gsBN;AwF3gsBE;EACE,kBAAA;AxF6gsBJ;AwF3gsBI;EACE,8BAAA;AxF6gsBN;AwF1gsBI;EACE,8BAAA;AxF4gsBN;AwFzgsBI;EACE,uBAAA;AxF2gsBN;AwFxgsBI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;EACA,uBAAA;AxF0gsBN;AwFpgsBI;EACE,eAAA;AxFsgsBN;AwFhgsBI;EACE,aAAA;AxFkgsBN;AwF9/rBE;EACE,2DAAA;AxFggsBJ;AwF9/rBI;EACE,iEAAA;EACA,2CAAA;AxFggsBN;AwF7/rBI;EACE,2CAAA;AxF+/rBN;AwF3/rBM;EACE,gHAAA;AxF6/rBR;AwF1/rBM;EACE,gEAAA;EACA,wEAAA;EACA,kDAAA;AxF4/rBR;AwFx/rBI;EACE,2CAAA;AxF0/rBN;AwFt/rBE;;EAGE,4DAAA;AxFu/rBJ;AwFr/rBI;;EACE,kEAAA;EACA,4CAAA;AxFw/rBN;AwFr/rBI;;EACE,4CAAA;AxFw/rBN;AwFr/rBI;;EACE,4CAAA;AxFw/rBN;AwFp/rBE;EACE,qBtF/CY;AFqisBhB;;AwF/+rBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;AxFk/rBJ;AwF/+rBE;EACE,kBAAA;EACA,mBAAA;AxFi/rBJ;;AwF5+rBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AxF++rBJ;AwF5+rBE;EACE,kBAAA;EACA,mBAAA;AxF8+rBJ;AwF3+rBE;EACE,mBAAA;EACA,yBAAA;AxF6+rBJ;AwF1+rBE;EACE,uBAAA;AxF4+rBJ;AwFz+rBE;EACE,sBAAA;AxF2+rBJ;AwFx+rBE;EACE,sBAAA;EACA,wBAAA;AxF0+rBJ;;AwFr+rBE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;AxFw+rBJ;AwFr+rBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AxFu+rBJ;AwFp+rBE;EACE,oBAAA;EACA,yBAAA;AxFs+rBJ;AwFn+rBE;EACE,uBAAA;AxFq+rBJ;AwFl+rBE;EACE,sBAAA;AxFo+rBJ;AwFj+rBE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;AxFm+rBJ;;AwF79rBA;EACE,yBtFpKgB;AFoosBlB;AwF99rBE;;EAEE,ctF/Je;AF+nsBnB;;AwF59rBA;EACE,yBtFzYc;EsF0Yd,gCAAA;AxF+9rBF;AwF79rBE;EACE,WtFvZI;AFs3sBR;;AwF39rBA;EACE,yBtF7KiB;EsF8KjB,gCAAA;AxF89rBF;AwF59rBE;EACE,WtFhaI;AF83sBR;;AwFx9rBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,yBtFnac;EsFoad,WtF9aM;EsF+aN,2CAAA;EACA,oBAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,uGAAA;AxF29rBF;AwFv9rBE;EACE,sBAAA;AxFy9rBJ;;AwFn9rBA;EACE,WAAA;EACA,YAAA;EACA,yBtFvC8B;EsFwC9B,2CAAA;EACA,iCAAA;EACA,kBAAA;EACA,mBAAA;AxFs9rBF;AwFn9rBE;EACE,sBAAA;AxFq9rBJ;;AwF98rBE;EACE,yBtF1cY;EsF2cZ,gCAAA;AxFi9rBJ;AwF/8rBI;EACE,+BAAA;AxFi9rBN;AwF38rBE;EACE,WtF7dI;AF06sBR;AwF18rBE;EACE,oCAAA;EACA,oCAAA;EACA,qCAAA;EAEA,+CAAA;EACA,gCAAA;EACA,oCAAA;EACA,sDAAA;EACA,qCAAA;EACA,qDAAA;AxF28rBJ;AwFx8rBE;EACE,uCAAA;EACA,0CAAA;EACA,wCAAA;EACA,8CAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EACA,wCAAA;EACA,mDAAA;EACA,yCAAA;EACA,uDAAA;EACA,gDAAA;EACA,oDAAA;EACA,2DAAA;EACA,mDAAA;EACA,0DAAA;EACA,4CAAA;AxF08rBJ;AwFr8rBE;EACE,yBtFrRe;AF4tsBnB;AwFp8rBE;EACE,yBtF3ea;EsF4eb,6BAAA;AxFs8rBJ;AwFp8rBI;EACE,ctFlgBU;AFw8sBhB;AwFl8rBE;EACE,yBAAA;AxFo8rBJ;AwFl8rBI;;EAEE,ctFtSa;AF0usBnB;AwF97rBE;EACE,sBtF5hBI;EsF6hBJ,qBtFnhBY;EsFohBZ,ctFphBY;AFo9sBhB;;AyFr+sBA;EACE,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,6BAAA;AzFw+sBF;AyFt+sBE;EACE,oBAAA;AzFw+sBJ;AyFr+sBE;EACE,wBAAA;AzFu+sBJ;;AyF79sBE;;;;;;;;;;;EACE,gBvFqoBgB;EuFpoBhB,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;AzF0+sBJ;;AyFr+sBE;EACE,gBjFykB0B;EiFxkB1B,wBAAA;AzFw+sBJ;;AyFn+sBE;EACE,oCAAA;AzFs+sBJ;AyFn+sBE;EACE,oDAAA;EACA,iCAAA;AzFq+sBJ;AyFl+sBE;EACE,2DAAA;EACA,sDAAA;AzFo+sBJ;AyFj+sBE;EACE,0DAAA;EACA,qDAAA;AzFm+sBJ;AyFh+sBE;EACE,2DAAA;EACA,sDAAA;AzFk+sBJ;AyF/9sBE;EACE,2DAAA;EACA,sDAAA;AzFi+sBJ;AyF99sBE;EACE,wDAAA;EACA,mDAAA;AzFg+sBJ;AyF79sBE;EACE,gCAAA;AzF+9sBJ;;AgFjhtBM;;;ESuDJ,2BAAA;EACA,2BAAA;EACA,kCAAA;EACA,gDAAA;EACA,oDAAA;EACA,+CAAA;EACA,sDAAA;EACA,gDAAA;EACA,sDAAA;EACA,gDAAA;EACA,gDAAA;EACA,6CAAA;EACA,6BAAA;AzFg+sBF;;AgF7htBM;;ESiEJ,2BAAA;EACA,8BAAA;EACA,kCAAA;EACA,4CAAA;EACA,iCAAA;EACA,2CAAA;EACA,kCAAA;EACA,4CAAA;EACA,kCAAA;EACA,4CAAA;EACA,+BAAA;EACA,yCAAA;EACA,0BAAA;AzFi+sBF;;A0F5ktBA;EAEE,oBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,cxFQc;EwFPd,gBAAA;A1F8ktBF;;A0F3ktBA;EACE,mBAAA;EACA,sCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;A1F8ktBF;;A0F3ktBA;EACE,6BAAA;EACA,6BAAA;A1F8ktBF;A0F5ktBE;EACE,eAAA;A1F8ktBJ;;A0FzktBA;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;A1F4ktBF;;A0FpktBA;;EAEE,0BAAA;EACA,mBxFoX4B;AFmtsB9B;;A0FpktBA;;EAEE,0BAAA;EACA,mBxFoXyB;AFmtsB3B;;A0FpktBA;;EAEE,0BAAA;EACA,mBxFoX4B;AFmtsB9B;;A0FpktBA;;EAEE,0BAAA;EACA,mBxFoX2B;AFmtsB7B;;A0FpktBA;EACE,mBxFjCe;AFwmtBjB;;A0FlktBA;EACE,qBxF8W6B;AFutsB/B;;A0FlktBA;EACE,qBxFgX0B;AFqtsB5B;;A0FlktBA;EACE,qBxFkX6B;AFmtsB/B;;A0FlktBA;EACE,qBxFoX4B;AFitsB9B;;A0FlktBA;EACE,qBxFtDe;AF2ntBjB;;A0FhktBA;EACE,mBxFwV6B;AF2usB/B;;A0FhktBA;EACE,mBxF0V0B;AFyusB5B;;A0FhktBA;EACE,mBxF4V6B;AFuusB/B;;A0FhktBA;EACE,mBxF8V4B;AFqusB9B;;A0FhktBA;EACE,mBxFjGc;EwFkGd,WxF5GM;AF+qtBR;;A0F7jtBE;;;;;;;;;;EAUE,yBxFpHY;EwFqHZ,WxF7HI;AF6rtBR;A0F7jtBE;;EAEE,0BAAA;EACA,qBAAA;A1F+jtBJ;A0F5jtBE;;EAEE,0BAAA;EACA,qBAAA;A1F8jtBJ;A0F3jtBE;;EAEE,0BAAA;EACA,qBAAA;A1F6jtBJ;A0F1jtBE;;EAEE,0BAAA;EACA,qBAAA;A1F4jtBJ;A0FzjtBE;;EAEE,qBxFvHa;AFkrtBjB;A0FtjtBE;EACE,mBAAA;A1FwjtBJ;A0FrjtBE;EACE,mBAAA;A1FujtBJ;A0FpjtBE;EACE,mBAAA;A1FsjtBJ;A0FnjtBE;EACE,mBAAA;A1FqjtBJ;A0FljtBE;EACE,mBxFrJY;EwFsJZ,cxFvKY;AF2ttBhB;;A2F5utBA;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,2CAAA;EACA,qBAAA;EACA,oBAAA;EACA,czFSc;EyFRd,yBzF4Be;AFmttBjB;;A2F5utBA;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,2CAAA;EACA,czFNc;AFqvtBhB;;A2F5utBA;EACE,yBzFVc;EyFWd,WzFrBM;AFowtBR;;A2F5utBA;EACE,yBzFfc;EyFgBd,WzF1BM;AFywtBR;A2F7utBE;EACE,yBzFCa;EyFAb,czFpBY;AFmwtBhB;;A2F1utBE;EACE,yBzF5BY;EyF6BZ,WzFrCI;AFkxtBR;A2F3utBI;EACE,yBzFVW;EyFWX,czF/BU;AF4wtBhB;A2FzutBE;EACE,yBzFnBY;EyFoBZ,czFrCY;AFgxtBhB;A2FzutBI;EACE,yBzFxCU;EyFyCV,WzFnDE;AF8xtBR;;A4FrytBA;EACE,mBAAA;A5FwytBF;A4FtytBE;EAEE,aAAA;EACA,mBAAA;EACA,c1FUY;E0FTZ,aAAA;A5FuytBJ;A4FrytBI;EACE,UAAA;A5FuytBN;A4FlytBE;EACE,sBAAA;A5FoytBJ;;A4F/xtBA;EACE,aAAA;EACA,mBAAA;A5FkytBF;;A4F/xtBA;EACE,4BAAA;EACA,oDAAA;A5FkytBF;A4FhytBE;EACE,eAAA;EACA,cAAA;A5FkytBJ;;A4F7xtBE;EACE,2DAAA;A5FgytBJ;A4F9xtBI;EACE,iEAAA;A5FgytBN;A4F7xtBI;;EAEE,W1FxCE;AFu0tBR;A4F3xtBE;EACE,uDAAA;A5F6xtBJ;;A6Fh1tBE;EACE,mBAAA;EACA,oBAAA;A7Fm1tBJ;A6Fh1tBE;EACE,qBAAA;A7Fk1tBJ;A6F/0tBE;EAEE,mBAAA;EACA,mBAAA;A7Fg1tBJ;;A6F50tBA;E7D+CE,4BAAA;EACA,6BAAA;E1B8NI,2BALI;E0BvNR,iCAAA;E6D1CA,qBAAA;EACA,sB3FgvBmB;AF4lsBrB;;A6Fz0tBA;;EAEE,mB3FsuBmB;AFsmsBrB;;A6Fz0tBA;;EAGE,oB3FstBmB;AFqnsBrB;;A6Fx0tBA;E7DwBE,4BAAA;EACA,4BAAA;E1B8NI,wBALI;E0BvNR,iCAAA;E6DnBA,qB3FssBmB;E2FrsBnB,sBAAA;A7Fw0tBF;;A6Fj0tBE;EACE,YAAA;EACA,8DAAA;EACA,+BAAA;A7Fo0tBJ;A6Fh0tBI;EACE,YAAA;A7Fk0tBN;A6F5ztBI;EACE,YAAA;A7F8ztBN;;A6FtztBE;EACE,sBAAA;EACA,sBAAA;A7FyztBJ;;A6FtztBE;EACE,qBAAA;EACA,uBAAA;A7FyztBJ;;A6Fh0tBE;EACE,oBAAA;EACA,sBAAA;A7Fm0tBJ;A6Fh0tBE;EACE,mBAAA;EACA,uBAAA;A7Fk0tBJ;;A6Fz0tBE;EACE,oBAAA;EACA,uBAAA;A7F40tBJ;A6Fz0tBE;EACE,mBAAA;EACA,wBAAA;A7F20tBJ;;A6Fl1tBE;EACE,oBAAA;EACA,oBAAA;A7Fq1tBJ;A6Fl1tBE;EACE,mBAAA;EACA,qBAAA;A7Fo1tBJ;;A6F31tBE;EACE,sBAAA;EACA,uBAAA;A7F81tBJ;A6F31tBE;EACE,qBAAA;EACA,wBAAA;A7F61tBJ;;A6Fp0tBE;;;EACE,cAAA;A7Fy0tBJ;A6Ft0tBE;;;EACE,eAAA;A7F00tBJ;;A6Fh0tBA;EACE,qBAAA;EACA,kBAAA;Eb/HA,a9Eg1Ba;E8E/0Bb,c9E+0Ba;AFonsBf;A6Fj0tBE;EbnIA,e9Eq1BgB;E8Ep1BhB,gB9Eo1BgB;AFmnsBlB;A6Fj0tBE;EbvIA,e9Ek1BgB;E8Ej1BhB,gB9Ei1BgB;AF0nsBlB;A6Fh0tBE;Eb5IA,c9Ei1BgB;E8Eh1BhB,e9Eg1BgB;AF+nsBlB;A6F/ztBE;EbjJA,gB9Es1BgB;E8Er1BhB,iB9Eq1BgB;AF8nsBlB;;A6F7ztBA;;;;EAIE,c3F3Ic;AF28tBhB;A6F9ztBE;;;;EACE,WAAA;A7Fm0tBJ;;A8F99tBA;ECmBE,yCAAA;EACA,oBAAA;EACA,8BAAA;EACA,yBAAA;EAEA,0BAAA;EACA,0BAAA;EACA,oCAAA;EAEA,gDAAA;EACA,2BAAA;EACA,qCAAA;EAEA,6DAAA;EAEA,kDAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;A/F28tBF;A+Fz8tBE;EAIE,+CAAA;EACA,0BAAA;EACA,oCAAA;A/Fw8tBJ;;A8Fh+tBA;ECFE,sCAAA;EACA,wBAAA;EACA,2CAAA;EACA,4BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,oCAAA;EAEA,8BAAA;EACA,+BAAA;EACA,qCAAA;EAEA,4CAAA;EAEA,8CAAA;EACA,iCAAA;EACA,uCAAA;EACA,4BAAA;A/Fk+tBF;A+Fh+tBE;EAIE,4CAAA;EACA,8BAAA;EACA,wCAAA;A/F+9tBJ;;A8Fl+tBA;ECvBE,sCAAA;EACA,wBAAA;EACA,8BAAA;EACA,4BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,oCAAA;EAEA,8BAAA;EACA,+BAAA;EACA,qCAAA;EAEA,4CAAA;EAEA,8CAAA;EACA,iCAAA;EACA,uCAAA;EACA,4BAAA;A/Fy/tBF;A+Fv/tBE;EAIE,4CAAA;EACA,8BAAA;EACA,wCAAA;A/Fs/tBJ;;A8Fl+tBA;;;EC9CE,yCAAA;EACA,oBAAA;EACA,8BAAA;EACA,yBAAA;EAEA,0BAAA;EACA,0BAAA;EACA,oCAAA;EAEA,gDAAA;EACA,2BAAA;EACA,qCAAA;EAEA,4CAAA;EAEA,kDAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;A/FkhuBF;A+FhhuBE;;;;;EAIE,+CAAA;EACA,0BAAA;EACA,oCAAA;A/FmhuBJ;A8Fx+tBE;;;ECrEA,yCAAA;EACA,oBAAA;EACA,8BAAA;EACA,yBAAA;EAEA,0BAAA;EACA,0BAAA;EACA,oCAAA;EAEA,gDAAA;EACA,2BAAA;EACA,qCAAA;EAEA,4CAAA;EAEA,kDAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;A/F8iuBF;A+F5iuBE;;;;;EAIE,+CAAA;EACA,0BAAA;EACA,oCAAA;A/F+iuBJ;;A8F9+tBA;;EC3FE,yCAAA;EACA,oBAAA;EACA,8BAAA;EACA,yBAAA;EAEA,0BAAA;EACA,0BAAA;EACA,oCAAA;EAEA,gDAAA;EACA,2BAAA;EACA,qCAAA;EAEA,4CAAA;EAEA,kDAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;A/F0kuBF;A+FxkuBE;;;EAIE,+CAAA;EACA,0BAAA;EACA,oCAAA;A/FykuBJ;;A8Fl/tBA;;ECjHE,sCAAA;EACA,wBAAA;EACA,8BAAA;EACA,4BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,oCAAA;EAEA,8BAAA;EACA,+BAAA;EACA,qCAAA;EAEA,+BAAA;EAEA,8CAAA;EACA,iCAAA;EACA,uCAAA;EACA,4BAAA;A/FomuBF;A+FlmuBE;;;EAIE,4CAAA;EACA,8BAAA;EACA,oCAAA;A/FmmuBJ;;A8Fn/tBA;EC1IE,yCAAA;EACA,oBAAA;EACA,8BAAA;EACA,yBAAA;EAEA,0BAAA;EACA,0BAAA;EACA,oCAAA;EAEA,gDAAA;EACA,2BAAA;EACA,qCAAA;EAEA,yDAAA;EAEA,kDAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;A/F6nuBF;A+F3nuBE;EAIE,+CAAA;EACA,0BAAA;EACA,oCAAA;A/F0nuBJ;;A8Fr/tBA;EC/JE,sCAAA;EACA,oBAAA;EACA,8BAAA;EACA,4BAAA;EAEA,0BAAA;EACA,0BAAA;EACA,oCAAA;EAEA,gDAAA;EACA,2BAAA;EACA,qCAAA;EAEA,yDAAA;EAEA,8CAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;A/FopuBF;A+FlpuBE;EAIE,4CAAA;EACA,0BAAA;EACA,oCAAA;A/FipuBJ;A8Fr/tBI;EACE,W5FvME;AF8ruBR;;A8Fl/tBA;;EC5LE,sCAAA;EACA,wBAAA;EACA,8BAAA;EACA,4BAAA;EAEA,6BAAA;EACA,8BAAA;EACA,oCAAA;EAEA,8BAAA;EACA,+BAAA;EACA,qCAAA;EAEA,+BAAA;EAEA,8CAAA;EACA,iCAAA;EACA,uCAAA;EACA,4BAAA;A/F+quBF;A+F7quBE;;;EAIE,4CAAA;EACA,8BAAA;EACA,oCAAA;A/F8quBJ;;A8Fr/tBA;;;EAKE,sCAAA;EACA,8BAAA;EACA,6BAAA;A9Fs/tBF;A8Fp/tBE;;;EACE,c5FnOY;AF2tuBhB;A8Fr/tBE;;;EAGE,wBAAA;EACA,uBAAA;A9Fu/tBJ;A8Fp/tBE;;;;;EAEE,qBAAA;A9Fy/tBJ;A8Fr/tBI;;;Ed5PF,qEAAA;AhFsvuBF;A8Fn/tBI;;;;;EdnQF,iGAAA;AhF6vuBF;A8Fn/tBI;;;;;EACE,4BAAA;EACA,sBAAA;A9Fy/tBN;;A8Fp/tBA;EACE,4CAAA;A9Fu/tBF;A8Fr/tBE;EACE,6B5Fw/Be;E4Fv/Bf,6BAAA;A9Fu/tBJ;;A8Fn/tBA;;EAEE,+BAAA;A9Fs/tBF;A8Fp/tBE;;EACE,wCAAA;A9Fu/tBJ;;A8F9+tBA;ECzRE,wCAAA;EACA,wBAAA;EACA,+CAAA;EACA,yBAAA;EAEA,0BAAA;EACA,8BAAA;EACA,qDAAA;EAEA,2BAAA;EACA,+BAAA;EACA,sDAAA;EAEA,4CAAA;EAEA,iDAAA;EACA,iCAAA;EACA,uCAAA;EACA,4BAAA;A/FuwuBF;A+FrwuBE;EAIE,8CAAA;EACA,8BAAA;EACA,qDAAA;A/FowuBJ;;A8F5+tBA;;;EClTE,sCAAA;EACA,oBAAA;EACA,8BAAA;EACA,4BAAA;EAEA,6BAAA;EACA,0BAAA;EACA,oCAAA;EAEA,6CAAA;EACA,2BAAA;EACA,qCAAA;EAEA,4CAAA;EAEA,iDAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;A/FgyuBF;A+F9xuBE;;;;;EAIE,4CAAA;EACA,0BAAA;EACA,oCAAA;A/FiyuBJ;;A8Fl/tBA;;;EAGE,kCAAA;EACA,8BAAA;EACA,gCAAA;A9Fq/tBF;;A8F/+tBE;;;ECpVA,yCAAA;EACA,wBAAA;EACA,8BAAA;EACA,yBAAA;EAEA,0BAAA;EACA,8BAAA;EACA,iCAAA;EAEA,gDAAA;EACA,+BAAA;EACA,qCAAA;EAEA,+BAAA;EAEA,iDAAA;EACA,iCAAA;EACA,uCAAA;EACA,4BAAA;A/Fq0uBF;A+Fn0uBE;;;;;EAIE,+CAAA;EACA,8BAAA;EACA,oCAAA;A/Fs0uBJ;A8Fp/tBE;EACE,8BAAA;A9Fs/tBJ;A8Fn/tBE;EChXA,yCAAA;EACA,sCAAA;EACA,kCAAA;EACA,yBAAA;EAEA,0BAAA;EACA,4CAAA;EACA,wCAAA;EAEA,gDAAA;EACA,6CAAA;EACA,yCAAA;EAEA,4CAAA;EAEA,iDAAA;EACA,+CAAA;EACA,2CAAA;EACA,4BAAA;A/Fk2uBF;A+Fh2uBE;EAIE,+CAAA;EACA,4CAAA;EACA,sDAAA;A/F+1uBJ;A8Fn/tBE;ECtYA,sCAAA;EACA,oBAAA;EACA,8BAAA;EACA,4BAAA;EAEA,6BAAA;EACA,0BAAA;EACA,oCAAA;EAEA,6CAAA;EACA,2BAAA;EACA,qCAAA;EAEA,6DAAA;EAEA,iDAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;A/Fw3uBF;A+Ft3uBE;EAIE,4CAAA;EACA,0BAAA;EACA,oCAAA;A/Fq3uBJ;A8Fp/tBE;EC3ZA,yCAAA;EACA,wBAAA;EACA,6CAAA;EACA,yBAAA;EAEA,0BAAA;EACA,8BAAA;EACA,oCAAA;EAEA,gDAAA;EACA,+BAAA;EACA,qCAAA;EAEA,+BAAA;EAEA,iDAAA;EACA,iCAAA;EACA,uCAAA;EACA,4BAAA;A/F84uBF;A+F54uBE;EAIE,+CAAA;EACA,8BAAA;EACA,oCAAA;A/F24uBJ;A8Fr/tBE;EChbA,yCAAA;EACA,sCAAA;EACA,kCAAA;EACA,yBAAA;EAEA,0BAAA;EACA,4CAAA;EACA,wCAAA;EAEA,gDAAA;EACA,6CAAA;EACA,yCAAA;EAEA,yDAAA;EAEA,iDAAA;EACA,+CAAA;EACA,2CAAA;EACA,4BAAA;A/Fo6uBF;A+Fl6uBE;EAIE,+CAAA;EACA,4CAAA;EACA,wCAAA;A/Fi6uBJ;A8Fp/tBE;ECvcA,sCAAA;EACA,oBAAA;EACA,8BAAA;EACA,4BAAA;EAEA,6BAAA;EACA,0BAAA;EACA,oCAAA;EAEA,6CAAA;EACA,2BAAA;EACA,qCAAA;EAEA,yDAAA;EAEA,iDAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;A/F07uBF;A+Fx7uBE;EAIE,4CAAA;EACA,0BAAA;EACA,oCAAA;A/Fu7uBJ;A8Fr/tBE;;EC5dA,yCAAA;EACA,wBAAA;EACA,8BAAA;EACA,yBAAA;EAEA,0BAAA;EACA,8BAAA;EACA,oCAAA;EAEA,gDAAA;EACA,+BAAA;EACA,qCAAA;EAEA,+BAAA;EAEA,iDAAA;EACA,iCAAA;EACA,uCAAA;EACA,4BAAA;A/Fi9uBF;A+F/8uBE;;;EAIE,+CAAA;EACA,8BAAA;EACA,oCAAA;A/Fg9uBJ;A8Fx/tBE;EClfA,yCAAA;EACA,sCAAA;EACA,kCAAA;EACA,yBAAA;EAEA,0BAAA;EACA,4CAAA;EACA,wCAAA;EAEA,gDAAA;EACA,6CAAA;EACA,yCAAA;EAEA,yDAAA;EAEA,iDAAA;EACA,+CAAA;EACA,2CAAA;EACA,4BAAA;A/Fy+uBF;A+Fv+uBE;EAIE,+CAAA;EACA,4CAAA;EACA,wCAAA;A/Fs+uBJ;A8Fz/tBE;;;EAKE,gCAAA;A9Fy/tBJ;A8Fv/tBI;;;EACE,W5F/hBE;AF0hvBR;A8Fx/tBI;;;EACE,W5FniBE;AF+hvBR;A8F1/tBM;;;EdpiBJ,+DAAA;AhFmivBF;A8F1/tBI;;;;;EAEE,gCAAA;A9F+/tBN;A8F7/tBM;;;;;Ed7iBJ,qEAAA;AhFijvBF;A8F7/tBM;;;;;EACE,+BAAA;EACA,sBAAA;A9FmguBR;A8F//tBI;;;EACE,gCAAA;A9FmguBN;A8F7/tBI;;EACE,oCAAA;A9FgguBN;A8F5/tBE;EACE,iDAAA;A9F8/tBJ;A8F5/tBI;EACE,4CAAA;A9F8/tBN;;AgGpkvBA;EACE,mB9FwBe;AF+ivBjB;AgGrkvBE;EACE,6BAAA;EACA,6BAAA;EACA,yBAAA;AhGukvBJ;AgGrkvBI;EAGE,WAAA;EACA,6BAAA;EACA,yBAAA;EACA,gBAAA;AhGqkvBN;AgGjkvBE;;EAEE,c9FfY;E8FgBZ,sB9F1BI;E8F2BJ,yBAAA;EACA,sDAAA;AhGmkvBJ;AgGjkvBI;;EACE,WAAA;EAEA,iDAAA;AhGmkvBN;;AgG9jvBA;EAIE,uCAAA;AhG8jvBF;AgG5jvBE;EACE,6BAAA;EACA,6BAAA;AhG8jvBJ;AgG5jvBI;EAEE,iDAAA;AhG6jvBN;AgG1jvBI;EACE,8BAAA;EACA,+BAAA;AhG4jvBN;AgGzjvBI;EACE,+BAAA;AhG2jvBN;AgGxjvBI;EACE,8BAAA;AhG0jvBN;AgGvjvBI;EACE,gCAAA;AhGyjvBN;AgGtjvBI;EAEE,gCAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AhGujvBN;AgGnjvBE;EACE,yBAAA;EACA,qBAAA;EACA,W9FlFI;AFuovBR;;AgGjjvBA;EACE,mB9FzDe;AF6mvBjB;AgGljvBE;EACE,6BAAA;EACA,6BAAA;EACA,yBAAA;AhGojvBJ;AgGljvBI;EAEE,c9FtFU;E8FuFV,6BAAA;EACA,yBAAA;EACA,gBAAA;AhGmjvBN;AgGjjvBM;EACE,6B9FwqCW;AF24sBnB;AgG9ivBE;;EAEE,W9F7GI;E8F8GJ,yB9FrGY;E8FsGZ,yBAAA;AhGgjvBJ;;AgG3ivBE;EACE,yBAAA;AhG8ivBJ;AgG3ivBE;EACE,iCAAA;AhG6ivBJ;AgGxivBE;EACE,8BAAA;AhG0ivBJ;AgGvivBE;EACE,6BAAA;AhGyivBJ;;AgGnivBE;;EACE,qDAAA;AhGuivBJ;;AgGlivBE;EACE,mB9FrIY;AF0qvBhB;AgGnivBI;EACE,gCAAA;AhGqivBN;AgGnivBM;EAGE,W9FxJA;AF2rvBR;AgG/hvBI;;EAEE,gCAAA;EACA,yB9FtJU;E8FuJV,yBAAA;EACA,mDAAA;AhGiivBN;AgG/hvBM;;EACE,W9FpKA;E8FsKA,sDAAA;AhGiivBR;AgG5hvBE;EACE,oDAAA;AhG8hvBJ;AgG5hvBI;EACE,gCAAA;AhG8hvBN;AgG5hvBM;EACE,gCAAA;AhG8hvBR;AgG1hvBI;EACE,yBAAA;EACA,qBAAA;EACA,c9F/KU;AF2svBhB;AgGxhvBE;EACE,mB9FnLY;AF6svBhB;AgGxhvBI;EACE,gCAAA;EACA,6BAAA;EACA,yBAAA;AhG0hvBN;AgGxhvBM;EAEE,W9FvMA;E8FwMA,yBAAA;EACA,gBAAA;AhGyhvBR;AgGvhvBQ;EACE,6B9FkkCS;AFu9sBnB;AgGphvBI;;EAEE,c9FzMU;E8F0MV,yB9FxLW;E8FyLX,yBAAA;AhGshvBN;AgGphvBM;;EACE,WAAA;AhGuhvBR;;AiGtvvBA;EACE,gCAAA;EACA,4DAAA;AjGyvvBF;AiGvvvBE;EAEE,+BAAA;EACA,qCAAA;AjGwvvBJ;AiGrvvBE;EACE,kCAAA;AjGuvvBJ;;AiGnvvBA;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,6BAAA;AjGsvvBF;AiGpvvBE;EACE,gBAAA;AjGsvvBJ;AiGnvvBE;EACE,mBAAA;AjGqvvBJ;AiGnvvBI;EACE,oBAAA;AjGqvvBN;AiGnvvBM;;EAEE,YAAA;AjGqvvBR;AiGlvvBM;EAEE,YAAA;AjGmvvBR;AiGhvvBM;EACE,gBAAA;EACA,yDAAA;AjGkvvBR;;AiG3uvBE;EACE,qBAAA;AjG8uvBJ;;AiG1uvBA;EACE,oBAAA;AjG6uvBF;;AiG1uvBA;EACE,aAAA;AjG6uvBF;;AiG1uvBA;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AjG6uvBF;AiG3uvBE;EACE,qBAAA;AjG6uvBJ;AiG1uvBE;EACE,wBAAA;AjG4uvBJ;;AiGxuvBA;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,kDAAA;AjG2uvBF;AiGzuvBE;EACE,yDAAA;EAEA,UAAA;AjG0uvBJ;AiGvuvBE;EAGE,UAAA;EACA,gBAAA;AjGuuvBJ;AiGpuvBE;EAEE,aAAA;AjGquvBJ;AiGluvBE;EACE,gCAAA;EACA,UAAA;AjGouvBJ;AiGluvBI;EACE,aAAA;AjGouvBN;AiGhuvBE;EACE,gBAAA;AjGkuvBJ;AiG/tvBE;EACE,UAAA;EACA,8CAAA;EACA,gCAAA;AjGiuvBJ;AiG/tvBI;EACE,UAAA;AjGiuvBN;AiG9tvBI;EACE,aAAA;AjGguvBN;AiG7tvBI;EAEE,YAAA;AjG8tvBN;;AiGztvBA;EACE,wCAAA;EACA,sCAAA;EACA,mBAAA;EACA,kDAAA;EACA,gBAAA;EACA,iBAAA;AjG4tvBF;AiG1tvBE;EACE,aAAA;AjG4tvBJ;AiG1tvBI;EACE,gBAAA;AjG4tvBN;;AiGrtvBE;EACE,sBAAA;AjGwtvBJ;AiGrtvBE;EACE,sBAAA;AjGutvBJ;;AiGntvBA;EACE,mCAAA;AjGstvBF;AiGntvBI;EACE,uBAAA;AjGqtvBN;AiGltvBI;EACE,uBAAA;AjGotvBN;AiGhtvBE;EACE,6CAAA;EACA,oBAAA;EACA,yBAAA;AjGktvBJ;AiG/svBE;EACE,oBAAA;EACA,8BAAA;EACA,yBAAA;EACA,iBAAA;AjGitvBJ;AiG/svBI;EACE,qBAAA;AjGitvBN;AiG9svBI;EACE,gBAAA;EACA,sBAAA;AjGgtvBN;AiG5svBE;EACE,gCAAA;EACA,eAAA;EACA,qBAAA;AjG8svBJ;;AiGxsvBI;EACE,uBAAA;AjG2svBN;AiGxsvBI;EACE,uBAAA;AjG0svBN;AiGtsvBE;EACE,4CAAA;EACA,oBAAA;EACA,yBAAA;AjGwsvBJ;AiGrsvBE;EACE,wBAAA;AjGusvBJ;AiGrsvBI;;EAEE,gBAAA;AjGusvBN;AiGnsvBE;EACE,gCAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;AjGqsvBJ;;AiGjsvBA;EACE,mCAAA;AjGosvBF;AiGjsvBI;EACE,sBAAA;AjGmsvBN;AiGhsvBI;EACE,sBAAA;AjGksvBN;AiG9rvBE;EACE,4CAAA;EACA,mBAAA;EACA,yBAAA;AjGgsvBJ;AiG7rvBE;EACE,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AjG+rvBJ;AiG7rvBI;EACE,yBAAA;EACA,kBAAA;AjG+rvBN;AiG5rvBI;EACE,yBAAA;EACA,gBAAA;AjG8rvBN;AiG1rvBE;EACE,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AjG4rvBJ;AiGvrvBM;EACE,uBAAA;AjGyrvBR;AiGtrvBM;EACE,qBAAA;AjGwrvBR;AiGprvBI;EACE,gDAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AjGsrvBN;AiGnrvBI;EACE,wBAAA;AjGqrvBN;AiGnrvBM;EACE,gBAAA;AjGqrvBR;AiGlrvBM;EACE,yBAAA;AjGorvBR;AiGhrvBI;EACE,oCAAA;AjGkrvBN;AiG5qvBM;EACE,sBAAA;AjG8qvBR;AiG3qvBM;EACE,sBAAA;AjG6qvBR;AiGzqvBI;EACE,6CAAA;EACA,oBAAA;EACA,yBAAA;AjG2qvBN;AiGxqvBI;EACE,yBAAA;EACA,wBAAA;AjG0qvBN;AiGxqvBM;EACE,6BAAA;AjG0qvBR;AiGvqvBM;EACE,yBAAA;AjGyqvBR;AiGrqvBI;EACE,iCAAA;AjGuqvBN;;AiGlqvBA;EACE,yCAAA;EACA,6CAAA;EACA,gDAAA;EACA,+CAAA;AjGqqvBF;AiGlqvBI;EACE,SAAA;AjGoqvBN;AiGjqvBI;EACE,aAAA;AjGmqvBN;AiGhqvBI;EACE,aAAA;AjGkqvBN;AiG9pvBE;;EAEE,cAAA;EACA,eAAA;AjGgqvBJ;;AiG3pvBE;EACE,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,iCAAA;EACA,8BAAA;EACA,iCAAA;EACA,oCAAA;EACA,iEAAA;EACA,gCAAA;AjG8pvBJ;AiG1pvBI;EACE,6BAAA;AjG4pvBN;;AkGxiwBA;EACE,chGgBc;AF2hwBhB;;AkGxiwBA;EACE,UAAA;EACA,gBAAA;AlG2iwBF;;AkGxiwBA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AlG2iwBF;;AkGxiwBA;EACE,oBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;AlG2iwBF;;AkGxiwBA;EACE,wCAAA;AlG2iwBF;;AkGxiwBA;EACE,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;AlG2iwBF;;AkGxiwBA;EACE,oBAAA;EACA,qBAAA;EACA,yBAAA;EACA,aAAA;AlG2iwBF;;AkGxiwBA;EACE,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;AlG2iwBF;;AkGviwBE;EACE,mBAAA;AlG0iwBJ;AkGviwBE;EACE,oBAAA;EACA,yBAAA;EACA,sBAAA;AlGyiwBJ;AkGtiwBE;EACE,iBAAA;AlGwiwBJ;AkGriwBE;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;AlGuiwBJ;AkGpiwBE;EACE,oBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;AlGsiwBJ;;AkGliwBA;EACE,2BAAA;AlGqiwBF;;AkGliwBA;EACE,oCAAA;AlGqiwBF;AkGniwBE;EACE,eAAA;EACA,gBAAA;AlGqiwBJ;;AkGjiwBA;EACE,mBAAA;EACA,yBAAA;EACA,6BAAA;AlGoiwBF;AkGliwBE;EACE,chGlFY;AFsnwBhB;;AkG/hwBE;;EAEE,WhGnGI;AFqowBR;AkG/hwBE;EACE,qBAAA;AlGiiwBJ;AkG9hwBE;EACE,+BAAA;AlGgiwBJ;AkG7hwBE;EACE,gCAAA;AlG+hwBJ;AkG7hwBI;EACE,WhGlHE;AFipwBR;;AmGxpwBA;EACE,yCAAA;AnG2pwBF;;AmGtpwBI;EACE,aAAA;AnGypwBN;AmGtpwBI;EACE,aAAA;AnGwpwBN;AmGrpwBI;EACE,aAAA;AnGupwBN;AmGnpwBM;EACE,YAAA;AnGqpwBR;AmGlpwBM;EACE,UAAA;AnGopwBR;AmGjpwBM;EACE,aAAA;AnGmpwBR;;AmG7owBA;EACE,iBAAA;EACA,kBAAA;AnGgpwBF;;AmG7owBA;EACE,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;AnGgpwBF;;AmG3owBE;EACE,qBAAA;AnG8owBJ;AmG1owBE;EACE,oBAAA;AnG4owBJ;AmGpowBI;EACE,aAAA;AnGsowBN;AmGjowBI;EACE,aAAA;AnGmowBN;AmG7nwBI;EACE,YAAA;AnG+nwBN;AmG1nwBM;EACE,UAAA;AnG4nwBR;;AmGtnwBA;EACE,mBAAA;EACA,kBAAA;AnGynwBF;;AmGrnwBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AnGwnwBF;;AmGrnwBA;EACE,uBAAA;EACA,sBAAA;AnGwnwBF;;AmGrnwBA;EACE,iBAAA;EACA,kBAAA;EACA,oBAAA;EAEA,aAAA;EACA,mBAAA;AnGunwBF;;AmGlnwBA;EACE,oBjG49BsB;AFypuBxB;AmGnnwBE;EAEE,yBAAA;EACA,2BAAA;AnGonwBJ;;AmGhnwBA;EACE,oBjGs9BsB;AF6puBxB;AmGjnwBE;EAEE,yBAAA;EACA,4BAAA;AnGknwBJ;;AmG7mwBE;EAEE,8CAAA;EACA,yBAAA;EACA,8DAAA;EACA,kEAAA;EACA,mDAAA;EACA,oCAAA;EACA,iCAAA;EACA,oCAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AnG+mwBJ;;AoGrwwBA;EACE,+BAAA;EAEA,2BAAA;EAEA,gBAAA;ApGswwBF;AoGpwwBE;EACE,sBAAA;ApGswwBJ;;AoGlwwBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iGAAA;ApGqwwBF;AoGnwwBE;EACE,iCAAA;ApGqwwBJ;AoGlwwBI;EACE,aAAA;ApGowwBN;AoGhwwBE;EACE,kCAAA;EACA,aAAA;ApGkwwBJ;AoG/vwBE;EACE,UAAA;EACA,mCAAA;EACA,gCAAA;ApGiwwBJ;AoG/vwBI;EACE,iCAAA;ApGiwwBN;AoG5vwBI;;EAEE,YAAA;ApG8vwBN;AoG3vwBI;EACE,aAAA;ApG6vwBN;AoGvvwBI;;;EAEE,aAAA;ApG0vwBN;AoGvvwBI;EACE,aAAA;ApGyvwBN;AoGrvwBE;EAEE,oBAAA;EACA,mBAAA;ApGsvwBJ;AoGpvwBI;EACE,YAAA;ApGsvwBN;AoGnvwBI;EACE,UAAA;ApGqvwBN;AoGlvwBI;EACE,uBAAA;ApGovwBN;;AoG/uwBA;EACE,iBAAA;EACA,YAAA;EACA,kCAAA;ApGkvwBF;;AoG/uwBA;EACE,kBAAA;EACA,gB5F6gB4B;E4F5gB5B,qBAAA;EACA,yBAAA;EACA,YAAA;EACA,kCAAA;ApGkvwBF;;AoG/uwBA;EACE,oDAAA;ApGkvwBF;AoGhvwBE;EACE,yBAAA;ApGkvwBJ;;AoG7uwBE;EACE,iCAAA;EACA,kCAAA;EACA,mCAAA;ApGgvwBJ;AoG9uwBI;EACE,oCAAA;ApGgvwBN;;AoG1uwBE;EACE,YAAA;EACA,oBAAA;EACA,yBAAA;ApG6uwBJ;AoG1uwBE;EACE,iBAAA;ApG4uwBJ;;AoGvuwBE;EACE,YAAA;EACA,oBAAA;EACA,yBAAA;ApG0uwBJ;AoGvuwBE;EACE,iBAAA;ApGyuwBJ;AoGtuwBE;EACE,uBAAA;ApGwuwBJ;;AoGnuwBE;EACE,YAAA;ApGsuwBJ;AoGnuwBE;EACE,oBAAA;ApGquwBJ;AoGjuwBI;EACE,YAAA;ApGmuwBN;AoGhuwBI;EACE,mBAAA;EACA,oBAAA;EACA,yBAAA;ApGkuwBN;AoG7twBI;EACE,YAAA;ApG+twBN;AoG5twBI;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;ApG8twBN;;AoGxtwBE;EACE,4BAAA;EAEA,2BAAA;EAEA,gDAAA;EAEA,2BAAA;EACA,qCAAA;EACA,oCAAA;EAEA,kCAAA;EACA,uDAAA;EACA,4CAAA;EAEA,uDAAA;EACA,6DAAA;EACA,wCAAA;EACA,8DAAA;EACA,yCAAA;EACA,oCAAA;EACA,oCAAA;ApGstwBJ;;AqGp6wBA;EACE,gDnG0nBW;AF6yvBb;AGz2wBI;EkG/DJ;IAII,oDnGynBY;EF+yvBd;AACF;;AqGv5wBE;EADF;IAEI,oBAAA;IACA,gBnGkuCO;EFyruBT;AACF;AqG36wBE;EACE,kBnGkvCsB;AF2ruB1B;AqG36wBI;EACE,kBnG+uCoB;EmG9uCpB,6CAAA;ArG66wBN;AqG95wBE;EACE,sBnG+tCqB;AFisuBzB;AqG75wBE;EACE,cAAA;ArG+5wBJ;;AqGx7wBE;EACE,enGqvCsB;AFssuB1B;AqGz7wBI;EACE,enGkvCoB;EmGjvCpB,oCAAA;ArG27wBN;AqGh6wBE;EACE,gDnGilBS;AFi1vBb;AqG/5wBE;EACE,yBnGktCqB;AF+suBzB;AqG95wBE;EACE,oBAAA;ArGg6wBJ;;AqG55wBA;;EAEE,iCAAA;EACA,uCAAA;ArG+5wBF;;AqG55wBA;EACE,iBAAA;ArG+5wBF;;AqGx5wBE;EACE,8BAAA;ArG25wBJ;;AqGr5wBE;EACE,SAAA;ArGw5wBJ;AqGr5wBE;EACE,6BAAA;ArGu5wBJ;;AG35wBI;EkGYA;IACE,8BAAA;ErGm5wBJ;EqGh5wBE;IACE,6BAAA;ErGk5wBJ;AACF;AGj7wBI;EkGmCA;IACE,8BAAA;ErGi5wBJ;EqG94wBE;IACE,6BAAA;ErGg5wBJ;AACF;;AqGp4wBM;;;EACE,gBAAA;ArGy4wBR;;AqGh4wBE;EACE,4CAAA;EACA,kBAAA;EACA,8BAAA;ArGm4wBJ;;AqG13wBI;EACE,kDAAA;ArG63wBN;AqGz3wBE;EACE,mBnGhIY;EmGiIZ,WnG1II;EmG2IJ,sDAAA;ArG23wBJ;AG98wBI;EkGgFF;IAMI,mDnG8ee;EF84vBnB;AACF;AqGz3wBE;;;;EAIE,gCAAA;ArG23wBJ;;AsGrhxBE;;;;EAGE,gBAAA;AtGyhxBJ;;AsGphxBE;EACE,mBAAA;AtGuhxBJ;AsGnhxBI;EACE,6BpGimCgC;AFo7uBtC;;AsG9gxBE;;EtBvBA,oCsBwBkB;EtBvBlB,qCsBuBkB;EAChB,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AtGmhxBJ;;AsG7gxBE;EACE,sDAAA;AtGghxBJ;;AsG3gxBE;EACE,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,mBAAA;EACA,yBAAA;AtG8gxBJ;;AsG1gxBA;EACE,aAAA;AtG6gxBF;AsG3gxBE;EACE,6BAAA;AtG6gxBJ;;AsGzgxBA;EACE,sCAAA;EACA,gCAAA;AtG4gxBF;;AsGzgxBA;EACE,sCAAA;EACA,kCAAA;AtG4gxBF;;AsGzgxBA;EACE,kCAAA;EACA,qCAAA;EACA,iCAAA;AtG4gxBF;;AsGxgxBE;EACE,gDAAA;EACA,wDAAA;EACA,+BAAA;EACA,qCAAA;EACA,iCAAA;EACA,iCAAA;EACA,iCAAA;AtG2gxBJ;;AuGhmxBA;EACE,8BAAA;EACA,gC/F65CkC;ARssuBpC;;AuGhmxBA;EACE,gBAAA;EACA,8LrG8oBiB;EqG7oBjB,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,sBAAA;AvGmmxBF;AuGjmxBE;EACE,gDAAA;AvGmmxBJ;;AuG/lxBA;EACE,aAAA;EACA,UAAA;EACA,qBAAA;AvGkmxBF;;AuG/lxBA;EACE,wBAAA;AvGkmxBF;AuGhmxBE;EACE,kDAAA;AvGkmxBJ;AuG/lxBE;;EAEE,YAAA;AvGimxBJ;;AuG7lxBA;EACE,uBrG2pCqB;AFq8uBvB;;AuG9lxBA;EACE,qBrGwpCqB;AFy8uBvB;;AuG/lxBA;EACE,oBrGqpCqB;AF68uBvB;;AuGhmxBA;EACE,sBrGkpCqB;AFi9uBvB;;AuG/lxBE;EACE,wBAAA;EACA,+BAAA;EACA,6BAAA;AvGkmxBJ;AuG/lxBE;EACE,qBAAA;AvGimxBJ;;AuG7lxBA;EACE,6BAAA;AvGgmxBF;;AuG5lxBA;EACE,aAAA;AvG+lxBF;;AuG3lxBA;EACE,iBAAA;AvG8lxBF;;AwGxqxBA;;EAEE,wBAAA;EACA,yBAAA;AxG2qxBF;;AwGxqxBA;EACE,yBAAA;AxG2qxBF;;AyGlrxBA;EACE,4BAAA;EACA,uCAAA;EACA,qCAAA;EACA,oDAAA;EACA,qCAAA;EACA,2CAAA;EACA,iCAAA;EACA,8BAAA;EACA,8BAAA;EACA,mCAAA;EACA,6BAAA;EACA,kCAAA;EACA,gCAAA;EACA,wCAAA;EACA,mDAAA;EACA,kCAAA;EACA,sCAAA;EACA,8BAAA;EACA,4CAAA;EACA,2CAAA;EACA,iCAAA;EACA,wCAAA;EACA,4BAAA;AzGqrxBF;;AyGlrxBA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AzGqrxBF;AyGlrxBI;EACE,UAAA;AzGorxBN;AyG/qxBI;EACE,UAAA;AzGirxBN;AyG5qxBI;EACE,kCAAA;EACA,4CAAA;AzG8qxBN;AyG3qxBI;EACE,mDAAA;AzG6qxBN;AyGxqxBI;EACE,kCAAA;EACA,+CAAA;AzG0qxBN;AyGtqxBM;EACE,mDAAA;AzGwqxBR;AyGlqxBI;EACE,4CAAA;EACA,cvGrDU;AFytxBhB;AyGjqxBI;EACE,UAAA;EACA,sCAAA;AzGmqxBN;AyG9pxBI;EACE,2CAAA;EACA,kCAAA;AzGgqxBN;AyG7pxBI;EACE,UAAA;EACA,qCAAA;AzG+pxBN;;AyG1pxBA;EACE,qBAAA;AzG6pxBF;;AyG1pxBA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;AzG6pxBF;AyG1pxBI;;;EAGE,YAAA;AzG4pxBN;AyGvpxBI;EACE,UAAA;AzGypxBN;AyGrpxBM;EACE,yDAAA;EACA,kCAAA;AzGupxBR;AyGjpxBI;EACE,qBvGqIU;AF8gxBhB;;AyG9oxBA;EACE,aAAA;EACA,mBAAA;AzGipxBF;;AyG9oxBA;EACE,qDAAA;EACA,YAAA;EACA,WAAA;AzGipxBF;;AyG9oxBA;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,mDAAA;EACA,2CAAA;EACA,cAAA;AzGipxBF;AyG/oxBE;EACE,iDAAA;AzGipxBJ;AyG9oxBE;EACE,uDAAA;AzGgpxBJ;AyG7oxBE;EACE,4CAAA;EACA,2CAAA;AzG+oxBJ;;AyG3oxBA;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;AzG8oxBF;;AyG3oxBA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;AzG8oxBF;;AyG1oxBE;EACE,cAAA;AzG6oxBJ;AyG1oxBE;EACE,YAAA;EACA,WAAA;AzG4oxBJ;AyGvoxBI;;EACE,6BAAA;EACA,cAAA;EACA,aAAA;AzG0oxBN;AyGroxBI;EACE,gCAAA;AzGuoxBN;AyGloxBI;EACE,iCAAA;AzGooxBN;;AyG9nxBE;EACE,eAAA;EACA,cAAA;EACA,6CAAA;EACA,2CAAA;AzGioxBJ;AyG5nxBM;EACE,0CAAA;EACA,sCAAA;AzG8nxBR;AyGznxBM;EACE,kDAAA;AzG2nxBR;AyGtnxBM;EACE,uCAAA;AzGwnxBR;AyGnnxBM;EACE,wCAAA;AzGqnxBR;AyG7mxBQ;EACE,6BAAA;EACA,qDAAA;AzG+mxBV;;AyGvmxBE;EACE,gBAAA;AzG0mxBJ;AyGvmxBE;EACE,aAAA;AzGymxBJ;AyGtmxBE;EACE,kBAAA;AzGwmxBJ;AyGpmxBI;EACE,SAAA;AzGsmxBN;;AyGhmxBE;EACE,aAAA;EACA,gDAAA;EACA,4CAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AzGmmxBJ;AyGjmxBI;EACE,iBAAA;AzGmmxBN;AyGhmxBI;EACE,uDAAA;EACA,6DAAA;AzGkmxBN;AyG9lxBE;EACE,gBAAA;EACA,oBAAA;AzGgmxBJ;AyG5lxBI;EACE,4DAAA;AzG8lxBN;AyG3lxBI;EACE,qBvGrDU;EuGsDV,UAAA;AzG6lxBN;AyG3lxBM;EACE,yBAAA;AzG6lxBR;;AyGtlxBE;EACE,+BAAA;EACA,uCAAA;EACA,qCAAA;EACA,iDAAA;EACA,qCAAA;EACA,wCAAA;EACA,iCAAA;EACA,8BAAA;EACA,8BAAA;EACA,mCAAA;EACA,6BAAA;EACA,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,mDAAA;EACA,kCAAA;EACA,yCAAA;EACA,8BAAA;EACA,4CAAA;EACA,2CAAA;EACA,iCAAA;EACA,wCAAA;EACA,4BAAA;AzGylxBJ;;A0Gz6xBA;EAEE,kCAAA;A1G26xBF;A0Gv6xBE;;EAEE,kCAAA;A1Gy6xBJ;A0Gt6xBE;;EAEE,oBAAA;EACA,cxGVY;AFk7xBhB;A0Gr6xBE;EACE,gCAAA;A1Gu6xBJ;A0Gp6xBE;EACE,mBAAA;EACA,yBAAA;A1Gs6xBJ;A0Gl6xBE;EACE,sBAAA;A1Go6xBJ;A0Gj6xBE;EACE,gBAAA;A1Gm6xBJ;;A0G/5xBA;EACE,wCAAA;EACA,4CAAA;A1Gk6xBF;;A0G/5xBA;EACE,sCAAA;A1Gk6xBF;;A0G/5xBA;EACE,mCAAA;A1Gk6xBF;;A0G/5xBA;EACE,mBAAA;A1Gk6xBF;;A0G/5xBA;EACE,mBAAA;EAEA,kBAAA;A1Gi6xBF;A0G/5xBE;EACE,gBAAA;A1Gi6xBJ;;A0G15xBE;EACE,sBAAA;A1G65xBJ;A0G35xBI;EACE,+CAAA;A1G65xBN;;A0Gv5xBE;EAEE,YAAA;EACA,uBAAA;A1Gy5xBJ;;A0Gp5xBE;EACE,mBAAA;A1Gu5xBJ;;A0Gn5xBA;EACE,sBAAA;EACA,2CAAA;A1Gs5xBF;A0Gp5xBE;EACE,sBxGpGI;AF0/xBR;;A0Gl5xBA;EACE,sBAAA;EACA,8BAAA;A1Gq5xBF;;A0Gl5xBA;EACE,mBAAA;EACA,8BAAA;A1Gq5xBF;;A0G94xBA;EACE,sBAAA;A1Gi5xBF;;A0G94xBA;EACE,sBAAA;EACA,2BAAA;A1Gi5xBF;;A0G74xBE;EACE,yBAAA;EACA,gCAAA;A1Gg5xBJ;;A0G34xBE;EACE,yBxG3Ga;EwG4Gb,gCAAA;A1G84xBJ;;A0Gx4xBA;EACE,iCAAA;A1G24xBF;A0Gz4xBE;;EAEE,kCAAA;A1G24xBJ;A0Gx4xBE;;EAEE,kBAAA;EACA,iBAAA;A1G04xBJ;A0Gv4xBE;EACE,oBAAA;EACA,yBAAA;A1Gy4xBJ;A0Gt4xBE;EACE,uBAAA;A1Gw4xBJ;;A0Gl4xBA;EACE,mCAAA;A1Gq4xBF;A0Gn4xBE;;EAEE,kCAAA;A1Gq4xBJ;A0Gl4xBE;EACE,oBAAA;EACA,gBAAA;A1Go4xBJ;A0Gj4xBE;EACE,2BAAA;A1Gm4xBJ;;A0G53xBE;;;EAGE,qBxGjKa;AFgiyBjB;A0G53xBE;EACE,qBxGnKa;EwGoKb,4BxG/LY;AF6jyBhB;;A0Gx3xBA;EACE,kBAAA;A1G23xBF;A0Gt3xBM;;EACE,gBAAA;A1Gy3xBR;A0Gt3xBM;;EACE,iBAAA;A1Gy3xBR;;A0G92xBM;;EACE,gBAAA;A1Gk3xBR;;A0G52xBA;EACE,mCAAA;EACA,iDAAA;EACA,wCAAA;A1G+2xBF;A0G72xBE;EACE,yBAAA;A1G+2xBJ;A0G52xBE;EACE,2CAAA;A1G82xBJ;A0G32xBE;EACE,qCAAA;A1G62xBJ;A0G12xBE;EACE,4BAAA;A1G42xBJ;;A0Gt2xBI;EACE,aAAA;A1Gy2xBN;A0Gr2xBE;EACE,cxG7PY;AFomyBhB;;A0Gn2xBA;EACE,sEAAA;A1Gs2xBF;AG7iyBI;EuGsMJ;IAII,mBAAA;E1Gu2xBF;E0Gr2xBE;IACE,mBAAA;IACA,YAAA;E1Gu2xBJ;E0Gn2xBI;;IAEE,UAAA;E1Gq2xBN;E0Gn2xBM;;IACE,aAAA;E1Gs2xBR;E0Gl2xBI;;IAGE,gBAAA;IACA,UAAA;IACA,UAAA;E1Gm2xBN;E0G9oyBA;;IACE,WAAA;IACA,kBAAA;IACA,QAAA;IACA,QAAA;IACA,YAAA;IACA,WAAA;IACA,6CAAA;IACA,WAAA;E1GipyBF;E0G32xBI;IACE,gBAAA;E1G62xBN;E0Gz2xBE;;IAGE,gBAAA;IACA,OAAA;IACA,UAAA;E1G02xBJ;E0GlqyBA;;IACE,WAAA;IACA,kBAAA;IACA,QAAA;IACA,QAAA;IACA,YAAA;IACA,WAAA;IACA,6CAAA;IACA,WAAA;E1GqqyBF;E0Gl3xBE;IACE,gBAAA;E1Go3xBJ;AACF;;A0G/2xBE;EACE,sBAAA;EACA,2CAAA;EACA,mDAAA;EACA,8BAAA;EACA,8CAAA;EACA,iDAAA;A1Gk3xBJ;A0Gh3xBI;EACE,gCAAA;A1Gk3xBN;A0G/2xBI;EACE,qBxGxSW;AFypyBjB;A0G32xBI;EACE,sBAAA;A1G62xBN;A0Gz2xBE;EACE,sBAAA;EACA,8BAAA;A1G22xBJ;A0Gz2xBI;EACE,yBxG/UU;AF0ryBhB;A0Gv2xBE;EACE,sBAAA;EACA,8BAAA;A1Gy2xBJ;A0Gt2xBE;EACE,sBAAA;EACA,8BAAA;A1Gw2xBJ;A0Gr2xBE;EACE,sBAAA;A1Gu2xBJ;A0Gp2xBE;EAKE,sBAAA;EACA,8BAAA;A1Gk2xBJ;A0Gv2xBI;EACE,mBAAA;A1Gy2xBN;A0Gj2xBI;EACE,mBAAA;EACA,gCAAA;A1Gm2xBN;A0G91xBI;EACE,mBAAA;EACA,gCAAA;A1Gg2xBN;A0G31xBI;EACE,sBAAA;A1G61xBN;A0Gx1xBI;;;EAGE,qBxGrYU;AF+tyBhB;A0Gv1xBI;EACE,gCAAA;A1Gy1xBN;A0Gt1xBI;EACE,qBxG/YU;AFuuyBhB;A0Gp1xBE;;EAEE,gCAAA;A1Gs1xBJ;A0Gn1xBE;EACE,mCAAA;EACA,oDAAA;EACA,2CAAA;A1Gq1xBJ;A0Gj1xBI;EACE,gCAAA;A1Gm1xBN;A0G/0xBE;EACE,mEAAA;A1Gi1xBJ;;A2GlwyBA;EACE,qBAAA;A3GqwyBF;;A2GlwyBA;EACE,gDzGsnBW;AF+oxBb;;A2GhwyBA;EACE,oBzGspCqB;EyGrpCrB,qBAAA;A3GmwyBF;A2GjwyBE;EACE,wBzGgmBY;EyG/lBZ,uBAAA;A3GmwyBJ;;A2G/vyBA;EACE,qBzGupCe;AF2mwBjB;;A2G/vyBA;EACE,mBzGmpCe;AF+mwBjB;;A2G/vyBA;EACE,kBzG+oCe;AFmnwBjB;;A2G/vyBA;EACE,oBzG2oCe;AFunwBjB;;A2G7vyBE;EACE,uBzGsoCkB;AF0nwBtB;A2G7vyBE;EACE,qBzGkoCkB;AF6nwBtB;A2G5vyBE;EACE,oBzG8nCkB;AFgowBtB;A2G3vyBE;EACE,sBzG0nCkB;AFmowBtB;;A2GvvyBA;;EAEE,qBAAA;EACA,2BAAA;A3G0vyBF;;A2GtvyBE;EACE,wBAAA;EACA,wBAAA;A3GyvyBJ;;A4G3zyBA;EACE,iBAAA;A5G8zyBF;;A4G3zyBA;EACE,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;A5G8zyBF;A4G5zyBE;EACE,0BAAA;A5G8zyBJ;A4G3zyBE;EACE,cAAA;A5G6zyBJ;;A4GzzyBA;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;A5G4zyBF;;A4GzzyBA;EACE,iBAAA;EACA,iBAAA;EACA,YAAA;A5G4zyBF;;A4GxzyBE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;A5G2zyBJ;;A4GtzyBE;EACE,gCAAA;EACA,uBAAA;A5GyzyBJ;A4GvzyBI;EACE,oBAAA;A5GyzyBN;A4GrzyBE;EACE,aAAA;EACA,gBAAA;A5GuzyBJ;;A4GlzyBA;EACE,oBAAA;A5GqzyBF;A4GnzyBE;EACE,aAAA;A5GqzyBJ;;A4G/yyBE;EACE,gBAAA;A5GkzyBJ;;A4G5yyBA;;EAEE,mBAAA;EACA,wCAAA;EACA,gCAAA;A5G+yyBF;A4G7yyBE;;EACE,4B1G9Ca;AF81yBjB;;A4G3yyBE;EACE,sBAAA;EACA,2CAAA;EACA,6BAAA;A5G8yyBJ;A4G5yyBI;EACE,4B1GjFU;AF+3yBhB;A4GzyyBI;EACE,YAAA;A5G2yyBN;;A6Gh5yBA;EACE,wCAAA;EACA,gBAAA;EACA,kBAAA;A7Gm5yBF;A6Gj5yBE;;EAEE,qBAAA;EACA,cAAA;EACA,SAAA;A7Gm5yBJ;A6Gh5yBE;EACE,UAAA;A7Gk5yBJ;;A6G74yBE;EACE,6BAAA;A7Gg5yBJ;A6G74yBE;EACE,mBAAA;A7G+4yBJ;;A6G34yBA;EACE,cAAA;EACA,aAAA;A7G84yBF;;A6G34yBA;EACE,6BAAA;EACA,6BAAA;EACA,eAAA;EACA,wCAAA;A7G84yBF;A6G54yBE;EACE,8CAAA;A7G84yBJ;A6G54yBI;;EAEE,YAAA;A7G84yBN;A6G34yBI;EACE,UAAA;A7G64yBN;;A6Gx4yBA;EACE,aAAA;A7G24yBF;;A6Gx4yBA;;;EAGE,qB3G2Mc;AFgsyBhB;;A6Gx4yBA;EACE,qBAAA;A7G24yBF;;A6Gx4yBA;EACE,mBAAA;A7G24yBF;A6Gz4yBE;;;EAGE,YAAA;A7G24yBJ;A6Gx4yBE;EACE,uDAAA;A7G04yBJ;;A6Gt4yBA;EACE,oBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA,EAAA,4BAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;A7Gy4yBF;;A6Gt4yBA;EACE,WAAA;EACA,cAAA;A7Gy4yBF;;A6Gt4yBA;EACE,WAAA;EACA,cAAA;A7Gy4yBF;;A6Gt4yBA;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,uCAAA;A7Gy4yBF;A6Gv4yBE;EACE,wBAAA;EACA,MAAA;EACA,SAAA;A7Gy4yBJ;A6Gt4yBE;EACE,wBAAA;EACA,YAAA;A7Gw4yBJ;;A6Gp4yBA;EACE,aAAA;A7Gu4yBF;;A6Gp4yBA;EACE,yB3GsIc;AFiwyBhB;;A6Gp4yBA;EACE,4B3GkIc;E2GhId,mBAAA;EACA,kBAAA;EACA,0BAAA;A7Gs4yBF;;A6Gl4yBE;EACE,0BAAA;A7Gq4yBJ;;A6Gj4yBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;EACA,2DAAA;EACA,0CAAA;EACA,2CAAA;A7Go4yBF;;A6Gj4yBA;EAEE,gBrG2c4B;EqG1c5B,mCAAA;A7Gm4yBF;;A6Gh4yBA;EACE,wCAAA;EACA,gBAAA;EACA,6BAAA;A7Gm4yBF;A6Gj4yBE;EACE,yB3G2FY;AFwyyBhB;;AgFphzBM;;;E6BsJJ,6BAAA;EACA,sCAAA;EACA,+CAAA;EACA,6CAAA;EACA,oCAAA;EACA,+BAAA;A7Go4yBF;;AgFzhzBM;;E6ByJJ,gCAAA;EACA,sCAAA;EACA,+CAAA;EACA,6CAAA;EACA,uCAAA;EACA,+BAAA;A7Gq4yBF;;A8GjkzBA;EACE,uDAAA;EAEA,qBAAA;A9GmkzBF;;A8GhkzBA;EACE,cAAA;A9GmkzBF;A8G9jzBE;EACE,c5GEY;E4GDZ,aAAA;EACA,8DAAA;A9GgkzBJ;A8G7jzBI;EACE,uBAAA;A9G+jzBN;A8G3jzBE;EAEE,UAAA;A9G4jzBJ;A8GzjzBE;EACE,2CAAA;A9G2jzBJ;A8GzjzBI;EACE,YAAA;A9G2jzBN;A8GvjzBE;EACE,qCAAA;A9GyjzBJ;A8GvjzBI;EACE,YAAA;A9GyjzBN;A8GrjzBE;EACE,+BAAA;A9GujzBJ;A8GpjzBE;EACE,wCAAA;EACA,oBAAA;EACA,mBAAA;A9GsjzBJ;A8GpjzBI;EACE,YAAA;A9GsjzBN;;A8GjjzBA;EACE,8BAAA;EACA,gB5GxDM;AF4mzBR;;A8GjjzBA;EACE,qBAAA;EACA,gB5G7DM;AFinzBR;;A8G3izBE;;EACE,kDtG8eoB;ARikyBxB;;A8GvizBA;EACE,4BAAA;EACA,6DAAA;EAEA,6CAAA;EACA,oFAAA;A9GyizBF;A8GvizBE;EACE,kBAAA;A9GyizBJ;A8GvizBI;EACE,yDAAA;A9GyizBN;A8GtizBI;EACE,qCAAA;EACA,wDAAA;EACA,UAAA;A9GwizBN;A8GrizBI;EACE,8DAAA;EACA,UAAA;A9GuizBN;A8GlizBI;;EAEE,iBAAA;A9GoizBN;A8GhizBE;EACE,mCAAA;EAEA,iDAAA;EACA,aAAA;A9GiizBJ;A8G9hzBE;EACE,0EAAA;EAEA,2EAAA;EAEA,qEAAA;EAGA,gBAAA;A9G4hzBJ;A8G1hzBI;EACE,wDAAA;A9G4hzBN;;A8GvhzBA;EACE,yBAAA;A9G0hzBF;;A8GnhzBA;EACE,uCAAA;EACA,6CAAA;EACA,qCAAA;EACA,gDAAA;EACA,mDAAA;EACA,kDAAA;EAEA,4DAAA;A9GqhzBF;A8GnhzBE;EACE,sDAAA;EACA,0DAAA;A9GqhzBJ;A8GnhzBI;EACE,oEAAA;A9GqhzBN;A8GlhzBI;EACE,mEAAA;A9GohzBN;A8GjhzBI;EACE,kEAAA;A9GmhzBN;A8G/gzBE;EACE,gBAAA;A9GihzBJ;A8G/gzBI;EACE,gCAAA;A9GihzBN;A8G/gzBM;EACE,kEAAA;A9GihzBR;A8G9gzBM;EACE,gCAAA;EACA,iEAAA;A9GghzBR;;A8GtgzBA;EACE,kCAAA;EACA,2CAAA;EACA,iCAAA;EACA,sCAAA;EACA,0CAAA;EACA,gCAAA;EACA,sCAAA;EACA,sCAAA;A9GygzBF;A8GvgzBE;EACE,mDAAA;EACA,kDAAA;A9GygzBJ;A8GvgzBI;EACE,gDAAA;EACA,4CAAA;A9GygzBN;A8GvgzBM;EACE,4CAAA;A9GygzBR;A8GrgzBI;EACE,oDAAA;EACA,oDAAA;EACA,sCAAA;A9GugzBN;A8GrgzBM;EACE,sCAAA;A9GugzBR;A8GngzBI;EACE,qB5G6BU;AFw+yBhB;;A8G5/yBA;EACE,gCAAA;EACA,qCAAA;EACA,+CAAA;EACA,wCAAA;EACA,+CAAA;EACA,2CAAA;EACA,sCAAA;EACA,gDAAA;EAEA,mDAAA;A9G8/yBF;A8G5/yBE;EACE,mDAAA;EACA,mDAAA;EACA,gCAAA;A9G8/yBJ;A8G5/yBI;EACE,oDAAA;EACA,gDAAA;EACA,iEAAA;A9G8/yBN;A8G3/yBI;EACE,yDAAA;EACA,qDAAA;EACA,gEAAA;A9G6/yBN;A8G1/yBI;EACE,oEAAA;EACA,qCAAA;A9G4/yBN;A8Gv/yBI;EACE,gCAAA;A9Gy/yBN;A8Gv/yBM;EACE,+DAAA;A9Gy/yBR;A8Gt/yBM;EACE,gCAAA;EACA,8DAAA;A9Gw/yBR;;A8G9+yBA;EACE,+CAAA;EACA,iCAAA;EACA,wCAAA;EACA,8CAAA;EACA,8CAAA;A9Gi/yBF;A8G/+yBE;EACE,uDAAA;A9Gi/yBJ;A8G9+yBE;EACE,kDAAA;EACA,sDAAA;EACA,mDAAA;A9Gg/yBJ;A8G9+yBI;EACE,gEAAA;A9Gg/yBN;A8G7+yBI;EACE,+DAAA;A9G++yBN;A8G5+yBI;EACE,mEAAA;EACA,+BAAA;A9G8+yBN;A8Gz+yBI;EACE,0DAAA;A9G2+yBN;A8Gx+yBI;EACE,uDAAA;EACA,6BAAA;EACA,+BAAA;A9G0+yBN;A8Gx+yBM;EACE,8DAAA;EACA,yDAAA;A9G0+yBR;A8Gv+yBM;EACE,6DAAA;EACA,yDAAA;A9Gy+yBR;;A8Gn+yBA;EACE,0B5GzTe;AF+xzBjB;;A8G/9yBA;EACE,kEAAA;EACA,kFAAA;EACA,qCAAA;EAGA,cAAA;EACA,gBAAA;EACA,6CAAA;A9Gg+yBF;A8G99yBE;EACE,oBAAA;A9Gg+yBJ;A8G79yBE;EACE,sDAAA;EACA,sDAAA;A9G+9yBJ;A8G79yBI;EACE,qB5GnHU;E4GoHV,+BAAA;A9G+9yBN;A8G59yBI;EACE,6DAAA;EACA,kBAAA;EACA,UAAA;A9G89yBN;A8G19yBE;EACE,wEAAA;EACA,4BAAA;EAEA,uCAAA;EACA,yDAAA;EACA,kBAAA;A9G29yBJ;A8Gx9yBE;EACE,uDAAA;EACA,SAAA;A9G09yBJ;A8Gv9yBE;EACE,sFAAA;EAEA,gBAAA;A9Gw9yBJ;;A8G98yBE;EACE,0DAAA;EACA,+BAAA;EACA,8CAAA;EACA,sDAAA;A9Gi9yBJ;A8G/8yBI;EACE,W5G/ZE;AFg3zBR;A8G78yBE;EACE,0B5G5ZY;E4G6ZZ,mB5G5ZY;AF22zBhB;A8G58yBE;EACE,mB5GhaY;AF82zBhB;A8Gz8yBE;EACE,kDAAA;EACA,+BAAA;EACA,mCAAA;EACA,kEAAA;EACA,qCAAA;EACA,mEAAA;A9G28yBJ;A8Gz8yBI;EACE,0EAAA;EAEA,2EAAA;A9G08yBN;A8Gt8yBI;EACE,mCAAA;A9Gw8yBN;A8Gp8yBE;EACE,qB5G9bY;AFo4zBhB;A8Gj8yBE;EACE,wCAAA;EACA,uCAAA;EACA,mDAAA;EACA,kDAAA;A9Gm8yBJ;A8G97yBE;EACE,sCAAA;EACA,2DAAA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,mCAAA;EACA,yCAAA;A9Gg8yBJ;A8G37yBE;EACE,gCAAA;EACA,qCAAA;EACA,0DAAA;EACA,+CAAA;EACA,2CAAA;EACA,sCAAA;EACA,gDAAA;A9G67yBJ;A8G17yBE;EACE,0BAAA;A9G47yBJ;A8Gv7yBE;EACE,+CAAA;EACA,oCAAA;EACA,wCAAA;EACA,8CAAA;A9Gy7yBJ;A8Gp7yBE;EACE,kEAAA;EACA,gFAAA;EAEA,wCAAA;A9Gq7yBJ;A8Gn7yBI;EACE,sEAAA;EACA,+BAAA;A9Gq7yBN;A8Gl7yBI;EACE,kFAAA;EAGA,mB5G5fU;AF86zBhB;A8G96yBE;EACE,gD5G+Gc;AFi0yBlB;;A+Gh8zBA;EACE,aAAA;A/Gm8zBF;;A+Gh8zBA;EACE,aAAA;A/Gm8zBF;;A+Gh8zBA;EACE,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,wBAAA;EACA,uBAAA;A/Gm8zBF;;A+Gh8zBA;EACE,YAAA;EACA,sB7GbM;E6GcN,gBAAA;EACA,uGvGsnCkC;AR60xBpC;A+Gj8zBE;EACE,yB7GRY;AF28zBhB;A+G/7zBE;EACE,gBAAA;A/Gi8zBJ;A+G97zBE;EACE,qCAAA;EACA,+BAAA;A/Gg8zBJ;A+G57zBI;EACE,wBAAA;EACA,kBAAA;EACA,6BAAA;A/G87zBN;A+G57zBM;EACE,yB7GTS;AFu8zBjB;A+G57zBQ;EACE,yB7GhCM;AF89zBhB;A+G17zBM;EACE,wDAAA;EACA,qCAAA;A/G47zBR;A+G17zBQ;EACE,qCAAA;A/G47zBV;A+Gx7zBM;EACE,+BAAA;A/G07zBR;A+Gv7zBM;EACE,gCAAA;EACA,gBAAA;EACA,UAAA;A/Gy7zBR;A+Gt7zBM;EACE,qBAAA;A/Gw7zBR;A+Gl7zBM;EACE,sBAAA;A/Go7zBR;A+G/6zBQ;EACE,sBAAA;A/Gi7zBV;A+Gx6zBQ;EACE,kBAAA;A/G06zBV;A+Gr6zBU;EACE,sBAAA;A/Gu6zBZ;;A+G/5zBA;EACE,aAAA;EACA,mBAAA;A/Gk6zBF;A+G/5zBE;EACE,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,QAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,+CAAA;A/Gi6zBJ;A+G95zBE;EACE,wCAAA;A/Gg6zBJ;A+G95zBI;EACE,yB7GjHU;E6GkHV,UAAA;A/Gg6zBN;A+G95zBM;EACE,sB7G/HA;AF+h0BR;A+Gx5zBI;EACE,aAAA;A/G05zBN;;A+Gj5zBA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;A/Go5zBF;;A+Gj5zBA;EACE,oBAAA;EACA,yBAAA;EACA,aAAA;A/Go5zBF;;A+Gj5zBA;EACE,mBAAA;EACA,yBAAA;EACA,aAAA;A/Go5zBF;;A+G54zBE;EACE,uCAAA;EACA,yCAAA;A/G+4zBJ;A+G74zBI;EACE,uBAAA;A/G+4zBN;A+G34zBM;EACE,aAAA;A/G64zBR;A+Gz4zBI;;EAEE,oBAAA;A/G24zBN;A+Gv4zBM;EACE,4BAAA;A/Gy4zBR;A+Gp4zBQ;EACE,qBAAA;A/Gs4zBV;A+Gj4zBU;EACE,oBAAA;A/Gm4zBZ;A+G13zBU;EACE,kBAAA;A/G43zBZ;A+Gv3zBY;EACE,kBAAA;A/Gy3zBd;;A+G12zBI;EACE,oBAAA;EACA,sBAAA;EACA,yBAAA;A/G62zBN;A+G32zBM;EACE,sBAAA;A/G62zBR;A+Gt2zBM;EACE,sBAAA;EACA,yBAAA;A/Gw2zBR;A+Gn2zBE;EACE,yBAAA;A/Gq2zBJ;A+Gl2zBE;EACE,mBAAA;A/Go2zBJ;A+Gj2zBE;EACE,aAAA;A/Gm2zBJ;;A+G71zBI;EACE,oBAAA;EACA,qBAAA;EACA,wBAAA;A/Gg2zBN;A+G11zBM;EACE,mBAAA;EACA,sBAAA;A/G41zBR;A+Gv1zBE;EACE,iBAAA;A/Gy1zBJ;A+Gt1zBE;EACE,eAAA;A/Gw1zBJ;A+Gr1zBE;EACE,oBAAA;A/Gu1zBJ;;A+Gj1zBI;EACE,kCAAA;EACA,kCAAA;A/Go1zBN;A+Gj1zBI;EACE,sCAAA;A/Gm1zBN;;AgHxo0BA;EACE,sB9GIM;E8GHN,mB9GghCmB;AF2nyBrB;AgHxo0BE;EACE,qB9GgiCyB;E8G/hCzB,sB9G+hCyB;AF2myB7B;AgHro0BI;;EACE,kBAAA;AhHwo0BN;AgHro0BM;;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,8CAAA;AhHwo0BR;AgH9n0BI;;;EACE,yB9GGW;AF+n0BjB;AgHho0BM;;;EACE,yB9GES;AFko0BjB;AgH5n0BI;;EAEE,aAAA;AhH8n0BN;AgH5n0BM;;EACE,yB9GgNQ;AF+6zBhB;AgHvn0BI;;EACE,yB9G9CU;AFwq0BhB;AgHxn0BM;;EACE,yB9G3BS;AFsp0BjB;AgHtn0BE;EACE,6BAAA;AhHwn0BJ;AgHrn0BI;EACE,WAAA;AhHun0BN;AgHjn0BM;EACE,WAAA;AhHmn0BR;AgH9m0BE;EACE,yBAAA;AhHgn0BJ;AgH9m0BI;EACE,qB9G9EU;AF8r0BhB;AgH1m0BI;EACE,aAAA;AhH4m0BN;AgHzm0BI;EACE,aAAA;AhH2m0BN;AgHxm0BI;EACE,mB9GxEW;AFkr0BjB;AgHxm0BM;;EAEE,UAAA;AhH0m0BR;;AgHpm0BA;EACE,uCAAA;EACA,iDAAA;EACA,0CAAA;EACA,wCAAA;EACA,kDAAA;EAUA,uBAAA;EACA,SAAA;EACA,+CAAA;AhH8l0BF;AgHxm0BE;EACE,YAAA;AhH0m0BJ;AgHxm0BI;EAHF;IAII,YAAA;EhH2m0BJ;AACF;AgHpm0BE;EACE,cAAA;AhHsm0BJ;AgHnm0BE;EACE,+CAAA;EACA,iFAAA;EACA,6CAAA;AhHqm0BJ;AgHlm0BE;EACE,uCAAA;AhHom0BJ;AgHjm0BE;EACE,gDAAA;EACA,kFAAA;EACA,6CAAA;AhHmm0BJ;AgHjm0BI;EACE,YAAA;AhHmm0BN;AgH/l0BE;EACE,qBAAA;EACA,qB9Gs4ByB;AF2tyB7B;;AgH7l0BA;EACE,gCAAA;AhHgm0BF;AgH9l0BE;EACE,qB9G5JY;AF4v0BhB;;AgH5l0BA;EACE,uD9G2cc;E8G1cd,UAAA;AhH+l0BF;AgH7l0BE;EACE,qCAAA;AhH+l0BJ;;AgHzl0BE;EACE,yCAAA;EACA,sCAAA;AhH4l0BJ;AgH1l0BI;EACE,sCAAA;AhH4l0BN;AgHzl0BI;EACE,yBAAA;EACA,yBAAA;AhH2l0BN;AgHzl0BM;EACE,6BAAA;AhH2l0BR;AgHzl0BQ;EACE,yB9GzLM;AFox0BhB;AgHxl0BQ;EACE,sB9GtMF;AFgy0BR;AgHrl0BI;EACE,qBAAA;AhHul0BN;;AgH/k0BA;EACE,yB9G3Mc;E8G4Md,W9GtNM;E8GuNN,2CAAA;EACA,oBAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;AhHkl0BF;AgH/k0BE;EACE,sBAAA;AhHil0BJ;;AgH5k0BE;EACE,oBAAA;EACA,yBAAA;EACA,6BAAA;AhH+k0BJ;AgH5k0BE;EACE,0BAAA;EACA,yBAAA;AhH8k0BJ;;AgHzk0BE;EACE,4CAAA;EACA,6BAAA;EACA,mCAAA;EACA,mDAAA;EACA,0DAAA;EACA,qEAAA;EAEA,yB9G/OY;AF0z0BhB;AgHzk0BI;EACE,mB9GnPU;AF8z0BhB;AgHzk0BM;EACE,mB9GvPQ;AFk00BhB;AgHtk0BE;EACE,uCAAA;EACA,iDAAA;EACA,uCAAA;EACA,wCAAA;EACA,kDAAA;AhHwk0BJ;AgHrk0BE;EACE,yB9G/Oa;E8GgPb,c9GpQY;AF200BhB;AgHpk0BI;EACE,qB9GzQU;AF+00BhB;AgHjk0BI;EACE,W9GxRE;AF210BR;;AgH9j0BA;EACE,gBAAA;AhHik0BF;;AgH1j0BA;EACE,0CAAA;EACA,oBAAA;AhH6j0BF;AgH3j0BE;EACE,kCAAA;AhH6j0BJ;AgH1j0BE;EACE,gBAAA;AhH4j0BJ;AgHxj0BE;EACE,2BAAA;AhH0j0BJ;;AgHtj0BA;EACE,gCAAA;EACA,0CAAA;EACA,oBAAA;AhHyj0BF;AgHvj0BE;EACE,kCAAA;AhHyj0BJ;AgHtj0BE;EACE,gBAAA;AhHwj0BJ;;AgH9i0BI;EAEI,yCAAA;EAIA,YAAA;EACA,gBAAA;AhH6i0BR;;AGv00BI;E6GmRA;IAEI,yCAAA;EhHuj0BN;AACF;AGh00BI;E6GsQA;IAMI,YAAA;IACA,gBAAA;EhHwj0BN;AACF;;AGn10BI;E6GmRA;IAEI,yCAAA;EhHmk0BN;AACF;AG500BI;E6GsQA;IAMI,YAAA;IACA,gBAAA;EhHok0BN;AACF;;AG/10BI;E6GmRA;IAEI,yCAAA;EhH+k0BN;AACF;AGx10BI;E6GsQA;IAMI,YAAA;IACA,gBAAA;EhHgl0BN;AACF;;AG320BI;E6GmRA;IAEI,yCAAA;EhH2l0BN;AACF;AGp20BI;E6GsQA;IAMI,YAAA;IACA,gBAAA;EhH4l0BN;AACF;;AGv30BI;E6GmRA;IAEI,yCAAA;EhHum0BN;AACF;AGh30BI;E6GsQA;IAMI,YAAA;IACA,gBAAA;EhHwm0BN;AACF;;AgH7l0BA;EACE,mBAAA;EAEA,wCAAA;AhH+l0BF;AgH7l0BE;EACE,iCAAA;AhH+l0BJ;AgH3l0BI;EACE,kCAAA;AhH6l0BN;AgHzl0BE;EACE,UAAA;AhH2l0BJ;AgHxl0BE;EACE,oBAAA;AhH0l0BJ;;AgHtl0BA;EACE,yCAAA;EAEA,UAAA;AhHwl0BF;AgHtl0BE;EACE,kBAAA;AhHwl0BJ;AgHrl0BM;EACE,eAAA;AhHul0BR;AgHrl0BQ;EACE,SAAA;AhHul0BV;;AiHj+0BA;EACE,oCAAA;EACA,4CAAA;AjHo+0BF;;AiHj+0BA;EACE,yCAAA;EACA,iDAAA;AjHo+0BF;;AiHj+0BA;EACE,0CAAA;EACA,kDAAA;AjHo+0BF;;AgFt90BM;;;EiCVJ,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EACA,gCAAA;AjHs+0BF;;AgF390BM;;EiCPJ,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EACA,gCAAA;AjHu+0BF;;AkHrg1BA;EAEE,uCAAA;EACA;;GAAA;AlHyg1BF;AkHrg1BE;EACE,sDAAA;EACA,yDAAA;AlHug1BJ;;AkHng1BA;EACE,oBAAA;AlHsg1BF;AkHpg1BE;EACE,+CAAA;AlHsg1BJ;AkHng1BE;EACE,gDAAA;AlHqg1BJ;AkHlg1BE;EACE,gDAAA;AlHog1BJ;AkHjg1BE;EACE,iDAAA;AlHmg1BJ;;AkH//0BA;EACE,yDAAA;AlHkg1BF;AkHhg1BE;EACE,mDAAA;AlHkg1BJ;AkH9/0BI;EACE,kDAAA;AlHgg1BN;;AkH3/0BA;EACE,gDAAA;AlH8/0BF;;AkH3/0BA;EACE,eAAA;AlH8/0BF;;AkH1/0BA;EACE,yCAAA;EACA,4BAAA;EACA,4BAAA;AlH6/0BF;AkH3/0BE;EACE,kBAAA;EACA,iBAAA;EACA,6BAAA;AlH6/0BJ;AkH1/0BE;EACE,gCAAA;AlH4/0BJ;AkHv/0BI;EACE,qBAAA;AlHy/0BN;AkHr/0BE;EACE,chH5DY;AFmj1BhB;AkHp/0BE;EACE,chHlEY;AFwj1BhB;AkHl/0BI;EACE,uBAAA;AlHo/0BN;AkHj/0BI;EACE,6BAAA;AlHm/0BN;AkH/+0BE;EAEE,yBAAA;EACA,UAAA;AlHg/0BJ;AkH9+0BI;EACE,uBAAA;AlHg/0BN;AkH7+0BI;EACE,4BAAA;AlH++0BN;;AkHx+0BI;EACE,sCAAA;AlH2+0BN;AkHx+0BI;EACE,0BhHnGU;AF6k1BhB;;AkHn+0BI;EACE,uCAAA;AlHs+0BN;AkHn+0BI;EACE,2BhH/GU;AFol1BhB;;AkHh+0BA;EACE,0BAAA;EACA,2BAAA;EACA,2BAAA;AlHm+0BF;;AkHh+0BA;EACE,2BAAA;EACA,8BAAA;EACA,mCAAA;AlHm+0BF;AkHj+0BE;EACE,oBAAA;EACA,yBAAA;AlHm+0BJ;;AkH/90BA;EACE,2BAAA;EACA,iCAAA;EACA,iCAAA;AlHk+0BF;AkHh+0BE;EACE,mBAAA;EACA,yBAAA;AlHk+0BJ;;AkH990BA;EACE,2BAAA;EACA,mCAAA;EACA,mCAAA;EACA,wCAAA;AlHi+0BF;AkH/90BE;EACE,kBAAA;EACA,gBAAA;AlHi+0BJ;;AkH190BA;EACE,2BAAA;AlH690BF;;AkHv90BE;EACE,oCAAA;EACA,0BAAA;AlH090BJ;AkHt90BI;EACE,iCAAA;AlHw90BN;AkHr90BI;EACE,mCAAA;AlHu90BN;AkHp90BI;EACE,4CAAA;AlHs90BN;AkHn90BI;EACE,6CAAA;AlHq90BN;AkHj90BE;EACE,yBhHhMY;AFmp1BhB;AkH780BI;EACE,WhHjNE;EgHkNF,aAAA;AlH+80BN;AkH580BI;EACE,gCAAA;AlH880BN;AkH380BI;EACE,WhH1NE;AFuq1BR;AkH180BI;EACE,gCAAA;AlH480BN;AkHv80BM;EACE,+BAAA;AlHy80BR;AkHl80BM;EACE,4CAAA;AlHo80BR;AkHj80BM;EACE,uBhHhPA;AFmr1BR;AkH570BM;EACE,6CAAA;AlH870BR;AkH370BM;EACE,wBhH5PA;AFyr1BR;;AmH/p1BA;EACE,0BAAA;EACA,kCAAA;EACA,8BAAA;EACA,mCAAA;EACA,2CAAA;EACA,0CAAA;EACA,iCAAA;EACA,qCAAA;EACA,iDAAA;EACA,+BAAA;EACA,qCAAA;EAEA,aAAA;EACA,mBAAA;EA9CA,uCAAA;EACA,YA8CyB;EA7CzB,kBAAA;EACA,mBAAA;AnHgt1BF;AmH9s1BE;EACE,WAyCkB;AnHuq1BtB;AmH9s1BI;EACE,mBAAA;EACA,oBAAA;AnHgt1BN;AmH7s1BI;EACE,mBAAA;AnH+s1BN;AmH5s1BE;EACE,oBAAA;AnH8s1BJ;AmH3s1BE;EACE,WAyBuB;EAxBvB,YAwBuB;AnHqr1B3B;AmH1s1BE;EACE,WAoBkB;EAnBlB,mBAAA;AnH4s1BJ;;AmHrr1BE;EACE,2CAAA;AnHwr1BJ;AmHrr1BE;EACE,mDAAA;AnHur1BJ;AmHpr1BE;EACE,kDAAA;EACA,gBAAA;AnHsr1BJ;AmHpr1BI;EACE,eAAA;AnHsr1BN;;AmH/q1BA;EAvEE,uCAAA;EACA,YAuEyB;EAtEzB,kBAAA;EACA,mBAAA;AnH0v1BF;AmHxv1BE;EACE,WAkEkB;AnHwr1BtB;AmHxv1BI;EACE,kBAAA;EACA,mBAAA;AnH0v1BN;AmHvv1BI;EACE,kBAAA;AnHyv1BN;AmHtv1BE;EACE,mBAAA;AnHwv1BJ;AmHrv1BE;EACE,WAkDuB;EAjDvB,YAiDuB;AnHss1B3B;AmHpv1BE;EACE,WA6CkB;EA5ClB,kBAAA;AnHsv1BJ;;AmHvs1BA;EA3EE,uCAAA;EACA,YA2EyB;EA1EzB,kBAAA;EACA,mBAAA;AnHsx1BF;AmHpx1BE;EACE,WAsEkB;AnHgt1BtB;AmHpx1BI;EACE,kBAAA;EACA,mBAAA;AnHsx1BN;AmHnx1BI;EACE,kBAAA;AnHqx1BN;AmHlx1BE;EACE,mBAAA;AnHox1BJ;AmHjx1BE;EACE,WAsDuB;EArDvB,YAqDuB;AnH8t1B3B;AmHhx1BE;EACE,WAiDkB;EAhDlB,kBAAA;AnHkx1BJ;;AmH7t1BA;EAjFE,uCAAA;EACA,YAiFyB;EAhFzB,gBAAA;EACA,iBAAA;AnHkz1BF;AmHhz1BE;EACE,WA4EkB;AnHsu1BtB;AmHhz1BI;EACE,iBAAA;EACA,kBAAA;AnHkz1BN;AmH/y1BI;EACE,iBAAA;AnHiz1BN;AmH9y1BE;EACE,kBAAA;AnHgz1BJ;AmH7y1BE;EACE,WA4DuB;EA3DvB,YA2DuB;AnHov1B3B;AmH5y1BE;EACE,WAuDkB;EAtDlB,iBAAA;AnH8y1BJ;;AmHrv1BA;EArFE,uCAAA;EACA,YAqF0B;EApF1B,gBAAA;EACA,iBAAA;AnH801BF;AmH501BE;EACE,YAgFkB;AnH8v1BtB;AmH501BI;EACE,iBAAA;EACA,kBAAA;AnH801BN;AmH301BI;EACE,iBAAA;AnH601BN;AmH101BE;EACE,kBAAA;AnH401BJ;AmHz01BE;EACE,WAgEwB;EA/DxB,YA+DwB;AnH4w1B5B;AmHx01BE;EACE,YA2DkB;EA1DlB,iBAAA;AnH001BJ;;AmH1w1BI;;;EAEE,qBAAA;AnH8w1BN;;AmHzw1BA;EACE,yCAAA;EACA,uCAAA;EACA,sDAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AnH4w1BF;AmH1w1BE;EACE,aAAA;AnH4w1BJ;AmHzw1BE;EACE,6BAAA;EACA,yBAAA;AnH2w1BJ;AmHxw1BE;EACE,gBAAA;EACA,gBAAA;AnH0w1BJ;AmHvw1BE;EAEE,aAAA;AnHww1BJ;AmHrw1BE;EAEE,wBAAA;AnHsw1BJ;;AmHlw1BA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,0CAAA;EACA,wCAAA;EACA,gDjH0eW;EiHzeX,kBAAA;EACA,sBAAA;EACA,qBAAA;AnHqw1BF;AmHnw1BE;EAGE,UAAA;AnHmw1BJ;AmH/v1BE;EACE,WAAA;EACA,kBAAA;EACA,ejH+gCkB;EiH9gClB,iBjH+gCmB;EiH9gCnB,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,2BAAA;EACA,mCAAA;EACA,gDAAA;AnHiw1BJ;;AmH5v1BE;EACE,oCAAA;AnH+v1BJ;;AmH3v1BA;EACE,kCAAA;EACA,kCAAA;AnH8v1BF;;AmH3v1BA;EACE,kCAAA;EACA,mCAAA;AnH8v1BF;;AmH3v1BA;EACE,2BAAA;AnH8v1BF;;AmH3v1BA;EACE,0CAAA;EACA,UAAA;AnH8v1BF;;AmH3v1BA;EACE,oBAAA;AnH8v1BF;;AmH3v1BA;EACE,oBAAA;EACA,qBAAA;EACA,sCAAA;EACA,aAAA;AnH8v1BF;;AmH3v1BA;EACE,yCAAA;EACA,UAAA;AnH8v1BF;AmH5v1BE;EACE,uBAAA;AnH8v1BJ;;AmH1v1BA;;EAEE,6CAAA;AnH6v1BF;;AmHzv1BA;EACE,0BAAA;EACA,+BAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EACA,0CAAA;EACA,iCAAA;AnH4v1BF;AmH1v1BE;EACE,qCAAA;EACA,iCAAA;AnH4v1BJ;;AmHvv1BA;EACE,iCAAA;EACA,0CAAA;AnH0v1BF;;AmHtv1BA;EACE,kCAAA;EACA,iCAAA;EACA,2CAAA;EACA,0CAAA;AnHyv1BF;;AmHpv1BE;EACE,0BAAA;EACA,kCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EACA,0CAAA;EACA,iCAAA;EACA,qCAAA;EACA,oDAAA;EAEA,kCAAA;EACA,kCAAA;AnHsv1BJ;AmHnv1BE;EACE,+BAAA;EACA,qCAAA;AnHqv1BJ;AmHlv1BE;EACE,0BAAA;EACA,kCAAA;EACA,mCAAA;EACA,2CAAA;EACA,0CAAA;EACA,iCAAA;EACA,iCAAA;EACA,qCAAA;AnHov1BJ;AmHlv1BI;EACE,iCAAA;AnHov1BN;AmHhv1BE;EACE,0BAAA;EACA,iCAAA;EACA,mCAAA;EACA,0CAAA;EACA,iCAAA;AnHkv1BJ;AmH/u1BE;EACE,0BAAA;EACA,kCAAA;EACA,iCAAA;EACA,2CAAA;EACA,0CAAA;EACA,iCAAA;EACA,mCAAA;AnHiv1BJ;AmH9u1BE;EACE,qCAAA;EACA,iCAAA;AnHgv1BJ;AmH5u1BI;EACE,qBjHrDU;AFmy1BhB;;AoHzi2BA;EACE,gBAAA;ApH4i2BF;;AoHzi2BA;EACE,mBlHiyBqB;AF2w0BvB;;AoHxi2BE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;ApH2i2BJ;;AoHvi2BA;EACE,qBAAA;EACA,iBAAA;EACA,sBlHgxByB;EkH/wBzB,oBAAA;EACA,yBAAA;ApH0i2BF;;AqH9j2BA;;;EAGE,qBAAA;ArHik2BF;;AqH7j2BE;EACE,cnH8a2B;AFkp1B/B;AqH7j2BE;EACE,cnH4b0B;AFmo1B9B;;AsH9k2BA;EACE,cpHg1Ba;AFiw0Bf;AsH/k2BE;EACE,qBpHOY;AF0k2BhB;AsH9k2BE;EACE,qBpH8PY;EoH7PZ,2BAAA;AtHgl2BJ;AsH7k2BE;EACE,gCAAA;EACA,UAAA;AtH+k2BJ;AsH1k2BI;EACE,cpH2yB6B;AFiy0BnC;AsHtk2BE;EACE,aAAA;AtHwk2BJ;;AsHpk2BA;;EAEE,qBpHmxBqB;EoHlxBrB,yBAAA;AtHuk2BF;;AsHpk2BA;EACE,gBpH6yBgB;EoH5yBhB,gBAAA;AtHuk2BF;;AsHpk2BA;EACE,epHuyBgB;EoHtyBhB,yBAAA;AtHuk2BF;;AsHnk2BE;EACE,YAAA;EACA,kBpH+xBW;AFuy0Bf;;AsH9j2BE;;EACE,oBpHwuBkB;EoHvuBlB,qBAAA;EACA,kBAAA;EACA,iBAAA;AtHkk2BJ;;AsH3j2BE;;EAEE,WpHhEI;EoHiEJ,iBpHjEI;EoHkEJ,qBpH3DY;AFyn2BhB;AsH5j2BI;;EACE,qBpHlCW;AFim2BjB;AsH5j2BI;;EACE,+BAAA;AtH+j2BN;AsH1j2BI;EAEE,+BAAA;EACA,yBpHxEU;EoHyEV,qBpH3EU;AFso2BhB;AsHzj2BM;EACE,+BAAA;AtH2j2BR;AsHtj2BE;EACE,gCAAA;EACA,qBpHrFY;EoHsFZ,yBpHpFY;AF4o2BhB;;AuHvp2BE;EACE,crH20BW;AF+00Bf;AuHvp2BE;EACE,UAAA;AvHyp2BJ;AuHvp2BI;EACE,uBAAA;AvHyp2BN;AuHrp2BE;EACE,qBrHPY;AF8p2BhB;AuHpp2BE;EACE,2BAAA;EACA,gCAAA;EACA,UAAA;AvHsp2BJ;;AuHjp2BE;EACE,6BrH0yBsB;AF020B1B;;AuH/o2BE;EACE,gBrH+yBc;EqH9yBd,0BrH47BqB;EqH37BrB,sBrH07B+B;AFwt0BnC;;AuH7o2BE;EACE,erHsyBc;AF020BlB;;AuH5o2BA;EACE,0DAAA;AvH+o2BF;;AuH5o2BA;EACE,0DAAA;AvH+o2BF;;AuH1o2BI;EACE,0DAAA;AvH6o2BN;AuH3o2BM;EACE,yBrH9CQ;AF2r2BhB;AuHxo2BE;EACE,qEAAA;AvH0o2BJ;AuHvo2BE;EACE,qEAAA;AvHyo2BJ;AuHro2BI;EACE,+BAAA;AvHuo2BN;;AwHpt2BA;EACE,etHm2BwB;EsHl2BxB,eAAA;AxHut2BF;AwHrt2BE;EACE,gCAAA;EACA,aAAA;AxHut2BJ;AwHpt2BE;EACE,yBtHi2BsB;AFq30B1B;AwHnt2BE;EACE,qBtHIY;AFit2BhB;AwHnt2BI;EACE,cAAA;AxHqt2BN;AwHjt2BE;EACE,yBtHea;EsHdb,yBAAA;EACA,mBAAA;EACA,mBAAA;AxHmt2BJ;AwHjt2BI;EACE,mBAAA;AxHmt2BN;AwH5s2BI;EACE,0DAAA;AxH8s2BN;AwH1s2BM;EACE,0DAAA;AxH4s2BR;;AwHrs2BE;EAEE,qBAAA;AxHus2BJ;AwHls2BM;EACE,gEAAA;AxHos2BR;;AwH9r2BA;EACE,mBAAA;EACA,sBAAA;EACA,gBAAA;AxHis2BF;;AwH9r2BA;EACE,wBAAA;AxHis2BF;;AwH9r2BA;EACE,mFAAA;EAEA,oBtHsxBuB;EsHrxBvB,qBtHqxBuB;AF260BzB;AwH7r2BI;EACE,gBAAA;AxH+r2BN;AwH3r2BM;EACE,ctHpEQ;AFiw2BhB;A8B5w2BI;E0FoFE,qBtHwU0B;AFm31BhC;AwHzr2BM;EACE,gBAAA;AxH2r2BR;AwHxr2BM;EACE,6BtHwwBiB;AFk70BzB;AwHtr2BQ;EACE,ctHrFM;AF6w2BhB;AwHpr2BM;EAEE,sBtHrGA;EsHsGA,qBtHqTwB;AFg41BhC;AwHnr2BQ;EACE,yDAAA;AxHqr2BV;AwHlr2BQ;EACE,kFAAA;AxHor2BV;A8Bly2BI;E0FqHE,qBtHyTyB;AFu31B/B;AwH9q2BM;EACE,gBAAA;AxHgr2BR;AwH7q2BM;EACE,6BtHuuBiB;AFw80BzB;AwH3q2BQ;EACE,ctHtHM;AFmy2BhB;AwHzq2BM;EACE,sBtHrIA;AFgz2BR;AwHzq2BQ;EACE,0DAAA;AxH2q2BV;AwHxq2BQ;EACE,mFAAA;AxH0q2BV;;AwHjq2BA;EACE,gBAAA;EACA,eAAA;AxHoq2BF;AwHlq2BE;EACE,gBAAA;EACA,sBAAA;AxHoq2BJ;AwHjq2BE;EACE,wBAAA;AxHmq2BJ;AwH/p2BE;EACE,wBAAA;AxHiq2BJ;;AwH5p2BE;EACE,kBAAA;AxH+p2BJ;AwH5p2BE;EACE,sBAAA;AxH8p2BJ;AwH1p2BE;EACE,qBAAA;AxH4p2BJ;;AwHrp2BA;EACE,gBAAA;AxHwp2BF;AwHrp2BE;EACE,WAAA;AxHup2BJ;;AwHhp2BE;EACE,yBAAA;EACA,yBtHzKa;AF4z2BjB;AwHjp2BI;EACE,yBtHnMU;AFs12BhB;AwHhp2BI;EACE,yBtHpMU;AFs12BhB;AwH/o2BI;EACE,yBtHhLW;EsHiLX,qBtHjLW;AFk02BjB;AwH9o2BI;EACE,yDAAA;AxHgp2BN;AwH7o2BI;EACE,yBtH7LW;EsH8LX,0DAAA;AxH+o2BN;AwH5o2BI;EACE,yBtHhMW;EsHiMX,0DAAA;AxH8o2BN;AwH3o2BI;EACE,yDAAA;AxH6o2BN;AwH1o2BI;EACE,6BAAA;EACA,8CAAA;AxH4o2BN;;AwHto2BE;EACE,mFAAA;AxHyo2BJ;AwHto2BE;EACE,yBtH5OY;EsH6OZ,qBtHlPY;AF032BhB;AwHto2BI;EACE,yBtHhPU;EsHiPV,qBtHtPU;EsHuPV,0DAAA;AxHwo2BN;AwHpo2BM;EACE,yBtHvPQ;EsHwPR,qBtH7PQ;EsH8PR,0DAAA;AxHso2BR;AwHlo2BI;EACE,yBAAA;EACA,yBtHjQU;AFq42BhB;AwHlo2BM;EACE,0DAAA;AxHoo2BR;AwHjo2BM;EACE,YAAA;EACA,WtHjRA;AFo52BR;AwH/n2BI;EACE,qBtHjRU;AFk52BhB;AwH9n2BI;EACE,qBtH/PU;AF+32BhB;AwH9n2BM;EACE,WtH7RA;AF652BR;A8B952BI;E0FmSE,qBtHiJyB;AF6+1B/B;AwH5n2BM;EACE,gCAAA;AxH8n2BR;AwH3n2BM;EAEE,qBtHyIuB;EsHxIvB,yBtHjSQ;AF652BhB;AwH1n2BQ;EACE,0DAAA;AxH4n2BV;AwHxn2BM;EAEE,qBtH+HuB;AF0/1B/B;A8B962BI;E0F0TE,qBtH4IwB;EsH3IxB,yBtHhTU;AFu62BhB;AwHrn2BM;EACE,gCAAA;AxHun2BR;AwHpn2BM;EAEE,qBtHmIsB;EsHlItB,yBtHzTQ;AF862BhB;AwHnn2BQ;EACE,0DAAA;AxHqn2BV;AwHjn2BM;EAEE,qBtHyHsB;AFy/1B9B;AwH7m2BM;EACE,qBtHvTQ;AFs62BhB;AwH5m2BM;EACE,0DAAA;AxH8m2BR;AwH5m2BQ;EACE,0DAAA;AxH8m2BV;AwH1m2BM;EACE,yBAAA;AxH4m2BR;AwHzm2BM;EACE,0DAAA;AxH2m2BR;AwHnm2BI;EACE,qBtH1UW;EsH2UX,yBtHnWU;EsHoWV,0DAAA;AxHqm2BN;AwHnm2BM;EACE,kBtHhXA;EsHiXA,yBtHxWQ;EsHyWR,0DAAA;AxHqm2BR;AwHlm2BM;EACE,qBtHrVS;AFy72BjB;AwHjm2BM;EACE,0DAAA;AxHmm2BR;AwH9l2BM;EACE,qBtH3XQ;EsH4XR,yBtHxXQ;EsHyXR,0DAAA;AxHgm2BR;AwH7l2BM;EACE,qBtHjYQ;EsHkYR,yBtHlYQ;EsHmYR,0DAAA;AxH+l2BR;AwH5l2BM;EACE,qBtH9WS;EsH+WT,yBtH/WS;EsHgXT,0DAAA;AxH8l2BR;AwH5l2BQ;EACE,kBtHjZF;EsHkZE,sBtHlZF;EsHmZE,0DAAA;AxH8l2BV;AwH3l2BQ;EACE,8CAAA;AxH6l2BV;AwHvl2BE;EACE,gCAAA;AxHyl2BJ;;AyH9/2BA;EACE,kBvH88B0B;EuH78B1B,mBvH68B0B;EuH58B1B,uBvH68B4B;EuH58B5B,mBAAA;AzHig3BF;AyH//2BE;EACE,sBvH28B8B;AFsj1BlC;AyH9/2BE;EACE,avHo8BwB;EuHn8BxB,cvHm8BwB;EuHl8BxB,uBAAA;EACA,aAAA;AzHgg3BJ;AyH7/2BE;EACE,evH+7BsB;AFgk1B1B;AyH5/2BE;EACE,sBAAA;AzH8/2BJ;;AyHv/2BE;EACE,kBvHu7B2B;AFmk1B/B;AyHx/2BI;EACE,WvHm7BiB;EuHl7BjB,kBAAA;AzH0/2BN;;AyHp/2BE;EACE,eAAA;AzHu/2BJ;;A0Hhi3BA;EACE,mFAAA;A1Hmi3BF;A0Hhi3BI;EACE,yBxHi5BgC;EwHh5BhC,yBxHSU;EwHRV,0DAAA;A1Hki3BN;A0H/h3BI;EACE,yBxHIU;EwHHV,0DAAA;EACA,qBxHEU;AF+h3BhB;A0H9h3BI;EACE,0DAAA;A1Hgi3BN;A0H7h3BI;EACE,yBxHFU;EwHGV,qBxHHU;AFki3BhB;A0H3h3BM;EACE,yBxHuYwB;EwHtYxB,qBxHsYwB;AFup2BhC;A0H3h3BQ;EACE,0DAAA;A1H6h3BV;A8Btj3BI;E4FgCE,qBxH8YyB;AF2o2B/B;A0Hvh3BM;EACE,yBxH2YuB;EwH1YvB,qBxH0YuB;AF+o2B/B;A0Hvh3BQ;EACE,0DAAA;A1Hyh3BV;A0Hlh3BI;EACE,sBxH9CE;EwH+CF,yBAAA;EACA,0DAAA;A1Hoh3BN;A0Hlh3BM;EACE,oCAAA;EACA,yBxHzCQ;EwH0CR,0DAAA;A1Hoh3BR;A0Hlh3BQ;EACE,yBxH5CM;AFgk3BhB;A0H/g3BQ;EACE,sBxH9DF;EwH+DE,0DAAA;EACA,qBxHrDM;AFsk3BhB;A0H9g3BQ;EACE,0DAAA;A1Hgh3BV;A0H5g3BM;EACE,0DAAA;EACA,qBxH3CS;AFyj3BjB;A0H3g3BM;EACE,yBxHhDS;EwHiDT,0DAAA;EACA,qBxHlDS;AF+j3BjB;;A0Htg3BE;EACE,mFAAA;A1Hyg3BJ;A0Htg3BM;EACE,qBxH7DS;EwH8DT,yBxH9DS;EwH+DT,0DAAA;A1Hwg3BR;A0Htg3BQ;EACE,sBxHjGF;AFym3BR;A0Hpg3BM;EACE,yBxHvES;EwHwET,qBxHxES;EwHyET,0DAAA;A1Hsg3BR;A0Hlg3BQ;EAEE,qBxHqUqB;EwHpUrB,yBxHoUqB;AF+r2B/B;A0Hjg3BU;EACE,0DAAA;A1Hmg3BZ;A0H7/2BQ;EAEE,qBxH2UoB;EwH1UpB,yBxH0UoB;AFor2B9B;A0H5/2BU;EACE,0DAAA;A1H8/2BZ;A0Hv/2BM;EACE,qBxHrGS;EwHsGT,yBxH9HQ;EwH+HR,0DAAA;A1Hy/2BR;A0Hv/2BQ;EACE,kBxH3IF;EwH4IE,yBxHnIM;EwHoIN,0DAAA;A1Hy/2BV;A0Hv/2BU;EACE,WxHhJJ;AFyo3BR;A0Hr/2BQ;EACE,0DAAA;A1Hu/2BV;A0Hl/2BQ;EACE,qBxHtJM;EwHuJN,yBxHnJM;EwHoJN,0DAAA;A1Ho/2BV;A0Hj/2BQ;EACE,qBxH5JM;EwH6JN,yBxH7JM;EwH8JN,0DAAA;A1Hm/2BV;A0Hh/2BQ;EACE,qBxHzIO;EwH0IP,yBxH1IO;EwH2IP,0DAAA;A1Hk/2BV;A0Hh/2BU;EACE,kBxH5KJ;EwH6KI,sBxH7KJ;EwH8KI,0DAAA;A1Hk/2BZ;A0H/+2BU;EACE,8CAAA;A1Hi/2BZ;;A2Hzq3BE;EACE,gBAAA;A3H4q3BJ;A2Hrq3BI;;;EACE,UAAA;A3Hyq3BN;A2Hrq3BE;EACE,kBAAA;EACA,YAAA;EACA,azHg0BW;EyH/zBX,sBAAA;A3Huq3BJ;;A2Hnq3BA;EACE,czH0zBa;AF421Bf;A2Hpq3BE;EACE,eAAA;A3Hsq3BJ;;A2Hlq3BA;EACE,gBAAA;EACA,SAAA;A3Hqq3BF;;A2Hjq3BE;;EAEE,gBzH6yBc;AFu31BlB;A2H7p3BE;EAEE,yBAAA;A3H8p3BJ;A2H3p3BE;EACE,ezHgyBc;AF631BlB;;A2Hxp3BE;EACE,oCAAA;EACA,uCAAA;A3H2p3BJ;A2Hxp3BE;;EAEE,ezHmxBc;AFu41BlB;A2Hvp3BE;EAEE,sBzHu5B4B;AFiw1BhC;A2Hrp3BE;EACE,czH0wBc;EyHzwBd,0BAAA;A3Hup3BJ;;A2Hnp3BA;EACE,gBAAA;A3Hsp3BF;;A4Hpu3BA;EACE,+BAAA;A5Huu3BF;A4H/t3BM;;EAEE,UAAA;A5Hiu3BR;A4H/t3BQ;;EACE,gCAAA;A5Hku3BV;A4H5t3BM;;EAEE,0DAAA;A5H8t3BR;A4Hzt3BM;;EAEE,4DAAA;A5H2t3BR;A4Hvt3BI;EACE,gBAAA;A5Hyt3BN;A4Hvt3BM;;EAEE,UAAA;A5Hyt3BR;A4Hvt3BQ;;EACE,gCAAA;A5H0t3BV;A4Hrt3BI;EACE,6B1HuwBK;AFg91BX;A4Hlt3BM;EACE,6CAAA;A5Hot3BR;A4H/s3BE;EACE,uBAAA;EACA,oBAAA;A5Hit3BJ;A4Hps3BE;EACE,wBAAA;A5Hss3BJ;A4Hns3BE;EACE,qBAAA;A5Hqs3BJ;A4Hls3BE;EACE,SAAA;A5Hos3BJ;A4Hjs3BE;EACE,sBAAA;EACA,wBAAA;EACA,qBAAA;EACA,0BAAA;EACA,6BAAA;EACA,wEAAA;A5Hms3BJ;A4Hhs3BE;EACE,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;EACA,wEAAA;A5Hks3BJ;;A4H1q3BI;EACE,yBArBc;EAsBd,4BAtBc;EAuBd,gBAvBc;A5Hos3BpB;A4H1q3BI;EACE,0BA3Bc;EA4Bd,6BA5Bc;EA6Bd,gBA7Bc;A5Hys3BpB;;A4Hrr3BI;EACE,yBArBc;EAsBd,4BAtBc;EAuBd,eAvBc;A5H+s3BpB;A4Hrr3BI;EACE,0BA3Bc;EA4Bd,6BA5Bc;EA6Bd,eA7Bc;A5Hot3BpB;;A4Hjr3BE;EACE,+BAAA;A5Hor3BJ;;A8B1z3BI;E+FAA,+CAAA;A7H8z3BJ;A8B9z3BI;E+FIA,iDAAA;A7H6z3BJ;;A8Bj03BI;E+FUA,8GAAA;A7H2z3BJ;A8Br03BI;E+FeA,8GAAA;A7Hyz3BJ;;A8Bx03BI;E+FsBA,8GAAA;A7Hsz3BJ;A8B503BI;E+F2BA,8GAAA;A7Hoz3BJ;;A8B/03BI;E+FmCA,0B3Hg9B6B;E2H/8B7B,+CAAA;A7Hgz3BJ;A8Bp13BI;E+FyCA,0B3H08B6B;E2Hz8B7B,iDAAA;A7H8y3BJ;;A8Bx13BI;E+FiDE,+GAAA;A7H2y3BN;A8B513BI;E+FqDE,+GAAA;A7H0y3BN;A8B/13BI;E+F2DE,+GAAA;A7Huy3BN;A8Bl23BI;E+F+DE,+GAAA;A7Hsy3BN;A8Br23BI;E+FqEE,+GAAA;A7Hmy3BN;A8Bx23BI;E+FyEE,+GAAA;A7Hky3BN;A8B323BI;E+F+EE,0DAAA;A7H+x3BN;A8B923BI;E+FmFE,0DAAA;A7H8x3BN;;A8Hv33BA;EACE,gB5HMM;AFo33BR;A8Hx33BE;EACE,mB5HaY;AF623BhB;;A+H333BE;EACE,yBAAA;A/H833BJ;A+Hx33BE;EACE,gBAAA;A/H033BJ;A+Ht33BE;EACE,iBAAA;A/Hw33BJ;A+Hr33BE;EACE,qBAAA;A/Hu33BJ;;AG/z3BI;E6HrEA;IACE,gBAAA;EhIw43BJ;AACF;AGtz3BI;E6H7EA;IACE,gBAAA;EhIs43BJ;EgIl43BE;IACE,iBAAA;EhIo43BJ;AACF;AG113BI;E6HtCA;IACE,iBAAA;EhIm43BJ;AACF;;AiI953BA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qD/HinBc;AFgz2BhB;;AkIt63BA;EACE,wBAAA;AlIy63BF;;AkIr63BA;EACE,wCAAA;AlIw63BF;;AkIp63BA;EACE,wCAAA;AlIu63BF;;AkIn63BA;EACE,gCAAA;EACA,oDAAA;AlIs63BF;AkIp63BE;EACE,sBhIhBI;AFs73BR;AkIp63BI;EACE,yBhIXU;AFi73BhB;;AkIh63BA;EACE,aAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;EACA,0CAAA;EACA,8DAAA;AlIm63BF;AkIj63BE;EACE,cAAA;EACA,kBAAA;AlIm63BJ;;AkI/53BA;EACE,oBAAA;EACA,sBAAA;EACA,mBAAA;AlIk63BF;;AmIt93BA;EACE,qBAAA;EACA,0BAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cjISc;EiIRd,yBjI2Be;AF873BjB;AmIv93BE;EACE,yBjIGY;EiIFZ,WjINI;AF+93BR;;AoIl+3BA;EACE;IACE,aAAA;EpIq+3BF;EoIl+3BE;IACE,iBAAA;IACA,iCAAA;IACA,iBAAA;IACA,QAAA;EpIo+3BJ;AACF;AqIh/3BA;EACE,kBAAA;ArIk/3BF;AqIh/3BE;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBnI6GW;EmI5GX,kBAAA;EACA,SAAA;EACA,OAAA;ArIk/3BJ;;AsI7/3BA;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;AtIgg4BF;;AuIng4BE;EACE,mBAAA;AvIsg4BJ;AG383BI;EoItDA;IACE,gBAAA;EvIog4BJ;AACF;AGh93BI;EoI/CA;IACE,gBAAA;EvIkg4BJ;AACF;AuI//3BE;EACE,UAAA;EACA,eAAA;EACA,QAAA;AvIig4BJ;AuI9/3BE;EACE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,0CAAA;EACA,gBrI6nBgB;EqI5nBhB,yBAAA;EACA,kBAAA;EACA,gDAAA;AvIgg4BJ;AuI7/3BE;EACE,sCAAA;EACA,eAAA;AvI+/3BJ;AuI5/3BE;EACE,kCAAA;AvI8/3BJ;AuI3/3BE;EACE,kBrIzCI;AFsi4BR;AuI1/3BI;EACE,WAAA;EACA,qEAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AvI4/3BN;;AwIvj4BA;EACE,eAAA;AxI0j4BF;AG7/3BI;EqI9DJ;IAII,eAAA;ExI2j4BF;AACF;AGlg4BI;EqI9DJ;IAQI,eAAA;ExI4j4BF;AACF;;AwIxj4BA;EACE,iBAAA;AxI2j4BF;AG3g4BI;EqIjDJ;IAII,iBAAA;ExI4j4BF;AACF;AGhh4BI;EqIjDJ;IAQI,eAAA;ExI6j4BF;AACF;;AwI1j4BA;EACE,eAAA;AxI6j4BF;AGzh4BI;EqIrCJ;IAII,eAAA;ExI8j4BF;AACF;AG9h4BI;EqIrCJ;IAQI,eAAA;ExI+j4BF;AACF;;AwI5j4BA;EACE,iBAAA;AxI+j4BF;AGvi4BI;EqIzBJ;IAII,eAAA;ExIgk4BF;AACF;AG5i4BI;EqIzBJ;IAQI,iBAAA;ExIik4BF;AACF;;AwI9j4BA;EACE,eAAA;AxIik4BF;AGrj4BI;EqIbJ;IAII,eAAA;ExIkk4BF;AACF;AG1j4BI;EqIbJ;IAQI,eAAA;ExImk4BF;AACF;;AG/j4BI;EqIAJ;IAEI,yBAAA;ExIkk4BF;AACF;;AGrk4BI;EsI9DF;IACE,gBAAA;EzIuo4BF;AACF;AyIpo4BA;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;AzIso4BF;AyIno4BE;EACE,2BAAA;AzIqo4BJ;AyIjo4BI;EACE,qBAAA;AzImo4BN;;AyI9n4BA;EACE,gBAAA;AzIio4BF;;AyI9n4BA;EACE,gBAAA;AzIio4BF;;AyI9n4BA;EACE,gBAAA;AzIio4BF;;AGrl4BI;EsIzCJ;IAEI,iBAAA;EzIio4BF;AACF;AG3l4BI;EsIzCJ;IAMI,iBAAA;EzIko4BF;AACF;;A0I1q4BA;E1DDE,W0DEgB;E1DDhB,Y0DCgB;A1I8q4BlB;;A0I3q4BA;E1DLE,W0DMgB;E1DLhB,Y0DKgB;A1I+q4BlB;;A0I5q4BA;E1DTE,a0DUgB;E1DThB,c0DSgB;A1Igr4BlB;;A0I7q4BA;E1DbE,W0DcgB;E1DbhB,Y0DagB;A1Iir4BlB;;A0I9q4BA;E1DjBE,W0DkBgB;E1DjBhB,Y0DiBgB;A1Ikr4BlB;;A2Ils4BA;EACE,cAAA;EAGA,SAAA;EACA,UAAA;EAGA,qBAAA;A3Iis4BF;A2I/r4BE;EACE,YAAA;EACA,yBAAA;A3Iis4BJ;A2I9r4BE;EACE,YAAA;A3Igs4BJ;A2I7r4BE;EACE,czIRY;AFus4BhB;;A4Ilt4BA;EACC;IACC,UAAA;E5Iqt4BA;E4Ilt4BD;IACC,UAAA;E5Iot4BA;AACF;A4Ijt4BA;EACC;IACC,8BAAA;E5Imt4BA;E4Iht4BD;IACC,0BAAA;E5Ikt4BA;AACF;A4I/s4BA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCA5BgB;EA6BhB,gBAAA;EACA,eAAA;EACA,UAAA;EACA,mCAjCoB;EAkCpB,wBAnCiB;EAoCjB,2BAAA;EAKA,iCAAA;A5Iit4BD;;A4I9s4BA;EACC,UAAA;A5Iit4BD;A4I/s4BC;EAKC,8BAAA;A5Iit4BF;;A4I7s4BA;EACC,gBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACG,aAAA;EACA,uBAAA;EACH,sBAAA;A5Igt4BD;;A4I7s4BA;EACC,aAAA;EACG,uBAAA;EACA,mBAAA;EACH,WAAA;EACA,YAAA;A5Igt4BD;A4I9s4BI;EAPJ;IAQQ,kBAAA;IACA,sBAAA;E5Iit4BN;AACF;;A4I9s4BA;EACC,WAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mCArFoB;EAsFpB,wBAvFiB;EAwFjB,iCAAA;EAKA,0BAAA;EAKA,mCAAA;A5Iit4BD;A4I/s4BC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A5Iit4BF;;A4I7s4BA;EACC,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;A5Igt4BD;A4I9s4BI;EAZJ;IAaQ,MAAA;IACA,YAAA;E5Iit4BN;AACF;A4I/s4BC;EACC,wBAAA;A5Iit4BF;A4I9s4BC;EACC,yBAAA;A5Igt4BF;A4I7s4BC;EAEC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;A5I8s4BF;;A6I/14BA;EACE,iBAAA;A7Ik24BF;A6I914BE;;EAEE,wBAAA;EACA,SAAA;A7Ig24BJ;A6I514BE;EACE,0BAAA;A7I814BJ;;A6I114BA;EACE,mBAAA;A7I614BF;;A6I114BA;EACE,oBAAA;A7I614BF;;A6I114BA;EACE,oBAAA;A7I614BF;;A6I114BA;EACE,YAAA;A7I614BF;;A8I334BA,WAAA;AAEA;EACI,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;EAIA,iBAAA;EAEA,mBAAA;EACA,wCAAA;A9I634BJ;;A8I334BA;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;A9I834BJ;A8I534BI;EACI,aAAA;A9I834BR;A8I334BI;EACI,eAAA;EACA,YAAA;A9I634BR;;A8I134BA;;EAMI,+BAAA;A9I634BJ;;A8I134BA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A9I634BJ;A8I334BI;EAEI,WAAA;EACA,cAAA;A9I434BR;A8Iz34BI;EACI,WAAA;A9I234BR;A8Ix34BI;EACI,kBAAA;A9I034BR;;A8Iv34BA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EAWA,aAAA;A9Ig34BJ;A8I134BI;EACI,YAAA;A9I434BR;A8I134BI;EACI,cAAA;A9I434BR;A8I134BI;EACI,aAAA;A9I434BR;A8Iv34BI;EACI,oBAAA;A9Iy34BR;A8It34BI;EACI,cAAA;A9Iw34BR;A8Ir34BI;EACI,kBAAA;A9Iu34BR;A8Ip34BI;EACI,cAAA;EACA,YAAA;EACA,6BAAA;A9Is34BR;;A8In34BA;EACI,aAAA;A9Is34BJ;;A+It94BA;EACE,cAAA;A/Iy94BF;;A+It94BA;EACE,YAAA;A/Iy94BF;;A+In94BE;EACE,aAAA;A/Is94BJ;A+In94BE;EACE,YAAA;A/Iq94BJ;A+In94BI;EACE,YAAA;A/Iq94BN;;A+I984BA;EACE,gCAAA;EACA,sCAAA;EACA,uCAAA;EAGA,uBAAA;EACA,6BAAA;A/I+84BF;A+I784BE;EACE,WAAA;EACA,cAAA;EACA,wCAAA;EACA,8CAAA;A/I+84BJ;A+I384BI;EACE,+CAAA;A/I684BN;A+Ix84BI;EACE,8CAAA;A/I084BN;A+It84BE;EACE,UAAA;EACA,qB7I4MY;AF4v4BhB;;A+Ip84BA;EACE,8BAAA;A/Iu84BF;;A+Il84BA;EACE,kBAAA;E/DpEA,W+DqEgB;E/DpEhB,Y+DoEgB;A/Is84BlB;A+Ip84BE;E/DvEA,U+DwEkB;E/DvElB,W+DuEkB;EAChB,kBAAA;A/Iu84BJ;;A+In84BA;E/D7EE,W+D8EgB;E/D7EhB,Y+D6EgB;A/Iu84BlB;A+Ir84BE;E/DhFA,W+DiFkB;E/DhFlB,Y+DgFkB;A/Iw84BpB;;A+Il84BA;;EAEE,2BAAA;A/Iq84BF;A+In84BE;;EACE,WAAA;EACA,gBAAA;A/Is84BJ;;A+Il84BA;;EAEE,0BAAA;A/Iq84BF;A+In84BE;;EACE,eAAA;EACA,eAAA;A/Is84BJ;;A+Ij84BE;EACE,uBAAA;A/Io84BJ;;A+I/74BE;EACE,4BAAA;A/Ik84BJ;;A+I974BA;EACE,gBAAA;EACA,QAAA;EACA,oEAAA;A/Ii84BF;;A+I974BA;EACE;IACE,QAAA;E/Ii84BF;E+I/74BA;IACE,WAAA;E/Ii84BF;AACF;A+I574BA;EACE,8CAAA;EACA,2CAAA;EACA,8CAAA;A/I874BF;A+I574BE;EAEE,4CAAA;A/I674BJ;;A+Iz74BA;EACE,gCAAA;EACA,mCAAA;EACA,uCAAA;A/I474BF;A+I174BE;EACE,yDAAA;A/I474BJ;A+Ix74BI;EACE,wDAAA;A/I074BN;;A+Il74BE;EACE,gCAAA;EACA,mCAAA;EACA,uCAAA;A/Iq74BJ;;AgJ/l5BA;EACE,8BAAA;EACA,mCAAA;EACA,iCAAA;EACA,yCAAA;EACA,uCAAA;EACA,0DAAA;EAGA,mBAAA;EACA,uCAAA;EAEA,oBAAA;AhJ+l5BF;;AgJzl5BE;EACE,kBAAA;AhJ4l5BJ;;AgJtl5BA;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;AhJyl5BF;;AgJnl5BE;EACE,kCAAA;EACA,oBAAA;AhJsl5BJ;;AgJjl5BE;EACE,kCAAA;EACA,mBAAA;AhJol5BJ;AgJhl5BE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AhJkl5BJ;;AgJ7k5BE;;EAEE,kCAAA;EACA,kDAAA;AhJgl5BJ;;AgJ1k5BE;EACE,6CAAA;AhJ6k5BJ;AgJ1k5BE;EACE,6CAAA;AhJ4k5BJ;;AgJxk5BA;EACE,mCAAA;AhJ2k5BF;;AgJtk5BA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AhJyk5BF;;AgJrk5BE;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AhJwk5BJ;;AgJhk5BE;;EACE,aAAA;AhJok5BJ;;AgJ/j5BE;EACE,0BAAA;EACA,qCAAA;AhJkk5BJ;;AgJ9j5BA;EACE,kCAAA;EACA,mBAAA;EACA,eAAA;AhJik5BF;;AgJ9j5BA;EACE,uDAAA;AhJik5BF;;AgJ3j5BE;EACE,2BAAA;EACA,kCAAA;EACA,iCAAA;EACA,yCAAA;EACA,uCAAA;EACA,6DAAA;EACA,sBAAA;EACA,0CAAA;AhJ8j5BJ;;AiJrs5BA;EACE,6BAAA;EAEA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;AjJms5BF;;AiJ/r5BE;EACE,6BAAA;EAEA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;EACA,6BAAA;AjJ6r5BJ;;AkJnv5BA;EACE,4BAAA;EACA,oCAAA;EACA,gCAAA;EACA,gCAAA;EAEA,2BAAA;AlJqv5BF;AkJnv5BE;EACE,8BAAA;EACA,YAAA;AlJqv5BJ;;AkJjv5BA;EACE,sCAAA;EACA,eAAA;AlJov5BF;;AkJjv5BA;EACE,qCAAA;EACA,oCAAA;AlJov5BF;;AkJ7u5BE;EACE,kBAAA;AlJgv5BJ;AkJ7u5BI;EACE,kCAAA;EACA,mBAAA;AlJ+u5BN;AkJ5u5BI;EACE,mCAAA;EACA,mBAAA;AlJ8u5BN;;AkJxu5BE;EACE,4BAAA;EACA,oCAAA;EACA,mCAAA;EACA,gCAAA;AlJ2u5BJ;;AmJ1w5BA;EACE,cAAA;AnJ6w5BF;;AmJ1w5BA;EACE,gDjJkmBW;EiJjmBX,gBAAA;EACA,aAAA;EACA,YAAA;AnJ6w5BF;AmJzw5BE;EACE,uBAAA;AnJ2w5BJ;AmJxw5BE;EAEE,aAAA;AnJyw5BJ;AmJlw5BQ;EACE,gBAAA;AnJow5BV;AmJ9v5BE;EACE,gBAAA;AnJgw5BJ;;AmJ3v5BA;EACE,mBAAA;AnJ8v5BF;AmJ5v5BE;;EAEE,SAAA;EACA,aAAA;EACA,4BAAA;AnJ8v5BJ;AmJ5v5BI;;EACE,ajJnDU;AFkz5BhB;AmJ3v5BE;;EAEE,UAAA;AnJ6v5BJ;AmJ1v5BE;;EAEE,WAAA;AnJ4v5BJ;;AmJxv5BA;EACE,YA7EgB;AnJw05BlB;;AmJtv5BA;EACE,cjJzEc;EiJ0Ed,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AnJyv5BF;AmJvv5BE;EAEE,4BAAA;AnJwv5BJ;AmJpv5BE;EACE,kBAAA;EACA,gBAAA;AnJsv5BJ;AmJpv5BI;EAEE,6CAAA;EAlGJ,WAAA;EACA,kBAAA;EACA,yBjJwBe;EiJvBf,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;AnJw15BF;AmJtv5BM;EACE,gBAAA;AnJwv5BR;AmJ/u5BI;EACE,mBjJ1FW;AF205BjB;AmJ1u5BI;EACE,mCjJjDc;AF6x5BpB;AmJru5BI;EAEE,mBjJ1GW;AFg15BjB;AmJju5BE;EACE,yCjJhEgB;AFmy5BpB;AmJju5BI;EAEE,yBjJjHW;AFm15BjB;AmJ1t5BI;EAME,mBjJtJU;AF625BhB;AmJ9s5BI;EACE,gBAAA;AnJgt5BN;AmJ9s5BM;EACE,4BAAA;AnJgt5BR;AmJ1s5BE;EAME,kBAAA;AnJus5BJ;AmJps5BI;EAzLF,WAAA;EACA,kBAAA;EACA,yBjJwBe;EiJvBf,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;AnJg45BF;AmJrs5BI;EACE,SAAA;AnJus5BN;AmJ/r5BI;EACE,UAAA;AnJis5BN;;AmJzr5BE;EACE,eAAA;AnJ4r5BJ;;AmJxr5BA;EACE,YA7NgB;EA8NhB,gBA9NgB;EA+NhB,gBA/NgB;AnJ055BlB;;AmJxr5BA;EACE,mBAAA;EACA,mBAAA;EACA,cAAA;AnJ2r5BF;;AmJvr5BA;EACE,gBAAA;EACA,8BAAA;AnJ0r5BF;;AmJjr5BI;;;;;;EAEE,wCAAA;AnJwr5BN;;AmJlr5BA;EACE,8CAAA;AnJqr5BF;;AmJ/q5BI;EAEE,wDAAA;AnJir5BN;;AmJzq5BE;EACE,SAAA;AnJ4q5BJ;AmJzq5BE;;EAEE,uBAAA;AnJ2q5BJ;;AmJtq5BE;EACE,kBAAA;AnJyq5BJ;AmJvq5BI;EACE,uBAAA;AnJyq5BN;AmJpq5BE;;;EAGE,gB3IkU0B;E2IjU1B,eAAA;EACA,sBAAA;AnJsq5BJ;AmJjq5BM;EACE,0CAAA;AnJmq5BR;AmJjq5BM;EACE,4BjJrSQ;AFw85BhB;AmJ/p5BM;EACE,uCAAA;AnJiq5BR;AmJ/p5BM;EACE,yBjJ7SQ;AF885BhB;;AmJ1p5BE;EACE,gBAAA;EACA,WAAA;AnJ6p5BJ;AmJ1p5BE;EACE,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,6BAAA;AnJ4p5BJ;AmJ1p5BI;EACE,yBAAA;AnJ4p5BN;AmJzp5BI;EAEE,yBjJlTW;AF485BjB;AmJvp5BI;EAGE,mBAAA;EACA,gBAAA;EACA,cjJ7UU;AFo+5BhB;AmJnp5BE;EACE,mBAAA;EACA,gBAAA;EACA,cjJpVY;AFy+5BhB;AmJlp5BE;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,cjJ3VY;AF++5BhB;AmJlp5BI;EAEE,mBjJ3UW;AF895BjB;AmJ/o5BE;EACE,qBAAA;EACA,YAAA;EACA,oCAAA;AnJip5BJ;AmJ/o5BI;EACE,UAAA;AnJip5BN;AmJ9o5BI;EACE,wBAAA;EACA,4BjJ9WU;EiJ+WV,QAAA;AnJgp5BN;AmJ7o5BI;EACE,qBAAA;EACA,yBjJpXU;EiJqXV,QAAA;AnJ+o5BN;;AmJpo5BE;EACE,8CAAA;AnJuo5BJ;AmJpo5BE;EACE,oDjJ4OiB;EiJ3OjB,yBjJvYY;AF6g6BhB;AmJlo5BI;;EAEE,+BAAA;AnJoo5BN;AmJlo5BM;;EACE,UjJzZA;AF8h6BR;AmJ/n5BI;;;EAGE,WjJlaE;AFmi6BR;AmJ7n5BE;EACE,WjJvaI;AFsi6BR;AmJ5n5BE;EACE,gCAAA;AnJ8n5BJ;AmJ5n5BI;EACE,gCAAA;AnJ8n5BN;AmJzn5BM;EAEE,6CAAA;EACA,yBjJ9aQ;AFwi6BhB;AmJpn5BM;EACE,gBAAA;AnJsn5BR;AmJ9m5BM;EACE,mBjJ9bQ;AF8i6BhB;AmJ7m5BM;EACE,mBjJncQ;AFkj6BhB;AmJ5m5BM;EAEE,mBjJxcQ;AFqj6BhB;AmJzm5BI;EAEE,+BAAA;AnJ0m5BN;AmJtm5BI;EACE,yBjJldU;AF0j6BhB;AmJtm5BM;EAEE,yBjJvdQ;EiJwdR,WjJ/dA;AFsk6BR;AmJnm5BI;EACE,sBjJpeE;EiJqeF,cjJ3dU;AFgk6BhB;AmJ/l5BM;EAME,mBjJveQ;AFmk6BhB;AmJll5BQ;EACE,4BAAA;AnJol5BV;AmJ9k5BI;EAME,sBjJxgBE;EiJygBF,cjJ/fU;AF0k6BhB;AmJxk5BM;EACE,yBjJrgBQ;AF+k6BhB;AmJpk5BI;;;;EAIE,WjJvhBE;AF6l6BR;AmJnk5BI;EACE,WjJ3hBE;AFgm6BR;AmJnk5BM;EAEE,mBjJxhBQ;AF4l6BhB;AmJhk5BI;EACE,0CAAA;EACA,6BAAA;AnJkk5BN;AmJhk5BM;EACE,yBAAA;EACA,yBjJliBQ;AFom6BhB;AmJ/j5BM;EACE,yBjJtiBQ;AFum6BhB;AmJ5j5BM;EACE,yBjJnjBA;AFin6BR;AmJ3j5BM;EACE,sBjJvjBA;AFon6BR;AmJvj5BE;EACE,qBjJxjBY;AFin6BhB;AmJpj5BM;EACE,6CAAA;AnJsj5BR;AmJpj5BM;EACE,yBjJvkBA;AF6n6BR;AmJlj5BM;EACE,0CAAA;AnJoj5BR;AmJlj5BM;EACE,sBjJ/kBA;AFmo6BR;;AoJro6BA;EACE,aAAA;ApJwo6BF;;AoJro6BA;;EAAA;AAGA;EACE,kBAAA;ApJwo6BF;AoJto6BE;EACE,gBAAA;EACA,uBAAA;ApJwo6BJ;AoJto6BI;EACE,aAAA;ApJwo6BN;AoJpo6BE;EACE,kBAAA;ApJso6BJ;;AoJlo6BA;;EAAA;AAiBA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;ApJun6BF;AoJpn6BE;EACE,qBAnBqB;EAoBrB,gDAAA;EACA,cAZc;EAad,UAAA;ApJsn6BJ;AoJnn6BE;EACE,YAAA;ApJqn6BJ;AoJjn6BE;EACE,yBAjC4B;EAkC5B,UAAA;ApJmn6BJ;AoJhn6BE;EACE,qBAnC6B;EAoC7B,gDAAA;ApJkn6BJ;AoJ/m6BE;EACE,qBAvC2B;EAwC3B,gDAAA;ApJin6BJ;AoJ3m6BI;EACE,cAvCkB;EAwClB,UAAA;ApJ6m6BN;AoJzm6BI;EACE,cA7CkB;ApJwp6BxB;AoJvm6BI;EACE,cAlDkB;ApJ2p6BxB;AoJrm6BE;EACE,uBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;ApJum6BJ;AoJpm6BE;EACE,iBAAA;ApJsm6BJ;;AoJlm6BA;;EAAA;AAGA;EACE,UAAA;ApJqm6BF;AoJnm6BE;EACE,iBAAA;ApJqm6BJ;;AoJjm6BA;;EAAA;AAYA;EACE,yBAV2B;EAW3B,SAAA;EACA,sBAAA;EACA,cA3IkB;EA4IlB,oBAAA;EACA,iBAAA;EAEA,qBAAA;ApJ0l6BF;AoJxl6BE;EACE,uBAAA;ApJ0l6BJ;AoJxl6BI;EACE,sBAAA;ApJ0l6BN;AoJtl6BE;EACE,oCAzBkC;EA0BlC,cA1JiB;EA2JjB,oBAAA;ApJwl6BJ;AoJrl6BE;EACE,eAAA;ApJul6BJ;AoJpl6BE;EACE,yBApKgB;EAqKhB,WAnKc;EAoKd,aAAA;EACA,qBAAA;ApJsl6BJ;AoJnl6BE;EAEE,sBAAA;EACA,4BAAA;EACA,yBAAA;EAEA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;ApJml6BJ;AoJjl6BI;EAEE,cAAA;ApJkl6BN;;AoJ7k6BA;;EAAA;AAGA;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;EACA,oBAAA,EAAA,oCAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;ApJgl6BF;AoJ9k6BE;EACE,WAAA;ApJgl6BJ;AoJ7k6BE;EACE,oBAAA;EACA,oBAAA,EAAA,yCAAA;ApJ+k6BJ;;AoJ3k6BA;EACE,mBAAA;ApJ8k6BF;AoJ3k6BE;EAEE,sCAAA;EACA,mBAAA;ApJ4k6BJ;;AoJvk6BA;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;ApJ0k6BF;;AoJvk6BA;;EAAA;AAGA;EACE,SAAA;ApJ0k6BF;AoJvk6BE;EAEE,UAAA;ApJwk6BJ;AoJrk6BE;EACE,yBAAA;EACA,4BAAA;ApJuk6BJ;AoJpk6BE;EACE,0BAAA;EACA,6BAAA;ApJsk6BJ;;AqJv06BA;EACE,eAAA;ArJ006BF;AqJx06BE;EACE,kBAAA;ArJ006BJ;AqJv06BE;EACE,aAAA;ArJy06BJ;;AqJr06BA;EACE,aAAA;ArJw06BF;AqJt06BE;EACE,WAAA;ArJw06BJ;AqJr06BE;EAEE,aAAA;ArJs06BJ;;AqJl06BA;EACE,SAAA;ArJq06BF;;AqJj06BE;EACE,gBAAA;EACA,kBAAA;ArJo06BJ;AqJh06BE;EACE,kBAAA;ArJk06BJ;AqJ9z6BE;EACE,aAAA;EACA,8DAAA;ArJg06BJ;;AsJv26BE;EAEE,cAAA;AtJy26BJ;;AsJr26BA;EACE,gB9IimB4B;E8IhmB5B,WpJJM;AF426BR;;AsJp26BE;EACE,aAAA;AtJu26BJ;;AsJn26BA;EACE,qBpJ8xBqB;AFwk5BvB;;AsJl26BE;EACE,WpJpBI;AFy36BR;AsJl26BE;EACE,2CAAA;AtJo26BJ;;AuJl46BE;EACE,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,mBAAA;AvJq46BJ;AuJn46BI;EACE,gCAAA;AvJq46BN;AuJl46BI;EACE,gCAAA;AvJo46BN;AuJh46BE;EAEE,0BAAA;AvJi46BJ;AuJ936BE;EACE,wCAAA;EACA,8BAAA;EACA,wCAAA;AvJg46BJ;AuJ936BI;EAEE,wCAAA;EACA,0DAAA;EACA,4BAAA;EACA,0CrJ67BoB;EqJ57BpB,0BrJ67BgB;EqJ57BhB,wBAAA;EACA,yBAAA;AvJ+36BN;AuJ536BI;EAEE,yBAAA;EACA,oCAAA;AvJ636BN;AuJ136BI;EACE,oCAAA;AvJ436BN;AuJx36BE;EACE,kCAAA;AvJ036BJ;;AuJp36BI;EACE,qBrJ1CU;AFi66BhB;AuJr36BM;EACE,gCAAA;AvJu36BR;AuJn36BI;EACE,gCAAA;AvJq36BN;AuJl36BI;EACE,WrJ7DE;AFi76BR;AuJj36BI;EACE,mBrJxDU;AF266BhB;AuJh36BI;EACE,2CAAA;AvJk36BN;AuJh36BM;EACE,0DAAA;EACA,sBAAA;AvJk36BR;AuJ/26BM;EAEE,oCAAA;EACA,sBAAA;AvJg36BR;AuJ726BM;EACE,oCAAA;AvJ+26BR;AuJ326BI;EACE,sBAAA;AvJ626BN;;AwJ586BA;EACE,sBAAA;EACA,8JACE;EAWF,mCAAA;EACA,kCAAA;AxJo86BF;;AwJj86BA;EACE,+EAAA;AxJo86BF;;AwJj86BA;EACE,aAAA;AxJo86BF","sourcesContent":["@charset \"UTF-8\";\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;1,300;1,400;1,500&display=swap\");\n@import '~flatpickr/dist/flatpickr.css';\n.absolute-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.opacity-100-hover {\n  transition: opacity 300ms;\n}\n.opacity-100-hover:hover {\n  opacity: 1 !important;\n}\n\n.hover-shadow {\n  transition: box-shadow 300ms;\n}\n.hover-shadow:hover {\n  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);\n}\n\n.hover-shadow-lg {\n  transition: box-shadow 300ms;\n}\n.hover-shadow-lg:hover {\n  box-shadow: 0 1.25rem 1.875rem rgba(35, 35, 35, 0.2);\n}\n\n.hover-shadow-elevated {\n  transition: box-shadow 300ms;\n  box-shadow: 0 0.5625rem 0.875rem rgba(35, 35, 35, 0.14);\n}\n.hover-shadow-elevated:hover {\n  box-shadow: 0 1.25rem 1.875rem rgba(35, 35, 35, 0.2);\n}\n\n@media (min-width: 992px) {\n  .lh-lg-1-5 {\n    line-height: 1.5 !important;\n  }\n}\n.dark .dark-d-none {\n  display: none !important;\n}\n.dark .dark-d-inline {\n  display: inline !important;\n}\n.dark .hover-shadow:hover {\n  box-shadow: 0 0.75rem 1rem rgba(0, 0, 0, 0.5);\n}\n.dark .hover-shadow-lg:hover {\n  box-shadow: 0 1.25rem 1.875rem rgba(0, 0, 0, 0.6);\n}\n.dark .hover-shadow-elevated {\n  box-shadow: 0 0.5625rem 0.875rem rgba(0, 0, 0, 0.5);\n}\n.dark .hover-shadow-elevated:hover {\n  box-shadow: 0 1.25rem 1.875rem rgba(0, 0, 0, 0.6);\n}\n\n/*!\n * Bootstrap  v5.3.2 (https://getbootstrap.com/)\n * Copyright 2011-2023 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root,\n[data-bs-theme=light] {\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f8f9fa;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #0d6efd;\n  --bs-secondary: #6c757d;\n  --bs-success: #2ee68c;\n  --bs-info: #4fc3f7;\n  --bs-warning: #ffee5c;\n  --bs-danger: #ff7591;\n  --bs-light: #f2f2f2;\n  --bs-dark: #111111;\n  --bs-primary-rgb: 13, 110, 253;\n  --bs-secondary-rgb: 108, 117, 125;\n  --bs-success-rgb: 46, 230, 140;\n  --bs-info-rgb: 79, 195, 247;\n  --bs-warning-rgb: 255, 238, 92;\n  --bs-danger-rgb: 255, 117, 145;\n  --bs-light-rgb: 242, 242, 242;\n  --bs-dark-rgb: 17, 17, 17;\n  --bs-primary-text-emphasis: #052c65;\n  --bs-secondary-text-emphasis: #2b2f32;\n  --bs-success-text-emphasis: #125c38;\n  --bs-info-text-emphasis: #204e63;\n  --bs-warning-text-emphasis: #665f25;\n  --bs-danger-text-emphasis: #662f3a;\n  --bs-light-text-emphasis: #495057;\n  --bs-dark-text-emphasis: #495057;\n  --bs-primary-bg-subtle: #cfe2ff;\n  --bs-secondary-bg-subtle: #e2e3e5;\n  --bs-success-bg-subtle: #e6fff2;\n  --bs-info-bg-subtle: #ecfafe;\n  --bs-warning-bg-subtle: #fffff0;\n  --bs-danger-bg-subtle: #ffedf0;\n  --bs-light-bg-subtle: #fcfcfd;\n  --bs-dark-bg-subtle: #ced4da;\n  --bs-primary-border-subtle: #9ec5fe;\n  --bs-secondary-border-subtle: #c4c8cb;\n  --bs-success-border-subtle: #2ee68c;\n  --bs-info-border-subtle: #4fc3f7;\n  --bs-warning-border-subtle: #ffee5c;\n  --bs-danger-border-subtle: #ff7591;\n  --bs-light-border-subtle: #e9ecef;\n  --bs-dark-border-subtle: #adb5bd;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-font-sans-serif: Arial, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: \"Roboto\", Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.75;\n  --bs-body-color: #111111;\n  --bs-body-color-rgb: 17, 17, 17;\n  --bs-body-bg: #fff;\n  --bs-body-bg-rgb: 255, 255, 255;\n  --bs-emphasis-color: #000;\n  --bs-emphasis-color-rgb: 0, 0, 0;\n  --bs-secondary-color: #666666;\n  --bs-secondary-color-rgb: 102, 102, 102;\n  --bs-secondary-bg: #e9ecef;\n  --bs-secondary-bg-rgb: 233, 236, 239;\n  --bs-tertiary-color: rgba(17, 17, 17, 0.5);\n  --bs-tertiary-color-rgb: 17, 17, 17;\n  --bs-tertiary-bg: #f8f9fa;\n  --bs-tertiary-bg-rgb: 248, 249, 250;\n  --bs-heading-color: inherit;\n  --bs-link-color: #002bbc;\n  --bs-link-color-rgb: 0, 43, 188;\n  --bs-link-decoration: none;\n  --bs-link-hover-color: #002bbc;\n  --bs-link-hover-color-rgb: 0, 43, 188;\n  --bs-link-hover-decoration: underline;\n  --bs-code-color: #d63384;\n  --bs-highlight-color: #111111;\n  --bs-highlight-bg: #fff3cd;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #ededed;\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --bs-border-radius: 0.3125rem;\n  --bs-border-radius-sm: 0.1875rem;\n  --bs-border-radius-lg: 0.5rem;\n  --bs-border-radius-xl: 0.75rem;\n  --bs-border-radius-xxl: 1rem;\n  --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n  --bs-border-radius-pill: 50rem;\n  --bs-box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);\n  --bs-box-shadow-sm: 0 0.5625rem 0.875rem rgba(35, 35, 35, 0.14);\n  --bs-box-shadow-lg: 0 1.25rem 1.875rem rgba(35, 35, 35, 0.2);\n  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --bs-focus-ring-width: 0.25rem;\n  --bs-focus-ring-opacity: 0.25;\n  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);\n  --bs-form-valid-color: #0c6636;\n  --bs-form-valid-border-color: #15ad5c;\n  --bs-form-invalid-color: #9e3232;\n  --bs-form-invalid-border-color: #e64949;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: var(--bs-border-width) solid;\n  opacity: 0.25;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 2rem;\n  font-weight: 300;\n  line-height: 1.5;\n  color: var(--bs-heading-color);\n}\n\nh1, .h1 {\n  font-size: 2rem;\n}\n\nh2, .h2 {\n  font-size: 1.8125rem;\n}\n\nh3, .h3 {\n  font-size: 1.625rem;\n}\n\nh4, .h4 {\n  font-size: 1.4375rem;\n}\n\nh5, .h5 {\n  font-size: 1.25rem;\n}\n\nh6, .h6 {\n  font-size: 0.875rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall, .small {\n  font-size: 0.8125em;\n}\n\nmark, .mark {\n  padding: 0.1875em;\n  color: var(--bs-highlight-color);\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n  text-decoration: none;\n}\na:hover {\n  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n  text-decoration: underline;\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.8125em;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.8125em;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 0.8125em;\n  color: var(--bs-body-bg);\n  background-color: var(--bs-body-color);\n  border-radius: 0.1875rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: var(--bs-secondary-color);\n  text-align: left;\n}\n\nth {\n  font-weight: normal;\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.125rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: 5.625rem;\n  font-weight: 300;\n  line-height: 1.5;\n}\n\n.display-2 {\n  font-size: 4.1875rem;\n  font-weight: 300;\n  line-height: 1.5;\n}\n\n.display-3 {\n  font-size: 3.1875rem;\n  font-weight: 300;\n  line-height: 1.5;\n}\n\n.display-4 {\n  font-size: 2.375rem;\n  font-weight: 300;\n  line-height: 1.5;\n}\n\n.display-5 {\n  font-size: 1.75rem;\n  font-weight: 300;\n  line-height: 1.5;\n}\n\n.display-6 {\n  font-size: 1.333rem;\n  font-weight: 300;\n  line-height: 1.5;\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.8125em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.8125em;\n  color: #6c757d;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--bs-body-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.8125em;\n  color: var(--bs-secondary-color);\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --bs-gutter-x: 1.875rem;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1320px;\n  }\n}\n:root {\n  --bs-breakpoint-xs: 0;\n  --bs-breakpoint-sm: 576px;\n  --bs-breakpoint-md: 768px;\n  --bs-breakpoint-lg: 992px;\n  --bs-breakpoint-xl: 1200px;\n  --bs-breakpoint-xxl: 1400px;\n}\n\n.row {\n  --bs-gutter-x: 1.875rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.125rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.125rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-6,\n.gx-6 {\n  --bs-gutter-x: 2rem;\n}\n\n.g-6,\n.gy-6 {\n  --bs-gutter-y: 2rem;\n}\n\n.g-7,\n.gx-7 {\n  --bs-gutter-x: 2.5rem;\n}\n\n.g-7,\n.gy-7 {\n  --bs-gutter-y: 2.5rem;\n}\n\n.g-8,\n.gx-8 {\n  --bs-gutter-x: 3rem;\n}\n\n.g-8,\n.gy-8 {\n  --bs-gutter-y: 3rem;\n}\n\n.g-9,\n.gx-9 {\n  --bs-gutter-x: 3.5rem;\n}\n\n.g-9,\n.gy-9 {\n  --bs-gutter-y: 3.5rem;\n}\n\n.g-10,\n.gx-10 {\n  --bs-gutter-x: 4rem;\n}\n\n.g-10,\n.gy-10 {\n  --bs-gutter-y: 4rem;\n}\n\n.g-11,\n.gx-11 {\n  --bs-gutter-x: 5rem;\n}\n\n.g-11,\n.gy-11 {\n  --bs-gutter-y: 5rem;\n}\n\n.g-12,\n.gx-12 {\n  --bs-gutter-x: 6rem;\n}\n\n.g-12,\n.gy-12 {\n  --bs-gutter-y: 6rem;\n}\n\n.g-13,\n.gx-13 {\n  --bs-gutter-x: 6.5rem;\n}\n\n.g-13,\n.gy-13 {\n  --bs-gutter-y: 6.5rem;\n}\n\n.g-14,\n.gx-14 {\n  --bs-gutter-x: 8rem;\n}\n\n.g-14,\n.gy-14 {\n  --bs-gutter-y: 8rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n  .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-sm-0,\n  .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-sm-1,\n  .gx-sm-1 {\n    --bs-gutter-x: 0.125rem;\n  }\n  .g-sm-1,\n  .gy-sm-1 {\n    --bs-gutter-y: 0.125rem;\n  }\n  .g-sm-2,\n  .gx-sm-2 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-sm-2,\n  .gy-sm-2 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-sm-3,\n  .gx-sm-3 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-sm-3,\n  .gy-sm-3 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-sm-4,\n  .gx-sm-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-sm-4,\n  .gy-sm-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-sm-5,\n  .gx-sm-5 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-sm-5,\n  .gy-sm-5 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-sm-6,\n  .gx-sm-6 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-sm-6,\n  .gy-sm-6 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-sm-7,\n  .gx-sm-7 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-sm-7,\n  .gy-sm-7 {\n    --bs-gutter-y: 2.5rem;\n  }\n  .g-sm-8,\n  .gx-sm-8 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-sm-8,\n  .gy-sm-8 {\n    --bs-gutter-y: 3rem;\n  }\n  .g-sm-9,\n  .gx-sm-9 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .g-sm-9,\n  .gy-sm-9 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .g-sm-10,\n  .gx-sm-10 {\n    --bs-gutter-x: 4rem;\n  }\n  .g-sm-10,\n  .gy-sm-10 {\n    --bs-gutter-y: 4rem;\n  }\n  .g-sm-11,\n  .gx-sm-11 {\n    --bs-gutter-x: 5rem;\n  }\n  .g-sm-11,\n  .gy-sm-11 {\n    --bs-gutter-y: 5rem;\n  }\n  .g-sm-12,\n  .gx-sm-12 {\n    --bs-gutter-x: 6rem;\n  }\n  .g-sm-12,\n  .gy-sm-12 {\n    --bs-gutter-y: 6rem;\n  }\n  .g-sm-13,\n  .gx-sm-13 {\n    --bs-gutter-x: 6.5rem;\n  }\n  .g-sm-13,\n  .gy-sm-13 {\n    --bs-gutter-y: 6.5rem;\n  }\n  .g-sm-14,\n  .gx-sm-14 {\n    --bs-gutter-x: 8rem;\n  }\n  .g-sm-14,\n  .gy-sm-14 {\n    --bs-gutter-y: 8rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n  .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-md-0,\n  .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-md-1,\n  .gx-md-1 {\n    --bs-gutter-x: 0.125rem;\n  }\n  .g-md-1,\n  .gy-md-1 {\n    --bs-gutter-y: 0.125rem;\n  }\n  .g-md-2,\n  .gx-md-2 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-md-2,\n  .gy-md-2 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-md-3,\n  .gx-md-3 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-md-3,\n  .gy-md-3 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-md-4,\n  .gx-md-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-md-4,\n  .gy-md-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-md-5,\n  .gx-md-5 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-md-5,\n  .gy-md-5 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-md-6,\n  .gx-md-6 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-md-6,\n  .gy-md-6 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-md-7,\n  .gx-md-7 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-md-7,\n  .gy-md-7 {\n    --bs-gutter-y: 2.5rem;\n  }\n  .g-md-8,\n  .gx-md-8 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-md-8,\n  .gy-md-8 {\n    --bs-gutter-y: 3rem;\n  }\n  .g-md-9,\n  .gx-md-9 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .g-md-9,\n  .gy-md-9 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .g-md-10,\n  .gx-md-10 {\n    --bs-gutter-x: 4rem;\n  }\n  .g-md-10,\n  .gy-md-10 {\n    --bs-gutter-y: 4rem;\n  }\n  .g-md-11,\n  .gx-md-11 {\n    --bs-gutter-x: 5rem;\n  }\n  .g-md-11,\n  .gy-md-11 {\n    --bs-gutter-y: 5rem;\n  }\n  .g-md-12,\n  .gx-md-12 {\n    --bs-gutter-x: 6rem;\n  }\n  .g-md-12,\n  .gy-md-12 {\n    --bs-gutter-y: 6rem;\n  }\n  .g-md-13,\n  .gx-md-13 {\n    --bs-gutter-x: 6.5rem;\n  }\n  .g-md-13,\n  .gy-md-13 {\n    --bs-gutter-y: 6.5rem;\n  }\n  .g-md-14,\n  .gx-md-14 {\n    --bs-gutter-x: 8rem;\n  }\n  .g-md-14,\n  .gy-md-14 {\n    --bs-gutter-y: 8rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n  .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-lg-0,\n  .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-lg-1,\n  .gx-lg-1 {\n    --bs-gutter-x: 0.125rem;\n  }\n  .g-lg-1,\n  .gy-lg-1 {\n    --bs-gutter-y: 0.125rem;\n  }\n  .g-lg-2,\n  .gx-lg-2 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-lg-2,\n  .gy-lg-2 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-lg-3,\n  .gx-lg-3 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-lg-3,\n  .gy-lg-3 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-lg-4,\n  .gx-lg-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-lg-4,\n  .gy-lg-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-lg-5,\n  .gx-lg-5 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-lg-5,\n  .gy-lg-5 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-lg-6,\n  .gx-lg-6 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-lg-6,\n  .gy-lg-6 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-lg-7,\n  .gx-lg-7 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-lg-7,\n  .gy-lg-7 {\n    --bs-gutter-y: 2.5rem;\n  }\n  .g-lg-8,\n  .gx-lg-8 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-lg-8,\n  .gy-lg-8 {\n    --bs-gutter-y: 3rem;\n  }\n  .g-lg-9,\n  .gx-lg-9 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .g-lg-9,\n  .gy-lg-9 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .g-lg-10,\n  .gx-lg-10 {\n    --bs-gutter-x: 4rem;\n  }\n  .g-lg-10,\n  .gy-lg-10 {\n    --bs-gutter-y: 4rem;\n  }\n  .g-lg-11,\n  .gx-lg-11 {\n    --bs-gutter-x: 5rem;\n  }\n  .g-lg-11,\n  .gy-lg-11 {\n    --bs-gutter-y: 5rem;\n  }\n  .g-lg-12,\n  .gx-lg-12 {\n    --bs-gutter-x: 6rem;\n  }\n  .g-lg-12,\n  .gy-lg-12 {\n    --bs-gutter-y: 6rem;\n  }\n  .g-lg-13,\n  .gx-lg-13 {\n    --bs-gutter-x: 6.5rem;\n  }\n  .g-lg-13,\n  .gy-lg-13 {\n    --bs-gutter-y: 6.5rem;\n  }\n  .g-lg-14,\n  .gx-lg-14 {\n    --bs-gutter-x: 8rem;\n  }\n  .g-lg-14,\n  .gy-lg-14 {\n    --bs-gutter-y: 8rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n  .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xl-0,\n  .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xl-1,\n  .gx-xl-1 {\n    --bs-gutter-x: 0.125rem;\n  }\n  .g-xl-1,\n  .gy-xl-1 {\n    --bs-gutter-y: 0.125rem;\n  }\n  .g-xl-2,\n  .gx-xl-2 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xl-2,\n  .gy-xl-2 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xl-3,\n  .gx-xl-3 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xl-3,\n  .gy-xl-3 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xl-4,\n  .gx-xl-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xl-4,\n  .gy-xl-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xl-5,\n  .gx-xl-5 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xl-5,\n  .gy-xl-5 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xl-6,\n  .gx-xl-6 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-xl-6,\n  .gy-xl-6 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-xl-7,\n  .gx-xl-7 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-xl-7,\n  .gy-xl-7 {\n    --bs-gutter-y: 2.5rem;\n  }\n  .g-xl-8,\n  .gx-xl-8 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xl-8,\n  .gy-xl-8 {\n    --bs-gutter-y: 3rem;\n  }\n  .g-xl-9,\n  .gx-xl-9 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .g-xl-9,\n  .gy-xl-9 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .g-xl-10,\n  .gx-xl-10 {\n    --bs-gutter-x: 4rem;\n  }\n  .g-xl-10,\n  .gy-xl-10 {\n    --bs-gutter-y: 4rem;\n  }\n  .g-xl-11,\n  .gx-xl-11 {\n    --bs-gutter-x: 5rem;\n  }\n  .g-xl-11,\n  .gy-xl-11 {\n    --bs-gutter-y: 5rem;\n  }\n  .g-xl-12,\n  .gx-xl-12 {\n    --bs-gutter-x: 6rem;\n  }\n  .g-xl-12,\n  .gy-xl-12 {\n    --bs-gutter-y: 6rem;\n  }\n  .g-xl-13,\n  .gx-xl-13 {\n    --bs-gutter-x: 6.5rem;\n  }\n  .g-xl-13,\n  .gy-xl-13 {\n    --bs-gutter-y: 6.5rem;\n  }\n  .g-xl-14,\n  .gx-xl-14 {\n    --bs-gutter-x: 8rem;\n  }\n  .g-xl-14,\n  .gy-xl-14 {\n    --bs-gutter-y: 8rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --bs-gutter-x: 0.125rem;\n  }\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --bs-gutter-y: 0.125rem;\n  }\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxl-6,\n  .gx-xxl-6 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-xxl-6,\n  .gy-xxl-6 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-xxl-7,\n  .gx-xxl-7 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-xxl-7,\n  .gy-xxl-7 {\n    --bs-gutter-y: 2.5rem;\n  }\n  .g-xxl-8,\n  .gx-xxl-8 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xxl-8,\n  .gy-xxl-8 {\n    --bs-gutter-y: 3rem;\n  }\n  .g-xxl-9,\n  .gx-xxl-9 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .g-xxl-9,\n  .gy-xxl-9 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .g-xxl-10,\n  .gx-xxl-10 {\n    --bs-gutter-x: 4rem;\n  }\n  .g-xxl-10,\n  .gy-xxl-10 {\n    --bs-gutter-y: 4rem;\n  }\n  .g-xxl-11,\n  .gx-xxl-11 {\n    --bs-gutter-x: 5rem;\n  }\n  .g-xxl-11,\n  .gy-xxl-11 {\n    --bs-gutter-y: 5rem;\n  }\n  .g-xxl-12,\n  .gx-xxl-12 {\n    --bs-gutter-x: 6rem;\n  }\n  .g-xxl-12,\n  .gy-xxl-12 {\n    --bs-gutter-y: 6rem;\n  }\n  .g-xxl-13,\n  .gx-xxl-13 {\n    --bs-gutter-x: 6.5rem;\n  }\n  .g-xxl-13,\n  .gy-xxl-13 {\n    --bs-gutter-y: 6.5rem;\n  }\n  .g-xxl-14,\n  .gx-xxl-14 {\n    --bs-gutter-x: 8rem;\n  }\n  .g-xxl-14,\n  .gy-xxl-14 {\n    --bs-gutter-y: 8rem;\n  }\n}\n.table {\n  --bs-table-color-type: initial;\n  --bs-table-bg-type: initial;\n  --bs-table-color-state: initial;\n  --bs-table-bg-state: initial;\n  --bs-table-color: rgba(17, 17, 17, 0.64);\n  --bs-table-bg: #fff;\n  --bs-table-border-color: #ededed;\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: rgba(17, 17, 17, 0.64);\n  --bs-table-striped-bg: #fafafa;\n  --bs-table-active-color: rgba(17, 17, 17, 0.64);\n  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);\n  --bs-table-hover-color: rgba(17, 17, 17, 0.64);\n  --bs-table-hover-bg: rgba(17, 17, 17, 0.02);\n  width: 100%;\n  margin-bottom: 1rem;\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.table > :not(caption) > * > * {\n  padding: 0.75rem 0.9375rem;\n  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));\n  background-color: var(--bs-table-bg);\n  border-bottom-width: var(--bs-border-width);\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.5rem 0.75rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: var(--bs-border-width) 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 var(--bs-border-width);\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-active {\n  --bs-table-color-state: var(--bs-table-active-color);\n  --bs-table-bg-state: var(--bs-table-active-bg);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-color-state: var(--bs-table-hover-color);\n  --bs-table-bg-state: var(--bs-table-hover-bg);\n}\n\n.table-primary {\n  --bs-table-color: #000;\n  --bs-table-bg: #cfe2ff;\n  --bs-table-border-color: #a6b5cc;\n  --bs-table-striped-bg: #c5d7f2;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #bacbe6;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #bfd1ec;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n  --bs-table-color: #000;\n  --bs-table-bg: #e2e3e5;\n  --bs-table-border-color: #b5b6b7;\n  --bs-table-striped-bg: #d7d8da;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #cbccce;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #d1d2d4;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n  --bs-table-color: #000;\n  --bs-table-bg: #d5fae8;\n  --bs-table-border-color: #aac8ba;\n  --bs-table-striped-bg: #caeedc;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #c0e1d1;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #c5e7d7;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n  --bs-table-color: #000;\n  --bs-table-bg: #dcf3fd;\n  --bs-table-border-color: #b0c2ca;\n  --bs-table-striped-bg: #d1e7f0;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #c6dbe4;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #cce1ea;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n  --bs-table-color: #000;\n  --bs-table-bg: #fffcde;\n  --bs-table-border-color: #cccab2;\n  --bs-table-striped-bg: #f2efd3;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #e6e3c8;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #ece9cd;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n  --bs-table-color: #000;\n  --bs-table-bg: #ffe3e9;\n  --bs-table-border-color: #ccb6ba;\n  --bs-table-striped-bg: #f2d8dd;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #e6ccd2;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #ecd2d8;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n  --bs-table-color: #000;\n  --bs-table-bg: #f2f2f2;\n  --bs-table-border-color: #c2c2c2;\n  --bs-table-striped-bg: #e6e6e6;\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: #dadada;\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: #e0e0e0;\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n  --bs-table-color: #fff;\n  --bs-table-bg: #111111;\n  --bs-table-border-color: #414141;\n  --bs-table-striped-bg: #1d1d1d;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: #292929;\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: #232323;\n  --bs-table-hover-color: #fff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.75rem;\n  font-size: 0.875rem;\n}\n\n.col-form-label {\n  padding-top: calc(0.5rem + var(--bs-border-width));\n  padding-bottom: calc(0.5rem + var(--bs-border-width));\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.7142857143;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.6875rem + var(--bs-border-width));\n  padding-bottom: calc(0.6875rem + var(--bs-border-width));\n  font-size: 0.9375rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.375rem + var(--bs-border-width));\n  padding-bottom: calc(0.375rem + var(--bs-border-width));\n  font-size: 0.8125rem;\n}\n\n.form-text {\n  margin-top: 0.5rem;\n  font-size: 0.6875rem;\n  color: var(--bs-secondary-color);\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0.9375rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.7142857143;\n  color: #111111;\n  appearance: none;\n  background-color: transparent;\n  background-clip: padding-box;\n  border: var(--bs-border-width) solid #dedede;\n  border-radius: 0;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: #111111;\n  background-color: transparent;\n  border-color: #304ffe;\n  outline: 0;\n  box-shadow: none;\n}\n.form-control::-webkit-date-and-time-value {\n  min-width: 85px;\n  height: 1.7142857143em;\n  margin: 0;\n}\n.form-control::-webkit-datetime-edit {\n  display: block;\n  padding: 0;\n}\n.form-control::placeholder {\n  color: rgba(17, 17, 17, 0.64);\n  opacity: 1;\n}\n.form-control:disabled {\n  background-color: #fafafa;\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.5rem 0.9375rem;\n  margin: -0.5rem -0.9375rem;\n  margin-inline-end: 0.9375rem;\n  color: #111111;\n  background-color: var(--bs-tertiary-bg);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: var(--bs-border-width);\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: var(--bs-secondary-bg);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0;\n  margin-bottom: 0;\n  line-height: 1.7142857143;\n  color: var(--bs-body-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: var(--bs-border-width) 0;\n}\n.form-control-plaintext:focus {\n  outline: 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: 2.25rem;\n  padding: 0.375rem 0.9375rem;\n  font-size: 0.8125rem;\n  border-radius: 0;\n}\n.form-control-sm::file-selector-button {\n  padding: 0.375rem 0.9375rem;\n  margin: -0.375rem -0.9375rem;\n  margin-inline-end: 0.9375rem;\n}\n\n.form-control-lg {\n  min-height: 2.875rem;\n  padding: 0.6875rem 0.9375rem;\n  font-size: 0.9375rem;\n  border-radius: 0;\n}\n.form-control-lg::file-selector-button {\n  padding: 0.6875rem 0.9375rem;\n  margin: -0.6875rem -0.9375rem;\n  margin-inline-end: 0.9375rem;\n}\n\ntextarea.form-control {\n  min-height: 2.5rem;\n}\ntextarea.form-control-sm {\n  min-height: 2.25rem;\n}\ntextarea.form-control-lg {\n  min-height: 2.875rem;\n}\n\n.form-control-color {\n  width: 3rem;\n  height: 2.5rem;\n  padding: 0.5rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: 0;\n}\n.form-control-color::-webkit-color-swatch {\n  border: 0 !important;\n  border-radius: 0;\n}\n.form-control-color.form-control-sm {\n  height: 2.25rem;\n}\n.form-control-color.form-control-lg {\n  height: 2.875rem;\n}\n\n.form-select {\n  --bs-form-select-bg-img: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23111111\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"m7 10 5.5 5.5L18 10\"%3e%3c/path%3e%3c/svg%3e');\n  display: block;\n  width: 100%;\n  padding: 0.5rem 2.75rem 0.5rem 0.9375rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.7142857143;\n  color: #111111;\n  appearance: none;\n  background-color: transparent;\n  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: right 0.625rem center;\n  background-size: 24px 24px;\n  border: var(--bs-border-width) solid #dedede;\n  border-radius: 0;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: #304ffe;\n  outline: 0;\n  box-shadow: none;\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 0.9375rem;\n  background-image: none;\n}\n.form-select:disabled {\n  background-color: #fafafa;\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #111111;\n}\n\n.form-select-sm, .input-group-sm > .form-select {\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  padding-left: 0.9375rem;\n  font-size: 0.8125rem;\n  border-radius: 0;\n}\n\n.form-select-lg, .input-group-lg > .form-select {\n  padding-top: 0.6875rem;\n  padding-bottom: 0.6875rem;\n  padding-left: 0.9375rem;\n  font-size: 0.9375rem;\n  border-radius: 0;\n}\n\n.form-check {\n  display: block;\n  min-height: 1.75rem;\n  padding-left: 1.875rem;\n  margin-bottom: 1rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.875rem;\n}\n\n.form-check-reverse {\n  padding-right: 1.875rem;\n  padding-left: 0;\n  text-align: right;\n}\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -1.875rem;\n  margin-left: 0;\n}\n\n.form-check-input {\n  --bs-form-check-bg: #fff;\n  flex-shrink: 0;\n  width: 1.125rem;\n  height: 1.125rem;\n  margin-top: 0.3125rem;\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: 1px solid #b6b6b6;\n  print-color-adjust: exact;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-check-input {\n    transition: none;\n  }\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: #304ffe;\n  outline: 0;\n  box-shadow: none;\n}\n.form-check-input:checked {\n  background-color: #fff;\n  border-color: #b6b6b6;\n}\n.form-check-input:checked[type=checkbox] {\n  --bs-form-check-bg-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23343434\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"-12 -12 24 24\"%3e%3ccircle r=\"6\" fill=\"%23343434\"/%3e%3c/svg%3e');\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #fff;\n  border-color: #b6b6b6;\n  --bs-form-check-bg-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cline stroke=\"%23343434\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate%286.000000, 11.500000%29\" x1=\"12\" y1=\"0.5\" x2=\"4.99600361e-16\" y2=\"0.5\"%3e%3c/line%3e%3c/svg%3e');\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 1;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-check-label {\n  color: rgba(17, 17, 17, 0.84);\n  cursor: pointer;\n}\n\n.form-switch {\n  padding-left: 3.25rem;\n}\n.form-switch .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-9 -9 18 18'%3e%3ccircle r='7' fill='%23fff' style='filter: drop-shadow%280px 2px 1px rgb%2817 17 17 / 0.18%29%29' /%3e%3c/svg%3e\");\n  width: 2.25rem;\n  margin-left: -3.25rem;\n  background-image: var(--bs-form-switch-bg);\n  background-position: left center;\n  border-radius: 2.25rem;\n  transition: background-position 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-9 -9 18 18'%3e%3ccircle r='7' fill='%23fff' stroke='%23304ffe' stroke-width='0.6' style='filter: drop-shadow%280px 2px 1px rgb%2817 17 17 / 0.18%29%29' /%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-9 -9 18 18'%3e%3ccircle r='7' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-reverse {\n  padding-right: 3.25rem;\n  padding-left: 0;\n}\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -3.25rem;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1.9375rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  appearance: none;\n  background-color: transparent;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #fff, none;\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fff, none;\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  appearance: none;\n  background-color: #343434;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: #c2c2c2;\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  appearance: none;\n  background-color: #343434;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: #c2c2c2;\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: var(--bs-secondary-color);\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: var(--bs-secondary-color);\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  height: 100%;\n  padding: 1rem 0.9375rem;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: var(--bs-border-width) solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext {\n  padding: 1rem 0.9375rem;\n}\n.form-floating > .form-control::placeholder,\n.form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill,\n.form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-select ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:focus ~ label::after,\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after,\n.form-floating > .form-control-plaintext ~ label::after,\n.form-floating > .form-select ~ label::after {\n  position: absolute;\n  inset: 1rem 0.46875rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  background-color: transparent;\n  border-radius: 0;\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control-plaintext ~ label {\n  border-width: var(--bs-border-width) 0;\n}\n.form-floating > :disabled ~ label,\n.form-floating > .form-control:disabled ~ label {\n  color: #6c757d;\n}\n.form-floating > :disabled ~ label::after,\n.form-floating > .form-control:disabled ~ label::after {\n  background-color: #fafafa;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select,\n.input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus,\n.input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 0.9375rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.7142857143;\n  color: rgba(17, 17, 17, 0.64);\n  text-align: center;\n  white-space: nowrap;\n  background-color: #f2f2f2;\n  border: var(--bs-border-width) solid #dedede;\n  border-radius: 0;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.6875rem 0.9375rem;\n  font-size: 0.9375rem;\n  border-radius: 0;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.375rem 0.9375rem;\n  font-size: 0.8125rem;\n  border-radius: 0;\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 3.6875rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: calc(var(--bs-border-width) * -1);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .form-floating:not(:first-child) > .form-control,\n.input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.5rem;\n  font-size: 0.6875rem;\n  color: var(--bs-form-valid-color);\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.375rem 1rem;\n  margin-top: 0.1rem;\n  font-size: 0.75rem;\n  color: #fff;\n  background-color: var(--bs-success);\n  border-radius: 0.1875rem;\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n  padding-right: calc(1.7142857143em + 1rem);\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%2315ad5c\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n  background-repeat: no-repeat;\n  background-position: right calc(0.4285714286em + -0.0625rem) center;\n  background-size: calc(0.8571428572em + 0.5rem) calc(0.8571428572em + 0.5rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.7142857143em + 1rem);\n  background-position: top calc(0.4285714286em + -0.0625rem) right calc(0.4285714286em + -0.0625rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%2315ad5c\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n  padding-right: 5.09375rem;\n  background-position: right 0.625rem center, center right 2.75rem;\n  background-size: 24px 24px, 32px 32px;\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated .form-control-color:valid, .form-control-color.is-valid {\n  width: calc(3rem + calc(1.7142857143em + 1rem));\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: var(--bs-form-valid-color);\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: var(--bs-form-valid-color);\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,\n.was-validated .input-group > .form-select:not(:focus):valid,\n.input-group > .form-select:not(:focus).is-valid,\n.was-validated .input-group > .form-floating:not(:focus-within):valid,\n.input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.5rem;\n  font-size: 0.6875rem;\n  color: var(--bs-form-invalid-color);\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.375rem 1rem;\n  margin-top: 0.1rem;\n  font-size: 0.75rem;\n  color: #fff;\n  background-color: var(--bs-danger);\n  border-radius: 0.1875rem;\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n  padding-right: calc(1.7142857143em + 1rem);\n  background-image: url('data:image/svg+xml,%3csvg width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" d=\"M0 0h32v32H0z\"%3e%3c/path%3e%3cpath fill=\"%23e64949\" d=\"m24.928 24.116-8.4-15.6c-.21-.389-.847-.389-1.057 0l-8.4 15.6A.6.6 0 0 0 7.6 25h16.8a.6.6 0 0 0 .528-.884Zm-7.9-10.516-.428 6h-1.2l-.428-6h2.056ZM16 23.2a1.067 1.067 0 1 1 0-2.134 1.067 1.067 0 0 1 0 2.134Z\"%3e%3c/path%3e%3c/svg%3e');\n  background-repeat: no-repeat;\n  background-position: right calc(0.4285714286em + -0.0625rem) center;\n  background-size: calc(0.8571428572em + 0.5rem) calc(0.8571428572em + 0.5rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.7142857143em + 1rem);\n  background-position: top calc(0.4285714286em + -0.0625rem) right calc(0.4285714286em + -0.0625rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url('data:image/svg+xml,%3csvg width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" d=\"M0 0h32v32H0z\"%3e%3c/path%3e%3cpath fill=\"%23e64949\" d=\"m24.928 24.116-8.4-15.6c-.21-.389-.847-.389-1.057 0l-8.4 15.6A.6.6 0 0 0 7.6 25h16.8a.6.6 0 0 0 .528-.884Zm-7.9-10.516-.428 6h-1.2l-.428-6h2.056ZM16 23.2a1.067 1.067 0 1 1 0-2.134 1.067 1.067 0 0 1 0 2.134Z\"%3e%3c/path%3e%3c/svg%3e');\n  padding-right: 5.09375rem;\n  background-position: right 0.625rem center, center right 2.75rem;\n  background-size: 24px 24px, 32px 32px;\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated .form-control-color:invalid, .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.7142857143em + 1rem));\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: var(--bs-form-invalid-color);\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: var(--bs-form-invalid-color);\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .input-group > .form-select:not(:focus):invalid,\n.input-group > .form-select:not(:focus).is-invalid,\n.was-validated .input-group > .form-floating:not(:focus-within):invalid,\n.input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --bs-btn-padding-x: 1.25rem;\n  --bs-btn-padding-y: 0.3125rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 0.875rem;\n  --bs-btn-font-weight: 400;\n  --bs-btn-line-height: 2;\n  --bs-btn-color: var(--bs-body-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: var(--bs-border-width);\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: 0.3125rem;\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n  --bs-btn-disabled-opacity: 0.5;\n  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: var(--bs-btn-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n.btn-check + .btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n.btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n}\n.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n}\n\n.btn-primary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #0d6efd;\n  --bs-btn-border-color: #0d6efd;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0b5ed7;\n  --bs-btn-hover-border-color: #0a58ca;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0a58ca;\n  --bs-btn-active-border-color: #0a53be;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #0d6efd;\n  --bs-btn-disabled-border-color: #0d6efd;\n}\n\n.btn-secondary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #6c757d;\n  --bs-btn-border-color: #6c757d;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #5c636a;\n  --bs-btn-hover-border-color: #565e64;\n  --bs-btn-focus-shadow-rgb: 130, 138, 145;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #565e64;\n  --bs-btn-active-border-color: #51585e;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #6c757d;\n  --bs-btn-disabled-border-color: #6c757d;\n}\n\n.btn-success {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #2ee68c;\n  --bs-btn-border-color: #2ee68c;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #4dea9d;\n  --bs-btn-hover-border-color: #43e998;\n  --bs-btn-focus-shadow-rgb: 39, 196, 119;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #58eba3;\n  --bs-btn-active-border-color: #43e998;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #2ee68c;\n  --bs-btn-disabled-border-color: #2ee68c;\n}\n\n.btn-info {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #4fc3f7;\n  --bs-btn-border-color: #4fc3f7;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #69ccf8;\n  --bs-btn-hover-border-color: #61c9f8;\n  --bs-btn-focus-shadow-rgb: 67, 166, 210;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #72cff9;\n  --bs-btn-active-border-color: #61c9f8;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #4fc3f7;\n  --bs-btn-disabled-border-color: #4fc3f7;\n}\n\n.btn-warning {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #ffee5c;\n  --bs-btn-border-color: #ffee5c;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #fff174;\n  --bs-btn-hover-border-color: #fff06c;\n  --bs-btn-focus-shadow-rgb: 217, 202, 78;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #fff17d;\n  --bs-btn-active-border-color: #fff06c;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #ffee5c;\n  --bs-btn-disabled-border-color: #ffee5c;\n}\n\n.btn-danger {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #ff7591;\n  --bs-btn-border-color: #ff7591;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ff8aa2;\n  --bs-btn-hover-border-color: #ff839c;\n  --bs-btn-focus-shadow-rgb: 217, 99, 123;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ff91a7;\n  --bs-btn-active-border-color: #ff839c;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #ff7591;\n  --bs-btn-disabled-border-color: #ff7591;\n}\n\n.btn-light {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #f2f2f2;\n  --bs-btn-border-color: #f2f2f2;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #cecece;\n  --bs-btn-hover-border-color: #c2c2c2;\n  --bs-btn-focus-shadow-rgb: 206, 206, 206;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #c2c2c2;\n  --bs-btn-active-border-color: #b6b6b6;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #f2f2f2;\n  --bs-btn-disabled-border-color: #f2f2f2;\n}\n\n.btn-dark {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #111111;\n  --bs-btn-border-color: #111111;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #353535;\n  --bs-btn-hover-border-color: #292929;\n  --bs-btn-focus-shadow-rgb: 53, 53, 53;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #414141;\n  --bs-btn-active-border-color: #292929;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #111111;\n  --bs-btn-disabled-border-color: #111111;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #0d6efd;\n  --bs-btn-border-color: #0d6efd;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #0d6efd;\n  --bs-btn-hover-border-color: #0d6efd;\n  --bs-btn-focus-shadow-rgb: 13, 110, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #0d6efd;\n  --bs-btn-active-border-color: #0d6efd;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #0d6efd;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #0d6efd;\n  --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n  --bs-btn-color: #6c757d;\n  --bs-btn-border-color: #6c757d;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #6c757d;\n  --bs-btn-hover-border-color: #6c757d;\n  --bs-btn-focus-shadow-rgb: 108, 117, 125;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #6c757d;\n  --bs-btn-active-border-color: #6c757d;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #6c757d;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #6c757d;\n  --bs-gradient: none;\n}\n\n.btn-outline-success {\n  --bs-btn-color: #2ee68c;\n  --bs-btn-border-color: #2ee68c;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #2ee68c;\n  --bs-btn-hover-border-color: #2ee68c;\n  --bs-btn-focus-shadow-rgb: 46, 230, 140;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #2ee68c;\n  --bs-btn-active-border-color: #2ee68c;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #2ee68c;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #2ee68c;\n  --bs-gradient: none;\n}\n\n.btn-outline-info {\n  --bs-btn-color: #4fc3f7;\n  --bs-btn-border-color: #4fc3f7;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #4fc3f7;\n  --bs-btn-hover-border-color: #4fc3f7;\n  --bs-btn-focus-shadow-rgb: 79, 195, 247;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #4fc3f7;\n  --bs-btn-active-border-color: #4fc3f7;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #4fc3f7;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #4fc3f7;\n  --bs-gradient: none;\n}\n\n.btn-outline-warning {\n  --bs-btn-color: #ffee5c;\n  --bs-btn-border-color: #ffee5c;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ffee5c;\n  --bs-btn-hover-border-color: #ffee5c;\n  --bs-btn-focus-shadow-rgb: 255, 238, 92;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ffee5c;\n  --bs-btn-active-border-color: #ffee5c;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffee5c;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ffee5c;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger {\n  --bs-btn-color: #ff7591;\n  --bs-btn-border-color: #ff7591;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ff7591;\n  --bs-btn-hover-border-color: #ff7591;\n  --bs-btn-focus-shadow-rgb: 255, 117, 145;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ff7591;\n  --bs-btn-active-border-color: #ff7591;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ff7591;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ff7591;\n  --bs-gradient: none;\n}\n\n.btn-outline-light {\n  --bs-btn-color: #f2f2f2;\n  --bs-btn-border-color: #f2f2f2;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #f2f2f2;\n  --bs-btn-hover-border-color: #f2f2f2;\n  --bs-btn-focus-shadow-rgb: 242, 242, 242;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #f2f2f2;\n  --bs-btn-active-border-color: #f2f2f2;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f2f2f2;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f2f2f2;\n  --bs-gradient: none;\n}\n\n.btn-outline-dark {\n  --bs-btn-color: #111111;\n  --bs-btn-border-color: #111111;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #111111;\n  --bs-btn-hover-border-color: #111111;\n  --bs-btn-focus-shadow-rgb: 17, 17, 17;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #111111;\n  --bs-btn-active-border-color: #111111;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #111111;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #111111;\n  --bs-gradient: none;\n}\n\n.btn-link, .btn-brand-quartenary,\n.btn-darker-quartenary,\n.btn-standard-quartenary {\n  --bs-btn-font-weight: 400;\n  --bs-btn-color: var(--bs-link-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: var(--bs-link-hover-color);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: var(--bs-link-hover-color);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: #6c757d;\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: 0 0 0 #000;\n  --bs-btn-focus-shadow-rgb: 38, 75, 198;\n  text-decoration: none;\n}\n.btn-link:hover, .btn-brand-quartenary:hover,\n.btn-darker-quartenary:hover,\n.btn-standard-quartenary:hover, .btn-link:focus-visible, .btn-brand-quartenary:focus-visible,\n.btn-darker-quartenary:focus-visible,\n.btn-standard-quartenary:focus-visible {\n  text-decoration: underline;\n}\n.btn-link:focus-visible, .btn-brand-quartenary:focus-visible,\n.btn-darker-quartenary:focus-visible,\n.btn-standard-quartenary:focus-visible {\n  color: var(--bs-btn-color);\n}\n.btn-link:hover, .btn-brand-quartenary:hover,\n.btn-darker-quartenary:hover,\n.btn-standard-quartenary:hover {\n  color: var(--bs-btn-hover-color);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  --bs-btn-padding-y: 0.5rem;\n  --bs-btn-padding-x: 1.5625rem;\n  --bs-btn-font-size: 0.9375rem;\n  --bs-btn-border-radius: 0.3125rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  --bs-btn-padding-y: 0.3125rem;\n  --bs-btn-padding-x: 1.125rem;\n  --bs-btn-font-size: 0.8125rem;\n  --bs-btn-border-radius: 0.3125rem;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.5rem;\n  --bs-dropdown-spacer: 0.125rem;\n  --bs-dropdown-font-size: 0.875rem;\n  --bs-dropdown-color: rgba(17, 17, 17, 0.64);\n  --bs-dropdown-bg: var(--bs-body-bg);\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-border-radius: 0;\n  --bs-dropdown-border-width: 0;\n  --bs-dropdown-inner-border-radius: calc(0 - 0);\n  --bs-dropdown-divider-bg: #ededed;\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: 0 1.25rem 1.875rem rgba(35, 35, 35, 0.2);\n  --bs-dropdown-link-color: rgba(17, 17, 17, 0.64);\n  --bs-dropdown-link-hover-color: #111111;\n  --bs-dropdown-link-hover-bg: #fafafa;\n  --bs-dropdown-link-active-color: #111111;\n  --bs-dropdown-link-active-bg: #f2f2f2;\n  --bs-dropdown-link-disabled-color: rgba(17, 17, 17, 0.4);\n  --bs-dropdown-item-padding-x: 0.9375rem;\n  --bs-dropdown-item-padding-y: 0.5rem;\n  --bs-dropdown-header-color: #111111;\n  --bs-dropdown-header-padding-x: 0.9375rem;\n  --bs-dropdown-header-padding-y: 0.75rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  border-radius: var(--bs-dropdown-item-border-radius, 0);\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: rgba(255, 255, 255, 0.64);\n  --bs-dropdown-bg: #232323;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: 0 1.25rem 1.875rem rgba(17, 17, 17, 0.6);\n  --bs-dropdown-link-color: rgba(255, 255, 255, 0.64);\n  --bs-dropdown-link-hover-color: #fff;\n  --bs-dropdown-divider-bg: #404040;\n  --bs-dropdown-link-hover-bg: #343434;\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #404040;\n  --bs-dropdown-link-disabled-color: #adb5bd;\n  --bs-dropdown-header-color: #adb5bd;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: 0.3125rem;\n}\n.btn-group > :not(.btn-check:first-child) + .btn,\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: calc(var(--bs-border-width) * -1);\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn.dropdown-toggle-split:first-child,\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.9375rem;\n  padding-left: 0.9375rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.84375rem;\n  padding-left: 0.84375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 1.171875rem;\n  padding-left: 1.171875rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: calc(var(--bs-border-width) * -1);\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --bs-nav-link-padding-x: 1.25rem;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-size: 0.875rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: rgba(17, 17, 17, 0.64);\n  --bs-nav-link-hover-color: #111111;\n  --bs-nav-link-disabled-color: rgba(17, 17, 17, 0.5);\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  background: none;\n  border: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n  text-decoration: none;\n}\n.nav-link:focus-visible {\n  outline: 0;\n  box-shadow: none;\n}\n.nav-link.disabled, .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-width: var(--bs-border-width);\n  --bs-nav-tabs-border-color: #cccccc;\n  --bs-nav-tabs-border-radius: 0;\n  --bs-nav-tabs-link-hover-border-color: #111111 #111111 transparent;\n  --bs-nav-tabs-link-active-color: rgba(17, 17, 17, 0.84);\n  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);\n  --bs-nav-tabs-link-active-border-color: #cccccc #cccccc transparent;\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: 0;\n  --bs-nav-pills-link-active-color: rgba(255, 255, 255, 0.92);\n  --bs-nav-pills-link-active-bg: #666666;\n}\n.nav-pills .nav-link {\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-underline {\n  --bs-nav-underline-gap: 1rem;\n  --bs-nav-underline-border-width: 0.125rem;\n  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n  gap: var(--bs-nav-underline-gap);\n}\n.nav-underline .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: var(--bs-nav-underline-border-width) solid transparent;\n}\n.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {\n  border-bottom-color: currentcolor;\n}\n.nav-underline .nav-link.active,\n.nav-underline .show > .nav-link {\n  font-weight: 700;\n  color: var(--bs-nav-underline-link-active-color);\n  border-bottom-color: currentcolor;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0.3125rem;\n  --bs-navbar-color: rgba(17, 17, 17, 0.64);\n  --bs-navbar-hover-color: #111111;\n  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);\n  --bs-navbar-active-color: rgba(17, 17, 17, 0.92);\n  --bs-navbar-brand-padding-y: 0;\n  --bs-navbar-brand-margin-end: 1.5625rem;\n  --bs-navbar-brand-font-size: 1rem;\n  --bs-navbar-brand-color: #111111;\n  --bs-navbar-brand-hover-color: rgba(17, 17, 17, 0.92);\n  --bs-navbar-nav-link-padding-x: 0.625rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0.75rem;\n  --bs-navbar-toggler-font-size: 1.25rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2817, 17, 17, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);\n  --bs-navbar-toggler-border-radius: 0.3125rem;\n  --bs-navbar-toggler-focus-width: 0.25rem;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n  text-decoration: none;\n}\n\n.navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-size: 0.875rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {\n  color: var(--bs-navbar-active-color);\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-navbar-color);\n}\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  transition: none;\n}\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=dark] {\n  --bs-navbar-color: rgba(255, 255, 255, 0.55);\n  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --bs-navbar-active-color: #fff;\n  --bs-navbar-brand-color: #fff;\n  --bs-navbar-brand-hover-color: #fff;\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --bs-card-spacer-y: 1.25rem;\n  --bs-card-spacer-x: 1.5625rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-title-color: ;\n  --bs-card-subtitle-color: ;\n  --bs-card-border-width: 0;\n  --bs-card-border-color: #dedede;\n  --bs-card-border-radius: 0;\n  --bs-card-box-shadow: ;\n  --bs-card-inner-border-radius: 0;\n  --bs-card-cap-padding-y: 0.625rem;\n  --bs-card-cap-padding-x: 1.5625rem;\n  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: var(--bs-body-bg);\n  --bs-card-img-overlay-padding: 1.5625rem;\n  --bs-card-group-margin: 0.9375rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  color: var(--bs-body-color);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n  color: var(--bs-card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n  color: var(--bs-card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link:hover {\n  text-decoration: none;\n}\n.card-link + .card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group > .card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --bs-accordion-color: #111111;\n  --bs-accordion-bg: #fff;\n  --bs-accordion-transition: border-radius 0.15s ease;\n  --bs-accordion-border-color: #dedede;\n  --bs-accordion-border-width: var(--bs-border-width);\n  --bs-accordion-border-radius: 0;\n  --bs-accordion-inner-border-radius: 0.75rem;\n  --bs-accordion-btn-padding-x: 1.1875rem;\n  --bs-accordion-btn-padding-y: 0.6875rem;\n  --bs-accordion-btn-color: #111111;\n  --bs-accordion-btn-bg: #fff;\n  --bs-accordion-btn-icon: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23111111\" vector-effect=\"non-scaling-stroke\" opacity=\"1\" d=\"m7 10 5.5 5.5L18 10\"%3e%3c/path%3e%3c/svg%3e');\n  --bs-accordion-btn-icon-width: 1.5rem;\n  --bs-accordion-btn-icon-transform: rotate(180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23111111\" vector-effect=\"non-scaling-stroke\" opacity=\"1\" d=\"m7 10 5.5 5.5L18 10\"%3e%3c/path%3e%3c/svg%3e');\n  --bs-accordion-btn-focus-border-color: #304ffe;\n  --bs-accordion-btn-focus-box-shadow: none;\n  --bs-accordion-body-padding-x: 1.25rem;\n  --bs-accordion-body-padding-y: 1rem;\n  --bs-accordion-active-color: #111111;\n  --bs-accordion-active-bg: #fff;\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 1rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  border-color: var(--bs-accordion-btn-focus-border-color);\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:last-of-type .accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush .accordion-collapse {\n  border-width: 0;\n}\n.accordion-flush .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {\n  border-radius: 0;\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 0;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-font-size: 0.75rem;\n  --bs-breadcrumb-bg: ;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: var(--bs-secondary-color);\n  --bs-breadcrumb-item-padding-x: 0.5rem;\n  --bs-breadcrumb-item-active-color: rgba(17, 17, 17, 0.5);\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"9\" height=\"9\"%3e%3cpath fill=\"none\" stroke=\"%23111111\" stroke-linecap=\"square\" d=\"m2.8 1 3.5 3.5L2.8 8\" opacity=\".4\"/%3e%3c/svg%3e')) /* rtl: var(--bs-breadcrumb-divider, url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"9\" height=\"9\"%3e%3cpath fill=\"none\" stroke=\"%23111111\" stroke-linecap=\"square\" d=\"m2.8 1 3.5 3.5L2.8 8\" opacity=\".4\"/%3e%3c/svg%3e')) */;\n}\n.breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.9rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 0.8125rem;\n  --bs-pagination-color: rgba(17, 17, 17, 0.64);\n  --bs-pagination-bg: transparent;\n  --bs-pagination-border-width: 0;\n  --bs-pagination-border-color: var(--bs-border-color);\n  --bs-pagination-border-radius: var(--bs-border-radius);\n  --bs-pagination-hover-color: #111111;\n  --bs-pagination-hover-bg: rgba(17, 17, 17, 0.06);\n  --bs-pagination-hover-border-color: var(--bs-border-color);\n  --bs-pagination-focus-color: rgba(17, 17, 17, 0.64);\n  --bs-pagination-focus-bg: transparent;\n  --bs-pagination-focus-box-shadow: none;\n  --bs-pagination-active-color: #fff;\n  --bs-pagination-active-bg: #111111;\n  --bs-pagination-active-border-color: #343434;\n  --bs-pagination-disabled-color: rgba(17, 17, 17, 0.5);\n  --bs-pagination-disabled-bg: transparent;\n  --bs-pagination-disabled-border-color: var(--bs-border-color);\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: none;\n}\n.page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n.page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n.page-link.active, .active > .page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n.page-link.disabled, .disabled > .page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: calc(0 * -1);\n}\n.page-item:first-child .page-link {\n  border-top-left-radius: var(--bs-pagination-border-radius);\n  border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: var(--bs-pagination-border-radius);\n  border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n  --bs-pagination-padding-x: 1.5rem;\n  --bs-pagination-padding-y: 0.75rem;\n  --bs-pagination-font-size: 1.25rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-lg);\n}\n\n.pagination-sm {\n  --bs-pagination-padding-x: 0.9rem;\n  --bs-pagination-padding-y: 0.25rem;\n  --bs-pagination-font-size: 0.875rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-sm);\n}\n\n.badge {\n  --bs-badge-padding-x: 0.9em;\n  --bs-badge-padding-y: 0.3em;\n  --bs-badge-font-size: 62.5%;\n  --bs-badge-font-weight: normal;\n  --bs-badge-color: #111111;\n  --bs-badge-border-radius: var(--bs-border-radius);\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 1.25rem;\n  --bs-alert-padding-y: 0.5rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: 0.1875rem;\n  --bs-alert-link-color: inherit;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 300;\n  color: var(--bs-alert-link-color);\n}\n\n.alert-dismissible {\n  padding-right: 3.75rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 0.625rem 1.25rem;\n}\n\n.alert-primary {\n  --bs-alert-color: var(--bs-primary-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-text-emphasis);\n}\n\n.alert-secondary {\n  --bs-alert-color: var(--bs-secondary-text-emphasis);\n  --bs-alert-bg: var(--bs-secondary-bg-subtle);\n  --bs-alert-border-color: var(--bs-secondary-border-subtle);\n  --bs-alert-link-color: var(--bs-secondary-text-emphasis);\n}\n\n.alert-success {\n  --bs-alert-color: var(--bs-success-text-emphasis);\n  --bs-alert-bg: var(--bs-success-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-border-subtle);\n  --bs-alert-link-color: var(--bs-success-text-emphasis);\n}\n\n.alert-info {\n  --bs-alert-color: var(--bs-info-text-emphasis);\n  --bs-alert-bg: var(--bs-info-bg-subtle);\n  --bs-alert-border-color: var(--bs-info-border-subtle);\n  --bs-alert-link-color: var(--bs-info-text-emphasis);\n}\n\n.alert-warning {\n  --bs-alert-color: var(--bs-warning-text-emphasis);\n  --bs-alert-bg: var(--bs-warning-bg-subtle);\n  --bs-alert-border-color: var(--bs-warning-border-subtle);\n  --bs-alert-link-color: var(--bs-warning-text-emphasis);\n}\n\n.alert-danger {\n  --bs-alert-color: var(--bs-danger-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-text-emphasis);\n}\n\n.alert-light {\n  --bs-alert-color: var(--bs-light-text-emphasis);\n  --bs-alert-bg: var(--bs-light-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-border-subtle);\n  --bs-alert-link-color: var(--bs-light-text-emphasis);\n}\n\n.alert-dark {\n  --bs-alert-color: var(--bs-dark-text-emphasis);\n  --bs-alert-bg: var(--bs-dark-bg-subtle);\n  --bs-alert-border-color: var(--bs-dark-border-subtle);\n  --bs-alert-link-color: var(--bs-dark-text-emphasis);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 0.3125rem;\n  }\n}\n.progress,\n.progress-stacked {\n  --bs-progress-height: 0.3125rem;\n  --bs-progress-font-size: 0.6875rem;\n  --bs-progress-bg: #ededed;\n  --bs-progress-border-radius: 0;\n  --bs-progress-box-shadow: var(--bs-box-shadow-inset);\n  --bs-progress-bar-color: #fff;\n  --bs-progress-bar-bg: #767676;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --bs-list-group-color: rgba(17, 17, 17, 0.64);\n  --bs-list-group-bg: var(--bs-body-bg);\n  --bs-list-group-border-color: #f2f2f2;\n  --bs-list-group-border-width: var(--bs-border-width);\n  --bs-list-group-border-radius: 0;\n  --bs-list-group-item-padding-x: 0.9375rem;\n  --bs-list-group-item-padding-y: 0;\n  --bs-list-group-action-color: var(--bs-secondary-color);\n  --bs-list-group-action-hover-color: #111111;\n  --bs-list-group-action-hover-bg: #f2f2f2;\n  --bs-list-group-action-active-color: rgba(17, 17, 17, 0.84);\n  --bs-list-group-action-active-bg: #fafafa;\n  --bs-list-group-disabled-color: #111111;\n  --bs-list-group-disabled-bg: var(--bs-body-bg);\n  --bs-list-group-active-color: rgba(17, 17, 17, 0.84);\n  --bs-list-group-active-bg: #fafafa;\n  --bs-list-group-active-border-color: #f2f2f2;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n.list-group-item-action:active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n.list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  --bs-list-group-color: var(--bs-primary-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);\n}\n\n.list-group-item-secondary {\n  --bs-list-group-color: var(--bs-secondary-text-emphasis);\n  --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);\n}\n\n.list-group-item-success {\n  --bs-list-group-color: var(--bs-success-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);\n}\n\n.list-group-item-info {\n  --bs-list-group-color: var(--bs-info-text-emphasis);\n  --bs-list-group-bg: var(--bs-info-bg-subtle);\n  --bs-list-group-border-color: var(--bs-info-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);\n  --bs-list-group-active-color: var(--bs-info-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-info-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);\n}\n\n.list-group-item-warning {\n  --bs-list-group-color: var(--bs-warning-text-emphasis);\n  --bs-list-group-bg: var(--bs-warning-bg-subtle);\n  --bs-list-group-border-color: var(--bs-warning-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-active-color: var(--bs-warning-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);\n}\n\n.list-group-item-danger {\n  --bs-list-group-color: var(--bs-danger-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);\n}\n\n.list-group-item-light {\n  --bs-list-group-color: var(--bs-light-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);\n}\n\n.list-group-item-dark {\n  --bs-list-group-color: var(--bs-dark-text-emphasis);\n  --bs-list-group-bg: var(--bs-dark-bg-subtle);\n  --bs-list-group-border-color: var(--bs-dark-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-active-color: var(--bs-dark-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);\n}\n\n.btn-close {\n  --bs-btn-close-color: #111111;\n  --bs-btn-close-bg: url('data:image/svg+xml,%3csvg width=\"100%25\" height=\"100%25\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath stroke=\"%23111111\" stroke-linecap=\"square\" fill=\"none\" d=\"M16.2 7.8l-8.4 8.4m8.4 0L7.8 7.8\"%3e%3c/path%3e%3c/svg%3e');\n  --bs-btn-close-opacity: 0.5;\n  --bs-btn-close-hover-opacity: 0.8;\n  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  --bs-btn-close-focus-opacity: 0.5;\n  --bs-btn-close-disabled-opacity: 0.25;\n  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n  box-sizing: content-box;\n  width: 1.5rem;\n  height: 1.5rem;\n  padding: 0 0;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/1.5rem auto no-repeat;\n  border: 0;\n  border-radius: 0.3125rem;\n  opacity: var(--bs-btn-close-opacity);\n}\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n.toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 0.75rem;\n  --bs-toast-max-width: 255px;\n  --bs-toast-font-size: 0.8125rem;\n  --bs-toast-color: rgba(255, 255, 255, 0.64);\n  --bs-toast-bg: #232323;\n  --bs-toast-border-width: 0;\n  --bs-toast-border-color: transparent;\n  --bs-toast-border-radius: 0;\n  --bs-toast-box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);\n  --bs-toast-header-color: #fff;\n  --bs-toast-header-bg: transparent;\n  --bs-toast-header-border-color: #404040;\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n.toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 540px;\n  --bs-modal-padding: 1rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: ;\n  --bs-modal-bg: var(--bs-body-bg);\n  --bs-modal-border-color: transparent;\n  --bs-modal-border-width: 0;\n  --bs-modal-border-radius: 0.3125rem;\n  --bs-modal-box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);\n  --bs-modal-inner-border-radius: 0.3125rem;\n  --bs-modal-header-padding-x: 1rem;\n  --bs-modal-header-padding-y: 1rem;\n  --bs-modal-header-padding: 1rem 1rem;\n  --bs-modal-header-border-color: transparent;\n  --bs-modal-header-border-width: 0;\n  --bs-modal-title-line-height: 1.75;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: #ededed;\n  --bs-modal-footer-border-width: 1px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #000;\n  --bs-backdrop-opacity: 0.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-footer > * {\n  margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: var(--bs-box-shadow);\n  }\n  .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n  .modal-sm {\n    --bs-modal-width: 285px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    --bs-modal-width: 980px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    --bs-modal-width: 1110px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header,\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header,\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header,\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header,\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header,\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.tooltip {\n  --bs-tooltip-zindex: 1080;\n  --bs-tooltip-max-width: 200px;\n  --bs-tooltip-padding-x: 1rem;\n  --bs-tooltip-padding-y: 0.375rem;\n  --bs-tooltip-margin: ;\n  --bs-tooltip-font-size: 0.75rem;\n  --bs-tooltip-color: #fff;\n  --bs-tooltip-bg: #343434;\n  --bs-tooltip-border-radius: 0.1875rem;\n  --bs-tooltip-opacity: 1;\n  --bs-tooltip-arrow-width: 0.875rem;\n  --bs-tooltip-arrow-height: 0.4375rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  margin: var(--bs-tooltip-margin);\n  font-family: \"Roboto\", Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.75;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 240px;\n  --bs-popover-font-size: 0.8125rem;\n  --bs-popover-bg: var(--bs-body-bg);\n  --bs-popover-border-width: 0px;\n  --bs-popover-border-color: var(--bs-border-color-translucent);\n  --bs-popover-border-radius: 0.3125rem;\n  --bs-popover-inner-border-radius: calc(0.3125rem - 0px);\n  --bs-popover-box-shadow: var(--bs-box-shadow);\n  --bs-popover-header-padding-x: 1rem;\n  --bs-popover-header-padding-y: 0.5rem;\n  --bs-popover-header-font-size: 1rem;\n  --bs-popover-header-color: #111111;\n  --bs-popover-header-bg: transparent;\n  --bs-popover-body-padding-x: 1rem;\n  --bs-popover-body-padding-y: 1rem;\n  --bs-popover-body-color: var(--bs-body-color);\n  --bs-popover-arrow-width: 1.1875rem;\n  --bs-popover-arrow-height: 0.625rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: \"Roboto\", Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.75;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n}\n.popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.2em;\n  --bs-spinner-border-width: 0.25em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.2em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    --bs-spinner-animation-speed: 1.5s;\n  }\n}\n.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 320px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 0.9375rem;\n  --bs-offcanvas-padding-y: 1.125rem;\n  --bs-offcanvas-color: var(--bs-body-color);\n  --bs-offcanvas-bg: var(--bs-body-bg);\n  --bs-offcanvas-border-width: 1px;\n  --bs-offcanvas-border-color: #ededed;\n  --bs-offcanvas-box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);\n  --bs-offcanvas-transition: transform 0.3s ease-in-out;\n  --bs-offcanvas-title-line-height: 1.75;\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-sm {\n    transition: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 576px) {\n  .offcanvas-sm {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-md {\n    transition: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 768px) {\n  .offcanvas-md {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-lg {\n    transition: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 992px) {\n  .offcanvas-lg {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xl {\n    transition: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .offcanvas-xl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxl {\n    transition: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .offcanvas-xxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--bs-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--bs-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--bs-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  transition: var(--bs-offcanvas-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n.offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--bs-offcanvas-width);\n  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n.offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--bs-offcanvas-width);\n  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(100%);\n}\n.offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n.offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(100%);\n}\n.offcanvas.showing, .offcanvas.show:not(.hiding) {\n  transform: none;\n}\n.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {\n  visibility: visible;\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #fff;\n}\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.offcanvas-backdrop.show {\n  opacity: 0.8;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n.offcanvas-header .btn-close {\n  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));\n  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));\n  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--bs-offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n  overflow-y: auto;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-primary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: RGBA(7, 55, 127, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(7, 55, 127, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary {\n  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: RGBA(54, 59, 63, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(54, 59, 63, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success {\n  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-success:hover, .link-success:focus {\n  color: RGBA(151, 243, 198, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(151, 243, 198, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info {\n  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-info:hover, .link-info:focus {\n  color: RGBA(167, 225, 251, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(167, 225, 251, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning {\n  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: RGBA(255, 247, 174, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 247, 174, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger {\n  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: RGBA(255, 186, 200, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 186, 200, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light {\n  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light:hover, .link-light:focus {\n  color: RGBA(249, 249, 249, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(249, 249, 249, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark {\n  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: RGBA(9, 9, 9, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(9, 9, 9, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-body-emphasis:hover, .link-body-emphasis:focus {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n}\n\n.focus-ring:focus {\n  outline: 0;\n  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);\n}\n\n.icon-link {\n  display: inline-flex;\n  gap: 0.375rem;\n  align-items: center;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-underline-offset: 0.25em;\n  backface-visibility: hidden;\n}\n.icon-link > .bi {\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  fill: currentcolor;\n  transition: 0.2s ease-in-out transform;\n}\n@media (prefers-reduced-motion: reduce) {\n  .icon-link > .bi {\n    transition: none;\n  }\n}\n\n.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {\n  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n  position: absolute !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: var(--bs-border-width);\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-10 {\n  opacity: 0.1 !important;\n}\n\n.opacity-20 {\n  opacity: 0.2 !important;\n}\n\n.opacity-30 {\n  opacity: 0.3 !important;\n}\n\n.opacity-40 {\n  opacity: 0.4 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-60 {\n  opacity: 0.6 !important;\n}\n\n.opacity-70 {\n  opacity: 0.7 !important;\n}\n\n.opacity-80 {\n  opacity: 0.8 !important;\n}\n\n.opacity-90 {\n  opacity: 0.9 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-inline-grid {\n  display: inline-grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2) !important;\n}\n\n.shadow-xs {\n  box-shadow: 0 0.625rem 1.25rem rgba(35, 35, 35, 0.08) !important;\n}\n\n.shadow-sm {\n  box-shadow: 0 0.5625rem 0.875rem rgba(35, 35, 35, 0.14) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 1.25rem 1.875rem rgba(35, 35, 35, 0.2) !important;\n}\n\n.shadow-xl {\n  box-shadow: 0 1.875rem 2.5rem rgba(35, 35, 35, 0.26) !important;\n}\n\n.shadow-dark-xs {\n  box-shadow: 0 0.625rem 1.25rem rgba(17, 17, 17, 0.5) !important;\n}\n\n.shadow-dark-sm {\n  box-shadow: 0 0.5625rem 0.875rem rgba(17, 17, 17, 0.5) !important;\n}\n\n.shadow-dark {\n  box-shadow: 0 0.75rem 1rem rgba(17, 17, 17, 0.5) !important;\n}\n\n.shadow-dark-lg {\n  box-shadow: 0 1.25rem 1.875rem rgba(17, 17, 17, 0.6) !important;\n}\n\n.shadow-dark-xl {\n  box-shadow: 0 1.875rem 2.5rem rgba(17, 17, 17, 0.7) !important;\n}\n\n.shadow-nm-up {\n  box-shadow: 12px 12px 24px rgba(0, 0, 0, 0.12), -12px -12px 24px #fff !important;\n}\n\n.shadow-nm-down {\n  box-shadow: inset 8px 8px 12px rgba(0, 0, 0, 0.12), inset -8px -8px 12px rgba(255, 255, 255, 0.54) !important;\n}\n\n.shadow-nm-dark-up {\n  box-shadow: 12px 12px 24px 0 rgba(0, 0, 0, 0.6), -12px -12px 24px 0 rgba(255, 255, 255, 0.06) !important;\n}\n\n.shadow-nm-dark-down {\n  box-shadow: inset 8px 8px 12px 0 rgba(0, 0, 0, 0.32), inset -8px -8px 12px 0 rgba(255, 255, 255, 0.04) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.focus-ring-primary {\n  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-secondary {\n  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success {\n  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info {\n  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-warning {\n  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger {\n  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-light {\n  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-dark {\n  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: #ededed !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-black {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.125rem !important;\n}\n\n.m-2 {\n  margin: 0.25rem !important;\n}\n\n.m-3 {\n  margin: 0.5rem !important;\n}\n\n.m-4 {\n  margin: 1rem !important;\n}\n\n.m-5 {\n  margin: 1.5rem !important;\n}\n\n.m-6 {\n  margin: 2rem !important;\n}\n\n.m-7 {\n  margin: 2.5rem !important;\n}\n\n.m-8 {\n  margin: 3rem !important;\n}\n\n.m-9 {\n  margin: 3.5rem !important;\n}\n\n.m-10 {\n  margin: 4rem !important;\n}\n\n.m-11 {\n  margin: 5rem !important;\n}\n\n.m-12 {\n  margin: 6rem !important;\n}\n\n.m-13 {\n  margin: 6.5rem !important;\n}\n\n.m-14 {\n  margin: 8rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.125rem !important;\n  margin-left: 0.125rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-3 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-4 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-5 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-6 {\n  margin-right: 2rem !important;\n  margin-left: 2rem !important;\n}\n\n.mx-7 {\n  margin-right: 2.5rem !important;\n  margin-left: 2.5rem !important;\n}\n\n.mx-8 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-9 {\n  margin-right: 3.5rem !important;\n  margin-left: 3.5rem !important;\n}\n\n.mx-10 {\n  margin-right: 4rem !important;\n  margin-left: 4rem !important;\n}\n\n.mx-11 {\n  margin-right: 5rem !important;\n  margin-left: 5rem !important;\n}\n\n.mx-12 {\n  margin-right: 6rem !important;\n  margin-left: 6rem !important;\n}\n\n.mx-13 {\n  margin-right: 6.5rem !important;\n  margin-left: 6.5rem !important;\n}\n\n.mx-14 {\n  margin-right: 8rem !important;\n  margin-left: 8rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.125rem !important;\n  margin-bottom: 0.125rem !important;\n}\n\n.my-2 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-3 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-4 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-5 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-6 {\n  margin-top: 2rem !important;\n  margin-bottom: 2rem !important;\n}\n\n.my-7 {\n  margin-top: 2.5rem !important;\n  margin-bottom: 2.5rem !important;\n}\n\n.my-8 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-9 {\n  margin-top: 3.5rem !important;\n  margin-bottom: 3.5rem !important;\n}\n\n.my-10 {\n  margin-top: 4rem !important;\n  margin-bottom: 4rem !important;\n}\n\n.my-11 {\n  margin-top: 5rem !important;\n  margin-bottom: 5rem !important;\n}\n\n.my-12 {\n  margin-top: 6rem !important;\n  margin-bottom: 6rem !important;\n}\n\n.my-13 {\n  margin-top: 6.5rem !important;\n  margin-bottom: 6.5rem !important;\n}\n\n.my-14 {\n  margin-top: 8rem !important;\n  margin-bottom: 8rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.125rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-3 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-4 {\n  margin-top: 1rem !important;\n}\n\n.mt-5 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-6 {\n  margin-top: 2rem !important;\n}\n\n.mt-7 {\n  margin-top: 2.5rem !important;\n}\n\n.mt-8 {\n  margin-top: 3rem !important;\n}\n\n.mt-9 {\n  margin-top: 3.5rem !important;\n}\n\n.mt-10 {\n  margin-top: 4rem !important;\n}\n\n.mt-11 {\n  margin-top: 5rem !important;\n}\n\n.mt-12 {\n  margin-top: 6rem !important;\n}\n\n.mt-13 {\n  margin-top: 6.5rem !important;\n}\n\n.mt-14 {\n  margin-top: 8rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.125rem !important;\n}\n\n.me-2 {\n  margin-right: 0.25rem !important;\n}\n\n.me-3 {\n  margin-right: 0.5rem !important;\n}\n\n.me-4 {\n  margin-right: 1rem !important;\n}\n\n.me-5 {\n  margin-right: 1.5rem !important;\n}\n\n.me-6 {\n  margin-right: 2rem !important;\n}\n\n.me-7 {\n  margin-right: 2.5rem !important;\n}\n\n.me-8 {\n  margin-right: 3rem !important;\n}\n\n.me-9 {\n  margin-right: 3.5rem !important;\n}\n\n.me-10 {\n  margin-right: 4rem !important;\n}\n\n.me-11 {\n  margin-right: 5rem !important;\n}\n\n.me-12 {\n  margin-right: 6rem !important;\n}\n\n.me-13 {\n  margin-right: 6.5rem !important;\n}\n\n.me-14 {\n  margin-right: 8rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.125rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-6 {\n  margin-bottom: 2rem !important;\n}\n\n.mb-7 {\n  margin-bottom: 2.5rem !important;\n}\n\n.mb-8 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-9 {\n  margin-bottom: 3.5rem !important;\n}\n\n.mb-10 {\n  margin-bottom: 4rem !important;\n}\n\n.mb-11 {\n  margin-bottom: 5rem !important;\n}\n\n.mb-12 {\n  margin-bottom: 6rem !important;\n}\n\n.mb-13 {\n  margin-bottom: 6.5rem !important;\n}\n\n.mb-14 {\n  margin-bottom: 8rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.125rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-3 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-4 {\n  margin-left: 1rem !important;\n}\n\n.ms-5 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-6 {\n  margin-left: 2rem !important;\n}\n\n.ms-7 {\n  margin-left: 2.5rem !important;\n}\n\n.ms-8 {\n  margin-left: 3rem !important;\n}\n\n.ms-9 {\n  margin-left: 3.5rem !important;\n}\n\n.ms-10 {\n  margin-left: 4rem !important;\n}\n\n.ms-11 {\n  margin-left: 5rem !important;\n}\n\n.ms-12 {\n  margin-left: 6rem !important;\n}\n\n.ms-13 {\n  margin-left: 6.5rem !important;\n}\n\n.ms-14 {\n  margin-left: 8rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.m-n1 {\n  margin: -0.125rem !important;\n}\n\n.m-n2 {\n  margin: -0.25rem !important;\n}\n\n.m-n3 {\n  margin: -0.5rem !important;\n}\n\n.m-n4 {\n  margin: -1rem !important;\n}\n\n.m-n5 {\n  margin: -1.5rem !important;\n}\n\n.m-n6 {\n  margin: -2rem !important;\n}\n\n.m-n7 {\n  margin: -2.5rem !important;\n}\n\n.m-n8 {\n  margin: -3rem !important;\n}\n\n.m-n9 {\n  margin: -3.5rem !important;\n}\n\n.m-n10 {\n  margin: -4rem !important;\n}\n\n.m-n11 {\n  margin: -5rem !important;\n}\n\n.m-n12 {\n  margin: -6rem !important;\n}\n\n.m-n13 {\n  margin: -6.5rem !important;\n}\n\n.m-n14 {\n  margin: -8rem !important;\n}\n\n.mx-n1 {\n  margin-right: -0.125rem !important;\n  margin-left: -0.125rem !important;\n}\n\n.mx-n2 {\n  margin-right: -0.25rem !important;\n  margin-left: -0.25rem !important;\n}\n\n.mx-n3 {\n  margin-right: -0.5rem !important;\n  margin-left: -0.5rem !important;\n}\n\n.mx-n4 {\n  margin-right: -1rem !important;\n  margin-left: -1rem !important;\n}\n\n.mx-n5 {\n  margin-right: -1.5rem !important;\n  margin-left: -1.5rem !important;\n}\n\n.mx-n6 {\n  margin-right: -2rem !important;\n  margin-left: -2rem !important;\n}\n\n.mx-n7 {\n  margin-right: -2.5rem !important;\n  margin-left: -2.5rem !important;\n}\n\n.mx-n8 {\n  margin-right: -3rem !important;\n  margin-left: -3rem !important;\n}\n\n.mx-n9 {\n  margin-right: -3.5rem !important;\n  margin-left: -3.5rem !important;\n}\n\n.mx-n10 {\n  margin-right: -4rem !important;\n  margin-left: -4rem !important;\n}\n\n.mx-n11 {\n  margin-right: -5rem !important;\n  margin-left: -5rem !important;\n}\n\n.mx-n12 {\n  margin-right: -6rem !important;\n  margin-left: -6rem !important;\n}\n\n.mx-n13 {\n  margin-right: -6.5rem !important;\n  margin-left: -6.5rem !important;\n}\n\n.mx-n14 {\n  margin-right: -8rem !important;\n  margin-left: -8rem !important;\n}\n\n.my-n1 {\n  margin-top: -0.125rem !important;\n  margin-bottom: -0.125rem !important;\n}\n\n.my-n2 {\n  margin-top: -0.25rem !important;\n  margin-bottom: -0.25rem !important;\n}\n\n.my-n3 {\n  margin-top: -0.5rem !important;\n  margin-bottom: -0.5rem !important;\n}\n\n.my-n4 {\n  margin-top: -1rem !important;\n  margin-bottom: -1rem !important;\n}\n\n.my-n5 {\n  margin-top: -1.5rem !important;\n  margin-bottom: -1.5rem !important;\n}\n\n.my-n6 {\n  margin-top: -2rem !important;\n  margin-bottom: -2rem !important;\n}\n\n.my-n7 {\n  margin-top: -2.5rem !important;\n  margin-bottom: -2.5rem !important;\n}\n\n.my-n8 {\n  margin-top: -3rem !important;\n  margin-bottom: -3rem !important;\n}\n\n.my-n9 {\n  margin-top: -3.5rem !important;\n  margin-bottom: -3.5rem !important;\n}\n\n.my-n10 {\n  margin-top: -4rem !important;\n  margin-bottom: -4rem !important;\n}\n\n.my-n11 {\n  margin-top: -5rem !important;\n  margin-bottom: -5rem !important;\n}\n\n.my-n12 {\n  margin-top: -6rem !important;\n  margin-bottom: -6rem !important;\n}\n\n.my-n13 {\n  margin-top: -6.5rem !important;\n  margin-bottom: -6.5rem !important;\n}\n\n.my-n14 {\n  margin-top: -8rem !important;\n  margin-bottom: -8rem !important;\n}\n\n.mt-n1 {\n  margin-top: -0.125rem !important;\n}\n\n.mt-n2 {\n  margin-top: -0.25rem !important;\n}\n\n.mt-n3 {\n  margin-top: -0.5rem !important;\n}\n\n.mt-n4 {\n  margin-top: -1rem !important;\n}\n\n.mt-n5 {\n  margin-top: -1.5rem !important;\n}\n\n.mt-n6 {\n  margin-top: -2rem !important;\n}\n\n.mt-n7 {\n  margin-top: -2.5rem !important;\n}\n\n.mt-n8 {\n  margin-top: -3rem !important;\n}\n\n.mt-n9 {\n  margin-top: -3.5rem !important;\n}\n\n.mt-n10 {\n  margin-top: -4rem !important;\n}\n\n.mt-n11 {\n  margin-top: -5rem !important;\n}\n\n.mt-n12 {\n  margin-top: -6rem !important;\n}\n\n.mt-n13 {\n  margin-top: -6.5rem !important;\n}\n\n.mt-n14 {\n  margin-top: -8rem !important;\n}\n\n.me-n1 {\n  margin-right: -0.125rem !important;\n}\n\n.me-n2 {\n  margin-right: -0.25rem !important;\n}\n\n.me-n3 {\n  margin-right: -0.5rem !important;\n}\n\n.me-n4 {\n  margin-right: -1rem !important;\n}\n\n.me-n5 {\n  margin-right: -1.5rem !important;\n}\n\n.me-n6 {\n  margin-right: -2rem !important;\n}\n\n.me-n7 {\n  margin-right: -2.5rem !important;\n}\n\n.me-n8 {\n  margin-right: -3rem !important;\n}\n\n.me-n9 {\n  margin-right: -3.5rem !important;\n}\n\n.me-n10 {\n  margin-right: -4rem !important;\n}\n\n.me-n11 {\n  margin-right: -5rem !important;\n}\n\n.me-n12 {\n  margin-right: -6rem !important;\n}\n\n.me-n13 {\n  margin-right: -6.5rem !important;\n}\n\n.me-n14 {\n  margin-right: -8rem !important;\n}\n\n.mb-n1 {\n  margin-bottom: -0.125rem !important;\n}\n\n.mb-n2 {\n  margin-bottom: -0.25rem !important;\n}\n\n.mb-n3 {\n  margin-bottom: -0.5rem !important;\n}\n\n.mb-n4 {\n  margin-bottom: -1rem !important;\n}\n\n.mb-n5 {\n  margin-bottom: -1.5rem !important;\n}\n\n.mb-n6 {\n  margin-bottom: -2rem !important;\n}\n\n.mb-n7 {\n  margin-bottom: -2.5rem !important;\n}\n\n.mb-n8 {\n  margin-bottom: -3rem !important;\n}\n\n.mb-n9 {\n  margin-bottom: -3.5rem !important;\n}\n\n.mb-n10 {\n  margin-bottom: -4rem !important;\n}\n\n.mb-n11 {\n  margin-bottom: -5rem !important;\n}\n\n.mb-n12 {\n  margin-bottom: -6rem !important;\n}\n\n.mb-n13 {\n  margin-bottom: -6.5rem !important;\n}\n\n.mb-n14 {\n  margin-bottom: -8rem !important;\n}\n\n.ms-n1 {\n  margin-left: -0.125rem !important;\n}\n\n.ms-n2 {\n  margin-left: -0.25rem !important;\n}\n\n.ms-n3 {\n  margin-left: -0.5rem !important;\n}\n\n.ms-n4 {\n  margin-left: -1rem !important;\n}\n\n.ms-n5 {\n  margin-left: -1.5rem !important;\n}\n\n.ms-n6 {\n  margin-left: -2rem !important;\n}\n\n.ms-n7 {\n  margin-left: -2.5rem !important;\n}\n\n.ms-n8 {\n  margin-left: -3rem !important;\n}\n\n.ms-n9 {\n  margin-left: -3.5rem !important;\n}\n\n.ms-n10 {\n  margin-left: -4rem !important;\n}\n\n.ms-n11 {\n  margin-left: -5rem !important;\n}\n\n.ms-n12 {\n  margin-left: -6rem !important;\n}\n\n.ms-n13 {\n  margin-left: -6.5rem !important;\n}\n\n.ms-n14 {\n  margin-left: -8rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.125rem !important;\n}\n\n.p-2 {\n  padding: 0.25rem !important;\n}\n\n.p-3 {\n  padding: 0.5rem !important;\n}\n\n.p-4 {\n  padding: 1rem !important;\n}\n\n.p-5 {\n  padding: 1.5rem !important;\n}\n\n.p-6 {\n  padding: 2rem !important;\n}\n\n.p-7 {\n  padding: 2.5rem !important;\n}\n\n.p-8 {\n  padding: 3rem !important;\n}\n\n.p-9 {\n  padding: 3.5rem !important;\n}\n\n.p-10 {\n  padding: 4rem !important;\n}\n\n.p-11 {\n  padding: 5rem !important;\n}\n\n.p-12 {\n  padding: 6rem !important;\n}\n\n.p-13 {\n  padding: 6.5rem !important;\n}\n\n.p-14 {\n  padding: 8rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.125rem !important;\n  padding-left: 0.125rem !important;\n}\n\n.px-2 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-3 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-4 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-5 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-6 {\n  padding-right: 2rem !important;\n  padding-left: 2rem !important;\n}\n\n.px-7 {\n  padding-right: 2.5rem !important;\n  padding-left: 2.5rem !important;\n}\n\n.px-8 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.px-9 {\n  padding-right: 3.5rem !important;\n  padding-left: 3.5rem !important;\n}\n\n.px-10 {\n  padding-right: 4rem !important;\n  padding-left: 4rem !important;\n}\n\n.px-11 {\n  padding-right: 5rem !important;\n  padding-left: 5rem !important;\n}\n\n.px-12 {\n  padding-right: 6rem !important;\n  padding-left: 6rem !important;\n}\n\n.px-13 {\n  padding-right: 6.5rem !important;\n  padding-left: 6.5rem !important;\n}\n\n.px-14 {\n  padding-right: 8rem !important;\n  padding-left: 8rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.125rem !important;\n  padding-bottom: 0.125rem !important;\n}\n\n.py-2 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-3 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-4 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-5 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-6 {\n  padding-top: 2rem !important;\n  padding-bottom: 2rem !important;\n}\n\n.py-7 {\n  padding-top: 2.5rem !important;\n  padding-bottom: 2.5rem !important;\n}\n\n.py-8 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.py-9 {\n  padding-top: 3.5rem !important;\n  padding-bottom: 3.5rem !important;\n}\n\n.py-10 {\n  padding-top: 4rem !important;\n  padding-bottom: 4rem !important;\n}\n\n.py-11 {\n  padding-top: 5rem !important;\n  padding-bottom: 5rem !important;\n}\n\n.py-12 {\n  padding-top: 6rem !important;\n  padding-bottom: 6rem !important;\n}\n\n.py-13 {\n  padding-top: 6.5rem !important;\n  padding-bottom: 6.5rem !important;\n}\n\n.py-14 {\n  padding-top: 8rem !important;\n  padding-bottom: 8rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.125rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-3 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-4 {\n  padding-top: 1rem !important;\n}\n\n.pt-5 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-6 {\n  padding-top: 2rem !important;\n}\n\n.pt-7 {\n  padding-top: 2.5rem !important;\n}\n\n.pt-8 {\n  padding-top: 3rem !important;\n}\n\n.pt-9 {\n  padding-top: 3.5rem !important;\n}\n\n.pt-10 {\n  padding-top: 4rem !important;\n}\n\n.pt-11 {\n  padding-top: 5rem !important;\n}\n\n.pt-12 {\n  padding-top: 6rem !important;\n}\n\n.pt-13 {\n  padding-top: 6.5rem !important;\n}\n\n.pt-14 {\n  padding-top: 8rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.125rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-3 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-4 {\n  padding-right: 1rem !important;\n}\n\n.pe-5 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-6 {\n  padding-right: 2rem !important;\n}\n\n.pe-7 {\n  padding-right: 2.5rem !important;\n}\n\n.pe-8 {\n  padding-right: 3rem !important;\n}\n\n.pe-9 {\n  padding-right: 3.5rem !important;\n}\n\n.pe-10 {\n  padding-right: 4rem !important;\n}\n\n.pe-11 {\n  padding-right: 5rem !important;\n}\n\n.pe-12 {\n  padding-right: 6rem !important;\n}\n\n.pe-13 {\n  padding-right: 6.5rem !important;\n}\n\n.pe-14 {\n  padding-right: 8rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.125rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-6 {\n  padding-bottom: 2rem !important;\n}\n\n.pb-7 {\n  padding-bottom: 2.5rem !important;\n}\n\n.pb-8 {\n  padding-bottom: 3rem !important;\n}\n\n.pb-9 {\n  padding-bottom: 3.5rem !important;\n}\n\n.pb-10 {\n  padding-bottom: 4rem !important;\n}\n\n.pb-11 {\n  padding-bottom: 5rem !important;\n}\n\n.pb-12 {\n  padding-bottom: 6rem !important;\n}\n\n.pb-13 {\n  padding-bottom: 6.5rem !important;\n}\n\n.pb-14 {\n  padding-bottom: 8rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.125rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-3 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-4 {\n  padding-left: 1rem !important;\n}\n\n.ps-5 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-6 {\n  padding-left: 2rem !important;\n}\n\n.ps-7 {\n  padding-left: 2.5rem !important;\n}\n\n.ps-8 {\n  padding-left: 3rem !important;\n}\n\n.ps-9 {\n  padding-left: 3.5rem !important;\n}\n\n.ps-10 {\n  padding-left: 4rem !important;\n}\n\n.ps-11 {\n  padding-left: 5rem !important;\n}\n\n.ps-12 {\n  padding-left: 6rem !important;\n}\n\n.ps-13 {\n  padding-left: 6.5rem !important;\n}\n\n.ps-14 {\n  padding-left: 8rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.125rem !important;\n}\n\n.gap-2 {\n  gap: 0.25rem !important;\n}\n\n.gap-3 {\n  gap: 0.5rem !important;\n}\n\n.gap-4 {\n  gap: 1rem !important;\n}\n\n.gap-5 {\n  gap: 1.5rem !important;\n}\n\n.gap-6 {\n  gap: 2rem !important;\n}\n\n.gap-7 {\n  gap: 2.5rem !important;\n}\n\n.gap-8 {\n  gap: 3rem !important;\n}\n\n.gap-9 {\n  gap: 3.5rem !important;\n}\n\n.gap-10 {\n  gap: 4rem !important;\n}\n\n.gap-11 {\n  gap: 5rem !important;\n}\n\n.gap-12 {\n  gap: 6rem !important;\n}\n\n.gap-13 {\n  gap: 6.5rem !important;\n}\n\n.gap-14 {\n  gap: 8rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.125rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.25rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 0.5rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 1rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-6 {\n  row-gap: 2rem !important;\n}\n\n.row-gap-7 {\n  row-gap: 2.5rem !important;\n}\n\n.row-gap-8 {\n  row-gap: 3rem !important;\n}\n\n.row-gap-9 {\n  row-gap: 3.5rem !important;\n}\n\n.row-gap-10 {\n  row-gap: 4rem !important;\n}\n\n.row-gap-11 {\n  row-gap: 5rem !important;\n}\n\n.row-gap-12 {\n  row-gap: 6rem !important;\n}\n\n.row-gap-13 {\n  row-gap: 6.5rem !important;\n}\n\n.row-gap-14 {\n  row-gap: 8rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  column-gap: 0.125rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 0.25rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 0.5rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 1rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-6 {\n  column-gap: 2rem !important;\n}\n\n.column-gap-7 {\n  column-gap: 2.5rem !important;\n}\n\n.column-gap-8 {\n  column-gap: 3rem !important;\n}\n\n.column-gap-9 {\n  column-gap: 3.5rem !important;\n}\n\n.column-gap-10 {\n  column-gap: 4rem !important;\n}\n\n.column-gap-11 {\n  column-gap: 5rem !important;\n}\n\n.column-gap-12 {\n  column-gap: 6rem !important;\n}\n\n.column-gap-13 {\n  column-gap: 6.5rem !important;\n}\n\n.column-gap-14 {\n  column-gap: 8rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: 2rem !important;\n}\n\n.fs-2 {\n  font-size: 1.8125rem !important;\n}\n\n.fs-3 {\n  font-size: 1.625rem !important;\n}\n\n.fs-4 {\n  font-size: 1.4375rem !important;\n}\n\n.fs-5 {\n  font-size: 1.25rem !important;\n}\n\n.fs-6 {\n  font-size: 0.875rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-1-125 {\n  line-height: 1.125 !important;\n}\n\n.lh-1-25 {\n  line-height: 1.25 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-1-375 {\n  line-height: 1.375 !important;\n}\n\n.lh-1-5 {\n  line-height: 1.5 !important;\n}\n\n.lh-1-625 {\n  line-height: 1.625 !important;\n}\n\n.lh-1-75 {\n  line-height: 1.75 !important;\n}\n\n.lh-base {\n  line-height: 1.75 !important;\n}\n\n.lh-1-875 {\n  line-height: 1.875 !important;\n}\n\n.lh-2 {\n  line-height: 2 !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text-emphasis) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text-emphasis) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text-emphasis) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text-emphasis) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text-emphasis) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text-emphasis) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text-emphasis) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text-emphasis) !important;\n}\n\n.link-opacity-10 {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-10-hover:hover {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-25 {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-25-hover:hover {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-50 {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-50-hover:hover {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-75 {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-75-hover:hover {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-100 {\n  --bs-link-opacity: 1;\n}\n\n.link-opacity-100-hover:hover {\n  --bs-link-opacity: 1;\n}\n\n.link-offset-1 {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-1-hover:hover {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-2 {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-2-hover:hover {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-3 {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-offset-3-hover:hover {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-underline-primary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-secondary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-warning {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-light {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-dark {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-underline-opacity-0 {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-0-hover:hover {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-10 {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-10-hover:hover {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-25 {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-25-hover:hover {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-50 {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-50-hover:hover {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-75 {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-75-hover:hover {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-100 {\n  --bs-link-underline-opacity: 1;\n}\n\n.link-underline-opacity-100-hover:hover {\n  --bs-link-underline-opacity: 1;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: #fff !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: #fafafa !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: #f2f2f2 !important;\n}\n\n.bg-quartenary {\n  --bs-bg-opacity: 1;\n  background-color: #ededed !important;\n}\n\n.bg-quinary {\n  --bs-bg-opacity: 1;\n  background-color: #dedede !important;\n}\n\n.bg-bp-yellow {\n  --bs-bg-opacity: 1;\n  background-color: #ffe600 !important;\n}\n\n.bg-bp-green-logo {\n  --bs-bg-opacity: 1;\n  background-color: #009900 !important;\n}\n\n.bg-bp-green {\n  --bs-bg-opacity: 1;\n  background-color: #007f00 !important;\n}\n\n.bg-bp-light-green {\n  --bs-bg-opacity: 1;\n  background-color: #99cc00 !important;\n}\n\n.bg-almost-dark {\n  --bs-bg-opacity: 1;\n  background-color: #1d1d1d !important;\n}\n\n.bg-dark-secondary {\n  --bs-bg-opacity: 1;\n  background-color: #121212 !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: var(--bs-border-radius-xs) !important;\n}\n\n.rounded-2 {\n  border-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-3 {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-4 {\n  border-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-5 {\n  border-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-6 {\n  border-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-7 {\n  border-radius: var(--bs-border-radius-3xl) !important;\n}\n\n.rounded-8 {\n  border-radius: var(--bs-border-radius-4xl) !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-xs) !important;\n  border-top-right-radius: var(--bs-border-radius-xs) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-6 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-7 {\n  border-top-left-radius: var(--bs-border-radius-3xl) !important;\n  border-top-right-radius: var(--bs-border-radius-3xl) !important;\n}\n\n.rounded-top-8 {\n  border-top-left-radius: var(--bs-border-radius-4xl) !important;\n  border-top-right-radius: var(--bs-border-radius-4xl) !important;\n}\n\n.rounded-end {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-1 {\n  border-bottom-right-radius: var(--bs-border-radius-xs) !important;\n  border-top-right-radius: var(--bs-border-radius-xs) !important;\n}\n\n.rounded-end-2 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-3 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-4 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-6 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-end-7 {\n  border-bottom-right-radius: var(--bs-border-radius-3xl) !important;\n  border-top-right-radius: var(--bs-border-radius-3xl) !important;\n}\n\n.rounded-end-8 {\n  border-bottom-right-radius: var(--bs-border-radius-4xl) !important;\n  border-top-right-radius: var(--bs-border-radius-4xl) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-xs) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xs) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-6 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-7 {\n  border-bottom-right-radius: var(--bs-border-radius-3xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-3xl) !important;\n}\n\n.rounded-bottom-8 {\n  border-bottom-right-radius: var(--bs-border-radius-4xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-4xl) !important;\n}\n\n.rounded-start {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-1 {\n  border-top-left-radius: var(--bs-border-radius-xs) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xs) !important;\n}\n\n.rounded-start-2 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-3 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-4 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-5 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-6 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-start-7 {\n  border-top-left-radius: var(--bs-border-radius-3xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-3xl) !important;\n}\n\n.rounded-start-8 {\n  border-top-left-radius: var(--bs-border-radius-4xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-4xl) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-n1 {\n  z-index: -1 !important;\n}\n\n.z-0 {\n  z-index: 0 !important;\n}\n\n.z-1 {\n  z-index: 1 !important;\n}\n\n.z-2 {\n  z-index: 2 !important;\n}\n\n.z-3 {\n  z-index: 3 !important;\n}\n\n.rounded-top-left {\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-left-1 {\n  border-top-left-radius: var(--bs-border-radius-xs) !important;\n}\n\n.rounded-top-left-2 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-left-3 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-left-4 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-left-5 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-left-6 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-left-7 {\n  border-top-left-radius: var(--bs-border-radius-3xl) !important;\n}\n\n.rounded-top-left-8 {\n  border-top-left-radius: var(--bs-border-radius-4xl) !important;\n}\n\n.rounded-top-right {\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-right-1 {\n  border-top-right-radius: var(--bs-border-radius-xs) !important;\n}\n\n.rounded-top-right-2 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-right-3 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-right-4 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-right-5 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-right-6 {\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-right-7 {\n  border-top-right-radius: var(--bs-border-radius-3xl) !important;\n}\n\n.rounded-top-right-8 {\n  border-top-right-radius: var(--bs-border-radius-4xl) !important;\n}\n\n.rounded-bottom-right {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-right-1 {\n  border-bottom-right-radius: var(--bs-border-radius-xs) !important;\n}\n\n.rounded-bottom-right-2 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-right-3 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-right-4 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-right-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-right-6 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-right-7 {\n  border-bottom-right-radius: var(--bs-border-radius-3xl) !important;\n}\n\n.rounded-bottom-right-8 {\n  border-bottom-right-radius: var(--bs-border-radius-4xl) !important;\n}\n\n.rounded-bottom-left {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-left-1 {\n  border-bottom-left-radius: var(--bs-border-radius-xs) !important;\n}\n\n.rounded-bottom-left-2 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-left-3 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-left-4 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-left-5 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-left-6 {\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-left-7 {\n  border-bottom-left-radius: var(--bs-border-radius-3xl) !important;\n}\n\n.rounded-bottom-left-8 {\n  border-bottom-left-radius: var(--bs-border-radius-4xl) !important;\n}\n\n.ls-0 {\n  letter-spacing: 0 !important;\n}\n\n.ls-0-3 {\n  letter-spacing: 0.3px !important;\n}\n\n.ls-1 {\n  letter-spacing: 1px !important;\n}\n\n.ls-1-2 {\n  letter-spacing: 1.2px !important;\n}\n\n.ls-1-5 {\n  letter-spacing: 1.5px !important;\n}\n\n.ls-2 {\n  letter-spacing: 2px !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.125rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.25rem !important;\n  }\n  .m-sm-3 {\n    margin: 0.5rem !important;\n  }\n  .m-sm-4 {\n    margin: 1rem !important;\n  }\n  .m-sm-5 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-6 {\n    margin: 2rem !important;\n  }\n  .m-sm-7 {\n    margin: 2.5rem !important;\n  }\n  .m-sm-8 {\n    margin: 3rem !important;\n  }\n  .m-sm-9 {\n    margin: 3.5rem !important;\n  }\n  .m-sm-10 {\n    margin: 4rem !important;\n  }\n  .m-sm-11 {\n    margin: 5rem !important;\n  }\n  .m-sm-12 {\n    margin: 6rem !important;\n  }\n  .m-sm-13 {\n    margin: 6.5rem !important;\n  }\n  .m-sm-14 {\n    margin: 8rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.125rem !important;\n    margin-left: 0.125rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-6 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-sm-7 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-sm-8 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-sm-9 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-sm-10 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-sm-11 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-sm-12 {\n    margin-right: 6rem !important;\n    margin-left: 6rem !important;\n  }\n  .mx-sm-13 {\n    margin-right: 6.5rem !important;\n    margin-left: 6.5rem !important;\n  }\n  .mx-sm-14 {\n    margin-right: 8rem !important;\n    margin-left: 8rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.125rem !important;\n    margin-bottom: 0.125rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-6 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-sm-7 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-sm-8 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-sm-9 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-sm-10 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-sm-11 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-sm-12 {\n    margin-top: 6rem !important;\n    margin-bottom: 6rem !important;\n  }\n  .my-sm-13 {\n    margin-top: 6.5rem !important;\n    margin-bottom: 6.5rem !important;\n  }\n  .my-sm-14 {\n    margin-top: 8rem !important;\n    margin-bottom: 8rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.125rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-6 {\n    margin-top: 2rem !important;\n  }\n  .mt-sm-7 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-sm-8 {\n    margin-top: 3rem !important;\n  }\n  .mt-sm-9 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-sm-10 {\n    margin-top: 4rem !important;\n  }\n  .mt-sm-11 {\n    margin-top: 5rem !important;\n  }\n  .mt-sm-12 {\n    margin-top: 6rem !important;\n  }\n  .mt-sm-13 {\n    margin-top: 6.5rem !important;\n  }\n  .mt-sm-14 {\n    margin-top: 8rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.125rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.25rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 0.5rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 1rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-6 {\n    margin-right: 2rem !important;\n  }\n  .me-sm-7 {\n    margin-right: 2.5rem !important;\n  }\n  .me-sm-8 {\n    margin-right: 3rem !important;\n  }\n  .me-sm-9 {\n    margin-right: 3.5rem !important;\n  }\n  .me-sm-10 {\n    margin-right: 4rem !important;\n  }\n  .me-sm-11 {\n    margin-right: 5rem !important;\n  }\n  .me-sm-12 {\n    margin-right: 6rem !important;\n  }\n  .me-sm-13 {\n    margin-right: 6.5rem !important;\n  }\n  .me-sm-14 {\n    margin-right: 8rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.125rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-6 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-sm-7 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-sm-8 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-sm-9 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-sm-10 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-sm-11 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-sm-12 {\n    margin-bottom: 6rem !important;\n  }\n  .mb-sm-13 {\n    margin-bottom: 6.5rem !important;\n  }\n  .mb-sm-14 {\n    margin-bottom: 8rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.125rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-6 {\n    margin-left: 2rem !important;\n  }\n  .ms-sm-7 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-sm-8 {\n    margin-left: 3rem !important;\n  }\n  .ms-sm-9 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-sm-10 {\n    margin-left: 4rem !important;\n  }\n  .ms-sm-11 {\n    margin-left: 5rem !important;\n  }\n  .ms-sm-12 {\n    margin-left: 6rem !important;\n  }\n  .ms-sm-13 {\n    margin-left: 6.5rem !important;\n  }\n  .ms-sm-14 {\n    margin-left: 8rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .m-sm-n1 {\n    margin: -0.125rem !important;\n  }\n  .m-sm-n2 {\n    margin: -0.25rem !important;\n  }\n  .m-sm-n3 {\n    margin: -0.5rem !important;\n  }\n  .m-sm-n4 {\n    margin: -1rem !important;\n  }\n  .m-sm-n5 {\n    margin: -1.5rem !important;\n  }\n  .m-sm-n6 {\n    margin: -2rem !important;\n  }\n  .m-sm-n7 {\n    margin: -2.5rem !important;\n  }\n  .m-sm-n8 {\n    margin: -3rem !important;\n  }\n  .m-sm-n9 {\n    margin: -3.5rem !important;\n  }\n  .m-sm-n10 {\n    margin: -4rem !important;\n  }\n  .m-sm-n11 {\n    margin: -5rem !important;\n  }\n  .m-sm-n12 {\n    margin: -6rem !important;\n  }\n  .m-sm-n13 {\n    margin: -6.5rem !important;\n  }\n  .m-sm-n14 {\n    margin: -8rem !important;\n  }\n  .mx-sm-n1 {\n    margin-right: -0.125rem !important;\n    margin-left: -0.125rem !important;\n  }\n  .mx-sm-n2 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-sm-n3 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-sm-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-sm-n5 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-sm-n6 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-sm-n7 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-sm-n8 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-sm-n9 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-sm-n10 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-sm-n11 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .mx-sm-n12 {\n    margin-right: -6rem !important;\n    margin-left: -6rem !important;\n  }\n  .mx-sm-n13 {\n    margin-right: -6.5rem !important;\n    margin-left: -6.5rem !important;\n  }\n  .mx-sm-n14 {\n    margin-right: -8rem !important;\n    margin-left: -8rem !important;\n  }\n  .my-sm-n1 {\n    margin-top: -0.125rem !important;\n    margin-bottom: -0.125rem !important;\n  }\n  .my-sm-n2 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-sm-n3 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-sm-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-sm-n5 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-sm-n6 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-sm-n7 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-sm-n8 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-sm-n9 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-sm-n10 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-sm-n11 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .my-sm-n12 {\n    margin-top: -6rem !important;\n    margin-bottom: -6rem !important;\n  }\n  .my-sm-n13 {\n    margin-top: -6.5rem !important;\n    margin-bottom: -6.5rem !important;\n  }\n  .my-sm-n14 {\n    margin-top: -8rem !important;\n    margin-bottom: -8rem !important;\n  }\n  .mt-sm-n1 {\n    margin-top: -0.125rem !important;\n  }\n  .mt-sm-n2 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-sm-n3 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-sm-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-sm-n5 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-sm-n6 {\n    margin-top: -2rem !important;\n  }\n  .mt-sm-n7 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-sm-n8 {\n    margin-top: -3rem !important;\n  }\n  .mt-sm-n9 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-sm-n10 {\n    margin-top: -4rem !important;\n  }\n  .mt-sm-n11 {\n    margin-top: -5rem !important;\n  }\n  .mt-sm-n12 {\n    margin-top: -6rem !important;\n  }\n  .mt-sm-n13 {\n    margin-top: -6.5rem !important;\n  }\n  .mt-sm-n14 {\n    margin-top: -8rem !important;\n  }\n  .me-sm-n1 {\n    margin-right: -0.125rem !important;\n  }\n  .me-sm-n2 {\n    margin-right: -0.25rem !important;\n  }\n  .me-sm-n3 {\n    margin-right: -0.5rem !important;\n  }\n  .me-sm-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-sm-n5 {\n    margin-right: -1.5rem !important;\n  }\n  .me-sm-n6 {\n    margin-right: -2rem !important;\n  }\n  .me-sm-n7 {\n    margin-right: -2.5rem !important;\n  }\n  .me-sm-n8 {\n    margin-right: -3rem !important;\n  }\n  .me-sm-n9 {\n    margin-right: -3.5rem !important;\n  }\n  .me-sm-n10 {\n    margin-right: -4rem !important;\n  }\n  .me-sm-n11 {\n    margin-right: -5rem !important;\n  }\n  .me-sm-n12 {\n    margin-right: -6rem !important;\n  }\n  .me-sm-n13 {\n    margin-right: -6.5rem !important;\n  }\n  .me-sm-n14 {\n    margin-right: -8rem !important;\n  }\n  .mb-sm-n1 {\n    margin-bottom: -0.125rem !important;\n  }\n  .mb-sm-n2 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-sm-n3 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-sm-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-sm-n5 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-sm-n6 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-sm-n7 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-sm-n8 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-sm-n9 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-sm-n10 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-sm-n11 {\n    margin-bottom: -5rem !important;\n  }\n  .mb-sm-n12 {\n    margin-bottom: -6rem !important;\n  }\n  .mb-sm-n13 {\n    margin-bottom: -6.5rem !important;\n  }\n  .mb-sm-n14 {\n    margin-bottom: -8rem !important;\n  }\n  .ms-sm-n1 {\n    margin-left: -0.125rem !important;\n  }\n  .ms-sm-n2 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-sm-n3 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-sm-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-sm-n5 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-sm-n6 {\n    margin-left: -2rem !important;\n  }\n  .ms-sm-n7 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-sm-n8 {\n    margin-left: -3rem !important;\n  }\n  .ms-sm-n9 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-sm-n10 {\n    margin-left: -4rem !important;\n  }\n  .ms-sm-n11 {\n    margin-left: -5rem !important;\n  }\n  .ms-sm-n12 {\n    margin-left: -6rem !important;\n  }\n  .ms-sm-n13 {\n    margin-left: -6.5rem !important;\n  }\n  .ms-sm-n14 {\n    margin-left: -8rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.125rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.25rem !important;\n  }\n  .p-sm-3 {\n    padding: 0.5rem !important;\n  }\n  .p-sm-4 {\n    padding: 1rem !important;\n  }\n  .p-sm-5 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-6 {\n    padding: 2rem !important;\n  }\n  .p-sm-7 {\n    padding: 2.5rem !important;\n  }\n  .p-sm-8 {\n    padding: 3rem !important;\n  }\n  .p-sm-9 {\n    padding: 3.5rem !important;\n  }\n  .p-sm-10 {\n    padding: 4rem !important;\n  }\n  .p-sm-11 {\n    padding: 5rem !important;\n  }\n  .p-sm-12 {\n    padding: 6rem !important;\n  }\n  .p-sm-13 {\n    padding: 6.5rem !important;\n  }\n  .p-sm-14 {\n    padding: 8rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.125rem !important;\n    padding-left: 0.125rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-6 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-sm-7 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-sm-8 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-sm-9 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-sm-10 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-sm-11 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .px-sm-12 {\n    padding-right: 6rem !important;\n    padding-left: 6rem !important;\n  }\n  .px-sm-13 {\n    padding-right: 6.5rem !important;\n    padding-left: 6.5rem !important;\n  }\n  .px-sm-14 {\n    padding-right: 8rem !important;\n    padding-left: 8rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.125rem !important;\n    padding-bottom: 0.125rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-6 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-sm-7 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-sm-8 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-sm-9 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-sm-10 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-sm-11 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .py-sm-12 {\n    padding-top: 6rem !important;\n    padding-bottom: 6rem !important;\n  }\n  .py-sm-13 {\n    padding-top: 6.5rem !important;\n    padding-bottom: 6.5rem !important;\n  }\n  .py-sm-14 {\n    padding-top: 8rem !important;\n    padding-bottom: 8rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.125rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-6 {\n    padding-top: 2rem !important;\n  }\n  .pt-sm-7 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-sm-8 {\n    padding-top: 3rem !important;\n  }\n  .pt-sm-9 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-sm-10 {\n    padding-top: 4rem !important;\n  }\n  .pt-sm-11 {\n    padding-top: 5rem !important;\n  }\n  .pt-sm-12 {\n    padding-top: 6rem !important;\n  }\n  .pt-sm-13 {\n    padding-top: 6.5rem !important;\n  }\n  .pt-sm-14 {\n    padding-top: 8rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.125rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-6 {\n    padding-right: 2rem !important;\n  }\n  .pe-sm-7 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-sm-8 {\n    padding-right: 3rem !important;\n  }\n  .pe-sm-9 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-sm-10 {\n    padding-right: 4rem !important;\n  }\n  .pe-sm-11 {\n    padding-right: 5rem !important;\n  }\n  .pe-sm-12 {\n    padding-right: 6rem !important;\n  }\n  .pe-sm-13 {\n    padding-right: 6.5rem !important;\n  }\n  .pe-sm-14 {\n    padding-right: 8rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.125rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-6 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-sm-7 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-sm-8 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-sm-9 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-sm-10 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-sm-11 {\n    padding-bottom: 5rem !important;\n  }\n  .pb-sm-12 {\n    padding-bottom: 6rem !important;\n  }\n  .pb-sm-13 {\n    padding-bottom: 6.5rem !important;\n  }\n  .pb-sm-14 {\n    padding-bottom: 8rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.125rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-6 {\n    padding-left: 2rem !important;\n  }\n  .ps-sm-7 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-sm-8 {\n    padding-left: 3rem !important;\n  }\n  .ps-sm-9 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-sm-10 {\n    padding-left: 4rem !important;\n  }\n  .ps-sm-11 {\n    padding-left: 5rem !important;\n  }\n  .ps-sm-12 {\n    padding-left: 6rem !important;\n  }\n  .ps-sm-13 {\n    padding-left: 6.5rem !important;\n  }\n  .ps-sm-14 {\n    padding-left: 8rem !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.125rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.25rem !important;\n  }\n  .gap-sm-3 {\n    gap: 0.5rem !important;\n  }\n  .gap-sm-4 {\n    gap: 1rem !important;\n  }\n  .gap-sm-5 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-6 {\n    gap: 2rem !important;\n  }\n  .gap-sm-7 {\n    gap: 2.5rem !important;\n  }\n  .gap-sm-8 {\n    gap: 3rem !important;\n  }\n  .gap-sm-9 {\n    gap: 3.5rem !important;\n  }\n  .gap-sm-10 {\n    gap: 4rem !important;\n  }\n  .gap-sm-11 {\n    gap: 5rem !important;\n  }\n  .gap-sm-12 {\n    gap: 6rem !important;\n  }\n  .gap-sm-13 {\n    gap: 6.5rem !important;\n  }\n  .gap-sm-14 {\n    gap: 8rem !important;\n  }\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-sm-1 {\n    row-gap: 0.125rem !important;\n  }\n  .row-gap-sm-2 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-sm-3 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-sm-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-sm-5 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-sm-6 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-sm-7 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-sm-8 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-sm-9 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-sm-10 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-sm-11 {\n    row-gap: 5rem !important;\n  }\n  .row-gap-sm-12 {\n    row-gap: 6rem !important;\n  }\n  .row-gap-sm-13 {\n    row-gap: 6.5rem !important;\n  }\n  .row-gap-sm-14 {\n    row-gap: 8rem !important;\n  }\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-sm-1 {\n    column-gap: 0.125rem !important;\n  }\n  .column-gap-sm-2 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-sm-3 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-sm-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-sm-5 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-sm-6 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-sm-7 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-sm-8 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-sm-9 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-sm-10 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-sm-11 {\n    column-gap: 5rem !important;\n  }\n  .column-gap-sm-12 {\n    column-gap: 6rem !important;\n  }\n  .column-gap-sm-13 {\n    column-gap: 6.5rem !important;\n  }\n  .column-gap-sm-14 {\n    column-gap: 8rem !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.125rem !important;\n  }\n  .m-md-2 {\n    margin: 0.25rem !important;\n  }\n  .m-md-3 {\n    margin: 0.5rem !important;\n  }\n  .m-md-4 {\n    margin: 1rem !important;\n  }\n  .m-md-5 {\n    margin: 1.5rem !important;\n  }\n  .m-md-6 {\n    margin: 2rem !important;\n  }\n  .m-md-7 {\n    margin: 2.5rem !important;\n  }\n  .m-md-8 {\n    margin: 3rem !important;\n  }\n  .m-md-9 {\n    margin: 3.5rem !important;\n  }\n  .m-md-10 {\n    margin: 4rem !important;\n  }\n  .m-md-11 {\n    margin: 5rem !important;\n  }\n  .m-md-12 {\n    margin: 6rem !important;\n  }\n  .m-md-13 {\n    margin: 6.5rem !important;\n  }\n  .m-md-14 {\n    margin: 8rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.125rem !important;\n    margin-left: 0.125rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-6 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-md-7 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-md-8 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-md-9 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-md-10 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-md-11 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-md-12 {\n    margin-right: 6rem !important;\n    margin-left: 6rem !important;\n  }\n  .mx-md-13 {\n    margin-right: 6.5rem !important;\n    margin-left: 6.5rem !important;\n  }\n  .mx-md-14 {\n    margin-right: 8rem !important;\n    margin-left: 8rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.125rem !important;\n    margin-bottom: 0.125rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-md-3 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-md-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-md-5 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-6 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-md-7 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-md-8 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-md-9 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-md-10 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-md-11 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-md-12 {\n    margin-top: 6rem !important;\n    margin-bottom: 6rem !important;\n  }\n  .my-md-13 {\n    margin-top: 6.5rem !important;\n    margin-bottom: 6.5rem !important;\n  }\n  .my-md-14 {\n    margin-top: 8rem !important;\n    margin-bottom: 8rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.125rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-6 {\n    margin-top: 2rem !important;\n  }\n  .mt-md-7 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-md-8 {\n    margin-top: 3rem !important;\n  }\n  .mt-md-9 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-md-10 {\n    margin-top: 4rem !important;\n  }\n  .mt-md-11 {\n    margin-top: 5rem !important;\n  }\n  .mt-md-12 {\n    margin-top: 6rem !important;\n  }\n  .mt-md-13 {\n    margin-top: 6.5rem !important;\n  }\n  .mt-md-14 {\n    margin-top: 8rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.125rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.25rem !important;\n  }\n  .me-md-3 {\n    margin-right: 0.5rem !important;\n  }\n  .me-md-4 {\n    margin-right: 1rem !important;\n  }\n  .me-md-5 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-6 {\n    margin-right: 2rem !important;\n  }\n  .me-md-7 {\n    margin-right: 2.5rem !important;\n  }\n  .me-md-8 {\n    margin-right: 3rem !important;\n  }\n  .me-md-9 {\n    margin-right: 3.5rem !important;\n  }\n  .me-md-10 {\n    margin-right: 4rem !important;\n  }\n  .me-md-11 {\n    margin-right: 5rem !important;\n  }\n  .me-md-12 {\n    margin-right: 6rem !important;\n  }\n  .me-md-13 {\n    margin-right: 6.5rem !important;\n  }\n  .me-md-14 {\n    margin-right: 8rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.125rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-6 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-md-7 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-md-8 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-md-9 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-md-10 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-md-11 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-md-12 {\n    margin-bottom: 6rem !important;\n  }\n  .mb-md-13 {\n    margin-bottom: 6.5rem !important;\n  }\n  .mb-md-14 {\n    margin-bottom: 8rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.125rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-6 {\n    margin-left: 2rem !important;\n  }\n  .ms-md-7 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-md-8 {\n    margin-left: 3rem !important;\n  }\n  .ms-md-9 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-md-10 {\n    margin-left: 4rem !important;\n  }\n  .ms-md-11 {\n    margin-left: 5rem !important;\n  }\n  .ms-md-12 {\n    margin-left: 6rem !important;\n  }\n  .ms-md-13 {\n    margin-left: 6.5rem !important;\n  }\n  .ms-md-14 {\n    margin-left: 8rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .m-md-n1 {\n    margin: -0.125rem !important;\n  }\n  .m-md-n2 {\n    margin: -0.25rem !important;\n  }\n  .m-md-n3 {\n    margin: -0.5rem !important;\n  }\n  .m-md-n4 {\n    margin: -1rem !important;\n  }\n  .m-md-n5 {\n    margin: -1.5rem !important;\n  }\n  .m-md-n6 {\n    margin: -2rem !important;\n  }\n  .m-md-n7 {\n    margin: -2.5rem !important;\n  }\n  .m-md-n8 {\n    margin: -3rem !important;\n  }\n  .m-md-n9 {\n    margin: -3.5rem !important;\n  }\n  .m-md-n10 {\n    margin: -4rem !important;\n  }\n  .m-md-n11 {\n    margin: -5rem !important;\n  }\n  .m-md-n12 {\n    margin: -6rem !important;\n  }\n  .m-md-n13 {\n    margin: -6.5rem !important;\n  }\n  .m-md-n14 {\n    margin: -8rem !important;\n  }\n  .mx-md-n1 {\n    margin-right: -0.125rem !important;\n    margin-left: -0.125rem !important;\n  }\n  .mx-md-n2 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-md-n3 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-md-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-md-n5 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-md-n6 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-md-n7 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-md-n8 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-md-n9 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-md-n10 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-md-n11 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .mx-md-n12 {\n    margin-right: -6rem !important;\n    margin-left: -6rem !important;\n  }\n  .mx-md-n13 {\n    margin-right: -6.5rem !important;\n    margin-left: -6.5rem !important;\n  }\n  .mx-md-n14 {\n    margin-right: -8rem !important;\n    margin-left: -8rem !important;\n  }\n  .my-md-n1 {\n    margin-top: -0.125rem !important;\n    margin-bottom: -0.125rem !important;\n  }\n  .my-md-n2 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-md-n3 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-md-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-md-n5 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-md-n6 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-md-n7 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-md-n8 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-md-n9 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-md-n10 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-md-n11 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .my-md-n12 {\n    margin-top: -6rem !important;\n    margin-bottom: -6rem !important;\n  }\n  .my-md-n13 {\n    margin-top: -6.5rem !important;\n    margin-bottom: -6.5rem !important;\n  }\n  .my-md-n14 {\n    margin-top: -8rem !important;\n    margin-bottom: -8rem !important;\n  }\n  .mt-md-n1 {\n    margin-top: -0.125rem !important;\n  }\n  .mt-md-n2 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-md-n3 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-md-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-md-n5 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-md-n6 {\n    margin-top: -2rem !important;\n  }\n  .mt-md-n7 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-md-n8 {\n    margin-top: -3rem !important;\n  }\n  .mt-md-n9 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-md-n10 {\n    margin-top: -4rem !important;\n  }\n  .mt-md-n11 {\n    margin-top: -5rem !important;\n  }\n  .mt-md-n12 {\n    margin-top: -6rem !important;\n  }\n  .mt-md-n13 {\n    margin-top: -6.5rem !important;\n  }\n  .mt-md-n14 {\n    margin-top: -8rem !important;\n  }\n  .me-md-n1 {\n    margin-right: -0.125rem !important;\n  }\n  .me-md-n2 {\n    margin-right: -0.25rem !important;\n  }\n  .me-md-n3 {\n    margin-right: -0.5rem !important;\n  }\n  .me-md-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-md-n5 {\n    margin-right: -1.5rem !important;\n  }\n  .me-md-n6 {\n    margin-right: -2rem !important;\n  }\n  .me-md-n7 {\n    margin-right: -2.5rem !important;\n  }\n  .me-md-n8 {\n    margin-right: -3rem !important;\n  }\n  .me-md-n9 {\n    margin-right: -3.5rem !important;\n  }\n  .me-md-n10 {\n    margin-right: -4rem !important;\n  }\n  .me-md-n11 {\n    margin-right: -5rem !important;\n  }\n  .me-md-n12 {\n    margin-right: -6rem !important;\n  }\n  .me-md-n13 {\n    margin-right: -6.5rem !important;\n  }\n  .me-md-n14 {\n    margin-right: -8rem !important;\n  }\n  .mb-md-n1 {\n    margin-bottom: -0.125rem !important;\n  }\n  .mb-md-n2 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-md-n3 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-md-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-md-n5 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-md-n6 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-md-n7 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-md-n8 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-md-n9 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-md-n10 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-md-n11 {\n    margin-bottom: -5rem !important;\n  }\n  .mb-md-n12 {\n    margin-bottom: -6rem !important;\n  }\n  .mb-md-n13 {\n    margin-bottom: -6.5rem !important;\n  }\n  .mb-md-n14 {\n    margin-bottom: -8rem !important;\n  }\n  .ms-md-n1 {\n    margin-left: -0.125rem !important;\n  }\n  .ms-md-n2 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-md-n3 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-md-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-md-n5 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-md-n6 {\n    margin-left: -2rem !important;\n  }\n  .ms-md-n7 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-md-n8 {\n    margin-left: -3rem !important;\n  }\n  .ms-md-n9 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-md-n10 {\n    margin-left: -4rem !important;\n  }\n  .ms-md-n11 {\n    margin-left: -5rem !important;\n  }\n  .ms-md-n12 {\n    margin-left: -6rem !important;\n  }\n  .ms-md-n13 {\n    margin-left: -6.5rem !important;\n  }\n  .ms-md-n14 {\n    margin-left: -8rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.125rem !important;\n  }\n  .p-md-2 {\n    padding: 0.25rem !important;\n  }\n  .p-md-3 {\n    padding: 0.5rem !important;\n  }\n  .p-md-4 {\n    padding: 1rem !important;\n  }\n  .p-md-5 {\n    padding: 1.5rem !important;\n  }\n  .p-md-6 {\n    padding: 2rem !important;\n  }\n  .p-md-7 {\n    padding: 2.5rem !important;\n  }\n  .p-md-8 {\n    padding: 3rem !important;\n  }\n  .p-md-9 {\n    padding: 3.5rem !important;\n  }\n  .p-md-10 {\n    padding: 4rem !important;\n  }\n  .p-md-11 {\n    padding: 5rem !important;\n  }\n  .p-md-12 {\n    padding: 6rem !important;\n  }\n  .p-md-13 {\n    padding: 6.5rem !important;\n  }\n  .p-md-14 {\n    padding: 8rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.125rem !important;\n    padding-left: 0.125rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-md-3 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-md-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-md-5 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-6 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-md-7 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-md-8 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-md-9 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-md-10 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-md-11 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .px-md-12 {\n    padding-right: 6rem !important;\n    padding-left: 6rem !important;\n  }\n  .px-md-13 {\n    padding-right: 6.5rem !important;\n    padding-left: 6.5rem !important;\n  }\n  .px-md-14 {\n    padding-right: 8rem !important;\n    padding-left: 8rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.125rem !important;\n    padding-bottom: 0.125rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-md-3 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-md-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-md-5 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-6 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-md-7 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-md-8 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-md-9 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-md-10 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-md-11 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .py-md-12 {\n    padding-top: 6rem !important;\n    padding-bottom: 6rem !important;\n  }\n  .py-md-13 {\n    padding-top: 6.5rem !important;\n    padding-bottom: 6.5rem !important;\n  }\n  .py-md-14 {\n    padding-top: 8rem !important;\n    padding-bottom: 8rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.125rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-6 {\n    padding-top: 2rem !important;\n  }\n  .pt-md-7 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-md-8 {\n    padding-top: 3rem !important;\n  }\n  .pt-md-9 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-md-10 {\n    padding-top: 4rem !important;\n  }\n  .pt-md-11 {\n    padding-top: 5rem !important;\n  }\n  .pt-md-12 {\n    padding-top: 6rem !important;\n  }\n  .pt-md-13 {\n    padding-top: 6.5rem !important;\n  }\n  .pt-md-14 {\n    padding-top: 8rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.125rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-6 {\n    padding-right: 2rem !important;\n  }\n  .pe-md-7 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-md-8 {\n    padding-right: 3rem !important;\n  }\n  .pe-md-9 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-md-10 {\n    padding-right: 4rem !important;\n  }\n  .pe-md-11 {\n    padding-right: 5rem !important;\n  }\n  .pe-md-12 {\n    padding-right: 6rem !important;\n  }\n  .pe-md-13 {\n    padding-right: 6.5rem !important;\n  }\n  .pe-md-14 {\n    padding-right: 8rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.125rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-6 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-md-7 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-md-8 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-md-9 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-md-10 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-md-11 {\n    padding-bottom: 5rem !important;\n  }\n  .pb-md-12 {\n    padding-bottom: 6rem !important;\n  }\n  .pb-md-13 {\n    padding-bottom: 6.5rem !important;\n  }\n  .pb-md-14 {\n    padding-bottom: 8rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.125rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-6 {\n    padding-left: 2rem !important;\n  }\n  .ps-md-7 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-md-8 {\n    padding-left: 3rem !important;\n  }\n  .ps-md-9 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-md-10 {\n    padding-left: 4rem !important;\n  }\n  .ps-md-11 {\n    padding-left: 5rem !important;\n  }\n  .ps-md-12 {\n    padding-left: 6rem !important;\n  }\n  .ps-md-13 {\n    padding-left: 6.5rem !important;\n  }\n  .ps-md-14 {\n    padding-left: 8rem !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.125rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.25rem !important;\n  }\n  .gap-md-3 {\n    gap: 0.5rem !important;\n  }\n  .gap-md-4 {\n    gap: 1rem !important;\n  }\n  .gap-md-5 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-6 {\n    gap: 2rem !important;\n  }\n  .gap-md-7 {\n    gap: 2.5rem !important;\n  }\n  .gap-md-8 {\n    gap: 3rem !important;\n  }\n  .gap-md-9 {\n    gap: 3.5rem !important;\n  }\n  .gap-md-10 {\n    gap: 4rem !important;\n  }\n  .gap-md-11 {\n    gap: 5rem !important;\n  }\n  .gap-md-12 {\n    gap: 6rem !important;\n  }\n  .gap-md-13 {\n    gap: 6.5rem !important;\n  }\n  .gap-md-14 {\n    gap: 8rem !important;\n  }\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-md-1 {\n    row-gap: 0.125rem !important;\n  }\n  .row-gap-md-2 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-md-3 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-md-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-md-5 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-md-6 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-md-7 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-md-8 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-md-9 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-md-10 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-md-11 {\n    row-gap: 5rem !important;\n  }\n  .row-gap-md-12 {\n    row-gap: 6rem !important;\n  }\n  .row-gap-md-13 {\n    row-gap: 6.5rem !important;\n  }\n  .row-gap-md-14 {\n    row-gap: 8rem !important;\n  }\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-md-1 {\n    column-gap: 0.125rem !important;\n  }\n  .column-gap-md-2 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-md-3 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-md-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-md-5 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-md-6 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-md-7 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-md-8 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-md-9 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-md-10 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-md-11 {\n    column-gap: 5rem !important;\n  }\n  .column-gap-md-12 {\n    column-gap: 6rem !important;\n  }\n  .column-gap-md-13 {\n    column-gap: 6.5rem !important;\n  }\n  .column-gap-md-14 {\n    column-gap: 8rem !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.125rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.25rem !important;\n  }\n  .m-lg-3 {\n    margin: 0.5rem !important;\n  }\n  .m-lg-4 {\n    margin: 1rem !important;\n  }\n  .m-lg-5 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-6 {\n    margin: 2rem !important;\n  }\n  .m-lg-7 {\n    margin: 2.5rem !important;\n  }\n  .m-lg-8 {\n    margin: 3rem !important;\n  }\n  .m-lg-9 {\n    margin: 3.5rem !important;\n  }\n  .m-lg-10 {\n    margin: 4rem !important;\n  }\n  .m-lg-11 {\n    margin: 5rem !important;\n  }\n  .m-lg-12 {\n    margin: 6rem !important;\n  }\n  .m-lg-13 {\n    margin: 6.5rem !important;\n  }\n  .m-lg-14 {\n    margin: 8rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.125rem !important;\n    margin-left: 0.125rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-6 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-lg-7 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-lg-8 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-lg-9 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-lg-10 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-lg-11 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-lg-12 {\n    margin-right: 6rem !important;\n    margin-left: 6rem !important;\n  }\n  .mx-lg-13 {\n    margin-right: 6.5rem !important;\n    margin-left: 6.5rem !important;\n  }\n  .mx-lg-14 {\n    margin-right: 8rem !important;\n    margin-left: 8rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.125rem !important;\n    margin-bottom: 0.125rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-6 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-lg-7 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-lg-8 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-lg-9 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-lg-10 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-lg-11 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-lg-12 {\n    margin-top: 6rem !important;\n    margin-bottom: 6rem !important;\n  }\n  .my-lg-13 {\n    margin-top: 6.5rem !important;\n    margin-bottom: 6.5rem !important;\n  }\n  .my-lg-14 {\n    margin-top: 8rem !important;\n    margin-bottom: 8rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.125rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-6 {\n    margin-top: 2rem !important;\n  }\n  .mt-lg-7 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-lg-8 {\n    margin-top: 3rem !important;\n  }\n  .mt-lg-9 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-lg-10 {\n    margin-top: 4rem !important;\n  }\n  .mt-lg-11 {\n    margin-top: 5rem !important;\n  }\n  .mt-lg-12 {\n    margin-top: 6rem !important;\n  }\n  .mt-lg-13 {\n    margin-top: 6.5rem !important;\n  }\n  .mt-lg-14 {\n    margin-top: 8rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.125rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.25rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 0.5rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 1rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-6 {\n    margin-right: 2rem !important;\n  }\n  .me-lg-7 {\n    margin-right: 2.5rem !important;\n  }\n  .me-lg-8 {\n    margin-right: 3rem !important;\n  }\n  .me-lg-9 {\n    margin-right: 3.5rem !important;\n  }\n  .me-lg-10 {\n    margin-right: 4rem !important;\n  }\n  .me-lg-11 {\n    margin-right: 5rem !important;\n  }\n  .me-lg-12 {\n    margin-right: 6rem !important;\n  }\n  .me-lg-13 {\n    margin-right: 6.5rem !important;\n  }\n  .me-lg-14 {\n    margin-right: 8rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.125rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-6 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-lg-7 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-lg-8 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-lg-9 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-lg-10 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-lg-11 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-lg-12 {\n    margin-bottom: 6rem !important;\n  }\n  .mb-lg-13 {\n    margin-bottom: 6.5rem !important;\n  }\n  .mb-lg-14 {\n    margin-bottom: 8rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.125rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-6 {\n    margin-left: 2rem !important;\n  }\n  .ms-lg-7 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-lg-8 {\n    margin-left: 3rem !important;\n  }\n  .ms-lg-9 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-lg-10 {\n    margin-left: 4rem !important;\n  }\n  .ms-lg-11 {\n    margin-left: 5rem !important;\n  }\n  .ms-lg-12 {\n    margin-left: 6rem !important;\n  }\n  .ms-lg-13 {\n    margin-left: 6.5rem !important;\n  }\n  .ms-lg-14 {\n    margin-left: 8rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .m-lg-n1 {\n    margin: -0.125rem !important;\n  }\n  .m-lg-n2 {\n    margin: -0.25rem !important;\n  }\n  .m-lg-n3 {\n    margin: -0.5rem !important;\n  }\n  .m-lg-n4 {\n    margin: -1rem !important;\n  }\n  .m-lg-n5 {\n    margin: -1.5rem !important;\n  }\n  .m-lg-n6 {\n    margin: -2rem !important;\n  }\n  .m-lg-n7 {\n    margin: -2.5rem !important;\n  }\n  .m-lg-n8 {\n    margin: -3rem !important;\n  }\n  .m-lg-n9 {\n    margin: -3.5rem !important;\n  }\n  .m-lg-n10 {\n    margin: -4rem !important;\n  }\n  .m-lg-n11 {\n    margin: -5rem !important;\n  }\n  .m-lg-n12 {\n    margin: -6rem !important;\n  }\n  .m-lg-n13 {\n    margin: -6.5rem !important;\n  }\n  .m-lg-n14 {\n    margin: -8rem !important;\n  }\n  .mx-lg-n1 {\n    margin-right: -0.125rem !important;\n    margin-left: -0.125rem !important;\n  }\n  .mx-lg-n2 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-lg-n3 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-lg-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-lg-n5 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-lg-n6 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-lg-n7 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-lg-n8 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-lg-n9 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-lg-n10 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-lg-n11 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .mx-lg-n12 {\n    margin-right: -6rem !important;\n    margin-left: -6rem !important;\n  }\n  .mx-lg-n13 {\n    margin-right: -6.5rem !important;\n    margin-left: -6.5rem !important;\n  }\n  .mx-lg-n14 {\n    margin-right: -8rem !important;\n    margin-left: -8rem !important;\n  }\n  .my-lg-n1 {\n    margin-top: -0.125rem !important;\n    margin-bottom: -0.125rem !important;\n  }\n  .my-lg-n2 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-lg-n3 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-lg-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-lg-n5 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-lg-n6 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-lg-n7 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-lg-n8 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-lg-n9 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-lg-n10 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-lg-n11 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .my-lg-n12 {\n    margin-top: -6rem !important;\n    margin-bottom: -6rem !important;\n  }\n  .my-lg-n13 {\n    margin-top: -6.5rem !important;\n    margin-bottom: -6.5rem !important;\n  }\n  .my-lg-n14 {\n    margin-top: -8rem !important;\n    margin-bottom: -8rem !important;\n  }\n  .mt-lg-n1 {\n    margin-top: -0.125rem !important;\n  }\n  .mt-lg-n2 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-lg-n3 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-lg-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-lg-n5 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-lg-n6 {\n    margin-top: -2rem !important;\n  }\n  .mt-lg-n7 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-lg-n8 {\n    margin-top: -3rem !important;\n  }\n  .mt-lg-n9 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-lg-n10 {\n    margin-top: -4rem !important;\n  }\n  .mt-lg-n11 {\n    margin-top: -5rem !important;\n  }\n  .mt-lg-n12 {\n    margin-top: -6rem !important;\n  }\n  .mt-lg-n13 {\n    margin-top: -6.5rem !important;\n  }\n  .mt-lg-n14 {\n    margin-top: -8rem !important;\n  }\n  .me-lg-n1 {\n    margin-right: -0.125rem !important;\n  }\n  .me-lg-n2 {\n    margin-right: -0.25rem !important;\n  }\n  .me-lg-n3 {\n    margin-right: -0.5rem !important;\n  }\n  .me-lg-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-lg-n5 {\n    margin-right: -1.5rem !important;\n  }\n  .me-lg-n6 {\n    margin-right: -2rem !important;\n  }\n  .me-lg-n7 {\n    margin-right: -2.5rem !important;\n  }\n  .me-lg-n8 {\n    margin-right: -3rem !important;\n  }\n  .me-lg-n9 {\n    margin-right: -3.5rem !important;\n  }\n  .me-lg-n10 {\n    margin-right: -4rem !important;\n  }\n  .me-lg-n11 {\n    margin-right: -5rem !important;\n  }\n  .me-lg-n12 {\n    margin-right: -6rem !important;\n  }\n  .me-lg-n13 {\n    margin-right: -6.5rem !important;\n  }\n  .me-lg-n14 {\n    margin-right: -8rem !important;\n  }\n  .mb-lg-n1 {\n    margin-bottom: -0.125rem !important;\n  }\n  .mb-lg-n2 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-lg-n3 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-lg-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-lg-n5 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-lg-n6 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-lg-n7 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-lg-n8 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-lg-n9 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-lg-n10 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-lg-n11 {\n    margin-bottom: -5rem !important;\n  }\n  .mb-lg-n12 {\n    margin-bottom: -6rem !important;\n  }\n  .mb-lg-n13 {\n    margin-bottom: -6.5rem !important;\n  }\n  .mb-lg-n14 {\n    margin-bottom: -8rem !important;\n  }\n  .ms-lg-n1 {\n    margin-left: -0.125rem !important;\n  }\n  .ms-lg-n2 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-lg-n3 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-lg-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-lg-n5 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-lg-n6 {\n    margin-left: -2rem !important;\n  }\n  .ms-lg-n7 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-lg-n8 {\n    margin-left: -3rem !important;\n  }\n  .ms-lg-n9 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-lg-n10 {\n    margin-left: -4rem !important;\n  }\n  .ms-lg-n11 {\n    margin-left: -5rem !important;\n  }\n  .ms-lg-n12 {\n    margin-left: -6rem !important;\n  }\n  .ms-lg-n13 {\n    margin-left: -6.5rem !important;\n  }\n  .ms-lg-n14 {\n    margin-left: -8rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.125rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.25rem !important;\n  }\n  .p-lg-3 {\n    padding: 0.5rem !important;\n  }\n  .p-lg-4 {\n    padding: 1rem !important;\n  }\n  .p-lg-5 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-6 {\n    padding: 2rem !important;\n  }\n  .p-lg-7 {\n    padding: 2.5rem !important;\n  }\n  .p-lg-8 {\n    padding: 3rem !important;\n  }\n  .p-lg-9 {\n    padding: 3.5rem !important;\n  }\n  .p-lg-10 {\n    padding: 4rem !important;\n  }\n  .p-lg-11 {\n    padding: 5rem !important;\n  }\n  .p-lg-12 {\n    padding: 6rem !important;\n  }\n  .p-lg-13 {\n    padding: 6.5rem !important;\n  }\n  .p-lg-14 {\n    padding: 8rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.125rem !important;\n    padding-left: 0.125rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-6 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-lg-7 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-lg-8 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-lg-9 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-lg-10 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-lg-11 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .px-lg-12 {\n    padding-right: 6rem !important;\n    padding-left: 6rem !important;\n  }\n  .px-lg-13 {\n    padding-right: 6.5rem !important;\n    padding-left: 6.5rem !important;\n  }\n  .px-lg-14 {\n    padding-right: 8rem !important;\n    padding-left: 8rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.125rem !important;\n    padding-bottom: 0.125rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-6 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-lg-7 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-lg-8 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-lg-9 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-lg-10 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-lg-11 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .py-lg-12 {\n    padding-top: 6rem !important;\n    padding-bottom: 6rem !important;\n  }\n  .py-lg-13 {\n    padding-top: 6.5rem !important;\n    padding-bottom: 6.5rem !important;\n  }\n  .py-lg-14 {\n    padding-top: 8rem !important;\n    padding-bottom: 8rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.125rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-6 {\n    padding-top: 2rem !important;\n  }\n  .pt-lg-7 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-lg-8 {\n    padding-top: 3rem !important;\n  }\n  .pt-lg-9 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-lg-10 {\n    padding-top: 4rem !important;\n  }\n  .pt-lg-11 {\n    padding-top: 5rem !important;\n  }\n  .pt-lg-12 {\n    padding-top: 6rem !important;\n  }\n  .pt-lg-13 {\n    padding-top: 6.5rem !important;\n  }\n  .pt-lg-14 {\n    padding-top: 8rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.125rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-6 {\n    padding-right: 2rem !important;\n  }\n  .pe-lg-7 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-lg-8 {\n    padding-right: 3rem !important;\n  }\n  .pe-lg-9 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-lg-10 {\n    padding-right: 4rem !important;\n  }\n  .pe-lg-11 {\n    padding-right: 5rem !important;\n  }\n  .pe-lg-12 {\n    padding-right: 6rem !important;\n  }\n  .pe-lg-13 {\n    padding-right: 6.5rem !important;\n  }\n  .pe-lg-14 {\n    padding-right: 8rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.125rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-6 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-lg-7 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-lg-8 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-lg-9 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-lg-10 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-lg-11 {\n    padding-bottom: 5rem !important;\n  }\n  .pb-lg-12 {\n    padding-bottom: 6rem !important;\n  }\n  .pb-lg-13 {\n    padding-bottom: 6.5rem !important;\n  }\n  .pb-lg-14 {\n    padding-bottom: 8rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.125rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-6 {\n    padding-left: 2rem !important;\n  }\n  .ps-lg-7 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-lg-8 {\n    padding-left: 3rem !important;\n  }\n  .ps-lg-9 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-lg-10 {\n    padding-left: 4rem !important;\n  }\n  .ps-lg-11 {\n    padding-left: 5rem !important;\n  }\n  .ps-lg-12 {\n    padding-left: 6rem !important;\n  }\n  .ps-lg-13 {\n    padding-left: 6.5rem !important;\n  }\n  .ps-lg-14 {\n    padding-left: 8rem !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.125rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.25rem !important;\n  }\n  .gap-lg-3 {\n    gap: 0.5rem !important;\n  }\n  .gap-lg-4 {\n    gap: 1rem !important;\n  }\n  .gap-lg-5 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-6 {\n    gap: 2rem !important;\n  }\n  .gap-lg-7 {\n    gap: 2.5rem !important;\n  }\n  .gap-lg-8 {\n    gap: 3rem !important;\n  }\n  .gap-lg-9 {\n    gap: 3.5rem !important;\n  }\n  .gap-lg-10 {\n    gap: 4rem !important;\n  }\n  .gap-lg-11 {\n    gap: 5rem !important;\n  }\n  .gap-lg-12 {\n    gap: 6rem !important;\n  }\n  .gap-lg-13 {\n    gap: 6.5rem !important;\n  }\n  .gap-lg-14 {\n    gap: 8rem !important;\n  }\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-lg-1 {\n    row-gap: 0.125rem !important;\n  }\n  .row-gap-lg-2 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-lg-3 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-lg-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-lg-5 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-lg-6 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-lg-7 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-lg-8 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-lg-9 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-lg-10 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-lg-11 {\n    row-gap: 5rem !important;\n  }\n  .row-gap-lg-12 {\n    row-gap: 6rem !important;\n  }\n  .row-gap-lg-13 {\n    row-gap: 6.5rem !important;\n  }\n  .row-gap-lg-14 {\n    row-gap: 8rem !important;\n  }\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-lg-1 {\n    column-gap: 0.125rem !important;\n  }\n  .column-gap-lg-2 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-lg-3 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-lg-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-lg-5 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-lg-6 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-lg-7 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-lg-8 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-lg-9 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-lg-10 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-lg-11 {\n    column-gap: 5rem !important;\n  }\n  .column-gap-lg-12 {\n    column-gap: 6rem !important;\n  }\n  .column-gap-lg-13 {\n    column-gap: 6.5rem !important;\n  }\n  .column-gap-lg-14 {\n    column-gap: 8rem !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.125rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.25rem !important;\n  }\n  .m-xl-3 {\n    margin: 0.5rem !important;\n  }\n  .m-xl-4 {\n    margin: 1rem !important;\n  }\n  .m-xl-5 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-6 {\n    margin: 2rem !important;\n  }\n  .m-xl-7 {\n    margin: 2.5rem !important;\n  }\n  .m-xl-8 {\n    margin: 3rem !important;\n  }\n  .m-xl-9 {\n    margin: 3.5rem !important;\n  }\n  .m-xl-10 {\n    margin: 4rem !important;\n  }\n  .m-xl-11 {\n    margin: 5rem !important;\n  }\n  .m-xl-12 {\n    margin: 6rem !important;\n  }\n  .m-xl-13 {\n    margin: 6.5rem !important;\n  }\n  .m-xl-14 {\n    margin: 8rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.125rem !important;\n    margin-left: 0.125rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-6 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-xl-7 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-xl-8 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xl-9 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-xl-10 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-xl-11 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-xl-12 {\n    margin-right: 6rem !important;\n    margin-left: 6rem !important;\n  }\n  .mx-xl-13 {\n    margin-right: 6.5rem !important;\n    margin-left: 6.5rem !important;\n  }\n  .mx-xl-14 {\n    margin-right: 8rem !important;\n    margin-left: 8rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.125rem !important;\n    margin-bottom: 0.125rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-6 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-xl-7 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-xl-8 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xl-9 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-xl-10 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-xl-11 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-xl-12 {\n    margin-top: 6rem !important;\n    margin-bottom: 6rem !important;\n  }\n  .my-xl-13 {\n    margin-top: 6.5rem !important;\n    margin-bottom: 6.5rem !important;\n  }\n  .my-xl-14 {\n    margin-top: 8rem !important;\n    margin-bottom: 8rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.125rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-6 {\n    margin-top: 2rem !important;\n  }\n  .mt-xl-7 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-xl-8 {\n    margin-top: 3rem !important;\n  }\n  .mt-xl-9 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-xl-10 {\n    margin-top: 4rem !important;\n  }\n  .mt-xl-11 {\n    margin-top: 5rem !important;\n  }\n  .mt-xl-12 {\n    margin-top: 6rem !important;\n  }\n  .mt-xl-13 {\n    margin-top: 6.5rem !important;\n  }\n  .mt-xl-14 {\n    margin-top: 8rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.125rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 1rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-6 {\n    margin-right: 2rem !important;\n  }\n  .me-xl-7 {\n    margin-right: 2.5rem !important;\n  }\n  .me-xl-8 {\n    margin-right: 3rem !important;\n  }\n  .me-xl-9 {\n    margin-right: 3.5rem !important;\n  }\n  .me-xl-10 {\n    margin-right: 4rem !important;\n  }\n  .me-xl-11 {\n    margin-right: 5rem !important;\n  }\n  .me-xl-12 {\n    margin-right: 6rem !important;\n  }\n  .me-xl-13 {\n    margin-right: 6.5rem !important;\n  }\n  .me-xl-14 {\n    margin-right: 8rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.125rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-6 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-xl-7 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-xl-8 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xl-9 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-xl-10 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-xl-11 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-xl-12 {\n    margin-bottom: 6rem !important;\n  }\n  .mb-xl-13 {\n    margin-bottom: 6.5rem !important;\n  }\n  .mb-xl-14 {\n    margin-bottom: 8rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.125rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-6 {\n    margin-left: 2rem !important;\n  }\n  .ms-xl-7 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-xl-8 {\n    margin-left: 3rem !important;\n  }\n  .ms-xl-9 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-xl-10 {\n    margin-left: 4rem !important;\n  }\n  .ms-xl-11 {\n    margin-left: 5rem !important;\n  }\n  .ms-xl-12 {\n    margin-left: 6rem !important;\n  }\n  .ms-xl-13 {\n    margin-left: 6.5rem !important;\n  }\n  .ms-xl-14 {\n    margin-left: 8rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .m-xl-n1 {\n    margin: -0.125rem !important;\n  }\n  .m-xl-n2 {\n    margin: -0.25rem !important;\n  }\n  .m-xl-n3 {\n    margin: -0.5rem !important;\n  }\n  .m-xl-n4 {\n    margin: -1rem !important;\n  }\n  .m-xl-n5 {\n    margin: -1.5rem !important;\n  }\n  .m-xl-n6 {\n    margin: -2rem !important;\n  }\n  .m-xl-n7 {\n    margin: -2.5rem !important;\n  }\n  .m-xl-n8 {\n    margin: -3rem !important;\n  }\n  .m-xl-n9 {\n    margin: -3.5rem !important;\n  }\n  .m-xl-n10 {\n    margin: -4rem !important;\n  }\n  .m-xl-n11 {\n    margin: -5rem !important;\n  }\n  .m-xl-n12 {\n    margin: -6rem !important;\n  }\n  .m-xl-n13 {\n    margin: -6.5rem !important;\n  }\n  .m-xl-n14 {\n    margin: -8rem !important;\n  }\n  .mx-xl-n1 {\n    margin-right: -0.125rem !important;\n    margin-left: -0.125rem !important;\n  }\n  .mx-xl-n2 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-xl-n3 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-xl-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-xl-n5 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xl-n6 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-xl-n7 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-xl-n8 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-xl-n9 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-xl-n10 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-xl-n11 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .mx-xl-n12 {\n    margin-right: -6rem !important;\n    margin-left: -6rem !important;\n  }\n  .mx-xl-n13 {\n    margin-right: -6.5rem !important;\n    margin-left: -6.5rem !important;\n  }\n  .mx-xl-n14 {\n    margin-right: -8rem !important;\n    margin-left: -8rem !important;\n  }\n  .my-xl-n1 {\n    margin-top: -0.125rem !important;\n    margin-bottom: -0.125rem !important;\n  }\n  .my-xl-n2 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-xl-n3 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-xl-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-xl-n5 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xl-n6 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-xl-n7 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-xl-n8 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-xl-n9 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-xl-n10 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-xl-n11 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .my-xl-n12 {\n    margin-top: -6rem !important;\n    margin-bottom: -6rem !important;\n  }\n  .my-xl-n13 {\n    margin-top: -6.5rem !important;\n    margin-bottom: -6.5rem !important;\n  }\n  .my-xl-n14 {\n    margin-top: -8rem !important;\n    margin-bottom: -8rem !important;\n  }\n  .mt-xl-n1 {\n    margin-top: -0.125rem !important;\n  }\n  .mt-xl-n2 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-xl-n3 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-xl-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-xl-n5 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xl-n6 {\n    margin-top: -2rem !important;\n  }\n  .mt-xl-n7 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-xl-n8 {\n    margin-top: -3rem !important;\n  }\n  .mt-xl-n9 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-xl-n10 {\n    margin-top: -4rem !important;\n  }\n  .mt-xl-n11 {\n    margin-top: -5rem !important;\n  }\n  .mt-xl-n12 {\n    margin-top: -6rem !important;\n  }\n  .mt-xl-n13 {\n    margin-top: -6.5rem !important;\n  }\n  .mt-xl-n14 {\n    margin-top: -8rem !important;\n  }\n  .me-xl-n1 {\n    margin-right: -0.125rem !important;\n  }\n  .me-xl-n2 {\n    margin-right: -0.25rem !important;\n  }\n  .me-xl-n3 {\n    margin-right: -0.5rem !important;\n  }\n  .me-xl-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-xl-n5 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xl-n6 {\n    margin-right: -2rem !important;\n  }\n  .me-xl-n7 {\n    margin-right: -2.5rem !important;\n  }\n  .me-xl-n8 {\n    margin-right: -3rem !important;\n  }\n  .me-xl-n9 {\n    margin-right: -3.5rem !important;\n  }\n  .me-xl-n10 {\n    margin-right: -4rem !important;\n  }\n  .me-xl-n11 {\n    margin-right: -5rem !important;\n  }\n  .me-xl-n12 {\n    margin-right: -6rem !important;\n  }\n  .me-xl-n13 {\n    margin-right: -6.5rem !important;\n  }\n  .me-xl-n14 {\n    margin-right: -8rem !important;\n  }\n  .mb-xl-n1 {\n    margin-bottom: -0.125rem !important;\n  }\n  .mb-xl-n2 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-xl-n3 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-xl-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-xl-n5 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xl-n6 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-xl-n7 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-xl-n8 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-xl-n9 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-xl-n10 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-xl-n11 {\n    margin-bottom: -5rem !important;\n  }\n  .mb-xl-n12 {\n    margin-bottom: -6rem !important;\n  }\n  .mb-xl-n13 {\n    margin-bottom: -6.5rem !important;\n  }\n  .mb-xl-n14 {\n    margin-bottom: -8rem !important;\n  }\n  .ms-xl-n1 {\n    margin-left: -0.125rem !important;\n  }\n  .ms-xl-n2 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-xl-n3 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-xl-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-xl-n5 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xl-n6 {\n    margin-left: -2rem !important;\n  }\n  .ms-xl-n7 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-xl-n8 {\n    margin-left: -3rem !important;\n  }\n  .ms-xl-n9 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-xl-n10 {\n    margin-left: -4rem !important;\n  }\n  .ms-xl-n11 {\n    margin-left: -5rem !important;\n  }\n  .ms-xl-n12 {\n    margin-left: -6rem !important;\n  }\n  .ms-xl-n13 {\n    margin-left: -6.5rem !important;\n  }\n  .ms-xl-n14 {\n    margin-left: -8rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.125rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.25rem !important;\n  }\n  .p-xl-3 {\n    padding: 0.5rem !important;\n  }\n  .p-xl-4 {\n    padding: 1rem !important;\n  }\n  .p-xl-5 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-6 {\n    padding: 2rem !important;\n  }\n  .p-xl-7 {\n    padding: 2.5rem !important;\n  }\n  .p-xl-8 {\n    padding: 3rem !important;\n  }\n  .p-xl-9 {\n    padding: 3.5rem !important;\n  }\n  .p-xl-10 {\n    padding: 4rem !important;\n  }\n  .p-xl-11 {\n    padding: 5rem !important;\n  }\n  .p-xl-12 {\n    padding: 6rem !important;\n  }\n  .p-xl-13 {\n    padding: 6.5rem !important;\n  }\n  .p-xl-14 {\n    padding: 8rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.125rem !important;\n    padding-left: 0.125rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-6 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-xl-7 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-xl-8 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-xl-9 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-xl-10 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-xl-11 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .px-xl-12 {\n    padding-right: 6rem !important;\n    padding-left: 6rem !important;\n  }\n  .px-xl-13 {\n    padding-right: 6.5rem !important;\n    padding-left: 6.5rem !important;\n  }\n  .px-xl-14 {\n    padding-right: 8rem !important;\n    padding-left: 8rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.125rem !important;\n    padding-bottom: 0.125rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-6 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-xl-7 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-xl-8 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-xl-9 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-xl-10 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-xl-11 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .py-xl-12 {\n    padding-top: 6rem !important;\n    padding-bottom: 6rem !important;\n  }\n  .py-xl-13 {\n    padding-top: 6.5rem !important;\n    padding-bottom: 6.5rem !important;\n  }\n  .py-xl-14 {\n    padding-top: 8rem !important;\n    padding-bottom: 8rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.125rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-6 {\n    padding-top: 2rem !important;\n  }\n  .pt-xl-7 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-xl-8 {\n    padding-top: 3rem !important;\n  }\n  .pt-xl-9 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-xl-10 {\n    padding-top: 4rem !important;\n  }\n  .pt-xl-11 {\n    padding-top: 5rem !important;\n  }\n  .pt-xl-12 {\n    padding-top: 6rem !important;\n  }\n  .pt-xl-13 {\n    padding-top: 6.5rem !important;\n  }\n  .pt-xl-14 {\n    padding-top: 8rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.125rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-6 {\n    padding-right: 2rem !important;\n  }\n  .pe-xl-7 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-xl-8 {\n    padding-right: 3rem !important;\n  }\n  .pe-xl-9 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-xl-10 {\n    padding-right: 4rem !important;\n  }\n  .pe-xl-11 {\n    padding-right: 5rem !important;\n  }\n  .pe-xl-12 {\n    padding-right: 6rem !important;\n  }\n  .pe-xl-13 {\n    padding-right: 6.5rem !important;\n  }\n  .pe-xl-14 {\n    padding-right: 8rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.125rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-6 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-xl-7 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-xl-8 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-xl-9 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-xl-10 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-xl-11 {\n    padding-bottom: 5rem !important;\n  }\n  .pb-xl-12 {\n    padding-bottom: 6rem !important;\n  }\n  .pb-xl-13 {\n    padding-bottom: 6.5rem !important;\n  }\n  .pb-xl-14 {\n    padding-bottom: 8rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.125rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-6 {\n    padding-left: 2rem !important;\n  }\n  .ps-xl-7 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-xl-8 {\n    padding-left: 3rem !important;\n  }\n  .ps-xl-9 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-xl-10 {\n    padding-left: 4rem !important;\n  }\n  .ps-xl-11 {\n    padding-left: 5rem !important;\n  }\n  .ps-xl-12 {\n    padding-left: 6rem !important;\n  }\n  .ps-xl-13 {\n    padding-left: 6.5rem !important;\n  }\n  .ps-xl-14 {\n    padding-left: 8rem !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.125rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.25rem !important;\n  }\n  .gap-xl-3 {\n    gap: 0.5rem !important;\n  }\n  .gap-xl-4 {\n    gap: 1rem !important;\n  }\n  .gap-xl-5 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-6 {\n    gap: 2rem !important;\n  }\n  .gap-xl-7 {\n    gap: 2.5rem !important;\n  }\n  .gap-xl-8 {\n    gap: 3rem !important;\n  }\n  .gap-xl-9 {\n    gap: 3.5rem !important;\n  }\n  .gap-xl-10 {\n    gap: 4rem !important;\n  }\n  .gap-xl-11 {\n    gap: 5rem !important;\n  }\n  .gap-xl-12 {\n    gap: 6rem !important;\n  }\n  .gap-xl-13 {\n    gap: 6.5rem !important;\n  }\n  .gap-xl-14 {\n    gap: 8rem !important;\n  }\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xl-1 {\n    row-gap: 0.125rem !important;\n  }\n  .row-gap-xl-2 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xl-3 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xl-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xl-5 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xl-6 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-xl-7 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-xl-8 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-xl-9 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-xl-10 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-xl-11 {\n    row-gap: 5rem !important;\n  }\n  .row-gap-xl-12 {\n    row-gap: 6rem !important;\n  }\n  .row-gap-xl-13 {\n    row-gap: 6.5rem !important;\n  }\n  .row-gap-xl-14 {\n    row-gap: 8rem !important;\n  }\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xl-1 {\n    column-gap: 0.125rem !important;\n  }\n  .column-gap-xl-2 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xl-3 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xl-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xl-5 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xl-6 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-xl-7 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-xl-8 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-xl-9 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-xl-10 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-xl-11 {\n    column-gap: 5rem !important;\n  }\n  .column-gap-xl-12 {\n    column-gap: 6rem !important;\n  }\n  .column-gap-xl-13 {\n    column-gap: 6.5rem !important;\n  }\n  .column-gap-xl-14 {\n    column-gap: 8rem !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.125rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.25rem !important;\n  }\n  .m-xxl-3 {\n    margin: 0.5rem !important;\n  }\n  .m-xxl-4 {\n    margin: 1rem !important;\n  }\n  .m-xxl-5 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-6 {\n    margin: 2rem !important;\n  }\n  .m-xxl-7 {\n    margin: 2.5rem !important;\n  }\n  .m-xxl-8 {\n    margin: 3rem !important;\n  }\n  .m-xxl-9 {\n    margin: 3.5rem !important;\n  }\n  .m-xxl-10 {\n    margin: 4rem !important;\n  }\n  .m-xxl-11 {\n    margin: 5rem !important;\n  }\n  .m-xxl-12 {\n    margin: 6rem !important;\n  }\n  .m-xxl-13 {\n    margin: 6.5rem !important;\n  }\n  .m-xxl-14 {\n    margin: 8rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.125rem !important;\n    margin-left: 0.125rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-6 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-xxl-7 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-xxl-8 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xxl-9 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-xxl-10 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-xxl-11 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-xxl-12 {\n    margin-right: 6rem !important;\n    margin-left: 6rem !important;\n  }\n  .mx-xxl-13 {\n    margin-right: 6.5rem !important;\n    margin-left: 6.5rem !important;\n  }\n  .mx-xxl-14 {\n    margin-right: 8rem !important;\n    margin-left: 8rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.125rem !important;\n    margin-bottom: 0.125rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-6 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-xxl-7 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-xxl-8 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xxl-9 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-xxl-10 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-xxl-11 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-xxl-12 {\n    margin-top: 6rem !important;\n    margin-bottom: 6rem !important;\n  }\n  .my-xxl-13 {\n    margin-top: 6.5rem !important;\n    margin-bottom: 6.5rem !important;\n  }\n  .my-xxl-14 {\n    margin-top: 8rem !important;\n    margin-bottom: 8rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.125rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-6 {\n    margin-top: 2rem !important;\n  }\n  .mt-xxl-7 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-xxl-8 {\n    margin-top: 3rem !important;\n  }\n  .mt-xxl-9 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-xxl-10 {\n    margin-top: 4rem !important;\n  }\n  .mt-xxl-11 {\n    margin-top: 5rem !important;\n  }\n  .mt-xxl-12 {\n    margin-top: 6rem !important;\n  }\n  .mt-xxl-13 {\n    margin-top: 6.5rem !important;\n  }\n  .mt-xxl-14 {\n    margin-top: 8rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.125rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 1rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-6 {\n    margin-right: 2rem !important;\n  }\n  .me-xxl-7 {\n    margin-right: 2.5rem !important;\n  }\n  .me-xxl-8 {\n    margin-right: 3rem !important;\n  }\n  .me-xxl-9 {\n    margin-right: 3.5rem !important;\n  }\n  .me-xxl-10 {\n    margin-right: 4rem !important;\n  }\n  .me-xxl-11 {\n    margin-right: 5rem !important;\n  }\n  .me-xxl-12 {\n    margin-right: 6rem !important;\n  }\n  .me-xxl-13 {\n    margin-right: 6.5rem !important;\n  }\n  .me-xxl-14 {\n    margin-right: 8rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.125rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-6 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-xxl-7 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-xxl-8 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xxl-9 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-xxl-10 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-xxl-11 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-xxl-12 {\n    margin-bottom: 6rem !important;\n  }\n  .mb-xxl-13 {\n    margin-bottom: 6.5rem !important;\n  }\n  .mb-xxl-14 {\n    margin-bottom: 8rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.125rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-6 {\n    margin-left: 2rem !important;\n  }\n  .ms-xxl-7 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-xxl-8 {\n    margin-left: 3rem !important;\n  }\n  .ms-xxl-9 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-xxl-10 {\n    margin-left: 4rem !important;\n  }\n  .ms-xxl-11 {\n    margin-left: 5rem !important;\n  }\n  .ms-xxl-12 {\n    margin-left: 6rem !important;\n  }\n  .ms-xxl-13 {\n    margin-left: 6.5rem !important;\n  }\n  .ms-xxl-14 {\n    margin-left: 8rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .m-xxl-n1 {\n    margin: -0.125rem !important;\n  }\n  .m-xxl-n2 {\n    margin: -0.25rem !important;\n  }\n  .m-xxl-n3 {\n    margin: -0.5rem !important;\n  }\n  .m-xxl-n4 {\n    margin: -1rem !important;\n  }\n  .m-xxl-n5 {\n    margin: -1.5rem !important;\n  }\n  .m-xxl-n6 {\n    margin: -2rem !important;\n  }\n  .m-xxl-n7 {\n    margin: -2.5rem !important;\n  }\n  .m-xxl-n8 {\n    margin: -3rem !important;\n  }\n  .m-xxl-n9 {\n    margin: -3.5rem !important;\n  }\n  .m-xxl-n10 {\n    margin: -4rem !important;\n  }\n  .m-xxl-n11 {\n    margin: -5rem !important;\n  }\n  .m-xxl-n12 {\n    margin: -6rem !important;\n  }\n  .m-xxl-n13 {\n    margin: -6.5rem !important;\n  }\n  .m-xxl-n14 {\n    margin: -8rem !important;\n  }\n  .mx-xxl-n1 {\n    margin-right: -0.125rem !important;\n    margin-left: -0.125rem !important;\n  }\n  .mx-xxl-n2 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-xxl-n3 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-xxl-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-xxl-n5 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xxl-n6 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-xxl-n7 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-xxl-n8 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-xxl-n9 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-xxl-n10 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-xxl-n11 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .mx-xxl-n12 {\n    margin-right: -6rem !important;\n    margin-left: -6rem !important;\n  }\n  .mx-xxl-n13 {\n    margin-right: -6.5rem !important;\n    margin-left: -6.5rem !important;\n  }\n  .mx-xxl-n14 {\n    margin-right: -8rem !important;\n    margin-left: -8rem !important;\n  }\n  .my-xxl-n1 {\n    margin-top: -0.125rem !important;\n    margin-bottom: -0.125rem !important;\n  }\n  .my-xxl-n2 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-xxl-n3 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-xxl-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-xxl-n5 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xxl-n6 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-xxl-n7 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-xxl-n8 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-xxl-n9 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-xxl-n10 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-xxl-n11 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .my-xxl-n12 {\n    margin-top: -6rem !important;\n    margin-bottom: -6rem !important;\n  }\n  .my-xxl-n13 {\n    margin-top: -6.5rem !important;\n    margin-bottom: -6.5rem !important;\n  }\n  .my-xxl-n14 {\n    margin-top: -8rem !important;\n    margin-bottom: -8rem !important;\n  }\n  .mt-xxl-n1 {\n    margin-top: -0.125rem !important;\n  }\n  .mt-xxl-n2 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-xxl-n3 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-xxl-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-xxl-n5 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xxl-n6 {\n    margin-top: -2rem !important;\n  }\n  .mt-xxl-n7 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-xxl-n8 {\n    margin-top: -3rem !important;\n  }\n  .mt-xxl-n9 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-xxl-n10 {\n    margin-top: -4rem !important;\n  }\n  .mt-xxl-n11 {\n    margin-top: -5rem !important;\n  }\n  .mt-xxl-n12 {\n    margin-top: -6rem !important;\n  }\n  .mt-xxl-n13 {\n    margin-top: -6.5rem !important;\n  }\n  .mt-xxl-n14 {\n    margin-top: -8rem !important;\n  }\n  .me-xxl-n1 {\n    margin-right: -0.125rem !important;\n  }\n  .me-xxl-n2 {\n    margin-right: -0.25rem !important;\n  }\n  .me-xxl-n3 {\n    margin-right: -0.5rem !important;\n  }\n  .me-xxl-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-xxl-n5 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xxl-n6 {\n    margin-right: -2rem !important;\n  }\n  .me-xxl-n7 {\n    margin-right: -2.5rem !important;\n  }\n  .me-xxl-n8 {\n    margin-right: -3rem !important;\n  }\n  .me-xxl-n9 {\n    margin-right: -3.5rem !important;\n  }\n  .me-xxl-n10 {\n    margin-right: -4rem !important;\n  }\n  .me-xxl-n11 {\n    margin-right: -5rem !important;\n  }\n  .me-xxl-n12 {\n    margin-right: -6rem !important;\n  }\n  .me-xxl-n13 {\n    margin-right: -6.5rem !important;\n  }\n  .me-xxl-n14 {\n    margin-right: -8rem !important;\n  }\n  .mb-xxl-n1 {\n    margin-bottom: -0.125rem !important;\n  }\n  .mb-xxl-n2 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-xxl-n3 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-xxl-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-xxl-n5 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xxl-n6 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-xxl-n7 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-xxl-n8 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-xxl-n9 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-xxl-n10 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-xxl-n11 {\n    margin-bottom: -5rem !important;\n  }\n  .mb-xxl-n12 {\n    margin-bottom: -6rem !important;\n  }\n  .mb-xxl-n13 {\n    margin-bottom: -6.5rem !important;\n  }\n  .mb-xxl-n14 {\n    margin-bottom: -8rem !important;\n  }\n  .ms-xxl-n1 {\n    margin-left: -0.125rem !important;\n  }\n  .ms-xxl-n2 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-xxl-n3 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-xxl-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-xxl-n5 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xxl-n6 {\n    margin-left: -2rem !important;\n  }\n  .ms-xxl-n7 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-xxl-n8 {\n    margin-left: -3rem !important;\n  }\n  .ms-xxl-n9 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-xxl-n10 {\n    margin-left: -4rem !important;\n  }\n  .ms-xxl-n11 {\n    margin-left: -5rem !important;\n  }\n  .ms-xxl-n12 {\n    margin-left: -6rem !important;\n  }\n  .ms-xxl-n13 {\n    margin-left: -6.5rem !important;\n  }\n  .ms-xxl-n14 {\n    margin-left: -8rem !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.125rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.25rem !important;\n  }\n  .p-xxl-3 {\n    padding: 0.5rem !important;\n  }\n  .p-xxl-4 {\n    padding: 1rem !important;\n  }\n  .p-xxl-5 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-6 {\n    padding: 2rem !important;\n  }\n  .p-xxl-7 {\n    padding: 2.5rem !important;\n  }\n  .p-xxl-8 {\n    padding: 3rem !important;\n  }\n  .p-xxl-9 {\n    padding: 3.5rem !important;\n  }\n  .p-xxl-10 {\n    padding: 4rem !important;\n  }\n  .p-xxl-11 {\n    padding: 5rem !important;\n  }\n  .p-xxl-12 {\n    padding: 6rem !important;\n  }\n  .p-xxl-13 {\n    padding: 6.5rem !important;\n  }\n  .p-xxl-14 {\n    padding: 8rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.125rem !important;\n    padding-left: 0.125rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-6 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-xxl-7 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-xxl-8 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-xxl-9 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-xxl-10 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-xxl-11 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .px-xxl-12 {\n    padding-right: 6rem !important;\n    padding-left: 6rem !important;\n  }\n  .px-xxl-13 {\n    padding-right: 6.5rem !important;\n    padding-left: 6.5rem !important;\n  }\n  .px-xxl-14 {\n    padding-right: 8rem !important;\n    padding-left: 8rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.125rem !important;\n    padding-bottom: 0.125rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-6 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-xxl-7 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-xxl-8 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-xxl-9 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-xxl-10 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-xxl-11 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .py-xxl-12 {\n    padding-top: 6rem !important;\n    padding-bottom: 6rem !important;\n  }\n  .py-xxl-13 {\n    padding-top: 6.5rem !important;\n    padding-bottom: 6.5rem !important;\n  }\n  .py-xxl-14 {\n    padding-top: 8rem !important;\n    padding-bottom: 8rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.125rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-6 {\n    padding-top: 2rem !important;\n  }\n  .pt-xxl-7 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-xxl-8 {\n    padding-top: 3rem !important;\n  }\n  .pt-xxl-9 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-xxl-10 {\n    padding-top: 4rem !important;\n  }\n  .pt-xxl-11 {\n    padding-top: 5rem !important;\n  }\n  .pt-xxl-12 {\n    padding-top: 6rem !important;\n  }\n  .pt-xxl-13 {\n    padding-top: 6.5rem !important;\n  }\n  .pt-xxl-14 {\n    padding-top: 8rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.125rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-6 {\n    padding-right: 2rem !important;\n  }\n  .pe-xxl-7 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-xxl-8 {\n    padding-right: 3rem !important;\n  }\n  .pe-xxl-9 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-xxl-10 {\n    padding-right: 4rem !important;\n  }\n  .pe-xxl-11 {\n    padding-right: 5rem !important;\n  }\n  .pe-xxl-12 {\n    padding-right: 6rem !important;\n  }\n  .pe-xxl-13 {\n    padding-right: 6.5rem !important;\n  }\n  .pe-xxl-14 {\n    padding-right: 8rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.125rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-6 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-xxl-7 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-xxl-8 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-xxl-9 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-xxl-10 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-xxl-11 {\n    padding-bottom: 5rem !important;\n  }\n  .pb-xxl-12 {\n    padding-bottom: 6rem !important;\n  }\n  .pb-xxl-13 {\n    padding-bottom: 6.5rem !important;\n  }\n  .pb-xxl-14 {\n    padding-bottom: 8rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.125rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-6 {\n    padding-left: 2rem !important;\n  }\n  .ps-xxl-7 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-xxl-8 {\n    padding-left: 3rem !important;\n  }\n  .ps-xxl-9 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-xxl-10 {\n    padding-left: 4rem !important;\n  }\n  .ps-xxl-11 {\n    padding-left: 5rem !important;\n  }\n  .ps-xxl-12 {\n    padding-left: 6rem !important;\n  }\n  .ps-xxl-13 {\n    padding-left: 6.5rem !important;\n  }\n  .ps-xxl-14 {\n    padding-left: 8rem !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.125rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.25rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 0.5rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 1rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-6 {\n    gap: 2rem !important;\n  }\n  .gap-xxl-7 {\n    gap: 2.5rem !important;\n  }\n  .gap-xxl-8 {\n    gap: 3rem !important;\n  }\n  .gap-xxl-9 {\n    gap: 3.5rem !important;\n  }\n  .gap-xxl-10 {\n    gap: 4rem !important;\n  }\n  .gap-xxl-11 {\n    gap: 5rem !important;\n  }\n  .gap-xxl-12 {\n    gap: 6rem !important;\n  }\n  .gap-xxl-13 {\n    gap: 6.5rem !important;\n  }\n  .gap-xxl-14 {\n    gap: 8rem !important;\n  }\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xxl-1 {\n    row-gap: 0.125rem !important;\n  }\n  .row-gap-xxl-2 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xxl-3 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xxl-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xxl-5 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xxl-6 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-xxl-7 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-xxl-8 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-xxl-9 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-xxl-10 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-xxl-11 {\n    row-gap: 5rem !important;\n  }\n  .row-gap-xxl-12 {\n    row-gap: 6rem !important;\n  }\n  .row-gap-xxl-13 {\n    row-gap: 6.5rem !important;\n  }\n  .row-gap-xxl-14 {\n    row-gap: 8rem !important;\n  }\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xxl-1 {\n    column-gap: 0.125rem !important;\n  }\n  .column-gap-xxl-2 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xxl-3 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xxl-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xxl-5 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xxl-6 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-xxl-7 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-xxl-8 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-xxl-9 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-xxl-10 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-xxl-11 {\n    column-gap: 5rem !important;\n  }\n  .column-gap-xxl-12 {\n    column-gap: 6rem !important;\n  }\n  .column-gap-xxl-13 {\n    column-gap: 6.5rem !important;\n  }\n  .column-gap-xxl-14 {\n    column-gap: 8rem !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\n[data-bs-theme=dark],\n.dark {\n  --bs-body-color: #fff;\n  --bs-border-color: #343434;\n  --bs-success-rgb: 107, 240, 175;\n  --bs-info-rgb: 140, 219, 255;\n  --bs-warning-rgb: 255, 243, 148;\n  --bs-danger-rgb: 255, 169, 187;\n  --bs-success-border-subtle: #24a365;\n  --bs-info-border-subtle: #3789ad;\n  --bs-warning-border-subtle: #c4b63f;\n  --bs-danger-border-subtle: #c34b63;\n  --bs-form-valid-border-color: #2ee68c;\n  --bs-form-invalid-border-color: #ff7591;\n}\n\n.dark {\n  background: #111;\n  color: #fff;\n}\n\n:root {\n  --bs-border-radius-xs: 0.125rem;\n  --bs-border-radius-3xl: 1.25rem;\n  --bs-border-radius-4xl: 1.5rem;\n}\n\n.dark .bg-primary {\n  background-color: #343434 !important;\n}\n.dark .bg-secondary {\n  background-color: #232323 !important;\n}\n.dark .bg-tertiary {\n  background-color: #111111 !important;\n}\n.dark .bg-quartenary {\n  background-color: #090909 !important;\n}\n.dark .bg-quinary {\n  background-color: #000000 !important;\n}\n.dark .dark-bg-primary {\n  background-color: #343434 !important;\n}\n.dark .dark-bg-secondary {\n  background-color: #232323 !important;\n}\n.dark .dark-bg-tertiary {\n  background-color: #111111 !important;\n}\n.dark .dark-bg-quartenary {\n  background-color: #090909 !important;\n}\n.dark .dark-bg-quinary {\n  background-color: #000000 !important;\n}\n\n.bg-dark-gray-50 {\n  background-color: #767676 !important;\n}\n\n.text-dark-gray-50 {\n  color: #767676 !important;\n}\n\n.border-dark-gray-50 {\n  border-color: #767676 !important;\n}\n\n.bg-dark-gray-100 {\n  background-color: #666666 !important;\n}\n\n.text-dark-gray-100 {\n  color: #666666 !important;\n}\n\n.border-dark-gray-100 {\n  border-color: #666666 !important;\n}\n\n.bg-dark-gray-200 {\n  background-color: #575757 !important;\n}\n\n.text-dark-gray-200 {\n  color: #575757 !important;\n}\n\n.border-dark-gray-200 {\n  border-color: #575757 !important;\n}\n\n.bg-dark-gray-300 {\n  background-color: #4b4b4b !important;\n}\n\n.text-dark-gray-300 {\n  color: #4b4b4b !important;\n}\n\n.border-dark-gray-300 {\n  border-color: #4b4b4b !important;\n}\n\n.bg-dark-gray-400 {\n  background-color: #404040 !important;\n}\n\n.text-dark-gray-400 {\n  color: #404040 !important;\n}\n\n.border-dark-gray-400 {\n  border-color: #404040 !important;\n}\n\n.bg-dark-gray-500 {\n  background-color: #343434 !important;\n}\n\n.text-dark-gray-500 {\n  color: #343434 !important;\n}\n\n.border-dark-gray-500 {\n  border-color: #343434 !important;\n}\n\n.bg-dark-gray-600 {\n  background-color: #232323 !important;\n}\n\n.text-dark-gray-600 {\n  color: #232323 !important;\n}\n\n.border-dark-gray-600 {\n  border-color: #232323 !important;\n}\n\n.bg-dark-gray-700 {\n  background-color: #111111 !important;\n}\n\n.text-dark-gray-700 {\n  color: #111111 !important;\n}\n\n.border-dark-gray-700 {\n  border-color: #111111 !important;\n}\n\n.bg-dark-gray-800 {\n  background-color: #090909 !important;\n}\n\n.text-dark-gray-800 {\n  color: #090909 !important;\n}\n\n.border-dark-gray-800 {\n  border-color: #090909 !important;\n}\n\n.bg-dark-gray-900 {\n  background-color: #000000 !important;\n}\n\n.text-dark-gray-900 {\n  color: #000000 !important;\n}\n\n.border-dark-gray-900 {\n  border-color: #000000 !important;\n}\n\n.bg-light-gray-50 {\n  background-color: #fcfcfc !important;\n}\n\n.text-light-gray-50 {\n  color: #fcfcfc !important;\n}\n\n.border-light-gray-50 {\n  border-color: #fcfcfc !important;\n}\n\n.bg-light-gray-100 {\n  background-color: #fafafa !important;\n}\n\n.text-light-gray-100 {\n  color: #fafafa !important;\n}\n\n.border-light-gray-100 {\n  border-color: #fafafa !important;\n}\n\n.bg-light-gray-200 {\n  background-color: #f2f2f2 !important;\n}\n\n.text-light-gray-200 {\n  color: #f2f2f2 !important;\n}\n\n.border-light-gray-200 {\n  border-color: #f2f2f2 !important;\n}\n\n.bg-light-gray-300 {\n  background-color: #ededed !important;\n}\n\n.text-light-gray-300 {\n  color: #ededed !important;\n}\n\n.border-light-gray-300 {\n  border-color: #ededed !important;\n}\n\n.bg-light-gray-400 {\n  background-color: #dedede !important;\n}\n\n.text-light-gray-400 {\n  color: #dedede !important;\n}\n\n.border-light-gray-400 {\n  border-color: #dedede !important;\n}\n\n.bg-light-gray-500 {\n  background-color: #cccccc !important;\n}\n\n.text-light-gray-500 {\n  color: #cccccc !important;\n}\n\n.border-light-gray-500 {\n  border-color: #cccccc !important;\n}\n\n.bg-light-gray-600 {\n  background-color: #b6b6b6 !important;\n}\n\n.text-light-gray-600 {\n  color: #b6b6b6 !important;\n}\n\n.border-light-gray-600 {\n  border-color: #b6b6b6 !important;\n}\n\n.bg-light-gray-700 {\n  background-color: #a1a1a1 !important;\n}\n\n.text-light-gray-700 {\n  color: #a1a1a1 !important;\n}\n\n.border-light-gray-700 {\n  border-color: #a1a1a1 !important;\n}\n\n.bg-light-gray-800 {\n  background-color: #878787 !important;\n}\n\n.text-light-gray-800 {\n  color: #878787 !important;\n}\n\n.border-light-gray-800 {\n  border-color: #878787 !important;\n}\n\n.bg-light-gray-900 {\n  background-color: #808080 !important;\n}\n\n.text-light-gray-900 {\n  color: #808080 !important;\n}\n\n.border-light-gray-900 {\n  border-color: #808080 !important;\n}\n\n.bg-op-dark-gray-50 {\n  background-color: rgba(17, 17, 17, 0.575) !important;\n}\n\n.text-op-dark-gray-50 {\n  color: rgba(17, 17, 17, 0.575) !important;\n}\n\n.border-op-dark-gray-50 {\n  border-color: rgba(17, 17, 17, 0.575) !important;\n}\n\n.bg-op-dark-gray-100 {\n  background-color: rgba(17, 17, 17, 0.645) !important;\n}\n\n.text-op-dark-gray-100 {\n  color: rgba(17, 17, 17, 0.645) !important;\n}\n\n.border-op-dark-gray-100 {\n  border-color: rgba(17, 17, 17, 0.645) !important;\n}\n\n.bg-op-dark-gray-200 {\n  background-color: rgba(17, 17, 17, 0.705) !important;\n}\n\n.text-op-dark-gray-200 {\n  color: rgba(17, 17, 17, 0.705) !important;\n}\n\n.border-op-dark-gray-200 {\n  border-color: rgba(17, 17, 17, 0.705) !important;\n}\n\n.bg-op-dark-gray-300 {\n  background-color: rgba(17, 17, 17, 0.755) !important;\n}\n\n.text-op-dark-gray-300 {\n  color: rgba(17, 17, 17, 0.755) !important;\n}\n\n.border-op-dark-gray-300 {\n  border-color: rgba(17, 17, 17, 0.755) !important;\n}\n\n.bg-op-dark-gray-400 {\n  background-color: rgba(17, 17, 17, 0.805) !important;\n}\n\n.text-op-dark-gray-400 {\n  color: rgba(17, 17, 17, 0.805) !important;\n}\n\n.border-op-dark-gray-400 {\n  border-color: rgba(17, 17, 17, 0.805) !important;\n}\n\n.bg-op-dark-gray-500 {\n  background-color: rgba(17, 17, 17, 0.85) !important;\n}\n\n.text-op-dark-gray-500 {\n  color: rgba(17, 17, 17, 0.85) !important;\n}\n\n.border-op-dark-gray-500 {\n  border-color: rgba(17, 17, 17, 0.85) !important;\n}\n\n.bg-op-dark-gray-600 {\n  background-color: rgba(17, 17, 17, 0.925) !important;\n}\n\n.text-op-dark-gray-600 {\n  color: rgba(17, 17, 17, 0.925) !important;\n}\n\n.border-op-dark-gray-600 {\n  border-color: rgba(17, 17, 17, 0.925) !important;\n}\n\n.bg-op-dark-gray-700 {\n  background-color: #111111 !important;\n}\n\n.text-op-dark-gray-700 {\n  color: #111111 !important;\n}\n\n.border-op-dark-gray-700 {\n  border-color: #111111 !important;\n}\n\n.bg-op-dark-gray-800 {\n  background-color: #090909 !important;\n}\n\n.text-op-dark-gray-800 {\n  color: #090909 !important;\n}\n\n.border-op-dark-gray-800 {\n  border-color: #090909 !important;\n}\n\n.bg-op-dark-gray-900 {\n  background-color: black !important;\n}\n\n.text-op-dark-gray-900 {\n  color: black !important;\n}\n\n.border-op-dark-gray-900 {\n  border-color: black !important;\n}\n\n.bg-op-light-gray-50 {\n  background-color: rgba(17, 17, 17, 0.01) !important;\n}\n\n.text-op-light-gray-50 {\n  color: rgba(17, 17, 17, 0.01) !important;\n}\n\n.border-op-light-gray-50 {\n  border-color: rgba(17, 17, 17, 0.01) !important;\n}\n\n.bg-op-light-gray-100 {\n  background-color: rgba(17, 17, 17, 0.02) !important;\n}\n\n.text-op-light-gray-100 {\n  color: rgba(17, 17, 17, 0.02) !important;\n}\n\n.border-op-light-gray-100 {\n  border-color: rgba(17, 17, 17, 0.02) !important;\n}\n\n.bg-op-light-gray-200 {\n  background-color: rgba(17, 17, 17, 0.055) !important;\n}\n\n.text-op-light-gray-200 {\n  color: rgba(17, 17, 17, 0.055) !important;\n}\n\n.border-op-light-gray-200 {\n  border-color: rgba(17, 17, 17, 0.055) !important;\n}\n\n.bg-op-light-gray-300 {\n  background-color: rgba(17, 17, 17, 0.075) !important;\n}\n\n.text-op-light-gray-300 {\n  color: rgba(17, 17, 17, 0.075) !important;\n}\n\n.border-op-light-gray-300 {\n  border-color: rgba(17, 17, 17, 0.075) !important;\n}\n\n.bg-op-light-gray-400 {\n  background-color: rgba(17, 17, 17, 0.135) !important;\n}\n\n.text-op-light-gray-400 {\n  color: rgba(17, 17, 17, 0.135) !important;\n}\n\n.border-op-light-gray-400 {\n  border-color: rgba(17, 17, 17, 0.135) !important;\n}\n\n.bg-op-light-gray-500 {\n  background-color: rgba(17, 17, 17, 0.215) !important;\n}\n\n.text-op-light-gray-500 {\n  color: rgba(17, 17, 17, 0.215) !important;\n}\n\n.border-op-light-gray-500 {\n  border-color: rgba(17, 17, 17, 0.215) !important;\n}\n\n.bg-op-light-gray-600 {\n  background-color: rgba(17, 17, 17, 0.305) !important;\n}\n\n.text-op-light-gray-600 {\n  color: rgba(17, 17, 17, 0.305) !important;\n}\n\n.border-op-light-gray-600 {\n  border-color: rgba(17, 17, 17, 0.305) !important;\n}\n\n.bg-op-light-gray-700 {\n  background-color: rgba(17, 17, 17, 0.395) !important;\n}\n\n.text-op-light-gray-700 {\n  color: rgba(17, 17, 17, 0.395) !important;\n}\n\n.border-op-light-gray-700 {\n  border-color: rgba(17, 17, 17, 0.395) !important;\n}\n\n.bg-op-light-gray-800 {\n  background-color: rgba(17, 17, 17, 0.505) !important;\n}\n\n.text-op-light-gray-800 {\n  color: rgba(17, 17, 17, 0.505) !important;\n}\n\n.border-op-light-gray-800 {\n  border-color: rgba(17, 17, 17, 0.505) !important;\n}\n\n.bg-op-light-gray-900 {\n  background-color: rgba(17, 17, 17, 0.535) !important;\n}\n\n.text-op-light-gray-900 {\n  color: rgba(17, 17, 17, 0.535) !important;\n}\n\n.border-op-light-gray-900 {\n  border-color: rgba(17, 17, 17, 0.535) !important;\n}\n\n.bg-bp-green-50 {\n  background-color: #e7f5e6 !important;\n}\n\n.text-bp-green-50 {\n  color: #e7f5e6 !important;\n}\n\n.border-bp-green-50 {\n  border-color: #e7f5e6 !important;\n}\n\n.bg-bp-green-100 {\n  background-color: #c5e7c1 !important;\n}\n\n.text-bp-green-100 {\n  color: #c5e7c1 !important;\n}\n\n.border-bp-green-100 {\n  border-color: #c5e7c1 !important;\n}\n\n.bg-bp-green-200 {\n  background-color: #a0d799 !important;\n}\n\n.text-bp-green-200 {\n  color: #a0d799 !important;\n}\n\n.border-bp-green-200 {\n  border-color: #a0d799 !important;\n}\n\n.bg-bp-green-300 {\n  background-color: #77c96e !important;\n}\n\n.text-bp-green-300 {\n  color: #77c96e !important;\n}\n\n.border-bp-green-300 {\n  border-color: #77c96e !important;\n}\n\n.bg-bp-green-400 {\n  background-color: #57bd4d !important;\n}\n\n.text-bp-green-400 {\n  color: #57bd4d !important;\n}\n\n.border-bp-green-400 {\n  border-color: #57bd4d !important;\n}\n\n.bg-bp-green-500 {\n  background-color: #34b128 !important;\n}\n\n.text-bp-green-500 {\n  color: #34b128 !important;\n}\n\n.border-bp-green-500 {\n  border-color: #34b128 !important;\n}\n\n.bg-bp-green-600 {\n  background-color: #29a21f !important;\n}\n\n.text-bp-green-600 {\n  color: #29a21f !important;\n}\n\n.border-bp-green-600 {\n  border-color: #29a21f !important;\n}\n\n.bg-bp-green-700 {\n  background-color: #199011 !important;\n}\n\n.text-bp-green-700 {\n  color: #199011 !important;\n}\n\n.border-bp-green-700 {\n  border-color: #199011 !important;\n}\n\n.bg-bp-green-800 {\n  background-color: #007f00 !important;\n}\n\n.text-bp-green-800 {\n  color: #007f00 !important;\n}\n\n.border-bp-green-800 {\n  border-color: #007f00 !important;\n}\n\n.bg-bp-green-900 {\n  background-color: #006000 !important;\n}\n\n.text-bp-green-900 {\n  color: #006000 !important;\n}\n\n.border-bp-green-900 {\n  border-color: #006000 !important;\n}\n\n.bg-bp-light-green-50 {\n  background-color: #f4f9e5 !important;\n}\n\n.text-bp-light-green-50 {\n  color: #f4f9e5 !important;\n}\n\n.border-bp-light-green-50 {\n  border-color: #f4f9e5 !important;\n}\n\n.bg-bp-light-green-100 {\n  background-color: #e3f0bf !important;\n}\n\n.text-bp-light-green-100 {\n  color: #e3f0bf !important;\n}\n\n.border-bp-light-green-100 {\n  border-color: #e3f0bf !important;\n}\n\n.bg-bp-light-green-200 {\n  background-color: #cfe696 !important;\n}\n\n.text-bp-light-green-200 {\n  color: #cfe696 !important;\n}\n\n.border-bp-light-green-200 {\n  border-color: #cfe696 !important;\n}\n\n.bg-bp-light-green-300 {\n  background-color: #bbdc68 !important;\n}\n\n.text-bp-light-green-300 {\n  color: #bbdc68 !important;\n}\n\n.border-bp-light-green-300 {\n  border-color: #bbdc68 !important;\n}\n\n.bg-bp-light-green-400 {\n  background-color: #a9d441 !important;\n}\n\n.text-bp-light-green-400 {\n  color: #a9d441 !important;\n}\n\n.border-bp-light-green-400 {\n  border-color: #a9d441 !important;\n}\n\n.bg-bp-light-green-500 {\n  background-color: #99cc00 !important;\n}\n\n.text-bp-light-green-500 {\n  color: #99cc00 !important;\n}\n\n.border-bp-light-green-500 {\n  border-color: #99cc00 !important;\n}\n\n.bg-bp-light-green-600 {\n  background-color: #88bc00 !important;\n}\n\n.text-bp-light-green-600 {\n  color: #88bc00 !important;\n}\n\n.border-bp-light-green-600 {\n  border-color: #88bc00 !important;\n}\n\n.bg-bp-light-green-700 {\n  background-color: #71a800 !important;\n}\n\n.text-bp-light-green-700 {\n  color: #71a800 !important;\n}\n\n.border-bp-light-green-700 {\n  border-color: #71a800 !important;\n}\n\n.bg-bp-light-green-800 {\n  background-color: #5a9400 !important;\n}\n\n.text-bp-light-green-800 {\n  color: #5a9400 !important;\n}\n\n.border-bp-light-green-800 {\n  border-color: #5a9400 !important;\n}\n\n.bg-bp-light-green-900 {\n  background-color: #2e7300 !important;\n}\n\n.text-bp-light-green-900 {\n  color: #2e7300 !important;\n}\n\n.border-bp-light-green-900 {\n  border-color: #2e7300 !important;\n}\n\n.bg-bp-yellow-50 {\n  background-color: #fffce5 !important;\n}\n\n.text-bp-yellow-50 {\n  color: #fffce5 !important;\n}\n\n.border-bp-yellow-50 {\n  border-color: #fffce5 !important;\n}\n\n.bg-bp-yellow-100 {\n  background-color: #fff7be !important;\n}\n\n.text-bp-yellow-100 {\n  color: #fff7be !important;\n}\n\n.border-bp-yellow-100 {\n  border-color: #fff7be !important;\n}\n\n.bg-bp-yellow-200 {\n  background-color: #fff292 !important;\n}\n\n.text-bp-yellow-200 {\n  color: #fff292 !important;\n}\n\n.border-bp-yellow-200 {\n  border-color: #fff292 !important;\n}\n\n.bg-bp-yellow-300 {\n  background-color: #ffed65 !important;\n}\n\n.text-bp-yellow-300 {\n  color: #ffed65 !important;\n}\n\n.border-bp-yellow-300 {\n  border-color: #ffed65 !important;\n}\n\n.bg-bp-yellow-400 {\n  background-color: #fee83d !important;\n}\n\n.text-bp-yellow-400 {\n  color: #fee83d !important;\n}\n\n.border-bp-yellow-400 {\n  border-color: #fee83d !important;\n}\n\n.bg-bp-yellow-500 {\n  background-color: #ffe600 !important;\n}\n\n.text-bp-yellow-500 {\n  color: #ffe600 !important;\n}\n\n.border-bp-yellow-500 {\n  border-color: #ffe600 !important;\n}\n\n.bg-bp-yellow-600 {\n  background-color: #fed200 !important;\n}\n\n.text-bp-yellow-600 {\n  color: #fed200 !important;\n}\n\n.border-bp-yellow-600 {\n  border-color: #fed200 !important;\n}\n\n.bg-bp-yellow-700 {\n  background-color: #fdb900 !important;\n}\n\n.text-bp-yellow-700 {\n  color: #fdb900 !important;\n}\n\n.border-bp-yellow-700 {\n  border-color: #fdb900 !important;\n}\n\n.bg-bp-yellow-800 {\n  background-color: #fda000 !important;\n}\n\n.text-bp-yellow-800 {\n  color: #fda000 !important;\n}\n\n.border-bp-yellow-800 {\n  border-color: #fda000 !important;\n}\n\n.bg-bp-yellow-900 {\n  background-color: #fb7300 !important;\n}\n\n.text-bp-yellow-900 {\n  color: #fb7300 !important;\n}\n\n.border-bp-yellow-900 {\n  border-color: #fb7300 !important;\n}\n\n.bg-bp-bright-green-50 {\n  background-color: #f9ffe7 !important;\n}\n\n.text-bp-bright-green-50 {\n  color: #f9ffe7 !important;\n}\n\n.border-bp-bright-green-50 {\n  border-color: #f9ffe7 !important;\n}\n\n.bg-bp-bright-green-100 {\n  background-color: #f0ffc2 !important;\n}\n\n.text-bp-bright-green-100 {\n  color: #f0ffc2 !important;\n}\n\n.border-bp-bright-green-100 {\n  border-color: #f0ffc2 !important;\n}\n\n.bg-bp-bright-green-200 {\n  background-color: #e4fe98 !important;\n}\n\n.text-bp-bright-green-200 {\n  color: #e4fe98 !important;\n}\n\n.border-bp-bright-green-200 {\n  border-color: #e4fe98 !important;\n}\n\n.bg-bp-bright-green-300 {\n  background-color: #d8fd69 !important;\n}\n\n.text-bp-bright-green-300 {\n  color: #d8fd69 !important;\n}\n\n.border-bp-bright-green-300 {\n  border-color: #d8fd69 !important;\n}\n\n.bg-bp-bright-green-400 {\n  background-color: #cdfa3f !important;\n}\n\n.text-bp-bright-green-400 {\n  color: #cdfa3f !important;\n}\n\n.border-bp-bright-green-400 {\n  border-color: #cdfa3f !important;\n}\n\n.bg-bp-bright-green-500 {\n  background-color: #ccff00 !important;\n}\n\n.text-bp-bright-green-500 {\n  color: #ccff00 !important;\n}\n\n.border-bp-bright-green-500 {\n  border-color: #ccff00 !important;\n}\n\n.bg-bp-bright-green-600 {\n  background-color: #c1eb00 !important;\n}\n\n.text-bp-bright-green-600 {\n  color: #c1eb00 !important;\n}\n\n.border-bp-bright-green-600 {\n  border-color: #c1eb00 !important;\n}\n\n.bg-bp-bright-green-700 {\n  background-color: #b1d400 !important;\n}\n\n.text-bp-bright-green-700 {\n  color: #b1d400 !important;\n}\n\n.border-bp-bright-green-700 {\n  border-color: #b1d400 !important;\n}\n\n.bg-bp-bright-green-800 {\n  background-color: #a3bc00 !important;\n}\n\n.text-bp-bright-green-800 {\n  color: #a3bc00 !important;\n}\n\n.border-bp-bright-green-800 {\n  border-color: #a3bc00 !important;\n}\n\n.bg-bp-bright-green-900 {\n  background-color: #8c9300 !important;\n}\n\n.text-bp-bright-green-900 {\n  color: #8c9300 !important;\n}\n\n.border-bp-bright-green-900 {\n  border-color: #8c9300 !important;\n}\n\n.bg-bp-dark-green-50 {\n  background-color: #e5f4e9 !important;\n}\n\n.text-bp-dark-green-50 {\n  color: #e5f4e9 !important;\n}\n\n.border-bp-dark-green-50 {\n  border-color: #e5f4e9 !important;\n}\n\n.bg-bp-dark-green-100 {\n  background-color: #c1e4ca !important;\n}\n\n.text-bp-dark-green-100 {\n  color: #c1e4ca !important;\n}\n\n.border-bp-dark-green-100 {\n  border-color: #c1e4ca !important;\n}\n\n.bg-bp-dark-green-200 {\n  background-color: #99d3a8 !important;\n}\n\n.text-bp-dark-green-200 {\n  color: #99d3a8 !important;\n}\n\n.border-bp-dark-green-200 {\n  border-color: #99d3a8 !important;\n}\n\n.bg-bp-dark-green-300 {\n  background-color: #6ec386 !important;\n}\n\n.text-bp-dark-green-300 {\n  color: #6ec386 !important;\n}\n\n.border-bp-dark-green-300 {\n  border-color: #6ec386 !important;\n}\n\n.bg-bp-dark-green-400 {\n  background-color: #4db66d !important;\n}\n\n.text-bp-dark-green-400 {\n  color: #4db66d !important;\n}\n\n.border-bp-dark-green-400 {\n  border-color: #4db66d !important;\n}\n\n.bg-bp-dark-green-500 {\n  background-color: #24aa54 !important;\n}\n\n.text-bp-dark-green-500 {\n  color: #24aa54 !important;\n}\n\n.border-bp-dark-green-500 {\n  border-color: #24aa54 !important;\n}\n\n.bg-bp-dark-green-600 {\n  background-color: #1b9b4a !important;\n}\n\n.text-bp-dark-green-600 {\n  color: #1b9b4a !important;\n}\n\n.border-bp-dark-green-600 {\n  border-color: #1b9b4a !important;\n}\n\n.bg-bp-dark-green-700 {\n  background-color: #0e893f !important;\n}\n\n.text-bp-dark-green-700 {\n  color: #0e893f !important;\n}\n\n.border-bp-dark-green-700 {\n  border-color: #0e893f !important;\n}\n\n.bg-bp-dark-green-800 {\n  background-color: #007834 !important;\n}\n\n.text-bp-dark-green-800 {\n  color: #007834 !important;\n}\n\n.border-bp-dark-green-800 {\n  border-color: #007834 !important;\n}\n\n.bg-bp-dark-green-900 {\n  background-color: #005921 !important;\n}\n\n.text-bp-dark-green-900 {\n  color: #005921 !important;\n}\n\n.border-bp-dark-green-900 {\n  border-color: #005921 !important;\n}\n\n.bg-bp-dark-blue-50 {\n  background-color: #ece5f6 !important;\n}\n\n.text-bp-dark-blue-50 {\n  color: #ece5f6 !important;\n}\n\n.border-bp-dark-blue-50 {\n  border-color: #ece5f6 !important;\n}\n\n.bg-bp-dark-blue-100 {\n  background-color: #cebee9 !important;\n}\n\n.text-bp-dark-blue-100 {\n  color: #cebee9 !important;\n}\n\n.border-bp-dark-blue-100 {\n  border-color: #cebee9 !important;\n}\n\n.bg-bp-dark-blue-200 {\n  background-color: #ad93db !important;\n}\n\n.text-bp-dark-blue-200 {\n  color: #ad93db !important;\n}\n\n.border-bp-dark-blue-200 {\n  border-color: #ad93db !important;\n}\n\n.bg-bp-dark-blue-300 {\n  background-color: #8c67ce !important;\n}\n\n.text-bp-dark-blue-300 {\n  color: #8c67ce !important;\n}\n\n.border-bp-dark-blue-300 {\n  border-color: #8c67ce !important;\n}\n\n.bg-bp-dark-blue-400 {\n  background-color: #7246c4 !important;\n}\n\n.text-bp-dark-blue-400 {\n  color: #7246c4 !important;\n}\n\n.border-bp-dark-blue-400 {\n  border-color: #7246c4 !important;\n}\n\n.bg-bp-dark-blue-500 {\n  background-color: #5724b9 !important;\n}\n\n.text-bp-dark-blue-500 {\n  color: #5724b9 !important;\n}\n\n.border-bp-dark-blue-500 {\n  border-color: #5724b9 !important;\n}\n\n.bg-bp-dark-blue-600 {\n  background-color: #4d1fb4 !important;\n}\n\n.text-bp-dark-blue-600 {\n  color: #4d1fb4 !important;\n}\n\n.border-bp-dark-blue-600 {\n  border-color: #4d1fb4 !important;\n}\n\n.bg-bp-dark-blue-700 {\n  background-color: #3e17ab !important;\n}\n\n.text-bp-dark-blue-700 {\n  color: #3e17ab !important;\n}\n\n.border-bp-dark-blue-700 {\n  border-color: #3e17ab !important;\n}\n\n.bg-bp-dark-blue-800 {\n  background-color: #2e10a4 !important;\n}\n\n.text-bp-dark-blue-800 {\n  color: #2e10a4 !important;\n}\n\n.border-bp-dark-blue-800 {\n  border-color: #2e10a4 !important;\n}\n\n.bg-bp-dark-blue-900 {\n  background-color: #000099 !important;\n}\n\n.text-bp-dark-blue-900 {\n  color: #000099 !important;\n}\n\n.border-bp-dark-blue-900 {\n  border-color: #000099 !important;\n}\n\n.bg-bp-yellow-orange-50 {\n  background-color: #fcf7e1 !important;\n}\n\n.text-bp-yellow-orange-50 {\n  color: #fcf7e1 !important;\n}\n\n.border-bp-yellow-orange-50 {\n  border-color: #fcf7e1 !important;\n}\n\n.bg-bp-yellow-orange-100 {\n  background-color: #f9eab4 !important;\n}\n\n.text-bp-yellow-orange-100 {\n  color: #f9eab4 !important;\n}\n\n.border-bp-yellow-orange-100 {\n  border-color: #f9eab4 !important;\n}\n\n.bg-bp-yellow-orange-200 {\n  background-color: #f5dc84 !important;\n}\n\n.text-bp-yellow-orange-200 {\n  color: #f5dc84 !important;\n}\n\n.border-bp-yellow-orange-200 {\n  border-color: #f5dc84 !important;\n}\n\n.bg-bp-yellow-orange-300 {\n  background-color: #f1d054 !important;\n}\n\n.text-bp-yellow-orange-300 {\n  color: #f1d054 !important;\n}\n\n.border-bp-yellow-orange-300 {\n  border-color: #f1d054 !important;\n}\n\n.bg-bp-yellow-orange-400 {\n  background-color: #efc433 !important;\n}\n\n.text-bp-yellow-orange-400 {\n  color: #efc433 !important;\n}\n\n.border-bp-yellow-orange-400 {\n  border-color: #efc433 !important;\n}\n\n.bg-bp-yellow-orange-500 {\n  background-color: #edbb20 !important;\n}\n\n.text-bp-yellow-orange-500 {\n  color: #edbb20 !important;\n}\n\n.border-bp-yellow-orange-500 {\n  border-color: #edbb20 !important;\n}\n\n.bg-bp-yellow-orange-600 {\n  background-color: #edac1a !important;\n}\n\n.text-bp-yellow-orange-600 {\n  color: #edac1a !important;\n}\n\n.border-bp-yellow-orange-600 {\n  border-color: #edac1a !important;\n}\n\n.bg-bp-yellow-orange-700 {\n  background-color: #ec9c16 !important;\n}\n\n.text-bp-yellow-orange-700 {\n  color: #ec9c16 !important;\n}\n\n.border-bp-yellow-orange-700 {\n  border-color: #ec9c16 !important;\n}\n\n.bg-bp-yellow-orange-800 {\n  background-color: #ec8c12 !important;\n}\n\n.text-bp-yellow-orange-800 {\n  color: #ec8c12 !important;\n}\n\n.border-bp-yellow-orange-800 {\n  border-color: #ec8c12 !important;\n}\n\n.bg-bp-yellow-orange-900 {\n  background-color: #ea6f0d !important;\n}\n\n.text-bp-yellow-orange-900 {\n  color: #ea6f0d !important;\n}\n\n.border-bp-yellow-orange-900 {\n  border-color: #ea6f0d !important;\n}\n\n.bg-bp-pale-yellow-50 {\n  background-color: #fef9e4 !important;\n}\n\n.text-bp-pale-yellow-50 {\n  color: #fef9e4 !important;\n}\n\n.border-bp-pale-yellow-50 {\n  border-color: #fef9e4 !important;\n}\n\n.bg-bp-pale-yellow-100 {\n  background-color: #fceebb !important;\n}\n\n.text-bp-pale-yellow-100 {\n  color: #fceebb !important;\n}\n\n.border-bp-pale-yellow-100 {\n  border-color: #fceebb !important;\n}\n\n.bg-bp-pale-yellow-200 {\n  background-color: #fce48f !important;\n}\n\n.text-bp-pale-yellow-200 {\n  color: #fce48f !important;\n}\n\n.border-bp-pale-yellow-200 {\n  border-color: #fce48f !important;\n}\n\n.bg-bp-pale-yellow-300 {\n  background-color: #fbdb65 !important;\n}\n\n.text-bp-pale-yellow-300 {\n  color: #fbdb65 !important;\n}\n\n.border-bp-pale-yellow-300 {\n  border-color: #fbdb65 !important;\n}\n\n.bg-bp-pale-yellow-400 {\n  background-color: #fad14a !important;\n}\n\n.text-bp-pale-yellow-400 {\n  color: #fad14a !important;\n}\n\n.border-bp-pale-yellow-400 {\n  border-color: #fad14a !important;\n}\n\n.bg-bp-pale-yellow-500 {\n  background-color: #fbc93a !important;\n}\n\n.text-bp-pale-yellow-500 {\n  color: #fbc93a !important;\n}\n\n.border-bp-pale-yellow-500 {\n  border-color: #fbc93a !important;\n}\n\n.bg-bp-pale-yellow-600 {\n  background-color: #fabb34 !important;\n}\n\n.text-bp-pale-yellow-600 {\n  color: #fabb34 !important;\n}\n\n.border-bp-pale-yellow-600 {\n  border-color: #fabb34 !important;\n}\n\n.bg-bp-pale-yellow-700 {\n  background-color: #f9a92e !important;\n}\n\n.text-bp-pale-yellow-700 {\n  color: #f9a92e !important;\n}\n\n.border-bp-pale-yellow-700 {\n  border-color: #f9a92e !important;\n}\n\n.bg-bp-pale-yellow-800 {\n  background-color: #f89929 !important;\n}\n\n.text-bp-pale-yellow-800 {\n  color: #f89929 !important;\n}\n\n.border-bp-pale-yellow-800 {\n  border-color: #f89929 !important;\n}\n\n.bg-bp-pale-yellow-900 {\n  background-color: #f77d1f !important;\n}\n\n.text-bp-pale-yellow-900 {\n  color: #f77d1f !important;\n}\n\n.border-bp-pale-yellow-900 {\n  border-color: #f77d1f !important;\n}\n\n.bg-bp-pale-green-50 {\n  background-color: #e4f1e5 !important;\n}\n\n.text-bp-pale-green-50 {\n  color: #e4f1e5 !important;\n}\n\n.border-bp-pale-green-50 {\n  border-color: #e4f1e5 !important;\n}\n\n.bg-bp-pale-green-100 {\n  background-color: #bedbbf !important;\n}\n\n.text-bp-pale-green-100 {\n  color: #bedbbf !important;\n}\n\n.border-bp-pale-green-100 {\n  border-color: #bedbbf !important;\n}\n\n.bg-bp-pale-green-200 {\n  background-color: #94c496 !important;\n}\n\n.text-bp-pale-green-200 {\n  color: #94c496 !important;\n}\n\n.border-bp-pale-green-200 {\n  border-color: #94c496 !important;\n}\n\n.bg-bp-pale-green-300 {\n  background-color: #6aae6e !important;\n}\n\n.text-bp-pale-green-300 {\n  color: #6aae6e !important;\n}\n\n.border-bp-pale-green-300 {\n  border-color: #6aae6e !important;\n}\n\n.bg-bp-pale-green-400 {\n  background-color: #4a9e51 !important;\n}\n\n.text-bp-pale-green-400 {\n  color: #4a9e51 !important;\n}\n\n.border-bp-pale-green-400 {\n  border-color: #4a9e51 !important;\n}\n\n.bg-bp-pale-green-500 {\n  background-color: #288f33 !important;\n}\n\n.text-bp-pale-green-500 {\n  color: #288f33 !important;\n}\n\n.border-bp-pale-green-500 {\n  border-color: #288f33 !important;\n}\n\n.bg-bp-pale-green-600 {\n  background-color: #1f812b !important;\n}\n\n.text-bp-pale-green-600 {\n  color: #1f812b !important;\n}\n\n.border-bp-pale-green-600 {\n  border-color: #1f812b !important;\n}\n\n.bg-bp-pale-green-700 {\n  background-color: #147122 !important;\n}\n\n.text-bp-pale-green-700 {\n  color: #147122 !important;\n}\n\n.border-bp-pale-green-700 {\n  border-color: #147122 !important;\n}\n\n.bg-bp-pale-green-800 {\n  background-color: #066018 !important;\n}\n\n.text-bp-pale-green-800 {\n  color: #066018 !important;\n}\n\n.border-bp-pale-green-800 {\n  border-color: #066018 !important;\n}\n\n.bg-bp-pale-green-900 {\n  background-color: #004306 !important;\n}\n\n.text-bp-pale-green-900 {\n  color: #004306 !important;\n}\n\n.border-bp-pale-green-900 {\n  border-color: #004306 !important;\n}\n\n.bg-bp-orange-50 {\n  background-color: #fff7e0 !important;\n}\n\n.text-bp-orange-50 {\n  color: #fff7e0 !important;\n}\n\n.border-bp-orange-50 {\n  border-color: #fff7e0 !important;\n}\n\n.bg-bp-orange-100 {\n  background-color: #ffeab1 !important;\n}\n\n.text-bp-orange-100 {\n  color: #ffeab1 !important;\n}\n\n.border-bp-orange-100 {\n  border-color: #ffeab1 !important;\n}\n\n.bg-bp-orange-200 {\n  background-color: #ffdc7e !important;\n}\n\n.text-bp-orange-200 {\n  color: #ffdc7e !important;\n}\n\n.border-bp-orange-200 {\n  border-color: #ffdc7e !important;\n}\n\n.bg-bp-orange-300 {\n  background-color: #ffd04a !important;\n}\n\n.text-bp-orange-300 {\n  color: #ffd04a !important;\n}\n\n.border-bp-orange-300 {\n  border-color: #ffd04a !important;\n}\n\n.bg-bp-orange-400 {\n  background-color: #ffc41f !important;\n}\n\n.text-bp-orange-400 {\n  color: #ffc41f !important;\n}\n\n.border-bp-orange-400 {\n  border-color: #ffc41f !important;\n}\n\n.bg-bp-orange-500 {\n  background-color: #ffba00 !important;\n}\n\n.text-bp-orange-500 {\n  color: #ffba00 !important;\n}\n\n.border-bp-orange-500 {\n  border-color: #ffba00 !important;\n}\n\n.bg-bp-orange-600 {\n  background-color: #ffac00 !important;\n}\n\n.text-bp-orange-600 {\n  color: #ffac00 !important;\n}\n\n.border-bp-orange-600 {\n  border-color: #ffac00 !important;\n}\n\n.bg-bp-orange-700 {\n  background-color: #ff9900 !important;\n}\n\n.text-bp-orange-700 {\n  color: #ff9900 !important;\n}\n\n.border-bp-orange-700 {\n  border-color: #ff9900 !important;\n}\n\n.bg-bp-orange-800 {\n  background-color: #ff8700 !important;\n}\n\n.text-bp-orange-800 {\n  color: #ff8700 !important;\n}\n\n.border-bp-orange-800 {\n  border-color: #ff8700 !important;\n}\n\n.bg-bp-orange-900 {\n  background-color: #ff6600 !important;\n}\n\n.text-bp-orange-900 {\n  color: #ff6600 !important;\n}\n\n.border-bp-orange-900 {\n  border-color: #ff6600 !important;\n}\n\n.bg-bp-CO2-blue-50 {\n  background-color: #e1f5fd !important;\n}\n\n.text-bp-CO2-blue-50 {\n  color: #e1f5fd !important;\n}\n\n.border-bp-CO2-blue-50 {\n  border-color: #e1f5fd !important;\n}\n\n.bg-bp-CO2-blue-100 {\n  background-color: #b3e6fa !important;\n}\n\n.text-bp-CO2-blue-100 {\n  color: #b3e6fa !important;\n}\n\n.border-bp-CO2-blue-100 {\n  border-color: #b3e6fa !important;\n}\n\n.bg-bp-CO2-blue-200 {\n  background-color: #82d5f6 !important;\n}\n\n.text-bp-CO2-blue-200 {\n  color: #82d5f6 !important;\n}\n\n.border-bp-CO2-blue-200 {\n  border-color: #82d5f6 !important;\n}\n\n.bg-bp-CO2-blue-300 {\n  background-color: #51c4f2 !important;\n}\n\n.text-bp-CO2-blue-300 {\n  color: #51c4f2 !important;\n}\n\n.border-bp-CO2-blue-300 {\n  border-color: #51c4f2 !important;\n}\n\n.bg-bp-CO2-blue-400 {\n  background-color: #2db7f1 !important;\n}\n\n.text-bp-CO2-blue-400 {\n  color: #2db7f1 !important;\n}\n\n.border-bp-CO2-blue-400 {\n  border-color: #2db7f1 !important;\n}\n\n.bg-bp-CO2-blue-500 {\n  background-color: #05abef !important;\n}\n\n.text-bp-CO2-blue-500 {\n  color: #05abef !important;\n}\n\n.border-bp-CO2-blue-500 {\n  border-color: #05abef !important;\n}\n\n.bg-bp-CO2-blue-600 {\n  background-color: #009de0 !important;\n}\n\n.text-bp-CO2-blue-600 {\n  color: #009de0 !important;\n}\n\n.border-bp-CO2-blue-600 {\n  border-color: #009de0 !important;\n}\n\n.bg-bp-CO2-blue-700 {\n  background-color: #008acc !important;\n}\n\n.text-bp-CO2-blue-700 {\n  color: #008acc !important;\n}\n\n.border-bp-CO2-blue-700 {\n  border-color: #008acc !important;\n}\n\n.bg-bp-CO2-blue-800 {\n  background-color: #0079b9 !important;\n}\n\n.text-bp-CO2-blue-800 {\n  color: #0079b9 !important;\n}\n\n.border-bp-CO2-blue-800 {\n  border-color: #0079b9 !important;\n}\n\n.bg-bp-CO2-blue-900 {\n  background-color: #005997 !important;\n}\n\n.text-bp-CO2-blue-900 {\n  color: #005997 !important;\n}\n\n.border-bp-CO2-blue-900 {\n  border-color: #005997 !important;\n}\n\n.bg-bp-purple-50 {\n  background-color: #f3e4f5 !important;\n}\n\n.text-bp-purple-50 {\n  color: #f3e4f5 !important;\n}\n\n.border-bp-purple-50 {\n  border-color: #f3e4f5 !important;\n}\n\n.bg-bp-purple-100 {\n  background-color: #e0bae6 !important;\n}\n\n.text-bp-purple-100 {\n  color: #e0bae6 !important;\n}\n\n.border-bp-purple-100 {\n  border-color: #e0bae6 !important;\n}\n\n.bg-bp-purple-200 {\n  background-color: #cd8dd6 !important;\n}\n\n.text-bp-purple-200 {\n  color: #cd8dd6 !important;\n}\n\n.border-bp-purple-200 {\n  border-color: #cd8dd6 !important;\n}\n\n.bg-bp-purple-300 {\n  background-color: #b85fc5 !important;\n}\n\n.text-bp-purple-300 {\n  color: #b85fc5 !important;\n}\n\n.border-bp-purple-300 {\n  border-color: #b85fc5 !important;\n}\n\n.bg-bp-purple-400 {\n  background-color: #a939b9 !important;\n}\n\n.text-bp-purple-400 {\n  color: #a939b9 !important;\n}\n\n.border-bp-purple-400 {\n  border-color: #a939b9 !important;\n}\n\n.bg-bp-purple-500 {\n  background-color: #9907ad !important;\n}\n\n.text-bp-purple-500 {\n  color: #9907ad !important;\n}\n\n.border-bp-purple-500 {\n  border-color: #9907ad !important;\n}\n\n.bg-bp-purple-600 {\n  background-color: #8b06a8 !important;\n}\n\n.text-bp-purple-600 {\n  color: #8b06a8 !important;\n}\n\n.border-bp-purple-600 {\n  border-color: #8b06a8 !important;\n}\n\n.bg-bp-purple-700 {\n  background-color: #7802a0 !important;\n}\n\n.text-bp-purple-700 {\n  color: #7802a0 !important;\n}\n\n.border-bp-purple-700 {\n  border-color: #7802a0 !important;\n}\n\n.bg-bp-purple-800 {\n  background-color: #660099 !important;\n}\n\n.text-bp-purple-800 {\n  color: #660099 !important;\n}\n\n.border-bp-purple-800 {\n  border-color: #660099 !important;\n}\n\n.bg-bp-purple-900 {\n  background-color: #44008d !important;\n}\n\n.text-bp-purple-900 {\n  color: #44008d !important;\n}\n\n.border-bp-purple-900 {\n  border-color: #44008d !important;\n}\n\n:root,\n[data-bs-theme=light] {\n  --text-default-color: #111;\n  --text-brand-primary-color: #007f00;\n}\n\n[data-bs-theme=dark],\n.dark {\n  --text-default-color: #fff;\n  --text-brand-primary-color: #ccff00;\n}\n\n.text-default {\n  color: var(--text-default-color) !important;\n}\n\n.text-bp-bright-green {\n  color: #ccff00 !important;\n}\n\n.text-brand-primary {\n  color: var(--text-brand-primary-color) !important;\n}\n\na.link-border,\n.btn-link,\n.btn-brand-quartenary,\n.btn-darker-quartenary,\n.btn-standard-quartenary {\n  display: inline-flex;\n  align-items: center;\n}\n\na.link-border,\n.btn-link span,\n.btn-brand-quartenary span,\n.btn-darker-quartenary span,\n.btn-standard-quartenary span {\n  background-image: linear-gradient(to right, rgba(0, 43, 188, 0) 0%, rgba(0, 43, 188, 0) 100%);\n  background-size: 100% 3.6%;\n  background-position: right 93%;\n  background-repeat: no-repeat;\n  transition: opacity 300ms, color 300ms, background-position 300ms;\n}\n\na.link-border:hover,\n.btn-link:hover span,\n.btn-brand-quartenary:hover span,\n.btn-darker-quartenary:hover span,\n.btn-standard-quartenary:hover span {\n  background-image: linear-gradient(to right, currentColor 0%, currentColor 100%);\n}\n\na.link-border:focus,\na.link-border.focus {\n  background-position-y: 100%;\n}\n\na.link-border,\n.card-link,\n.btn-link,\n.btn-brand-quartenary,\n.btn-darker-quartenary,\n.btn-standard-quartenary,\n.btn-link:hover,\n.btn-link:focus,\n.btn-link.focus {\n  text-decoration: none;\n}\n\n.dark {\n  --bs-link-color-rgb: 141, 219, 255;\n  --bs-link-hover-color-rgb: 141, 219, 255;\n  --bs-link-color: #8ddbff;\n  --bs-link-hover-color: #8ddbff;\n}\n\n.link-primary:not(.btn) {\n  color: rgba(17, 17, 17, 0.7) !important;\n}\n.link-primary:hover {\n  color: #111111 !important;\n}\n\n.dark .link-primary:not(.btn) {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n.dark .link-primary:hover, .dark .link-primary:focus {\n  color: #fff !important;\n}\n\na.link-border-animation {\n  background-image: linear-gradient(to right, currentColor 0%, currentColor 100%);\n}\na.link-border-animation:hover {\n  animation: 450ms cubic-bezier(0.785, 0.135, 0.15, 0.86) 0s 1 normal none running linkAnimation;\n}\n\na.link-dark {\n  color: rgba(17, 17, 17, 0.7) !important;\n}\n\na.link-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\na.link-light:hover, a.link-light:focus {\n  color: #fff !important;\n}\n\n@keyframes linkAnimation {\n  0% {\n    background-size: 100% 4%;\n    background-position-x: 100%;\n  }\n  50% {\n    background-size: 0px 4%;\n    background-position-x: 100%;\n  }\n  50.01% {\n    background-size: 0px 4%;\n    background-position-x: 0px;\n  }\n  100% {\n    background-size: 100% 4%;\n    background-position-x: 0px;\n  }\n}\nbody {\n  letter-spacing: 0.15px;\n}\n\n.bg-dark,\n.bg-dark-secondary {\n  color: #fff;\n}\n\nh1,\n.h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5 {\n  letter-spacing: 0.2px;\n}\nh1.fw-normal, h2.fw-normal, h3.fw-normal, h4.fw-normal, h5.fw-normal,\n.h1.fw-normal, .h2.fw-normal, .h3.fw-normal, .h4.fw-normal, .h5.fw-normal {\n  letter-spacing: 0.15px;\n}\nh1.fw-medium, h2.fw-medium, h3.fw-medium, h4.fw-medium, h5.fw-medium,\n.h1.fw-medium, .h2.fw-medium, .h3.fw-medium, .h4.fw-medium, .h5.fw-medium {\n  letter-spacing: 0.1px;\n}\n\nh2, .h2 {\n  line-height: 1.5172413793;\n}\n\nh4, .h4 {\n  line-height: 1.5217391304;\n}\n\nh3,\n.h3, h4, .h4 {\n  margin-bottom: 1.5rem;\n}\n\nh5,\n.h5, h6, .h6 {\n  margin-bottom: 1rem;\n}\n\nh6, .h6 {\n  text-transform: uppercase;\n  letter-spacing: 1.6px;\n}\n\n.font-family-base {\n  font-family: \"Roboto\", Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;\n}\n\n.display-1 {\n  letter-spacing: 0.3px;\n  line-height: 1.1222222222;\n}\n.display-1.fw-normal {\n  letter-spacing: 0.25px;\n}\n.display-1.fw-medium {\n  letter-spacing: 0.2px;\n}\n\n.display-2 {\n  line-height: 1.2537313433;\n}\n\n.display-1,\n.display-2 {\n  margin-bottom: 2.5rem;\n}\n\n.display-2,\n.display-3 {\n  letter-spacing: 0.4px;\n}\n.display-2.fw-normal,\n.display-3.fw-normal {\n  letter-spacing: 0.35px;\n}\n.display-2.fw-medium,\n.display-3.fw-medium {\n  letter-spacing: 0.3px;\n}\n\n.display-3 {\n  line-height: 1.3725490196;\n}\n\n.display-3,\n.display-4 {\n  margin-bottom: 2rem;\n}\n\n.display-4 {\n  line-height: 1.4473684211;\n}\n\n.display-4,\n.display-5 {\n  letter-spacing: 0.5px;\n}\n.display-4.fw-normal,\n.display-5.fw-normal {\n  letter-spacing: 0.45px;\n}\n.display-4.fw-medium,\n.display-5.fw-medium {\n  letter-spacing: 0.4px;\n}\n\n.display-5 {\n  line-height: 1.4285714286;\n}\n\n.display-5,\n.display-6 {\n  margin-bottom: 1.5rem;\n}\n\n.fs-base {\n  font-size: 1rem !important;\n  line-height: 1.75;\n}\n\np {\n  opacity: 0.8;\n}\n\n.lead {\n  letter-spacing: 0.2px;\n  line-height: 1.7777777778;\n  opacity: 1;\n}\n\n.small-md {\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\np.small {\n  font-size: 0.8125rem;\n  line-height: 1.7692307692;\n  letter-spacing: 0.25px;\n  opacity: 0.7;\n}\n\nsmall,\n.small {\n  font-weight: 300;\n  font-size: 0.75rem;\n  line-height: 1.75;\n  letter-spacing: 0.25px;\n}\n\n.small-sm {\n  font-size: 0.6875rem;\n  line-height: 1.9090909091;\n  font-weight: 400;\n}\n\n.small-xs {\n  font-size: 0.625rem !important;\n  line-height: 2;\n  font-weight: 400;\n}\n\n.list-styled,\n.list-styled ul,\n.list-styled ol {\n  padding-left: 1.5rem;\n}\n.list-styled li + li,\n.list-styled ul li:first-child,\n.list-styled ol li:first-child {\n  margin-top: 0.5rem;\n}\n\n.dark .border-primary {\n  border-color: #343434 !important;\n}\n\n.row-5 .col {\n  flex: 1 0 0%;\n}\n.row-5 .row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n.row-5 .row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n.row-5 .row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n.row-5 .row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n.row-5 .row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n.row-5 .row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n.row-5 .row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n.row-5 .col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n.row-5 .col-1 {\n  flex: 0 0 auto;\n  width: 20%;\n}\n.row-5 .col-2 {\n  flex: 0 0 auto;\n  width: 40%;\n}\n.row-5 .col-3 {\n  flex: 0 0 auto;\n  width: 60%;\n}\n.row-5 .col-4 {\n  flex: 0 0 auto;\n  width: 80%;\n}\n.row-5 .col-5 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n.row-5 .offset-1 {\n  margin-left: 20%;\n}\n.row-5 .offset-2 {\n  margin-left: 40%;\n}\n.row-5 .offset-3 {\n  margin-left: 60%;\n}\n.row-5 .offset-4 {\n  margin-left: 80%;\n}\n.row-5 .g-0,\n.row-5 .gx-0 {\n  --bs-gutter-x: 0;\n}\n.row-5 .g-0,\n.row-5 .gy-0 {\n  --bs-gutter-y: 0;\n}\n.row-5 .g-1,\n.row-5 .gx-1 {\n  --bs-gutter-x: 0.125rem;\n}\n.row-5 .g-1,\n.row-5 .gy-1 {\n  --bs-gutter-y: 0.125rem;\n}\n.row-5 .g-2,\n.row-5 .gx-2 {\n  --bs-gutter-x: 0.25rem;\n}\n.row-5 .g-2,\n.row-5 .gy-2 {\n  --bs-gutter-y: 0.25rem;\n}\n.row-5 .g-3,\n.row-5 .gx-3 {\n  --bs-gutter-x: 0.5rem;\n}\n.row-5 .g-3,\n.row-5 .gy-3 {\n  --bs-gutter-y: 0.5rem;\n}\n.row-5 .g-4,\n.row-5 .gx-4 {\n  --bs-gutter-x: 1rem;\n}\n.row-5 .g-4,\n.row-5 .gy-4 {\n  --bs-gutter-y: 1rem;\n}\n.row-5 .g-5,\n.row-5 .gx-5 {\n  --bs-gutter-x: 1.5rem;\n}\n.row-5 .g-5,\n.row-5 .gy-5 {\n  --bs-gutter-y: 1.5rem;\n}\n.row-5 .g-6,\n.row-5 .gx-6 {\n  --bs-gutter-x: 2rem;\n}\n.row-5 .g-6,\n.row-5 .gy-6 {\n  --bs-gutter-y: 2rem;\n}\n.row-5 .g-7,\n.row-5 .gx-7 {\n  --bs-gutter-x: 2.5rem;\n}\n.row-5 .g-7,\n.row-5 .gy-7 {\n  --bs-gutter-y: 2.5rem;\n}\n.row-5 .g-8,\n.row-5 .gx-8 {\n  --bs-gutter-x: 3rem;\n}\n.row-5 .g-8,\n.row-5 .gy-8 {\n  --bs-gutter-y: 3rem;\n}\n.row-5 .g-9,\n.row-5 .gx-9 {\n  --bs-gutter-x: 3.5rem;\n}\n.row-5 .g-9,\n.row-5 .gy-9 {\n  --bs-gutter-y: 3.5rem;\n}\n.row-5 .g-10,\n.row-5 .gx-10 {\n  --bs-gutter-x: 4rem;\n}\n.row-5 .g-10,\n.row-5 .gy-10 {\n  --bs-gutter-y: 4rem;\n}\n.row-5 .g-11,\n.row-5 .gx-11 {\n  --bs-gutter-x: 5rem;\n}\n.row-5 .g-11,\n.row-5 .gy-11 {\n  --bs-gutter-y: 5rem;\n}\n.row-5 .g-12,\n.row-5 .gx-12 {\n  --bs-gutter-x: 6rem;\n}\n.row-5 .g-12,\n.row-5 .gy-12 {\n  --bs-gutter-y: 6rem;\n}\n.row-5 .g-13,\n.row-5 .gx-13 {\n  --bs-gutter-x: 6.5rem;\n}\n.row-5 .g-13,\n.row-5 .gy-13 {\n  --bs-gutter-y: 6.5rem;\n}\n.row-5 .g-14,\n.row-5 .gx-14 {\n  --bs-gutter-x: 8rem;\n}\n.row-5 .g-14,\n.row-5 .gy-14 {\n  --bs-gutter-y: 8rem;\n}\n@media (min-width: 576px) {\n  .row-5 .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-5 .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-5 .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-5 .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-5 .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-5 .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-5 .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-5 .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .row-5 .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-5 .col-sm-1 {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-5 .col-sm-2 {\n    flex: 0 0 auto;\n    width: 40%;\n  }\n  .row-5 .col-sm-3 {\n    flex: 0 0 auto;\n    width: 60%;\n  }\n  .row-5 .col-sm-4 {\n    flex: 0 0 auto;\n    width: 80%;\n  }\n  .row-5 .col-sm-5 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-5 .offset-sm-0 {\n    margin-left: 0;\n  }\n  .row-5 .offset-sm-1 {\n    margin-left: 20%;\n  }\n  .row-5 .offset-sm-2 {\n    margin-left: 40%;\n  }\n  .row-5 .offset-sm-3 {\n    margin-left: 60%;\n  }\n  .row-5 .offset-sm-4 {\n    margin-left: 80%;\n  }\n  .row-5 .g-sm-0,\n  .row-5 .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n  .row-5 .g-sm-0,\n  .row-5 .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n  .row-5 .g-sm-1,\n  .row-5 .gx-sm-1 {\n    --bs-gutter-x: 0.125rem;\n  }\n  .row-5 .g-sm-1,\n  .row-5 .gy-sm-1 {\n    --bs-gutter-y: 0.125rem;\n  }\n  .row-5 .g-sm-2,\n  .row-5 .gx-sm-2 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .row-5 .g-sm-2,\n  .row-5 .gy-sm-2 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .row-5 .g-sm-3,\n  .row-5 .gx-sm-3 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .row-5 .g-sm-3,\n  .row-5 .gy-sm-3 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .row-5 .g-sm-4,\n  .row-5 .gx-sm-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .row-5 .g-sm-4,\n  .row-5 .gy-sm-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .row-5 .g-sm-5,\n  .row-5 .gx-sm-5 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .row-5 .g-sm-5,\n  .row-5 .gy-sm-5 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .row-5 .g-sm-6,\n  .row-5 .gx-sm-6 {\n    --bs-gutter-x: 2rem;\n  }\n  .row-5 .g-sm-6,\n  .row-5 .gy-sm-6 {\n    --bs-gutter-y: 2rem;\n  }\n  .row-5 .g-sm-7,\n  .row-5 .gx-sm-7 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .row-5 .g-sm-7,\n  .row-5 .gy-sm-7 {\n    --bs-gutter-y: 2.5rem;\n  }\n  .row-5 .g-sm-8,\n  .row-5 .gx-sm-8 {\n    --bs-gutter-x: 3rem;\n  }\n  .row-5 .g-sm-8,\n  .row-5 .gy-sm-8 {\n    --bs-gutter-y: 3rem;\n  }\n  .row-5 .g-sm-9,\n  .row-5 .gx-sm-9 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .row-5 .g-sm-9,\n  .row-5 .gy-sm-9 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .row-5 .g-sm-10,\n  .row-5 .gx-sm-10 {\n    --bs-gutter-x: 4rem;\n  }\n  .row-5 .g-sm-10,\n  .row-5 .gy-sm-10 {\n    --bs-gutter-y: 4rem;\n  }\n  .row-5 .g-sm-11,\n  .row-5 .gx-sm-11 {\n    --bs-gutter-x: 5rem;\n  }\n  .row-5 .g-sm-11,\n  .row-5 .gy-sm-11 {\n    --bs-gutter-y: 5rem;\n  }\n  .row-5 .g-sm-12,\n  .row-5 .gx-sm-12 {\n    --bs-gutter-x: 6rem;\n  }\n  .row-5 .g-sm-12,\n  .row-5 .gy-sm-12 {\n    --bs-gutter-y: 6rem;\n  }\n  .row-5 .g-sm-13,\n  .row-5 .gx-sm-13 {\n    --bs-gutter-x: 6.5rem;\n  }\n  .row-5 .g-sm-13,\n  .row-5 .gy-sm-13 {\n    --bs-gutter-y: 6.5rem;\n  }\n  .row-5 .g-sm-14,\n  .row-5 .gx-sm-14 {\n    --bs-gutter-x: 8rem;\n  }\n  .row-5 .g-sm-14,\n  .row-5 .gy-sm-14 {\n    --bs-gutter-y: 8rem;\n  }\n}\n@media (min-width: 768px) {\n  .row-5 .col-md {\n    flex: 1 0 0%;\n  }\n  .row-5 .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-5 .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-5 .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-5 .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-5 .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-5 .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-5 .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .row-5 .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-5 .col-md-1 {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-5 .col-md-2 {\n    flex: 0 0 auto;\n    width: 40%;\n  }\n  .row-5 .col-md-3 {\n    flex: 0 0 auto;\n    width: 60%;\n  }\n  .row-5 .col-md-4 {\n    flex: 0 0 auto;\n    width: 80%;\n  }\n  .row-5 .col-md-5 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-5 .offset-md-0 {\n    margin-left: 0;\n  }\n  .row-5 .offset-md-1 {\n    margin-left: 20%;\n  }\n  .row-5 .offset-md-2 {\n    margin-left: 40%;\n  }\n  .row-5 .offset-md-3 {\n    margin-left: 60%;\n  }\n  .row-5 .offset-md-4 {\n    margin-left: 80%;\n  }\n  .row-5 .g-md-0,\n  .row-5 .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n  .row-5 .g-md-0,\n  .row-5 .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n  .row-5 .g-md-1,\n  .row-5 .gx-md-1 {\n    --bs-gutter-x: 0.125rem;\n  }\n  .row-5 .g-md-1,\n  .row-5 .gy-md-1 {\n    --bs-gutter-y: 0.125rem;\n  }\n  .row-5 .g-md-2,\n  .row-5 .gx-md-2 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .row-5 .g-md-2,\n  .row-5 .gy-md-2 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .row-5 .g-md-3,\n  .row-5 .gx-md-3 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .row-5 .g-md-3,\n  .row-5 .gy-md-3 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .row-5 .g-md-4,\n  .row-5 .gx-md-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .row-5 .g-md-4,\n  .row-5 .gy-md-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .row-5 .g-md-5,\n  .row-5 .gx-md-5 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .row-5 .g-md-5,\n  .row-5 .gy-md-5 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .row-5 .g-md-6,\n  .row-5 .gx-md-6 {\n    --bs-gutter-x: 2rem;\n  }\n  .row-5 .g-md-6,\n  .row-5 .gy-md-6 {\n    --bs-gutter-y: 2rem;\n  }\n  .row-5 .g-md-7,\n  .row-5 .gx-md-7 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .row-5 .g-md-7,\n  .row-5 .gy-md-7 {\n    --bs-gutter-y: 2.5rem;\n  }\n  .row-5 .g-md-8,\n  .row-5 .gx-md-8 {\n    --bs-gutter-x: 3rem;\n  }\n  .row-5 .g-md-8,\n  .row-5 .gy-md-8 {\n    --bs-gutter-y: 3rem;\n  }\n  .row-5 .g-md-9,\n  .row-5 .gx-md-9 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .row-5 .g-md-9,\n  .row-5 .gy-md-9 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .row-5 .g-md-10,\n  .row-5 .gx-md-10 {\n    --bs-gutter-x: 4rem;\n  }\n  .row-5 .g-md-10,\n  .row-5 .gy-md-10 {\n    --bs-gutter-y: 4rem;\n  }\n  .row-5 .g-md-11,\n  .row-5 .gx-md-11 {\n    --bs-gutter-x: 5rem;\n  }\n  .row-5 .g-md-11,\n  .row-5 .gy-md-11 {\n    --bs-gutter-y: 5rem;\n  }\n  .row-5 .g-md-12,\n  .row-5 .gx-md-12 {\n    --bs-gutter-x: 6rem;\n  }\n  .row-5 .g-md-12,\n  .row-5 .gy-md-12 {\n    --bs-gutter-y: 6rem;\n  }\n  .row-5 .g-md-13,\n  .row-5 .gx-md-13 {\n    --bs-gutter-x: 6.5rem;\n  }\n  .row-5 .g-md-13,\n  .row-5 .gy-md-13 {\n    --bs-gutter-y: 6.5rem;\n  }\n  .row-5 .g-md-14,\n  .row-5 .gx-md-14 {\n    --bs-gutter-x: 8rem;\n  }\n  .row-5 .g-md-14,\n  .row-5 .gy-md-14 {\n    --bs-gutter-y: 8rem;\n  }\n}\n@media (min-width: 992px) {\n  .row-5 .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-5 .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-5 .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-5 .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-5 .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-5 .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-5 .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-5 .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .row-5 .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-5 .col-lg-1 {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-5 .col-lg-2 {\n    flex: 0 0 auto;\n    width: 40%;\n  }\n  .row-5 .col-lg-3 {\n    flex: 0 0 auto;\n    width: 60%;\n  }\n  .row-5 .col-lg-4 {\n    flex: 0 0 auto;\n    width: 80%;\n  }\n  .row-5 .col-lg-5 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-5 .offset-lg-0 {\n    margin-left: 0;\n  }\n  .row-5 .offset-lg-1 {\n    margin-left: 20%;\n  }\n  .row-5 .offset-lg-2 {\n    margin-left: 40%;\n  }\n  .row-5 .offset-lg-3 {\n    margin-left: 60%;\n  }\n  .row-5 .offset-lg-4 {\n    margin-left: 80%;\n  }\n  .row-5 .g-lg-0,\n  .row-5 .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n  .row-5 .g-lg-0,\n  .row-5 .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n  .row-5 .g-lg-1,\n  .row-5 .gx-lg-1 {\n    --bs-gutter-x: 0.125rem;\n  }\n  .row-5 .g-lg-1,\n  .row-5 .gy-lg-1 {\n    --bs-gutter-y: 0.125rem;\n  }\n  .row-5 .g-lg-2,\n  .row-5 .gx-lg-2 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .row-5 .g-lg-2,\n  .row-5 .gy-lg-2 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .row-5 .g-lg-3,\n  .row-5 .gx-lg-3 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .row-5 .g-lg-3,\n  .row-5 .gy-lg-3 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .row-5 .g-lg-4,\n  .row-5 .gx-lg-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .row-5 .g-lg-4,\n  .row-5 .gy-lg-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .row-5 .g-lg-5,\n  .row-5 .gx-lg-5 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .row-5 .g-lg-5,\n  .row-5 .gy-lg-5 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .row-5 .g-lg-6,\n  .row-5 .gx-lg-6 {\n    --bs-gutter-x: 2rem;\n  }\n  .row-5 .g-lg-6,\n  .row-5 .gy-lg-6 {\n    --bs-gutter-y: 2rem;\n  }\n  .row-5 .g-lg-7,\n  .row-5 .gx-lg-7 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .row-5 .g-lg-7,\n  .row-5 .gy-lg-7 {\n    --bs-gutter-y: 2.5rem;\n  }\n  .row-5 .g-lg-8,\n  .row-5 .gx-lg-8 {\n    --bs-gutter-x: 3rem;\n  }\n  .row-5 .g-lg-8,\n  .row-5 .gy-lg-8 {\n    --bs-gutter-y: 3rem;\n  }\n  .row-5 .g-lg-9,\n  .row-5 .gx-lg-9 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .row-5 .g-lg-9,\n  .row-5 .gy-lg-9 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .row-5 .g-lg-10,\n  .row-5 .gx-lg-10 {\n    --bs-gutter-x: 4rem;\n  }\n  .row-5 .g-lg-10,\n  .row-5 .gy-lg-10 {\n    --bs-gutter-y: 4rem;\n  }\n  .row-5 .g-lg-11,\n  .row-5 .gx-lg-11 {\n    --bs-gutter-x: 5rem;\n  }\n  .row-5 .g-lg-11,\n  .row-5 .gy-lg-11 {\n    --bs-gutter-y: 5rem;\n  }\n  .row-5 .g-lg-12,\n  .row-5 .gx-lg-12 {\n    --bs-gutter-x: 6rem;\n  }\n  .row-5 .g-lg-12,\n  .row-5 .gy-lg-12 {\n    --bs-gutter-y: 6rem;\n  }\n  .row-5 .g-lg-13,\n  .row-5 .gx-lg-13 {\n    --bs-gutter-x: 6.5rem;\n  }\n  .row-5 .g-lg-13,\n  .row-5 .gy-lg-13 {\n    --bs-gutter-y: 6.5rem;\n  }\n  .row-5 .g-lg-14,\n  .row-5 .gx-lg-14 {\n    --bs-gutter-x: 8rem;\n  }\n  .row-5 .g-lg-14,\n  .row-5 .gy-lg-14 {\n    --bs-gutter-y: 8rem;\n  }\n}\n@media (min-width: 1200px) {\n  .row-5 .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-5 .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-5 .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-5 .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-5 .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-5 .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-5 .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-5 .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .row-5 .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-5 .col-xl-1 {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-5 .col-xl-2 {\n    flex: 0 0 auto;\n    width: 40%;\n  }\n  .row-5 .col-xl-3 {\n    flex: 0 0 auto;\n    width: 60%;\n  }\n  .row-5 .col-xl-4 {\n    flex: 0 0 auto;\n    width: 80%;\n  }\n  .row-5 .col-xl-5 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-5 .offset-xl-0 {\n    margin-left: 0;\n  }\n  .row-5 .offset-xl-1 {\n    margin-left: 20%;\n  }\n  .row-5 .offset-xl-2 {\n    margin-left: 40%;\n  }\n  .row-5 .offset-xl-3 {\n    margin-left: 60%;\n  }\n  .row-5 .offset-xl-4 {\n    margin-left: 80%;\n  }\n  .row-5 .g-xl-0,\n  .row-5 .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n  .row-5 .g-xl-0,\n  .row-5 .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n  .row-5 .g-xl-1,\n  .row-5 .gx-xl-1 {\n    --bs-gutter-x: 0.125rem;\n  }\n  .row-5 .g-xl-1,\n  .row-5 .gy-xl-1 {\n    --bs-gutter-y: 0.125rem;\n  }\n  .row-5 .g-xl-2,\n  .row-5 .gx-xl-2 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .row-5 .g-xl-2,\n  .row-5 .gy-xl-2 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .row-5 .g-xl-3,\n  .row-5 .gx-xl-3 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .row-5 .g-xl-3,\n  .row-5 .gy-xl-3 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .row-5 .g-xl-4,\n  .row-5 .gx-xl-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .row-5 .g-xl-4,\n  .row-5 .gy-xl-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .row-5 .g-xl-5,\n  .row-5 .gx-xl-5 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .row-5 .g-xl-5,\n  .row-5 .gy-xl-5 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .row-5 .g-xl-6,\n  .row-5 .gx-xl-6 {\n    --bs-gutter-x: 2rem;\n  }\n  .row-5 .g-xl-6,\n  .row-5 .gy-xl-6 {\n    --bs-gutter-y: 2rem;\n  }\n  .row-5 .g-xl-7,\n  .row-5 .gx-xl-7 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .row-5 .g-xl-7,\n  .row-5 .gy-xl-7 {\n    --bs-gutter-y: 2.5rem;\n  }\n  .row-5 .g-xl-8,\n  .row-5 .gx-xl-8 {\n    --bs-gutter-x: 3rem;\n  }\n  .row-5 .g-xl-8,\n  .row-5 .gy-xl-8 {\n    --bs-gutter-y: 3rem;\n  }\n  .row-5 .g-xl-9,\n  .row-5 .gx-xl-9 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .row-5 .g-xl-9,\n  .row-5 .gy-xl-9 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .row-5 .g-xl-10,\n  .row-5 .gx-xl-10 {\n    --bs-gutter-x: 4rem;\n  }\n  .row-5 .g-xl-10,\n  .row-5 .gy-xl-10 {\n    --bs-gutter-y: 4rem;\n  }\n  .row-5 .g-xl-11,\n  .row-5 .gx-xl-11 {\n    --bs-gutter-x: 5rem;\n  }\n  .row-5 .g-xl-11,\n  .row-5 .gy-xl-11 {\n    --bs-gutter-y: 5rem;\n  }\n  .row-5 .g-xl-12,\n  .row-5 .gx-xl-12 {\n    --bs-gutter-x: 6rem;\n  }\n  .row-5 .g-xl-12,\n  .row-5 .gy-xl-12 {\n    --bs-gutter-y: 6rem;\n  }\n  .row-5 .g-xl-13,\n  .row-5 .gx-xl-13 {\n    --bs-gutter-x: 6.5rem;\n  }\n  .row-5 .g-xl-13,\n  .row-5 .gy-xl-13 {\n    --bs-gutter-y: 6.5rem;\n  }\n  .row-5 .g-xl-14,\n  .row-5 .gx-xl-14 {\n    --bs-gutter-x: 8rem;\n  }\n  .row-5 .g-xl-14,\n  .row-5 .gy-xl-14 {\n    --bs-gutter-y: 8rem;\n  }\n}\n@media (min-width: 1400px) {\n  .row-5 .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-5 .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-5 .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-5 .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-5 .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-5 .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-5 .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-5 .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .row-5 .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-5 .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-5 .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 40%;\n  }\n  .row-5 .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 60%;\n  }\n  .row-5 .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 80%;\n  }\n  .row-5 .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-5 .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .row-5 .offset-xxl-1 {\n    margin-left: 20%;\n  }\n  .row-5 .offset-xxl-2 {\n    margin-left: 40%;\n  }\n  .row-5 .offset-xxl-3 {\n    margin-left: 60%;\n  }\n  .row-5 .offset-xxl-4 {\n    margin-left: 80%;\n  }\n  .row-5 .g-xxl-0,\n  .row-5 .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .row-5 .g-xxl-0,\n  .row-5 .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .row-5 .g-xxl-1,\n  .row-5 .gx-xxl-1 {\n    --bs-gutter-x: 0.125rem;\n  }\n  .row-5 .g-xxl-1,\n  .row-5 .gy-xxl-1 {\n    --bs-gutter-y: 0.125rem;\n  }\n  .row-5 .g-xxl-2,\n  .row-5 .gx-xxl-2 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .row-5 .g-xxl-2,\n  .row-5 .gy-xxl-2 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .row-5 .g-xxl-3,\n  .row-5 .gx-xxl-3 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .row-5 .g-xxl-3,\n  .row-5 .gy-xxl-3 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .row-5 .g-xxl-4,\n  .row-5 .gx-xxl-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .row-5 .g-xxl-4,\n  .row-5 .gy-xxl-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .row-5 .g-xxl-5,\n  .row-5 .gx-xxl-5 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .row-5 .g-xxl-5,\n  .row-5 .gy-xxl-5 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .row-5 .g-xxl-6,\n  .row-5 .gx-xxl-6 {\n    --bs-gutter-x: 2rem;\n  }\n  .row-5 .g-xxl-6,\n  .row-5 .gy-xxl-6 {\n    --bs-gutter-y: 2rem;\n  }\n  .row-5 .g-xxl-7,\n  .row-5 .gx-xxl-7 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .row-5 .g-xxl-7,\n  .row-5 .gy-xxl-7 {\n    --bs-gutter-y: 2.5rem;\n  }\n  .row-5 .g-xxl-8,\n  .row-5 .gx-xxl-8 {\n    --bs-gutter-x: 3rem;\n  }\n  .row-5 .g-xxl-8,\n  .row-5 .gy-xxl-8 {\n    --bs-gutter-y: 3rem;\n  }\n  .row-5 .g-xxl-9,\n  .row-5 .gx-xxl-9 {\n    --bs-gutter-x: 3.5rem;\n  }\n  .row-5 .g-xxl-9,\n  .row-5 .gy-xxl-9 {\n    --bs-gutter-y: 3.5rem;\n  }\n  .row-5 .g-xxl-10,\n  .row-5 .gx-xxl-10 {\n    --bs-gutter-x: 4rem;\n  }\n  .row-5 .g-xxl-10,\n  .row-5 .gy-xxl-10 {\n    --bs-gutter-y: 4rem;\n  }\n  .row-5 .g-xxl-11,\n  .row-5 .gx-xxl-11 {\n    --bs-gutter-x: 5rem;\n  }\n  .row-5 .g-xxl-11,\n  .row-5 .gy-xxl-11 {\n    --bs-gutter-y: 5rem;\n  }\n  .row-5 .g-xxl-12,\n  .row-5 .gx-xxl-12 {\n    --bs-gutter-x: 6rem;\n  }\n  .row-5 .g-xxl-12,\n  .row-5 .gy-xxl-12 {\n    --bs-gutter-y: 6rem;\n  }\n  .row-5 .g-xxl-13,\n  .row-5 .gx-xxl-13 {\n    --bs-gutter-x: 6.5rem;\n  }\n  .row-5 .g-xxl-13,\n  .row-5 .gy-xxl-13 {\n    --bs-gutter-y: 6.5rem;\n  }\n  .row-5 .g-xxl-14,\n  .row-5 .gx-xxl-14 {\n    --bs-gutter-x: 8rem;\n  }\n  .row-5 .g-xxl-14,\n  .row-5 .gy-xxl-14 {\n    --bs-gutter-y: 8rem;\n  }\n}\n\n.x5-me-0,\n.x5-mx-0 {\n  margin-right: 0 !important;\n}\n\n.x5-ms-0,\n.x5-mx-0 {\n  margin-left: 0 !important;\n}\n\n.x5-me-1,\n.x5-mx-1 {\n  margin-right: 0.3125rem !important;\n}\n\n.x5-ms-1,\n.x5-mx-1 {\n  margin-left: 0.3125rem !important;\n}\n\n.x5-me-2,\n.x5-mx-2 {\n  margin-right: 0.625rem !important;\n}\n\n.x5-ms-2,\n.x5-mx-2 {\n  margin-left: 0.625rem !important;\n}\n\n.x5-me-3,\n.x5-mx-3 {\n  margin-right: 0.9375rem !important;\n}\n\n.x5-ms-3,\n.x5-mx-3 {\n  margin-left: 0.9375rem !important;\n}\n\n.x5-me-4,\n.x5-mx-4 {\n  margin-right: 1.5625rem !important;\n}\n\n.x5-ms-4,\n.x5-mx-4 {\n  margin-left: 1.5625rem !important;\n}\n\n.x5-me-5,\n.x5-mx-5 {\n  margin-right: 1.875rem !important;\n}\n\n.x5-ms-5,\n.x5-mx-5 {\n  margin-left: 1.875rem !important;\n}\n\n.x5-me-6,\n.x5-mx-6 {\n  margin-right: 2.5rem !important;\n}\n\n.x5-ms-6,\n.x5-mx-6 {\n  margin-left: 2.5rem !important;\n}\n\n.x5-me-7,\n.x5-mx-7 {\n  margin-right: 2.8125rem !important;\n}\n\n.x5-ms-7,\n.x5-mx-7 {\n  margin-left: 2.8125rem !important;\n}\n\n.x5-me-8,\n.x5-mx-8 {\n  margin-right: 3.75rem !important;\n}\n\n.x5-ms-8,\n.x5-mx-8 {\n  margin-left: 3.75rem !important;\n}\n\n.x5-pe-0,\n.x5-px-0 {\n  padding-right: 0 !important;\n}\n\n.x5-ps-0,\n.x5-px-0 {\n  padding-left: 0 !important;\n}\n\n.x5-pe-1,\n.x5-px-1 {\n  padding-right: 0.3125rem !important;\n}\n\n.x5-ps-1,\n.x5-px-1 {\n  padding-left: 0.3125rem !important;\n}\n\n.x5-pe-2,\n.x5-px-2 {\n  padding-right: 0.625rem !important;\n}\n\n.x5-ps-2,\n.x5-px-2 {\n  padding-left: 0.625rem !important;\n}\n\n.x5-pe-3,\n.x5-px-3 {\n  padding-right: 0.9375rem !important;\n}\n\n.x5-ps-3,\n.x5-px-3 {\n  padding-left: 0.9375rem !important;\n}\n\n.x5-pe-4,\n.x5-px-4 {\n  padding-right: 1.5625rem !important;\n}\n\n.x5-ps-4,\n.x5-px-4 {\n  padding-left: 1.5625rem !important;\n}\n\n.x5-pe-5,\n.x5-px-5 {\n  padding-right: 1.875rem !important;\n}\n\n.x5-ps-5,\n.x5-px-5 {\n  padding-left: 1.875rem !important;\n}\n\n.x5-pe-6,\n.x5-px-6 {\n  padding-right: 2.5rem !important;\n}\n\n.x5-ps-6,\n.x5-px-6 {\n  padding-left: 2.5rem !important;\n}\n\n.x5-pe-7,\n.x5-px-7 {\n  padding-right: 2.8125rem !important;\n}\n\n.x5-ps-7,\n.x5-px-7 {\n  padding-left: 2.8125rem !important;\n}\n\n.x5-pe-8,\n.x5-px-8 {\n  padding-right: 3.75rem !important;\n}\n\n.x5-ps-8,\n.x5-px-8 {\n  padding-left: 3.75rem !important;\n}\n\n.x5-me-n1,\n.x5-mx-n1 {\n  margin-right: -0.3125rem !important;\n}\n\n.x5-ms-n1,\n.x5-mx-n1 {\n  margin-left: -0.3125rem !important;\n}\n\n.x5-me-n2,\n.x5-mx-n2 {\n  margin-right: -0.625rem !important;\n}\n\n.x5-ms-n2,\n.x5-mx-n2 {\n  margin-left: -0.625rem !important;\n}\n\n.x5-me-n3,\n.x5-mx-n3 {\n  margin-right: -0.9375rem !important;\n}\n\n.x5-ms-n3,\n.x5-mx-n3 {\n  margin-left: -0.9375rem !important;\n}\n\n.x5-me-n4,\n.x5-mx-n4 {\n  margin-right: -1.5625rem !important;\n}\n\n.x5-ms-n4,\n.x5-mx-n4 {\n  margin-left: -1.5625rem !important;\n}\n\n.x5-me-n5,\n.x5-mx-n5 {\n  margin-right: -1.875rem !important;\n}\n\n.x5-ms-n5,\n.x5-mx-n5 {\n  margin-left: -1.875rem !important;\n}\n\n.x5-me-n6,\n.x5-mx-n6 {\n  margin-right: -2.5rem !important;\n}\n\n.x5-ms-n6,\n.x5-mx-n6 {\n  margin-left: -2.5rem !important;\n}\n\n.x5-me-n7,\n.x5-mx-n7 {\n  margin-right: -2.8125rem !important;\n}\n\n.x5-ms-n7,\n.x5-mx-n7 {\n  margin-left: -2.8125rem !important;\n}\n\n.x5-me-n8,\n.x5-mx-n8 {\n  margin-right: -3.75rem !important;\n}\n\n.x5-ms-n8,\n.x5-mx-n8 {\n  margin-left: -3.75rem !important;\n}\n\n@media (min-width: 576px) {\n  .x5-me-sm-0,\n  .x5-mx-sm-0 {\n    margin-right: 0 !important;\n  }\n  .x5-ms-sm-0,\n  .x5-mx-sm-0 {\n    margin-left: 0 !important;\n  }\n  .x5-me-sm-1,\n  .x5-mx-sm-1 {\n    margin-right: 0.3125rem !important;\n  }\n  .x5-ms-sm-1,\n  .x5-mx-sm-1 {\n    margin-left: 0.3125rem !important;\n  }\n  .x5-me-sm-2,\n  .x5-mx-sm-2 {\n    margin-right: 0.625rem !important;\n  }\n  .x5-ms-sm-2,\n  .x5-mx-sm-2 {\n    margin-left: 0.625rem !important;\n  }\n  .x5-me-sm-3,\n  .x5-mx-sm-3 {\n    margin-right: 0.9375rem !important;\n  }\n  .x5-ms-sm-3,\n  .x5-mx-sm-3 {\n    margin-left: 0.9375rem !important;\n  }\n  .x5-me-sm-4,\n  .x5-mx-sm-4 {\n    margin-right: 1.5625rem !important;\n  }\n  .x5-ms-sm-4,\n  .x5-mx-sm-4 {\n    margin-left: 1.5625rem !important;\n  }\n  .x5-me-sm-5,\n  .x5-mx-sm-5 {\n    margin-right: 1.875rem !important;\n  }\n  .x5-ms-sm-5,\n  .x5-mx-sm-5 {\n    margin-left: 1.875rem !important;\n  }\n  .x5-me-sm-6,\n  .x5-mx-sm-6 {\n    margin-right: 2.5rem !important;\n  }\n  .x5-ms-sm-6,\n  .x5-mx-sm-6 {\n    margin-left: 2.5rem !important;\n  }\n  .x5-me-sm-7,\n  .x5-mx-sm-7 {\n    margin-right: 2.8125rem !important;\n  }\n  .x5-ms-sm-7,\n  .x5-mx-sm-7 {\n    margin-left: 2.8125rem !important;\n  }\n  .x5-me-sm-8,\n  .x5-mx-sm-8 {\n    margin-right: 3.75rem !important;\n  }\n  .x5-ms-sm-8,\n  .x5-mx-sm-8 {\n    margin-left: 3.75rem !important;\n  }\n  .x5-pe-sm-0,\n  .x5-px-sm-0 {\n    padding-right: 0 !important;\n  }\n  .x5-ps-sm-0,\n  .x5-px-sm-0 {\n    padding-left: 0 !important;\n  }\n  .x5-pe-sm-1,\n  .x5-px-sm-1 {\n    padding-right: 0.3125rem !important;\n  }\n  .x5-ps-sm-1,\n  .x5-px-sm-1 {\n    padding-left: 0.3125rem !important;\n  }\n  .x5-pe-sm-2,\n  .x5-px-sm-2 {\n    padding-right: 0.625rem !important;\n  }\n  .x5-ps-sm-2,\n  .x5-px-sm-2 {\n    padding-left: 0.625rem !important;\n  }\n  .x5-pe-sm-3,\n  .x5-px-sm-3 {\n    padding-right: 0.9375rem !important;\n  }\n  .x5-ps-sm-3,\n  .x5-px-sm-3 {\n    padding-left: 0.9375rem !important;\n  }\n  .x5-pe-sm-4,\n  .x5-px-sm-4 {\n    padding-right: 1.5625rem !important;\n  }\n  .x5-ps-sm-4,\n  .x5-px-sm-4 {\n    padding-left: 1.5625rem !important;\n  }\n  .x5-pe-sm-5,\n  .x5-px-sm-5 {\n    padding-right: 1.875rem !important;\n  }\n  .x5-ps-sm-5,\n  .x5-px-sm-5 {\n    padding-left: 1.875rem !important;\n  }\n  .x5-pe-sm-6,\n  .x5-px-sm-6 {\n    padding-right: 2.5rem !important;\n  }\n  .x5-ps-sm-6,\n  .x5-px-sm-6 {\n    padding-left: 2.5rem !important;\n  }\n  .x5-pe-sm-7,\n  .x5-px-sm-7 {\n    padding-right: 2.8125rem !important;\n  }\n  .x5-ps-sm-7,\n  .x5-px-sm-7 {\n    padding-left: 2.8125rem !important;\n  }\n  .x5-pe-sm-8,\n  .x5-px-sm-8 {\n    padding-right: 3.75rem !important;\n  }\n  .x5-ps-sm-8,\n  .x5-px-sm-8 {\n    padding-left: 3.75rem !important;\n  }\n  .x5-me-sm-n1,\n  .x5-mx-sm-n1 {\n    margin-right: -0.3125rem !important;\n  }\n  .x5-ms-sm-n1,\n  .x5-mx-sm-n1 {\n    margin-left: -0.3125rem !important;\n  }\n  .x5-me-sm-n2,\n  .x5-mx-sm-n2 {\n    margin-right: -0.625rem !important;\n  }\n  .x5-ms-sm-n2,\n  .x5-mx-sm-n2 {\n    margin-left: -0.625rem !important;\n  }\n  .x5-me-sm-n3,\n  .x5-mx-sm-n3 {\n    margin-right: -0.9375rem !important;\n  }\n  .x5-ms-sm-n3,\n  .x5-mx-sm-n3 {\n    margin-left: -0.9375rem !important;\n  }\n  .x5-me-sm-n4,\n  .x5-mx-sm-n4 {\n    margin-right: -1.5625rem !important;\n  }\n  .x5-ms-sm-n4,\n  .x5-mx-sm-n4 {\n    margin-left: -1.5625rem !important;\n  }\n  .x5-me-sm-n5,\n  .x5-mx-sm-n5 {\n    margin-right: -1.875rem !important;\n  }\n  .x5-ms-sm-n5,\n  .x5-mx-sm-n5 {\n    margin-left: -1.875rem !important;\n  }\n  .x5-me-sm-n6,\n  .x5-mx-sm-n6 {\n    margin-right: -2.5rem !important;\n  }\n  .x5-ms-sm-n6,\n  .x5-mx-sm-n6 {\n    margin-left: -2.5rem !important;\n  }\n  .x5-me-sm-n7,\n  .x5-mx-sm-n7 {\n    margin-right: -2.8125rem !important;\n  }\n  .x5-ms-sm-n7,\n  .x5-mx-sm-n7 {\n    margin-left: -2.8125rem !important;\n  }\n  .x5-me-sm-n8,\n  .x5-mx-sm-n8 {\n    margin-right: -3.75rem !important;\n  }\n  .x5-ms-sm-n8,\n  .x5-mx-sm-n8 {\n    margin-left: -3.75rem !important;\n  }\n}\n@media (min-width: 768px) {\n  .x5-me-md-0,\n  .x5-mx-md-0 {\n    margin-right: 0 !important;\n  }\n  .x5-ms-md-0,\n  .x5-mx-md-0 {\n    margin-left: 0 !important;\n  }\n  .x5-me-md-1,\n  .x5-mx-md-1 {\n    margin-right: 0.3125rem !important;\n  }\n  .x5-ms-md-1,\n  .x5-mx-md-1 {\n    margin-left: 0.3125rem !important;\n  }\n  .x5-me-md-2,\n  .x5-mx-md-2 {\n    margin-right: 0.625rem !important;\n  }\n  .x5-ms-md-2,\n  .x5-mx-md-2 {\n    margin-left: 0.625rem !important;\n  }\n  .x5-me-md-3,\n  .x5-mx-md-3 {\n    margin-right: 0.9375rem !important;\n  }\n  .x5-ms-md-3,\n  .x5-mx-md-3 {\n    margin-left: 0.9375rem !important;\n  }\n  .x5-me-md-4,\n  .x5-mx-md-4 {\n    margin-right: 1.5625rem !important;\n  }\n  .x5-ms-md-4,\n  .x5-mx-md-4 {\n    margin-left: 1.5625rem !important;\n  }\n  .x5-me-md-5,\n  .x5-mx-md-5 {\n    margin-right: 1.875rem !important;\n  }\n  .x5-ms-md-5,\n  .x5-mx-md-5 {\n    margin-left: 1.875rem !important;\n  }\n  .x5-me-md-6,\n  .x5-mx-md-6 {\n    margin-right: 2.5rem !important;\n  }\n  .x5-ms-md-6,\n  .x5-mx-md-6 {\n    margin-left: 2.5rem !important;\n  }\n  .x5-me-md-7,\n  .x5-mx-md-7 {\n    margin-right: 2.8125rem !important;\n  }\n  .x5-ms-md-7,\n  .x5-mx-md-7 {\n    margin-left: 2.8125rem !important;\n  }\n  .x5-me-md-8,\n  .x5-mx-md-8 {\n    margin-right: 3.75rem !important;\n  }\n  .x5-ms-md-8,\n  .x5-mx-md-8 {\n    margin-left: 3.75rem !important;\n  }\n  .x5-pe-md-0,\n  .x5-px-md-0 {\n    padding-right: 0 !important;\n  }\n  .x5-ps-md-0,\n  .x5-px-md-0 {\n    padding-left: 0 !important;\n  }\n  .x5-pe-md-1,\n  .x5-px-md-1 {\n    padding-right: 0.3125rem !important;\n  }\n  .x5-ps-md-1,\n  .x5-px-md-1 {\n    padding-left: 0.3125rem !important;\n  }\n  .x5-pe-md-2,\n  .x5-px-md-2 {\n    padding-right: 0.625rem !important;\n  }\n  .x5-ps-md-2,\n  .x5-px-md-2 {\n    padding-left: 0.625rem !important;\n  }\n  .x5-pe-md-3,\n  .x5-px-md-3 {\n    padding-right: 0.9375rem !important;\n  }\n  .x5-ps-md-3,\n  .x5-px-md-3 {\n    padding-left: 0.9375rem !important;\n  }\n  .x5-pe-md-4,\n  .x5-px-md-4 {\n    padding-right: 1.5625rem !important;\n  }\n  .x5-ps-md-4,\n  .x5-px-md-4 {\n    padding-left: 1.5625rem !important;\n  }\n  .x5-pe-md-5,\n  .x5-px-md-5 {\n    padding-right: 1.875rem !important;\n  }\n  .x5-ps-md-5,\n  .x5-px-md-5 {\n    padding-left: 1.875rem !important;\n  }\n  .x5-pe-md-6,\n  .x5-px-md-6 {\n    padding-right: 2.5rem !important;\n  }\n  .x5-ps-md-6,\n  .x5-px-md-6 {\n    padding-left: 2.5rem !important;\n  }\n  .x5-pe-md-7,\n  .x5-px-md-7 {\n    padding-right: 2.8125rem !important;\n  }\n  .x5-ps-md-7,\n  .x5-px-md-7 {\n    padding-left: 2.8125rem !important;\n  }\n  .x5-pe-md-8,\n  .x5-px-md-8 {\n    padding-right: 3.75rem !important;\n  }\n  .x5-ps-md-8,\n  .x5-px-md-8 {\n    padding-left: 3.75rem !important;\n  }\n  .x5-me-md-n1,\n  .x5-mx-md-n1 {\n    margin-right: -0.3125rem !important;\n  }\n  .x5-ms-md-n1,\n  .x5-mx-md-n1 {\n    margin-left: -0.3125rem !important;\n  }\n  .x5-me-md-n2,\n  .x5-mx-md-n2 {\n    margin-right: -0.625rem !important;\n  }\n  .x5-ms-md-n2,\n  .x5-mx-md-n2 {\n    margin-left: -0.625rem !important;\n  }\n  .x5-me-md-n3,\n  .x5-mx-md-n3 {\n    margin-right: -0.9375rem !important;\n  }\n  .x5-ms-md-n3,\n  .x5-mx-md-n3 {\n    margin-left: -0.9375rem !important;\n  }\n  .x5-me-md-n4,\n  .x5-mx-md-n4 {\n    margin-right: -1.5625rem !important;\n  }\n  .x5-ms-md-n4,\n  .x5-mx-md-n4 {\n    margin-left: -1.5625rem !important;\n  }\n  .x5-me-md-n5,\n  .x5-mx-md-n5 {\n    margin-right: -1.875rem !important;\n  }\n  .x5-ms-md-n5,\n  .x5-mx-md-n5 {\n    margin-left: -1.875rem !important;\n  }\n  .x5-me-md-n6,\n  .x5-mx-md-n6 {\n    margin-right: -2.5rem !important;\n  }\n  .x5-ms-md-n6,\n  .x5-mx-md-n6 {\n    margin-left: -2.5rem !important;\n  }\n  .x5-me-md-n7,\n  .x5-mx-md-n7 {\n    margin-right: -2.8125rem !important;\n  }\n  .x5-ms-md-n7,\n  .x5-mx-md-n7 {\n    margin-left: -2.8125rem !important;\n  }\n  .x5-me-md-n8,\n  .x5-mx-md-n8 {\n    margin-right: -3.75rem !important;\n  }\n  .x5-ms-md-n8,\n  .x5-mx-md-n8 {\n    margin-left: -3.75rem !important;\n  }\n}\n@media (min-width: 992px) {\n  .x5-me-lg-0,\n  .x5-mx-lg-0 {\n    margin-right: 0 !important;\n  }\n  .x5-ms-lg-0,\n  .x5-mx-lg-0 {\n    margin-left: 0 !important;\n  }\n  .x5-me-lg-1,\n  .x5-mx-lg-1 {\n    margin-right: 0.3125rem !important;\n  }\n  .x5-ms-lg-1,\n  .x5-mx-lg-1 {\n    margin-left: 0.3125rem !important;\n  }\n  .x5-me-lg-2,\n  .x5-mx-lg-2 {\n    margin-right: 0.625rem !important;\n  }\n  .x5-ms-lg-2,\n  .x5-mx-lg-2 {\n    margin-left: 0.625rem !important;\n  }\n  .x5-me-lg-3,\n  .x5-mx-lg-3 {\n    margin-right: 0.9375rem !important;\n  }\n  .x5-ms-lg-3,\n  .x5-mx-lg-3 {\n    margin-left: 0.9375rem !important;\n  }\n  .x5-me-lg-4,\n  .x5-mx-lg-4 {\n    margin-right: 1.5625rem !important;\n  }\n  .x5-ms-lg-4,\n  .x5-mx-lg-4 {\n    margin-left: 1.5625rem !important;\n  }\n  .x5-me-lg-5,\n  .x5-mx-lg-5 {\n    margin-right: 1.875rem !important;\n  }\n  .x5-ms-lg-5,\n  .x5-mx-lg-5 {\n    margin-left: 1.875rem !important;\n  }\n  .x5-me-lg-6,\n  .x5-mx-lg-6 {\n    margin-right: 2.5rem !important;\n  }\n  .x5-ms-lg-6,\n  .x5-mx-lg-6 {\n    margin-left: 2.5rem !important;\n  }\n  .x5-me-lg-7,\n  .x5-mx-lg-7 {\n    margin-right: 2.8125rem !important;\n  }\n  .x5-ms-lg-7,\n  .x5-mx-lg-7 {\n    margin-left: 2.8125rem !important;\n  }\n  .x5-me-lg-8,\n  .x5-mx-lg-8 {\n    margin-right: 3.75rem !important;\n  }\n  .x5-ms-lg-8,\n  .x5-mx-lg-8 {\n    margin-left: 3.75rem !important;\n  }\n  .x5-pe-lg-0,\n  .x5-px-lg-0 {\n    padding-right: 0 !important;\n  }\n  .x5-ps-lg-0,\n  .x5-px-lg-0 {\n    padding-left: 0 !important;\n  }\n  .x5-pe-lg-1,\n  .x5-px-lg-1 {\n    padding-right: 0.3125rem !important;\n  }\n  .x5-ps-lg-1,\n  .x5-px-lg-1 {\n    padding-left: 0.3125rem !important;\n  }\n  .x5-pe-lg-2,\n  .x5-px-lg-2 {\n    padding-right: 0.625rem !important;\n  }\n  .x5-ps-lg-2,\n  .x5-px-lg-2 {\n    padding-left: 0.625rem !important;\n  }\n  .x5-pe-lg-3,\n  .x5-px-lg-3 {\n    padding-right: 0.9375rem !important;\n  }\n  .x5-ps-lg-3,\n  .x5-px-lg-3 {\n    padding-left: 0.9375rem !important;\n  }\n  .x5-pe-lg-4,\n  .x5-px-lg-4 {\n    padding-right: 1.5625rem !important;\n  }\n  .x5-ps-lg-4,\n  .x5-px-lg-4 {\n    padding-left: 1.5625rem !important;\n  }\n  .x5-pe-lg-5,\n  .x5-px-lg-5 {\n    padding-right: 1.875rem !important;\n  }\n  .x5-ps-lg-5,\n  .x5-px-lg-5 {\n    padding-left: 1.875rem !important;\n  }\n  .x5-pe-lg-6,\n  .x5-px-lg-6 {\n    padding-right: 2.5rem !important;\n  }\n  .x5-ps-lg-6,\n  .x5-px-lg-6 {\n    padding-left: 2.5rem !important;\n  }\n  .x5-pe-lg-7,\n  .x5-px-lg-7 {\n    padding-right: 2.8125rem !important;\n  }\n  .x5-ps-lg-7,\n  .x5-px-lg-7 {\n    padding-left: 2.8125rem !important;\n  }\n  .x5-pe-lg-8,\n  .x5-px-lg-8 {\n    padding-right: 3.75rem !important;\n  }\n  .x5-ps-lg-8,\n  .x5-px-lg-8 {\n    padding-left: 3.75rem !important;\n  }\n  .x5-me-lg-n1,\n  .x5-mx-lg-n1 {\n    margin-right: -0.3125rem !important;\n  }\n  .x5-ms-lg-n1,\n  .x5-mx-lg-n1 {\n    margin-left: -0.3125rem !important;\n  }\n  .x5-me-lg-n2,\n  .x5-mx-lg-n2 {\n    margin-right: -0.625rem !important;\n  }\n  .x5-ms-lg-n2,\n  .x5-mx-lg-n2 {\n    margin-left: -0.625rem !important;\n  }\n  .x5-me-lg-n3,\n  .x5-mx-lg-n3 {\n    margin-right: -0.9375rem !important;\n  }\n  .x5-ms-lg-n3,\n  .x5-mx-lg-n3 {\n    margin-left: -0.9375rem !important;\n  }\n  .x5-me-lg-n4,\n  .x5-mx-lg-n4 {\n    margin-right: -1.5625rem !important;\n  }\n  .x5-ms-lg-n4,\n  .x5-mx-lg-n4 {\n    margin-left: -1.5625rem !important;\n  }\n  .x5-me-lg-n5,\n  .x5-mx-lg-n5 {\n    margin-right: -1.875rem !important;\n  }\n  .x5-ms-lg-n5,\n  .x5-mx-lg-n5 {\n    margin-left: -1.875rem !important;\n  }\n  .x5-me-lg-n6,\n  .x5-mx-lg-n6 {\n    margin-right: -2.5rem !important;\n  }\n  .x5-ms-lg-n6,\n  .x5-mx-lg-n6 {\n    margin-left: -2.5rem !important;\n  }\n  .x5-me-lg-n7,\n  .x5-mx-lg-n7 {\n    margin-right: -2.8125rem !important;\n  }\n  .x5-ms-lg-n7,\n  .x5-mx-lg-n7 {\n    margin-left: -2.8125rem !important;\n  }\n  .x5-me-lg-n8,\n  .x5-mx-lg-n8 {\n    margin-right: -3.75rem !important;\n  }\n  .x5-ms-lg-n8,\n  .x5-mx-lg-n8 {\n    margin-left: -3.75rem !important;\n  }\n}\n@media (min-width: 1200px) {\n  .x5-me-xl-0,\n  .x5-mx-xl-0 {\n    margin-right: 0 !important;\n  }\n  .x5-ms-xl-0,\n  .x5-mx-xl-0 {\n    margin-left: 0 !important;\n  }\n  .x5-me-xl-1,\n  .x5-mx-xl-1 {\n    margin-right: 0.3125rem !important;\n  }\n  .x5-ms-xl-1,\n  .x5-mx-xl-1 {\n    margin-left: 0.3125rem !important;\n  }\n  .x5-me-xl-2,\n  .x5-mx-xl-2 {\n    margin-right: 0.625rem !important;\n  }\n  .x5-ms-xl-2,\n  .x5-mx-xl-2 {\n    margin-left: 0.625rem !important;\n  }\n  .x5-me-xl-3,\n  .x5-mx-xl-3 {\n    margin-right: 0.9375rem !important;\n  }\n  .x5-ms-xl-3,\n  .x5-mx-xl-3 {\n    margin-left: 0.9375rem !important;\n  }\n  .x5-me-xl-4,\n  .x5-mx-xl-4 {\n    margin-right: 1.5625rem !important;\n  }\n  .x5-ms-xl-4,\n  .x5-mx-xl-4 {\n    margin-left: 1.5625rem !important;\n  }\n  .x5-me-xl-5,\n  .x5-mx-xl-5 {\n    margin-right: 1.875rem !important;\n  }\n  .x5-ms-xl-5,\n  .x5-mx-xl-5 {\n    margin-left: 1.875rem !important;\n  }\n  .x5-me-xl-6,\n  .x5-mx-xl-6 {\n    margin-right: 2.5rem !important;\n  }\n  .x5-ms-xl-6,\n  .x5-mx-xl-6 {\n    margin-left: 2.5rem !important;\n  }\n  .x5-me-xl-7,\n  .x5-mx-xl-7 {\n    margin-right: 2.8125rem !important;\n  }\n  .x5-ms-xl-7,\n  .x5-mx-xl-7 {\n    margin-left: 2.8125rem !important;\n  }\n  .x5-me-xl-8,\n  .x5-mx-xl-8 {\n    margin-right: 3.75rem !important;\n  }\n  .x5-ms-xl-8,\n  .x5-mx-xl-8 {\n    margin-left: 3.75rem !important;\n  }\n  .x5-pe-xl-0,\n  .x5-px-xl-0 {\n    padding-right: 0 !important;\n  }\n  .x5-ps-xl-0,\n  .x5-px-xl-0 {\n    padding-left: 0 !important;\n  }\n  .x5-pe-xl-1,\n  .x5-px-xl-1 {\n    padding-right: 0.3125rem !important;\n  }\n  .x5-ps-xl-1,\n  .x5-px-xl-1 {\n    padding-left: 0.3125rem !important;\n  }\n  .x5-pe-xl-2,\n  .x5-px-xl-2 {\n    padding-right: 0.625rem !important;\n  }\n  .x5-ps-xl-2,\n  .x5-px-xl-2 {\n    padding-left: 0.625rem !important;\n  }\n  .x5-pe-xl-3,\n  .x5-px-xl-3 {\n    padding-right: 0.9375rem !important;\n  }\n  .x5-ps-xl-3,\n  .x5-px-xl-3 {\n    padding-left: 0.9375rem !important;\n  }\n  .x5-pe-xl-4,\n  .x5-px-xl-4 {\n    padding-right: 1.5625rem !important;\n  }\n  .x5-ps-xl-4,\n  .x5-px-xl-4 {\n    padding-left: 1.5625rem !important;\n  }\n  .x5-pe-xl-5,\n  .x5-px-xl-5 {\n    padding-right: 1.875rem !important;\n  }\n  .x5-ps-xl-5,\n  .x5-px-xl-5 {\n    padding-left: 1.875rem !important;\n  }\n  .x5-pe-xl-6,\n  .x5-px-xl-6 {\n    padding-right: 2.5rem !important;\n  }\n  .x5-ps-xl-6,\n  .x5-px-xl-6 {\n    padding-left: 2.5rem !important;\n  }\n  .x5-pe-xl-7,\n  .x5-px-xl-7 {\n    padding-right: 2.8125rem !important;\n  }\n  .x5-ps-xl-7,\n  .x5-px-xl-7 {\n    padding-left: 2.8125rem !important;\n  }\n  .x5-pe-xl-8,\n  .x5-px-xl-8 {\n    padding-right: 3.75rem !important;\n  }\n  .x5-ps-xl-8,\n  .x5-px-xl-8 {\n    padding-left: 3.75rem !important;\n  }\n  .x5-me-xl-n1,\n  .x5-mx-xl-n1 {\n    margin-right: -0.3125rem !important;\n  }\n  .x5-ms-xl-n1,\n  .x5-mx-xl-n1 {\n    margin-left: -0.3125rem !important;\n  }\n  .x5-me-xl-n2,\n  .x5-mx-xl-n2 {\n    margin-right: -0.625rem !important;\n  }\n  .x5-ms-xl-n2,\n  .x5-mx-xl-n2 {\n    margin-left: -0.625rem !important;\n  }\n  .x5-me-xl-n3,\n  .x5-mx-xl-n3 {\n    margin-right: -0.9375rem !important;\n  }\n  .x5-ms-xl-n3,\n  .x5-mx-xl-n3 {\n    margin-left: -0.9375rem !important;\n  }\n  .x5-me-xl-n4,\n  .x5-mx-xl-n4 {\n    margin-right: -1.5625rem !important;\n  }\n  .x5-ms-xl-n4,\n  .x5-mx-xl-n4 {\n    margin-left: -1.5625rem !important;\n  }\n  .x5-me-xl-n5,\n  .x5-mx-xl-n5 {\n    margin-right: -1.875rem !important;\n  }\n  .x5-ms-xl-n5,\n  .x5-mx-xl-n5 {\n    margin-left: -1.875rem !important;\n  }\n  .x5-me-xl-n6,\n  .x5-mx-xl-n6 {\n    margin-right: -2.5rem !important;\n  }\n  .x5-ms-xl-n6,\n  .x5-mx-xl-n6 {\n    margin-left: -2.5rem !important;\n  }\n  .x5-me-xl-n7,\n  .x5-mx-xl-n7 {\n    margin-right: -2.8125rem !important;\n  }\n  .x5-ms-xl-n7,\n  .x5-mx-xl-n7 {\n    margin-left: -2.8125rem !important;\n  }\n  .x5-me-xl-n8,\n  .x5-mx-xl-n8 {\n    margin-right: -3.75rem !important;\n  }\n  .x5-ms-xl-n8,\n  .x5-mx-xl-n8 {\n    margin-left: -3.75rem !important;\n  }\n}\n@media (min-width: 1400px) {\n  .x5-me-xxl-0,\n  .x5-mx-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .x5-ms-xxl-0,\n  .x5-mx-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .x5-me-xxl-1,\n  .x5-mx-xxl-1 {\n    margin-right: 0.3125rem !important;\n  }\n  .x5-ms-xxl-1,\n  .x5-mx-xxl-1 {\n    margin-left: 0.3125rem !important;\n  }\n  .x5-me-xxl-2,\n  .x5-mx-xxl-2 {\n    margin-right: 0.625rem !important;\n  }\n  .x5-ms-xxl-2,\n  .x5-mx-xxl-2 {\n    margin-left: 0.625rem !important;\n  }\n  .x5-me-xxl-3,\n  .x5-mx-xxl-3 {\n    margin-right: 0.9375rem !important;\n  }\n  .x5-ms-xxl-3,\n  .x5-mx-xxl-3 {\n    margin-left: 0.9375rem !important;\n  }\n  .x5-me-xxl-4,\n  .x5-mx-xxl-4 {\n    margin-right: 1.5625rem !important;\n  }\n  .x5-ms-xxl-4,\n  .x5-mx-xxl-4 {\n    margin-left: 1.5625rem !important;\n  }\n  .x5-me-xxl-5,\n  .x5-mx-xxl-5 {\n    margin-right: 1.875rem !important;\n  }\n  .x5-ms-xxl-5,\n  .x5-mx-xxl-5 {\n    margin-left: 1.875rem !important;\n  }\n  .x5-me-xxl-6,\n  .x5-mx-xxl-6 {\n    margin-right: 2.5rem !important;\n  }\n  .x5-ms-xxl-6,\n  .x5-mx-xxl-6 {\n    margin-left: 2.5rem !important;\n  }\n  .x5-me-xxl-7,\n  .x5-mx-xxl-7 {\n    margin-right: 2.8125rem !important;\n  }\n  .x5-ms-xxl-7,\n  .x5-mx-xxl-7 {\n    margin-left: 2.8125rem !important;\n  }\n  .x5-me-xxl-8,\n  .x5-mx-xxl-8 {\n    margin-right: 3.75rem !important;\n  }\n  .x5-ms-xxl-8,\n  .x5-mx-xxl-8 {\n    margin-left: 3.75rem !important;\n  }\n  .x5-pe-xxl-0,\n  .x5-px-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .x5-ps-xxl-0,\n  .x5-px-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .x5-pe-xxl-1,\n  .x5-px-xxl-1 {\n    padding-right: 0.3125rem !important;\n  }\n  .x5-ps-xxl-1,\n  .x5-px-xxl-1 {\n    padding-left: 0.3125rem !important;\n  }\n  .x5-pe-xxl-2,\n  .x5-px-xxl-2 {\n    padding-right: 0.625rem !important;\n  }\n  .x5-ps-xxl-2,\n  .x5-px-xxl-2 {\n    padding-left: 0.625rem !important;\n  }\n  .x5-pe-xxl-3,\n  .x5-px-xxl-3 {\n    padding-right: 0.9375rem !important;\n  }\n  .x5-ps-xxl-3,\n  .x5-px-xxl-3 {\n    padding-left: 0.9375rem !important;\n  }\n  .x5-pe-xxl-4,\n  .x5-px-xxl-4 {\n    padding-right: 1.5625rem !important;\n  }\n  .x5-ps-xxl-4,\n  .x5-px-xxl-4 {\n    padding-left: 1.5625rem !important;\n  }\n  .x5-pe-xxl-5,\n  .x5-px-xxl-5 {\n    padding-right: 1.875rem !important;\n  }\n  .x5-ps-xxl-5,\n  .x5-px-xxl-5 {\n    padding-left: 1.875rem !important;\n  }\n  .x5-pe-xxl-6,\n  .x5-px-xxl-6 {\n    padding-right: 2.5rem !important;\n  }\n  .x5-ps-xxl-6,\n  .x5-px-xxl-6 {\n    padding-left: 2.5rem !important;\n  }\n  .x5-pe-xxl-7,\n  .x5-px-xxl-7 {\n    padding-right: 2.8125rem !important;\n  }\n  .x5-ps-xxl-7,\n  .x5-px-xxl-7 {\n    padding-left: 2.8125rem !important;\n  }\n  .x5-pe-xxl-8,\n  .x5-px-xxl-8 {\n    padding-right: 3.75rem !important;\n  }\n  .x5-ps-xxl-8,\n  .x5-px-xxl-8 {\n    padding-left: 3.75rem !important;\n  }\n  .x5-me-xxl-n1,\n  .x5-mx-xxl-n1 {\n    margin-right: -0.3125rem !important;\n  }\n  .x5-ms-xxl-n1,\n  .x5-mx-xxl-n1 {\n    margin-left: -0.3125rem !important;\n  }\n  .x5-me-xxl-n2,\n  .x5-mx-xxl-n2 {\n    margin-right: -0.625rem !important;\n  }\n  .x5-ms-xxl-n2,\n  .x5-mx-xxl-n2 {\n    margin-left: -0.625rem !important;\n  }\n  .x5-me-xxl-n3,\n  .x5-mx-xxl-n3 {\n    margin-right: -0.9375rem !important;\n  }\n  .x5-ms-xxl-n3,\n  .x5-mx-xxl-n3 {\n    margin-left: -0.9375rem !important;\n  }\n  .x5-me-xxl-n4,\n  .x5-mx-xxl-n4 {\n    margin-right: -1.5625rem !important;\n  }\n  .x5-ms-xxl-n4,\n  .x5-mx-xxl-n4 {\n    margin-left: -1.5625rem !important;\n  }\n  .x5-me-xxl-n5,\n  .x5-mx-xxl-n5 {\n    margin-right: -1.875rem !important;\n  }\n  .x5-ms-xxl-n5,\n  .x5-mx-xxl-n5 {\n    margin-left: -1.875rem !important;\n  }\n  .x5-me-xxl-n6,\n  .x5-mx-xxl-n6 {\n    margin-right: -2.5rem !important;\n  }\n  .x5-ms-xxl-n6,\n  .x5-mx-xxl-n6 {\n    margin-left: -2.5rem !important;\n  }\n  .x5-me-xxl-n7,\n  .x5-mx-xxl-n7 {\n    margin-right: -2.8125rem !important;\n  }\n  .x5-ms-xxl-n7,\n  .x5-mx-xxl-n7 {\n    margin-left: -2.8125rem !important;\n  }\n  .x5-me-xxl-n8,\n  .x5-mx-xxl-n8 {\n    margin-right: -3.75rem !important;\n  }\n  .x5-ms-xxl-n8,\n  .x5-mx-xxl-n8 {\n    margin-left: -3.75rem !important;\n  }\n}\n.absolute-fill, .overlay::before {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n\n.overlay {\n  position: relative;\n}\n.overlay::before {\n  content: \"\";\n  z-index: 1;\n}\n.overlay .container {\n  z-index: 2;\n  position: relative;\n}\n\n.overlay-scrim {\n  --overlay-angle: to bottom;\n  --overlay-color: 17, 17, 17;\n  --overlay-opacity: 0.7;\n  --overlay-end-color: var(--overlay-color);\n  --overlay-end-opacity: 0;\n}\n.overlay-scrim::before {\n  background-image: linear-gradient(var(--overlay-angle), rgba(var(--overlay-color), var(--overlay-opacity)) 0%, rgba(var(--overlay-end-color), var(--overlay-end-opacity)) 100%);\n}\n\n.overlay-solid {\n  --overlay-color: 35, 35, 35;\n  --overlay-opacity: 0.8;\n}\n.overlay-solid::before {\n  background-color: rgba(var(--overlay-color), var(--overlay-opacity));\n}\n\n.overlay-scrim-left {\n  --overlay-angle: to right;\n}\n\n.overlay-scrim-right {\n  --overlay-angle: to left;\n}\n\n.overlay-scrim-top {\n  --overlay-angle: to bottom;\n}\n\n.overlay-scrim-bottom {\n  --overlay-angle: to top;\n}\n\n.overlay-scrim-top-left {\n  --overlay-angle: to bottom right;\n}\n\n.overlay-scrim-top-right {\n  --overlay-angle: to bottom left;\n}\n\n.overlay-scrim-bottom-right {\n  --overlay-angle: to top left;\n}\n\n.overlay-scrim-bottom-left {\n  --overlay-angle: to top right;\n}\n\n.overlay-dark {\n  --overlay-color: 17, 17, 17;\n}\n\n.overlay-blue {\n  --overlay-color: 46, 16, 164;\n}\n\n.overlay-green {\n  --overlay-color: 0, 96, 0;\n}\n\n.overlay-light {\n  --overlay-color: 242, 242, 242;\n}\n\n.overlay-opacity-100 {\n  --overlay-opacity: 1;\n}\n\n.overlay-opacity-90 {\n  --overlay-opacity: 0.9;\n}\n\n.overlay-opacity-80 {\n  --overlay-opacity: 0.8;\n}\n\n.overlay-opacity-70 {\n  --overlay-opacity: 0.7;\n}\n\n.overlay-opacity-60 {\n  --overlay-opacity: 0.6;\n}\n\n.overlay-opacity-50 {\n  --overlay-opacity: 0.5;\n}\n\n.overlay-opacity-40 {\n  --overlay-opacity: 0.4;\n}\n\n.overlay-opacity-30 {\n  --overlay-opacity: 0.3;\n}\n\n.overlay-opacity-20 {\n  --overlay-opacity: 0.2;\n}\n\n.overlay-opacity-10 {\n  --overlay-opacity: 0.1;\n}\n\n.overlay-scrim-light-blue::before {\n  background-image: linear-gradient(to bottom, rgba(200, 201, 255, 0.8), rgba(227, 248, 255, 0.8));\n}\n\n.overlay-primary {\n  --overlay-color: 255, 255, 255;\n}\n.dark .overlay-primary {\n  --overlay-color: 0, 0, 0;\n}\n\n.toast:not(.toast-light) .btn-close,\n.dark .toast-light .btn-close,\n.dark .card .btn-close,\n.dark .alert:not([class*=alert-solid-]) .btn-close {\n  filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n.btn-close-inline {\n  background: none;\n  color: #111111;\n  padding: 0;\n  opacity: 0.5;\n  border: 1px solid transparent;\n}\n.btn-close-inline:hover {\n  color: #111111;\n  text-decoration: none;\n  opacity: 0.8;\n}\n.btn-close-inline:focus {\n  outline: 0;\n  box-shadow: none;\n}\n.btn-close-inline:focus-visible {\n  border-color: #304ffe;\n}\n.btn-close-inline:disabled, .btn-close-inline.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: 0.25;\n}\n\n.dark .btn-close-inline {\n  color: #fff;\n}\n\n.alert {\n  --bs-alert-color: #111111;\n  --bs-alert-link-color: #111111;\n  font-weight: 300;\n  display: flex;\n}\n.alert > svg {\n  color: var(--bs-alert-icon-color);\n  flex-shrink: 0;\n  margin: 0.125rem 0.5rem 0 -0.5625rem;\n}\n.alert p {\n  opacity: 0.8;\n}\n.alert p:last-child {\n  margin-bottom: 0;\n}\n.alert .link-border {\n  background-image: linear-gradient(to right, rgba(17, 17, 17, 0.3) 0%, rgba(17, 17, 17, 0.3) 100%);\n}\n.alert .link-border:hover {\n  background-image: linear-gradient(to right, #111111 0%, #111111 100%);\n}\n\n.alert > svg.text-default,\n[class*=alert-solid-] > svg {\n  opacity: 0.8;\n}\n\n.alert-heading {\n  font-size: 1.125rem;\n  line-height: 1.7777777778;\n  margin-bottom: 0.5rem;\n}\n\n.alert-dismissible {\n  padding-right: 3.1875rem;\n}\n.alert-dismissible .btn-close {\n  width: 1.75rem;\n  height: 1.75rem;\n  background-position: 60% center;\n  padding: 0.5rem 0.6875rem 0.5rem 1rem;\n  opacity: 0.8;\n}\n.alert-dismissible .btn-close:hover, .alert-dismissible .btn-close:focus {\n  box-shadow: none;\n  opacity: 1;\n}\n\n.alert-lg {\n  padding: 1.25rem 1.875rem;\n}\n.alert-lg.alert-dismissible {\n  padding-right: 3.6875rem;\n}\n.alert-lg > svg {\n  margin-top: 0;\n  margin-left: -15px;\n}\n.alert-lg .btn-close {\n  width: 2rem;\n  height: 2rem;\n  background-size: 2rem;\n}\n\n.alert-success {\n  --bs-alert-icon-color: #15ad5c;\n}\n\n.alert-info {\n  --bs-alert-icon-color: #218dcc;\n}\n\n.alert-warning {\n  --bs-alert-icon-color: #ffc000;\n}\n\n.alert-danger {\n  --bs-alert-icon-color: #e64949;\n}\n\n.alert-neutral {\n  --bs-alert-bg: #fafafa;\n  --bs-alert-border-color: #cccccc;\n}\n\n[class*=alert-solid-] p {\n  opacity: 1;\n}\n\n.alert-solid-success {\n  --bs-alert-bg: #2ee68c;\n}\n\n.alert-solid-info {\n  --bs-alert-bg: #4fc3f7;\n}\n\n.alert-solid-warning {\n  --bs-alert-bg: #ffee5c;\n}\n\n.alert-solid-danger {\n  --bs-alert-bg: #ff7591;\n}\n\n.alert-solid-neutral {\n  --bs-alert-bg: rgba(17, 17, 17, 0.08);\n}\n\n.dark .alert {\n  --bs-alert-bg: #343434;\n  --bs-alert-color: #fff;\n  --bs-alert-link-color: #fff;\n}\n.dark .alert:not([class*=alert-solid-]) .link-border {\n  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.3) 100%);\n}\n.dark .alert:not([class*=alert-solid-]) .link-border:hover {\n  background-image: linear-gradient(to right, #fff 0%, #fff 100%);\n}\n.dark .alert-success {\n  --bs-alert-icon-color: #2ee68c;\n}\n.dark .alert-info {\n  --bs-alert-icon-color: #4fc3f7;\n}\n.dark .alert-warning {\n  --bs-alert-icon-color: #ffee5c;\n}\n.dark .alert-danger {\n  --bs-alert-icon-color: #ff7591;\n}\n.dark .alert-neutral {\n  --bs-alert-border-color: #575757;\n  --bs-alert-bg: #232323;\n}\n.dark [class*=alert-solid-] {\n  --bs-alert-color: #111111;\n  --bs-alert-link-color: #111111;\n}\n.dark .alert-solid-success {\n  --bs-alert-bg: #6bf0af;\n}\n.dark .alert-solid-info {\n  --bs-alert-bg: #8cdbff;\n}\n.dark .alert-solid-warning {\n  --bs-alert-bg: #fff394;\n}\n.dark .alert-solid-danger {\n  --bs-alert-bg: #ffa9bb;\n}\n.dark .alert-solid-neutral {\n  --bs-alert-color: #fff;\n  --bs-alert-bg: #4b4b4b;\n  --bs-alert-link-color: #fff;\n}\n.dark .alert-solid-neutral .btn-close {\n  filter: invert(1) grayscale(100%) brightness(200%);\n}\n.dark .alert-solid-neutral .link-border {\n  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.3) 100%);\n}\n.dark .alert-solid-neutral .link-border:hover {\n  background-image: linear-gradient(to right, #fff 0%, #fff 100%);\n}\n\n.avatar-inner {\n  width: 40px;\n  height: 40px;\n  background-color: #e8e8e8;\n  font-size: 0.8125rem;\n  letter-spacing: 0.9px;\n  color: rgba(17, 17, 17, 0.84);\n  box-shadow: 0 0 0 1px transparent, 0 0 0 3px transparent;\n  transition: box-shadow 0.15s ease-in-out, color 0.15s ease-in-out, background-color 0.15s ease-in-out;\n}\n.avatar-inner svg {\n  color: #111111;\n}\n\n.avatar-label {\n  position: relative;\n  font-size: 0.9375rem;\n  line-height: 1.3333333333;\n  color: var(--avatar-label-color);\n  transition: color 0.15s ease-in-out;\n}\n.avatar-label::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 0.0625rem;\n  width: 100%;\n  background-color: transparent;\n  transition: background-color 0.15s ease-in-out;\n}\n\n.avatar-label-prefix {\n  margin-right: 0.9375rem;\n}\n\n.avatar-label-suffix {\n  margin-left: 0.9375rem;\n}\n\n.avatar-arrow {\n  color: #111;\n  opacity: 0.54;\n  margin-left: 0.4375rem;\n}\n\n.avatar {\n  --avatar-inner-shadow-color: #fff;\n  --avatar-hover-shadow-color: #dedede;\n  --avatar-active-shadow-color: #111111;\n  --avatar-label-color: rgba(17, 17, 17, 0.64);\n  --avatar-hover-label-color: #111111;\n  --avatar-hover-label-border: #111111;\n  --avatar-active-label-color: rgba(17, 17, 17, 0.92);\n  --avatar-active-label-border: #a1a1a1;\n  --avatar-focus-label-color: rgba(17, 17, 17, 0.64);\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n  text-decoration: none !important;\n  border: none;\n  background-color: transparent;\n  padding: 0;\n  user-select: none;\n  transition: border-color 0.15s ease-in-out;\n}\n.avatar.dropdown-toggle + .dropdown-menu {\n  margin-top: 3px;\n}\n\n.avatar-action:hover .avatar-inner {\n  box-shadow: 0 0 0 1px var(--avatar-inner-shadow-color), 0 0 0 3px var(--avatar-hover-shadow-color);\n}\n.avatar-action:hover .avatar-label {\n  color: var(--avatar-hover-label-color);\n}\n.avatar-action:hover .avatar-label::after {\n  background-color: var(--avatar-hover-label-border);\n}\n.avatar-action:hover .avatar-arrow {\n  opacity: 0.9;\n}\n.avatar-action:active .avatar-inner,\n.avatar-action .active .avatar-inner, .dropdown.show > .avatar-action .avatar-inner {\n  box-shadow: 0 0 0 1px var(--avatar-inner-shadow-color), 0 0 0 3px var(--avatar-active-shadow-color);\n}\n.avatar-action:active .avatar-label,\n.avatar-action .active .avatar-label, .dropdown.show > .avatar-action .avatar-label {\n  color: var(--avatar-active-label-color);\n}\n.avatar-action:active .avatar-label::after,\n.avatar-action .active .avatar-label::after, .dropdown.show > .avatar-action .avatar-label::after {\n  background-color: var(--avatar-active-label-border);\n}\n.avatar-action:active .avatar-arrow,\n.avatar-action .active .avatar-arrow, .dropdown.show > .avatar-action .avatar-arrow {\n  opacity: 0.8;\n}\n.avatar-action:focus-visible {\n  outline: 0;\n}\n.avatar-action:focus-visible .avatar-inner {\n  box-shadow: 0 0 0 1px var(--avatar-inner-shadow-color), 0 0 0 2px #304ffe;\n}\n.avatar-action:focus-visible .avatar-label {\n  color: var(--avatar-focus-label-color);\n}\n.avatar-action:focus-visible .avatar-label::after {\n  background-color: #304ffe;\n}\n.avatar-action:focus-visible .avatar-arrow {\n  opacity: 0.56;\n}\n\n.avatar-pill {\n  --avatar-pill-background-color: #fff;\n  --avatar-pill-hover-background-color: #111111;\n  --avatar-pill-hover-label-color: #fff;\n  --avatar-pill-active-background-color: #f2f2f2;\n  --avatar-pill-active-border-color: #111111;\n  --avatar-pill-active-label-color: rgba(17, 17, 17, 0.84);\n  --avatar-pill-active-arrow-color: #111111;\n  --avatar-pill-hover-arrow-color: #fff;\n  --avatar-pill-hover-inner-background-color: #343434;\n  --avatar-pill-hover-border-color: #404040;\n  --avatar-pill-hover-inner-color: rgba(255, 255, 255, 0.92);\n  --avatar-pill-active-inner-border-color: #fff;\n  --avatar-pill-active-inner-background-color: #e8e8e8;\n  --avatar-pill-active-inner-color: rgba(17, 17, 17, 0.84);\n  --avatar-pill-hover-notification-border-color: #111111;\n  --avatar-pill-hover-notification-background-color: #ededed;\n  --avatar-pill-hover-notification-color: #111111;\n  background-color: var(--avatar-pill-background-color);\n  border-radius: 0.3125rem;\n  border: 1px solid transparent;\n  padding: 0.4375rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n.avatar-pill .avatar-inner {\n  width: 32px;\n  height: 32px;\n  font-size: 0.75rem;\n}\n.avatar-pill .avatar-label-prefix {\n  margin-left: 0.4375rem;\n}\n.avatar-pill .avatar-label-suffix {\n  margin-right: 0.4375rem;\n}\n.avatar-pill .avatar-arrow {\n  margin-right: 0.5rem;\n}\n.avatar-pill.avatar-sm .avatar-inner {\n  width: 24px;\n  height: 24px;\n  font-size: 0.6875rem;\n}\n.avatar-pill.avatar-sm .avatar-label-prefix {\n  margin: 0 0.75rem 0 0.3125rem;\n}\n.avatar-pill.avatar-sm .avatar-label-suffix {\n  margin: 0 0.3125rem 0 0.75rem;\n}\n.avatar-pill.avatar-sm .avatar-arrow {\n  margin-right: 0.1875rem;\n}\n.avatar-pill.avatar-sm .avatar-notification {\n  width: auto;\n  height: 18px;\n  padding: 0 0.239375rem;\n  margin-top: -0.5rem;\n  margin-right: -0.375rem;\n}\n.avatar-pill.avatar-xs {\n  padding: 0.1875rem;\n}\n.avatar-pill.avatar-xs .avatar-label-prefix {\n  margin: 0 0.625rem 0 0.4375rem;\n}\n.avatar-pill.avatar-xs .avatar-label-suffix {\n  margin: 0 0.4375rem 0 0.625rem;\n}\n.avatar-pill.avatar-xs .avatar-arrow {\n  margin-right: 0.1875rem;\n}\n.avatar-pill.avatar-xs .avatar-notification {\n  width: 12px;\n  height: 12px;\n  padding: 0;\n  margin-top: -0.125rem;\n  margin-right: -0.125rem;\n}\n.dropdown > .avatar-pill .avatar-label-suffix {\n  margin-right: 0;\n}\n.avatar-pill .avatar-label::after {\n  content: none;\n}\n.avatar-pill:hover {\n  background-color: var(--avatar-pill-hover-background-color);\n}\n.avatar-pill:hover .avatar-inner {\n  background-color: var(--avatar-pill-hover-inner-background-color);\n  color: var(--avatar-pill-hover-inner-color);\n}\n.avatar-pill:hover .avatar-label {\n  color: var(--avatar-pill-hover-label-color);\n}\n.avatar-pill:hover:not(:active) .avatar-inner {\n  box-shadow: 0 0 0 1px var(--avatar-pill-hover-background-color), 0 0 0 3px var(--avatar-pill-hover-border-color);\n}\n.avatar-pill:hover:not(:active) .avatar-notification {\n  border-color: var(--avatar-pill-hover-notification-border-color);\n  background-color: var(--avatar-pill-hover-notification-background-color);\n  color: var(--avatar-pill-hover-notification-color);\n}\n.avatar-pill:hover .avatar-arrow {\n  color: var(--avatar-pill-hover-arrow-color);\n}\n.avatar-pill:active,\n.avatar-pill .active, .dropdown.show > .avatar-pill {\n  background-color: var(--avatar-pill-active-background-color);\n}\n.avatar-pill:active .avatar-inner,\n.avatar-pill .active .avatar-inner, .dropdown.show > .avatar-pill .avatar-inner {\n  background-color: var(--avatar-pill-active-inner-background-color);\n  color: var(--avatar-pill-active-inner-color);\n}\n.avatar-pill:active .avatar-label,\n.avatar-pill .active .avatar-label, .dropdown.show > .avatar-pill .avatar-label {\n  color: var(--avatar-pill-active-label-color);\n}\n.avatar-pill:active .avatar-arrow,\n.avatar-pill .active .avatar-arrow, .dropdown.show > .avatar-pill .avatar-arrow {\n  color: var(--avatar-pill-active-arrow-color);\n}\n.avatar-pill:focus-visible {\n  border-color: #304ffe;\n}\n\n.avatar-lg .avatar-inner {\n  width: 48px;\n  height: 48px;\n  font-size: 0.875rem;\n  letter-spacing: 0.8px;\n}\n.avatar-lg .avatar-online {\n  margin-right: -2px;\n  margin-bottom: -2px;\n}\n\n.avatar-sm .avatar-inner {\n  width: 32px;\n  height: 32px;\n  font-size: 0.75rem;\n  line-height: 1.5833333333;\n}\n.avatar-sm .avatar-online {\n  margin-right: -2px;\n  margin-bottom: -2px;\n}\n.avatar-sm .avatar-label {\n  font-size: 0.875rem;\n  line-height: 1.4285714286;\n}\n.avatar-sm .avatar-label-prefix {\n  margin-right: 0.5625rem;\n}\n.avatar-sm .avatar-label-suffix {\n  margin-left: 0.5625rem;\n}\n.avatar-sm .avatar-notification {\n  margin-top: -0.5625rem;\n  margin-right: -0.5625rem;\n}\n\n.avatar-xs .avatar-inner {\n  width: 24px;\n  height: 24px;\n  font-size: 0.6875rem;\n  letter-spacing: 1px;\n}\n.avatar-xs .avatar-online {\n  width: 12px;\n  height: 12px;\n  margin-right: -2px;\n  margin-bottom: -2px;\n}\n.avatar-xs .avatar-label {\n  font-size: 0.8125rem;\n  line-height: 1.4615384615;\n}\n.avatar-xs .avatar-label-prefix {\n  margin-right: 0.4375rem;\n}\n.avatar-xs .avatar-label-suffix {\n  margin-left: 0.4375rem;\n}\n.avatar-xs .avatar-notification {\n  width: auto;\n  height: 18px;\n  padding: 0 0.239375rem;\n  margin-top: -0.3125rem;\n  margin-right: -0.3125rem;\n}\n\n.avatar-light-color {\n  background-color: #ece5f6;\n}\n.avatar-light-color,\n.avatar-light-color svg {\n  color: #000099;\n}\n\n.avatar-solid {\n  background-color: #111111;\n  color: rgba(255, 255, 255, 0.84);\n}\n.avatar-solid svg {\n  color: #fff;\n}\n\n.avatar-solid-color {\n  background-color: #000099;\n  color: rgba(255, 255, 255, 0.84);\n}\n.avatar-solid-color svg {\n  color: #fff;\n}\n\n.avatar-notification {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 22px;\n  height: 22px;\n  padding: 0 0.37625rem;\n  background-color: #111111;\n  color: #fff;\n  border-radius: var(--bs-border-radius-pill);\n  font-size: 0.5625rem;\n  line-height: 1.1111111111;\n  margin-top: -0.4375rem;\n  margin-right: -0.4375rem;\n  transition: border-color 0.15s ease-in-out, color 0.15s ease-in-out, background-color 0.15s ease-in-out;\n}\n.avatar-notification.position-absolute {\n  border: 2px solid #fff;\n}\n\n.avatar-online {\n  width: 14px;\n  height: 14px;\n  background-color: #15ad5c;\n  border-radius: var(--bs-border-radius-pill);\n  background-image: none !important;\n  margin-right: -1px;\n  margin-bottom: -1px;\n}\n.avatar-online.position-absolute {\n  border: 2px solid #fff;\n}\n\n.dark .avatar-inner {\n  background-color: #343434;\n  color: rgba(255, 255, 255, 0.92);\n}\n.dark .avatar-inner svg {\n  color: rgba(255, 255, 255, 0.9);\n}\n.dark .avatar-arrow {\n  color: #fff;\n}\n.dark .avatar {\n  --avatar-inner-shadow-color: #111111;\n  --avatar-hover-shadow-color: #404040;\n  --avatar-active-shadow-color: #dedede;\n  --avatar-label-color: rgba(255, 255, 255, 0.64);\n  --avatar-hover-label-color: #fff;\n  --avatar-hover-label-border: #cccccc;\n  --avatar-active-label-color: rgba(255, 255, 255, 0.92);\n  --avatar-active-label-border: #808080;\n  --avatar-focus-label-color: rgba(255, 255, 255, 0.64);\n}\n.dark .avatar-pill {\n  --avatar-pill-background-color: #111111;\n  --avatar-pill-hover-background-color: #fff;\n  --avatar-pill-hover-label-color: #111111;\n  --avatar-pill-active-background-color: #232323;\n  --avatar-pill-active-arrow-color: #fff;\n  --avatar-pill-active-label-color: #fff;\n  --avatar-pill-active-border-color: #dedede;\n  --avatar-pill-hover-arrow-color: #111111;\n  --avatar-pill-hover-inner-background-color: #e8e8e8;\n  --avatar-pill-hover-border-color: #dedede;\n  --avatar-pill-hover-inner-color: rgba(17, 17, 17, 0.84);\n  --avatar-pill-active-inner-border-color: #111111;\n  --avatar-pill-active-inner-background-color: #343434;\n  --avatar-pill-active-inner-color: rgba(255, 255, 255, 0.92);\n  --avatar-pill-hover-notification-border-color: #fff;\n  --avatar-pill-hover-notification-background-color: #111111;\n  --avatar-pill-hover-notification-color: #fff;\n}\n.dark .avatar-light-color {\n  background-color: #000099;\n}\n.dark .avatar-solid {\n  background-color: #f2f2f2;\n  color: rgba(17, 17, 17, 0.92);\n}\n.dark .avatar-solid svg {\n  color: #111111;\n}\n.dark .avatar-solid-color {\n  background-color: #ad93db;\n}\n.dark .avatar-solid-color,\n.dark .avatar-solid-color svg {\n  color: #000099;\n}\n.dark .avatar-notification {\n  background-color: #fff;\n  border-color: #111111;\n  color: #111111;\n}\n\n.badge {\n  text-decoration: none;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  line-height: 1.9;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.badge.rounded-pill {\n  padding: 0.3em 1.2em;\n}\n.badge > svg:first-child {\n  margin: 0 0.4em 0 -0.4em;\n}\n\nh1 .badge, .h1 .badge,\nh2 .badge,\n.h2 .badge,\nh3 .badge,\n.h3 .badge,\nh4 .badge,\n.h4 .badge,\nh5 .badge,\n.h5 .badge,\nh6 .badge,\n.h6 .badge {\n  font-weight: 300;\n  font-size: 75%;\n  letter-spacing: 0.5px;\n  line-height: 1.25;\n  padding: 0.25em 0.4em;\n  text-transform: none;\n}\n\n.nav-link .badge {\n  font-weight: 400;\n  padding: 0.33333em 0.7em;\n}\n\n.badge.bg-light {\n  background-color: #ededed !important;\n}\n.badge.bg-neutral {\n  background-color: var(--badge-neutral-bg) !important;\n  color: var(--badge-neutral-color);\n}\n.badge.bg-neutral-subtle {\n  background-color: var(--badge-neutral-subtle-bg) !important;\n  border-color: var(--badge-neutral-subtle-border-color);\n}\n.badge.bg-danger-subtle {\n  background-color: var(--badge-danger-subtle-bg) !important;\n  border-color: var(--badge-danger-subtle-border-color);\n}\n.badge.bg-success-subtle {\n  background-color: var(--badge-success-subtle-bg) !important;\n  border-color: var(--badge-success-subtle-border-color);\n}\n.badge.bg-warning-subtle {\n  background-color: var(--badge-warning-subtle-bg) !important;\n  border-color: var(--badge-warning-subtle-border-color);\n}\n.badge.bg-info-subtle {\n  background-color: var(--badge-info-subtle-bg) !important;\n  border-color: var(--badge-info-subtle-border-color);\n}\n.badge[class*=-subtle] {\n  color: var(--badge-subtle-color);\n}\n\n:root,\n[data-bs-theme=light],\n.light {\n  --badge-neutral-bg: #111111;\n  --badge-neutral-color: #fff;\n  --badge-neutral-subtle-bg: #ededed;\n  --badge-neutral-subtle-border-color: transparent;\n  --badge-danger-subtle-bg: var(--bs-danger-bg-subtle);\n  --badge-danger-subtle-border-color: transparent;\n  --badge-success-subtle-bg: var(--bs-success-bg-subtle);\n  --badge-success-subtle-border-color: transparent;\n  --badge-warning-subtle-bg: var(--bs-warning-bg-subtle);\n  --badge-warning-subtle-border-color: transparent;\n  --badge-info-subtle-bg: var(--bs-info-bg-subtle);\n  --badge-info-subtle-border-color: transparent;\n  --badge-subtle-color: #111111;\n}\n\n[data-bs-theme=dark],\n.dark {\n  --badge-neutral-bg: #fcfcfc;\n  --badge-neutral-color: #111111;\n  --badge-neutral-subtle-bg: #343434;\n  --badge-neutral-subtle-border-color: #878787;\n  --badge-danger-subtle-bg: #343434;\n  --badge-danger-subtle-border-color: #c34b63;\n  --badge-success-subtle-bg: #343434;\n  --badge-success-subtle-border-color: #24a365;\n  --badge-warning-subtle-bg: #343434;\n  --badge-warning-subtle-border-color: #c4b63f;\n  --badge-info-subtle-bg: #343434;\n  --badge-info-subtle-border-color: #3789ad;\n  --badge-subtle-color: #fff;\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid transparent;\n  margin: 0.125rem;\n  border-radius: 50em;\n  color: #111111;\n  overflow: hidden;\n}\n\n.chip-label {\n  font-size: 0.625rem;\n  padding: 0.1875rem 0 0.1875rem 0.75rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-transform: uppercase;\n  line-height: 1.9;\n  letter-spacing: 1px;\n}\n\n.chip-icon-prefix {\n  color: var(--chip-icon-color);\n  margin: 0 0.125rem 0 0.375rem;\n}\n.chip-icon-prefix + .chip-label {\n  padding-left: 0;\n}\n\n.chip-remove {\n  display: flex;\n  padding: 0.1875rem;\n  color: unset !important;\n}\n\n.chip-success,\n.chip-bordered-success {\n  --chip-icon-color: #15ad5c;\n  background: #e6fff2;\n}\n\n.chip-info,\n.chip-bordered-info {\n  --chip-icon-color: #218dcc;\n  background: #ecfafe;\n}\n\n.chip-warning,\n.chip-bordered-warning {\n  --chip-icon-color: #ffc000;\n  background: #fffff0;\n}\n\n.chip-danger,\n.chip-bordered-danger {\n  --chip-icon-color: #e64949;\n  background: #ffedf0;\n}\n\n.chip-neutral {\n  background: #ededed;\n}\n\n.chip-bordered-success {\n  border-color: #2ee68c;\n}\n\n.chip-bordered-info {\n  border-color: #4fc3f7;\n}\n\n.chip-bordered-warning {\n  border-color: #ffee5c;\n}\n\n.chip-bordered-danger {\n  border-color: #ff7591;\n}\n\n.chip-bordered-neutral {\n  border-color: #dedede;\n}\n\n.chip-solid-success {\n  background: #2ee68c;\n}\n\n.chip-solid-info {\n  background: #4fc3f7;\n}\n\n.chip-solid-warning {\n  background: #ffee5c;\n}\n\n.chip-solid-danger {\n  background: #ff7591;\n}\n\n.chip-solid-neutral {\n  background: #111111;\n  color: #fff;\n}\n\n.dark .chip-success,\n.dark .chip-bordered-success,\n.dark .chip-info,\n.dark .chip-bordered-info,\n.dark .chip-warning,\n.dark .chip-bordered-warning,\n.dark .chip-danger,\n.dark .chip-bordered-danger,\n.dark .chip-neutral,\n.dark .chip-bordered-neutral {\n  background-color: #343434;\n  color: #fff;\n}\n.dark .chip-success,\n.dark .chip-bordered-success {\n  --chip-icon-color: #2ee68c;\n  border-color: #24a365;\n}\n.dark .chip-info,\n.dark .chip-bordered-info {\n  --chip-icon-color: #4fc3f7;\n  border-color: #3789ad;\n}\n.dark .chip-warning,\n.dark .chip-bordered-warning {\n  --chip-icon-color: #ffee5c;\n  border-color: #c4b63f;\n}\n.dark .chip-danger,\n.dark .chip-bordered-danger {\n  --chip-icon-color: #ff7591;\n  border-color: #c34b63;\n}\n.dark .chip-neutral,\n.dark .chip-bordered-neutral {\n  border-color: #878787;\n}\n.dark .chip-solid-success {\n  background: #6bf0af;\n}\n.dark .chip-solid-info {\n  background: #8cdbff;\n}\n.dark .chip-solid-warning {\n  background: #fff394;\n}\n.dark .chip-solid-danger {\n  background: #ffa9bb;\n}\n.dark .chip-solid-neutral {\n  background: #fcfcfc;\n  color: #111111;\n}\n\n.notification-badge {\n  display: inline-flex;\n  align-items: center;\n  font-size: 0.75rem;\n  line-height: 1.5833333333;\n  padding: 0.3125rem 0.5rem 0.3125rem 0.75rem;\n  letter-spacing: 0.2px;\n  border-radius: 50rem;\n  color: #111111;\n  background-color: #ededed;\n}\n\n.notification-badge-counter {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 1.125rem;\n  height: 18px;\n  line-height: 0;\n  font-size: 0.5625rem;\n  padding: 0 0.375rem;\n  margin-left: 0.3125rem;\n  border-radius: var(--bs-border-radius-pill);\n  color: #111111;\n}\n\n.notification-badge-counter-neutral {\n  background-color: #111111;\n  color: #fff;\n}\n\n.notification-badge-dark {\n  background-color: #111111;\n  color: #fff;\n}\n.notification-badge-dark .notification-badge-counter-neutral {\n  background-color: #ededed;\n  color: #111111;\n}\n\n.dark .notification-badge {\n  background-color: #343434;\n  color: #fff;\n}\n.dark .notification-badge .notification-badge-counter-neutral {\n  background-color: #ededed;\n  color: #111111;\n}\n.dark .notification-badge-dark {\n  background-color: #fcfcfc;\n  color: #111111;\n}\n.dark .notification-badge-dark .notification-badge-counter-neutral {\n  background-color: #111111;\n  color: #fff;\n}\n\n.breadcrumb {\n  align-items: center;\n}\n.breadcrumb a {\n  display: flex;\n  align-items: center;\n  color: #111111;\n  opacity: 0.64;\n}\n.breadcrumb a:hover {\n  opacity: 1;\n}\n.breadcrumb svg:first-child:not(:only-child) {\n  margin-right: 0.375rem;\n}\n\n.breadcrumb-item {\n  display: flex;\n  align-items: center;\n}\n\n.breadcrumb-slash {\n  --bs-breadcrumb-divider: \"/\";\n  --bs-breadcrumb-divider-color: rgba(17, 17, 17, 0.4);\n}\n.breadcrumb-slash .breadcrumb-item + .breadcrumb-item::before {\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.dark .breadcrumb {\n  --bs-breadcrumb-item-active-color: rgba(255, 255, 255, 0.4);\n}\n.dark .breadcrumb:not(.breadcrumb-slash) {\n  --bs-breadcrumb-divider: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"9\" height=\"9\"%3e%3cpath fill=\"none\" stroke=\"%23fff\" stroke-linecap=\"square\" d=\"m2.8 1 3.5 3.5L2.8 8\" opacity=\".4\"/%3e%3c/svg%3e');\n}\n.dark .breadcrumb a,\n.dark .breadcrumb a:hover {\n  color: #fff;\n}\n.dark .breadcrumb-slash {\n  --bs-breadcrumb-divider-color: rgba(255, 255, 255, 0.4);\n}\n\n.btn:has(svg) {\n  align-items: center;\n  display: inline-flex;\n}\n.btn.text-uppercase {\n  letter-spacing: 0.7px;\n}\n.btn:disabled, .btn.disabled {\n  pointer-events: all;\n  cursor: not-allowed;\n}\n\n.btn-xs, .btn-group-xs > .btn {\n  --bs-btn-padding-y: 0.125rem;\n  --bs-btn-padding-x: 0.9375rem;\n  --bs-btn-font-size: 0.75rem;\n  --bs-btn-border-radius: 0.3125rem;\n  letter-spacing: 0.2px;\n  line-height: 1.4375rem;\n}\n\n.btn-sm, .btn-group-sm > .btn,\n.input-group-sm > .btn {\n  line-height: 1.5rem;\n}\n\n.btn-lg, .btn-group-lg > .btn,\n.input-group-lg > .btn {\n  line-height: 1.75rem;\n}\n\n.btn-xl, .btn-group-xl > .btn {\n  --bs-btn-padding-y: 0.625rem;\n  --bs-btn-padding-x: 1.875rem;\n  --bs-btn-font-size: 1rem;\n  --bs-btn-border-radius: 0.3125rem;\n  line-height: 2.125rem;\n  letter-spacing: 0.05px;\n}\n\n.btn svg {\n  opacity: 0.5;\n  transition: color 0.15s ease-in-out, opacity 0.15s ease-in-out;\n  color: var(--bs-btn-icon-color);\n}\n.btn:hover svg {\n  opacity: 0.9;\n}\n.btn:active svg, .btn.active svg {\n  opacity: 0.6;\n}\n\n.btn-icon-prefix {\n  margin-right: 0.375rem;\n  margin-left: -0.625rem;\n}\n\n.btn-icon-suffix {\n  margin-left: 0.375rem;\n  margin-right: -0.625rem;\n}\n\n.btn-xl .btn-icon-prefix, .btn-group-xl > .btn .btn-icon-prefix {\n  margin-right: 0.5rem;\n  margin-left: -1.125rem;\n}\n.btn-xl .btn-icon-suffix, .btn-group-xl > .btn .btn-icon-suffix {\n  margin-left: 0.5rem;\n  margin-right: -1.125rem;\n}\n\n.btn-lg .btn-icon-prefix, .btn-group-lg > .btn .btn-icon-prefix {\n  margin-right: 0.5rem;\n  margin-left: -0.8125rem;\n}\n.btn-lg .btn-icon-suffix, .btn-group-lg > .btn .btn-icon-suffix {\n  margin-left: 0.5rem;\n  margin-right: -0.8125rem;\n}\n\n.btn-sm .btn-icon-prefix, .btn-group-sm > .btn .btn-icon-prefix {\n  margin-right: 0.5rem;\n  margin-left: -0.5rem;\n}\n.btn-sm .btn-icon-suffix, .btn-group-sm > .btn .btn-icon-suffix {\n  margin-left: 0.5rem;\n  margin-right: -0.5rem;\n}\n\n.btn-xs .btn-icon-prefix, .btn-group-xs > .btn .btn-icon-prefix {\n  margin-right: 0.375rem;\n  margin-left: -0.4375rem;\n}\n.btn-xs .btn-icon-suffix, .btn-group-xs > .btn .btn-icon-suffix {\n  margin-left: 0.375rem;\n  margin-right: -0.4375rem;\n}\n\n.btn-link:not(.btn) .btn-icon-prefix, .btn-brand-quartenary:not(.btn) .btn-icon-prefix,\n.btn-darker-quartenary:not(.btn) .btn-icon-prefix,\n.btn-standard-quartenary:not(.btn) .btn-icon-prefix {\n  margin-left: 0;\n}\n.btn-link:not(.btn) .btn-icon-suffix, .btn-brand-quartenary:not(.btn) .btn-icon-suffix,\n.btn-darker-quartenary:not(.btn) .btn-icon-suffix,\n.btn-standard-quartenary:not(.btn) .btn-icon-suffix {\n  margin-right: 0;\n}\n\n.btn-square {\n  padding: 0 !important;\n  position: relative;\n  width: 2.5rem;\n  height: 2.5rem;\n}\n.btn-square.btn-xl, .btn-group-xl > .btn-square.btn {\n  width: 3.375rem;\n  height: 3.375rem;\n}\n.btn-square.btn-lg, .btn-group-lg > .btn-square.btn, .input-group-lg > .btn-square {\n  width: 2.875rem;\n  height: 2.875rem;\n}\n.btn-square.btn-sm, .btn-group-sm > .btn-square.btn, .input-group-sm > .btn-square {\n  width: 2.25rem;\n  height: 2.25rem;\n}\n.btn-square.btn-xs, .btn-group-xs > .btn-square.btn {\n  width: 1.8125rem;\n  height: 1.8125rem;\n}\n\n.btn-success,\n.btn-info,\n.btn-warning,\n.btn-danger {\n  color: #111111;\n}\n.btn-success:hover,\n.btn-info:hover,\n.btn-warning:hover,\n.btn-danger:hover {\n  color: #000;\n}\n\n.btn-brand-primary {\n  --bs-btn-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-bg: #007f00;\n  --bs-btn-border-color: #007f00;\n  --bs-btn-icon-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #004f00;\n  --bs-btn-hover-border-color: #004f00;\n  --bs-btn-active-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-active-bg: #006600;\n  --bs-btn-active-border-color: #006600;\n  --bs-btn-focus-box-shadow: 0 3px 4px 0 rgba(17, 17, 17, 0.22);\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-disabled-bg: #b2d8b2;\n  --bs-btn-disabled-border-color: #b2d8b2;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .btn-brand-primary, .btn-brand-primary:focus-visible {\n  --bs-btn-hover-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-hover-bg: #007f00;\n  --bs-btn-hover-border-color: #007f00;\n}\n\n.btn-brand-secondary {\n  --bs-btn-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: rgba(0, 127, 0, 0.4);\n  --bs-btn-icon-color: #111111;\n  --bs-btn-hover-color: #111111;\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: #004f00;\n  --bs-btn-active-color: #111111;\n  --bs-btn-active-bg: transparent;\n  --bs-btn-active-border-color: #006600;\n  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;\n  --bs-btn-disabled-color: rgba(17, 17, 17, 0.5);\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #b2d8b2;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .btn-brand-secondary, .btn-brand-secondary:focus-visible {\n  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: transparent;\n}\n\n.btn-brand-tertiary {\n  --bs-btn-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: #cccccc;\n  --bs-btn-icon-color: #111111;\n  --bs-btn-hover-color: #111111;\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: #111111;\n  --bs-btn-active-color: #111111;\n  --bs-btn-active-bg: transparent;\n  --bs-btn-active-border-color: #006600;\n  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;\n  --bs-btn-disabled-color: rgba(17, 17, 17, 0.5);\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ededed;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .btn-brand-tertiary, .btn-brand-tertiary:focus-visible {\n  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: transparent;\n}\n\n.btn-primary,\n.btn-dark,\n.btn-darker-primary {\n  --bs-btn-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-bg: #343434;\n  --bs-btn-border-color: #343434;\n  --bs-btn-icon-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #111111;\n  --bs-btn-hover-border-color: #111111;\n  --bs-btn-active-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-active-bg: #232323;\n  --bs-btn-active-border-color: #232323;\n  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-disabled-bg: #a1a1a1;\n  --bs-btn-disabled-border-color: #a1a1a1;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .btn-primary, .btn-primary:focus-visible,\n.btn-check:focus-visible + .btn-dark,\n.btn-dark:focus-visible,\n.btn-check:focus-visible + .btn-darker-primary,\n.btn-darker-primary:focus-visible {\n  --bs-btn-hover-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-hover-bg: #343434;\n  --bs-btn-hover-border-color: #343434;\n}\n.btn-primary.shadow-nm-dark-up,\n.btn-dark.shadow-nm-dark-up,\n.btn-darker-primary.shadow-nm-dark-up {\n  --bs-btn-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-bg: #1d1d1d;\n  --bs-btn-border-color: #1d1d1d;\n  --bs-btn-icon-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #111111;\n  --bs-btn-hover-border-color: #111111;\n  --bs-btn-active-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-active-bg: #1d1d1d;\n  --bs-btn-active-border-color: #343434;\n  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-disabled-bg: #a1a1a1;\n  --bs-btn-disabled-border-color: #a1a1a1;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .btn-primary.shadow-nm-dark-up, .btn-primary.shadow-nm-dark-up:focus-visible,\n.btn-check:focus-visible + .btn-dark.shadow-nm-dark-up,\n.btn-dark.shadow-nm-dark-up:focus-visible,\n.btn-check:focus-visible + .btn-darker-primary.shadow-nm-dark-up,\n.btn-darker-primary.shadow-nm-dark-up:focus-visible {\n  --bs-btn-hover-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-hover-bg: #1d1d1d;\n  --bs-btn-hover-border-color: #343434;\n}\n\n.btn-secondary,\n.btn-darker-secondary {\n  --bs-btn-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-bg: #666666;\n  --bs-btn-border-color: #666666;\n  --bs-btn-icon-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #343434;\n  --bs-btn-hover-border-color: #343434;\n  --bs-btn-active-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-active-bg: #404040;\n  --bs-btn-active-border-color: #404040;\n  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-disabled-bg: #b6b6b6;\n  --bs-btn-disabled-border-color: #b6b6b6;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .btn-secondary, .btn-secondary:focus-visible,\n.btn-check:focus-visible + .btn-darker-secondary,\n.btn-darker-secondary:focus-visible {\n  --bs-btn-hover-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-hover-bg: #666666;\n  --bs-btn-hover-border-color: #666666;\n}\n\n.btn-darker-tertiary,\n.btn-darker-outline {\n  --bs-btn-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: #b6b6b6;\n  --bs-btn-icon-color: #111111;\n  --bs-btn-hover-color: #111111;\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: #111111;\n  --bs-btn-active-color: #111111;\n  --bs-btn-active-bg: transparent;\n  --bs-btn-active-border-color: #111111;\n  --bs-btn-focus-box-shadow: none;\n  --bs-btn-disabled-color: rgba(17, 17, 17, 0.5);\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #dedede;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .btn-darker-tertiary, .btn-darker-tertiary:focus-visible,\n.btn-check:focus-visible + .btn-darker-outline,\n.btn-darker-outline:focus-visible {\n  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: #304ffe;\n}\n\n.btn-standard-primary {\n  --bs-btn-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-bg: #404040;\n  --bs-btn-border-color: #404040;\n  --bs-btn-icon-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #343434;\n  --bs-btn-hover-border-color: #343434;\n  --bs-btn-active-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-active-bg: #232323;\n  --bs-btn-active-border-color: #232323;\n  --bs-btn-focus-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-disabled-bg: #a1a1a1;\n  --bs-btn-disabled-border-color: #a1a1a1;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .btn-standard-primary, .btn-standard-primary:focus-visible {\n  --bs-btn-hover-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-hover-bg: #404040;\n  --bs-btn-hover-border-color: #404040;\n}\n\n.btn-standard-secondary {\n  --bs-btn-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-bg: #ededed;\n  --bs-btn-border-color: #ededed;\n  --bs-btn-icon-color: #111111;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #666666;\n  --bs-btn-hover-border-color: #666666;\n  --bs-btn-active-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-active-bg: #767676;\n  --bs-btn-active-border-color: #767676;\n  --bs-btn-focus-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n  --bs-btn-disabled-color: rgba(17, 17, 17, 0.5);\n  --bs-btn-disabled-bg: #f2f2f2;\n  --bs-btn-disabled-border-color: #f2f2f2;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .btn-standard-secondary, .btn-standard-secondary:focus-visible {\n  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-hover-bg: #ededed;\n  --bs-btn-hover-border-color: #ededed;\n}\n.btn-standard-secondary:hover svg, .btn-standard-secondary:active svg, .btn-standard-secondary.active svg {\n  color: #fff;\n}\n\n.btn-standard-tertiary,\n.btn-standard-outline {\n  --bs-btn-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: #cccccc;\n  --bs-btn-icon-color: #111111;\n  --bs-btn-hover-color: #111111;\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: #111111;\n  --bs-btn-active-color: #111111;\n  --bs-btn-active-bg: transparent;\n  --bs-btn-active-border-color: #404040;\n  --bs-btn-focus-box-shadow: none;\n  --bs-btn-disabled-color: rgba(17, 17, 17, 0.5);\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ededed;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .btn-standard-tertiary, .btn-standard-tertiary:focus-visible,\n.btn-check:focus-visible + .btn-standard-outline,\n.btn-standard-outline:focus-visible {\n  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: #304ffe;\n}\n\n.btn-brand-quartenary,\n.btn-darker-quartenary,\n.btn-standard-quartenary {\n  --bs-btn-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-active-color: #111111;\n  --bs-btn-hover-color: #111111;\n}\n.btn-brand-quartenary svg,\n.btn-darker-quartenary svg,\n.btn-standard-quartenary svg {\n  color: #111111;\n}\n.btn-brand-quartenary.d-block,\n.btn-darker-quartenary.d-block,\n.btn-standard-quartenary.d-block {\n  display: flex !important;\n  justify-content: center;\n}\n.btn-brand-quartenary:hover, .btn-brand-quartenary:focus-visible,\n.btn-darker-quartenary:hover,\n.btn-darker-quartenary:focus-visible,\n.btn-standard-quartenary:hover,\n.btn-standard-quartenary:focus-visible {\n  text-decoration: none;\n}\n.btn-brand-quartenary:hover span,\n.btn-darker-quartenary:hover span,\n.btn-standard-quartenary:hover span {\n  background-image: linear-gradient(to right, #111111 0%, #111111 100%);\n}\n.btn-brand-quartenary.active span, .btn-brand-quartenary:active span,\n.btn-darker-quartenary.active span,\n.btn-darker-quartenary:active span,\n.btn-standard-quartenary.active span,\n.btn-standard-quartenary:active span {\n  background-image: linear-gradient(to right, rgba(17, 17, 17, 0.5) 0%, rgba(17, 17, 17, 0.5) 100%);\n}\n.btn-brand-quartenary:disabled span, .btn-brand-quartenary.disabled span,\n.btn-darker-quartenary:disabled span,\n.btn-darker-quartenary.disabled span,\n.btn-standard-quartenary:disabled span,\n.btn-standard-quartenary.disabled span {\n  color: rgba(17, 17, 17, 0.5);\n  background-image: none;\n}\n\n.btn-brand-quartenary {\n  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;\n}\n.btn-brand-quartenary:focus-visible {\n  box-shadow: 0 0 4px 0 #304ffe;\n  color: rgba(17, 17, 17, 0.84);\n}\n\n.btn-darker-quartenary,\n.btn-standard-quartenary {\n  --bs-btn-focus-box-shadow: none;\n}\n.btn-darker-quartenary:focus-visible,\n.btn-standard-quartenary:focus-visible {\n  border: 1px solid rgba(48, 79, 254, 0.5);\n}\n\n.btn-secondary-inverse {\n  --bs-btn-color: rgba(255, 255, 255, 0.8);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: rgba(255, 255, 255, 0.4);\n  --bs-btn-icon-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: rgba(255, 255, 255, 0.8);\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: transparent;\n  --bs-btn-active-border-color: rgba(255, 255, 255, 0.8);\n  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #343434;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .btn-secondary-inverse, .btn-secondary-inverse:focus-visible {\n  --bs-btn-hover-color: rgba(255, 255, 255, 0.8);\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: rgba(255, 255, 255, 0.5);\n}\n\n.dark .btn-primary,\n.dark .btn-darker-primary,\n.btn-light {\n  --bs-btn-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-bg: #fcfcfc;\n  --bs-btn-border-color: #fcfcfc;\n  --bs-btn-icon-color: #111111;\n  --bs-btn-hover-color: #111111;\n  --bs-btn-hover-bg: #dedede;\n  --bs-btn-hover-border-color: #dedede;\n  --bs-btn-active-color: rgba(17, 17, 17, 0.92);\n  --bs-btn-active-bg: #f2f2f2;\n  --bs-btn-active-border-color: #f2f2f2;\n  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);\n  --bs-btn-disabled-bg: #4b4b4b;\n  --bs-btn-disabled-border-color: #4b4b4b;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .dark .btn-primary, .dark .btn-primary:focus-visible,\n.btn-check:focus-visible + .dark .btn-darker-primary,\n.dark .btn-darker-primary:focus-visible,\n.btn-check:focus-visible + .btn-light,\n.btn-light:focus-visible {\n  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-hover-bg: #fcfcfc;\n  --bs-btn-hover-border-color: #fcfcfc;\n}\n\n.dark .show > .btn-primary.dropdown-toggle,\n.dark .show > .btn-darker-primary.dropdown-toggle,\n.show > .btn-light.dropdown-toggle {\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-bg);\n  color: var(--bs-btn-hover-color);\n}\n\n.dark .btn-secondary,\n.dark .btn-darker-secondary,\n.dark .btn-darker-outline {\n  --bs-btn-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: #343434;\n  --bs-btn-icon-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: #fff;\n  --bs-btn-active-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-active-bg: transparent;\n  --bs-btn-active-border-color: #808080;\n  --bs-btn-focus-box-shadow: none;\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #343434;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .dark .btn-secondary, .dark .btn-secondary:focus-visible,\n.btn-check:focus-visible + .dark .btn-darker-secondary,\n.dark .btn-darker-secondary:focus-visible,\n.btn-check:focus-visible + .dark .btn-darker-outline,\n.dark .btn-darker-outline:focus-visible {\n  --bs-btn-hover-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: #304ffe;\n}\n.dark .btn-darker-outline {\n  --bs-btn-border-color: #575757;\n}\n.dark .btn-darker-tertiary {\n  --bs-btn-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-bg: rgba(255, 255, 255, 0.06);\n  --bs-btn-border-color: transparent;\n  --bs-btn-icon-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgba(255, 255, 255, 0.14);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-active-bg: rgba(255, 255, 255, 0.08);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-focus-box-shadow: 0 0 4px 0 #304ffe;\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);\n  --bs-btn-disabled-bg: rgba(255, 255, 255, 0.02);\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .dark .btn-darker-tertiary, .dark .btn-darker-tertiary:focus-visible {\n  --bs-btn-hover-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-hover-bg: rgba(255, 255, 255, 0.06);\n  --bs-btn-hover-border-color: rgba(255, 255, 255, 0.06);\n}\n.dark .btn-brand-primary {\n  --bs-btn-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-bg: #ccff00;\n  --bs-btn-border-color: #ccff00;\n  --bs-btn-icon-color: #111111;\n  --bs-btn-hover-color: #111111;\n  --bs-btn-hover-bg: #9fe300;\n  --bs-btn-hover-border-color: #9fe300;\n  --bs-btn-active-color: rgba(17, 17, 17, 0.92);\n  --bs-btn-active-bg: #b0f000;\n  --bs-btn-active-border-color: #b0f000;\n  --bs-btn-focus-box-shadow: 0 3px 4px 0 rgba(17, 17, 17, 0.22);\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);\n  --bs-btn-disabled-bg: #414e0c;\n  --bs-btn-disabled-border-color: #414e0c;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .dark .btn-brand-primary, .dark .btn-brand-primary:focus-visible {\n  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-hover-bg: #ccff00;\n  --bs-btn-hover-border-color: #ccff00;\n}\n.dark .btn-brand-secondary {\n  --bs-btn-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: rgba(204, 255, 0, 0.4);\n  --bs-btn-icon-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: #9fe300;\n  --bs-btn-active-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-active-bg: transparent;\n  --bs-btn-active-border-color: #b0f000;\n  --bs-btn-focus-box-shadow: none;\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #414e0c;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .dark .btn-brand-secondary, .dark .btn-brand-secondary:focus-visible {\n  --bs-btn-hover-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: #304ffe;\n}\n.dark .btn-brand-tertiary {\n  --bs-btn-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-bg: rgba(255, 255, 255, 0.02);\n  --bs-btn-border-color: transparent;\n  --bs-btn-icon-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgba(255, 255, 255, 0.08);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-active-bg: rgba(255, 255, 255, 0.06);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-focus-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);\n  --bs-btn-disabled-bg: rgba(255, 255, 255, 0.02);\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .dark .btn-brand-tertiary, .dark .btn-brand-tertiary:focus-visible {\n  --bs-btn-hover-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-hover-bg: rgba(255, 255, 255, 0.02);\n  --bs-btn-hover-border-color: transparent;\n}\n.dark .btn-standard-primary {\n  --bs-btn-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-bg: #dedede;\n  --bs-btn-border-color: #dedede;\n  --bs-btn-icon-color: #111111;\n  --bs-btn-hover-color: #111111;\n  --bs-btn-hover-bg: #a1a1a1;\n  --bs-btn-hover-border-color: #a1a1a1;\n  --bs-btn-active-color: rgba(17, 17, 17, 0.92);\n  --bs-btn-active-bg: #b6b6b6;\n  --bs-btn-active-border-color: #b6b6b6;\n  --bs-btn-focus-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);\n  --bs-btn-disabled-bg: #404040;\n  --bs-btn-disabled-border-color: #404040;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .dark .btn-standard-primary, .dark .btn-standard-primary:focus-visible {\n  --bs-btn-hover-color: rgba(17, 17, 17, 0.84);\n  --bs-btn-hover-bg: #dedede;\n  --bs-btn-hover-border-color: #dedede;\n}\n.dark .btn-standard-secondary,\n.dark .btn-standard-outline {\n  --bs-btn-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: #343434;\n  --bs-btn-icon-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: #b6b6b6;\n  --bs-btn-active-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-active-bg: transparent;\n  --bs-btn-active-border-color: #808080;\n  --bs-btn-focus-box-shadow: none;\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #232323;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .dark .btn-standard-secondary, .dark .btn-standard-secondary:focus-visible,\n.btn-check:focus-visible + .dark .btn-standard-outline,\n.dark .btn-standard-outline:focus-visible {\n  --bs-btn-hover-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-hover-bg: transparent;\n  --bs-btn-hover-border-color: #304ffe;\n}\n.dark .btn-standard-tertiary {\n  --bs-btn-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-bg: rgba(255, 255, 255, 0.02);\n  --bs-btn-border-color: transparent;\n  --bs-btn-icon-color: #fff;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgba(255, 255, 255, 0.08);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: rgba(255, 255, 255, 0.92);\n  --bs-btn-active-bg: rgba(255, 255, 255, 0.06);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-focus-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);\n  --bs-btn-disabled-bg: rgba(255, 255, 255, 0.02);\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-disabled-opacity: 1;\n}\n.btn-check:focus-visible + .dark .btn-standard-tertiary, .dark .btn-standard-tertiary:focus-visible {\n  --bs-btn-hover-color: rgba(255, 255, 255, 0.84);\n  --bs-btn-hover-bg: rgba(255, 255, 255, 0.02);\n  --bs-btn-hover-border-color: transparent;\n}\n.dark .btn-brand-quartenary,\n.dark .btn-darker-quartenary,\n.dark .btn-standard-quartenary {\n  color: rgba(255, 255, 255, 0.84);\n}\n.dark .btn-brand-quartenary svg,\n.dark .btn-darker-quartenary svg,\n.dark .btn-standard-quartenary svg {\n  color: #fff;\n}\n.dark .btn-brand-quartenary:hover,\n.dark .btn-darker-quartenary:hover,\n.dark .btn-standard-quartenary:hover {\n  color: #fff;\n}\n.dark .btn-brand-quartenary:hover span,\n.dark .btn-darker-quartenary:hover span,\n.dark .btn-standard-quartenary:hover span {\n  background-image: linear-gradient(to right, #fff 0%, #fff 100%);\n}\n.dark .btn-brand-quartenary.active, .dark .btn-brand-quartenary:active,\n.dark .btn-darker-quartenary.active,\n.dark .btn-darker-quartenary:active,\n.dark .btn-standard-quartenary.active,\n.dark .btn-standard-quartenary:active {\n  color: rgba(255, 255, 255, 0.92);\n}\n.dark .btn-brand-quartenary.active span, .dark .btn-brand-quartenary:active span,\n.dark .btn-darker-quartenary.active span,\n.dark .btn-darker-quartenary:active span,\n.dark .btn-standard-quartenary.active span,\n.dark .btn-standard-quartenary:active span {\n  background-image: linear-gradient(to right, #808080 0%, #808080 100%);\n}\n.dark .btn-brand-quartenary:disabled span, .dark .btn-brand-quartenary.disabled span,\n.dark .btn-darker-quartenary:disabled span,\n.dark .btn-darker-quartenary.disabled span,\n.dark .btn-standard-quartenary:disabled span,\n.dark .btn-standard-quartenary.disabled span {\n  color: rgba(255, 255, 255, 0.4);\n  background-image: none;\n}\n.dark .btn-brand-quartenary:focus-visible,\n.dark .btn-darker-quartenary:focus-visible,\n.dark .btn-standard-quartenary:focus-visible {\n  color: rgba(255, 255, 255, 0.84);\n}\n.dark .btn-darker-quartenary:focus-visible,\n.dark .btn-standard-quartenary:focus-visible {\n  border-color: rgba(48, 79, 254, 0.5);\n}\n.dark .btn-brand-quartenary {\n  --bs-btn-disabled-color: rgba(255, 255, 255, 0.4);\n}\n.dark .btn-brand-quartenary:focus-visible {\n  box-shadow: 0 0 4px 0 rgba(48, 79, 254, 0.5);\n}\n\n.btn-group-shadow {\n  background: #ededed;\n}\n.btn-group-shadow .btn {\n  color: rgba(17, 17, 17, 0.84);\n  background-color: transparent;\n  border-color: transparent;\n}\n.btn-group-shadow .btn:hover, .btn-group-shadow .btn:focus, .btn-group-shadow .btn:not(:disabled):not(.disabled):active {\n  color: #000;\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: none;\n}\n.btn-group-shadow .btn:not(:disabled):not(.disabled).active,\n.btn-group-shadow .show > .btn.dropdown-toggle {\n  color: #111111;\n  background-color: #fff;\n  border-color: transparent;\n  box-shadow: 0 0.4375rem 0.875rem 0 rgba(0, 0, 0, 0.14);\n}\n.btn-group-shadow .btn:not(:disabled):not(.disabled).active:focus,\n.btn-group-shadow .show > .btn.dropdown-toggle:focus {\n  color: #000;\n  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.24);\n}\n\n.btn-group-brand {\n  --btn-group-brand-border-color: #c5e7c1;\n}\n.btn-group-brand .btn {\n  background-color: transparent;\n  color: rgba(17, 17, 17, 0.84);\n}\n.btn-group-brand .btn, .btn-group-brand .btn:focus {\n  border-color: var(--btn-group-brand-border-color);\n}\n.btn-group-brand .btn:not(:first-child):not(:last-child) {\n  border-left-color: transparent;\n  border-right-color: transparent;\n}\n.btn-group-brand .btn:first-child {\n  border-right-color: transparent;\n}\n.btn-group-brand .btn:last-child {\n  border-left-color: transparent;\n}\n.btn-group-brand .btn:hover {\n  border-color: #004f00 !important;\n}\n.btn-group-brand .btn:focus, .btn-group-brand .btn:not(:disabled):not(.disabled):active {\n  border-color: #304ffe !important;\n  box-shadow: none;\n  background-color: unset;\n  color: unset;\n}\n.btn-group-brand .btn:not(:disabled):not(.disabled).active {\n  background-color: #006600;\n  border-color: #006600;\n  color: #fff;\n}\n\n.btn-group-fill {\n  background: #ededed;\n}\n.btn-group-fill .btn {\n  color: rgba(17, 17, 17, 0.84);\n  background-color: transparent;\n  border-color: transparent;\n}\n.btn-group-fill .btn:hover, .btn-group-fill .btn:not(:disabled):not(.disabled):active {\n  color: #111111;\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: none;\n}\n.btn-group-fill .btn:hover:focus, .btn-group-fill .btn:not(:disabled):not(.disabled):active:focus {\n  box-shadow: 0 0 4px 0 #304ffe;\n}\n.btn-group-fill .btn:not(:disabled):not(.disabled).active,\n.btn-group-fill .show > .btn.dropdown-toggle {\n  color: #fff;\n  background-color: #232323;\n  border-color: transparent;\n}\n\n.btn-group.rounded-0 > .btn {\n  --bs-btn-border-radius: 0;\n}\n.btn-group.rounded-2 > .btn {\n  --bs-btn-border-radius: 0.1875rem;\n}\n.btn-group.rounded-4 > .btn {\n  --bs-btn-border-radius: 0.5rem;\n}\n.btn-group.rounded-pill > .btn {\n  --bs-btn-border-radius: 50rem;\n}\n\n.btn-group-fill > .btn,\n.btn-group-shadow > .btn {\n  border-radius: var(--bs-btn-border-radius) !important;\n}\n\n.dark .btn-group-shadow {\n  background: #090909;\n}\n.dark .btn-group-shadow .btn {\n  color: rgba(255, 255, 255, 0.84);\n}\n.dark .btn-group-shadow .btn:hover, .dark .btn-group-shadow .btn:focus, .dark .btn-group-shadow .btn:not(:disabled):not(.disabled):active {\n  color: #fff;\n}\n.dark .btn-group-shadow .btn:not(:disabled):not(.disabled).active,\n.dark .btn-group-shadow .show > .btn.dropdown-toggle {\n  color: rgba(255, 255, 255, 0.92);\n  background-color: #232323;\n  border-color: transparent;\n  box-shadow: 0 0.4375rem 0.875rem rgba(0, 0, 0, 0.5);\n}\n.dark .btn-group-shadow .btn:not(:disabled):not(.disabled).active:focus,\n.dark .btn-group-shadow .show > .btn.dropdown-toggle:focus {\n  color: #fff;\n  box-shadow: 0 0.5625rem 0.875rem rgba(17, 17, 17, 0.7);\n}\n.dark .btn-group-brand {\n  --btn-group-brand-border-color: rgba(0, 127, 0, 0.2);\n}\n.dark .btn-group-brand .btn {\n  color: rgba(255, 255, 255, 0.84);\n}\n.dark .btn-group-brand .btn:hover {\n  border-color: #9fe300 !important;\n}\n.dark .btn-group-brand .btn:not(:disabled):not(.disabled).active {\n  background-color: #b0f000;\n  border-color: #b0f000;\n  color: #111111;\n}\n.dark .btn-group-fill {\n  background: #090909;\n}\n.dark .btn-group-fill .btn {\n  color: rgba(255, 255, 255, 0.84);\n  background-color: transparent;\n  border-color: transparent;\n}\n.dark .btn-group-fill .btn:hover, .dark .btn-group-fill .btn:not(:disabled):not(.disabled):active {\n  color: #fff;\n  border-color: transparent;\n  box-shadow: none;\n}\n.dark .btn-group-fill .btn:hover:focus, .dark .btn-group-fill .btn:not(:disabled):not(.disabled):active:focus {\n  box-shadow: 0 0 4px 0 #304ffe;\n}\n.dark .btn-group-fill .btn:not(:disabled):not(.disabled).active,\n.dark .btn-group-fill .show > .btn.dropdown-toggle {\n  color: #111111;\n  background-color: #fafafa;\n  border-color: transparent;\n}\n.dark .btn-group-fill .btn:not(:disabled):not(.disabled).active:focus,\n.dark .btn-group-fill .show > .btn.dropdown-toggle:focus {\n  color: #000;\n}\n\n.accordion {\n  --bs-accordion-hover-bg: #fafafa;\n  --bs-accordion-btn-active-icon: var(--bs-accordion-btn-icon);\n}\n.accordion.rounded-0, .accordion.accordion-flush {\n  --bs-accordion-border-radius: 0;\n  --bs-accordion-inner-border-radius: 0;\n}\n.accordion:not(.rounded-0) .accordion-item:last-child .accordion-body {\n  border-radius: 0 0 0.75rem 0.75rem;\n}\n\n.accordion-item {\n  position: relative;\n  overflow: hidden;\n  border: 0;\n  background-color: transparent;\n}\n.accordion-item + .accordion-item {\n  margin-top: -1px;\n}\n.accordion-item.disabled {\n  cursor: not-allowed;\n}\n.accordion-item.disabled .accordion-button {\n  pointer-events: none;\n}\n.accordion-item.disabled .accordion-button .accordion-title,\n.accordion-item.disabled .accordion-button .accordion-subtitle {\n  opacity: 0.5;\n}\n.accordion-item.disabled .accordion-button svg, .accordion-item.disabled .accordion-button::after {\n  opacity: 0.4;\n}\n.accordion-item.disabled .accordion-button:focus-visible {\n  box-shadow: none;\n  border-color: var(--bs-accordion-border-color) !important;\n}\n\n.accordion-has-icon-suffix .accordion-button::after {\n  margin-left: 0.625rem;\n}\n\n.accordion-btn-icon-prefix {\n  margin-right: 0.5rem;\n}\n\n.accordion-title {\n  opacity: 0.84;\n}\n\n.accordion-subtitle {\n  opacity: 0.57;\n  font-size: 0.75rem;\n  letter-spacing: 0.2px;\n  line-height: 1.9166666667;\n}\n.accordion-subtitle:first-child {\n  margin-top: 0.0625rem;\n}\n.accordion-subtitle + .accordion-title {\n  margin-bottom: 0.0625rem;\n}\n\n.accordion-button {\n  align-items: start;\n  font-size: 0.875rem;\n  line-height: 1.7142857143;\n  outline: 0;\n  border: 1px solid var(--bs-accordion-border-color);\n}\n.accordion-button:focus {\n  border-color: var(--bs-accordion-border-color) !important;\n  z-index: 2;\n}\n.accordion-button:active, .accordion-button:focus, .accordion-button:focus-visible {\n  outline: 0;\n  box-shadow: none;\n}\n.accordion-button svg, .accordion-button::after {\n  opacity: 0.64;\n}\n.accordion-button:focus-visible {\n  border-color: #304ffe !important;\n  z-index: 3;\n}\n.accordion-button:focus-visible .accordion-subtitle {\n  opacity: 0.64;\n}\n.accordion-button:not(.collapsed) {\n  box-shadow: none;\n}\n.accordion-button:hover {\n  z-index: 3;\n  background-color: var(--bs-accordion-hover-bg);\n  border-color: #000000 !important;\n}\n.accordion-button:hover .accordion-title {\n  opacity: 1;\n}\n.accordion-button:hover .accordion-subtitle {\n  opacity: 0.64;\n}\n.accordion-button:hover svg, .accordion-button:hover::after {\n  opacity: 0.9;\n}\n\n.accordion-body {\n  background-color: var(--bs-accordion-bg);\n  padding: 0.9375rem 1.1875rem 1.1875rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--bs-accordion-border-color);\n  border-top: none;\n  letter-spacing: 0;\n}\n.accordion-body p {\n  opacity: 0.64;\n}\n.accordion-body p:last-child {\n  margin-bottom: 0;\n}\n\n.accordion-has-btn-icon-prefix .accordion-button {\n  padding-left: 0.875rem;\n}\n.accordion-has-btn-icon-prefix .accordion-body {\n  padding-left: 2.875rem;\n}\n\n.accordion-lg {\n  --bs-accordion-btn-icon-width: 2rem;\n}\n.accordion-lg.accordion-has-btn-icon-prefix .accordion-button {\n  padding-left: 1.0625rem;\n}\n.accordion-lg.accordion-has-btn-icon-prefix .accordion-body {\n  padding-left: 3.5625rem;\n}\n.accordion-lg .accordion-button {\n  padding: 0.6875rem 1.0625rem 0.6875rem 1.5rem;\n  font-size: 0.9375rem;\n  line-height: 2.1333333333;\n}\n.accordion-lg .accordion-subtitle {\n  font-size: 0.8125rem;\n  margin: -0.0625rem 0 0.1875rem;\n  line-height: 1.4615384615;\n  letter-spacing: 0;\n}\n.accordion-lg .accordion-subtitle:first-child {\n  margin: 0.4375rem 0 0;\n}\n.accordion-lg .accordion-subtitle + .accordion-title {\n  line-height: 1.8;\n  margin-bottom: 0.25rem;\n}\n.accordion-lg .accordion-body {\n  padding: 1.1875rem 1.5rem 1.5rem;\n  font-size: 1rem;\n  letter-spacing: 0.1px;\n}\n\n.accordion-sm.accordion-has-btn-icon-prefix .accordion-button {\n  padding-left: 0.5625rem;\n}\n.accordion-sm.accordion-has-btn-icon-prefix .accordion-body {\n  padding-left: 2.5625rem;\n}\n.accordion-sm .accordion-button {\n  padding: 0.4375rem 0.5rem 0.4375rem 0.875rem;\n  font-size: 0.8125rem;\n  line-height: 1.8461538462;\n}\n.accordion-sm .accordion-subtitle {\n  margin-bottom: 0.0625rem;\n}\n.accordion-sm .accordion-subtitle:first-child,\n.accordion-sm .accordion-subtitle + .accordion-title {\n  margin-bottom: 0;\n}\n.accordion-sm .accordion-body {\n  padding: 1rem 0.875rem 1.1875rem;\n  font-size: 0.8125rem;\n  line-height: 1.6153846154;\n  letter-spacing: 0.2px;\n}\n\n.accordion-marketing {\n  --bs-accordion-btn-icon-width: 3rem;\n}\n.accordion-marketing.accordion-has-btn-icon-prefix .accordion-button {\n  padding-left: 0.875rem;\n}\n.accordion-marketing.accordion-has-btn-icon-prefix .accordion-body {\n  padding-left: 4.375rem;\n}\n.accordion-marketing .accordion-button {\n  padding: 1.9375rem 0.875rem 1.9375rem 1.5rem;\n  font-size: 1.625rem;\n  line-height: 1.8461538462;\n}\n.accordion-marketing .accordion-subtitle {\n  font-size: 1.125rem;\n  line-height: 1.8888888889;\n  margin-bottom: 0.125rem;\n  letter-spacing: 0.15px;\n}\n.accordion-marketing .accordion-subtitle:first-child {\n  line-height: 1.7777777778;\n  margin: 0.5rem 0 0;\n}\n.accordion-marketing .accordion-subtitle + .accordion-title {\n  line-height: 1.8076923077;\n  margin-bottom: 0;\n}\n.accordion-marketing .accordion-body {\n  padding: 2rem 1.5rem 2.1875rem;\n  font-size: 1.125rem;\n  line-height: 1.7777777778;\n  letter-spacing: 0.15px;\n}\n.accordion-marketing.accordion-lg.accordion-has-btn-icon-prefix .accordion-button {\n  padding-left: 1.1875rem;\n}\n.accordion-marketing.accordion-lg.accordion-has-btn-icon-prefix .accordion-body {\n  padding-left: 4.75rem;\n}\n.accordion-marketing.accordion-lg .accordion-button {\n  padding: 2.4375rem 1.1875rem 2.4375rem 1.8125rem;\n  font-size: 1.75rem;\n  line-height: 1.7142857143;\n  letter-spacing: 0.45px;\n}\n.accordion-marketing.accordion-lg .accordion-subtitle {\n  margin-bottom: 0.1875rem;\n}\n.accordion-marketing.accordion-lg .accordion-subtitle:first-child {\n  margin-bottom: 0;\n}\n.accordion-marketing.accordion-lg .accordion-subtitle + .accordion-title {\n  line-height: 1.7142857143;\n}\n.accordion-marketing.accordion-lg .accordion-body {\n  padding: 2.25rem 1.8125rem 2.4375rem;\n}\n.accordion-marketing.accordion-sm.accordion-has-btn-icon-prefix .accordion-button {\n  padding-left: 0.875rem;\n}\n.accordion-marketing.accordion-sm.accordion-has-btn-icon-prefix .accordion-body {\n  padding-left: 4.375rem;\n}\n.accordion-marketing.accordion-sm .accordion-button {\n  padding: 1.4375rem 0.5625rem 1.4375rem 1.5rem;\n  font-size: 1.4375rem;\n  line-height: 2.0869565217;\n}\n.accordion-marketing.accordion-sm .accordion-subtitle {\n  line-height: 1.6111111111;\n  margin-bottom: 0.3125rem;\n}\n.accordion-marketing.accordion-sm .accordion-subtitle:first-child {\n  margin: 0.5625rem 0 0.1875rem;\n}\n.accordion-marketing.accordion-sm .accordion-subtitle + .accordion-title {\n  line-height: 1.8260869565;\n}\n.accordion-marketing.accordion-sm .accordion-body {\n  padding: 1.75rem 1.5rem 2.1875rem;\n}\n\n.accordion-flush {\n  --bs-accordion-bg: transparent !important;\n  --bs-accordion-btn-bg: transparent !important;\n  --bs-accordion-active-bg: transparent !important;\n  --bs-accordion-hover-bg: transparent !important;\n}\n.accordion-flush .accordion-item:last-child .accordion-body {\n  border: 0;\n}\n.accordion-flush .accordion-item + .accordion-item {\n  margin-top: 0;\n}\n.accordion-flush .accordion-item .accordion-button {\n  border-top: 0;\n}\n.accordion-flush .accordion-button,\n.accordion-flush .accordion-body {\n  border-left: 0;\n  border-right: 0;\n}\n\n.dark .accordion {\n  --bs-accordion-bg: #111111;\n  --bs-accordion-color: #fff;\n  --bs-accordion-btn-color: #fff;\n  --bs-accordion-active-color: #fff;\n  --bs-accordion-btn-bg: #111111;\n  --bs-accordion-active-bg: #111111;\n  --bs-accordion-border-color: #232323;\n  --bs-accordion-btn-icon: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23fff\" vector-effect=\"non-scaling-stroke\" opacity=\"1\" d=\"m7 10 5.5 5.5L18 10\"%3e%3c/path%3e%3c/svg%3e');\n  --bs-accordion-hover-bg: #232323;\n}\n.dark .accordion-button:hover {\n  border-color: #fff !important;\n}\n\na.card {\n  color: #111111;\n}\n\nbutton.card {\n  padding: 0;\n  text-align: left;\n}\n\n.card-title {\n  font-size: 1rem;\n  font-weight: normal;\n  line-height: 1.5;\n  letter-spacing: 0.05px;\n}\n\n.card-subtitle {\n  font-size: 0.8125rem;\n  letter-spacing: 0.2px;\n  text-transform: none;\n  font-weight: normal;\n  opacity: 0.6;\n}\n\n.card-body {\n  padding: 1rem 1.5625rem 1.5rem 1.5625rem;\n}\n\n.card-text {\n  font-size: 0.875rem;\n  letter-spacing: 0.2px;\n  line-height: 1.7857142857;\n  opacity: 0.6;\n}\n\n.card-text-sm {\n  font-size: 0.8125rem;\n  letter-spacing: 0.2px;\n  line-height: 1.7692307692;\n  opacity: 0.84;\n}\n\n.card-text-lg {\n  font-size: 1rem;\n  letter-spacing: 0.1px;\n  line-height: 1.75;\n  opacity: 0.6;\n}\n\n.card-lg .card-title {\n  font-size: 1.125rem;\n}\n.card-lg .card-title-lg {\n  font-size: 1.4375rem;\n  line-height: 1.5217391304;\n  letter-spacing: 0.15px;\n}\n.card-lg .card-body {\n  padding: 1.875rem;\n}\n.card-lg .card-text {\n  font-size: 1rem;\n  line-height: 1.75;\n  letter-spacing: 0.1px;\n}\n.card-lg .card-subtitle {\n  font-size: 0.8125rem;\n  letter-spacing: 0.2px;\n  line-height: 1.5384615385;\n  text-transform: none;\n  opacity: 0.6;\n  margin-bottom: 1rem;\n}\n\n.card-border {\n  --bs-card-border-width: 1px;\n}\n\n.card-implicit {\n  --bs-card-bg: transparent !important;\n}\n.card-implicit .card-body {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.card-link {\n  font-size: 0.875rem;\n  line-height: 1.4285714286;\n  color: rgba(17, 17, 17, 0.84);\n}\n.card-link:hover {\n  color: #111111;\n}\n\n.dark a.card,\n.dark button.card {\n  color: #fff;\n}\n.dark .card {\n  --bs-card-bg: #111111;\n}\n.dark .card-border {\n  --bs-card-border-color: #343434;\n}\n.dark .card-link {\n  color: rgba(255, 255, 255, 0.84);\n}\n.dark .card-link:hover {\n  color: #fff;\n}\n\n.dropdown-menu {\n  box-shadow: var(--bs-dropdown-box-shadow);\n}\n\n.dropdown-menu-media .dropdown-item svg {\n  opacity: 0.54;\n}\n.dropdown-menu-media .dropdown-item h5, .dropdown-menu-media .dropdown-item .h5 {\n  opacity: 0.84;\n}\n.dropdown-menu-media .dropdown-item p {\n  opacity: 0.64;\n}\n.dropdown-menu-media .dropdown-item:hover svg {\n  opacity: 0.9;\n}\n.dropdown-menu-media .dropdown-item:hover h5, .dropdown-menu-media .dropdown-item:hover .h5 {\n  opacity: 1;\n}\n.dropdown-menu-media .dropdown-item:hover p {\n  opacity: 0.84;\n}\n\n.dropdown-menu-scroll {\n  max-height: 315px;\n  overflow-y: scroll;\n}\n\n.dropdown-header {\n  text-transform: none;\n  letter-spacing: 0;\n  font-weight: 400;\n  font-size: 0.9375rem;\n}\n\n.show > .dropdown-toggle > svg {\n  transform: scaleY(-1);\n}\n.dropdown-toggle > * {\n  pointer-events: none;\n}\n.dropdown-toggle::after, .dropup .dropdown-toggle::after, .dropend .dropdown-toggle::after {\n  content: none;\n}\n.dropstart .dropdown-toggle::before {\n  content: none;\n}\n.dropend .dropdown-toggle.dropdown-item .dropdown-suffix {\n  opacity: 0.3;\n}\n.dropend .dropdown-toggle.dropdown-item:hover .dropdown-suffix, .dropend .dropdown-toggle.dropdown-item:focus .dropdown-suffix {\n  opacity: 1;\n}\n\n.dropdown-menu .dropend .dropdown-menu {\n  margin-left: -0.5em;\n  margin-top: -0.5em;\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  line-height: 1.7142857143;\n}\n\n.dropdown-icon-prefix {\n  margin-left: -0.3125rem;\n  margin-right: 0.625rem;\n}\n\n.dropdown-suffix {\n  margin-left: auto;\n  padding-left: 30px;\n  font-size: 0.8125rem;\n  display: flex;\n  align-items: center;\n}\n\n.dropdown-menu-sm {\n  font-size: 0.8125rem;\n}\n.dropdown-menu-sm .dropdown-item {\n  line-height: 1.8461538462;\n  padding: 0.375rem 0.9375rem;\n}\n\n.dropdown-menu-lg {\n  font-size: 0.9375rem;\n}\n.dropdown-menu-lg .dropdown-item {\n  line-height: 2.1333333333;\n  padding: 0.4375rem 0.9375rem;\n}\n\n.dark .dropdown-menu {\n  --bs-dropdown-color: rgba(255, 255, 255, 0.64);\n  --bs-dropdown-bg: #232323;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: 0 1.25rem 1.875rem rgba(17, 17, 17, 0.6);\n  --bs-dropdown-link-color: rgba(255, 255, 255, 0.64);\n  --bs-dropdown-link-hover-color: #fff;\n  --bs-dropdown-divider-bg: #404040;\n  --bs-dropdown-link-hover-bg: #343434;\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #404040;\n  --bs-dropdown-link-disabled-color: #adb5bd;\n  --bs-dropdown-header-color: #adb5bd;\n}\n\n.list-group {\n  --list-group-sub-color: #111111;\n  --bs-info-rgb: 33, 141, 204;\n  min-width: 255px;\n}\n.list-group .avatar {\n  margin-right: 0.625rem;\n}\n\n.list-group-item {\n  display: flex;\n  align-items: center;\n  height: 48px;\n  font-size: 0.875rem;\n  line-height: 1.4285714286;\n  letter-spacing: 0;\n  transition: border 0.15s ease-in-out, color 0.15s ease-in-out, background-color 0.15s ease-in-out;\n}\n.list-group-item + .list-group-item {\n  border-top: 1px solid transparent;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-item .list-group-icon {\n  color: var(--list-group-sub-color);\n  opacity: 0.54;\n}\n.list-group-item:focus-visible {\n  outline: 0;\n  background: var(--bs-list-group-bg);\n  border-color: #304ffe !important;\n}\n.list-group-item:focus-visible:not(.disabled) {\n  color: var(--bs-list-group-color);\n}\n.list-group-item:hover .list-group-icon,\n.list-group-item:hover .list-group-icon-prefix {\n  opacity: 0.9;\n}\n.list-group-item:hover .list-group-item-subtitle {\n  opacity: 0.64;\n}\n.list-group-item.active .list-group-icon,\n.list-group-item.active .list-group-icon-prefix, .list-group-item:active .list-group-icon,\n.list-group-item:active .list-group-icon-prefix {\n  opacity: 0.64;\n}\n.list-group-item.active .list-group-item-subtitle, .list-group-item:active .list-group-item-subtitle {\n  opacity: 0.57;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  pointer-events: auto;\n  cursor: not-allowed;\n}\n.list-group-item.disabled > *, .list-group-item:disabled > * {\n  opacity: 0.5;\n}\n.list-group-item.disabled .list-group-item-subtitle, .list-group-item:disabled .list-group-item-subtitle {\n  opacity: 1;\n}\n.list-group-item.disabled > svg, .list-group-item:disabled > svg {\n  opacity: 0.4 !important;\n}\n\n.list-group-icon-prefix {\n  margin-right: 6px;\n  opacity: 0.5;\n  color: var(--list-group-sub-color);\n}\n\n.list-group-item-subtitle {\n  font-size: 0.75rem;\n  font-weight: 400;\n  letter-spacing: 0.2px;\n  line-height: 1.5833333333;\n  opacity: 0.5;\n  color: var(--list-group-sub-color);\n}\n\n.list-group-borderless {\n  --bs-list-group-border-color: transparent !important;\n}\n.list-group-borderless .list-group-item.active {\n  border-color: transparent;\n}\n\n.list-group-flush > .list-group-item {\n  border-top: 1px solid transparent;\n  border-left: 1px solid transparent;\n  border-right: 1px solid transparent;\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom: 1px solid transparent;\n}\n\n.list-group-sm .list-group-item {\n  height: 44px;\n  font-size: 0.8125rem;\n  line-height: 1.4615384615;\n}\n.list-group-sm .list-group-icon-prefix {\n  margin-right: 4px;\n}\n\n.list-group-lg .list-group-item {\n  height: 56px;\n  font-size: 0.9375rem;\n  line-height: 1.3333333333;\n}\n.list-group-lg .list-group-icon-prefix {\n  margin-right: 8px;\n}\n.list-group-lg .avatar {\n  margin-right: 0.9375rem;\n}\n\n.list-group-two-tier .list-group-item {\n  height: 72px;\n}\n.list-group-two-tier .list-group-item-subtitle {\n  margin-top: 0.125rem;\n}\n.list-group-two-tier.list-group-lg .list-group-item {\n  height: 80px;\n}\n.list-group-two-tier.list-group-lg .list-group-item-subtitle {\n  margin-top: 0.25rem;\n  font-size: 0.8125rem;\n  line-height: 1.4615384615;\n}\n.list-group-two-tier.list-group-sm .list-group-item {\n  height: 64px;\n}\n.list-group-two-tier.list-group-sm .list-group-item-subtitle {\n  margin-top: 0;\n  font-size: 0.75rem;\n  line-height: 1.5833333333;\n}\n\n.dark .list-group {\n  --list-group-sub-color: #fff;\n  --bs-info-rgb: 79, 195, 247;\n  --bs-list-group-color: rgba(255, 255, 255, 0.64);\n  --bs-list-group-bg: #111111;\n  --bs-list-group-border-color: #232323;\n  --bs-list-group-disabled-color: #fff;\n  --bs-list-group-active-bg: #232323;\n  --bs-list-group-active-color: rgba(255, 255, 255, 0.84);\n  --bs-list-group-active-border-color: #232323;\n  --bs-list-group-action-color: rgba(255, 255, 255, 0.64);\n  --bs-list-group-action-hover-color: rgba(255, 255, 255, 0.84);\n  --bs-list-group-action-hover-bg: #343434;\n  --bs-list-group-action-active-color: rgba(255, 255, 255, 0.84);\n  --bs-list-group-action-active-bg: #232323;\n  --bs-list-group-disabled-bg: #111111;\n  --bs-list-group-disabled-color: #fff;\n}\n\n.modal-content {\n  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);\n}\n@media (min-width: 768px) {\n  .modal-content {\n    box-shadow: 0 1.875rem 2.5rem rgba(35, 35, 35, 0.26);\n  }\n}\n\n@media (min-width: 216px) {\n  .modal-xs {\n    margin: 1.75rem auto;\n    max-width: 180px;\n  }\n}\n.modal-xs .modal-header {\n  padding: 0.3125rem;\n}\n.modal-xs .modal-header .btn-close-inline {\n  padding: 0.3125rem;\n  margin: -0.3125rem -0.3125rem -0.3125rem auto;\n}\n.modal-xs .modal-body {\n  padding: 1rem 0.625rem;\n}\n.modal-xs .modal-header + .modal-body {\n  padding-top: 0;\n}\n\n.modal-sm .modal-header {\n  padding: 0.5rem;\n}\n.modal-sm .modal-header .btn-close-inline {\n  padding: 0.5rem;\n  margin: -0.5rem -0.5rem -0.5rem auto;\n}\n.modal-sm .modal-content {\n  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);\n}\n.modal-sm .modal-body {\n  padding: 1.5rem 0.9375rem;\n}\n.modal-sm .btn.text-uppercase {\n  font-size: 0.8125rem;\n}\n\n.modal-lg,\n.modal-xl {\n  --bs-modal-border-radius: 0.75rem;\n  --bs-modal-inner-border-radius: 0.75rem;\n}\n\n.modal-btn-margin {\n  margin: 0.1875rem;\n}\n\n.modal-footer-row > div + div {\n  border-left: 1px solid #ededed;\n}\n\n.modal-footer-column > * {\n  margin: 0;\n}\n.modal-footer-column > div + div {\n  border-top: 1px solid #ededed;\n}\n\n@media (max-width: 575.98px) {\n  .modal-footer-grid > div:nth-child(even) {\n    border-left: 1px solid #ededed;\n  }\n  .modal-footer-grid > div:nth-child(n+3) {\n    border-top: 1px solid #ededed;\n  }\n}\n@media (min-width: 576px) {\n  .modal-footer-grid > div + div:not(:nth-child(5n)) {\n    border-left: 1px solid #ededed;\n  }\n  .modal-footer-grid > div:nth-child(n+5) {\n    border-top: 1px solid #ededed;\n  }\n}\n\n.dark .modal-footer-column .btn:focus,\n.dark .modal-footer-row .btn:focus,\n.dark .modal-footer-grid .btn:focus {\n  box-shadow: none;\n}\n\n.modal-header .btn-close-inline {\n  border-radius: var(--bs-modal-border-radius);\n  padding: 1rem 1rem;\n  margin: -1rem -1rem -1rem auto;\n}\n\n.dark .modal-sm .modal-content {\n  box-shadow: 0 0.75rem 1rem 0 rgba(17, 17, 17, 0.5);\n}\n.dark .modal-content {\n  background: #232323;\n  color: #fff;\n  box-shadow: 0 1.875rem 2.5rem 0 rgba(17, 17, 17, 0.26);\n}\n@media (min-width: 768px) {\n  .dark .modal-content {\n    box-shadow: 0 1.875rem 2.5rem rgba(17, 17, 17, 0.7);\n  }\n}\n.dark .modal-footer,\n.dark .modal-footer-row > div,\n.dark .modal-footer-column > div,\n.dark .modal-footer-grid > div {\n  border-color: #343434 !important;\n}\n\n.page-item:first-child .page-link, .pagination-lg .page-item:first-child .page-link, .pagination-sm .page-item:first-child .page-link,\n.page-item:last-child .page-link,\n.pagination-lg .page-item:last-child .page-link,\n.pagination-sm .page-item:last-child .page-link {\n  border-radius: 0;\n}\n\n.page-item.disabled {\n  cursor: not-allowed;\n}\n.page-item:not(.disabled) .page-link:focus-visible {\n  box-shadow: 0 0 4px 0 #304ffe;\n}\n\n.page-item-circle .page-link,\n.page-item-square .page-link {\n  width: var(--pagination-square-size);\n  height: var(--pagination-square-size);\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: 0;\n}\n\n.page-item-pill .page-link {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.page-item-word .page-link {\n  height: var(--pagination-square-size);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--pagination-word-font-size);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.page-item-circle {\n  margin: 0 2px;\n}\n.page-item-circle .page-link {\n  border-radius: 50% !important;\n}\n\n.pagination {\n  --pagination-word-font-size: 0.6875rem;\n  --pagination-square-size: 2.5rem;\n}\n\n.pagination-lg {\n  --pagination-word-font-size: 1.0625rem;\n  --pagination-square-size: 2.875rem;\n}\n\n.pagination-sm {\n  --bs-pagination-font-size: 0.75rem;\n  --pagination-word-font-size: 0.625rem;\n  --pagination-square-size: 2.25rem;\n}\n\n.dark .pagination {\n  --bs-pagination-color: rgba(255, 255, 255, 0.64);\n  --bs-pagination-disabled-color: rgba(255, 255, 255, 0.4);\n  --bs-pagination-active-bg: #fff;\n  --bs-pagination-active-color: #111111;\n  --bs-pagination-hover-color: #fff;\n  --bs-pagination-hover-bg: #232323;\n  --bs-pagination-focus-color: #fff;\n}\n\n.popover {\n  padding: 1rem 1.25rem 1.125rem;\n  box-shadow: var(--bs-box-shadow);\n}\n\n.popover-header {\n  font-weight: 400;\n  font-family: \"Roboto\", Arial, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;\n  font-size: 0.875rem;\n  letter-spacing: 0.3px;\n  line-height: 1.5;\n  padding: 0;\n  margin-bottom: 0.75rem;\n}\n.popover-header svg:first-child {\n  margin: -0.125rem 0.3125rem -0.0625rem -0.375rem;\n}\n\n.popover-body {\n  opacity: 0.64;\n  padding: 0;\n  letter-spacing: 0.2px;\n}\n\n.popover-dark {\n  --bs-popover-bg: #232323;\n}\n.popover-dark .popover-inner {\n  filter: invert(1) grayscale(100%) brightness(120%);\n}\n.popover-dark .popover-header,\n.popover-dark .popover-body {\n  color: unset;\n}\n\n.bs-popover-top, .bs-popover-auto[data-popper-placement^=top] {\n  margin-bottom: 0.625rem;\n}\n\n.bs-popover-end, .bs-popover-auto[data-popper-placement^=right] {\n  margin-left: 0.625rem;\n}\n\n.bs-popover-bottom, .bs-popover-auto[data-popper-placement^=bottom] {\n  margin-top: 0.625rem;\n}\n\n.bs-popover-start, .bs-popover-auto[data-popper-placement^=left] {\n  margin-right: 0.625rem;\n}\n\n.dark .popover {\n  --bs-popover-bg: #232323;\n  --bs-popover-header-color: #fff;\n  --bs-popover-body-color: #fff;\n}\n.dark .popover-dark {\n  --bs-popover-bg: #fff;\n}\n\n.popover-walkthrough {\n  --bs-popover-max-width: 280px;\n}\n\n.__floater__arrow {\n  display: none;\n}\n\n.react-joyride__spotlight {\n  margin-left: -1px;\n}\n\n.spinner-border-lg,\n.spinner-grow-lg {\n  --bs-spinner-width: 3rem;\n  --bs-spinner-height: 3rem;\n}\n\n.spinner-label {\n  transition: opacity 300ms;\n}\n\n.steps {\n  --steps-contrast-color: #fff;\n  --steps-incomplete-track-color: #ededed;\n  --steps-complete-track-color: #767676;\n  --steps-incomplete-circle-color: rgba(#111111, 0.64);\n  --steps-incomplete-circle-bg: #ededed;\n  --steps-incomplete-circle-hover-bg: #000000;\n  --steps-active-circle-bg: #343434;\n  --steps-success-color: #15ad5c;\n  --steps-warning-color: #ffc000;\n  --steps-warning-text-color: #a67d00;\n  --steps-danger-color: #e64949;\n  --steps-danger-text-color: #9e3232;\n  --steps-progress-circle-bg: #fff;\n  --steps-circular-progress-color: #2ee68c;\n  --steps-circular-progress-background-color: #ededed;\n  --steps-tabbed-background: #fafafa;\n  --steps-tabbed-background-active: #fff;\n  --steps-tabbed-border: #dedede;\n  --steps-tabbed-active-border-bottom: #a1a1a1;\n  --steps-tabbed-hover-border-bottom: #111111;\n  --steps-xs-circle-border: #cccccc;\n  --steps-xs-circle-active-border: #767676;\n  --steps-xs-complete: #343434;\n}\n\n.steps-step {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n.steps-step:first-child .step-left-line {\n  opacity: 0;\n}\n.steps-step:last-child .step-right-line {\n  opacity: 0;\n}\n.steps-step.step-complete .step-circle {\n  color: var(--steps-contrast-color);\n  background-color: var(--steps-success-color);\n}\n.steps-step.step-complete .step-line {\n  background-color: var(--steps-complete-track-color);\n}\n.steps-step.step-active .step-circle {\n  color: var(--steps-contrast-color);\n  background-color: var(--steps-active-circle-bg);\n}\n.steps-step.step-active .step-line.step-left-line {\n  background-color: var(--steps-complete-track-color);\n}\n.steps-step.step-warning .step-circle {\n  background-color: var(--steps-warning-color);\n  color: #111111;\n}\n.steps-step.step-warning .step-description {\n  opacity: 1;\n  color: var(--steps-warning-text-color);\n}\n.steps-step.step-error .step-circle {\n  background-color: var(--steps-danger-color);\n  color: var(--steps-contrast-color);\n}\n.steps-step.step-error .step-description {\n  opacity: 1;\n  color: var(--steps-danger-text-color);\n}\n\na.step-action {\n  text-decoration: none;\n}\n\n.step-action {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  outline: none;\n}\n.step-action:disabled .step-label,\n.step-action:disabled .step-description,\n.step-action:disabled .step-number {\n  opacity: 0.5;\n}\n.step-action:not(:disabled):hover .step-label {\n  opacity: 1;\n}\n.step-action:not(:disabled):hover.step-incomplete.step-normal .step-circle {\n  background-color: var(--steps-incomplete-circle-hover-bg);\n  color: var(--steps-contrast-color);\n}\n.step-action:focus-visible .step-circle {\n  border-color: #304ffe;\n}\n\n.step-top {\n  display: flex;\n  align-items: center;\n}\n\n.step-line {\n  background-color: var(--steps-incomplete-track-color);\n  flex-grow: 1;\n  height: 1px;\n}\n\n.step-circle {\n  display: flex;\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  font-size: 0.75rem;\n  height: 1.5rem;\n  width: 1.5rem;\n  border: 1px solid transparent;\n  border-radius: 50%;\n  background-color: var(--steps-incomplete-circle-bg);\n  color: var(--steps-incomplete-circle-color);\n  flex-shrink: 0;\n}\n.step-circle.step-circle-progress {\n  background-color: var(--steps-progress-circle-bg);\n}\n.step-circle .step-progress-track {\n  stroke: var(--steps-circular-progress-background-color);\n}\n.step-circle .step-progress-percent {\n  stroke: var(--steps-circular-progress-color);\n  transition: stroke-dashoffset 0.15s ease-in;\n}\n\n.step-label {\n  line-height: 1.25rem;\n  opacity: 0.84;\n  font-size: 0.875rem;\n}\n\n.step-description {\n  line-height: 1rem;\n  opacity: 0.57;\n  font-size: 0.75rem;\n}\n\n.steps-sm .step-top {\n  height: 1.5rem;\n}\n.steps-sm .step-circle {\n  height: 1rem;\n  width: 1rem;\n}\n.steps-sm .step-error .step-circle,\n.steps-sm .step-warning .step-circle {\n  background-color: transparent;\n  height: 1.5rem;\n  width: 1.5rem;\n}\n.steps-sm .step-error .step-circle {\n  color: var(--steps-danger-color);\n}\n.steps-sm .step-warning .step-circle {\n  color: var(--steps-warning-color);\n}\n\n.steps-xs .step-circle {\n  height: 0.75rem;\n  width: 0.75rem;\n  background-color: var(--steps-contrast-color);\n  border-color: var(--steps-xs-circle-border);\n}\n.steps-xs .steps-step.step-complete .step-circle {\n  background-color: var(--steps-xs-complete);\n  border-color: var(--steps-xs-complete);\n}\n.steps-xs .steps-step.step-active .step-circle {\n  border-color: var(--steps-xs-circle-active-border);\n}\n.steps-xs .steps-step.step-error .step-circle {\n  border-color: var(--steps-danger-color);\n}\n.steps-xs .steps-step.step-warning .step-circle {\n  border-color: var(--steps-warning-color);\n}\n.steps-xs .step-action.step-normal:not(:disabled):hover .step-circle {\n  background-color: transparent;\n  border-color: var(--steps-incomplete-circle-hover-bg);\n}\n\n.steps-alignment-left .steps-step {\n  text-align: left;\n}\n.steps-alignment-left .step-left-line {\n  display: none;\n}\n.steps-alignment-left .step-right-line {\n  margin: 0 0.625rem;\n}\n.steps-alignment-left.steps-xs .step-right-line {\n  margin: 0;\n}\n\n.steps-tabbed .steps-step {\n  display: flex;\n  background-color: var(--steps-tabbed-background);\n  border: 1px solid var(--steps-tabbed-border);\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 20px;\n  flex-direction: row;\n}\n.steps-tabbed .steps-step + .steps-step {\n  margin-left: -1px;\n}\n.steps-tabbed .steps-step.step-active {\n  background-color: var(--steps-tabbed-background-active);\n  border-bottom-color: var(--steps-tabbed-active-border-bottom);\n}\n.steps-tabbed .step-text {\n  text-align: left;\n  margin: 0 !important;\n}\n.steps-tabbed .step-action:not(:disabled):hover {\n  border-bottom-color: var(--steps-tabbed-hover-border-bottom);\n}\n.steps-tabbed .step-action:focus-visible {\n  border-color: #304ffe;\n  z-index: 1;\n}\n.steps-tabbed .step-action:focus-visible .step-circle {\n  border-color: transparent;\n}\n\n.dark .steps {\n  --steps-contrast-color: #111111;\n  --steps-incomplete-track-color: #4b4b4b;\n  --steps-complete-track-color: #878787;\n  --steps-incomplete-circle-color: rgba(#fff, 0.84);\n  --steps-incomplete-circle-bg: #343434;\n  --steps-incomplete-circle-hover-bg: #fff;\n  --steps-active-circle-bg: #dedede;\n  --steps-success-color: #2ee68c;\n  --steps-warning-color: #ffee5c;\n  --steps-warning-text-color: #fff17a;\n  --steps-danger-color: #ff7591;\n  --steps-danger-text-color: #ff94aa;\n  --steps-progress-circle-bg: #343434;\n  --steps-circular-progress-color: #2ee68c;\n  --steps-circular-progress-background-color: #4b4b4b;\n  --steps-tabbed-background: #232323;\n  --steps-tabbed-background-active: #343434;\n  --steps-tabbed-border: #343434;\n  --steps-tabbed-active-border-bottom: #808080;\n  --steps-tabbed-hover-border-bottom: #cccccc;\n  --steps-xs-circle-border: #4b4b4b;\n  --steps-xs-circle-active-border: #878787;\n  --steps-xs-complete: #dedede;\n}\n\n.table {\n  --bs-table-cell-padding-y: 0.75rem;\n}\n.table,\n.table .table {\n  --bs-table-cell-square-width: 47px;\n}\n.table tfoot th,\n.table thead th {\n  font-size: 0.8125rem;\n  color: #111111;\n}\n.table thead th {\n  border-bottom: 1px solid #666666;\n}\n.table tbody {\n  font-size: 0.875rem;\n  line-height: 1.5714285714;\n}\n.table > tbody:not(caption) > :last-child > * {\n  border-bottom-width: 0;\n}\n.table > :not(:first-child) {\n  border-top: none;\n}\n\n.table-cell-square {\n  width: var(--bs-table-cell-square-width);\n  min-width: var(--bs-table-cell-square-width);\n}\n\nth .table-cell-square-icon {\n  bottom: var(--bs-table-cell-padding-y);\n}\n\ntd .table-cell-square-icon {\n  top: var(--bs-table-cell-padding-y);\n}\n\n.table-layout-fixed {\n  table-layout: fixed;\n}\n\n[class*=table-responsive] {\n  margin-bottom: 1rem;\n  overflow-y: hidden;\n}\n[class*=table-responsive] .table {\n  margin-bottom: 0;\n}\n\n.table .table {\n  --bs-table-bg: #f2f2f2;\n}\n.table .table thead th {\n  background-color: var(--bs-table-bg) !important;\n}\n\n.table-bordered .table-bordered {\n  margin: -1px;\n  width: calc(100% + 2px);\n}\n\n.table-header-borderless thead th {\n  border-bottom: none;\n}\n\n.table-striped {\n  --bs-table-bg: #f2f2f2;\n  --bs-table-hover-bg: rgba(17, 17, 17, 0.02);\n}\n.table-striped thead th {\n  background-color: #fff;\n}\n\n.table-striped-blue {\n  --bs-table-bg: #eef0f5;\n  --bs-table-striped-bg: #f6f8fd;\n}\n\n.table-striped-blue-and-white {\n  --bs-table-bg: #fff;\n  --bs-table-striped-bg: #f6f8fd;\n}\n\n.tr-blue {\n  --bs-table-bg: #f6f8fd;\n}\n\n.table-striped-gray-and-white {\n  --bs-table-bg: #fafafa;\n  --bs-table-striped-bg: #fff;\n}\n\n.table-heading-blue thead th {\n  background-color: #f6f8fd;\n  border-bottom: 1px solid #cccccc;\n}\n\n.table-heading-gray thead th {\n  background-color: #f2f2f2;\n  border-bottom: 1px solid #cccccc;\n}\n\n.table-sm {\n  --bs-table-cell-padding-y: 0.5rem;\n}\n.table-sm,\n.table-sm .table {\n  --bs-table-cell-square-width: 39px;\n}\n.table-sm tfoot th,\n.table-sm thead th {\n  font-size: 0.75rem;\n  line-height: 1.75;\n}\n.table-sm tbody {\n  font-size: 0.8125rem;\n  line-height: 1.7692307692;\n}\n.table-sm > :not(caption) > * > * {\n  padding: 0.5rem 0.75rem;\n}\n\n.table-lg {\n  --bs-table-cell-padding-y: 0.875rem;\n}\n.table-lg,\n.table-lg .table {\n  --bs-table-cell-square-width: 52px;\n}\n.table-lg tbody {\n  font-size: 0.9375rem;\n  line-height: 1.6;\n}\n.table-lg > :not(caption) > * > * {\n  padding: 0.875rem 0.9375rem;\n}\n\n.table-bordered,\n.table-bordered th,\n.table-bordered td {\n  border-color: #cccccc;\n}\n.table-bordered thead th {\n  border-color: #a1a1a1;\n  border-bottom-color: #404040;\n}\n\n.table-center {\n  text-align: center;\n}\n.table-center tr > th:first-child,\n.table-center tr > td:first-child {\n  text-align: left;\n}\n.table-center tr > th:last-child,\n.table-center tr > td:last-child {\n  text-align: right;\n}\n\n.table-col-2-left tr > th:nth-child(2),\n.table-col-2-left tr > td:nth-child(2) {\n  text-align: left;\n}\n\n.table-vertical-stack {\n  --bs-table-first-column-bg: #fafafa;\n  --bs-table-thead-th-color: rgba(17, 17, 17, 0.92);\n  --bs-table-color: rgba(17, 17, 17, 0.84);\n}\n.table-vertical-stack thead th {\n  border-bottom-color: #ccc;\n}\n.table-vertical-stack > :not(caption):not(thead) > tr > th:first-child {\n  background: var(--bs-table-first-column-bg);\n}\n.table-vertical-stack > :not(thead) th {\n  color: var(--bs-table-thead-th-color);\n}\n.table-vertical-stack tbody td {\n  color: var(--bs-table-color);\n}\n\n.table-vertical-stack-collapse.collapsed tr:nth-child(n+4) {\n  display: none;\n}\n.table-vertical-stack-collapse th {\n  color: #111111;\n}\n\n.table-column-sticky {\n  --table-column-sticky-shadow: 0 1.25rem 1.875rem rgba(35, 35, 35, 0.2);\n}\n@media (max-width: 767.98px) {\n  .table-column-sticky {\n    table-layout: fixed;\n  }\n  .table-column-sticky th {\n    white-space: nowrap;\n    width: 150px;\n  }\n  .table-column-sticky.table-row-selection th:first-child,\n  .table-column-sticky.table-row-selection td:first-child {\n    z-index: 2;\n  }\n  .table-column-sticky.table-row-selection th:first-child::after,\n  .table-column-sticky.table-row-selection td:first-child::after {\n    display: none;\n  }\n  .table-column-sticky.table-row-selection th:nth-child(2),\n  .table-column-sticky.table-row-selection td:nth-child(2) {\n    position: sticky;\n    left: 40px;\n    z-index: 1;\n  }\n  .table-column-sticky.table-row-selection th:nth-child(2)::after,\n  .table-column-sticky.table-row-selection td:nth-child(2)::after {\n    content: \"\";\n    position: absolute;\n    top: 1px;\n    right: 0;\n    height: 100%;\n    width: 100%;\n    box-shadow: var(--table-column-sticky-shadow);\n    z-index: -1;\n  }\n  .table-column-sticky.table-row-selection tr:last-child td:nth-child(2) {\n    overflow-y: clip;\n  }\n  .table-column-sticky th:first-child,\n  .table-column-sticky td:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 1;\n  }\n  .table-column-sticky th:first-child::after,\n  .table-column-sticky td:first-child::after {\n    content: \"\";\n    position: absolute;\n    top: 1px;\n    right: 0;\n    height: 100%;\n    width: 100%;\n    box-shadow: var(--table-column-sticky-shadow);\n    z-index: -1;\n  }\n  .table-column-sticky tr:last-child td:first-child {\n    overflow-y: clip;\n  }\n}\n\n.dark .table {\n  --bs-table-bg: #111111;\n  --bs-table-color: rgba(255, 255, 255, 0.64);\n  --bs-table-striped-color: rgba(255, 255, 255, 0.64);\n  --bs-table-striped-bg: #1f1f1f;\n  --bs-table-hover-bg: rgba(255, 255, 255, 0.05);\n  --bs-table-hover-color: rgba(255, 255, 255, 0.64);\n}\n.dark .table:not(caption) > * > * {\n  border-bottom: 1px solid #232323;\n}\n.dark .table thead th {\n  border-color: #b6b6b6;\n}\n.dark .table .table {\n  --bs-table-bg: #1f1f1f;\n}\n.dark .table-striped {\n  --bs-table-bg: #1f1f1f;\n  --bs-table-striped-bg: #141414;\n}\n.dark .table-striped thead th {\n  background-color: #111111;\n}\n.dark .table-striped-blue {\n  --bs-table-bg: #1e1f23;\n  --bs-table-striped-bg: #16181a;\n}\n.dark .table-striped-blue-and-white {\n  --bs-table-bg: #111111;\n  --bs-table-striped-bg: #16181a;\n}\n.dark .tr-blue {\n  --bs-table-bg: #16181a;\n}\n.dark .table-striped-gray-and-white {\n  --bs-table-bg: #141414;\n  --bs-table-striped-bg: #111111;\n}\n.dark .table-striped-gray-and-white thead th {\n  background: #1f1f1f;\n}\n.dark .table-heading-blue thead th {\n  background: #1e1f23;\n  border-bottom: 1px solid #404040;\n}\n.dark .table-heading-gray thead th {\n  background: #1f1f1f;\n  border-bottom: 1px solid #404040;\n}\n.dark .table-borderless:not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.dark .table-bordered,\n.dark .table-bordered th,\n.dark .table-bordered td {\n  border-color: #404040;\n}\n.dark .table-bordered:not(caption) > * > * {\n  border-bottom: 1px solid #404040;\n}\n.dark .table-bordered thead th {\n  border-color: #575757;\n}\n.dark tfoot th,\n.dark thead th {\n  color: rgba(255, 255, 255, 0.92);\n}\n.dark .table-vertical-stack {\n  --bs-table-first-column-bg: #141414;\n  --bs-table-thead-th-color: rgba(255, 255, 255, 0.92);\n  --bs-table-color: rgba(255, 255, 255, 0.84);\n}\n.dark .table-vertical-stack-collapse th {\n  color: rgba(255, 255, 255, 0.92);\n}\n.dark .table-column-sticky {\n  --table-column-sticky-shadow: 0 1.25rem 1.875rem rgba(0, 0, 0, 0.6);\n}\n\n.tooltip {\n  letter-spacing: 0.3px;\n}\n\n.tooltip-inner {\n  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);\n}\n\n.tooltip-lg {\n  font-size: 0.8125rem;\n  letter-spacing: 0.5px;\n}\n.tooltip-lg .tooltip-inner {\n  border-radius: 0.3125rem;\n  padding: 0.5625rem 1rem;\n}\n\n.bs-tooltip-top, .bs-tooltip-auto[data-popper-placement^=top] {\n  margin-bottom: 0.5rem;\n}\n\n.bs-tooltip-end, .bs-tooltip-auto[data-popper-placement^=right] {\n  margin-left: 0.5rem;\n}\n\n.bs-tooltip-bottom, .bs-tooltip-auto[data-popper-placement^=bottom] {\n  margin-top: 0.5rem;\n}\n\n.bs-tooltip-start, .bs-tooltip-auto[data-popper-placement^=left] {\n  margin-right: 0.5rem;\n}\n\n.tooltip-link.bs-tooltip-top, .tooltip-link.bs-tooltip-auto[data-popper-placement^=top] {\n  margin-bottom: 0.125rem;\n}\n.tooltip-link.bs-tooltip-end, .tooltip-link.bs-tooltip-auto[data-popper-placement^=right] {\n  margin-left: 0.125rem;\n}\n.tooltip-link.bs-tooltip-bottom, .tooltip-link.bs-tooltip-auto[data-popper-placement^=bottom] {\n  margin-top: 0.125rem;\n}\n.tooltip-link.bs-tooltip-start, .tooltip-link.bs-tooltip-auto[data-popper-placement^=left] {\n  margin-right: 0.125rem;\n}\n\n.tooltip-light,\n.dark .tooltip {\n  --bs-tooltip-bg: #fff;\n  --bs-tooltip-color: #111111;\n}\n\n.dark .tooltip-light {\n  --bs-tooltip-bg: #343434;\n  --bs-tooltip-color: #fff;\n}\n\n.toast-container {\n  padding: 1.375rem;\n}\n\n.toast-header {\n  font-size: 0.875rem;\n  letter-spacing: 0.3px;\n  line-height: 1.7142857143;\n  border-bottom: none;\n  padding: 1rem 1.25rem 0.75rem;\n}\n.toast-header + .toast-body {\n  padding: 0 1.25rem 1.25rem;\n}\n.toast-header small, .toast-header .small {\n  line-height: 2;\n}\n\n.toast-body {\n  display: flex;\n  align-items: flex-start;\n  letter-spacing: 0.2px;\n  padding: 1rem 1.25rem;\n  line-height: 1.5;\n}\n\n.toast-icon {\n  margin-right: 1px;\n  margin-left: -6px;\n  opacity: 0.8;\n}\n\n.toast .btn-close {\n  margin-top: -8px;\n  margin-left: 5px;\n  margin-right: -10px;\n  flex-shrink: 0;\n}\n\n.toast-border .toast-header {\n  border-bottom: 1px solid #404040;\n  padding: 0.5rem 1.25rem;\n}\n.toast-border .toast-header + .toast-body {\n  padding-top: 0.75rem;\n}\n.toast-border .btn-close {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.toast-header:only-child {\n  padding-top: 0.75rem;\n}\n.toast-header:only-child .btn-close {\n  margin-top: 0;\n}\n\n.toast-body:only-child .btn-close {\n  margin-top: -4px;\n}\n\n.toast-light,\n.dark .toast {\n  --bs-toast-bg: #fff;\n  --bs-toast-color: rgba(17, 17, 17, 0.64);\n  --bs-toast-header-color: #111111;\n}\n.toast-light .toast-header,\n.dark .toast .toast-header {\n  border-bottom-color: #dedede;\n}\n\n.dark .toast-light {\n  --bs-toast-bg: #232323;\n  --bs-toast-color: rgba(255, 255, 255, 0.64);\n  --bs-toast-header-color: #fff;\n}\n.dark .toast-light .toast-header {\n  border-bottom-color: #404040;\n}\n.dark .toast:not(.toast-light) .btn-close {\n  filter: none;\n}\n\n.tree-root {\n  background: var(--tree-background-color);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.tree-root ul,\n.tree-root li {\n  list-style-type: none;\n  text-indent: 0;\n  margin: 0;\n}\n.tree-root ul {\n  padding: 0;\n}\n\n.tree-sm .tree-node {\n  padding: 0.34375rem 0.9375rem;\n}\n.tree-sm .tree-label {\n  font-size: 0.875rem;\n}\n\n.tree-node-expand {\n  color: inherit;\n  opacity: 0.54;\n}\n\n.tree-node {\n  border: 1px solid transparent;\n  padding: 0.59375rem 0.9375rem;\n  cursor: pointer;\n  background: var(--tree-background-color);\n}\n.tree-node:not(.tree-node-disabled):hover {\n  background: var(--tree-hover-background-color);\n}\n.tree-node:not(.tree-node-disabled):hover .tree-node-expand,\n.tree-node:not(.tree-node-disabled):hover .tree-icon {\n  opacity: 0.9;\n}\n.tree-node:not(.tree-node-disabled):hover .tree-label {\n  opacity: 1;\n}\n\n.tree-node-focusable {\n  outline: none;\n}\n\nbutton.tree-node:focus-visible,\na.tree-node:focus-visible,\nli:focus-visible > .tree-node {\n  border-color: #304ffe;\n}\n\na.tree-node:hover {\n  text-decoration: none;\n}\n\n.tree-node-disabled {\n  cursor: not-allowed;\n}\n.tree-node-disabled .tree-node-expand,\n.tree-node-disabled .tree-icon,\n.tree-node-disabled .tree-label {\n  opacity: 0.5;\n}\n.tree-node-disabled:hover {\n  background: var(--tree-disabled-hover-background-color);\n}\n\n.tree-label {\n  font-size: 0.9375rem;\n  line-height: 1.25rem;\n  padding: 0.21875rem 0;\n  opacity: 0.64;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* number of lines to show */\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  text-align: left;\n}\n\n.tree-prefix {\n  width: 24px;\n  flex-shrink: 0;\n}\n\n.tree-indicator-spacing {\n  width: 16px;\n  flex-shrink: 0;\n}\n\n.tree-vertical-line {\n  position: absolute;\n  z-index: 1;\n  align-self: center;\n  width: 1px;\n  background: var(--tree-indicator-color);\n}\n.tree-vertical-line.tree-node-full-height {\n  height: calc(100% + 2px);\n  top: 0;\n  bottom: 0;\n}\n.tree-vertical-line.tree-node-bottom-half {\n  height: calc(50% - 12px);\n  bottom: -2px;\n}\n\n.tree-icon {\n  opacity: 0.54;\n}\n\n.tree-is-above {\n  border-top-color: #304ffe;\n}\n\n.tree-is-below {\n  border-bottom-color: #304ffe;\n  margin-bottom: -1px;\n  position: relative;\n  padding-bottom: 0.65625rem;\n}\n\n.tree-sm .tree-is-below {\n  padding-bottom: 0.40625rem;\n}\n\n.tree-node-notification {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 18px;\n  height: 18px;\n  line-height: 0;\n  font-size: 0.5625rem;\n  padding: 0 0.37625rem;\n  background-color: var(--tree-notification-background-color);\n  color: var(--tree-notification-text-color);\n  border-radius: var(--bs-border-radius-pill);\n}\n\n.tree-notification-badge {\n  font-weight: 400;\n  padding: 0.33333em 0.7em !important;\n}\n\n.tree-spacer {\n  background: var(--tree-background-color);\n  min-height: 10px;\n  border: 1px solid transparent;\n}\n.tree-spacer.tree-is-over {\n  border-top-color: #304ffe;\n}\n\n:root,\n[data-bs-theme=light],\n.light {\n  --tree-background-color: #fff;\n  --tree-hover-background-color: #f2f2f2;\n  --tree-disabled-hover-background-color: #fafafa;\n  --tree-notification-background-color: #111111;\n  --tree-notification-text-color: #fff;\n  --tree-indicator-color: #dedede;\n}\n\n[data-bs-theme=dark],\n.dark {\n  --tree-background-color: #111111;\n  --tree-hover-background-color: #343434;\n  --tree-disabled-hover-background-color: #232323;\n  --tree-notification-background-color: #ededed;\n  --tree-notification-text-color: #111111;\n  --tree-indicator-color: #404040;\n}\n\n.nav {\n  --bs-nav-tabs-link-active-color: rgba(17, 17, 17, 0.84);\n  letter-spacing: 0.3px;\n}\n\n.nav-link {\n  line-height: 2;\n}\n.nav-link svg {\n  color: #111111;\n  opacity: 0.54;\n  transition: opacity 0.15s ease-in-out, color 0.15s ease-in-out;\n}\n.nav-link svg:first-child:not(:only-child) {\n  margin-right: 0.3125rem;\n}\n.nav-link:focus, .nav-link:focus-within {\n  outline: 0;\n}\n.nav-link.active {\n  color: var(--bs-nav-tabs-link-active-color);\n}\n.nav-link.active svg {\n  opacity: 0.8;\n}\n.nav-link:hover {\n  color: var(--bs-nav-link-hover-color);\n}\n.nav-link:hover svg {\n  opacity: 0.9;\n}\n.nav-link:focus-visible {\n  color: var(--bs-nav-link-color);\n}\n.nav-link.disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: auto;\n  cursor: not-allowed;\n}\n.nav-link.disabled svg {\n  opacity: 0.4;\n}\n\n.tab-content-vertical {\n  border-left: 1px solid #ededed;\n  background: #fff;\n}\n\n.nav-tabs-column {\n  min-width: 15.9375rem;\n  background: #fff;\n}\n\n[class=nav] .nav-link:focus-visible,\n[class=\"nav flex-column\"] .nav-link:focus-visible {\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.nav-tabs {\n  --bs-nav-tabs-bg-color: #fff;\n  --bs-nav-tabs-focus-border-color: #304ffe #304ffe transparent;\n  background-color: var(--bs-nav-tabs-bg-color);\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  position: relative;\n}\n.nav-tabs .nav-link.active {\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-tabs .nav-link:not(.disabled):hover {\n  color: var(--bs-nav-link-hover-color);\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n  z-index: 2;\n}\n.nav-tabs .nav-link:not(.disabled):focus-visible {\n  border-color: var(--bs-nav-tabs-focus-border-color) !important;\n  z-index: 1;\n}\n.nav-tabs:not(.flex-column) .nav-item + .nav-item,\n.nav-tabs:not(.flex-column) .nav-link + .nav-link {\n  margin-left: -1px;\n}\n.nav-tabs + .tab-content {\n  --bs-nav-tabs-border-color: #cccccc;\n  border: 1px solid var(--bs-nav-tabs-border-color);\n  border-top: 0;\n}\n.nav-tabs.flex-column {\n  --bs-nav-tabs-link-hover-border-color: #111111 transparent #111111 #111111;\n  --bs-nav-tabs-link-active-border-color: #cccccc transparent #cccccc #cccccc;\n  --bs-nav-tabs-focus-border-color: #304ffe transparent #304ffe #304ffe;\n  border-bottom: 0;\n}\n.nav-tabs.flex-column .nav-link {\n  margin-right: calc(-1 * var(--bs-nav-tabs-border-width));\n}\n\n.nav-tabs + .tab-content-vertical {\n  border: 1px solid #cccccc;\n}\n\n.nav-standard {\n  --bs-nav-standard-border-color: #cccccc;\n  --bs-nav-standard-focus-border-color: #304ffe;\n  --bs-nav-standard-link-bg-color: #fff;\n  --bs-nav-standard-link-border-color: transparent;\n  --bs-nav-standard-link-active-border-color: #a1a1a1;\n  --bs-nav-standard-link-hover-border-color: #111111;\n  border-bottom: 1px solid var(--bs-nav-standard-border-color);\n}\n.nav-standard .nav-link {\n  background-color: var(--bs-nav-standard-link-bg-color);\n  border: 1px solid var(--bs-nav-standard-link-border-color);\n}\n.nav-standard .nav-link.active {\n  border-bottom-color: var(--bs-nav-standard-link-active-border-color);\n}\n.nav-standard .nav-link:not(.disabled):hover {\n  border-bottom-color: var(--bs-nav-standard-link-hover-border-color);\n}\n.nav-standard .nav-link:not(.disabled):focus-visible {\n  border-color: var(--bs-nav-standard-focus-border-color) !important;\n}\n.nav-standard.flex-column {\n  border-bottom: 0;\n}\n.nav-standard.flex-column .nav-link {\n  border-bottom-color: transparent;\n}\n.nav-standard.flex-column .nav-link.active {\n  border-left-color: var(--bs-nav-standard-link-active-border-color);\n}\n.nav-standard.flex-column .nav-link:not(.disabled):hover {\n  border-bottom-color: transparent;\n  border-left-color: var(--bs-nav-standard-link-hover-border-color);\n}\n\n.nav-pills {\n  --bs-nav-pills-bg-link-color: #fff;\n  --bs-nav-link-color: rgba(17, 17, 17, 0.84);\n  --bs-nav-pills-border-color: #fff;\n  --bs-nav-pills-hover-bg-color: #111111;\n  --bs-nav-pills-hover-border-color: #111111;\n  --bs-nav-pills-hover-color: #fff;\n  --bs-nav-pills-hover-focus-color: #fff;\n  --bs-nav-pills-active-icon-color: #fff;\n}\n.nav-pills .nav-link {\n  background-color: var(--bs-nav-pills-bg-link-color);\n  border: 1px solid var(--bs-nav-pills-border-color);\n}\n.nav-pills .nav-link.active {\n  border-color: var(--bs-nav-pills-link-active-bg);\n  color: var(--bs-nav-pills-link-active-color);\n}\n.nav-pills .nav-link.active svg {\n  color: var(--bs-nav-pills-active-icon-color);\n}\n.nav-pills .nav-link:not(.disabled):hover {\n  background-color: var(--bs-nav-pills-hover-bg-color);\n  border-color: var(--bs-nav-pills-hover-border-color);\n  color: var(--bs-nav-pills-hover-color);\n}\n.nav-pills .nav-link:not(.disabled):hover svg {\n  color: var(--bs-nav-pills-hover-color);\n}\n.nav-pills .nav-link:not(.disabled):focus-visible {\n  border-color: #304ffe;\n}\n\n.nav-boxed {\n  --bs-nav-boxed-bg-color: #fafafa;\n  --bs-nav-boxed-link-bg-color: #fafafa;\n  --bs-nav-boxed-link-focus-border-color: #304ffe;\n  --bs-nav-boxed-link-focus-color: #f2f2f2;\n  --bs-nav-boxed-link-hover-border-color: #111111;\n  --bs-nav-boxed-link-hover-bg-color: #f2f2f2;\n  --bs-nav-boxed-link-active-bg: #f7f7f7;\n  --bs-nav-boxed-link-active-border-color: #a1a1a1;\n  background: var(--bs-nav-boxed-bg-color) !important;\n}\n.nav-boxed .nav-link {\n  background-color: var(--bs-nav-boxed-link-bg-color);\n  border: 1px solid var(--bs-nav-boxed-link-bg-color);\n  border-bottom-color: transparent;\n}\n.nav-boxed .nav-link.active {\n  background-color: var(--bs-nav-boxed-link-active-bg);\n  border-color: var(--bs-nav-boxed-link-active-bg);\n  border-bottom-color: var(--bs-nav-boxed-link-active-border-color);\n}\n.nav-boxed .nav-link:not(.disabled):hover {\n  background-color: var(--bs-nav-boxed-link-hover-bg-color);\n  border-color: var(--bs-nav-boxed-link-hover-bg-color);\n  border-bottom-color: var(--bs-nav-boxed-link-hover-border-color);\n}\n.nav-boxed .nav-link:not(.disabled):focus-visible {\n  border-color: var(--bs-nav-boxed-link-focus-border-color) !important;\n  color: var(--bs-nav-link-focus-color);\n}\n.nav-boxed.flex-column .nav-link {\n  border-bottom-color: transparent;\n}\n.nav-boxed.flex-column .nav-link.active {\n  border-left-color: var(--bs-nav-boxed-link-active-border-color);\n}\n.nav-boxed.flex-column .nav-link:not(.disabled):hover {\n  border-bottom-color: transparent;\n  border-left-color: var(--bs-nav-boxed-link-hover-border-color);\n}\n\n.nav-bordered {\n  --bs-nav-tabs-link-active-border-color: #a1a1a1;\n  --bs-nav-tabs-link-bg-color: #fff;\n  --bs-nav-tabs-link-border-color: #dedede;\n  --bs-nav-tabs-link-focus-border-color: #304ffe;\n  --bs-nav-tabs-link-hover-border-color: #111111;\n}\n.nav-bordered .nav-item:first-child .nav-link {\n  border-left-color: var(--bs-nav-tabs-link-border-color);\n}\n.nav-bordered .nav-link {\n  background-color: var(--bs-nav-tabs-link-bg-color);\n  border: 1px solid var(--bs-nav-tabs-link-border-color);\n  border-left-color: var(--bs-nav-tabs-link-bg-color);\n}\n.nav-bordered .nav-link.active {\n  border-bottom-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-bordered .nav-link:not(.disabled):hover {\n  border-bottom-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.nav-bordered .nav-link:not(.disabled):focus-visible {\n  border-color: var(--bs-nav-tabs-link-focus-border-color) !important;\n  color: var(--bs-nav-link-color);\n}\n.nav-bordered.flex-column .nav-item:first-child .nav-link {\n  border-top: 1px solid var(--bs-nav-tabs-link-border-color);\n}\n.nav-bordered.flex-column .nav-link {\n  border-left-color: var(--bs-nav-tabs-link-border-color);\n  border-top-color: transparent;\n  border-right-color: transparent;\n}\n.nav-bordered.flex-column .nav-link.active {\n  border-left-color: var(--bs-nav-tabs-link-active-border-color);\n  border-bottom-color: var(--bs-nav-tabs-link-border-color);\n}\n.nav-bordered.flex-column .nav-link:hover {\n  border-left-color: var(--bs-nav-tabs-link-hover-border-color);\n  border-bottom-color: var(--bs-nav-tabs-link-border-color);\n}\n\n.nav-bordered + .tab-content-vertical {\n  border-left-color: #dedede;\n}\n\n.nav-elevated {\n  --bs-nav-elevated-box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);\n  --bs-nav-elevated-nav-link-active-box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);\n  --bs-nav-elevated-link-bg-color: #fff;\n  flex-shrink: 0;\n  overflow: hidden;\n  box-shadow: var(--bs-nav-elevated-box-shadow);\n}\n.nav-elevated:not(.nav-justified):not(.flex-column) {\n  display: inline-flex;\n}\n.nav-elevated .nav-link {\n  background-color: var(--bs-nav-elevated-link-bg-color);\n  border: 1px solid var(--bs-nav-elevated-link-bg-color);\n}\n.nav-elevated .nav-link:not(.disabled):focus-visible {\n  border-color: #304ffe;\n  color: var(--bs-nav-link-color);\n}\n.nav-elevated .nav-link.active {\n  box-shadow: var(--bs-nav-elevated-nav-link-active-box-shadow);\n  position: relative;\n  z-index: 1;\n}\n.nav-elevated + .tab-content {\n  --bs-nav-elevated-tab-content-box-shadow: 0 0 1rem rgba(35, 35, 35, 0.2);\n  --bs-nav-tabs-bg-color: #fff;\n  background: var(--bs-nav-tabs-bg-color);\n  box-shadow: var(--bs-nav-elevated-tab-content-box-shadow);\n  position: relative;\n}\n.nav-elevated + .tab-content-vertical {\n  box-shadow: 0 1.25rem 1.875rem 0 rgba(35, 35, 35, 0.08);\n  border: 0;\n}\n.nav-elevated.flex-column {\n  --bs-nav-elevated-nav-link-active-box-shadow: 0 0.5rem 1.25rem 0 rgba(35, 35, 35, 0.2);\n  box-shadow: none;\n}\n\n.dark .nav-link {\n  --bs-nav-tabs-link-active-color: rgba(255, 255, 255, 0.84);\n  --bs-nav-link-hover-color: #fff;\n  --bs-nav-link-color: rgba(255, 255, 255, 0.64);\n  --bs-nav-link-disabled-color: rgba(255, 255, 255, 0.4);\n}\n.dark .nav-link svg {\n  color: #fff;\n}\n.dark .tab-content-vertical {\n  border-left-color: #343434;\n  background: #232323;\n}\n.dark .nav-tabs-column {\n  background: #232323;\n}\n.dark .nav-tabs {\n  --bs-nav-tabs-active-color: rgba(17, 17, 17, 0.84);\n  --bs-nav-tabs-bg-color: #232323;\n  --bs-nav-tabs-border-color: #575757;\n  --bs-nav-tabs-link-hover-border-color: #cccccc #cccccc transparent;\n  --bs-nav-tabs-link-active-bg: #232323;\n  --bs-nav-tabs-link-active-border-color: #575757 #575757 transparent;\n}\n.dark .nav-tabs.flex-column {\n  --bs-nav-tabs-link-hover-border-color: #cccccc transparent #cccccc #cccccc;\n  --bs-nav-tabs-link-active-border-color: #575757 transparent #575757 #575757;\n}\n.dark .nav-tabs + .tab-content {\n  --bs-nav-tabs-border-color: #575757;\n}\n.dark .nav-tabs + .tab-content-vertical {\n  border-color: #575757;\n}\n.dark .nav-standard {\n  --bs-nav-standard-link-bg-color: #232323;\n  --bs-nav-standard-border-color: #343434;\n  --bs-nav-standard-link-active-border-color: #808080;\n  --bs-nav-standard-link-hover-border-color: #cccccc;\n}\n.dark .nav-pills {\n  --bs-nav-pills-link-active-bg: #434343;\n  --bs-nav-pills-link-active-color: rgba(255, 255, 255, 0.92);\n  --bs-nav-pills-bg-link-color: #232323;\n  --bs-nav-pills-border-color: #232323;\n  --bs-nav-pills-hover-bg-color: #fff;\n  --bs-nav-pills-hover-border-color: #fff;\n  --bs-nav-pills-hover-color: #111111;\n  --bs-nav-pills-hover-focus-color: #111111;\n}\n.dark .nav-boxed {\n  --bs-nav-boxed-bg-color: #1e1e1e;\n  --bs-nav-boxed-link-bg-color: #1e1e1e;\n  --bs-nav-boxed-link-focus-color: rgba(255, 255, 255, 0.64);\n  --bs-nav-boxed-link-hover-border-color: #cccccc;\n  --bs-nav-boxed-link-hover-bg-color: #343434;\n  --bs-nav-boxed-link-active-bg: #232323;\n  --bs-nav-boxed-link-active-border-color: #808080;\n}\n.dark .nav-boxed + .tab-content-vertical {\n  border-left-color: #1e1e1e;\n}\n.dark .nav-bordered {\n  --bs-nav-tabs-link-active-border-color: #808080;\n  --bs-nav-tabs-link-bg-color: #232323;\n  --bs-nav-tabs-link-border-color: #343434;\n  --bs-nav-tabs-link-hover-border-color: #cccccc;\n}\n.dark .nav-elevated {\n  --bs-nav-elevated-box-shadow: 0 0.75rem 1rem rgba(17, 17, 17, 0.5);\n  --bs-nav-elevated-nav-link-active-box-shadow: 0 0.75rem 1rem rgba(9, 9, 9, 0.64);\n  --bs-nav-elevated-link-bg-color: #232323;\n}\n.dark .nav-elevated + .tab-content {\n  --bs-nav-elevated-tab-content-box-shadow: 0 0 1rem rgba(9, 9, 9, 0.64);\n  --bs-nav-tabs-bg-color: #232323;\n}\n.dark .nav-elevated.flex-column {\n  --bs-nav-elevated-nav-link-active-box-shadow: 0 0.5rem 1.25rem rgba(9, 9, 9, 0.64);\n  background: #111111;\n}\n.dark .nav-elevated + .tab-content-vertical {\n  box-shadow: 0 0.75rem 1rem rgba(17, 17, 17, 0.5);\n}\n\n.offcanvas-sidebar {\n  z-index: 1029;\n}\n\n.offcanvas-backdrop-sidebar {\n  z-index: 1028;\n}\n\n.nav-sidebar-header {\n  text-transform: uppercase;\n  letter-spacing: 0.05625rem;\n  font-size: 0.75rem;\n  padding: 0.5rem 1.875rem;\n  margin-bottom: 0.125rem;\n}\n\n.nav-sidebar {\n  width: 20rem;\n  background-color: #fff;\n  overflow-y: auto;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n.dark .nav-sidebar {\n  background-color: #111111;\n}\n.nav-sidebar .list-unstyled > li {\n  margin-top: 1rem;\n}\n.nav-sidebar .nav {\n  --bs-nav-link-hover-bg-color: #111111;\n  --bs-nav-link-hover-color: #fff;\n}\n.nav-sidebar .nav.flex-column .nav-link {\n  padding: 0.5rem 1.875rem;\n  position: relative;\n  border: 1px solid transparent;\n}\n.nav-sidebar .nav.flex-column .nav-link.active {\n  background-color: #f2f2f2;\n}\n.dark .nav-sidebar .nav.flex-column .nav-link.active {\n  background-color: #232323;\n}\n.nav-sidebar .nav.flex-column .nav-link:not(.disabled):hover {\n  background: var(--bs-nav-link-hover-bg-color) !important;\n  color: var(--bs-nav-link-hover-color);\n}\n.nav-sidebar .nav.flex-column .nav-link:not(.disabled):hover .nav-link-icon {\n  color: var(--bs-nav-link-hover-color);\n}\n.nav-sidebar .nav.flex-column .nav-link:focus {\n  color: var(--bs-nav-link-color);\n}\n.nav-sidebar .nav.flex-column .nav-link:focus-visible {\n  border-color: #304ffe !important;\n  box-shadow: none;\n  outline: 0;\n}\n.nav-sidebar .nav.flex-column .nav-link .avatar:first-child {\n  margin-right: 0.75rem;\n}\n.nav-sidebar .nav.flex-column .flex-column .nav-link {\n  padding-left: 3.125rem;\n}\n.nav-sidebar .nav.flex-column .flex-column .flex-column .nav-link {\n  padding-left: 4.375rem;\n}\n.nav-sidebar .nav.flex-column .nav-item-icon .flex-column .nav-link {\n  padding-left: 5rem;\n}\n.nav-sidebar .nav.flex-column .nav-item-icon .flex-column .flex-column .nav-link {\n  padding-left: 6.875rem;\n}\n\n.nav-link-accordion {\n  display: flex;\n  align-items: center;\n}\n.nav-link-accordion::before {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  width: 0;\n  height: 85%;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  transition: background-color 300ms, width 300ms;\n}\n.nav-link-accordion.active {\n  background-color: transparent !important;\n}\n.nav-link-accordion.active::before {\n  background-color: #111111;\n  width: 2px;\n}\n.dark .nav-link-accordion.active::before {\n  background-color: #fff;\n}\n.nav-link-accordion + div .nav-link-accordion::before {\n  content: none;\n}\n\n.user-profile {\n  display: flex;\n  align-items: center;\n  padding: 1.5rem 1.875rem;\n}\n\n.user-name {\n  font-size: 0.9375rem;\n  line-height: 1.3333333333;\n  opacity: 0.84;\n}\n\n.user-contact {\n  font-size: 0.875rem;\n  line-height: 1.4285714286;\n  opacity: 0.64;\n}\n\n.nav-sidebar .nav-pills {\n  --bs-nav-pills-border-radius: 0.3125rem;\n  --bs-nav-pills-link-active-color: #111111;\n}\n.nav-sidebar .nav-pills .nav-link {\n  background: transparent;\n}\n.nav-sidebar .nav-pills .nav-link-accordion::before {\n  content: none;\n}\n.nav-sidebar .nav-pills .nav-item + .nav-item,\n.nav-sidebar .nav-pills .nav-link-accordion + div {\n  margin-top: 0.125rem;\n}\n.nav-sidebar .nav-pills.nav.flex-column .nav-link {\n  padding: 0.3125rem 0.9375rem;\n}\n.nav-sidebar .nav-pills.nav.flex-column .flex-column .nav-link {\n  padding-left: 2.25rem;\n}\n.nav-sidebar .nav-pills.nav.flex-column .flex-column .flex-column .nav-link {\n  padding-left: 3.5rem;\n}\n.nav-sidebar .nav-pills.nav.flex-column .nav-item-icon .flex-column .nav-link {\n  padding-left: 4rem;\n}\n.nav-sidebar .nav-pills.nav.flex-column .nav-item-icon .flex-column .flex-column .nav-link {\n  padding-left: 6rem;\n}\n\n.nav-sidebar-sm .nav.flex-column .nav-link {\n  font-size: 0.8125rem;\n  padding-top: 0.3125rem;\n  padding-bottom: 0.3125rem;\n}\n.nav-sidebar-sm .nav.flex-column .nav-link .avatar:first-child {\n  margin-right: 0.625rem;\n}\n.nav-sidebar-sm .nav-pills.nav.flex-column .nav-link {\n  padding-top: 0.1875rem;\n  padding-bottom: 0.1875rem;\n}\n.nav-sidebar-sm .user-profile {\n  padding: 1.25rem 1.875rem;\n}\n.nav-sidebar-sm .user-name {\n  font-size: 0.875rem;\n}\n.nav-sidebar-sm .user-contact {\n  display: none;\n}\n\n.nav-sidebar-lg .nav.flex-column .nav-link {\n  font-size: 0.9375rem;\n  padding-top: 0.625rem;\n  padding-bottom: 0.625rem;\n}\n.nav-sidebar-lg .nav-pills.nav.flex-column .nav-link {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.nav-sidebar-lg .user-profile {\n  padding: 1.875rem;\n}\n.nav-sidebar-lg .user-name {\n  font-size: 1rem;\n}\n.nav-sidebar-lg .user-contact {\n  font-size: 0.9375rem;\n}\n\n.dark .nav-sidebar .nav-link {\n  --bs-nav-link-hover-bg-color: #fff;\n  --bs-nav-link-hover-color: #111111;\n}\n.dark .nav-sidebar .nav-pills {\n  --bs-nav-pills-link-active-color: #fff;\n}\n\n.navbar {\n  background-color: #fff;\n  font-size: 0.875rem;\n}\n.navbar > [class*=container-fluid] {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n.navbar .nav-link > span,\n.navbar .dropdown-item > span {\n  position: relative;\n}\n.navbar .nav-link > span::after,\n.navbar .dropdown-item > span::after {\n  content: \"\";\n  position: absolute;\n  bottom: -0.3125rem;\n  height: 0.0625rem;\n  background-color: transparent;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  transition: background-color 0.15s ease-in-out;\n}\n.navbar .nav-link.active > span::after,\n.navbar .nav-item.show > .nav-link > span::after,\n.navbar .dropdown-item.active > span::after {\n  background-color: #a1a1a1;\n}\n.dark .navbar .nav-link.active > span::after,\n.dark .navbar .nav-item.show > .nav-link > span::after,\n.dark .navbar .dropdown-item.active > span::after {\n  background-color: #808080;\n}\n.navbar .nav-link:focus-visible,\n.navbar .dropdown-item:focus-visible {\n  outline: none;\n}\n.navbar .nav-link:focus-visible > span::after,\n.navbar .dropdown-item:focus-visible > span::after {\n  background-color: #304ffe;\n}\n.navbar .nav-link:hover > span::after,\n.navbar .dropdown-item:hover > span::after {\n  background-color: #111111;\n}\n.dark .navbar .nav-link:hover > span::after,\n.dark .navbar .dropdown-item:hover > span::after {\n  background-color: #cccccc;\n}\n.navbar .dropdown-item {\n  background-color: transparent;\n}\n.navbar .dropdown-item > span::after {\n  bottom: 2px;\n}\n.navbar .dropdown-menu-lg .dropdown-item > span::after {\n  bottom: 6px;\n}\n.navbar .dropdown-menu {\n  border: 1px solid #ededed;\n}\n.dark .navbar .dropdown-menu {\n  border-color: #404040;\n}\n.navbar .dropdown-btn-item svg {\n  opacity: 0.64;\n}\n.navbar .dropdown-btn-item > div {\n  opacity: 0.84;\n}\n.navbar .dropdown-btn-item:hover {\n  background: #fafafa;\n}\n.navbar .dropdown-btn-item:hover svg,\n.navbar .dropdown-btn-item:hover > div {\n  opacity: 1;\n}\n\n.btn-navbar-nine-dot {\n  --btn-navbar-nine-dot-hover-bg: #fafafa;\n  --btn-navbar-nine-dot-hover-border-color: #111111;\n  --btn-navbar-nine-dot-hover-color: #111111;\n  --btn-navbar-nine-dot-active-bg: #fafafa;\n  --btn-navbar-nine-dot-active-border-color: #a1a1a1;\n  background: transparent;\n  border: 0;\n  border-bottom: 1px solid transparent !important;\n}\n.btn-navbar-nine-dot + .dropdown-menu {\n  width: 320px;\n}\n@media (min-width: 430px) {\n  .btn-navbar-nine-dot + .dropdown-menu {\n    width: 405px;\n  }\n}\n.btn-navbar-nine-dot svg {\n  color: inherit;\n}\n.btn-navbar-nine-dot:hover {\n  background: var(--btn-navbar-nine-dot-hover-bg);\n  border-bottom: 1px solid var(--btn-navbar-nine-dot-hover-border-color) !important;\n  color: var(--btn-navbar-nine-dot-hover-color);\n}\n.btn-navbar-nine-dot:focus-visible {\n  border-bottom-color: #304ffe !important;\n}\n.dropdown.show > .btn-navbar-nine-dot {\n  background: var(--btn-navbar-nine-dot-active-bg);\n  border-bottom: 1px solid var(--btn-navbar-nine-dot-active-border-color) !important;\n  color: var(--btn-navbar-nine-dot-hover-color);\n}\n.dropdown.show > .btn-navbar-nine-dot svg {\n  opacity: 0.9;\n}\n.dropdown:has(.btn-navbar-nine-dot) {\n  margin-left: -1.25rem;\n  margin-right: 1.25rem;\n}\n\n.navbar-border {\n  border-bottom: 1px solid #dedede;\n}\n.dark .navbar-border {\n  border-color: #404040;\n}\n\n.navbar-elevation {\n  box-shadow: 0 0.5625rem 0.875rem rgba(35, 35, 35, 0.14);\n  z-index: 2;\n}\n.dark .navbar-elevation {\n  box-shadow: 0 0.5625rem 0.875rem #000;\n}\n\n.navbar-nav.nav-pills {\n  --bs-nav-pills-link-active-color: #111111;\n  --bs-nav-pills-link-active-bg: #f2f2f2;\n}\n.dark .navbar-nav.nav-pills {\n  --bs-nav-pills-link-active-color: #fff;\n}\n.navbar-nav.nav-pills .nav-link {\n  padding: 0.375rem 0.75rem;\n  border-color: transparent;\n}\n.dark .navbar-nav.nav-pills .nav-link {\n  background-color: transparent;\n}\n.dark .navbar-nav.nav-pills .nav-link.active {\n  background-color: #232323;\n}\n.dark .navbar-nav.nav-pills .nav-link:hover {\n  background-color: #fff;\n}\n.navbar-nav.nav-pills .nav-item + .nav-item {\n  margin-left: 0.125rem;\n}\n\n.navbar-notification {\n  background-color: #111111;\n  color: #fff;\n  border-radius: var(--bs-border-radius-pill);\n  font-size: 0.5625rem;\n  line-height: 1.1111111111;\n  padding: 0.25rem 0.4375rem;\n  text-align: center;\n}\n.navbar-notification.position-absolute {\n  border: 2px solid #fff;\n}\n\n.dropdown-mega-menu .nav-col-title {\n  font-size: 0.8125rem;\n  line-height: 1.4615384615;\n  color: rgba(17, 17, 17, 0.92);\n}\n.dropdown-mega-menu .nav-link {\n  padding-left: 0 !important;\n  line-height: 1.4285714286;\n}\n\n.dark .navbar {\n  --bs-navbar-color: rgba(255, 255, 255, 0.64);\n  --bs-navbar-brand-color: #fff;\n  --bs-navbar-brand-hover-color: #fff;\n  --bs-navbar-active-color: rgba(255, 255, 255, 0.92);\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  background-color: #111111;\n}\n.dark .navbar .dropdown-btn-item {\n  background: #232323;\n}\n.dark .navbar .dropdown-btn-item:hover {\n  background: #343434;\n}\n.dark .btn-navbar-nine-dot {\n  --btn-navbar-nine-dot-hover-bg: #232323;\n  --btn-navbar-nine-dot-hover-border-color: #cccccc;\n  --btn-navbar-nine-dot-hover-color: #fff;\n  --btn-navbar-nine-dot-active-bg: #232323;\n  --btn-navbar-nine-dot-active-border-color: #808080;\n}\n.dark .navbar-notification {\n  background-color: #ededed;\n  color: #111111;\n}\n.dark .navbar-notification.position-absolute {\n  border-color: #232323;\n}\n.dark .dropdown-mega-menu .nav-col-title {\n  color: #fff;\n}\n\n.navbar-brand img {\n  max-height: 62px;\n}\n\n.navbar-sm {\n  --bs-navbar-nav-link-padding-x: 0.46875rem;\n  font-size: 0.8125rem;\n}\n.navbar-sm .nav-link {\n  --bs-nav-link-font-size: 0.8125rem;\n}\n.navbar-sm .navbar-brand img {\n  max-height: 54px;\n}\n.navbar-sm .navbar-notification {\n  padding: 0.125rem 0.3125rem;\n}\n\n.navbar-lg {\n  --bs-navbar-padding-y: 0.6875rem;\n  --bs-navbar-nav-link-padding-x: 0.78125rem;\n  font-size: 0.9375rem;\n}\n.navbar-lg .nav-link {\n  --bs-nav-link-font-size: 0.9375rem;\n}\n.navbar-lg .navbar-brand img {\n  max-height: 66px;\n}\n\n.navbar-expand-xs .dropdown-menu {\n  left: var(--bs-navbar-nav-link-padding-x);\n  border: none;\n  box-shadow: none;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm .dropdown-menu {\n    left: var(--bs-navbar-nav-link-padding-x);\n  }\n}\n@media (max-width: 575.98px) {\n  .navbar-expand-sm .dropdown-menu {\n    border: none;\n    box-shadow: none;\n  }\n}\n\n@media (min-width: 768px) {\n  .navbar-expand-md .dropdown-menu {\n    left: var(--bs-navbar-nav-link-padding-x);\n  }\n}\n@media (max-width: 767.98px) {\n  .navbar-expand-md .dropdown-menu {\n    border: none;\n    box-shadow: none;\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar-expand-lg .dropdown-menu {\n    left: var(--bs-navbar-nav-link-padding-x);\n  }\n}\n@media (max-width: 991.98px) {\n  .navbar-expand-lg .dropdown-menu {\n    border: none;\n    box-shadow: none;\n  }\n}\n\n@media (min-width: 1200px) {\n  .navbar-expand-xl .dropdown-menu {\n    left: var(--bs-navbar-nav-link-padding-x);\n  }\n}\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl .dropdown-menu {\n    border: none;\n    box-shadow: none;\n  }\n}\n\n@media (min-width: 1400px) {\n  .navbar-expand-xxl .dropdown-menu {\n    left: var(--bs-navbar-nav-link-padding-x);\n  }\n}\n@media (max-width: 1399.98px) {\n  .navbar-expand-xxl .dropdown-menu {\n    border: none;\n    box-shadow: none;\n  }\n}\n\n.navbar-secondary {\n  padding: 0 0.625rem;\n  --bs-navbar-nav-link-padding-x: 0.625rem;\n}\n.navbar-secondary .navbar-nav {\n  --bs-nav-link-padding-y: 0.625rem;\n}\n.navbar-secondary.navbar-sm .navbar-nav {\n  --bs-nav-link-padding-y: 0.4375rem;\n}\n.navbar-secondary.navbar-elevation {\n  z-index: 1;\n}\n.navbar-secondary + .navbar-tabs {\n  padding: 0 0.3125rem;\n}\n\n.navbar-tabs {\n  --bs-navbar-nav-link-padding-x: 0.9375rem;\n  padding: 0;\n}\n.navbar-tabs .nav-item {\n  position: relative;\n}\n.navbar-tabs .nav-item .nav-link > span {\n  position: unset;\n}\n.navbar-tabs .nav-item .nav-link > span::after {\n  bottom: 0;\n}\n\n.progress {\n  --bs-progress-bg: var(--progress-bg);\n  --bs-progress-bar-bg: var(--progress-bar-bg);\n}\n\n.progress-dark {\n  --bs-progress-bg: var(--progress-dark-bg);\n  --bs-progress-bar-bg: var(--progress-dark-bar-bg);\n}\n\n.progress-brand {\n  --bs-progress-bg: var(--progress-brand-bg);\n  --bs-progress-bar-bg: var(--progress-brand-bar-bg);\n}\n\n:root,\n[data-bs-theme=light],\n.light {\n  --progress-bg: #ededed;\n  --progress-bar-bg: #767676;\n  --progress-dark-bg: #b6b6b6;\n  --progress-dark-bar-bg: #000000;\n  --progress-brand-bg: #ededed;\n  --progress-brand-bar-bg: #007f00;\n}\n\n[data-bs-theme=dark],\n.dark {\n  --progress-bg: #4b4b4b;\n  --progress-bar-bg: #878787;\n  --progress-dark-bg: #666666;\n  --progress-dark-bar-bg: #fcfcfc;\n  --progress-brand-bg: #404040;\n  --progress-brand-bar-bg: #ccff00;\n}\n\n.offcanvas {\n  --bs-offcanvas-close-margin-x: 0.625rem;\n  --bs-offcanvas-close-margin-calc: calc(\n    -1 * var(--bs-offcanvas-padding-x) + var(--bs-offcanvas-close-margin-x)\n  );\n}\n.offcanvas .btn-close-inline {\n  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));\n  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));\n}\n\n.offcanvas-shadow {\n  border: 0 !important;\n}\n.offcanvas-shadow.offcanvas-start {\n  box-shadow: 5px 0 20px 0 rgba(35, 35, 35, 0.14);\n}\n.offcanvas-shadow.offcanvas-end {\n  box-shadow: -5px 0 20px 0 rgba(35, 35, 35, 0.14);\n}\n.offcanvas-shadow.offcanvas-top {\n  box-shadow: 0 10px 20px 0 rgba(35, 35, 35, 0.08);\n}\n.offcanvas-shadow.offcanvas-bottom {\n  box-shadow: 0 -10px 20px 0 rgba(35, 35, 35, 0.08);\n}\n\n.offcanvas-header {\n  border-bottom: 1px solid var(--bs-offcanvas-border-color);\n}\n.offcanvas-header .btn-close-inline {\n  margin-right: var(--bs-offcanvas-close-margin-calc);\n}\n.offcanvas-header.flex-row-reverse .btn-close-inline {\n  margin-left: var(--bs-offcanvas-close-margin-calc);\n}\n\n.offcanvas-header-shadow {\n  box-shadow: 0 10px 20px 0 rgba(35, 35, 35, 0.08);\n}\n\n.offcanvas-title {\n  font-size: 1rem;\n}\n\n.btn-panel-xs {\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-padding-x: 0.625rem;\n  --bs-btn-padding-y: 0.875rem;\n}\n.btn-panel-xs .btn-label {\n  font-size: 0.75rem;\n  line-height: 1.75;\n  color: rgba(17, 17, 17, 0.64);\n}\n.btn-panel-xs:focus-visible {\n  border-color: #304ffe !important;\n}\n.btn-panel-xs.active svg, .btn-panel-xs:focus-visible svg {\n  opacity: 1 !important;\n}\n.btn-panel-xs.active .btn-label {\n  color: #000000;\n}\n.btn-panel-xs:focus-visible .btn-label {\n  color: #111111;\n}\n.btn-panel-xs:hover svg {\n  opacity: 0.7 !important;\n}\n.btn-panel-xs:hover .btn-label {\n  color: rgba(17, 17, 17, 0.84);\n}\n.btn-panel-xs.disabled, .btn-panel-xs:disabled {\n  border-color: transparent;\n  opacity: 1;\n}\n.btn-panel-xs.disabled svg, .btn-panel-xs:disabled svg {\n  opacity: 0.4 !important;\n}\n.btn-panel-xs.disabled .btn-label, .btn-panel-xs:disabled .btn-label {\n  color: rgba(17, 17, 17, 0.5);\n}\n\n.offcanvas-end .btn-panel-xs:not(:disabled):hover {\n  border-left-color: rgba(0, 0, 0, 0.52);\n}\n.offcanvas-end .btn-panel-xs.active {\n  border-left-color: #000000;\n}\n\n.offcanvas-start .btn-panel-xs:not(:disabled):hover {\n  border-right-color: rgba(0, 0, 0, 0.52);\n}\n.offcanvas-start .btn-panel-xs.active {\n  border-right-color: #000000;\n}\n\n.offcanvas-panel-xs {\n  --bs-offcanvas-width: 80px;\n  --bs-offcanvas-padding-y: 0;\n  --bs-offcanvas-padding-x: 0;\n}\n\n.offcanvas-panel-sm {\n  --bs-offcanvas-width: 256px;\n  --bs-offcanvas-padding-y: 1rem;\n  --bs-offcanvas-padding-x: 0.9375rem;\n}\n.offcanvas-panel-sm .offcanvas-title {\n  font-size: 0.8125rem;\n  line-height: 1.6923076923;\n}\n\n.offcanvas-panel-lg {\n  --bs-offcanvas-width: 400px;\n  --bs-offcanvas-padding-y: 1.25rem;\n  --bs-offcanvas-padding-x: 1.25rem;\n}\n.offcanvas-panel-lg .offcanvas-title {\n  font-size: 1.125rem;\n  line-height: 1.7777777778;\n}\n\n.offcanvas-panel-xl {\n  --bs-offcanvas-width: 528px;\n  --bs-offcanvas-padding-y: 1.5625rem;\n  --bs-offcanvas-padding-x: 1.5625rem;\n  --bs-offcanvas-close-margin-x: 0.9375rem;\n}\n.offcanvas-panel-xl .offcanvas-title {\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n\n.offcanvas-tray {\n  --bs-offcanvas-height: 72px;\n}\n\n.dark .offcanvas {\n  --bs-offcanvas-border-color: #404040;\n  --bs-offcanvas-bg: #111111;\n}\n.dark .offcanvas-shadow.offcanvas-start {\n  box-shadow: 15px 0 16px 0 #000000;\n}\n.dark .offcanvas-shadow.offcanvas-end {\n  box-shadow: -15px 0 -16px 0 #000000;\n}\n.dark .offcanvas-shadow.offcanvas-top {\n  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.5);\n}\n.dark .offcanvas-shadow.offcanvas-bottom {\n  box-shadow: 0 -10px 20px 0 rgba(0, 0, 0, 0.5);\n}\n.dark .offcanvas-backdrop {\n  background-color: #111111;\n}\n.dark .btn-panel-xs svg {\n  color: #fff;\n  opacity: 0.64;\n}\n.dark .btn-panel-xs .btn-label {\n  color: rgba(255, 255, 255, 0.84);\n}\n.dark .btn-panel-xs.active .btn-label {\n  color: #fff;\n}\n.dark .btn-panel-xs:focus-visible .btn-label {\n  color: rgba(255, 255, 255, 0.92);\n}\n.dark .btn-panel-xs.disabled .btn-label, .dark .btn-panel-xs:disabled .btn-label {\n  color: rgba(255, 255, 255, 0.4);\n}\n.dark .offcanvas-end .btn-panel-xs:not(:disabled):hover {\n  border-left-color: rgba(255, 255, 255, 0.64);\n}\n.dark .offcanvas-end .btn-panel-xs.btn.active {\n  border-left-color: #fff;\n}\n.dark .offcanvas-start .btn-panel-xs:not(:disabled):hover {\n  border-right-color: rgba(255, 255, 255, 0.64);\n}\n.dark .offcanvas-start .btn-panel-xs.btn.active {\n  border-right-color: #fff;\n}\n\n.range-slider {\n  --range-slider-bg: #ededed;\n  --range-slider-connect-bg: #767676;\n  --range-slider-handle-bg: #fff;\n  --range-slider-disabled-bg: #ededed;\n  --range-slider-disabled-connect-bg: #cccccc;\n  --range-slider-disabled-handle-bg: #dedede;\n  --range-slider-marker-bg: #b6b6b6;\n  --range-slider-marker-end-bg: #a1a1a1;\n  --range-slider-value-color: rgba(17, 17, 17, 0.7);\n  --range-slider-tooltip-bg: #fff;\n  --range-slider-tooltip-color: #111111;\n  display: flex;\n  align-items: center;\n  --range-slider-handle-size: $handleSize;\n  height: 21px;\n  margin-left: 5.5px;\n  margin-right: 5.5px;\n}\n.range-slider .range-slider-track {\n  height: 5px;\n}\n.range-slider .range-slider-track:not(:first-of-type) {\n  margin-left: 10.5px;\n  margin-right: 10.5px;\n}\n.range-slider .range-slider-track:first-of-type {\n  margin-left: 10.5px;\n}\n.range-slider .range-slider-track-connect {\n  margin-right: 10.5px;\n}\n.range-slider .range-slider-handle {\n  width: 21px;\n  height: 21px;\n}\n.range-slider .range-slider-marker {\n  height: 5px;\n  margin-left: 10.5px;\n}\n\n.range-slider.disabled .range-slider-track {\n  background: var(--range-slider-disabled-bg);\n}\n.range-slider.disabled .range-slider-track-connect {\n  background: var(--range-slider-disabled-connect-bg);\n}\n.range-slider.disabled .range-slider-handle {\n  background: var(--range-slider-disabled-handle-bg);\n  box-shadow: none;\n}\n.range-slider.disabled .range-slider-handle:hover {\n  transform: none;\n}\n\n.range-slider-xs {\n  --range-slider-handle-size: $handleSize;\n  height: 13px;\n  margin-left: 9.5px;\n  margin-right: 9.5px;\n}\n.range-slider-xs .range-slider-track {\n  height: 1px;\n}\n.range-slider-xs .range-slider-track:not(:first-of-type) {\n  margin-left: 6.5px;\n  margin-right: 6.5px;\n}\n.range-slider-xs .range-slider-track:first-of-type {\n  margin-left: 6.5px;\n}\n.range-slider-xs .range-slider-track-connect {\n  margin-right: 6.5px;\n}\n.range-slider-xs .range-slider-handle {\n  width: 13px;\n  height: 13px;\n}\n.range-slider-xs .range-slider-marker {\n  height: 1px;\n  margin-left: 6.5px;\n}\n\n.range-slider-sm {\n  --range-slider-handle-size: $handleSize;\n  height: 15px;\n  margin-left: 8.5px;\n  margin-right: 8.5px;\n}\n.range-slider-sm .range-slider-track {\n  height: 3px;\n}\n.range-slider-sm .range-slider-track:not(:first-of-type) {\n  margin-left: 7.5px;\n  margin-right: 7.5px;\n}\n.range-slider-sm .range-slider-track:first-of-type {\n  margin-left: 7.5px;\n}\n.range-slider-sm .range-slider-track-connect {\n  margin-right: 7.5px;\n}\n.range-slider-sm .range-slider-handle {\n  width: 15px;\n  height: 15px;\n}\n.range-slider-sm .range-slider-marker {\n  height: 3px;\n  margin-left: 7.5px;\n}\n\n.range-slider-lg {\n  --range-slider-handle-size: $handleSize;\n  height: 24px;\n  margin-left: 4px;\n  margin-right: 4px;\n}\n.range-slider-lg .range-slider-track {\n  height: 8px;\n}\n.range-slider-lg .range-slider-track:not(:first-of-type) {\n  margin-left: 12px;\n  margin-right: 12px;\n}\n.range-slider-lg .range-slider-track:first-of-type {\n  margin-left: 12px;\n}\n.range-slider-lg .range-slider-track-connect {\n  margin-right: 12px;\n}\n.range-slider-lg .range-slider-handle {\n  width: 24px;\n  height: 24px;\n}\n.range-slider-lg .range-slider-marker {\n  height: 8px;\n  margin-left: 12px;\n}\n\n.range-slider-xl {\n  --range-slider-handle-size: $handleSize;\n  height: 32px;\n  margin-left: 0px;\n  margin-right: 0px;\n}\n.range-slider-xl .range-slider-track {\n  height: 12px;\n}\n.range-slider-xl .range-slider-track:not(:first-of-type) {\n  margin-left: 16px;\n  margin-right: 16px;\n}\n.range-slider-xl .range-slider-track:first-of-type {\n  margin-left: 16px;\n}\n.range-slider-xl .range-slider-track-connect {\n  margin-right: 16px;\n}\n.range-slider-xl .range-slider-handle {\n  width: 32px;\n  height: 32px;\n}\n.range-slider-xl .range-slider-marker {\n  height: 12px;\n  margin-left: 16px;\n}\n\n.range-slider-xs .range-slider-handle:hover, .range-slider-xs .range-slider-handle:active,\n.range-slider-md .range-slider-handle:hover,\n.range-slider-md .range-slider-handle:active {\n  transform: scale(1.2);\n}\n\n.range-slider-handle {\n  background: var(--range-slider-handle-bg);\n  transition: transform 200ms, left 100ms;\n  box-shadow: 0 0.25rem 0.625rem 0 rgba(35, 35, 35, 0.2);\n  border: none;\n  border-radius: 50%;\n  cursor: grab;\n}\n.range-slider-handle:focus {\n  outline: none;\n}\n.range-slider-handle:focus-visible {\n  box-shadow: 0 0 6px 0 #304ffe;\n  border: solid 1px #304ffe;\n}\n.range-slider-handle:active {\n  cursor: grabbing;\n  transition: none;\n}\n.range-slider-handle::before, .range-slider-handle::after {\n  content: none;\n}\n.range-slider-handle:hover, .range-slider-handle:active {\n  transform: scale(1.0625);\n}\n\n.range-slider-tooltip {\n  position: absolute;\n  border: none;\n  border-radius: 3px;\n  text-align: center;\n  left: 50%;\n  transform: translate(-50%, 0);\n  bottom: 150%;\n  opacity: 0;\n  transition: opacity 200ms;\n  background: var(--range-slider-tooltip-bg);\n  color: var(--range-slider-tooltip-color);\n  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);\n  font-size: 0.75rem;\n  padding: 0.375rem 1rem;\n  letter-spacing: 0.3px;\n}\n.range-slider-handle:hover .range-slider-tooltip, .range-slider-handle:active .range-slider-tooltip, .range-slider-handle:focus-visible .range-slider-tooltip {\n  opacity: 1;\n}\n.range-slider-tooltip::before {\n  content: \"\";\n  position: absolute;\n  width: 0.875rem;\n  height: 0.4375rem;\n  border-color: transparent;\n  border-style: solid;\n  top: 100%;\n  margin-top: -1px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 0.4375rem 0.4375rem 0;\n  border-top-color: var(--range-slider-tooltip-bg);\n}\n\n.range-slider-light .range-slider-handle:focus-visible {\n  border-color: rgba(48, 79, 254, 0.7);\n}\n\n.range-slider-tooltip-dark {\n  --range-slider-tooltip-bg: #343434;\n  --range-slider-tooltip-color: #fff;\n}\n\n.range-slider-track {\n  background: var(--range-slider-bg);\n  transition: left 100ms, right 100ms;\n}\n\n.range-slider-is-dragging {\n  transition: none !important;\n}\n\n.range-slider-track-connect {\n  background: var(--range-slider-connect-bg);\n  z-index: 1;\n}\n\n.range-slider-track-rounded {\n  border-radius: 50rem;\n}\n\n.range-slider-value {\n  font-size: 0.8125rem;\n  letter-spacing: 0.2px;\n  color: var(--range-slider-value-color);\n  opacity: 0.64;\n}\n\n.range-slider-marker {\n  background: var(--range-slider-marker-bg);\n  width: 1px;\n}\n.range-slider-marker:first-child {\n  width: 100px !important;\n}\n\n.range-slider .range-slider-marker:first-of-type,\n.range-slider .range-slider-marker:last-of-type {\n  background: var(--range-slider-marker-end-bg);\n}\n\n.range-slider-dark {\n  --range-slider-bg: #b6b6b6;\n  --range-slider-connect-bg: #000;\n  --range-slider-handle-bg: #343434;\n  --range-slider-disabled-bg: #cccccc;\n  --range-slider-disabled-connect-bg: #a1a1a1;\n  --range-slider-disabled-handle-bg: #878787;\n  --range-slider-marker-bg: #808080;\n}\n.range-slider-dark.range-slider-xs {\n  --range-slider-marker-end-bg: #575757;\n  --range-slider-marker-bg: #4b4b4b;\n}\n\n.range-slider-brand {\n  --range-slider-handle-bg: #007f00;\n  --range-slider-disabled-handle-bg: #666666;\n}\n\n.range-slider-brand-light {\n  --range-slider-connect-bg: #007f00;\n  --range-slider-handle-bg: #34b128;\n  --range-slider-disabled-connect-bg: #666666;\n  --range-slider-disabled-handle-bg: #cccccc;\n}\n\n.dark .range-slider {\n  --range-slider-bg: #4b4b4b;\n  --range-slider-connect-bg: #878787;\n  --range-slider-handle-bg: #343434;\n  --range-slider-disabled-bg: #404040;\n  --range-slider-disabled-connect-bg: #4b4b4b;\n  --range-slider-disabled-handle-bg: #4b4b4b;\n  --range-slider-marker-bg: #666666;\n  --range-slider-marker-end-bg: #666666;\n  --range-slider-value-color: rgba(255, 255, 255, 0.7);\n  --range-slider-tooltip-bg: #343434;\n  --range-slider-tooltip-color: #fff;\n}\n.dark .range-slider-tooltip-dark {\n  --range-slider-tooltip-bg: #fff;\n  --range-slider-tooltip-color: #111111;\n}\n.dark .range-slider-dark {\n  --range-slider-bg: #666666;\n  --range-slider-connect-bg: #fcfcfc;\n  --range-slider-disabled-bg: #4b4b4b;\n  --range-slider-disabled-connect-bg: #575757;\n  --range-slider-disabled-handle-bg: #767676;\n  --range-slider-handle-bg: #ededed;\n  --range-slider-marker-bg: #b6b6b6;\n  --range-slider-marker-end-bg: #a1a1a1;\n}\n.dark .range-slider-dark.range-slider-xs {\n  --range-slider-marker-bg: #b6b6b6;\n}\n.dark .range-slider-brand {\n  --range-slider-bg: #404040;\n  --range-slider-handle-bg: #ccff00;\n  --range-slider-disabled-bg: #404040;\n  --range-slider-disabled-handle-bg: #4b4b4b;\n  --range-slider-marker-bg: #666666;\n}\n.dark .range-slider-brand-light {\n  --range-slider-bg: #404040;\n  --range-slider-connect-bg: #ccff00;\n  --range-slider-handle-bg: #9fe300;\n  --range-slider-disabled-connect-bg: #4b4b4b;\n  --range-slider-disabled-handle-bg: #666666;\n  --range-slider-marker-bg: #666666;\n  --range-slider-disabled-bg: #4b4b4b;\n}\n.dark .range-slider-xs {\n  --range-slider-marker-end-bg: #a1a1a1;\n  --range-slider-marker-bg: #878787;\n}\n.dark .range-slider-light .range-slider-handle:focus-visible {\n  border-color: #304ffe;\n}\n\n.form-label {\n  line-height: 1.5;\n}\n\n.col-form-label {\n  font-size: 0.875rem;\n}\n\n.label-optional::after {\n  opacity: 0.64;\n  content: \"optional\";\n  font-size: 0.75rem;\n  margin-left: 0.5rem;\n  letter-spacing: 0.3px;\n}\n\n.label-info {\n  text-decoration: none;\n  margin-left: auto;\n  margin-bottom: 0.75rem;\n  font-size: 0.6875rem;\n  line-height: 1.9090909091;\n}\n\n.form-text,\n.invalid-feedback,\n.valid-feedback {\n  letter-spacing: 0.5px;\n}\n\n.dark .valid-feedback {\n  color: #47ed9c;\n}\n.dark .invalid-feedback {\n  color: #ff94aa;\n}\n\n.form-control {\n  height: 2.5rem;\n}\n.form-control:not(:disabled):hover {\n  border-color: #666666;\n}\n.form-control:focus {\n  border-color: #304ffe;\n  box-shadow: none !important;\n}\n.form-control:focus-visible {\n  border-color: #304ffe !important;\n  outline: 0;\n}\n.form-control:disabled::placeholder, .form-control[readonly]::placeholder {\n  color: #c2c2c2;\n}\n.form-control::-ms-reveal {\n  display: none;\n}\n\n.form-control,\n.form-select {\n  letter-spacing: 0.1px;\n  line-height: 1.7142857143;\n}\n\n.form-control-lg {\n  height: 2.875rem;\n  line-height: 1.6;\n}\n\n.form-control-sm {\n  height: 2.25rem;\n  line-height: 1.8461538462;\n}\n\ntextarea.form-control {\n  height: auto;\n  min-height: 2.5rem;\n}\n\ninput + .input-length,\ntextarea + .input-length {\n  font-size: 0.6875rem;\n  letter-spacing: 0.5px;\n  margin-top: 0.5rem;\n  text-align: right;\n}\n\n.dark .form-control,\n.dark .form-select {\n  color: #fff;\n  caret-color: #fff;\n  border-color: #404040;\n}\n.dark .form-control:focus,\n.dark .form-select:focus {\n  border-color: #878787;\n}\n.dark .form-control::placeholder,\n.dark .form-select::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n.dark .form-control:disabled, .dark .form-control[readonly] {\n  color: rgba(255, 255, 255, 0.5);\n  background-color: #232323;\n  border-color: #404040;\n}\n.dark .form-control:disabled::placeholder, .dark .form-control[readonly]::placeholder {\n  color: rgba(255, 255, 255, 0.4);\n}\n.dark .input-group-text {\n  color: rgba(255, 255, 255, 0.64);\n  border-color: #404040;\n  background-color: #232323;\n}\n\n.form-select:not([multiple]) {\n  height: 2.5rem;\n}\n.form-select[multiple] {\n  padding: 0;\n}\n.form-select[multiple] option {\n  padding: 11px 0.9375rem;\n}\n.form-select:not(:disabled):hover {\n  border-color: #666666;\n}\n.form-select:focus-visible {\n  box-shadow: none !important;\n  border-color: #304ffe !important;\n  outline: 0;\n}\n\n.form-select-placeholder-hack:invalid {\n  color: rgba(17, 17, 17, 0.64);\n}\n\n.form-select-lg:not([multiple]), .input-group-lg > .form-select:not([multiple]) {\n  height: 2.875rem;\n  background-size: 32px 32px;\n  padding-right: 3.25rem;\n}\n\n.form-select-sm:not([multiple]), .input-group-sm > .form-select:not([multiple]) {\n  height: 2.25rem;\n}\n\n.form-select-triangle {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath stroke-linecap=\"square\" fill=\"%23111111\" opacity=\"0.54\" d=\"M6.6 9.4h10.8L12 16.6z\"%3e%3c/path%3e%3c/svg%3e');\n}\n\n.form-select-up-down {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23111111\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"M15.25 15.1 12 18.35 8.75 15.1m0-5.2L12 6.65l3.25 3.25\"%3e%3c/path%3e%3c/svg%3e');\n}\n\n.dark .form-select:not([multiple]) {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23fff\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"m7 10 5.5 5.5L18 10\"%3e%3c/path%3e%3c/svg%3e');\n}\n.dark .form-select:not([multiple]) option {\n  background-color: #232323;\n}\n.dark .form-select-triangle {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath stroke-linecap=\"square\" fill=\"%23fff\" opacity=\"0.54\" d=\"M6.6 9.4h10.8L12 16.6z\"%3e%3c/path%3e%3c/svg%3e') !important;\n}\n.dark .form-select-up-down {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23fff\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"M15.25 15.1 12 18.35 8.75 15.1m0-5.2L12 6.65l3.25 3.25\"%3e%3c/path%3e%3c/svg%3e') !important;\n}\n.dark .form-select-placeholder-hack:invalid {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.form-check-input {\n  cursor: pointer;\n  margin-top: 1px;\n}\n.form-check-input:focus-visible {\n  border-color: #304ffe !important;\n  outline: none;\n}\n.form-check-input:not(:checked):focus {\n  border: 1px solid #b6b6b6;\n}\n.form-check-input:not(:disabled):hover {\n  border-color: #090909;\n}\n.form-check-input:not(:disabled):hover ~ .form-check-label {\n  color: #111111;\n}\n.form-check-input:disabled {\n  background-color: #ededed;\n  border-color: transparent;\n  pointer-events: all;\n  cursor: not-allowed;\n}\n.form-check-input:disabled ~ .form-check-label {\n  cursor: not-allowed;\n}\n.form-check-input[type=radio]:disabled:checked {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"-12 -12 24 24\"%3e%3ccircle r=\"6\" fill=\"%23878787\"/%3e%3c/svg%3e');\n}\n.form-check-input[type=radio]:not(:disabled):checked:hover {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"-12 -12 24 24\"%3e%3ccircle r=\"6\" fill=\"%23111111\"/%3e%3c/svg%3e');\n}\n\n.form-check:not(.form-switch) .form-check-input {\n  background-size: 110%;\n}\n.form-check:not(.form-switch) .form-check-input[type=checkbox]:not(:disabled):checked:hover {\n  background-image: var(--form-check-input-checked-hover-bg-image);\n}\n\n.form-check-label {\n  font-size: 0.875rem;\n  letter-spacing: 0.05px;\n  margin-bottom: 0;\n}\n\n.form-check-comfortable {\n  margin-bottom: 1.1875rem;\n}\n\n.form-check {\n  --form-check-input-checked-hover-bg-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23111111\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n  min-height: 1.125rem;\n  line-height: 1.125rem;\n}\n.form-check .form-check-input:focus-visible {\n  box-shadow: none;\n}\n.form-check .form-check-input:disabled ~ .form-check-label {\n  color: #111111;\n}\n.was-validated .form-check .form-check-input:valid, .form-check .form-check-input.is-valid {\n  border-color: #15ad5c;\n}\n.was-validated .form-check .form-check-input:valid:focus, .form-check .form-check-input.is-valid:focus {\n  box-shadow: none;\n}\n.was-validated .form-check .form-check-input:valid ~ .form-check-label, .form-check .form-check-input.is-valid ~ .form-check-label {\n  color: rgba(17, 17, 17, 0.84);\n}\n.was-validated .form-check .form-check-input:valid:hover ~ .form-check-label, .form-check .form-check-input.is-valid:hover ~ .form-check-label {\n  color: #111111;\n}\n.was-validated .form-check .form-check-input:valid:checked, .form-check .form-check-input.is-valid:checked {\n  background-color: #fff;\n  border-color: #15ad5c;\n}\n.was-validated .form-check .form-check-input:valid:checked[type=checkbox], .form-check .form-check-input.is-valid:checked[type=checkbox] {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%2315ad5c\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.was-validated .form-check .form-check-input:valid:checked:hover, .form-check .form-check-input.is-valid:checked:hover {\n  --form-check-input-checked-hover-bg-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%2315ad5c\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.was-validated .form-check .form-check-input:invalid, .form-check .form-check-input.is-invalid {\n  border-color: #e64949;\n}\n.was-validated .form-check .form-check-input:invalid:focus, .form-check .form-check-input.is-invalid:focus {\n  box-shadow: none;\n}\n.was-validated .form-check .form-check-input:invalid ~ .form-check-label, .form-check .form-check-input.is-invalid ~ .form-check-label {\n  color: rgba(17, 17, 17, 0.84);\n}\n.was-validated .form-check .form-check-input:invalid:hover ~ .form-check-label, .form-check .form-check-input.is-invalid:hover ~ .form-check-label {\n  color: #111111;\n}\n.was-validated .form-check .form-check-input:invalid:checked, .form-check .form-check-input.is-invalid:checked {\n  background-color: #fff;\n}\n.was-validated .form-check .form-check-input:invalid:checked[type=checkbox], .form-check .form-check-input.is-invalid:checked[type=checkbox] {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23e64949\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.was-validated .form-check .form-check-input:invalid:checked:hover, .form-check .form-check-input.is-invalid:checked:hover {\n  --form-check-input-checked-hover-bg-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23e64949\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n\n.nested-checks {\n  list-style: none;\n  padding-left: 0;\n}\n.nested-checks ul {\n  list-style: none;\n  padding-left: 1.625rem;\n}\n.nested-checks li .form-check {\n  margin-bottom: 1.3125rem;\n}\n.nested-checks > li > .form-check {\n  margin-bottom: 1.3125rem;\n}\n\n.nested-checks-lg ul {\n  padding-left: 2rem;\n}\n.nested-checks-lg li .form-check {\n  margin-bottom: 1.25rem;\n}\n.nested-checks-lg > li > .form-check {\n  margin-bottom: 1.5rem;\n}\n\n.form-check-reverse {\n  text-align: left;\n}\n.form-check-reverse .form-check-label {\n  width: 100%;\n}\n\n.form-switch .form-check-input {\n  border-color: transparent;\n  background-color: #dedede;\n}\n.form-switch .form-check-input:checked {\n  background-color: #343434;\n}\n.form-switch .form-check-input:not(:disabled):checked:hover {\n  background-color: #090909;\n}\n.form-switch .form-check-input:not(:checked):not(:disabled):hover {\n  background-color: #878787;\n  border-color: #878787;\n}\n.form-switch .form-check-input:focus {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-9 -9 18 18'%3e%3ccircle r='7' fill='%23fff' style='filter: drop-shadow%280px 2px 1px rgb%2817 17 17 / 0.18%29%29' /%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:disabled {\n  background-color: #dedede;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23f2f2f2'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:disabled:checked {\n  background-color: #b6b6b6;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23dedede'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:not(:checked):focus-visible {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-9 -9 18 18'%3e%3ccircle r='7' fill='%23fff' stroke='%23304ffe' stroke-width='0.6' style='filter: drop-shadow%280px 2px 1px rgb%2817 17 17 / 0.18%29%29' /%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked:not(:disabled):focus-visible {\n  border: 1px solid transparent;\n  box-shadow: 0 0 1px 3px rgba(48, 79, 254, 0.3);\n}\n\n.dark .form-check {\n  --form-check-input-checked-hover-bg-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23fcfcfc\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.dark .form-check-input {\n  background-color: #111111;\n  border-color: #575757;\n}\n.dark .form-check-input:not(:disabled):checked {\n  background-color: #111111;\n  border-color: #575757;\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23dedede\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.dark .form-check-input[type=checkbox]:indeterminate {\n  background-color: #111111;\n  border-color: #575757;\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cline stroke=\"%23dedede\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate%286.000000, 11.500000%29\" x1=\"12\" y1=\"0.5\" x2=\"4.99600361e-16\" y2=\"0.5\"%3e%3c/line%3e%3c/svg%3e');\n}\n.dark .form-check-input:disabled {\n  border-color: transparent;\n  background-color: #343434;\n}\n.dark .form-check-input:disabled:checked[type=checkbox] {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23808080\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.dark .form-check-input:disabled ~ .form-check-label {\n  opacity: 0.4;\n  color: #fff;\n}\n.dark .form-check-input:not(:checked):focus {\n  border-color: #575757;\n}\n.dark .form-check-input:not(:disabled):hover {\n  border-color: #fcfcfc;\n}\n.dark .form-check-input:not(:disabled):hover ~ .form-check-label {\n  color: #fff;\n}\n.was-validated .dark .form-check-input:valid, .dark .form-check-input.is-valid {\n  border-color: #2ee68c;\n}\n.was-validated .dark .form-check-input:valid ~ .form-check-label, .dark .form-check-input.is-valid ~ .form-check-label {\n  color: rgba(255, 255, 255, 0.84);\n}\n.was-validated .dark .form-check-input:valid:checked, .was-validated .dark .form-check-input:valid:checked:not(:disabled):hover, .dark .form-check-input.is-valid:checked, .dark .form-check-input.is-valid:checked:not(:disabled):hover {\n  border-color: #2ee68c;\n  background-color: #111111;\n}\n.was-validated .dark .form-check-input:valid:checked[type=checkbox], .was-validated .dark .form-check-input:valid:checked:not(:disabled):hover[type=checkbox], .dark .form-check-input.is-valid:checked[type=checkbox], .dark .form-check-input.is-valid:checked:not(:disabled):hover[type=checkbox] {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%232ee68c\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.was-validated .dark .form-check-input:valid:not(:checked):hover, .was-validated .dark .form-check-input:valid:not(:checked):focus, .dark .form-check-input.is-valid:not(:checked):hover, .dark .form-check-input.is-valid:not(:checked):focus {\n  border-color: #2ee68c;\n}\n.was-validated .dark .form-check-input:invalid, .dark .form-check-input.is-invalid {\n  border-color: #ff7591;\n  background-color: #111111;\n}\n.was-validated .dark .form-check-input:invalid ~ .form-check-label, .dark .form-check-input.is-invalid ~ .form-check-label {\n  color: rgba(255, 255, 255, 0.84);\n}\n.was-validated .dark .form-check-input:invalid:checked, .was-validated .dark .form-check-input:invalid:checked:not(:disabled):hover, .dark .form-check-input.is-invalid:checked, .dark .form-check-input.is-invalid:checked:not(:disabled):hover {\n  border-color: #ff7591;\n  background-color: #111111;\n}\n.was-validated .dark .form-check-input:invalid:checked[type=checkbox], .was-validated .dark .form-check-input:invalid:checked:not(:disabled):hover[type=checkbox], .dark .form-check-input.is-invalid:checked[type=checkbox], .dark .form-check-input.is-invalid:checked:not(:disabled):hover[type=checkbox] {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23ff7591\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.was-validated .dark .form-check-input:invalid:not(:checked):hover, .was-validated .dark .form-check-input:invalid:not(:checked):focus, .dark .form-check-input.is-invalid:not(:checked):hover, .dark .form-check-input.is-invalid:not(:checked):focus {\n  border-color: #ff7591;\n}\n.dark .form-check-input[type=radio]:not(:disabled):hover {\n  border-color: #fcfcfc;\n}\n.dark .form-check-input[type=radio]:not(:disabled):checked {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"-12 -12 24 24\"%3e%3ccircle r=\"6\" fill=\"%23dedede\"/%3e%3c/svg%3e');\n}\n.dark .form-check-input[type=radio]:not(:disabled):checked:hover {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"-12 -12 24 24\"%3e%3ccircle r=\"6\" fill=\"%23fcfcfc\"/%3e%3c/svg%3e');\n}\n.dark .form-check-input[type=radio]:disabled {\n  border-color: transparent;\n}\n.dark .form-check-input[type=radio]:disabled:checked {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"-12 -12 24 24\"%3e%3ccircle r=\"6\" fill=\"%23808080\"/%3e%3c/svg%3e');\n}\n.dark .form-switch .form-check-input {\n  border-color: #b6b6b6;\n  background-color: #232323;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23cccccc'/%3e%3c/svg%3e\");\n}\n.dark .form-switch .form-check-input:not(:disabled):hover {\n  border-color: #fff;\n  background-color: #232323;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ededed'/%3e%3c/svg%3e\");\n}\n.dark .form-switch .form-check-input:not(:checked):focus {\n  border-color: #b6b6b6;\n}\n.dark .form-switch .form-check-input:not(:disabled):not(:checked):focus-visible {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-9 -9 18 18'%3e%3ccircle r='7' fill='%23cccccc' stroke='%23304ffe' stroke-width='0.6' style='filter: drop-shadow%280px 2px 1px rgb%2817 17 17 / 0.18%29%29' /%3e%3c/svg%3e\");\n}\n.dark .form-switch .form-check-input:not(:checked):disabled {\n  border-color: #575757;\n  background-color: #232323;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23575757'/%3e%3c/svg%3e\");\n}\n.dark .form-switch .form-check-input:checked:disabled {\n  border-color: #575757;\n  background-color: #575757;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23232323'/%3e%3c/svg%3e\");\n}\n.dark .form-switch .form-check-input:not(:disabled):checked {\n  border-color: #ededed;\n  background-color: #ededed;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23232323'/%3e%3c/svg%3e\");\n}\n.dark .form-switch .form-check-input:not(:disabled):checked:hover {\n  border-color: #fff;\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23232323'/%3e%3c/svg%3e\");\n}\n.dark .form-switch .form-check-input:not(:disabled):checked:focus-visible {\n  box-shadow: 0 0 1px 3px rgba(48, 79, 254, 0.6);\n}\n.dark .form-check-label {\n  color: rgba(255, 255, 255, 0.84);\n}\n\n.form-check-lg {\n  min-height: 1.5rem;\n  line-height: 1.5rem;\n  padding-left: 2.4375rem;\n  margin-bottom: 1rem;\n}\n.form-check-lg.form-check-inline {\n  margin-right: 1.875rem;\n}\n.form-check-lg .form-check-input {\n  width: 1.5rem;\n  height: 1.5rem;\n  margin-left: -2.4375rem;\n  margin-top: 0;\n}\n.form-check-lg .form-check-label {\n  font-size: 1rem;\n}\n.form-check-lg.form-check-comfortable {\n  margin-bottom: 1.25rem;\n}\n\n.form-switch.form-check-lg {\n  padding-left: 4rem;\n}\n.form-switch.form-check-lg .form-check-input {\n  width: 3rem;\n  margin-left: -4rem;\n}\n\n.form-check-reverse.form-check-lg {\n  padding-left: 0;\n}\n\n.form-check-alt {\n  --form-check-input-checked-hover-bg-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23fff\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.form-check-alt .form-check-input[type=checkbox]:checked:not(:disabled) {\n  border: 1px solid #343434;\n  background-color: #343434;\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23fff\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.form-check-alt .form-check-input[type=checkbox]:indeterminate {\n  background-color: #343434;\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cline stroke=\"%23fff\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate%286.000000, 11.500000%29\" x1=\"12\" y1=\"0.5\" x2=\"4.99600361e-16\" y2=\"0.5\"%3e%3c/line%3e%3c/svg%3e');\n  border-color: #343434;\n}\n.form-check-alt .form-check-input[type=checkbox]:checked:disabled {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23878787\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.form-check-alt .form-check-input[type=checkbox]:checked:not(:disabled):hover {\n  background-color: #000000;\n  border-color: #000000;\n}\n.was-validated .form-check-alt .form-check-input[type=checkbox]:valid:checked:not(:disabled), .form-check-alt .form-check-input[type=checkbox].is-valid:checked:not(:disabled) {\n  background-color: #15ad5c;\n  border-color: #15ad5c;\n}\n.was-validated .form-check-alt .form-check-input[type=checkbox]:valid:checked:not(:disabled)[type=checkbox], .form-check-alt .form-check-input[type=checkbox].is-valid:checked:not(:disabled)[type=checkbox] {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23fff\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.was-validated .form-check-alt .form-check-input[type=checkbox]:invalid, .form-check-alt .form-check-input[type=checkbox].is-invalid {\n  border-color: #e64949;\n}\n.was-validated .form-check-alt .form-check-input[type=checkbox]:invalid:checked:not(:disabled), .form-check-alt .form-check-input[type=checkbox].is-invalid:checked:not(:disabled) {\n  background-color: #e64949;\n  border-color: #e64949;\n}\n.was-validated .form-check-alt .form-check-input[type=checkbox]:invalid:checked:not(:disabled)[type=checkbox], .form-check-alt .form-check-input[type=checkbox].is-invalid:checked:not(:disabled)[type=checkbox] {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23fff\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.form-check-alt.form-switch .form-check-input {\n  background-color: #fff;\n  border: 1px solid #b6b6b6;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23767676'/%3e%3c/svg%3e\");\n}\n.form-check-alt.form-switch .form-check-input:checked:not(:disabled) {\n  border-color: transparent !important;\n  background-color: #090909;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-check-alt.form-switch .form-check-input:checked:not(:disabled):hover {\n  background-color: #000000;\n}\n.form-check-alt.form-switch .form-check-input:not(:checked):not(:disabled):hover {\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23575757'/%3e%3c/svg%3e\");\n  border-color: #090909;\n}\n.form-check-alt.form-switch .form-check-input:not(:checked):not(:disabled):focus-visible {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-9 -9 18 18'%3e%3ccircle r='7' fill='%23767676' stroke='%23304ffe' stroke-width='0.6' style='filter: drop-shadow%280px 2px 1px rgb%2817 17 17 / 0.18%29%29' /%3e%3c/svg%3e\");\n}\n.form-check-alt.form-switch .form-check-input:not(:checked):disabled {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ededed'/%3e%3c/svg%3e\");\n  border-color: #dedede;\n}\n.form-check-alt.form-switch .form-check-input:disabled:checked {\n  background-color: #ededed;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n  border-color: #ededed;\n}\n\n.dark .form-check-alt {\n  --form-check-input-checked-hover-bg-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23111111\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.dark .form-check-alt .form-check-input[type=checkbox]:checked:not(:disabled) {\n  border-color: #dedede;\n  background-color: #dedede;\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23111111\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.dark .form-check-alt .form-check-input[type=checkbox]:checked:not(:disabled):hover {\n  background-color: #fff;\n}\n.dark .form-check-alt .form-check-input[type=checkbox]:indeterminate {\n  background-color: #dedede;\n  border-color: #dedede;\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cline stroke=\"%23111111\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate%286.000000, 11.500000%29\" x1=\"12\" y1=\"0.5\" x2=\"4.99600361e-16\" y2=\"0.5\"%3e%3c/line%3e%3c/svg%3e');\n}\n.was-validated .dark .form-check-alt .form-check-input[type=checkbox]:valid:checked, .was-validated .dark .form-check-alt .form-check-input[type=checkbox]:valid:checked:not(:disabled):hover, .dark .form-check-alt .form-check-input[type=checkbox].is-valid:checked, .dark .form-check-alt .form-check-input[type=checkbox].is-valid:checked:not(:disabled):hover {\n  border-color: #2ee68c;\n  background-color: #2ee68c;\n}\n.was-validated .dark .form-check-alt .form-check-input[type=checkbox]:valid:checked[type=checkbox], .was-validated .dark .form-check-alt .form-check-input[type=checkbox]:valid:checked:not(:disabled):hover[type=checkbox], .dark .form-check-alt .form-check-input[type=checkbox].is-valid:checked[type=checkbox], .dark .form-check-alt .form-check-input[type=checkbox].is-valid:checked:not(:disabled):hover[type=checkbox] {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23111111\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.was-validated .dark .form-check-alt .form-check-input[type=checkbox]:invalid:checked, .was-validated .dark .form-check-alt .form-check-input[type=checkbox]:invalid:checked:not(:disabled):hover, .dark .form-check-alt .form-check-input[type=checkbox].is-invalid:checked, .dark .form-check-alt .form-check-input[type=checkbox].is-invalid:checked:not(:disabled):hover {\n  border-color: #ff7591;\n  background-color: #ff7591;\n}\n.was-validated .dark .form-check-alt .form-check-input[type=checkbox]:invalid:checked[type=checkbox], .was-validated .dark .form-check-alt .form-check-input[type=checkbox]:invalid:checked:not(:disabled):hover[type=checkbox], .dark .form-check-alt .form-check-input[type=checkbox].is-invalid:checked[type=checkbox], .dark .form-check-alt .form-check-input[type=checkbox].is-invalid:checked:not(:disabled):hover[type=checkbox] {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23111111\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.dark .form-check-alt.form-switch .form-check-input {\n  border-color: #b6b6b6;\n  background-color: #232323;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23cccccc'/%3e%3c/svg%3e\");\n}\n.dark .form-check-alt.form-switch .form-check-input:not(:disabled):hover {\n  border-color: #fff;\n  background-color: #232323;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ededed'/%3e%3c/svg%3e\");\n}\n.dark .form-check-alt.form-switch .form-check-input:not(:disabled):hover ~ .form-check-label {\n  color: #fff;\n}\n.dark .form-check-alt.form-switch .form-check-input:not(:disabled):not(:checked):focus-visible {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-9 -9 18 18'%3e%3ccircle r='7' fill='%23cccccc' stroke='%23304ffe' stroke-width='0.6' style='filter: drop-shadow%280px 2px 1px rgb%2817 17 17 / 0.18%29%29' /%3e%3c/svg%3e\");\n}\n.dark .form-check-alt.form-switch .form-check-input:not(:checked):disabled {\n  border-color: #575757;\n  background-color: #232323;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23575757'/%3e%3c/svg%3e\");\n}\n.dark .form-check-alt.form-switch .form-check-input:checked:disabled {\n  border-color: #575757;\n  background-color: #575757;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23232323'/%3e%3c/svg%3e\");\n}\n.dark .form-check-alt.form-switch .form-check-input:not(:disabled):checked {\n  border-color: #ededed;\n  background-color: #ededed;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23232323'/%3e%3c/svg%3e\");\n}\n.dark .form-check-alt.form-switch .form-check-input:not(:disabled):checked:hover {\n  border-color: #fff;\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23232323'/%3e%3c/svg%3e\");\n}\n.dark .form-check-alt.form-switch .form-check-input:not(:disabled):checked:focus-visible {\n  box-shadow: 0 0 1px 3px rgba(48, 79, 254, 0.6);\n}\n\n.input-group .btn {\n  border-radius: 0;\n}\n.input-group .form-control:hover,\n.input-group .form-select:hover,\n.input-group .btn:hover {\n  z-index: 3;\n}\n.input-group > .form-control-square {\n  text-align: center;\n  flex-grow: 0;\n  width: 2.5rem;\n  padding: 0.5rem 0.5rem;\n}\n\n.input-group-text {\n  height: 2.5rem;\n}\n.input-group-text[data-toggle] {\n  cursor: pointer;\n}\n\n.input-group-search {\n  max-width: 540px;\n  flex: 1;\n}\n\n.input-group-lg > .input-group-text,\n.input-group-lg > .form-control:not(textarea) {\n  height: 2.875rem;\n}\n.input-group-lg > .btn {\n  padding: 0.5rem 1.5625rem;\n}\n.input-group-lg > .form-control-square {\n  width: 2.875rem;\n}\n\n.input-group-sm > .btn {\n  padding-top: var(--bs-btn-padding-y);\n  padding-bottom: var(--bs-btn-padding-y);\n}\n.input-group-sm > .input-group-text,\n.input-group-sm > .form-control:not(textarea) {\n  height: 2.25rem;\n}\n.input-group-sm > .form-select {\n  padding-right: 2.75rem;\n}\n.input-group-sm > .form-control-square {\n  width: 2.25rem;\n  padding: 0.375rem 0.375rem;\n}\n\n.input-group-spinner {\n  max-width: 192px;\n}\n\n.input-group.input-group-merge {\n  --bs-input-disabled-bg: #fafafa;\n}\n.input-group.input-group-merge > .form-control:not(:disabled):hover,\n.input-group.input-group-merge > .form-control:not(:disabled):hover ~ [class*=input-group] {\n  z-index: 3;\n}\n.input-group.input-group-merge > .form-control:not(:disabled):hover > .input-group-text,\n.input-group.input-group-merge > .form-control:not(:disabled):hover ~ [class*=input-group] > .input-group-text {\n  border-color: #666666 !important;\n}\n.input-group.input-group-merge > .form-control.is-valid,\n.input-group.input-group-merge > .form-control.is-valid ~ [class*=input-group] > .input-group-text {\n  border-color: var(--bs-form-valid-border-color) !important;\n}\n.input-group.input-group-merge > .form-control.is-invalid,\n.input-group.input-group-merge > .form-control.is-invalid ~ [class*=input-group] > .input-group-text {\n  border-color: var(--bs-form-invalid-border-color) !important;\n}\n.input-group.input-group-merge > .form-control:not(:disabled):focus {\n  box-shadow: none;\n}\n.input-group.input-group-merge > .form-control:not(:disabled):focus,\n.input-group.input-group-merge > .form-control:not(:disabled):focus ~ [class*=input-group] {\n  z-index: 5;\n}\n.input-group.input-group-merge > .form-control:not(:disabled):focus > .input-group-text,\n.input-group.input-group-merge > .form-control:not(:disabled):focus ~ [class*=input-group] > .input-group-text {\n  border-color: #304ffe !important;\n}\n.input-group.input-group-merge > .form-control ~ [class*=input-group] > .input-group-text {\n  background-color: transparent;\n}\n.input-group.input-group-merge > .form-control:disabled ~ [class*=input-group] > .input-group-text, .input-group.input-group-merge > .form-control[readonly] ~ [class*=input-group] > .input-group-text {\n  background-color: var(--bs-input-disabled-bg);\n}\n.input-group.input-group-merge > .form-control-prepended {\n  padding-left: 0.3125rem;\n  border-left-width: 0;\n}\n.input-group.input-group-merge > .form-control-appended:not(.is-valid):not(.is-invalid) {\n  padding-right: 0.3125rem;\n}\n.input-group.input-group-merge > .form-control-appended {\n  border-right-width: 0;\n}\n.input-group.input-group-merge > .input-group-prepend {\n  order: -1;\n}\n.input-group.input-group-merge > .input-group-prepend > .input-group-text {\n  padding-left: 0.625rem;\n  padding-right: 0.3125rem;\n  border-right-width: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n.input-group.input-group-merge > .input-group-append > .input-group-text {\n  padding-left: 0.3125rem;\n  padding-right: 0.625rem;\n  border-left-width: 0;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.input-group-lg.input-group-merge > .input-group-prepend > .input-group-text {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  height: 2.875rem;\n}\n.input-group-lg.input-group-merge > .input-group-append > .input-group-text {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  height: 2.875rem;\n}\n\n.input-group-sm.input-group-merge > .input-group-prepend > .input-group-text {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  height: 2.25rem;\n}\n.input-group-sm.input-group-merge > .input-group-append > .input-group-text {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  height: 2.25rem;\n}\n\n.dark .input-group.input-group-merge {\n  --bs-input-disabled-bg: #232323;\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n\n.was-validated .form-select-triangle:valid, .form-select-triangle.is-valid {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath stroke-linecap=\"square\" fill=\"%23111111\" opacity=\"0.54\" d=\"M6.6 9.4h10.8L12 16.6z\"%3e%3c/path%3e%3c/svg%3e'), url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%2315ad5c\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e') !important;\n}\n.was-validated .form-select-triangle:invalid, .form-select-triangle.is-invalid {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath stroke-linecap=\"square\" fill=\"%23111111\" opacity=\"0.54\" d=\"M6.6 9.4h10.8L12 16.6z\"%3e%3c/path%3e%3c/svg%3e'), url('data:image/svg+xml,%3csvg width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" d=\"M0 0h32v32H0z\"%3e%3c/path%3e%3cpath fill=\"%23e64949\" d=\"m24.928 24.116-8.4-15.6c-.21-.389-.847-.389-1.057 0l-8.4 15.6A.6.6 0 0 0 7.6 25h16.8a.6.6 0 0 0 .528-.884Zm-7.9-10.516-.428 6h-1.2l-.428-6h2.056ZM16 23.2a1.067 1.067 0 1 1 0-2.134 1.067 1.067 0 0 1 0 2.134Z\"%3e%3c/path%3e%3c/svg%3e') !important;\n}\n\n.was-validated .form-select-up-down:valid, .form-select-up-down.is-valid {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23111111\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"M15.25 15.1 12 18.35 8.75 15.1m0-5.2L12 6.65l3.25 3.25\"%3e%3c/path%3e%3c/svg%3e'), url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%2315ad5c\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e') !important;\n}\n.was-validated .form-select-up-down:invalid, .form-select-up-down.is-invalid {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23111111\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"M15.25 15.1 12 18.35 8.75 15.1m0-5.2L12 6.65l3.25 3.25\"%3e%3c/path%3e%3c/svg%3e'), url('data:image/svg+xml,%3csvg width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" d=\"M0 0h32v32H0z\"%3e%3c/path%3e%3cpath fill=\"%23e64949\" d=\"m24.928 24.116-8.4-15.6c-.21-.389-.847-.389-1.057 0l-8.4 15.6A.6.6 0 0 0 7.6 25h16.8a.6.6 0 0 0 .528-.884Zm-7.9-10.516-.428 6h-1.2l-.428-6h2.056ZM16 23.2a1.067 1.067 0 1 1 0-2.134 1.067 1.067 0 0 1 0 2.134Z\"%3e%3c/path%3e%3c/svg%3e') !important;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  background-size: 32px 32px;\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  background-size: 32px 32px;\n  border-color: var(--bs-form-invalid-border-color);\n}\n\n.was-validated .dark .form-select:valid, .dark .form-select.is-valid {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23fff\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"m7 10 5.5 5.5L18 10\"%3e%3c/path%3e%3c/svg%3e'), url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%232ee68c\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e') !important;\n}\n.was-validated .dark .form-select:invalid, .dark .form-select.is-invalid {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23fff\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"m7 10 5.5 5.5L18 10\"%3e%3c/path%3e%3c/svg%3e'), url('data:image/svg+xml,%3csvg width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" d=\"M0 0h32v32H0z\"%3e%3c/path%3e%3cpath fill=\"%23ff7591\" d=\"m24.928 24.116-8.4-15.6c-.21-.389-.847-.389-1.057 0l-8.4 15.6A.6.6 0 0 0 7.6 25h16.8a.6.6 0 0 0 .528-.884Zm-7.9-10.516-.428 6h-1.2l-.428-6h2.056ZM16 23.2a1.067 1.067 0 1 1 0-2.134 1.067 1.067 0 0 1 0 2.134Z\"%3e%3c/path%3e%3c/svg%3e') !important;\n}\n.was-validated .dark .form-select-triangle:valid, .dark .form-select-triangle.is-valid {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath stroke-linecap=\"square\" fill=\"%23fff\" opacity=\"0.54\" d=\"M6.6 9.4h10.8L12 16.6z\"%3e%3c/path%3e%3c/svg%3e'), url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%232ee68c\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e') !important;\n}\n.was-validated .dark .form-select-triangle:invalid, .dark .form-select-triangle.is-invalid {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath stroke-linecap=\"square\" fill=\"%23fff\" opacity=\"0.54\" d=\"M6.6 9.4h10.8L12 16.6z\"%3e%3c/path%3e%3c/svg%3e'), url('data:image/svg+xml,%3csvg width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" d=\"M0 0h32v32H0z\"%3e%3c/path%3e%3cpath fill=\"%23ff7591\" d=\"m24.928 24.116-8.4-15.6c-.21-.389-.847-.389-1.057 0l-8.4 15.6A.6.6 0 0 0 7.6 25h16.8a.6.6 0 0 0 .528-.884Zm-7.9-10.516-.428 6h-1.2l-.428-6h2.056ZM16 23.2a1.067 1.067 0 1 1 0-2.134 1.067 1.067 0 0 1 0 2.134Z\"%3e%3c/path%3e%3c/svg%3e') !important;\n}\n.was-validated .dark .form-select-up-down:valid, .dark .form-select-up-down.is-valid {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23fff\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"M15.25 15.1 12 18.35 8.75 15.1m0-5.2L12 6.65l3.25 3.25\"%3e%3c/path%3e%3c/svg%3e'), url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%232ee68c\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e') !important;\n}\n.was-validated .dark .form-select-up-down:invalid, .dark .form-select-up-down.is-invalid {\n  background-image: url('data:image/svg+xml,%3csvg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" stroke-linecap=\"square\" stroke=\"%23fff\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"M15.25 15.1 12 18.35 8.75 15.1m0-5.2L12 6.65l3.25 3.25\"%3e%3c/path%3e%3c/svg%3e'), url('data:image/svg+xml,%3csvg width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" d=\"M0 0h32v32H0z\"%3e%3c/path%3e%3cpath fill=\"%23ff7591\" d=\"m24.928 24.116-8.4-15.6c-.21-.389-.847-.389-1.057 0l-8.4 15.6A.6.6 0 0 0 7.6 25h16.8a.6.6 0 0 0 .528-.884Zm-7.9-10.516-.428 6h-1.2l-.428-6h2.056ZM16 23.2a1.067 1.067 0 1 1 0-2.134 1.067 1.067 0 0 1 0 2.134Z\"%3e%3c/path%3e%3c/svg%3e') !important;\n}\n.was-validated .dark .form-control:valid, .dark .form-control.is-valid {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%232ee68c\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n}\n.was-validated .dark .form-control:invalid, .dark .form-control.is-invalid {\n  background-image: url('data:image/svg+xml,%3csvg width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"%3e%3cpath fill=\"none\" d=\"M0 0h32v32H0z\"%3e%3c/path%3e%3cpath fill=\"%23ff7591\" d=\"m24.928 24.116-8.4-15.6c-.21-.389-.847-.389-1.057 0l-8.4 15.6A.6.6 0 0 0 7.6 25h16.8a.6.6 0 0 0 .528-.884Zm-7.9-10.516-.428 6h-1.2l-.428-6h2.056ZM16 23.2a1.067 1.067 0 1 1 0-2.134 1.067 1.067 0 0 1 0 2.134Z\"%3e%3c/path%3e%3c/svg%3e');\n}\n\n.bg-footer {\n  background: #fff;\n}\n.dark .bg-footer {\n  background: #111111;\n}\n\n.anchor-grid .col-6 {\n  border: 1px solid #232323;\n}\n.anchor-grid .col-6:nth-child(n+3) {\n  margin-top: -1px;\n}\n.anchor-grid .col-6:nth-child(even) {\n  margin-left: -1px;\n}\n.anchor-grid a {\n  text-decoration: none;\n}\n\n@media (max-width: 575.98px) {\n  .border-grid > div + div {\n    margin-top: -1px;\n  }\n}\n@media (min-width: 576px) and (max-width: 991.98px) {\n  .border-grid > div:nth-child(n+3) {\n    margin-top: -1px;\n  }\n  .border-grid > div:nth-child(even) {\n    margin-left: -1px;\n  }\n}\n@media (min-width: 992px) {\n  .border-grid > div + div {\n    margin-left: -1px;\n  }\n}\n\n.card-tag {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-transform: uppercase;\n  padding: 0.5rem 1rem;\n  background: #fff;\n  box-shadow: 0 0.625rem 1.25rem rgba(35, 35, 35, 0.08);\n}\n\n.card-body-side {\n  padding: 2.5rem 1.875rem;\n}\n\n.card-body-side-sm {\n  padding: 2.5rem 1.625rem 2.5rem 2.125rem;\n}\n\n.card-body-side-xs {\n  padding: 1.25rem 1.875rem 1.5rem 1.25rem;\n}\n\n.card-hover-bg {\n  text-decoration: none !important;\n  transition: box-shadow 300ms, background-color 300ms;\n}\n.card-hover-bg:hover {\n  background-color: #fff;\n}\n.dark .card-hover-bg:hover {\n  background-color: #343434;\n}\n\n.image-stacks-7-cc {\n  display: flex;\n  align-items: flex-end;\n  height: 267px;\n  max-width: 427px;\n  margin: 0 auto;\n  padding: 2.1875rem 1.875rem;\n  border-radius: 1rem;\n  backdrop-filter: blur(15px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 0.5rem 1.4375rem -0.125rem rgba(17, 17, 17, 0.6);\n}\n.image-stacks-7-cc h6, .image-stacks-7-cc .h6 {\n  font-size: 7px;\n  margin-bottom: 9px;\n}\n\n.image-stacks-7-cc-number {\n  font-size: 1.3125rem;\n  letter-spacing: 1.75px;\n  margin-bottom: 37px;\n}\n\n.heading-badge {\n  display: inline-block;\n  padding: 0.125rem 0.754rem;\n  line-height: 2;\n  letter-spacing: 1.5px;\n  font-size: 0.6875rem;\n  font-weight: normal;\n  color: #111111;\n  background-color: #f2f2f2;\n}\n.dark .heading-badge {\n  background-color: #343434;\n  color: #fff;\n}\n\n@media (min-width: 1440px) {\n  .hero-1-nav-container {\n    display: flex;\n  }\n  .hero-1-nav-container > div {\n    text-align: right;\n    margin-bottom: 0.35rem !important;\n    margin-left: auto;\n    order: 2;\n  }\n}\n.line-after {\n  position: relative;\n}\n.line-after::after {\n  content: \"\";\n  height: 1px;\n  width: 2.5rem;\n  background: #007f00;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n\n.price-card-currency {\n  position: absolute;\n  font-size: 1.5rem;\n  top: 0.5rem;\n  right: 100%;\n  margin-right: 2px;\n}\n\n.radio-grid > div:not(:last-child) {\n  margin-bottom: 30px;\n}\n@media (min-width: 576px) {\n  .radio-grid > div:nth-child(n+7) {\n    margin-bottom: 0;\n  }\n}\n@media (min-width: 992px) {\n  .radio-grid > div:nth-child(n+5) {\n    margin-bottom: 0;\n  }\n}\n.radio-grid input[type=radio] {\n  opacity: 0;\n  position: fixed;\n  width: 0;\n}\n.radio-grid label {\n  display: block;\n  position: relative;\n  height: 100%;\n  padding: 1.875rem 1.875rem 2.5rem 1.875rem;\n  font-weight: 300;\n  border: 1px solid #232323;\n  border-radius: 5px;\n  transition: border-color 300ms, box-shadow 300ms;\n}\n.radio-grid label:hover {\n  border-color: rgba(255, 255, 255, 0.8);\n  cursor: pointer;\n}\n.radio-grid input[type=radio]:focus + label {\n  box-shadow: 0 0px 10px 0px #304ffe;\n}\n.radio-grid input[type=radio]:checked + label {\n  border-color: #fff;\n}\n.radio-grid input[type=radio]:checked + label::after {\n  content: \"\";\n  background: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23fff\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e') center no-repeat;\n  background-size: cover;\n  display: block;\n  width: 32px;\n  height: 32px;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n\n.section-padding-xs {\n  padding: 2rem 0;\n}\n@media (min-width: 576px) {\n  .section-padding-xs {\n    padding: 3rem 0;\n  }\n}\n@media (min-width: 768px) {\n  .section-padding-xs {\n    padding: 4rem 0;\n  }\n}\n\n.section-padding-sm {\n  padding: 2.5rem 0;\n}\n@media (min-width: 576px) {\n  .section-padding-sm {\n    padding: 3.5rem 0;\n  }\n}\n@media (min-width: 768px) {\n  .section-padding-sm {\n    padding: 5rem 0;\n  }\n}\n\n.section-padding {\n  padding: 3rem 0;\n}\n@media (min-width: 576px) {\n  .section-padding {\n    padding: 4rem 0;\n  }\n}\n@media (min-width: 768px) {\n  .section-padding {\n    padding: 6rem 0;\n  }\n}\n\n.section-padding-lg {\n  padding: 3.5rem 0;\n}\n@media (min-width: 576px) {\n  .section-padding-lg {\n    padding: 5rem 0;\n  }\n}\n@media (min-width: 768px) {\n  .section-padding-lg {\n    padding: 6.5rem 0;\n  }\n}\n\n.section-padding-xl {\n  padding: 4rem 0;\n}\n@media (min-width: 576px) {\n  .section-padding-xl {\n    padding: 6rem 0;\n  }\n}\n@media (min-width: 768px) {\n  .section-padding-xl {\n    padding: 8rem 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .cta-pb-xl {\n    padding-bottom: 20.875rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .splits-5-row {\n    min-height: 95vh;\n  }\n}\n.splits-5-anchor {\n  position: relative;\n  overflow: hidden;\n  text-decoration: none !important;\n}\n.splits-5-anchor .absolute-fill, .splits-5-anchor .overlay::before {\n  transition: transform 300ms;\n}\n.splits-5-anchor:hover .absolute-fill, .splits-5-anchor:hover .overlay::before {\n  transform: scale(1.1);\n}\n\n.splits-text-width-sm {\n  max-width: 400px;\n}\n\n.splits-text-width {\n  max-width: 445px;\n}\n\n.splits-text-width-lg {\n  max-width: 600px;\n}\n\n@media (max-width: 991.98px) {\n  .split-media-col {\n    min-height: 400px;\n  }\n}\n@media (max-width: 767.98px) {\n  .split-media-col {\n    min-height: 300px;\n  }\n}\n\n.square-sm {\n  width: 3rem;\n  height: 3rem;\n}\n\n.square {\n  width: 4rem;\n  height: 4rem;\n}\n\n.square-lg {\n  width: 4.5rem;\n  height: 4.5rem;\n}\n\n.square-xl {\n  width: 5rem;\n  height: 5rem;\n}\n\n.square-xxl {\n  width: 6rem;\n  height: 6rem;\n}\n\n.video-play-anchor {\n  display: block;\n  border: 0;\n  padding: 0;\n  opacity: 1 !important;\n}\n.video-play-anchor::before {\n  opacity: 0.1;\n  transition: opacity 300ms;\n}\n.video-play-anchor:hover::before {\n  opacity: 0.3;\n}\n.video-play-anchor .bg-white {\n  color: #343434;\n}\n\n@keyframes modal-video {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes modal-video-inner {\n  from {\n    transform: translate(0, 100px);\n  }\n  to {\n    transform: translate(0, 0);\n  }\n}\n.modal-video {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000000;\n  cursor: pointer;\n  opacity: 1;\n  animation-timing-function: ease-out;\n  animation-duration: 0.3s;\n  animation-name: modal-video;\n  -webkit-transition: opacity 0.3s ease-out;\n  -moz-transition: opacity 0.3s ease-out;\n  -ms-transition: opacity 0.3s ease-out;\n  -o-transition: opacity 0.3s ease-out;\n  transition: opacity 0.3s ease-out;\n}\n\n.modal-video-effect-exit {\n  opacity: 0;\n}\n.modal-video-effect-exit .modal-video-movie-wrap {\n  -webkit-transform: translate(0, 100px);\n  -moz-transform: translate(0, 100px);\n  -ms-transform: translate(0, 100px);\n  -o-transform: translate(0, 100px);\n  transform: translate(0, 100px);\n}\n\n.modal-video-body {\n  max-width: 960px;\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  padding: 0 10px;\n  display: flex;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.modal-video-inner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n@media (orientation: landscape) {\n  .modal-video-inner {\n    padding: 10px 60px;\n    box-sizing: border-box;\n  }\n}\n\n.modal-video-movie-wrap {\n  width: 100%;\n  height: 0;\n  position: relative;\n  padding-bottom: 56.25%;\n  background-color: #333;\n  animation-timing-function: ease-out;\n  animation-duration: 0.3s;\n  animation-name: modal-video-inner;\n  -webkit-transform: translate(0, 0);\n  -moz-transform: translate(0, 0);\n  -ms-transform: translate(0, 0);\n  -o-transform: translate(0, 0);\n  transform: translate(0, 0);\n  -webkit-transition: -webkit-transform 0.3s ease-out;\n  -moz-transition: -moz-transform 0.3s ease-out;\n  -ms-transition: -ms-transform 0.3s ease-out;\n  -o-transition: -o-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n}\n.modal-video-movie-wrap iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.modal-video-close-btn {\n  position: absolute;\n  z-index: 2;\n  top: -45px;\n  right: 0px;\n  display: inline-block;\n  width: 35px;\n  height: 35px;\n  overflow: hidden;\n  border: none;\n  background: transparent;\n}\n@media (orientation: landscape) {\n  .modal-video-close-btn {\n    top: 0;\n    right: -45px;\n  }\n}\n.modal-video-close-btn:before {\n  transform: rotate(45deg);\n}\n.modal-video-close-btn:after {\n  transform: rotate(-45deg);\n}\n.modal-video-close-btn:before, .modal-video-close-btn:after {\n  content: \"\";\n  position: absolute;\n  height: 2px;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  margin-top: -1px;\n  background: #fff;\n  border-radius: 5px;\n  margin-top: -6px;\n}\n\n.react-table-pagination-total {\n  line-height: 41px;\n}\n.react-table-pagination-total input::-webkit-outer-spin-button,\n.react-table-pagination-total input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.react-table-pagination-total input[type=number] {\n  -moz-appearance: textfield;\n}\n\n.react-table-pagination {\n  font-size: 0.875rem;\n}\n\n.react-table-pagination-sm {\n  font-size: 0.8125rem;\n}\n\n.react-table-pagination-lg {\n  font-size: 0.9375rem;\n}\n\n.react-table-sort {\n  height: 25px;\n}\n\n/* Slider */\n.slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.slick-list {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n.slick-list:focus {\n  outline: none;\n}\n.slick-list.dragging {\n  cursor: pointer;\n  cursor: hand;\n}\n\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  -o-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.slick-track {\n  position: relative;\n  left: 0;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.slick-track:before, .slick-track:after {\n  content: \"\";\n  display: table;\n}\n.slick-track:after {\n  clear: both;\n}\n.slick-loading .slick-track {\n  visibility: hidden;\n}\n\n.slick-slide {\n  float: left;\n  height: 100%;\n  min-height: 1px;\n  display: none;\n}\n[dir=rtl] .slick-slide {\n  float: right;\n}\n.slick-slide img {\n  display: block;\n}\n.slick-slide.slick-loading img {\n  display: none;\n}\n.slick-slide.dragging img {\n  pointer-events: none;\n}\n.slick-initialized .slick-slide {\n  display: block;\n}\n.slick-loading .slick-slide {\n  visibility: hidden;\n}\n.slick-vertical .slick-slide {\n  display: block;\n  height: auto;\n  border: 1px solid transparent;\n}\n\n.slick-arrow.slick-hidden {\n  display: none;\n}\n\n.slick-slide img {\n  display: unset;\n}\n\n.slick-vertical .slick-slide {\n  border: none;\n}\n\n.slick-slider:not(.slick-vertical) .slick-track {\n  display: flex;\n}\n.slick-slider:not(.slick-vertical) .slick-slide {\n  height: auto;\n}\n.slick-slider:not(.slick-vertical) .slick-slide > div {\n  height: 100%;\n}\n\n.carousel-page {\n  --carousel-page-item-bg: #b6b6b6;\n  --carousel-page-item-bg-hover: #111111;\n  --carousel-page-item-bg-active: #343434;\n  background: transparent;\n  border: 1px solid transparent;\n}\n.carousel-page::before {\n  content: \"\";\n  display: block;\n  background: var(--carousel-page-item-bg);\n  transition: background-color 0.15s ease-in-out;\n}\n.carousel-page.active::before {\n  background: var(--carousel-page-item-bg-active);\n}\n.carousel-page:hover::before {\n  background: var(--carousel-page-item-bg-hover);\n}\n.carousel-page:focus-visible {\n  outline: 0;\n  border-color: #304ffe;\n}\n\n.carousel-text-transition {\n  transition: opacity 500ms ease;\n}\n\n.carousel-page-dot {\n  padding: 0.4375rem;\n  width: 24px;\n  height: 24px;\n}\n.carousel-page-dot::before {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.carousel-page-dot-lg {\n  width: 28px;\n  height: 28px;\n}\n.carousel-page-dot-lg::before {\n  width: 12px;\n  height: 12px;\n}\n\n.carousel-page-bar,\n.carousel-page-pill {\n  padding: 1.125rem 0.1875rem;\n}\n.carousel-page-bar::before,\n.carousel-page-pill::before {\n  width: 2rem;\n  height: 0.125rem;\n}\n\n.carousel-page-bar-lg,\n.carousel-page-pill-lg {\n  padding: 1.25rem 0.1875rem;\n}\n.carousel-page-bar-lg::before,\n.carousel-page-pill-lg::before {\n  width: 2.375rem;\n  height: 0.25rem;\n}\n\n.carousel-page-pill::before {\n  border-radius: 0.125rem;\n}\n\n.carousel-progress-parent:hover .carousel-progress-bar {\n  animation-play-state: paused;\n}\n\n.carousel-progress-bar {\n  transition: none;\n  width: 0;\n  animation: grow-width var(--carousel-slide-duration) linear forwards;\n}\n\n@keyframes grow-width {\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n}\n.btn-carousel-overlay {\n  --bs-btn-disabled-bg: rgba(255, 255, 255, 0.5);\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-disabled-color: rgba(17, 17, 17, 0.5);\n}\n.btn-carousel-overlay:not(.disabled), .btn-carousel-overlay:not(:disabled) {\n  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.26);\n}\n\n.carousel-page-overlay {\n  --carousel-page-item-bg: #a1a1a1;\n  --carousel-page-item-bg-hover: #fff;\n  --carousel-page-item-bg-active: #fcfcfc;\n}\n.carousel-page-overlay::before {\n  box-shadow: 0 0.03125rem 0.03125rem 0 rgba(0, 0, 0, 0.84);\n}\n.carousel-page-overlay.active::before {\n  box-shadow: 0 0.03125rem 0.1875rem 0 rgba(0, 0, 0, 0.92);\n}\n\n.dark .carousel-page:not(.carousel-page-overlay) {\n  --carousel-page-item-bg: #343434;\n  --carousel-page-item-bg-hover: #fff;\n  --carousel-page-item-bg-active: #808080;\n}\n\n.recharts-wrapper {\n  --recharts-grid-color: #111111;\n  --recharts-polar-grid-opacity: 0.14;\n  --recharts-radial-bar-bg: #ededed;\n  --recharts-tooltip-cursor-stroke: #002bbc;\n  --recharts-reference-line-blue: #ccd5f2;\n  --recharts-bar-tooltip-cursor-fill: rgba(17, 17, 17, 0.08);\n  --recharts-bg: #fff;\n  --recharts-pie-text-overlay-color: #fff;\n  font-size: 0.8125rem;\n}\n\n.recharts-surface text {\n  fill: currentColor;\n}\n\n.recharts-tooltip-content {\n  min-width: 165px;\n  max-width: 200px;\n  visibility: \"visible\";\n}\n\n.recharts-cartesian-grid line {\n  stroke: var(--recharts-grid-color);\n  stroke-opacity: 0.08;\n}\n\n.recharts-cartesian-axis line {\n  stroke: var(--recharts-grid-color);\n  stroke-opacity: 0.4;\n}\n.recharts-cartesian-axis .recharts-label {\n  font-size: 1rem;\n  opacity: 0.52;\n  text-anchor: middle;\n}\n\n.recharts-polar-grid line,\n.recharts-polar-grid path {\n  stroke: var(--recharts-grid-color);\n  stroke-opacity: var(--recharts-polar-grid-opacity);\n}\n\n.recharts-tooltip-cursor:not(.recharts-rectangle) {\n  stroke: var(--recharts-tooltip-cursor-stroke);\n}\n.recharts-tooltip-cursor.recharts-rectangle {\n  fill: var(--recharts-bar-tooltip-cursor-fill);\n}\n\n.recharts-radial-bar-background-sector {\n  fill: var(--recharts-radial-bar-bg);\n}\n\n.recharts-label-list {\n  font-size: 0.75rem;\n  text-anchor: middle;\n  fill-opacity: 0.84;\n  stroke: var(--recharts-bg);\n  stroke-opacity: 0.8;\n  stroke-width: 4px;\n  paint-order: stroke;\n}\n\n.recharts-reference-line .recharts-label {\n  stroke: var(--recharts-bg);\n  stroke-opacity: 0.8;\n  stroke-width: 10px;\n  paint-order: stroke;\n}\n\n.recharts-pie-sector:focus,\n.recharts-sector:focus {\n  outline: none;\n}\n\n.recharts-pie-sector .recharts-sector {\n  stroke: var(--recharts-bg);\n  transition: opacity 0.15s ease-in-out;\n}\n\n.recharts-pie-label-line {\n  stroke: var(--recharts-grid-color);\n  stroke-opacity: 0.4;\n  stroke-width: 1;\n}\n\n.recharts-pie-text-overlay {\n  fill: var(--recharts-pie-text-overlay-color) !important;\n}\n\n.dark .recharts-wrapper {\n  --recharts-grid-color: #fff;\n  --recharts-polar-grid-opacity: 0.4;\n  --recharts-radial-bar-bg: #090909;\n  --recharts-tooltip-cursor-stroke: #8ddbff;\n  --recharts-reference-line-blue: #2a3a41;\n  --recharts-bar-tooltip-cursor-fill: rgba(255, 255, 255, 0.06);\n  --recharts-bg: #111111;\n  --recharts-pie-text-overlay-color: #111111;\n}\n\n.recharts-wrapper {\n  --recharts-color-1-1: #090909;\n  --recharts-color-2-1: #090909;\n  --recharts-color-2-2: #b6b6b6;\n  --recharts-color-3-1: #090909;\n  --recharts-color-3-2: #606060;\n  --recharts-color-3-3: #b6b6b6;\n  --recharts-color-4-1: #090909;\n  --recharts-color-4-2: #434343;\n  --recharts-color-4-3: #7d7d7d;\n  --recharts-color-4-4: #b6b6b6;\n  --recharts-color-5-1: #090909;\n  --recharts-color-5-2: #343434;\n  --recharts-color-5-3: #5f5f5f;\n  --recharts-color-5-4: #bababa;\n  --recharts-color-5-5: #b6b6b6;\n  --recharts-color-6-1: #090909;\n  --recharts-color-6-2: #2c2c2c;\n  --recharts-color-6-3: #4f4f4f;\n  --recharts-color-6-4: #727272;\n  --recharts-color-6-5: #959595;\n  --recharts-color-6-6: #b6b6b6;\n}\n\n.dark .recharts-wrapper {\n  --recharts-color-1-1: #fcfcfc;\n  --recharts-color-2-1: #fcfcfc;\n  --recharts-color-2-2: #575757;\n  --recharts-color-3-1: #fcfcfc;\n  --recharts-color-3-2: #a6a6a6;\n  --recharts-color-3-3: #575757;\n  --recharts-color-4-1: #fcfcfc;\n  --recharts-color-4-2: #c2c2c2;\n  --recharts-color-4-3: #8a8a8a;\n  --recharts-color-4-4: #575757;\n  --recharts-color-5-1: #fcfcfc;\n  --recharts-color-5-2: #d0d0d0;\n  --recharts-color-5-3: #a6a6a6;\n  --recharts-color-5-4: #7d7d7d;\n  --recharts-color-5-5: #575757;\n  --recharts-color-6-1: #fcfcfc;\n  --recharts-color-6-2: #d9d9d9;\n  --recharts-color-6-3: #b6b6b6;\n  --recharts-color-6-4: #959595;\n  --recharts-color-6-5: #757575;\n  --recharts-color-6-6: #575757;\n}\n\n.recharts-brush {\n  --recharts-brush-bg: #ededed;\n  --recharts-brush-connect-bg: #767676;\n  --recharts-brush-handle-bg: #fff;\n  --recharts-brush-stroke: #dedede;\n  transform: translateY(30px);\n}\n.recharts-brush > rect:first-child {\n  fill: var(--recharts-brush-bg);\n  stroke: none;\n}\n\n.recharts-brush-slide {\n  fill: var(--recharts-brush-connect-bg);\n  fill-opacity: 1;\n}\n\n.recharts-brush-traveller-circle {\n  fill: var(--recharts-brush-handle-bg);\n  stroke: var(--recharts-brush-stroke);\n}\n\n.recharts-brush-texts text {\n  fill: currentColor;\n}\n.recharts-brush-texts text:first-child {\n  transform: translate(10.5px, 30px);\n  text-anchor: middle;\n}\n.recharts-brush-texts text:last-child {\n  transform: translate(-10.5px, 30px);\n  text-anchor: middle;\n}\n\n.dark .recharts-brush {\n  --recharts-brush-bg: #4b4b4b;\n  --recharts-brush-connect-bg: #878787;\n  --recharts-brush-handle-bg: #343434;\n  --recharts-brush-stroke: #575757;\n}\n\n.flatpickr-wrapper {\n  display: block;\n}\n\n.flatpickr-calendar {\n  box-shadow: 0 0.75rem 1rem rgba(35, 35, 35, 0.2);\n  border-radius: 0;\n  padding: 20px;\n  width: 320px;\n}\n.flatpickr-calendar.multiMonth {\n  width: 602px !important;\n}\n.flatpickr-calendar.arrowTop::before, .flatpickr-calendar.arrowTop::after {\n  content: none;\n}\n.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {\n  box-shadow: none;\n}\n.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {\n  border-top: none;\n}\n\n.flatpickr-months {\n  margin-bottom: 14px;\n}\n.flatpickr-months .flatpickr-prev-month,\n.flatpickr-months .flatpickr-next-month {\n  top: 20px;\n  display: flex;\n  fill: rgba(17, 17, 17, 0.54);\n}\n.flatpickr-months .flatpickr-prev-month:hover svg,\n.flatpickr-months .flatpickr-next-month:hover svg {\n  fill: #111111;\n}\n.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,\n.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {\n  left: 20px;\n}\n.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,\n.flatpickr-months .flatpickr-next-month.flatpickr-next-month {\n  right: 20px;\n}\n\n.flatpickr-days {\n  width: 280px;\n}\n\n.flatpickr-day {\n  color: #111111;\n  border: none;\n  width: 40px;\n  height: 40px;\n  max-width: 40px;\n}\n.flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay {\n  color: rgba(17, 17, 17, 0.5);\n}\n.flatpickr-day.inRange {\n  border-radius: 50%;\n  box-shadow: none;\n}\n.flatpickr-day.inRange::after {\n  box-shadow: -5px 0 0 #f2f2f2, 5px 0 0 #f2f2f2;\n  content: \"\";\n  position: absolute;\n  background-color: #f2f2f2;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n}\n.flatpickr-day.inRange:nth-child(7n+7)::after, .flatpickr-day.inRange:nth-child(7n+1)::after {\n  box-shadow: none;\n}\n.flatpickr-day.inRange, .flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange {\n  background: #f2f2f2;\n}\n.flatpickr-day.today.inRange, .flatpickr-day.prevMonthDay.today.inRange, .flatpickr-day.nextMonthDay.today.inRange {\n  background: rgba(17, 17, 17, 0.075);\n}\n.flatpickr-day:hover, .flatpickr-day:focus, .flatpickr-day.prevMonthDay:hover, .flatpickr-day.prevMonthDay:focus, .flatpickr-day.nextMonthDay:hover, .flatpickr-day.nextMonthDay:focus {\n  background: #ededed;\n}\n.flatpickr-day.today {\n  background-color: rgba(17, 17, 17, 0.075);\n}\n.flatpickr-day.today:hover, .flatpickr-day.today:focus {\n  background-color: #b6b6b6;\n}\n.flatpickr-day.selected, .flatpickr-day.selected.inRange, .flatpickr-day.selected:focus, .flatpickr-day.selected:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange, .flatpickr-day.startRange.inRange, .flatpickr-day.startRange:focus, .flatpickr-day.startRange:hover, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange, .flatpickr-day.endRange.inRange, .flatpickr-day.endRange:focus, .flatpickr-day.endRange:hover, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.endRange.nextMonthDay {\n  background: #111111;\n}\n.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {\n  box-shadow: none;\n}\n.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1))::after, .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1))::after, .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1))::after {\n  box-shadow: -5px 0 0 #f2f2f2;\n}\n.flatpickr-day.selected.startRange, .flatpickr-day.startRange.startRange, .flatpickr-day.endRange.startRange, .flatpickr-day.selected.endRange, .flatpickr-day.startRange.endRange, .flatpickr-day.endRange.endRange {\n  border-radius: 50%;\n}\n.flatpickr-day.selected.startRange::after, .flatpickr-day.startRange.startRange::after, .flatpickr-day.endRange.startRange::after, .flatpickr-day.selected.endRange::after, .flatpickr-day.startRange.endRange::after, .flatpickr-day.endRange.endRange::after {\n  content: \"\";\n  position: absolute;\n  background-color: #f2f2f2;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n}\n.flatpickr-day.selected.startRange::after, .flatpickr-day.startRange.startRange::after, .flatpickr-day.endRange.startRange::after {\n  left: 50%;\n}\n.flatpickr-day.selected.endRange::after, .flatpickr-day.startRange.endRange::after, .flatpickr-day.endRange.endRange::after {\n  right: 50%;\n}\n\n.rangeMode .flatpickr-day {\n  margin-top: 0px;\n}\n\n.dayContainer {\n  width: 280px;\n  min-width: 280px;\n  max-width: 280px;\n}\n\nspan.flatpickr-weekday {\n  font-weight: normal;\n  font-size: 0.875rem;\n  color: #0f0f0f;\n}\n\n.dayContainer + .dayContainer {\n  box-shadow: none;\n  border-left: 1px solid #dedede;\n}\n\n.flatpickr-input[readonly],\n.flatpickr-input[readonly] ~ [class*=input-group] > .input-group-text,\n.flatpickr-input + .form-control[readonly],\n.flatpickr-input + .form-control[readonly] ~ [class*=input-group] > .input-group-text,\n.form-control[data-fp-omit][readonly],\n.form-control[data-fp-omit][readonly] ~ [class*=input-group] > .input-group-text {\n  background-color: transparent !important;\n}\n\n.input-group-flatpickr {\n  --flatpickr-input-active-border-color: #000000;\n}\n\n.flatpickr-input + .form-control:not(:focus).active, .flatpickr-input + .form-control:not(:focus).active + .input-group-prepend .input-group-text, .flatpickr-input.form-control:not(:focus).active, .flatpickr-input.form-control:not(:focus).active + .input-group-prepend .input-group-text {\n  border-color: var(--flatpickr-input-active-border-color);\n}\n\n.numInputWrapper span {\n  border: 0;\n}\n.numInputWrapper:hover,\n.numInputWrapper span:hover {\n  background: transparent;\n}\n\n.flatpickr-current-month .flatpickr-monthDropdown-months {\n  margin-right: 18px;\n}\n.flatpickr-current-month .flatpickr-monthDropdown-months:hover {\n  background: transparent;\n}\n.flatpickr-current-month .flatpickr-monthDropdown-months,\n.flatpickr-current-month input.cur-year,\n.flatpickr-current-month span.cur-month {\n  font-weight: 500;\n  font-size: 1rem;\n  letter-spacing: 0.05px;\n}\n.flatpickr-current-month .numInputWrapper span.arrowUp:after {\n  border-bottom-color: rgba(17, 17, 17, 0.3);\n}\n.flatpickr-current-month .numInputWrapper span.arrowUp:hover:after {\n  border-bottom-color: #111111;\n}\n.flatpickr-current-month .numInputWrapper span.arrowDown:after {\n  border-top-color: rgba(17, 17, 17, 0.3);\n}\n.flatpickr-current-month .numInputWrapper span.arrowDown:hover:after {\n  border-top-color: #111111;\n}\n\n.flatpickr-time .flatpickr-time-separator {\n  font-weight: 700;\n  width: 40px;\n}\n.flatpickr-time input {\n  padding-right: 22px;\n  cursor: pointer;\n  transition: border-color 0.15s ease-in-out;\n  border: 1px solid transparent;\n}\n.flatpickr-time input:focus {\n  border: 1px solid #304ffe;\n}\n.flatpickr-time input:hover, .flatpickr-time input:focus {\n  background-color: #f2f2f2;\n}\n.flatpickr-time input.flatpickr-hour, .flatpickr-time input.flatpickr-minute, .flatpickr-time input.flatpickr-second {\n  font-size: 1.125rem;\n  font-weight: 400;\n  color: #111111;\n}\n.flatpickr-time .flatpickr-time-separator {\n  font-size: 1.125rem;\n  font-weight: 400;\n  color: #111111;\n}\n.flatpickr-time .flatpickr-am-pm {\n  border-radius: 50%;\n  width: 40px;\n  margin-left: 30px;\n  color: #111111;\n}\n.flatpickr-time .flatpickr-am-pm:hover, .flatpickr-time .flatpickr-am-pm:focus {\n  background: #ededed;\n}\n.flatpickr-time .numInputWrapper span {\n  padding: 0 16px 0 6px;\n  opacity: 0.5;\n  transition: opacity 0.2s ease-in-out;\n}\n.flatpickr-time .numInputWrapper span:hover {\n  opacity: 1;\n}\n.flatpickr-time .numInputWrapper span.arrowUp:after {\n  border-bottom-width: 6px;\n  border-bottom-color: #111111;\n  top: 40%;\n}\n.flatpickr-time .numInputWrapper span.arrowDown:after {\n  border-top-width: 6px;\n  border-top-color: #111111;\n  top: 25%;\n}\n\n.dark .input-group-flatpickr {\n  --flatpickr-input-active-border-color: #fafafa;\n}\n.dark .flatpickr-calendar {\n  box-shadow: 0 1.25rem 1.875rem rgba(17, 17, 17, 0.6);\n  background-color: #232323;\n}\n.dark .flatpickr-months .flatpickr-prev-month,\n.dark .flatpickr-months .flatpickr-next-month {\n  fill: rgba(255, 255, 255, 0.54);\n}\n.dark .flatpickr-months .flatpickr-prev-month:hover svg,\n.dark .flatpickr-months .flatpickr-next-month:hover svg {\n  fill: #fff;\n}\n.dark .flatpickr-current-month .flatpickr-monthDropdown-months,\n.dark .flatpickr-current-month input.cur-year,\n.dark .flatpickr-current-month span.cur-month {\n  color: #fff;\n}\n.dark span.flatpickr-weekday {\n  color: #fff;\n}\n.dark .flatpickr-day {\n  color: rgba(255, 255, 255, 0.92);\n}\n.dark .flatpickr-day.flatpickr-disabled:hover {\n  color: rgba(255, 255, 255, 0.92);\n}\n.dark .flatpickr-day.inRange::after {\n  box-shadow: -5px 0 0 #343434, 5px 0 0 #343434;\n  background-color: #343434;\n}\n.dark .flatpickr-day:nth-child(7n+7)::after, .dark .flatpickr-day:nth-child(7n+1)::after {\n  box-shadow: none;\n}\n.dark .flatpickr-day.inRange, .dark .flatpickr-day.prevMonthDay.inRange, .dark .flatpickr-day.nextMonthDay.inRange {\n  background: #343434;\n}\n.dark .flatpickr-day.today.inRange, .dark .flatpickr-day.prevMonthDay.today.inRange, .dark .flatpickr-day.nextMonthDay.today.inRange {\n  background: #404040;\n}\n.dark .flatpickr-day:hover, .dark .flatpickr-day:focus, .dark .flatpickr-day.prevMonthDay:hover, .dark .flatpickr-day.prevMonthDay:focus, .dark .flatpickr-day.nextMonthDay:hover, .dark .flatpickr-day.nextMonthDay:focus {\n  background: #404040;\n}\n.dark .flatpickr-day.prevMonthDay, .dark .flatpickr-day.nextMonthDay {\n  color: rgba(255, 255, 255, 0.4);\n}\n.dark .flatpickr-day.today {\n  background-color: #343434;\n}\n.dark .flatpickr-day.today:hover, .dark .flatpickr-day.today:focus {\n  background-color: #404040;\n  color: #fff;\n}\n.dark .flatpickr-day.selected {\n  background-color: #fff;\n  color: #111111;\n}\n.dark .flatpickr-day.startRange, .dark .flatpickr-day.startRange.inRange, .dark .flatpickr-day.startRange:focus, .dark .flatpickr-day.startRange:hover, .dark .flatpickr-day.startRange.prevMonthDay, .dark .flatpickr-day.startRange.nextMonthDay, .dark .flatpickr-day.endRange, .dark .flatpickr-day.endRange.inRange, .dark .flatpickr-day.endRange:focus, .dark .flatpickr-day.endRange:hover, .dark .flatpickr-day.endRange.prevMonthDay, .dark .flatpickr-day.endRange.nextMonthDay {\n  background: #111111;\n}\n.dark .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1))::after, .dark .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1))::after, .dark .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1))::after {\n  box-shadow: -5px 0 0 #343434;\n}\n.dark .flatpickr-day.selected.startRange, .dark .flatpickr-day.startRange.startRange, .dark .flatpickr-day.endRange.startRange, .dark .flatpickr-day.selected.endRange, .dark .flatpickr-day.startRange.endRange, .dark .flatpickr-day.endRange.endRange {\n  background-color: #fff;\n  color: #111111;\n}\n.dark .flatpickr-day.selected.startRange::after, .dark .flatpickr-day.startRange.startRange::after, .dark .flatpickr-day.endRange.startRange::after, .dark .flatpickr-day.selected.endRange::after, .dark .flatpickr-day.startRange.endRange::after, .dark .flatpickr-day.endRange.endRange::after {\n  background-color: #343434;\n}\n.dark .flatpickr-time input.flatpickr-hour,\n.dark .flatpickr-time .flatpickr-time-separator,\n.dark .flatpickr-time input.flatpickr-minute,\n.dark .flatpickr-time input.flatpickr-second {\n  color: #fff;\n}\n.dark .flatpickr-time .flatpickr-am-pm {\n  color: #fff;\n}\n.dark .flatpickr-time .flatpickr-am-pm:hover, .dark .flatpickr-time .flatpickr-am-pm:focus {\n  background: #404040;\n}\n.dark .flatpickr-time input {\n  transition: border-color 0.15s ease-in-out;\n  border: 1px solid transparent;\n}\n.dark .flatpickr-time input:focus {\n  border: 1px solid #304ffe;\n  background-color: #404040;\n}\n.dark .flatpickr-time input:hover {\n  background-color: #404040;\n}\n.dark .flatpickr-time .numInputWrapper span.arrowUp:after {\n  border-bottom-color: #fff;\n}\n.dark .flatpickr-time .numInputWrapper span.arrowDown:after {\n  border-top-color: #fff;\n}\n.dark .dayContainer + .dayContainer {\n  border-color: #4b4b4b;\n}\n.dark .flatpickr-current-month .numInputWrapper span.arrowUp:after {\n  border-bottom-color: rgba(255, 255, 255, 0.3);\n}\n.dark .flatpickr-current-month .numInputWrapper span.arrowUp:hover:after {\n  border-bottom-color: #fff;\n}\n.dark .flatpickr-current-month .numInputWrapper span.arrowDown:after {\n  border-top-color: rgba(255, 255, 255, 0.3);\n}\n.dark .flatpickr-current-month .numInputWrapper span.arrowDown:hover:after {\n  border-top-color: #fff;\n}\n\n.rbt .rbt-input-main::-ms-clear {\n  display: none;\n}\n\n/**\n * Menu\n */\n.rbt-menu {\n  margin-bottom: 2px;\n}\n.rbt-menu > .dropdown-item {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rbt-menu > .dropdown-item:focus {\n  outline: none;\n}\n.rbt-menu-pagination-option {\n  text-align: center;\n}\n\n/**\n * Multi-select Input\n */\n.rbt-input-multi {\n  cursor: text;\n  overflow: hidden;\n  position: relative;\n}\n.rbt-input-multi.focus {\n  border-color: #80bdff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  color: #495057;\n  outline: 0;\n}\n.rbt-input-multi.form-control {\n  height: auto;\n}\n.rbt-input-multi.disabled {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.rbt-input-multi.is-invalid.focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n.rbt-input-multi.is-valid.focus {\n  border-color: #28a745;\n  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n.rbt-input-multi input::-moz-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.rbt-input-multi input:-ms-input-placeholder {\n  color: #6c757d;\n}\n.rbt-input-multi input::-webkit-input-placeholder {\n  color: #6c757d;\n}\n.rbt-input-multi .rbt-input-wrapper {\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: -4px;\n  margin-top: -1px;\n  overflow: hidden;\n}\n.rbt-input-multi .rbt-input-main {\n  margin: 1px 0 4px;\n}\n\n/**\n * Close Button\n */\n.rbt-close {\n  z-index: 1;\n}\n.rbt-close-lg {\n  font-size: 1.5rem;\n}\n\n/**\n * Token\n */\n.rbt-token {\n  background-color: #e7f4ff;\n  border: 0;\n  border-radius: 0.25rem;\n  color: #007bff;\n  display: inline-flex;\n  line-height: 1rem;\n  margin: 1px 3px 2px 0;\n}\n.rbt-token .rbt-token-label {\n  padding: 0.25rem 0.5rem;\n}\n.rbt-token .rbt-token-label:not(:last-child) {\n  padding-right: 0.25rem;\n}\n.rbt-token-disabled {\n  background-color: rgba(0, 0, 0, 0.1);\n  color: #495057;\n  pointer-events: none;\n}\n.rbt-token-removeable {\n  cursor: pointer;\n}\n.rbt-token-active {\n  background-color: #007bff;\n  color: #fff;\n  outline: none;\n  text-decoration: none;\n}\n.rbt-token .rbt-token-remove-button {\n  background-image: none;\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n  box-shadow: none;\n  color: inherit;\n  display: flex;\n  justify-content: center;\n  font-size: inherit;\n  font-weight: normal;\n  opacity: 1;\n  outline: none;\n  padding: 0.25rem 0.5rem;\n  padding-left: 0;\n  text-shadow: none;\n}\n.rbt-token .rbt-token-remove-button .rbt-close-content {\n  display: block;\n}\n\n/**\n * Loader + CloseButton container\n */\n.rbt-aux {\n  align-items: center;\n  display: flex;\n  bottom: 0;\n  justify-content: center;\n  pointer-events: none; /* Don't block clicks on the input */\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 2rem;\n}\n.rbt-aux-lg {\n  width: 3rem;\n}\n.rbt-aux .rbt-close {\n  margin-top: -0.25rem;\n  pointer-events: auto; /* Override pointer-events: none; above */\n}\n\n.has-aux .form-control {\n  padding-right: 2rem;\n}\n.has-aux .form-control.is-valid, .has-aux .form-control.is-invalid {\n  background-position: right 2rem center;\n  padding-right: 4rem;\n}\n\n.rbt-highlight-text {\n  background-color: inherit;\n  color: inherit;\n  font-weight: bold;\n  padding: 0;\n}\n\n/**\n * Input Groups\n */\n.input-group > .rbt {\n  flex: 1;\n}\n.input-group > .rbt .rbt-input-hint, .input-group > .rbt .rbt-aux {\n  z-index: 5;\n}\n.input-group > .rbt:not(:first-child) .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .rbt:not(:last-child) .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rbt-close {\n  font-size: 1rem;\n}\n.rbt-close-sm {\n  font-size: 0.75rem;\n}\n.rbt-close-content {\n  display: none;\n}\n\n.rbt-aux {\n  width: 2.5rem;\n}\n.rbt-aux-lg {\n  width: 3rem;\n}\n.rbt-aux .rbt-close {\n  margin-top: 0;\n}\n\n.rbt .form-floating {\n  flex: 1;\n}\n\n.form-floating > .rbt-input-multi:not(:placeholder-shown) ~ label {\n  opacity: inherit;\n  transform: inherit;\n}\n.form-floating > .rbt-input-multi .rbt-input-main::placeholder {\n  color: transparent;\n}\n.form-floating > .rbt-input-multi.focus ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n\n.rbt .dropdown-item {\n  display: block;\n}\n\n.rbt-highlight-text {\n  font-weight: 400;\n  color: #000;\n}\n\n.rbt-aux .rbt-close {\n  margin-top: 0;\n}\n\n.rbt-input-hint {\n  letter-spacing: 0.1px;\n}\n\n.dark .rbt-highlight-text {\n  color: #fff;\n}\n.dark .rbt-input-hint {\n  color: rgba(255, 255, 255, 0.54) !important;\n}\n\n.react-select__control {\n  background-color: transparent !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  font-size: 0.875rem;\n}\n.react-select__control:hover {\n  border-color: #666666 !important;\n}\n.react-select__control--is-focused {\n  border-color: #304ffe !important;\n}\n.react-select__control, .react-select__option {\n  cursor: pointer !important;\n}\n.react-select__option {\n  color: rgba(17, 17, 17, 0.64) !important;\n  font-size: 0.875rem !important;\n  background-color: transparent !important;\n}\n.react-select__option--is-selected {\n  background-color: transparent !important;\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"%23090909\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n  background-repeat: no-repeat;\n  background-position: right 0.625rem center;\n  background-size: 24px 24px;\n  padding-right: 3.6875rem;\n  color: #111111 !important;\n}\n.react-select__option:hover, .react-select__option--is-focused {\n  color: #111111 !important;\n  background-color: #fafafa !important;\n}\n.react-select__option:active {\n  background-color: #f2f2f2 !important;\n}\n.react-select__value-container {\n  padding-left: 0.9375rem !important;\n}\n\n.dark .react-select__control {\n  border-color: #404040;\n}\n.dark .react-select__control--is-focused {\n  border-color: #878787 !important;\n}\n.dark .react-select__placeholder {\n  color: rgba(255, 255, 255, 0.64);\n}\n.dark .react-select__input-container {\n  color: #fff;\n}\n.dark .react-select__menu {\n  background: #232323;\n}\n.dark .react-select__option {\n  color: rgba(255, 255, 255, 0.64) !important;\n}\n.dark .react-select__option--is-selected {\n  background-image: url('data:image/svg+xml,%3csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"%3e%3cpolyline stroke=\"rgba%28255, 255, 255, 0.64%29\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate%285.834623, 8.000000%29\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"%3e%3c/polyline%3e%3c/svg%3e');\n  color: #fff !important;\n}\n.dark .react-select__option:hover, .dark .react-select__option--is-focused {\n  background-color: #343434 !important;\n  color: #fff !important;\n}\n.dark .react-select__option:active {\n  background-color: #404040 !important;\n}\n.dark .react-select__single-value {\n  color: #fff !important;\n}\n\nbody {\n  background-color: #fff;\n  font-family: \"Roboto\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n#webpack-dev-server-client-overlay {\n  display: none;\n}","// https://getbootstrap.com/docs/5.3/utilities/api/#override-utilities\n\n// Bootstrap utilities overrides\n\n$utilities: (\n  'background-color': (\n    property: background-color,\n    class: bg,\n    local-vars: (\n      'bg-opacity': 1,\n    ),\n    values:\n      map-merge(\n        $utilities-bg-colors,\n        (\n          'transparent': transparent,\n          // 5 levels, these flip in dark mode\n          'primary': $white,\n          'secondary': $light-gray-100,\n          'tertiary': $light-gray-200,\n          'quartenary': $light-gray-300,\n          'quinary': $light-gray-400,\n          'bp-yellow': $bp-yellow,\n          'bp-green-logo': $bp-green-logo,\n          'bp-green': $bp-green,\n          'bp-light-green': $bp-light-green,\n          'almost-dark': #1d1d1d,\n          'dark-secondary': #121212,\n        )\n      ),\n  ),\n  'border-color': (\n    property: border-color,\n    class: border,\n    local-vars: (\n      'border-opacity': 1,\n    ),\n    values:\n      map-merge(\n        $utilities-border-colors,\n        (\n          'primary': $light-gray-300,\n        )\n      ),\n  ),\n  'rounded': (\n    property: border-radius,\n    class: rounded,\n    values: (\n      null: var(--#{$prefix}border-radius),\n      0: 0,\n      1: var(--#{$prefix}border-radius-xs),\n      2: var(--#{$prefix}border-radius-sm),\n      3: var(--#{$prefix}border-radius),\n      4: var(--#{$prefix}border-radius-lg),\n      5: var(--#{$prefix}border-radius-xl),\n      6: var(--#{$prefix}border-radius-xxl),\n      7: var(--#{$prefix}border-radius-3xl),\n      8: var(--#{$prefix}border-radius-4xl),\n      circle: 50%,\n      pill: var(--#{$prefix}border-radius-pill),\n    ),\n  ),\n  'rounded-top': (\n    // prettier-ignore to prevent error from extra comma at end of list\n    property: (border-top-left-radius border-top-right-radius),\n    class: rounded-top,\n    values: (\n      null: var(--#{$prefix}border-radius),\n      1: var(--#{$prefix}border-radius-xs),\n      2: var(--#{$prefix}border-radius-sm),\n      3: var(--#{$prefix}border-radius),\n      4: var(--#{$prefix}border-radius-lg),\n      5: var(--#{$prefix}border-radius-xl),\n      6: var(--#{$prefix}border-radius-xxl),\n      7: var(--#{$prefix}border-radius-3xl),\n      8: var(--#{$prefix}border-radius-4xl),\n    ),\n  ),\n  'rounded-top-left': (\n    property: border-top-left-radius,\n    class: rounded-top-left,\n    values: (\n      null: var(--#{$prefix}border-radius),\n      1: var(--#{$prefix}border-radius-xs),\n      2: var(--#{$prefix}border-radius-sm),\n      3: var(--#{$prefix}border-radius),\n      4: var(--#{$prefix}border-radius-lg),\n      5: var(--#{$prefix}border-radius-xl),\n      6: var(--#{$prefix}border-radius-xxl),\n      7: var(--#{$prefix}border-radius-3xl),\n      8: var(--#{$prefix}border-radius-4xl),\n    ),\n  ),\n  'rounded-top-right': (\n    property: border-top-right-radius,\n    class: rounded-top-right,\n    values: (\n      null: var(--#{$prefix}border-radius),\n      1: var(--#{$prefix}border-radius-xs),\n      2: var(--#{$prefix}border-radius-sm),\n      3: var(--#{$prefix}border-radius),\n      4: var(--#{$prefix}border-radius-lg),\n      5: var(--#{$prefix}border-radius-xl),\n      6: var(--#{$prefix}border-radius-xxl),\n      7: var(--#{$prefix}border-radius-3xl),\n      8: var(--#{$prefix}border-radius-4xl),\n    ),\n  ),\n  'rounded-bottom-right': (\n    property: border-bottom-right-radius,\n    class: rounded-bottom-right,\n    values: (\n      null: var(--#{$prefix}border-radius),\n      1: var(--#{$prefix}border-radius-xs),\n      2: var(--#{$prefix}border-radius-sm),\n      3: var(--#{$prefix}border-radius),\n      4: var(--#{$prefix}border-radius-lg),\n      5: var(--#{$prefix}border-radius-xl),\n      6: var(--#{$prefix}border-radius-xxl),\n      7: var(--#{$prefix}border-radius-3xl),\n      8: var(--#{$prefix}border-radius-4xl),\n    ),\n  ),\n  'rounded-bottom-left': (\n    property: border-bottom-left-radius,\n    class: rounded-bottom-left,\n    values: (\n      null: var(--#{$prefix}border-radius),\n      1: var(--#{$prefix}border-radius-xs),\n      2: var(--#{$prefix}border-radius-sm),\n      3: var(--#{$prefix}border-radius),\n      4: var(--#{$prefix}border-radius-lg),\n      5: var(--#{$prefix}border-radius-xl),\n      6: var(--#{$prefix}border-radius-xxl),\n      7: var(--#{$prefix}border-radius-3xl),\n      8: var(--#{$prefix}border-radius-4xl),\n    ),\n  ),\n  'rounded-end': (\n    // prettier-ignore to prevent error from extra comma at end of list\n    property: (border-bottom-right-radius border-top-right-radius),\n    class: rounded-end,\n    values: (\n      null: var(--#{$prefix}border-radius),\n      1: var(--#{$prefix}border-radius-xs),\n      2: var(--#{$prefix}border-radius-sm),\n      3: var(--#{$prefix}border-radius),\n      4: var(--#{$prefix}border-radius-lg),\n      5: var(--#{$prefix}border-radius-xl),\n      6: var(--#{$prefix}border-radius-xxl),\n      7: var(--#{$prefix}border-radius-3xl),\n      8: var(--#{$prefix}border-radius-4xl),\n    ),\n  ),\n  'rounded-bottom': (\n    // prettier-ignore to prevent error from extra comma at end of list\n    property: (border-bottom-right-radius border-bottom-left-radius),\n    class: rounded-bottom,\n    values: (\n      null: var(--#{$prefix}border-radius),\n      1: var(--#{$prefix}border-radius-xs),\n      2: var(--#{$prefix}border-radius-sm),\n      3: var(--#{$prefix}border-radius),\n      4: var(--#{$prefix}border-radius-lg),\n      5: var(--#{$prefix}border-radius-xl),\n      6: var(--#{$prefix}border-radius-xxl),\n      7: var(--#{$prefix}border-radius-3xl),\n      8: var(--#{$prefix}border-radius-4xl),\n    ),\n  ),\n  'rounded-start': (\n    // prettier-ignore to prevent error from extra comma at end of list\n    property: (border-top-left-radius border-bottom-left-radius),\n    class: rounded-start,\n    values: (\n      null: var(--#{$prefix}border-radius),\n      1: var(--#{$prefix}border-radius-xs),\n      2: var(--#{$prefix}border-radius-sm),\n      3: var(--#{$prefix}border-radius),\n      4: var(--#{$prefix}border-radius-lg),\n      5: var(--#{$prefix}border-radius-xl),\n      6: var(--#{$prefix}border-radius-xxl),\n      7: var(--#{$prefix}border-radius-3xl),\n      8: var(--#{$prefix}border-radius-4xl),\n    ),\n  ),\n  'letter-spacing': (\n    property: letter-spacing,\n    class: ls,\n    values: (\n      '0': 0,\n      '0-3': 0.3px,\n      '1': 1px,\n      '1-2': 1.2px,\n      '1-5': 1.5px,\n      '2': 2px,\n    ),\n  ),\n  'line-height': (\n    property: line-height,\n    class: lh,\n    values: (\n      '1': 1,\n      '1-125': 1.125,\n      '1-25': 1.25,\n      'sm': $line-height-sm,\n      '1-375': 1.375,\n      '1-5': 1.5,\n      '1-625': 1.625,\n      '1-75': 1.75,\n      'base': $line-height-base,\n      '1-875': 1.875,\n      '2': 2,\n      'lg': $line-height-lg,\n    ),\n  ),\n  'opacity': (\n    // instead of the default 4 opacity utilities\n    // https://getbootstrap.com/docs/5.3/utilities/opacity/\n    property: opacity,\n    values: (\n      0: 0,\n      10: 0.1,\n      20: 0.2,\n      30: 0.3,\n      40: 0.4,\n      50: 0.5,\n      60: 0.6,\n      70: 0.7,\n      80: 0.8,\n      90: 0.9,\n      100: 1,\n    ),\n  ),\n  'shadow': (\n    property: box-shadow,\n    class: shadow,\n    values: (\n      null: $box-shadow,\n      xs: $box-shadow-xs,\n      sm: $box-shadow-sm,\n      lg: $box-shadow-lg,\n      xl: $box-shadow-xl,\n      'dark-xs': $box-shadow-dark-xs,\n      'dark-sm': $box-shadow-dark-sm,\n      'dark': $box-shadow-dark,\n      'dark-lg': $box-shadow-dark-lg,\n      'dark-xl': $box-shadow-dark-xl,\n      'nm-up': $box-shadow-nm-up,\n      'nm-down': $box-shadow-nm-down,\n      'nm-dark-up': $box-shadow-nm-dark-up,\n      'nm-dark-down': $box-shadow-nm-dark-down,\n      none: none,\n    ),\n  ),\n);\n\n// for svg inside of .btn-square and .square (non-button icon circles)\n.absolute-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n// use state: hover in $utilities opacity map to generate hover state class for all 10 increments instead?\n.opacity-100-hover {\n  transition: opacity 300ms;\n\n  &:hover {\n    opacity: 1 !important;\n  }\n}\n\n// shadow on hover for cards\n\n.hover-shadow {\n  transition: box-shadow 300ms;\n\n  &:hover {\n    box-shadow: $box-shadow;\n  }\n}\n\n.hover-shadow-lg {\n  transition: box-shadow 300ms;\n\n  &:hover {\n    box-shadow: $box-shadow-lg;\n  }\n}\n\n.hover-shadow-elevated {\n  transition: box-shadow 300ms;\n  box-shadow: $box-shadow-sm;\n\n  &:hover {\n    box-shadow: $box-shadow-lg;\n  }\n}\n\n// for Splits 2 header\n@include media-breakpoint-up(lg) {\n  .lh-lg-1-5 {\n    line-height: 1.5 !important;\n  }\n}\n\n// for dark mode logo\n.dark {\n  .dark-d-none {\n    display: none !important;\n  }\n\n  .dark-d-inline {\n    display: inline !important;\n  }\n\n  .hover-shadow {\n    &:hover {\n      box-shadow: 0 toRem(12px) toRem(16px) rgba($black, 0.5);\n    }\n  }\n\n  .hover-shadow-lg {\n    &:hover {\n      box-shadow: 0 toRem(20px) toRem(30px) rgba($black, 0.6);\n    }\n  }\n\n  .hover-shadow-elevated {\n    box-shadow: 0 toRem(9px) toRem(14px) rgba($black, 0.5);\n\n    &:hover {\n      box-shadow: 0 toRem(20px) toRem(30px) rgba($black, 0.6);\n    }\n  }\n}\n","// Variables / custom Bootstrap overrides\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white: #fff;\n$black: #000;\n\n$dark-gray-50: #767676;\n$dark-gray-100: #666666;\n$dark-gray-200: #575757;\n$dark-gray-300: #4b4b4b;\n$dark-gray-400: #404040;\n$dark-gray-500: #343434;\n$dark-gray-600: #232323;\n$dark-gray-700: #111111;\n$dark-gray-800: #090909;\n$dark-gray-900: #000000;\n\n$dark-grays: (\n  '50': $dark-gray-50,\n  '100': $dark-gray-100,\n  '200': $dark-gray-200,\n  '300': $dark-gray-300,\n  '400': $dark-gray-400,\n  '500': $dark-gray-500,\n  '600': $dark-gray-600,\n  '700': $dark-gray-700,\n  '800': $dark-gray-800,\n  '900': $dark-gray-900,\n);\n\n$light-gray-50: #fcfcfc;\n$light-gray-100: #fafafa;\n$light-gray-200: #f2f2f2;\n$light-gray-300: #ededed;\n$light-gray-400: #dedede;\n$light-gray-500: #cccccc;\n$light-gray-600: #b6b6b6;\n$light-gray-700: #a1a1a1;\n$light-gray-800: #878787;\n$light-gray-900: #808080;\n\n$light-grays: (\n  '50': $light-gray-50,\n  '100': $light-gray-100,\n  '200': $light-gray-200,\n  '300': $light-gray-300,\n  '400': $light-gray-400,\n  '500': $light-gray-500,\n  '600': $light-gray-600,\n  '700': $light-gray-700,\n  '800': $light-gray-800,\n  '900': $light-gray-900,\n);\n\n$op-dark-gray-50: rgba(#111, 0.575);\n$op-dark-gray-100: rgba(#111, 0.645);\n$op-dark-gray-200: rgba(#111, 0.705);\n$op-dark-gray-300: rgba(#111, 0.755);\n$op-dark-gray-400: rgba(#111, 0.805);\n$op-dark-gray-500: rgba(#111, 0.85);\n$op-dark-gray-600: rgba(#111, 0.925);\n$op-dark-gray-700: rgba(#111, 1);\n$op-dark-gray-800: rgba(#090909, 1);\n$op-dark-gray-900: rgba(#000, 1);\n\n$op-dark-grays: (\n  '50': $op-dark-gray-50,\n  '100': $op-dark-gray-100,\n  '200': $op-dark-gray-200,\n  '300': $op-dark-gray-300,\n  '400': $op-dark-gray-400,\n  '500': $op-dark-gray-500,\n  '600': $op-dark-gray-600,\n  '700': $op-dark-gray-700,\n  '800': $op-dark-gray-800,\n  '900': $op-dark-gray-900,\n);\n\n$op-light-gray-50: rgba(#111, 0.01);\n$op-light-gray-100: rgba(#111, 0.02);\n$op-light-gray-200: rgba(#111, 0.055);\n$op-light-gray-300: rgba(#111, 0.075);\n$op-light-gray-400: rgba(#111, 0.135);\n$op-light-gray-500: rgba(#111, 0.215);\n$op-light-gray-600: rgba(#111, 0.305);\n$op-light-gray-700: rgba(#111, 0.395);\n$op-light-gray-800: rgba(#111, 0.505);\n$op-light-gray-900: rgba(#111, 0.535);\n\n$op-light-grays: (\n  '50': $op-light-gray-50,\n  '100': $op-light-gray-100,\n  '200': $op-light-gray-200,\n  '300': $op-light-gray-300,\n  '400': $op-light-gray-400,\n  '500': $op-light-gray-500,\n  '600': $op-light-gray-600,\n  '700': $op-light-gray-700,\n  '800': $op-light-gray-800,\n  '900': $op-light-gray-900,\n);\n\n$bp-green-logo: #009900;\n\n// Primary colours\n\n$bp-green-50: #e7f5e6;\n$bp-green-100: #c5e7c1;\n$bp-green-200: #a0d799;\n$bp-green-300: #77c96e;\n$bp-green-400: #57bd4d;\n$bp-green-500: #34b128;\n$bp-green-600: #29a21f;\n$bp-green-700: #199011;\n$bp-green-800: #007f00;\n$bp-green-900: #006000;\n$bp-green: $bp-green-800;\n\n$bp-greens: (\n  '50': $bp-green-50,\n  '100': $bp-green-100,\n  '200': $bp-green-200,\n  '300': $bp-green-300,\n  '400': $bp-green-400,\n  '500': $bp-green-500,\n  '600': $bp-green-600,\n  '700': $bp-green-700,\n  '800': $bp-green-800,\n  '900': $bp-green-900,\n);\n\n$bp-light-green-50: #f4f9e5;\n$bp-light-green-100: #e3f0bf;\n$bp-light-green-200: #cfe696;\n$bp-light-green-300: #bbdc68;\n$bp-light-green-400: #a9d441;\n$bp-light-green-500: #99cc00;\n$bp-light-green-600: #88bc00;\n$bp-light-green-700: #71a800;\n$bp-light-green-800: #5a9400;\n$bp-light-green-900: #2e7300;\n$bp-light-green: $bp-light-green-500;\n\n$bp-light-greens: (\n  '50': $bp-light-green-50,\n  '100': $bp-light-green-100,\n  '200': $bp-light-green-200,\n  '300': $bp-light-green-300,\n  '400': $bp-light-green-400,\n  '500': $bp-light-green-500,\n  '600': $bp-light-green-600,\n  '700': $bp-light-green-700,\n  '800': $bp-light-green-800,\n  '900': $bp-light-green-900,\n);\n\n$bp-yellow-50: #fffce5;\n$bp-yellow-100: #fff7be;\n$bp-yellow-200: #fff292;\n$bp-yellow-300: #ffed65;\n$bp-yellow-400: #fee83d;\n$bp-yellow-500: #ffe600;\n$bp-yellow-600: #fed200;\n$bp-yellow-700: #fdb900;\n$bp-yellow-800: #fda000;\n$bp-yellow-900: #fb7300;\n$bp-yellow: $bp-yellow-500;\n\n$bp-yellows: (\n  '50': $bp-yellow-50,\n  '100': $bp-yellow-100,\n  '200': $bp-yellow-200,\n  '300': $bp-yellow-300,\n  '400': $bp-yellow-400,\n  '500': $bp-yellow-500,\n  '600': $bp-yellow-600,\n  '700': $bp-yellow-700,\n  '800': $bp-yellow-800,\n  '900': $bp-yellow-900,\n);\n\n// Supporting colours\n\n$bp-bright-green-50: #f9ffe7;\n$bp-bright-green-100: #f0ffc2;\n$bp-bright-green-200: #e4fe98;\n$bp-bright-green-300: #d8fd69;\n$bp-bright-green-400: #cdfa3f;\n$bp-bright-green-500: #ccff00;\n$bp-bright-green-600: #c1eb00;\n$bp-bright-green-700: #b1d400;\n$bp-bright-green-800: #a3bc00;\n$bp-bright-green-900: #8c9300;\n$bp-bright-green: $bp-bright-green-500;\n\n$bp-bright-greens: (\n  '50': $bp-bright-green-50,\n  '100': $bp-bright-green-100,\n  '200': $bp-bright-green-200,\n  '300': $bp-bright-green-300,\n  '400': $bp-bright-green-400,\n  '500': $bp-bright-green-500,\n  '600': $bp-bright-green-600,\n  '700': $bp-bright-green-700,\n  '800': $bp-bright-green-800,\n  '900': $bp-bright-green-900,\n);\n\n$bp-dark-green-50: #e5f4e9;\n$bp-dark-green-100: #c1e4ca;\n$bp-dark-green-200: #99d3a8;\n$bp-dark-green-300: #6ec386;\n$bp-dark-green-400: #4db66d;\n$bp-dark-green-500: #24aa54;\n$bp-dark-green-600: #1b9b4a;\n$bp-dark-green-700: #0e893f;\n$bp-dark-green-800: #007834;\n$bp-dark-green-900: #005921;\n$bp-dark-green: $bp-dark-green-800;\n\n$bp-dark-greens: (\n  '50': $bp-dark-green-50,\n  '100': $bp-dark-green-100,\n  '200': $bp-dark-green-200,\n  '300': $bp-dark-green-300,\n  '400': $bp-dark-green-400,\n  '500': $bp-dark-green-500,\n  '600': $bp-dark-green-600,\n  '700': $bp-dark-green-700,\n  '800': $bp-dark-green-800,\n  '900': $bp-dark-green-900,\n);\n\n$bp-dark-blue-50: #ece5f6;\n$bp-dark-blue-100: #cebee9;\n$bp-dark-blue-200: #ad93db;\n$bp-dark-blue-300: #8c67ce;\n$bp-dark-blue-400: #7246c4;\n$bp-dark-blue-500: #5724b9;\n$bp-dark-blue-600: #4d1fb4;\n$bp-dark-blue-700: #3e17ab;\n$bp-dark-blue-800: #2e10a4;\n$bp-dark-blue-900: #000099;\n$bp-dark-blue: $bp-dark-blue-900;\n\n$bp-dark-blues: (\n  '50': $bp-dark-blue-50,\n  '100': $bp-dark-blue-100,\n  '200': $bp-dark-blue-200,\n  '300': $bp-dark-blue-300,\n  '400': $bp-dark-blue-400,\n  '500': $bp-dark-blue-500,\n  '600': $bp-dark-blue-600,\n  '700': $bp-dark-blue-700,\n  '800': $bp-dark-blue-800,\n  '900': $bp-dark-blue-900,\n);\n\n$electric-blue: #304ffe;\n\n$bp-yellow-orange-50: #fcf7e1;\n$bp-yellow-orange-100: #f9eab4;\n$bp-yellow-orange-200: #f5dc84;\n$bp-yellow-orange-300: #f1d054;\n$bp-yellow-orange-400: #efc433;\n$bp-yellow-orange-500: #edbb20;\n$bp-yellow-orange-600: #edac1a;\n$bp-yellow-orange-700: #ec9c16;\n$bp-yellow-orange-800: #ec8c12;\n$bp-yellow-orange-900: #ea6f0d;\n$bp-yellow-orange: $bp-yellow-orange-600;\n\n$bp-yellow-oranges: (\n  '50': $bp-yellow-orange-50,\n  '100': $bp-yellow-orange-100,\n  '200': $bp-yellow-orange-200,\n  '300': $bp-yellow-orange-300,\n  '400': $bp-yellow-orange-400,\n  '500': $bp-yellow-orange-500,\n  '600': $bp-yellow-orange-600,\n  '700': $bp-yellow-orange-700,\n  '800': $bp-yellow-orange-800,\n  '900': $bp-yellow-orange-900,\n);\n\n$bp-pale-yellow-50: #fef9e4;\n$bp-pale-yellow-100: #fceebb;\n$bp-pale-yellow-200: #fce48f;\n$bp-pale-yellow-300: #fbdb65;\n$bp-pale-yellow-400: #fad14a;\n$bp-pale-yellow-500: #fbc93a;\n$bp-pale-yellow-600: #fabb34;\n$bp-pale-yellow-700: #f9a92e;\n$bp-pale-yellow-800: #f89929;\n$bp-pale-yellow-900: #f77d1f;\n$bp-pale-yellow: $bp-pale-yellow-300;\n\n$bp-pale-yellows: (\n  '50': $bp-pale-yellow-50,\n  '100': $bp-pale-yellow-100,\n  '200': $bp-pale-yellow-200,\n  '300': $bp-pale-yellow-300,\n  '400': $bp-pale-yellow-400,\n  '500': $bp-pale-yellow-500,\n  '600': $bp-pale-yellow-600,\n  '700': $bp-pale-yellow-700,\n  '800': $bp-pale-yellow-800,\n  '900': $bp-pale-yellow-900,\n);\n\n$bp-pale-green-50: #e4f1e5;\n$bp-pale-green-100: #bedbbf;\n$bp-pale-green-200: #94c496;\n$bp-pale-green-300: #6aae6e;\n$bp-pale-green-400: #4a9e51;\n$bp-pale-green-500: #288f33;\n$bp-pale-green-600: #1f812b;\n$bp-pale-green-700: #147122;\n$bp-pale-green-800: #066018;\n$bp-pale-green-900: #004306;\n$bp-pale-green: $bp-pale-green-100;\n\n$bp-pale-greens: (\n  '50': $bp-pale-green-50,\n  '100': $bp-pale-green-100,\n  '200': $bp-pale-green-200,\n  '300': $bp-pale-green-300,\n  '400': $bp-pale-green-400,\n  '500': $bp-pale-green-500,\n  '600': $bp-pale-green-600,\n  '700': $bp-pale-green-700,\n  '800': $bp-pale-green-800,\n  '900': $bp-pale-green-900,\n);\n\n// Accent colours\n\n$bp-orange-50: #fff7e0;\n$bp-orange-100: #ffeab1;\n$bp-orange-200: #ffdc7e;\n$bp-orange-300: #ffd04a;\n$bp-orange-400: #ffc41f;\n$bp-orange-500: #ffba00;\n$bp-orange-600: #ffac00;\n$bp-orange-700: #ff9900;\n$bp-orange-800: #ff8700;\n$bp-orange-900: #ff6600;\n$bp-orange: $bp-orange-900;\n\n$bp-oranges: (\n  '50': $bp-orange-50,\n  '100': $bp-orange-100,\n  '200': $bp-orange-200,\n  '300': $bp-orange-300,\n  '400': $bp-orange-400,\n  '500': $bp-orange-500,\n  '600': $bp-orange-600,\n  '700': $bp-orange-700,\n  '800': $bp-orange-800,\n  '900': $bp-orange-900,\n);\n\n$bp-CO2-blue-50: #e1f5fd;\n$bp-CO2-blue-100: #b3e6fa;\n$bp-CO2-blue-200: #82d5f6;\n$bp-CO2-blue-300: #51c4f2;\n$bp-CO2-blue-400: #2db7f1;\n$bp-CO2-blue-500: #05abef;\n$bp-CO2-blue-600: #009de0;\n$bp-CO2-blue-700: #008acc;\n$bp-CO2-blue-800: #0079b9;\n$bp-CO2-blue-900: #005997;\n$bp-CO2-blue: $bp-CO2-blue-600;\n\n$bp-CO2-blues: (\n  '50': $bp-CO2-blue-50,\n  '100': $bp-CO2-blue-100,\n  '200': $bp-CO2-blue-200,\n  '300': $bp-CO2-blue-300,\n  '400': $bp-CO2-blue-400,\n  '500': $bp-CO2-blue-500,\n  '600': $bp-CO2-blue-600,\n  '700': $bp-CO2-blue-700,\n  '800': $bp-CO2-blue-800,\n  '900': $bp-CO2-blue-900,\n);\n\n$bp-purple-50: #f3e4f5;\n$bp-purple-100: #e0bae6;\n$bp-purple-200: #cd8dd6;\n$bp-purple-300: #b85fc5;\n$bp-purple-400: #a939b9;\n$bp-purple-500: #9907ad;\n$bp-purple-600: #8b06a8;\n$bp-purple-700: #7802a0;\n$bp-purple-800: #660099;\n$bp-purple-900: #44008d;\n$bp-purple: $bp-purple-800;\n\n$bp-purples: (\n  '50': $bp-purple-50,\n  '100': $bp-purple-100,\n  '200': $bp-purple-200,\n  '300': $bp-purple-300,\n  '400': $bp-purple-400,\n  '500': $bp-purple-500,\n  '600': $bp-purple-600,\n  '700': $bp-purple-700,\n  '800': $bp-purple-800,\n  '900': $bp-purple-900,\n);\n\n// Success\n$validation-success-text-light: #0c6636;\n$validation-success-fill-light: #15ad5c;\n$validation-success-border-light: #2ee68c;\n$validation-success-bg-light: #e6fff2;\n\n// Info\n$validation-info-text-light: #165d87;\n$validation-info-fill-light: #218dcc;\n$validation-info-border-light: #4fc3f7;\n$validation-info-bg-light: #ecfafe;\n\n// Warning\n$validation-warning-text-light: #a67d00;\n$validation-warning-fill-light: #ffc000;\n$validation-warning-border-light: #ffee5c;\n$validation-warning-bg-light: #fffff0;\n\n// Danger\n$validation-danger-text-light: #9e3232;\n$validation-danger-fill-light: #e64949;\n$validation-danger-border-light: #ff7591;\n$validation-danger-bg-light: #ffedf0;\n\n// Success (dark mode)\n$validation-success-text-dark: #47ed9c;\n$validation-success-fill-dark: #2ee68c;\n$validation-success-border-dark: #24a365;\n$validation-success-bg-dark: #6bf0af;\n\n// Info (dark mode)\n$validation-info-text-dark: #70d3ff;\n$validation-info-fill-dark: #4fc3f7;\n$validation-info-border-dark: #3789ad;\n$validation-info-bg-dark: #8cdbff;\n\n// Warning (dark mode)\n$validation-warning-text-dark: #fff17a;\n$validation-warning-fill-dark: #ffee5c;\n$validation-warning-border-dark: #c4b63f;\n$validation-warning-bg-dark: #fff394;\n\n// Danger (dark mode)\n$validation-danger-text-dark: #ff94aa;\n$validation-danger-fill-dark: #ff7591;\n$validation-danger-border-dark: #c34b63;\n$validation-danger-bg-dark: #ffa9bb;\n\n// status colors for backgrounds, borders, text\n$success: $validation-success-fill-dark;\n$success-bg-subtle: $validation-success-bg-light;\n$success-border-subtle: $success;\n\n$info: $validation-info-fill-dark;\n$info-bg-subtle: $validation-info-bg-light;\n$info-border-subtle: $info;\n\n$warning: $validation-warning-fill-dark;\n$warning-bg-subtle: $validation-warning-bg-light;\n$warning-border-subtle: $warning;\n\n$danger: $validation-danger-fill-dark;\n$danger-bg-subtle: $validation-danger-bg-light;\n$danger-border-subtle: $danger;\n\n$neutral-dark: rgba($dark-gray-700, 0.08);\n$neutral: $light-gray-500;\n$neutral-bg: $light-gray-100;\n\n$dark: $dark-gray-700;\n$light: $light-gray-200;\n\n$component-active-bg: $dark-gray-500;\n\n// Characters which are escaped by the escape-svg function\n// prettier-ignore\n$escaped-characters: (\n  (\"%\", \"%25\"), // fix for css minimizer plugin warning in css-webpack-config.js\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n);\n\n// Options\n//\n\n$enable-rfs: false;\n$enable-negative-margins: true;\n\n// if setting $enable-dark-mode back to default value, true, then need to add:\n// @import '~bootstrap/scss/variables-dark';  after  @import '~bootstrap/scss/variables';  in bp-bootstrap.scss\n$enable-dark-mode: false;\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem;\n\n$spacer-0: 0;\n$spacer-1: toRem(2px);\n$spacer-2: toRem(4px);\n$spacer-3: toRem(8px);\n$spacer-4: toRem(16px);\n$spacer-5: toRem(24px);\n$spacer-6: toRem(32px);\n$spacer-7: toRem(40px);\n$spacer-8: toRem(48px);\n$spacer-9: toRem(56px);\n$spacer-10: toRem(64px);\n$spacer-11: toRem(80px);\n$spacer-12: toRem(96px);\n$spacer-13: toRem(104px);\n$spacer-14: toRem(128px);\n\n$spacers: ();\n\n$spacers: map-merge(\n  (\n    0: $spacer-0,\n    1: $spacer-1,\n    2: $spacer-2,\n    3: $spacer-3,\n    4: $spacer-4,\n    5: $spacer-5,\n    6: $spacer-6,\n    7: $spacer-7,\n    8: $spacer-8,\n    9: $spacer-9,\n    10: $spacer-10,\n    11: $spacer-11,\n    12: $spacer-12,\n    13: $spacer-13,\n    14: $spacer-14,\n  ),\n  $spacers\n);\n\n// 5px based horizontal spacing\n\n$spacerXprefix: 'x5';\n\n$spacersX: ();\n\n$spacer-x-0: 0;\n$spacer-x-1: toRem(5px);\n$spacer-x-2: toRem(10px);\n$spacer-x-3: toRem(15px);\n$spacer-x-4: toRem(25px);\n$spacer-x-5: toRem(30px);\n$spacer-x-6: toRem(40px);\n$spacer-x-7: toRem(45px);\n$spacer-x-8: toRem(60px);\n\n$spacersX: map-merge(\n  (\n    0: $spacer-x-0,\n    1: $spacer-x-1,\n    2: $spacer-x-2,\n    3: $spacer-x-3,\n    4: $spacer-x-4,\n    5: $spacer-x-5,\n    6: $spacer-x-6,\n    7: $spacer-x-7,\n    8: $spacer-x-8,\n  ),\n  $spacersX\n);\n\n// Grid columns\n//\n$grid-gutter-width: 1.875rem; // 30px\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-color: $dark-gray-700;\n\n$body-secondary-color: $dark-gray-100;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color: #002bbc;\n$link-hover-color: #002bbc;\n$link-shade-percentage: 50%;\n$link-decoration: none;\n$link-hover-decoration: underline;\n\n// default link in dark mode\n$link-color-dark: #8ddbff;\n$link-hover-color-dark: #8ddbff;\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$border-color: $light-gray-300;\n\n$border-radius-xs: toRem(2px);\n$border-radius-sm: toRem(3px);\n$border-radius: toRem(5px);\n$border-radius-lg: toRem(8px);\n$border-radius-xl: toRem(12px);\n$border-radius-xxl: toRem(16px);\n$border-radius-3xl: toRem(20px);\n$border-radius-4xl: toRem(24px);\n\n$shadow-color: $dark-gray-600;\n$shadow-color-dark: $dark-gray-700;\n\n$box-shadow-xs: 0 toRem(10px) toRem(20px) rgba($shadow-color, 0.08);\n$box-shadow-sm: 0 toRem(9px) toRem(14px) rgba($shadow-color, 0.14);\n$box-shadow: 0 toRem(12px) toRem(16px) rgba($shadow-color, 0.2);\n$box-shadow-lg: 0 toRem(20px) toRem(30px) rgba($shadow-color, 0.2);\n$box-shadow-xl: 0 toRem(30px) toRem(40px) rgba($shadow-color, 0.26);\n\n$box-shadow-dark-xs: 0 toRem(10px) toRem(20px) rgba($shadow-color-dark, 0.5);\n$box-shadow-dark-sm: 0 toRem(9px) toRem(14px) rgba($shadow-color-dark, 0.5);\n$box-shadow-dark: 0 toRem(12px) toRem(16px) rgba($shadow-color-dark, 0.5);\n$box-shadow-dark-lg: 0 toRem(20px) toRem(30px) rgba($shadow-color-dark, 0.6);\n$box-shadow-dark-xl: 0 toRem(30px) toRem(40px) rgba($shadow-color-dark, 0.7);\n\n// Neumorphic Shadows\n\n$box-shadow-nm-up: 12px 12px 24px rgba(#000, 0.12), -12px -12px 24px $white;\n$box-shadow-nm-down: inset 8px 8px 12px rgba(#000, 0.12), inset -8px -8px 12px rgba($white, 0.54);\n\n$box-shadow-nm-dark-up: 12px 12px 24px 0 rgba(#000, 0.6), -12px -12px 24px 0 rgba($white, 0.06);\n$box-shadow-nm-dark-down: inset 8px 8px 12px 0 rgba(#000, 0.32),\n  inset -8px -8px 12px 0 rgba($white, 0.04);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n$font-family-sans-serif: Arial, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,\n  'Helvetica Neue', 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',\n  'Segoe UI Symbol', 'Noto Color Emoji';\n$font-family-base: 'Roboto', #{$font-family-sans-serif};\n\n$font-size-base: 1rem; // Assumes the browser default, typically `16px`\n$font-size-lg: $font-size-base * 1.25;\n$font-size-sm: $font-size-base * 0.875;\n$font-size-xl: $font-size-base * 1.5;\n$font-size-xs: $font-size-base * 0.75;\n\n$font-weight-light: 300;\n\n$line-height-1: 1;\n$lne-height-1-125: 1.125;\n$line-height-1-25: 1.25;\n$line-height-sm: 1.25;\n$line-height-1-37: 1.37;\n$line-height-1-5: 1.5;\n$line-height-1-625: 1.625;\n$line-height-base: 1.75;\n$line-height-1-75: 1.75;\n$line-height-1-875: 1.875;\n$line-height-lg: 2;\n$line-height-2: 2;\n\n// Letter spacing\n$letter-spacing-0: 0;\n$letter-spacing-0-3: 0.3px;\n$letter-spacing-1: 1px;\n$letter-spacing-1-2: 1.2px;\n$letter-spacing-1-5: 1.5px;\n$letter-spacing-2: 2px;\n\n// Typescale - 1.125 - Major Second\n$h1-font-size: toRem(32px);\n$h2-font-size: toRem(29px);\n$h3-font-size: toRem(26px);\n$h4-font-size: toRem(23px);\n$h5-font-size: toRem(20px);\n$h6-font-size: toRem(14px);\n\n$headings-margin-bottom: $spacer * 2;\n$headings-line-height: 1.5;\n\n// Typescale - 1.333 - Perfect Fourth - Display\n$display-1-font-size: toRem(90px);\n$display-2-font-size: toRem(67px);\n$display-3-font-size: toRem(51px);\n$display-4-font-size: toRem(38px);\n$display-5-font-size: toRem(28px);\n$display-6-font-size: toRem(21.328px);\n\n$display-font-sizes: (\n  1: $display-1-font-size,\n  2: $display-2-font-size,\n  3: $display-3-font-size,\n  4: $display-4-font-size,\n  5: $display-5-font-size,\n  6: $display-6-font-size,\n);\n\n$lead-font-size: toRem(18px);\n\n$small-font-size: 0.8125em;\n\n$headings-font-weight: $font-weight-light;\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding-y: toRem(12px);\n$table-cell-padding-x: toRem(15px);\n\n$table-cell-padding-y-sm: toRem(8px);\n$table-cell-padding-x-sm: toRem(12px);\n\n$table-cell-padding-y-lg: toRem(14px);\n$table-cell-padding-x-lg: toRem(15px);\n\n$table-bg: $white;\n$table-color: rgba($dark-gray-700, 0.64);\n\n$table-hover-color: rgba($dark-gray-700, 0.64);\n$table-hover-bg: rgba($dark-gray-700, 0.02);\n\n$table-striped-bg: $light-gray-100;\n\n$table-border-color: $light-gray-300;\n\n$table-th-font-weight: normal;\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y-xl: toRem(10px);\n$input-btn-padding-x-xl: toRem(30px);\n$input-btn-font-size-xl: toRem(16px);\n$btn-line-height-xl: toRem(34px);\n\n$input-btn-padding-y-lg: toRem(8px);\n$input-btn-padding-x-lg: toRem(25px);\n$input-btn-font-size-lg: toRem(15px);\n$btn-line-height-lg: toRem(28px);\n\n$input-btn-padding-y: toRem(5px);\n$input-btn-padding-x: toRem(20px);\n$input-btn-font-size: toRem(14px);\n$input-btn-line-height: divide(28, 14);\n\n$input-btn-padding-y-sm: toRem(5px);\n$input-btn-padding-x-sm: toRem(18px);\n$input-btn-font-size-sm: toRem(13px);\n$btn-line-height-sm: toRem(24px);\n\n$input-btn-padding-y-xs: toRem(2px);\n$input-btn-padding-x-xs: toRem(15px);\n$input-btn-font-size-xs: toRem(12px);\n$btn-line-height-xs: toRem(23px);\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y-xs: $input-btn-padding-y-xs;\n$btn-padding-x-xs: $input-btn-padding-x-xs;\n$btn-font-size-xs: $input-btn-font-size-xs;\n\n$btn-padding-y-xl: $input-btn-padding-y-xl;\n$btn-padding-x-xl: $input-btn-padding-x-xl;\n$btn-font-size-xl: $input-btn-font-size-xl;\n\n$btn-border-radius: $border-radius;\n$btn-border-radius-xs: $btn-border-radius;\n$btn-border-radius-sm: $btn-border-radius;\n$btn-border-radius-lg: $btn-border-radius;\n$btn-border-radius-xl: $btn-border-radius;\n\n// Forms\n\n$focus-blue: $electric-blue;\n\n$form-text-margin-top: toRem(8px);\n$form-text-font-size: toRem(11px);\n\n$form-label-margin-bottom: toRem(12px);\n$form-label-font-size: toRem(14px);\n\n$input-padding-y: toRem(8px);\n$input-padding-x: toRem(15px);\n\n$input-padding-y-sm: toRem(6px);\n$input-padding-x-sm: $input-padding-x;\n\n$input-padding-y-lg: toRem(11px);\n$input-padding-x-lg: $input-padding-x;\n\n// 24 / 14 = 1.7142857143\n// using result instead of math.div() or Bootstrap divide() to get around errors\n$input-line-height: 1.7142857143;\n$input-letter-spacing: 0.1px;\n\n$input-bg: transparent; // for light and dark mode\n\n$input-border-color: $light-gray-400;\n$input-hover-border-color: $dark-gray-100;\n\n$input-focus-border-color: $focus-blue;\n$input-focus-box-shadow: none;\n\n$input-disabled-bg: $light-gray-100;\n$input-disabled-placeholder-color: #c2c2c2;\n\n$input-dark-disabled-bg: $dark-gray-600;\n\n$input-border-radius: 0;\n$input-border-radius-lg: 0;\n$input-border-radius-sm: 0;\n\n$input-color: $dark-gray-700;\n$input-placeholder-color: rgba($input-color, 0.64);\n\n// used for form validation icon bg position, same as default, but offset 5px to right\n$input-height-inner-quarter: add(\n  $input-line-height * 0.25em,\n  divide($input-padding-y, 2rem) - toRem(5px)\n);\n\n// set height manually instead of default calc from line-height, padding-y and border\n$input-height: toRem(40px);\n$input-height-sm: toRem(36px);\n$input-height-lg: toRem(46px);\n\n// currently only used for btn-square\n$input-height-xl: toRem(54px);\n$input-height-xs: toRem(29px);\n// todo: add square sizes for icon circles?\n\n$input-group-addon-color: rgba($dark-gray-700, 0.64);\n$input-group-addon-bg: $light-gray-200;\n\n// Custom Forms\n\n// General for both Check and Radio\n\n$form-check-input-width: toRem(18px);\n$form-check-padding-start: $form-check-input-width + toRem(12px);\n$form-check-margin-bottom: 1rem;\n$form-check-label-cursor: pointer;\n$form-check-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\n  box-shadow 0.15s ease-in-out;\n\n$form-check-input-bg: $white;\n$form-check-label-color: rgba($dark-gray-700, 0.84);\n\n$form-check-input-border: 1px solid $light-gray-600;\n$form-check-input-border-color-hover: $dark-gray-800;\n\n$form-check-input-focus-border: $electric-blue;\n$form-check-input-disabled-bg-color: $light-gray-300;\n$form-check-input-checked-color: $dark-gray-500;\n$form-check-input-checked-bg-color: $white; // use $component-active-bg instead?\n$form-check-input-checked-border-color: $light-gray-600;\n\n$form-check-input-disabled-opacity: 1;\n$form-check-label-disabled-opacity: 0.5;\n\n$form-check-input-focus-box-shadow: none;\n\n$form-check-inline-margin-end: toRem(31px);\n\n// Custom warning\n\n@function warning-icon($color) {\n  @return url('data:image/svg+xml,<svg width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" d=\"M0 0h32v32H0z\"></path><path fill=\"#{$color}\" d=\"m24.928 24.116-8.4-15.6c-.21-.389-.847-.389-1.057 0l-8.4 15.6A.6.6 0 0 0 7.6 25h16.8a.6.6 0 0 0 .528-.884Zm-7.9-10.516-.428 6h-1.2l-.428-6h2.056ZM16 23.2a1.067 1.067 0 1 1 0-2.134 1.067 1.067 0 0 1 0 2.134Z\"></path></svg>');\n}\n\n// Custom Check\n\n@function check-icon($color) {\n  @return url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"><polyline stroke=\"#{$color}\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" transform=\"translate(5.834623, 8.000000)\" points=\"0.689327222 5.19141548 3.94037135 8.4424596 12.0679817 0.314849286\"></polyline></svg>');\n}\n\n@function indeterminate-icon($color) {\n  @return url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\"><line stroke=\"#{$color}\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(6.000000, 11.500000)\" x1=\"12\" y1=\"0.5\" x2=\"4.99600361e-16\" y2=\"0.5\"></line></svg>');\n}\n\n$form-check-input-border-radius: 0;\n$form-check-input-checked-bg-image: check-icon($form-check-input-checked-color);\n\n$form-check-input-indeterminate-bg-color: $white; // use $component-active-bg instead?\n$form-check-input-indeterminate-color: $form-check-input-checked-color;\n$form-check-input-indeterminate-bg-image: indeterminate-icon($form-check-input-indeterminate-color);\n$form-check-input-indeterminate-border-color: $form-check-input-checked-border-color;\n\n// Custom Check Alternate Style (checked color and checked BG flipped)\n\n$form-check-input-alt-checked-color: $white;\n$form-check-input-alt-checked-border: 1px solid $dark-gray-500;\n$form-check-input-alt-checked-bg: $dark-gray-500; // use $component-active-bg instead?\n$form-check-input-alt-checked-bg-image: check-icon($form-check-input-alt-checked-color);\n\n$form-check-input-alt-indeterminate-bg: $dark-gray-500; // use $component-active-bg instead?\n$form-check-input-alt-indeterminate-color: $form-check-input-alt-checked-color;\n$form-check-input-alt-icon-indeterminate: indeterminate-icon(\n  $form-check-input-alt-indeterminate-color\n);\n\n// Custom Radio\n\n@function radio-icon($color) {\n  @return url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24px\" height=\"24px\" viewBox=\"-12 -12 24 24\"><circle r=\"6\" fill=\"#{$color}\"/></svg>');\n}\n\n$form-check-radio-checked-color: $dark-gray-500;\n$form-check-radio-checked-bg-image: radio-icon($form-check-radio-checked-color);\n\n// Custom Switch\n\n@function switch-icon($color) {\n  @return url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$color}'/></svg>\");\n}\n\n$form-switch-color: $white;\n$form-switch-width: $form-check-input-width * 2;\n$form-switch-padding-start: $form-switch-width + 1rem;\n$form-switch-bg-color: $light-gray-400;\n$form-switch-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-9 -9 18 18'><circle r='7' fill='#{$form-switch-color}' style='filter: drop-shadow(0px 2px 1px rgb(17 17 17 / 0.18))' /></svg>\");\n$form-switch-hover-bg: $light-gray-800;\n$form-switch-checked-bg: $dark-gray-500;\n$form-switch-disabled-bg: $form-switch-bg-color;\n// $form-switch-indicator-disabled-bg: $light-gray-200;\n$form-switch-transition: background-position 0.15s ease-in-out, background-color 0.15s ease-in-out,\n  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\n$form-switch-focus-color: $form-switch-color;\n$form-switch-focus-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-9 -9 18 18'><circle r='7' fill='#{$form-switch-focus-color}' stroke='#{$focus-blue}' stroke-width='0.6' style='filter: drop-shadow(0px 2px 1px rgb(17 17 17 / 0.18))' /></svg>\");\n$form-switch-focus-border-color: $focus-blue;\n$form-switch-checked-color: $white;\n$form-switch-checked-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-9 -9 18 18'><circle r='7' fill='#{$form-switch-checked-color}'/></svg>\");\n\n// Custom Switch Alternate Style\n\n$form-switch-alt-bg-color: $white;\n$form-switch-alt-border-color: $light-gray-600;\n\n$form-switch-alt-hover-border-color: $dark-gray-800;\n$form-switch-alt-bg-image: switch-icon($dark-gray-50);\n$form-switch-alt-focus-bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-9 -9 18 18'><circle r='7' fill='#{$dark-gray-50}' stroke='#{$focus-blue}' stroke-width='0.6' style='filter: drop-shadow(0px 2px 1px rgb(17 17 17 / 0.18))' /></svg>\");\n$form-switch-alt-checked-bg-image: switch-icon($white);\n$form-switch-alt-hover-bg-image: switch-icon($dark-gray-200);\n$form-switch-alt-disabled-bg-image: switch-icon($light-gray-300);\n\n// Large Custom Forms\n\n$form-check-input-width-lg: toRem(24px);\n$form-check-padding-start-lg: $form-check-input-width-lg + toRem(15px);\n$form-check-font-size-lg: toRem(16px);\n$form-check-inline-margin-end-lg: toRem(30px);\n\n$form-switch-width-lg: $form-check-input-width-lg * 2;\n$form-switch-padding-start-lg: $form-switch-width-lg + 1rem;\n\n// Form Select\n\n$form-select-padding-x: $input-padding-x;\n// Extra padding to account for the presence of the background-image based indicator:\n$form-select-indicator-padding: toRem(44px);\n$form-select-bg-position: right toRem(10px) center;\n$form-select-bg-size: 24px 24px;\n$form-select-indicator-color: $dark-gray-700;\n\n$form-select-lg-indicator-padding: toRem(52px);\n$form-select-lg-bg-size: 32px 32px;\n\n// Down24\n@function chevron-down-icon($color, $opacity) {\n  @return url('data:image/svg+xml,<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke-linecap=\"square\" stroke=\"#{$color}\" vector-effect=\"non-scaling-stroke\" opacity=\"#{$opacity}\" d=\"m7 10 5.5 5.5L18 10\"></path></svg>');\n}\n\n$form-select-indicator: chevron-down-icon($form-select-indicator-color, 0.54);\n\n@function triangle-icon($color) {\n  @return url('data:image/svg+xml,<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"square\" fill=\"#{$color}\" opacity=\"0.54\" d=\"M6.6 9.4h10.8L12 16.6z\"></path></svg>');\n}\n\n$form-select-triangle-indicator: triangle-icon($form-select-indicator-color);\n\n@function up-down-icon($color) {\n  @return url('data:image/svg+xml,<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"none\" stroke-linecap=\"square\" stroke=\"#{$color}\" vector-effect=\"non-scaling-stroke\" opacity=\"0.54\" d=\"M15.25 15.1 12 18.35 8.75 15.1m0-5.2L12 6.65l3.25 3.25\"></path></svg>');\n}\n\n$form-select-up-down-indicator: up-down-icon($form-select-indicator-color);\n\n// offset default custom select feedback icon position 15px to the right, like $input-height-inner-quarter\n$form-select-feedback-icon-position: center right\n  ($form-select-padding-x + $form-select-indicator-padding) - toRem(15px);\n$form-select-feedback-icon-size: 32px 32px;\n\n$form-select-focus-box-shadow: $input-focus-box-shadow;\n\n$form-select-dark-indicator-color: $white;\n$form-select-dark-indicator: chevron-down-icon($form-select-dark-indicator-color, 0.54);\n$form-select-dark-triangle: triangle-icon($form-select-dark-indicator-color);\n$form-select-dark-up-down: up-down-icon($form-select-dark-indicator-color);\n\n// Form validation\n\n$form-feedback-valid-color: $validation-success-text-light;\n$form-feedback-invalid-color: $validation-danger-text-light;\n\n$form-feedback-icon-valid-color: $validation-success-fill-light;\n$form-feedback-icon-valid: check-icon($form-feedback-icon-valid-color);\n\n$form-feedback-icon-invalid-color: $validation-danger-fill-light;\n$form-feedback-icon-invalid: warning-icon($form-feedback-icon-invalid-color);\n$form-feedback-icon-invalid-check: check-icon($form-feedback-icon-invalid-color);\n\n$form-valid-border-color: $validation-success-fill-light;\n$form-invalid-border-color: $validation-danger-fill-light;\n\n// Navs\n$nav-link-padding-y: toRem(8px);\n$nav-link-padding-x: toRem(20px);\n$nav-link-font-size: toRem(14px);\n$nav-link-color: rgba($dark-gray-700, 0.64);\n$nav-link-hover-color: $dark-gray-700;\n$nav-link-disabled-color: rgba($dark-gray-700, 0.5);\n$nav-link-focus-box-shadow: none;\n\n$nav-tabs-border-color: $light-gray-500;\n$nav-tabs-border-radius: 0;\n$nav-tabs-link-active-color: rgba($dark-gray-700, 0.84);\n$nav-tabs-link-hover-border-color: $dark-gray-700 $dark-gray-700 transparent;\n$nav-tabs-link-active-border-color: $light-gray-500 $light-gray-500 transparent;\n\n$nav-pills-border-radius: 0;\n$nav-pills-link-active-color: rgba($white, 0.92);\n$nav-pills-link-active-bg: $dark-gray-100;\n\n// Navbar\n\n$navbar-padding-y: toRem(5px);\n$navbar-padding-x: 0;\n$navbar-container-padding-x: toRem(20px);\n\n$navbar-nav-link-padding-x: toRem(10px);\n\n$navbar-brand-font-size: toRem(16px);\n$navbar-brand-padding-y: 0;\n$navbar-brand-margin-end: toRem(25px);\n\n$navbar-light-color: $nav-link-color;\n$navbar-light-hover-color: $dark-gray-700;\n$navbar-light-active-color: rgba($dark-gray-700, 0.92);\n$navbar-light-brand-color: $dark-gray-700;\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// $dropdown-min-width: toRem(255px);\n$dropdown-font-size: toRem(14px);\n$dropdown-border-radius: 0;\n$dropdown-border-width: 0;\n$dropdown-divider-bg: $light-gray-300;\n$dropdown-box-shadow: $box-shadow-lg;\n\n$dropdown-color: rgba($dark-gray-700, 0.64);\n$dropdown-link-color: $dropdown-color;\n$dropdown-link-hover-color: $dark-gray-700;\n$dropdown-link-hover-bg: $light-gray-100;\n\n$dropdown-link-active-color: $dark-gray-700;\n$dropdown-link-active-bg: $light-gray-200;\n\n$dropdown-link-disabled-color: rgba($dark-gray-700, 0.4);\n\n$dropdown-item-padding-y: toRem(8px);\n$dropdown-item-padding-x: toRem(15px);\n\n$dropdown-header-color: $dark-gray-700;\n$dropdown-header-padding-y: toRem(12px);\n\n// dropdown small\n$dropdown-font-size-sm: toRem(13px);\n$dropdown-item-padding-y-sm: toRem(6px);\n\n// dropdown large\n$dropdown-font-size-lg: toRem(15px);\n$dropdown-item-padding-y-lg: toRem(7px);\n\n$dropdown-dark-color: rgba($white, 0.64);\n$dropdown-dark-bg: $dark-gray-600;\n$dropdown-dark-divider-bg: $dark-gray-400;\n$dropdown-dark-box-shadow: $box-shadow-dark-lg;\n$dropdown-dark-link-hover-bg: $dark-gray-500;\n$dropdown-dark-link-active-color: $white;\n$dropdown-dark-link-active-bg: $dark-gray-400;\n\n// Pagination\n$pagination-font-size: toRem(13px);\n\n$pagination-padding-x: 0.9rem;\n$pagination-padding-x-sm: 0.9rem;\n\n$pagination-bg: transparent;\n$pagination-color: rgba($dark-gray-700, 0.64);\n$pagination-border-width: 0;\n\n$pagination-active-bg: $dark-gray-700;\n\n$pagination-hover-color: $dark-gray-700;\n$pagination-hover-bg: rgba($dark-gray-700, 0.06);\n\n$pagination-focus-color: rgba($dark-gray-700, 0.64);\n$pagination-focus-bg: transparent;\n$pagination-focus-box-shadow: none;\n$pagination-focus-visible-box-shadow: 0 0 4px 0 $electric-blue;\n\n$pagination-disabled-color: rgba($dark-gray-700, 0.5);\n$pagination-disabled-bg: transparent;\n\n$pagination-transition: none; // prevent flicker when changing the page\n\n// Cards\n\n$card-spacer-y: toRem(20px);\n$card-spacer-x: toRem(25px);\n$card-border-width: 0;\n$card-border-color: $light-gray-400;\n$card-border-radius: 0;\n$card-img-overlay-padding: toRem(25px);\n\n// Accordion\n\n$accordion-color: $dark-gray-700;\n$accordion-bg: $white;\n$accordion-border-color: $light-gray-400;\n$accordion-border-radius: 0;\n$accordion-inner-border-radius: toRem(12px);\n\n$accordion-button-padding-y: toRem(11px);\n$accordion-button-padding-x: toRem(19px);\n$accordion-button-color: $accordion-color;\n$accordion-button-bg: $white;\n$accordion-transition: border-radius 0.15s ease;\n$accordion-button-active-bg: $white;\n$accordion-button-active-color: $accordion-color;\n\n$accordion-button-focus-border-color: $electric-blue;\n$accordion-button-focus-box-shadow: none;\n\n$accordion-icon-width: toRem(24px);\n$accordion-icon-transform: rotate(180deg);\n\n$accordion-button-icon: chevron-down-icon($accordion-color, 1);\n$accordion-button-active-icon: $accordion-button-icon;\n\n// light icon for dark bg\n$accordion-dark-button-icon: chevron-down-icon($white, 1);\n\n// Tooltips\n\n$tooltip-font-size: $font-size-xs;\n$tooltip-font-size-lg: toRem(13px);\n$tooltip-bg: $dark-gray-500;\n$tooltip-color: $white;\n\n$tooltip-border-radius: $border-radius-sm;\n$tooltip-border-radius-lg: $border-radius;\n$tooltip-opacity: 1;\n$tooltip-padding-y: toRem(6px);\n$tooltip-padding-x: toRem(16px);\n$tooltip-padding-y-lg: toRem(9px);\n$tooltip-padding-x-lg: toRem(16px);\n$tooltip-spacer: toRem(8px); // $tooltip-margin variable doesn't work for every direction\n$tooltip-link-spacer: toRem(2px);\n\n$tooltip-arrow-width: toRem(14px);\n$tooltip-arrow-height: toRem(7px);\n\n// Tooltips Light\n\n$tooltip-color-light: $dark-gray-700;\n$tooltip-bg-light: $white;\n\n// Popovers\n\n$popover-font-size: toRem(13px);\n$popover-max-width: 240px;\n$popover-border-width: 0px;\n$popover-border-radius: $border-radius;\n$popover-header-bg: transparent;\n$popover-header-color: $dark-gray-700; // for light popover-header in dark mode\n$popover-dark-bg: $dark-gray-600;\n\n$popover-arrow-width: toRem(19px);\n$popover-arrow-height: toRem(10px);\n\n$popover-margin: $popover-arrow-height;\n\n// Toasts\n\n$toast-max-width: 255px;\n$toast-font-size: toRem(13px);\n$toast-color: rgba($white, 0.64);\n$toast-background-color: $dark-gray-600;\n$toast-border-width: 0;\n$toast-border-color: transparent;\n$toast-border-radius: 0;\n$toast-box-shadow: $box-shadow;\n$toast-spacing: toRem(12px);\n\n$toast-header-color: $white;\n$toast-header-background-color: transparent;\n$toast-header-border-color: $dark-gray-400;\n\n// Toasts Light\n\n$toast-light-color: rgba($dark-gray-700, 0.64);\n$toast-light-header-color: $dark-gray-700;\n$toast-light-background-color: $white;\n$toast-light-header-border-color: $light-gray-400;\n\n// Badges\n\n$badge-font-size: 62.5%;\n$badge-font-weight: normal;\n$badge-color: $dark-gray-700;\n$badge-padding-y: 0.3em;\n$badge-padding-x: 0.9em;\n\n$badge-pill-padding-x: 1.2em;\n\n// Modals\n\n$modal-content-border-color: transparent;\n$modal-content-border-width: 0;\n$modal-content-border-radius: toRem(5px);\n$modal-content-box-shadow: $box-shadow;\n$modal-content-box-shadow-xs: $box-shadow;\n$modal-content-box-shadow-md-up: $box-shadow-xl;\n\n$modal-header-border-width: 0;\n$modal-header-border-color: transparent;\n\n$modal-footer-border-color: $light-gray-300;\n$modal-footer-border-width: 1px;\n\n$modal-xl: 1110px;\n$modal-lg: 980px;\n$modal-md: 540px;\n$modal-sm: 285px;\n$modal-xs: 180px;\n\n$modal-xs-header-padding: toRem(5px);\n$modal-xs-inner-padding: toRem(16px) toRem(10px);\n\n$modal-sm-header-padding: toRem(8px);\n$modal-sm-inner-padding: toRem(24px) toRem(15px);\n\n// Alerts\n\n$alert-padding-y: toRem(8px);\n$alert-padding-x: toRem(20px);\n$alert-border-radius: toRem(3px);\n$alert-link-font-weight: 300;\n\n// Progress bars\n\n$progress-height: toRem(5px);\n$progress-font-size: toRem(11px);\n$progress-bg: $light-gray-300;\n$progress-bar-bg: $dark-gray-50;\n$progress-border-radius: 0;\n\n// -----------------------------------------------------------------\n\n// Brand Button Variants\n\n$btn-focus-shadow: 0 0 4px 0 $focus-blue;\n$btn-disabled-opacity: 0.5;\n\n// Buttons light mode\n\n// -----------------------------------------------------------------\n\n// Brand\n\n$btn-light-brand-primary-bg: $bp-green-800;\n$btn-light-brand-primary-border: $bp-green-800;\n$btn-light-brand-primary-color: rgba($white, 0.92);\n$btn-light-brand-primary-hover-bg: #004f00;\n$btn-light-brand-primary-hover-border: #004f00;\n$btn-light-brand-primary-hover-color: $white;\n$btn-light-brand-primary-active-bg: #006600;\n$btn-light-brand-primary-active-border: #006600;\n$btn-light-brand-primary-active-color: rgba($white, 0.92);\n$btn-light-brand-primary-disabled-bg: #b2d8b2;\n$btn-light-brand-primary-disabled-border: #b2d8b2;\n$btn-light-brand-primary-disabled-color: rgba($white, 0.84);\n$btn-light-brand-primary-focus-bg: #007f00;\n$btn-light-brand-primary-focus-border: #007f00;\n$btn-light-brand-primary-focus-shadow: 0 3px 4px 0 rgba(17, 17, 17, 0.22);\n\n$btn-light-brand-secondary-bg: transparent;\n$btn-light-brand-secondary-border: rgba(0, 127, 0, 0.4);\n$btn-light-brand-secondary-color: rgba(17, 17, 17, 0.84);\n$btn-light-brand-secondary-hover-bg: transparent;\n$btn-light-brand-secondary-hover-border: #004f00;\n$btn-light-brand-secondary-hover-color: $dark-gray-700;\n$btn-light-brand-secondary-active-bg: transparent;\n$btn-light-brand-secondary-active-border: #006600;\n$btn-light-brand-secondary-active-color: $dark-gray-700;\n$btn-light-brand-secondary-disabled-bg: transparent;\n$btn-light-brand-secondary-disabled-border: #b2d8b2;\n$btn-light-brand-secondary-disabled-color: rgba(17, 17, 17, 0.5);\n$btn-light-brand-secondary-focus-bg: transparent;\n$btn-light-brand-secondary-focus-border: transparent;\n$btn-light-brand-secondary-focus-shadow: $btn-focus-shadow;\n\n$btn-light-brand-tertiary-bg: transparent;\n$btn-light-brand-tertiary-border: #cccccc;\n$btn-light-brand-tertiary-color: rgba(17, 17, 17, 0.84);\n$btn-light-brand-tertiary-hover-bg: transparent;\n$btn-light-brand-tertiary-hover-border: $dark-gray-700;\n$btn-light-brand-tertiary-hover-color: $dark-gray-700;\n$btn-light-brand-tertiary-active-bg: transparent;\n$btn-light-brand-tertiary-active-border: #006600;\n$btn-light-brand-tertiary-active-color: $dark-gray-700;\n$btn-light-brand-tertiary-disabled-bg: transparent;\n$btn-light-brand-tertiary-disabled-border: #ededed;\n$btn-light-brand-tertiary-disabled-color: rgba(17, 17, 17, 0.5);\n$btn-light-brand-tertiary-focus-bg: transparent;\n$btn-light-brand-tertiary-focus-border: transparent;\n$btn-light-brand-tertiary-focus-shadow: $btn-focus-shadow;\n\n// Darker\n\n$btn-light-darker-primary-bg: $dark-gray-500;\n$btn-light-darker-primary-border: $dark-gray-500;\n$btn-light-darker-primary-color: rgba($white, 0.92);\n$btn-light-darker-primary-hover-bg: $dark-gray-700;\n$btn-light-darker-primary-hover-border: $dark-gray-700;\n$btn-light-darker-primary-hover-color: $white;\n$btn-light-darker-primary-active-bg: $dark-gray-600;\n$btn-light-darker-primary-active-border: $dark-gray-600;\n$btn-light-darker-primary-active-color: rgba($white, 0.92);\n$btn-light-darker-primary-disabled-bg: $light-gray-700;\n$btn-light-darker-primary-disabled-border: $light-gray-700;\n$btn-light-darker-primary-disabled-color: rgba($white, 0.84);\n$btn-light-darker-primary-focus-bg: $dark-gray-500;\n$btn-light-darker-primary-focus-border: $dark-gray-500;\n$btn-light-darker-primary-focus-shadow: $btn-focus-shadow;\n\n$btn-light-darker-secondary-bg: $dark-gray-100;\n$btn-light-darker-secondary-border: $dark-gray-100;\n$btn-light-darker-secondary-color: rgba($white, 0.92);\n$btn-light-darker-secondary-hover-bg: $dark-gray-500;\n$btn-light-darker-secondary-hover-border: $dark-gray-500;\n$btn-light-darker-secondary-hover-color: $white;\n$btn-light-darker-secondary-active-bg: $dark-gray-400;\n$btn-light-darker-secondary-active-border: $dark-gray-400;\n$btn-light-darker-secondary-active-color: rgba($white, 0.92);\n$btn-light-darker-secondary-disabled-bg: $light-gray-600;\n$btn-light-darker-secondary-disabled-border: $light-gray-600;\n$btn-light-darker-secondary-disabled-color: rgba($white, 0.84);\n$btn-light-darker-secondary-focus-bg: $dark-gray-100;\n$btn-light-darker-secondary-focus-border: $dark-gray-100;\n$btn-light-darker-secondary-focus-shadow: $btn-focus-shadow;\n\n$btn-light-darker-tertiary-bg: transparent;\n$btn-light-darker-tertiary-border: $light-gray-600;\n$btn-light-darker-tertiary-color: rgba(17, 17, 17, 0.84);\n$btn-light-darker-tertiary-hover-bg: transparent;\n$btn-light-darker-tertiary-hover-border: $dark-gray-700;\n$btn-light-darker-tertiary-hover-color: $dark-gray-700;\n$btn-light-darker-tertiary-active-bg: transparent;\n$btn-light-darker-tertiary-active-border: $dark-gray-700;\n$btn-light-darker-tertiary-active-color: $dark-gray-700;\n$btn-light-darker-tertiary-disabled-bg: transparent;\n$btn-light-darker-tertiary-disabled-border: $light-gray-400;\n$btn-light-darker-tertiary-disabled-color: rgba(17, 17, 17, 0.5);\n$btn-light-darker-tertiary-focus-bg: transparent;\n$btn-light-darker-tertiary-focus-border: $focus-blue;\n$btn-light-darker-tertiary-focus-shadow: none;\n\n// Standard\n\n$btn-light-standard-primary-bg: $dark-gray-400;\n$btn-light-standard-primary-border: $dark-gray-400;\n$btn-light-standard-primary-color: rgba($white, 0.92);\n$btn-light-standard-primary-hover-bg: $dark-gray-500;\n$btn-light-standard-primary-hover-border: $dark-gray-500;\n$btn-light-standard-primary-hover-color: $white;\n$btn-light-standard-primary-active-bg: $dark-gray-600;\n$btn-light-standard-primary-active-border: $dark-gray-600;\n$btn-light-standard-primary-active-color: rgba($white, 0.92);\n$btn-light-standard-primary-disabled-bg: $light-gray-700;\n$btn-light-standard-primary-disabled-border: $light-gray-700;\n$btn-light-standard-primary-disabled-color: rgba($white, 0.84);\n$btn-light-standard-primary-focus-bg: $dark-gray-400;\n$btn-light-standard-primary-focus-border: $dark-gray-400;\n$btn-light-standard-primary-focus-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n\n$btn-light-standard-secondary-bg: $light-gray-300;\n$btn-light-standard-secondary-border: $light-gray-300;\n$btn-light-standard-secondary-color: rgba(17, 17, 17, 0.84);\n$btn-light-standard-secondary-hover-bg: $dark-gray-100;\n$btn-light-standard-secondary-hover-border: $dark-gray-100;\n$btn-light-standard-secondary-hover-color: $white;\n$btn-light-standard-secondary-active-bg: $dark-gray-50;\n$btn-light-standard-secondary-active-border: $dark-gray-50;\n$btn-light-standard-secondary-active-color: rgba($white, 0.92);\n$btn-light-standard-secondary-disabled-bg: $light-gray-200;\n$btn-light-standard-secondary-disabled-border: $light-gray-200;\n$btn-light-standard-secondary-disabled-color: rgba(17, 17, 17, 0.5);\n$btn-light-standard-secondary-focus-bg: $light-gray-300;\n$btn-light-standard-secondary-focus-border: $light-gray-300;\n$btn-light-standard-secondary-focus-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n\n$btn-light-standard-tertiary-bg: transparent;\n$btn-light-standard-tertiary-border: $light-gray-500;\n$btn-light-standard-tertiary-color: rgba(17, 17, 17, 0.84);\n$btn-light-standard-tertiary-hover-bg: transparent;\n$btn-light-standard-tertiary-hover-border: $dark-gray-700;\n$btn-light-standard-tertiary-hover-color: $dark-gray-700;\n$btn-light-standard-tertiary-active-bg: transparent;\n$btn-light-standard-tertiary-active-border: $dark-gray-400;\n$btn-light-standard-tertiary-active-color: $dark-gray-700;\n$btn-light-standard-tertiary-disabled-bg: transparent;\n$btn-light-standard-tertiary-disabled-border: $light-gray-300;\n$btn-light-standard-tertiary-disabled-color: rgba(17, 17, 17, 0.5);\n$btn-light-standard-tertiary-focus-bg: transparent;\n$btn-light-standard-tertiary-focus-border: $focus-blue;\n$btn-light-standard-tertiary-focus-shadow: none;\n\n// -----------------------------------------------------------------\n\n// Buttons dark mode\n\n// -----------------------------------------------------------------\n\n// Brand\n\n$btn-inverse-brand-primary-bg: #ccff00;\n$btn-inverse-brand-primary-border: #ccff00;\n$btn-inverse-brand-primary-color: rgba(17, 17, 17, 0.84);\n$btn-inverse-brand-primary-hover-bg: #9fe300;\n$btn-inverse-brand-primary-hover-border: #9fe300;\n$btn-inverse-brand-primary-hover-color: $dark-gray-700;\n$btn-inverse-brand-primary-active-bg: #b0f000;\n$btn-inverse-brand-primary-active-border: #b0f000;\n$btn-inverse-brand-primary-active-color: rgba(17, 17, 17, 0.92);\n$btn-inverse-brand-primary-disabled-bg: #414e0c;\n$btn-inverse-brand-primary-disabled-border: #414e0c;\n$btn-inverse-brand-primary-disabled-color: rgba($white, 0.4);\n$btn-inverse-brand-primary-focus-bg: #ccff00;\n$btn-inverse-brand-primary-focus-border: #ccff00;\n$btn-inverse-brand-primary-focus-shadow: 0 3px 4px 0 rgba(17, 17, 17, 0.22);\n\n$btn-inverse-brand-secondary-bg: transparent;\n$btn-inverse-brand-secondary-border: rgba(204, 255, 0, 0.4);\n$btn-inverse-brand-secondary-color: rgba($white, 0.84);\n$btn-inverse-brand-secondary-hover-bg: transparent;\n$btn-inverse-brand-secondary-hover-border: #9fe300;\n$btn-inverse-brand-secondary-hover-color: $white;\n$btn-inverse-brand-secondary-active-bg: transparent;\n$btn-inverse-brand-secondary-active-border: #b0f000;\n$btn-inverse-brand-secondary-active-color: rgba($white, 0.92);\n$btn-inverse-brand-secondary-disabled-bg: transparent;\n$btn-inverse-brand-secondary-disabled-border: #414e0c;\n$btn-inverse-brand-secondary-disabled-color: rgba($white, 0.4);\n$btn-inverse-brand-secondary-focus-bg: transparent;\n$btn-inverse-brand-secondary-focus-border: $focus-blue;\n$btn-inverse-brand-secondary-focus-shadow: none;\n\n$btn-inverse-brand-tertiary-bg: rgba($white, 0.02);\n$btn-inverse-brand-tertiary-border: transparent;\n$btn-inverse-brand-tertiary-color: rgba($white, 0.84);\n$btn-inverse-brand-tertiary-hover-bg: rgba($white, 0.08);\n$btn-inverse-brand-tertiary-hover-border: transparent;\n$btn-inverse-brand-tertiary-hover-color: $white;\n$btn-inverse-brand-tertiary-active-bg: rgba($white, 0.06);\n$btn-inverse-brand-tertiary-active-border: transparent;\n$btn-inverse-brand-tertiary-active-color: rgba($white, 0.92);\n$btn-inverse-brand-tertiary-disabled-bg: rgba($white, 0.02);\n$btn-inverse-brand-tertiary-disabled-border: transparent;\n$btn-inverse-brand-tertiary-disabled-color: rgba($white, 0.4);\n$btn-inverse-brand-tertiary-focus-bg: rgba($white, 0.02);\n$btn-inverse-brand-tertiary-focus-border: transparent;\n$btn-inverse-brand-tertiary-focus-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n\n// Darker\n\n$btn-inverse-darker-primary-bg: $light-gray-50;\n$btn-inverse-darker-primary-border: $light-gray-50;\n$btn-inverse-darker-primary-color: rgba(17, 17, 17, 0.84);\n$btn-inverse-darker-primary-hover-bg: $light-gray-400;\n$btn-inverse-darker-primary-hover-border: $light-gray-400;\n$btn-inverse-darker-primary-hover-color: $dark-gray-700;\n$btn-inverse-darker-primary-active-bg: $light-gray-200;\n$btn-inverse-darker-primary-active-border: $light-gray-200;\n$btn-inverse-darker-primary-active-color: rgba(17, 17, 17, 0.92);\n$btn-inverse-darker-primary-disabled-bg: $dark-gray-300;\n$btn-inverse-darker-primary-disabled-border: $dark-gray-300;\n$btn-inverse-darker-primary-disabled-color: rgba($white, 0.4);\n$btn-inverse-darker-primary-focus-bg: $light-gray-50;\n$btn-inverse-darker-primary-focus-border: $light-gray-50;\n$btn-inverse-darker-primary-focus-shadow: $btn-focus-shadow;\n\n$btn-inverse-darker-secondary-bg: transparent;\n$btn-inverse-darker-secondary-border: $dark-gray-500;\n$btn-inverse-darker-secondary-color: rgba($white, 0.84);\n$btn-inverse-darker-secondary-hover-bg: transparent;\n$btn-inverse-darker-secondary-hover-border: $white;\n$btn-inverse-darker-secondary-hover-color: $white;\n$btn-inverse-darker-secondary-active-bg: transparent;\n$btn-inverse-darker-secondary-active-border: $light-gray-900;\n$btn-inverse-darker-secondary-active-color: rgba($white, 0.92);\n$btn-inverse-darker-secondary-disabled-bg: transparent;\n$btn-inverse-darker-secondary-disabled-border: $dark-gray-500;\n$btn-inverse-darker-secondary-disabled-color: rgba($white, 0.4);\n$btn-inverse-darker-secondary-focus-bg: transparent;\n$btn-inverse-darker-secondary-focus-border: $focus-blue;\n$btn-inverse-darker-secondary-focus-shadow: none;\n\n$btn-inverse-darker-tertiary-bg: rgba($white, 0.06);\n$btn-inverse-darker-tertiary-border: transparent;\n$btn-inverse-darker-tertiary-color: rgba($white, 0.84);\n$btn-inverse-darker-tertiary-hover-bg: rgba($white, 0.14);\n$btn-inverse-darker-tertiary-hover-border: transparent;\n$btn-inverse-darker-tertiary-hover-color: $white;\n$btn-inverse-darker-tertiary-active-bg: rgba($white, 0.08);\n$btn-inverse-darker-tertiary-active-border: transparent;\n$btn-inverse-darker-tertiary-active-color: rgba($white, 0.92);\n$btn-inverse-darker-tertiary-disabled-bg: rgba($white, 0.02);\n$btn-inverse-darker-tertiary-disabled-border: transparent;\n$btn-inverse-darker-tertiary-disabled-color: rgba($white, 0.4);\n$btn-inverse-darker-tertiary-focus-bg: rgba($white, 0.06);\n$btn-inverse-darker-tertiary-focus-border: rgba($white, 0.06);\n$btn-inverse-darker-tertiary-focus-shadow: 0 0 4px 0 $focus-blue;\n\n// Standard\n\n$btn-inverse-standard-primary-bg: $light-gray-400;\n$btn-inverse-standard-primary-border: $light-gray-400;\n$btn-inverse-standard-primary-color: rgba(17, 17, 17, 0.84);\n$btn-inverse-standard-primary-hover-bg: $light-gray-700;\n$btn-inverse-standard-primary-hover-border: $light-gray-700;\n$btn-inverse-standard-primary-hover-color: $dark-gray-700;\n$btn-inverse-standard-primary-active-bg: $light-gray-600;\n$btn-inverse-standard-primary-active-border: $light-gray-600;\n$btn-inverse-standard-primary-active-color: rgba(17, 17, 17, 0.92);\n$btn-inverse-standard-primary-disabled-bg: $dark-gray-400;\n$btn-inverse-standard-primary-disabled-border: $dark-gray-400;\n$btn-inverse-standard-primary-disabled-color: rgba($white, 0.4);\n$btn-inverse-standard-primary-focus-bg: $light-gray-400;\n$btn-inverse-standard-primary-focus-border: $light-gray-400;\n$btn-inverse-standard-primary-focus-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n\n$btn-inverse-standard-secondary-bg: transparent;\n$btn-inverse-standard-secondary-border: $dark-gray-500;\n$btn-inverse-standard-secondary-color: rgba($white, 0.84);\n$btn-inverse-standard-secondary-hover-bg: transparent;\n$btn-inverse-standard-secondary-hover-border: $light-gray-600;\n$btn-inverse-standard-secondary-hover-color: $white;\n$btn-inverse-standard-secondary-active-bg: transparent;\n$btn-inverse-standard-secondary-active-border: $light-gray-900;\n$btn-inverse-standard-secondary-active-color: rgba($white, 0.92);\n$btn-inverse-standard-secondary-disabled-bg: transparent;\n$btn-inverse-standard-secondary-disabled-border: $dark-gray-600;\n$btn-inverse-standard-secondary-disabled-color: rgba($white, 0.4);\n$btn-inverse-standard-secondary-focus-bg: transparent;\n$btn-inverse-standard-secondary-focus-border: $focus-blue;\n$btn-inverse-standard-secondary-focus-shadow: none;\n\n$btn-inverse-standard-tertiary-bg: rgba($white, 0.02);\n$btn-inverse-standard-tertiary-border: transparent;\n$btn-inverse-standard-tertiary-color: rgba($white, 0.84);\n$btn-inverse-standard-tertiary-hover-bg: rgba($white, 0.08);\n$btn-inverse-standard-tertiary-hover-border: transparent;\n$btn-inverse-standard-tertiary-hover-color: $white;\n$btn-inverse-standard-tertiary-active-bg: rgba($white, 0.06);\n$btn-inverse-standard-tertiary-active-border: transparent;\n$btn-inverse-standard-tertiary-active-color: rgba($white, 0.92);\n$btn-inverse-standard-tertiary-disabled-bg: rgba($white, 0.02);\n$btn-inverse-standard-tertiary-disabled-border: transparent;\n$btn-inverse-standard-tertiary-disabled-color: rgba($white, 0.4);\n$btn-inverse-standard-tertiary-focus-bg: rgba($white, 0.02);\n$btn-inverse-standard-tertiary-focus-border: transparent;\n$btn-inverse-standard-tertiary-focus-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);\n\n// -----------------------------------------------------------------\n\n// Spinners\n\n$spinner-vertical-align: -0.2em;\n\n// Breadcrumbs\n\n// chevron right icon\n@function breadcrumb-icon($color) {\n  @return url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9\" height=\"9\"><path fill=\"none\" stroke=\"#{$color}\" stroke-linecap=\"square\" d=\"m2.8 1 3.5 3.5L2.8 8\" opacity=\".4\"/></svg>');\n}\n\n$breadcrumb-font-size: toRem(12px);\n$breadcrumb-active-color: rgba($dark-gray-700, 0.5);\n$breadcrumb-divider: breadcrumb-icon($dark-gray-700);\n\n// Close\n$btn-close-width: toRem(24px);\n$btn-close-padding-x: 0; // only affects to toast, overridden for alert and modal\n$btn-close-color: $dark-gray-700;\n$btn-close-bg: url('data:image/svg+xml,<svg width=\"100%\" height=\"100%\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke=\"#{$btn-close-color}\" stroke-linecap=\"square\" fill=\"none\" d=\"M16.2 7.8l-8.4 8.4m8.4 0L7.8 7.8\"></path></svg>');\n$btn-close-hover-opacity: 0.8;\n$btn-close-focus-opacity: 0.5;\n\n// Offcanvas\n$offcanvas-padding-y: toRem(18px);\n$offcanvas-padding-x: toRem(15px);\n$offcanvas-border-color: $light-gray-300;\n$offcanvas-border-width: 1px;\n$offcanvas-backdrop-bg: $white;\n$offcanvas-backdrop-opacity: 0.8;\n\n// Panel\n$offcanvas-horizontal-width: 320px; // default / medium panel size\n$panel-horizontal-width-xs: 80px;\n$panel-horizontal-width-sm: 256px;\n$panel-horizontal-width-lg: 400px;\n$panel-horizontal-width-xl: 528px;\n\n// Panel paddings for sizes\n$panel-padding-y-xs: 0;\n$panel-padding-x-xs: 0;\n\n$panel-padding-y-sm: toRem(16px);\n$panel-padding-x-sm: toRem(15px);\n\n$panel-padding-y-lg: toRem(20px);\n$panel-padding-x-lg: toRem(20px);\n\n$panel-padding-y-xl: toRem(25px);\n$panel-padding-x-xl: toRem(25px);\n\n// List Group\n\n// Controls the group and group items\n$list-group-color: rgba($dark-gray-700, 0.64);\n$list-group-focus-visible-color: $electric-blue;\n$list-group-border-color: $light-gray-200;\n$list-group-border-radius: 0;\n\n$list-group-item-padding-y: 0;\n$list-group-item-padding-x: toRem(15px);\n\n// disabled state colors\n$list-group-disabled-color: $dark-gray-700;\n\n// active colors\n$list-group-active-bg: $light-gray-100;\n$list-group-active-color: rgba($dark-gray-700, 0.84);\n$list-group-active-border-color: $light-gray-200;\n\n// colors the overridden when list group item is set to action\n$list-group-action-hover-color: $dark-gray-700;\n$list-group-hover-bg: $light-gray-200;\n$list-group-action-active-color: rgba($dark-gray-700, 0.84);\n$list-group-action-active-bg: $light-gray-100;\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.2 (https://getbootstrap.com/)\n   * Copyright 2011-2023 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","[data-bs-theme='dark'],\n.dark {\n  --#{$prefix}body-color: #{$white};\n  --#{$prefix}border-color: #{$dark-gray-500};\n\n  --#{$prefix}success-rgb: #{to-rgb($validation-success-bg-dark)};\n  --#{$prefix}info-rgb: #{to-rgb($validation-info-bg-dark)};\n  --#{$prefix}warning-rgb: #{to-rgb($validation-warning-bg-dark)};\n  --#{$prefix}danger-rgb: #{to-rgb($validation-danger-bg-dark)};\n\n  --#{$prefix}success-border-subtle: #{$validation-success-border-dark};\n  --#{$prefix}info-border-subtle: #{$validation-info-border-dark};\n  --#{$prefix}warning-border-subtle: #{$validation-warning-border-dark};\n  --#{$prefix}danger-border-subtle: #{$validation-danger-border-dark};\n\n  --#{$prefix}form-valid-border-color: #{$validation-success-fill-dark};\n  --#{$prefix}form-invalid-border-color: #{$validation-danger-fill-dark};\n}\n\n.dark {\n  background: #111;\n  color: $white;\n}\n",":root {\n  --#{$prefix}border-radius-xs: #{$border-radius-xs};\n  --#{$prefix}border-radius-3xl: #{$border-radius-3xl};\n  --#{$prefix}border-radius-4xl: #{$border-radius-4xl};\n}\n","// more background-color utilities defined in src/scss/_utilities.scss\n\n.dark {\n  .bg-primary {\n    background-color: $dark-gray-500 !important;\n  }\n\n  .bg-secondary {\n    background-color: $dark-gray-600 !important;\n  }\n\n  .bg-tertiary {\n    background-color: $dark-gray-700 !important;\n  }\n\n  .bg-quartenary {\n    background-color: $dark-gray-800 !important;\n  }\n\n  .bg-quinary {\n    background-color: $dark-gray-900 !important;\n  }\n\n  // background classes for dark mode only, for section backgrounds that don't flip 1:1\n\n  .dark-bg-primary {\n    background-color: $dark-gray-500 !important;\n  }\n\n  .dark-bg-secondary {\n    background-color: $dark-gray-600 !important;\n  }\n\n  .dark-bg-tertiary {\n    background-color: $dark-gray-700 !important;\n  }\n\n  .dark-bg-quartenary {\n    background-color: $dark-gray-800 !important;\n  }\n\n  .dark-bg-quinary {\n    background-color: $dark-gray-900 !important;\n  }\n}\n","$color-harmonies: (\n  'dark-gray': $dark-grays,\n  'light-gray': $light-grays,\n  'op-dark-gray': $op-dark-grays,\n  'op-light-gray': $op-light-grays,\n  'bp-green': $bp-greens,\n  'bp-light-green': $bp-light-greens,\n  'bp-yellow': $bp-yellows,\n  'bp-bright-green': $bp-bright-greens,\n  'bp-dark-green': $bp-dark-greens,\n  'bp-dark-blue': $bp-dark-blues,\n  'bp-yellow-orange': $bp-yellow-oranges,\n  'bp-pale-yellow': $bp-pale-yellows,\n  'bp-pale-green': $bp-pale-greens,\n  'bp-orange': $bp-oranges,\n  'bp-CO2-blue': $bp-CO2-blues,\n  'bp-purple': $bp-purples,\n);\n\n$types: (\n  'bg': background-color,\n  'text': color,\n  'border': border-color,\n);\n\n// loop through all key values in above, the key helps generate the main (middle) part of the class name.\n@each $theme, $colors in $color-harmonies {\n  // loop through all key values in each array $colors array. $value represents the last part of the class name (for e.g 50 or 100).\n  @each $shade, $color in $colors {\n    // @types is a map of the class name prefix and $prop is the css property to be set.\n    @each $type, $prop in $types {\n      .#{$type}-#{$theme}-#{$shade} {\n        #{$prop}: $color !important;\n      }\n    }\n  }\n}\n",":root,\n[data-bs-theme='light'] {\n  --text-default-color: #111;\n  --text-brand-primary-color: #{$bp-green};\n}\n\n[data-bs-theme='dark'],\n.dark {\n  --text-default-color: #{$white};\n  --text-brand-primary-color: #{$bp-bright-green};\n}\n\n.text-default {\n  color: var(--text-default-color) !important;\n}\n\n.text-bp-bright-green {\n  color: $bp-bright-green !important;\n}\n\n.text-brand-primary {\n  color: var(--text-brand-primary-color) !important;\n}\n","//\n// Links\n//\n\n// .link-border also has styles in _alert.scss\n\n// need \"a\" for specificity to override reboot \"a:hover\"\n\na.link-border,\n.btn-link {\n  // vertically align icons and text\n  display: inline-flex;\n  align-items: center;\n}\n\na.link-border,\n.btn-link span {\n  @include link-gradient(rgba($link-color, 0)); // transparent by default\n  background-size: 100% 3.6%;\n  background-position: right 93%;\n  background-repeat: no-repeat;\n  transition: opacity 300ms, color 300ms, background-position 300ms;\n}\n\n// hover\na.link-border:hover,\n.btn-link:hover span {\n  @include link-gradient(currentColor);\n}\n\n// focus\na.link-border:focus,\na.link-border.focus {\n  background-position-y: 100%;\n}\n\na.link-border,\n.card-link, // because bootstrap sets .card-link:hover { text-decoration: none } by default\n.btn-link,\n.btn-link:hover,\n.btn-link:focus,\n.btn-link.focus {\n  text-decoration: none;\n}\n\n// -----------------------------\n\n// dark default link\n.dark {\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n  --#{$prefix}link-color: #{$link-color-dark}; // used for .btn-link\n  --#{$prefix}link-hover-color: #{$link-hover-color-dark}; // used for .btn-link\n}\n\n.link-primary {\n  &:not(.btn) {\n    color: rgba($dark-gray-700, 0.7) !important;\n  }\n\n  &:hover {\n    color: $dark-gray-700 !important;\n  }\n}\n\n// used on blue header link in FunctionalLayouts3\n.dark {\n  .link-primary {\n    &:not(.btn) {\n      color: rgba($white, 0.7) !important;\n    }\n\n    &:hover,\n    &:focus {\n      color: $white !important;\n    }\n  }\n}\n\n// -----------------------------\n\n// animated bottom border on hover, use with .link-border class\n\na.link-border-animation {\n  @include link-gradient(currentColor); // not transparent by default\n\n  &:hover {\n    animation: 450ms cubic-bezier(0.785, 0.135, 0.15, 0.86) 0s 1 normal none running linkAnimation;\n  }\n}\n// -----------------------------\n\n// link-dark default style\n\na.link-dark {\n  color: rgba($dark-gray-700, 0.7) !important;\n}\n\na.link-light {\n  color: rgba($white, 0.7) !important;\n\n  &:hover,\n  &:focus {\n    color: $white !important;\n  }\n}\n\n@keyframes linkAnimation {\n  0% {\n    background-size: 100% 4%;\n    background-position-x: 100%;\n  }\n  50% {\n    background-size: 0px 4%;\n    background-position-x: 100%;\n  }\n  50.01% {\n    background-size: 0px 4%;\n    background-position-x: 0px;\n  }\n  100% {\n    background-size: 100% 4%;\n    background-position-x: 0px;\n  }\n}\n","@mixin square($size) {\n  width: $size;\n  height: $size;\n}\n\n// gradient-x for _links.scss .link-border\n// same value for start and end\n@mixin link-gradient($color) {\n  background-image: linear-gradient(to right, $color 0%, $color 100%);\n}\n\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == 'media-query' {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    @if $root {\n      :root,\n      [data-bs-theme='#{$mode}'],\n      .#{$mode} {\n        @content;\n      }\n    } @else {\n      [data-bs-theme='#{$mode}'],\n      .#{$mode} {\n        @content;\n      }\n    }\n  }\n}\n\n@mixin light-mode() {\n  @include color-mode(light, true) {\n    @content;\n  }\n}\n\n@mixin dark-mode() {\n  @include color-mode(dark, false) {\n    @content;\n  }\n}\n","body {\n  letter-spacing: 0.15px;\n}\n\n.bg-dark,\n.bg-dark-secondary {\n  color: $white;\n}\n\n//\n// Headings\n//\n\n// prettier-ignore\nh1, h2, h3, h4, h5,\n.h1, .h2, .h3, .h4, .h5 {\n  letter-spacing: 0.2px;\n\n  // 400\n  &.fw-normal {\n    letter-spacing: 0.15px;\n  }\n\n  // medium / 500\n  &.fw-medium {\n    letter-spacing: 0.1px;\n  }\n}\n\n// prettier-ignore\nh2, .h2 {\n  line-height: divide(44, 29);\n}\n\n// prettier-ignore\nh4, .h4 {\n  line-height: divide(35, 23);\n}\n\n// prettier-ignore\nh3, h4,\n.h3, .h4 {\n  margin-bottom: toRem(24px);\n}\n\n// prettier-ignore\nh5, h6,\n.h5, .h6 {\n  margin-bottom: toRem(16px);\n}\n\n// prettier-ignore\nh6, .h6 {\n  text-transform: uppercase;\n  letter-spacing: 1.6px;\n}\n\n.font-family-base {\n  font-family: $font-family-base;\n}\n\n// Type display classes\n\n.display-1 {\n  letter-spacing: 0.3px;\n  line-height: divide(101, 90);\n\n  &.fw-normal {\n    letter-spacing: 0.25px;\n  }\n\n  &.fw-medium {\n    letter-spacing: 0.2px;\n  }\n}\n\n.display-2 {\n  line-height: divide(84, 67);\n}\n\n.display-1,\n.display-2 {\n  margin-bottom: toRem(40px);\n}\n\n.display-2,\n.display-3 {\n  letter-spacing: 0.4px;\n\n  &.fw-normal {\n    letter-spacing: 0.35px;\n  }\n\n  &.fw-medium {\n    letter-spacing: 0.3px;\n  }\n}\n\n.display-3 {\n  line-height: divide(70, 51);\n}\n\n.display-3,\n.display-4 {\n  margin-bottom: toRem(32px);\n}\n\n.display-4 {\n  line-height: divide(55, 38);\n}\n\n.display-4,\n.display-5 {\n  letter-spacing: 0.5px;\n\n  &.fw-normal {\n    letter-spacing: 0.45px;\n  }\n\n  &.fw-medium {\n    letter-spacing: 0.4px;\n  }\n}\n\n.display-5 {\n  line-height: divide(40, 28);\n}\n\n.display-5,\n.display-6 {\n  margin-bottom: toRem(24px);\n}\n\n.fs-base {\n  font-size: 1rem !important;\n  line-height: divide(28, 16);\n}\n\n//\n// Emphasis\n//\n\np {\n  opacity: 0.8;\n}\n\n.lead {\n  letter-spacing: 0.2px;\n  line-height: divide(32, 18);\n  opacity: 1;\n}\n\n// for cards-5 and icon stacks 3\n.small-md {\n  font-size: toRem(14px);\n  line-height: divide(21, 14);\n}\n\np.small {\n  font-size: toRem(13px);\n  line-height: divide(23, 13);\n  letter-spacing: 0.25px;\n  opacity: 0.7;\n}\n\nsmall,\n.small {\n  font-weight: $font-weight-light;\n  font-size: toRem(12px);\n  line-height: divide(21, 12);\n  letter-spacing: 0.25px; // use utility class instead?\n}\n\n.small-sm {\n  font-size: toRem(11px);\n  line-height: divide(21, 11);\n  font-weight: $font-weight-normal;\n}\n\n.small-xs {\n  font-size: toRem(10px) !important;\n  line-height: divide(20, 10);\n  font-weight: $font-weight-normal;\n}\n",".list-styled {\n  &,\n  ul,\n  ol {\n    padding-left: 1.5rem;\n  }\n\n  li + li,\n  ul li:first-child,\n  ol li:first-child {\n    margin-top: 0.5rem;\n  }\n}\n",".dark {\n  .border-primary {\n    border-color: $dark-gray-500 !important;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacersX {\n        .#{$spacerXprefix}-#{$abbrev}e#{$infix}-#{$size},\n        .#{$spacerXprefix}-#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$spacerXprefix}-#{$abbrev}s#{$infix}-#{$size},\n        .#{$spacerXprefix}-#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacersX {\n      @if $size != 0 {\n        .#{$spacerXprefix}-me#{$infix}-n#{$size},\n        .#{$spacerXprefix}-mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .#{$spacerXprefix}-ms#{$infix}-n#{$size},\n        .#{$spacerXprefix}-mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n  }\n}\n","// for background image and video and overlays\n.absolute-fill {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n\n// ------------------------------------\n\n// transparent gradient or solid color above cover-bg and below content\n.overlay {\n  position: relative;\n\n  &::before {\n    @extend .absolute-fill;\n    content: '';\n    z-index: 1;\n  }\n\n  // use .z-2 if there isn't a .container inside inside the .overlay\n  .container {\n    z-index: 2;\n    position: relative;\n  }\n}\n\n//-----------------------------------\n\n// type\n\n.overlay-scrim {\n  --overlay-angle: to bottom;\n  --overlay-color: #{to-rgb($dark-gray-700)};\n  --overlay-opacity: 0.7;\n  --overlay-end-color: var(--overlay-color);\n  --overlay-end-opacity: 0;\n\n  &::before {\n    background-image: linear-gradient(\n      var(--overlay-angle),\n      rgba(var(--overlay-color), var(--overlay-opacity)) 0%,\n      rgba(var(--overlay-end-color), var(--overlay-end-opacity)) 100%\n    );\n  }\n}\n\n.overlay-solid {\n  --overlay-color: #{to-rgb($dark-gray-600)};\n  --overlay-opacity: 0.8;\n\n  &::before {\n    background-color: rgba(var(--overlay-color), var(--overlay-opacity));\n  }\n}\n\n// starting point / angle\n\n$scrim-angles: (\n  'left': 'to right',\n  'right': 'to left',\n  'top': 'to bottom',\n  'bottom': 'to top',\n  'top-left': 'to bottom right',\n  'top-right': 'to bottom left',\n  'bottom-right': 'to top left',\n  'bottom-left': 'to top right',\n);\n\n@each $className, $angle in $scrim-angles {\n  .overlay-scrim-#{$className} {\n    --overlay-angle: #{$angle};\n  }\n}\n\n// color\n\n$scrim-colors: (\n  'dark': $dark-gray-700,\n  'blue': $bp-dark-blue-800,\n  'green': $bp-green-900,\n  'light': $light-gray-200,\n);\n\n@each $className, $color in $scrim-colors {\n  .overlay-#{$className} {\n    --overlay-color: #{to-rgb($color)};\n  }\n}\n\n// opacity\n\n@for $i from 10 through 1 {\n  .overlay-opacity-#{$i * 10} {\n    --overlay-opacity: #{divide($i, 10)};\n  }\n}\n\n//  ------------------------------------\n\n// leftovers from original classes / blocks\n\n.overlay-scrim-light-blue {\n  &::before {\n    @include gradient-y(rgba(200, 201, 255, 0.8), rgba(227, 248, 255, 0.8));\n  }\n}\n\n.overlay-primary {\n  --overlay-color: #{to-rgb($white)};\n\n  .dark & {\n    --overlay-color: #{to-rgb($black)};\n  }\n}\n","// background SVG close button\n\n.toast:not(.toast-light),\n.dark .toast-light,\n.dark .card,\n.dark .alert:not([class*='alert-solid-']) {\n  .btn-close {\n    // light X for dark background\n    filter: $btn-close-white-filter;\n  }\n}\n\n// inline SVG close button\n\n.btn-close-inline {\n  background: none;\n  color: $btn-close-color;\n  padding: 0;\n  opacity: $btn-close-opacity;\n  border: 1px solid transparent;\n\n  // Override <a>'s hover style\n  &:hover {\n    color: $btn-close-color;\n    text-decoration: none;\n    opacity: $btn-close-hover-opacity;\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: none;\n  }\n\n  &:focus-visible {\n    border-color: $focus-blue;\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: $btn-close-disabled-opacity;\n  }\n}\n\n.dark {\n  .btn-close-inline {\n    color: $white;\n  }\n}\n",".alert {\n  --#{$prefix}alert-color: #{$dark-gray-700};\n  --#{$prefix}alert-link-color: #{$dark-gray-700};\n\n  font-weight: $font-weight-light;\n  display: flex;\n\n  // left icon\n  > svg {\n    color: var(--#{$prefix}alert-icon-color);\n    flex-shrink: 0;\n    margin: toRem(2px) toRem(8px) 0 toRem(-9px);\n  }\n\n  p {\n    opacity: 0.8;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  .link-border {\n    @include link-gradient(rgba($dark-gray-700, 0.3));\n\n    &:hover {\n      @include link-gradient($dark-gray-700);\n    }\n  }\n}\n\n.alert > svg.text-default,\n[class*='alert-solid-'] > svg {\n  opacity: 0.8;\n}\n\n.alert-heading {\n  font-size: toRem(18px);\n  line-height: divide(32, 18);\n  margin-bottom: toRem(8px);\n}\n\n.alert-dismissible {\n  // icon width + close pr + close pl\n  padding-right: toRem(24px) + toRem(11px) + toRem(16px);\n\n  .btn-close {\n    @include square(toRem(28px));\n    background-position: 60% center;\n    padding: $alert-padding-y toRem(11px) $alert-padding-y toRem(16px);\n    opacity: 0.8;\n\n    &:hover,\n    &:focus {\n      box-shadow: none;\n      opacity: 1;\n    }\n  }\n}\n\n// multi-line\n\n.alert-lg {\n  padding: toRem(20px) toRem(30px);\n\n  &.alert-dismissible {\n    // icon width + close pr + close pl\n    padding-right: toRem(32px) + toRem(11px) + toRem(16px);\n  }\n\n  > svg {\n    margin-top: 0;\n    margin-left: -15px;\n  }\n\n  // larger close icon\n  .btn-close {\n    @include square(toRem(32px));\n    background-size: toRem(32px);\n  }\n}\n\n// bordered variants\n\n.alert-success {\n  --#{$prefix}alert-icon-color: #{$validation-success-fill-light};\n}\n\n.alert-info {\n  --#{$prefix}alert-icon-color: #{$validation-info-fill-light};\n}\n\n.alert-warning {\n  --#{$prefix}alert-icon-color: #{$validation-warning-fill-light};\n}\n\n.alert-danger {\n  --#{$prefix}alert-icon-color: #{$validation-danger-fill-light};\n}\n\n.alert-neutral {\n  --#{$prefix}alert-bg: #{$neutral-bg};\n  --#{$prefix}alert-border-color: #{$neutral};\n}\n\n// solid variants\n\n[class*='alert-solid-'] {\n  p {\n    opacity: 1;\n  }\n}\n\n.alert-solid-success {\n  --#{$prefix}alert-bg: #{$success};\n}\n\n.alert-solid-info {\n  --#{$prefix}alert-bg: #{$info};\n}\n\n.alert-solid-warning {\n  --#{$prefix}alert-bg: #{$warning};\n}\n\n.alert-solid-danger {\n  --#{$prefix}alert-bg: #{$danger};\n}\n\n.alert-solid-neutral {\n  --#{$prefix}alert-bg: #{$neutral-dark};\n}\n\n.dark {\n  //  bordered variants\n\n  .alert {\n    --#{$prefix}alert-bg: #{$dark-gray-500};\n    --#{$prefix}alert-color: #{$white};\n    --#{$prefix}alert-link-color: #{$white};\n\n    &:not([class*='alert-solid-']) {\n      .link-border {\n        @include link-gradient(rgba($white, 0.3));\n\n        &:hover {\n          @include link-gradient($white);\n        }\n      }\n    }\n  }\n\n  .alert-success {\n    --#{$prefix}alert-icon-color: #{$success};\n  }\n\n  .alert-info {\n    --#{$prefix}alert-icon-color: #{$info};\n  }\n\n  .alert-warning {\n    --#{$prefix}alert-icon-color: #{$warning};\n  }\n\n  .alert-danger {\n    --#{$prefix}alert-icon-color: #{$danger};\n  }\n\n  .alert-neutral {\n    --#{$prefix}alert-border-color: #{$dark-gray-200};\n    --#{$prefix}alert-bg: #{$dark-gray-600}; // this might change\n  }\n\n  // solid variants\n\n  [class*='alert-solid-'] {\n    --#{$prefix}alert-color: #{$dark-gray-700};\n    --#{$prefix}alert-link-color: #{$dark-gray-700};\n  }\n\n  .alert-solid-success {\n    --#{$prefix}alert-bg: #6bf0af;\n  }\n\n  .alert-solid-info {\n    --#{$prefix}alert-bg: #8cdbff;\n  }\n\n  .alert-solid-warning {\n    --#{$prefix}alert-bg: #fff394;\n  }\n\n  .alert-solid-danger {\n    --#{$prefix}alert-bg: #ffa9bb;\n  }\n\n  .alert-solid-neutral {\n    --#{$prefix}alert-color: #{$white};\n    --#{$prefix}alert-bg: #{$dark-gray-300};\n    --#{$prefix}alert-link-color: #{$white};\n\n    .btn-close {\n      filter: $btn-close-white-filter;\n    }\n\n    .link-border {\n      @include link-gradient(rgba($white, 0.3));\n\n      &:hover {\n        @include link-gradient($white);\n      }\n    }\n  }\n}\n",".avatar-inner {\n  width: 40px;\n  height: 40px;\n  background-color: #e8e8e8;\n  font-size: toRem(13px);\n  letter-spacing: 0.9px;\n  color: rgba($dark-gray-700, 0.84);\n  box-shadow: 0 0 0 1px transparent, 0 0 0 3px transparent;\n  transition: box-shadow 0.15s ease-in-out, color 0.15s ease-in-out,\n    background-color 0.15s ease-in-out;\n\n  svg {\n    color: $dark-gray-700;\n  }\n}\n\n// Text Label\n\n.avatar-label {\n  position: relative;\n  font-size: toRem(15px);\n  line-height: divide(20, 15);\n  color: var(--avatar-label-color);\n  transition: color 0.15s ease-in-out;\n\n  &::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    height: toRem(1px);\n    width: 100%;\n    background-color: transparent;\n    transition: background-color 0.15s ease-in-out;\n  }\n}\n\n.avatar-label-prefix {\n  margin-right: toRem(15px);\n}\n\n.avatar-label-suffix {\n  margin-left: toRem(15px);\n}\n\n// Dropdown toggle down arrow svg\n\n.avatar-arrow {\n  color: #111;\n  opacity: 0.54;\n  margin-left: toRem(7px);\n}\n\n// Outer most element\n\n.avatar {\n  --avatar-inner-shadow-color: #{$white};\n  --avatar-hover-shadow-color: #{$light-gray-400};\n  --avatar-active-shadow-color: #{$dark-gray-700};\n\n  --avatar-label-color: #{rgba($dark-gray-700, 0.64)};\n  --avatar-hover-label-color: #{$dark-gray-700};\n  --avatar-hover-label-border: #{$dark-gray-700};\n  --avatar-active-label-color: #{rgba($dark-gray-700, 0.92)};\n  --avatar-active-label-border: #{$light-gray-700};\n  --avatar-focus-label-color: #{rgba($dark-gray-700, 0.64)};\n\n  // vertically align avatar-outer and label\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n  text-decoration: none !important;\n\n  // button reset\n  border: none;\n  background-color: transparent;\n  padding: 0;\n  user-select: none;\n  transition: border-color 0.15s ease-in-out;\n\n  &.dropdown-toggle {\n    + .dropdown-menu {\n      margin-top: 3px;\n    }\n  }\n}\n\n.avatar-action {\n  &:hover {\n    .avatar-inner {\n      box-shadow: 0 0 0 1px var(--avatar-inner-shadow-color),\n        0 0 0 3px var(--avatar-hover-shadow-color);\n    }\n\n    .avatar-label {\n      color: var(--avatar-hover-label-color);\n\n      &::after {\n        background-color: var(--avatar-hover-label-border);\n      }\n    }\n\n    .avatar-arrow {\n      opacity: 0.9;\n    }\n  }\n\n  &:active,\n  .active,\n  .dropdown.show > & {\n    .avatar-inner {\n      box-shadow: 0 0 0 1px var(--avatar-inner-shadow-color),\n        0 0 0 3px var(--avatar-active-shadow-color);\n    }\n\n    .avatar-label {\n      color: var(--avatar-active-label-color);\n\n      &::after {\n        background-color: var(--avatar-active-label-border);\n      }\n    }\n\n    .avatar-arrow {\n      opacity: 0.8;\n    }\n  }\n\n  &:focus-visible {\n    outline: 0;\n\n    .avatar-inner {\n      box-shadow: 0 0 0 1px var(--avatar-inner-shadow-color), 0 0 0 2px $focus-blue;\n    }\n\n    .avatar-label {\n      color: var(--avatar-focus-label-color);\n\n      &::after {\n        background-color: $electric-blue;\n      }\n    }\n\n    .avatar-arrow {\n      opacity: 0.56;\n    }\n  }\n}\n\n// navbar avatar pill\n\n.avatar-pill {\n  --avatar-pill-background-color: #{$white};\n  --avatar-pill-hover-background-color: #{$dark-gray-700};\n  --avatar-pill-hover-label-color: #{$white};\n  --avatar-pill-active-background-color: #{$light-gray-200};\n  --avatar-pill-active-border-color: #{$dark-gray-700};\n  --avatar-pill-active-label-color: #{rgba($dark-gray-700, 0.84)};\n  --avatar-pill-active-arrow-color: #{$dark-gray-700};\n  --avatar-pill-hover-arrow-color: #{$white};\n  --avatar-pill-hover-inner-background-color: #{$dark-gray-500};\n  --avatar-pill-hover-border-color: #{$dark-gray-400};\n  --avatar-pill-hover-inner-color: #{rgba($white, 0.92)};\n  --avatar-pill-active-inner-border-color: #{$white};\n  --avatar-pill-active-inner-background-color: #e8e8e8;\n  --avatar-pill-active-inner-color: #{rgba($dark-gray-700, 0.84)};\n  --avatar-pill-hover-notification-border-color: #{$dark-gray-700};\n  --avatar-pill-hover-notification-background-color: #{$light-gray-300};\n  --avatar-pill-hover-notification-color: #{$dark-gray-700};\n\n  background-color: var(--avatar-pill-background-color);\n  border-radius: $border-radius;\n  border: 1px solid transparent;\n  padding: toRem(7px);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n\n  .avatar-inner {\n    width: 32px;\n    height: 32px;\n    font-size: toRem(12px);\n  }\n\n  .avatar-label-prefix {\n    margin-left: toRem(7px);\n  }\n\n  .avatar-label-suffix {\n    margin-right: toRem(7px);\n  }\n\n  .avatar-arrow {\n    margin-right: toRem(8px);\n  }\n\n  &.avatar-sm {\n    .avatar-inner {\n      width: 24px;\n      height: 24px;\n      font-size: toRem(11px);\n    }\n\n    .avatar-label-prefix {\n      margin: 0 toRem(12px) 0 toRem(5px);\n    }\n\n    .avatar-label-suffix {\n      margin: 0 toRem(5px) 0 toRem(12px);\n    }\n\n    .avatar-arrow {\n      margin-right: toRem(3px);\n    }\n\n    .avatar-notification {\n      width: auto;\n      height: 18px;\n      padding: 0 toRem(3.83px);\n      margin-top: toRem(-8px);\n      margin-right: toRem(-6px);\n    }\n  }\n\n  &.avatar-xs {\n    padding: toRem(3px);\n\n    .avatar-label-prefix {\n      margin: 0 toRem(10px) 0 toRem(7px);\n    }\n\n    .avatar-label-suffix {\n      margin: 0 toRem(7px) 0 toRem(10px);\n    }\n\n    .avatar-arrow {\n      margin-right: toRem(3px);\n    }\n\n    .avatar-notification {\n      width: 12px;\n      height: 12px;\n      padding: 0;\n      margin-top: toRem(-2px);\n      margin-right: toRem(-2px);\n    }\n  }\n\n  // remove space between label and arrow\n  .dropdown > & {\n    .avatar-label-suffix {\n      margin-right: 0;\n    }\n  }\n\n  // remove label underline\n  .avatar-label {\n    &::after {\n      content: none;\n    }\n  }\n\n  &:hover {\n    background-color: var(--avatar-pill-hover-background-color);\n\n    .avatar-inner {\n      background-color: var(--avatar-pill-hover-inner-background-color);\n      color: var(--avatar-pill-hover-inner-color);\n    }\n\n    .avatar-label {\n      color: var(--avatar-pill-hover-label-color);\n    }\n\n    &:not(:active) {\n      .avatar-inner {\n        box-shadow: 0 0 0 1px var(--avatar-pill-hover-background-color),\n          0 0 0 3px var(--avatar-pill-hover-border-color);\n      }\n      .avatar-notification {\n        border-color: var(--avatar-pill-hover-notification-border-color);\n        background-color: var(--avatar-pill-hover-notification-background-color);\n        color: var(--avatar-pill-hover-notification-color);\n      }\n    }\n\n    .avatar-arrow {\n      color: var(--avatar-pill-hover-arrow-color);\n    }\n  }\n\n  &:active,\n  .active,\n  .dropdown.show > & {\n    background-color: var(--avatar-pill-active-background-color);\n\n    .avatar-inner {\n      background-color: var(--avatar-pill-active-inner-background-color);\n      color: var(--avatar-pill-active-inner-color);\n    }\n\n    .avatar-label {\n      color: var(--avatar-pill-active-label-color);\n    }\n\n    .avatar-arrow {\n      color: var(--avatar-pill-active-arrow-color);\n    }\n  }\n\n  &:focus-visible {\n    border-color: $electric-blue;\n  }\n}\n\n// Sizes\n\n.avatar-lg {\n  .avatar-inner {\n    width: 48px;\n    height: 48px;\n    font-size: toRem(14px);\n    letter-spacing: 0.8px;\n  }\n\n  .avatar-online {\n    margin-right: -2px;\n    margin-bottom: -2px;\n  }\n}\n\n.avatar-sm {\n  .avatar-inner {\n    width: 32px;\n    height: 32px;\n    font-size: toRem(12px);\n    line-height: divide(19, 12);\n  }\n\n  .avatar-online {\n    margin-right: -2px;\n    margin-bottom: -2px;\n  }\n\n  .avatar-label {\n    font-size: toRem(14px);\n    line-height: divide(20, 14);\n  }\n\n  .avatar-label-prefix {\n    margin-right: toRem(9px);\n  }\n\n  .avatar-label-suffix {\n    margin-left: toRem(9px);\n  }\n\n  .avatar-notification {\n    margin-top: toRem(-9px);\n    margin-right: toRem(-9px);\n  }\n}\n\n.avatar-xs {\n  .avatar-inner {\n    width: 24px;\n    height: 24px;\n    font-size: toRem(11px);\n    letter-spacing: 1px;\n  }\n\n  .avatar-online {\n    width: 12px;\n    height: 12px;\n    margin-right: -2px;\n    margin-bottom: -2px;\n  }\n\n  .avatar-label {\n    font-size: toRem(13px);\n    line-height: divide(19, 13);\n  }\n\n  .avatar-label-prefix {\n    margin-right: toRem(7px);\n  }\n\n  .avatar-label-suffix {\n    margin-left: toRem(7px);\n  }\n\n  .avatar-notification {\n    width: auto;\n    height: 18px;\n    padding: 0 toRem(3.83px);\n    margin-top: toRem(-5px);\n    margin-right: toRem(-5px);\n  }\n}\n\n// Color Variants - on same element as inner\n\n.avatar-light-color {\n  background-color: $bp-dark-blue-50;\n\n  &,\n  svg {\n    color: $bp-dark-blue-900;\n  }\n}\n\n.avatar-solid {\n  background-color: $dark-gray-700;\n  color: rgba($white, 0.84);\n\n  svg {\n    color: $white;\n  }\n}\n\n.avatar-solid-color {\n  background-color: $bp-dark-blue-900;\n  color: rgba($white, 0.84);\n\n  svg {\n    color: $white;\n  }\n}\n\n// Notification\n\n.avatar-notification {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 22px;\n  height: 22px;\n  padding: 0 toRem(6.02px); // if notification >= 10, width is auto\n  background-color: $dark-gray-700;\n  color: $white;\n  border-radius: var(--bs-border-radius-pill);\n  font-size: toRem(9px);\n  line-height: divide(10, 9);\n  margin-top: toRem(-7px);\n  margin-right: toRem(-7px);\n  transition: border-color 0.15s ease-in-out, color 0.15s ease-in-out,\n    background-color 0.15s ease-in-out;\n\n  // icon knockout border, same as navbar background color\n  &.position-absolute {\n    border: 2px solid $white;\n  }\n}\n\n// Online\n\n.avatar-online {\n  width: 14px;\n  height: 14px;\n  background-color: $validation-success-fill-light;\n  border-radius: var(--bs-border-radius-pill);\n  background-image: none !important;\n  margin-right: -1px;\n  margin-bottom: -1px;\n\n  // icon knockout border, same as navbar background color\n  &.position-absolute {\n    border: 2px solid $white;\n  }\n}\n\n//  Dark mode\n\n.dark {\n  .avatar-inner {\n    background-color: $dark-gray-500;\n    color: rgba($white, 0.92);\n\n    svg {\n      color: rgba($white, 0.9);\n    }\n  }\n\n  // dropdown toggle down arrow svg\n\n  .avatar-arrow {\n    color: $white;\n  }\n\n  .avatar {\n    --avatar-inner-shadow-color: #{$dark-gray-700};\n    --avatar-hover-shadow-color: #{$dark-gray-400};\n    --avatar-active-shadow-color: #dedede;\n\n    --avatar-label-color: #{rgba($white, 0.64)};\n    --avatar-hover-label-color: #{$white};\n    --avatar-hover-label-border: #{$light-gray-500};\n    --avatar-active-label-color: #{rgba($white, 0.92)};\n    --avatar-active-label-border: #{$light-gray-900};\n    --avatar-focus-label-color: #{rgba($white, 0.64)};\n  }\n\n  .avatar-pill {\n    --avatar-pill-background-color: #{$dark-gray-700};\n    --avatar-pill-hover-background-color: #{$white};\n    --avatar-pill-hover-label-color: #{$dark-gray-700};\n    --avatar-pill-active-background-color: #{$dark-gray-600};\n    --avatar-pill-active-arrow-color: #{$white};\n    --avatar-pill-active-label-color: #{$white};\n    --avatar-pill-active-border-color: #{$light-gray-400};\n    --avatar-pill-hover-arrow-color: #{$dark-gray-700};\n    --avatar-pill-hover-inner-background-color: #e8e8e8;\n    --avatar-pill-hover-border-color: #{$light-gray-400};\n    --avatar-pill-hover-inner-color: #{rgba($dark-gray-700, 0.84)};\n    --avatar-pill-active-inner-border-color: #{$dark-gray-700};\n    --avatar-pill-active-inner-background-color: #{$dark-gray-500};\n    --avatar-pill-active-inner-color: #{rgba($white, 0.92)};\n    --avatar-pill-hover-notification-border-color: #{$white};\n    --avatar-pill-hover-notification-background-color: #{$dark-gray-700};\n    --avatar-pill-hover-notification-color: #{$white};\n  }\n\n  //  Color Variants - on same element as inner\n\n  .avatar-light-color {\n    background-color: $bp-dark-blue-900;\n  }\n\n  .avatar-solid {\n    background-color: $light-gray-200;\n    color: rgba($dark-gray-700, 0.92);\n\n    svg {\n      color: $dark-gray-700;\n    }\n  }\n\n  .avatar-solid-color {\n    background-color: #ad93db;\n\n    &,\n    svg {\n      color: $bp-dark-blue-900;\n    }\n  }\n\n  // Notification\n\n  .avatar-notification {\n    background-color: $white;\n    border-color: $dark-gray-700;\n    color: $dark-gray-700;\n  }\n}\n",".badge {\n  text-decoration: none;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  line-height: 1.9;\n  vertical-align: middle;\n  border: 1px solid transparent;\n\n  &.rounded-pill {\n    padding: $badge-padding-y $badge-pill-padding-x;\n  }\n\n  > svg:first-child {\n    margin: 0 0.4em 0 -0.4em;\n  }\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  .badge {\n    font-weight: $font-weight-light;\n    font-size: 75%;\n    letter-spacing: 0.5px;\n    line-height: 1.25;\n    padding: 0.25em 0.4em;\n    text-transform: none;\n  }\n}\n\n.nav-link {\n  .badge {\n    font-weight: $font-weight-normal;\n    padding: 0.33333em 0.7em;\n  }\n}\n\n.badge {\n  &.bg-light {\n    background-color: $light-gray-300 !important;\n  }\n\n  &.bg-neutral {\n    background-color: var(--badge-neutral-bg) !important;\n    color: var(--badge-neutral-color);\n  }\n\n  &.bg-neutral-subtle {\n    background-color: var(--badge-neutral-subtle-bg) !important;\n    border-color: var(--badge-neutral-subtle-border-color);\n  }\n\n  &.bg-danger-subtle {\n    background-color: var(--badge-danger-subtle-bg) !important;\n    border-color: var(--badge-danger-subtle-border-color);\n  }\n\n  &.bg-success-subtle {\n    background-color: var(--badge-success-subtle-bg) !important;\n    border-color: var(--badge-success-subtle-border-color);\n  }\n\n  &.bg-warning-subtle {\n    background-color: var(--badge-warning-subtle-bg) !important;\n    border-color: var(--badge-warning-subtle-border-color);\n  }\n\n  &.bg-info-subtle {\n    background-color: var(--badge-info-subtle-bg) !important;\n    border-color: var(--badge-info-subtle-border-color);\n  }\n\n  &[class*='-subtle'] {\n    color: var(--badge-subtle-color);\n  }\n}\n\n@include light-mode() {\n  --badge-neutral-bg: #{$dark-gray-700};\n  --badge-neutral-color: #{$white};\n  --badge-neutral-subtle-bg: #{$light-gray-300};\n  --badge-neutral-subtle-border-color: transparent;\n  --badge-danger-subtle-bg: var(--#{$prefix}danger-bg-subtle);\n  --badge-danger-subtle-border-color: transparent;\n  --badge-success-subtle-bg: var(--#{$prefix}success-bg-subtle);\n  --badge-success-subtle-border-color: transparent;\n  --badge-warning-subtle-bg: var(--#{$prefix}warning-bg-subtle);\n  --badge-warning-subtle-border-color: transparent;\n  --badge-info-subtle-bg: var(--#{$prefix}info-bg-subtle);\n  --badge-info-subtle-border-color: transparent;\n  --badge-subtle-color: #{$badge-color};\n}\n\n@include dark-mode() {\n  --badge-neutral-bg: #{$light-gray-50};\n  --badge-neutral-color: #{$dark-gray-700};\n  --badge-neutral-subtle-bg: #{$dark-gray-500};\n  --badge-neutral-subtle-border-color: #{$light-gray-800};\n  --badge-danger-subtle-bg: #{$dark-gray-500};\n  --badge-danger-subtle-border-color: #c34b63;\n  --badge-success-subtle-bg: #{$dark-gray-500};\n  --badge-success-subtle-border-color: #24a365;\n  --badge-warning-subtle-bg: #{$dark-gray-500};\n  --badge-warning-subtle-border-color: #c4b63f;\n  --badge-info-subtle-bg: #{$dark-gray-500};\n  --badge-info-subtle-border-color: #3789ad;\n  --badge-subtle-color: #{$white};\n}\n","// replacement for .react-select__multi-value\n\n.chip {\n  // removed css-in-js styles and placed here\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid transparent;\n  margin: toRem(2px);\n  border-radius: 50em;\n  color: $dark-gray-700;\n  overflow: hidden;\n}\n\n.chip-label {\n  font-size: toRem(10px);\n  padding: toRem(3px) 0 toRem(3px) toRem(12px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-transform: uppercase;\n  line-height: 1.9;\n  letter-spacing: 1px;\n}\n\n.chip-icon-prefix {\n  color: var(--chip-icon-color);\n  margin: 0 toRem(2px) 0 toRem(6px);\n\n  + .chip-label {\n    padding-left: 0;\n  }\n}\n\n// chip x\n.chip-remove {\n  display: flex;\n  padding: toRem(3px);\n  color: unset !important;\n}\n\n// Variants and status colors\n// .chip{ | -bordered | -solid }-{ success | info | warning | danger | neutral }\n\n// default / light / subtle\n\n.chip-success,\n.chip-bordered-success {\n  --chip-icon-color: #{$validation-success-fill-light};\n  background: $success-bg-subtle;\n}\n\n.chip-info,\n.chip-bordered-info {\n  --chip-icon-color: #{$validation-info-fill-light};\n  background: $info-bg-subtle;\n}\n\n.chip-warning,\n.chip-bordered-warning {\n  --chip-icon-color: #{$validation-warning-fill-light};\n  background: $warning-bg-subtle;\n}\n\n.chip-danger,\n.chip-bordered-danger {\n  --chip-icon-color: #{$validation-danger-fill-light};\n  background: $danger-bg-subtle;\n}\n\n.chip-neutral {\n  background: $light-gray-300;\n}\n\n// bordered\n\n.chip-bordered-success {\n  border-color: $success;\n}\n\n.chip-bordered-info {\n  border-color: $info;\n}\n\n.chip-bordered-warning {\n  border-color: $warning;\n}\n\n.chip-bordered-danger {\n  border-color: $danger;\n}\n\n.chip-bordered-neutral {\n  border-color: $light-gray-400;\n}\n\n// solid\n\n.chip-solid-success {\n  background: $success;\n}\n\n.chip-solid-info {\n  background: $info;\n}\n\n.chip-solid-warning {\n  background: $warning;\n}\n\n.chip-solid-danger {\n  background: $danger;\n}\n\n.chip-solid-neutral {\n  background: $dark-gray-700;\n  color: $white;\n}\n\n.dark {\n  // default and bordered\n\n  .chip-success,\n  .chip-bordered-success,\n  .chip-info,\n  .chip-bordered-info,\n  .chip-warning,\n  .chip-bordered-warning,\n  .chip-danger,\n  .chip-bordered-danger,\n  .chip-neutral,\n  .chip-bordered-neutral {\n    background-color: $dark-gray-500;\n    color: $white;\n  }\n\n  .chip-success,\n  .chip-bordered-success {\n    --chip-icon-color: #{$success};\n    border-color: #24a365;\n  }\n\n  .chip-info,\n  .chip-bordered-info {\n    --chip-icon-color: #{$info};\n    border-color: #3789ad;\n  }\n\n  .chip-warning,\n  .chip-bordered-warning {\n    --chip-icon-color: #{$warning};\n    border-color: #c4b63f;\n  }\n\n  .chip-danger,\n  .chip-bordered-danger {\n    --chip-icon-color: #{$danger};\n    border-color: #c34b63;\n  }\n\n  .chip-neutral,\n  .chip-bordered-neutral {\n    border-color: $light-gray-800;\n  }\n\n  // solid\n\n  .chip-solid-success {\n    background: #6bf0af;\n  }\n\n  .chip-solid-info {\n    background: #8cdbff;\n  }\n\n  .chip-solid-warning {\n    background: #fff394;\n  }\n\n  .chip-solid-danger {\n    background: #ffa9bb;\n  }\n\n  .chip-solid-neutral {\n    background: $light-gray-50;\n    color: $dark-gray-700;\n  }\n}\n",".notification-badge {\n  display: inline-flex;\n  align-items: center;\n  font-size: toRem(12px);\n  line-height: divide(19, 12);\n  padding: toRem(5px) toRem(8px) toRem(5px) toRem(12px);\n  letter-spacing: 0.2px;\n  border-radius: 50rem;\n  color: $dark-gray-700;\n  background-color: $light-gray-300;\n}\n\n.notification-badge-counter {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  min-width: toRem(18px);\n  height: 18px;\n  line-height: 0;\n  font-size: toRem(9px);\n  padding: 0 toRem(6px);\n  margin-left: toRem(5px);\n  border-radius: var(--bs-border-radius-pill);\n  color: $dark-gray-700;\n}\n\n.notification-badge-counter-neutral {\n  background-color: $dark-gray-700;\n  color: $white;\n}\n\n.notification-badge-dark {\n  background-color: $dark-gray-700;\n  color: $white;\n\n  .notification-badge-counter-neutral {\n    background-color: $light-gray-300;\n    color: $dark-gray-700;\n  }\n}\n\n.dark {\n  .notification-badge {\n    background-color: $dark-gray-500;\n    color: $white;\n\n    .notification-badge-counter-neutral {\n      background-color: $light-gray-300;\n      color: $dark-gray-700;\n    }\n  }\n\n  .notification-badge-dark {\n    background-color: $light-gray-50;\n    color: $dark-gray-700;\n\n    .notification-badge-counter-neutral {\n      background-color: $dark-gray-700;\n      color: $white;\n    }\n  }\n}\n",".breadcrumb {\n  align-items: center;\n\n  a {\n    // vertically align icon + text (used in Tray With Breadcrumb story)\n    display: flex;\n    align-items: center;\n    color: $dark-gray-700;\n    opacity: 0.64;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n\n  // margin between icons + text (used in Tray With Breadcrumb story)\n  svg:first-child:not(:only-child) {\n    margin-right: toRem(6px);\n  }\n}\n\n// vertically align divider\n.breadcrumb-item {\n  display: flex;\n  align-items: center;\n}\n\n.breadcrumb-slash {\n  --#{$prefix}breadcrumb-divider: '/';\n  --#{$prefix}breadcrumb-divider-color: #{rgba($dark-gray-700, 0.4)};\n\n  .breadcrumb-item + .breadcrumb-item::before {\n    font-size: toRem(16px);\n    line-height: 1;\n  }\n}\n\n.dark {\n  .breadcrumb {\n    --#{$prefix}breadcrumb-item-active-color: #{rgba($white, 0.4)};\n\n    &:not(.breadcrumb-slash) {\n      --#{$prefix}breadcrumb-divider: #{escape-svg(breadcrumb-icon($white))};\n    }\n\n    a,\n    a:hover {\n      color: $white;\n    }\n  }\n\n  .breadcrumb-slash {\n    --#{$prefix}breadcrumb-divider-color: #{rgba($white, 0.4)};\n  }\n}\n",".btn {\n  &:has(svg) {\n    align-items: center;\n    display: inline-flex;\n  }\n\n  &.text-uppercase {\n    letter-spacing: 0.7px;\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: all;\n    cursor: not-allowed;\n  }\n}\n\n.btn-xs {\n  @include button-size(\n    $btn-padding-y-xs,\n    $btn-padding-x-xs,\n    $btn-font-size-xs,\n    $btn-border-radius-xs\n  );\n\n  letter-spacing: 0.2px;\n  line-height: $btn-line-height-xs;\n}\n\n.btn-sm,\n.input-group-sm > .btn {\n  line-height: $btn-line-height-sm;\n}\n\n.btn-lg,\n.input-group-lg > .btn {\n  // rem so button height is whole number, it wasn't exact with divide(20, 15)\n  line-height: $btn-line-height-lg;\n}\n\n.btn-xl {\n  @include button-size(\n    $btn-padding-y-xl,\n    $btn-padding-x-xl,\n    $btn-font-size-xl,\n    $btn-border-radius-xl\n  );\n\n  line-height: $btn-line-height-xl;\n  letter-spacing: 0.05px;\n}\n\n// ------------------------------------------------------------------------\n\n// button icon opacity\n.btn {\n  svg {\n    opacity: 0.5;\n    transition: color 0.15s ease-in-out, opacity 0.15s ease-in-out;\n    color: var(--#{$prefix}btn-icon-color);\n  }\n\n  &:hover {\n    svg {\n      opacity: 0.9;\n    }\n  }\n\n  &:active,\n  &.active {\n    svg {\n      opacity: 0.6;\n    }\n  }\n}\n\n// button icon prefix and suffix spacing\n\n@mixin btn-icon-spacing($inside-margin, $outside-margin, $padding-x) {\n  .btn-icon-prefix {\n    margin-right: toRem($inside-margin);\n    margin-left: -$padding-x + toRem($outside-margin);\n  }\n\n  .btn-icon-suffix {\n    margin-left: toRem($inside-margin);\n    margin-right: -$padding-x + toRem($outside-margin);\n  }\n}\n\n// default / md\n@include btn-icon-spacing(6px, 10px, $btn-padding-x);\n\n.btn-xl {\n  @include btn-icon-spacing(8px, 12px, $btn-padding-x-xl);\n}\n\n.btn-lg {\n  @include btn-icon-spacing(8px, 12px, $btn-padding-x-lg);\n}\n\n.btn-sm {\n  @include btn-icon-spacing(8px, 10px, $btn-padding-x-sm);\n}\n\n.btn-xs {\n  @include btn-icon-spacing(6px, 8px, $btn-padding-x-xs);\n}\n\n// reset negative margin on icons in non-button button links that don't have padding\n.btn-link:not(.btn) {\n  .btn-icon-prefix {\n    margin-left: 0;\n  }\n\n  .btn-icon-suffix {\n    margin-right: 0;\n  }\n}\n\n// ------------------------------------------------------------------------\n\n// square buttons for icons\n// use .btn-square.rounded-circle class for circle buttons\n// use .absolute-center on svg inside of .btn-square and .square (non-button icon circles)\n\n.btn-square {\n  padding: 0 !important;\n  position: relative;\n\n  @include square($input-height);\n\n  &.btn-xl {\n    @include square($input-height-xl);\n  }\n\n  &.btn-lg,\n  .input-group-lg > & {\n    @include square($input-height-lg);\n  }\n\n  &.btn-sm,\n  .input-group-sm > & {\n    @include square($input-height-sm);\n  }\n\n  &.btn-xs {\n    @include square($input-height-xs);\n  }\n}\n\n// override default bootstrap btn variant color: color-contrast($background)\n.btn-success,\n.btn-info,\n.btn-warning,\n.btn-danger {\n  color: $dark-gray-700;\n\n  &:hover {\n    color: #000;\n  }\n}\n","// Brand Button Variants\n\n// Brand\n\n.btn-brand-primary {\n  @include button-brand-variant(\n    $btn-light-brand-primary-bg,\n    $btn-light-brand-primary-border,\n    $btn-light-brand-primary-color,\n    $btn-light-brand-primary-hover-bg,\n    $btn-light-brand-primary-hover-border,\n    $btn-light-brand-primary-hover-color,\n    $btn-light-brand-primary-active-bg,\n    $btn-light-brand-primary-active-border,\n    $btn-light-brand-primary-active-color,\n    $btn-light-brand-primary-disabled-bg,\n    $btn-light-brand-primary-disabled-border,\n    $btn-light-brand-primary-disabled-color,\n    $btn-light-brand-primary-focus-bg,\n    $btn-light-brand-primary-focus-border,\n    $btn-light-brand-primary-focus-shadow,\n    $white\n  );\n}\n\n.btn-brand-secondary {\n  @include button-brand-variant(\n    $btn-light-brand-secondary-bg,\n    $btn-light-brand-secondary-border,\n    $btn-light-brand-secondary-color,\n    $btn-light-brand-secondary-hover-bg,\n    $btn-light-brand-secondary-hover-border,\n    $btn-light-brand-secondary-hover-color,\n    $btn-light-brand-secondary-active-bg,\n    $btn-light-brand-secondary-active-border,\n    $btn-light-brand-secondary-active-color,\n    $btn-light-brand-secondary-disabled-bg,\n    $btn-light-brand-secondary-disabled-border,\n    $btn-light-brand-secondary-disabled-color,\n    $btn-light-brand-secondary-focus-bg,\n    $btn-light-brand-secondary-focus-border,\n    $btn-light-brand-secondary-focus-shadow,\n    $dark-gray-700\n  );\n}\n\n.btn-brand-tertiary {\n  @include button-brand-variant(\n    $btn-light-brand-tertiary-bg,\n    $btn-light-brand-tertiary-border,\n    $btn-light-brand-tertiary-color,\n    $btn-light-brand-tertiary-hover-bg,\n    $btn-light-brand-tertiary-hover-border,\n    $btn-light-brand-tertiary-hover-color,\n    $btn-light-brand-tertiary-active-bg,\n    $btn-light-brand-tertiary-active-border,\n    $btn-light-brand-tertiary-active-color,\n    $btn-light-brand-tertiary-disabled-bg,\n    $btn-light-brand-tertiary-disabled-border,\n    $btn-light-brand-tertiary-disabled-color,\n    $btn-light-brand-tertiary-focus-bg,\n    $btn-light-brand-tertiary-focus-border,\n    $btn-light-brand-tertiary-focus-shadow,\n    $dark-gray-700\n  );\n}\n\n// Darker\n\n.btn-primary,\n.btn-dark,\n.btn-darker-primary {\n  @include button-brand-variant(\n    $btn-light-darker-primary-bg,\n    $btn-light-darker-primary-border,\n    $btn-light-darker-primary-color,\n    $btn-light-darker-primary-hover-bg,\n    $btn-light-darker-primary-hover-border,\n    $btn-light-darker-primary-hover-color,\n    $btn-light-darker-primary-active-bg,\n    $btn-light-darker-primary-active-border,\n    $btn-light-darker-primary-active-color,\n    $btn-light-darker-primary-disabled-bg,\n    $btn-light-darker-primary-disabled-border,\n    $btn-light-darker-primary-disabled-color,\n    $btn-light-darker-primary-focus-bg,\n    $btn-light-darker-primary-focus-border,\n    $btn-light-darker-primary-focus-shadow,\n    $white\n  );\n\n  // for bg-dark sections / CTA 8\n  &.shadow-nm-dark-up {\n    @include button-brand-variant(\n      #1d1d1d,\n      #1d1d1d,\n      $btn-light-darker-primary-color,\n      $btn-light-darker-primary-hover-bg,\n      $btn-light-darker-primary-hover-border,\n      $btn-light-darker-primary-hover-color,\n      #1d1d1d,\n      $dark-gray-500,\n      $btn-light-darker-primary-active-color,\n      $btn-light-darker-primary-disabled-bg,\n      $btn-light-darker-primary-disabled-border,\n      $btn-light-darker-primary-disabled-color,\n      #1d1d1d,\n      $dark-gray-500,\n      $btn-light-darker-primary-focus-shadow,\n      $white\n    );\n  }\n}\n\n.btn-secondary,\n.btn-darker-secondary {\n  @include button-brand-variant(\n    $btn-light-darker-secondary-bg,\n    $btn-light-darker-secondary-border,\n    $btn-light-darker-secondary-color,\n    $btn-light-darker-secondary-hover-bg,\n    $btn-light-darker-secondary-hover-border,\n    $btn-light-darker-secondary-hover-color,\n    $btn-light-darker-secondary-active-bg,\n    $btn-light-darker-secondary-active-border,\n    $btn-light-darker-secondary-active-color,\n    $btn-light-darker-secondary-disabled-bg,\n    $btn-light-darker-secondary-disabled-border,\n    $btn-light-darker-secondary-disabled-color,\n    $btn-light-darker-secondary-focus-bg,\n    $btn-light-darker-secondary-focus-border,\n    $btn-light-darker-secondary-focus-shadow,\n    $white\n  );\n}\n\n.btn-darker-tertiary,\n.btn-darker-outline {\n  // darker-outline is darker-tertiary in light mode and darker-secondary in dark mode\n  @include button-brand-variant(\n    $btn-light-darker-tertiary-bg,\n    $btn-light-darker-tertiary-border,\n    $btn-light-darker-tertiary-color,\n    $btn-light-darker-tertiary-hover-bg,\n    $btn-light-darker-tertiary-hover-border,\n    $btn-light-darker-tertiary-hover-color,\n    $btn-light-darker-tertiary-active-bg,\n    $btn-light-darker-tertiary-active-border,\n    $btn-light-darker-tertiary-active-color,\n    $btn-light-darker-tertiary-disabled-bg,\n    $btn-light-darker-tertiary-disabled-border,\n    $btn-light-darker-tertiary-disabled-color,\n    $btn-light-darker-tertiary-focus-bg,\n    $btn-light-darker-tertiary-focus-border,\n    $btn-light-darker-tertiary-focus-shadow,\n    $dark-gray-700\n  );\n}\n\n// Standard\n\n.btn-standard-primary {\n  @include button-brand-variant(\n    $btn-light-standard-primary-bg,\n    $btn-light-standard-primary-border,\n    $btn-light-standard-primary-color,\n    $btn-light-standard-primary-hover-bg,\n    $btn-light-standard-primary-hover-border,\n    $btn-light-standard-primary-hover-color,\n    $btn-light-standard-primary-active-bg,\n    $btn-light-standard-primary-active-border,\n    $btn-light-standard-primary-active-color,\n    $btn-light-standard-primary-disabled-bg,\n    $btn-light-standard-primary-disabled-border,\n    $btn-light-standard-primary-disabled-color,\n    $btn-light-standard-primary-focus-bg,\n    $btn-light-standard-primary-focus-border,\n    $btn-light-standard-primary-focus-shadow,\n    $white\n  );\n}\n\n.btn-standard-secondary {\n  @include button-brand-variant(\n    $btn-light-standard-secondary-bg,\n    $btn-light-standard-secondary-border,\n    $btn-light-standard-secondary-color,\n    $btn-light-standard-secondary-hover-bg,\n    $btn-light-standard-secondary-hover-border,\n    $btn-light-standard-secondary-hover-color,\n    $btn-light-standard-secondary-active-bg,\n    $btn-light-standard-secondary-active-border,\n    $btn-light-standard-secondary-active-color,\n    $btn-light-standard-secondary-disabled-bg,\n    $btn-light-standard-secondary-disabled-border,\n    $btn-light-standard-secondary-disabled-color,\n    $btn-light-standard-secondary-focus-bg,\n    $btn-light-standard-secondary-focus-border,\n    $btn-light-standard-secondary-focus-shadow,\n    $dark-gray-700\n  );\n\n  &:hover,\n  &:active,\n  &.active {\n    svg {\n      color: $white;\n    }\n  }\n}\n\n.btn-standard-tertiary,\n.btn-standard-outline {\n  // standard-outline is standard-tertiary in light mode and standard-secondary in dark mode\n  @include button-brand-variant(\n    $btn-light-standard-tertiary-bg,\n    $btn-light-standard-tertiary-border,\n    $btn-light-standard-tertiary-color,\n    $btn-light-standard-tertiary-hover-bg,\n    $btn-light-standard-tertiary-hover-border,\n    $btn-light-standard-tertiary-hover-color,\n    $btn-light-standard-tertiary-active-bg,\n    $btn-light-standard-tertiary-active-border,\n    $btn-light-standard-tertiary-active-color,\n    $btn-light-standard-tertiary-disabled-bg,\n    $btn-light-standard-tertiary-disabled-border,\n    $btn-light-standard-tertiary-disabled-color,\n    $btn-light-standard-tertiary-focus-bg,\n    $btn-light-standard-tertiary-focus-border,\n    $btn-light-standard-tertiary-focus-shadow,\n    $dark-gray-700\n  );\n}\n\n.btn-brand-quartenary,\n.btn-darker-quartenary,\n.btn-standard-quartenary {\n  @extend .btn-link;\n\n  --#{$prefix}btn-color: rgba(17, 17, 17, 0.84);\n  --#{$prefix}btn-active-color: #{$dark-gray-700};\n  --#{$prefix}btn-hover-color: #{$dark-gray-700};\n\n  svg {\n    color: $dark-gray-700;\n  }\n\n  &.d-block {\n    // btn-link is inline-flex for icon alignment\n    // block btn-link is flex fix for underline position\n    display: flex !important;\n    justify-content: center;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: none;\n  }\n\n  &:hover {\n    span {\n      @include link-gradient($dark-gray-700);\n    }\n  }\n\n  &.active,\n  &:active {\n    span {\n      @include link-gradient(rgba($dark-gray-700, 0.5));\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    span {\n      color: rgba(17, 17, 17, 0.5);\n      background-image: none;\n    }\n  }\n}\n\n.btn-brand-quartenary {\n  --#{$prefix}btn-focus-box-shadow: #{$btn-focus-shadow};\n\n  &:focus-visible {\n    box-shadow: $btn-focus-shadow;\n    color: rgba($dark-gray-700, 0.84);\n  }\n}\n\n.btn-darker-quartenary,\n.btn-standard-quartenary {\n  --#{$prefix}btn-focus-box-shadow: none;\n\n  &:focus-visible {\n    border: 1px solid rgba($focus-blue, 0.5);\n  }\n}\n\n// ---------------------------------------------\n\n// secondary inverse for bg-dark sections\n// used in Blocks: CTA1 and Hero4\n\n.btn-secondary-inverse {\n  @include button-brand-variant(\n    transparent,\n    rgba($white, 0.4),\n    rgba($white, 0.8),\n    transparent,\n    rgba($white, 0.8),\n    $white,\n    transparent,\n    rgba($white, 0.8),\n    $white,\n    transparent,\n    $dark-gray-500,\n    rgba($white, 0.4),\n    transparent,\n    rgba($white, 0.5),\n    $btn-focus-shadow,\n    $white\n  );\n}\n\n// ---------------------------------------------\n\n// Darker\n\n.dark .btn-primary,\n.dark .btn-darker-primary,\n.btn-light {\n  @include button-brand-variant(\n    $btn-inverse-darker-primary-bg,\n    $btn-inverse-darker-primary-border,\n    $btn-inverse-darker-primary-color,\n    $btn-inverse-darker-primary-hover-bg,\n    $btn-inverse-darker-primary-hover-border,\n    $btn-inverse-darker-primary-hover-color,\n    $btn-inverse-darker-primary-active-bg,\n    $btn-inverse-darker-primary-active-border,\n    $btn-inverse-darker-primary-active-color,\n    $btn-inverse-darker-primary-disabled-bg,\n    $btn-inverse-darker-primary-disabled-border,\n    $btn-inverse-darker-primary-disabled-color,\n    $btn-inverse-darker-primary-focus-bg,\n    $btn-inverse-darker-primary-focus-border,\n    $btn-inverse-darker-primary-focus-shadow,\n    $dark-gray-700\n  );\n}\n\n.dark .show > .btn-primary.dropdown-toggle,\n.dark .show > .btn-darker-primary.dropdown-toggle,\n.show > .btn-light.dropdown-toggle {\n  background-color: var(--#{$prefix}btn-bg);\n  border-color: var(--#{$prefix}btn-bg);\n  color: var(--#{$prefix}btn-hover-color);\n}\n\n.dark {\n  // Darker\n\n  .btn-secondary,\n  .btn-darker-secondary,\n  .btn-darker-outline {\n    @include button-brand-variant(\n      $btn-inverse-darker-secondary-bg,\n      $btn-inverse-darker-secondary-border,\n      $btn-inverse-darker-secondary-color,\n      $btn-inverse-darker-secondary-hover-bg,\n      $btn-inverse-darker-secondary-hover-border,\n      $btn-inverse-darker-secondary-hover-color,\n      $btn-inverse-darker-secondary-active-bg,\n      $btn-inverse-darker-secondary-active-border,\n      $btn-inverse-darker-secondary-active-color,\n      $btn-inverse-darker-secondary-disabled-bg,\n      $btn-inverse-darker-secondary-disabled-border,\n      $btn-inverse-darker-secondary-disabled-color,\n      $btn-inverse-darker-secondary-focus-bg,\n      $btn-inverse-darker-secondary-focus-border,\n      $btn-inverse-darker-secondary-focus-shadow,\n      $white\n    );\n  }\n\n  // for input group buttons\n  .btn-darker-outline {\n    --#{$prefix}btn-border-color: #{$dark-gray-200};\n  }\n\n  .btn-darker-tertiary {\n    @include button-brand-variant(\n      $btn-inverse-darker-tertiary-bg,\n      $btn-inverse-darker-tertiary-border,\n      $btn-inverse-darker-tertiary-color,\n      $btn-inverse-darker-tertiary-hover-bg,\n      $btn-inverse-darker-tertiary-hover-border,\n      $btn-inverse-darker-tertiary-hover-color,\n      $btn-inverse-darker-tertiary-active-bg,\n      $btn-inverse-darker-tertiary-active-border,\n      $btn-inverse-darker-tertiary-active-color,\n      $btn-inverse-darker-tertiary-disabled-bg,\n      $btn-inverse-darker-tertiary-disabled-border,\n      $btn-inverse-darker-tertiary-disabled-color,\n      $btn-inverse-darker-tertiary-focus-bg,\n      $btn-inverse-darker-tertiary-focus-border,\n      $btn-inverse-darker-tertiary-focus-shadow,\n      $white\n    );\n  }\n\n  // Brand\n  .btn-brand-primary {\n    @include button-brand-variant(\n      $btn-inverse-brand-primary-bg,\n      $btn-inverse-brand-primary-border,\n      $btn-inverse-brand-primary-color,\n      $btn-inverse-brand-primary-hover-bg,\n      $btn-inverse-brand-primary-hover-border,\n      $btn-inverse-brand-primary-hover-color,\n      $btn-inverse-brand-primary-active-bg,\n      $btn-inverse-brand-primary-active-border,\n      $btn-inverse-brand-primary-active-color,\n      $btn-inverse-brand-primary-disabled-bg,\n      $btn-inverse-brand-primary-disabled-border,\n      $btn-inverse-brand-primary-disabled-color,\n      $btn-inverse-brand-primary-focus-bg,\n      $btn-inverse-brand-primary-focus-border,\n      $btn-inverse-brand-primary-focus-shadow,\n      $dark-gray-700\n    );\n  }\n\n  .btn-brand-secondary {\n    @include button-brand-variant(\n      $btn-inverse-brand-secondary-bg,\n      $btn-inverse-brand-secondary-border,\n      $btn-inverse-brand-secondary-color,\n      $btn-inverse-brand-secondary-hover-bg,\n      $btn-inverse-brand-secondary-hover-border,\n      $btn-inverse-brand-secondary-hover-color,\n      $btn-inverse-brand-secondary-active-bg,\n      $btn-inverse-brand-secondary-active-border,\n      $btn-inverse-brand-secondary-active-color,\n      $btn-inverse-brand-secondary-disabled-bg,\n      $btn-inverse-brand-secondary-disabled-border,\n      $btn-inverse-brand-secondary-disabled-color,\n      $btn-inverse-brand-secondary-focus-bg,\n      $btn-inverse-brand-secondary-focus-border,\n      $btn-inverse-brand-secondary-focus-shadow,\n      $white\n    );\n  }\n\n  .btn-brand-tertiary {\n    @include button-brand-variant(\n      $btn-inverse-brand-tertiary-bg,\n      $btn-inverse-brand-tertiary-border,\n      $btn-inverse-brand-tertiary-color,\n      $btn-inverse-brand-tertiary-hover-bg,\n      $btn-inverse-brand-tertiary-hover-border,\n      $btn-inverse-brand-tertiary-hover-color,\n      $btn-inverse-brand-tertiary-active-bg,\n      $btn-inverse-brand-tertiary-active-border,\n      $btn-inverse-brand-tertiary-active-color,\n      $btn-inverse-brand-tertiary-disabled-bg,\n      $btn-inverse-brand-tertiary-disabled-border,\n      $btn-inverse-brand-tertiary-disabled-color,\n      $btn-inverse-brand-tertiary-focus-bg,\n      $btn-inverse-brand-tertiary-focus-border,\n      $btn-inverse-brand-tertiary-focus-shadow,\n      $white\n    );\n  }\n\n  // Standard\n\n  .btn-standard-primary {\n    @include button-brand-variant(\n      $btn-inverse-standard-primary-bg,\n      $btn-inverse-standard-primary-border,\n      $btn-inverse-standard-primary-color,\n      $btn-inverse-standard-primary-hover-bg,\n      $btn-inverse-standard-primary-hover-border,\n      $btn-inverse-standard-primary-hover-color,\n      $btn-inverse-standard-primary-active-bg,\n      $btn-inverse-standard-primary-active-border,\n      $btn-inverse-standard-primary-active-color,\n      $btn-inverse-standard-primary-disabled-bg,\n      $btn-inverse-standard-primary-disabled-border,\n      $btn-inverse-standard-primary-disabled-color,\n      $btn-inverse-standard-primary-focus-bg,\n      $btn-inverse-standard-primary-focus-border,\n      $btn-inverse-standard-primary-focus-shadow,\n      $dark-gray-700\n    );\n  }\n\n  .btn-standard-secondary,\n  .btn-standard-outline {\n    @include button-brand-variant(\n      $btn-inverse-standard-secondary-bg,\n      $btn-inverse-standard-secondary-border,\n      $btn-inverse-standard-secondary-color,\n      $btn-inverse-standard-secondary-hover-bg,\n      $btn-inverse-standard-secondary-hover-border,\n      $btn-inverse-standard-secondary-hover-color,\n      $btn-inverse-standard-secondary-active-bg,\n      $btn-inverse-standard-secondary-active-border,\n      $btn-inverse-standard-secondary-active-color,\n      $btn-inverse-standard-secondary-disabled-bg,\n      $btn-inverse-standard-secondary-disabled-border,\n      $btn-inverse-standard-secondary-disabled-color,\n      $btn-inverse-standard-secondary-focus-bg,\n      $btn-inverse-standard-secondary-focus-border,\n      $btn-inverse-standard-secondary-focus-shadow,\n      $white\n    );\n  }\n\n  .btn-standard-tertiary {\n    @include button-brand-variant(\n      $btn-inverse-standard-tertiary-bg,\n      $btn-inverse-standard-tertiary-border,\n      $btn-inverse-standard-tertiary-color,\n      $btn-inverse-standard-tertiary-hover-bg,\n      $btn-inverse-standard-tertiary-hover-border,\n      $btn-inverse-standard-tertiary-hover-color,\n      $btn-inverse-standard-tertiary-active-bg,\n      $btn-inverse-standard-tertiary-active-border,\n      $btn-inverse-standard-tertiary-active-color,\n      $btn-inverse-standard-tertiary-disabled-bg,\n      $btn-inverse-standard-tertiary-disabled-border,\n      $btn-inverse-standard-tertiary-disabled-color,\n      $btn-inverse-standard-tertiary-focus-bg,\n      $btn-inverse-standard-tertiary-focus-border,\n      $btn-inverse-standard-tertiary-focus-shadow,\n      $white\n    );\n  }\n\n  .btn-brand-quartenary,\n  .btn-darker-quartenary,\n  .btn-standard-quartenary {\n    // not using CSS variables here\n    // because those would be overridden by .dark link default light blue\n    color: rgba($white, 0.84);\n\n    svg {\n      color: $white;\n    }\n\n    &:hover {\n      color: $white;\n\n      span {\n        @include link-gradient($white);\n      }\n    }\n\n    &.active,\n    &:active {\n      color: rgba($white, 0.92);\n\n      span {\n        @include link-gradient(#808080);\n      }\n    }\n\n    &:disabled,\n    &.disabled {\n      span {\n        color: rgba($white, 0.4);\n        background-image: none;\n      }\n    }\n\n    &:focus-visible {\n      color: rgba($white, 0.84);\n    }\n  }\n\n  .btn-darker-quartenary,\n  .btn-standard-quartenary {\n    &:focus-visible {\n      border-color: rgba($focus-blue, 0.5);\n    }\n  }\n\n  .btn-brand-quartenary {\n    --#{$prefix}btn-disabled-color: #{rgba($white, 0.4)};\n\n    &:focus-visible {\n      box-shadow: 0 0 4px 0 rgba($focus-blue, 0.5);\n    }\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-brand-variant(\n  $background,\n  $border,\n  $color,\n  $hover-background,\n  $hover-border,\n  $hover-color,\n  $active-background,\n  $active-border,\n  $active-color,\n  $disabled-background,\n  $disabled-border,\n  $disabled-color,\n  $focus-background,\n  $focus-border,\n  $focus-shadow,\n  $icon-color\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-icon-color: #{$icon-color};\n  // hover variables\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  // active variables\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  // ---------------\n  --#{$prefix}btn-focus-box-shadow: #{$focus-shadow};\n  // disable variables\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n  --#{$prefix}btn-disabled-opacity: 1;\n\n  .btn-check:focus-visible + &,\n  &:focus-visible {\n    // Bootstrap also uses these vars for :focus\n    // so set these vars here instead of property so it doesn't override :active\n    --#{$prefix}btn-hover-color: #{$color};\n    --#{$prefix}btn-hover-bg: #{$focus-background};\n    --#{$prefix}btn-hover-border-color: #{$focus-border};\n  }\n}\n","// Sizing\n\n.btn-group-xl > .btn {\n  @extend .btn-xl;\n}\n\n.btn-group-xs > .btn {\n  @extend .btn-xs;\n}\n\n// also used for Nav Tabs\n\n.btn-group-shadow {\n  background: $light-gray-300;\n\n  .btn {\n    color: rgba($dark-gray-700, 0.84);\n    background-color: transparent;\n    border-color: transparent;\n\n    &:hover,\n    &:focus,\n    &:not(:disabled):not(.disabled):active {\n      color: #000;\n      background-color: transparent;\n      border-color: transparent;\n      box-shadow: none;\n    }\n  }\n\n  .btn:not(:disabled):not(.disabled).active,\n  .show > .btn.dropdown-toggle {\n    color: $dark-gray-700;\n    background-color: $white;\n    border-color: transparent;\n    box-shadow: 0 toRem(7px) toRem(14px) 0 rgba($dark-gray-900, 0.14);\n\n    &:focus {\n      color: #000;\n      // .04 darker opacity than $box-shadow\n      box-shadow: 0 toRem(12px) toRem(16px) rgba($shadow-color, 0.24);\n    }\n  }\n}\n\n.btn-group-brand {\n  // use a CSS variable for border color\n  // so it doesn't override transparent middle borders in dark mode\n  // and won't need to duplicate transparent border styles in dark mode\n  --btn-group-brand-border-color: #{$bp-green-100};\n\n  .btn {\n    background-color: transparent;\n    color: rgba($dark-gray-700, 0.84);\n\n    &,\n    &:focus {\n      border-color: var(--btn-group-brand-border-color);\n    }\n\n    &:not(:first-child):not(:last-child) {\n      border-left-color: transparent;\n      border-right-color: transparent;\n    }\n\n    &:first-child {\n      border-right-color: transparent;\n    }\n\n    &:last-child {\n      border-left-color: transparent;\n    }\n\n    &:hover {\n      border-color: #004f00 !important;\n    }\n\n    &:focus,\n    &:not(:disabled):not(.disabled):active {\n      border-color: $electric-blue !important;\n      box-shadow: none;\n      background-color: unset;\n      color: unset;\n    }\n  }\n\n  .btn:not(:disabled):not(.disabled).active {\n    background-color: #006600;\n    border-color: #006600;\n    color: $white;\n  }\n}\n\n.btn-group-fill {\n  background: $light-gray-300;\n\n  .btn {\n    color: rgba($dark-gray-700, 0.84);\n    background-color: transparent;\n    border-color: transparent;\n\n    &:hover,\n    &:not(:disabled):not(.disabled):active {\n      color: $dark-gray-700;\n      background-color: transparent;\n      border-color: transparent;\n      box-shadow: none;\n\n      &:focus {\n        box-shadow: $btn-focus-shadow;\n      }\n    }\n  }\n\n  .btn:not(:disabled):not(.disabled).active,\n  .show > .btn.dropdown-toggle {\n    color: $white;\n    background-color: $dark-gray-600;\n    border-color: transparent;\n  }\n}\n\n.btn-group {\n  &.rounded-0 > .btn {\n    --#{$prefix}btn-border-radius: 0;\n  }\n\n  &.rounded-2 > .btn {\n    --#{$prefix}btn-border-radius: #{$border-radius-sm};\n  }\n\n  // rounded-3 is default\n\n  &.rounded-4 > .btn {\n    --#{$prefix}btn-border-radius: #{$border-radius-lg};\n  }\n\n  &.rounded-pill > .btn {\n    --#{$prefix}btn-border-radius: #{$border-radius-pill};\n  }\n}\n\n.btn-group-fill,\n.btn-group-shadow {\n  > .btn {\n    border-radius: var(--#{$prefix}btn-border-radius) !important;\n  }\n}\n\n.dark {\n  .btn-group-shadow {\n    background: $dark-gray-800;\n\n    .btn {\n      color: rgba($white, 0.84);\n\n      &:hover,\n      &:focus,\n      &:not(:disabled):not(.disabled):active {\n        color: $white;\n      }\n    }\n\n    .btn:not(:disabled):not(.disabled).active,\n    .show > .btn.dropdown-toggle {\n      color: rgba($white, 0.92);\n      background-color: $dark-gray-600;\n      border-color: transparent;\n      box-shadow: 0 toRem(7px) toRem(14px) rgba($dark-gray-900, 0.5);\n\n      &:focus {\n        color: $white;\n        // .2 darker opacity than $box-shadow-dark-sm\n        box-shadow: 0 toRem(9px) toRem(14px) rgba($shadow-color-dark, 0.7);\n      }\n    }\n  }\n\n  .btn-group-brand {\n    --btn-group-brand-border-color: rgba(#{to-rgb($bp-green-800)}, 0.2);\n\n    .btn {\n      color: rgba($white, 0.84);\n\n      &:hover {\n        border-color: #9fe300 !important;\n      }\n    }\n\n    .btn:not(:disabled):not(.disabled).active {\n      background-color: #b0f000;\n      border-color: #b0f000;\n      color: $dark-gray-700;\n    }\n  }\n\n  .btn-group-fill {\n    background: $dark-gray-800;\n\n    .btn {\n      color: rgba($white, 0.84);\n      background-color: transparent;\n      border-color: transparent;\n\n      &:hover,\n      &:not(:disabled):not(.disabled):active {\n        color: $white;\n        border-color: transparent;\n        box-shadow: none;\n\n        &:focus {\n          box-shadow: $btn-focus-shadow;\n        }\n      }\n    }\n\n    .btn:not(:disabled):not(.disabled).active,\n    .show > .btn.dropdown-toggle {\n      color: $dark-gray-700;\n      background-color: $light-gray-100;\n      border-color: transparent;\n\n      &:focus {\n        color: #000;\n      }\n    }\n  }\n}\n",".accordion {\n  --#{$prefix}accordion-hover-bg: #{$light-gray-100};\n  --#{$prefix}accordion-btn-active-icon: var(--#{$prefix}accordion-btn-icon);\n\n  &.rounded-0,\n  &.accordion-flush {\n    --#{$prefix}accordion-border-radius: 0;\n    --#{$prefix}accordion-inner-border-radius: 0;\n  }\n\n  &:not(.rounded-0) .accordion-item:last-child .accordion-body {\n    border-radius: 0 0 $accordion-inner-border-radius $accordion-inner-border-radius;\n  }\n}\n\n.accordion-item {\n  position: relative;\n  overflow: hidden;\n  border: 0;\n  background-color: transparent;\n\n  + .accordion-item {\n    margin-top: -1px;\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n\n    .accordion-button {\n      pointer-events: none;\n\n      .accordion-title,\n      .accordion-subtitle {\n        opacity: 0.5;\n      }\n\n      svg,\n      &::after {\n        opacity: 0.4;\n      }\n\n      &:focus-visible {\n        box-shadow: none;\n        border-color: var(--#{$prefix}accordion-border-color) !important;\n      }\n    }\n  }\n}\n\n.accordion-has-icon-suffix {\n  .accordion-button::after {\n    margin-left: toRem(10px);\n  }\n}\n\n.accordion-btn-icon-prefix {\n  margin-right: toRem(8px);\n}\n\n.accordion-title {\n  opacity: 0.84;\n}\n\n.accordion-subtitle {\n  opacity: 0.57;\n  font-size: toRem(12px);\n  letter-spacing: 0.2px;\n  line-height: divide(23, 12);\n\n  &:first-child {\n    margin-top: toRem(1px);\n  }\n\n  + .accordion-title {\n    margin-bottom: toRem(1px);\n  }\n}\n\n.accordion-button {\n  align-items: start;\n  font-size: toRem(14px);\n  line-height: divide(24, 14);\n  outline: 0;\n  border: 1px solid var(--#{$prefix}accordion-border-color);\n\n  &:focus {\n    border-color: var(--#{$prefix}accordion-border-color) !important;\n    // Bootstrap zi override, place :hover and :focus-visible above :focus so borders aren't covered up\n    z-index: 2;\n  }\n\n  &:active,\n  &:focus,\n  &:focus-visible {\n    outline: 0;\n    box-shadow: none;\n  }\n\n  svg,\n  &::after {\n    opacity: 0.64;\n  }\n\n  &:focus-visible {\n    border-color: $electric-blue !important;\n    z-index: 3;\n\n    .accordion-subtitle {\n      opacity: 0.64;\n    }\n  }\n\n  &:not(.collapsed) {\n    box-shadow: none;\n  }\n\n  &:hover {\n    z-index: 3;\n    background-color: var(--#{$prefix}accordion-hover-bg);\n    border-color: $dark-gray-900 !important;\n\n    .accordion-title {\n      opacity: 1;\n    }\n\n    .accordion-subtitle {\n      opacity: 0.64;\n    }\n\n    svg,\n    &::after {\n      opacity: 0.9;\n    }\n  }\n}\n\n.accordion-body {\n  background-color: var(--#{$prefix}accordion-bg);\n  padding: toRem(15px) toRem(19px) toRem(19px);\n  font-size: toRem(14px);\n  border: 1px solid var(--#{$prefix}accordion-border-color);\n  border-top: none;\n  letter-spacing: 0;\n\n  p {\n    opacity: 0.64;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n// pads content further in to align to the accordion title\n.accordion-has-btn-icon-prefix {\n  .accordion-button {\n    padding-left: toRem(14px);\n  }\n\n  .accordion-body {\n    padding-left: toRem(46px);\n  }\n}\n\n.accordion-lg {\n  --#{$prefix}accordion-btn-icon-width: #{toRem(32px)};\n\n  &.accordion-has-btn-icon-prefix {\n    .accordion-button {\n      padding-left: toRem(17px);\n    }\n\n    .accordion-body {\n      padding-left: toRem(57px);\n    }\n  }\n\n  .accordion-button {\n    padding: toRem(11px) toRem(17px) toRem(11px) toRem(24px);\n    font-size: toRem(15px);\n    line-height: divide(32, 15);\n  }\n\n  .accordion-subtitle {\n    font-size: toRem(13px);\n    margin: toRem(-1px) 0 toRem(3px);\n    line-height: divide(19, 13);\n    letter-spacing: 0;\n\n    &:first-child {\n      margin: toRem(7px) 0 0;\n    }\n\n    + .accordion-title {\n      line-height: divide(27, 15);\n      margin-bottom: toRem(4px);\n    }\n  }\n\n  .accordion-body {\n    padding: toRem(19px) toRem(24px) toRem(24px);\n    font-size: toRem(16px);\n    letter-spacing: 0.1px;\n  }\n}\n\n.accordion-sm {\n  &.accordion-has-btn-icon-prefix {\n    .accordion-button {\n      padding-left: toRem(9px);\n    }\n\n    .accordion-body {\n      padding-left: toRem(41px);\n    }\n  }\n\n  .accordion-button {\n    padding: toRem(7px) toRem(8px) toRem(7px) toRem(14px);\n    font-size: toRem(13px);\n    line-height: divide(24, 13);\n  }\n\n  .accordion-subtitle {\n    margin-bottom: toRem(1px);\n\n    &:first-child,\n    + .accordion-title {\n      margin-bottom: 0;\n    }\n  }\n\n  .accordion-body {\n    padding: toRem(16px) toRem(14px) toRem(19px);\n    font-size: toRem(13px);\n    line-height: divide(21, 13);\n    letter-spacing: 0.2px;\n  }\n}\n\n.accordion-marketing {\n  --#{$prefix}accordion-btn-icon-width: #{toRem(48px)};\n\n  &.accordion-has-btn-icon-prefix {\n    .accordion-button {\n      padding-left: toRem(14px);\n    }\n\n    .accordion-body {\n      padding-left: toRem(70px);\n    }\n  }\n\n  .accordion-button {\n    padding: toRem(31px) toRem(14px) toRem(31px) toRem(24px);\n    font-size: toRem(26px);\n    line-height: divide(48, 26);\n  }\n\n  .accordion-subtitle {\n    font-size: toRem(18px);\n    line-height: divide(34, 18);\n    margin-bottom: toRem(2px);\n    letter-spacing: 0.15px;\n\n    &:first-child {\n      line-height: divide(32, 18);\n      margin: toRem(8px) 0 0;\n    }\n\n    + .accordion-title {\n      line-height: divide(47, 26);\n      margin-bottom: 0;\n    }\n  }\n\n  .accordion-body {\n    padding: toRem(32px) toRem(24px) toRem(35px);\n    font-size: toRem(18px);\n    line-height: divide(32, 18);\n    letter-spacing: 0.15px;\n  }\n\n  &.accordion-lg {\n    &.accordion-has-btn-icon-prefix {\n      .accordion-button {\n        padding-left: toRem(19px);\n      }\n\n      .accordion-body {\n        padding-left: toRem(76px);\n      }\n    }\n\n    .accordion-button {\n      padding: toRem(39px) toRem(19px) toRem(39px) toRem(29px);\n      font-size: toRem(28px);\n      line-height: divide(48, 28);\n      letter-spacing: 0.45px;\n    }\n\n    .accordion-subtitle {\n      margin-bottom: toRem(3px);\n\n      &:first-child {\n        margin-bottom: 0;\n      }\n\n      + .accordion-title {\n        line-height: divide(48, 28);\n      }\n    }\n\n    .accordion-body {\n      padding: toRem(36px) toRem(29px) toRem(39px);\n    }\n  }\n\n  &.accordion-sm {\n    &.accordion-has-btn-icon-prefix {\n      .accordion-button {\n        padding-left: toRem(14px);\n      }\n\n      .accordion-body {\n        padding-left: toRem(70px);\n      }\n    }\n\n    .accordion-button {\n      padding: toRem(23px) toRem(9px) toRem(23px) toRem(24px);\n      font-size: toRem(23px);\n      line-height: divide(48, 23);\n    }\n\n    .accordion-subtitle {\n      line-height: divide(29, 18);\n      margin-bottom: toRem(5px);\n\n      &:first-child {\n        margin: toRem(9px) 0 toRem(3px);\n      }\n\n      + .accordion-title {\n        line-height: divide(42, 23);\n      }\n    }\n\n    .accordion-body {\n      padding: toRem(28px) toRem(24px) toRem(35px);\n    }\n  }\n}\n\n.accordion-flush {\n  --#{$prefix}accordion-bg: transparent !important;\n  --#{$prefix}accordion-btn-bg: transparent !important;\n  --#{$prefix}accordion-active-bg: transparent !important;\n  --#{$prefix}accordion-hover-bg: transparent !important;\n\n  .accordion-item {\n    &:last-child .accordion-body {\n      border: 0;\n    }\n\n    + .accordion-item {\n      margin-top: 0;\n    }\n\n    .accordion-button {\n      border-top: 0;\n    }\n  }\n\n  .accordion-button,\n  .accordion-body {\n    border-left: 0;\n    border-right: 0;\n  }\n}\n\n.dark {\n  .accordion {\n    --#{$prefix}accordion-bg: #{$dark-gray-700};\n    --#{$prefix}accordion-color: #{$white};\n    --#{$prefix}accordion-btn-color: #{$white};\n    --#{$prefix}accordion-active-color: #{$white};\n    --#{$prefix}accordion-btn-bg: #{$dark-gray-700};\n    --#{$prefix}accordion-active-bg: #{$dark-gray-700};\n    --#{$prefix}accordion-border-color: #{$dark-gray-600};\n    --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-dark-button-icon)};\n    --#{$prefix}accordion-hover-bg: #{$dark-gray-600};\n  }\n\n  .accordion-button {\n    &:hover {\n      border-color: $white !important;\n    }\n  }\n}\n","a.card {\n  color: $dark-gray-700;\n}\n\nbutton.card {\n  padding: 0;\n  text-align: left;\n}\n\n.card-title {\n  font-size: toRem(16px);\n  font-weight: normal; // override h1...h6 headings element font weight 300\n  line-height: divide(24, 16);\n  letter-spacing: 0.05px;\n}\n\n.card-subtitle {\n  font-size: toRem(13px);\n  letter-spacing: 0.2px;\n  text-transform: none; // override h6 caps\n  font-weight: normal; // override headings\n  opacity: 0.6;\n}\n\n.card-body {\n  padding: toRem(16px) toRem(25px) toRem(24px) toRem(25px);\n}\n\n.card-text {\n  font-size: toRem(14px);\n  letter-spacing: 0.2px;\n  line-height: divide(25, 14);\n  opacity: 0.6;\n}\n\n.card-text-sm {\n  font-size: toRem(13px);\n  letter-spacing: 0.2px;\n  line-height: divide(23, 13);\n  opacity: 0.84;\n}\n\n.card-text-lg {\n  font-size: toRem(16px);\n  letter-spacing: 0.1px;\n  line-height: divide(28, 16);\n  opacity: 0.6;\n}\n\n.card-lg {\n  .card-title {\n    font-size: toRem(18px);\n  }\n\n  .card-title-lg {\n    font-size: toRem(23px);\n    line-height: divide(35, 23);\n    letter-spacing: 0.15px;\n  }\n\n  .card-body {\n    padding: toRem(30px);\n  }\n\n  .card-text {\n    font-size: toRem(16px);\n    line-height: divide(28, 16);\n    letter-spacing: 0.1px;\n  }\n\n  .card-subtitle {\n    font-size: toRem(13px);\n    letter-spacing: 0.2px;\n    line-height: divide(20, 13);\n    text-transform: none; // override h6 caps\n    opacity: 0.6;\n    margin-bottom: toRem(16px);\n  }\n}\n\n.card-border {\n  --#{$prefix}card-border-width: 1px;\n}\n\n.card-implicit {\n  --#{$prefix}card-bg: transparent !important;\n\n  .card-body {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n.card-link {\n  font-size: toRem(14px);\n  line-height: divide(20, 14);\n  color: rgba($dark-gray-700, 0.84);\n\n  &:hover {\n    color: $dark-gray-700;\n  }\n}\n\n.dark {\n  a.card,\n  button.card {\n    color: $white;\n  }\n\n  .card {\n    --#{$prefix}card-bg: #{$dark-gray-700};\n  }\n\n  .card-border {\n    --#{$prefix}card-border-color: #{$dark-gray-500};\n  }\n\n  .card-link {\n    color: rgba($white, 0.84);\n\n    &:hover {\n      color: $white;\n    }\n  }\n}\n",".dropdown-menu {\n  box-shadow: var(--#{$prefix}dropdown-box-shadow);\n}\n\n.dropdown-menu-media {\n  .dropdown-item {\n    svg {\n      opacity: 0.54;\n    }\n\n    h5 {\n      opacity: 0.84;\n    }\n\n    p {\n      opacity: 0.64;\n    }\n\n    &:hover {\n      svg {\n        opacity: 0.9;\n      }\n\n      h5 {\n        opacity: 1;\n      }\n\n      p {\n        opacity: 0.84;\n      }\n    }\n  }\n}\n\n.dropdown-menu-scroll {\n  max-height: 315px;\n  overflow-y: scroll;\n}\n\n.dropdown-header {\n  text-transform: none;\n  letter-spacing: 0;\n  font-weight: 400;\n  font-size: toRem(15px);\n}\n\n.dropdown-toggle {\n  // button icon - flip chevron when dropdown is open\n  .show > & > svg {\n    transform: scaleY(-1);\n  }\n\n  // prevent span, svg, prefix or suffix within dropdown-toggle from stopping propagation to the dropdown-toggle\n  > * {\n    pointer-events: none;\n  }\n\n  // hide default toggle arrow, so we can use inline svg icon\n  // applies to both top level dropdown buttons and submenu dropdown items\n  &,\n  .dropup &,\n  .dropend & {\n    &::after {\n      content: none;\n    }\n  }\n\n  .dropstart & {\n    &::before {\n      content: none;\n    }\n  }\n\n  // triangle right arrow for submenu\n  .dropend &.dropdown-item {\n    .dropdown-suffix {\n      opacity: 0.3;\n    }\n\n    &:hover,\n    &:focus {\n      .dropdown-suffix {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.dropdown-menu .dropend .dropdown-menu {\n  margin-left: -0.5em;\n  margin-top: -0.5em;\n}\n\n// vertically center prefix and suffix icons inside of .dropdown-item\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  line-height: divide(toRem(24px), $dropdown-font-size);\n}\n\n.dropdown-icon-prefix {\n  margin-left: toRem(-5px);\n  margin-right: toRem(10px);\n}\n\n.dropdown-suffix {\n  margin-left: auto; // right align the suffix\n  padding-left: 30px;\n  font-size: toRem(13px);\n  // vertically center apple cmd icon\n  display: flex;\n  align-items: center;\n}\n\n// dropdown small and large sizes\n\n.dropdown-menu-sm {\n  font-size: $dropdown-font-size-sm;\n\n  .dropdown-item {\n    // 24px line height to leave room for 24px icon\n    line-height: divide(toRem(24px), $dropdown-font-size-sm);\n    padding: $dropdown-item-padding-y-sm $dropdown-item-padding-x;\n  }\n}\n\n.dropdown-menu-lg {\n  font-size: $dropdown-font-size-lg;\n\n  .dropdown-item {\n    // 32px line height to leave room for 32px icon\n    line-height: divide(toRem(32px), $dropdown-font-size-lg);\n    padding: $dropdown-item-padding-y-lg $dropdown-item-padding-x;\n  }\n}\n\n.dark {\n  .dropdown-menu {\n    // @extend .dropdown-menu-dark doesn't include CSS variables? so copy them from Bootstrap here\n    --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n    --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n    --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n    --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n    --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n    --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n    --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n    --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n    --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n    --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n    --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n    --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  }\n}\n",".list-group {\n  --list-group-sub-color: #{$dark-gray-700};\n\n  --#{$prefix}info-rgb: #{to-rgb($validation-info-fill-light)};\n\n  min-width: 255px;\n\n  .avatar {\n    margin-right: toRem(10px);\n  }\n}\n\n.list-group-item {\n  display: flex;\n  align-items: center;\n  height: 48px;\n  font-size: toRem(14px);\n  line-height: divide(20, 14);\n  letter-spacing: 0;\n  transition: border 0.15s ease-in-out, color 0.15s ease-in-out, background-color 0.15s ease-in-out;\n\n  + .list-group-item {\n    border-top: 1px solid transparent;\n\n    // override bootstrap negative margin to fix jumping when list-group-item active class is added / removed\n    &.active {\n      margin-top: 0;\n    }\n  }\n\n  .list-group-icon {\n    color: var(--list-group-sub-color);\n    opacity: 0.54;\n  }\n\n  &:focus-visible {\n    outline: 0;\n    background: var(--#{$prefix}list-group-bg);\n    border-color: $list-group-focus-visible-color !important;\n\n    &:not(.disabled) {\n      color: var(--#{$prefix}list-group-color);\n    }\n  }\n\n  &:hover {\n    .list-group-icon,\n    .list-group-icon-prefix {\n      opacity: 0.9;\n    }\n\n    .list-group-item-subtitle {\n      opacity: 0.64;\n    }\n  }\n\n  &.active,\n  &:active {\n    .list-group-icon,\n    .list-group-icon-prefix {\n      opacity: 0.64;\n    }\n\n    .list-group-item-subtitle {\n      opacity: 0.57;\n    }\n  }\n\n  &.disabled,\n  &:disabled {\n    pointer-events: auto;\n    cursor: not-allowed;\n\n    > * {\n      opacity: 0.5;\n    }\n\n    .list-group-item-subtitle {\n      opacity: 1;\n    }\n\n    > svg {\n      opacity: 0.4 !important;\n    }\n  }\n}\n\n.list-group-icon-prefix {\n  margin-right: 6px;\n  opacity: 0.5;\n  color: var(--list-group-sub-color);\n}\n\n.list-group-item-subtitle {\n  font-size: toRem(12px);\n  font-weight: $font-weight-normal;\n  letter-spacing: 0.2px;\n  line-height: divide(19, 12);\n  opacity: 0.5;\n  color: var(--list-group-sub-color);\n}\n\n.list-group-borderless {\n  --#{$prefix}list-group-border-color: transparent !important;\n\n  .list-group-item.active {\n    border-color: transparent;\n  }\n}\n\n.list-group-flush {\n  > .list-group-item {\n    border-top: 1px solid transparent;\n    border-left: 1px solid transparent;\n    border-right: 1px solid transparent;\n\n    &:last-child {\n      border-bottom: 1px solid transparent;\n    }\n  }\n}\n\n.list-group-sm {\n  .list-group-item {\n    height: 44px;\n    font-size: toRem(13px);\n    line-height: divide(19, 13);\n  }\n\n  .list-group-icon-prefix {\n    margin-right: 4px;\n  }\n}\n\n.list-group-lg {\n  .list-group-item {\n    height: 56px;\n    font-size: toRem(15px);\n    line-height: divide(20, 15);\n  }\n\n  .list-group-icon-prefix {\n    margin-right: 8px;\n  }\n\n  .avatar {\n    margin-right: toRem(15px);\n  }\n}\n\n.list-group-two-tier {\n  .list-group-item {\n    height: 72px;\n  }\n\n  .list-group-item-subtitle {\n    margin-top: toRem(2px);\n  }\n\n  &.list-group-lg {\n    .list-group-item {\n      height: 80px;\n    }\n\n    .list-group-item-subtitle {\n      margin-top: toRem(4px);\n      font-size: toRem(13px);\n      line-height: divide(19, 13);\n    }\n  }\n\n  &.list-group-sm {\n    .list-group-item {\n      height: 64px;\n    }\n\n    .list-group-item-subtitle {\n      margin-top: 0;\n      font-size: toRem(12px);\n      line-height: divide(19, 12);\n    }\n  }\n}\n\n.dark {\n  .list-group {\n    --list-group-sub-color: #{$white};\n\n    --#{$prefix}info-rgb: #{to-rgb($info)};\n\n    --#{$prefix}list-group-color: #{rgba($white, 0.64)};\n\n    --#{$prefix}list-group-bg: #{$dark-gray-700};\n    --#{$prefix}list-group-border-color: #{$dark-gray-600};\n    --#{$prefix}list-group-disabled-color: #{$white};\n\n    --#{$prefix}list-group-active-bg: #{$dark-gray-600};\n    --#{$prefix}list-group-active-color: #{rgba($white, 0.84)};\n    --#{$prefix}list-group-active-border-color: #{$dark-gray-600};\n\n    --#{$prefix}list-group-action-color: #{rgba($white, 0.64)};\n    --#{$prefix}list-group-action-hover-color: #{rgba($white, 0.84)};\n    --#{$prefix}list-group-action-hover-bg: #{$dark-gray-500};\n    --#{$prefix}list-group-action-active-color: #{rgba($white, 0.84)};\n    --#{$prefix}list-group-action-active-bg: #{$dark-gray-600};\n    --#{$prefix}list-group-disabled-bg: #{$dark-gray-700};\n    --#{$prefix}list-group-disabled-color: #{$white};\n  }\n}\n",".modal-content {\n  box-shadow: $modal-content-box-shadow-xs;\n\n  @include media-breakpoint-up(md) {\n    box-shadow: $modal-content-box-shadow-md-up;\n  }\n}\n\n@mixin modal-header-padding($header-padding) {\n  .modal-header {\n    padding: $header-padding;\n\n    .btn-close-inline {\n      padding: $header-padding;\n      margin: (-$header-padding) (-$header-padding) (-$header-padding) auto;\n    }\n  }\n}\n\n// flash message / extra small\n\n.modal-xs {\n  @media (min-width: ($modal-xs + 36px)) {\n    margin: 1.75rem auto;\n    max-width: $modal-xs;\n  }\n\n  @include modal-header-padding($modal-xs-header-padding);\n\n  .modal-body {\n    padding: $modal-xs-inner-padding;\n  }\n\n  .modal-header + .modal-body {\n    padding-top: 0;\n  }\n}\n\n.modal-sm {\n  @include modal-header-padding($modal-sm-header-padding);\n\n  .modal-content {\n    box-shadow: $box-shadow;\n  }\n\n  .modal-body {\n    padding: $modal-sm-inner-padding;\n  }\n\n  .btn.text-uppercase {\n    font-size: toRem(13px);\n  }\n}\n\n.modal-lg,\n.modal-xl {\n  --#{$prefix}modal-border-radius: #{toRem(12px)};\n  --#{$prefix}modal-inner-border-radius: #{toRem(12px)};\n}\n\n.modal-btn-margin {\n  margin: toRem(3px);\n}\n\n// ----------------------------------------------------------\n\n// left border on columns separating buttons\n.modal-footer-row {\n  > div + div {\n    border-left: 1px solid $modal-footer-border-color;\n  }\n}\n\n// top border on rows separating buttons\n.modal-footer-column {\n  > * {\n    margin: 0; // default bootstrap override\n  }\n\n  > div + div {\n    border-top: 1px solid $modal-footer-border-color;\n  }\n}\n\n// inside borders for\n// col-6 col-sm-3\n.modal-footer-grid {\n  @include media-breakpoint-down(sm) {\n    > div:nth-child(even) {\n      border-left: 1px solid $modal-footer-border-color;\n    }\n\n    > div:nth-child(n + 3) {\n      border-top: 1px solid $modal-footer-border-color;\n    }\n  }\n\n  @include media-breakpoint-up(sm) {\n    > div + div:not(:nth-child(5n)) {\n      border-left: 1px solid $modal-footer-border-color;\n    }\n\n    > div:nth-child(n + 5) {\n      border-top: 1px solid $modal-footer-border-color;\n    }\n  }\n}\n\n// modal footer columm / row / grid buttons\n\n.modal-footer-column,\n.modal-footer-row,\n.modal-footer-grid {\n  .btn {\n    // remove box shadow because button corner sticks outside of modal border-radius\n    .dark & {\n      &:focus {\n        box-shadow: none;\n      }\n    }\n  }\n}\n\n// -------------------------------------------------------------------\n\n.modal-header {\n  .btn-close-inline {\n    border-radius: var(--bs-modal-border-radius);\n    padding: ($modal-header-padding-y) ($modal-header-padding-x);\n    margin: ($modal-header-padding-y * -1) ($modal-header-padding-x * -1)\n      ($modal-header-padding-y * -1) auto;\n  }\n}\n\n// -------------------------------------------------------------------\n\n.dark {\n  .modal-sm {\n    .modal-content {\n      box-shadow: 0 toRem(12px) toRem(16px) 0 rgba($dark-gray-700, 0.5);\n    }\n  }\n\n  .modal-content {\n    background: $dark-gray-600;\n    color: $white;\n    box-shadow: 0 toRem(30px) toRem(40px) 0 rgba($dark-gray-700, 0.26);\n\n    @include media-breakpoint-up(md) {\n      box-shadow: $box-shadow-dark-xl;\n    }\n  }\n\n  .modal-footer,\n  .modal-footer-row > div,\n  .modal-footer-column > div,\n  .modal-footer-grid > div {\n    border-color: $dark-gray-500 !important;\n  }\n}\n","// reset first-child border-radius-left and last-child border-radius right\n.page-item:first-child .page-link,\n.page-item:last-child .page-link {\n  &,\n  .pagination-lg &,\n  .pagination-sm & {\n    border-radius: 0;\n  }\n}\n\n.page-item {\n  &.disabled {\n    cursor: not-allowed;\n  }\n\n  &:not(.disabled) {\n    .page-link:focus-visible {\n      box-shadow: $pagination-focus-visible-box-shadow;\n    }\n  }\n}\n\n.page-item-circle,\n.page-item-square {\n  .page-link {\n    @include square(var(--pagination-square-size));\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    outline: 0;\n  }\n}\n\n// for Previous / Next\n.page-item-pill {\n  .page-link {\n    border-radius: var(--#{$prefix}border-radius-pill) !important;\n  }\n}\n\n.page-item-word {\n  .page-link {\n    height: var(--pagination-square-size);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: var(--pagination-word-font-size);\n    letter-spacing: 1px;\n    text-transform: uppercase;\n  }\n}\n\n.page-item-circle {\n  margin: 0 2px;\n\n  .page-link {\n    border-radius: 50% !important;\n  }\n}\n\n.pagination {\n  --pagination-word-font-size: #{toRem(11px)};\n  --pagination-square-size: #{$input-height};\n}\n\n.pagination-lg {\n  --pagination-word-font-size: #{toRem(17px)};\n  --pagination-square-size: #{$input-height-lg};\n}\n\n.pagination-sm {\n  --#{$prefix}pagination-font-size: #{$font-size-xs};\n  --pagination-word-font-size: #{toRem(10px)};\n  --pagination-square-size: #{$input-height-sm};\n}\n\n.dark {\n  .pagination {\n    --#{$prefix}pagination-color: #{rgba($white, 0.64)};\n    --#{$prefix}pagination-disabled-color: #{rgba($white, 0.4)};\n    --#{$prefix}pagination-active-bg: #{$white};\n    --#{$prefix}pagination-active-color: #{$dark-gray-700};\n    --#{$prefix}pagination-hover-color: #{$white};\n    --#{$prefix}pagination-hover-bg: #{$dark-gray-600};\n    --#{$prefix}pagination-focus-color: #{$white};\n  }\n}\n",".popover {\n  padding: toRem(16px) toRem(20px) toRem(18px);\n  box-shadow: $popover-box-shadow;\n}\n\n.popover-header {\n  font-weight: 400;\n  font-family: $font-family-base;\n  font-size: toRem(14px);\n  letter-spacing: 0.3px;\n  line-height: 1.5;\n  padding: 0;\n  margin-bottom: toRem(12px);\n\n  svg:first-child {\n    margin: toRem(-2px) toRem(5px) toRem(-1px) toRem(-6px);\n  }\n}\n\n.popover-body {\n  opacity: 0.64;\n  padding: 0;\n  letter-spacing: 0.2px;\n}\n\n.popover-dark {\n  --#{$prefix}popover-bg: #{$popover-dark-bg};\n\n  .popover-inner {\n    filter: invert(1) grayscale(100%) brightness(120%);\n  }\n\n  .popover-header,\n  .popover-body {\n    color: unset;\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-margin;\n}\n.bs-popover-end {\n  margin-left: $popover-margin;\n}\n.bs-popover-bottom {\n  margin-top: $popover-margin;\n}\n.bs-popover-start {\n  margin-right: $popover-margin;\n}\n\n.dark {\n  .popover {\n    --#{$prefix}popover-bg: #{$popover-dark-bg};\n    --#{$prefix}popover-header-color: #{$white};\n    --#{$prefix}popover-body-color: #{$white};\n  }\n\n  .popover-dark {\n    --#{$prefix}popover-bg: #{$white};\n  }\n}\n\n.popover-walkthrough {\n  --#{$prefix}popover-max-width: 280px;\n}\n\n// Remove arrow for react-joyride\n.__floater__arrow {\n  display: none;\n}\n\n// include the left border of the target in the spotlight\n.react-joyride__spotlight {\n  margin-left: -1px;\n}\n",".spinner-border-lg,\n.spinner-grow-lg {\n  --#{$prefix}spinner-width: 3rem;\n  --#{$prefix}spinner-height: 3rem;\n}\n\n.spinner-label {\n  transition: opacity 300ms;\n}\n",".steps {\n  --steps-contrast-color: #{$white};\n  --steps-incomplete-track-color: #{$light-gray-300};\n  --steps-complete-track-color: #{$dark-gray-50};\n  --steps-incomplete-circle-color: rgba(#{$dark-gray-700}, 0.64);\n  --steps-incomplete-circle-bg: #{$light-gray-300};\n  --steps-incomplete-circle-hover-bg: #{$dark-gray-900};\n  --steps-active-circle-bg: #{$dark-gray-500};\n  --steps-success-color: #{$validation-success-fill-light};\n  --steps-warning-color: #{$validation-warning-fill-light};\n  --steps-warning-text-color: #{$validation-warning-text-light};\n  --steps-danger-color: #{$validation-danger-fill-light};\n  --steps-danger-text-color: #{$validation-danger-text-light};\n  --steps-progress-circle-bg: #{$white};\n  --steps-circular-progress-color: #{$success};\n  --steps-circular-progress-background-color: #{$light-gray-300};\n  --steps-tabbed-background: #{$light-gray-100};\n  --steps-tabbed-background-active: #{$white};\n  --steps-tabbed-border: #{$light-gray-400};\n  --steps-tabbed-active-border-bottom: #{$light-gray-700};\n  --steps-tabbed-hover-border-bottom: #{$dark-gray-700};\n  --steps-xs-circle-border: #{$light-gray-500};\n  --steps-xs-circle-active-border: #{$dark-gray-50};\n  --steps-xs-complete: #{$dark-gray-500};\n}\n\n.steps-step {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n\n  &:first-child {\n    .step-left-line {\n      opacity: 0;\n    }\n  }\n\n  &:last-child {\n    .step-right-line {\n      opacity: 0;\n    }\n  }\n\n  &.step-complete {\n    .step-circle {\n      color: var(--steps-contrast-color);\n      background-color: var(--steps-success-color);\n    }\n\n    .step-line {\n      background-color: var(--steps-complete-track-color);\n    }\n  }\n\n  &.step-active {\n    .step-circle {\n      color: var(--steps-contrast-color);\n      background-color: var(--steps-active-circle-bg);\n    }\n\n    .step-line {\n      &.step-left-line {\n        background-color: var(--steps-complete-track-color);\n      }\n    }\n  }\n\n  &.step-warning {\n    .step-circle {\n      background-color: var(--steps-warning-color);\n      color: $dark-gray-700;\n    }\n\n    .step-description {\n      opacity: 1;\n      color: var(--steps-warning-text-color);\n    }\n  }\n\n  &.step-error {\n    .step-circle {\n      background-color: var(--steps-danger-color);\n      color: var(--steps-contrast-color);\n    }\n\n    .step-description {\n      opacity: 1;\n      color: var(--steps-danger-text-color);\n    }\n  }\n}\n\na.step-action {\n  text-decoration: none;\n}\n\n.step-action {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  outline: none;\n\n  &:disabled {\n    .step-label,\n    .step-description,\n    .step-number {\n      opacity: 0.5;\n    }\n  }\n\n  &:not(:disabled):hover {\n    .step-label {\n      opacity: 1;\n    }\n\n    &.step-incomplete.step-normal {\n      .step-circle {\n        background-color: var(--steps-incomplete-circle-hover-bg);\n        color: var(--steps-contrast-color);\n      }\n    }\n  }\n\n  &:focus-visible {\n    .step-circle {\n      border-color: $electric-blue;\n    }\n  }\n}\n\n.step-top {\n  display: flex;\n  align-items: center;\n}\n\n.step-line {\n  background-color: var(--steps-incomplete-track-color);\n  flex-grow: 1;\n  height: 1px;\n}\n\n.step-circle {\n  display: flex;\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  font-size: toRem(12px);\n  height: toRem(24px);\n  width: toRem(24px);\n  border: 1px solid transparent;\n  border-radius: 50%;\n  background-color: var(--steps-incomplete-circle-bg);\n  color: var(--steps-incomplete-circle-color);\n  flex-shrink: 0;\n\n  &.step-circle-progress {\n    background-color: var(--steps-progress-circle-bg);\n  }\n\n  .step-progress-track {\n    stroke: var(--steps-circular-progress-background-color);\n  }\n\n  .step-progress-percent {\n    stroke: var(--steps-circular-progress-color);\n    transition: stroke-dashoffset 0.15s ease-in;\n  }\n}\n\n.step-label {\n  line-height: toRem(20px);\n  opacity: 0.84;\n  font-size: toRem(14px);\n}\n\n.step-description {\n  line-height: toRem(16px);\n  opacity: 0.57;\n  font-size: toRem(12px);\n}\n\n.steps-sm {\n  .step-top {\n    height: toRem(24px);\n  }\n\n  .step-circle {\n    height: toRem(16px);\n    width: toRem(16px);\n  }\n\n  .step-error,\n  .step-warning {\n    .step-circle {\n      background-color: transparent;\n      height: toRem(24px);\n      width: toRem(24px);\n    }\n  }\n\n  .step-error {\n    .step-circle {\n      color: var(--steps-danger-color);\n    }\n  }\n\n  .step-warning {\n    .step-circle {\n      color: var(--steps-warning-color);\n    }\n  }\n}\n\n.steps-xs {\n  .step-circle {\n    height: toRem(12px);\n    width: toRem(12px);\n    background-color: var(--steps-contrast-color);\n    border-color: var(--steps-xs-circle-border);\n  }\n\n  .steps-step {\n    &.step-complete {\n      .step-circle {\n        background-color: var(--steps-xs-complete);\n        border-color: var(--steps-xs-complete);\n      }\n    }\n\n    &.step-active {\n      .step-circle {\n        border-color: var(--steps-xs-circle-active-border);\n      }\n    }\n\n    &.step-error {\n      .step-circle {\n        border-color: var(--steps-danger-color);\n      }\n    }\n\n    &.step-warning {\n      .step-circle {\n        border-color: var(--steps-warning-color);\n      }\n    }\n  }\n\n  .step-action {\n    &.step-normal {\n      &:not(:disabled):hover {\n        .step-circle {\n          background-color: transparent;\n          border-color: var(--steps-incomplete-circle-hover-bg);\n        }\n      }\n    }\n  }\n}\n\n.steps-alignment-left {\n  .steps-step {\n    text-align: left;\n  }\n\n  .step-left-line {\n    display: none;\n  }\n\n  .step-right-line {\n    margin: 0 toRem(10px);\n  }\n\n  &.steps-xs {\n    .step-right-line {\n      margin: 0;\n    }\n  }\n}\n\n.steps-tabbed {\n  .steps-step {\n    display: flex;\n    background-color: var(--steps-tabbed-background);\n    border: 1px solid var(--steps-tabbed-border);\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 20px;\n    flex-direction: row;\n\n    + .steps-step {\n      margin-left: -1px;\n    }\n\n    &.step-active {\n      background-color: var(--steps-tabbed-background-active);\n      border-bottom-color: var(--steps-tabbed-active-border-bottom);\n    }\n  }\n\n  .step-text {\n    text-align: left;\n    margin: 0 !important;\n  }\n\n  .step-action {\n    &:not(:disabled):hover {\n      border-bottom-color: var(--steps-tabbed-hover-border-bottom);\n    }\n\n    &:focus-visible {\n      border-color: $electric-blue;\n      z-index: 1;\n\n      .step-circle {\n        border-color: transparent;\n      }\n    }\n  }\n}\n\n.dark {\n  .steps {\n    --steps-contrast-color: #{$dark-gray-700};\n    --steps-incomplete-track-color: #{$dark-gray-300};\n    --steps-complete-track-color: #{$light-gray-800};\n    --steps-incomplete-circle-color: rgba(#{$white}, 0.84);\n    --steps-incomplete-circle-bg: #{$dark-gray-500};\n    --steps-incomplete-circle-hover-bg: #{$white};\n    --steps-active-circle-bg: #{$light-gray-400};\n    --steps-success-color: #{$success};\n    --steps-warning-color: #{$warning};\n    --steps-warning-text-color: #{$validation-warning-text-dark};\n    --steps-danger-color: #{$danger};\n    --steps-danger-text-color: #{$validation-danger-text-dark};\n    --steps-progress-circle-bg: #{$dark-gray-500};\n    --steps-circular-progress-color: #{$success};\n    --steps-circular-progress-background-color: #{$dark-gray-300};\n    --steps-tabbed-background: #{$dark-gray-600};\n    --steps-tabbed-background-active: #{$dark-gray-500};\n    --steps-tabbed-border: #{$dark-gray-500};\n    --steps-tabbed-active-border-bottom: #{$light-gray-900};\n    --steps-tabbed-hover-border-bottom: #{$light-gray-500};\n    --steps-xs-circle-border: #{$dark-gray-300};\n    --steps-xs-circle-active-border: #{$light-gray-800};\n    --steps-xs-complete: #{$light-gray-400};\n  }\n}\n","@mixin cell-shadow {\n  &::after {\n    content: '';\n    position: absolute;\n    top: 1px; // needs to be one pixel so it doesn't show over the border\n    right: 0;\n    height: 100%;\n    width: 100%;\n    box-shadow: var(--table-column-sticky-shadow);\n    z-index: -1;\n  }\n}\n\n.table {\n  // CSS var for paddding-y used for icon top value at different table sizes\n  --#{$prefix}table-cell-padding-y: #{$table-cell-padding-y};\n\n  // width of a cell with only an icon (edit, row options dropdown, delete, collapse, etc)\n  // nested tables are different size than parent, but nested table icon cells get width of parent table icon cell\n  &,\n  .table {\n    --#{$prefix}table-cell-square-width: 47px;\n  }\n\n  tfoot th,\n  thead th {\n    font-size: toRem(13px);\n    color: $dark-gray-700;\n  }\n\n  thead th {\n    border-bottom: 1px solid $dark-gray-100;\n  }\n\n  tbody {\n    font-size: toRem(14px);\n    line-height: divide(22, 14);\n  }\n\n  // remove bottom border on last row\n  > tbody:not(caption) > :last-child > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top: none;\n  }\n}\n\n.table-cell-square {\n  width: var(--#{$prefix}table-cell-square-width);\n  min-width: var(--#{$prefix}table-cell-square-width);\n}\n\nth .table-cell-square-icon {\n  bottom: var(--#{$prefix}table-cell-padding-y);\n}\n\ntd .table-cell-square-icon {\n  top: var(--#{$prefix}table-cell-padding-y);\n}\n\n.table-layout-fixed {\n  table-layout: fixed;\n}\n\n[class*='table-responsive'] {\n  margin-bottom: toRem(16px);\n  // horizontal scroll sticky column shadow overflows and adds vertical scrollbar\n  overflow-y: hidden;\n\n  .table {\n    margin-bottom: 0;\n  }\n}\n\n// nested table\n\n.table {\n  .table {\n    --#{$prefix}table-bg: #{$light-gray-200};\n\n    thead th {\n      background-color: var(--#{$prefix}table-bg) !important;\n    }\n  }\n}\n\n.table-bordered {\n  .table-bordered {\n    // set nested table outside borders to overlap with parent table cell borders\n    margin: -1px;\n    width: calc(100% + 2px);\n  }\n}\n\n.table-header-borderless {\n  thead th {\n    border-bottom: none;\n  }\n}\n\n.table-striped {\n  --#{$prefix}table-bg: #{$light-gray-200};\n  --#{$prefix}table-hover-bg: #{rgba($dark-gray-700, 0.02)};\n\n  thead th {\n    background-color: $white;\n  }\n}\n\n.table-striped-blue {\n  --#{$prefix}table-bg: #eef0f5;\n  --#{$prefix}table-striped-bg: #f6f8fd;\n}\n\n.table-striped-blue-and-white {\n  --#{$prefix}table-bg: #{$white};\n  --#{$prefix}table-striped-bg: #f6f8fd;\n}\n\n// for a striped table with a nested table\n// this class is only meant to be added with:\n// <tr className={classNames(index % 2 === 0 && 'tr-blue')}>\n// because expanded rows add another row which throws off the normal .table-striped-blue-and-white striping\n.tr-blue {\n  --#{$prefix}table-bg: #f6f8fd;\n}\n\n.table-striped-gray-and-white {\n  --#{$prefix}table-bg: #{$light-gray-100};\n  --#{$prefix}table-striped-bg: #{$white};\n}\n\n.table-heading-blue {\n  thead th {\n    background-color: #f6f8fd;\n    border-bottom: 1px solid $light-gray-500;\n  }\n}\n\n.table-heading-gray {\n  thead th {\n    background-color: $light-gray-200;\n    border-bottom: 1px solid $light-gray-500;\n  }\n}\n\n// Small / compact table\n\n.table-sm {\n  --#{$prefix}table-cell-padding-y: #{$table-cell-padding-y-sm};\n\n  &,\n  .table {\n    --#{$prefix}table-cell-square-width: 39px;\n  }\n\n  tfoot th,\n  thead th {\n    font-size: toRem(12px);\n    line-height: divide(21, 12);\n  }\n\n  tbody {\n    font-size: toRem(13px);\n    line-height: divide(23, 13);\n  }\n\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n// Large / comfortable table\n\n.table-lg {\n  --#{$prefix}table-cell-padding-y: #{$table-cell-padding-y-lg};\n\n  &,\n  .table {\n    --#{$prefix}table-cell-square-width: 52px;\n  }\n\n  tbody {\n    font-size: toRem(15px);\n    line-height: divide(24, 15);\n  }\n\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-lg $table-cell-padding-x-lg;\n  }\n}\n\n// Border versions\n\n.table-bordered {\n  &,\n  th,\n  td {\n    border-color: $light-gray-500;\n  }\n\n  thead th {\n    border-color: $light-gray-700;\n    border-bottom-color: $dark-gray-400;\n  }\n}\n\n// split into separate classes?\n// .text-center .table-first-col-left .table-last-col-right\n.table-center {\n  text-align: center;\n\n  tr > {\n    th,\n    td {\n      &:first-child {\n        text-align: left;\n      }\n\n      &:last-child {\n        text-align: right;\n      }\n    }\n  }\n}\n\n// left align the second column\n.table-col-2-left {\n  tr > {\n    th,\n    td {\n      &:nth-child(2) {\n        text-align: left;\n      }\n    }\n  }\n}\n\n.table-vertical-stack {\n  --#{$prefix}table-first-column-bg: #{$light-gray-100};\n  --#{$prefix}table-thead-th-color: #{rgba($dark-gray-700, 0.92)};\n  --#{$prefix}table-color: #{rgba($dark-gray-700, 0.84)};\n\n  thead th {\n    border-bottom-color: #ccc;\n  }\n\n  > :not(caption):not(thead) > tr > th:first-child {\n    background: var(--#{$prefix}table-first-column-bg);\n  }\n\n  > :not(thead) th {\n    color: var(--#{$prefix}table-thead-th-color);\n  }\n\n  tbody td {\n    color: var(--#{$prefix}table-color);\n  }\n}\n\n.table-vertical-stack-collapse {\n  &.collapsed {\n    tr:nth-child(n + 4) {\n      display: none;\n    }\n  }\n\n  th {\n    color: $dark-gray-700;\n  }\n}\n\n.table-column-sticky {\n  --table-column-sticky-shadow: #{$box-shadow-lg};\n\n  @include media-breakpoint-down(md) {\n    table-layout: fixed;\n\n    th {\n      white-space: nowrap;\n      width: 150px;\n    }\n\n    &.table-row-selection {\n      th:first-child,\n      td:first-child {\n        z-index: 2;\n\n        &::after {\n          display: none;\n        }\n      }\n\n      th:nth-child(2),\n      td:nth-child(2) {\n        @include cell-shadow;\n        position: sticky;\n        left: 40px;\n        z-index: 1;\n      }\n\n      tr:last-child td:nth-child(2) {\n        overflow-y: clip;\n      }\n    }\n\n    th:first-child,\n    td:first-child {\n      @include cell-shadow;\n      position: sticky;\n      left: 0;\n      z-index: 1;\n    }\n\n    tr:last-child td:first-child {\n      overflow-y: clip;\n    }\n  }\n}\n\n.dark {\n  .table {\n    --#{$prefix}table-bg: #{$dark-gray-700};\n    --#{$prefix}table-color: #{rgba($white, 0.64)};\n    --#{$prefix}table-striped-color: #{rgba($white, 0.64)};\n    --#{$prefix}table-striped-bg: #1f1f1f;\n    --#{$prefix}table-hover-bg: #{rgba($white, 0.05)};\n    --#{$prefix}table-hover-color: #{rgba($white, 0.64)};\n\n    &:not(caption) > * > * {\n      border-bottom: 1px solid $dark-gray-600;\n    }\n\n    thead th {\n      border-color: $light-gray-600;\n    }\n  }\n\n  // nested table\n  .table {\n    .table {\n      --#{$prefix}table-bg: #1f1f1f;\n    }\n  }\n\n  .table-striped {\n    --#{$prefix}table-bg: #1f1f1f;\n    --#{$prefix}table-striped-bg: #141414;\n\n    thead th {\n      background-color: $dark-gray-700;\n    }\n  }\n\n  .table-striped-blue {\n    --#{$prefix}table-bg: #1e1f23;\n    --#{$prefix}table-striped-bg: #16181a;\n  }\n\n  .table-striped-blue-and-white {\n    --#{$prefix}table-bg: #{$dark-gray-700};\n    --#{$prefix}table-striped-bg: #16181a;\n  }\n\n  .tr-blue {\n    --#{$prefix}table-bg: #16181a;\n  }\n\n  .table-striped-gray-and-white {\n    thead th {\n      background: #1f1f1f;\n    }\n\n    --#{$prefix}table-bg: #141414;\n    --#{$prefix}table-striped-bg: #{$dark-gray-700};\n  }\n\n  .table-heading-blue {\n    thead th {\n      background: #1e1f23;\n      border-bottom: 1px solid $dark-gray-400;\n    }\n  }\n\n  .table-heading-gray {\n    thead th {\n      background: #1f1f1f;\n      border-bottom: 1px solid $dark-gray-400;\n    }\n  }\n\n  .table-borderless {\n    &:not(caption) > * > * {\n      border-bottom-width: 0;\n    }\n  }\n\n  .table-bordered {\n    &,\n    th,\n    td {\n      border-color: $dark-gray-400;\n    }\n\n    &:not(caption) > * > * {\n      border-bottom: 1px solid $dark-gray-400;\n    }\n\n    thead th {\n      border-color: $dark-gray-200;\n    }\n  }\n\n  tfoot th,\n  thead th {\n    color: rgba($white, 0.92);\n  }\n\n  .table-vertical-stack {\n    --#{$prefix}table-first-column-bg: #141414;\n    --#{$prefix}table-thead-th-color: #{rgba($white, 0.92)};\n    --#{$prefix}table-color: #{rgba($white, 0.84)};\n  }\n\n  .table-vertical-stack-collapse {\n    th {\n      color: rgba($white, 0.92);\n    }\n  }\n\n  .table-column-sticky {\n    --table-column-sticky-shadow: #{0 toRem(20px) toRem(30px) rgba($dark-gray-900, 0.6)};\n  }\n}\n",".tooltip {\n  letter-spacing: 0.3px;\n}\n\n.tooltip-inner {\n  box-shadow: $box-shadow;\n}\n\n// large size\n\n.tooltip-lg {\n  font-size: $tooltip-font-size-lg;\n  letter-spacing: 0.5px;\n\n  .tooltip-inner {\n    border-radius: $tooltip-border-radius-lg;\n    padding: $tooltip-padding-y-lg $tooltip-padding-x-lg;\n  }\n}\n\n.bs-tooltip-top {\n  margin-bottom: $tooltip-spacer;\n}\n\n.bs-tooltip-end {\n  margin-left: $tooltip-spacer;\n}\n\n.bs-tooltip-bottom {\n  margin-top: $tooltip-spacer;\n}\n\n.bs-tooltip-start {\n  margin-right: $tooltip-spacer;\n}\n\n// smaller margin for inline links, closer to text\n.tooltip-link {\n  &.bs-tooltip-top {\n    margin-bottom: $tooltip-link-spacer;\n  }\n\n  &.bs-tooltip-end {\n    margin-left: $tooltip-link-spacer;\n  }\n\n  &.bs-tooltip-bottom {\n    margin-top: $tooltip-link-spacer;\n  }\n\n  &.bs-tooltip-start {\n    margin-right: $tooltip-link-spacer;\n  }\n}\n\n// light bg\n\n.tooltip-light,\n.dark .tooltip {\n  --#{$prefix}tooltip-bg: #{$tooltip-bg-light};\n  --#{$prefix}tooltip-color: #{$tooltip-color-light};\n}\n\n.dark {\n  .tooltip-light {\n    --#{$prefix}tooltip-bg: #{$tooltip-bg};\n    --#{$prefix}tooltip-color: #{$tooltip-color};\n  }\n}\n",".toast-container {\n  padding: toRem(22px);\n}\n\n.toast-header {\n  font-size: toRem(14px);\n  letter-spacing: 0.3px;\n  line-height: divide(24, 14);\n  border-bottom: none;\n  padding: toRem(16px) toRem(20px) toRem(12px);\n\n  + .toast-body {\n    padding: 0 toRem(20px) toRem(20px);\n  }\n\n  small {\n    line-height: divide(24, 12);\n  }\n}\n\n.toast-body {\n  display: flex;\n  align-items: flex-start;\n  letter-spacing: 0.2px;\n  padding: toRem(16px) toRem(20px);\n  line-height: 1.5;\n}\n\n.toast-icon {\n  margin-right: 1px;\n  margin-left: -6px;\n  opacity: 0.8;\n}\n\n.toast {\n  .btn-close {\n    margin-top: -8px;\n    margin-left: 5px;\n    margin-right: -10px;\n    flex-shrink: 0;\n  }\n}\n\n.toast-border {\n  .toast-header {\n    border-bottom: 1px solid $toast-header-border-color;\n    padding: toRem(8px) toRem(20px);\n\n    + .toast-body {\n      padding-top: toRem(12px);\n    }\n  }\n\n  .btn-close {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n}\n\n// header without body\n.toast-header:only-child {\n  padding-top: toRem(12px);\n\n  .btn-close {\n    margin-top: 0;\n  }\n}\n\n// body without header\n.toast-body:only-child {\n  .btn-close {\n    margin-top: -4px;\n  }\n}\n\n// Light Toasts\n\n.toast-light,\n.dark .toast {\n  --#{$prefix}toast-bg: #{$toast-light-background-color};\n  --#{$prefix}toast-color: #{$toast-light-color};\n  --#{$prefix}toast-header-color: #{$toast-light-header-color};\n\n  .toast-header {\n    border-bottom-color: $toast-light-header-border-color;\n  }\n}\n\n.dark {\n  .toast-light {\n    --#{$prefix}toast-bg: #{$toast-background-color};\n    --#{$prefix}toast-color: #{$toast-color};\n    --#{$prefix}toast-header-color: #{$toast-header-color};\n\n    .toast-header {\n      border-bottom-color: $dark-gray-400;\n    }\n  }\n\n  .toast:not(.toast-light) {\n    .btn-close {\n      filter: none;\n    }\n  }\n}\n",".tree-root {\n  background: var(--tree-background-color);\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  ul,\n  li {\n    list-style-type: none;\n    text-indent: 0;\n    margin: 0;\n  }\n\n  ul {\n    padding: 0;\n  }\n}\n\n.tree-sm {\n  .tree-node {\n    padding: toRem(5.5px) toRem(15px);\n  }\n\n  .tree-label {\n    font-size: toRem(14px);\n  }\n}\n\n.tree-node-expand {\n  color: inherit;\n  opacity: 0.54;\n}\n\n.tree-node {\n  border: 1px solid transparent;\n  padding: toRem(9.5px) toRem(15px);\n  cursor: pointer;\n  background: var(--tree-background-color);\n\n  &:not(.tree-node-disabled):hover {\n    background: var(--tree-hover-background-color);\n\n    .tree-node-expand,\n    .tree-icon {\n      opacity: 0.9;\n    }\n\n    .tree-label {\n      opacity: 1;\n    }\n  }\n}\n\n.tree-node-focusable {\n  outline: none;\n}\n\nbutton.tree-node:focus-visible,\na.tree-node:focus-visible,\nli:focus-visible > .tree-node {\n  border-color: $electric-blue;\n}\n\na.tree-node:hover {\n  text-decoration: none;\n}\n\n.tree-node-disabled {\n  cursor: not-allowed;\n\n  .tree-node-expand,\n  .tree-icon,\n  .tree-label {\n    opacity: 0.5;\n  }\n\n  &:hover {\n    background: var(--tree-disabled-hover-background-color);\n  }\n}\n\n.tree-label {\n  font-size: toRem(15px);\n  line-height: toRem(20px);\n  padding: toRem(3.5px) 0;\n  opacity: 0.64;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2; /* number of lines to show */\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  text-align: left;\n}\n\n.tree-prefix {\n  width: 24px;\n  flex-shrink: 0;\n}\n\n.tree-indicator-spacing {\n  width: 16px;\n  flex-shrink: 0;\n}\n\n.tree-vertical-line {\n  position: absolute;\n  z-index: 1;\n  align-self: center;\n  width: 1px;\n  background: var(--tree-indicator-color);\n\n  &.tree-node-full-height {\n    height: calc(100% + 2px);\n    top: 0;\n    bottom: 0;\n  }\n\n  &.tree-node-bottom-half {\n    height: calc(50% - 12px);\n    bottom: -2px;\n  }\n}\n\n.tree-icon {\n  opacity: 0.54;\n}\n\n.tree-is-above {\n  border-top-color: $electric-blue;\n}\n\n.tree-is-below {\n  border-bottom-color: $electric-blue;\n  // Keeps the border-bottom in the same place\n  margin-bottom: -1px;\n  position: relative;\n  padding-bottom: toRem(10.5px);\n}\n\n.tree-sm {\n  .tree-is-below {\n    padding-bottom: toRem(6.5px);\n  }\n}\n\n.tree-node-notification {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 18px;\n  height: 18px;\n  line-height: 0;\n  font-size: toRem(9px);\n  padding: 0 toRem(6.02px); // if notification >= 10, width is auto\n  background-color: var(--tree-notification-background-color);\n  color: var(--tree-notification-text-color);\n  border-radius: var(--bs-border-radius-pill);\n}\n\n.tree-notification-badge {\n  // Copied from _badge.scss\n  font-weight: $font-weight-normal;\n  padding: 0.33333em 0.7em !important;\n}\n\n.tree-spacer {\n  background: var(--tree-background-color);\n  min-height: 10px;\n  border: 1px solid transparent;\n\n  &.tree-is-over {\n    border-top-color: $electric-blue;\n  }\n}\n\n@include light-mode() {\n  --tree-background-color: #{$white};\n  --tree-hover-background-color: #{$light-gray-200};\n  --tree-disabled-hover-background-color: #{$light-gray-100};\n  --tree-notification-background-color: #{$dark-gray-700};\n  --tree-notification-text-color: #{$white};\n  --tree-indicator-color: #{$light-gray-400};\n}\n\n@include dark-mode() {\n  --tree-background-color: #{$dark-gray-700};\n  --tree-hover-background-color: #{$dark-gray-500};\n  --tree-disabled-hover-background-color: #{$dark-gray-600};\n  --tree-notification-background-color: #{$light-gray-300};\n  --tree-notification-text-color: #{$dark-gray-700};\n  --tree-indicator-color: #{$dark-gray-400};\n}\n","// Base nav\n\n.nav {\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n\n  letter-spacing: 0.3px;\n}\n\n.nav-link {\n  line-height: ceil(divide(24, 14));\n\n  // redefine active, hover and disabled color here\n  // so :hover comes after and overrides .active\n\n  svg {\n    color: $dark-gray-700;\n    opacity: 0.54;\n    transition: opacity 0.15s ease-in-out, color 0.15s ease-in-out;\n\n    // not only child or else this would affect Navbar > icon only nav-link\n    &:first-child:not(:only-child) {\n      margin-right: toRem(5px);\n    }\n  }\n\n  &:focus,\n  &:focus-within {\n    outline: 0;\n  }\n\n  &.active {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n\n    svg {\n      opacity: 0.8;\n    }\n  }\n\n  &:hover {\n    color: var(--#{$prefix}nav-link-hover-color);\n\n    svg {\n      opacity: 0.9;\n    }\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}nav-link-color);\n  }\n\n  &.disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: auto;\n    cursor: not-allowed;\n\n    svg {\n      opacity: 0.4;\n    }\n  }\n}\n\n.tab-content-vertical {\n  border-left: 1px solid $light-gray-300;\n  background: $white;\n}\n\n.nav-tabs-column {\n  min-width: toRem(255px);\n  background: $white;\n}\n\n// $nav-link-focus-box-shadow is overridden to none for navbar, sidebar and tabs - these have focus border.\n// Re-add bootstrap focus shadow to default bootstrap nav-link, but not navbar, tabs nav-link.\n// Only apply to an .nav-link if its parent .nav doesn't have any other classes that add focus borders.\n// This also affects sidebar nav-links, so that is overridden again with none.\n[class='nav'],\n[class='nav flex-column'] {\n  .nav-link:focus-visible {\n    box-shadow: $focus-ring-box-shadow;\n  }\n}\n\n// --------------------------------\n\n// Tabs\n\n.nav-tabs {\n  --#{$prefix}nav-tabs-bg-color: #{$white};\n  --#{$prefix}nav-tabs-focus-border-color: #{$electric-blue $electric-blue transparent};\n\n  background-color: var(--#{$prefix}nav-tabs-bg-color);\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    position: relative;\n\n    &.active {\n      border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n    }\n\n    &:not(.disabled):hover {\n      color: var(--#{$prefix}nav-link-hover-color);\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color); // override .active\n      z-index: 2;\n    }\n\n    &:not(.disabled):focus-visible {\n      border-color: var(--#{$prefix}nav-tabs-focus-border-color) !important;\n      z-index: 1;\n    }\n  }\n\n  &:not(.flex-column) {\n    .nav-item + .nav-item,\n    .nav-link + .nav-link {\n      margin-left: -1px;\n    }\n  }\n\n  + .tab-content {\n    --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n\n    border: 1px solid var(--#{$prefix}nav-tabs-border-color);\n    border-top: 0;\n  }\n\n  &.flex-column {\n    --#{$prefix}nav-tabs-link-hover-border-color: #{$dark-gray-700 transparent $dark-gray-700\n      $dark-gray-700};\n    --#{$prefix}nav-tabs-link-active-border-color: #{$light-gray-500 transparent $light-gray-500\n      $light-gray-500};\n    --#{$prefix}nav-tabs-focus-border-color: #{$electric-blue transparent $electric-blue\n      $electric-blue};\n\n    border-bottom: 0;\n\n    .nav-link {\n      margin-right: calc(-1 * var(--bs-nav-tabs-border-width));\n    }\n  }\n}\n\n.nav-tabs + .tab-content-vertical {\n  border: 1px solid $light-gray-500;\n}\n\n// --------------------------------\n\n// Standard - default, underlined\n\n.nav-standard {\n  --#{$prefix}nav-standard-border-color: #{$light-gray-500};\n  --#{$prefix}nav-standard-focus-border-color: #{$electric-blue};\n  --#{$prefix}nav-standard-link-bg-color: #{$white};\n  --#{$prefix}nav-standard-link-border-color: transparent;\n  --#{$prefix}nav-standard-link-active-border-color: #{$light-gray-700};\n  --#{$prefix}nav-standard-link-hover-border-color: #{$dark-gray-700};\n\n  border-bottom: 1px solid var(--#{$prefix}nav-standard-border-color);\n\n  .nav-link {\n    background-color: var(--#{$prefix}nav-standard-link-bg-color);\n    border: 1px solid var(--#{$prefix}nav-standard-link-border-color);\n\n    &.active {\n      border-bottom-color: var(--#{$prefix}nav-standard-link-active-border-color);\n    }\n\n    &:not(.disabled):hover {\n      border-bottom-color: var(--#{$prefix}nav-standard-link-hover-border-color);\n    }\n\n    &:not(.disabled):focus-visible {\n      border-color: var(--#{$prefix}nav-standard-focus-border-color) !important;\n    }\n  }\n\n  &.flex-column {\n    border-bottom: 0;\n\n    .nav-link {\n      border-bottom-color: transparent;\n\n      &.active {\n        border-left-color: var(--#{$prefix}nav-standard-link-active-border-color);\n      }\n\n      &:not(.disabled):hover {\n        border-bottom-color: transparent;\n        border-left-color: var(--#{$prefix}nav-standard-link-hover-border-color);\n      }\n    }\n  }\n}\n\n// --------------------------------\n\n// Pills / fill\n\n.nav-pills {\n  --#{$prefix}nav-pills-bg-link-color: #{$white};\n  --#{$prefix}nav-link-color: #{rgba($dark-gray-700, 0.84)};\n  --#{$prefix}nav-pills-border-color: #{$white};\n  --#{$prefix}nav-pills-hover-bg-color: #{$dark-gray-700};\n  --#{$prefix}nav-pills-hover-border-color: #{$dark-gray-700};\n  --#{$prefix}nav-pills-hover-color: #{$white};\n  --#{$prefix}nav-pills-hover-focus-color: #{$white};\n  --#{$prefix}nav-pills-active-icon-color: #{$white};\n\n  .nav-link {\n    background-color: var(--#{$prefix}nav-pills-bg-link-color);\n    border: 1px solid var(--#{$prefix}nav-pills-border-color);\n\n    &.active {\n      border-color: var(--#{$prefix}nav-pills-link-active-bg);\n      color: var(--#{$prefix}nav-pills-link-active-color);\n\n      svg {\n        color: var(--#{$prefix}nav-pills-active-icon-color);\n      }\n    }\n\n    &:not(.disabled):hover {\n      background-color: var(--#{$prefix}nav-pills-hover-bg-color);\n      border-color: var(--#{$prefix}nav-pills-hover-border-color);\n      color: var(--#{$prefix}nav-pills-hover-color);\n\n      svg {\n        color: var(--#{$prefix}nav-pills-hover-color);\n      }\n    }\n\n    &:not(.disabled):focus-visible {\n      border-color: $electric-blue;\n    }\n  }\n}\n\n// --------------------------------\n\n// Boxed\n\n.nav-boxed {\n  --#{$prefix}nav-boxed-bg-color: #{$light-gray-100};\n  --#{$prefix}nav-boxed-link-bg-color: #{$light-gray-100};\n  --#{$prefix}nav-boxed-link-focus-border-color: #{$electric-blue};\n  --#{$prefix}nav-boxed-link-focus-color: #{$light-gray-200};\n  --#{$prefix}nav-boxed-link-hover-border-color: #{$dark-gray-700};\n  --#{$prefix}nav-boxed-link-hover-bg-color: #{$light-gray-200};\n  --#{$prefix}nav-boxed-link-active-bg: #f7f7f7;\n  --#{$prefix}nav-boxed-link-active-border-color: #{$light-gray-700};\n\n  background: var(--#{$prefix}nav-boxed-bg-color) !important;\n\n  .nav-link {\n    background-color: var(--#{$prefix}nav-boxed-link-bg-color);\n    border: 1px solid var(--#{$prefix}nav-boxed-link-bg-color);\n    border-bottom-color: transparent;\n\n    &.active {\n      background-color: var(--#{$prefix}nav-boxed-link-active-bg);\n      border-color: var(--#{$prefix}nav-boxed-link-active-bg);\n      border-bottom-color: var(--#{$prefix}nav-boxed-link-active-border-color);\n    }\n\n    &:not(.disabled):hover {\n      background-color: var(--#{$prefix}nav-boxed-link-hover-bg-color);\n      border-color: var(--#{$prefix}nav-boxed-link-hover-bg-color);\n      border-bottom-color: var(--#{$prefix}nav-boxed-link-hover-border-color);\n    }\n\n    &:not(.disabled):focus-visible {\n      border-color: var(--#{$prefix}nav-boxed-link-focus-border-color) !important;\n      color: var(--#{$prefix}nav-link-focus-color);\n    }\n  }\n\n  &.flex-column {\n    .nav-link {\n      border-bottom-color: transparent;\n\n      &.active {\n        border-left-color: var(--#{$prefix}nav-boxed-link-active-border-color);\n      }\n\n      &:not(.disabled):hover {\n        border-bottom-color: transparent;\n        border-left-color: var(--#{$prefix}nav-boxed-link-hover-border-color);\n      }\n    }\n  }\n}\n\n// --------------------------------\n\n// Bordered\n\n.nav-bordered {\n  --#{$prefix}nav-tabs-link-active-border-color: #{$light-gray-700};\n  --#{$prefix}nav-tabs-link-bg-color: #{$white};\n  --#{$prefix}nav-tabs-link-border-color: #{$light-gray-400};\n  --#{$prefix}nav-tabs-link-focus-border-color: #{$electric-blue};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$dark-gray-700};\n\n  .nav-item:first-child .nav-link {\n    border-left-color: var(--#{$prefix}nav-tabs-link-border-color);\n  }\n\n  .nav-link {\n    background-color: var(--#{$prefix}nav-tabs-link-bg-color);\n    border: 1px solid var(--#{$prefix}nav-tabs-link-border-color);\n    border-left-color: var(--#{$prefix}nav-tabs-link-bg-color);\n\n    &.active {\n      border-bottom-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n    }\n\n    &:not(.disabled):hover {\n      border-bottom-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n\n    &:not(.disabled):focus-visible {\n      border-color: var(--#{$prefix}nav-tabs-link-focus-border-color) !important;\n      color: var(--#{$prefix}nav-link-color);\n    }\n  }\n\n  &.flex-column {\n    .nav-item:first-child .nav-link {\n      border-top: 1px solid var(--#{$prefix}nav-tabs-link-border-color);\n    }\n\n    .nav-link {\n      border-left-color: var(--#{$prefix}nav-tabs-link-border-color);\n      border-top-color: transparent;\n      border-right-color: transparent;\n\n      &.active {\n        border-left-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n        border-bottom-color: var(--#{$prefix}nav-tabs-link-border-color);\n      }\n\n      &:hover {\n        border-left-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n        border-bottom-color: var(--#{$prefix}nav-tabs-link-border-color);\n      }\n    }\n  }\n}\n\n.nav-bordered + .tab-content-vertical {\n  border-left-color: $light-gray-400;\n}\n\n// --------------------------------\n\n// Elevated\n\n.nav-elevated {\n  --#{$prefix}nav-elevated-box-shadow: #{$box-shadow};\n  --#{$prefix}nav-elevated-nav-link-active-box-shadow: #{$box-shadow};\n  --#{$prefix}nav-elevated-link-bg-color: #{$white};\n\n  // in a flexed container, flex-shrink prevents the tab panel overlapping the tabs\n  flex-shrink: 0;\n  overflow: hidden;\n  box-shadow: var(--#{$prefix}nav-elevated-box-shadow);\n\n  &:not(.nav-justified):not(.flex-column) {\n    display: inline-flex;\n  }\n\n  .nav-link {\n    background-color: var(--#{$prefix}nav-elevated-link-bg-color);\n    border: 1px solid var(--#{$prefix}nav-elevated-link-bg-color);\n\n    &:not(.disabled):focus-visible {\n      border-color: $electric-blue;\n      color: var(--#{$prefix}nav-link-color);\n    }\n\n    &.active {\n      box-shadow: var(--#{$prefix}nav-elevated-nav-link-active-box-shadow);\n      position: relative;\n      z-index: 1;\n    }\n  }\n\n  + .tab-content {\n    --#{$prefix}nav-elevated-tab-content-box-shadow: #{0 0 toRem(16px) rgba($shadow-color, 0.2)};\n    --#{$prefix}nav-tabs-bg-color: #{$white};\n\n    background: var(--#{$prefix}nav-tabs-bg-color);\n    box-shadow: var(--#{$prefix}nav-elevated-tab-content-box-shadow);\n    position: relative;\n  }\n\n  + .tab-content-vertical {\n    box-shadow: 0 toRem(20px) toRem(30px) 0 rgba($shadow-color, 0.08);\n    border: 0;\n  }\n\n  &.flex-column {\n    --#{$prefix}nav-elevated-nav-link-active-box-shadow: #{0 toRem(8px) toRem(20px) 0\n      rgba($dark-gray-600, 0.2)};\n    box-shadow: none;\n  }\n}\n\n// -------------------------------------------------------------------\n// -------------------------------------------------------------------\n\n// Dark Mode\n\n.dark {\n  .nav-link {\n    --#{$prefix}nav-tabs-link-active-color: #{rgba($white, 0.84)};\n    --#{$prefix}nav-link-hover-color: #{$white};\n    --#{$prefix}nav-link-color: #{rgba($white, 0.64)};\n    --#{$prefix}nav-link-disabled-color: #{rgba($white, 0.4)};\n\n    svg {\n      color: $white;\n    }\n  }\n\n  .tab-content-vertical {\n    border-left-color: $dark-gray-500;\n    background: $dark-gray-600;\n  }\n\n  .nav-tabs-column {\n    background: $dark-gray-600;\n  }\n\n  // Tabs\n\n  .nav-tabs {\n    --#{$prefix}nav-tabs-active-color: #{rgba($dark-gray-700, 0.84)};\n    --#{$prefix}nav-tabs-bg-color: #{$dark-gray-600};\n    --#{$prefix}nav-tabs-border-color: #{$dark-gray-200};\n    --#{$prefix}nav-tabs-link-hover-border-color: #{$light-gray-500 $light-gray-500 transparent};\n    --#{$prefix}nav-tabs-link-active-bg: #{$dark-gray-600};\n    --#{$prefix}nav-tabs-link-active-border-color: #{$dark-gray-200 $dark-gray-200 transparent};\n\n    &.flex-column {\n      --#{$prefix}nav-tabs-link-hover-border-color: #{$light-gray-500 transparent $light-gray-500\n        $light-gray-500};\n      --#{$prefix}nav-tabs-link-active-border-color: #{$dark-gray-200 transparent $dark-gray-200\n        $dark-gray-200};\n    }\n\n    + .tab-content {\n      --#{$prefix}nav-tabs-border-color: #{$dark-gray-200};\n    }\n  }\n\n  .nav-tabs + .tab-content-vertical {\n    border-color: $dark-gray-200;\n  }\n\n  // Standard\n\n  .nav-standard {\n    --#{$prefix}nav-standard-link-bg-color: #{$dark-gray-600};\n    --#{$prefix}nav-standard-border-color: #{$dark-gray-500};\n    --#{$prefix}nav-standard-link-active-border-color: #{$light-gray-900};\n    --#{$prefix}nav-standard-link-hover-border-color: #{$light-gray-500};\n  }\n\n  // Pills\n\n  .nav-pills {\n    --#{$prefix}nav-pills-link-active-bg: #434343;\n    --#{$prefix}nav-pills-link-active-color: #{rgba($white, 0.92)};\n    --#{$prefix}nav-pills-bg-link-color: #{$dark-gray-600};\n    --#{$prefix}nav-pills-border-color: #{$dark-gray-600};\n    --#{$prefix}nav-pills-hover-bg-color: #{$white};\n    --#{$prefix}nav-pills-hover-border-color: #{$white};\n    --#{$prefix}nav-pills-hover-color: #{$dark-gray-700};\n    --#{$prefix}nav-pills-hover-focus-color: #{$dark-gray-700};\n  }\n\n  // Boxed\n\n  .nav-boxed {\n    --#{$prefix}nav-boxed-bg-color: #1e1e1e;\n    --#{$prefix}nav-boxed-link-bg-color: #1e1e1e;\n    --#{$prefix}nav-boxed-link-focus-color: #{rgba($white, 0.64)};\n    --#{$prefix}nav-boxed-link-hover-border-color: #{$light-gray-500};\n    --#{$prefix}nav-boxed-link-hover-bg-color: #{$dark-gray-500};\n    --#{$prefix}nav-boxed-link-active-bg: #{$dark-gray-600};\n    --#{$prefix}nav-boxed-link-active-border-color: #{$light-gray-900};\n  }\n\n  .nav-boxed + .tab-content-vertical {\n    border-left-color: #1e1e1e;\n  }\n\n  // Bordered\n\n  .nav-bordered {\n    --#{$prefix}nav-tabs-link-active-border-color: #{$light-gray-900};\n    --#{$prefix}nav-tabs-link-bg-color: #{$dark-gray-600};\n    --#{$prefix}nav-tabs-link-border-color: #{$dark-gray-500};\n    --#{$prefix}nav-tabs-link-hover-border-color: #{$light-gray-500};\n  }\n\n  // Elevated\n\n  .nav-elevated {\n    --#{$prefix}nav-elevated-box-shadow: #{$box-shadow-dark};\n    --#{$prefix}nav-elevated-nav-link-active-box-shadow: #{0 toRem(12px) toRem(16px)\n      rgba($dark-gray-800, 0.64)};\n    --#{$prefix}nav-elevated-link-bg-color: #{$dark-gray-600};\n\n    + .tab-content {\n      --#{$prefix}nav-elevated-tab-content-box-shadow: #{0 0 toRem(16px) rgba($dark-gray-800, 0.64)};\n      --#{$prefix}nav-tabs-bg-color: #{$dark-gray-600};\n    }\n\n    &.flex-column {\n      --#{$prefix}nav-elevated-nav-link-active-box-shadow: #{0 toRem(8px) toRem(20px)\n        rgba($dark-gray-800, 0.64)};\n\n      background: $dark-gray-700;\n    }\n  }\n\n  .nav-elevated + .tab-content-vertical {\n    box-shadow: $box-shadow-dark;\n  }\n}\n","// vertical sidebar navigation\n\n.offcanvas-sidebar {\n  z-index: $zindex-fixed - 1;\n}\n\n.offcanvas-backdrop-sidebar {\n  z-index: $zindex-fixed - 2;\n}\n\n.nav-sidebar-header {\n  text-transform: uppercase;\n  letter-spacing: toRem(0.9px);\n  font-size: toRem(12px);\n  padding: $nav-link-padding-y toRem(30px);\n  margin-bottom: toRem(2px);\n}\n\n.nav-sidebar {\n  width: toRem(320px);\n  background-color: $white;\n  overflow-y: auto;\n  transition: $nav-link-transition;\n\n  .dark & {\n    background-color: $dark-gray-700;\n  }\n\n  // use .mb-4 on <Nav> instead?\n  .list-unstyled > li {\n    margin-top: toRem(16px);\n  }\n\n  .nav {\n    --#{$prefix}nav-link-hover-bg-color: #{$dark-gray-700};\n    --#{$prefix}nav-link-hover-color: #{$white};\n  }\n\n  .nav.flex-column {\n    .nav-link {\n      padding: $nav-link-padding-y toRem(30px);\n      position: relative;\n      border: 1px solid transparent;\n\n      &.active {\n        background-color: $light-gray-200;\n\n        .dark & {\n          background-color: $dark-gray-600;\n        }\n      }\n\n      &:not(.disabled):hover {\n        background: var(--#{$prefix}nav-link-hover-bg-color) !important;\n        color: var(--#{$prefix}nav-link-hover-color);\n\n        .nav-link-icon {\n          color: var(--#{$prefix}nav-link-hover-color);\n        }\n      }\n\n      &:focus {\n        color: var(--bs-nav-link-color);\n      }\n\n      &:focus-visible {\n        border-color: $focus-blue !important;\n        box-shadow: none;\n        outline: 0;\n      }\n\n      .avatar:first-child {\n        margin-right: toRem(12px);\n      }\n    }\n\n    // 2nd level nav\n    .flex-column {\n      .nav-link {\n        padding-left: toRem(50px);\n      }\n\n      // 3rd level nav\n      .flex-column {\n        .nav-link {\n          padding-left: toRem(70px);\n        }\n      }\n    }\n\n    // with top level icon, indent 2nd and 3rd level more\n    // 2nd level nav\n    .nav-item-icon {\n      .flex-column {\n        .nav-link {\n          padding-left: toRem(80px);\n        }\n\n        // 3rd level nav\n        .flex-column {\n          .nav-link {\n            padding-left: toRem(110px);\n          }\n        }\n      }\n    }\n  }\n}\n\n.nav-link-accordion {\n  display: flex;\n  align-items: center;\n\n  // left border\n  &::before {\n    content: '';\n    position: absolute;\n    background-color: transparent;\n    width: 0;\n    height: 85%;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: background-color 300ms, width 300ms;\n  }\n\n  &.active {\n    background-color: transparent !important;\n\n    &::before {\n      background-color: $dark-gray-700;\n      width: 2px;\n\n      .dark & {\n        background-color: $white;\n      }\n    }\n  }\n\n  // only use left border on top level accordion\n  // \"div\" is the adjacent .collapse, but it changes to .collapsing during transition\n  + div .nav-link-accordion {\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// ----------------------------------------------\n\n// user profile\n\n.user-profile {\n  display: flex;\n  align-items: center;\n  padding: toRem(24px) toRem(30px);\n}\n\n.user-name {\n  font-size: toRem(15px);\n  line-height: divide(20, 15);\n  opacity: 0.84;\n}\n\n.user-contact {\n  font-size: toRem(14px);\n  line-height: divide(20, 14);\n  opacity: 0.64;\n}\n\n// -------------------------------------------------------------\n\n// pills\n\n.nav-sidebar {\n  .nav-pills {\n    --#{$prefix}nav-pills-border-radius: #{$border-radius};\n    --#{$prefix}nav-pills-link-active-color: #{$dark-gray-700};\n\n    .nav-link {\n      background: transparent;\n    }\n\n    .nav-link-accordion {\n      &::before {\n        content: none;\n      }\n    }\n\n    .nav-item + .nav-item,\n    .nav-link-accordion + div {\n      margin-top: toRem(2px);\n    }\n\n    &.nav.flex-column {\n      .nav-link {\n        padding: toRem(5px) toRem(15px);\n      }\n\n      // 2nd level nav\n      .flex-column {\n        .nav-link {\n          padding-left: toRem(36px);\n        }\n\n        // 3rd level nav\n        .flex-column {\n          .nav-link {\n            padding-left: toRem(56px);\n          }\n        }\n      }\n\n      // with top level icon, indent 2nd and 3rd level more\n      // 2nd level nav\n      .nav-item-icon {\n        .flex-column {\n          .nav-link {\n            padding-left: toRem(64px);\n          }\n\n          // 3rd level nav\n          .flex-column {\n            .nav-link {\n              padding-left: toRem(96px);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// ----------------------------------------------\n\n// Sizes small and large\n\n.nav-sidebar-sm {\n  .nav.flex-column {\n    .nav-link {\n      font-size: toRem(13px);\n      padding-top: toRem(5px);\n      padding-bottom: toRem(5px);\n\n      .avatar:first-child {\n        margin-right: toRem(10px);\n      }\n    }\n  }\n\n  .nav-pills {\n    &.nav.flex-column {\n      .nav-link {\n        padding-top: toRem(3px);\n        padding-bottom: toRem(3px);\n      }\n    }\n  }\n\n  .user-profile {\n    padding: toRem(20px) toRem(30px);\n  }\n\n  .user-name {\n    font-size: toRem(14px);\n  }\n\n  .user-contact {\n    display: none;\n  }\n}\n\n.nav-sidebar-lg {\n  .nav.flex-column {\n    .nav-link {\n      font-size: toRem(15px);\n      padding-top: toRem(10px);\n      padding-bottom: toRem(10px);\n    }\n  }\n\n  .nav-pills {\n    &.nav.flex-column {\n      .nav-link {\n        padding-top: toRem(8px);\n        padding-bottom: toRem(8px);\n      }\n    }\n  }\n\n  .user-profile {\n    padding: toRem(30px);\n  }\n\n  .user-name {\n    font-size: toRem(16px);\n  }\n\n  .user-contact {\n    font-size: toRem(15px);\n  }\n}\n\n.dark {\n  .nav-sidebar {\n    .nav-link {\n      --#{$prefix}nav-link-hover-bg-color: #{$white};\n      --#{$prefix}nav-link-hover-color: #{$dark-gray-700};\n    }\n\n    .nav-pills {\n      --#{$prefix}nav-pills-link-active-color: #{$white};\n    }\n  }\n}\n","// navbar horizontal styles\n\n.navbar {\n  background-color: $white;\n  font-size: $nav-link-font-size;\n\n  // class selector so bootstrap doesn't extend this / so this padding won't affect non-fluid navbar containers\n  > [class*='container-fluid'] {\n    padding-left: $navbar-container-padding-x;\n    padding-right: $navbar-container-padding-x;\n  }\n\n  .nav-link,\n  .dropdown-item {\n    > span {\n      position: relative;\n\n      // underline, transparent by default\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: toRem(-5px);\n        height: toRem(1px);\n        background-color: transparent;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 100%;\n        transition: background-color 0.15s ease-in-out;\n      }\n    }\n  }\n\n  // underline nav-link and dropdown-item on hover / active\n  // and dropdowon-toggle on open\n  .nav-link.active,\n  .nav-item.show > .nav-link,\n  .dropdown-item.active {\n    > span::after {\n      background-color: $light-gray-700;\n\n      .dark & {\n        background-color: $light-gray-900;\n      }\n    }\n  }\n\n  // focus blue\n  .nav-link,\n  .dropdown-item {\n    &:focus-visible {\n      // override user agent outline\n      outline: none;\n\n      > span::after {\n        background-color: $focus-blue;\n      }\n    }\n  }\n\n  // darker underline on hover\n  .nav-link:hover,\n  .dropdown-item:hover {\n    > span::after {\n      background-color: $dark-gray-700;\n\n      .dark & {\n        background-color: $light-gray-500;\n      }\n    }\n  }\n\n  .dropdown-item {\n    background-color: transparent;\n\n    // position underline closer to text\n    > span::after {\n      bottom: 2px;\n    }\n  }\n\n  .dropdown-menu-lg {\n    .dropdown-item {\n      > span::after {\n        bottom: 6px;\n      }\n    }\n  }\n\n  .dropdown-menu {\n    border: 1px solid $light-gray-300;\n\n    .dark & {\n      border-color: $dropdown-dark-divider-bg;\n    }\n  }\n\n  // square-ish buttons within nine-dot dropdown menu\n  .dropdown-btn-item {\n    svg {\n      opacity: 0.64;\n    }\n\n    > div {\n      opacity: 0.84;\n    }\n\n    &:hover {\n      background: $light-gray-100;\n\n      svg,\n      > div {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.btn-navbar-nine-dot {\n  --btn-navbar-nine-dot-hover-bg: #{$light-gray-100};\n  --btn-navbar-nine-dot-hover-border-color: #{$dark-gray-700};\n  --btn-navbar-nine-dot-hover-color: #{$dark-gray-700};\n  --btn-navbar-nine-dot-active-bg: #{$light-gray-100};\n  --btn-navbar-nine-dot-active-border-color: #{$light-gray-700};\n\n  + .dropdown-menu {\n    width: 320px;\n\n    @media (min-width: 430px) {\n      width: 405px;\n    }\n  }\n\n  background: transparent;\n  border: 0;\n  border-bottom: 1px solid transparent !important;\n\n  svg {\n    color: inherit;\n  }\n\n  &:hover {\n    background: var(--btn-navbar-nine-dot-hover-bg);\n    border-bottom: 1px solid var(--btn-navbar-nine-dot-hover-border-color) !important;\n    color: var(--btn-navbar-nine-dot-hover-color);\n  }\n\n  &:focus-visible {\n    border-bottom-color: $focus-blue !important;\n  }\n\n  .dropdown.show > & {\n    background: var(--btn-navbar-nine-dot-active-bg);\n    border-bottom: 1px solid var(--btn-navbar-nine-dot-active-border-color) !important;\n    color: var(--btn-navbar-nine-dot-hover-color);\n\n    svg {\n      opacity: 0.9;\n    }\n  }\n\n  .dropdown:has(&) {\n    margin-left: -$navbar-container-padding-x;\n    margin-right: $navbar-container-padding-x;\n  }\n}\n\n.navbar-border {\n  border-bottom: 1px solid $light-gray-400;\n\n  .dark & {\n    border-color: $dark-gray-400;\n  }\n}\n\n.navbar-elevation {\n  box-shadow: $box-shadow-sm;\n  z-index: 2;\n\n  .dark & {\n    box-shadow: 0 toRem(9px) toRem(14px) $black;\n  }\n}\n\n// pills\n.navbar-nav {\n  &.nav-pills {\n    --#{$prefix}nav-pills-link-active-color: #{$dark-gray-700};\n    --#{$prefix}nav-pills-link-active-bg: #{$light-gray-200};\n\n    .dark & {\n      --#{$prefix}nav-pills-link-active-color: #{$white};\n    }\n\n    .nav-link {\n      padding: toRem(6px) toRem(12px);\n      border-color: transparent;\n\n      .dark & {\n        background-color: transparent;\n\n        &.active {\n          background-color: $dark-gray-600;\n        }\n\n        &:hover {\n          background-color: $white;\n        }\n      }\n    }\n\n    .nav-item + .nav-item {\n      margin-left: toRem(2px);\n    }\n  }\n}\n\n// could background or border-color be utility classes?\n// .text-bg-inverse / .dark .text-bg-inverse ?\n\n.navbar-notification {\n  background-color: $dark-gray-700;\n  color: $white;\n  border-radius: var(--bs-border-radius-pill);\n  font-size: toRem(9px);\n  line-height: divide(10, 9);\n  padding: toRem(4px) toRem(7px);\n  text-align: center;\n\n  // icon knockout border, same as navbar background color\n  &.position-absolute {\n    border: 2px solid $white;\n  }\n}\n\n.dropdown-mega-menu {\n  .nav-col-title {\n    font-size: toRem(13px);\n    line-height: divide(19, 13);\n    color: rgba($dark-gray-700, 0.92);\n  }\n\n  .nav-link {\n    padding-left: 0 !important;\n    line-height: divide(20, 14);\n  }\n}\n\n.dark {\n  .navbar {\n    --#{$prefix}navbar-color: #{rgba($white, 0.64)};\n    --#{$prefix}navbar-brand-color: #{$white};\n    --#{$prefix}navbar-brand-hover-color: #{$white};\n    --#{$prefix}navbar-active-color: #{rgba($white, 0.92)};\n    --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n    --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n\n    background-color: $dark-gray-700;\n\n    .dropdown-btn-item {\n      background: $dark-gray-600;\n\n      &:hover {\n        background: $dark-gray-500;\n      }\n    }\n  }\n\n  .btn-navbar-nine-dot {\n    --btn-navbar-nine-dot-hover-bg: #{$dark-gray-600};\n    --btn-navbar-nine-dot-hover-border-color: #{$light-gray-500};\n    --btn-navbar-nine-dot-hover-color: #{$white};\n    --btn-navbar-nine-dot-active-bg: #{$dark-gray-600};\n    --btn-navbar-nine-dot-active-border-color: #{$light-gray-900};\n  }\n\n  .navbar-notification {\n    background-color: $light-gray-300;\n    color: $dark-gray-700;\n\n    // icon knockout border, same as navbar background color\n    &.position-absolute {\n      border-color: $dark-gray-600;\n    }\n  }\n\n  .dropdown-mega-menu {\n    .nav-col-title {\n      color: $white;\n    }\n  }\n}\n\n.navbar-brand img {\n  max-height: 62px;\n}\n\n// ----------------------------------------------\n\n// Sizes\n\n.navbar-sm {\n  --#{$prefix}navbar-nav-link-padding-x: #{toRem(7.5px)};\n  font-size: toRem(13px);\n\n  .nav-link {\n    --#{$prefix}nav-link-font-size: #{toRem(13px)};\n  }\n\n  .navbar-brand img {\n    max-height: 54px;\n  }\n\n  // should this be .navbar-notification-sm instead of nested?\n  .navbar-notification {\n    padding: toRem(2px) toRem(5px);\n  }\n}\n\n.navbar-lg {\n  --#{$prefix}navbar-padding-y: #{toRem(11px)};\n  --#{$prefix}navbar-nav-link-padding-x: #{toRem(12.5px)};\n  font-size: toRem(15px);\n\n  .nav-link {\n    --#{$prefix}nav-link-font-size: #{toRem(15px)};\n  }\n\n  .navbar-brand img {\n    max-height: 66px;\n  }\n}\n\n// ----------------------------------------------\n\n// no border or box-shadow on navbar dropdown-menu below the expand-* breakpoint\n\n@mixin navbar-dropdown($breakpoint) {\n  .navbar-expand-#{$breakpoint} {\n    .dropdown-menu {\n      @include media-breakpoint-up($breakpoint) {\n        left: var(--#{$prefix}navbar-nav-link-padding-x);\n      }\n\n      @include media-breakpoint-down($breakpoint) {\n        border: none;\n        box-shadow: none;\n      }\n    }\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include navbar-dropdown($breakpoint);\n}\n\n// ----------------------------------------------\n\n.navbar-secondary {\n  padding: 0 toRem(10px);\n\n  --#{$prefix}navbar-nav-link-padding-x: #{toRem(10px)};\n\n  .navbar-nav {\n    --#{$prefix}nav-link-padding-y: #{toRem(10px)};\n  }\n\n  &.navbar-sm {\n    .navbar-nav {\n      --#{$prefix}nav-link-padding-y: #{toRem(7px)};\n    }\n  }\n\n  &.navbar-elevation {\n    z-index: 1;\n  }\n\n  + .navbar-tabs {\n    padding: 0 toRem(5px);\n  }\n}\n\n.navbar-tabs {\n  --#{$prefix}navbar-nav-link-padding-x: #{toRem(15px)};\n\n  padding: 0;\n\n  .nav-item {\n    position: relative;\n\n    .nav-link {\n      > span {\n        position: unset;\n\n        &::after {\n          bottom: 0;\n        }\n      }\n    }\n  }\n}\n",".progress {\n  --#{$prefix}progress-bg: var(--progress-bg);\n  --#{$prefix}progress-bar-bg: var(--progress-bar-bg);\n}\n\n.progress-dark {\n  --#{$prefix}progress-bg: var(--progress-dark-bg);\n  --#{$prefix}progress-bar-bg: var(--progress-dark-bar-bg);\n}\n\n.progress-brand {\n  --#{$prefix}progress-bg: var(--progress-brand-bg);\n  --#{$prefix}progress-bar-bg: var(--progress-brand-bar-bg);\n}\n\n@include light-mode() {\n  --progress-bg: #{$light-gray-300};\n  --progress-bar-bg: #{$dark-gray-50};\n  --progress-dark-bg: #{$light-gray-600};\n  --progress-dark-bar-bg: #{$dark-gray-900};\n  --progress-brand-bg: #{$light-gray-300};\n  --progress-brand-bar-bg: #{$bp-green-800};\n}\n\n@include dark-mode() {\n  --progress-bg: #{$dark-gray-300};\n  --progress-bar-bg: #{$light-gray-800};\n  --progress-dark-bg: #{$dark-gray-100};\n  --progress-dark-bar-bg: #{$light-gray-50};\n  --progress-brand-bg: #{$dark-gray-400};\n  --progress-brand-bar-bg: #{$bp-bright-green-500};\n}\n",".offcanvas {\n  // spacing between close button and outside of offcanvas\n  --#{$prefix}offcanvas-close-margin-x: #{toRem(10px)};\n  --#{$prefix}offcanvas-close-margin-calc: calc(\n    -1 * var(--#{$prefix}offcanvas-padding-x) + var(--#{$prefix}offcanvas-close-margin-x)\n  );\n\n  .btn-close-inline {\n    margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));\n    margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));\n  }\n}\n\n.offcanvas-shadow {\n  border: 0 !important;\n\n  &.offcanvas-start {\n    box-shadow: 5px 0 20px 0 rgba($dark-gray-600, 0.14);\n  }\n\n  &.offcanvas-end {\n    box-shadow: -5px 0 20px 0 rgba($dark-gray-600, 0.14);\n  }\n\n  &.offcanvas-top {\n    box-shadow: 0 10px 20px 0 rgba($dark-gray-600, 0.08);\n  }\n\n  &.offcanvas-bottom {\n    box-shadow: 0 -10px 20px 0 rgba($dark-gray-600, 0.08);\n  }\n}\n\n.offcanvas-header {\n  border-bottom: 1px solid var(--#{$prefix}offcanvas-border-color);\n\n  .btn-close-inline {\n    margin-right: var(--#{$prefix}offcanvas-close-margin-calc);\n  }\n\n  &.flex-row-reverse {\n    .btn-close-inline {\n      margin-left: var(--#{$prefix}offcanvas-close-margin-calc);\n    }\n  }\n}\n\n.offcanvas-header-shadow {\n  box-shadow: 0 10px 20px 0 rgba($dark-gray-600, 0.08);\n}\n\n.offcanvas-title {\n  font-size: toRem(16px);\n}\n\n// Panel\n.btn-panel-xs {\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-padding-x: #{toRem(10px)};\n  --#{$prefix}btn-padding-y: #{toRem(14px)};\n\n  .btn-label {\n    font-size: toRem(12px);\n    line-height: divide(21, 12);\n    color: rgba($dark-gray-700, 0.64);\n  }\n\n  &:focus-visible {\n    border-color: $electric-blue !important;\n  }\n\n  &.active,\n  &:focus-visible {\n    svg {\n      opacity: 1 !important;\n    }\n  }\n\n  &.active .btn-label {\n    color: $dark-gray-900;\n  }\n\n  &:focus-visible .btn-label {\n    color: $dark-gray-700;\n  }\n\n  &:hover {\n    svg {\n      opacity: 0.7 !important;\n    }\n\n    .btn-label {\n      color: rgba($dark-gray-700, 0.84);\n    }\n  }\n\n  &.disabled,\n  &:disabled {\n    border-color: transparent;\n    opacity: 1; // button opacity is set to 0.5 by default on disabled buttons, need to reset to 1 so it doesn't affect children.\n\n    svg {\n      opacity: 0.4 !important;\n    }\n\n    .btn-label {\n      color: rgba($dark-gray-700, 0.5);\n    }\n  }\n}\n\n.offcanvas-end {\n  .btn-panel-xs {\n    &:not(:disabled):hover {\n      border-left-color: rgba($dark-gray-900, 0.52);\n    }\n\n    &.active {\n      border-left-color: $dark-gray-900;\n    }\n  }\n}\n\n.offcanvas-start {\n  .btn-panel-xs {\n    &:not(:disabled):hover {\n      border-right-color: rgba($dark-gray-900, 0.52);\n    }\n\n    &.active {\n      border-right-color: $dark-gray-900;\n    }\n  }\n}\n\n.offcanvas-panel-xs {\n  --#{$prefix}offcanvas-width: #{$panel-horizontal-width-xs};\n  --#{$prefix}offcanvas-padding-y: #{$panel-padding-y-xs};\n  --#{$prefix}offcanvas-padding-x: #{$panel-padding-x-xs};\n}\n\n.offcanvas-panel-sm {\n  --#{$prefix}offcanvas-width: #{$panel-horizontal-width-sm};\n  --#{$prefix}offcanvas-padding-y: #{$panel-padding-y-sm};\n  --#{$prefix}offcanvas-padding-x: #{$panel-padding-x-sm};\n\n  .offcanvas-title {\n    font-size: toRem(13px);\n    line-height: divide(22, 13);\n  }\n}\n\n.offcanvas-panel-lg {\n  --#{$prefix}offcanvas-width: #{$panel-horizontal-width-lg};\n  --#{$prefix}offcanvas-padding-y: #{$panel-padding-y-lg};\n  --#{$prefix}offcanvas-padding-x: #{$panel-padding-x-lg};\n\n  .offcanvas-title {\n    font-size: toRem(18px);\n    line-height: divide(32, 18);\n  }\n}\n\n.offcanvas-panel-xl {\n  --#{$prefix}offcanvas-width: #{$panel-horizontal-width-xl};\n  --#{$prefix}offcanvas-padding-y: #{$panel-padding-y-xl};\n  --#{$prefix}offcanvas-padding-x: #{$panel-padding-x-xl};\n  --#{$prefix}offcanvas-close-margin-x: #{toRem(15px)};\n\n  .offcanvas-title {\n    font-size: toRem(20px);\n    line-height: divide(30, 20);\n  }\n}\n\n// ------------------------------------------------------\n\n// Trays\n.offcanvas-tray {\n  --#{$prefix}offcanvas-height: 72px;\n}\n\n// ------------------------------------------------------\n\n.dark {\n  .offcanvas {\n    --#{$prefix}offcanvas-border-color: #{$dark-gray-400};\n    --#{$prefix}offcanvas-bg: #{$dark-gray-700};\n  }\n\n  .offcanvas-shadow {\n    &.offcanvas-start {\n      box-shadow: 15px 0 16px 0 $dark-gray-900;\n    }\n\n    &.offcanvas-end {\n      box-shadow: -15px 0 -16px 0 $dark-gray-900;\n    }\n\n    &.offcanvas-top {\n      box-shadow: 0 10px 20px 0 rgba($dark-gray-900, 0.5);\n    }\n\n    &.offcanvas-bottom {\n      box-shadow: 0 -10px 20px 0 rgba($dark-gray-900, 0.5);\n    }\n  }\n\n  .offcanvas-backdrop {\n    background-color: $dark-gray-700;\n  }\n\n  // Panel\n\n  .btn-panel-xs {\n    svg {\n      color: $white;\n      opacity: 0.64;\n    }\n\n    .btn-label {\n      color: rgba($white, 0.84);\n    }\n\n    &.active .btn-label {\n      color: $white;\n    }\n\n    &:focus-visible .btn-label {\n      color: rgba($white, 0.92);\n    }\n\n    &.disabled,\n    &:disabled {\n      .btn-label {\n        color: rgba($white, 0.4);\n      }\n    }\n  }\n\n  .offcanvas-end {\n    .btn-panel-xs {\n      &:not(:disabled):hover {\n        border-left-color: rgba($white, 0.64);\n      }\n\n      &.btn.active {\n        border-left-color: $white;\n      }\n    }\n  }\n\n  .offcanvas-start {\n    .btn-panel-xs {\n      &:not(:disabled):hover {\n        border-right-color: rgba($white, 0.64);\n      }\n\n      &.btn.active {\n        border-right-color: $white;\n      }\n    }\n  }\n}\n","@mixin range-size($sliderHeight, $handleSize) {\n  --range-slider-handle-size: $handleSize;\n  height: $handleSize;\n  margin-left: calc(16px - $handleSize / 2);\n  margin-right: calc(16px - $handleSize / 2);\n\n  .range-slider-track {\n    height: $sliderHeight;\n\n    &:not(:first-of-type) {\n      margin-left: calc($handleSize / 2);\n      margin-right: calc($handleSize / 2);\n    }\n\n    &:first-of-type {\n      margin-left: calc($handleSize / 2);\n    }\n  }\n  .range-slider-track-connect {\n    margin-right: calc($handleSize / 2);\n  }\n\n  .range-slider-handle {\n    width: $handleSize;\n    height: $handleSize;\n  }\n\n  .range-slider-marker {\n    height: $sliderHeight;\n    margin-left: calc($handleSize / 2);\n  }\n}\n\n.range-slider {\n  --range-slider-bg: #{$light-gray-300};\n  --range-slider-connect-bg: #{$dark-gray-50};\n  --range-slider-handle-bg: #{$white};\n  --range-slider-disabled-bg: #{$light-gray-300};\n  --range-slider-disabled-connect-bg: #{$light-gray-500};\n  --range-slider-disabled-handle-bg: #{$light-gray-400};\n  --range-slider-marker-bg: #{$light-gray-600};\n  --range-slider-marker-end-bg: #{$light-gray-700};\n  --range-slider-value-color: #{rgba($dark-gray-700, 0.7)};\n  --range-slider-tooltip-bg: #{$tooltip-bg-light};\n  --range-slider-tooltip-color: #{$dark-gray-700};\n\n  display: flex;\n  align-items: center;\n  @include range-size(5px, 21px);\n}\n\n.range-slider.disabled {\n  .range-slider-track {\n    background: var(--range-slider-disabled-bg);\n  }\n\n  .range-slider-track-connect {\n    background: var(--range-slider-disabled-connect-bg);\n  }\n\n  .range-slider-handle {\n    background: var(--range-slider-disabled-handle-bg);\n    box-shadow: none;\n\n    &:hover {\n      transform: none;\n    }\n  }\n}\n\n// Sizes\n\n.range-slider-xs {\n  @include range-size(1px, 13px);\n}\n\n.range-slider-sm {\n  @include range-size(3px, 15px);\n}\n\n// default is md / 5px, 21px\n\n.range-slider-lg {\n  @include range-size(8px, 24px);\n}\n\n.range-slider-xl {\n  @include range-size(12px, 32px);\n}\n\n.range-slider-xs,\n.range-slider-md {\n  .range-slider-handle {\n    &:hover,\n    &:active {\n      transform: scale(1.2);\n    }\n  }\n}\n\n.range-slider-handle {\n  background: var(--range-slider-handle-bg);\n  transition: transform 200ms, left 100ms;\n  box-shadow: 0 toRem(4px) toRem(10px) 0 rgba($dark-gray-600, 0.2);\n  border: none;\n  border-radius: 50%;\n  cursor: grab;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:focus-visible {\n    box-shadow: 0 0 6px 0 $electric-blue;\n    border: solid 1px $electric-blue;\n  }\n\n  &:active {\n    cursor: grabbing;\n    transition: none;\n  }\n\n  &::before,\n  &::after {\n    content: none;\n  }\n\n  &:hover,\n  &:active {\n    transform: scale(1.0625);\n  }\n}\n\n.range-slider-tooltip {\n  position: absolute;\n  border: none;\n  border-radius: 3px;\n  text-align: center;\n  left: 50%;\n  transform: translate(-50%, 0);\n  bottom: 150%;\n  opacity: 0;\n  transition: opacity 200ms;\n  background: var(--range-slider-tooltip-bg);\n  color: var(--range-slider-tooltip-color);\n  box-shadow: $box-shadow;\n  font-size: toRem(12px);\n  padding: toRem(6px) toRem(16px);\n  letter-spacing: 0.3px;\n\n  .range-slider-handle:hover &,\n  .range-slider-handle:active &,\n  .range-slider-handle:focus-visible & {\n    opacity: 1;\n  }\n\n  // arrow\n  &::before {\n    content: '';\n    position: absolute;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n    border-color: transparent;\n    border-style: solid;\n    top: 100%;\n    margin-top: -1px;\n    left: 50%;\n    transform: translateX(-50%);\n    border-width: $tooltip-arrow-height ($tooltip-arrow-width * 0.5) 0;\n    border-top-color: var(--range-slider-tooltip-bg);\n  }\n}\n\n.range-slider-light {\n  .range-slider-handle:focus-visible {\n    border-color: rgba(48, 79, 254, 0.7);\n  }\n}\n\n.range-slider-tooltip-dark {\n  --range-slider-tooltip-bg: #{$tooltip-bg};\n  --range-slider-tooltip-color: #{$white};\n}\n\n.range-slider-track {\n  background: var(--range-slider-bg);\n  transition: left 100ms, right 100ms;\n}\n\n.range-slider-is-dragging {\n  transition: none !important;\n}\n\n.range-slider-track-connect {\n  background: var(--range-slider-connect-bg);\n  z-index: 1;\n}\n\n.range-slider-track-rounded {\n  border-radius: 50rem;\n}\n\n.range-slider-value {\n  font-size: toRem(13px);\n  letter-spacing: 0.2px;\n  color: var(--range-slider-value-color);\n  opacity: 0.64;\n}\n\n.range-slider-marker {\n  background: var(--range-slider-marker-bg);\n  width: 1px;\n\n  &:first-child {\n    width: 100px !important;\n  }\n}\n\n.range-slider .range-slider-marker:first-of-type,\n.range-slider .range-slider-marker:last-of-type {\n  background: var(--range-slider-marker-end-bg);\n}\n\n// dark\n.range-slider-dark {\n  --range-slider-bg: #{$light-gray-600};\n  --range-slider-connect-bg: #{#000};\n  --range-slider-handle-bg: #{$dark-gray-500};\n  --range-slider-disabled-bg: #{$light-gray-500};\n  --range-slider-disabled-connect-bg: #{$light-gray-700};\n  --range-slider-disabled-handle-bg: #{$light-gray-800};\n  --range-slider-marker-bg: #{$light-gray-900};\n\n  &.range-slider-xs {\n    --range-slider-marker-end-bg: #{$dark-gray-200};\n    --range-slider-marker-bg: #{$dark-gray-300};\n  }\n}\n\n// brand\n.range-slider-brand {\n  --range-slider-handle-bg: #{$bp-green-800};\n  --range-slider-disabled-handle-bg: #{$dark-gray-100};\n}\n\n// brand-light\n.range-slider-brand-light {\n  --range-slider-connect-bg: #{$bp-green-800};\n  --range-slider-handle-bg: #{$bp-green-500};\n  --range-slider-disabled-connect-bg: #{$dark-gray-100};\n  --range-slider-disabled-handle-bg: #{$light-gray-500};\n}\n\n// dark mode\n.dark {\n  .range-slider {\n    --range-slider-bg: #{$dark-gray-300};\n    --range-slider-connect-bg: #{$light-gray-800};\n    --range-slider-handle-bg: #{$dark-gray-500};\n    --range-slider-disabled-bg: #{$dark-gray-400};\n    --range-slider-disabled-connect-bg: #{$dark-gray-300};\n    --range-slider-disabled-handle-bg: #{$dark-gray-300};\n    --range-slider-marker-bg: #{$dark-gray-100};\n    --range-slider-marker-end-bg: #{$dark-gray-100};\n    --range-slider-value-color: #{rgba($white, 0.7)};\n\n    --range-slider-tooltip-bg: #{$tooltip-bg};\n    --range-slider-tooltip-color: #{$white};\n  }\n\n  .range-slider-tooltip-dark {\n    --range-slider-tooltip-bg: #{$tooltip-bg-light};\n    --range-slider-tooltip-color: #{$dark-gray-700};\n  }\n\n  .range-slider-dark {\n    --range-slider-bg: #{$dark-gray-100};\n    --range-slider-connect-bg: #{$light-gray-50};\n    --range-slider-disabled-bg: #{$dark-gray-300};\n    --range-slider-disabled-connect-bg: #{$dark-gray-200};\n    --range-slider-disabled-handle-bg: #{$dark-gray-50};\n    --range-slider-handle-bg: #{$light-gray-300};\n    --range-slider-marker-bg: #{$light-gray-600};\n    --range-slider-marker-end-bg: #{$light-gray-700};\n\n    &.range-slider-xs {\n      --range-slider-marker-bg: #{$light-gray-600};\n    }\n  }\n\n  .range-slider-brand {\n    --range-slider-bg: #{$dark-gray-400};\n    --range-slider-handle-bg: #{$bp-bright-green-500};\n    --range-slider-disabled-bg: #{$dark-gray-400};\n    --range-slider-disabled-handle-bg: #{$dark-gray-300};\n    --range-slider-marker-bg: #{$dark-gray-100};\n  }\n\n  .range-slider-brand-light {\n    --range-slider-bg: #{$dark-gray-400};\n    --range-slider-connect-bg: #{$bp-bright-green-500};\n    --range-slider-handle-bg: #9fe300;\n    --range-slider-disabled-connect-bg: #{$dark-gray-300};\n    --range-slider-disabled-handle-bg: #{$dark-gray-100};\n    --range-slider-marker-bg: #{$dark-gray-100};\n    --range-slider-disabled-bg: #{$dark-gray-300};\n  }\n\n  .range-slider-xs {\n    --range-slider-marker-end-bg: #{$light-gray-700};\n    --range-slider-marker-bg: #{$light-gray-800};\n  }\n\n  .range-slider-light {\n    .range-slider-handle:focus-visible {\n      border-color: $electric-blue;\n    }\n  }\n}\n",".form-label {\n  line-height: divide(21, 14);\n}\n\n.col-form-label {\n  font-size: $form-label-font-size;\n}\n\n.label-optional {\n  &::after {\n    opacity: 0.64;\n    content: 'optional';\n    font-size: toRem(12px);\n    margin-left: toRem(8px);\n    letter-spacing: 0.3px;\n  }\n}\n\n.label-info {\n  text-decoration: none;\n  margin-left: auto;\n  margin-bottom: $form-label-margin-bottom;\n  font-size: toRem(11px);\n  line-height: divide(21, 11);\n}\n","// Form help text\n// https://getbootstrap.com/docs/5.3/forms/overview/#form-text\n\n.form-text,\n.invalid-feedback,\n.valid-feedback {\n  letter-spacing: 0.5px;\n}\n\n.dark {\n  .valid-feedback {\n    color: $validation-success-text-dark;\n  }\n\n  .invalid-feedback {\n    color: $validation-danger-text-dark;\n  }\n}\n",".form-control {\n  height: $input-height; // input group merge icons height is wrong without setting height\n\n  &:not(:disabled):hover {\n    border-color: $input-hover-border-color;\n  }\n\n  &:focus {\n    border-color: $input-focus-border-color;\n    box-shadow: none !important;\n  }\n\n  &:focus-visible {\n    border-color: $focus-blue !important;\n    outline: 0;\n  }\n\n  &:disabled,\n  &[readonly] {\n    &::placeholder {\n      color: $input-disabled-placeholder-color;\n    }\n  }\n\n  // Hide password reveal control in Edge browser, use <PasswordToggle /> component instead\n  // https://learn.microsoft.com/en-us/microsoft-edge/web-platform/password-reveal#remove-the-password-reveal-control\n  &::-ms-reveal {\n    display: none;\n  }\n}\n\n.form-control,\n.form-select {\n  letter-spacing: $input-letter-spacing;\n  line-height: divide(24, 14);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  line-height: divide(24, 15); // for multi-line text area\n}\n\n.form-control-sm {\n  height: $input-height-sm;\n  line-height: divide(24, 13); // for multi-line text area\n}\n\ntextarea {\n  &.form-control {\n    height: auto;\n    min-height: $input-height;\n  }\n}\n\n// character counter\n// src/reactstrap/form-controls/input-max.js\ninput,\ntextarea {\n  + .input-length {\n    font-size: $form-text-font-size;\n    letter-spacing: 0.5px;\n    margin-top: toRem(8px);\n    text-align: right;\n  }\n}\n\n// ---------------------------------------------------------\n\n.dark {\n  .form-control,\n  .form-select {\n    color: $white;\n    caret-color: $white;\n    border-color: $dark-gray-400;\n\n    &:focus {\n      border-color: $light-gray-800;\n    }\n\n    &::placeholder {\n      color: rgba($white, 0.6);\n    }\n  }\n\n  .form-control {\n    &:disabled,\n    &[readonly] {\n      color: rgba($white, 0.5);\n      background-color: $input-dark-disabled-bg;\n      border-color: $dark-gray-400;\n\n      &::placeholder {\n        color: rgba($white, 0.4);\n      }\n    }\n  }\n\n  .input-group-text {\n    color: rgba($white, 0.64);\n    border-color: $dark-gray-400;\n    background-color: $dark-gray-600;\n  }\n}\n","// Select\n//\n// Replaces the browser default select with a custom one\n\n.form-select {\n  &:not([multiple]) {\n    height: $input-height;\n  }\n\n  &[multiple] {\n    padding: 0;\n\n    option {\n      padding: 11px $form-select-padding-x;\n    }\n  }\n\n  &:not(:disabled):hover {\n    border-color: $input-hover-border-color;\n  }\n\n  &:focus-visible {\n    box-shadow: none !important;\n    border-color: $focus-blue !important;\n    outline: 0;\n  }\n}\n\n.form-select-placeholder-hack {\n  &:invalid {\n    color: $input-placeholder-color;\n  }\n}\n\n.form-select-lg {\n  &:not([multiple]) {\n    height: $input-height-lg;\n    background-size: $form-select-lg-bg-size;\n    padding-right: $form-select-lg-indicator-padding;\n  }\n}\n\n.form-select-sm {\n  &:not([multiple]) {\n    height: $input-height-sm;\n  }\n}\n\n.form-select-triangle {\n  background-image: escape-svg($form-select-triangle-indicator);\n}\n\n.form-select-up-down {\n  background-image: escape-svg($form-select-up-down-indicator);\n}\n\n.dark {\n  .form-select {\n    &:not([multiple]) {\n      background-image: escape-svg($form-select-dark-indicator);\n\n      option {\n        background-color: $dark-gray-600;\n      }\n    }\n  }\n\n  .form-select-triangle {\n    background-image: escape-svg($form-select-dark-triangle) !important;\n  }\n\n  .form-select-up-down {\n    background-image: escape-svg($form-select-dark-up-down) !important;\n  }\n\n  .form-select-placeholder-hack {\n    &:invalid {\n      color: rgba($white, 0.6);\n    }\n  }\n}\n",".form-check-input {\n  cursor: $form-check-label-cursor;\n  margin-top: 1px;\n\n  &:focus-visible {\n    border-color: $form-check-input-focus-border !important;\n    outline: none;\n  }\n\n  &:not(:checked):focus {\n    border: $form-check-input-border;\n  }\n\n  &:not(:disabled):hover {\n    border-color: $form-check-input-border-color-hover;\n\n    ~ .form-check-label {\n      color: $dark-gray-700;\n    }\n  }\n\n  &:disabled {\n    background-color: $form-check-input-disabled-bg-color;\n    border-color: transparent;\n    pointer-events: all;\n    cursor: not-allowed;\n\n    ~ .form-check-label {\n      cursor: not-allowed;\n    }\n  }\n\n  // radio\n\n  &[type='radio'] {\n    &:disabled:checked {\n      background-image: escape-svg(radio-icon($light-gray-800));\n    }\n\n    &:not(:disabled):checked {\n      &:hover {\n        background-image: escape-svg(radio-icon($dark-gray-700));\n      }\n    }\n  }\n}\n\n.form-check:not(.form-switch) {\n  .form-check-input {\n    // check and radio bg icon appears smaller in bootstrap v5 than in v4\n    background-size: 110%;\n\n    // CSS var to avoid duplicating long selector\n    // set var on .form-check for default, dark, alt, and dark alt\n    &[type='checkbox'] {\n      &:not(:disabled):checked:hover {\n        background-image: var(--form-check-input-checked-hover-bg-image);\n      }\n    }\n  }\n}\n\n.form-check-label {\n  font-size: toRem(14px);\n  letter-spacing: 0.05px;\n  margin-bottom: 0;\n}\n\n.form-check-comfortable {\n  margin-bottom: toRem(19px);\n}\n\n.form-check {\n  --form-check-input-checked-hover-bg-image: #{escape-svg(check-icon($dark-gray-700))};\n\n  min-height: $form-check-input-width;\n  line-height: $form-check-input-width;\n\n  .form-check-input {\n    &:focus-visible {\n      box-shadow: none;\n    }\n\n    &:disabled {\n      ~ .form-check-label {\n        color: $dark-gray-700;\n      }\n    }\n\n    @include form-validation-state-selector('valid') {\n      border-color: $validation-success-fill-light;\n\n      &:focus {\n        box-shadow: none;\n      }\n\n      ~ .form-check-label {\n        color: $form-check-label-color;\n      }\n\n      &:hover {\n        ~ .form-check-label {\n          color: $dark-gray-700;\n        }\n      }\n\n      &:checked {\n        // checked checks and radios\n        background-color: $form-check-input-bg;\n        border-color: $validation-success-fill-light;\n\n        &[type='checkbox'] {\n          background-image: escape-svg($form-feedback-icon-valid);\n        }\n\n        &:hover {\n          --form-check-input-checked-hover-bg-image: #{escape-svg($form-feedback-icon-valid)};\n        }\n      }\n    }\n\n    // invalid check - red on white background\n    @include form-validation-state-selector('invalid') {\n      border-color: $validation-danger-fill-light;\n\n      &:focus {\n        box-shadow: none;\n      }\n\n      ~ .form-check-label {\n        color: $form-check-label-color;\n      }\n\n      &:hover {\n        ~ .form-check-label {\n          color: $dark-gray-700;\n        }\n      }\n\n      &:checked {\n        background-color: $form-check-input-bg;\n\n        &[type='checkbox'] {\n          background-image: escape-svg($form-feedback-icon-invalid-check);\n        }\n\n        &:hover {\n          --form-check-input-checked-hover-bg-image: #{escape-svg($form-feedback-icon-invalid-check)};\n        }\n      }\n    }\n  }\n}\n\n// nested for checks under indeterminate check\n\n.nested-checks {\n  list-style: none;\n  padding-left: 0;\n\n  ul {\n    list-style: none;\n    padding-left: $form-check-input-width + toRem(8px);\n  }\n\n  li .form-check {\n    margin-bottom: toRem(21px);\n  }\n\n  // first / top level item\n  > li > .form-check {\n    margin-bottom: toRem(21px);\n  }\n}\n\n.nested-checks-lg {\n  ul {\n    padding-left: $form-check-input-width-lg + toRem(8px);\n  }\n\n  li .form-check {\n    margin-bottom: toRem(20px);\n  }\n\n  // first / top level item\n  > li > .form-check {\n    margin-bottom: toRem(24px);\n  }\n}\n\n// Reverse / right aligned check, radio and switch / list\n// https://getbootstrap.com/docs/5.3/forms/checks-radios/#reverse\n\n.form-check-reverse {\n  text-align: left; // override bootstrap\n\n  // for a larger click area between label text and input\n  .form-check-label {\n    width: 100%;\n  }\n}\n\n// Switches\n\n.form-switch {\n  .form-check-input {\n    border-color: transparent;\n    background-color: $form-switch-bg-color;\n\n    &:checked {\n      background-color: $form-switch-checked-bg;\n    }\n\n    &:not(:disabled):checked:hover {\n      background-color: $dark-gray-800;\n    }\n\n    &:not(:checked):not(:disabled):hover {\n      background-color: $form-switch-hover-bg;\n      border-color: $form-switch-hover-bg;\n    }\n\n    &:focus {\n      background-image: escape-svg($form-switch-bg-image);\n    }\n\n    &:disabled {\n      background-color: $form-switch-disabled-bg;\n      background-image: escape-svg(switch-icon($light-gray-200));\n    }\n\n    &:disabled:checked {\n      background-color: $light-gray-600;\n      background-image: escape-svg(switch-icon($light-gray-400));\n    }\n\n    &:not(:checked):focus-visible {\n      background-image: escape-svg($form-switch-focus-bg-image);\n    }\n\n    &:checked:not(:disabled):focus-visible {\n      border: 1px solid transparent;\n      box-shadow: 0 0 1px 3px rgba(48, 79, 254, 0.3);\n    }\n  }\n}\n\n.dark {\n  .form-check {\n    --form-check-input-checked-hover-bg-image: #{escape-svg(check-icon($light-gray-50))};\n  }\n\n  .form-check-input {\n    background-color: $dark-gray-700;\n    border-color: $dark-gray-200;\n\n    &:not(:disabled):checked {\n      background-color: $dark-gray-700;\n      border-color: $dark-gray-200;\n      background-image: escape-svg(check-icon($light-gray-400));\n    }\n\n    &[type='checkbox'] {\n      &:indeterminate {\n        background-color: $dark-gray-700;\n        border-color: $dark-gray-200;\n        background-image: escape-svg(indeterminate-icon($light-gray-400));\n      }\n    }\n\n    &:disabled {\n      border-color: transparent;\n      background-color: $dark-gray-500;\n\n      &:checked[type='checkbox'] {\n        background-image: escape-svg(check-icon($light-gray-900));\n      }\n\n      ~ .form-check-label {\n        opacity: 0.4;\n        color: $white;\n      }\n    }\n\n    &:not(:checked):focus {\n      border-color: $dark-gray-200;\n    }\n\n    &:not(:disabled):hover {\n      border-color: $light-gray-50;\n\n      ~ .form-check-label {\n        color: $white;\n      }\n    }\n\n    @include form-validation-state-selector('valid') {\n      border-color: $success;\n\n      ~ .form-check-label {\n        color: rgba($white, 0.84);\n      }\n\n      &:checked,\n      &:checked:not(:disabled):hover {\n        border-color: $success;\n        background-color: $dark-gray-700;\n\n        &[type='checkbox'] {\n          background-image: escape-svg(check-icon($success));\n        }\n      }\n\n      &:not(:checked):hover,\n      &:not(:checked):focus {\n        border-color: $success;\n      }\n    }\n\n    @include form-validation-state-selector('invalid') {\n      border-color: $danger;\n      background-color: $dark-gray-700;\n\n      ~ .form-check-label {\n        color: rgba($white, 0.84);\n      }\n\n      &:checked,\n      &:checked:not(:disabled):hover {\n        border-color: $danger;\n        background-color: $dark-gray-700;\n\n        &[type='checkbox'] {\n          background-image: escape-svg(check-icon($danger));\n        }\n      }\n\n      &:not(:checked):hover,\n      &:not(:checked):focus {\n        border-color: $danger;\n      }\n    }\n\n    &[type='radio'] {\n      &:not(:disabled):hover {\n        border-color: $light-gray-50;\n      }\n\n      &:not(:disabled):checked {\n        background-image: escape-svg(radio-icon($light-gray-400));\n\n        &:hover {\n          background-image: escape-svg(radio-icon($light-gray-50));\n        }\n      }\n\n      &:disabled {\n        border-color: transparent;\n      }\n\n      &:disabled:checked {\n        background-image: escape-svg(radio-icon($light-gray-900));\n      }\n    }\n  }\n\n  // There is no dark mode for default switch. Use alt switch in order to have light and dark mode\n\n  .form-switch {\n    .form-check-input {\n      border-color: $light-gray-600;\n      background-color: $dark-gray-600;\n      background-image: escape-svg(switch-icon($light-gray-500));\n\n      &:not(:disabled):hover {\n        border-color: $white;\n        background-color: $dark-gray-600;\n        background-image: escape-svg(switch-icon($light-gray-300));\n      }\n\n      &:not(:checked):focus {\n        border-color: $light-gray-600;\n      }\n\n      &:not(:disabled):not(:checked):focus-visible {\n        background-image: escape-svg(\n          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-9 -9 18 18'><circle r='7' fill='#{$light-gray-500}' stroke='#{$focus-blue}' stroke-width='0.6' style='filter: drop-shadow(0px 2px 1px rgb(17 17 17 / 0.18))' /></svg>\")\n        );\n      }\n\n      &:not(:checked):disabled {\n        border-color: $dark-gray-200;\n        background-color: $dark-gray-600;\n        background-image: escape-svg(switch-icon($dark-gray-200));\n      }\n\n      &:checked:disabled {\n        border-color: $dark-gray-200;\n        background-color: $dark-gray-200;\n        background-image: escape-svg(switch-icon($dark-gray-600));\n      }\n\n      &:not(:disabled):checked {\n        border-color: $light-gray-300;\n        background-color: $light-gray-300;\n        background-image: escape-svg(switch-icon($dark-gray-600));\n\n        &:hover {\n          border-color: $white;\n          background-color: $white;\n          background-image: escape-svg(switch-icon($dark-gray-600));\n        }\n\n        &:focus-visible {\n          box-shadow: 0 0 1px 3px rgba(48, 79, 254, 0.6);\n        }\n      }\n    }\n  }\n\n  .form-check-label {\n    color: rgba($white, 0.84);\n  }\n}\n",".form-check-lg {\n  min-height: $form-check-input-width-lg;\n  line-height: $form-check-input-width-lg;\n  padding-left: $form-check-padding-start-lg;\n  margin-bottom: toRem(16px);\n\n  &.form-check-inline {\n    margin-right: $form-check-inline-margin-end-lg;\n  }\n\n  .form-check-input {\n    width: $form-check-input-width-lg;\n    height: $form-check-input-width-lg;\n    margin-left: -$form-check-padding-start-lg;\n    margin-top: 0;\n  }\n\n  .form-check-label {\n    font-size: $form-check-font-size-lg;\n  }\n\n  &.form-check-comfortable {\n    margin-bottom: toRem(20px);\n  }\n}\n\n// Large Switch\n\n.form-switch {\n  &.form-check-lg {\n    padding-left: $form-switch-padding-start-lg;\n\n    .form-check-input {\n      width: $form-switch-width-lg;\n      margin-left: $form-switch-padding-start-lg * -1;\n    }\n  }\n}\n\n.form-check-reverse {\n  &.form-check-lg {\n    padding-left: 0;\n  }\n}\n",".form-check-alt {\n  --form-check-input-checked-hover-bg-image: #{escape-svg($form-check-input-alt-checked-bg-image)};\n\n  .form-check-input[type='checkbox'] {\n    &:checked:not(:disabled) {\n      border: $form-check-input-alt-checked-border;\n      background-color: $form-check-input-alt-checked-bg;\n      background-image: escape-svg($form-check-input-alt-checked-bg-image);\n    }\n\n    &:indeterminate {\n      background-color: $form-check-input-alt-indeterminate-bg;\n      background-image: escape-svg($form-check-input-alt-icon-indeterminate);\n      border-color: $dark-gray-500;\n    }\n\n    &:checked:disabled {\n      background-image: escape-svg(check-icon($light-gray-800));\n    }\n\n    &:checked:not(:disabled):hover {\n      background-color: $dark-gray-900;\n      border-color: $dark-gray-900;\n    }\n\n    @include form-validation-state-selector('valid') {\n      &:checked:not(:disabled) {\n        background-color: $validation-success-fill-light;\n        border-color: $validation-success-fill-light;\n\n        &[type='checkbox'] {\n          background-image: escape-svg(check-icon($white));\n        }\n      }\n    }\n\n    // invalid check - white check on red background\n    @include form-validation-state-selector('invalid') {\n      border-color: $validation-danger-fill-light;\n\n      &:checked:not(:disabled) {\n        background-color: $validation-danger-fill-light;\n        border-color: $validation-danger-fill-light;\n\n        &[type='checkbox'] {\n          background-image: escape-svg(check-icon($white));\n        }\n      }\n    }\n  }\n\n  &.form-switch {\n    .form-check-input {\n      background-color: $form-switch-alt-bg-color;\n      border: 1px solid $form-switch-alt-border-color;\n      background-image: escape-svg($form-switch-alt-bg-image);\n\n      &:checked:not(:disabled) {\n        border-color: transparent !important;\n        background-color: $dark-gray-800;\n        background-image: escape-svg($form-switch-alt-checked-bg-image);\n\n        &:hover {\n          background-color: $dark-gray-900;\n        }\n      }\n\n      &:not(:checked):not(:disabled) {\n        &:hover {\n          background-color: $form-switch-alt-bg-color;\n          background-image: escape-svg($form-switch-alt-hover-bg-image);\n          border-color: $form-switch-alt-hover-border-color;\n        }\n\n        &:focus-visible {\n          background-image: escape-svg($form-switch-alt-focus-bg-image);\n        }\n      }\n\n      &:not(:checked):disabled {\n        background-image: escape-svg($form-switch-alt-disabled-bg-image);\n        border-color: $light-gray-400;\n      }\n\n      &:disabled:checked {\n        background-color: $light-gray-300;\n        background-image: escape-svg($form-switch-alt-checked-bg-image);\n        border-color: $light-gray-300;\n      }\n    }\n  }\n}\n\n.dark {\n  .form-check-alt {\n    --form-check-input-checked-hover-bg-image: #{escape-svg(check-icon($dark-gray-700))};\n\n    .form-check-input[type='checkbox'] {\n      &:checked:not(:disabled) {\n        border-color: $light-gray-400;\n        background-color: $light-gray-400;\n        background-image: escape-svg(check-icon($dark-gray-700));\n\n        &:hover {\n          background-color: $white;\n        }\n      }\n\n      &:indeterminate {\n        background-color: $light-gray-400;\n        border-color: $light-gray-400;\n        background-image: escape-svg(indeterminate-icon($dark-gray-700));\n      }\n\n      @include form-validation-state-selector('valid') {\n        &:checked,\n        &:checked:not(:disabled):hover {\n          border-color: $success;\n          background-color: $success;\n\n          &[type='checkbox'] {\n            background-image: escape-svg(check-icon($dark-gray-700));\n          }\n        }\n      }\n\n      @include form-validation-state-selector('invalid') {\n        &:checked,\n        &:checked:not(:disabled):hover {\n          border-color: $danger;\n          background-color: $danger;\n\n          &[type='checkbox'] {\n            background-image: escape-svg(check-icon($dark-gray-700));\n          }\n        }\n      }\n    }\n\n    &.form-switch {\n      .form-check-input {\n        border-color: $light-gray-600;\n        background-color: $dark-gray-600;\n        background-image: escape-svg(switch-icon($light-gray-500));\n\n        &:not(:disabled):hover {\n          border-color: $white;\n          background-color: $dark-gray-600;\n          background-image: escape-svg(switch-icon($light-gray-300));\n\n          ~ .form-check-label {\n            color: $white;\n          }\n        }\n\n        &:not(:disabled):not(:checked):focus-visible {\n          background-image: escape-svg(\n            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-9 -9 18 18'><circle r='7' fill='#{$light-gray-500}' stroke='#{$focus-blue}' stroke-width='0.6' style='filter: drop-shadow(0px 2px 1px rgb(17 17 17 / 0.18))' /></svg>\")\n          );\n        }\n\n        &:not(:checked):disabled {\n          border-color: $dark-gray-200;\n          background-color: $dark-gray-600;\n          background-image: escape-svg(switch-icon($dark-gray-200));\n        }\n\n        &:checked:disabled {\n          border-color: $dark-gray-200;\n          background-color: $dark-gray-200;\n          background-image: escape-svg(switch-icon($dark-gray-600));\n        }\n\n        &:not(:disabled):checked {\n          border-color: $light-gray-300;\n          background-color: $light-gray-300;\n          background-image: escape-svg(switch-icon($dark-gray-600));\n\n          &:hover {\n            border-color: $white;\n            background-color: $white;\n            background-image: escape-svg(switch-icon($dark-gray-600));\n          }\n\n          &:focus-visible {\n            box-shadow: 0 0 1px 3px rgba(48, 79, 254, 0.6);\n          }\n        }\n      }\n    }\n  }\n}\n",".input-group {\n  .btn {\n    border-radius: 0;\n  }\n\n  // fixes adjacent element border overlap\n  .form-control,\n  .form-select,\n  .btn {\n    &:hover {\n      z-index: 3;\n    }\n  }\n\n  > .form-control-square {\n    text-align: center;\n    flex-grow: 0;\n    width: $input-height;\n    padding: $input-padding-y toRem(8px);\n  }\n}\n\n.input-group-text {\n  height: $input-height;\n\n  &[data-toggle] {\n    cursor: pointer;\n  }\n}\n\n.input-group-search {\n  max-width: 540px;\n  flex: 1;\n}\n\n.input-group-lg {\n  > .input-group-text,\n  > .form-control:not(textarea) {\n    height: $input-height-lg;\n  }\n\n  > .form-select {\n    @extend .form-select-lg;\n  }\n\n  > .btn {\n    // use button lg padding instead of input lg padding\n    padding: $btn-padding-y-lg $btn-padding-x-lg;\n  }\n\n  > .form-control-square {\n    width: $input-height-lg;\n  }\n}\n\n.input-group-sm {\n  > .btn {\n    padding-top: var(--#{$prefix}btn-padding-y);\n    padding-bottom: var(--#{$prefix}btn-padding-y);\n  }\n\n  > .input-group-text,\n  > .form-control:not(textarea) {\n    height: $input-height-sm;\n  }\n\n  > .form-select {\n    @extend .form-select-sm;\n    padding-right: $form-select-indicator-padding;\n  }\n\n  > .form-control-square {\n    width: $input-height-sm;\n    padding: $input-padding-y-sm toRem(6px);\n  }\n}\n\n.input-group-spinner {\n  max-width: 192px;\n}\n",".input-group.input-group-merge {\n  --#{$prefix}input-disabled-bg: #{$input-disabled-bg};\n\n  > .form-control {\n    @if ($input-border-radius > 0) {\n      border-radius: $input-border-radius;\n    }\n\n    &:not(:disabled):hover {\n      &,\n      ~ [class*='input-group'] {\n        z-index: 3;\n\n        > .input-group-text {\n          border-color: $input-hover-border-color !important;\n        }\n      }\n    }\n\n    &.is-valid {\n      &,\n      ~ [class*='input-group'] > .input-group-text {\n        border-color: var(--#{$prefix}form-valid-border-color) !important;\n      }\n    }\n\n    &.is-invalid {\n      &,\n      ~ [class*='input-group'] > .input-group-text {\n        border-color: var(--#{$prefix}form-invalid-border-color) !important;\n      }\n    }\n\n    &:not(:disabled):focus {\n      box-shadow: none;\n\n      &,\n      ~ [class*='input-group'] {\n        z-index: 5;\n\n        > .input-group-text {\n          border-color: $focus-blue !important;\n        }\n      }\n    }\n\n    ~ [class*='input-group'] > .input-group-text {\n      background-color: $input-bg;\n    }\n\n    &:disabled,\n    &[readonly] {\n      ~ [class*='input-group'] > .input-group-text {\n        background-color: var(--#{$prefix}input-disabled-bg);\n      }\n    }\n  }\n\n  > .form-control-prepended {\n    padding-left: toRem(5px);\n    border-left-width: 0;\n\n    @if ($input-border-radius > 0) {\n      border-top-left-radius: 0 !important;\n      border-bottom-left-radius: 0 !important;\n\n      &:not(.form-control-appended) {\n        border-top-right-radius: $input-border-radius !important;\n        border-bottom-right-radius: $input-border-radius !important;\n      }\n    }\n  }\n\n  > .form-control-appended:not(.is-valid):not(.is-invalid) {\n    padding-right: toRem(5px);\n  }\n\n  > .form-control-appended {\n    border-right-width: 0;\n  }\n\n  > .input-group-prepend {\n    order: -1;\n  }\n\n  > .input-group-prepend > .input-group-text {\n    padding-left: toRem(10px);\n    padding-right: toRem(5px);\n    border-right-width: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  }\n\n  > .input-group-append > .input-group-text {\n    padding-left: toRem(5px);\n    padding-right: toRem(10px);\n    border-left-width: 0;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  }\n}\n\n$input-group-sizes: (\n  'lg' $input-border-radius-lg $input-height-lg,\n  'sm' $input-border-radius-sm $input-height-sm\n);\n\n@each $size, $radius, $input-height in $input-group-sizes {\n  .input-group-#{$size}.input-group-merge {\n    @if ($radius > 0) {\n      > .form-control {\n        border-radius: $radius;\n      }\n\n      > .form-control-prepended {\n        &:not(.form-control-appended) {\n          border-top-right-radius: $radius !important;\n          border-bottom-right-radius: $radius !important;\n        }\n      }\n    }\n\n    > .input-group-prepend > .input-group-text {\n      border-top-left-radius: $radius;\n      border-bottom-left-radius: $radius;\n      height: $input-height;\n    }\n\n    > .input-group-append > .input-group-text {\n      border-top-right-radius: $radius;\n      border-bottom-right-radius: $radius;\n      height: $input-height;\n    }\n  }\n}\n\n.dark {\n  .input-group.input-group-merge {\n    --#{$prefix}input-disabled-bg: #{$input-dark-disabled-bg};\n  }\n}\n","@use 'sass:list';\n\n// Form validation\n\n.form-select {\n  @include form-validation-state-selector('valid') {\n    border-color: var(--#{$prefix}form-valid-border-color);\n  }\n\n  @include form-validation-state-selector('invalid') {\n    border-color: var(--#{$prefix}form-invalid-border-color);\n  }\n}\n\n.form-select-triangle {\n  @include form-validation-state-selector('valid') {\n    background-image: escape-svg($form-select-triangle-indicator),\n      escape-svg($form-feedback-icon-valid) !important;\n  }\n\n  @include form-validation-state-selector('invalid') {\n    background-image: escape-svg($form-select-triangle-indicator),\n      escape-svg($form-feedback-icon-invalid) !important;\n  }\n}\n\n.form-select-up-down {\n  @include form-validation-state-selector('valid') {\n    background-image: escape-svg($form-select-up-down-indicator),\n      escape-svg($form-feedback-icon-valid) !important;\n  }\n\n  @include form-validation-state-selector('invalid') {\n    background-image: escape-svg($form-select-up-down-indicator),\n      escape-svg($form-feedback-icon-invalid) !important;\n  }\n}\n\n.form-control {\n  @include form-validation-state-selector('valid') {\n    // increase size of check icon\n    background-size: $form-select-feedback-icon-size;\n    border-color: var(--#{$prefix}form-valid-border-color);\n  }\n\n  @include form-validation-state-selector('invalid') {\n    // increase size of error icon\n    background-size: $form-select-feedback-icon-size;\n    border-color: var(--#{$prefix}form-invalid-border-color);\n  }\n}\n\n.dark {\n  .form-select {\n    @include form-validation-state-selector('valid') {\n      background-image: escape-svg($form-select-dark-indicator), escape-svg(check-icon($success)) !important;\n    }\n\n    @include form-validation-state-selector('invalid') {\n      background-image: escape-svg($form-select-dark-indicator), escape-svg(warning-icon($danger)) !important;\n    }\n  }\n\n  .form-select-triangle {\n    @include form-validation-state-selector('valid') {\n      background-image: escape-svg($form-select-dark-triangle), escape-svg(check-icon($success)) !important;\n    }\n\n    @include form-validation-state-selector('invalid') {\n      background-image: escape-svg($form-select-dark-triangle), escape-svg(warning-icon($danger)) !important;\n    }\n  }\n\n  .form-select-up-down {\n    @include form-validation-state-selector('valid') {\n      background-image: escape-svg($form-select-dark-up-down), escape-svg(check-icon($success)) !important;\n    }\n\n    @include form-validation-state-selector('invalid') {\n      background-image: escape-svg($form-select-dark-up-down), escape-svg(warning-icon($danger)) !important;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector('valid') {\n      background-image: escape-svg(check-icon($success));\n    }\n\n    @include form-validation-state-selector('invalid') {\n      background-image: escape-svg(warning-icon($danger));\n    }\n  }\n}\n",".bg-footer {\n  background: $white;\n\n  .dark & {\n    background: $dark-gray-700;\n  }\n}\n","// for Splits7\n\n.anchor-grid {\n  .col-6 {\n    border: 1px solid $dark-gray-600;\n  }\n\n  // overlapping borders\n\n  // bottom row\n  .col-6:nth-child(n + 3) {\n    margin-top: -1px;\n  }\n\n  // right column\n  .col-6:nth-child(even) {\n    margin-left: -1px;\n  }\n\n  a {\n    text-decoration: none;\n  }\n}\n","// no gutters row with overlapping borders\n// for Icon Stacks 4 and 8\n\n// similar to Splits7 / _anchor-grid.scss\n\n.border-grid > div {\n  @include media-breakpoint-down(sm) {\n    + div {\n      margin-top: -1px;\n    }\n  }\n\n  @include media-breakpoint-between(sm, lg) {\n    // bottom row\n    &:nth-child(n + 3) {\n      margin-top: -1px;\n    }\n\n    // right column\n    &:nth-child(even) {\n      margin-left: -1px;\n    }\n  }\n\n  @include media-breakpoint-up(lg) {\n    + div {\n      margin-left: -1px;\n    }\n  }\n}\n",".card-tag {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-transform: uppercase;\n  padding: 0.5rem 1rem;\n  background: $white;\n  box-shadow: $box-shadow-xs;\n}\n","// SideImageCard\n\n// Cards6\n.card-body-side {\n  padding: toRem(40px) toRem(30px);\n}\n\n// Card8\n.card-body-side-sm {\n  padding: toRem(40px) toRem(26px) toRem(40px) toRem(34px);\n}\n\n// SideImageCardSmall\n.card-body-side-xs {\n  padding: toRem(20px) toRem(30px) toRem(24px) toRem(20px);\n}\n\n// for Image Stacks 6\n.card-hover-bg {\n  text-decoration: none !important;\n  transition: box-shadow 300ms, background-color 300ms;\n\n  &:hover {\n    background-color: $white;\n\n    .dark & {\n      background-color: $dark-gray-500;\n    }\n  }\n}\n\n// credit card styles for Image Stacks 7\n.image-stacks-7-cc {\n  display: flex;\n  align-items: flex-end;\n  height: 267px;\n  max-width: 427px;\n  margin: 0 auto;\n  padding: toRem(35px) toRem(30px);\n  border-radius: toRem(16px);\n  backdrop-filter: blur(15px);\n  border: 1px solid rgba($white, 0.1);\n  box-shadow: 0 toRem(8px) toRem(23px) toRem(-2px) rgba(17, 17, 17, 0.6);\n\n  h6 {\n    font-size: 7px;\n    margin-bottom: 9px;\n  }\n}\n\n.image-stacks-7-cc-number {\n  font-size: toRem(21px);\n  letter-spacing: 1.75px;\n  margin-bottom: 37px;\n}\n","// todo: remove this once it's been replaced with <Badge /> everywhere\n.heading-badge {\n  display: inline-block;\n  padding: 0.125rem 0.754rem;\n  line-height: 2;\n  letter-spacing: 1.5px;\n  font-size: toRem(11px);\n  font-weight: normal;\n  color: $dark-gray-700;\n  background-color: $light-gray-200;\n\n  .dark & {\n    background-color: $dark-gray-500;\n    color: $white;\n  }\n}\n","// could use responsive utility classes like d-xxl-flex for >= 1400px\n\n// but this is a content dependent breakpoint\n// change 1440 to the window width where content breaks\n@media (min-width: 1440px) {\n  .hero-1-nav-container {\n    display: flex;\n\n    // quote\n    > div {\n      text-align: right;\n      margin-bottom: toRem(5.6px) !important; // same as linl-border padding-bottom\n      margin-left: auto;\n      order: 2;\n    }\n  }\n}\n","// paragraph underline on image-stacks-5\n\n.line-after {\n  position: relative;\n\n  &::after {\n    content: '';\n    height: 1px;\n    width: 2.5rem;\n    background: $bp-green-800;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n  }\n}\n","// for Price Card dollar sign\n.price-card-currency {\n  position: absolute; // so price stays centered\n  font-size: toRem(24px);\n  top: toRem(8px);\n  right: 100%;\n  margin-right: 2px;\n}\n","// for FunctionalLayouts3\n\n.radio-grid {\n  > div:not(:last-child) {\n    margin-bottom: 30px;\n  }\n\n  // no margin on last two / bottom row\n  @include media-breakpoint-up(sm) {\n    > div:nth-child(n + 7) {\n      margin-bottom: 0;\n    }\n  }\n\n  // no margin on last four / bottom row\n  @include media-breakpoint-up(lg) {\n    > div:nth-child(n + 5) {\n      margin-bottom: 0;\n    }\n  }\n\n  input[type='radio'] {\n    opacity: 0;\n    position: fixed;\n    width: 0;\n  }\n\n  label {\n    display: block;\n    position: relative;\n    height: 100%;\n    padding: toRem(30px) toRem(30px) toRem(40px) toRem(30px);\n    font-weight: $font-weight-light;\n    border: 1px solid $dark-gray-600;\n    border-radius: 5px;\n    transition: border-color 300ms, box-shadow 300ms;\n  }\n\n  label:hover {\n    border-color: rgba($white, 0.8);\n    cursor: pointer;\n  }\n\n  input[type='radio']:focus + label {\n    box-shadow: 0 0px 10px 0px $focus-blue;\n  }\n\n  input[type='radio']:checked + label {\n    border-color: $white;\n\n    // check mark in corner\n    &::after {\n      content: '';\n      background: escape-svg(check-icon($white)) center no-repeat;\n      background-size: cover;\n      display: block;\n      width: 32px;\n      height: 32px;\n      position: absolute;\n      top: 10px;\n      right: 10px;\n    }\n  }\n}\n","// for Form 2\n.section-padding-xs {\n  padding: map-get($spacers, 6) 0;\n\n  @include media-breakpoint-up(sm) {\n    padding: map-get($spacers, 8) 0;\n  }\n\n  @include media-breakpoint-up(md) {\n    padding: map-get($spacers, 10) 0; // 64\n  }\n}\n\n// for CTA inline\n.section-padding-sm {\n  padding: map-get($spacers, 7) 0;\n\n  @include media-breakpoint-up(sm) {\n    padding: map-get($spacers, 9) 0;\n  }\n\n  @include media-breakpoint-up(md) {\n    padding: map-get($spacers, 11) 0; // 80\n  }\n}\n\n.section-padding {\n  padding: map-get($spacers, 8) 0;\n\n  @include media-breakpoint-up(sm) {\n    padding: map-get($spacers, 10) 0;\n  }\n\n  @include media-breakpoint-up(md) {\n    padding: map-get($spacers, 12) 0; // 96\n  }\n}\n\n.section-padding-lg {\n  padding: map-get($spacers, 9) 0;\n\n  @include media-breakpoint-up(sm) {\n    padding: map-get($spacers, 11) 0;\n  }\n\n  @include media-breakpoint-up(md) {\n    padding: map-get($spacers, 13) 0; // 104\n  }\n}\n\n.section-padding-xl {\n  padding: map-get($spacers, 10) 0;\n\n  @include media-breakpoint-up(sm) {\n    padding: map-get($spacers, 12) 0;\n  }\n\n  @include media-breakpoint-up(md) {\n    padding: map-get($spacers, 14) 0; // 128\n  }\n}\n\n// for block / CTA 2\n.cta-pb-xl {\n  @include media-breakpoint-up(xl) {\n    padding-bottom: toRem(334px);\n  }\n}\n","@include media-breakpoint-up(lg) {\n  .splits-5-row {\n    min-height: 95vh;\n  }\n}\n\n.splits-5-anchor {\n  position: relative;\n  overflow: hidden;\n  text-decoration: none !important;\n\n  // img / background media\n  .absolute-fill {\n    transition: transform 300ms;\n  }\n\n  &:hover {\n    .absolute-fill {\n      transform: scale(1.1);\n    }\n  }\n}\n\n.splits-text-width-sm {\n  max-width: 400px;\n}\n\n.splits-text-width {\n  max-width: 445px;\n}\n\n.splits-text-width-lg {\n  max-width: 600px;\n}\n\n.split-media-col {\n  @include media-breakpoint-down(lg) {\n    min-height: 400px;\n  }\n\n  @include media-breakpoint-down(md) {\n    min-height: 300px;\n  }\n}\n","// for circle icon containers\n\n.square-sm {\n  @include square(toRem(48px));\n}\n\n.square {\n  @include square(toRem(64px));\n}\n\n.square-lg {\n  @include square(toRem(72px));\n}\n\n.square-xl {\n  @include square(toRem(80px));\n}\n\n.square-xxl {\n  @include square(toRem(96px));\n}\n","// to be used with .overlay.overlay-solid\n// for BackgroundMedia.js VideoButton\n\n.video-play-anchor {\n  display: block;\n\n  // override button defaults\n  border: 0;\n  padding: 0;\n\n  // override .bg-dark anchor opacity\n  opacity: 1 !important;\n\n  &::before {\n    opacity: 0.1;\n    transition: opacity 300ms;\n  }\n\n  &:hover::before {\n    opacity: 0.3;\n  }\n\n  .bg-white {\n    color: $dark-gray-500;\n  }\n}\n","$animation-speed: .3s;\n$animation-function: ease-out;\n$backdrop-color: rgba(0, 0, 0, .5);\n\n@keyframes modal-video {\n\tfrom {\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes modal-video-inner {\n\tfrom {\n\t\ttransform: translate(0, 100px);\n\t}\n\n\tto {\n\t\ttransform: translate(0, 0);\n\t}\n}\n\n.modal-video {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: $backdrop-color;\n\tz-index: 1000000;\n\tcursor: pointer;\n\topacity: 1;\n\tanimation-timing-function: $animation-function;\n\tanimation-duration: $animation-speed;\n\tanimation-name: modal-video;\n\t-webkit-transition: opacity $animation-speed $animation-function;\n\t-moz-transition: opacity $animation-speed $animation-function;\n\t-ms-transition: opacity $animation-speed $animation-function;\n\t-o-transition: opacity $animation-speed $animation-function;\n\ttransition: opacity $animation-speed $animation-function;\n}\n\n.modal-video-effect-exit {\n\topacity: 0;\n\n\t& .modal-video-movie-wrap {\n\t\t-webkit-transform: translate(0, 100px);\n\t\t-moz-transform: translate(0, 100px);\n\t\t-ms-transform: translate(0, 100px);\n\t\t-o-transform: translate(0, 100px);\n\t\ttransform: translate(0, 100px);\n\t}\n}\n\n.modal-video-body {\n\tmax-width: 960px;\n\twidth: 100%;\n\theight: 100%;\n\tmargin: 0 auto;\n\tpadding: 0 10px;\n    display: flex;\n    justify-content: center;\n\tbox-sizing: border-box;\n}\n\n.modal-video-inner {\n\tdisplay: flex;\n    justify-content: center;\n    align-items: center;\n\twidth: 100%;\n\theight: 100%;\n\n    @media (orientation: landscape) {\n        padding: 10px 60px;\n        box-sizing: border-box;\n    }\n}\n\n.modal-video-movie-wrap {\n\twidth: 100%;\n\theight: 0;\n\tposition: relative;\n\tpadding-bottom: 56.25%;\n\tbackground-color: #333;\n\tanimation-timing-function: $animation-function;\n\tanimation-duration: $animation-speed;\n\tanimation-name: modal-video-inner;\n\t-webkit-transform: translate(0, 0);\n\t-moz-transform: translate(0, 0);\n\t-ms-transform: translate(0, 0);\n\t-o-transform: translate(0, 0);\n\ttransform: translate(0, 0);\n\t-webkit-transition: -webkit-transform $animation-speed $animation-function;\n\t-moz-transition: -moz-transform $animation-speed $animation-function;\n\t-ms-transition: -ms-transform $animation-speed $animation-function;\n\t-o-transition: -o-transform $animation-speed $animation-function;\n\ttransition: transform $animation-speed $animation-function;\n\n\t& iframe {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n}\n\n.modal-video-close-btn {\n\tposition: absolute;\n\tz-index: 2;\n\ttop: -45px;\n\tright: 0px;\n\tdisplay: inline-block;\n\twidth: 35px;\n\theight: 35px;\n\toverflow: hidden;\n\tborder: none;\n\tbackground: transparent;\n\n    @media (orientation: landscape) {\n        top: 0;\n        right: -45px;\n    }\n\n\t&:before {\n\t\ttransform: rotate(45deg);\n\t}\n\n\t&:after {\n\t\ttransform: rotate(-45deg);\n\t}\n\n\t&:before,\n\t&:after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\theight: 2px;\n\t\twidth: 100%;\n\t\ttop: 50%;\n\t\tleft: 0;\n\t\tmargin-top: -1px;\n\t\tbackground: #fff;\n\t\tborder-radius: 5px;\n\t\tmargin-top: -6px;\n\t}\n}\n",".react-table-pagination-total {\n  line-height: 41px;\n\n  // remove arrows/spinners\n  // Chrome, Safari, Edge, Opera\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  // Firefox\n  input[type='number'] {\n    -moz-appearance: textfield;\n  }\n}\n\n.react-table-pagination {\n  font-size: toRem(14px);\n}\n\n.react-table-pagination-sm {\n  font-size: toRem(13px);\n}\n\n.react-table-pagination-lg {\n  font-size: toRem(15px);\n}\n\n.react-table-sort {\n  height: 25px;\n}\n","/* Slider */\n\n.slick-slider {\n    position: relative;\n    display: block;\n    box-sizing: border-box;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -ms-touch-action: pan-y;\n    touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n}\n.slick-list {\n    position: relative;\n    overflow: hidden;\n    display: block;\n    margin: 0;\n    padding: 0;\n\n    &:focus {\n        outline: none;\n    }\n\n    &.dragging {\n        cursor: pointer;\n        cursor: hand;\n    }\n}\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n    -o-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n}\n\n.slick-track {\n    position: relative;\n    left: 0;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n\n    &:before,\n    &:after {\n        content: \"\";\n        display: table;\n    }\n\n    &:after {\n        clear: both;\n    }\n\n    .slick-loading & {\n        visibility: hidden;\n    }\n}\n.slick-slide {\n    float: left;\n    height: 100%;\n    min-height: 1px;\n    [dir=\"rtl\"] & {\n        float: right;\n    }\n    img {\n        display: block;\n    }\n    &.slick-loading img {\n        display: none;\n    }\n\n    display: none;\n\n    &.dragging img {\n        pointer-events: none;\n    }\n\n    .slick-initialized & {\n        display: block;\n    }\n\n    .slick-loading & {\n        visibility: hidden;\n    }\n\n    .slick-vertical & {\n        display: block;\n        height: auto;\n        border: 1px solid transparent;\n    }\n}\n.slick-arrow.slick-hidden {\n    display: none;\n}\n","@import '~slick-carousel/slick/slick';\n\n.slick-slide img {\n  display: unset;\n}\n\n.slick-vertical .slick-slide {\n  border: none;\n}\n\n// enable equal height cards in horizontal carousel\n\n.slick-slider:not(.slick-vertical) {\n  .slick-track {\n    display: flex;\n  }\n\n  .slick-slide {\n    height: auto;\n\n    > div {\n      height: 100%;\n    }\n  }\n}\n\n// carousel page item base styles for dot, bar and pill\n\n.carousel-page {\n  --carousel-page-item-bg: #{$light-gray-600};\n  --carousel-page-item-bg-hover: #{$dark-gray-700};\n  --carousel-page-item-bg-active: #{$dark-gray-500};\n\n  // <button> reset\n  background: transparent;\n  border: 1px solid transparent;\n\n  &::before {\n    content: '';\n    display: block;\n    background: var(--carousel-page-item-bg);\n    transition: background-color 0.15s ease-in-out;\n  }\n\n  &.active {\n    &::before {\n      background: var(--carousel-page-item-bg-active);\n    }\n  }\n\n  &:hover {\n    &::before {\n      background: var(--carousel-page-item-bg-hover);\n    }\n  }\n\n  &:focus-visible {\n    outline: 0;\n    border-color: $focus-blue;\n  }\n}\n\n.carousel-text-transition {\n  transition: opacity 500ms ease;\n}\n\n// dot\n\n.carousel-page-dot {\n  padding: toRem(7px);\n  @include square(24px);\n\n  &::before {\n    @include square(8px);\n    border-radius: 50%;\n  }\n}\n\n.carousel-page-dot-lg {\n  @include square(28px);\n\n  &::before {\n    @include square(12px);\n  }\n}\n\n// bar and pill\n\n.carousel-page-bar,\n.carousel-page-pill {\n  padding: toRem(18px) toRem(3px);\n\n  &::before {\n    width: toRem(32px);\n    height: toRem(2px);\n  }\n}\n\n.carousel-page-bar-lg,\n.carousel-page-pill-lg {\n  padding: toRem(20px) toRem(3px);\n\n  &::before {\n    width: toRem(38px);\n    height: toRem(4px);\n  }\n}\n\n.carousel-page-pill {\n  &::before {\n    border-radius: toRem(2px);\n  }\n}\n\n.carousel-progress-parent:hover {\n  .carousel-progress-bar {\n    animation-play-state: paused;\n  }\n}\n\n.carousel-progress-bar {\n  transition: none;\n  width: 0;\n  animation: grow-width var(--carousel-slide-duration) linear forwards;\n}\n\n@keyframes grow-width {\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n}\n\n// overlay\n\n.btn-carousel-overlay {\n  --#{$prefix}btn-disabled-bg: #{rgba($white, 0.5)};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{rgba($dark-gray-700, 0.5)};\n\n  &:not(.disabled),\n  &:not(:disabled) {\n    box-shadow: 0 6px 12px 0 rgba($black, 0.26);\n  }\n}\n\n.carousel-page-overlay {\n  --carousel-page-item-bg: #{$light-gray-700};\n  --carousel-page-item-bg-hover: #{$white};\n  --carousel-page-item-bg-active: #{$light-gray-50};\n\n  &::before {\n    box-shadow: 0 toRem(0.5px) toRem(0.5px) 0 rgba($black, 0.84);\n  }\n\n  &.active {\n    &::before {\n      box-shadow: 0 toRem(0.5px) toRem(3px) 0 rgba($black, 0.92);\n    }\n  }\n}\n\n// dark mode\n\n.dark {\n  .carousel-page:not(.carousel-page-overlay) {\n    --carousel-page-item-bg: #{$dark-gray-500};\n    --carousel-page-item-bg-hover: #{$white};\n    --carousel-page-item-bg-active: #{$light-gray-900};\n  }\n}\n",".recharts-wrapper {\n  --recharts-grid-color: #{$dark-gray-700};\n  --recharts-polar-grid-opacity: 0.14;\n  --recharts-radial-bar-bg: #{$light-gray-300};\n  --recharts-tooltip-cursor-stroke: #002bbc;\n  --recharts-reference-line-blue: #ccd5f2;\n  --recharts-bar-tooltip-cursor-fill: #{rgba($dark-gray-700, 0.08)};\n  // --recharts-bg: should be same as or close to body / chart background color\n  // used for dot icon bg elements, label list stroke, pie stroke, treemap stroke, bar mix stroke\n  --recharts-bg: #{$white};\n  --recharts-pie-text-overlay-color: #{$white};\n\n  font-size: toRem(13px);\n}\n\n// the recharts svg element\n\n.recharts-surface {\n  text {\n    fill: currentColor;\n  }\n}\n\n// for custom tooltip, class is not in recharts defaults\n\n.recharts-tooltip-content {\n  min-width: 165px;\n  max-width: 200px;\n  visibility: 'visible';\n}\n\n// cartesian grid\n\n.recharts-cartesian-grid {\n  line {\n    stroke: var(--recharts-grid-color);\n    stroke-opacity: 0.08;\n  }\n}\n\n.recharts-cartesian-axis {\n  line {\n    stroke: var(--recharts-grid-color);\n    stroke-opacity: 0.4;\n  }\n\n  // x and y axis label\n  .recharts-label {\n    font-size: toRem(16px);\n    opacity: 0.52;\n    text-anchor: middle;\n  }\n}\n\n.recharts-polar-grid {\n  line,\n  path {\n    stroke: var(--recharts-grid-color);\n    stroke-opacity: var(--recharts-polar-grid-opacity);\n  }\n}\n\n.recharts-tooltip-cursor {\n  // blue stroke for line and area (curve) scatter (cross) and radial bar (sector) tooltip cursors, but not bar (rectangle) tooltip cursor\n  &:not(.recharts-rectangle) {\n    stroke: var(--recharts-tooltip-cursor-stroke);\n  }\n\n  &.recharts-rectangle {\n    fill: var(--recharts-bar-tooltip-cursor-fill);\n  }\n}\n\n.recharts-radial-bar-background-sector {\n  fill: var(--recharts-radial-bar-bg);\n}\n\n// label above each line / scatter chart dot\n\n.recharts-label-list {\n  font-size: toRem(12px);\n  text-anchor: middle;\n  fill-opacity: 0.84;\n  stroke: var(--recharts-bg);\n  stroke-opacity: 0.8;\n  stroke-width: 4px;\n  paint-order: stroke;\n}\n\n.recharts-reference-line {\n  .recharts-label {\n    stroke: var(--recharts-bg);\n    stroke-opacity: 0.8;\n    stroke-width: 10px;\n    paint-order: stroke;\n  }\n}\n\n// pie chart\n\n.recharts-pie-sector,\n.recharts-sector {\n  &:focus {\n    outline: none;\n  }\n}\n\n.recharts-pie-sector {\n  .recharts-sector {\n    stroke: var(--recharts-bg);\n    transition: opacity 0.15s ease-in-out;\n  }\n}\n\n.recharts-pie-label-line {\n  stroke: var(--recharts-grid-color);\n  stroke-opacity: 0.4;\n  stroke-width: 1;\n}\n\n.recharts-pie-text-overlay {\n  fill: var(--recharts-pie-text-overlay-color) !important;\n}\n\n// dark mode\n\n.dark {\n  .recharts-wrapper {\n    --recharts-grid-color: #{$white};\n    --recharts-polar-grid-opacity: 0.4;\n    --recharts-radial-bar-bg: #{$dark-gray-800};\n    --recharts-tooltip-cursor-stroke: #8ddbff;\n    --recharts-reference-line-blue: #2a3a41;\n    --recharts-bar-tooltip-cursor-fill: #{rgba($white, 0.06)};\n    --recharts-bg: #{$dark-gray-700};\n    --recharts-pie-text-overlay-color: #{$dark-gray-700};\n  }\n}\n",".recharts-wrapper {\n  --recharts-color-1-1: #090909;\n\n  --recharts-color-2-1: #090909;\n  --recharts-color-2-2: #b6b6b6;\n\n  --recharts-color-3-1: #090909;\n  --recharts-color-3-2: #606060;\n  --recharts-color-3-3: #b6b6b6;\n\n  --recharts-color-4-1: #090909;\n  --recharts-color-4-2: #434343;\n  --recharts-color-4-3: #7d7d7d;\n  --recharts-color-4-4: #b6b6b6;\n\n  --recharts-color-5-1: #090909;\n  --recharts-color-5-2: #343434;\n  --recharts-color-5-3: #5f5f5f;\n  --recharts-color-5-4: #bababa;\n  --recharts-color-5-5: #b6b6b6;\n\n  --recharts-color-6-1: #090909;\n  --recharts-color-6-2: #2c2c2c;\n  --recharts-color-6-3: #4f4f4f;\n  --recharts-color-6-4: #727272;\n  --recharts-color-6-5: #959595;\n  --recharts-color-6-6: #b6b6b6;\n}\n\n.dark {\n  .recharts-wrapper {\n    --recharts-color-1-1: #fcfcfc;\n\n    --recharts-color-2-1: #fcfcfc;\n    --recharts-color-2-2: #575757;\n\n    --recharts-color-3-1: #fcfcfc;\n    --recharts-color-3-2: #a6a6a6;\n    --recharts-color-3-3: #575757;\n\n    --recharts-color-4-1: #fcfcfc;\n    --recharts-color-4-2: #c2c2c2;\n    --recharts-color-4-3: #8a8a8a;\n    --recharts-color-4-4: #575757;\n\n    --recharts-color-5-1: #fcfcfc;\n    --recharts-color-5-2: #d0d0d0;\n    --recharts-color-5-3: #a6a6a6;\n    --recharts-color-5-4: #7d7d7d;\n    --recharts-color-5-5: #575757;\n\n    --recharts-color-6-1: #fcfcfc;\n    --recharts-color-6-2: #d9d9d9;\n    --recharts-color-6-3: #b6b6b6;\n    --recharts-color-6-4: #959595;\n    --recharts-color-6-5: #757575;\n    --recharts-color-6-6: #575757;\n  }\n}\n","// Brush (slider) and traveller (handle)\n\n.recharts-brush {\n  --recharts-brush-bg: #{$light-gray-300};\n  --recharts-brush-connect-bg: #{$dark-gray-50};\n  --recharts-brush-handle-bg: #{$white};\n  --recharts-brush-stroke: #{$light-gray-400};\n\n  transform: translateY(30px);\n\n  > rect:first-child {\n    fill: var(--recharts-brush-bg);\n    stroke: none;\n  }\n}\n\n.recharts-brush-slide {\n  fill: var(--recharts-brush-connect-bg);\n  fill-opacity: 1;\n}\n\n.recharts-brush-traveller-circle {\n  fill: var(--recharts-brush-handle-bg);\n  stroke: var(--recharts-brush-stroke);\n}\n\n.recharts-brush-texts {\n  // 13 == same as travellerWidth prop on <Brush />\n  $brush-handle-radius: #{(divide(13, 2) + 4)}px;\n\n  text {\n    fill: currentColor;\n\n    // center the text below the handle\n    &:first-child {\n      transform: translate($brush-handle-radius, 30px);\n      text-anchor: middle;\n    }\n\n    &:last-child {\n      transform: translate(-$brush-handle-radius, 30px);\n      text-anchor: middle;\n    }\n  }\n}\n\n.dark {\n  .recharts-brush {\n    --recharts-brush-bg: #{$dark-gray-300};\n    --recharts-brush-connect-bg: #{$light-gray-800};\n    --recharts-brush-handle-bg: #{$dark-gray-500};\n    --recharts-brush-stroke: #{$dark-gray-200};\n  }\n}\n","@import '~flatpickr/dist/flatpickr.css';\n\n$flatpickr-range-bg: $light-gray-200;\n$flatpickr-hover-bg: $light-gray-300;\n$flatpickr-today-bg: $op-light-gray-300;\n$flatpickr-today-hover-bg: $light-gray-600;\n$flatpickr-padding: 20px;\n$flatpickr-width: 280px;\n\n@mixin pseudoBG {\n  content: '';\n  position: absolute;\n  background-color: $flatpickr-range-bg;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n}\n\n.flatpickr-wrapper {\n  display: block;\n}\n\n.flatpickr-calendar {\n  box-shadow: $box-shadow;\n  border-radius: 0;\n  padding: 20px;\n  width: $flatpickr-width + ($flatpickr-padding * 2);\n\n  // override inline style width that cuts off the width\n  // fixed width for 2 months\n  &.multiMonth {\n    width: $flatpickr-width * 2 + $flatpickr-padding * 2 + 2px !important;\n  }\n\n  &.arrowTop::before,\n  &.arrowTop::after {\n    content: none;\n  }\n\n  // hide box shadow to each day next to the line separator\n  &.multiMonth {\n    .flatpickr-days {\n      .dayContainer:nth-child(n + 2) {\n        .flatpickr-day.inRange:nth-child(7n + 1) {\n          box-shadow: none;\n        }\n      }\n    }\n  }\n\n  &.noCalendar.hasTime .flatpickr-time {\n    border-top: none;\n  }\n}\n\n// fix prev and next arrow position\n.flatpickr-months {\n  margin-bottom: 14px;\n\n  .flatpickr-prev-month,\n  .flatpickr-next-month {\n    top: 20px;\n    display: flex;\n    fill: rgba($dark-gray-700, 0.54);\n\n    &:hover svg {\n      fill: $dark-gray-700;\n    }\n  }\n  // prev\n  .flatpickr-prev-month.flatpickr-prev-month,\n  .flatpickr-next-month.flatpickr-prev-month {\n    left: 20px;\n  }\n  // next\n  .flatpickr-prev-month.flatpickr-next-month,\n  .flatpickr-next-month.flatpickr-next-month {\n    right: 20px;\n  }\n}\n\n.flatpickr-days {\n  width: $flatpickr-width;\n}\n\n// Range / Start / End\n\n.flatpickr-day {\n  color: $dark-gray-700;\n  border: none;\n  width: 40px;\n  height: 40px;\n  max-width: 40px;\n\n  &.prevMonthDay,\n  &.nextMonthDay {\n    color: rgba($dark-gray-700, 0.5);\n  }\n\n  // in range days\n  &.inRange {\n    border-radius: 50%;\n    box-shadow: none;\n\n    &::after {\n      // fill in gaps in between days\n      box-shadow: -5px 0 0 $flatpickr-range-bg, 5px 0 0 $flatpickr-range-bg;\n\n      @include pseudoBG;\n    }\n\n    &:nth-child(7n + 7),\n    &:nth-child(7n + 1) {\n      &::after {\n        box-shadow: none;\n      }\n    }\n  }\n\n  // in range days\n  &,\n  &.prevMonthDay,\n  &.nextMonthDay {\n    &.inRange {\n      background: $flatpickr-range-bg;\n    }\n  }\n\n  &,\n  &.prevMonthDay,\n  &.nextMonthDay {\n    &.today.inRange {\n      background: $flatpickr-today-bg;\n    }\n  }\n\n  &,\n  &.prevMonthDay,\n  &.nextMonthDay {\n    &:hover,\n    &:focus {\n      background: $flatpickr-hover-bg;\n    }\n  }\n\n  // today\n  &.today {\n    background-color: $flatpickr-today-bg;\n\n    &:hover,\n    &:focus {\n      background-color: $flatpickr-today-hover-bg;\n    }\n  }\n\n  // selected, start and end date\n  &.selected,\n  &.startRange,\n  &.endRange {\n    &,\n    &.inRange,\n    &:focus,\n    &:hover,\n    &.prevMonthDay,\n    &.nextMonthDay {\n      background: $dark-gray-700;\n    }\n  }\n\n  // move fill between adjacent start and end dates to ::after\n  // because of circle border radius\n  &.selected.startRange,\n  &.startRange.startRange,\n  &.endRange.startRange {\n    & + .endRange:not(:nth-child(7n + 1)) {\n      box-shadow: none;\n\n      &::after {\n        box-shadow: -5px 0 0 $flatpickr-range-bg;\n      }\n    }\n  }\n\n  // circular start and end range\n  &.selected.startRange,\n  &.startRange.startRange,\n  &.endRange.startRange,\n  &.selected.endRange,\n  &.startRange.endRange,\n  &.endRange.endRange {\n    border-radius: 50%;\n\n    // background behind circle\n    &::after {\n      @include pseudoBG;\n    }\n  }\n\n  // bg behind right half of start range circle\n  &.selected.startRange,\n  &.startRange.startRange,\n  &.endRange.startRange {\n    &::after {\n      left: 50%;\n    }\n  }\n\n  // bg behind left half of end range circle\n  &.selected.endRange,\n  &.startRange.endRange,\n  &.endRange.endRange {\n    &::after {\n      right: 50%;\n    }\n  }\n}\n\n// remove margin-top to match the design\n\n.rangeMode {\n  .flatpickr-day {\n    margin-top: 0px;\n  }\n}\n\n.dayContainer {\n  width: $flatpickr-width;\n  min-width: $flatpickr-width;\n  max-width: $flatpickr-width;\n}\n\nspan.flatpickr-weekday {\n  font-weight: normal;\n  font-size: toRem(14px);\n  color: #0f0f0f;\n}\n\n// line separator on multi month range selection\n.dayContainer + .dayContainer {\n  box-shadow: none;\n  border-left: 1px solid $light-gray-400;\n}\n\n// style readonly flatpickr input to look like it's not readonly\n\n.flatpickr-input,\n.flatpickr-input + .form-control,\n.form-control[data-fp-omit] {\n  &[readonly] {\n    &,\n    ~ [class*='input-group'] > .input-group-text {\n      background-color: $input-bg !important;\n    }\n  }\n}\n\n// Active input color when calendar is open\n.input-group-flatpickr {\n  --flatpickr-input-active-border-color: #{$dark-gray-900};\n}\n\n.flatpickr-input {\n  + .form-control:not(:focus),\n  &.form-control:not(:focus) {\n    &.active,\n    &.active + .input-group-prepend .input-group-text {\n      border-color: var(--flatpickr-input-active-border-color);\n    }\n  }\n}\n\n// year and time arrows\n\n.numInputWrapper {\n  span {\n    border: 0;\n  }\n\n  &:hover,\n  span:hover {\n    background: transparent;\n  }\n}\n\n.flatpickr-current-month {\n  .flatpickr-monthDropdown-months {\n    margin-right: 18px;\n\n    &:hover {\n      background: transparent;\n    }\n  }\n\n  // month and year inputs font weight and size\n  .flatpickr-monthDropdown-months,\n  input.cur-year,\n  span.cur-month {\n    font-weight: $font-weight-medium;\n    font-size: toRem(16px);\n    letter-spacing: 0.05px;\n  }\n\n  .numInputWrapper span {\n    &.arrowUp {\n      &:after {\n        border-bottom-color: rgba($dark-gray-700, 0.3);\n      }\n      &:hover:after {\n        border-bottom-color: $dark-gray-700;\n      }\n    }\n    &.arrowDown {\n      &:after {\n        border-top-color: rgba($dark-gray-700, 0.3);\n      }\n      &:hover:after {\n        border-top-color: $dark-gray-700;\n      }\n    }\n  }\n}\n\n.flatpickr-time {\n  .flatpickr-time-separator {\n    font-weight: 700;\n    width: 40px;\n  }\n\n  input {\n    padding-right: 22px;\n    cursor: pointer;\n    transition: border-color 0.15s ease-in-out;\n    border: 1px solid transparent;\n\n    &:focus {\n      border: 1px solid $input-focus-border-color;\n    }\n\n    &:hover,\n    &:focus {\n      background-color: $light-gray-200;\n    }\n\n    &.flatpickr-hour,\n    &.flatpickr-minute,\n    &.flatpickr-second {\n      font-size: toRem(18px);\n      font-weight: 400;\n      color: $dark-gray-700;\n    }\n  }\n\n  .flatpickr-time-separator {\n    font-size: toRem(18px);\n    font-weight: 400;\n    color: $dark-gray-700;\n  }\n\n  .flatpickr-am-pm {\n    border-radius: 50%;\n    width: 40px;\n    margin-left: 30px;\n    color: $dark-gray-700;\n\n    &:hover,\n    &:focus {\n      background: $flatpickr-hover-bg;\n    }\n  }\n\n  .numInputWrapper span {\n    padding: 0 16px 0 6px;\n    opacity: 0.5;\n    transition: opacity 0.2s ease-in-out;\n\n    &:hover {\n      opacity: 1;\n    }\n\n    &.arrowUp:after {\n      border-bottom-width: 6px;\n      border-bottom-color: $dark-gray-700;\n      top: 40%;\n    }\n\n    &.arrowDown:after {\n      border-top-width: 6px;\n      border-top-color: $dark-gray-700;\n      top: 25%;\n    }\n  }\n}\n\n.dark {\n  $flatpickr-today-bg: $dark-gray-500;\n  $flatpickr-today-hover-bg: $dark-gray-400;\n  $flatpickr-hover-bg: $dark-gray-400;\n  $flatpickr-range-bg: $dark-gray-500;\n\n  .input-group-flatpickr {\n    --flatpickr-input-active-border-color: #{$light-gray-100};\n  }\n\n  .flatpickr-calendar {\n    box-shadow: $box-shadow-dark-lg;\n    background-color: $dark-gray-600;\n  }\n\n  .flatpickr-months {\n    .flatpickr-prev-month,\n    .flatpickr-next-month {\n      fill: rgba($white, 0.54);\n\n      &:hover svg {\n        fill: $white;\n      }\n    }\n  }\n\n  .flatpickr-current-month {\n    .flatpickr-monthDropdown-months,\n    input.cur-year,\n    span.cur-month {\n      color: $white;\n    }\n  }\n\n  span.flatpickr-weekday {\n    color: $white;\n  }\n\n  .flatpickr-day {\n    color: rgba($white, 0.92);\n\n    &.flatpickr-disabled:hover {\n      color: rgba($white, 0.92);\n    }\n\n    // in range days\n    &.inRange {\n      &::after {\n        // fill in gaps in between days\n        box-shadow: -5px 0 0 $flatpickr-range-bg, 5px 0 0 $flatpickr-range-bg;\n        background-color: $flatpickr-range-bg;\n      }\n    }\n\n    &:nth-child(7n + 7),\n    &:nth-child(7n + 1) {\n      &::after {\n        box-shadow: none;\n      }\n    }\n\n    // in range days\n    &,\n    &.prevMonthDay,\n    &.nextMonthDay {\n      &.inRange {\n        background: $flatpickr-range-bg;\n      }\n\n      &.today.inRange {\n        background: $dark-gray-400;\n      }\n\n      &:hover,\n      &:focus {\n        background: $flatpickr-hover-bg;\n      }\n    }\n\n    &.prevMonthDay,\n    &.nextMonthDay {\n      color: rgba($white, 0.4);\n    }\n\n    // today\n    &.today {\n      background-color: $flatpickr-today-bg;\n\n      &:hover,\n      &:focus {\n        background-color: $flatpickr-today-hover-bg;\n        color: $white;\n      }\n    }\n\n    &.selected {\n      background-color: $white;\n      color: $dark-gray-700;\n    }\n\n    // start and end date\n    &.startRange,\n    &.endRange {\n      &,\n      &.inRange,\n      &:focus,\n      &:hover,\n      &.prevMonthDay,\n      &.nextMonthDay {\n        background: $dark-gray-700;\n      }\n    }\n\n    // move fill between adjacent start and end dates to ::after\n    // because of circle border radius\n    &.selected.startRange,\n    &.startRange.startRange,\n    &.endRange.startRange {\n      & + .endRange:not(:nth-child(7n + 1)) {\n        &::after {\n          box-shadow: -5px 0 0 $flatpickr-range-bg;\n        }\n      }\n    }\n\n    // circular start and end range\n    &.selected.startRange,\n    &.startRange.startRange,\n    &.endRange.startRange,\n    &.selected.endRange,\n    &.startRange.endRange,\n    &.endRange.endRange {\n      background-color: $white;\n      color: $dark-gray-700;\n\n      // background behind circle\n      &::after {\n        background-color: $flatpickr-range-bg;\n      }\n    }\n  }\n\n  .flatpickr-time {\n    input.flatpickr-hour,\n    .flatpickr-time-separator,\n    input.flatpickr-minute,\n    input.flatpickr-second {\n      color: $white;\n    }\n\n    .flatpickr-am-pm {\n      color: $white;\n\n      &:hover,\n      &:focus {\n        background: $flatpickr-hover-bg;\n      }\n    }\n\n    input {\n      transition: border-color 0.15s ease-in-out;\n      border: 1px solid transparent;\n\n      &:focus {\n        border: 1px solid $input-focus-border-color;\n        background-color: $flatpickr-hover-bg;\n      }\n\n      &:hover {\n        background-color: $flatpickr-hover-bg;\n      }\n    }\n\n    .numInputWrapper span {\n      &.arrowUp:after {\n        border-bottom-color: $white;\n      }\n\n      &.arrowDown:after {\n        border-top-color: $white;\n      }\n    }\n  }\n\n  // line separator on multi month range selection\n  .dayContainer + .dayContainer {\n    border-color: $dark-gray-300;\n  }\n\n  .flatpickr-current-month .numInputWrapper span {\n    &.arrowUp {\n      &:after {\n        border-bottom-color: rgba($white, 0.3);\n      }\n      &:hover:after {\n        border-bottom-color: $white;\n      }\n    }\n    &.arrowDown {\n      &:after {\n        border-top-color: rgba($white, 0.3);\n      }\n      &:hover:after {\n        border-top-color: $white;\n      }\n    }\n  }\n}\n","$rbt-color-primary: #007bff !default;\n$rbt-color-disabled: #495057 !default;\n$rbt-color-white: #fff !default;\n\n// Hide IE's native \"clear\" button\n.rbt .rbt-input-main::-ms-clear {\n  display: none;\n}\n\n/**\n * Menu\n */\n.rbt-menu {\n  margin-bottom: 2px; // Spacing for dropup\n\n  & > .dropdown-item {\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  &-pagination-option {\n    text-align: center;\n  }\n}\n\n/**\n * Multi-select Input\n */\n$rbt-background-color-disabled: #e9ecef !default;\n\n$rbt-border-color-focus: #80bdff !default;\n$rbt-border-color-focus-invalid: #dc3545 !default;\n$rbt-border-color-focus-valid: #28a745 !default;\n\n$rbt-box-shadow-dimensions: 0 0 0 0.2rem;\n$rbt-box-shadow-color: rgba(0, 123, 255, 0.25) !default;\n$rbt-box-shadow-color-invalid: rgba(220, 53, 69, 0.25) !default;\n$rbt-box-shadow-color-valid: rgba(40, 167, 69, 0.25) !default;\n\n$rbt-color-focus: #495057 !default;\n$rbt-placeholder-color: #6c757d !default;\n\n.rbt-input-multi {\n  cursor: text;\n  overflow: hidden;\n  position: relative;\n\n  // Apply Bootstrap focus styles\n  &.focus {\n    border-color: $rbt-border-color-focus;\n    box-shadow: $rbt-box-shadow-dimensions $rbt-box-shadow-color;\n    color: $rbt-color-focus;\n    outline: 0;\n  }\n\n  &.form-control {\n    height: auto;\n  }\n\n  // BS4 uses the :disabled pseudo-class, which doesn't work with non-inputs.\n  &.disabled {\n    background-color: $rbt-background-color-disabled;\n    opacity: 1;\n  }\n\n  &.is-invalid.focus {\n    border-color: $rbt-border-color-focus-invalid;\n    box-shadow: $rbt-box-shadow-dimensions $rbt-box-shadow-color-invalid;\n  }\n\n  &.is-valid.focus {\n    border-color: $rbt-border-color-focus-valid;\n    box-shadow: $rbt-box-shadow-dimensions $rbt-box-shadow-color-valid;\n  }\n\n  // Apply Bootstrap placeholder styles\n  input {\n    // Firefox\n    &::-moz-placeholder {\n      color: $rbt-placeholder-color;\n      opacity: 1;\n    }\n\n    // Internet Explorer 10+\n    &:-ms-input-placeholder {\n      color: $rbt-placeholder-color;\n    }\n\n    // Safari and Chrome\n    &::-webkit-input-placeholder {\n      color: $rbt-placeholder-color;\n    }\n  }\n\n  .rbt-input-wrapper {\n    align-items: flex-start;\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: -4px;\n    margin-top: -1px;\n    overflow: hidden;\n  }\n\n  .rbt-input-main {\n    margin: 1px 0 4px;\n  }\n}\n\n/**\n * Close Button\n */\n.rbt-close {\n  z-index: 1;\n\n  &-lg {\n    font-size: 1.5rem;\n  }\n}\n\n/**\n * Token\n */\n$rbt-token-background-color: #e7f4ff !default;\n$rbt-token-color: $rbt-color-primary !default;\n\n$rbt-token-disabled-background-color: rgba(0, 0, 0, 0.1) !default;\n$rbt-token-disabled-color: $rbt-color-disabled !default;\n\n$rbt-token-active-background-color: $rbt-color-primary !default;\n$rbt-token-active-color: $rbt-color-white !default;\n\n.rbt-token {\n  background-color: $rbt-token-background-color;\n  border: 0;\n  border-radius: 0.25rem;\n  color: $rbt-token-color;\n  display: inline-flex;\n  line-height: 1rem;\n  // TODO: Use `gap` when it's better supported\n  margin: 1px 3px 2px 0;\n\n  .rbt-token-label {\n    padding: 0.25rem 0.5rem;\n\n    &:not(:last-child) {\n      padding-right: 0.25rem;\n    }\n  }\n\n  &-disabled {\n    background-color: $rbt-token-disabled-background-color;\n    color: $rbt-token-disabled-color;\n    pointer-events: none;\n  }\n\n  &-removeable {\n    cursor: pointer;\n  }\n\n  &-active {\n    background-color: $rbt-token-active-background-color;\n    color: $rbt-token-active-color;\n    outline: none;\n    text-decoration: none;\n  }\n\n  & &-remove-button {\n    // Hide Bootstrap close button image\n    background-image: none;\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n    // Override Bootstrap button shadow\n    box-shadow: none;\n    color: inherit;\n    display: flex;\n    justify-content: center;\n    font-size: inherit;\n    font-weight: normal;\n    opacity: 1;\n    outline: none;\n    padding: 0.25rem 0.5rem;\n    padding-left: 0;\n    text-shadow: none;\n\n    .rbt-close-content {\n      // Override `display: none` in BS5 styles.\n      display: block;\n    }\n  }\n}\n\n/**\n * Loader + CloseButton container\n */\n.rbt-aux {\n  align-items: center;\n  display: flex;\n  bottom: 0;\n  justify-content: center;\n  pointer-events: none; /* Don't block clicks on the input */\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 2rem;\n\n  &-lg {\n    width: 3rem;\n  }\n\n  & .rbt-close {\n    margin-top: -0.25rem;\n    pointer-events: auto; /* Override pointer-events: none; above */\n  }\n}\n\n.has-aux .form-control {\n  padding-right: 2rem;\n\n  // Position validation icons next to clear button and loader.\n  &.is-valid,\n  &.is-invalid {\n    background-position: right 2rem center;\n    padding-right: 4rem;\n  }\n}\n\n// Default highlight style\n.rbt-highlight-text {\n  background-color: inherit;\n  color: inherit;\n  font-weight: bold;\n  padding: 0;\n}\n\n/**\n * Input Groups\n */\n.input-group > .rbt {\n  flex: 1;\n\n  // Form-controls within input-groups have a higher z-index.\n  & .rbt-input-hint,\n  & .rbt-aux {\n    z-index: 5;\n  }\n\n  &:not(:first-child) .form-control {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  &:not(:last-child) .form-control {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n}\n",".rbt-close {\n  font-size: 1rem;\n\n  &-sm {\n    font-size: 0.75rem;\n  }\n\n  &-content {\n    display: none;\n  }\n}\n\n.rbt-aux {\n  width: 2.5rem;\n\n  &-lg {\n    width: 3rem;\n  }\n\n  & .rbt-close {\n    // Overrides `margin-top: -4px` in BS4 styles\n    margin-top: 0;\n  }\n}\n\n.rbt .form-floating {\n  flex: 1;\n}\n\n.form-floating > .rbt-input-multi {\n  &:not(:placeholder-shown) ~ label {\n    opacity: inherit;\n    transform: inherit;\n  }\n\n  // Hide the placeholder\n  .rbt-input-main::placeholder {\n    color: transparent;\n  }\n\n  // Shrink the label when multi-selector is focused or there are selections.\n  &.focus ~ label {\n    opacity: 0.65;\n    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n  }\n}\n","@import '~react-bootstrap-typeahead/css/Typeahead';\n@import '~react-bootstrap-typeahead/css/Typeahead.bs5';\n\n.rbt {\n  .dropdown-item {\n    // override display flex (was collapsing space between highlight text and remainder)\n    display: block;\n  }\n}\n\n.rbt-highlight-text {\n  font-weight: $font-weight-normal;\n  color: $black;\n}\n\n.rbt-aux {\n  .rbt-close {\n    margin-top: 0;\n  }\n}\n\n.rbt-input-hint {\n  letter-spacing: $input-letter-spacing;\n}\n\n.dark {\n  .rbt-highlight-text {\n    color: $white;\n  }\n\n  .rbt-input-hint {\n    color: rgba($white, 0.54) !important;\n  }\n}\n",".react-select {\n  &__control {\n    background-color: $input-bg !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    font-size: toRem(14px);\n\n    &:hover {\n      border-color: $input-hover-border-color !important;\n    }\n\n    &--is-focused {\n      border-color: $input-focus-border-color !important;\n    }\n  }\n\n  &__control,\n  &__option {\n    cursor: pointer !important;\n  }\n\n  &__option {\n    color: $dropdown-link-color !important;\n    font-size: $dropdown-font-size !important;\n    background-color: transparent !important;\n\n    &--is-selected {\n      // use custom check mark\n      background-color: transparent !important;\n      background-image: escape-svg(check-icon($dark-gray-800));\n      background-repeat: no-repeat;\n      background-position: $form-select-bg-position;\n      background-size: $form-select-bg-size;\n      padding-right: $form-select-padding-x + $form-select-indicator-padding;\n      color: $dropdown-link-active-color !important;\n    }\n\n    &:hover,\n    &--is-focused {\n      color: $dropdown-link-hover-color !important;\n      background-color: $dropdown-link-hover-bg !important;\n    }\n\n    &:active {\n      background-color: $dropdown-link-active-bg !important;\n    }\n  }\n\n  &__value-container {\n    padding-left: $form-select-padding-x !important;\n  }\n}\n\n.dark {\n  .react-select {\n    &__control {\n      border-color: $dark-gray-400;\n\n      &--is-focused {\n        border-color: $light-gray-800 !important;\n      }\n    }\n\n    &__placeholder {\n      color: rgba($white, 0.64);\n    }\n\n    &__input-container {\n      color: $white;\n    }\n\n    &__menu {\n      background: $dark-gray-600;\n    }\n\n    &__option {\n      color: $dropdown-dark-color !important;\n\n      &--is-selected {\n        background-image: escape-svg(check-icon($dropdown-dark-color));\n        color: $dropdown-dark-link-active-color !important;\n      }\n\n      &:hover,\n      &--is-focused {\n        background-color: $dropdown-dark-link-hover-bg !important;\n        color: $dropdown-dark-link-active-color !important;\n      }\n\n      &:active {\n        background-color: $dropdown-dark-link-active-bg !important;\n      }\n    }\n\n    &__single-value {\n      color: $dropdown-dark-link-active-color !important;\n    }\n  }\n}\n","body {\r\n  background-color: #fff;\r\n  font-family:\r\n    'Roboto',\r\n    -apple-system,\r\n    BlinkMacSystemFont,\r\n    'Segoe UI',\r\n    'Oxygen',\r\n    'Ubuntu',\r\n    'Cantarell',\r\n    'Fira Sans',\r\n    'Droid Sans',\r\n    'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\r\n}\r\n\r\n#webpack-dev-server-client-overlay {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
